(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components"], factory);
	else if(typeof exports === 'object')
		exports["Zakeke"] = factory(require("react"), require("styled-components"));
	else
		root["Zakeke"] = factory(root["react"], root["styled-components"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_styled_components__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/call-bind/callBound.js":
/*!*********************************************!*\
  !*** ./node_modules/call-bind/callBound.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");

var callBind = __webpack_require__(/*! ./ */ "./node_modules/call-bind/index.js");

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ "./node_modules/call-bind/index.js":
/*!*****************************************!*\
  !*** ./node_modules/call-bind/index.js ***!
  \*****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");
var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ "./node_modules/function-bind/implementation.js":
/*!******************************************************!*\
  !*** ./node_modules/function-bind/implementation.js ***!
  \******************************************************/
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ "./node_modules/function-bind/index.js":
/*!*********************************************!*\
  !*** ./node_modules/function-bind/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(/*! ./implementation */ "./node_modules/function-bind/implementation.js");

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ "./node_modules/get-intrinsic/index.js":
/*!*********************************************!*\
  !*** ./node_modules/get-intrinsic/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(/*! has-symbols */ "./node_modules/has-symbols/index.js")();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

try {
	null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
	// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
	var errorProto = getProto(getProto(e));
	INTRINSICS['%Error.prototype%'] = errorProto;
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");
var hasOwn = __webpack_require__(/*! has */ "./node_modules/has/src/index.js");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ "./node_modules/has-symbols/index.js":
/*!*******************************************!*\
  !*** ./node_modules/has-symbols/index.js ***!
  \*******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(/*! ./shams */ "./node_modules/has-symbols/shams.js");

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ "./node_modules/has-symbols/shams.js":
/*!*******************************************!*\
  !*** ./node_modules/has-symbols/shams.js ***!
  \*******************************************/
/***/ ((module) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ "./node_modules/has/src/index.js":
/*!***************************************!*\
  !*** ./node_modules/has/src/index.js ***!
  \***************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ "./node_modules/lodash/lodash.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/lodash.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ "./node_modules/object-inspect/index.js":
/*!**********************************************!*\
  !*** ./node_modules/object-inspect/index.js ***!
  \**********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(/*! ./util.inspect */ "?4f7e");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ "./node_modules/qs/lib/formats.js":
/*!****************************************!*\
  !*** ./node_modules/qs/lib/formats.js ***!
  \****************************************/
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ "./node_modules/qs/lib/index.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/index.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(/*! ./stringify */ "./node_modules/qs/lib/stringify.js");
var parse = __webpack_require__(/*! ./parse */ "./node_modules/qs/lib/parse.js");
var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ "./node_modules/qs/lib/parse.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/parse.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "./node_modules/qs/lib/utils.js");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ "./node_modules/qs/lib/stringify.js":
/*!******************************************!*\
  !*** ./node_modules/qs/lib/stringify.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(/*! side-channel */ "./node_modules/side-channel/index.js");
var utils = __webpack_require__(/*! ./utils */ "./node_modules/qs/lib/utils.js");
var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ "./node_modules/qs/lib/utils.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/utils.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ "./node_modules/side-channel/index.js":
/*!********************************************!*\
  !*** ./node_modules/side-channel/index.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");
var callBound = __webpack_require__(/*! call-bind/callBound */ "./node_modules/call-bind/callBound.js");
var inspect = __webpack_require__(/*! object-inspect */ "./node_modules/object-inspect/index.js");

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ "../../../node_modules/@gltf-transform/core/dist/core.modern.js":
/*!**********************************************************************!*\
  !*** ../../../node_modules/@gltf-transform/core/dist/core.modern.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Accessor": () => (/* binding */ P),
/* harmony export */   "Animation": () => (/* binding */ U),
/* harmony export */   "AnimationChannel": () => (/* binding */ k),
/* harmony export */   "AnimationSampler": () => (/* binding */ F),
/* harmony export */   "AttributeLink": () => (/* binding */ J),
/* harmony export */   "Buffer": () => (/* binding */ G),
/* harmony export */   "BufferUtils": () => (/* binding */ T),
/* harmony export */   "COPY_IDENTITY": () => (/* binding */ O),
/* harmony export */   "Camera": () => (/* binding */ j),
/* harmony export */   "ColorUtils": () => (/* binding */ y),
/* harmony export */   "Document": () => (/* binding */ ht),
/* harmony export */   "Extension": () => (/* binding */ ot),
/* harmony export */   "ExtensionProperty": () => (/* binding */ D),
/* harmony export */   "FileUtils": () => (/* binding */ A),
/* harmony export */   "Format": () => (/* binding */ a),
/* harmony export */   "GLB_BUFFER": () => (/* binding */ h),
/* harmony export */   "Graph": () => (/* binding */ d),
/* harmony export */   "GraphChild": () => (/* binding */ p),
/* harmony export */   "GraphChildList": () => (/* binding */ g),
/* harmony export */   "ImageUtils": () => (/* binding */ x),
/* harmony export */   "IndexLink": () => (/* binding */ z),
/* harmony export */   "Link": () => (/* binding */ f),
/* harmony export */   "Logger": () => (/* binding */ I),
/* harmony export */   "Material": () => (/* binding */ K),
/* harmony export */   "MathUtils": () => (/* binding */ M),
/* harmony export */   "Mesh": () => (/* binding */ Q),
/* harmony export */   "Node": () => (/* binding */ X),
/* harmony export */   "NodeIO": () => (/* binding */ yt),
/* harmony export */   "PlatformIO": () => (/* binding */ Tt),
/* harmony export */   "Primitive": () => (/* binding */ tt),
/* harmony export */   "PrimitiveTarget": () => (/* binding */ st),
/* harmony export */   "Property": () => (/* binding */ _),
/* harmony export */   "PropertyType": () => (/* binding */ o),
/* harmony export */   "ReaderContext": () => (/* binding */ ct),
/* harmony export */   "Root": () => (/* binding */ nt),
/* harmony export */   "Scene": () => (/* binding */ et),
/* harmony export */   "Skin": () => (/* binding */ it),
/* harmony export */   "Texture": () => (/* binding */ rt),
/* harmony export */   "TextureChannel": () => (/* binding */ c),
/* harmony export */   "TextureInfo": () => (/* binding */ W),
/* harmony export */   "TextureLink": () => (/* binding */ $),
/* harmony export */   "VERSION": () => (/* binding */ n),
/* harmony export */   "VertexLayout": () => (/* binding */ u),
/* harmony export */   "WebIO": () => (/* binding */ Et),
/* harmony export */   "WriterContext": () => (/* binding */ gt),
/* harmony export */   "bounds": () => (/* binding */ w),
/* harmony export */   "uuid": () => (/* binding */ C)
/* harmony export */ });
/* harmony import */ var gl_matrix_vec3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! gl-matrix/vec3 */ "../../../node_modules/gl-matrix/esm/vec3.js");
/* harmony import */ var gl_matrix_mat4__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! gl-matrix/mat4 */ "../../../node_modules/gl-matrix/esm/mat4.js");
const n="v1.2.4",h="@glb.bin";var o,u,c,a;function l(t,s,e,i){var r,n=arguments.length,h=n<3?s:null===i?i=Object.getOwnPropertyDescriptor(s,e):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)h=Reflect.decorate(t,s,e,i);else for(var o=t.length-1;o>=0;o--)(r=t[o])&&(h=(n<3?r(h):n>3?r(s,e,h):r(s,e))||h);return n>3&&h&&Object.defineProperty(s,e,h),h}!function(t){t.ACCESSOR="Accessor",t.ANIMATION="Animation",t.ANIMATION_CHANNEL="AnimationChannel",t.ANIMATION_SAMPLER="AnimationSampler",t.BUFFER="Buffer",t.CAMERA="Camera",t.MATERIAL="Material",t.MESH="Mesh",t.PRIMITIVE="Primitive",t.PRIMITIVE_TARGET="PrimitiveTarget",t.NODE="Node",t.ROOT="Root",t.SCENE="Scene",t.SKIN="Skin",t.TEXTURE="Texture",t.TEXTURE_INFO="TextureInfo"}(o||(o={})),function(t){t.INTERLEAVED="interleaved",t.SEPARATE="separate"}(u||(u={})),function(t){t[t.R=4096]="R",t[t.G=256]="G",t[t.B=16]="B",t[t.A=1]="A"}(c||(c={})),function(t){t.GLTF="GLTF",t.GLB="GLB"}(a||(a={}));class f{constructor(t,s,e){if(this.t=void 0,this.i=void 0,this.h=void 0,this.o=!1,this.u=[],this.t=t,this.i=s,this.h=e,!s.canLink(e))throw new Error("Cannot link disconnected graphs/documents.")}getName(){return this.t}getParent(){return this.i}getChild(){return this.h}setChild(t){return this.h=t,this}dispose(){this.o||(this.o=!0,this.u.forEach(t=>t()),this.u.length=0)}onDispose(t){return this.u.push(t),this}isDisposed(){return this.o}}class d{constructor(){this.l=new Set,this.p=new Set,this.g=new Map,this.v=new Map,this.u={}}on(t,s){return this.u[t]=this.u[t]||[],this.u[t].push(s),this}emit(t,s){for(const e of this.u[t]||[])e(s);return this}getLinks(){return Array.from(this.p)}listParentLinks(t){return Array.from(this.v.get(t)||this.l)}listParents(t){return this.listParentLinks(t).map(t=>t.getParent())}listChildLinks(t){return Array.from(this.g.get(t)||this.l)}listChildren(t){return this.listChildLinks(t).map(t=>t.getChild())}disconnectChildren(t){return(this.g.get(t)||this.l).forEach(t=>t.dispose()),this}disconnectParents(t,s){let e=Array.from(this.v.get(t)||this.l);return s&&(e=e.filter(t=>s(t.getParent()))),e.forEach(t=>t.dispose()),this}swapChild(t,s,e){const i=this.g.get(t)||this.l;return Array.from(i).filter(t=>t.getChild()===s).forEach(t=>{this.v.get(s).delete(t),t.setChild(e),this.v.has(e)||this.v.set(e,new Set),this.v.get(e).add(t)}),this}link(t,s,e){if(!e)return null;const i=new f(t,s,e);return this.registerLink(i),i}registerLink(t){this.p.add(t);const s=t.getParent();this.g.has(s)||this.g.set(s,new Set),this.g.get(s).add(t);const e=t.getChild();return this.v.has(e)||this.v.set(e,new Set),this.v.get(e).add(t),t.onDispose(()=>this.unlink(t)),t}unlink(t){return this.p.delete(t),this.g.get(t.getParent()).delete(t),this.v.get(t.getChild()).delete(t),this}}function p(t,s){Object.defineProperty(t,s,{get:function(){return this["__"+s]},set:function(t){const e=this["__"+s];e&&!Array.isArray(e)&&e.dispose(),t&&!Array.isArray(t)&&t.onDispose(()=>{this["__"+s]=null}),this["__"+s]=t},enumerable:!0})}function g(t,s){}function w(t){const s={min:[Infinity,Infinity,Infinity],max:[-Infinity,-Infinity,-Infinity]},e=t.propertyType===o.NODE?[t]:t.listChildren();for(const t of e)t.traverse(t=>{const e=t.getMesh();if(!e)return;const i=v(e,t.getWorldMatrix());m(i.min,s),m(i.max,s)});return s}function v(s,e){const i={min:[Infinity,Infinity,Infinity],max:[-Infinity,-Infinity,-Infinity]};for(const r of s.listPrimitives()){const s=r.getAttribute("POSITION");if(!s)continue;let n=[0,0,0],h=[0,0,0];for(let r=0;r<s.getCount();r++)n=s.getElement(r,n),h=(0,gl_matrix_vec3__WEBPACK_IMPORTED_MODULE_0__.transformMat4)(h,n,e),m(h,i)}return i}function m(t,s){for(let e=0;e<3;e++)s.min[e]=Math.min(t[e],s.min[e]),s.max[e]=Math.max(t[e],s.max[e])}class T{static createBufferFromDataURI(t){if("undefined"==typeof Buffer){const s=atob(t.split(",")[1]),e=new Uint8Array(s.length);for(let t=0;t<s.length;t++)e[t]=s.charCodeAt(t);return e.buffer}{const s=t.split(",")[1],e=t.indexOf("base64")>=0;return this.trim(Buffer.from(s,e?"base64":"utf8"))}}static encodeText(t){return"undefined"!=typeof TextEncoder?(new TextEncoder).encode(t).buffer:this.trim(Buffer.from(t))}static decodeText(t){return"undefined"!=typeof TextDecoder?(new TextDecoder).decode(t):Buffer.from(t).toString("utf8")}static trim(t){const{byteOffset:s,byteLength:e}=t;return t.buffer.slice(s,s+e)}static concat(t){let s=0;for(const e of t)s+=e.byteLength;const e=new Uint8Array(s);let i=0;for(const s of t)e.set(new Uint8Array(s),i),i+=s.byteLength;return e.buffer}static pad(t,s=0){const e=this.padNumber(t.byteLength);if(e!==t.byteLength){const i=new Uint8Array(e);if(i.set(new Uint8Array(t)),0!==s)for(let r=t.byteLength;r<e;r++)i[r]=s;return i.buffer}return t}static padNumber(t){return 4*Math.ceil(t/4)}static equals(t,s){if(t===s)return!0;if(t.byteLength!==s.byteLength)return!1;const e=new DataView(t),i=new DataView(s);let r=t.byteLength;for(;r--;)if(e.getUint8(r)!==i.getUint8(r))return!1;return!0}}class y{static hexToFactor(t,s){t=Math.floor(t);const e=s;return e[0]=(t>>16&255)/255,e[1]=(t>>8&255)/255,e[2]=(255&t)/255,this.convertSRGBToLinear(s,s)}static factorToHex(t){const s=[...t],[e,i,r]=this.convertLinearToSRGB(t,s);return 255*e<<16^255*i<<8^255*r<<0}static convertSRGBToLinear(t,s){const e=t,i=s;for(let t=0;t<3;t++)i[t]=e[t]<.04045?.0773993808*e[t]:Math.pow(.9478672986*e[t]+.0521327014,2.4);return s}static convertLinearToSRGB(t,s){const e=t,i=s;for(let t=0;t<3;t++)i[t]=e[t]<.0031308?12.92*e[t]:1.055*Math.pow(e[t],.41666)-.055;return s}}class A{static basename(t){const s=t.split(/[\\/]/).pop();return s.substr(0,s.lastIndexOf("."))}static extension(t){return 0!==t.indexOf("data:")?t.split(/[\\/]/).pop().split(/[.]/).pop():0===t.indexOf("data:image/png")?"png":0===t.indexOf("data:image/jpeg")?"jpeg":"bin"}}class E{match(t){const s=new Uint8Array(t);return s.length>=8&&137===s[0]&&80===s[1]&&78===s[2]&&71===s[3]&&13===s[4]&&10===s[5]&&26===s[6]&&10===s[7]}getSize(t){const s=new DataView(t);return T.decodeText(t.slice(12,16))===E.PNG_FRIED_CHUNK_NAME?[s.getUint32(32,!1),s.getUint32(36,!1)]:[s.getUint32(16,!1),s.getUint32(20,!1)]}getChannels(t){return 4}}E.PNG_FRIED_CHUNK_NAME="CgBI";class x{static registerFormat(t,s){this.impls[t]=s}static getMimeType(t){for(const s in this.impls)if(this.impls[s].match(t))return s;return null}static getSize(t,s){return this.impls[s]?this.impls[s].getSize(t):null}static getChannels(t,s){return this.impls[s]?this.impls[s].getChannels(t):null}static getMemSize(t,s){if(!this.impls[s])return null;if(this.impls[s].getGPUByteLength)return this.impls[s].getGPUByteLength(t);let e=0;const i=this.getSize(t,s);if(!i)return null;for(;i[0]>1||i[1]>1;)e+=i[0]*i[1]*4,i[0]=Math.max(Math.floor(i[0]/2),1),i[1]=Math.max(Math.floor(i[1]/2),1);return e+=4,e}static mimeTypeToExtension(t){return"image/jpeg"===t?"jpg":t.split("/").pop()}static extensionToMimeType(t){return"jpg"===t?"image/jpeg":`image/${t}`}}function S(t,s){if(s>t.byteLength)throw new TypeError("Corrupt JPG, exceeded buffer limits");if(255!==t.getUint8(s))throw new TypeError("Invalid JPG, marker table corrupted");return t}x.impls={"image/jpeg":new class{match(t){const s=new Uint8Array(t);return s.length>=3&&255===s[0]&&216===s[1]&&255===s[2]}getSize(t){let s,e,i=new DataView(t,4);for(;i.byteLength;){if(s=i.getUint16(0,!1),S(i,s),e=i.getUint8(s+1),192===e||193===e||194===e)return[i.getUint16(s+7,!1),i.getUint16(s+5,!1)];i=new DataView(t,i.byteOffset+s+2)}throw new TypeError("Invalid JPG, no size found")}getChannels(t){return 3}},"image/png":new E};class M{static identity(t){return t}static eq(t,s){if(t.length!==s.length)return!1;for(let e=0;e<t.length;e++)if(Math.abs(t[e]-s[e])>1e-5)return!1;return!0}static denormalize(t,s){switch(s){case 5126:return t;case 5123:return t/65535;case 5121:return t/255;case 5122:return Math.max(t/32767,-1);case 5120:return Math.max(t/127,-1);default:throw new Error("Invalid component type.")}}static normalize(t,s){switch(s){case 5126:return t;case 5123:return Math.round(65535*t);case 5121:return Math.round(255*t);case 5122:return Math.round(32767*t);case 5120:return Math.round(127*t);default:throw new Error("Invalid component type.")}}static decompose(t,r,n,h){let o=(0,gl_matrix_vec3__WEBPACK_IMPORTED_MODULE_0__.length)([t[0],t[1],t[2]]);const u=(0,gl_matrix_vec3__WEBPACK_IMPORTED_MODULE_0__.length)([t[4],t[5],t[6]]),c=(0,gl_matrix_vec3__WEBPACK_IMPORTED_MODULE_0__.length)([t[8],t[9],t[10]]);(0,gl_matrix_mat4__WEBPACK_IMPORTED_MODULE_1__.determinant)(t)<0&&(o=-o),r[0]=t[12],r[1]=t[13],r[2]=t[14];const a=t.slice(),l=1/o,f=1/u,d=1/c;a[0]*=l,a[1]*=l,a[2]*=l,a[4]*=f,a[5]*=f,a[6]*=f,a[8]*=d,a[9]*=d,a[10]*=d,(0,gl_matrix_mat4__WEBPACK_IMPORTED_MODULE_1__.getRotation)(n,a),h[0]=o,h[1]=u,h[2]=c}static compose(t,s,e,i){const r=i,n=s[0],h=s[1],o=s[2],u=s[3],c=n+n,a=h+h,l=o+o,f=n*c,d=n*a,p=n*l,g=h*a,w=h*l,v=o*l,m=u*c,T=u*a,y=u*l,A=e[0],E=e[1],x=e[2];return r[0]=(1-(g+v))*A,r[1]=(d+y)*A,r[2]=(p-T)*A,r[3]=0,r[4]=(d-y)*E,r[5]=(1-(f+v))*E,r[6]=(w+m)*E,r[7]=0,r[8]=(p+T)*x,r[9]=(w-m)*x,r[10]=(1-(f+g))*x,r[11]=0,r[12]=t[0],r[13]=t[1],r[14]=t[2],r[15]=1,r}}class I{constructor(t){this.verbosity=void 0,this.verbosity=t}debug(t){this.verbosity<=I.Verbosity.DEBUG&&console.debug(t)}info(t){this.verbosity<=I.Verbosity.INFO&&console.info(t)}warn(t){this.verbosity<=I.Verbosity.WARN&&console.warn(t)}error(t){this.verbosity<=I.Verbosity.ERROR&&console.error(t)}}I.Verbosity={SILENT:4,ERROR:3,WARN:2,INFO:1,DEBUG:0},I.DEFAULT_INSTANCE=new I(I.Verbosity.INFO);const b="23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ",R=new Set,N=function(){let t="";for(let s=0;s<6;s++)t+=b.charAt(Math.floor(Math.random()*b.length));return t},C=function(){for(let t=0;t<999;t++){const t=N();if(!R.has(t))return R.add(t),t}return""},O=t=>t;class _ extends class{constructor(t){this.graph=void 0,this.o=!1,this.graph=t,this.graph=t}canLink(t){return this.graph===t.graph}isDisposed(){return this.o}dispose(){this.graph.disconnectChildren(this),this.graph.disconnectParents(this),this.o=!0,this.graph.emit("dispose",this)}detach(){return this.graph.disconnectParents(this),this}swap(t,s){return this.graph.swapChild(this,t,s),this}addGraphChild(t,s){return t.push(s),s.onDispose(()=>{const e=t.filter(t=>t!==s);t.length=0;for(const s of e)t.push(s)}),this}removeGraphChild(t,s){return t.filter(t=>t.getChild()===s).forEach(t=>t.dispose()),this}clearGraphChildList(t){for(;t.length>0;)t[0].dispose();return this}listGraphParents(){return this.graph.listParents(this)}}{constructor(t,s=""){super(t),this.graph=void 0,this.m={},this.t="",this.graph=t,this.t=s}getName(){return this.t}setName(t){return this.t=t,this}getExtras(){return this.m}setExtras(t){return this.m=t,this}clone(){const t=new(0,this.constructor)(this.graph).copy(this,O);return this.graph.emit("clone",t),t}copy(t,s=O){return this.t=t.t,this.m=JSON.parse(JSON.stringify(t.m)),this}detach(){return this.graph.disconnectParents(this,t=>"Root"!==t.propertyType),this}listParents(){return this.listGraphParents()}}const B="Pass extension name (string) as lookup token, not a constructor.";class L extends _{constructor(...t){super(...t),this.extensions=[]}copy(t,s=O){return super.copy(t,s),this.clearGraphChildList(this.extensions),t.extensions.forEach(t=>{const e=t.getChild();this.setExtension(e.extensionName,s(e))}),this}getExtension(t){if("string"!=typeof t)throw new Error(B);const s=this.extensions.find(s=>s.getChild().extensionName===t);return s?s.getChild():null}setExtension(t,s){if("string"!=typeof t)throw new Error(B);const e=this.getExtension(t);return e&&this.removeGraphChild(this.extensions,e),s?(s.T(this),this.addGraphChild(this.extensions,this.graph.link(t,this,s))):this}listExtensions(){return this.extensions.map(t=>t.getChild())}}l([g],L.prototype,"extensions",void 0);class P extends L{constructor(...t){super(...t),this.propertyType=o.ACCESSOR,this.S=null,this.M=P.Type.SCALAR,this.I=P.ComponentType.FLOAT,this.N=!1,this.C=M.identity,this.O=M.identity,this.buffer=null}copy(t,s=O){return super.copy(t,s),this.M=t.M,this.I=t.I,this.N=t.N,this.C=t.C,this.O=t.O,t.S&&(this.S=t.S.slice()),this.setBuffer(t.buffer?s(t.buffer.getChild()):null),this}static getElementSize(t){switch(t){case P.Type.SCALAR:return 1;case P.Type.VEC2:return 2;case P.Type.VEC3:return 3;case P.Type.VEC4:case P.Type.MAT2:return 4;case P.Type.MAT3:return 9;case P.Type.MAT4:return 16;default:throw new Error("Unexpected type: "+t)}}static getComponentSize(t){switch(t){case P.ComponentType.BYTE:case P.ComponentType.UNSIGNED_BYTE:return 1;case P.ComponentType.SHORT:case P.ComponentType.UNSIGNED_SHORT:return 2;case P.ComponentType.UNSIGNED_INT:case P.ComponentType.FLOAT:return 4;default:throw new Error("Unexpected component type: "+t)}}getMinNormalized(t){const s=this.getElementSize();this.getMin(t);for(let e=0;e<s;e++)t[e]=this.O(t[e]);return t}getMin(t){const s=this.getCount(),e=this.getElementSize();for(let s=0;s<e;s++)t[s]=Infinity;for(let i=0;i<s*e;i+=e)for(let s=0;s<e;s++){const e=this.S[i+s];Number.isFinite(e)&&(t[s]=Math.min(t[s],e))}return t}getMaxNormalized(t){const s=this.getElementSize();this.getMax(t);for(let e=0;e<s;e++)t[e]=this.O(t[e]);return t}getMax(t){const s=this.getCount(),e=this.getElementSize();for(let s=0;s<e;s++)t[s]=-Infinity;for(let i=0;i<s*e;i+=e)for(let s=0;s<e;s++){const e=this.S[i+s];Number.isFinite(e)&&(t[s]=Math.max(t[s],e))}return t}getCount(){return this.S?this.S.length/this.getElementSize():0}getType(){return this.M}setType(t){return this.M=t,this}getElementSize(){return P.getElementSize(this.M)}getComponentSize(){return this.S.BYTES_PER_ELEMENT}getComponentType(){return this.I}getNormalized(){return this.N}setNormalized(t){return this.N=t,t?(this.O=t=>M.denormalize(t,this.I),this.C=t=>M.normalize(t,this.I)):(this.O=M.identity,this.C=M.identity),this}getScalar(t){const s=this.getElementSize();return this.O(this.S[t*s])}setScalar(t,s){return this.S[t*this.getElementSize()]=this.C(s),this}getElement(t,s){const e=this.getElementSize();for(let i=0;i<e;i++)s[i]=this.O(this.S[t*e+i]);return s}setElement(t,s){const e=this.getElementSize();for(let i=0;i<e;i++)this.S[t*e+i]=this.C(s[i]);return this}getBuffer(){return this.buffer?this.buffer.getChild():null}setBuffer(t){return this.buffer=this.graph.link("buffer",this,t),this}getArray(){return this.S}setArray(t){return this.I=t?function(t){switch(t.constructor){case Float32Array:return P.ComponentType.FLOAT;case Uint32Array:return P.ComponentType.UNSIGNED_INT;case Uint16Array:return P.ComponentType.UNSIGNED_SHORT;case Uint8Array:return P.ComponentType.UNSIGNED_BYTE;case Int16Array:return P.ComponentType.SHORT;case Int8Array:return P.ComponentType.BYTE;default:throw new Error("Unknown accessor componentType.")}}(t):P.ComponentType.FLOAT,this.S=t,this}getByteLength(){return this.S?this.S.byteLength:0}}P.Type={SCALAR:"SCALAR",VEC2:"VEC2",VEC3:"VEC3",VEC4:"VEC4",MAT2:"MAT2",MAT3:"MAT3",MAT4:"MAT4"},P.ComponentType={BYTE:5120,UNSIGNED_BYTE:5121,SHORT:5122,UNSIGNED_SHORT:5123,UNSIGNED_INT:5125,FLOAT:5126},l([p],P.prototype,"buffer",void 0);class U extends L{constructor(...t){super(...t),this.propertyType=o.ANIMATION,this.channels=[],this.samplers=[]}copy(t,s=O){return super.copy(t,s),this.clearGraphChildList(this.channels),this.clearGraphChildList(this.samplers),t.channels.forEach(t=>this.addChannel(s(t.getChild()))),t.samplers.forEach(t=>this.addSampler(s(t.getChild()))),this}addChannel(t){const s=this.graph.link("channel",this,t);return this.addGraphChild(this.channels,s)}removeChannel(t){return this.removeGraphChild(this.channels,t)}listChannels(){return this.channels.map(t=>t.getChild())}addSampler(t){const s=this.graph.link("sampler",this,t);return this.addGraphChild(this.samplers,s)}removeSampler(t){return this.removeGraphChild(this.samplers,t)}listSamplers(){return this.samplers.map(t=>t.getChild())}}l([g],U.prototype,"channels",void 0),l([g],U.prototype,"samplers",void 0);class k extends _{constructor(...t){super(...t),this.propertyType=o.ANIMATION_CHANNEL,this._=null,this.targetNode=null,this.sampler=null}copy(t,s=O){return super.copy(t,s),this._=t._,this.setTargetNode(t.targetNode?s(t.targetNode.getChild()):null),this.setSampler(t.sampler?s(t.sampler.getChild()):null),this}getTargetPath(){return this._}setTargetPath(t){return this._=t,this}getTargetNode(){return this.targetNode?this.targetNode.getChild():null}setTargetNode(t){return this.targetNode=this.graph.link("target.node",this,t),this}getSampler(){return this.sampler?this.sampler.getChild():null}setSampler(t){return this.sampler=this.graph.link("sampler",this,t),this}}k.TargetPath={TRANSLATION:"translation",ROTATION:"rotation",SCALE:"scale",WEIGHTS:"weights"},l([p],k.prototype,"targetNode",void 0),l([p],k.prototype,"sampler",void 0);class F extends _{constructor(...t){super(...t),this.propertyType=o.ANIMATION_SAMPLER,this.L=F.Interpolation.LINEAR,this.input=null,this.output=null}copy(t,s=O){return super.copy(t,s),this.L=t.L,this.setInput(t.input?s(t.input.getChild()):null),this.setOutput(t.output?s(t.output.getChild()):null),this}getInterpolation(){return this.L}setInterpolation(t){return this.L=t,this}getInput(){return this.input?this.input.getChild():null}setInput(t){return this.input=this.graph.link("input",this,t),this}getOutput(){return this.output?this.output.getChild():null}setOutput(t){return this.output=this.graph.link("output",this,t),this}}F.Interpolation={LINEAR:"LINEAR",STEP:"STEP",CUBICSPLINE:"CUBICSPLINE"},l([p],F.prototype,"input",void 0),l([p],F.prototype,"output",void 0);class G extends L{constructor(...t){super(...t),this.propertyType=o.BUFFER,this.P=""}copy(t,s=O){return super.copy(t,s),this.P=t.P,this}getURI(){return this.P}setURI(t){return this.P=t,this}}class j extends L{constructor(...t){super(...t),this.propertyType=o.CAMERA,this.M=j.Type.PERSPECTIVE,this.U=.1,this.k=100,this.F=null,this.j=2*Math.PI*50/360,this.D=1,this.J=1}copy(t,s=O){return super.copy(t,s),this.M=t.M,this.U=t.U,this.k=t.k,this.F=t.F,this.j=t.j,this.D=t.D,this.J=t.J,this}getType(){return this.M}setType(t){return this.M=t,this}getZNear(){return this.U}setZNear(t){return this.U=t,this}getZFar(){return this.k}setZFar(t){return this.k=t,this}getAspectRatio(){return this.F}setAspectRatio(t){return this.F=t,this}getYFov(){return this.j}setYFov(t){return this.j=t,this}getXMag(){return this.D}setXMag(t){return this.D=t,this}getYMag(){return this.J}setYMag(t){return this.J=t,this}}j.Type={PERSPECTIVE:"perspective",ORTHOGRAPHIC:"orthographic"};class D extends _{constructor(t,s){super(t),this.$=void 0,this.$=s,this.$.addExtensionProperty(this)}clone(){const t=new(0,this.constructor)(this.graph,this.$).copy(this,O);return this.graph.emit("clone",t),t}dispose(){this.$.removeExtensionProperty(this),super.dispose()}T(t){if(!this.parentTypes.includes(t.propertyType))throw new Error(`Parent "${t.propertyType}" invalid for child "${this.propertyType}".`)}}D.EXTENSION_NAME=void 0;class J extends f{constructor(...t){super(...t),this.semantic=""}copy(t){return this.semantic=t.semantic,this}}class z extends f{copy(t){return this}}class $ extends f{constructor(...t){super(...t),this.channels=0}copy(t){return this.channels=t.channels,this}}class V extends d{linkAttribute(t,s,e){if(!e)return null;const i=new J(t,s,e);return i.semantic=t,this.registerLink(i),i}linkIndex(t,s,e){if(!e)return null;const i=new z(t,s,e);return this.registerLink(i),i}linkTexture(t,s,e,i){if(!i)return null;const r=new $(t,e,i);return r.channels=s,this.registerLink(r),r}}class W extends L{constructor(...t){super(...t),this.propertyType=o.TEXTURE_INFO,this.V=0,this.W=null,this.q=null,this.Y=W.WrapMode.REPEAT,this.H=W.WrapMode.REPEAT}copy(t,s=O){return super.copy(t,s),this.V=t.V,this.W=t.W,this.q=t.q,this.Y=t.Y,this.H=t.H,this}equals(t){return this.getTexCoord()===t.getTexCoord()&&this.getMagFilter()===t.getMagFilter()&&this.getMinFilter()===t.getMinFilter()&&this.getWrapS()===t.getWrapS()&&this.getWrapT()===t.getWrapT()}getTexCoord(){return this.V}setTexCoord(t){return this.V=t,this}getMagFilter(){return this.W}setMagFilter(t){return this.W=t,this}getMinFilter(){return this.q}setMinFilter(t){return this.q=t,this}getWrapS(){return this.Y}setWrapS(t){return this.Y=t,this}getWrapT(){return this.H}setWrapT(t){return this.H=t,this}}W.WrapMode={CLAMP_TO_EDGE:33071,MIRRORED_REPEAT:33648,REPEAT:10497},W.MagFilter={NEAREST:9728,LINEAR:9729},W.MinFilter={NEAREST:9728,LINEAR:9729,NEAREST_MIPMAP_NEAREST:9984,LINEAR_MIPMAP_NEAREST:9985,NEAREST_MIPMAP_LINEAR:9986,LINEAR_MIPMAP_LINEAR:9987};const{R:q,G:Y,B:H,A:Z}=c;class K extends L{constructor(...t){super(...t),this.propertyType=o.MATERIAL,this.Z=K.AlphaMode.OPAQUE,this.K=.5,this.X=!1,this.tt=[1,1,1,1],this.st=[0,0,0],this.et=1,this.it=1,this.rt=1,this.nt=1,this.baseColorTexture=null,this.baseColorTextureInfo=this.graph.link("baseColorTextureInfo",this,new W(this.graph)),this.emissiveTexture=null,this.emissiveTextureInfo=this.graph.link("emissiveTextureInfo",this,new W(this.graph)),this.normalTexture=null,this.normalTextureInfo=this.graph.link("normalTextureInfo",this,new W(this.graph)),this.occlusionTexture=null,this.occlusionTextureInfo=this.graph.link("occlusionTextureInfo",this,new W(this.graph)),this.metallicRoughnessTexture=null,this.metallicRoughnessTextureInfo=this.graph.link("metallicRoughnessTextureInfo",this,new W(this.graph))}copy(t,s=O){return super.copy(t,s),this.Z=t.Z,this.K=t.K,this.X=t.X,this.tt=[...t.tt],this.st=[...t.st],this.et=t.et,this.it=t.it,this.rt=t.rt,this.nt=t.nt,this.setBaseColorTexture(t.baseColorTexture?s(t.baseColorTexture.getChild()):null),this.baseColorTextureInfo.getChild().copy(s(t.baseColorTextureInfo.getChild()),s),this.setEmissiveTexture(t.emissiveTexture?s(t.emissiveTexture.getChild()):null),this.emissiveTextureInfo.getChild().copy(s(t.emissiveTextureInfo.getChild()),s),this.setNormalTexture(t.normalTexture?s(t.normalTexture.getChild()):null),this.normalTextureInfo.getChild().copy(s(t.normalTextureInfo.getChild()),s),this.setOcclusionTexture(t.occlusionTexture?s(t.occlusionTexture.getChild()):null),this.occlusionTextureInfo.getChild().copy(s(t.occlusionTextureInfo.getChild()),s),this.setMetallicRoughnessTexture(t.metallicRoughnessTexture?s(t.metallicRoughnessTexture.getChild()):null),this.metallicRoughnessTextureInfo.getChild().copy(s(t.metallicRoughnessTextureInfo.getChild()),s),this}equals(t){if(this.getAlphaMode()!==t.getAlphaMode())return!1;if(this.getAlphaCutoff()!==t.getAlphaCutoff())return!1;if(this.getDoubleSided()!==t.getDoubleSided())return!1;if(!M.eq(this.getBaseColorFactor(),t.getBaseColorFactor()))return!1;if(!M.eq(this.getEmissiveFactor(),t.getEmissiveFactor()))return!1;if(this.getNormalScale()!==t.getNormalScale())return!1;if(this.getOcclusionStrength()!==t.getOcclusionStrength())return!1;if(this.getRoughnessFactor()!==t.getRoughnessFactor())return!1;if(this.getMetallicFactor()!==t.getMetallicFactor())return!1;if(this.getBaseColorTexture()||t.getBaseColorTexture()){if(this.getBaseColorTexture()!==t.getBaseColorTexture())return!1;if(this.getBaseColorTexture()&&!this.getBaseColorTextureInfo().equals(t.getBaseColorTextureInfo()))return!1}if(this.getEmissiveTexture()||t.getEmissiveTexture()){if(this.getEmissiveTexture()!==t.getEmissiveTexture())return!1;if(this.getEmissiveTexture()&&!this.getEmissiveTextureInfo().equals(t.getEmissiveTextureInfo()))return!1}if(this.getNormalTexture()||t.getNormalTexture()){if(this.getNormalTexture()!==t.getNormalTexture())return!1;if(this.getNormalTexture()&&!this.getNormalTextureInfo().equals(t.getNormalTextureInfo()))return!1}if(this.getOcclusionTexture()||t.getOcclusionTexture()){if(this.getOcclusionTexture()!==t.getOcclusionTexture())return!1;if(this.getOcclusionTexture()&&!this.getOcclusionTextureInfo().equals(t.getOcclusionTextureInfo()))return!1}if(this.getMetallicRoughnessTexture()||t.getMetallicRoughnessTexture()){if(this.getMetallicRoughnessTexture()!==t.getMetallicRoughnessTexture())return!1;if(this.getMetallicRoughnessTexture()&&!this.getMetallicRoughnessTextureInfo().equals(t.getMetallicRoughnessTextureInfo()))return!1}const s=this.listExtensions(),e=t.listExtensions();if(s.length!==e.length)return!1;for(let t=0;t<s.length;t++)if(s[t]!==e[t])return!1;return!0}dispose(){this.baseColorTextureInfo.getChild().dispose(),this.emissiveTextureInfo.getChild().dispose(),this.normalTextureInfo.getChild().dispose(),this.occlusionTextureInfo.getChild().dispose(),this.metallicRoughnessTextureInfo.getChild().dispose(),super.dispose()}getDoubleSided(){return this.X}setDoubleSided(t){return this.X=t,this}getAlpha(){return this.tt[3]}setAlpha(t){return this.tt[3]=t,this}getAlphaMode(){return this.Z}setAlphaMode(t){return this.Z=t,this}getAlphaCutoff(){return this.K}setAlphaCutoff(t){return this.K=t,this}getBaseColorFactor(){return this.tt}setBaseColorFactor(t){return this.tt=t,this}getBaseColorHex(){return y.factorToHex(this.tt)}setBaseColorHex(t){return y.hexToFactor(t,this.tt),this}getBaseColorTexture(){return this.baseColorTexture?this.baseColorTexture.getChild():null}getBaseColorTextureInfo(){return this.baseColorTexture?this.baseColorTextureInfo.getChild():null}setBaseColorTexture(t){return this.baseColorTexture=this.graph.linkTexture("baseColorTexture",q|Y|H|Z,this,t),this}getEmissiveFactor(){return this.st}setEmissiveFactor(t){return this.st=t,this}getEmissiveHex(){return y.factorToHex(this.st)}setEmissiveHex(t){return y.hexToFactor(t,this.st),this}getEmissiveTexture(){return this.emissiveTexture?this.emissiveTexture.getChild():null}getEmissiveTextureInfo(){return this.emissiveTexture?this.emissiveTextureInfo.getChild():null}setEmissiveTexture(t){return this.emissiveTexture=this.graph.linkTexture("emissiveTexture",q|Y|H,this,t),this}getNormalScale(){return this.et}setNormalScale(t){return this.et=t,this}getNormalTexture(){return this.normalTexture?this.normalTexture.getChild():null}getNormalTextureInfo(){return this.normalTexture?this.normalTextureInfo.getChild():null}setNormalTexture(t){return this.normalTexture=this.graph.linkTexture("normalTexture",q|Y|H,this,t),this}getOcclusionStrength(){return this.it}setOcclusionStrength(t){return this.it=t,this}getOcclusionTexture(){return this.occlusionTexture?this.occlusionTexture.getChild():null}getOcclusionTextureInfo(){return this.occlusionTexture?this.occlusionTextureInfo.getChild():null}setOcclusionTexture(t){return this.occlusionTexture=this.graph.linkTexture("occlusionTexture",q,this,t),this}getRoughnessFactor(){return this.rt}setRoughnessFactor(t){return this.rt=t,this}getMetallicFactor(){return this.nt}setMetallicFactor(t){return this.nt=t,this}getMetallicRoughnessTexture(){return this.metallicRoughnessTexture?this.metallicRoughnessTexture.getChild():null}getMetallicRoughnessTextureInfo(){return this.metallicRoughnessTexture?this.metallicRoughnessTextureInfo.getChild():null}setMetallicRoughnessTexture(t){return this.metallicRoughnessTexture=this.graph.linkTexture("metallicRoughnessTexture",Y|H,this,t),this}}K.AlphaMode={OPAQUE:"OPAQUE",MASK:"MASK",BLEND:"BLEND"},l([p],K.prototype,"baseColorTexture",void 0),l([p],K.prototype,"baseColorTextureInfo",void 0),l([p],K.prototype,"emissiveTexture",void 0),l([p],K.prototype,"emissiveTextureInfo",void 0),l([p],K.prototype,"normalTexture",void 0),l([p],K.prototype,"normalTextureInfo",void 0),l([p],K.prototype,"occlusionTexture",void 0),l([p],K.prototype,"occlusionTextureInfo",void 0),l([p],K.prototype,"metallicRoughnessTexture",void 0),l([p],K.prototype,"metallicRoughnessTextureInfo",void 0);class Q extends L{constructor(...t){super(...t),this.propertyType=o.MESH,this.ht=[],this.primitives=[]}copy(t,s=O){return super.copy(t,s),this.ht=[...t.ht],this.clearGraphChildList(this.primitives),t.primitives.forEach(t=>this.addPrimitive(s(t.getChild()))),this}addPrimitive(t){return this.addGraphChild(this.primitives,this.graph.link("primitive",this,t))}removePrimitive(t){return this.removeGraphChild(this.primitives,t)}listPrimitives(){return this.primitives.map(t=>t.getChild())}getWeights(){return this.ht}setWeights(t){return this.ht=t,this}}l([g],Q.prototype,"primitives",void 0);class X extends L{constructor(...t){super(...t),this.propertyType=o.NODE,this.ot=[0,0,0],this.ut=[0,0,0,1],this.ct=[1,1,1],this.ht=[],this.i=null,this.camera=null,this.mesh=null,this.skin=null,this.children=[]}copy(t,s=O){return super.copy(t,s),this.ot=[...t.ot],this.ut=[...t.ut],this.ct=[...t.ct],this.ht=[...t.ht],this.setCamera(t.camera?s(t.camera.getChild()):null),this.setMesh(t.mesh?s(t.mesh.getChild()):null),this.setSkin(t.skin?s(t.skin.getChild()):null),s!==O&&(this.clearGraphChildList(this.children),t.children.forEach(t=>this.addChild(s(t.getChild())))),this}getTranslation(){return this.ot}getRotation(){return this.ut}getScale(){return this.ct}setTranslation(t){return this.ot=t,this}setRotation(t){return this.ut=t,this}setScale(t){return this.ct=t,this}getMatrix(){return M.compose(this.ot,this.ut,this.ct,[])}setMatrix(t){return M.decompose(t,this.ot,this.ut,this.ct),this}getWorldTranslation(){const t=[0,0,0];return M.decompose(this.getWorldMatrix(),t,[0,0,0,1],[1,1,1]),t}getWorldRotation(){const t=[0,0,0,1];return M.decompose(this.getWorldMatrix(),[0,0,0],t,[1,1,1]),t}getWorldScale(){const t=[1,1,1];return M.decompose(this.getWorldMatrix(),[0,0,0],[0,0,0,1],t),t}getWorldMatrix(){const t=[];for(let s=this;s instanceof X;s=s.i)t.push(s);let s;const e=t.pop().getMatrix();for(;s=t.pop();)(0,gl_matrix_mat4__WEBPACK_IMPORTED_MODULE_1__.multiply)(e,e,s.getMatrix());return e}addChild(t){t.i&&t.i.removeChild(t);const s=this.graph.link("child",this,t);return this.addGraphChild(this.children,s),t.i=this,s.onDispose(()=>t.i=null),this}removeChild(t){return this.removeGraphChild(this.children,t)}listChildren(){return this.children.map(t=>t.getChild())}getParent(){return this.i}getMesh(){return this.mesh?this.mesh.getChild():null}setMesh(t){return this.mesh=this.graph.link("mesh",this,t),this}getCamera(){return this.camera?this.camera.getChild():null}setCamera(t){return this.camera=this.graph.link("camera",this,t),this}getSkin(){return this.skin?this.skin.getChild():null}setSkin(t){return this.skin=this.graph.link("skin",this,t),this}getWeights(){return this.ht}setWeights(t){return this.ht=t,this}traverse(t){t(this);for(const s of this.listChildren())s.traverse(t);return this}}l([p],X.prototype,"camera",void 0),l([p],X.prototype,"mesh",void 0),l([p],X.prototype,"skin",void 0),l([g],X.prototype,"children",void 0);class tt extends L{constructor(...t){super(...t),this.propertyType=o.PRIMITIVE,this.at=tt.Mode.TRIANGLES,this.material=null,this.indices=null,this.attributes=[],this.targets=[]}copy(t,s=O){return super.copy(t,s),this.at=t.at,this.setIndices(t.indices?s(t.indices.getChild()):null),this.setMaterial(t.material?s(t.material.getChild()):null),this.clearGraphChildList(this.attributes),t.listSemantics().forEach(e=>{this.setAttribute(e,s(t.getAttribute(e)))}),this.clearGraphChildList(this.targets),t.targets.forEach(t=>this.addTarget(s(t.getChild()))),this}getIndices(){return this.indices?this.indices.getChild():null}setIndices(t){return this.indices=this.graph.linkIndex("indices",this,t),this}getAttribute(t){const s=this.attributes.find(s=>s.semantic===t);return s?s.getChild():null}setAttribute(t,s){const e=this.getAttribute(t);if(e&&this.removeGraphChild(this.attributes,e),!s)return this;const i=this.graph.linkAttribute(t,this,s);return this.addGraphChild(this.attributes,i)}listAttributes(){return this.attributes.map(t=>t.getChild())}listSemantics(){return this.attributes.map(t=>t.semantic)}getMaterial(){return this.material?this.material.getChild():null}setMaterial(t){return this.material=this.graph.link("material",this,t),this}getMode(){return this.at}setMode(t){return this.at=t,this}listTargets(){return this.targets.map(t=>t.getChild())}addTarget(t){return this.addGraphChild(this.targets,this.graph.link("target",this,t)),this}removeTarget(t){return this.removeGraphChild(this.targets,t)}}tt.Mode={POINTS:0,LINES:1,LINE_LOOP:2,LINE_STRIP:3,TRIANGLES:4,TRIANGLE_STRIP:5,TRIANGLE_FAN:6},l([p],tt.prototype,"material",void 0),l([p],tt.prototype,"indices",void 0),l([g],tt.prototype,"attributes",void 0),l([g],tt.prototype,"targets",void 0);class st extends _{constructor(...t){super(...t),this.propertyType=o.PRIMITIVE_TARGET,this.attributes=[]}copy(t,s=O){return super.copy(t,s),this.clearGraphChildList(this.attributes),t.listSemantics().forEach(e=>{this.setAttribute(e,s(t.getAttribute(e)))}),this}getAttribute(t){const s=this.attributes.find(s=>s.semantic===t);return s?s.getChild():null}setAttribute(t,s){const e=this.getAttribute(t);if(e&&this.removeGraphChild(this.attributes,e),!s)return this;const i=this.graph.linkAttribute(t,this,s);return i.semantic=t,this.addGraphChild(this.attributes,i)}listAttributes(){return this.attributes.map(t=>t.getChild())}listSemantics(){return this.attributes.map(t=>t.semantic)}}l([g],st.prototype,"attributes",void 0);class et extends L{constructor(...t){super(...t),this.propertyType=o.SCENE,this.children=[]}copy(t,s=O){return super.copy(t,s),s!==O&&(this.clearGraphChildList(this.children),t.children.forEach(t=>this.addChild(s(t.getChild())))),this}addChild(t){t.i&&t.i.removeChild(t);const s=this.graph.link("child",this,t);return this.addGraphChild(this.children,s),t.i=this,s.onDispose(()=>t.i=null),this}removeChild(t){return this.removeGraphChild(this.children,t)}listChildren(){return this.children.map(t=>t.getChild())}traverse(t){for(const s of this.listChildren())s.traverse(t);return this}}l([g],et.prototype,"children",void 0);class it extends L{constructor(...t){super(...t),this.propertyType=o.SKIN,this.skeleton=null,this.inverseBindMatrices=null,this.joints=[]}copy(t,s=O){return super.copy(t,s),this.setSkeleton(t.skeleton?s(t.skeleton.getChild()):null),this.setInverseBindMatrices(t.inverseBindMatrices?s(t.inverseBindMatrices.getChild()):null),this.clearGraphChildList(this.joints),t.joints.forEach(t=>this.addJoint(s(t.getChild()))),this}getSkeleton(){return this.skeleton?this.skeleton.getChild():null}setSkeleton(t){return this.skeleton=this.graph.link("skeleton",this,t),this}getInverseBindMatrices(){return this.inverseBindMatrices?this.inverseBindMatrices.getChild():null}setInverseBindMatrices(t){return this.inverseBindMatrices=this.graph.link("inverseBindMatrices",this,t),this}addJoint(t){const s=this.graph.link("joint",this,t);return this.addGraphChild(this.joints,s)}removeJoint(t){return this.removeGraphChild(this.joints,t)}listJoints(){return this.joints.map(t=>t.getChild())}}l([p],it.prototype,"skeleton",void 0),l([p],it.prototype,"inverseBindMatrices",void 0),l([g],it.prototype,"joints",void 0);class rt extends L{constructor(...t){super(...t),this.propertyType=o.TEXTURE,this.lt=null,this.ft="",this.P=""}copy(t,s=O){return super.copy(t,s),this.ft=t.ft,this.P=t.P,t.lt&&(this.lt=t.lt.slice(0)),this}getMimeType(){return this.ft||x.extensionToMimeType(A.extension(this.P))}setMimeType(t){return this.ft=t,this}getURI(){return this.P}setURI(t){return this.P=t,this.ft=x.extensionToMimeType(A.extension(t)),this}getImage(){return this.lt}setImage(t){return this.lt=t,this}getSize(){return this.lt?x.getSize(this.lt,this.getMimeType()):null}}class nt extends _{constructor(t){super(t),this.propertyType=o.ROOT,this.dt={generator:"glTF-Transform v1.2.4",version:"2.0"},this.gt=new Set,this.defaultScene=null,this.accessors=[],this.animations=[],this.buffers=[],this.cameras=[],this.materials=[],this.meshes=[],this.nodes=[],this.scenes=[],this.skins=[],this.textures=[],t.on("clone",t=>this.wt(t))}clone(){throw new Error("Root cannot be cloned.")}copy(t,s=O){if(super.copy(t,s),s===O)throw new Error("Root cannot be copied.");return Object.assign(this.dt,t.dt),t.accessors.forEach(t=>this.vt(s(t.getChild()))),t.animations.forEach(t=>this.Tt(s(t.getChild()))),t.buffers.forEach(t=>this.yt(s(t.getChild()))),t.cameras.forEach(t=>this.At(s(t.getChild()))),t.materials.forEach(t=>this.Et(s(t.getChild()))),t.meshes.forEach(t=>this.xt(s(t.getChild()))),t.nodes.forEach(t=>this.St(s(t.getChild()))),t.scenes.forEach(t=>this.Mt(s(t.getChild()))),t.skins.forEach(t=>this.It(s(t.getChild()))),t.textures.forEach(t=>this.bt(s(t.getChild()))),this.setDefaultScene(t.defaultScene?s(t.defaultScene.getChild()):null),this}wt(t){return t instanceof et?this.Mt(t):t instanceof X?this.St(t):t instanceof j?this.At(t):t instanceof it?this.It(t):t instanceof Q?this.xt(t):t instanceof K?this.Et(t):t instanceof rt?this.bt(t):t instanceof U?this.Tt(t):t instanceof P?this.vt(t):t instanceof G&&this.yt(t),this}getAsset(){return this.dt}listExtensionsUsed(){return Array.from(this.gt)}listExtensionsRequired(){return this.listExtensionsUsed().filter(t=>t.isRequired())}Rt(t){return this.gt.add(t),this}Nt(t){return this.gt.delete(t),this}Mt(t){return this.addGraphChild(this.scenes,this.graph.link("scene",this,t))}listScenes(){return this.scenes.map(t=>t.getChild())}setDefaultScene(t){return this.defaultScene=this.graph.link("scene",this,t),this}getDefaultScene(){return this.defaultScene?this.defaultScene.getChild():null}St(t){return this.addGraphChild(this.nodes,this.graph.link("node",this,t))}listNodes(){return this.nodes.map(t=>t.getChild())}At(t){return this.addGraphChild(this.cameras,this.graph.link("camera",this,t))}listCameras(){return this.cameras.map(t=>t.getChild())}It(t){return this.addGraphChild(this.skins,this.graph.link("skin",this,t))}listSkins(){return this.skins.map(t=>t.getChild())}xt(t){return this.addGraphChild(this.meshes,this.graph.link("mesh",this,t))}listMeshes(){return this.meshes.map(t=>t.getChild())}Et(t){return this.addGraphChild(this.materials,this.graph.link("material",this,t))}listMaterials(){return this.materials.map(t=>t.getChild())}bt(t){return this.addGraphChild(this.textures,this.graph.link("texture",this,t))}listTextures(){return this.textures.map(t=>t.getChild())}Tt(t){return this.addGraphChild(this.animations,this.graph.link("animation",this,t))}listAnimations(){return this.animations.map(t=>t.getChild())}vt(t){return this.addGraphChild(this.accessors,this.graph.link("accessor",this,t))}listAccessors(){return this.accessors.map(t=>t.getChild())}yt(t){return this.addGraphChild(this.buffers,this.graph.link("buffer",this,t))}listBuffers(){return this.buffers.map(t=>t.getChild())}}l([p],nt.prototype,"defaultScene",void 0),l([g],nt.prototype,"accessors",void 0),l([g],nt.prototype,"animations",void 0),l([g],nt.prototype,"buffers",void 0),l([g],nt.prototype,"cameras",void 0),l([g],nt.prototype,"materials",void 0),l([g],nt.prototype,"meshes",void 0),l([g],nt.prototype,"nodes",void 0),l([g],nt.prototype,"scenes",void 0),l([g],nt.prototype,"skins",void 0),l([g],nt.prototype,"textures",void 0);class ht{constructor(){this.Ct=new V,this.Ot=new nt(this.Ct),this._t=I.DEFAULT_INSTANCE}getRoot(){return this.Ot}getGraph(){return this.Ct}getLogger(){return this._t}setLogger(t){return this._t=t,this}clone(){return(new ht).merge(this).setLogger(this._t)}merge(t){const s={};for(const e of t.getRoot().listExtensionsUsed()){const t=this.createExtension(e.constructor);e.isRequired()&&t.setRequired(!0),s[t.extensionName]=t}const e=new Set,i=new Map;e.add(t.Ot),i.set(t.Ot,this.Ot);for(const r of t.Ct.getLinks())for(const t of[r.getParent(),r.getChild()]){if(e.has(t))continue;let r;if(t.propertyType===o.TEXTURE_INFO)r=t;else{const e=t.constructor;r=t instanceof D?new e(this.Ct,s[t.extensionName]):new e(this.Ct)}i.set(t,r),e.add(t)}const r=t=>{const s=i.get(t);if(!s)throw new Error("Could resolve property.");return s};for(const t of e){const s=i.get(t);if(!s)throw new Error("Could resolve property.");s.copy(t,r)}return this}async transform(...t){const s=t.map(t=>t.name);for(const e of t)await e(this,{stack:s});return this}createExtension(t){const s=t.EXTENSION_NAME;return this.getRoot().listExtensionsUsed().find(t=>t.extensionName===s)||new t(this)}createScene(t=""){const s=new et(this.Ct,t);return this.Ot.Mt(s),s}createNode(t=""){const s=new X(this.Ct,t);return this.Ot.St(s),s}createCamera(t=""){const s=new j(this.Ct,t);return this.Ot.At(s),s}createSkin(t=""){const s=new it(this.Ct,t);return this.Ot.It(s),s}createMesh(t=""){const s=new Q(this.Ct,t);return this.Ot.xt(s),s}createPrimitive(){return new tt(this.Ct)}createPrimitiveTarget(t=""){return new st(this.Ct,t)}createMaterial(t=""){const s=new K(this.Ct,t);return this.Ot.Et(s),s}createTexture(t=""){const s=new rt(this.Ct,t);return this.Ot.bt(s),s}createAnimation(t=""){const s=new U(this.Ct,t);return this.Ot.Tt(s),s}createAnimationChannel(t=""){return new k(this.Ct,t)}createAnimationSampler(t=""){return new F(this.Ct,t)}createAccessor(t="",s=null){s||(s=this.getRoot().listBuffers()[0]);const e=new P(this.Ct,t).setBuffer(s);return this.Ot.vt(e),e}createBuffer(t=""){const s=new G(this.Ct,t);return this.Ot.yt(s),s}}class ot{constructor(t){this.doc=void 0,this.extensionName="",this.prereadTypes=[],this.prewriteTypes=[],this.readDependencies=[],this.writeDependencies=[],this.required=!1,this.properties=new Set,this.doc=t,t.getRoot().Rt(this)}dispose(){this.doc.getRoot().Nt(this);for(const t of this.properties)t.dispose()}static register(){}isRequired(){return this.required}setRequired(t){return this.required=t,this}addExtensionProperty(t){return this.properties.add(t),this}removeExtensionProperty(t){return this.properties.delete(t),this}install(t,s){return this}preread(t,s){return this}prewrite(t,s){return this}}function ut(){return(ut=Object.assign||function(t){for(var s=1;s<arguments.length;s++){var e=arguments[s];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i])}return t}).apply(this,arguments)}ot.EXTENSION_NAME=void 0;class ct{constructor(t){this.jsonDoc=void 0,this.buffers=[],this.bufferViews=[],this.bufferViewBuffers=[],this.accessors=[],this.textures=[],this.textureInfos=new Map,this.materials=[],this.meshes=[],this.cameras=[],this.nodes=[],this.skins=[],this.animations=[],this.scenes=[],this.jsonDoc=t}setTextureInfo(t,s){this.textureInfos.set(t,s),void 0!==s.texCoord&&t.setTexCoord(s.texCoord);const e=this.jsonDoc.json.textures[s.index];if(void 0===e.sampler)return;const i=this.jsonDoc.json.samplers[e.sampler];void 0!==i.magFilter&&t.setMagFilter(i.magFilter),void 0!==i.minFilter&&t.setMinFilter(i.minFilter),void 0!==i.wrapS&&t.setWrapS(i.wrapS),void 0!==i.wrapT&&t.setWrapT(i.wrapT)}}const at={5120:Int8Array,5121:Uint8Array,5122:Int16Array,5123:Uint16Array,5125:Uint32Array,5126:Float32Array},lt={logger:I.DEFAULT_INSTANCE,extensions:[],dependencies:{}};function ft(t,s){const e=s.bufferViews[t.bufferView],i=s.jsonDoc.json.bufferViews[t.bufferView],r=at[t.componentType],n=P.getElementSize(t.type),h=r.BYTES_PER_ELEMENT;if(void 0!==i.byteStride&&i.byteStride!==n*h)return function(t,s){const e=s.bufferViews[t.bufferView],i=s.jsonDoc.json.bufferViews[t.bufferView],r=at[t.componentType],n=P.getElementSize(t.type),h=r.BYTES_PER_ELEMENT,o=t.byteOffset||0,u=new r(t.count*n),c=new DataView(e.buffer,e.byteOffset,e.byteLength),a=i.byteStride;for(let s=0;s<t.count;s++)for(let e=0;e<n;e++){const i=o+s*a+e*h;let r;switch(t.componentType){case P.ComponentType.FLOAT:r=c.getFloat32(i,!0);break;case P.ComponentType.UNSIGNED_INT:r=c.getUint32(i,!0);break;case P.ComponentType.UNSIGNED_SHORT:r=c.getUint16(i,!0);break;case P.ComponentType.UNSIGNED_BYTE:r=c.getUint8(i);break;case P.ComponentType.SHORT:r=c.getInt16(i,!0);break;case P.ComponentType.BYTE:r=c.getInt8(i);break;default:throw new Error(`Unexpected componentType "${t.componentType}".`)}u[s*n+e]=r}return u}(t,s);const o=e.byteOffset+(t.byteOffset||0);return new r(e.buffer.slice(o,o+t.count*n*h))}var dt,pt;!function(t){t[t.ARRAY_BUFFER=34962]="ARRAY_BUFFER",t[t.ELEMENT_ARRAY_BUFFER=34963]="ELEMENT_ARRAY_BUFFER"}(dt||(dt={})),function(t){t.ARRAY_BUFFER="ARRAY_BUFFER",t.ELEMENT_ARRAY_BUFFER="ELEMENT_ARRAY_BUFFER",t.INVERSE_BIND_MATRICES="INVERSE_BIND_MATRICES",t.OTHER="OTHER"}(pt||(pt={}));class gt{constructor(t,s,e){this.Bt=void 0,this.jsonDoc=void 0,this.options=void 0,this.accessorIndexMap=new Map,this.bufferIndexMap=new Map,this.cameraIndexMap=new Map,this.skinIndexMap=new Map,this.materialIndexMap=new Map,this.meshIndexMap=new Map,this.nodeIndexMap=new Map,this.imageIndexMap=new Map,this.textureDefIndexMap=new Map,this.textureInfoDefMap=new Map,this.samplerDefIndexMap=new Map,this.imageBufferViews=[],this.otherBufferViews=new Map,this.otherBufferViewsIndexMap=new Map,this.extensionData={},this.bufferURIGenerator=void 0,this.imageURIGenerator=void 0,this.logger=void 0,this.Lt=new Map,this.accessorUsageGroupedByParent=new Set(["ARRAY_BUFFER"]),this.accessorParents=new Map,this.Bt=t,this.jsonDoc=s,this.options=e;const i=t.getRoot(),r=i.listBuffers().length,n=i.listTextures().length;this.bufferURIGenerator=new wt(r>1,e.basename),this.imageURIGenerator=new wt(n>1,e.basename),this.logger=t.getLogger()}createTextureInfoDef(t,s){const e={magFilter:s.getMagFilter()||void 0,minFilter:s.getMinFilter()||void 0,wrapS:s.getWrapS(),wrapT:s.getWrapT()},i=JSON.stringify(e);this.samplerDefIndexMap.has(i)||(this.samplerDefIndexMap.set(i,this.jsonDoc.json.samplers.length),this.jsonDoc.json.samplers.push(e));const r={source:this.imageIndexMap.get(t),sampler:this.samplerDefIndexMap.get(i)},n=JSON.stringify(r);this.textureDefIndexMap.has(n)||(this.textureDefIndexMap.set(n,this.jsonDoc.json.textures.length),this.jsonDoc.json.textures.push(r));const h={index:this.textureDefIndexMap.get(n)};return 0!==s.getTexCoord()&&(h.texCoord=s.getTexCoord()),this.textureInfoDefMap.set(s,h),h}createPropertyDef(t){const s={};return t.getName()&&(s.name=t.getName()),Object.keys(t.getExtras()).length>0&&(s.extras=t.getExtras()),s}createAccessorDef(t){const s=this.createPropertyDef(t);return s.type=t.getType(),s.componentType=t.getComponentType(),s.count=t.getCount(),this.Bt.getGraph().listParentLinks(t).some(t=>"POSITION"===t.getName()||"input"===t.getName())&&(s.max=t.getMax([]).map(Math.fround),s.min=t.getMin([]).map(Math.fround)),t.getNormalized()&&(s.normalized=t.getNormalized()),s}createImageData(t,s,e){if(this.options.format===a.GLB)this.imageBufferViews.push(s),t.bufferView=this.jsonDoc.json.bufferViews.length,this.jsonDoc.json.bufferViews.push({buffer:0,byteOffset:-1,byteLength:s.byteLength});else{const i=x.mimeTypeToExtension(e.getMimeType());t.uri=this.imageURIGenerator.createURI(e,i),this.jsonDoc.resources[t.uri]=s}}getAccessorUsage(t){const s=this.Lt.get(t);if(s)return s;for(const s of this.Bt.getGraph().listParentLinks(t)){if("inverseBindMatrices"===s.getName())return gt.BufferViewUsage.INVERSE_BIND_MATRICES;if(s instanceof J)return gt.BufferViewUsage.ARRAY_BUFFER;if(s instanceof z)return gt.BufferViewUsage.ELEMENT_ARRAY_BUFFER}return gt.BufferViewUsage.OTHER}addAccessorToUsageGroup(t,s){const e=this.Lt.get(t);if(e&&e!==s)throw new Error(`Accessor with usage "${e}" cannot be reused as "${s}".`);return this.Lt.set(t,s),this}listAccessorUsageGroups(){const t={};for(const[s,e]of Array.from(this.Lt.entries()))t[e]=t[e]||[],t[e].push(s);return t}}gt.BufferViewTarget=dt,gt.BufferViewUsage=pt,gt.USAGE_TO_TARGET={[pt.ARRAY_BUFFER]:dt.ARRAY_BUFFER,[pt.ELEMENT_ARRAY_BUFFER]:dt.ELEMENT_ARRAY_BUFFER};class wt{constructor(t,s){this.multiple=void 0,this.basename=void 0,this.counter=1,this.multiple=t,this.basename=s}createURI(t,s){return t.getURI()?t.getURI():this.multiple?`${this.basename}_${this.counter++}.${s}`:`${this.basename}.${s}`}}const{BufferViewUsage:vt}=gt;var mt;!function(t){t[t.JSON=1313821514]="JSON",t[t.BIN=5130562]="BIN"}(mt||(mt={}));class Tt{constructor(){this._t=I.DEFAULT_INSTANCE,this.gt=new Set,this.Pt={},this.Ut=u.INTERLEAVED}setLogger(t){return this._t=t,this}registerExtensions(t){for(const s of t)this.gt.add(s),s.register();return this}registerDependencies(t){return Object.assign(this.Pt,t),this}setVertexLayout(t){return this.Ut=t,this}kt(t){function s(s){if(s.uri&&!(s.uri in t.resources)&&s.uri.match(/data:/)){const e=`__${C()}.${A.extension(s.uri)}`;t.resources[e]=T.createBufferFromDataURI(s.uri),s.uri=e}}(t.json.images||[]).forEach(t=>{if(void 0===t.bufferView&&void 0===t.uri)throw new Error("Missing resource URI or buffer view.");s(t)}),(t.json.buffers||[]).forEach(s)}readJSON(t){return t=this.Ft(t),this.kt(t),class{static read(t,s=lt){const e=ut({},lt,s),{json:i}=t,r=new ht;this.validate(t,e);const n=new ct(t),h=i.asset,u=r.getRoot().getAsset();h.copyright&&(u.copyright=h.copyright),h.extras&&(u.extras=h.extras),void 0!==i.extras&&r.getRoot().setExtras(ut({},i.extras));const c=i.extensionsUsed||[],a=i.extensionsRequired||[];for(const t of e.extensions)if(c.includes(t.EXTENSION_NAME)){const s=r.createExtension(t).setRequired(a.includes(t.EXTENSION_NAME));for(const t of s.readDependencies)s.install(t,e.dependencies[t])}const l=i.buffers||[];r.getRoot().listExtensionsUsed().filter(t=>t.prereadTypes.includes(o.BUFFER)).forEach(t=>t.preread(n,o.BUFFER)),n.buffers=l.map(t=>{const s=r.createBuffer(t.name);return t.extras&&s.setExtras(t.extras),t.uri&&0!==t.uri.indexOf("__")&&s.setURI(t.uri),s}),n.bufferViewBuffers=(i.bufferViews||[]).map((s,e)=>{if(!n.bufferViews[e]){const i=t.json.buffers[s.buffer],r=new Uint8Array(i.uri?t.resources[i.uri]:t.resources["@glb.bin"],s.byteOffset||0,s.byteLength);n.bufferViews[e]=r}return n.buffers[s.buffer]}),n.accessors=(i.accessors||[]).map(t=>{const s=r.createAccessor(t.name,n.bufferViewBuffers[t.bufferView]).setType(t.type);if(t.extras&&s.setExtras(t.extras),void 0!==t.normalized&&s.setNormalized(t.normalized),void 0===t.bufferView&&!t.sparse)return s;let e;return e=void 0!==t.sparse?function(t,s){const e=at[t.componentType],i=P.getElementSize(t.type);let r;r=void 0!==t.bufferView?ft(t,s):new e(t.count*i);const n=t.sparse,h=n.count,o=ut({},t,n.indices,{count:h,type:"SCALAR"}),u=ut({},t,n.values,{count:h}),c=ft(o,s),a=ft(u,s);for(let t=0;t<o.count;t++)for(let s=0;s<i;s++)r[c[t]*i+s]=a[t*i+s];return r}(t,n):ft(t,n),s.setArray(e),s});const f=i.images||[],d=i.textures||[];r.getRoot().listExtensionsUsed().filter(t=>t.prereadTypes.includes(o.TEXTURE)).forEach(t=>t.preread(n,o.TEXTURE)),n.textures=f.map(s=>{const e=r.createTexture(s.name);if(s.extras&&e.setExtras(s.extras),void 0!==s.bufferView){const r=i.bufferViews[s.bufferView],n=t.json.buffers[r.buffer],h=r.byteOffset||0,o=(n.uri?t.resources[n.uri]:t.resources["@glb.bin"]).slice(h,h+r.byteLength);e.setImage(o)}else void 0!==s.uri&&(e.setImage(t.resources[s.uri]),0!==s.uri.indexOf("__")&&e.setURI(s.uri));if(void 0!==s.mimeType)e.setMimeType(s.mimeType);else if(s.uri){const t=A.extension(s.uri);e.setMimeType(x.extensionToMimeType(t))}return e}),n.materials=(i.materials||[]).map(t=>{const s=r.createMaterial(t.name);t.extras&&s.setExtras(t.extras),void 0!==t.alphaMode&&s.setAlphaMode(t.alphaMode),void 0!==t.alphaCutoff&&s.setAlphaCutoff(t.alphaCutoff),void 0!==t.doubleSided&&s.setDoubleSided(t.doubleSided);const e=t.pbrMetallicRoughness||{};if(void 0!==e.baseColorFactor&&s.setBaseColorFactor(e.baseColorFactor),void 0!==t.emissiveFactor&&s.setEmissiveFactor(t.emissiveFactor),void 0!==e.metallicFactor&&s.setMetallicFactor(e.metallicFactor),void 0!==e.roughnessFactor&&s.setRoughnessFactor(e.roughnessFactor),void 0!==e.baseColorTexture){const t=e.baseColorTexture;s.setBaseColorTexture(n.textures[d[t.index].source]),n.setTextureInfo(s.getBaseColorTextureInfo(),t)}if(void 0!==t.emissiveTexture){const e=t.emissiveTexture;s.setEmissiveTexture(n.textures[d[e.index].source]),n.setTextureInfo(s.getEmissiveTextureInfo(),e)}if(void 0!==t.normalTexture){const e=t.normalTexture;s.setNormalTexture(n.textures[d[e.index].source]),n.setTextureInfo(s.getNormalTextureInfo(),e),void 0!==t.normalTexture.scale&&s.setNormalScale(t.normalTexture.scale)}if(void 0!==t.occlusionTexture){const e=t.occlusionTexture;s.setOcclusionTexture(n.textures[d[e.index].source]),n.setTextureInfo(s.getOcclusionTextureInfo(),e),void 0!==t.occlusionTexture.strength&&s.setOcclusionStrength(t.occlusionTexture.strength)}if(void 0!==e.metallicRoughnessTexture){const t=e.metallicRoughnessTexture;s.setMetallicRoughnessTexture(n.textures[d[t.index].source]),n.setTextureInfo(s.getMetallicRoughnessTextureInfo(),t)}return s});const p=i.meshes||[];r.getRoot().listExtensionsUsed().filter(t=>t.prereadTypes.includes(o.PRIMITIVE)).forEach(t=>t.preread(n,o.PRIMITIVE)),n.meshes=p.map(t=>{const s=r.createMesh(t.name);return t.extras&&s.setExtras(t.extras),void 0!==t.weights&&s.setWeights(t.weights),(t.primitives||[]).forEach(e=>{const i=r.createPrimitive();e.extras&&i.setExtras(e.extras),void 0!==e.material&&i.setMaterial(n.materials[e.material]),void 0!==e.mode&&i.setMode(e.mode);for(const[t,s]of Object.entries(e.attributes||{}))i.setAttribute(t,n.accessors[s]);void 0!==e.indices&&i.setIndices(n.accessors[e.indices]);const h=t.extras&&t.extras.targetNames||[];(e.targets||[]).forEach((t,s)=>{const e=h[s]||s.toString(),o=r.createPrimitiveTarget(e);for(const[s,e]of Object.entries(t))o.setAttribute(s,n.accessors[e]);i.addTarget(o)}),s.addPrimitive(i)}),s}),n.cameras=(i.cameras||[]).map(t=>{const s=r.createCamera(t.name).setType(t.type);if(t.extras&&s.setExtras(t.extras),t.type===j.Type.PERSPECTIVE){const e=t.perspective;s.setYFov(e.yfov),s.setZNear(e.znear),void 0!==e.zfar&&s.setZFar(e.zfar),void 0!==e.aspectRatio&&s.setAspectRatio(e.aspectRatio)}else{const e=t.orthographic;s.setZNear(e.znear).setZFar(e.zfar).setXMag(e.xmag).setYMag(e.ymag)}return s});const g=i.nodes||[];r.getRoot().listExtensionsUsed().filter(t=>t.prereadTypes.includes(o.NODE)).forEach(t=>t.preread(n,o.NODE)),n.nodes=g.map(t=>{const s=r.createNode(t.name);if(t.extras&&s.setExtras(t.extras),void 0!==t.translation&&s.setTranslation(t.translation),void 0!==t.rotation&&s.setRotation(t.rotation),void 0!==t.scale&&s.setScale(t.scale),void 0!==t.matrix){const e=[0,0,0],i=[0,0,0,1],r=[1,1,1];M.decompose(t.matrix,e,i,r),s.setTranslation(e),s.setRotation(i),s.setScale(r)}return void 0!==t.weights&&s.setWeights(t.weights),s}),n.skins=(i.skins||[]).map(t=>{const s=r.createSkin(t.name);t.extras&&s.setExtras(t.extras),void 0!==t.inverseBindMatrices&&s.setInverseBindMatrices(n.accessors[t.inverseBindMatrices]),void 0!==t.skeleton&&s.setSkeleton(n.nodes[t.skeleton]);for(const e of t.joints)s.addJoint(n.nodes[e]);return s}),g.map((t,s)=>{const e=n.nodes[s];(t.children||[]).forEach(t=>e.addChild(n.nodes[t])),void 0!==t.mesh&&e.setMesh(n.meshes[t.mesh]),void 0!==t.camera&&e.setCamera(n.cameras[t.camera]),void 0!==t.skin&&e.setSkin(n.skins[t.skin])}),n.animations=(i.animations||[]).map(t=>{const s=r.createAnimation(t.name);t.extras&&s.setExtras(t.extras);const e=(t.samplers||[]).map(t=>{const e=r.createAnimationSampler().setInput(n.accessors[t.input]).setOutput(n.accessors[t.output]).setInterpolation(t.interpolation||F.Interpolation.LINEAR);return t.extras&&e.setExtras(t.extras),s.addSampler(e),e});return(t.channels||[]).forEach(t=>{const i=r.createAnimationChannel().setSampler(e[t.sampler]).setTargetNode(n.nodes[t.target.node]).setTargetPath(t.target.path);t.extras&&i.setExtras(t.extras),s.addChannel(i)}),s});const w=i.scenes||[];return r.getRoot().listExtensionsUsed().filter(t=>t.prereadTypes.includes(o.SCENE)).forEach(t=>t.preread(n,o.SCENE)),n.scenes=w.map(t=>{const s=r.createScene(t.name);return t.extras&&s.setExtras(t.extras),(t.nodes||[]).map(t=>n.nodes[t]).forEach(t=>s.addChild(t)),s}),void 0!==i.scene&&r.getRoot().setDefaultScene(n.scenes[i.scene]),r.getRoot().listExtensionsUsed().forEach(t=>t.read(n)),r}static validate(t,s){const e=t.json;if("2.0"!==e.asset.version)throw new Error(`Unsupported glTF version, "${e.asset.version}".`);if(e.extensionsRequired)for(const t of e.extensionsRequired)if(!s.extensions.find(s=>s.EXTENSION_NAME===t))throw new Error(`Missing required extension, "${t}".`);if(e.extensionsUsed)for(const t of e.extensionsUsed)s.extensions.find(s=>s.EXTENSION_NAME===t)||s.logger.warn(`Missing optional extension, "${t}".`)}}.read(t,{extensions:Array.from(this.gt),dependencies:this.Pt,logger:this._t})}writeJSON(t,s={}){if(s.format===a.GLB&&t.getRoot().listBuffers().length>1)throw new Error("GLB must have 0–1 buffers.");return class{static write(t,s){const e=t.getRoot(),i={asset:ut({generator:"glTF-Transform v1.2.4"},e.getAsset()),extras:ut({},e.getExtras())},r={json:i,resources:{}},n=new gt(t,r,s),h=s.logger||I.DEFAULT_INSTANCE,c=new Set(s.extensions.map(t=>t.EXTENSION_NAME)),l=t.getRoot().listExtensionsUsed().filter(t=>c.has(t.extensionName)),f=t.getRoot().listExtensionsRequired().filter(t=>c.has(t.extensionName));l.length<t.getRoot().listExtensionsUsed().length&&h.debug("Some extensions were not registered for I/O, and will not be written.");for(const t of l)for(const e of t.writeDependencies)t.install(e,s.dependencies[e]);function d(t,s,e,r){const h=[];let o=0;for(const s of t){const t=n.createAccessorDef(s);t.bufferView=i.bufferViews.length;const e=T.pad(s.getArray().buffer);t.byteOffset=o,o+=e.byteLength,h.push(e),n.accessorIndexMap.set(s,i.accessors.length),i.accessors.push(t)}const u={buffer:s,byteOffset:e,byteLength:T.concat(h).byteLength};return r&&(u.target=r),i.bufferViews.push(u),{buffers:h,byteLength:o}}function p(t,s,e){const r=t[0].getCount();let h=0;for(const s of t){const t=n.createAccessorDef(s);t.bufferView=i.bufferViews.length,t.byteOffset=h;const e=s.getElementSize(),r=s.getComponentSize();h+=T.padNumber(e*r),n.accessorIndexMap.set(s,i.accessors.length),i.accessors.push(t)}const o=r*h,u=new ArrayBuffer(o),c=new DataView(u);for(let s=0;s<r;s++){let e=0;for(const i of t){const t=i.getElementSize(),r=i.getComponentSize(),n=i.getComponentType(),o=i.getArray();for(let i=0;i<t;i++){const u=s*h+e+i*r,a=o[s*t+i];switch(n){case P.ComponentType.FLOAT:c.setFloat32(u,a,!0);break;case P.ComponentType.BYTE:c.setInt8(u,a);break;case P.ComponentType.SHORT:c.setInt16(u,a,!0);break;case P.ComponentType.UNSIGNED_BYTE:c.setUint8(u,a);break;case P.ComponentType.UNSIGNED_SHORT:c.setUint16(u,a,!0);break;case P.ComponentType.UNSIGNED_INT:c.setUint32(u,a,!0);break;default:throw new Error("Unexpected component type: "+n)}}e+=T.padNumber(t*r)}}return i.bufferViews.push({buffer:s,byteOffset:e,byteLength:o,byteStride:h,target:gt.BufferViewTarget.ARRAY_BUFFER}),{byteLength:o,buffers:[u]}}const g=new Map;for(const s of t.getGraph().getLinks()){if(s.getParent()===e)continue;const t=s.getChild();if(t instanceof P){const e=g.get(t)||[];e.push(s),g.set(t,e)}}if(i.accessors=[],i.bufferViews=[],i.samplers=[],i.textures=[],i.images=e.listTextures().map((t,s)=>{const e=n.createPropertyDef(t);t.getMimeType()&&(e.mimeType=t.getMimeType());const i=t.getImage();return i&&n.createImageData(e,i,t),n.imageIndexMap.set(t,s),e}),l.filter(t=>t.prewriteTypes.includes(o.ACCESSOR)).forEach(t=>t.prewrite(n,o.ACCESSOR)),e.listAccessors().forEach(t=>{const s=n.accessorUsageGroupedByParent,e=n.accessorParents;if(n.accessorIndexMap.has(t))return;const i=g.get(t)||[],r=n.getAccessorUsage(t);if(n.addAccessorToUsageGroup(t,r),s.has(r)){const s=i[0].getParent(),r=e.get(s)||new Set;r.add(t),e.set(s,r)}}),l.filter(t=>t.prewriteTypes.includes(o.BUFFER)).forEach(t=>t.prewrite(n,o.BUFFER)),(e.listAccessors().length>0||e.listTextures().length>0||n.otherBufferViews.size>0)&&0===e.listBuffers().length)throw new Error("Buffer required for Document resources, but none was found.");i.buffers=[],e.listBuffers().forEach((t,e)=>{const h=n.createPropertyDef(t),o=n.accessorUsageGroupedByParent,c=n.accessorParents,l=t.listParents().filter(t=>t instanceof P),f=new Set(l),g=[],w=i.buffers.length;let v=0;const m=n.listAccessorUsageGroups();for(const t in m)if(o.has(t))for(const e of Array.from(c.values())){const i=Array.from(e).filter(t=>f.has(t)).filter(s=>n.getAccessorUsage(s)===t);if(i.length)if(t!==vt.ARRAY_BUFFER||s.vertexLayout===u.INTERLEAVED){const s=t===vt.ARRAY_BUFFER?p(i,w,v):d(i,w,v);v+=s.byteLength,g.push(...s.buffers)}else for(const t of i){const s=p([t],w,v);v+=s.byteLength,g.push(...s.buffers)}}else{const s=m[t].filter(t=>f.has(t));if(!s.length)continue;const e=d(s,w,v,t===vt.ELEMENT_ARRAY_BUFFER?gt.BufferViewTarget.ELEMENT_ARRAY_BUFFER:void 0);v+=e.byteLength,g.push(...e.buffers)}if(n.imageBufferViews.length&&0===e)for(let t=0;t<n.imageBufferViews.length;t++)if(i.bufferViews[i.images[t].bufferView].byteOffset=v,v+=n.imageBufferViews[t].byteLength,g.push(n.imageBufferViews[t]),v%8){const t=8-v%8;v+=t,g.push(new ArrayBuffer(t))}if(n.otherBufferViews.has(t))for(const s of n.otherBufferViews.get(t))i.bufferViews.push({buffer:w,byteOffset:v,byteLength:s.byteLength}),n.otherBufferViewsIndexMap.set(s,i.bufferViews.length-1),v+=s.byteLength,g.push(s);if(v){let e;s.format===a.GLB?e="@glb.bin":(e=n.bufferURIGenerator.createURI(t,"bin"),h.uri=e),h.byteLength=v,r.resources[e]=T.concat(g)}i.buffers.push(h),n.bufferIndexMap.set(t,e)}),e.listAccessors().find(t=>!t.getBuffer())&&h.warn("Skipped writing one or more Accessors: no Buffer assigned."),i.materials=e.listMaterials().map((t,s)=>{const e=n.createPropertyDef(t);if(t.getAlphaMode()!==K.AlphaMode.OPAQUE&&(e.alphaMode=t.getAlphaMode()),t.getAlphaMode()===K.AlphaMode.MASK&&(e.alphaCutoff=t.getAlphaCutoff()),t.getDoubleSided()&&(e.doubleSided=!0),e.pbrMetallicRoughness={},M.eq(t.getBaseColorFactor(),[1,1,1,1])||(e.pbrMetallicRoughness.baseColorFactor=t.getBaseColorFactor()),M.eq(t.getEmissiveFactor(),[0,0,0])||(e.emissiveFactor=t.getEmissiveFactor()),1!==t.getRoughnessFactor()&&(e.pbrMetallicRoughness.roughnessFactor=t.getRoughnessFactor()),1!==t.getMetallicFactor()&&(e.pbrMetallicRoughness.metallicFactor=t.getMetallicFactor()),t.getBaseColorTexture()){const s=t.getBaseColorTexture(),i=t.getBaseColorTextureInfo();e.pbrMetallicRoughness.baseColorTexture=n.createTextureInfoDef(s,i)}if(t.getEmissiveTexture()){const s=t.getEmissiveTexture(),i=t.getEmissiveTextureInfo();e.emissiveTexture=n.createTextureInfoDef(s,i)}if(t.getNormalTexture()){const s=t.getNormalTexture(),i=t.getNormalTextureInfo(),r=n.createTextureInfoDef(s,i);1!==t.getNormalScale()&&(r.scale=t.getNormalScale()),e.normalTexture=r}if(t.getOcclusionTexture()){const s=t.getOcclusionTexture(),i=t.getOcclusionTextureInfo(),r=n.createTextureInfoDef(s,i);1!==t.getOcclusionStrength()&&(r.strength=t.getOcclusionStrength()),e.occlusionTexture=r}if(t.getMetallicRoughnessTexture()){const s=t.getMetallicRoughnessTexture(),i=t.getMetallicRoughnessTextureInfo();e.pbrMetallicRoughness.metallicRoughnessTexture=n.createTextureInfoDef(s,i)}return n.materialIndexMap.set(t,s),e}),i.meshes=e.listMeshes().map((t,s)=>{const e=n.createPropertyDef(t);let i=null;return e.primitives=t.listPrimitives().map(t=>{const s={attributes:{}};s.mode=t.getMode();const e=t.getMaterial();e&&(s.material=n.materialIndexMap.get(e)),Object.keys(t.getExtras()).length&&(s.extras=t.getExtras());const r=t.getIndices();r&&(s.indices=n.accessorIndexMap.get(r));for(const e of t.listSemantics())s.attributes[e]=n.accessorIndexMap.get(t.getAttribute(e));for(const e of t.listTargets()){const t={};for(const s of e.listSemantics())t[s]=n.accessorIndexMap.get(e.getAttribute(s));s.targets=s.targets||[],s.targets.push(t)}return t.listTargets().length&&!i&&(i=t.listTargets().map(t=>t.getName())),s}),t.getWeights().length&&(e.weights=t.getWeights()),i&&(e.extras=e.extras||{},e.extras.targetNames=i),n.meshIndexMap.set(t,s),e}),i.cameras=e.listCameras().map((t,s)=>{const e=n.createPropertyDef(t);if(e.type=t.getType(),e.type===j.Type.PERSPECTIVE){e.perspective={znear:t.getZNear(),zfar:t.getZFar(),yfov:t.getYFov()};const s=t.getAspectRatio();null!==s&&(e.perspective.aspectRatio=s)}else e.orthographic={znear:t.getZNear(),zfar:t.getZFar(),xmag:t.getXMag(),ymag:t.getYMag()};return n.cameraIndexMap.set(t,s),e}),i.nodes=e.listNodes().map((t,s)=>{const e=n.createPropertyDef(t);return M.eq(t.getTranslation(),[0,0,0])||(e.translation=t.getTranslation()),M.eq(t.getRotation(),[0,0,0,1])||(e.rotation=t.getRotation()),M.eq(t.getScale(),[1,1,1])||(e.scale=t.getScale()),t.getWeights().length&&(e.weights=t.getWeights()),n.nodeIndexMap.set(t,s),e}),i.skins=e.listSkins().map((t,s)=>{const e=n.createPropertyDef(t),i=t.getInverseBindMatrices();i&&(e.inverseBindMatrices=n.accessorIndexMap.get(i));const r=t.getSkeleton();return r&&(e.skeleton=n.nodeIndexMap.get(r)),e.joints=t.listJoints().map(t=>n.nodeIndexMap.get(t)),n.skinIndexMap.set(t,s),e}),e.listNodes().forEach((t,s)=>{const e=i.nodes[s],r=t.getMesh();r&&(e.mesh=n.meshIndexMap.get(r));const h=t.getCamera();h&&(e.camera=n.cameraIndexMap.get(h));const o=t.getSkin();o&&(e.skin=n.skinIndexMap.get(o)),t.listChildren().length>0&&(e.children=t.listChildren().map(t=>n.nodeIndexMap.get(t)))}),i.animations=e.listAnimations().map(t=>{const s=n.createPropertyDef(t),e=new Map;return s.samplers=t.listSamplers().map((t,s)=>{const i=n.createPropertyDef(t);return i.input=n.accessorIndexMap.get(t.getInput()),i.output=n.accessorIndexMap.get(t.getOutput()),i.interpolation=t.getInterpolation(),e.set(t,s),i}),s.channels=t.listChannels().map(t=>{const s=n.createPropertyDef(t);return s.sampler=e.get(t.getSampler()),s.target={node:n.nodeIndexMap.get(t.getTargetNode()),path:t.getTargetPath()},s}),s}),i.scenes=e.listScenes().map(t=>{const s=n.createPropertyDef(t);return s.nodes=t.listChildren().map(t=>n.nodeIndexMap.get(t)),s});const w=e.getDefaultScene();return w&&(i.scene=e.listScenes().indexOf(w)),i.extensionsUsed=l.map(t=>t.extensionName),i.extensionsRequired=f.map(t=>t.extensionName),l.forEach(t=>t.write(n)),function(t){const s=[];for(const e in t){const i=t[e];(Array.isArray(i)&&0===i.length||null===i||""===i||i&&"object"==typeof i&&0===Object.keys(i).length)&&s.push(e)}for(const e of s)delete t[e]}(i),r}}.write(t,{format:s.format||a.GLTF,basename:s.basename||"",logger:this._t,vertexLayout:this.Ut,dependencies:ut({},this.Pt),extensions:Array.from(this.gt)})}Ft(t){const{images:s,buffers:e}=t.json;return t={json:ut({},t.json),resources:ut({},t.resources)},s&&(t.json.images=s.map(t=>ut({},t))),e&&(t.json.buffers=e.map(t=>ut({},t))),t}binaryToJSON(t){const s=this.Gt(t);this.kt(s);const e=s.json;if(e.buffers&&e.buffers.some(t=>function(t,s){return void 0!==s.uri&&!(s.uri in t.resources)}(s,t)))throw new Error("Cannot resolve external buffers with binaryToJSON().");if(e.images&&e.images.some(t=>function(t,s){return void 0!==s.uri&&!(s.uri in t.resources)&&void 0===s.bufferView}(s,t)))throw new Error("Cannot resolve external images with binaryToJSON().");return s}Gt(t){const s=new Uint32Array(t,0,3);if(1179937895!==s[0])throw new Error("Invalid glTF asset.");if(2!==s[1])throw new Error(`Unsupported glTF binary version, "${s[1]}".`);const e=new Uint32Array(t,12,2);if(e[1]!==mt.JSON)throw new Error("Missing required GLB JSON chunk.");const i=e[0],r=T.decodeText(t.slice(20,20+i)),n=JSON.parse(r),h=20+i;if(t.byteLength<=h)return{json:n,resources:{}};const o=new Uint32Array(t,h,2);if(o[1]!==mt.BIN)throw new Error("Expected GLB BIN in second chunk.");return{json:n,resources:{"@glb.bin":t.slice(h+8,h+8+o[0])}}}readBinary(t){return this.readJSON(this.binaryToJSON(t))}writeBinary(t){const{json:s,resources:e}=this.writeJSON(t,{format:a.GLB}),i=new Uint32Array([1179937895,2,12]),r=JSON.stringify(s),n=T.pad(T.encodeText(r),32),h=new Uint32Array([n.byteLength,1313821514]).buffer,o=T.concat([h,n]);i[i.length-1]+=o.byteLength;const u=Object.values(e)[0];if(!u||!u.byteLength)return T.concat([i.buffer,o]);const c=T.pad(u,0),l=new Uint32Array([c.byteLength,5130562]).buffer,f=T.concat([l,c]);return i[i.length-1]+=f.byteLength,T.concat([i.buffer,o,f])}}class yt extends Tt{constructor(){super(),this.jt=void 0,this.Dt=void 0,this.lastReadBytes=0,this.lastWriteBytes=0,this.jt=__webpack_require__(/*! fs */ "?ec06"),this.Dt=__webpack_require__(/*! path */ "?f46d")}read(t){return this.readJSON(this.readAsJSON(t))}readAsJSON(t){return t.match(/\.glb$/)||t.match(/^data:application\/octet-stream;/)?this.Jt(t):this.zt(t)}write(t,s){t.match(/\.glb$/)?this.$t(t,s):this.Vt(t,s)}Wt(t,s){[...t.json.images||[],...t.json.buffers||[]].forEach(e=>{if(e.uri&&!e.uri.match(/data:/)){const i=this.Dt.resolve(s,e.uri);t.resources[e.uri]=T.trim(this.jt.readFileSync(i)),this.lastReadBytes+=t.resources[e.uri].byteLength}})}Jt(t){const s=this.jt.readFileSync(t),e=T.trim(s);this.lastReadBytes=e.byteLength;const i=this.Gt(e);return this.Wt(i,this.Dt.dirname(t)),this.kt(i),i}zt(t){this.lastReadBytes=0;const s=this.jt.readFileSync(t,"utf8");this.lastReadBytes+=s.length;const e={json:JSON.parse(s),resources:{}};return this.Wt(e,this.Dt.dirname(t)),this.kt(e),e}Vt(t,s){this.lastWriteBytes=0;const{json:e,resources:i}=this.writeJSON(s,{format:a.GLTF,basename:A.basename(t)}),{jt:r,Dt:n}=this,h=n.dirname(t),o=JSON.stringify(e,null,2);this.lastWriteBytes+=o.length,r.writeFileSync(t,o),Object.keys(i).forEach(t=>{const s=Buffer.from(i[t]);r.writeFileSync(n.join(h,t),s),this.lastWriteBytes+=s.byteLength})}$t(t,s){const e=Buffer.from(this.writeBinary(s));this.jt.writeFileSync(t,e),this.lastWriteBytes=e.byteLength}}const At={};class Et extends Tt{constructor(t=At){super(),this.qt=void 0,this.qt=t}read(t){return this.readAsJSON(t).then(t=>this.readJSON(t))}readAsJSON(t){return t.match(/^data:application\/octet-stream;/)||new URL(t,window.location.href).pathname.match(/\.glb$/)?this.Jt(t):this.zt(t)}Wt(t,s){const e=[...t.json.images||[],...t.json.buffers||[]].map(e=>{const i=e.uri;return!i||i.match(/data:/)?Promise.resolve():fetch(function(t,s){if(!function(t){return!/^(?:[a-zA-Z]+:)?\//.test(t)}(s))return s;const e=t.split("/"),i=s.split("/");e.pop();for(let t=0;t<i.length;t++)"."!==i[t]&&(".."===i[t]?e.pop():e.push(i[t]));return e.join("/")}(s,i),this.qt).then(t=>t.arrayBuffer()).then(s=>{t.resources[i]=s})});return Promise.all(e).then(()=>{})}zt(t){var s=this;const e={json:{},resources:{}};return fetch(t,this.qt).then(t=>t.json()).then(async function(i){return e.json=i,await s.Wt(e,xt(t)),s.kt(e),e})}Jt(t){var s=this;return fetch(t,this.qt).then(t=>t.arrayBuffer()).then(async function(e){const i=s.Gt(e);return await s.Wt(i,xt(t)),s.kt(i),i})}}function xt(t){const s=t.lastIndexOf("/");return-1===s?"./":t.substr(0,s+1)}
//# sourceMappingURL=core.modern.js.map


/***/ }),

/***/ "../../../node_modules/acorn/dist/acorn.js":
/*!*************************************************!*\
  !*** ../../../node_modules/acorn/dist/acorn.js ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
   true ? factory(exports) :
  0;
})(this, (function (exports) { 'use strict';

  // This file was generated. Do not modify manually!
  var astralIdentifierCodes = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];

  // This file was generated. Do not modify manually!
  var astralIdentifierStartCodes = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 3104, 541, 1507, 4938, 6, 4191];

  // This file was generated. Do not modify manually!
  var nonASCIIidentifierChars = "\u200c\u200d\xb7\u0300-\u036f\u0387\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u0669\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u06f0-\u06f9\u0711\u0730-\u074a\u07a6-\u07b0\u07c0-\u07c9\u07eb-\u07f3\u07fd\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u0898-\u089f\u08ca-\u08e1\u08e3-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u09e6-\u09ef\u09fe\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0ae6-\u0aef\u0afa-\u0aff\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b55-\u0b57\u0b62\u0b63\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c00-\u0c04\u0c3c\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c66-\u0c6f\u0c81-\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0ce6-\u0cef\u0cf3\u0d00-\u0d03\u0d3b\u0d3c\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d66-\u0d6f\u0d81-\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0de6-\u0def\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0e50-\u0e59\u0eb1\u0eb4-\u0ebc\u0ec8-\u0ece\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1040-\u1049\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u1369-\u1371\u1712-\u1715\u1732-\u1734\u1752\u1753\u1772\u1773\u17b4-\u17d3\u17dd\u17e0-\u17e9\u180b-\u180d\u180f-\u1819\u18a9\u1920-\u192b\u1930-\u193b\u1946-\u194f\u19d0-\u19da\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1ab0-\u1abd\u1abf-\u1ace\u1b00-\u1b04\u1b34-\u1b44\u1b50-\u1b59\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1bad\u1bb0-\u1bb9\u1be6-\u1bf3\u1c24-\u1c37\u1c40-\u1c49\u1c50-\u1c59\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf4\u1cf7-\u1cf9\u1dc0-\u1dff\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua620-\ua629\ua66f\ua674-\ua67d\ua69e\ua69f\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua82c\ua880\ua881\ua8b4-\ua8c5\ua8d0-\ua8d9\ua8e0-\ua8f1\ua8ff-\ua909\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\ua9d0-\ua9d9\ua9e5\ua9f0-\ua9f9\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa50-\uaa59\uaa7b-\uaa7d\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uaaeb-\uaaef\uaaf5\uaaf6\uabe3-\uabea\uabec\uabed\uabf0-\uabf9\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f";

  // This file was generated. Do not modify manually!
  var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u037f\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u052f\u0531-\u0556\u0559\u0560-\u0588\u05d0-\u05ea\u05ef-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u0860-\u086a\u0870-\u0887\u0889-\u088e\u08a0-\u08c9\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u09fc\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0af9\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c39\u0c3d\u0c58-\u0c5a\u0c5d\u0c60\u0c61\u0c80\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cdd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d04-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d54-\u0d56\u0d5f-\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e86-\u0e8a\u0e8c-\u0ea3\u0ea5\u0ea7-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f5\u13f8-\u13fd\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f8\u1700-\u1711\u171f-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1878\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191e\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19b0-\u19c9\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4c\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1c80-\u1c88\u1c90-\u1cba\u1cbd-\u1cbf\u1ce9-\u1cec\u1cee-\u1cf3\u1cf5\u1cf6\u1cfa\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2118-\u211d\u2124\u2126\u2128\u212a-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309b-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312f\u3131-\u318e\u31a0-\u31bf\u31f0-\u31ff\u3400-\u4dbf\u4e00-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua69d\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua7ca\ua7d0\ua7d1\ua7d3\ua7d5-\ua7d9\ua7f2-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua8fd\ua8fe\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\ua9e0-\ua9e4\ua9e6-\ua9ef\ua9fa-\ua9fe\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa7e-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uab30-\uab5a\uab5c-\uab69\uab70-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";

  // These are a run-length and offset encoded representation of the

  // Reserved word lists for various dialects of the language

  var reservedWords = {
    3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
    5: "class enum extends super const export import",
    6: "enum",
    strict: "implements interface let package private protected public static yield",
    strictBind: "eval arguments"
  };

  // And the keywords

  var ecma5AndLessKeywords = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this";

  var keywords$1 = {
    5: ecma5AndLessKeywords,
    "5module": ecma5AndLessKeywords + " export import",
    6: ecma5AndLessKeywords + " const class extends export import super"
  };

  var keywordRelationalOperator = /^in(stanceof)?$/;

  // ## Character categories

  var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
  var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");

  // This has a complexity linear to the value of the code. The
  // assumption is that looking up astral identifier characters is
  // rare.
  function isInAstralSet(code, set) {
    var pos = 0x10000;
    for (var i = 0; i < set.length; i += 2) {
      pos += set[i];
      if (pos > code) { return false }
      pos += set[i + 1];
      if (pos >= code) { return true }
    }
    return false
  }

  // Test whether a given character code starts an identifier.

  function isIdentifierStart(code, astral) {
    if (code < 65) { return code === 36 }
    if (code < 91) { return true }
    if (code < 97) { return code === 95 }
    if (code < 123) { return true }
    if (code <= 0xffff) { return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code)) }
    if (astral === false) { return false }
    return isInAstralSet(code, astralIdentifierStartCodes)
  }

  // Test whether a given character is part of an identifier.

  function isIdentifierChar(code, astral) {
    if (code < 48) { return code === 36 }
    if (code < 58) { return true }
    if (code < 65) { return false }
    if (code < 91) { return true }
    if (code < 97) { return code === 95 }
    if (code < 123) { return true }
    if (code <= 0xffff) { return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code)) }
    if (astral === false) { return false }
    return isInAstralSet(code, astralIdentifierStartCodes) || isInAstralSet(code, astralIdentifierCodes)
  }

  // ## Token types

  // The assignment of fine-grained, information-carrying type objects
  // allows the tokenizer to store the information it has about a
  // token in a way that is very cheap for the parser to look up.

  // All token type variables start with an underscore, to make them
  // easy to recognize.

  // The `beforeExpr` property is used to disambiguate between regular
  // expressions and divisions. It is set on all token types that can
  // be followed by an expression (thus, a slash after them would be a
  // regular expression).
  //
  // The `startsExpr` property is used to check if the token ends a
  // `yield` expression. It is set on all token types that either can
  // directly start an expression (like a quotation mark) or can
  // continue an expression (like the body of a string).
  //
  // `isLoop` marks a keyword as starting a loop, which is important
  // to know when parsing a label, in order to allow or disallow
  // continue jumps to that label.

  var TokenType = function TokenType(label, conf) {
    if ( conf === void 0 ) conf = {};

    this.label = label;
    this.keyword = conf.keyword;
    this.beforeExpr = !!conf.beforeExpr;
    this.startsExpr = !!conf.startsExpr;
    this.isLoop = !!conf.isLoop;
    this.isAssign = !!conf.isAssign;
    this.prefix = !!conf.prefix;
    this.postfix = !!conf.postfix;
    this.binop = conf.binop || null;
    this.updateContext = null;
  };

  function binop(name, prec) {
    return new TokenType(name, {beforeExpr: true, binop: prec})
  }
  var beforeExpr = {beforeExpr: true}, startsExpr = {startsExpr: true};

  // Map keyword names to token types.

  var keywords = {};

  // Succinct definitions of keyword token types
  function kw(name, options) {
    if ( options === void 0 ) options = {};

    options.keyword = name;
    return keywords[name] = new TokenType(name, options)
  }

  var types$1 = {
    num: new TokenType("num", startsExpr),
    regexp: new TokenType("regexp", startsExpr),
    string: new TokenType("string", startsExpr),
    name: new TokenType("name", startsExpr),
    privateId: new TokenType("privateId", startsExpr),
    eof: new TokenType("eof"),

    // Punctuation token types.
    bracketL: new TokenType("[", {beforeExpr: true, startsExpr: true}),
    bracketR: new TokenType("]"),
    braceL: new TokenType("{", {beforeExpr: true, startsExpr: true}),
    braceR: new TokenType("}"),
    parenL: new TokenType("(", {beforeExpr: true, startsExpr: true}),
    parenR: new TokenType(")"),
    comma: new TokenType(",", beforeExpr),
    semi: new TokenType(";", beforeExpr),
    colon: new TokenType(":", beforeExpr),
    dot: new TokenType("."),
    question: new TokenType("?", beforeExpr),
    questionDot: new TokenType("?."),
    arrow: new TokenType("=>", beforeExpr),
    template: new TokenType("template"),
    invalidTemplate: new TokenType("invalidTemplate"),
    ellipsis: new TokenType("...", beforeExpr),
    backQuote: new TokenType("`", startsExpr),
    dollarBraceL: new TokenType("${", {beforeExpr: true, startsExpr: true}),

    // Operators. These carry several kinds of properties to help the
    // parser use them properly (the presence of these properties is
    // what categorizes them as operators).
    //
    // `binop`, when present, specifies that this operator is a binary
    // operator, and will refer to its precedence.
    //
    // `prefix` and `postfix` mark the operator as a prefix or postfix
    // unary operator.
    //
    // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
    // binary operators with a very low precedence, that should result
    // in AssignmentExpression nodes.

    eq: new TokenType("=", {beforeExpr: true, isAssign: true}),
    assign: new TokenType("_=", {beforeExpr: true, isAssign: true}),
    incDec: new TokenType("++/--", {prefix: true, postfix: true, startsExpr: true}),
    prefix: new TokenType("!/~", {beforeExpr: true, prefix: true, startsExpr: true}),
    logicalOR: binop("||", 1),
    logicalAND: binop("&&", 2),
    bitwiseOR: binop("|", 3),
    bitwiseXOR: binop("^", 4),
    bitwiseAND: binop("&", 5),
    equality: binop("==/!=/===/!==", 6),
    relational: binop("</>/<=/>=", 7),
    bitShift: binop("<</>>/>>>", 8),
    plusMin: new TokenType("+/-", {beforeExpr: true, binop: 9, prefix: true, startsExpr: true}),
    modulo: binop("%", 10),
    star: binop("*", 10),
    slash: binop("/", 10),
    starstar: new TokenType("**", {beforeExpr: true}),
    coalesce: binop("??", 1),

    // Keyword token types.
    _break: kw("break"),
    _case: kw("case", beforeExpr),
    _catch: kw("catch"),
    _continue: kw("continue"),
    _debugger: kw("debugger"),
    _default: kw("default", beforeExpr),
    _do: kw("do", {isLoop: true, beforeExpr: true}),
    _else: kw("else", beforeExpr),
    _finally: kw("finally"),
    _for: kw("for", {isLoop: true}),
    _function: kw("function", startsExpr),
    _if: kw("if"),
    _return: kw("return", beforeExpr),
    _switch: kw("switch"),
    _throw: kw("throw", beforeExpr),
    _try: kw("try"),
    _var: kw("var"),
    _const: kw("const"),
    _while: kw("while", {isLoop: true}),
    _with: kw("with"),
    _new: kw("new", {beforeExpr: true, startsExpr: true}),
    _this: kw("this", startsExpr),
    _super: kw("super", startsExpr),
    _class: kw("class", startsExpr),
    _extends: kw("extends", beforeExpr),
    _export: kw("export"),
    _import: kw("import", startsExpr),
    _null: kw("null", startsExpr),
    _true: kw("true", startsExpr),
    _false: kw("false", startsExpr),
    _in: kw("in", {beforeExpr: true, binop: 7}),
    _instanceof: kw("instanceof", {beforeExpr: true, binop: 7}),
    _typeof: kw("typeof", {beforeExpr: true, prefix: true, startsExpr: true}),
    _void: kw("void", {beforeExpr: true, prefix: true, startsExpr: true}),
    _delete: kw("delete", {beforeExpr: true, prefix: true, startsExpr: true})
  };

  // Matches a whole line break (where CRLF is considered a single
  // line break). Used to count lines.

  var lineBreak = /\r\n?|\n|\u2028|\u2029/;
  var lineBreakG = new RegExp(lineBreak.source, "g");

  function isNewLine(code) {
    return code === 10 || code === 13 || code === 0x2028 || code === 0x2029
  }

  function nextLineBreak(code, from, end) {
    if ( end === void 0 ) end = code.length;

    for (var i = from; i < end; i++) {
      var next = code.charCodeAt(i);
      if (isNewLine(next))
        { return i < end - 1 && next === 13 && code.charCodeAt(i + 1) === 10 ? i + 2 : i + 1 }
    }
    return -1
  }

  var nonASCIIwhitespace = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/;

  var skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;

  var ref = Object.prototype;
  var hasOwnProperty = ref.hasOwnProperty;
  var toString = ref.toString;

  var hasOwn = Object.hasOwn || (function (obj, propName) { return (
    hasOwnProperty.call(obj, propName)
  ); });

  var isArray = Array.isArray || (function (obj) { return (
    toString.call(obj) === "[object Array]"
  ); });

  function wordsRegexp(words) {
    return new RegExp("^(?:" + words.replace(/ /g, "|") + ")$")
  }

  function codePointToString(code) {
    // UTF-16 Decoding
    if (code <= 0xFFFF) { return String.fromCharCode(code) }
    code -= 0x10000;
    return String.fromCharCode((code >> 10) + 0xD800, (code & 1023) + 0xDC00)
  }

  var loneSurrogate = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/;

  // These are used when `options.locations` is on, for the
  // `startLoc` and `endLoc` properties.

  var Position = function Position(line, col) {
    this.line = line;
    this.column = col;
  };

  Position.prototype.offset = function offset (n) {
    return new Position(this.line, this.column + n)
  };

  var SourceLocation = function SourceLocation(p, start, end) {
    this.start = start;
    this.end = end;
    if (p.sourceFile !== null) { this.source = p.sourceFile; }
  };

  // The `getLineInfo` function is mostly useful when the
  // `locations` option is off (for performance reasons) and you
  // want to find the line/column position for a given character
  // offset. `input` should be the code string that the offset refers
  // into.

  function getLineInfo(input, offset) {
    for (var line = 1, cur = 0;;) {
      var nextBreak = nextLineBreak(input, cur, offset);
      if (nextBreak < 0) { return new Position(line, offset - cur) }
      ++line;
      cur = nextBreak;
    }
  }

  // A second argument must be given to configure the parser process.
  // These options are recognized (only `ecmaVersion` is required):

  var defaultOptions = {
    // `ecmaVersion` indicates the ECMAScript version to parse. Must be
    // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
    // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
    // (the latest version the library supports). This influences
    // support for strict mode, the set of reserved words, and support
    // for new syntax features.
    ecmaVersion: null,
    // `sourceType` indicates the mode the code should be parsed in.
    // Can be either `"script"` or `"module"`. This influences global
    // strict mode and parsing of `import` and `export` declarations.
    sourceType: "script",
    // `onInsertedSemicolon` can be a callback that will be called
    // when a semicolon is automatically inserted. It will be passed
    // the position of the comma as an offset, and if `locations` is
    // enabled, it is given the location as a `{line, column}` object
    // as second argument.
    onInsertedSemicolon: null,
    // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
    // trailing commas.
    onTrailingComma: null,
    // By default, reserved words are only enforced if ecmaVersion >= 5.
    // Set `allowReserved` to a boolean value to explicitly turn this on
    // an off. When this option has the value "never", reserved words
    // and keywords can also not be used as property names.
    allowReserved: null,
    // When enabled, a return at the top level is not considered an
    // error.
    allowReturnOutsideFunction: false,
    // When enabled, import/export statements are not constrained to
    // appearing at the top of the program, and an import.meta expression
    // in a script isn't considered an error.
    allowImportExportEverywhere: false,
    // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
    // When enabled, await identifiers are allowed to appear at the top-level scope,
    // but they are still not allowed in non-async functions.
    allowAwaitOutsideFunction: null,
    // When enabled, super identifiers are not constrained to
    // appearing in methods and do not raise an error when they appear elsewhere.
    allowSuperOutsideMethod: null,
    // When enabled, hashbang directive in the beginning of file is
    // allowed and treated as a line comment. Enabled by default when
    // `ecmaVersion` >= 2023.
    allowHashBang: false,
    // When `locations` is on, `loc` properties holding objects with
    // `start` and `end` properties in `{line, column}` form (with
    // line being 1-based and column 0-based) will be attached to the
    // nodes.
    locations: false,
    // A function can be passed as `onToken` option, which will
    // cause Acorn to call that function with object in the same
    // format as tokens returned from `tokenizer().getToken()`. Note
    // that you are not allowed to call the parser from the
    // callback—that will corrupt its internal state.
    onToken: null,
    // A function can be passed as `onComment` option, which will
    // cause Acorn to call that function with `(block, text, start,
    // end)` parameters whenever a comment is skipped. `block` is a
    // boolean indicating whether this is a block (`/* */`) comment,
    // `text` is the content of the comment, and `start` and `end` are
    // character offsets that denote the start and end of the comment.
    // When the `locations` option is on, two more parameters are
    // passed, the full `{line, column}` locations of the start and
    // end of the comments. Note that you are not allowed to call the
    // parser from the callback—that will corrupt its internal state.
    onComment: null,
    // Nodes have their start and end characters offsets recorded in
    // `start` and `end` properties (directly on the node, rather than
    // the `loc` object, which holds line/column data. To also add a
    // [semi-standardized][range] `range` property holding a `[start,
    // end]` array with the same numbers, set the `ranges` option to
    // `true`.
    //
    // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
    ranges: false,
    // It is possible to parse multiple files into a single AST by
    // passing the tree produced by parsing the first file as
    // `program` option in subsequent parses. This will add the
    // toplevel forms of the parsed file to the `Program` (top) node
    // of an existing parse tree.
    program: null,
    // When `locations` is on, you can pass this to record the source
    // file in every node's `loc` object.
    sourceFile: null,
    // This value, if given, is stored in every node, whether
    // `locations` is on or off.
    directSourceFile: null,
    // When enabled, parenthesized expressions are represented by
    // (non-standard) ParenthesizedExpression nodes
    preserveParens: false
  };

  // Interpret and default an options object

  var warnedAboutEcmaVersion = false;

  function getOptions(opts) {
    var options = {};

    for (var opt in defaultOptions)
      { options[opt] = opts && hasOwn(opts, opt) ? opts[opt] : defaultOptions[opt]; }

    if (options.ecmaVersion === "latest") {
      options.ecmaVersion = 1e8;
    } else if (options.ecmaVersion == null) {
      if (!warnedAboutEcmaVersion && typeof console === "object" && console.warn) {
        warnedAboutEcmaVersion = true;
        console.warn("Since Acorn 8.0.0, options.ecmaVersion is required.\nDefaulting to 2020, but this will stop working in the future.");
      }
      options.ecmaVersion = 11;
    } else if (options.ecmaVersion >= 2015) {
      options.ecmaVersion -= 2009;
    }

    if (options.allowReserved == null)
      { options.allowReserved = options.ecmaVersion < 5; }

    if (!opts || opts.allowHashBang == null)
      { options.allowHashBang = options.ecmaVersion >= 14; }

    if (isArray(options.onToken)) {
      var tokens = options.onToken;
      options.onToken = function (token) { return tokens.push(token); };
    }
    if (isArray(options.onComment))
      { options.onComment = pushComment(options, options.onComment); }

    return options
  }

  function pushComment(options, array) {
    return function(block, text, start, end, startLoc, endLoc) {
      var comment = {
        type: block ? "Block" : "Line",
        value: text,
        start: start,
        end: end
      };
      if (options.locations)
        { comment.loc = new SourceLocation(this, startLoc, endLoc); }
      if (options.ranges)
        { comment.range = [start, end]; }
      array.push(comment);
    }
  }

  // Each scope gets a bitset that may contain these flags
  var
      SCOPE_TOP = 1,
      SCOPE_FUNCTION = 2,
      SCOPE_ASYNC = 4,
      SCOPE_GENERATOR = 8,
      SCOPE_ARROW = 16,
      SCOPE_SIMPLE_CATCH = 32,
      SCOPE_SUPER = 64,
      SCOPE_DIRECT_SUPER = 128,
      SCOPE_CLASS_STATIC_BLOCK = 256,
      SCOPE_VAR = SCOPE_TOP | SCOPE_FUNCTION | SCOPE_CLASS_STATIC_BLOCK;

  function functionFlags(async, generator) {
    return SCOPE_FUNCTION | (async ? SCOPE_ASYNC : 0) | (generator ? SCOPE_GENERATOR : 0)
  }

  // Used in checkLVal* and declareName to determine the type of a binding
  var
      BIND_NONE = 0, // Not a binding
      BIND_VAR = 1, // Var-style binding
      BIND_LEXICAL = 2, // Let- or const-style binding
      BIND_FUNCTION = 3, // Function declaration
      BIND_SIMPLE_CATCH = 4, // Simple (identifier pattern) catch binding
      BIND_OUTSIDE = 5; // Special case for function names as bound inside the function

  var Parser = function Parser(options, input, startPos) {
    this.options = options = getOptions(options);
    this.sourceFile = options.sourceFile;
    this.keywords = wordsRegexp(keywords$1[options.ecmaVersion >= 6 ? 6 : options.sourceType === "module" ? "5module" : 5]);
    var reserved = "";
    if (options.allowReserved !== true) {
      reserved = reservedWords[options.ecmaVersion >= 6 ? 6 : options.ecmaVersion === 5 ? 5 : 3];
      if (options.sourceType === "module") { reserved += " await"; }
    }
    this.reservedWords = wordsRegexp(reserved);
    var reservedStrict = (reserved ? reserved + " " : "") + reservedWords.strict;
    this.reservedWordsStrict = wordsRegexp(reservedStrict);
    this.reservedWordsStrictBind = wordsRegexp(reservedStrict + " " + reservedWords.strictBind);
    this.input = String(input);

    // Used to signal to callers of `readWord1` whether the word
    // contained any escape sequences. This is needed because words with
    // escape sequences must not be interpreted as keywords.
    this.containsEsc = false;

    // Set up token state

    // The current position of the tokenizer in the input.
    if (startPos) {
      this.pos = startPos;
      this.lineStart = this.input.lastIndexOf("\n", startPos - 1) + 1;
      this.curLine = this.input.slice(0, this.lineStart).split(lineBreak).length;
    } else {
      this.pos = this.lineStart = 0;
      this.curLine = 1;
    }

    // Properties of the current token:
    // Its type
    this.type = types$1.eof;
    // For tokens that include more information than their type, the value
    this.value = null;
    // Its start and end offset
    this.start = this.end = this.pos;
    // And, if locations are used, the {line, column} object
    // corresponding to those offsets
    this.startLoc = this.endLoc = this.curPosition();

    // Position information for the previous token
    this.lastTokEndLoc = this.lastTokStartLoc = null;
    this.lastTokStart = this.lastTokEnd = this.pos;

    // The context stack is used to superficially track syntactic
    // context to predict whether a regular expression is allowed in a
    // given position.
    this.context = this.initialContext();
    this.exprAllowed = true;

    // Figure out if it's a module code.
    this.inModule = options.sourceType === "module";
    this.strict = this.inModule || this.strictDirective(this.pos);

    // Used to signify the start of a potential arrow function
    this.potentialArrowAt = -1;
    this.potentialArrowInForAwait = false;

    // Positions to delayed-check that yield/await does not exist in default parameters.
    this.yieldPos = this.awaitPos = this.awaitIdentPos = 0;
    // Labels in scope.
    this.labels = [];
    // Thus-far undefined exports.
    this.undefinedExports = Object.create(null);

    // If enabled, skip leading hashbang line.
    if (this.pos === 0 && options.allowHashBang && this.input.slice(0, 2) === "#!")
      { this.skipLineComment(2); }

    // Scope tracking for duplicate variable names (see scope.js)
    this.scopeStack = [];
    this.enterScope(SCOPE_TOP);

    // For RegExp validation
    this.regexpState = null;

    // The stack of private names.
    // Each element has two properties: 'declared' and 'used'.
    // When it exited from the outermost class definition, all used private names must be declared.
    this.privateNameStack = [];
  };

  var prototypeAccessors = { inFunction: { configurable: true },inGenerator: { configurable: true },inAsync: { configurable: true },canAwait: { configurable: true },allowSuper: { configurable: true },allowDirectSuper: { configurable: true },treatFunctionsAsVar: { configurable: true },allowNewDotTarget: { configurable: true },inClassStaticBlock: { configurable: true } };

  Parser.prototype.parse = function parse () {
    var node = this.options.program || this.startNode();
    this.nextToken();
    return this.parseTopLevel(node)
  };

  prototypeAccessors.inFunction.get = function () { return (this.currentVarScope().flags & SCOPE_FUNCTION) > 0 };

  prototypeAccessors.inGenerator.get = function () { return (this.currentVarScope().flags & SCOPE_GENERATOR) > 0 && !this.currentVarScope().inClassFieldInit };

  prototypeAccessors.inAsync.get = function () { return (this.currentVarScope().flags & SCOPE_ASYNC) > 0 && !this.currentVarScope().inClassFieldInit };

  prototypeAccessors.canAwait.get = function () {
    for (var i = this.scopeStack.length - 1; i >= 0; i--) {
      var scope = this.scopeStack[i];
      if (scope.inClassFieldInit || scope.flags & SCOPE_CLASS_STATIC_BLOCK) { return false }
      if (scope.flags & SCOPE_FUNCTION) { return (scope.flags & SCOPE_ASYNC) > 0 }
    }
    return (this.inModule && this.options.ecmaVersion >= 13) || this.options.allowAwaitOutsideFunction
  };

  prototypeAccessors.allowSuper.get = function () {
    var ref = this.currentThisScope();
      var flags = ref.flags;
      var inClassFieldInit = ref.inClassFieldInit;
    return (flags & SCOPE_SUPER) > 0 || inClassFieldInit || this.options.allowSuperOutsideMethod
  };

  prototypeAccessors.allowDirectSuper.get = function () { return (this.currentThisScope().flags & SCOPE_DIRECT_SUPER) > 0 };

  prototypeAccessors.treatFunctionsAsVar.get = function () { return this.treatFunctionsAsVarInScope(this.currentScope()) };

  prototypeAccessors.allowNewDotTarget.get = function () {
    var ref = this.currentThisScope();
      var flags = ref.flags;
      var inClassFieldInit = ref.inClassFieldInit;
    return (flags & (SCOPE_FUNCTION | SCOPE_CLASS_STATIC_BLOCK)) > 0 || inClassFieldInit
  };

  prototypeAccessors.inClassStaticBlock.get = function () {
    return (this.currentVarScope().flags & SCOPE_CLASS_STATIC_BLOCK) > 0
  };

  Parser.extend = function extend () {
      var plugins = [], len = arguments.length;
      while ( len-- ) plugins[ len ] = arguments[ len ];

    var cls = this;
    for (var i = 0; i < plugins.length; i++) { cls = plugins[i](cls); }
    return cls
  };

  Parser.parse = function parse (input, options) {
    return new this(options, input).parse()
  };

  Parser.parseExpressionAt = function parseExpressionAt (input, pos, options) {
    var parser = new this(options, input, pos);
    parser.nextToken();
    return parser.parseExpression()
  };

  Parser.tokenizer = function tokenizer (input, options) {
    return new this(options, input)
  };

  Object.defineProperties( Parser.prototype, prototypeAccessors );

  var pp$9 = Parser.prototype;

  // ## Parser utilities

  var literal = /^(?:'((?:\\.|[^'\\])*?)'|"((?:\\.|[^"\\])*?)")/;
  pp$9.strictDirective = function(start) {
    if (this.options.ecmaVersion < 5) { return false }
    for (;;) {
      // Try to find string literal.
      skipWhiteSpace.lastIndex = start;
      start += skipWhiteSpace.exec(this.input)[0].length;
      var match = literal.exec(this.input.slice(start));
      if (!match) { return false }
      if ((match[1] || match[2]) === "use strict") {
        skipWhiteSpace.lastIndex = start + match[0].length;
        var spaceAfter = skipWhiteSpace.exec(this.input), end = spaceAfter.index + spaceAfter[0].length;
        var next = this.input.charAt(end);
        return next === ";" || next === "}" ||
          (lineBreak.test(spaceAfter[0]) &&
           !(/[(`.[+\-/*%<>=,?^&]/.test(next) || next === "!" && this.input.charAt(end + 1) === "="))
      }
      start += match[0].length;

      // Skip semicolon, if any.
      skipWhiteSpace.lastIndex = start;
      start += skipWhiteSpace.exec(this.input)[0].length;
      if (this.input[start] === ";")
        { start++; }
    }
  };

  // Predicate that tests whether the next token is of the given
  // type, and if yes, consumes it as a side effect.

  pp$9.eat = function(type) {
    if (this.type === type) {
      this.next();
      return true
    } else {
      return false
    }
  };

  // Tests whether parsed token is a contextual keyword.

  pp$9.isContextual = function(name) {
    return this.type === types$1.name && this.value === name && !this.containsEsc
  };

  // Consumes contextual keyword if possible.

  pp$9.eatContextual = function(name) {
    if (!this.isContextual(name)) { return false }
    this.next();
    return true
  };

  // Asserts that following token is given contextual keyword.

  pp$9.expectContextual = function(name) {
    if (!this.eatContextual(name)) { this.unexpected(); }
  };

  // Test whether a semicolon can be inserted at the current position.

  pp$9.canInsertSemicolon = function() {
    return this.type === types$1.eof ||
      this.type === types$1.braceR ||
      lineBreak.test(this.input.slice(this.lastTokEnd, this.start))
  };

  pp$9.insertSemicolon = function() {
    if (this.canInsertSemicolon()) {
      if (this.options.onInsertedSemicolon)
        { this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc); }
      return true
    }
  };

  // Consume a semicolon, or, failing that, see if we are allowed to
  // pretend that there is a semicolon at this position.

  pp$9.semicolon = function() {
    if (!this.eat(types$1.semi) && !this.insertSemicolon()) { this.unexpected(); }
  };

  pp$9.afterTrailingComma = function(tokType, notNext) {
    if (this.type === tokType) {
      if (this.options.onTrailingComma)
        { this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc); }
      if (!notNext)
        { this.next(); }
      return true
    }
  };

  // Expect a token of a given type. If found, consume it, otherwise,
  // raise an unexpected token error.

  pp$9.expect = function(type) {
    this.eat(type) || this.unexpected();
  };

  // Raise an unexpected token error.

  pp$9.unexpected = function(pos) {
    this.raise(pos != null ? pos : this.start, "Unexpected token");
  };

  var DestructuringErrors = function DestructuringErrors() {
    this.shorthandAssign =
    this.trailingComma =
    this.parenthesizedAssign =
    this.parenthesizedBind =
    this.doubleProto =
      -1;
  };

  pp$9.checkPatternErrors = function(refDestructuringErrors, isAssign) {
    if (!refDestructuringErrors) { return }
    if (refDestructuringErrors.trailingComma > -1)
      { this.raiseRecoverable(refDestructuringErrors.trailingComma, "Comma is not permitted after the rest element"); }
    var parens = isAssign ? refDestructuringErrors.parenthesizedAssign : refDestructuringErrors.parenthesizedBind;
    if (parens > -1) { this.raiseRecoverable(parens, isAssign ? "Assigning to rvalue" : "Parenthesized pattern"); }
  };

  pp$9.checkExpressionErrors = function(refDestructuringErrors, andThrow) {
    if (!refDestructuringErrors) { return false }
    var shorthandAssign = refDestructuringErrors.shorthandAssign;
    var doubleProto = refDestructuringErrors.doubleProto;
    if (!andThrow) { return shorthandAssign >= 0 || doubleProto >= 0 }
    if (shorthandAssign >= 0)
      { this.raise(shorthandAssign, "Shorthand property assignments are valid only in destructuring patterns"); }
    if (doubleProto >= 0)
      { this.raiseRecoverable(doubleProto, "Redefinition of __proto__ property"); }
  };

  pp$9.checkYieldAwaitInDefaultParams = function() {
    if (this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos))
      { this.raise(this.yieldPos, "Yield expression cannot be a default value"); }
    if (this.awaitPos)
      { this.raise(this.awaitPos, "Await expression cannot be a default value"); }
  };

  pp$9.isSimpleAssignTarget = function(expr) {
    if (expr.type === "ParenthesizedExpression")
      { return this.isSimpleAssignTarget(expr.expression) }
    return expr.type === "Identifier" || expr.type === "MemberExpression"
  };

  var pp$8 = Parser.prototype;

  // ### Statement parsing

  // Parse a program. Initializes the parser, reads any number of
  // statements, and wraps them in a Program node.  Optionally takes a
  // `program` argument.  If present, the statements will be appended
  // to its body instead of creating a new node.

  pp$8.parseTopLevel = function(node) {
    var exports = Object.create(null);
    if (!node.body) { node.body = []; }
    while (this.type !== types$1.eof) {
      var stmt = this.parseStatement(null, true, exports);
      node.body.push(stmt);
    }
    if (this.inModule)
      { for (var i = 0, list = Object.keys(this.undefinedExports); i < list.length; i += 1)
        {
          var name = list[i];

          this.raiseRecoverable(this.undefinedExports[name].start, ("Export '" + name + "' is not defined"));
        } }
    this.adaptDirectivePrologue(node.body);
    this.next();
    node.sourceType = this.options.sourceType;
    return this.finishNode(node, "Program")
  };

  var loopLabel = {kind: "loop"}, switchLabel = {kind: "switch"};

  pp$8.isLet = function(context) {
    if (this.options.ecmaVersion < 6 || !this.isContextual("let")) { return false }
    skipWhiteSpace.lastIndex = this.pos;
    var skip = skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length, nextCh = this.input.charCodeAt(next);
    // For ambiguous cases, determine if a LexicalDeclaration (or only a
    // Statement) is allowed here. If context is not empty then only a Statement
    // is allowed. However, `let [` is an explicit negative lookahead for
    // ExpressionStatement, so special-case it first.
    if (nextCh === 91 || nextCh === 92) { return true } // '[', '/'
    if (context) { return false }

    if (nextCh === 123 || nextCh > 0xd7ff && nextCh < 0xdc00) { return true } // '{', astral
    if (isIdentifierStart(nextCh, true)) {
      var pos = next + 1;
      while (isIdentifierChar(nextCh = this.input.charCodeAt(pos), true)) { ++pos; }
      if (nextCh === 92 || nextCh > 0xd7ff && nextCh < 0xdc00) { return true }
      var ident = this.input.slice(next, pos);
      if (!keywordRelationalOperator.test(ident)) { return true }
    }
    return false
  };

  // check 'async [no LineTerminator here] function'
  // - 'async /*foo*/ function' is OK.
  // - 'async /*\n*/ function' is invalid.
  pp$8.isAsyncFunction = function() {
    if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
      { return false }

    skipWhiteSpace.lastIndex = this.pos;
    var skip = skipWhiteSpace.exec(this.input);
    var next = this.pos + skip[0].length, after;
    return !lineBreak.test(this.input.slice(this.pos, next)) &&
      this.input.slice(next, next + 8) === "function" &&
      (next + 8 === this.input.length ||
       !(isIdentifierChar(after = this.input.charCodeAt(next + 8)) || after > 0xd7ff && after < 0xdc00))
  };

  // Parse a single statement.
  //
  // If expecting a statement and finding a slash operator, parse a
  // regular expression literal. This is to handle cases like
  // `if (foo) /blah/.exec(foo)`, where looking at the previous token
  // does not help.

  pp$8.parseStatement = function(context, topLevel, exports) {
    var starttype = this.type, node = this.startNode(), kind;

    if (this.isLet(context)) {
      starttype = types$1._var;
      kind = "let";
    }

    // Most types of statements are recognized by the keyword they
    // start with. Many are trivial to parse, some require a bit of
    // complexity.

    switch (starttype) {
    case types$1._break: case types$1._continue: return this.parseBreakContinueStatement(node, starttype.keyword)
    case types$1._debugger: return this.parseDebuggerStatement(node)
    case types$1._do: return this.parseDoStatement(node)
    case types$1._for: return this.parseForStatement(node)
    case types$1._function:
      // Function as sole body of either an if statement or a labeled statement
      // works, but not when it is part of a labeled statement that is the sole
      // body of an if statement.
      if ((context && (this.strict || context !== "if" && context !== "label")) && this.options.ecmaVersion >= 6) { this.unexpected(); }
      return this.parseFunctionStatement(node, false, !context)
    case types$1._class:
      if (context) { this.unexpected(); }
      return this.parseClass(node, true)
    case types$1._if: return this.parseIfStatement(node)
    case types$1._return: return this.parseReturnStatement(node)
    case types$1._switch: return this.parseSwitchStatement(node)
    case types$1._throw: return this.parseThrowStatement(node)
    case types$1._try: return this.parseTryStatement(node)
    case types$1._const: case types$1._var:
      kind = kind || this.value;
      if (context && kind !== "var") { this.unexpected(); }
      return this.parseVarStatement(node, kind)
    case types$1._while: return this.parseWhileStatement(node)
    case types$1._with: return this.parseWithStatement(node)
    case types$1.braceL: return this.parseBlock(true, node)
    case types$1.semi: return this.parseEmptyStatement(node)
    case types$1._export:
    case types$1._import:
      if (this.options.ecmaVersion > 10 && starttype === types$1._import) {
        skipWhiteSpace.lastIndex = this.pos;
        var skip = skipWhiteSpace.exec(this.input);
        var next = this.pos + skip[0].length, nextCh = this.input.charCodeAt(next);
        if (nextCh === 40 || nextCh === 46) // '(' or '.'
          { return this.parseExpressionStatement(node, this.parseExpression()) }
      }

      if (!this.options.allowImportExportEverywhere) {
        if (!topLevel)
          { this.raise(this.start, "'import' and 'export' may only appear at the top level"); }
        if (!this.inModule)
          { this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'"); }
      }
      return starttype === types$1._import ? this.parseImport(node) : this.parseExport(node, exports)

      // If the statement does not start with a statement keyword or a
      // brace, it's an ExpressionStatement or LabeledStatement. We
      // simply start parsing an expression, and afterwards, if the
      // next token is a colon and the expression was a simple
      // Identifier node, we switch to interpreting it as a label.
    default:
      if (this.isAsyncFunction()) {
        if (context) { this.unexpected(); }
        this.next();
        return this.parseFunctionStatement(node, true, !context)
      }

      var maybeName = this.value, expr = this.parseExpression();
      if (starttype === types$1.name && expr.type === "Identifier" && this.eat(types$1.colon))
        { return this.parseLabeledStatement(node, maybeName, expr, context) }
      else { return this.parseExpressionStatement(node, expr) }
    }
  };

  pp$8.parseBreakContinueStatement = function(node, keyword) {
    var isBreak = keyword === "break";
    this.next();
    if (this.eat(types$1.semi) || this.insertSemicolon()) { node.label = null; }
    else if (this.type !== types$1.name) { this.unexpected(); }
    else {
      node.label = this.parseIdent();
      this.semicolon();
    }

    // Verify that there is an actual destination to break or
    // continue to.
    var i = 0;
    for (; i < this.labels.length; ++i) {
      var lab = this.labels[i];
      if (node.label == null || lab.name === node.label.name) {
        if (lab.kind != null && (isBreak || lab.kind === "loop")) { break }
        if (node.label && isBreak) { break }
      }
    }
    if (i === this.labels.length) { this.raise(node.start, "Unsyntactic " + keyword); }
    return this.finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement")
  };

  pp$8.parseDebuggerStatement = function(node) {
    this.next();
    this.semicolon();
    return this.finishNode(node, "DebuggerStatement")
  };

  pp$8.parseDoStatement = function(node) {
    this.next();
    this.labels.push(loopLabel);
    node.body = this.parseStatement("do");
    this.labels.pop();
    this.expect(types$1._while);
    node.test = this.parseParenExpression();
    if (this.options.ecmaVersion >= 6)
      { this.eat(types$1.semi); }
    else
      { this.semicolon(); }
    return this.finishNode(node, "DoWhileStatement")
  };

  // Disambiguating between a `for` and a `for`/`in` or `for`/`of`
  // loop is non-trivial. Basically, we have to parse the init `var`
  // statement or expression, disallowing the `in` operator (see
  // the second parameter to `parseExpression`), and then check
  // whether the next token is `in` or `of`. When there is no init
  // part (semicolon immediately after the opening parenthesis), it
  // is a regular `for` loop.

  pp$8.parseForStatement = function(node) {
    this.next();
    var awaitAt = (this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await")) ? this.lastTokStart : -1;
    this.labels.push(loopLabel);
    this.enterScope(0);
    this.expect(types$1.parenL);
    if (this.type === types$1.semi) {
      if (awaitAt > -1) { this.unexpected(awaitAt); }
      return this.parseFor(node, null)
    }
    var isLet = this.isLet();
    if (this.type === types$1._var || this.type === types$1._const || isLet) {
      var init$1 = this.startNode(), kind = isLet ? "let" : this.value;
      this.next();
      this.parseVar(init$1, true, kind);
      this.finishNode(init$1, "VariableDeclaration");
      if ((this.type === types$1._in || (this.options.ecmaVersion >= 6 && this.isContextual("of"))) && init$1.declarations.length === 1) {
        if (this.options.ecmaVersion >= 9) {
          if (this.type === types$1._in) {
            if (awaitAt > -1) { this.unexpected(awaitAt); }
          } else { node.await = awaitAt > -1; }
        }
        return this.parseForIn(node, init$1)
      }
      if (awaitAt > -1) { this.unexpected(awaitAt); }
      return this.parseFor(node, init$1)
    }
    var startsWithLet = this.isContextual("let"), isForOf = false;
    var refDestructuringErrors = new DestructuringErrors;
    var init = this.parseExpression(awaitAt > -1 ? "await" : true, refDestructuringErrors);
    if (this.type === types$1._in || (isForOf = this.options.ecmaVersion >= 6 && this.isContextual("of"))) {
      if (this.options.ecmaVersion >= 9) {
        if (this.type === types$1._in) {
          if (awaitAt > -1) { this.unexpected(awaitAt); }
        } else { node.await = awaitAt > -1; }
      }
      if (startsWithLet && isForOf) { this.raise(init.start, "The left-hand side of a for-of loop may not start with 'let'."); }
      this.toAssignable(init, false, refDestructuringErrors);
      this.checkLValPattern(init);
      return this.parseForIn(node, init)
    } else {
      this.checkExpressionErrors(refDestructuringErrors, true);
    }
    if (awaitAt > -1) { this.unexpected(awaitAt); }
    return this.parseFor(node, init)
  };

  pp$8.parseFunctionStatement = function(node, isAsync, declarationPosition) {
    this.next();
    return this.parseFunction(node, FUNC_STATEMENT | (declarationPosition ? 0 : FUNC_HANGING_STATEMENT), false, isAsync)
  };

  pp$8.parseIfStatement = function(node) {
    this.next();
    node.test = this.parseParenExpression();
    // allow function declarations in branches, but only in non-strict mode
    node.consequent = this.parseStatement("if");
    node.alternate = this.eat(types$1._else) ? this.parseStatement("if") : null;
    return this.finishNode(node, "IfStatement")
  };

  pp$8.parseReturnStatement = function(node) {
    if (!this.inFunction && !this.options.allowReturnOutsideFunction)
      { this.raise(this.start, "'return' outside of function"); }
    this.next();

    // In `return` (and `break`/`continue`), the keywords with
    // optional arguments, we eagerly look for a semicolon or the
    // possibility to insert one.

    if (this.eat(types$1.semi) || this.insertSemicolon()) { node.argument = null; }
    else { node.argument = this.parseExpression(); this.semicolon(); }
    return this.finishNode(node, "ReturnStatement")
  };

  pp$8.parseSwitchStatement = function(node) {
    this.next();
    node.discriminant = this.parseParenExpression();
    node.cases = [];
    this.expect(types$1.braceL);
    this.labels.push(switchLabel);
    this.enterScope(0);

    // Statements under must be grouped (by label) in SwitchCase
    // nodes. `cur` is used to keep the node that we are currently
    // adding statements to.

    var cur;
    for (var sawDefault = false; this.type !== types$1.braceR;) {
      if (this.type === types$1._case || this.type === types$1._default) {
        var isCase = this.type === types$1._case;
        if (cur) { this.finishNode(cur, "SwitchCase"); }
        node.cases.push(cur = this.startNode());
        cur.consequent = [];
        this.next();
        if (isCase) {
          cur.test = this.parseExpression();
        } else {
          if (sawDefault) { this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"); }
          sawDefault = true;
          cur.test = null;
        }
        this.expect(types$1.colon);
      } else {
        if (!cur) { this.unexpected(); }
        cur.consequent.push(this.parseStatement(null));
      }
    }
    this.exitScope();
    if (cur) { this.finishNode(cur, "SwitchCase"); }
    this.next(); // Closing brace
    this.labels.pop();
    return this.finishNode(node, "SwitchStatement")
  };

  pp$8.parseThrowStatement = function(node) {
    this.next();
    if (lineBreak.test(this.input.slice(this.lastTokEnd, this.start)))
      { this.raise(this.lastTokEnd, "Illegal newline after throw"); }
    node.argument = this.parseExpression();
    this.semicolon();
    return this.finishNode(node, "ThrowStatement")
  };

  // Reused empty array added for node fields that are always empty.

  var empty$1 = [];

  pp$8.parseTryStatement = function(node) {
    this.next();
    node.block = this.parseBlock();
    node.handler = null;
    if (this.type === types$1._catch) {
      var clause = this.startNode();
      this.next();
      if (this.eat(types$1.parenL)) {
        clause.param = this.parseBindingAtom();
        var simple = clause.param.type === "Identifier";
        this.enterScope(simple ? SCOPE_SIMPLE_CATCH : 0);
        this.checkLValPattern(clause.param, simple ? BIND_SIMPLE_CATCH : BIND_LEXICAL);
        this.expect(types$1.parenR);
      } else {
        if (this.options.ecmaVersion < 10) { this.unexpected(); }
        clause.param = null;
        this.enterScope(0);
      }
      clause.body = this.parseBlock(false);
      this.exitScope();
      node.handler = this.finishNode(clause, "CatchClause");
    }
    node.finalizer = this.eat(types$1._finally) ? this.parseBlock() : null;
    if (!node.handler && !node.finalizer)
      { this.raise(node.start, "Missing catch or finally clause"); }
    return this.finishNode(node, "TryStatement")
  };

  pp$8.parseVarStatement = function(node, kind) {
    this.next();
    this.parseVar(node, false, kind);
    this.semicolon();
    return this.finishNode(node, "VariableDeclaration")
  };

  pp$8.parseWhileStatement = function(node) {
    this.next();
    node.test = this.parseParenExpression();
    this.labels.push(loopLabel);
    node.body = this.parseStatement("while");
    this.labels.pop();
    return this.finishNode(node, "WhileStatement")
  };

  pp$8.parseWithStatement = function(node) {
    if (this.strict) { this.raise(this.start, "'with' in strict mode"); }
    this.next();
    node.object = this.parseParenExpression();
    node.body = this.parseStatement("with");
    return this.finishNode(node, "WithStatement")
  };

  pp$8.parseEmptyStatement = function(node) {
    this.next();
    return this.finishNode(node, "EmptyStatement")
  };

  pp$8.parseLabeledStatement = function(node, maybeName, expr, context) {
    for (var i$1 = 0, list = this.labels; i$1 < list.length; i$1 += 1)
      {
      var label = list[i$1];

      if (label.name === maybeName)
        { this.raise(expr.start, "Label '" + maybeName + "' is already declared");
    } }
    var kind = this.type.isLoop ? "loop" : this.type === types$1._switch ? "switch" : null;
    for (var i = this.labels.length - 1; i >= 0; i--) {
      var label$1 = this.labels[i];
      if (label$1.statementStart === node.start) {
        // Update information about previous labels on this node
        label$1.statementStart = this.start;
        label$1.kind = kind;
      } else { break }
    }
    this.labels.push({name: maybeName, kind: kind, statementStart: this.start});
    node.body = this.parseStatement(context ? context.indexOf("label") === -1 ? context + "label" : context : "label");
    this.labels.pop();
    node.label = expr;
    return this.finishNode(node, "LabeledStatement")
  };

  pp$8.parseExpressionStatement = function(node, expr) {
    node.expression = expr;
    this.semicolon();
    return this.finishNode(node, "ExpressionStatement")
  };

  // Parse a semicolon-enclosed block of statements, handling `"use
  // strict"` declarations when `allowStrict` is true (used for
  // function bodies).

  pp$8.parseBlock = function(createNewLexicalScope, node, exitStrict) {
    if ( createNewLexicalScope === void 0 ) createNewLexicalScope = true;
    if ( node === void 0 ) node = this.startNode();

    node.body = [];
    this.expect(types$1.braceL);
    if (createNewLexicalScope) { this.enterScope(0); }
    while (this.type !== types$1.braceR) {
      var stmt = this.parseStatement(null);
      node.body.push(stmt);
    }
    if (exitStrict) { this.strict = false; }
    this.next();
    if (createNewLexicalScope) { this.exitScope(); }
    return this.finishNode(node, "BlockStatement")
  };

  // Parse a regular `for` loop. The disambiguation code in
  // `parseStatement` will already have parsed the init statement or
  // expression.

  pp$8.parseFor = function(node, init) {
    node.init = init;
    this.expect(types$1.semi);
    node.test = this.type === types$1.semi ? null : this.parseExpression();
    this.expect(types$1.semi);
    node.update = this.type === types$1.parenR ? null : this.parseExpression();
    this.expect(types$1.parenR);
    node.body = this.parseStatement("for");
    this.exitScope();
    this.labels.pop();
    return this.finishNode(node, "ForStatement")
  };

  // Parse a `for`/`in` and `for`/`of` loop, which are almost
  // same from parser's perspective.

  pp$8.parseForIn = function(node, init) {
    var isForIn = this.type === types$1._in;
    this.next();

    if (
      init.type === "VariableDeclaration" &&
      init.declarations[0].init != null &&
      (
        !isForIn ||
        this.options.ecmaVersion < 8 ||
        this.strict ||
        init.kind !== "var" ||
        init.declarations[0].id.type !== "Identifier"
      )
    ) {
      this.raise(
        init.start,
        ((isForIn ? "for-in" : "for-of") + " loop variable declaration may not have an initializer")
      );
    }
    node.left = init;
    node.right = isForIn ? this.parseExpression() : this.parseMaybeAssign();
    this.expect(types$1.parenR);
    node.body = this.parseStatement("for");
    this.exitScope();
    this.labels.pop();
    return this.finishNode(node, isForIn ? "ForInStatement" : "ForOfStatement")
  };

  // Parse a list of variable declarations.

  pp$8.parseVar = function(node, isFor, kind) {
    node.declarations = [];
    node.kind = kind;
    for (;;) {
      var decl = this.startNode();
      this.parseVarId(decl, kind);
      if (this.eat(types$1.eq)) {
        decl.init = this.parseMaybeAssign(isFor);
      } else if (kind === "const" && !(this.type === types$1._in || (this.options.ecmaVersion >= 6 && this.isContextual("of")))) {
        this.unexpected();
      } else if (decl.id.type !== "Identifier" && !(isFor && (this.type === types$1._in || this.isContextual("of")))) {
        this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value");
      } else {
        decl.init = null;
      }
      node.declarations.push(this.finishNode(decl, "VariableDeclarator"));
      if (!this.eat(types$1.comma)) { break }
    }
    return node
  };

  pp$8.parseVarId = function(decl, kind) {
    decl.id = this.parseBindingAtom();
    this.checkLValPattern(decl.id, kind === "var" ? BIND_VAR : BIND_LEXICAL, false);
  };

  var FUNC_STATEMENT = 1, FUNC_HANGING_STATEMENT = 2, FUNC_NULLABLE_ID = 4;

  // Parse a function declaration or literal (depending on the
  // `statement & FUNC_STATEMENT`).

  // Remove `allowExpressionBody` for 7.0.0, as it is only called with false
  pp$8.parseFunction = function(node, statement, allowExpressionBody, isAsync, forInit) {
    this.initFunction(node);
    if (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !isAsync) {
      if (this.type === types$1.star && (statement & FUNC_HANGING_STATEMENT))
        { this.unexpected(); }
      node.generator = this.eat(types$1.star);
    }
    if (this.options.ecmaVersion >= 8)
      { node.async = !!isAsync; }

    if (statement & FUNC_STATEMENT) {
      node.id = (statement & FUNC_NULLABLE_ID) && this.type !== types$1.name ? null : this.parseIdent();
      if (node.id && !(statement & FUNC_HANGING_STATEMENT))
        // If it is a regular function declaration in sloppy mode, then it is
        // subject to Annex B semantics (BIND_FUNCTION). Otherwise, the binding
        // mode depends on properties of the current scope (see
        // treatFunctionsAsVar).
        { this.checkLValSimple(node.id, (this.strict || node.generator || node.async) ? this.treatFunctionsAsVar ? BIND_VAR : BIND_LEXICAL : BIND_FUNCTION); }
    }

    var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    this.enterScope(functionFlags(node.async, node.generator));

    if (!(statement & FUNC_STATEMENT))
      { node.id = this.type === types$1.name ? this.parseIdent() : null; }

    this.parseFunctionParams(node);
    this.parseFunctionBody(node, allowExpressionBody, false, forInit);

    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, (statement & FUNC_STATEMENT) ? "FunctionDeclaration" : "FunctionExpression")
  };

  pp$8.parseFunctionParams = function(node) {
    this.expect(types$1.parenL);
    node.params = this.parseBindingList(types$1.parenR, false, this.options.ecmaVersion >= 8);
    this.checkYieldAwaitInDefaultParams();
  };

  // Parse a class declaration or literal (depending on the
  // `isStatement` parameter).

  pp$8.parseClass = function(node, isStatement) {
    this.next();

    // ecma-262 14.6 Class Definitions
    // A class definition is always strict mode code.
    var oldStrict = this.strict;
    this.strict = true;

    this.parseClassId(node, isStatement);
    this.parseClassSuper(node);
    var privateNameMap = this.enterClassBody();
    var classBody = this.startNode();
    var hadConstructor = false;
    classBody.body = [];
    this.expect(types$1.braceL);
    while (this.type !== types$1.braceR) {
      var element = this.parseClassElement(node.superClass !== null);
      if (element) {
        classBody.body.push(element);
        if (element.type === "MethodDefinition" && element.kind === "constructor") {
          if (hadConstructor) { this.raise(element.start, "Duplicate constructor in the same class"); }
          hadConstructor = true;
        } else if (element.key && element.key.type === "PrivateIdentifier" && isPrivateNameConflicted(privateNameMap, element)) {
          this.raiseRecoverable(element.key.start, ("Identifier '#" + (element.key.name) + "' has already been declared"));
        }
      }
    }
    this.strict = oldStrict;
    this.next();
    node.body = this.finishNode(classBody, "ClassBody");
    this.exitClassBody();
    return this.finishNode(node, isStatement ? "ClassDeclaration" : "ClassExpression")
  };

  pp$8.parseClassElement = function(constructorAllowsSuper) {
    if (this.eat(types$1.semi)) { return null }

    var ecmaVersion = this.options.ecmaVersion;
    var node = this.startNode();
    var keyName = "";
    var isGenerator = false;
    var isAsync = false;
    var kind = "method";
    var isStatic = false;

    if (this.eatContextual("static")) {
      // Parse static init block
      if (ecmaVersion >= 13 && this.eat(types$1.braceL)) {
        this.parseClassStaticBlock(node);
        return node
      }
      if (this.isClassElementNameStart() || this.type === types$1.star) {
        isStatic = true;
      } else {
        keyName = "static";
      }
    }
    node.static = isStatic;
    if (!keyName && ecmaVersion >= 8 && this.eatContextual("async")) {
      if ((this.isClassElementNameStart() || this.type === types$1.star) && !this.canInsertSemicolon()) {
        isAsync = true;
      } else {
        keyName = "async";
      }
    }
    if (!keyName && (ecmaVersion >= 9 || !isAsync) && this.eat(types$1.star)) {
      isGenerator = true;
    }
    if (!keyName && !isAsync && !isGenerator) {
      var lastValue = this.value;
      if (this.eatContextual("get") || this.eatContextual("set")) {
        if (this.isClassElementNameStart()) {
          kind = lastValue;
        } else {
          keyName = lastValue;
        }
      }
    }

    // Parse element name
    if (keyName) {
      // 'async', 'get', 'set', or 'static' were not a keyword contextually.
      // The last token is any of those. Make it the element name.
      node.computed = false;
      node.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc);
      node.key.name = keyName;
      this.finishNode(node.key, "Identifier");
    } else {
      this.parseClassElementName(node);
    }

    // Parse element value
    if (ecmaVersion < 13 || this.type === types$1.parenL || kind !== "method" || isGenerator || isAsync) {
      var isConstructor = !node.static && checkKeyName(node, "constructor");
      var allowsDirectSuper = isConstructor && constructorAllowsSuper;
      // Couldn't move this check into the 'parseClassMethod' method for backward compatibility.
      if (isConstructor && kind !== "method") { this.raise(node.key.start, "Constructor can't have get/set modifier"); }
      node.kind = isConstructor ? "constructor" : kind;
      this.parseClassMethod(node, isGenerator, isAsync, allowsDirectSuper);
    } else {
      this.parseClassField(node);
    }

    return node
  };

  pp$8.isClassElementNameStart = function() {
    return (
      this.type === types$1.name ||
      this.type === types$1.privateId ||
      this.type === types$1.num ||
      this.type === types$1.string ||
      this.type === types$1.bracketL ||
      this.type.keyword
    )
  };

  pp$8.parseClassElementName = function(element) {
    if (this.type === types$1.privateId) {
      if (this.value === "constructor") {
        this.raise(this.start, "Classes can't have an element named '#constructor'");
      }
      element.computed = false;
      element.key = this.parsePrivateIdent();
    } else {
      this.parsePropertyName(element);
    }
  };

  pp$8.parseClassMethod = function(method, isGenerator, isAsync, allowsDirectSuper) {
    // Check key and flags
    var key = method.key;
    if (method.kind === "constructor") {
      if (isGenerator) { this.raise(key.start, "Constructor can't be a generator"); }
      if (isAsync) { this.raise(key.start, "Constructor can't be an async method"); }
    } else if (method.static && checkKeyName(method, "prototype")) {
      this.raise(key.start, "Classes may not have a static property named prototype");
    }

    // Parse value
    var value = method.value = this.parseMethod(isGenerator, isAsync, allowsDirectSuper);

    // Check value
    if (method.kind === "get" && value.params.length !== 0)
      { this.raiseRecoverable(value.start, "getter should have no params"); }
    if (method.kind === "set" && value.params.length !== 1)
      { this.raiseRecoverable(value.start, "setter should have exactly one param"); }
    if (method.kind === "set" && value.params[0].type === "RestElement")
      { this.raiseRecoverable(value.params[0].start, "Setter cannot use rest params"); }

    return this.finishNode(method, "MethodDefinition")
  };

  pp$8.parseClassField = function(field) {
    if (checkKeyName(field, "constructor")) {
      this.raise(field.key.start, "Classes can't have a field named 'constructor'");
    } else if (field.static && checkKeyName(field, "prototype")) {
      this.raise(field.key.start, "Classes can't have a static field named 'prototype'");
    }

    if (this.eat(types$1.eq)) {
      // To raise SyntaxError if 'arguments' exists in the initializer.
      var scope = this.currentThisScope();
      var inClassFieldInit = scope.inClassFieldInit;
      scope.inClassFieldInit = true;
      field.value = this.parseMaybeAssign();
      scope.inClassFieldInit = inClassFieldInit;
    } else {
      field.value = null;
    }
    this.semicolon();

    return this.finishNode(field, "PropertyDefinition")
  };

  pp$8.parseClassStaticBlock = function(node) {
    node.body = [];

    var oldLabels = this.labels;
    this.labels = [];
    this.enterScope(SCOPE_CLASS_STATIC_BLOCK | SCOPE_SUPER);
    while (this.type !== types$1.braceR) {
      var stmt = this.parseStatement(null);
      node.body.push(stmt);
    }
    this.next();
    this.exitScope();
    this.labels = oldLabels;

    return this.finishNode(node, "StaticBlock")
  };

  pp$8.parseClassId = function(node, isStatement) {
    if (this.type === types$1.name) {
      node.id = this.parseIdent();
      if (isStatement)
        { this.checkLValSimple(node.id, BIND_LEXICAL, false); }
    } else {
      if (isStatement === true)
        { this.unexpected(); }
      node.id = null;
    }
  };

  pp$8.parseClassSuper = function(node) {
    node.superClass = this.eat(types$1._extends) ? this.parseExprSubscripts(null, false) : null;
  };

  pp$8.enterClassBody = function() {
    var element = {declared: Object.create(null), used: []};
    this.privateNameStack.push(element);
    return element.declared
  };

  pp$8.exitClassBody = function() {
    var ref = this.privateNameStack.pop();
    var declared = ref.declared;
    var used = ref.used;
    var len = this.privateNameStack.length;
    var parent = len === 0 ? null : this.privateNameStack[len - 1];
    for (var i = 0; i < used.length; ++i) {
      var id = used[i];
      if (!hasOwn(declared, id.name)) {
        if (parent) {
          parent.used.push(id);
        } else {
          this.raiseRecoverable(id.start, ("Private field '#" + (id.name) + "' must be declared in an enclosing class"));
        }
      }
    }
  };

  function isPrivateNameConflicted(privateNameMap, element) {
    var name = element.key.name;
    var curr = privateNameMap[name];

    var next = "true";
    if (element.type === "MethodDefinition" && (element.kind === "get" || element.kind === "set")) {
      next = (element.static ? "s" : "i") + element.kind;
    }

    // `class { get #a(){}; static set #a(_){} }` is also conflict.
    if (
      curr === "iget" && next === "iset" ||
      curr === "iset" && next === "iget" ||
      curr === "sget" && next === "sset" ||
      curr === "sset" && next === "sget"
    ) {
      privateNameMap[name] = "true";
      return false
    } else if (!curr) {
      privateNameMap[name] = next;
      return false
    } else {
      return true
    }
  }

  function checkKeyName(node, name) {
    var computed = node.computed;
    var key = node.key;
    return !computed && (
      key.type === "Identifier" && key.name === name ||
      key.type === "Literal" && key.value === name
    )
  }

  // Parses module export declaration.

  pp$8.parseExport = function(node, exports) {
    this.next();
    // export * from '...'
    if (this.eat(types$1.star)) {
      if (this.options.ecmaVersion >= 11) {
        if (this.eatContextual("as")) {
          node.exported = this.parseModuleExportName();
          this.checkExport(exports, node.exported, this.lastTokStart);
        } else {
          node.exported = null;
        }
      }
      this.expectContextual("from");
      if (this.type !== types$1.string) { this.unexpected(); }
      node.source = this.parseExprAtom();
      this.semicolon();
      return this.finishNode(node, "ExportAllDeclaration")
    }
    if (this.eat(types$1._default)) { // export default ...
      this.checkExport(exports, "default", this.lastTokStart);
      var isAsync;
      if (this.type === types$1._function || (isAsync = this.isAsyncFunction())) {
        var fNode = this.startNode();
        this.next();
        if (isAsync) { this.next(); }
        node.declaration = this.parseFunction(fNode, FUNC_STATEMENT | FUNC_NULLABLE_ID, false, isAsync);
      } else if (this.type === types$1._class) {
        var cNode = this.startNode();
        node.declaration = this.parseClass(cNode, "nullableID");
      } else {
        node.declaration = this.parseMaybeAssign();
        this.semicolon();
      }
      return this.finishNode(node, "ExportDefaultDeclaration")
    }
    // export var|const|let|function|class ...
    if (this.shouldParseExportStatement()) {
      node.declaration = this.parseStatement(null);
      if (node.declaration.type === "VariableDeclaration")
        { this.checkVariableExport(exports, node.declaration.declarations); }
      else
        { this.checkExport(exports, node.declaration.id, node.declaration.id.start); }
      node.specifiers = [];
      node.source = null;
    } else { // export { x, y as z } [from '...']
      node.declaration = null;
      node.specifiers = this.parseExportSpecifiers(exports);
      if (this.eatContextual("from")) {
        if (this.type !== types$1.string) { this.unexpected(); }
        node.source = this.parseExprAtom();
      } else {
        for (var i = 0, list = node.specifiers; i < list.length; i += 1) {
          // check for keywords used as local names
          var spec = list[i];

          this.checkUnreserved(spec.local);
          // check if export is defined
          this.checkLocalExport(spec.local);

          if (spec.local.type === "Literal") {
            this.raise(spec.local.start, "A string literal cannot be used as an exported binding without `from`.");
          }
        }

        node.source = null;
      }
      this.semicolon();
    }
    return this.finishNode(node, "ExportNamedDeclaration")
  };

  pp$8.checkExport = function(exports, name, pos) {
    if (!exports) { return }
    if (typeof name !== "string")
      { name = name.type === "Identifier" ? name.name : name.value; }
    if (hasOwn(exports, name))
      { this.raiseRecoverable(pos, "Duplicate export '" + name + "'"); }
    exports[name] = true;
  };

  pp$8.checkPatternExport = function(exports, pat) {
    var type = pat.type;
    if (type === "Identifier")
      { this.checkExport(exports, pat, pat.start); }
    else if (type === "ObjectPattern")
      { for (var i = 0, list = pat.properties; i < list.length; i += 1)
        {
          var prop = list[i];

          this.checkPatternExport(exports, prop);
        } }
    else if (type === "ArrayPattern")
      { for (var i$1 = 0, list$1 = pat.elements; i$1 < list$1.length; i$1 += 1) {
        var elt = list$1[i$1];

          if (elt) { this.checkPatternExport(exports, elt); }
      } }
    else if (type === "Property")
      { this.checkPatternExport(exports, pat.value); }
    else if (type === "AssignmentPattern")
      { this.checkPatternExport(exports, pat.left); }
    else if (type === "RestElement")
      { this.checkPatternExport(exports, pat.argument); }
    else if (type === "ParenthesizedExpression")
      { this.checkPatternExport(exports, pat.expression); }
  };

  pp$8.checkVariableExport = function(exports, decls) {
    if (!exports) { return }
    for (var i = 0, list = decls; i < list.length; i += 1)
      {
      var decl = list[i];

      this.checkPatternExport(exports, decl.id);
    }
  };

  pp$8.shouldParseExportStatement = function() {
    return this.type.keyword === "var" ||
      this.type.keyword === "const" ||
      this.type.keyword === "class" ||
      this.type.keyword === "function" ||
      this.isLet() ||
      this.isAsyncFunction()
  };

  // Parses a comma-separated list of module exports.

  pp$8.parseExportSpecifiers = function(exports) {
    var nodes = [], first = true;
    // export { x, y as z } [from '...']
    this.expect(types$1.braceL);
    while (!this.eat(types$1.braceR)) {
      if (!first) {
        this.expect(types$1.comma);
        if (this.afterTrailingComma(types$1.braceR)) { break }
      } else { first = false; }

      var node = this.startNode();
      node.local = this.parseModuleExportName();
      node.exported = this.eatContextual("as") ? this.parseModuleExportName() : node.local;
      this.checkExport(
        exports,
        node.exported,
        node.exported.start
      );
      nodes.push(this.finishNode(node, "ExportSpecifier"));
    }
    return nodes
  };

  // Parses import declaration.

  pp$8.parseImport = function(node) {
    this.next();
    // import '...'
    if (this.type === types$1.string) {
      node.specifiers = empty$1;
      node.source = this.parseExprAtom();
    } else {
      node.specifiers = this.parseImportSpecifiers();
      this.expectContextual("from");
      node.source = this.type === types$1.string ? this.parseExprAtom() : this.unexpected();
    }
    this.semicolon();
    return this.finishNode(node, "ImportDeclaration")
  };

  // Parses a comma-separated list of module imports.

  pp$8.parseImportSpecifiers = function() {
    var nodes = [], first = true;
    if (this.type === types$1.name) {
      // import defaultObj, { x, y as z } from '...'
      var node = this.startNode();
      node.local = this.parseIdent();
      this.checkLValSimple(node.local, BIND_LEXICAL);
      nodes.push(this.finishNode(node, "ImportDefaultSpecifier"));
      if (!this.eat(types$1.comma)) { return nodes }
    }
    if (this.type === types$1.star) {
      var node$1 = this.startNode();
      this.next();
      this.expectContextual("as");
      node$1.local = this.parseIdent();
      this.checkLValSimple(node$1.local, BIND_LEXICAL);
      nodes.push(this.finishNode(node$1, "ImportNamespaceSpecifier"));
      return nodes
    }
    this.expect(types$1.braceL);
    while (!this.eat(types$1.braceR)) {
      if (!first) {
        this.expect(types$1.comma);
        if (this.afterTrailingComma(types$1.braceR)) { break }
      } else { first = false; }

      var node$2 = this.startNode();
      node$2.imported = this.parseModuleExportName();
      if (this.eatContextual("as")) {
        node$2.local = this.parseIdent();
      } else {
        this.checkUnreserved(node$2.imported);
        node$2.local = node$2.imported;
      }
      this.checkLValSimple(node$2.local, BIND_LEXICAL);
      nodes.push(this.finishNode(node$2, "ImportSpecifier"));
    }
    return nodes
  };

  pp$8.parseModuleExportName = function() {
    if (this.options.ecmaVersion >= 13 && this.type === types$1.string) {
      var stringLiteral = this.parseLiteral(this.value);
      if (loneSurrogate.test(stringLiteral.value)) {
        this.raise(stringLiteral.start, "An export name cannot include a lone surrogate.");
      }
      return stringLiteral
    }
    return this.parseIdent(true)
  };

  // Set `ExpressionStatement#directive` property for directive prologues.
  pp$8.adaptDirectivePrologue = function(statements) {
    for (var i = 0; i < statements.length && this.isDirectiveCandidate(statements[i]); ++i) {
      statements[i].directive = statements[i].expression.raw.slice(1, -1);
    }
  };
  pp$8.isDirectiveCandidate = function(statement) {
    return (
      this.options.ecmaVersion >= 5 &&
      statement.type === "ExpressionStatement" &&
      statement.expression.type === "Literal" &&
      typeof statement.expression.value === "string" &&
      // Reject parenthesized strings.
      (this.input[statement.start] === "\"" || this.input[statement.start] === "'")
    )
  };

  var pp$7 = Parser.prototype;

  // Convert existing expression atom to assignable pattern
  // if possible.

  pp$7.toAssignable = function(node, isBinding, refDestructuringErrors) {
    if (this.options.ecmaVersion >= 6 && node) {
      switch (node.type) {
      case "Identifier":
        if (this.inAsync && node.name === "await")
          { this.raise(node.start, "Cannot use 'await' as identifier inside an async function"); }
        break

      case "ObjectPattern":
      case "ArrayPattern":
      case "AssignmentPattern":
      case "RestElement":
        break

      case "ObjectExpression":
        node.type = "ObjectPattern";
        if (refDestructuringErrors) { this.checkPatternErrors(refDestructuringErrors, true); }
        for (var i = 0, list = node.properties; i < list.length; i += 1) {
          var prop = list[i];

        this.toAssignable(prop, isBinding);
          // Early error:
          //   AssignmentRestProperty[Yield, Await] :
          //     `...` DestructuringAssignmentTarget[Yield, Await]
          //
          //   It is a Syntax Error if |DestructuringAssignmentTarget| is an |ArrayLiteral| or an |ObjectLiteral|.
          if (
            prop.type === "RestElement" &&
            (prop.argument.type === "ArrayPattern" || prop.argument.type === "ObjectPattern")
          ) {
            this.raise(prop.argument.start, "Unexpected token");
          }
        }
        break

      case "Property":
        // AssignmentProperty has type === "Property"
        if (node.kind !== "init") { this.raise(node.key.start, "Object pattern can't contain getter or setter"); }
        this.toAssignable(node.value, isBinding);
        break

      case "ArrayExpression":
        node.type = "ArrayPattern";
        if (refDestructuringErrors) { this.checkPatternErrors(refDestructuringErrors, true); }
        this.toAssignableList(node.elements, isBinding);
        break

      case "SpreadElement":
        node.type = "RestElement";
        this.toAssignable(node.argument, isBinding);
        if (node.argument.type === "AssignmentPattern")
          { this.raise(node.argument.start, "Rest elements cannot have a default value"); }
        break

      case "AssignmentExpression":
        if (node.operator !== "=") { this.raise(node.left.end, "Only '=' operator can be used for specifying default value."); }
        node.type = "AssignmentPattern";
        delete node.operator;
        this.toAssignable(node.left, isBinding);
        break

      case "ParenthesizedExpression":
        this.toAssignable(node.expression, isBinding, refDestructuringErrors);
        break

      case "ChainExpression":
        this.raiseRecoverable(node.start, "Optional chaining cannot appear in left-hand side");
        break

      case "MemberExpression":
        if (!isBinding) { break }

      default:
        this.raise(node.start, "Assigning to rvalue");
      }
    } else if (refDestructuringErrors) { this.checkPatternErrors(refDestructuringErrors, true); }
    return node
  };

  // Convert list of expression atoms to binding list.

  pp$7.toAssignableList = function(exprList, isBinding) {
    var end = exprList.length;
    for (var i = 0; i < end; i++) {
      var elt = exprList[i];
      if (elt) { this.toAssignable(elt, isBinding); }
    }
    if (end) {
      var last = exprList[end - 1];
      if (this.options.ecmaVersion === 6 && isBinding && last && last.type === "RestElement" && last.argument.type !== "Identifier")
        { this.unexpected(last.argument.start); }
    }
    return exprList
  };

  // Parses spread element.

  pp$7.parseSpread = function(refDestructuringErrors) {
    var node = this.startNode();
    this.next();
    node.argument = this.parseMaybeAssign(false, refDestructuringErrors);
    return this.finishNode(node, "SpreadElement")
  };

  pp$7.parseRestBinding = function() {
    var node = this.startNode();
    this.next();

    // RestElement inside of a function parameter must be an identifier
    if (this.options.ecmaVersion === 6 && this.type !== types$1.name)
      { this.unexpected(); }

    node.argument = this.parseBindingAtom();

    return this.finishNode(node, "RestElement")
  };

  // Parses lvalue (assignable) atom.

  pp$7.parseBindingAtom = function() {
    if (this.options.ecmaVersion >= 6) {
      switch (this.type) {
      case types$1.bracketL:
        var node = this.startNode();
        this.next();
        node.elements = this.parseBindingList(types$1.bracketR, true, true);
        return this.finishNode(node, "ArrayPattern")

      case types$1.braceL:
        return this.parseObj(true)
      }
    }
    return this.parseIdent()
  };

  pp$7.parseBindingList = function(close, allowEmpty, allowTrailingComma) {
    var elts = [], first = true;
    while (!this.eat(close)) {
      if (first) { first = false; }
      else { this.expect(types$1.comma); }
      if (allowEmpty && this.type === types$1.comma) {
        elts.push(null);
      } else if (allowTrailingComma && this.afterTrailingComma(close)) {
        break
      } else if (this.type === types$1.ellipsis) {
        var rest = this.parseRestBinding();
        this.parseBindingListItem(rest);
        elts.push(rest);
        if (this.type === types$1.comma) { this.raise(this.start, "Comma is not permitted after the rest element"); }
        this.expect(close);
        break
      } else {
        var elem = this.parseMaybeDefault(this.start, this.startLoc);
        this.parseBindingListItem(elem);
        elts.push(elem);
      }
    }
    return elts
  };

  pp$7.parseBindingListItem = function(param) {
    return param
  };

  // Parses assignment pattern around given atom if possible.

  pp$7.parseMaybeDefault = function(startPos, startLoc, left) {
    left = left || this.parseBindingAtom();
    if (this.options.ecmaVersion < 6 || !this.eat(types$1.eq)) { return left }
    var node = this.startNodeAt(startPos, startLoc);
    node.left = left;
    node.right = this.parseMaybeAssign();
    return this.finishNode(node, "AssignmentPattern")
  };

  // The following three functions all verify that a node is an lvalue —
  // something that can be bound, or assigned to. In order to do so, they perform
  // a variety of checks:
  //
  // - Check that none of the bound/assigned-to identifiers are reserved words.
  // - Record name declarations for bindings in the appropriate scope.
  // - Check duplicate argument names, if checkClashes is set.
  //
  // If a complex binding pattern is encountered (e.g., object and array
  // destructuring), the entire pattern is recursively checked.
  //
  // There are three versions of checkLVal*() appropriate for different
  // circumstances:
  //
  // - checkLValSimple() shall be used if the syntactic construct supports
  //   nothing other than identifiers and member expressions. Parenthesized
  //   expressions are also correctly handled. This is generally appropriate for
  //   constructs for which the spec says
  //
  //   > It is a Syntax Error if AssignmentTargetType of [the production] is not
  //   > simple.
  //
  //   It is also appropriate for checking if an identifier is valid and not
  //   defined elsewhere, like import declarations or function/class identifiers.
  //
  //   Examples where this is used include:
  //     a += …;
  //     import a from '…';
  //   where a is the node to be checked.
  //
  // - checkLValPattern() shall be used if the syntactic construct supports
  //   anything checkLValSimple() supports, as well as object and array
  //   destructuring patterns. This is generally appropriate for constructs for
  //   which the spec says
  //
  //   > It is a Syntax Error if [the production] is neither an ObjectLiteral nor
  //   > an ArrayLiteral and AssignmentTargetType of [the production] is not
  //   > simple.
  //
  //   Examples where this is used include:
  //     (a = …);
  //     const a = …;
  //     try { … } catch (a) { … }
  //   where a is the node to be checked.
  //
  // - checkLValInnerPattern() shall be used if the syntactic construct supports
  //   anything checkLValPattern() supports, as well as default assignment
  //   patterns, rest elements, and other constructs that may appear within an
  //   object or array destructuring pattern.
  //
  //   As a special case, function parameters also use checkLValInnerPattern(),
  //   as they also support defaults and rest constructs.
  //
  // These functions deliberately support both assignment and binding constructs,
  // as the logic for both is exceedingly similar. If the node is the target of
  // an assignment, then bindingType should be set to BIND_NONE. Otherwise, it
  // should be set to the appropriate BIND_* constant, like BIND_VAR or
  // BIND_LEXICAL.
  //
  // If the function is called with a non-BIND_NONE bindingType, then
  // additionally a checkClashes object may be specified to allow checking for
  // duplicate argument names. checkClashes is ignored if the provided construct
  // is an assignment (i.e., bindingType is BIND_NONE).

  pp$7.checkLValSimple = function(expr, bindingType, checkClashes) {
    if ( bindingType === void 0 ) bindingType = BIND_NONE;

    var isBind = bindingType !== BIND_NONE;

    switch (expr.type) {
    case "Identifier":
      if (this.strict && this.reservedWordsStrictBind.test(expr.name))
        { this.raiseRecoverable(expr.start, (isBind ? "Binding " : "Assigning to ") + expr.name + " in strict mode"); }
      if (isBind) {
        if (bindingType === BIND_LEXICAL && expr.name === "let")
          { this.raiseRecoverable(expr.start, "let is disallowed as a lexically bound name"); }
        if (checkClashes) {
          if (hasOwn(checkClashes, expr.name))
            { this.raiseRecoverable(expr.start, "Argument name clash"); }
          checkClashes[expr.name] = true;
        }
        if (bindingType !== BIND_OUTSIDE) { this.declareName(expr.name, bindingType, expr.start); }
      }
      break

    case "ChainExpression":
      this.raiseRecoverable(expr.start, "Optional chaining cannot appear in left-hand side");
      break

    case "MemberExpression":
      if (isBind) { this.raiseRecoverable(expr.start, "Binding member expression"); }
      break

    case "ParenthesizedExpression":
      if (isBind) { this.raiseRecoverable(expr.start, "Binding parenthesized expression"); }
      return this.checkLValSimple(expr.expression, bindingType, checkClashes)

    default:
      this.raise(expr.start, (isBind ? "Binding" : "Assigning to") + " rvalue");
    }
  };

  pp$7.checkLValPattern = function(expr, bindingType, checkClashes) {
    if ( bindingType === void 0 ) bindingType = BIND_NONE;

    switch (expr.type) {
    case "ObjectPattern":
      for (var i = 0, list = expr.properties; i < list.length; i += 1) {
        var prop = list[i];

      this.checkLValInnerPattern(prop, bindingType, checkClashes);
      }
      break

    case "ArrayPattern":
      for (var i$1 = 0, list$1 = expr.elements; i$1 < list$1.length; i$1 += 1) {
        var elem = list$1[i$1];

      if (elem) { this.checkLValInnerPattern(elem, bindingType, checkClashes); }
      }
      break

    default:
      this.checkLValSimple(expr, bindingType, checkClashes);
    }
  };

  pp$7.checkLValInnerPattern = function(expr, bindingType, checkClashes) {
    if ( bindingType === void 0 ) bindingType = BIND_NONE;

    switch (expr.type) {
    case "Property":
      // AssignmentProperty has type === "Property"
      this.checkLValInnerPattern(expr.value, bindingType, checkClashes);
      break

    case "AssignmentPattern":
      this.checkLValPattern(expr.left, bindingType, checkClashes);
      break

    case "RestElement":
      this.checkLValPattern(expr.argument, bindingType, checkClashes);
      break

    default:
      this.checkLValPattern(expr, bindingType, checkClashes);
    }
  };

  // The algorithm used to determine whether a regexp can appear at a

  var TokContext = function TokContext(token, isExpr, preserveSpace, override, generator) {
    this.token = token;
    this.isExpr = !!isExpr;
    this.preserveSpace = !!preserveSpace;
    this.override = override;
    this.generator = !!generator;
  };

  var types = {
    b_stat: new TokContext("{", false),
    b_expr: new TokContext("{", true),
    b_tmpl: new TokContext("${", false),
    p_stat: new TokContext("(", false),
    p_expr: new TokContext("(", true),
    q_tmpl: new TokContext("`", true, true, function (p) { return p.tryReadTemplateToken(); }),
    f_stat: new TokContext("function", false),
    f_expr: new TokContext("function", true),
    f_expr_gen: new TokContext("function", true, false, null, true),
    f_gen: new TokContext("function", false, false, null, true)
  };

  var pp$6 = Parser.prototype;

  pp$6.initialContext = function() {
    return [types.b_stat]
  };

  pp$6.curContext = function() {
    return this.context[this.context.length - 1]
  };

  pp$6.braceIsBlock = function(prevType) {
    var parent = this.curContext();
    if (parent === types.f_expr || parent === types.f_stat)
      { return true }
    if (prevType === types$1.colon && (parent === types.b_stat || parent === types.b_expr))
      { return !parent.isExpr }

    // The check for `tt.name && exprAllowed` detects whether we are
    // after a `yield` or `of` construct. See the `updateContext` for
    // `tt.name`.
    if (prevType === types$1._return || prevType === types$1.name && this.exprAllowed)
      { return lineBreak.test(this.input.slice(this.lastTokEnd, this.start)) }
    if (prevType === types$1._else || prevType === types$1.semi || prevType === types$1.eof || prevType === types$1.parenR || prevType === types$1.arrow)
      { return true }
    if (prevType === types$1.braceL)
      { return parent === types.b_stat }
    if (prevType === types$1._var || prevType === types$1._const || prevType === types$1.name)
      { return false }
    return !this.exprAllowed
  };

  pp$6.inGeneratorContext = function() {
    for (var i = this.context.length - 1; i >= 1; i--) {
      var context = this.context[i];
      if (context.token === "function")
        { return context.generator }
    }
    return false
  };

  pp$6.updateContext = function(prevType) {
    var update, type = this.type;
    if (type.keyword && prevType === types$1.dot)
      { this.exprAllowed = false; }
    else if (update = type.updateContext)
      { update.call(this, prevType); }
    else
      { this.exprAllowed = type.beforeExpr; }
  };

  // Used to handle egde cases when token context could not be inferred correctly during tokenization phase

  pp$6.overrideContext = function(tokenCtx) {
    if (this.curContext() !== tokenCtx) {
      this.context[this.context.length - 1] = tokenCtx;
    }
  };

  // Token-specific context update code

  types$1.parenR.updateContext = types$1.braceR.updateContext = function() {
    if (this.context.length === 1) {
      this.exprAllowed = true;
      return
    }
    var out = this.context.pop();
    if (out === types.b_stat && this.curContext().token === "function") {
      out = this.context.pop();
    }
    this.exprAllowed = !out.isExpr;
  };

  types$1.braceL.updateContext = function(prevType) {
    this.context.push(this.braceIsBlock(prevType) ? types.b_stat : types.b_expr);
    this.exprAllowed = true;
  };

  types$1.dollarBraceL.updateContext = function() {
    this.context.push(types.b_tmpl);
    this.exprAllowed = true;
  };

  types$1.parenL.updateContext = function(prevType) {
    var statementParens = prevType === types$1._if || prevType === types$1._for || prevType === types$1._with || prevType === types$1._while;
    this.context.push(statementParens ? types.p_stat : types.p_expr);
    this.exprAllowed = true;
  };

  types$1.incDec.updateContext = function() {
    // tokExprAllowed stays unchanged
  };

  types$1._function.updateContext = types$1._class.updateContext = function(prevType) {
    if (prevType.beforeExpr && prevType !== types$1._else &&
        !(prevType === types$1.semi && this.curContext() !== types.p_stat) &&
        !(prevType === types$1._return && lineBreak.test(this.input.slice(this.lastTokEnd, this.start))) &&
        !((prevType === types$1.colon || prevType === types$1.braceL) && this.curContext() === types.b_stat))
      { this.context.push(types.f_expr); }
    else
      { this.context.push(types.f_stat); }
    this.exprAllowed = false;
  };

  types$1.backQuote.updateContext = function() {
    if (this.curContext() === types.q_tmpl)
      { this.context.pop(); }
    else
      { this.context.push(types.q_tmpl); }
    this.exprAllowed = false;
  };

  types$1.star.updateContext = function(prevType) {
    if (prevType === types$1._function) {
      var index = this.context.length - 1;
      if (this.context[index] === types.f_expr)
        { this.context[index] = types.f_expr_gen; }
      else
        { this.context[index] = types.f_gen; }
    }
    this.exprAllowed = true;
  };

  types$1.name.updateContext = function(prevType) {
    var allowed = false;
    if (this.options.ecmaVersion >= 6 && prevType !== types$1.dot) {
      if (this.value === "of" && !this.exprAllowed ||
          this.value === "yield" && this.inGeneratorContext())
        { allowed = true; }
    }
    this.exprAllowed = allowed;
  };

  // A recursive descent parser operates by defining functions for all

  var pp$5 = Parser.prototype;

  // Check if property name clashes with already added.
  // Object/class getters and setters are not allowed to clash —
  // either with each other or with an init property — and in
  // strict mode, init properties are also not allowed to be repeated.

  pp$5.checkPropClash = function(prop, propHash, refDestructuringErrors) {
    if (this.options.ecmaVersion >= 9 && prop.type === "SpreadElement")
      { return }
    if (this.options.ecmaVersion >= 6 && (prop.computed || prop.method || prop.shorthand))
      { return }
    var key = prop.key;
    var name;
    switch (key.type) {
    case "Identifier": name = key.name; break
    case "Literal": name = String(key.value); break
    default: return
    }
    var kind = prop.kind;
    if (this.options.ecmaVersion >= 6) {
      if (name === "__proto__" && kind === "init") {
        if (propHash.proto) {
          if (refDestructuringErrors) {
            if (refDestructuringErrors.doubleProto < 0) {
              refDestructuringErrors.doubleProto = key.start;
            }
          } else {
            this.raiseRecoverable(key.start, "Redefinition of __proto__ property");
          }
        }
        propHash.proto = true;
      }
      return
    }
    name = "$" + name;
    var other = propHash[name];
    if (other) {
      var redefinition;
      if (kind === "init") {
        redefinition = this.strict && other.init || other.get || other.set;
      } else {
        redefinition = other.init || other[kind];
      }
      if (redefinition)
        { this.raiseRecoverable(key.start, "Redefinition of property"); }
    } else {
      other = propHash[name] = {
        init: false,
        get: false,
        set: false
      };
    }
    other[kind] = true;
  };

  // ### Expression parsing

  // These nest, from the most general expression type at the top to
  // 'atomic', nondivisible expression types at the bottom. Most of
  // the functions will simply let the function(s) below them parse,
  // and, *if* the syntactic construct they handle is present, wrap
  // the AST node that the inner parser gave them in another node.

  // Parse a full expression. The optional arguments are used to
  // forbid the `in` operator (in for loops initalization expressions)
  // and provide reference for storing '=' operator inside shorthand
  // property assignment in contexts where both object expression
  // and object pattern might appear (so it's possible to raise
  // delayed syntax error at correct position).

  pp$5.parseExpression = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseMaybeAssign(forInit, refDestructuringErrors);
    if (this.type === types$1.comma) {
      var node = this.startNodeAt(startPos, startLoc);
      node.expressions = [expr];
      while (this.eat(types$1.comma)) { node.expressions.push(this.parseMaybeAssign(forInit, refDestructuringErrors)); }
      return this.finishNode(node, "SequenceExpression")
    }
    return expr
  };

  // Parse an assignment expression. This includes applications of
  // operators like `+=`.

  pp$5.parseMaybeAssign = function(forInit, refDestructuringErrors, afterLeftParse) {
    if (this.isContextual("yield")) {
      if (this.inGenerator) { return this.parseYield(forInit) }
      // The tokenizer will assume an expression is allowed after
      // `yield`, but this isn't that kind of yield
      else { this.exprAllowed = false; }
    }

    var ownDestructuringErrors = false, oldParenAssign = -1, oldTrailingComma = -1, oldDoubleProto = -1;
    if (refDestructuringErrors) {
      oldParenAssign = refDestructuringErrors.parenthesizedAssign;
      oldTrailingComma = refDestructuringErrors.trailingComma;
      oldDoubleProto = refDestructuringErrors.doubleProto;
      refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = -1;
    } else {
      refDestructuringErrors = new DestructuringErrors;
      ownDestructuringErrors = true;
    }

    var startPos = this.start, startLoc = this.startLoc;
    if (this.type === types$1.parenL || this.type === types$1.name) {
      this.potentialArrowAt = this.start;
      this.potentialArrowInForAwait = forInit === "await";
    }
    var left = this.parseMaybeConditional(forInit, refDestructuringErrors);
    if (afterLeftParse) { left = afterLeftParse.call(this, left, startPos, startLoc); }
    if (this.type.isAssign) {
      var node = this.startNodeAt(startPos, startLoc);
      node.operator = this.value;
      if (this.type === types$1.eq)
        { left = this.toAssignable(left, false, refDestructuringErrors); }
      if (!ownDestructuringErrors) {
        refDestructuringErrors.parenthesizedAssign = refDestructuringErrors.trailingComma = refDestructuringErrors.doubleProto = -1;
      }
      if (refDestructuringErrors.shorthandAssign >= left.start)
        { refDestructuringErrors.shorthandAssign = -1; } // reset because shorthand default was used correctly
      if (this.type === types$1.eq)
        { this.checkLValPattern(left); }
      else
        { this.checkLValSimple(left); }
      node.left = left;
      this.next();
      node.right = this.parseMaybeAssign(forInit);
      if (oldDoubleProto > -1) { refDestructuringErrors.doubleProto = oldDoubleProto; }
      return this.finishNode(node, "AssignmentExpression")
    } else {
      if (ownDestructuringErrors) { this.checkExpressionErrors(refDestructuringErrors, true); }
    }
    if (oldParenAssign > -1) { refDestructuringErrors.parenthesizedAssign = oldParenAssign; }
    if (oldTrailingComma > -1) { refDestructuringErrors.trailingComma = oldTrailingComma; }
    return left
  };

  // Parse a ternary conditional (`?:`) operator.

  pp$5.parseMaybeConditional = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseExprOps(forInit, refDestructuringErrors);
    if (this.checkExpressionErrors(refDestructuringErrors)) { return expr }
    if (this.eat(types$1.question)) {
      var node = this.startNodeAt(startPos, startLoc);
      node.test = expr;
      node.consequent = this.parseMaybeAssign();
      this.expect(types$1.colon);
      node.alternate = this.parseMaybeAssign(forInit);
      return this.finishNode(node, "ConditionalExpression")
    }
    return expr
  };

  // Start the precedence parser.

  pp$5.parseExprOps = function(forInit, refDestructuringErrors) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseMaybeUnary(refDestructuringErrors, false, false, forInit);
    if (this.checkExpressionErrors(refDestructuringErrors)) { return expr }
    return expr.start === startPos && expr.type === "ArrowFunctionExpression" ? expr : this.parseExprOp(expr, startPos, startLoc, -1, forInit)
  };

  // Parse binary operators with the operator precedence parsing
  // algorithm. `left` is the left-hand side of the operator.
  // `minPrec` provides context that allows the function to stop and
  // defer further parser to one of its callers when it encounters an
  // operator that has a lower precedence than the set it is parsing.

  pp$5.parseExprOp = function(left, leftStartPos, leftStartLoc, minPrec, forInit) {
    var prec = this.type.binop;
    if (prec != null && (!forInit || this.type !== types$1._in)) {
      if (prec > minPrec) {
        var logical = this.type === types$1.logicalOR || this.type === types$1.logicalAND;
        var coalesce = this.type === types$1.coalesce;
        if (coalesce) {
          // Handle the precedence of `tt.coalesce` as equal to the range of logical expressions.
          // In other words, `node.right` shouldn't contain logical expressions in order to check the mixed error.
          prec = types$1.logicalAND.binop;
        }
        var op = this.value;
        this.next();
        var startPos = this.start, startLoc = this.startLoc;
        var right = this.parseExprOp(this.parseMaybeUnary(null, false, false, forInit), startPos, startLoc, prec, forInit);
        var node = this.buildBinary(leftStartPos, leftStartLoc, left, right, op, logical || coalesce);
        if ((logical && this.type === types$1.coalesce) || (coalesce && (this.type === types$1.logicalOR || this.type === types$1.logicalAND))) {
          this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses");
        }
        return this.parseExprOp(node, leftStartPos, leftStartLoc, minPrec, forInit)
      }
    }
    return left
  };

  pp$5.buildBinary = function(startPos, startLoc, left, right, op, logical) {
    if (right.type === "PrivateIdentifier") { this.raise(right.start, "Private identifier can only be left side of binary expression"); }
    var node = this.startNodeAt(startPos, startLoc);
    node.left = left;
    node.operator = op;
    node.right = right;
    return this.finishNode(node, logical ? "LogicalExpression" : "BinaryExpression")
  };

  // Parse unary operators, both prefix and postfix.

  pp$5.parseMaybeUnary = function(refDestructuringErrors, sawUnary, incDec, forInit) {
    var startPos = this.start, startLoc = this.startLoc, expr;
    if (this.isContextual("await") && this.canAwait) {
      expr = this.parseAwait(forInit);
      sawUnary = true;
    } else if (this.type.prefix) {
      var node = this.startNode(), update = this.type === types$1.incDec;
      node.operator = this.value;
      node.prefix = true;
      this.next();
      node.argument = this.parseMaybeUnary(null, true, update, forInit);
      this.checkExpressionErrors(refDestructuringErrors, true);
      if (update) { this.checkLValSimple(node.argument); }
      else if (this.strict && node.operator === "delete" &&
               node.argument.type === "Identifier")
        { this.raiseRecoverable(node.start, "Deleting local variable in strict mode"); }
      else if (node.operator === "delete" && isPrivateFieldAccess(node.argument))
        { this.raiseRecoverable(node.start, "Private fields can not be deleted"); }
      else { sawUnary = true; }
      expr = this.finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
    } else if (!sawUnary && this.type === types$1.privateId) {
      if (forInit || this.privateNameStack.length === 0) { this.unexpected(); }
      expr = this.parsePrivateIdent();
      // only could be private fields in 'in', such as #x in obj
      if (this.type !== types$1._in) { this.unexpected(); }
    } else {
      expr = this.parseExprSubscripts(refDestructuringErrors, forInit);
      if (this.checkExpressionErrors(refDestructuringErrors)) { return expr }
      while (this.type.postfix && !this.canInsertSemicolon()) {
        var node$1 = this.startNodeAt(startPos, startLoc);
        node$1.operator = this.value;
        node$1.prefix = false;
        node$1.argument = expr;
        this.checkLValSimple(expr);
        this.next();
        expr = this.finishNode(node$1, "UpdateExpression");
      }
    }

    if (!incDec && this.eat(types$1.starstar)) {
      if (sawUnary)
        { this.unexpected(this.lastTokStart); }
      else
        { return this.buildBinary(startPos, startLoc, expr, this.parseMaybeUnary(null, false, false, forInit), "**", false) }
    } else {
      return expr
    }
  };

  function isPrivateFieldAccess(node) {
    return (
      node.type === "MemberExpression" && node.property.type === "PrivateIdentifier" ||
      node.type === "ChainExpression" && isPrivateFieldAccess(node.expression)
    )
  }

  // Parse call, dot, and `[]`-subscript expressions.

  pp$5.parseExprSubscripts = function(refDestructuringErrors, forInit) {
    var startPos = this.start, startLoc = this.startLoc;
    var expr = this.parseExprAtom(refDestructuringErrors, forInit);
    if (expr.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
      { return expr }
    var result = this.parseSubscripts(expr, startPos, startLoc, false, forInit);
    if (refDestructuringErrors && result.type === "MemberExpression") {
      if (refDestructuringErrors.parenthesizedAssign >= result.start) { refDestructuringErrors.parenthesizedAssign = -1; }
      if (refDestructuringErrors.parenthesizedBind >= result.start) { refDestructuringErrors.parenthesizedBind = -1; }
      if (refDestructuringErrors.trailingComma >= result.start) { refDestructuringErrors.trailingComma = -1; }
    }
    return result
  };

  pp$5.parseSubscripts = function(base, startPos, startLoc, noCalls, forInit) {
    var maybeAsyncArrow = this.options.ecmaVersion >= 8 && base.type === "Identifier" && base.name === "async" &&
        this.lastTokEnd === base.end && !this.canInsertSemicolon() && base.end - base.start === 5 &&
        this.potentialArrowAt === base.start;
    var optionalChained = false;

    while (true) {
      var element = this.parseSubscript(base, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained, forInit);

      if (element.optional) { optionalChained = true; }
      if (element === base || element.type === "ArrowFunctionExpression") {
        if (optionalChained) {
          var chainNode = this.startNodeAt(startPos, startLoc);
          chainNode.expression = element;
          element = this.finishNode(chainNode, "ChainExpression");
        }
        return element
      }

      base = element;
    }
  };

  pp$5.parseSubscript = function(base, startPos, startLoc, noCalls, maybeAsyncArrow, optionalChained, forInit) {
    var optionalSupported = this.options.ecmaVersion >= 11;
    var optional = optionalSupported && this.eat(types$1.questionDot);
    if (noCalls && optional) { this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions"); }

    var computed = this.eat(types$1.bracketL);
    if (computed || (optional && this.type !== types$1.parenL && this.type !== types$1.backQuote) || this.eat(types$1.dot)) {
      var node = this.startNodeAt(startPos, startLoc);
      node.object = base;
      if (computed) {
        node.property = this.parseExpression();
        this.expect(types$1.bracketR);
      } else if (this.type === types$1.privateId && base.type !== "Super") {
        node.property = this.parsePrivateIdent();
      } else {
        node.property = this.parseIdent(this.options.allowReserved !== "never");
      }
      node.computed = !!computed;
      if (optionalSupported) {
        node.optional = optional;
      }
      base = this.finishNode(node, "MemberExpression");
    } else if (!noCalls && this.eat(types$1.parenL)) {
      var refDestructuringErrors = new DestructuringErrors, oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;
      this.yieldPos = 0;
      this.awaitPos = 0;
      this.awaitIdentPos = 0;
      var exprList = this.parseExprList(types$1.parenR, this.options.ecmaVersion >= 8, false, refDestructuringErrors);
      if (maybeAsyncArrow && !optional && !this.canInsertSemicolon() && this.eat(types$1.arrow)) {
        this.checkPatternErrors(refDestructuringErrors, false);
        this.checkYieldAwaitInDefaultParams();
        if (this.awaitIdentPos > 0)
          { this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"); }
        this.yieldPos = oldYieldPos;
        this.awaitPos = oldAwaitPos;
        this.awaitIdentPos = oldAwaitIdentPos;
        return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, true, forInit)
      }
      this.checkExpressionErrors(refDestructuringErrors, true);
      this.yieldPos = oldYieldPos || this.yieldPos;
      this.awaitPos = oldAwaitPos || this.awaitPos;
      this.awaitIdentPos = oldAwaitIdentPos || this.awaitIdentPos;
      var node$1 = this.startNodeAt(startPos, startLoc);
      node$1.callee = base;
      node$1.arguments = exprList;
      if (optionalSupported) {
        node$1.optional = optional;
      }
      base = this.finishNode(node$1, "CallExpression");
    } else if (this.type === types$1.backQuote) {
      if (optional || optionalChained) {
        this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
      }
      var node$2 = this.startNodeAt(startPos, startLoc);
      node$2.tag = base;
      node$2.quasi = this.parseTemplate({isTagged: true});
      base = this.finishNode(node$2, "TaggedTemplateExpression");
    }
    return base
  };

  // Parse an atomic expression — either a single token that is an
  // expression, an expression started by a keyword like `function` or
  // `new`, or an expression wrapped in punctuation like `()`, `[]`,
  // or `{}`.

  pp$5.parseExprAtom = function(refDestructuringErrors, forInit) {
    // If a division operator appears in an expression position, the
    // tokenizer got confused, and we force it to read a regexp instead.
    if (this.type === types$1.slash) { this.readRegexp(); }

    var node, canBeArrow = this.potentialArrowAt === this.start;
    switch (this.type) {
    case types$1._super:
      if (!this.allowSuper)
        { this.raise(this.start, "'super' keyword outside a method"); }
      node = this.startNode();
      this.next();
      if (this.type === types$1.parenL && !this.allowDirectSuper)
        { this.raise(node.start, "super() call outside constructor of a subclass"); }
      // The `super` keyword can appear at below:
      // SuperProperty:
      //     super [ Expression ]
      //     super . IdentifierName
      // SuperCall:
      //     super ( Arguments )
      if (this.type !== types$1.dot && this.type !== types$1.bracketL && this.type !== types$1.parenL)
        { this.unexpected(); }
      return this.finishNode(node, "Super")

    case types$1._this:
      node = this.startNode();
      this.next();
      return this.finishNode(node, "ThisExpression")

    case types$1.name:
      var startPos = this.start, startLoc = this.startLoc, containsEsc = this.containsEsc;
      var id = this.parseIdent(false);
      if (this.options.ecmaVersion >= 8 && !containsEsc && id.name === "async" && !this.canInsertSemicolon() && this.eat(types$1._function)) {
        this.overrideContext(types.f_expr);
        return this.parseFunction(this.startNodeAt(startPos, startLoc), 0, false, true, forInit)
      }
      if (canBeArrow && !this.canInsertSemicolon()) {
        if (this.eat(types$1.arrow))
          { return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [id], false, forInit) }
        if (this.options.ecmaVersion >= 8 && id.name === "async" && this.type === types$1.name && !containsEsc &&
            (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc)) {
          id = this.parseIdent(false);
          if (this.canInsertSemicolon() || !this.eat(types$1.arrow))
            { this.unexpected(); }
          return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), [id], true, forInit)
        }
      }
      return id

    case types$1.regexp:
      var value = this.value;
      node = this.parseLiteral(value.value);
      node.regex = {pattern: value.pattern, flags: value.flags};
      return node

    case types$1.num: case types$1.string:
      return this.parseLiteral(this.value)

    case types$1._null: case types$1._true: case types$1._false:
      node = this.startNode();
      node.value = this.type === types$1._null ? null : this.type === types$1._true;
      node.raw = this.type.keyword;
      this.next();
      return this.finishNode(node, "Literal")

    case types$1.parenL:
      var start = this.start, expr = this.parseParenAndDistinguishExpression(canBeArrow, forInit);
      if (refDestructuringErrors) {
        if (refDestructuringErrors.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(expr))
          { refDestructuringErrors.parenthesizedAssign = start; }
        if (refDestructuringErrors.parenthesizedBind < 0)
          { refDestructuringErrors.parenthesizedBind = start; }
      }
      return expr

    case types$1.bracketL:
      node = this.startNode();
      this.next();
      node.elements = this.parseExprList(types$1.bracketR, true, true, refDestructuringErrors);
      return this.finishNode(node, "ArrayExpression")

    case types$1.braceL:
      this.overrideContext(types.b_expr);
      return this.parseObj(false, refDestructuringErrors)

    case types$1._function:
      node = this.startNode();
      this.next();
      return this.parseFunction(node, 0)

    case types$1._class:
      return this.parseClass(this.startNode(), false)

    case types$1._new:
      return this.parseNew()

    case types$1.backQuote:
      return this.parseTemplate()

    case types$1._import:
      if (this.options.ecmaVersion >= 11) {
        return this.parseExprImport()
      } else {
        return this.unexpected()
      }

    default:
      this.unexpected();
    }
  };

  pp$5.parseExprImport = function() {
    var node = this.startNode();

    // Consume `import` as an identifier for `import.meta`.
    // Because `this.parseIdent(true)` doesn't check escape sequences, it needs the check of `this.containsEsc`.
    if (this.containsEsc) { this.raiseRecoverable(this.start, "Escape sequence in keyword import"); }
    var meta = this.parseIdent(true);

    switch (this.type) {
    case types$1.parenL:
      return this.parseDynamicImport(node)
    case types$1.dot:
      node.meta = meta;
      return this.parseImportMeta(node)
    default:
      this.unexpected();
    }
  };

  pp$5.parseDynamicImport = function(node) {
    this.next(); // skip `(`

    // Parse node.source.
    node.source = this.parseMaybeAssign();

    // Verify ending.
    if (!this.eat(types$1.parenR)) {
      var errorPos = this.start;
      if (this.eat(types$1.comma) && this.eat(types$1.parenR)) {
        this.raiseRecoverable(errorPos, "Trailing comma is not allowed in import()");
      } else {
        this.unexpected(errorPos);
      }
    }

    return this.finishNode(node, "ImportExpression")
  };

  pp$5.parseImportMeta = function(node) {
    this.next(); // skip `.`

    var containsEsc = this.containsEsc;
    node.property = this.parseIdent(true);

    if (node.property.name !== "meta")
      { this.raiseRecoverable(node.property.start, "The only valid meta property for import is 'import.meta'"); }
    if (containsEsc)
      { this.raiseRecoverable(node.start, "'import.meta' must not contain escaped characters"); }
    if (this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere)
      { this.raiseRecoverable(node.start, "Cannot use 'import.meta' outside a module"); }

    return this.finishNode(node, "MetaProperty")
  };

  pp$5.parseLiteral = function(value) {
    var node = this.startNode();
    node.value = value;
    node.raw = this.input.slice(this.start, this.end);
    if (node.raw.charCodeAt(node.raw.length - 1) === 110) { node.bigint = node.raw.slice(0, -1).replace(/_/g, ""); }
    this.next();
    return this.finishNode(node, "Literal")
  };

  pp$5.parseParenExpression = function() {
    this.expect(types$1.parenL);
    var val = this.parseExpression();
    this.expect(types$1.parenR);
    return val
  };

  pp$5.parseParenAndDistinguishExpression = function(canBeArrow, forInit) {
    var startPos = this.start, startLoc = this.startLoc, val, allowTrailingComma = this.options.ecmaVersion >= 8;
    if (this.options.ecmaVersion >= 6) {
      this.next();

      var innerStartPos = this.start, innerStartLoc = this.startLoc;
      var exprList = [], first = true, lastIsComma = false;
      var refDestructuringErrors = new DestructuringErrors, oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, spreadStart;
      this.yieldPos = 0;
      this.awaitPos = 0;
      // Do not save awaitIdentPos to allow checking awaits nested in parameters
      while (this.type !== types$1.parenR) {
        first ? first = false : this.expect(types$1.comma);
        if (allowTrailingComma && this.afterTrailingComma(types$1.parenR, true)) {
          lastIsComma = true;
          break
        } else if (this.type === types$1.ellipsis) {
          spreadStart = this.start;
          exprList.push(this.parseParenItem(this.parseRestBinding()));
          if (this.type === types$1.comma) { this.raise(this.start, "Comma is not permitted after the rest element"); }
          break
        } else {
          exprList.push(this.parseMaybeAssign(false, refDestructuringErrors, this.parseParenItem));
        }
      }
      var innerEndPos = this.lastTokEnd, innerEndLoc = this.lastTokEndLoc;
      this.expect(types$1.parenR);

      if (canBeArrow && !this.canInsertSemicolon() && this.eat(types$1.arrow)) {
        this.checkPatternErrors(refDestructuringErrors, false);
        this.checkYieldAwaitInDefaultParams();
        this.yieldPos = oldYieldPos;
        this.awaitPos = oldAwaitPos;
        return this.parseParenArrowList(startPos, startLoc, exprList, forInit)
      }

      if (!exprList.length || lastIsComma) { this.unexpected(this.lastTokStart); }
      if (spreadStart) { this.unexpected(spreadStart); }
      this.checkExpressionErrors(refDestructuringErrors, true);
      this.yieldPos = oldYieldPos || this.yieldPos;
      this.awaitPos = oldAwaitPos || this.awaitPos;

      if (exprList.length > 1) {
        val = this.startNodeAt(innerStartPos, innerStartLoc);
        val.expressions = exprList;
        this.finishNodeAt(val, "SequenceExpression", innerEndPos, innerEndLoc);
      } else {
        val = exprList[0];
      }
    } else {
      val = this.parseParenExpression();
    }

    if (this.options.preserveParens) {
      var par = this.startNodeAt(startPos, startLoc);
      par.expression = val;
      return this.finishNode(par, "ParenthesizedExpression")
    } else {
      return val
    }
  };

  pp$5.parseParenItem = function(item) {
    return item
  };

  pp$5.parseParenArrowList = function(startPos, startLoc, exprList, forInit) {
    return this.parseArrowExpression(this.startNodeAt(startPos, startLoc), exprList, false, forInit)
  };

  // New's precedence is slightly tricky. It must allow its argument to
  // be a `[]` or dot subscript expression, but not a call — at least,
  // not without wrapping it in parentheses. Thus, it uses the noCalls
  // argument to parseSubscripts to prevent it from consuming the
  // argument list.

  var empty = [];

  pp$5.parseNew = function() {
    if (this.containsEsc) { this.raiseRecoverable(this.start, "Escape sequence in keyword new"); }
    var node = this.startNode();
    var meta = this.parseIdent(true);
    if (this.options.ecmaVersion >= 6 && this.eat(types$1.dot)) {
      node.meta = meta;
      var containsEsc = this.containsEsc;
      node.property = this.parseIdent(true);
      if (node.property.name !== "target")
        { this.raiseRecoverable(node.property.start, "The only valid meta property for new is 'new.target'"); }
      if (containsEsc)
        { this.raiseRecoverable(node.start, "'new.target' must not contain escaped characters"); }
      if (!this.allowNewDotTarget)
        { this.raiseRecoverable(node.start, "'new.target' can only be used in functions and class static block"); }
      return this.finishNode(node, "MetaProperty")
    }
    var startPos = this.start, startLoc = this.startLoc, isImport = this.type === types$1._import;
    node.callee = this.parseSubscripts(this.parseExprAtom(), startPos, startLoc, true, false);
    if (isImport && node.callee.type === "ImportExpression") {
      this.raise(startPos, "Cannot use new with import()");
    }
    if (this.eat(types$1.parenL)) { node.arguments = this.parseExprList(types$1.parenR, this.options.ecmaVersion >= 8, false); }
    else { node.arguments = empty; }
    return this.finishNode(node, "NewExpression")
  };

  // Parse template expression.

  pp$5.parseTemplateElement = function(ref) {
    var isTagged = ref.isTagged;

    var elem = this.startNode();
    if (this.type === types$1.invalidTemplate) {
      if (!isTagged) {
        this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal");
      }
      elem.value = {
        raw: this.value,
        cooked: null
      };
    } else {
      elem.value = {
        raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, "\n"),
        cooked: this.value
      };
    }
    this.next();
    elem.tail = this.type === types$1.backQuote;
    return this.finishNode(elem, "TemplateElement")
  };

  pp$5.parseTemplate = function(ref) {
    if ( ref === void 0 ) ref = {};
    var isTagged = ref.isTagged; if ( isTagged === void 0 ) isTagged = false;

    var node = this.startNode();
    this.next();
    node.expressions = [];
    var curElt = this.parseTemplateElement({isTagged: isTagged});
    node.quasis = [curElt];
    while (!curElt.tail) {
      if (this.type === types$1.eof) { this.raise(this.pos, "Unterminated template literal"); }
      this.expect(types$1.dollarBraceL);
      node.expressions.push(this.parseExpression());
      this.expect(types$1.braceR);
      node.quasis.push(curElt = this.parseTemplateElement({isTagged: isTagged}));
    }
    this.next();
    return this.finishNode(node, "TemplateLiteral")
  };

  pp$5.isAsyncProp = function(prop) {
    return !prop.computed && prop.key.type === "Identifier" && prop.key.name === "async" &&
      (this.type === types$1.name || this.type === types$1.num || this.type === types$1.string || this.type === types$1.bracketL || this.type.keyword || (this.options.ecmaVersion >= 9 && this.type === types$1.star)) &&
      !lineBreak.test(this.input.slice(this.lastTokEnd, this.start))
  };

  // Parse an object literal or binding pattern.

  pp$5.parseObj = function(isPattern, refDestructuringErrors) {
    var node = this.startNode(), first = true, propHash = {};
    node.properties = [];
    this.next();
    while (!this.eat(types$1.braceR)) {
      if (!first) {
        this.expect(types$1.comma);
        if (this.options.ecmaVersion >= 5 && this.afterTrailingComma(types$1.braceR)) { break }
      } else { first = false; }

      var prop = this.parseProperty(isPattern, refDestructuringErrors);
      if (!isPattern) { this.checkPropClash(prop, propHash, refDestructuringErrors); }
      node.properties.push(prop);
    }
    return this.finishNode(node, isPattern ? "ObjectPattern" : "ObjectExpression")
  };

  pp$5.parseProperty = function(isPattern, refDestructuringErrors) {
    var prop = this.startNode(), isGenerator, isAsync, startPos, startLoc;
    if (this.options.ecmaVersion >= 9 && this.eat(types$1.ellipsis)) {
      if (isPattern) {
        prop.argument = this.parseIdent(false);
        if (this.type === types$1.comma) {
          this.raise(this.start, "Comma is not permitted after the rest element");
        }
        return this.finishNode(prop, "RestElement")
      }
      // Parse argument.
      prop.argument = this.parseMaybeAssign(false, refDestructuringErrors);
      // To disallow trailing comma via `this.toAssignable()`.
      if (this.type === types$1.comma && refDestructuringErrors && refDestructuringErrors.trailingComma < 0) {
        refDestructuringErrors.trailingComma = this.start;
      }
      // Finish
      return this.finishNode(prop, "SpreadElement")
    }
    if (this.options.ecmaVersion >= 6) {
      prop.method = false;
      prop.shorthand = false;
      if (isPattern || refDestructuringErrors) {
        startPos = this.start;
        startLoc = this.startLoc;
      }
      if (!isPattern)
        { isGenerator = this.eat(types$1.star); }
    }
    var containsEsc = this.containsEsc;
    this.parsePropertyName(prop);
    if (!isPattern && !containsEsc && this.options.ecmaVersion >= 8 && !isGenerator && this.isAsyncProp(prop)) {
      isAsync = true;
      isGenerator = this.options.ecmaVersion >= 9 && this.eat(types$1.star);
      this.parsePropertyName(prop);
    } else {
      isAsync = false;
    }
    this.parsePropertyValue(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc);
    return this.finishNode(prop, "Property")
  };

  pp$5.parsePropertyValue = function(prop, isPattern, isGenerator, isAsync, startPos, startLoc, refDestructuringErrors, containsEsc) {
    if ((isGenerator || isAsync) && this.type === types$1.colon)
      { this.unexpected(); }

    if (this.eat(types$1.colon)) {
      prop.value = isPattern ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(false, refDestructuringErrors);
      prop.kind = "init";
    } else if (this.options.ecmaVersion >= 6 && this.type === types$1.parenL) {
      if (isPattern) { this.unexpected(); }
      prop.kind = "init";
      prop.method = true;
      prop.value = this.parseMethod(isGenerator, isAsync);
    } else if (!isPattern && !containsEsc &&
               this.options.ecmaVersion >= 5 && !prop.computed && prop.key.type === "Identifier" &&
               (prop.key.name === "get" || prop.key.name === "set") &&
               (this.type !== types$1.comma && this.type !== types$1.braceR && this.type !== types$1.eq)) {
      if (isGenerator || isAsync) { this.unexpected(); }
      prop.kind = prop.key.name;
      this.parsePropertyName(prop);
      prop.value = this.parseMethod(false);
      var paramCount = prop.kind === "get" ? 0 : 1;
      if (prop.value.params.length !== paramCount) {
        var start = prop.value.start;
        if (prop.kind === "get")
          { this.raiseRecoverable(start, "getter should have no params"); }
        else
          { this.raiseRecoverable(start, "setter should have exactly one param"); }
      } else {
        if (prop.kind === "set" && prop.value.params[0].type === "RestElement")
          { this.raiseRecoverable(prop.value.params[0].start, "Setter cannot use rest params"); }
      }
    } else if (this.options.ecmaVersion >= 6 && !prop.computed && prop.key.type === "Identifier") {
      if (isGenerator || isAsync) { this.unexpected(); }
      this.checkUnreserved(prop.key);
      if (prop.key.name === "await" && !this.awaitIdentPos)
        { this.awaitIdentPos = startPos; }
      prop.kind = "init";
      if (isPattern) {
        prop.value = this.parseMaybeDefault(startPos, startLoc, this.copyNode(prop.key));
      } else if (this.type === types$1.eq && refDestructuringErrors) {
        if (refDestructuringErrors.shorthandAssign < 0)
          { refDestructuringErrors.shorthandAssign = this.start; }
        prop.value = this.parseMaybeDefault(startPos, startLoc, this.copyNode(prop.key));
      } else {
        prop.value = this.copyNode(prop.key);
      }
      prop.shorthand = true;
    } else { this.unexpected(); }
  };

  pp$5.parsePropertyName = function(prop) {
    if (this.options.ecmaVersion >= 6) {
      if (this.eat(types$1.bracketL)) {
        prop.computed = true;
        prop.key = this.parseMaybeAssign();
        this.expect(types$1.bracketR);
        return prop.key
      } else {
        prop.computed = false;
      }
    }
    return prop.key = this.type === types$1.num || this.type === types$1.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never")
  };

  // Initialize empty function node.

  pp$5.initFunction = function(node) {
    node.id = null;
    if (this.options.ecmaVersion >= 6) { node.generator = node.expression = false; }
    if (this.options.ecmaVersion >= 8) { node.async = false; }
  };

  // Parse object or class method.

  pp$5.parseMethod = function(isGenerator, isAsync, allowDirectSuper) {
    var node = this.startNode(), oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;

    this.initFunction(node);
    if (this.options.ecmaVersion >= 6)
      { node.generator = isGenerator; }
    if (this.options.ecmaVersion >= 8)
      { node.async = !!isAsync; }

    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;
    this.enterScope(functionFlags(isAsync, node.generator) | SCOPE_SUPER | (allowDirectSuper ? SCOPE_DIRECT_SUPER : 0));

    this.expect(types$1.parenL);
    node.params = this.parseBindingList(types$1.parenR, false, this.options.ecmaVersion >= 8);
    this.checkYieldAwaitInDefaultParams();
    this.parseFunctionBody(node, false, true, false);

    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, "FunctionExpression")
  };

  // Parse arrow function expression with given parameters.

  pp$5.parseArrowExpression = function(node, params, isAsync, forInit) {
    var oldYieldPos = this.yieldPos, oldAwaitPos = this.awaitPos, oldAwaitIdentPos = this.awaitIdentPos;

    this.enterScope(functionFlags(isAsync, false) | SCOPE_ARROW);
    this.initFunction(node);
    if (this.options.ecmaVersion >= 8) { node.async = !!isAsync; }

    this.yieldPos = 0;
    this.awaitPos = 0;
    this.awaitIdentPos = 0;

    node.params = this.toAssignableList(params, true);
    this.parseFunctionBody(node, true, false, forInit);

    this.yieldPos = oldYieldPos;
    this.awaitPos = oldAwaitPos;
    this.awaitIdentPos = oldAwaitIdentPos;
    return this.finishNode(node, "ArrowFunctionExpression")
  };

  // Parse function body and check parameters.

  pp$5.parseFunctionBody = function(node, isArrowFunction, isMethod, forInit) {
    var isExpression = isArrowFunction && this.type !== types$1.braceL;
    var oldStrict = this.strict, useStrict = false;

    if (isExpression) {
      node.body = this.parseMaybeAssign(forInit);
      node.expression = true;
      this.checkParams(node, false);
    } else {
      var nonSimple = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(node.params);
      if (!oldStrict || nonSimple) {
        useStrict = this.strictDirective(this.end);
        // If this is a strict mode function, verify that argument names
        // are not repeated, and it does not try to bind the words `eval`
        // or `arguments`.
        if (useStrict && nonSimple)
          { this.raiseRecoverable(node.start, "Illegal 'use strict' directive in function with non-simple parameter list"); }
      }
      // Start a new scope with regard to labels and the `inFunction`
      // flag (restore them to their old value afterwards).
      var oldLabels = this.labels;
      this.labels = [];
      if (useStrict) { this.strict = true; }

      // Add the params to varDeclaredNames to ensure that an error is thrown
      // if a let/const declaration in the function clashes with one of the params.
      this.checkParams(node, !oldStrict && !useStrict && !isArrowFunction && !isMethod && this.isSimpleParamList(node.params));
      // Ensure the function name isn't a forbidden identifier in strict mode, e.g. 'eval'
      if (this.strict && node.id) { this.checkLValSimple(node.id, BIND_OUTSIDE); }
      node.body = this.parseBlock(false, undefined, useStrict && !oldStrict);
      node.expression = false;
      this.adaptDirectivePrologue(node.body.body);
      this.labels = oldLabels;
    }
    this.exitScope();
  };

  pp$5.isSimpleParamList = function(params) {
    for (var i = 0, list = params; i < list.length; i += 1)
      {
      var param = list[i];

      if (param.type !== "Identifier") { return false
    } }
    return true
  };

  // Checks function params for various disallowed patterns such as using "eval"
  // or "arguments" and duplicate parameters.

  pp$5.checkParams = function(node, allowDuplicates) {
    var nameHash = Object.create(null);
    for (var i = 0, list = node.params; i < list.length; i += 1)
      {
      var param = list[i];

      this.checkLValInnerPattern(param, BIND_VAR, allowDuplicates ? null : nameHash);
    }
  };

  // Parses a comma-separated list of expressions, and returns them as
  // an array. `close` is the token type that ends the list, and
  // `allowEmpty` can be turned on to allow subsequent commas with
  // nothing in between them to be parsed as `null` (which is needed
  // for array literals).

  pp$5.parseExprList = function(close, allowTrailingComma, allowEmpty, refDestructuringErrors) {
    var elts = [], first = true;
    while (!this.eat(close)) {
      if (!first) {
        this.expect(types$1.comma);
        if (allowTrailingComma && this.afterTrailingComma(close)) { break }
      } else { first = false; }

      var elt = (void 0);
      if (allowEmpty && this.type === types$1.comma)
        { elt = null; }
      else if (this.type === types$1.ellipsis) {
        elt = this.parseSpread(refDestructuringErrors);
        if (refDestructuringErrors && this.type === types$1.comma && refDestructuringErrors.trailingComma < 0)
          { refDestructuringErrors.trailingComma = this.start; }
      } else {
        elt = this.parseMaybeAssign(false, refDestructuringErrors);
      }
      elts.push(elt);
    }
    return elts
  };

  pp$5.checkUnreserved = function(ref) {
    var start = ref.start;
    var end = ref.end;
    var name = ref.name;

    if (this.inGenerator && name === "yield")
      { this.raiseRecoverable(start, "Cannot use 'yield' as identifier inside a generator"); }
    if (this.inAsync && name === "await")
      { this.raiseRecoverable(start, "Cannot use 'await' as identifier inside an async function"); }
    if (this.currentThisScope().inClassFieldInit && name === "arguments")
      { this.raiseRecoverable(start, "Cannot use 'arguments' in class field initializer"); }
    if (this.inClassStaticBlock && (name === "arguments" || name === "await"))
      { this.raise(start, ("Cannot use " + name + " in class static initialization block")); }
    if (this.keywords.test(name))
      { this.raise(start, ("Unexpected keyword '" + name + "'")); }
    if (this.options.ecmaVersion < 6 &&
      this.input.slice(start, end).indexOf("\\") !== -1) { return }
    var re = this.strict ? this.reservedWordsStrict : this.reservedWords;
    if (re.test(name)) {
      if (!this.inAsync && name === "await")
        { this.raiseRecoverable(start, "Cannot use keyword 'await' outside an async function"); }
      this.raiseRecoverable(start, ("The keyword '" + name + "' is reserved"));
    }
  };

  // Parse the next token as an identifier. If `liberal` is true (used
  // when parsing properties), it will also convert keywords into
  // identifiers.

  pp$5.parseIdent = function(liberal) {
    var node = this.startNode();
    if (this.type === types$1.name) {
      node.name = this.value;
    } else if (this.type.keyword) {
      node.name = this.type.keyword;

      // To fix https://github.com/acornjs/acorn/issues/575
      // `class` and `function` keywords push new context into this.context.
      // But there is no chance to pop the context if the keyword is consumed as an identifier such as a property name.
      // If the previous token is a dot, this does not apply because the context-managing code already ignored the keyword
      if ((node.name === "class" || node.name === "function") &&
          (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46)) {
        this.context.pop();
      }
    } else {
      this.unexpected();
    }
    this.next(!!liberal);
    this.finishNode(node, "Identifier");
    if (!liberal) {
      this.checkUnreserved(node);
      if (node.name === "await" && !this.awaitIdentPos)
        { this.awaitIdentPos = node.start; }
    }
    return node
  };

  pp$5.parsePrivateIdent = function() {
    var node = this.startNode();
    if (this.type === types$1.privateId) {
      node.name = this.value;
    } else {
      this.unexpected();
    }
    this.next();
    this.finishNode(node, "PrivateIdentifier");

    // For validating existence
    if (this.privateNameStack.length === 0) {
      this.raise(node.start, ("Private field '#" + (node.name) + "' must be declared in an enclosing class"));
    } else {
      this.privateNameStack[this.privateNameStack.length - 1].used.push(node);
    }

    return node
  };

  // Parses yield expression inside generator.

  pp$5.parseYield = function(forInit) {
    if (!this.yieldPos) { this.yieldPos = this.start; }

    var node = this.startNode();
    this.next();
    if (this.type === types$1.semi || this.canInsertSemicolon() || (this.type !== types$1.star && !this.type.startsExpr)) {
      node.delegate = false;
      node.argument = null;
    } else {
      node.delegate = this.eat(types$1.star);
      node.argument = this.parseMaybeAssign(forInit);
    }
    return this.finishNode(node, "YieldExpression")
  };

  pp$5.parseAwait = function(forInit) {
    if (!this.awaitPos) { this.awaitPos = this.start; }

    var node = this.startNode();
    this.next();
    node.argument = this.parseMaybeUnary(null, true, false, forInit);
    return this.finishNode(node, "AwaitExpression")
  };

  var pp$4 = Parser.prototype;

  // This function is used to raise exceptions on parse errors. It
  // takes an offset integer (into the current `input`) to indicate
  // the location of the error, attaches the position to the end
  // of the error message, and then raises a `SyntaxError` with that
  // message.

  pp$4.raise = function(pos, message) {
    var loc = getLineInfo(this.input, pos);
    message += " (" + loc.line + ":" + loc.column + ")";
    var err = new SyntaxError(message);
    err.pos = pos; err.loc = loc; err.raisedAt = this.pos;
    throw err
  };

  pp$4.raiseRecoverable = pp$4.raise;

  pp$4.curPosition = function() {
    if (this.options.locations) {
      return new Position(this.curLine, this.pos - this.lineStart)
    }
  };

  var pp$3 = Parser.prototype;

  var Scope = function Scope(flags) {
    this.flags = flags;
    // A list of var-declared names in the current lexical scope
    this.var = [];
    // A list of lexically-declared names in the current lexical scope
    this.lexical = [];
    // A list of lexically-declared FunctionDeclaration names in the current lexical scope
    this.functions = [];
    // A switch to disallow the identifier reference 'arguments'
    this.inClassFieldInit = false;
  };

  // The functions in this module keep track of declared variables in the current scope in order to detect duplicate variable names.

  pp$3.enterScope = function(flags) {
    this.scopeStack.push(new Scope(flags));
  };

  pp$3.exitScope = function() {
    this.scopeStack.pop();
  };

  // The spec says:
  // > At the top level of a function, or script, function declarations are
  // > treated like var declarations rather than like lexical declarations.
  pp$3.treatFunctionsAsVarInScope = function(scope) {
    return (scope.flags & SCOPE_FUNCTION) || !this.inModule && (scope.flags & SCOPE_TOP)
  };

  pp$3.declareName = function(name, bindingType, pos) {
    var redeclared = false;
    if (bindingType === BIND_LEXICAL) {
      var scope = this.currentScope();
      redeclared = scope.lexical.indexOf(name) > -1 || scope.functions.indexOf(name) > -1 || scope.var.indexOf(name) > -1;
      scope.lexical.push(name);
      if (this.inModule && (scope.flags & SCOPE_TOP))
        { delete this.undefinedExports[name]; }
    } else if (bindingType === BIND_SIMPLE_CATCH) {
      var scope$1 = this.currentScope();
      scope$1.lexical.push(name);
    } else if (bindingType === BIND_FUNCTION) {
      var scope$2 = this.currentScope();
      if (this.treatFunctionsAsVar)
        { redeclared = scope$2.lexical.indexOf(name) > -1; }
      else
        { redeclared = scope$2.lexical.indexOf(name) > -1 || scope$2.var.indexOf(name) > -1; }
      scope$2.functions.push(name);
    } else {
      for (var i = this.scopeStack.length - 1; i >= 0; --i) {
        var scope$3 = this.scopeStack[i];
        if (scope$3.lexical.indexOf(name) > -1 && !((scope$3.flags & SCOPE_SIMPLE_CATCH) && scope$3.lexical[0] === name) ||
            !this.treatFunctionsAsVarInScope(scope$3) && scope$3.functions.indexOf(name) > -1) {
          redeclared = true;
          break
        }
        scope$3.var.push(name);
        if (this.inModule && (scope$3.flags & SCOPE_TOP))
          { delete this.undefinedExports[name]; }
        if (scope$3.flags & SCOPE_VAR) { break }
      }
    }
    if (redeclared) { this.raiseRecoverable(pos, ("Identifier '" + name + "' has already been declared")); }
  };

  pp$3.checkLocalExport = function(id) {
    // scope.functions must be empty as Module code is always strict.
    if (this.scopeStack[0].lexical.indexOf(id.name) === -1 &&
        this.scopeStack[0].var.indexOf(id.name) === -1) {
      this.undefinedExports[id.name] = id;
    }
  };

  pp$3.currentScope = function() {
    return this.scopeStack[this.scopeStack.length - 1]
  };

  pp$3.currentVarScope = function() {
    for (var i = this.scopeStack.length - 1;; i--) {
      var scope = this.scopeStack[i];
      if (scope.flags & SCOPE_VAR) { return scope }
    }
  };

  // Could be useful for `this`, `new.target`, `super()`, `super.property`, and `super[property]`.
  pp$3.currentThisScope = function() {
    for (var i = this.scopeStack.length - 1;; i--) {
      var scope = this.scopeStack[i];
      if (scope.flags & SCOPE_VAR && !(scope.flags & SCOPE_ARROW)) { return scope }
    }
  };

  var Node = function Node(parser, pos, loc) {
    this.type = "";
    this.start = pos;
    this.end = 0;
    if (parser.options.locations)
      { this.loc = new SourceLocation(parser, loc); }
    if (parser.options.directSourceFile)
      { this.sourceFile = parser.options.directSourceFile; }
    if (parser.options.ranges)
      { this.range = [pos, 0]; }
  };

  // Start an AST node, attaching a start offset.

  var pp$2 = Parser.prototype;

  pp$2.startNode = function() {
    return new Node(this, this.start, this.startLoc)
  };

  pp$2.startNodeAt = function(pos, loc) {
    return new Node(this, pos, loc)
  };

  // Finish an AST node, adding `type` and `end` properties.

  function finishNodeAt(node, type, pos, loc) {
    node.type = type;
    node.end = pos;
    if (this.options.locations)
      { node.loc.end = loc; }
    if (this.options.ranges)
      { node.range[1] = pos; }
    return node
  }

  pp$2.finishNode = function(node, type) {
    return finishNodeAt.call(this, node, type, this.lastTokEnd, this.lastTokEndLoc)
  };

  // Finish node at given position

  pp$2.finishNodeAt = function(node, type, pos, loc) {
    return finishNodeAt.call(this, node, type, pos, loc)
  };

  pp$2.copyNode = function(node) {
    var newNode = new Node(this, node.start, this.startLoc);
    for (var prop in node) { newNode[prop] = node[prop]; }
    return newNode
  };

  // This file contains Unicode properties extracted from the ECMAScript specification.
  // The lists are extracted like so:
  // $$('#table-binary-unicode-properties > figure > table > tbody > tr > td:nth-child(1) code').map(el => el.innerText)

  // #table-binary-unicode-properties
  var ecma9BinaryProperties = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS";
  var ecma10BinaryProperties = ecma9BinaryProperties + " Extended_Pictographic";
  var ecma11BinaryProperties = ecma10BinaryProperties;
  var ecma12BinaryProperties = ecma11BinaryProperties + " EBase EComp EMod EPres ExtPict";
  var ecma13BinaryProperties = ecma12BinaryProperties;
  var ecma14BinaryProperties = ecma13BinaryProperties;

  var unicodeBinaryProperties = {
    9: ecma9BinaryProperties,
    10: ecma10BinaryProperties,
    11: ecma11BinaryProperties,
    12: ecma12BinaryProperties,
    13: ecma13BinaryProperties,
    14: ecma14BinaryProperties
  };

  // #table-unicode-general-category-values
  var unicodeGeneralCategoryValues = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu";

  // #table-unicode-script-values
  var ecma9ScriptValues = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb";
  var ecma10ScriptValues = ecma9ScriptValues + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd";
  var ecma11ScriptValues = ecma10ScriptValues + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho";
  var ecma12ScriptValues = ecma11ScriptValues + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi";
  var ecma13ScriptValues = ecma12ScriptValues + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith";
  var ecma14ScriptValues = ecma13ScriptValues + " Kawi Nag_Mundari Nagm";

  var unicodeScriptValues = {
    9: ecma9ScriptValues,
    10: ecma10ScriptValues,
    11: ecma11ScriptValues,
    12: ecma12ScriptValues,
    13: ecma13ScriptValues,
    14: ecma14ScriptValues
  };

  var data = {};
  function buildUnicodeData(ecmaVersion) {
    var d = data[ecmaVersion] = {
      binary: wordsRegexp(unicodeBinaryProperties[ecmaVersion] + " " + unicodeGeneralCategoryValues),
      nonBinary: {
        General_Category: wordsRegexp(unicodeGeneralCategoryValues),
        Script: wordsRegexp(unicodeScriptValues[ecmaVersion])
      }
    };
    d.nonBinary.Script_Extensions = d.nonBinary.Script;

    d.nonBinary.gc = d.nonBinary.General_Category;
    d.nonBinary.sc = d.nonBinary.Script;
    d.nonBinary.scx = d.nonBinary.Script_Extensions;
  }

  for (var i = 0, list = [9, 10, 11, 12, 13, 14]; i < list.length; i += 1) {
    var ecmaVersion = list[i];

    buildUnicodeData(ecmaVersion);
  }

  var pp$1 = Parser.prototype;

  var RegExpValidationState = function RegExpValidationState(parser) {
    this.parser = parser;
    this.validFlags = "gim" + (parser.options.ecmaVersion >= 6 ? "uy" : "") + (parser.options.ecmaVersion >= 9 ? "s" : "") + (parser.options.ecmaVersion >= 13 ? "d" : "");
    this.unicodeProperties = data[parser.options.ecmaVersion >= 14 ? 14 : parser.options.ecmaVersion];
    this.source = "";
    this.flags = "";
    this.start = 0;
    this.switchU = false;
    this.switchN = false;
    this.pos = 0;
    this.lastIntValue = 0;
    this.lastStringValue = "";
    this.lastAssertionIsQuantifiable = false;
    this.numCapturingParens = 0;
    this.maxBackReference = 0;
    this.groupNames = [];
    this.backReferenceNames = [];
  };

  RegExpValidationState.prototype.reset = function reset (start, pattern, flags) {
    var unicode = flags.indexOf("u") !== -1;
    this.start = start | 0;
    this.source = pattern + "";
    this.flags = flags;
    this.switchU = unicode && this.parser.options.ecmaVersion >= 6;
    this.switchN = unicode && this.parser.options.ecmaVersion >= 9;
  };

  RegExpValidationState.prototype.raise = function raise (message) {
    this.parser.raiseRecoverable(this.start, ("Invalid regular expression: /" + (this.source) + "/: " + message));
  };

  // If u flag is given, this returns the code point at the index (it combines a surrogate pair).
  // Otherwise, this returns the code unit of the index (can be a part of a surrogate pair).
  RegExpValidationState.prototype.at = function at (i, forceU) {
      if ( forceU === void 0 ) forceU = false;

    var s = this.source;
    var l = s.length;
    if (i >= l) {
      return -1
    }
    var c = s.charCodeAt(i);
    if (!(forceU || this.switchU) || c <= 0xD7FF || c >= 0xE000 || i + 1 >= l) {
      return c
    }
    var next = s.charCodeAt(i + 1);
    return next >= 0xDC00 && next <= 0xDFFF ? (c << 10) + next - 0x35FDC00 : c
  };

  RegExpValidationState.prototype.nextIndex = function nextIndex (i, forceU) {
      if ( forceU === void 0 ) forceU = false;

    var s = this.source;
    var l = s.length;
    if (i >= l) {
      return l
    }
    var c = s.charCodeAt(i), next;
    if (!(forceU || this.switchU) || c <= 0xD7FF || c >= 0xE000 || i + 1 >= l ||
        (next = s.charCodeAt(i + 1)) < 0xDC00 || next > 0xDFFF) {
      return i + 1
    }
    return i + 2
  };

  RegExpValidationState.prototype.current = function current (forceU) {
      if ( forceU === void 0 ) forceU = false;

    return this.at(this.pos, forceU)
  };

  RegExpValidationState.prototype.lookahead = function lookahead (forceU) {
      if ( forceU === void 0 ) forceU = false;

    return this.at(this.nextIndex(this.pos, forceU), forceU)
  };

  RegExpValidationState.prototype.advance = function advance (forceU) {
      if ( forceU === void 0 ) forceU = false;

    this.pos = this.nextIndex(this.pos, forceU);
  };

  RegExpValidationState.prototype.eat = function eat (ch, forceU) {
      if ( forceU === void 0 ) forceU = false;

    if (this.current(forceU) === ch) {
      this.advance(forceU);
      return true
    }
    return false
  };

  /**
   * Validate the flags part of a given RegExpLiteral.
   *
   * @param {RegExpValidationState} state The state to validate RegExp.
   * @returns {void}
   */
  pp$1.validateRegExpFlags = function(state) {
    var validFlags = state.validFlags;
    var flags = state.flags;

    for (var i = 0; i < flags.length; i++) {
      var flag = flags.charAt(i);
      if (validFlags.indexOf(flag) === -1) {
        this.raise(state.start, "Invalid regular expression flag");
      }
      if (flags.indexOf(flag, i + 1) > -1) {
        this.raise(state.start, "Duplicate regular expression flag");
      }
    }
  };

  /**
   * Validate the pattern part of a given RegExpLiteral.
   *
   * @param {RegExpValidationState} state The state to validate RegExp.
   * @returns {void}
   */
  pp$1.validateRegExpPattern = function(state) {
    this.regexp_pattern(state);

    // The goal symbol for the parse is |Pattern[~U, ~N]|. If the result of
    // parsing contains a |GroupName|, reparse with the goal symbol
    // |Pattern[~U, +N]| and use this result instead. Throw a *SyntaxError*
    // exception if _P_ did not conform to the grammar, if any elements of _P_
    // were not matched by the parse, or if any Early Error conditions exist.
    if (!state.switchN && this.options.ecmaVersion >= 9 && state.groupNames.length > 0) {
      state.switchN = true;
      this.regexp_pattern(state);
    }
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-Pattern
  pp$1.regexp_pattern = function(state) {
    state.pos = 0;
    state.lastIntValue = 0;
    state.lastStringValue = "";
    state.lastAssertionIsQuantifiable = false;
    state.numCapturingParens = 0;
    state.maxBackReference = 0;
    state.groupNames.length = 0;
    state.backReferenceNames.length = 0;

    this.regexp_disjunction(state);

    if (state.pos !== state.source.length) {
      // Make the same messages as V8.
      if (state.eat(0x29 /* ) */)) {
        state.raise("Unmatched ')'");
      }
      if (state.eat(0x5D /* ] */) || state.eat(0x7D /* } */)) {
        state.raise("Lone quantifier brackets");
      }
    }
    if (state.maxBackReference > state.numCapturingParens) {
      state.raise("Invalid escape");
    }
    for (var i = 0, list = state.backReferenceNames; i < list.length; i += 1) {
      var name = list[i];

      if (state.groupNames.indexOf(name) === -1) {
        state.raise("Invalid named capture referenced");
      }
    }
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-Disjunction
  pp$1.regexp_disjunction = function(state) {
    this.regexp_alternative(state);
    while (state.eat(0x7C /* | */)) {
      this.regexp_alternative(state);
    }

    // Make the same message as V8.
    if (this.regexp_eatQuantifier(state, true)) {
      state.raise("Nothing to repeat");
    }
    if (state.eat(0x7B /* { */)) {
      state.raise("Lone quantifier brackets");
    }
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-Alternative
  pp$1.regexp_alternative = function(state) {
    while (state.pos < state.source.length && this.regexp_eatTerm(state))
      { }
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-Term
  pp$1.regexp_eatTerm = function(state) {
    if (this.regexp_eatAssertion(state)) {
      // Handle `QuantifiableAssertion Quantifier` alternative.
      // `state.lastAssertionIsQuantifiable` is true if the last eaten Assertion
      // is a QuantifiableAssertion.
      if (state.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(state)) {
        // Make the same message as V8.
        if (state.switchU) {
          state.raise("Invalid quantifier");
        }
      }
      return true
    }

    if (state.switchU ? this.regexp_eatAtom(state) : this.regexp_eatExtendedAtom(state)) {
      this.regexp_eatQuantifier(state);
      return true
    }

    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-Assertion
  pp$1.regexp_eatAssertion = function(state) {
    var start = state.pos;
    state.lastAssertionIsQuantifiable = false;

    // ^, $
    if (state.eat(0x5E /* ^ */) || state.eat(0x24 /* $ */)) {
      return true
    }

    // \b \B
    if (state.eat(0x5C /* \ */)) {
      if (state.eat(0x42 /* B */) || state.eat(0x62 /* b */)) {
        return true
      }
      state.pos = start;
    }

    // Lookahead / Lookbehind
    if (state.eat(0x28 /* ( */) && state.eat(0x3F /* ? */)) {
      var lookbehind = false;
      if (this.options.ecmaVersion >= 9) {
        lookbehind = state.eat(0x3C /* < */);
      }
      if (state.eat(0x3D /* = */) || state.eat(0x21 /* ! */)) {
        this.regexp_disjunction(state);
        if (!state.eat(0x29 /* ) */)) {
          state.raise("Unterminated group");
        }
        state.lastAssertionIsQuantifiable = !lookbehind;
        return true
      }
    }

    state.pos = start;
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-Quantifier
  pp$1.regexp_eatQuantifier = function(state, noError) {
    if ( noError === void 0 ) noError = false;

    if (this.regexp_eatQuantifierPrefix(state, noError)) {
      state.eat(0x3F /* ? */);
      return true
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-QuantifierPrefix
  pp$1.regexp_eatQuantifierPrefix = function(state, noError) {
    return (
      state.eat(0x2A /* * */) ||
      state.eat(0x2B /* + */) ||
      state.eat(0x3F /* ? */) ||
      this.regexp_eatBracedQuantifier(state, noError)
    )
  };
  pp$1.regexp_eatBracedQuantifier = function(state, noError) {
    var start = state.pos;
    if (state.eat(0x7B /* { */)) {
      var min = 0, max = -1;
      if (this.regexp_eatDecimalDigits(state)) {
        min = state.lastIntValue;
        if (state.eat(0x2C /* , */) && this.regexp_eatDecimalDigits(state)) {
          max = state.lastIntValue;
        }
        if (state.eat(0x7D /* } */)) {
          // SyntaxError in https://www.ecma-international.org/ecma-262/8.0/#sec-term
          if (max !== -1 && max < min && !noError) {
            state.raise("numbers out of order in {} quantifier");
          }
          return true
        }
      }
      if (state.switchU && !noError) {
        state.raise("Incomplete quantifier");
      }
      state.pos = start;
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-Atom
  pp$1.regexp_eatAtom = function(state) {
    return (
      this.regexp_eatPatternCharacters(state) ||
      state.eat(0x2E /* . */) ||
      this.regexp_eatReverseSolidusAtomEscape(state) ||
      this.regexp_eatCharacterClass(state) ||
      this.regexp_eatUncapturingGroup(state) ||
      this.regexp_eatCapturingGroup(state)
    )
  };
  pp$1.regexp_eatReverseSolidusAtomEscape = function(state) {
    var start = state.pos;
    if (state.eat(0x5C /* \ */)) {
      if (this.regexp_eatAtomEscape(state)) {
        return true
      }
      state.pos = start;
    }
    return false
  };
  pp$1.regexp_eatUncapturingGroup = function(state) {
    var start = state.pos;
    if (state.eat(0x28 /* ( */)) {
      if (state.eat(0x3F /* ? */) && state.eat(0x3A /* : */)) {
        this.regexp_disjunction(state);
        if (state.eat(0x29 /* ) */)) {
          return true
        }
        state.raise("Unterminated group");
      }
      state.pos = start;
    }
    return false
  };
  pp$1.regexp_eatCapturingGroup = function(state) {
    if (state.eat(0x28 /* ( */)) {
      if (this.options.ecmaVersion >= 9) {
        this.regexp_groupSpecifier(state);
      } else if (state.current() === 0x3F /* ? */) {
        state.raise("Invalid group");
      }
      this.regexp_disjunction(state);
      if (state.eat(0x29 /* ) */)) {
        state.numCapturingParens += 1;
        return true
      }
      state.raise("Unterminated group");
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ExtendedAtom
  pp$1.regexp_eatExtendedAtom = function(state) {
    return (
      state.eat(0x2E /* . */) ||
      this.regexp_eatReverseSolidusAtomEscape(state) ||
      this.regexp_eatCharacterClass(state) ||
      this.regexp_eatUncapturingGroup(state) ||
      this.regexp_eatCapturingGroup(state) ||
      this.regexp_eatInvalidBracedQuantifier(state) ||
      this.regexp_eatExtendedPatternCharacter(state)
    )
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-InvalidBracedQuantifier
  pp$1.regexp_eatInvalidBracedQuantifier = function(state) {
    if (this.regexp_eatBracedQuantifier(state, true)) {
      state.raise("Nothing to repeat");
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-SyntaxCharacter
  pp$1.regexp_eatSyntaxCharacter = function(state) {
    var ch = state.current();
    if (isSyntaxCharacter(ch)) {
      state.lastIntValue = ch;
      state.advance();
      return true
    }
    return false
  };
  function isSyntaxCharacter(ch) {
    return (
      ch === 0x24 /* $ */ ||
      ch >= 0x28 /* ( */ && ch <= 0x2B /* + */ ||
      ch === 0x2E /* . */ ||
      ch === 0x3F /* ? */ ||
      ch >= 0x5B /* [ */ && ch <= 0x5E /* ^ */ ||
      ch >= 0x7B /* { */ && ch <= 0x7D /* } */
    )
  }

  // https://www.ecma-international.org/ecma-262/8.0/#prod-PatternCharacter
  // But eat eager.
  pp$1.regexp_eatPatternCharacters = function(state) {
    var start = state.pos;
    var ch = 0;
    while ((ch = state.current()) !== -1 && !isSyntaxCharacter(ch)) {
      state.advance();
    }
    return state.pos !== start
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ExtendedPatternCharacter
  pp$1.regexp_eatExtendedPatternCharacter = function(state) {
    var ch = state.current();
    if (
      ch !== -1 &&
      ch !== 0x24 /* $ */ &&
      !(ch >= 0x28 /* ( */ && ch <= 0x2B /* + */) &&
      ch !== 0x2E /* . */ &&
      ch !== 0x3F /* ? */ &&
      ch !== 0x5B /* [ */ &&
      ch !== 0x5E /* ^ */ &&
      ch !== 0x7C /* | */
    ) {
      state.advance();
      return true
    }
    return false
  };

  // GroupSpecifier ::
  //   [empty]
  //   `?` GroupName
  pp$1.regexp_groupSpecifier = function(state) {
    if (state.eat(0x3F /* ? */)) {
      if (this.regexp_eatGroupName(state)) {
        if (state.groupNames.indexOf(state.lastStringValue) !== -1) {
          state.raise("Duplicate capture group name");
        }
        state.groupNames.push(state.lastStringValue);
        return
      }
      state.raise("Invalid group");
    }
  };

  // GroupName ::
  //   `<` RegExpIdentifierName `>`
  // Note: this updates `state.lastStringValue` property with the eaten name.
  pp$1.regexp_eatGroupName = function(state) {
    state.lastStringValue = "";
    if (state.eat(0x3C /* < */)) {
      if (this.regexp_eatRegExpIdentifierName(state) && state.eat(0x3E /* > */)) {
        return true
      }
      state.raise("Invalid capture group name");
    }
    return false
  };

  // RegExpIdentifierName ::
  //   RegExpIdentifierStart
  //   RegExpIdentifierName RegExpIdentifierPart
  // Note: this updates `state.lastStringValue` property with the eaten name.
  pp$1.regexp_eatRegExpIdentifierName = function(state) {
    state.lastStringValue = "";
    if (this.regexp_eatRegExpIdentifierStart(state)) {
      state.lastStringValue += codePointToString(state.lastIntValue);
      while (this.regexp_eatRegExpIdentifierPart(state)) {
        state.lastStringValue += codePointToString(state.lastIntValue);
      }
      return true
    }
    return false
  };

  // RegExpIdentifierStart ::
  //   UnicodeIDStart
  //   `$`
  //   `_`
  //   `\` RegExpUnicodeEscapeSequence[+U]
  pp$1.regexp_eatRegExpIdentifierStart = function(state) {
    var start = state.pos;
    var forceU = this.options.ecmaVersion >= 11;
    var ch = state.current(forceU);
    state.advance(forceU);

    if (ch === 0x5C /* \ */ && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) {
      ch = state.lastIntValue;
    }
    if (isRegExpIdentifierStart(ch)) {
      state.lastIntValue = ch;
      return true
    }

    state.pos = start;
    return false
  };
  function isRegExpIdentifierStart(ch) {
    return isIdentifierStart(ch, true) || ch === 0x24 /* $ */ || ch === 0x5F /* _ */
  }

  // RegExpIdentifierPart ::
  //   UnicodeIDContinue
  //   `$`
  //   `_`
  //   `\` RegExpUnicodeEscapeSequence[+U]
  //   <ZWNJ>
  //   <ZWJ>
  pp$1.regexp_eatRegExpIdentifierPart = function(state) {
    var start = state.pos;
    var forceU = this.options.ecmaVersion >= 11;
    var ch = state.current(forceU);
    state.advance(forceU);

    if (ch === 0x5C /* \ */ && this.regexp_eatRegExpUnicodeEscapeSequence(state, forceU)) {
      ch = state.lastIntValue;
    }
    if (isRegExpIdentifierPart(ch)) {
      state.lastIntValue = ch;
      return true
    }

    state.pos = start;
    return false
  };
  function isRegExpIdentifierPart(ch) {
    return isIdentifierChar(ch, true) || ch === 0x24 /* $ */ || ch === 0x5F /* _ */ || ch === 0x200C /* <ZWNJ> */ || ch === 0x200D /* <ZWJ> */
  }

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-AtomEscape
  pp$1.regexp_eatAtomEscape = function(state) {
    if (
      this.regexp_eatBackReference(state) ||
      this.regexp_eatCharacterClassEscape(state) ||
      this.regexp_eatCharacterEscape(state) ||
      (state.switchN && this.regexp_eatKGroupName(state))
    ) {
      return true
    }
    if (state.switchU) {
      // Make the same message as V8.
      if (state.current() === 0x63 /* c */) {
        state.raise("Invalid unicode escape");
      }
      state.raise("Invalid escape");
    }
    return false
  };
  pp$1.regexp_eatBackReference = function(state) {
    var start = state.pos;
    if (this.regexp_eatDecimalEscape(state)) {
      var n = state.lastIntValue;
      if (state.switchU) {
        // For SyntaxError in https://www.ecma-international.org/ecma-262/8.0/#sec-atomescape
        if (n > state.maxBackReference) {
          state.maxBackReference = n;
        }
        return true
      }
      if (n <= state.numCapturingParens) {
        return true
      }
      state.pos = start;
    }
    return false
  };
  pp$1.regexp_eatKGroupName = function(state) {
    if (state.eat(0x6B /* k */)) {
      if (this.regexp_eatGroupName(state)) {
        state.backReferenceNames.push(state.lastStringValue);
        return true
      }
      state.raise("Invalid named reference");
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-CharacterEscape
  pp$1.regexp_eatCharacterEscape = function(state) {
    return (
      this.regexp_eatControlEscape(state) ||
      this.regexp_eatCControlLetter(state) ||
      this.regexp_eatZero(state) ||
      this.regexp_eatHexEscapeSequence(state) ||
      this.regexp_eatRegExpUnicodeEscapeSequence(state, false) ||
      (!state.switchU && this.regexp_eatLegacyOctalEscapeSequence(state)) ||
      this.regexp_eatIdentityEscape(state)
    )
  };
  pp$1.regexp_eatCControlLetter = function(state) {
    var start = state.pos;
    if (state.eat(0x63 /* c */)) {
      if (this.regexp_eatControlLetter(state)) {
        return true
      }
      state.pos = start;
    }
    return false
  };
  pp$1.regexp_eatZero = function(state) {
    if (state.current() === 0x30 /* 0 */ && !isDecimalDigit(state.lookahead())) {
      state.lastIntValue = 0;
      state.advance();
      return true
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-ControlEscape
  pp$1.regexp_eatControlEscape = function(state) {
    var ch = state.current();
    if (ch === 0x74 /* t */) {
      state.lastIntValue = 0x09; /* \t */
      state.advance();
      return true
    }
    if (ch === 0x6E /* n */) {
      state.lastIntValue = 0x0A; /* \n */
      state.advance();
      return true
    }
    if (ch === 0x76 /* v */) {
      state.lastIntValue = 0x0B; /* \v */
      state.advance();
      return true
    }
    if (ch === 0x66 /* f */) {
      state.lastIntValue = 0x0C; /* \f */
      state.advance();
      return true
    }
    if (ch === 0x72 /* r */) {
      state.lastIntValue = 0x0D; /* \r */
      state.advance();
      return true
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-ControlLetter
  pp$1.regexp_eatControlLetter = function(state) {
    var ch = state.current();
    if (isControlLetter(ch)) {
      state.lastIntValue = ch % 0x20;
      state.advance();
      return true
    }
    return false
  };
  function isControlLetter(ch) {
    return (
      (ch >= 0x41 /* A */ && ch <= 0x5A /* Z */) ||
      (ch >= 0x61 /* a */ && ch <= 0x7A /* z */)
    )
  }

  // https://www.ecma-international.org/ecma-262/8.0/#prod-RegExpUnicodeEscapeSequence
  pp$1.regexp_eatRegExpUnicodeEscapeSequence = function(state, forceU) {
    if ( forceU === void 0 ) forceU = false;

    var start = state.pos;
    var switchU = forceU || state.switchU;

    if (state.eat(0x75 /* u */)) {
      if (this.regexp_eatFixedHexDigits(state, 4)) {
        var lead = state.lastIntValue;
        if (switchU && lead >= 0xD800 && lead <= 0xDBFF) {
          var leadSurrogateEnd = state.pos;
          if (state.eat(0x5C /* \ */) && state.eat(0x75 /* u */) && this.regexp_eatFixedHexDigits(state, 4)) {
            var trail = state.lastIntValue;
            if (trail >= 0xDC00 && trail <= 0xDFFF) {
              state.lastIntValue = (lead - 0xD800) * 0x400 + (trail - 0xDC00) + 0x10000;
              return true
            }
          }
          state.pos = leadSurrogateEnd;
          state.lastIntValue = lead;
        }
        return true
      }
      if (
        switchU &&
        state.eat(0x7B /* { */) &&
        this.regexp_eatHexDigits(state) &&
        state.eat(0x7D /* } */) &&
        isValidUnicode(state.lastIntValue)
      ) {
        return true
      }
      if (switchU) {
        state.raise("Invalid unicode escape");
      }
      state.pos = start;
    }

    return false
  };
  function isValidUnicode(ch) {
    return ch >= 0 && ch <= 0x10FFFF
  }

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-IdentityEscape
  pp$1.regexp_eatIdentityEscape = function(state) {
    if (state.switchU) {
      if (this.regexp_eatSyntaxCharacter(state)) {
        return true
      }
      if (state.eat(0x2F /* / */)) {
        state.lastIntValue = 0x2F; /* / */
        return true
      }
      return false
    }

    var ch = state.current();
    if (ch !== 0x63 /* c */ && (!state.switchN || ch !== 0x6B /* k */)) {
      state.lastIntValue = ch;
      state.advance();
      return true
    }

    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-DecimalEscape
  pp$1.regexp_eatDecimalEscape = function(state) {
    state.lastIntValue = 0;
    var ch = state.current();
    if (ch >= 0x31 /* 1 */ && ch <= 0x39 /* 9 */) {
      do {
        state.lastIntValue = 10 * state.lastIntValue + (ch - 0x30 /* 0 */);
        state.advance();
      } while ((ch = state.current()) >= 0x30 /* 0 */ && ch <= 0x39 /* 9 */)
      return true
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-CharacterClassEscape
  pp$1.regexp_eatCharacterClassEscape = function(state) {
    var ch = state.current();

    if (isCharacterClassEscape(ch)) {
      state.lastIntValue = -1;
      state.advance();
      return true
    }

    if (
      state.switchU &&
      this.options.ecmaVersion >= 9 &&
      (ch === 0x50 /* P */ || ch === 0x70 /* p */)
    ) {
      state.lastIntValue = -1;
      state.advance();
      if (
        state.eat(0x7B /* { */) &&
        this.regexp_eatUnicodePropertyValueExpression(state) &&
        state.eat(0x7D /* } */)
      ) {
        return true
      }
      state.raise("Invalid property name");
    }

    return false
  };
  function isCharacterClassEscape(ch) {
    return (
      ch === 0x64 /* d */ ||
      ch === 0x44 /* D */ ||
      ch === 0x73 /* s */ ||
      ch === 0x53 /* S */ ||
      ch === 0x77 /* w */ ||
      ch === 0x57 /* W */
    )
  }

  // UnicodePropertyValueExpression ::
  //   UnicodePropertyName `=` UnicodePropertyValue
  //   LoneUnicodePropertyNameOrValue
  pp$1.regexp_eatUnicodePropertyValueExpression = function(state) {
    var start = state.pos;

    // UnicodePropertyName `=` UnicodePropertyValue
    if (this.regexp_eatUnicodePropertyName(state) && state.eat(0x3D /* = */)) {
      var name = state.lastStringValue;
      if (this.regexp_eatUnicodePropertyValue(state)) {
        var value = state.lastStringValue;
        this.regexp_validateUnicodePropertyNameAndValue(state, name, value);
        return true
      }
    }
    state.pos = start;

    // LoneUnicodePropertyNameOrValue
    if (this.regexp_eatLoneUnicodePropertyNameOrValue(state)) {
      var nameOrValue = state.lastStringValue;
      this.regexp_validateUnicodePropertyNameOrValue(state, nameOrValue);
      return true
    }
    return false
  };
  pp$1.regexp_validateUnicodePropertyNameAndValue = function(state, name, value) {
    if (!hasOwn(state.unicodeProperties.nonBinary, name))
      { state.raise("Invalid property name"); }
    if (!state.unicodeProperties.nonBinary[name].test(value))
      { state.raise("Invalid property value"); }
  };
  pp$1.regexp_validateUnicodePropertyNameOrValue = function(state, nameOrValue) {
    if (!state.unicodeProperties.binary.test(nameOrValue))
      { state.raise("Invalid property name"); }
  };

  // UnicodePropertyName ::
  //   UnicodePropertyNameCharacters
  pp$1.regexp_eatUnicodePropertyName = function(state) {
    var ch = 0;
    state.lastStringValue = "";
    while (isUnicodePropertyNameCharacter(ch = state.current())) {
      state.lastStringValue += codePointToString(ch);
      state.advance();
    }
    return state.lastStringValue !== ""
  };
  function isUnicodePropertyNameCharacter(ch) {
    return isControlLetter(ch) || ch === 0x5F /* _ */
  }

  // UnicodePropertyValue ::
  //   UnicodePropertyValueCharacters
  pp$1.regexp_eatUnicodePropertyValue = function(state) {
    var ch = 0;
    state.lastStringValue = "";
    while (isUnicodePropertyValueCharacter(ch = state.current())) {
      state.lastStringValue += codePointToString(ch);
      state.advance();
    }
    return state.lastStringValue !== ""
  };
  function isUnicodePropertyValueCharacter(ch) {
    return isUnicodePropertyNameCharacter(ch) || isDecimalDigit(ch)
  }

  // LoneUnicodePropertyNameOrValue ::
  //   UnicodePropertyValueCharacters
  pp$1.regexp_eatLoneUnicodePropertyNameOrValue = function(state) {
    return this.regexp_eatUnicodePropertyValue(state)
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-CharacterClass
  pp$1.regexp_eatCharacterClass = function(state) {
    if (state.eat(0x5B /* [ */)) {
      state.eat(0x5E /* ^ */);
      this.regexp_classRanges(state);
      if (state.eat(0x5D /* ] */)) {
        return true
      }
      // Unreachable since it threw "unterminated regular expression" error before.
      state.raise("Unterminated character class");
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-ClassRanges
  // https://www.ecma-international.org/ecma-262/8.0/#prod-NonemptyClassRanges
  // https://www.ecma-international.org/ecma-262/8.0/#prod-NonemptyClassRangesNoDash
  pp$1.regexp_classRanges = function(state) {
    while (this.regexp_eatClassAtom(state)) {
      var left = state.lastIntValue;
      if (state.eat(0x2D /* - */) && this.regexp_eatClassAtom(state)) {
        var right = state.lastIntValue;
        if (state.switchU && (left === -1 || right === -1)) {
          state.raise("Invalid character class");
        }
        if (left !== -1 && right !== -1 && left > right) {
          state.raise("Range out of order in character class");
        }
      }
    }
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-ClassAtom
  // https://www.ecma-international.org/ecma-262/8.0/#prod-ClassAtomNoDash
  pp$1.regexp_eatClassAtom = function(state) {
    var start = state.pos;

    if (state.eat(0x5C /* \ */)) {
      if (this.regexp_eatClassEscape(state)) {
        return true
      }
      if (state.switchU) {
        // Make the same message as V8.
        var ch$1 = state.current();
        if (ch$1 === 0x63 /* c */ || isOctalDigit(ch$1)) {
          state.raise("Invalid class escape");
        }
        state.raise("Invalid escape");
      }
      state.pos = start;
    }

    var ch = state.current();
    if (ch !== 0x5D /* ] */) {
      state.lastIntValue = ch;
      state.advance();
      return true
    }

    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ClassEscape
  pp$1.regexp_eatClassEscape = function(state) {
    var start = state.pos;

    if (state.eat(0x62 /* b */)) {
      state.lastIntValue = 0x08; /* <BS> */
      return true
    }

    if (state.switchU && state.eat(0x2D /* - */)) {
      state.lastIntValue = 0x2D; /* - */
      return true
    }

    if (!state.switchU && state.eat(0x63 /* c */)) {
      if (this.regexp_eatClassControlLetter(state)) {
        return true
      }
      state.pos = start;
    }

    return (
      this.regexp_eatCharacterClassEscape(state) ||
      this.regexp_eatCharacterEscape(state)
    )
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-ClassControlLetter
  pp$1.regexp_eatClassControlLetter = function(state) {
    var ch = state.current();
    if (isDecimalDigit(ch) || ch === 0x5F /* _ */) {
      state.lastIntValue = ch % 0x20;
      state.advance();
      return true
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-HexEscapeSequence
  pp$1.regexp_eatHexEscapeSequence = function(state) {
    var start = state.pos;
    if (state.eat(0x78 /* x */)) {
      if (this.regexp_eatFixedHexDigits(state, 2)) {
        return true
      }
      if (state.switchU) {
        state.raise("Invalid escape");
      }
      state.pos = start;
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-DecimalDigits
  pp$1.regexp_eatDecimalDigits = function(state) {
    var start = state.pos;
    var ch = 0;
    state.lastIntValue = 0;
    while (isDecimalDigit(ch = state.current())) {
      state.lastIntValue = 10 * state.lastIntValue + (ch - 0x30 /* 0 */);
      state.advance();
    }
    return state.pos !== start
  };
  function isDecimalDigit(ch) {
    return ch >= 0x30 /* 0 */ && ch <= 0x39 /* 9 */
  }

  // https://www.ecma-international.org/ecma-262/8.0/#prod-HexDigits
  pp$1.regexp_eatHexDigits = function(state) {
    var start = state.pos;
    var ch = 0;
    state.lastIntValue = 0;
    while (isHexDigit(ch = state.current())) {
      state.lastIntValue = 16 * state.lastIntValue + hexToInt(ch);
      state.advance();
    }
    return state.pos !== start
  };
  function isHexDigit(ch) {
    return (
      (ch >= 0x30 /* 0 */ && ch <= 0x39 /* 9 */) ||
      (ch >= 0x41 /* A */ && ch <= 0x46 /* F */) ||
      (ch >= 0x61 /* a */ && ch <= 0x66 /* f */)
    )
  }
  function hexToInt(ch) {
    if (ch >= 0x41 /* A */ && ch <= 0x46 /* F */) {
      return 10 + (ch - 0x41 /* A */)
    }
    if (ch >= 0x61 /* a */ && ch <= 0x66 /* f */) {
      return 10 + (ch - 0x61 /* a */)
    }
    return ch - 0x30 /* 0 */
  }

  // https://www.ecma-international.org/ecma-262/8.0/#prod-annexB-LegacyOctalEscapeSequence
  // Allows only 0-377(octal) i.e. 0-255(decimal).
  pp$1.regexp_eatLegacyOctalEscapeSequence = function(state) {
    if (this.regexp_eatOctalDigit(state)) {
      var n1 = state.lastIntValue;
      if (this.regexp_eatOctalDigit(state)) {
        var n2 = state.lastIntValue;
        if (n1 <= 3 && this.regexp_eatOctalDigit(state)) {
          state.lastIntValue = n1 * 64 + n2 * 8 + state.lastIntValue;
        } else {
          state.lastIntValue = n1 * 8 + n2;
        }
      } else {
        state.lastIntValue = n1;
      }
      return true
    }
    return false
  };

  // https://www.ecma-international.org/ecma-262/8.0/#prod-OctalDigit
  pp$1.regexp_eatOctalDigit = function(state) {
    var ch = state.current();
    if (isOctalDigit(ch)) {
      state.lastIntValue = ch - 0x30; /* 0 */
      state.advance();
      return true
    }
    state.lastIntValue = 0;
    return false
  };
  function isOctalDigit(ch) {
    return ch >= 0x30 /* 0 */ && ch <= 0x37 /* 7 */
  }

  // https://www.ecma-international.org/ecma-262/8.0/#prod-Hex4Digits
  // https://www.ecma-international.org/ecma-262/8.0/#prod-HexDigit
  // And HexDigit HexDigit in https://www.ecma-international.org/ecma-262/8.0/#prod-HexEscapeSequence
  pp$1.regexp_eatFixedHexDigits = function(state, length) {
    var start = state.pos;
    state.lastIntValue = 0;
    for (var i = 0; i < length; ++i) {
      var ch = state.current();
      if (!isHexDigit(ch)) {
        state.pos = start;
        return false
      }
      state.lastIntValue = 16 * state.lastIntValue + hexToInt(ch);
      state.advance();
    }
    return true
  };

  // Object type used to represent tokens. Note that normally, tokens
  // simply exist as properties on the parser object. This is only
  // used for the onToken callback and the external tokenizer.

  var Token = function Token(p) {
    this.type = p.type;
    this.value = p.value;
    this.start = p.start;
    this.end = p.end;
    if (p.options.locations)
      { this.loc = new SourceLocation(p, p.startLoc, p.endLoc); }
    if (p.options.ranges)
      { this.range = [p.start, p.end]; }
  };

  // ## Tokenizer

  var pp = Parser.prototype;

  // Move to the next token

  pp.next = function(ignoreEscapeSequenceInKeyword) {
    if (!ignoreEscapeSequenceInKeyword && this.type.keyword && this.containsEsc)
      { this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword); }
    if (this.options.onToken)
      { this.options.onToken(new Token(this)); }

    this.lastTokEnd = this.end;
    this.lastTokStart = this.start;
    this.lastTokEndLoc = this.endLoc;
    this.lastTokStartLoc = this.startLoc;
    this.nextToken();
  };

  pp.getToken = function() {
    this.next();
    return new Token(this)
  };

  // If we're in an ES6 environment, make parsers iterable
  if (typeof Symbol !== "undefined")
    { pp[Symbol.iterator] = function() {
      var this$1$1 = this;

      return {
        next: function () {
          var token = this$1$1.getToken();
          return {
            done: token.type === types$1.eof,
            value: token
          }
        }
      }
    }; }

  // Toggle strict mode. Re-reads the next number or string to please
  // pedantic tests (`"use strict"; 010;` should fail).

  // Read a single token, updating the parser object's token-related
  // properties.

  pp.nextToken = function() {
    var curContext = this.curContext();
    if (!curContext || !curContext.preserveSpace) { this.skipSpace(); }

    this.start = this.pos;
    if (this.options.locations) { this.startLoc = this.curPosition(); }
    if (this.pos >= this.input.length) { return this.finishToken(types$1.eof) }

    if (curContext.override) { return curContext.override(this) }
    else { this.readToken(this.fullCharCodeAtPos()); }
  };

  pp.readToken = function(code) {
    // Identifier or keyword. '\uXXXX' sequences are allowed in
    // identifiers, so '\' also dispatches to that.
    if (isIdentifierStart(code, this.options.ecmaVersion >= 6) || code === 92 /* '\' */)
      { return this.readWord() }

    return this.getTokenFromCode(code)
  };

  pp.fullCharCodeAtPos = function() {
    var code = this.input.charCodeAt(this.pos);
    if (code <= 0xd7ff || code >= 0xdc00) { return code }
    var next = this.input.charCodeAt(this.pos + 1);
    return next <= 0xdbff || next >= 0xe000 ? code : (code << 10) + next - 0x35fdc00
  };

  pp.skipBlockComment = function() {
    var startLoc = this.options.onComment && this.curPosition();
    var start = this.pos, end = this.input.indexOf("*/", this.pos += 2);
    if (end === -1) { this.raise(this.pos - 2, "Unterminated comment"); }
    this.pos = end + 2;
    if (this.options.locations) {
      for (var nextBreak = (void 0), pos = start; (nextBreak = nextLineBreak(this.input, pos, this.pos)) > -1;) {
        ++this.curLine;
        pos = this.lineStart = nextBreak;
      }
    }
    if (this.options.onComment)
      { this.options.onComment(true, this.input.slice(start + 2, end), start, this.pos,
                             startLoc, this.curPosition()); }
  };

  pp.skipLineComment = function(startSkip) {
    var start = this.pos;
    var startLoc = this.options.onComment && this.curPosition();
    var ch = this.input.charCodeAt(this.pos += startSkip);
    while (this.pos < this.input.length && !isNewLine(ch)) {
      ch = this.input.charCodeAt(++this.pos);
    }
    if (this.options.onComment)
      { this.options.onComment(false, this.input.slice(start + startSkip, this.pos), start, this.pos,
                             startLoc, this.curPosition()); }
  };

  // Called at the start of the parse and after every token. Skips
  // whitespace and comments, and.

  pp.skipSpace = function() {
    loop: while (this.pos < this.input.length) {
      var ch = this.input.charCodeAt(this.pos);
      switch (ch) {
      case 32: case 160: // ' '
        ++this.pos;
        break
      case 13:
        if (this.input.charCodeAt(this.pos + 1) === 10) {
          ++this.pos;
        }
      case 10: case 8232: case 8233:
        ++this.pos;
        if (this.options.locations) {
          ++this.curLine;
          this.lineStart = this.pos;
        }
        break
      case 47: // '/'
        switch (this.input.charCodeAt(this.pos + 1)) {
        case 42: // '*'
          this.skipBlockComment();
          break
        case 47:
          this.skipLineComment(2);
          break
        default:
          break loop
        }
        break
      default:
        if (ch > 8 && ch < 14 || ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) {
          ++this.pos;
        } else {
          break loop
        }
      }
    }
  };

  // Called at the end of every token. Sets `end`, `val`, and
  // maintains `context` and `exprAllowed`, and skips the space after
  // the token, so that the next one's `start` will point at the
  // right position.

  pp.finishToken = function(type, val) {
    this.end = this.pos;
    if (this.options.locations) { this.endLoc = this.curPosition(); }
    var prevType = this.type;
    this.type = type;
    this.value = val;

    this.updateContext(prevType);
  };

  // ### Token reading

  // This is the function that is called to fetch the next token. It
  // is somewhat obscure, because it works in character codes rather
  // than characters, and because operator parsing has been inlined
  // into it.
  //
  // All in the name of speed.
  //
  pp.readToken_dot = function() {
    var next = this.input.charCodeAt(this.pos + 1);
    if (next >= 48 && next <= 57) { return this.readNumber(true) }
    var next2 = this.input.charCodeAt(this.pos + 2);
    if (this.options.ecmaVersion >= 6 && next === 46 && next2 === 46) { // 46 = dot '.'
      this.pos += 3;
      return this.finishToken(types$1.ellipsis)
    } else {
      ++this.pos;
      return this.finishToken(types$1.dot)
    }
  };

  pp.readToken_slash = function() { // '/'
    var next = this.input.charCodeAt(this.pos + 1);
    if (this.exprAllowed) { ++this.pos; return this.readRegexp() }
    if (next === 61) { return this.finishOp(types$1.assign, 2) }
    return this.finishOp(types$1.slash, 1)
  };

  pp.readToken_mult_modulo_exp = function(code) { // '%*'
    var next = this.input.charCodeAt(this.pos + 1);
    var size = 1;
    var tokentype = code === 42 ? types$1.star : types$1.modulo;

    // exponentiation operator ** and **=
    if (this.options.ecmaVersion >= 7 && code === 42 && next === 42) {
      ++size;
      tokentype = types$1.starstar;
      next = this.input.charCodeAt(this.pos + 2);
    }

    if (next === 61) { return this.finishOp(types$1.assign, size + 1) }
    return this.finishOp(tokentype, size)
  };

  pp.readToken_pipe_amp = function(code) { // '|&'
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === code) {
      if (this.options.ecmaVersion >= 12) {
        var next2 = this.input.charCodeAt(this.pos + 2);
        if (next2 === 61) { return this.finishOp(types$1.assign, 3) }
      }
      return this.finishOp(code === 124 ? types$1.logicalOR : types$1.logicalAND, 2)
    }
    if (next === 61) { return this.finishOp(types$1.assign, 2) }
    return this.finishOp(code === 124 ? types$1.bitwiseOR : types$1.bitwiseAND, 1)
  };

  pp.readToken_caret = function() { // '^'
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === 61) { return this.finishOp(types$1.assign, 2) }
    return this.finishOp(types$1.bitwiseXOR, 1)
  };

  pp.readToken_plus_min = function(code) { // '+-'
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === code) {
      if (next === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 &&
          (this.lastTokEnd === 0 || lineBreak.test(this.input.slice(this.lastTokEnd, this.pos)))) {
        // A `-->` line comment
        this.skipLineComment(3);
        this.skipSpace();
        return this.nextToken()
      }
      return this.finishOp(types$1.incDec, 2)
    }
    if (next === 61) { return this.finishOp(types$1.assign, 2) }
    return this.finishOp(types$1.plusMin, 1)
  };

  pp.readToken_lt_gt = function(code) { // '<>'
    var next = this.input.charCodeAt(this.pos + 1);
    var size = 1;
    if (next === code) {
      size = code === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2;
      if (this.input.charCodeAt(this.pos + size) === 61) { return this.finishOp(types$1.assign, size + 1) }
      return this.finishOp(types$1.bitShift, size)
    }
    if (next === 33 && code === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 &&
        this.input.charCodeAt(this.pos + 3) === 45) {
      // `<!--`, an XML-style comment that should be interpreted as a line comment
      this.skipLineComment(4);
      this.skipSpace();
      return this.nextToken()
    }
    if (next === 61) { size = 2; }
    return this.finishOp(types$1.relational, size)
  };

  pp.readToken_eq_excl = function(code) { // '=!'
    var next = this.input.charCodeAt(this.pos + 1);
    if (next === 61) { return this.finishOp(types$1.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) }
    if (code === 61 && next === 62 && this.options.ecmaVersion >= 6) { // '=>'
      this.pos += 2;
      return this.finishToken(types$1.arrow)
    }
    return this.finishOp(code === 61 ? types$1.eq : types$1.prefix, 1)
  };

  pp.readToken_question = function() { // '?'
    var ecmaVersion = this.options.ecmaVersion;
    if (ecmaVersion >= 11) {
      var next = this.input.charCodeAt(this.pos + 1);
      if (next === 46) {
        var next2 = this.input.charCodeAt(this.pos + 2);
        if (next2 < 48 || next2 > 57) { return this.finishOp(types$1.questionDot, 2) }
      }
      if (next === 63) {
        if (ecmaVersion >= 12) {
          var next2$1 = this.input.charCodeAt(this.pos + 2);
          if (next2$1 === 61) { return this.finishOp(types$1.assign, 3) }
        }
        return this.finishOp(types$1.coalesce, 2)
      }
    }
    return this.finishOp(types$1.question, 1)
  };

  pp.readToken_numberSign = function() { // '#'
    var ecmaVersion = this.options.ecmaVersion;
    var code = 35; // '#'
    if (ecmaVersion >= 13) {
      ++this.pos;
      code = this.fullCharCodeAtPos();
      if (isIdentifierStart(code, true) || code === 92 /* '\' */) {
        return this.finishToken(types$1.privateId, this.readWord1())
      }
    }

    this.raise(this.pos, "Unexpected character '" + codePointToString(code) + "'");
  };

  pp.getTokenFromCode = function(code) {
    switch (code) {
    // The interpretation of a dot depends on whether it is followed
    // by a digit or another two dots.
    case 46: // '.'
      return this.readToken_dot()

    // Punctuation tokens.
    case 40: ++this.pos; return this.finishToken(types$1.parenL)
    case 41: ++this.pos; return this.finishToken(types$1.parenR)
    case 59: ++this.pos; return this.finishToken(types$1.semi)
    case 44: ++this.pos; return this.finishToken(types$1.comma)
    case 91: ++this.pos; return this.finishToken(types$1.bracketL)
    case 93: ++this.pos; return this.finishToken(types$1.bracketR)
    case 123: ++this.pos; return this.finishToken(types$1.braceL)
    case 125: ++this.pos; return this.finishToken(types$1.braceR)
    case 58: ++this.pos; return this.finishToken(types$1.colon)

    case 96: // '`'
      if (this.options.ecmaVersion < 6) { break }
      ++this.pos;
      return this.finishToken(types$1.backQuote)

    case 48: // '0'
      var next = this.input.charCodeAt(this.pos + 1);
      if (next === 120 || next === 88) { return this.readRadixNumber(16) } // '0x', '0X' - hex number
      if (this.options.ecmaVersion >= 6) {
        if (next === 111 || next === 79) { return this.readRadixNumber(8) } // '0o', '0O' - octal number
        if (next === 98 || next === 66) { return this.readRadixNumber(2) } // '0b', '0B' - binary number
      }

    // Anything else beginning with a digit is an integer, octal
    // number, or float.
    case 49: case 50: case 51: case 52: case 53: case 54: case 55: case 56: case 57: // 1-9
      return this.readNumber(false)

    // Quotes produce strings.
    case 34: case 39: // '"', "'"
      return this.readString(code)

    // Operators are parsed inline in tiny state machines. '=' (61) is
    // often referred to. `finishOp` simply skips the amount of
    // characters it is given as second argument, and returns a token
    // of the type given by its first argument.
    case 47: // '/'
      return this.readToken_slash()

    case 37: case 42: // '%*'
      return this.readToken_mult_modulo_exp(code)

    case 124: case 38: // '|&'
      return this.readToken_pipe_amp(code)

    case 94: // '^'
      return this.readToken_caret()

    case 43: case 45: // '+-'
      return this.readToken_plus_min(code)

    case 60: case 62: // '<>'
      return this.readToken_lt_gt(code)

    case 61: case 33: // '=!'
      return this.readToken_eq_excl(code)

    case 63: // '?'
      return this.readToken_question()

    case 126: // '~'
      return this.finishOp(types$1.prefix, 1)

    case 35: // '#'
      return this.readToken_numberSign()
    }

    this.raise(this.pos, "Unexpected character '" + codePointToString(code) + "'");
  };

  pp.finishOp = function(type, size) {
    var str = this.input.slice(this.pos, this.pos + size);
    this.pos += size;
    return this.finishToken(type, str)
  };

  pp.readRegexp = function() {
    var escaped, inClass, start = this.pos;
    for (;;) {
      if (this.pos >= this.input.length) { this.raise(start, "Unterminated regular expression"); }
      var ch = this.input.charAt(this.pos);
      if (lineBreak.test(ch)) { this.raise(start, "Unterminated regular expression"); }
      if (!escaped) {
        if (ch === "[") { inClass = true; }
        else if (ch === "]" && inClass) { inClass = false; }
        else if (ch === "/" && !inClass) { break }
        escaped = ch === "\\";
      } else { escaped = false; }
      ++this.pos;
    }
    var pattern = this.input.slice(start, this.pos);
    ++this.pos;
    var flagsStart = this.pos;
    var flags = this.readWord1();
    if (this.containsEsc) { this.unexpected(flagsStart); }

    // Validate pattern
    var state = this.regexpState || (this.regexpState = new RegExpValidationState(this));
    state.reset(start, pattern, flags);
    this.validateRegExpFlags(state);
    this.validateRegExpPattern(state);

    // Create Literal#value property value.
    var value = null;
    try {
      value = new RegExp(pattern, flags);
    } catch (e) {
      // ESTree requires null if it failed to instantiate RegExp object.
      // https://github.com/estree/estree/blob/a27003adf4fd7bfad44de9cef372a2eacd527b1c/es5.md#regexpliteral
    }

    return this.finishToken(types$1.regexp, {pattern: pattern, flags: flags, value: value})
  };

  // Read an integer in the given radix. Return null if zero digits
  // were read, the integer value otherwise. When `len` is given, this
  // will return `null` unless the integer has exactly `len` digits.

  pp.readInt = function(radix, len, maybeLegacyOctalNumericLiteral) {
    // `len` is used for character escape sequences. In that case, disallow separators.
    var allowSeparators = this.options.ecmaVersion >= 12 && len === undefined;

    // `maybeLegacyOctalNumericLiteral` is true if it doesn't have prefix (0x,0o,0b)
    // and isn't fraction part nor exponent part. In that case, if the first digit
    // is zero then disallow separators.
    var isLegacyOctalNumericLiteral = maybeLegacyOctalNumericLiteral && this.input.charCodeAt(this.pos) === 48;

    var start = this.pos, total = 0, lastCode = 0;
    for (var i = 0, e = len == null ? Infinity : len; i < e; ++i, ++this.pos) {
      var code = this.input.charCodeAt(this.pos), val = (void 0);

      if (allowSeparators && code === 95) {
        if (isLegacyOctalNumericLiteral) { this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"); }
        if (lastCode === 95) { this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"); }
        if (i === 0) { this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"); }
        lastCode = code;
        continue
      }

      if (code >= 97) { val = code - 97 + 10; } // a
      else if (code >= 65) { val = code - 65 + 10; } // A
      else if (code >= 48 && code <= 57) { val = code - 48; } // 0-9
      else { val = Infinity; }
      if (val >= radix) { break }
      lastCode = code;
      total = total * radix + val;
    }

    if (allowSeparators && lastCode === 95) { this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"); }
    if (this.pos === start || len != null && this.pos - start !== len) { return null }

    return total
  };

  function stringToNumber(str, isLegacyOctalNumericLiteral) {
    if (isLegacyOctalNumericLiteral) {
      return parseInt(str, 8)
    }

    // `parseFloat(value)` stops parsing at the first numeric separator then returns a wrong value.
    return parseFloat(str.replace(/_/g, ""))
  }

  function stringToBigInt(str) {
    if (typeof BigInt !== "function") {
      return null
    }

    // `BigInt(value)` throws syntax error if the string contains numeric separators.
    return BigInt(str.replace(/_/g, ""))
  }

  pp.readRadixNumber = function(radix) {
    var start = this.pos;
    this.pos += 2; // 0x
    var val = this.readInt(radix);
    if (val == null) { this.raise(this.start + 2, "Expected number in radix " + radix); }
    if (this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110) {
      val = stringToBigInt(this.input.slice(start, this.pos));
      ++this.pos;
    } else if (isIdentifierStart(this.fullCharCodeAtPos())) { this.raise(this.pos, "Identifier directly after number"); }
    return this.finishToken(types$1.num, val)
  };

  // Read an integer, octal integer, or floating-point number.

  pp.readNumber = function(startsWithDot) {
    var start = this.pos;
    if (!startsWithDot && this.readInt(10, undefined, true) === null) { this.raise(start, "Invalid number"); }
    var octal = this.pos - start >= 2 && this.input.charCodeAt(start) === 48;
    if (octal && this.strict) { this.raise(start, "Invalid number"); }
    var next = this.input.charCodeAt(this.pos);
    if (!octal && !startsWithDot && this.options.ecmaVersion >= 11 && next === 110) {
      var val$1 = stringToBigInt(this.input.slice(start, this.pos));
      ++this.pos;
      if (isIdentifierStart(this.fullCharCodeAtPos())) { this.raise(this.pos, "Identifier directly after number"); }
      return this.finishToken(types$1.num, val$1)
    }
    if (octal && /[89]/.test(this.input.slice(start, this.pos))) { octal = false; }
    if (next === 46 && !octal) { // '.'
      ++this.pos;
      this.readInt(10);
      next = this.input.charCodeAt(this.pos);
    }
    if ((next === 69 || next === 101) && !octal) { // 'eE'
      next = this.input.charCodeAt(++this.pos);
      if (next === 43 || next === 45) { ++this.pos; } // '+-'
      if (this.readInt(10) === null) { this.raise(start, "Invalid number"); }
    }
    if (isIdentifierStart(this.fullCharCodeAtPos())) { this.raise(this.pos, "Identifier directly after number"); }

    var val = stringToNumber(this.input.slice(start, this.pos), octal);
    return this.finishToken(types$1.num, val)
  };

  // Read a string value, interpreting backslash-escapes.

  pp.readCodePoint = function() {
    var ch = this.input.charCodeAt(this.pos), code;

    if (ch === 123) { // '{'
      if (this.options.ecmaVersion < 6) { this.unexpected(); }
      var codePos = ++this.pos;
      code = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos);
      ++this.pos;
      if (code > 0x10FFFF) { this.invalidStringToken(codePos, "Code point out of bounds"); }
    } else {
      code = this.readHexChar(4);
    }
    return code
  };

  pp.readString = function(quote) {
    var out = "", chunkStart = ++this.pos;
    for (;;) {
      if (this.pos >= this.input.length) { this.raise(this.start, "Unterminated string constant"); }
      var ch = this.input.charCodeAt(this.pos);
      if (ch === quote) { break }
      if (ch === 92) { // '\'
        out += this.input.slice(chunkStart, this.pos);
        out += this.readEscapedChar(false);
        chunkStart = this.pos;
      } else if (ch === 0x2028 || ch === 0x2029) {
        if (this.options.ecmaVersion < 10) { this.raise(this.start, "Unterminated string constant"); }
        ++this.pos;
        if (this.options.locations) {
          this.curLine++;
          this.lineStart = this.pos;
        }
      } else {
        if (isNewLine(ch)) { this.raise(this.start, "Unterminated string constant"); }
        ++this.pos;
      }
    }
    out += this.input.slice(chunkStart, this.pos++);
    return this.finishToken(types$1.string, out)
  };

  // Reads template string tokens.

  var INVALID_TEMPLATE_ESCAPE_ERROR = {};

  pp.tryReadTemplateToken = function() {
    this.inTemplateElement = true;
    try {
      this.readTmplToken();
    } catch (err) {
      if (err === INVALID_TEMPLATE_ESCAPE_ERROR) {
        this.readInvalidTemplateToken();
      } else {
        throw err
      }
    }

    this.inTemplateElement = false;
  };

  pp.invalidStringToken = function(position, message) {
    if (this.inTemplateElement && this.options.ecmaVersion >= 9) {
      throw INVALID_TEMPLATE_ESCAPE_ERROR
    } else {
      this.raise(position, message);
    }
  };

  pp.readTmplToken = function() {
    var out = "", chunkStart = this.pos;
    for (;;) {
      if (this.pos >= this.input.length) { this.raise(this.start, "Unterminated template"); }
      var ch = this.input.charCodeAt(this.pos);
      if (ch === 96 || ch === 36 && this.input.charCodeAt(this.pos + 1) === 123) { // '`', '${'
        if (this.pos === this.start && (this.type === types$1.template || this.type === types$1.invalidTemplate)) {
          if (ch === 36) {
            this.pos += 2;
            return this.finishToken(types$1.dollarBraceL)
          } else {
            ++this.pos;
            return this.finishToken(types$1.backQuote)
          }
        }
        out += this.input.slice(chunkStart, this.pos);
        return this.finishToken(types$1.template, out)
      }
      if (ch === 92) { // '\'
        out += this.input.slice(chunkStart, this.pos);
        out += this.readEscapedChar(true);
        chunkStart = this.pos;
      } else if (isNewLine(ch)) {
        out += this.input.slice(chunkStart, this.pos);
        ++this.pos;
        switch (ch) {
        case 13:
          if (this.input.charCodeAt(this.pos) === 10) { ++this.pos; }
        case 10:
          out += "\n";
          break
        default:
          out += String.fromCharCode(ch);
          break
        }
        if (this.options.locations) {
          ++this.curLine;
          this.lineStart = this.pos;
        }
        chunkStart = this.pos;
      } else {
        ++this.pos;
      }
    }
  };

  // Reads a template token to search for the end, without validating any escape sequences
  pp.readInvalidTemplateToken = function() {
    for (; this.pos < this.input.length; this.pos++) {
      switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break

      case "$":
        if (this.input[this.pos + 1] !== "{") {
          break
        }

      // falls through
      case "`":
        return this.finishToken(types$1.invalidTemplate, this.input.slice(this.start, this.pos))

      // no default
      }
    }
    this.raise(this.start, "Unterminated template");
  };

  // Used to read escaped characters

  pp.readEscapedChar = function(inTemplate) {
    var ch = this.input.charCodeAt(++this.pos);
    ++this.pos;
    switch (ch) {
    case 110: return "\n" // 'n' -> '\n'
    case 114: return "\r" // 'r' -> '\r'
    case 120: return String.fromCharCode(this.readHexChar(2)) // 'x'
    case 117: return codePointToString(this.readCodePoint()) // 'u'
    case 116: return "\t" // 't' -> '\t'
    case 98: return "\b" // 'b' -> '\b'
    case 118: return "\u000b" // 'v' -> '\u000b'
    case 102: return "\f" // 'f' -> '\f'
    case 13: if (this.input.charCodeAt(this.pos) === 10) { ++this.pos; } // '\r\n'
    case 10: // ' \n'
      if (this.options.locations) { this.lineStart = this.pos; ++this.curLine; }
      return ""
    case 56:
    case 57:
      if (this.strict) {
        this.invalidStringToken(
          this.pos - 1,
          "Invalid escape sequence"
        );
      }
      if (inTemplate) {
        var codePos = this.pos - 1;

        this.invalidStringToken(
          codePos,
          "Invalid escape sequence in template string"
        );
      }
    default:
      if (ch >= 48 && ch <= 55) {
        var octalStr = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0];
        var octal = parseInt(octalStr, 8);
        if (octal > 255) {
          octalStr = octalStr.slice(0, -1);
          octal = parseInt(octalStr, 8);
        }
        this.pos += octalStr.length - 1;
        ch = this.input.charCodeAt(this.pos);
        if ((octalStr !== "0" || ch === 56 || ch === 57) && (this.strict || inTemplate)) {
          this.invalidStringToken(
            this.pos - 1 - octalStr.length,
            inTemplate
              ? "Octal literal in template string"
              : "Octal literal in strict mode"
          );
        }
        return String.fromCharCode(octal)
      }
      if (isNewLine(ch)) {
        // Unicode new line characters after \ get removed from output in both
        // template literals and strings
        return ""
      }
      return String.fromCharCode(ch)
    }
  };

  // Used to read character escape sequences ('\x', '\u', '\U').

  pp.readHexChar = function(len) {
    var codePos = this.pos;
    var n = this.readInt(16, len);
    if (n === null) { this.invalidStringToken(codePos, "Bad character escape sequence"); }
    return n
  };

  // Read an identifier, and return it as a string. Sets `this.containsEsc`
  // to whether the word contained a '\u' escape.
  //
  // Incrementally adds only escaped chars, adding other chunks as-is
  // as a micro-optimization.

  pp.readWord1 = function() {
    this.containsEsc = false;
    var word = "", first = true, chunkStart = this.pos;
    var astral = this.options.ecmaVersion >= 6;
    while (this.pos < this.input.length) {
      var ch = this.fullCharCodeAtPos();
      if (isIdentifierChar(ch, astral)) {
        this.pos += ch <= 0xffff ? 1 : 2;
      } else if (ch === 92) { // "\"
        this.containsEsc = true;
        word += this.input.slice(chunkStart, this.pos);
        var escStart = this.pos;
        if (this.input.charCodeAt(++this.pos) !== 117) // "u"
          { this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"); }
        ++this.pos;
        var esc = this.readCodePoint();
        if (!(first ? isIdentifierStart : isIdentifierChar)(esc, astral))
          { this.invalidStringToken(escStart, "Invalid Unicode escape"); }
        word += codePointToString(esc);
        chunkStart = this.pos;
      } else {
        break
      }
      first = false;
    }
    return word + this.input.slice(chunkStart, this.pos)
  };

  // Read an identifier or keyword token. Will check for reserved
  // words when necessary.

  pp.readWord = function() {
    var word = this.readWord1();
    var type = types$1.name;
    if (this.keywords.test(word)) {
      type = keywords[word];
    }
    return this.finishToken(type, word)
  };

  // Acorn is a tiny, fast JavaScript parser written in JavaScript.

  var version = "8.8.2";

  Parser.acorn = {
    Parser: Parser,
    version: version,
    defaultOptions: defaultOptions,
    Position: Position,
    SourceLocation: SourceLocation,
    getLineInfo: getLineInfo,
    Node: Node,
    TokenType: TokenType,
    tokTypes: types$1,
    keywordTypes: keywords,
    TokContext: TokContext,
    tokContexts: types,
    isIdentifierChar: isIdentifierChar,
    isIdentifierStart: isIdentifierStart,
    Token: Token,
    isNewLine: isNewLine,
    lineBreak: lineBreak,
    lineBreakG: lineBreakG,
    nonASCIIwhitespace: nonASCIIwhitespace
  };

  // The main exported interface (under `self.acorn` when in the
  // browser) is a `parse` function that takes a code string and
  // returns an abstract syntax tree as specified by [Mozilla parser
  // API][api].
  //
  // [api]: https://developer.mozilla.org/en-US/docs/SpiderMonkey/Parser_API

  function parse(input, options) {
    return Parser.parse(input, options)
  }

  // This function tries to parse a single expression at a given
  // offset in a string. Useful for parsing mixed-language formats
  // that embed JavaScript expressions.

  function parseExpressionAt(input, pos, options) {
    return Parser.parseExpressionAt(input, pos, options)
  }

  // Acorn is organized as a tokenizer and a recursive-descent parser.
  // The `tokenizer` export provides an interface to the tokenizer.

  function tokenizer(input, options) {
    return Parser.tokenizer(input, options)
  }

  exports.Node = Node;
  exports.Parser = Parser;
  exports.Position = Position;
  exports.SourceLocation = SourceLocation;
  exports.TokContext = TokContext;
  exports.Token = Token;
  exports.TokenType = TokenType;
  exports.defaultOptions = defaultOptions;
  exports.getLineInfo = getLineInfo;
  exports.isIdentifierChar = isIdentifierChar;
  exports.isIdentifierStart = isIdentifierStart;
  exports.isNewLine = isNewLine;
  exports.keywordTypes = keywords;
  exports.lineBreak = lineBreak;
  exports.lineBreakG = lineBreakG;
  exports.nonASCIIwhitespace = nonASCIIwhitespace;
  exports.parse = parse;
  exports.parseExpressionAt = parseExpressionAt;
  exports.tokContexts = types;
  exports.tokTypes = types$1;
  exports.tokenizer = tokenizer;
  exports.version = version;

}));


/***/ }),

/***/ "../../../node_modules/axios/index.js":
/*!********************************************!*\
  !*** ../../../node_modules/axios/index.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(/*! ./lib/axios */ "../../../node_modules/axios/lib/axios.js");

/***/ }),

/***/ "../../../node_modules/axios/lib/adapters/xhr.js":
/*!*******************************************************!*\
  !*** ../../../node_modules/axios/lib/adapters/xhr.js ***!
  \*******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");
var settle = __webpack_require__(/*! ./../core/settle */ "../../../node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__(/*! ./../helpers/buildURL */ "../../../node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__(/*! ./../helpers/parseHeaders */ "../../../node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__(/*! ./../helpers/isURLSameOrigin */ "../../../node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__(/*! ../core/createError */ "../../../node_modules/axios/lib/core/createError.js");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(/*! ./../helpers/cookies */ "../../../node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "../../../node_modules/axios/lib/axios.js":
/*!************************************************!*\
  !*** ../../../node_modules/axios/lib/axios.js ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "../../../node_modules/axios/lib/utils.js");
var bind = __webpack_require__(/*! ./helpers/bind */ "../../../node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__(/*! ./core/Axios */ "../../../node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__(/*! ./defaults */ "../../../node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(/*! ./cancel/Cancel */ "../../../node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__(/*! ./cancel/CancelToken */ "../../../node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__(/*! ./cancel/isCancel */ "../../../node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(/*! ./helpers/spread */ "../../../node_modules/axios/lib/helpers/spread.js");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ "../../../node_modules/axios/lib/cancel/Cancel.js":
/*!********************************************************!*\
  !*** ../../../node_modules/axios/lib/cancel/Cancel.js ***!
  \********************************************************/
/***/ ((module) => {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "../../../node_modules/axios/lib/cancel/CancelToken.js":
/*!*************************************************************!*\
  !*** ../../../node_modules/axios/lib/cancel/CancelToken.js ***!
  \*************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var Cancel = __webpack_require__(/*! ./Cancel */ "../../../node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "../../../node_modules/axios/lib/cancel/isCancel.js":
/*!**********************************************************!*\
  !*** ../../../node_modules/axios/lib/cancel/isCancel.js ***!
  \**********************************************************/
/***/ ((module) => {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "../../../node_modules/axios/lib/core/Axios.js":
/*!*****************************************************!*\
  !*** ../../../node_modules/axios/lib/core/Axios.js ***!
  \*****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var defaults = __webpack_require__(/*! ./../defaults */ "../../../node_modules/axios/lib/defaults.js");
var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__(/*! ./InterceptorManager */ "../../../node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__(/*! ./dispatchRequest */ "../../../node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "../../../node_modules/axios/lib/core/InterceptorManager.js":
/*!******************************************************************!*\
  !*** ../../../node_modules/axios/lib/core/InterceptorManager.js ***!
  \******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "../../../node_modules/axios/lib/core/createError.js":
/*!***********************************************************!*\
  !*** ../../../node_modules/axios/lib/core/createError.js ***!
  \***********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var enhanceError = __webpack_require__(/*! ./enhanceError */ "../../../node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "../../../node_modules/axios/lib/core/dispatchRequest.js":
/*!***************************************************************!*\
  !*** ../../../node_modules/axios/lib/core/dispatchRequest.js ***!
  \***************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");
var transformData = __webpack_require__(/*! ./transformData */ "../../../node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__(/*! ../cancel/isCancel */ "../../../node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__(/*! ../defaults */ "../../../node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__(/*! ./../helpers/isAbsoluteURL */ "../../../node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__(/*! ./../helpers/combineURLs */ "../../../node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "../../../node_modules/axios/lib/core/enhanceError.js":
/*!************************************************************!*\
  !*** ../../../node_modules/axios/lib/core/enhanceError.js ***!
  \************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "../../../node_modules/axios/lib/core/settle.js":
/*!******************************************************!*\
  !*** ../../../node_modules/axios/lib/core/settle.js ***!
  \******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var createError = __webpack_require__(/*! ./createError */ "../../../node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "../../../node_modules/axios/lib/core/transformData.js":
/*!*************************************************************!*\
  !*** ../../../node_modules/axios/lib/core/transformData.js ***!
  \*************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "../../../node_modules/axios/lib/defaults.js":
/*!***************************************************!*\
  !*** ../../../node_modules/axios/lib/defaults.js ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "../../../node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__(/*! ./helpers/normalizeHeaderName */ "../../../node_modules/axios/lib/helpers/normalizeHeaderName.js");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(/*! ./adapters/xhr */ "../../../node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(/*! ./adapters/http */ "../../../node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/bind.js":
/*!*******************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/bind.js ***!
  \*******************************************************/
/***/ ((module) => {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/buildURL.js":
/*!***********************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/buildURL.js ***!
  \***********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/combineURLs.js":
/*!**************************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/combineURLs.js ***!
  \**************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/cookies.js":
/*!**********************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/cookies.js ***!
  \**********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/isAbsoluteURL.js":
/*!****************************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \****************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/isURLSameOrigin.js":
/*!******************************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/normalizeHeaderName.js":
/*!**********************************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/normalizeHeaderName.js ***!
  \**********************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "../../../node_modules/axios/lib/utils.js");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/parseHeaders.js":
/*!***************************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/parseHeaders.js ***!
  \***************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/spread.js":
/*!*********************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/spread.js ***!
  \*********************************************************/
/***/ ((module) => {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "../../../node_modules/axios/lib/utils.js":
/*!************************************************!*\
  !*** ../../../node_modules/axios/lib/utils.js ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! ./helpers/bind */ "../../../node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__(/*! is-buffer */ "../../../node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "../../3D/src/Components/AR/AndroidAR.ts":
/*!***********************************************!*\
  !*** ../../3D/src/Components/AR/AndroidAR.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AndroidAR": () => (/* binding */ AndroidAR)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AndroidAR = /*#__PURE__*/function () {
  function AndroidAR() {
    _classCallCheck(this, AndroidAR);
  }
  _createClass(AndroidAR, null, [{
    key: "openSceneViewer",
    value: function openSceneViewer(gltfSrc, notifyUnsupportedAR) {
      var _this = this;
      var arScale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      // If the fallback has ever been invoked this session, bounce early:
      if (this._fallbackInvoked) {
        return;
      }
      var location = self.location.toString();
      var locationUrl = new URL(location);
      var modelUrl = new URL(gltfSrc);
      var params = new URLSearchParams(modelUrl.search);
      locationUrl.hash = this._noArViewerSigil;

      // modelUrl can contain title/link/sound etc.
      params.set('mode', 'ar_preferred');
      if (!params.has('disable_occlusion')) {
        params.set('disable_occlusion', 'true');
      }
      if (!arScale) {
        params.set('resizable', 'false');
      }
      if (params.has('sound')) {
        var soundUrl = new URL(params.get('sound'), location);
        params.set('sound', soundUrl.toString());
      }
      if (params.has('link')) {
        var linkUrl = new URL(params.get('link'), location);
        params.set('link', linkUrl.toString());
      }
      var intent = "intent://arvr.google.com/scene-viewer/1.0?".concat(params.toString() + '&file=' + encodeURIComponent(modelUrl.toString()), "#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=").concat(encodeURIComponent(locationUrl.toString()), ";end;");
      console.log(intent);
      var undoHashChange = function undoHashChange() {
        if (self.location.hash === _this._noArViewerSigil && !_this._fallbackInvoked) {
          _this._fallbackInvoked = true;
          if (notifyUnsupportedAR) notifyUnsupportedAR();

          // The new history will be the current URL with a new hash.
          // Go back one step so that we reset to the expected URL.
          // NOTE: this should not invoke any browser-level navigation
          // because hash-only changes modify the URL in-place without
          // navigating:
          self.history.back();
        }
      };
      self.addEventListener('hashchange', undoHashChange, {
        once: true
      });
      this._anchor.setAttribute('href', intent);
      this._anchor.setAttribute('target', '_blank');
      document.body.appendChild(this._anchor);
      this._anchor.click();
    }
  }]);
  return AndroidAR;
}();
_defineProperty(AndroidAR, "_anchor", document.createElement('a'));
_defineProperty(AndroidAR, "_linkOrTitle", /(link|title)(=|&)|(\?|&)(link|title)$/);
_defineProperty(AndroidAR, "_noArViewerSigil", '#model-viewer-no-ar-fallback');
_defineProperty(AndroidAR, "_fallbackInvoked", false);

/***/ }),

/***/ "../../3D/src/Components/ActionExecutor/SceneActionExecutor.ts":
/*!*********************************************************************!*\
  !*** ../../3D/src/Components/ActionExecutor/SceneActionExecutor.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SceneActionsExecutor": () => (/* binding */ SceneActionsExecutor)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
/* harmony import */ var _Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Selector/ElementSelector */ "../../3D/src/Components/Selector/ElementSelector.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


var SceneActionsExecutor = /*#__PURE__*/function () {
  function SceneActionsExecutor(zkScene, scene, zkModel) {
    _classCallCheck(this, SceneActionsExecutor);
    _defineProperty(this, "_zkModel", null);
    _defineProperty(this, "_sceneHelper", null);
    _defineProperty(this, "_deviceType", MPlaza.DeviceType.All);
    _defineProperty(this, "_meshDesignRefreshRequiredListeners", []);
    _defineProperty(this, "_beginAssetsLoadingListeners", []);
    _defineProperty(this, "_endAssetsLoadingListeners", []);
    _defineProperty(this, "_useMaterialOffloading", false);
    _defineProperty(this, "_prefetchMeshes", true);
    _defineProperty(this, "_prefetchMaterials", true);
    this._zkScene = zkScene;
    this._scene = scene;
    this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper(scene);
    this._elementSelector = new _Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_1__.ElementSelector();
    if (zkModel) this._zkModel = zkModel;
  }
  _createClass(SceneActionsExecutor, [{
    key: "deviceType",
    get: function get() {
      return this._deviceType;
    },
    set: function set(value) {
      if (this._deviceType != value) this._deviceType = value;
    }
  }, {
    key: "useMaterialOffloading",
    get: function get() {
      return this._useMaterialOffloading;
    },
    set: function set(value) {
      if (this._useMaterialOffloading != value) this._useMaterialOffloading = value;
    }
  }, {
    key: "prefetchMeshes",
    get: function get() {
      return this._prefetchMeshes;
    },
    set: function set(value) {
      if (this._prefetchMeshes !== value) this._prefetchMeshes = value;
    }
  }, {
    key: "prefetchMaterials",
    get: function get() {
      return this._prefetchMaterials;
    },
    set: function set(value) {
      if (this._prefetchMaterials !== value) this._prefetchMaterials = value;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._sceneHelper) {
        this._sceneHelper.dispose();
        this._sceneHelper = null;
      }
    }

    // -------------------------------------------------------
    // Events
    // -------------------------------------------------------
  }, {
    key: "addMeshDesignRefreshRequiredListeners",
    value: function addMeshDesignRefreshRequiredListeners(callback) {
      this._meshDesignRefreshRequiredListeners.push(callback);
    }
  }, {
    key: "fireMeshDesignRefreshRequiredEvent",
    value: function fireMeshDesignRefreshRequiredEvent(meshes, effect) {
      var evt = {
        meshes: meshes,
        effect: effect
      };
      for (var i = 0; i < this._meshDesignRefreshRequiredListeners.length; ++i) {
        this._meshDesignRefreshRequiredListeners[i](evt);
      }
    }
  }, {
    key: "addBeginAssetsLoadingListener",
    value: function addBeginAssetsLoadingListener(callback) {
      this._beginAssetsLoadingListeners.push(callback);
    }
  }, {
    key: "fireBeginAssetsLoadingEvent",
    value: function fireBeginAssetsLoadingEvent() {
      for (var i = 0; i < this._beginAssetsLoadingListeners.length; ++i) {
        this._beginAssetsLoadingListeners[i]();
      }
    }
  }, {
    key: "addEndAssetsLoadingListener",
    value: function addEndAssetsLoadingListener(callback) {
      this._endAssetsLoadingListeners.push(callback);
    }
  }, {
    key: "fireEndAssetsLoadingEvent",
    value: function fireEndAssetsLoadingEvent() {
      for (var i = 0; i < this._endAssetsLoadingListeners.length; ++i) {
        this._endAssetsLoadingListeners[i]();
      }
    }

    // -------------------------------------------------------
    // Actions Helpers Methods
    // -------------------------------------------------------
  }, {
    key: "isActionForDevice",
    value: function isActionForDevice(action) {
      var type = action.get("deviceTypes");
      if (type === MPlaza.DeviceType.Any || type === MPlaza.DeviceType.All) return true;
      if ((type & this._deviceType) === this._deviceType) return true;
      return false;
    }

    // ad una mesh vengono associati dei dati aggiuntivi che servono per l'utilizzo dei filtri.
    // Un filtro consente di creare un contesto di mesh da associare ad una opzione di un attributo.
    // Quando si utilizza un'azione di tipo filtro, verranno visualizzate solo le mesh specificate dal filtro.
    // Per esempio, per un orologio potrei avere un attributo "modello" con le opzioni "classico", "moderno", "sportivo".
    // Selezionando un modello, potrebbe essere utile attivare solo le mesh che hanno a che fare con il
    // modello selezionato. Questo consentirebbe di specificare azioni su altre opzioni indipendentemente dal modello.
    // Ad esempio potrei avere un altro attributo "vetro" con le opzioni "zaffiro" e "normale" con le azioni
    // che visualizzano il vetro nel materiale selezionato, diverso per modello.
    // Un filtro è relativo ad un attributo, così da permettere la definizione di contesti più restrittivi
    // andando a cumulare filtri relativi ad attributi diversi.

    // Inizializza la struttura dati associata ad una mesh
  }, {
    key: "setupMeshData",
    value: function setupMeshData(mesh) {
      if (!mesh["data"]) {
        mesh["data"] = {
          filters: {},
          toShow: mesh.isVisible
        };
      }
    }

    // Imposta il filtro legato ad un attributo (da un'azione filtro)
  }, {
    key: "setMeshFilterAsync",
    value: function () {
      var _setMeshFilterAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(mesh, attributeID, value) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.setupMeshData(mesh);
              mesh["data"].filters[attributeID] = value;
              _context.next = 4;
              return this.chekMeshVisibilityAsync(mesh);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setMeshFilterAsync(_x, _x2, _x3) {
        return _setMeshFilterAsync.apply(this, arguments);
      }
      return setMeshFilterAsync;
    }() // Richiede la visibilità di una mesh (da un'azione show/hide)
  }, {
    key: "setMeshVisibilityAsync",
    value: function () {
      var _setMeshVisibilityAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(mesh, value) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.setupMeshData(mesh);
              mesh["data"].toShow = value;
              _context2.next = 4;
              return this.chekMeshVisibilityAsync(mesh);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setMeshVisibilityAsync(_x4, _x5) {
        return _setMeshVisibilityAsync.apply(this, arguments);
      }
      return setMeshVisibilityAsync;
    }() // Determina se dopo l'applicazione di un filtro o una richiesta di visibilità
    // la mesh debba essere mostrata o nascosta. Il risultato andrà ad agire sulla
    // effettiva visibilità della mesh, secondo l'espressione booleana:
    // mesh.isVisible = F1 && F2 && ... && Fn && toShow
  }, {
    key: "chekMeshVisibilityAsync",
    value: function () {
      var _chekMeshVisibilityAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(mesh) {
        var filters, property, rootUrl;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              filters = null;
              if (mesh && mesh["data"]) {
                filters = mesh["data"].toShow;
                if (filters) {
                  for (property in mesh["data"].filters) {
                    filters = filters && mesh["data"].filters[property];
                  }
                }
              }
              if (!(filters !== null && this._sceneHelper)) {
                _context3.next = 11;
                break;
              }
              if (!filters) {
                _context3.next = 10;
                break;
              }
              rootUrl = this._zkScene.get("rootUrl");
              if (!rootUrl) {
                _context3.next = 8;
                break;
              }
              _context3.next = 8;
              return this._sceneHelper.unsetMeshDummyMaterialAsync(mesh, rootUrl, true);
            case 8:
              _context3.next = 10;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.whenMeshIsReadyAsync(mesh);
            case 10:
              this._sceneHelper.showHideMesh(mesh.id, filters);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function chekMeshVisibilityAsync(_x6) {
        return _chekMeshVisibilityAsync.apply(this, arguments);
      }
      return chekMeshVisibilityAsync;
    }()
  }, {
    key: "getMeshByID",
    value: function getMeshByID(id) {
      return this._scene.getMeshByID(id);
    }
  }, {
    key: "getMaterialByID",
    value: function getMaterialByID(id) {
      return this._scene.getMaterialByID(id);
    }
  }, {
    key: "setCameraLocation",
    value: function setCameraLocation(locationID) {
      var zkCameraLocation = this._zkScene.getCameraLocation(locationID);
      if (zkCameraLocation) {
        var position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
        var target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
        if (this._sceneHelper) this._sceneHelper.animateCamera(target, position, 0.5);
      }
    }
  }, {
    key: "adjustCamera",
    value: function adjustCamera(animate) {
      if (this._sceneHelper) {
        if (animate !== undefined && typeof animate === "boolean") this._sceneHelper.adjustCamera(undefined, undefined, undefined, animate);else this._sceneHelper.adjustCamera();
      }
    }
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      if (this._sceneHelper) this._sceneHelper.zoomIn();
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      if (this._sceneHelper) this._sceneHelper.zoomOut();
    }
  }, {
    key: "zoom",
    value: function zoom(perc) {
      if (this._sceneHelper) this._sceneHelper.zoom(perc);
    }
  }, {
    key: "setCameraPivot",
    value: function setCameraPivot(meshID) {
      if (this._sceneHelper) {
        var mesh = meshID ? this._scene.getMeshByID(meshID) : null;
        this._sceneHelper.setCameraPivot(mesh);
      }
    }
  }, {
    key: "setCameraZoomEnabled",
    value: function setCameraZoomEnabled(enabled) {
      if (this._sceneHelper) {
        this._sceneHelper.setZoomEnabled(enabled);
      }
    }
  }, {
    key: "setMeshMaterial",
    value: function () {
      var _setMeshMaterial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(material, mesh) {
        var oldMaterial;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this._sceneHelper) {
                _context4.next = 7;
                break;
              }
              _context4.next = 3;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.whenAllMaterialTexturesAreReady(material);
            case 3:
              oldMaterial = mesh.material;
              Logger.info("Setting material to mesh | mesh: ".concat(mesh.id, " - ").concat(mesh.name, " | material: ").concat(material.id, " - ").concat(material.name));
              this._sceneHelper.applyMaterial(material, mesh);
              if (this._useMaterialOffloading && oldMaterial) {
                this._sceneHelper.offloadMaterial(oldMaterial.id);
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function setMeshMaterial(_x7, _x8) {
        return _setMeshMaterial.apply(this, arguments);
      }
      return setMeshMaterial;
    }()
  }, {
    key: "setSubmeshMaterial",
    value: function () {
      var _setSubmeshMaterial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(material, mesh, subMesh) {
        var oldMaterial;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!this._sceneHelper) {
                _context5.next = 6;
                break;
              }
              _context5.next = 3;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.whenAllMaterialTexturesAreReady(material);
            case 3:
              oldMaterial = this._sceneHelper.getSubMeshMaterial(mesh, subMesh);
              this._sceneHelper.applyMaterialToSubMesh(material, mesh, subMesh);
              if (this._useMaterialOffloading && oldMaterial) {
                this._sceneHelper.offloadMaterial(oldMaterial.id);
              }
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function setSubmeshMaterial(_x9, _x10, _x11) {
        return _setSubmeshMaterial.apply(this, arguments);
      }
      return setSubmeshMaterial;
    }()
  }, {
    key: "getMaterialFromActionValue",
    value: function getMaterialFromActionValue(action) {
      if (this._elementSelector) {
        // Recupero il materiale, che deve essere specificato tramite nome o ID
        var matSel = action.get("value");
        if (matSel != undefined && matSel != null) {
          var material = this._scene.getMaterialByID(matSel);
          if (!material) material = this._scene.getMaterialByName(matSel);
          return material;
        }
      }
      return null;
    }
  }, {
    key: "getDelayedMaterialIDFromAction",
    value: function getDelayedMaterialIDFromAction(action) {
      if (this._zkScene && this._scene && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.delayedMaterials) {
        // Recupero il materiale, che deve essere specificato tramite nome o ID
        var matSel = action.get("value");
        if (matSel != undefined && matSel != null) {
          if (this._scene.metadata.delayedMaterials.hasOwnProperty(matSel)) {
            return matSel; // id trovato
          } else {
            for (var key in this._scene.metadata.delayedMaterials) {
              if (this._scene.metadata.delayedMaterials[key].name === matSel) return key; // trovato nome
            }
          }
        }
      }

      return null;
    }
  }, {
    key: "checkDelayedMaterial",
    value: function () {
      var _checkDelayedMaterial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(materialID) {
        var material, rootUrl;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              material = this.getMaterialByID(materialID);
              if (!(!material && this._sceneHelper)) {
                _context6.next = 7;
                break;
              }
              rootUrl = this._zkScene.get("rootUrl");
              if (!(rootUrl != undefined && rootUrl != null)) {
                _context6.next = 7;
                break;
              }
              _context6.next = 6;
              return this._sceneHelper.loadDelayedMaterialAsync(rootUrl, materialID);
            case 6:
              material = _context6.sent;
            case 7:
              return _context6.abrupt("return", material);
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function checkDelayedMaterial(_x12) {
        return _checkDelayedMaterial.apply(this, arguments);
      }
      return checkDelayedMaterial;
    }()
  }, {
    key: "getOffloadedMaterialIDFromAction",
    value: function getOffloadedMaterialIDFromAction(action) {
      if (this._zkScene && this._scene && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
        // Recupero il materiale, che deve essere specificato tramite nome o ID
        var matSel = action.get("value");
        if (matSel !== undefined && matSel !== null) {
          if (this._scene.metadata.offloadedMaterials.hasOwnProperty(matSel)) {
            return matSel; // id trovato
          } else {
            for (var key in this._scene.metadata.offloadedMaterials) {
              if (this._scene.metadata.offloadedMaterials[key].name === matSel) return key; // trovato nome
            }
          }
        }
      }

      return null;
    }
  }, {
    key: "checkOffloadedMaterialAsync",
    value: function () {
      var _checkOffloadedMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(materialID) {
        var material, rootUrl;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              material = this.getMaterialByID(materialID);
              if (!(!material && this._sceneHelper)) {
                _context7.next = 7;
                break;
              }
              rootUrl = this._zkScene.get("rootUrl");
              if (!(rootUrl !== undefined && rootUrl !== null)) {
                _context7.next = 7;
                break;
              }
              _context7.next = 6;
              return this._sceneHelper.loadOffloadedMaterialAsync(rootUrl, materialID);
            case 6:
              material = _context7.sent;
            case 7:
              return _context7.abrupt("return", material);
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function checkOffloadedMaterialAsync(_x13) {
        return _checkOffloadedMaterialAsync.apply(this, arguments);
      }
      return checkOffloadedMaterialAsync;
    }() // Recupera il materiale specificato nel valore di un'azione, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
  }, {
    key: "getDeepMaterialFromActionValueAsync",
    value: function () {
      var _getDeepMaterialFromActionValueAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(action) {
        var material, rootUrl, materialID;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              material = this.getMaterialFromActionValue(action);
              if (!(!material && this._sceneHelper)) {
                _context8.next = 20;
                break;
              }
              rootUrl = this._zkScene.get("rootUrl");
              if (!(rootUrl !== undefined && rootUrl !== null)) {
                _context8.next = 20;
                break;
              }
              // Verifico se si tratta di un materiale offloaded o delayed
              materialID = this.getOffloadedMaterialIDFromAction(action);
              if (!materialID) {
                _context8.next = 13;
                break;
              }
              Logger.info("Requesting offloaded material - id: ", materialID);
              _context8.next = 9;
              return this._sceneHelper.loadOffloadedMaterialAsync(rootUrl, materialID);
            case 9:
              material = _context8.sent;
              Logger.info("Obtained offloaded material - id: ", materialID);
              _context8.next = 20;
              break;
            case 13:
              materialID = this.getDelayedMaterialIDFromAction(action);
              if (!materialID) {
                _context8.next = 20;
                break;
              }
              Logger.info("Requesting delayed material - id: ", materialID);
              _context8.next = 18;
              return this._sceneHelper.loadDelayedMaterialAsync(rootUrl, materialID);
            case 18:
              material = _context8.sent;
              Logger.info("Obtained delayed material - id: ", materialID);
            case 20:
              return _context8.abrupt("return", material);
            case 21:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getDeepMaterialFromActionValueAsync(_x14) {
        return _getDeepMaterialFromActionValueAsync.apply(this, arguments);
      }
      return getDeepMaterialFromActionValueAsync;
    }()
  }, {
    key: "scriptRequiresDelayedLoading",
    value: function scriptRequiresDelayedLoading(script) {
      for (var i = 0; i < script.length; i++) {
        var scriptActions = script[i];
        if (this.actionsRequireDelayedLoading(scriptActions.actions)) return true;
      }
      return false;
    }
  }, {
    key: "actionsRequireDelayedLoading",
    value: function actionsRequireDelayedLoading(actions) {
      for (var i = 0; i < actions.length; i++) {
        if (this.actionRequiresDelayedLoading(actions[i])) return true;
      }
      return false;
    }
  }, {
    key: "actionRequiresDelayedLoading",
    value: function actionRequiresDelayedLoading(action) {
      // Almeno una mesh con delayLoading oppure con materiale dummy e materiali originali delayed o offloaded
      if (this._sceneHelper && action.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && action.get("value") === "show") {
        var expression = action.get("selector");
        if (expression !== undefined && expression !== null) {
          var meshes = this._elementSelector.getElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
          for (var k = 0; k < meshes.length; k++) {
            var mesh = meshes[k];
            if (mesh instanceof BABYLON.AbstractMesh && !mesh.isVisible) {
              var meshDelayedMaterialIDs = this._sceneHelper.getMeshDelayedMaterialIDs(mesh);
              var meshOffloadedMaterialIDs = this._sceneHelper.getMeshOffloadedMaterialIDs(mesh);
              if (meshDelayedMaterialIDs.length > 0 || meshOffloadedMaterialIDs.length > 0) return true;
              if (_SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.meshRequiresDelayedLoading(mesh)) return true;
            }
          }
        }
      }

      // Almeno un materiale con delayedLoading
      if (action.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || action.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial || action.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor || action.get("actionTypeID") === MPlaza.SceneActionType.SetMeshDesignMaterial) {
        var material = this.getMaterialFromActionValue(action);
        if (!material) {
          var delayedMaterialID = this.getDelayedMaterialIDFromAction(action);
          if (delayedMaterialID) return true;
          var offloadedMaterialID = this.getOffloadedMaterialIDFromAction(action);
          if (offloadedMaterialID) return true;
        }
      }
      if (action.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
        var _expression = action.get("selector");
        if (_expression !== undefined && _expression !== null) {
          var delayedMaterialIDs = this._elementSelector.getDelayedElementIDs(this._zkScene, this._scene, null, _expression, MPlaza.SceneElementType.Material);
          var offloadedMaterialIDs = this._elementSelector.getOffloadedElementIDs(this._zkScene, this._scene, null, _expression, MPlaza.SceneElementType.Material);
          if (delayedMaterialIDs.length > 0 || offloadedMaterialIDs.length > 0) return true;
        }
      }
      return false;
    }
  }, {
    key: "getAllMaterialElementsAsync",
    value: function () {
      var _getAllMaterialElementsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(expression) {
        var allMaterials, materials, materialIDs, selectedDelayedMaterialIDs, selectedOffloadedMaterialIDs, rootUrl, delayedMaterialIDs, delayedMaterials, offloadedMaterialIDs, offloadedMaterials;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              allMaterials = [];
              if (!(this._zkScene && this._scene && this._sceneHelper && this._elementSelector)) {
                _context9.next = 23;
                break;
              }
              // Existing materials
              materials = this._elementSelector.getMaterialElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Material);
              Array.prototype.push.apply(allMaterials, materials);
              materialIDs = materials.map(function (m) {
                return m.id;
              });
              selectedDelayedMaterialIDs = this._elementSelector.getDelayedElementIDs(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Material);
              selectedOffloadedMaterialIDs = this._elementSelector.getOffloadedElementIDs(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Material);
              rootUrl = this._zkScene.get("rootUrl");
              if (!(rootUrl !== undefined && rootUrl !== null)) {
                _context9.next = 23;
                break;
              }
              // delayed materials
              delayedMaterialIDs = [];
              selectedDelayedMaterialIDs.forEach(function (id) {
                if (materialIDs.indexOf(id) === -1) delayedMaterialIDs.push(id);
              });
              if (!(delayedMaterialIDs.length > 0)) {
                _context9.next = 16;
                break;
              }
              _context9.next = 14;
              return this._sceneHelper.loadDelayedMaterialsAsync(rootUrl, delayedMaterialIDs);
            case 14:
              delayedMaterials = _context9.sent;
              Array.prototype.push.apply(allMaterials, delayedMaterials);
            case 16:
              // offloaded materials
              offloadedMaterialIDs = [];
              selectedOffloadedMaterialIDs.forEach(function (id) {
                if (materialIDs.indexOf(id) === -1) offloadedMaterialIDs.push(id);
              });
              if (!(offloadedMaterialIDs.length > 0)) {
                _context9.next = 23;
                break;
              }
              _context9.next = 21;
              return this._sceneHelper.loadOffloadedMaterialsByIDsAsync(rootUrl, offloadedMaterialIDs);
            case 21:
              offloadedMaterials = _context9.sent;
              Array.prototype.push.apply(allMaterials, offloadedMaterials);
            case 23:
              return _context9.abrupt("return", allMaterials);
            case 24:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getAllMaterialElementsAsync(_x15) {
        return _getAllMaterialElementsAsync.apply(this, arguments);
      }
      return getAllMaterialElementsAsync;
    }() // Uno script è un array di oggetti ognuno dei quali rappresenta le azioni da eseguire
    // conseguentemente alla selezione di un valore per un attributo
    // si suppone che le azioni siano già ordinate per ordine di esecuzione
    // script: [{attributeID, selectedValue, actions}]
  }, {
    key: "executeScriptAsync",
    value: function () {
      var _executeScriptAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(script) {
        var requireDelayedLoading, i, scriptActions;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              requireDelayedLoading = this.scriptRequiresDelayedLoading(script);
              if (requireDelayedLoading) {
                this.fireBeginAssetsLoadingEvent();
              }
              i = 0;
            case 3:
              if (!(i < script.length)) {
                _context10.next = 10;
                break;
              }
              scriptActions = script[i];
              _context10.next = 7;
              return this.executeActionsAsync(scriptActions.attributeID, scriptActions.selectedValue, scriptActions.actions, false);
            case 7:
              i++;
              _context10.next = 3;
              break;
            case 10:
              if (requireDelayedLoading) this.fireEndAssetsLoadingEvent();
            case 11:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function executeScriptAsync(_x16) {
        return _executeScriptAsync.apply(this, arguments);
      }
      return executeScriptAsync;
    }()
  }, {
    key: "executeActionsAsync",
    value: function () {
      var _executeActionsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(attributeID, selectedValue, actions) {
        var notifyDelayLoading,
          requireDelayedLoading,
          i,
          _args11 = arguments;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              notifyDelayLoading = _args11.length > 3 && _args11[3] !== undefined ? _args11[3] : true;
              if (!(actions.length > 0)) {
                _context11.next = 14;
                break;
              }
              // Caricamento mesh e materiali delayed previsti per le azioni
              requireDelayedLoading = this.actionsRequireDelayedLoading(actions);
              if (notifyDelayLoading && requireDelayedLoading) this.fireBeginAssetsLoadingEvent();
              _context11.next = 6;
              return this.checkActionsAssetsAreReadyAsync(actions);
            case 6:
              i = 0;
            case 7:
              if (!(i < actions.length)) {
                _context11.next = 13;
                break;
              }
              _context11.next = 10;
              return this.executeActionAsync(attributeID, selectedValue, actions[i]);
            case 10:
              i++;
              _context11.next = 7;
              break;
            case 13:
              if (notifyDelayLoading && requireDelayedLoading) this.fireEndAssetsLoadingEvent();
              // -----------------------------------------
            case 14:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function executeActionsAsync(_x17, _x18, _x19) {
        return _executeActionsAsync.apply(this, arguments);
      }
      return executeActionsAsync;
    }() // Esegue una singola azione generata dalla selezione di un attributo
    // action: MPlaza.AttributeSceneAction
  }, {
    key: "executeActionAsync",
    value: function () {
      var _executeActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(attributeID, selectedValue, action) {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context12.next = 2;
                break;
              }
              return _context12.abrupt("return");
            case 2:
              if (!action) {
                _context12.next = 42;
                break;
              }
              _context12.t0 = action.get("actionTypeID");
              _context12.next = _context12.t0 === MPlaza.SceneActionType.Filter ? 6 : _context12.t0 === MPlaza.SceneActionType.ShowHideMesh ? 9 : _context12.t0 === MPlaza.SceneActionType.SetMeshMaterial ? 12 : _context12.t0 === MPlaza.SceneActionType.SetSubMeshMaterial ? 15 : _context12.t0 === MPlaza.SceneActionType.SetMaterialColor ? 18 : _context12.t0 === MPlaza.SceneActionType.SetCameraLocation ? 21 : _context12.t0 === MPlaza.SceneActionType.AdjustCamera ? 24 : _context12.t0 === MPlaza.SceneActionType.SetCameraPivot ? 27 : _context12.t0 === MPlaza.SceneActionType.ResetCameraPivot ? 30 : _context12.t0 === MPlaza.SceneActionType.EnableDiableZoom ? 33 : _context12.t0 === MPlaza.SceneActionType.SetMeshDesignMaterial ? 36 : _context12.t0 === MPlaza.SceneActionType.SetMeshDesignEffect ? 39 : 42;
              break;
            case 6:
              _context12.next = 8;
              return this.executeFilterActionAsync(attributeID, selectedValue, action);
            case 8:
              return _context12.abrupt("break", 42);
            case 9:
              _context12.next = 11;
              return this.executeShowHideActionAsync(attributeID, selectedValue, action);
            case 11:
              return _context12.abrupt("break", 42);
            case 12:
              _context12.next = 14;
              return this.executeSetMeshMaterialActionAsync(attributeID, selectedValue, action);
            case 14:
              return _context12.abrupt("break", 42);
            case 15:
              _context12.next = 17;
              return this.executeSetSubMeshMaterialActionAsync(attributeID, selectedValue, action);
            case 17:
              return _context12.abrupt("break", 42);
            case 18:
              _context12.next = 20;
              return this.executeSetMaterialColorActionAsync(attributeID, selectedValue, action);
            case 20:
              return _context12.abrupt("break", 42);
            case 21:
              _context12.next = 23;
              return this.executeSetCameraLocationActionAsync(attributeID, selectedValue, action);
            case 23:
              return _context12.abrupt("break", 42);
            case 24:
              _context12.next = 26;
              return this.executeAdjustCameraActionAsync(attributeID, selectedValue, action);
            case 26:
              return _context12.abrupt("break", 42);
            case 27:
              _context12.next = 29;
              return this.executeSetCameraPivotActionAsync(attributeID, selectedValue, action);
            case 29:
              return _context12.abrupt("break", 42);
            case 30:
              _context12.next = 32;
              return this.executeResetCameraPivotActionAsync(attributeID, selectedValue, action);
            case 32:
              return _context12.abrupt("break", 42);
            case 33:
              _context12.next = 35;
              return this.executeEnableDisableZoomActionAsync(attributeID, selectedValue, action);
            case 35:
              return _context12.abrupt("break", 42);
            case 36:
              _context12.next = 38;
              return this.executeSetMeshDesignMaterialActionAsync(attributeID, selectedValue, action);
            case 38:
              return _context12.abrupt("break", 42);
            case 39:
              _context12.next = 41;
              return this.executeSetMeshDesignEffectActionAsync(attributeID, selectedValue, action);
            case 41:
              return _context12.abrupt("break", 42);
            case 42:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function executeActionAsync(_x20, _x21, _x22) {
        return _executeActionAsync.apply(this, arguments);
      }
      return executeActionAsync;
    }()
  }, {
    key: "executeFilterActionAsync",
    value: function () {
      var _executeFilterActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(attributeID, selectedValue, action) {
        var expression, elements, value, i, _i;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return");
            case 2:
              if (!(attributeID !== null && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction)) {
                _context13.next = 21;
                break;
              }
              // Recupero sia gli elementi che soddisfano il filtro che gli altri.
              // Questo perché per entrambe le tipologie di mesh devo settare i dati di filtro
              // e la conseguente visibilità
              expression = action.get("selector");
              if (!(expression !== undefined && expression !== null)) {
                _context13.next = 21;
                break;
              }
              elements = this._elementSelector.getYesNoElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
              value = action.get("value") === "enable" ? true : false;
              i = 0;
            case 8:
              if (!(i < elements.yes.length)) {
                _context13.next = 14;
                break;
              }
              _context13.next = 11;
              return this.setMeshFilterAsync(elements.yes[i], attributeID, value);
            case 11:
              i++;
              _context13.next = 8;
              break;
            case 14:
              _i = 0;
            case 15:
              if (!(_i < elements.no.length)) {
                _context13.next = 21;
                break;
              }
              _context13.next = 18;
              return this.setMeshFilterAsync(elements.yes[_i], attributeID, !value);
            case 18:
              _i++;
              _context13.next = 15;
              break;
            case 21:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function executeFilterActionAsync(_x23, _x24, _x25) {
        return _executeFilterActionAsync.apply(this, arguments);
      }
      return executeFilterActionAsync;
    }()
  }, {
    key: "executeShowHideActionAsync",
    value: function () {
      var _executeShowHideActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(attributeID, selectedValue, action) {
        var expression, meshes, value, i;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context14.next = 2;
                break;
              }
              return _context14.abrupt("return");
            case 2:
              if (!(this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction)) {
                _context14.next = 14;
                break;
              }
              expression = action.get("selector");
              if (!(expression !== undefined && expression !== null)) {
                _context14.next = 14;
                break;
              }
              meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
              value = action.get("value") === "show";
              i = 0;
            case 8:
              if (!(i < meshes.length)) {
                _context14.next = 14;
                break;
              }
              _context14.next = 11;
              return this.setMeshVisibilityAsync(meshes[i], value);
            case 11:
              i++;
              _context14.next = 8;
              break;
            case 14:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function executeShowHideActionAsync(_x26, _x27, _x28) {
        return _executeShowHideActionAsync.apply(this, arguments);
      }
      return executeShowHideActionAsync;
    }()
  }, {
    key: "executeSetMeshMaterialActionAsync",
    value: function () {
      var _executeSetMeshMaterialActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(attributeID, selectedValue, action) {
        var expression, meshes, material, i;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context15.next = 2;
                break;
              }
              return _context15.abrupt("return");
            case 2:
              if (!(this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction)) {
                _context15.next = 17;
                break;
              }
              expression = action.get("selector");
              if (!(expression !== undefined && expression !== null)) {
                _context15.next = 17;
                break;
              }
              meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
              _context15.next = 8;
              return this.getDeepMaterialFromActionValueAsync(action);
            case 8:
              material = _context15.sent;
              if (!material) {
                _context15.next = 17;
                break;
              }
              i = 0;
            case 11:
              if (!(i < meshes.length)) {
                _context15.next = 17;
                break;
              }
              _context15.next = 14;
              return this.setMeshMaterial(material, meshes[i]);
            case 14:
              i++;
              _context15.next = 11;
              break;
            case 17:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function executeSetMeshMaterialActionAsync(_x29, _x30, _x31) {
        return _executeSetMeshMaterialActionAsync.apply(this, arguments);
      }
      return executeSetMeshMaterialActionAsync;
    }()
  }, {
    key: "executeSetSubMeshMaterialActionAsync",
    value: function () {
      var _executeSetSubMeshMaterialActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(attributeID, selectedValue, action) {
        var expression, subMeshes, material, i;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context16.next = 2;
                break;
              }
              return _context16.abrupt("return");
            case 2:
              if (!(this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction)) {
                _context16.next = 17;
                break;
              }
              expression = action.get("selector");
              if (!(expression !== undefined && expression !== null)) {
                _context16.next = 17;
                break;
              }
              subMeshes = this._elementSelector.getSubMeshElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.SubMesh);
              _context16.next = 8;
              return this.getDeepMaterialFromActionValueAsync(action);
            case 8:
              material = _context16.sent;
              if (!material) {
                _context16.next = 17;
                break;
              }
              i = 0;
            case 11:
              if (!(i < subMeshes.length)) {
                _context16.next = 17;
                break;
              }
              _context16.next = 14;
              return this.setSubmeshMaterial(material, null, subMeshes[i]);
            case 14:
              i++;
              _context16.next = 11;
              break;
            case 17:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function executeSetSubMeshMaterialActionAsync(_x32, _x33, _x34) {
        return _executeSetSubMeshMaterialActionAsync.apply(this, arguments);
      }
      return executeSetSubMeshMaterialActionAsync;
    }()
  }, {
    key: "executeSetMaterialColorActionAsync",
    value: function () {
      var _executeSetMaterialColorActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(attributeID, selectedValue, action) {
        var expression, materials, propertyName, hexColor, color, i;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context17.next = 2;
                break;
              }
              return _context17.abrupt("return");
            case 2:
              if (!(this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction)) {
                _context17.next = 11;
                break;
              }
              expression = action.get("selector");
              if (!(expression !== undefined && expression !== null)) {
                _context17.next = 11;
                break;
              }
              _context17.next = 7;
              return this.getAllMaterialElementsAsync(expression);
            case 7:
              materials = _context17.sent;
              propertyName = action.get("propertyName");
              hexColor = action.get("value");
              if (propertyName && hexColor) {
                if (selectedValue) {
                  // Sostituisco la variabile %value% con il valore selezionato
                  hexColor = hexColor.replace(/%value%/g, selectedValue);
                }
                color = BABYLON.Color3.FromHexString(hexColor);
                for (i = 0; i < materials.length; i++) {
                  this._sceneHelper.changeMaterialColor(materials[i], propertyName, color);
                }
              }
            case 11:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function executeSetMaterialColorActionAsync(_x35, _x36, _x37) {
        return _executeSetMaterialColorActionAsync.apply(this, arguments);
      }
      return executeSetMaterialColorActionAsync;
    }()
  }, {
    key: "executeSetCameraLocationActionAsync",
    value: function () {
      var _executeSetCameraLocationActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(attributeID, selectedValue, action) {
        var value, cameraLocation, i, location;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context18.next = 2;
                break;
              }
              return _context18.abrupt("return");
            case 2:
              if (!(this._zkScene && this._scene && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction)) {
                _context18.next = 16;
                break;
              }
              value = action.get("value");
              cameraLocation = null;
              if (!value) {
                _context18.next = 15;
                break;
              }
              i = 0;
            case 7:
              if (!(i < this._zkScene.get("cameraLocations").length)) {
                _context18.next = 15;
                break;
              }
              location = this._zkScene.get("cameraLocations").at(i);
              if (!(location.get("locationID") === value || location.get("name") === value)) {
                _context18.next = 12;
                break;
              }
              cameraLocation = location;
              return _context18.abrupt("break", 15);
            case 12:
              i++;
              _context18.next = 7;
              break;
            case 15:
              if (cameraLocation !== null) this.setCameraLocation(cameraLocation.get("locationID"));
            case 16:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function executeSetCameraLocationActionAsync(_x38, _x39, _x40) {
        return _executeSetCameraLocationActionAsync.apply(this, arguments);
      }
      return executeSetCameraLocationActionAsync;
    }()
  }, {
    key: "executeAdjustCameraActionAsync",
    value: function () {
      var _executeAdjustCameraActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(attributeID, selectedValue, action) {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context19.next = 2;
                break;
              }
              return _context19.abrupt("return");
            case 2:
              if (this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction) {
                this._sceneHelper.adjustCamera();
              }
            case 3:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function executeAdjustCameraActionAsync(_x41, _x42, _x43) {
        return _executeAdjustCameraActionAsync.apply(this, arguments);
      }
      return executeAdjustCameraActionAsync;
    }()
  }, {
    key: "executeSetCameraPivotActionAsync",
    value: function () {
      var _executeSetCameraPivotActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(attributeID, selectedValue, action) {
        var value, cameraPivot, i, mesh;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context20.next = 2;
                break;
              }
              return _context20.abrupt("return");
            case 2:
              if (!(this._zkScene && this._scene && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction)) {
                _context20.next = 16;
                break;
              }
              value = action.get("value");
              cameraPivot = null;
              if (!value) {
                _context20.next = 15;
                break;
              }
              i = 0;
            case 7:
              if (!(i < this._scene.meshes.length)) {
                _context20.next = 15;
                break;
              }
              mesh = this._scene.meshes[i];
              if (!(mesh.id === value || mesh.name === value)) {
                _context20.next = 12;
                break;
              }
              cameraPivot = mesh;
              return _context20.abrupt("break", 15);
            case 12:
              i++;
              _context20.next = 7;
              break;
            case 15:
              if (cameraPivot) this.setCameraPivot(cameraPivot.id);
            case 16:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function executeSetCameraPivotActionAsync(_x44, _x45, _x46) {
        return _executeSetCameraPivotActionAsync.apply(this, arguments);
      }
      return executeSetCameraPivotActionAsync;
    }()
  }, {
    key: "executeResetCameraPivotActionAsync",
    value: function () {
      var _executeResetCameraPivotActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(attributeID, selectedValue, action) {
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context21.next = 2;
                break;
              }
              return _context21.abrupt("return");
            case 2:
              this.setCameraPivot(null);
            case 3:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function executeResetCameraPivotActionAsync(_x47, _x48, _x49) {
        return _executeResetCameraPivotActionAsync.apply(this, arguments);
      }
      return executeResetCameraPivotActionAsync;
    }()
  }, {
    key: "executeEnableDisableZoomActionAsync",
    value: function () {
      var _executeEnableDisableZoomActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(attributeID, selectedValue, action) {
        var value;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context22.next = 2;
                break;
              }
              return _context22.abrupt("return");
            case 2:
              if (this._zkScene && this._scene && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction) {
                value = action.get("value") === "enable";
                this.setCameraZoomEnabled(value);
              }
            case 3:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function executeEnableDisableZoomActionAsync(_x50, _x51, _x52) {
        return _executeEnableDisableZoomActionAsync.apply(this, arguments);
      }
      return executeEnableDisableZoomActionAsync;
    }()
  }, {
    key: "executeSetMeshDesignMaterialActionAsync",
    value: function () {
      var _executeSetMeshDesignMaterialActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(attributeID, selectedValue, action) {
        var expression, meshes, material, i, mesh;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (!(this._zkScene && this._scene && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction)) {
                _context23.next = 8;
                break;
              }
              expression = action.get("selector");
              if (!(expression != undefined && expression != null)) {
                _context23.next = 8;
                break;
              }
              meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
              _context23.next = 6;
              return this.getDeepMaterialFromActionValueAsync(action);
            case 6:
              material = _context23.sent;
              if (material) {
                for (i = 0; i < meshes.length; i++) {
                  mesh = meshes[i];
                  mesh.metadata = mesh.metadata || {};
                  mesh.metadata.designMaterialID = material.id;
                }
                this.fireMeshDesignRefreshRequiredEvent(meshes, null);
              }
            case 8:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function executeSetMeshDesignMaterialActionAsync(_x53, _x54, _x55) {
        return _executeSetMeshDesignMaterialActionAsync.apply(this, arguments);
      }
      return executeSetMeshDesignMaterialActionAsync;
    }()
  }, {
    key: "executeSetMeshDesignEffectActionAsync",
    value: function () {
      var _executeSetMeshDesignEffectActionAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(attributeID, selectedValue, action) {
        var expression, meshes, value, effect, i, scene, effects, k, eff, material, materialID;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (this.isActionForDevice(action)) {
                _context24.next = 2;
                break;
              }
              return _context24.abrupt("return");
            case 2:
              if (!(this._zkScene && this._scene && this._elementSelector && action && action instanceof MPlaza.AttributeSceneAction)) {
                _context24.next = 41;
                break;
              }
              expression = action.get("selector");
              if (!(expression != undefined && expression != null)) {
                _context24.next = 41;
                break;
              }
              meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
              value = action.get("value");
              effect = null;
              if (!(value != undefined && value != null && this._zkModel)) {
                _context24.next = 29;
                break;
              }
              i = 0;
            case 10:
              if (!(i < this._zkModel.get("scenes").length)) {
                _context24.next = 29;
                break;
              }
              scene = this._zkModel.get("scenes").at(i);
              if (!scene.get("isDefault")) {
                _context24.next = 24;
                break;
              }
              effects = scene.get("meshDesignEffects");
              if (!effects) {
                _context24.next = 24;
                break;
              }
              k = 0;
            case 16:
              if (!(k < effects.length)) {
                _context24.next = 24;
                break;
              }
              eff = effects.at(k);
              if (!(eff.get("effectID") === value || eff.get("name") === value)) {
                _context24.next = 21;
                break;
              }
              effect = eff;
              return _context24.abrupt("break", 24);
            case 21:
              k++;
              _context24.next = 16;
              break;
            case 24:
              if (!effect) {
                _context24.next = 26;
                break;
              }
              return _context24.abrupt("break", 29);
            case 26:
              i++;
              _context24.next = 10;
              break;
            case 29:
              material = null;
              if (!effect) {
                _context24.next = 40;
                break;
              }
              materialID = effect.get("materialID");
              if (!materialID) {
                _context24.next = 40;
                break;
              }
              _context24.next = 35;
              return this.checkOffloadedMaterialAsync(materialID);
            case 35:
              material = _context24.sent;
              if (material) {
                _context24.next = 40;
                break;
              }
              _context24.next = 39;
              return this.checkDelayedMaterial(materialID);
            case 39:
              material = _context24.sent;
            case 40:
              this.fireMeshDesignRefreshRequiredEvent(meshes, effect);
            case 41:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function executeSetMeshDesignEffectActionAsync(_x56, _x57, _x58) {
        return _executeSetMeshDesignEffectActionAsync.apply(this, arguments);
      }
      return executeSetMeshDesignEffectActionAsync;
    }()
  }, {
    key: "prefetchMeshesForUnselectedOptionsAsync",
    value: function () {
      var _prefetchMeshesForUnselectedOptionsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(actions) {
        var i, action, expression, meshes, k, mesh, material;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              if (!(this._zkScene && this._scene && this._elementSelector && this._sceneHelper && this._prefetchMeshes)) {
                _context25.next = 24;
                break;
              }
              i = 0;
            case 2:
              if (!(i < actions.length)) {
                _context25.next = 24;
                break;
              }
              action = actions[i];
              if (!(action && action instanceof MPlaza.AttributeSceneAction)) {
                _context25.next = 21;
                break;
              }
              if (!(action.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && action.get("value") == "show")) {
                _context25.next = 21;
                break;
              }
              expression = action.get("selector");
              if (!(expression != undefined && expression != null)) {
                _context25.next = 21;
                break;
              }
              meshes = this._elementSelector.getElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
              k = 0;
            case 10:
              if (!(k < meshes.length)) {
                _context25.next = 21;
                break;
              }
              mesh = meshes[k];
              if (!(mesh instanceof BABYLON.AbstractMesh && !mesh.isVisible)) {
                _context25.next = 18;
                break;
              }
              //Logger.info("prefetch", mesh);
              this._sceneHelper.checkDelayState(mesh);
              material = mesh.material;
              if (!material) {
                _context25.next = 18;
                break;
              }
              _context25.next = 18;
              return this._sceneHelper.prefetchTexturesForMaterialAsync(material);
            case 18:
              k++;
              _context25.next = 10;
              break;
            case 21:
              i++;
              _context25.next = 2;
              break;
            case 24:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function prefetchMeshesForUnselectedOptionsAsync(_x59) {
        return _prefetchMeshesForUnselectedOptionsAsync.apply(this, arguments);
      }
      return prefetchMeshesForUnselectedOptionsAsync;
    }()
  }, {
    key: "checkActionsAssetsAreReadyAsync",
    value: function () {
      var _checkActionsAssetsAreReadyAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(actions) {
        var i, action, meshes, expression, expressionMeshes, k, mesh, rootUrl, meshDelayedMaterialIDs, meshOffloadedMaterialIDs, _i2, _action, material, _expression2, materials;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!(this._zkScene && this._scene && this._elementSelector && this._sceneHelper)) {
                _context26.next = 52;
                break;
              }
              i = 0;
            case 2:
              if (!(i < actions.length)) {
                _context26.next = 33;
                break;
              }
              action = actions[i];
              meshes = [];
              if (!(action && action instanceof MPlaza.AttributeSceneAction)) {
                _context26.next = 28;
                break;
              }
              if (!(action.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && action.get("value") === "show")) {
                _context26.next = 28;
                break;
              }
              expression = action.get("selector");
              if (!(expression !== undefined && expression !== null)) {
                _context26.next = 28;
                break;
              }
              expressionMeshes = this._elementSelector.getElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
              k = 0;
            case 11:
              if (!(k < expressionMeshes.length)) {
                _context26.next = 28;
                break;
              }
              mesh = expressionMeshes[k];
              if (!(mesh instanceof BABYLON.AbstractMesh && !mesh.isVisible)) {
                _context26.next = 25;
                break;
              }
              rootUrl = this._zkScene.get("rootUrl");
              if (!rootUrl) {
                _context26.next = 24;
                break;
              }
              meshDelayedMaterialIDs = this._sceneHelper.getMeshDelayedMaterialIDs(mesh);
              meshOffloadedMaterialIDs = this._sceneHelper.getMeshOffloadedMaterialIDs(mesh);
              if (!(meshDelayedMaterialIDs.length > 0)) {
                _context26.next = 21;
                break;
              }
              _context26.next = 21;
              return this._sceneHelper.loadDelayedMaterialsAsync(rootUrl, meshDelayedMaterialIDs);
            case 21:
              if (!(meshOffloadedMaterialIDs.length > 0)) {
                _context26.next = 24;
                break;
              }
              _context26.next = 24;
              return this._sceneHelper.loadOffloadedMaterialsByIDsAsync(rootUrl, meshOffloadedMaterialIDs);
            case 24:
              meshes.push(mesh);
            case 25:
              k++;
              _context26.next = 11;
              break;
            case 28:
              _context26.next = 30;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.whenAllMeshesAreReadyAsync(meshes);
            case 30:
              i++;
              _context26.next = 2;
              break;
            case 33:
              _i2 = 0;
            case 34:
              if (!(_i2 < actions.length)) {
                _context26.next = 52;
                break;
              }
              _action = actions[_i2];
              if (!(_action && _action instanceof MPlaza.AttributeSceneAction)) {
                _context26.next = 49;
                break;
              }
              if (!(_action.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial || _action.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial)) {
                _context26.next = 43;
                break;
              }
              material = this.getMaterialFromActionValue(_action);
              if (material) {
                _context26.next = 43;
                break;
              }
              _context26.next = 42;
              return this.getDeepMaterialFromActionValueAsync(_action);
            case 42:
              material = _context26.sent;
            case 43:
              if (!(_action.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor)) {
                _context26.next = 49;
                break;
              }
              _expression2 = _action.get("selector");
              if (!(_expression2 !== undefined && _expression2 !== null)) {
                _context26.next = 49;
                break;
              }
              _context26.next = 48;
              return this.getAllMaterialElementsAsync(_expression2);
            case 48:
              materials = _context26.sent;
            case 49:
              _i2++;
              _context26.next = 34;
              break;
            case 52:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function checkActionsAssetsAreReadyAsync(_x60) {
        return _checkActionsAssetsAreReadyAsync.apply(this, arguments);
      }
      return checkActionsAssetsAreReadyAsync;
    }()
  }, {
    key: "prefetchDataForUnselectedOptionsAsync",
    value: function () {
      var _prefetchDataForUnselectedOptionsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(actions) {
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              return _context27.abrupt("return");
            case 1:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }));
      function prefetchDataForUnselectedOptionsAsync(_x61) {
        return _prefetchDataForUnselectedOptionsAsync.apply(this, arguments);
      }
      return prefetchDataForUnselectedOptionsAsync;
    }()
  }]);
  return SceneActionsExecutor;
}();

/***/ }),

/***/ "../../3D/src/Components/CollapseExplode/MeshLocationsManager.ts":
/*!***********************************************************************!*\
  !*** ../../3D/src/Components/CollapseExplode/MeshLocationsManager.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MeshLocationsManager": () => (/* binding */ MeshLocationsManager)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var MeshLocationsManager = /*#__PURE__*/function () {
  function MeshLocationsManager() {
    _classCallCheck(this, MeshLocationsManager);
    _defineProperty(this, "_zkScene", null);
    _defineProperty(this, "_scene", null);
    _defineProperty(this, "_sceneHelper", null);
    _defineProperty(this, "_meshLocationCache", {});
    _defineProperty(this, "_cameraAnimationCompletedListeners", []);
    _defineProperty(this, "_meshAnimationCompletedListeners", []);
    _defineProperty(this, "_beforeSaveMeshLocationListeners", []);
    _defineProperty(this, "_afterSaveMeshLocationListeners", []);
  }
  _createClass(MeshLocationsManager, [{
    key: "dispose",
    value: function dispose() {
      while (this._cameraAnimationCompletedListeners.length > 0) {
        this._cameraAnimationCompletedListeners.pop();
      }
      while (this._meshAnimationCompletedListeners.length > 0) {
        this._meshAnimationCompletedListeners.pop();
      }
      while (this._beforeSaveMeshLocationListeners.length > 0) {
        this._beforeSaveMeshLocationListeners.pop();
      }
      while (this._afterSaveMeshLocationListeners.length > 0) {
        this._afterSaveMeshLocationListeners.pop();
      }
      this.disposeSceneHelper();
    }
  }, {
    key: "setScene",
    value: function setScene(scene) {
      this._scene = scene;
      this.resetSceneHelper();
      this.resetCache();
    }
  }, {
    key: "setModel",
    value: function setModel(zkScene) {
      this._zkScene = zkScene;
      this.resetCache();
    }
  }, {
    key: "setModelAndScene",
    value: function setModelAndScene(zkScene, scene) {
      this._zkScene = zkScene;
      this._scene = scene;
      this.resetSceneHelper();
      this.resetCache();
    }
  }, {
    key: "resetCache",
    value: function resetCache() {
      this._meshLocationCache = {};
    }
  }, {
    key: "invalidateCache",
    value: function invalidateCache(locationID) {
      if (this._meshLocationCache) delete this._meshLocationCache[locationID];
    }
  }, {
    key: "disposeSceneHelper",
    value: function disposeSceneHelper() {
      if (this._sceneHelper) {
        this._sceneHelper.dispose();
        this._sceneHelper = null;
      }
    }
  }, {
    key: "resetSceneHelper",
    value: function resetSceneHelper() {
      this.disposeSceneHelper();
      if (this._scene) this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper(this._scene);
    }
  }, {
    key: "clearMeshLocations",
    value: function clearMeshLocations() {
      if (this._zkScene) {
        var items = this._zkScene.get("meshLocations");
        while (items.length > 0) items.remove(items.at(0));
      }
    }
  }, {
    key: "setMeshLocationByID",
    value: function () {
      var _setMeshLocationByID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(locationID) {
        var zkMeshLocation;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this._zkScene && this._scene)) {
                _context.next = 5;
                break;
              }
              zkMeshLocation = this._zkScene.getMeshLocation(locationID);
              if (!zkMeshLocation) {
                _context.next = 5;
                break;
              }
              _context.next = 5;
              return this.setMeshLocation(zkMeshLocation);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setMeshLocationByID(_x) {
        return _setMeshLocationByID.apply(this, arguments);
      }
      return setMeshLocationByID;
    }()
  }, {
    key: "setMeshLocation",
    value: function () {
      var _setMeshLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(zkMeshLocation) {
        var _this = this;
        var data, adjustCamera, locationID, compressedData, uint8Array, binary_string, len, bytes, _i, arrayBuffer, json, id, info, tasks, worldExtends, camera, radius, target, i, mesh;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this._zkScene && this._scene && this._sceneHelper)) {
                _context2.next = 9;
                break;
              }
              adjustCamera = true;
              if (zkMeshLocation) {
                locationID = zkMeshLocation.get("locationID");
                adjustCamera = zkMeshLocation.get("adjustCamera");
                if (this._meshLocationCache.hasOwnProperty(locationID)) {
                  data = this._meshLocationCache[locationID];
                } else {
                  compressedData = zkMeshLocation.get("data");
                  uint8Array = null; // Verifico se ho ottenuto una string (base64) o direttamente l'array
                  if (typeof compressedData === "string") {
                    binary_string = window.atob(compressedData);
                    len = binary_string.length;
                    bytes = new Uint8Array(len);
                    for (_i = 0; _i < len; _i++) {
                      bytes[_i] = binary_string.charCodeAt(_i);
                    }
                    arrayBuffer = bytes.buffer;
                    uint8Array = new Uint8Array(arrayBuffer);
                  } else if (Object.prototype.toString.call(compressedData) === '[object Array]') {
                    uint8Array = Uint8Array.from(compressedData);
                  }
                  if (uint8Array != null) {
                    json = LZString.decompressFromUint8Array(uint8Array);
                    data = JSON.parse(json);

                    // ho sostituito il clone nel getMeshesPRS ricostruendo le varie proprietà 
                    // in maniera tale da non dipendere dalle proprietà private di babylon,
                    // questo perchè qui inizialmente usavamo le proprietà pubbliche ma successivamente
                    // babylon le ha rese private rompendo la parte qui sotto dove ricostruivamo data
                    if (data) {
                      for (id in data) {
                        info = data[id];
                        if (info.p) info.p = new BABYLON.Vector3(info.p.x, info.p.y, info.p.z);
                        if (info.rE) info.rE = new BABYLON.Vector3(info.rE.x, info.rE.y, info.rE.z);
                        if (info.rQ) info.rQ = new BABYLON.Quaternion(info.rQ.x, info.rQ.y, info.rQ.z, info.rQ.w);
                        if (info.s) info.s = new BABYLON.Vector3(info.s.x, info.s.y, info.s.z);
                      }
                      this._meshLocationCache[locationID] = data;
                    }
                  }
                }
              }
              if (!data) {
                _context2.next = 9;
                break;
              }
              tasks = []; // Animazione della camera
              if (adjustCamera && data.hasOwnProperty("wemin") && data.hasOwnProperty("wemax")) {
                worldExtends = {
                  min: new BABYLON.Vector3(data.wemin.x, data.wemin.y, data.wemin.z),
                  max: new BABYLON.Vector3(data.wemax.x, data.wemax.y, data.wemax.z)
                };
                camera = this._sceneHelper.camera;
                if (camera && camera instanceof BABYLON.ArcRotateCamera) {
                  camera.upperRadiusLimit = null;
                  radius = this._sceneHelper.calculateCameraRadius(worldExtends);
                  target = this._sceneHelper.getWorldCenter(worldExtends);
                  if (target) {
                    this._sceneHelper.setCameraRadiusParameters(radius);
                    tasks.push(new Promise(function (resolve) {
                      if (camera && camera instanceof BABYLON.ArcRotateCamera) {
                        _this._sceneHelper.animateCameraToFinalParamters(camera.alpha, camera.beta, radius, target, 1, function () {
                          if (_this._sceneHelper) {
                            _this._sceneHelper.setupCameraLimits(worldExtends);
                            _this.fireCameraAnimationCompletedEvent();
                            resolve();
                          }
                        });
                      }
                    }));
                  }
                }
              }

              // Animazione delle mesh
              for (i = 0; i < this._scene.meshes.length; i++) {
                mesh = this._scene.meshes[i];
                id = mesh.id;
                if (data.hasOwnProperty(id)) {
                  info = data[id]; // Test animazione
                  tasks.push(new Promise(function (resolve) {
                    _this._sceneHelper.animateMeshToFinalParameters(mesh, info.p, info.rE, info.rQ, info.s, 1, function () {
                      _this.fireMeshAnimationCompletedEvent();
                      resolve();
                    });
                  }));
                }
              }
              _context2.next = 9;
              return Promise.all(tasks);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setMeshLocation(_x2) {
        return _setMeshLocation.apply(this, arguments);
      }
      return setMeshLocation;
    }()
  }, {
    key: "saveMeshLocation",
    value: function saveMeshLocation(name) {
      if (this._zkScene && this._scene) {
        var zkMeshLocation = new Zakeke.SceneMeshLocation();
        zkMeshLocation.set("name", name);
        this.updateMeshLocation(zkMeshLocation);
        this._zkScene.get("meshLocations").push(zkMeshLocation);
      }
    }
  }, {
    key: "saveExplodedMeshLocation",
    value: function saveExplodedMeshLocation() {
      if (this._zkScene && this._scene) {
        var zkMeshLocation = this._zkScene.getOrCreateExplodedMeshLocation();
        this.updateMeshLocation(zkMeshLocation);
      }
    }
  }, {
    key: "saveCollapsedMeshLocation",
    value: function saveCollapsedMeshLocation() {
      if (this._zkScene && this._scene) {
        var zkMeshLocation = this._zkScene.getOrCreateCollapsedMeshLocation();
        this.updateMeshLocation(zkMeshLocation);
      }
    }
  }, {
    key: "updateMeshLocation",
    value: function updateMeshLocation(zkMeshLocation) {
      this.fireBeforeSaveMeshLocationEvent();
      if (this._scene && this._sceneHelper) {
        var data = this.getMeshPRSs();
        // Salvo il world extends perché servirà nell'animazione della camera
        var worldExtends = this._sceneHelper.getWorldExtends();
        if (worldExtends) {
          var min = {
            x: worldExtends.min.x,
            y: worldExtends.min.y,
            z: worldExtends.min.z
          };
          var max = {
            x: worldExtends.max.x,
            y: worldExtends.max.y,
            z: worldExtends.max.z
          };
          data.wemin = min;
          data.wemax = max;
        }
        var json = JSON.stringify(data);
        var uint8Array = LZString.compressToUint8Array(json);
        var compressed = [].slice.call(uint8Array);
        // let compressed = Array.from(uint8Array);

        zkMeshLocation.set("data", compressed);
        this.invalidateCache(zkMeshLocation.get("locationID"));
      }
      this.fireAfterSaveMeshLocationEvent();
    }
  }, {
    key: "getMeshPRSs",
    value: function getMeshPRSs() {
      var data = {
        wemin: undefined,
        wemax: undefined
      };
      if (this._scene && this._sceneHelper) {
        for (var i = 0; i < this._scene.meshes.length; i++) {
          var mesh = this._scene.meshes[i];
          if (this._sceneHelper.isRealMesh(mesh)) {
            var id = mesh.id;
            var info = {
              p: undefined,
              rQ: undefined,
              rE: undefined,
              s: undefined
            };
            var p = {
              x: mesh.position.x,
              y: mesh.position.y,
              z: mesh.position.z
            };
            info.p = p;
            if (mesh.rotationQuaternion == null) {
              info.rQ = null;
              var rE = {
                x: mesh.rotation.x,
                y: mesh.rotation.y,
                z: mesh.rotation.z
              };
              info.rE = rE;
            } else {
              var rQ = {
                w: mesh.rotationQuaternion.w,
                x: mesh.rotationQuaternion.x,
                y: mesh.rotationQuaternion.y,
                z: mesh.rotationQuaternion.z
              };
              info.rQ = rQ;
              info.rE = null;
            }
            var s = {
              x: mesh.scaling.x,
              y: mesh.scaling.y,
              z: mesh.scaling.z
            };
            info.s = s;
            data[id] = info;
          }
        }
      }
      return data;
    }
  }, {
    key: "explodeMeshes",
    value: function () {
      var _explodeMeshes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var zkMeshLocation;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this._zkScene) {
                _context3.next = 5;
                break;
              }
              zkMeshLocation = this._zkScene.getFirstExplodedMeshLocation();
              if (!zkMeshLocation) {
                _context3.next = 5;
                break;
              }
              _context3.next = 5;
              return this.setMeshLocation(zkMeshLocation);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function explodeMeshes() {
        return _explodeMeshes.apply(this, arguments);
      }
      return explodeMeshes;
    }()
  }, {
    key: "collapseMeshes",
    value: function () {
      var _collapseMeshes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var zkMeshLocation;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!this._zkScene) {
                _context4.next = 5;
                break;
              }
              zkMeshLocation = this._zkScene.getFirstCollapsedMeshLocation();
              if (!zkMeshLocation) {
                _context4.next = 5;
                break;
              }
              _context4.next = 5;
              return this.setMeshLocation(zkMeshLocation);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function collapseMeshes() {
        return _collapseMeshes.apply(this, arguments);
      }
      return collapseMeshes;
    }() // Events
  }, {
    key: "fireCameraAnimationCompletedEvent",
    value: function fireCameraAnimationCompletedEvent() {
      for (var i = 0; i < this._cameraAnimationCompletedListeners.length; ++i) {
        this._cameraAnimationCompletedListeners[i]();
      }
    }
  }, {
    key: "addCameraAnimationCompletedListener",
    value: function addCameraAnimationCompletedListener(listenerFunction) {
      this._cameraAnimationCompletedListeners.push(listenerFunction);
    }
  }, {
    key: "fireMeshAnimationCompletedEvent",
    value: function fireMeshAnimationCompletedEvent() {
      for (var i = 0; i < this._meshAnimationCompletedListeners.length; ++i) {
        this._meshAnimationCompletedListeners[i]();
      }
    }
  }, {
    key: "addMeshAnimationCompletedListener",
    value: function addMeshAnimationCompletedListener(listenerFunction) {
      this._meshAnimationCompletedListeners.push(listenerFunction);
    }
  }, {
    key: "fireBeforeSaveMeshLocationEvent",
    value: function fireBeforeSaveMeshLocationEvent() {
      for (var i = 0; i < this._beforeSaveMeshLocationListeners.length; ++i) {
        this._beforeSaveMeshLocationListeners[i]();
      }
    }
  }, {
    key: "addBeforeSaveMeshLocationListener",
    value: function addBeforeSaveMeshLocationListener(listenerFunction) {
      this._beforeSaveMeshLocationListeners.push(listenerFunction);
    }
  }, {
    key: "fireAfterSaveMeshLocationEvent",
    value: function fireAfterSaveMeshLocationEvent() {
      for (var i = 0; i < this._afterSaveMeshLocationListeners.length; ++i) {
        this._afterSaveMeshLocationListeners[i]();
      }
    }
  }, {
    key: "addAfterSaveMeshLocationListener",
    value: function addAfterSaveMeshLocationListener(listenerFunction) {
      this._afterSaveMeshLocationListeners.push(listenerFunction);
    }
  }]);
  return MeshLocationsManager;
}();

/***/ }),

/***/ "../../3D/src/Components/DesignManagers/MeshDesignManager.ts":
/*!*******************************************************************!*\
  !*** ../../3D/src/Components/DesignManagers/MeshDesignManager.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MeshDesignManager": () => (/* binding */ MeshDesignManager)
/* harmony export */ });
/* harmony import */ var _Helpers_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Helpers/debounce */ "../../3D/src/Helpers/debounce.ts");
/* harmony import */ var _NormalMap_ProceduralNormalMap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../NormalMap/ProceduralNormalMap */ "../../3D/src/Components/NormalMap/ProceduralNormalMap.ts");
/* harmony import */ var _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ProceduralTextures/ForegroundBackgroundProceduralTexture */ "../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../ProceduralTextures/MultiplyProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MultiplyProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../ProceduralTextures/OverlayProceduralTexture */ "../../3D/src/Components/ProceduralTextures/OverlayProceduralTexture.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
/* harmony import */ var _Shadows_InnerShadow__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Shadows/InnerShadow */ "../../3D/src/Components/Shadows/InnerShadow.ts");
/* harmony import */ var _Shadows_OuterShadow__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Shadows/OuterShadow */ "../../3D/src/Components/Shadows/OuterShadow.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }








var MeshDesignManager = /*#__PURE__*/function () {
  function MeshDesignManager(scene, zkScene, mesh, subMesh, zkModel, zkDesign) {
    var showDesign = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    var effect = arguments.length > 7 ? arguments[7] : undefined;
    var designTextureResolution = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1024;
    _classCallCheck(this, MeshDesignManager);
    _defineProperty(this, "_subMesh", null);
    _defineProperty(this, "_isRefreshing", false);
    _defineProperty(this, "_showDesign", true);
    _defineProperty(this, "_designTextureResolution", 1024);
    // effect.get("materialID") indica il material da utilizzare per il design
    // effect.get("config") indica la configurazione da applicare
    _defineProperty(this, "_effect", null);
    _defineProperty(this, "_meshSide", null);
    // mesh - model side connection
    _defineProperty(this, "_side", null);
    _defineProperty(this, "_isDisposed", false);
    _defineProperty(this, "_baseWidth", MeshDesignManager.DEFAULT_SIZE);
    _defineProperty(this, "_baseHeight", MeshDesignManager.DEFAULT_SIZE);
    _defineProperty(this, "_textureWidth", MeshDesignManager.DEFAULT_SIZE);
    _defineProperty(this, "_textureHeight", MeshDesignManager.DEFAULT_SIZE);
    _defineProperty(this, "_coordinatesIndex", 0);
    // canale UV per le texture
    _defineProperty(this, "_currentVisibliity", true);
    _defineProperty(this, "_canvasMesh", null);
    // mesh clone per l'applicazione della texture dinamica (generata in base al design rappresentato sul canvas)
    _defineProperty(this, "_originalCanvasMeshPosition", null);
    // Posizione originale della mesh clonata
    _defineProperty(this, "_originalCanvasMeshScaling", null);
    // Scaling originale della mesh clonata
    _defineProperty(this, "_normalmapMaterial", null);
    // materiale clonato per l'applicazione della normal map dinamica sulla mesh originale
    _defineProperty(this, "_originalMaterial", null);
    // materiale originale della mesh
    _defineProperty(this, "_blankDataUrl", null);
    // utile per verificare quando il canvas contiene un'immagine completamente vuota
    // L'esportazione per AR non supporta zOffset per i materiali. Una soluzione è quella di creare un clone
    // per la parte interna e uno per la parte esterna dell'oggetto, rispettivamente rimpicciolito e ingrandito di pochissimo
    // in modo da sovrapporsi all'oggetto originale. Resterebbe in questo modo scoperto solo la parte laterale dell'oggetto,
    // ma dovrebbe mitigare le problematiche. Un'alternativa sarebbe quella di usare MeshExpander per espandere l'oggetto in modo da
    // racchiuderlo, ma questo creerebbe un duplicato della gemoetria e non risolverebbe comunque il caso di oggetto piatto (senza spessore).
    _defineProperty(this, "_innerCanvasMesh", null);
    _defineProperty(this, "_outerCanvasMesh", null);
    _defineProperty(this, "_ownDynamicMaterial", false);
    _defineProperty(this, "_dynamicMaterial", null);
    // Materiale applicato alla mesh clonata per rappresentare il contenuto del canvas 
    _defineProperty(this, "_dynamicTexture", null);
    // Texture che contiene il contenuto del canvas
    _defineProperty(this, "_normalmapTexture", null);
    // Texture che contiene la normal map relativa al contenuto del canvas
    // La normal map può essere applicata sia al materiale della mesh (per effetto rilievo/incassato)
    // che alla mesh clonata per evidenziare il design
    _defineProperty(this, "_dynamicOpacityTexture", null);
    // Procedurale creata nel caso in cui il design debba essere utilizzato
    // come mappa di opacità
    _defineProperty(this, "_ownOldDynamicMaterial", false);
    _defineProperty(this, "_oldDynamicMaterial", null);
    _defineProperty(this, "_originalDiffuseTexture", null);
    _defineProperty(this, "_combinedDiffuseTexture", null);
    // Le due normal map texture seguenti verranno eventualmente combinate (blend overlay) con
    // la normalmap generata dinamicamente dal contenuto del canvas
    _defineProperty(this, "_originalMeshNormalmapTexture", null);
    // normalmap texture presente inizialmente sul materiale della mesh originale
    _defineProperty(this, "_originalDesignNormalmapTexture", null);
    // Normal map orignale del materiale da utilizzare per la mesh clonata (che ricerverà il contenuto del canvas)
    // Texture procedurali date dalla combinazione della texture dinamica dal canvas
    // con le texture presenti sui materiali originali
    _defineProperty(this, "_meshCombinedNormalmapTexture", null);
    _defineProperty(this, "_designCombinedNormalmapTexture", null);
    // Lightmaps utili per outer e inner shadow
    _defineProperty(this, "_originalMeshLightmapTexture", null);
    // da combinare con outer shadow
    _defineProperty(this, "_originalDesignLightmapTexture", null);
    // da combinare con inner shadow
    _defineProperty(this, "_meshCombinedLightmapTexture", null);
    // outer shadow finale
    _defineProperty(this, "_designCombinedLightmapTexture", null);
    // inner shadow finale
    _defineProperty(this, "_innerShadowTexture", null);
    _defineProperty(this, "_outerShadowTexture", null);
    _defineProperty(this, "_context", null);
    _defineProperty(this, "_canvas", null);
    _defineProperty(this, "_canvasID", Zakeke.generateUUID());
    _defineProperty(this, "_customizer", null);
    _defineProperty(this, "_renderingNeededListeners", []);
    // Generatore di texture procedurali per la normal map
    _defineProperty(this, "_proceduralNormalMap", null);
    // Generatore di texture procedurali per inner/outer shadow
    _defineProperty(this, "_innerShadowGenerator", null);
    _defineProperty(this, "_outerShadowGenerator", null);
    _defineProperty(this, "_debouncedUpdateDynamicTexture", null);
    _defineProperty(this, "_originalViewMatrixValues", null);
    _defineProperty(this, "_grids", []);
    // First render is not debounced, usefull for screenshots that must wait the
    // render to finish
    _defineProperty(this, "isFirstRender", true);
    this._scene = scene;
    this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper(scene);
    this._zkScene = zkScene;
    this._mesh = mesh;
    this._subMesh = subMesh;
    this._zkModel = zkModel;
    this._zkDesign = zkDesign;
    this._showDesign = showDesign;
    if (effect) this._effect = effect;
    this._baseWidth = designTextureResolution;
    this._baseHeight = designTextureResolution;
    this._textureWidth = designTextureResolution;
    this._textureHeight = designTextureResolution;

    //this.initAsync();
  }

  // Temporary until we can access internal matrix (speak with Matteo)
  _createClass(MeshDesignManager, [{
    key: "showDesign",
    get: function get() {
      return this._showDesign;
    },
    set: function set(value) {
      if (this._showDesign != value) {
        this._showDesign = value;
      }
    }
  }, {
    key: "side",
    get: function get() {
      return this._side;
    }
  }, {
    key: "getInternalCustomizer",
    value: function getInternalCustomizer() {
      return this._customizer;
    }

    // Factory method for async object creation and initialization
  }, {
    key: "initAsync",
    value: function () {
      var _initAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var rootUrl;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Just to be sure the mesh has the right material and not the dummy one
              rootUrl = this._zkScene.get("rootUrl");
              if (!rootUrl) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return this._sceneHelper.unsetMeshDummyMaterialAsync(this._mesh, rootUrl, true);
            case 4:
              this.setupMeshSide();
              this.checkDefaultEffect();
              this.refreshModelSide();
              _context.next = 9;
              return this.setupClonedObjectsAsync();
            case 9:
              _context.next = 11;
              return this.setupCanvasAsync();
            case 11:
              _context.next = 13;
              return this.setupDynamicMaterialAsync();
            case 13:
              _context.next = 15;
              return this.refreshAsync();
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initAsync() {
        return _initAsync.apply(this, arguments);
      }
      return initAsync;
    }()
  }, {
    key: "isForMesh",
    value: function isForMesh(mesh, subMesh) {
      if (!mesh || !this._mesh) return false;
      if (mesh.id !== this._mesh.id) return false;
      if (!this._subMesh && !subMesh) return true;
      if (!this._subMesh || !subMesh) return false;
      if (subMesh.materialIndex === this._subMesh.materialIndex) return true;
      return false;
      /*
      if (mesh && subMesh && this._mesh && this._subMesh &&
          mesh.id === this._mesh.id &&
          subMesh.materialIndex === this._subMesh.materialIndex) {
          return true;
      }
      else {
          return false;
      }
      */
    }
  }, {
    key: "getMeshID",
    value: function getMeshID() {
      return this._mesh ? this._mesh.id : null;
    }
  }, {
    key: "getSubMeshIdx",
    value: function getSubMeshIdx() {
      return this._subMesh ? this._subMesh.materialIndex : 0;
    }
  }, {
    key: "getMaterialIDForDesign",
    value: function getMaterialIDForDesign() {
      var materialID;
      if (this._effect && this._effect.get("materialID")) {
        materialID = this._effect.get("materialID");
      } else if (this._mesh && this._mesh.metadata && this._mesh.metadata.designMaterialID) {
        materialID = this._mesh.metadata.designMaterialID;
      } else if (this._meshSide && this._meshSide.get("materialID")) {
        materialID = this._meshSide.get("materialID");
      }
      return materialID;
    }
  }, {
    key: "getDesignConfig",
    value: function getDesignConfig() {
      var config;
      if (this._effect && this._effect.get("config")) {
        config = this._effect.get("config");
      } else if (this._meshSide && this._meshSide.get("config")) {
        config = this._meshSide.get("config");
      }
      if (!config) {
        config = new MPlaza.MeshDesignConfig();
      }
      return config;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._isDisposed = true;
      if (this._customizer) {
        this._customizer.clearMemoryForIOS();
        this._customizer = null;
      }
      this.disposeOuterInnerCanvasMeshes();
      if (this._canvasMesh) {
        this._canvasMesh.dispose();
        this._canvasMesh = null;
        this._originalCanvasMeshPosition = null;
        this._originalCanvasMeshScaling = null;
      }
      this.disposeDynamicMaterial();
      if (this._dynamicOpacityTexture) {
        this._dynamicOpacityTexture.dispose();
        this._dynamicOpacityTexture = null;
      }
      if (this._dynamicTexture) {
        this._dynamicTexture.dispose();
        this._dynamicTexture = null;
      }
      this._renderingNeededListeners = [];
      $("#" + this._canvasID).remove();
      this.restoreOrignalMaterial();
      this.disposeNormalmapMaterial();
      if (this._proceduralNormalMap) {
        this._proceduralNormalMap.dispose();
        this._proceduralNormalMap = null;
      }
      if (this._innerShadowGenerator) {
        this._innerShadowGenerator.dispose();
        this._innerShadowGenerator = null;
      }
      if (this._combinedDiffuseTexture) {
        this._combinedDiffuseTexture.dispose();
        this._combinedDiffuseTexture = null;
      }
      if (this._meshCombinedNormalmapTexture) {
        this._meshCombinedNormalmapTexture.dispose();
        this._meshCombinedNormalmapTexture = null;
      }
      if (this._designCombinedNormalmapTexture) {
        this._designCombinedNormalmapTexture.dispose();
        this._designCombinedNormalmapTexture = null;
      }
      if (this._meshCombinedLightmapTexture) {
        this._meshCombinedLightmapTexture.dispose();
        this._meshCombinedLightmapTexture = null;
      }
      if (this._designCombinedLightmapTexture) {
        this._designCombinedLightmapTexture.dispose();
        this._designCombinedLightmapTexture = null;
      }
    }
  }, {
    key: "disposeOuterInnerCanvasMeshes",
    value: function disposeOuterInnerCanvasMeshes() {
      if (this._innerCanvasMesh) {
        this._innerCanvasMesh.dispose();
        this._innerCanvasMesh = null;
      }
      if (this._outerCanvasMesh) {
        this._outerCanvasMesh.dispose();
        this._outerCanvasMesh = null;
      }
    }
  }, {
    key: "disposeNormalmapMaterial",
    value: function disposeNormalmapMaterial() {
      if (this._normalmapMaterial && this._originalMaterial && this._normalmapMaterial.id !== this._originalMaterial.id && this._sceneHelper.getMeshesUsingMaterial(this._normalmapMaterial.id).length == 0) {
        this._normalmapMaterial.dispose();
        this._normalmapMaterial = null;
      }
      this._originalMeshNormalmapTexture = null;
      this._originalMeshLightmapTexture = null;
    }
  }, {
    key: "disposeDynamicMaterial",
    value: function disposeDynamicMaterial() {
      if (this._ownDynamicMaterial && this._dynamicMaterial) {
        this._dynamicMaterial.dispose();
      }
      this._dynamicMaterial = null;
      this._originalDesignNormalmapTexture = null;
      this._originalDesignLightmapTexture = null;
    }
  }, {
    key: "disposeOldDynamicMaterial",
    value: function disposeOldDynamicMaterial() {
      if (this._ownOldDynamicMaterial && this._oldDynamicMaterial && this._dynamicMaterial && this._oldDynamicMaterial != this._dynamicMaterial) {
        this._oldDynamicMaterial.dispose();
      }
      this._oldDynamicMaterial = null;
    }
  }, {
    key: "createCanvasMeshClone",
    value: function createCanvasMeshClone(name) {
      if (this._canvasMesh) {
        var clone = this._canvasMesh.clone(name, null);
        if (clone) {
          clone.id = Zakeke.generateUUID();
          if (this._canvasMesh.metadata && this._canvasMesh.metadata.AR !== undefined && this._canvasMesh.metadata.AR !== null) {
            if (!clone.metadata) clone.metadata = {};
            clone.metadata.AR = this._canvasMesh.metadata.AR;
          }
          return clone;
        }
      }
      return null;
    }
  }, {
    key: "expandCanvasMesh",
    value: function expandCanvasMesh() {
      if (!this._mesh || !this._canvasMesh) return;
      this.disposeOuterInnerCanvasMeshes();
      var scaling = this._mesh.scaling;
      var delta = 0.01;
      var scaleUp = 1.0 + delta;
      var scaleDown = 1.0 - delta;
      var meshSize = this.getMeshHierarchySize(this._mesh);
      var canvasMeshSize = this.getMeshHierarchySize(this._canvasMesh);

      // La mesh originale e il clone devono avere le stesse dimensioni iniziali
      if (!meshSize.equals(canvasMeshSize)) return;
      var meshCenter = this.getMeshHierarchyCenter(this._mesh);
      this._outerCanvasMesh = this.createCanvasMeshClone(this._mesh.name + " outer clone");
      //this._innerCanvasMesh = this.createCanvasMeshClone(this._mesh.name + " inner clone");

      this._canvasMesh.isVisible = false;
      if (this._outerCanvasMesh) {
        var epsilon = 0.1;
        var isPlane = Math.abs(meshSize.x) <= epsilon || Math.abs(meshSize.y) <= epsilon || Math.abs(meshSize.z) <= epsilon;
        if (!isPlane) {
          // Scale up outer mesh
          var scalingOuter = scaling.multiplyByFloats(scaleUp, scaleUp, scaleUp);
          this._outerCanvasMesh.scaling = scalingOuter;
          var outerCenter = this.getMeshHierarchyCenter(this._outerCanvasMesh);
          var deltaVect = meshCenter.subtract(outerCenter);
          if (!deltaVect.equals(BABYLON.Vector3.Zero())) {
            this._outerCanvasMesh.position.addInPlace(deltaVect);
          }

          // Scale down inner mesh
          //const scalingInner = scaling.multiplyByFloats(scaleDown, scaleDown, scaleDown);
          //this._innerCanvasMesh.scaling = scalingInner;

          //const innerCenter = this.getMeshHierarchyCenter(this._innerCanvasMesh);

          //deltaVect = meshCenter.subtract(innerCenter);
          //if (!deltaVect.equals(BABYLON.Vector3.Zero())) {
          //    this._innerCanvasMesh.position.addInPlace(deltaVect);
          //}
        } else {
          // se è un piano sposto la mesh leggermente nella direzione della normale
          var normals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
          var normal = BABYLON.Vector3.FromArray(normals, 0).normalize();
          this._outerCanvasMesh.position = this._outerCanvasMesh.position.add(normal.scale(delta));
          //this._innerCanvasMesh.position = this._innerCanvasMesh.position.add(normal.scale(-delta));
        }
      }
    }

    // Nel caso in cui la mesh non sia un piano, espande la mesh clone in modo che 
    // racchiuda quella originale e che eviti il problema z- fighting. 
    // Nel caso in cui si tratti di un piano (o di un disco o equivalenti), la mesh clone verrà solo
    // spostata leggermente nella direzione della normale al piano
    // Tale possibilità verrà sfruttata soprattutto in fase di esportazione in altro formato che non preveda
    // proprietà simili al zOffset di Babylon JS
  }, {
    key: "expandCanvasMesh_old",
    value: function expandCanvasMesh_old() {
      if (!this._mesh || !this._canvasMesh) return;
      var delta = 0.01;
      var scale = 1.0 + delta;
      var meshSize = this.getMeshHierarchySize(this._mesh);
      var canvasMeshSize = this.getMeshHierarchySize(this._canvasMesh);

      // La mesh originale e il clone devono avere le stesse dimensioni iniziali
      if (!meshSize.equals(canvasMeshSize)) return;
      var epsilon = 0.1;
      var isPlane = Math.abs(meshSize.x) <= epsilon || Math.abs(meshSize.y) <= epsilon || Math.abs(meshSize.z) <= epsilon;
      if (!isPlane) {
        var scaling = this._canvasMesh.scaling;
        scaling = scaling.multiplyByFloats(scale, scale, scale);
        this._canvasMesh.scaling = scaling;

        // Nel caso in cui il pivot non sia al centro della mesh
        // lo scaling del clone lo avrà anche spostato
        var meshCenter = this.getMeshHierarchyCenter(this._mesh);
        var canvasMeshCenter = this.getMeshHierarchyCenter(this._canvasMesh);
        var deltaVect = meshCenter.subtract(canvasMeshCenter);
        if (!deltaVect.equals(BABYLON.Vector3.Zero())) {
          this._canvasMesh.position.addInPlace(deltaVect);
        }
      } else {
        // se è un piano sposto la mesh leggermente nella direzione della normale
        var normals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
        var normal = BABYLON.Vector3.FromArray(normals, 0).normalize();
        this._canvasMesh.position = this._canvasMesh.position.add(normal.scale(delta));
      }
    }
  }, {
    key: "contractCanvasMesh",
    value: function contractCanvasMesh() {
      if (this._canvasMesh) this._canvasMesh.isVisible = true;
      this.disposeOuterInnerCanvasMeshes();
    }

    // Riporta la mesh clone allo stato originale, continuando a sfruttare unicamente la proprietà
    // zOffset per superare il problema dello z-fighting
  }, {
    key: "contractCanvasMesh_old",
    value: function contractCanvasMesh_old() {
      if (!this._mesh || !this._canvasMesh || !this._originalCanvasMeshScaling || !this._originalCanvasMeshPosition) return;
      this._canvasMesh.scaling = this._originalCanvasMeshScaling;
      this._canvasMesh.position = this._originalCanvasMeshPosition;

      // Verifico che il centro coincida
      var meshCenter = this.getMeshHierarchyCenter(this._mesh);
      var canvasMeshCenter = this.getMeshHierarchyCenter(this._canvasMesh);
      var deltaVect = meshCenter.subtract(canvasMeshCenter);
      if (!deltaVect.equals(BABYLON.Vector3.Zero())) {
        this._canvasMesh.position.addInPlace(deltaVect);
      }
    }
  }, {
    key: "setupMeshSide",
    value: function setupMeshSide() {
      this._meshSide = null;
      this._coordinatesIndex = 0;
      if (this._zkModel && this._mesh && this._mesh.id) {
        for (var i = 0; i < this._zkModel.get("scenes").length; i++) {
          var scene = this._zkModel.get("scenes").at(i);
          if (scene.get("isDefault")) {
            // Scena di default
            for (var j = 0; j < scene.get("meshSides").length; j++) {
              var meshSide = scene.get("meshSides").at(j);
              if (meshSide.get("meshID") == this._mesh.id) {
                this._meshSide = meshSide;
                if (this._meshSide.get("uvChannel") >= 0) this._coordinatesIndex = this._meshSide.get("uvChannel");
                return;
              }
            }
          }
        }
      }
    }
  }, {
    key: "checkDefaultEffect",
    value: function checkDefaultEffect() {
      if (!this._effect && this._meshSide) {
        var modelScene = this._meshSide.getParentModel();
        if (modelScene && modelScene instanceof MPlaza.ModelScene) {
          var meshID = this.getMeshID();
          if (meshID) {
            var effect = modelScene.getDefaultDesignEffect(meshID, this.getSubMeshIdx());
            if (effect) this._effect = effect;
          }
        }
      }
    }
  }, {
    key: "getAllSides",
    value: function getAllSides() {
      var sides = [];
      this._zkModel.get('colors').each(function (color) {
        color.get("sides").each(function (side) {
          if (!sides.find(function (x) {
            return x.get("sideID") == side.get("sideID");
          })) {
            sides.push(side);
          }
        });
      });
      return sides;
    }

    // Recupera il lato del modello corrispondente alla mesh in input
    // Del lato abbiamo solo sideID, mentre per il modello i lati sono per colore. Recuperiamo il colorID
    // in base agli elementi del design, considerando buono il primo colore con elementi grafici
  }, {
    key: "refreshModelSide",
    value: function refreshModelSide() {
      var _this = this;
      this._side = null;
      if (this._meshSide && this._zkDesign) {
        var _sideID = this._meshSide.get("sideID");
        var tempID = this._meshSide.tempID;
        var side = null;

        // Find the first side available so we can get all items on the side
        side = this.getAllSides().find(function (side) {
          return side.get("sideID") == _sideID;
        }) || null;
        if (side) {
          var designItem = null;
          var _iterator = _createForOfIteratorHelper(this._zkDesign.get("designItems").models),
            _step;
          try {
            var _loop = function _loop() {
              var _designItem = _step.value;
              designItem = _designItem;
              if (designItem.isOnSide(side)) {
                // Get the correct color from the design item
                var colorID = designItem && designItem.get("areas").length > 0 ? designItem.get("areas").at(0).get("colorID") : null;

                // Find the correct side of the correct color
                if (colorID) {
                  _this._zkModel.get("colors").each(function (color) {
                    if (color.get("colorID") == colorID) color.get("sides").each(function (_side) {
                      if (_side.tempID ? _side.tempID == tempID : _side.get("sideID") == _sideID) {
                        side = _side;
                      }
                    });
                  });
                }
                return "break";
              }
            };
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _ret = _loop();
              if (_ret === "break") break;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          this._side = side;
        }
      }
    }
  }, {
    key: "setupClonedObjectsAsync",
    value: function () {
      var _setupClonedObjectsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var i, mesh, name;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this._side) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              i = 0;
            case 3:
              if (!(i < this._scene.meshes.length)) {
                _context2.next = 15;
                break;
              }
              mesh = this._scene.meshes[i];
              if (!(mesh && mesh.metadata && mesh.metadata.originalMeshID && mesh.metadata.originalMeshID == this._mesh.id)) {
                _context2.next = 12;
                break;
              }
              this._canvasMesh = mesh;
              this._canvasMesh.isVisible = this._currentVisibliity;
              this._normalmapMaterial = this._mesh.material;
              this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial);
              this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial);
              return _context2.abrupt("break", 15);
            case 12:
              i++;
              _context2.next = 3;
              break;
            case 15:
              if (!this._canvasMesh) {
                name = this._mesh.name + " - clone";
                this._canvasMesh = this._mesh.clone(name, null);
                if (this._canvasMesh) {
                  this._canvasMesh.id = Zakeke.generateUUID();
                  this._canvasMesh.isVisible = this._currentVisibliity;
                  this._canvasMesh.doNotSerialize = true;
                  this._canvasMesh.isPickable = false;
                  this._canvasMesh.metadata = {};
                  this._canvasMesh.metadata.originalMeshID = this._mesh.id;
                  this._canvasMesh.metadata.isRealMesh = false;
                  this._canvasMesh.metadata.iscanvasMesh = true;
                  if (this._mesh.metadata && this._mesh.metadata.AR !== undefined && this._mesh.metadata.AR !== null) this._canvasMesh.metadata.AR = this._mesh.metadata.AR;
                }
              }
              if (this._canvasMesh) {
                this._originalCanvasMeshPosition = this._canvasMesh.position;
                this._originalCanvasMeshScaling = this._canvasMesh.scaling;
              }
              if (this._normalmapMaterial) {
                _context2.next = 20;
                break;
              }
              _context2.next = 20;
              return this.setupNormalmapMaterialAsync();
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setupClonedObjectsAsync() {
        return _setupClonedObjectsAsync.apply(this, arguments);
      }
      return setupClonedObjectsAsync;
    }() // Prepara il materiale per la normalmap da applicare alla mesh originale
    // posizionata sotto quella su cui è apposto il design.
    // Tale materiale viene utilizzato anche per l'eventuale lightmap di dropshadow (outer shadow)
    // quindi il nome andrebbe cambiato
  }, {
    key: "setupNormalmapMaterialAsync",
    value: function () {
      var _setupNormalmapMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var materialId, materialName;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.disposeNormalmapMaterial();
              this._originalMaterial = this._mesh.material;
              materialId = Zakeke.generateUUID();
              materialName = "normalmapMaterial - " + materialId;
              if (!this._originalMaterial) {
                _context3.next = 11;
                break;
              }
              materialName = this._originalMaterial.name + " - clone";
              _context3.next = 8;
              return this.cloneMaterialAsync(this._originalMaterial, materialName);
            case 8:
              this._normalmapMaterial = _context3.sent;
              _context3.next = 12;
              break;
            case 11:
              this._normalmapMaterial = new BABYLON.StandardMaterial(materialName, this._scene);
            case 12:
              if (this._normalmapMaterial) {
                this._normalmapMaterial.id = materialId;
                this._normalmapMaterial.doNotSerialize = true;
                this._normalmapMaterial.metadata = {};
                if (this._originalMaterial) this._normalmapMaterial.metadata.originalMaterialID = this._originalMaterial.id;else this._normalmapMaterial.metadata.originalMaterialID = null;
                this._normalmapMaterial.metadata.isRealMaterial = false;
                this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial);
                this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial);
              }
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function setupNormalmapMaterialAsync() {
        return _setupNormalmapMaterialAsync.apply(this, arguments);
      }
      return setupNormalmapMaterialAsync;
    }()
  }, {
    key: "getOriginalTexture",
    value: function getOriginalTexture() {
      if (this._originalMaterial) {
        var propertyName = this.getMaterialDiffuseTexturePropertyName(this._originalMaterial);
        if (!this._originalMaterial[propertyName]) return null;
        return this._originalMaterial[propertyName];
      }
      return null;
    }
  }, {
    key: "getMaterialDiffuseTexturePropertyName",
    value: function getMaterialDiffuseTexturePropertyName(material) {
      if (material instanceof BABYLON.StandardMaterial) {
        return "diffuseTexture";
      } else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
        return "baseTexture";
      } else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
        return "diffuseTexture";
      } else if (material instanceof BABYLON.PBRMaterial) {
        return "albedoTexture";
      } else if (material instanceof Zakeke.PBRMaterial) {
        return "albedoTexture";
      }
      return "diffuseTexture";
    }
  }, {
    key: "getMaterialOpacityTexturePropertyName",
    value: function getMaterialOpacityTexturePropertyName(material) {
      if (material instanceof BABYLON.StandardMaterial) {
        return "opacityTexture";
      } else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
        return null;
      } else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
        return null;
      } else if (material instanceof BABYLON.PBRMaterial) {
        return "opacityTexture";
      } else if (material instanceof Zakeke.PBRMaterial) {
        return "opacityTexture";
      }
      return "opacityTexture";
    }
  }, {
    key: "getMaterialNormalmapTexturePropertyName",
    value: function getMaterialNormalmapTexturePropertyName(material) {
      if (material instanceof BABYLON.StandardMaterial) {
        return "bumpTexture";
      } else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
        return "normalTexture";
      } else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
        return "normalTexture";
      } else if (material instanceof BABYLON.PBRMaterial) {
        return "bumpTexture";
      } else if (material instanceof Zakeke.PBRMaterial) {
        return "bumpTexture";
      }
      return "bumpTexture";
    }
  }, {
    key: "getMaterialLightmapTexturePropertyName",
    value: function getMaterialLightmapTexturePropertyName(material) {
      if (material instanceof BABYLON.StandardMaterial) {
        return "ambientTexture";
      } else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
        return "occlusionTexture";
      } else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
        return "occlusionTexture";
      } else if (material instanceof BABYLON.PBRMaterial) {
        return "ambientTexture";
      } else if (material instanceof Zakeke.PBRMaterial) {
        return "aoTexture";
      }
      return "lightmapTexture";
    }
  }, {
    key: "getMaterialDiffuse",
    value: function getMaterialDiffuse(material) {
      var propName = this.getMaterialDiffuseTexturePropertyName(material);
      return material[propName];
    }
  }, {
    key: "getMaterialNormalmap",
    value: function getMaterialNormalmap(material) {
      if (!material) return null;
      var propName = this.getMaterialNormalmapTexturePropertyName(material);
      return material[propName];
    }
  }, {
    key: "getMaterialLightmap",
    value: function getMaterialLightmap(material) {
      if (!material) return null;
      var propName = this.getMaterialLightmapTexturePropertyName(material);
      return material[propName];
    }
  }, {
    key: "getMaterialOpacity",
    value: function getMaterialOpacity(material) {
      if (!material) return null;
      var propName = this.getMaterialOpacityTexturePropertyName(material);
      if (propName) return material[propName];
      return null;
    }
  }, {
    key: "setMaterialLightmap",
    value: function setMaterialLightmap(material, texture) {
      if (!material) return;
      var propName = this.getMaterialLightmapTexturePropertyName(material);
      material[propName] = texture;
      if (material instanceof Zakeke.PBRMaterial) {
        material.useAOTextureAsLightmap = true;
      }
    }
  }, {
    key: "setTextureWrapping",
    value: function setTextureWrapping(texture) {
      if (texture) {
        texture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE;
        texture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE;
      }
    }
  }, {
    key: "setupCanvasAsync",
    value: function () {
      var _setupCanvasAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this2 = this;
        var width, height, $canvas;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(this._side && this._canvasMesh && this._meshSide && !this._isRefreshing)) {
                _context10.next = 23;
                break;
              }
              this._isRefreshing = true;
              width = this._baseWidth;
              if (this._meshSide.get("percWidth") > 0) width *= this._meshSide.get("percWidth");
              height = this._baseHeight;
              if (this._meshSide.get("percHeight") > 0) height *= this._meshSide.get("percHeight");
              this._textureWidth = width;
              this._textureHeight = height;

              // creo un offset canvas su cui eseguire il disegno
              $canvas = $("<canvas>", {
                id: this._canvasID
              }).attr({
                width: width,
                height: height
              });
              this._canvas = $canvas[0];

              /* Debug canvas 
              document.body.appendChild(this._canvas);
              this._canvas.style.background = 'red';
              this._canvas.style.position = 'fixed';
              this._canvas.style.left = '0';
              this._canvas.style.top = '0';
              this._canvas.style.width = '200px';
              this._canvas.style.height = '200px';
              this._canvas.style.zIndex = '10000';*/

              this._context = this._canvas.getContext("2d");
              if (!this._context) {
                _context10.next = 23;
                break;
              }
              this._context["imageSmoothingQuality"] = "high";
              this._context.imageSmoothingEnabled = true;
              this._customizer = new MPlaza.Customizer(true, false, this._canvas, true);
              this._blankDataUrl = this._canvas.toDataURL();
              this._customizer.showSideImage = false;
              this._customizer.model = this._zkModel;
              this._customizer.fitToScreenMargin = 1;
              this._customizer.setGrids(this._grids);
              this._customizer.setDesign(this._zkDesign);
              _context10.next = 23;
              return new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(resolve) {
                  var _this2$_customizer, _this2$_customizer2;
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _context9.next = 2;
                        return (_this2$_customizer = _this2._customizer) === null || _this2$_customizer === void 0 ? void 0 : _this2$_customizer.setSide(_this2._side);
                      case 2:
                        (_this2$_customizer2 = _this2._customizer) === null || _this2$_customizer2 === void 0 ? void 0 : _this2$_customizer2.refresh({
                          boundsToAreas: true
                        }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                          var valuesJson, values, matrix;
                          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                            while (1) switch (_context8.prev = _context8.next) {
                              case 0:
                                if (!_this2._customizer) {
                                  _context8.next = 8;
                                  break;
                                }
                                if (_this2._meshSide) {
                                  valuesJson = _this2._meshSide.get("matrix");
                                  if (valuesJson) {
                                    values = JSON.parse(valuesJson);
                                    matrix = new _this2._customizer.paper.Matrix(values);
                                    _this2._customizer.paper.view.matrix = matrix;
                                    _this2._customizer.paper.view.update();
                                  }
                                }
                                _context8.next = 4;
                                return _this2.updateDynamicTextureAsync();
                              case 4:
                                // Attach events only after the first rendering 
                                // to avoid concurrent updates
                                _this2._customizer.addItemCreatedListener( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                                    while (1) switch (_context4.prev = _context4.next) {
                                      case 0:
                                        _context4.next = 2;
                                        return _this2.updateDynamicTextureAsync();
                                      case 2:
                                        _this2.fireRenderingNeededEvent();
                                      case 3:
                                      case "end":
                                        return _context4.stop();
                                    }
                                  }, _callee4);
                                })));
                                _this2._customizer.addItemChangedListener( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
                                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                                    while (1) switch (_context5.prev = _context5.next) {
                                      case 0:
                                        _context5.next = 2;
                                        return _this2.updateDynamicTextureAsync();
                                      case 2:
                                        _this2.fireRenderingNeededEvent();
                                      case 3:
                                      case "end":
                                        return _context5.stop();
                                    }
                                  }, _callee5);
                                })));
                                _this2._customizer.addItemRemovedListener( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
                                  return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                                    while (1) switch (_context6.prev = _context6.next) {
                                      case 0:
                                        _context6.next = 2;
                                        return _this2.updateDynamicTextureAsync();
                                      case 2:
                                        _this2.fireRenderingNeededEvent();
                                      case 3:
                                      case "end":
                                        return _context6.stop();
                                    }
                                  }, _callee6);
                                })));
                                _this2._customizer.addImageLoadedListener( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                                    while (1) switch (_context7.prev = _context7.next) {
                                      case 0:
                                        _context7.next = 2;
                                        return _this2.updateDynamicTextureAsync();
                                      case 2:
                                        _this2.fireRenderingNeededEvent();
                                      case 3:
                                      case "end":
                                        return _context7.stop();
                                    }
                                  }, _callee7);
                                })));
                              case 8:
                                resolve();
                              case 9:
                              case "end":
                                return _context8.stop();
                            }
                          }, _callee8);
                        })));
                      case 3:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 23:
              this._isRefreshing = false;
            case 24:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function setupCanvasAsync() {
        return _setupCanvasAsync.apply(this, arguments);
      }
      return setupCanvasAsync;
    }()
  }, {
    key: "setCustomizerGrids",
    value: function setCustomizerGrids(grids) {
      var _this$_customizer;
      this._grids = grids;
      (_this$_customizer = this._customizer) === null || _this$_customizer === void 0 ? void 0 : _this$_customizer.setGrids(grids);
    }

    // Ripristino il materiale originale sulla mesh, a meno che non sia stato già cambiato
  }, {
    key: "restoreOrignalMaterial",
    value: function restoreOrignalMaterial() {
      if (this._mesh && this._originalMaterial && this._mesh.material && this._normalmapMaterial && this._mesh.material.id === this._normalmapMaterial.id) {
        this._mesh.material = this._originalMaterial;
      }
    }
  }, {
    key: "getMeshesUsingMaterial",
    value: function getMeshesUsingMaterial(materialID) {
      var meshes = [];
      var allMeshes = this._scene.meshes;
      for (var i = 0; i < allMeshes.length; i++) {
        var mesh = allMeshes[i];
        if (mesh.material) {
          if (mesh.material.id == materialID) {
            meshes.push(mesh);
          } else if (mesh.material instanceof BABYLON.MultiMaterial) {
            for (var k = 0; k < mesh.material.subMaterials.length; k++) {
              var subMaterial = mesh.material.subMaterials[k];
              if (subMaterial != null && subMaterial.id === materialID) {
                meshes.push(mesh);
                break;
              }
            }
          }
        }
      }
      return meshes;
    }
  }, {
    key: "checkNormalmapMaterialAsync",
    value: function () {
      var _checkNormalmapMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var changed;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              changed = this._mesh && this._normalmapMaterial && (!this._mesh.material || this._mesh.material.id !== this._normalmapMaterial.id);
              if (!changed) {
                _context11.next = 4;
                break;
              }
              _context11.next = 4;
              return this.setupNormalmapMaterialAsync();
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function checkNormalmapMaterialAsync() {
        return _checkNormalmapMaterialAsync.apply(this, arguments);
      }
      return checkNormalmapMaterialAsync;
    }() // Se il materiale associato alla mesh è cambiato lo ricrea
  }, {
    key: "checkDynamicMaterialAsync",
    value: function () {
      var _checkDynamicMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var materialID, changed;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              materialID = this.getMaterialIDForDesign();
              if (!materialID) {
                _context12.next = 6;
                break;
              }
              changed = this._side && this._canvasMesh && this._meshSide && this._dynamicMaterial && this._dynamicMaterial.id != materialID;
              if (!changed) {
                _context12.next = 6;
                break;
              }
              _context12.next = 6;
              return this.setupDynamicMaterialAsync();
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function checkDynamicMaterialAsync() {
        return _checkDynamicMaterialAsync.apply(this, arguments);
      }
      return checkDynamicMaterialAsync;
    }()
  }, {
    key: "setupDynamicMaterialAsync",
    value: function () {
      var _setupDynamicMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var materialID, dynMaterial, dynamicMaterial;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!(this._side && this._canvasMesh && this._meshSide)) {
                _context13.next = 18;
                break;
              }
              this._ownOldDynamicMaterial = this._ownDynamicMaterial;
              this._oldDynamicMaterial = this._dynamicMaterial;
              materialID = this.getMaterialIDForDesign();
              if (!materialID) {
                _context13.next = 11;
                break;
              }
              dynMaterial = this._scene.getMaterialByID(materialID);
              if (!dynMaterial) {
                _context13.next = 11;
                break;
              }
              _context13.next = 9;
              return this.cloneMaterialAsync(dynMaterial, dynMaterial.name + " - clone");
            case 9:
              this._dynamicMaterial = _context13.sent;
              this._ownDynamicMaterial = true;
            case 11:
              if (!this._dynamicMaterial) {
                if (this._mesh.material && this._mesh.material instanceof BABYLON.PBRBaseMaterial) {
                  dynamicMaterial = new BABYLON.PBRMaterial("dynamicMaterial", this._scene);
                  dynamicMaterial.enableSpecularAntiAliasing = true;
                  dynamicMaterial.backFaceCulling = false;
                  dynamicMaterial.albedoColor = BABYLON.Color3.White();
                  dynamicMaterial.reflectivityColor = BABYLON.Color3.Black();
                  if (this._mesh.material["subSurface"]["indexOfRefraction"] != undefined) dynamicMaterial.subSurface.indexOfRefraction = this._mesh.material["subSurface"]["indexOfRefraction"];
                  if (this._mesh.material["roughness"] != undefined) dynamicMaterial.roughness = this._mesh.material["roughness"];
                  if (this._mesh.material["metallic"] != undefined) dynamicMaterial.metallic = this._mesh.material["metallic"];
                  if (this._mesh.material["reflectionTexture"] != undefined) dynamicMaterial.reflectionTexture = this._mesh.material["reflectionTexture"];
                  if (this._mesh.material["microSurface"] != undefined) dynamicMaterial.microSurface = this._mesh.material["microSurface"];
                  this._dynamicMaterial = dynamicMaterial;
                } else {
                  this._dynamicMaterial = new BABYLON.StandardMaterial("dynamicMaterial", this._scene);
                  this._dynamicMaterial.backFaceCulling = false;
                  this._dynamicMaterial.specularColor = BABYLON.Color3.Black();
                  this._dynamicMaterial.ambientColor = BABYLON.Color3.White();
                  this._dynamicMaterial.diffuseColor = BABYLON.Color3.White();
                }
                this._dynamicMaterial.id = Zakeke.generateUUID();
                this._ownDynamicMaterial = true;

                /*
                this._dynamicMaterial = new BABYLON.StandardMaterial("dynamicMaterial", this._scene);
                this._dynamicMaterial.id = Zakeke.generateUUID();
                (this._dynamicMaterial as BABYLON.StandardMaterial).specularColor = BABYLON.Color3.Black();
                this._ownDynamicMaterial = true;
                //this.dynamicMaterial.diffuseTexture = this.dynamicTexture;
                */
              }

              this._dynamicMaterial.zOffset = -1;
              this._dynamicMaterial.metadata = {
                isRealMaterial: false
              };
              this._dynamicMaterial.doNotSerialize = true;
              this._originalDiffuseTexture = this.getMaterialDiffuse(this._dynamicMaterial);
              this._originalDesignNormalmapTexture = this.getMaterialNormalmap(this._dynamicMaterial);
              this._originalDesignLightmapTexture = this.getMaterialLightmap(this._dynamicMaterial);

              // Imposto il materiale solo quando è pronta la texture
              // altrimenti per qualche istante apparirebbe il materiale standard grigio/bianco
              //this.canvasMesh.material = this.dynamicMaterial;
            case 18:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function setupDynamicMaterialAsync() {
        return _setupDynamicMaterialAsync.apply(this, arguments);
      }
      return setupDynamicMaterialAsync;
    }()
    /*
    private whenTextureIsReadyAsync(texture: BABYLON.BaseTexture): Promise<void> {
        return new Promise<void>((resolve, reject) => {
              let t = setInterval(() => {
                if (texture.isReady()) {
                    clearInterval(t);
                    if (texture instanceof BABYLON.ProceduralTexture)
                        texture.getEffect();
                    resolve();
                }
            }, 5);
          });
    }
    */
  }, {
    key: "cloneMaterialAsync",
    value: function () {
      var _cloneMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(material, name) {
        var textures, newName, rootUrl, serialized, deserialized;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!material) {
                _context15.next = 14;
                break;
              }
              textures = material.getActiveTextures();
              textures.forEach( /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(txt) {
                  return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                    while (1) switch (_context14.prev = _context14.next) {
                      case 0:
                        _context14.next = 2;
                        return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(txt);
                      case 2:
                      case "end":
                        return _context14.stop();
                    }
                  }, _callee14);
                }));
                return function (_x4) {
                  return _ref7.apply(this, arguments);
                };
              }());

              //let promises: Promise<void>[] = [];

              //var textures = material.getActiveTextures();
              //textures.forEach((txt) => {
              //    promises.push(SceneHelper.whenTextureIsReadyAsync(txt));
              //});

              //await Promise.all(promises);
              newName = name || material.name + " - clone";
              if (!(material instanceof BABYLON.ShaderMaterial)) {
                _context15.next = 13;
                break;
              }
              rootUrl = this._zkScene.get("rootUrl");
              if (rootUrl) {
                _context15.next = 8;
                break;
              }
              return _context15.abrupt("return", null);
            case 8:
              serialized = material.serialize();
              deserialized = BABYLON.Material.Parse(serialized, this._scene, rootUrl);
              return _context15.abrupt("return", deserialized);
            case 13:
              return _context15.abrupt("return", material.clone(newName));
            case 14:
              return _context15.abrupt("return", null);
            case 15:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function cloneMaterialAsync(_x2, _x3) {
        return _cloneMaterialAsync.apply(this, arguments);
      }
      return cloneMaterialAsync;
    }()
  }, {
    key: "getMeshHierarchySize",
    value: function getMeshHierarchySize(mesh) {
      var boundingBox = mesh.getHierarchyBoundingVectors(true);
      var size = boundingBox.max.subtract(boundingBox.min);
      return size;
    }
  }, {
    key: "getMeshHierarchyCenter",
    value: function getMeshHierarchyCenter(mesh) {
      var boundingBox = mesh.getHierarchyBoundingVectors(true);
      var size = boundingBox.max.subtract(boundingBox.min);
      var center = boundingBox.min.add(size.scale(0.5));
      return center;
    }
  }, {
    key: "refreshAsync",
    value: function () {
      var _refreshAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(effect) {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (!this._isRefreshing) {
                _context17.next = 2;
                break;
              }
              return _context17.abrupt("return");
            case 2:
              this._isRefreshing = true;
              if (typeof effect !== "undefined") this._effect = effect;
              _context17.next = 6;
              return this.checkDynamicMaterialAsync();
            case 6:
              _context17.next = 8;
              return this.checkNormalmapMaterialAsync();
            case 8:
              // Always check a better model side. 
              // E.g, when running from a template without items, we can't know the correct colorID => sideID until
              // we add some item. But, for configurator we must select at last the first variant or we will be unable
              // to add any elements
              this.refreshModelSide();

              /*
              if (this._side && this._customizer) {
                  this._customizer.refresh({ boundsToAreas: true });
              
                  // apply matrix to view
                  if (this._meshSide) {
                      let valuesJson = this._meshSide.get("matrix");
                      if (valuesJson) {
                          var values = JSON.parse(valuesJson);
                          this._customizer.appendViewMatrix(values);
                      }
                  }
              
                  await this.updateDynamicTextureAsync();
              }
              */
              _context17.next = 11;
              return new Promise( /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(resolve) {
                  var _this3$_customizer, _this3$_customizer2, valuesJson, values, matrix;
                  return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        if (!(_this3._meshSide && _this3.side && _this3._customizer)) {
                          _context16.next = 11;
                          break;
                        }
                        _context16.next = 3;
                        return (_this3$_customizer = _this3._customizer) === null || _this3$_customizer === void 0 ? void 0 : _this3$_customizer.setSide(_this3.side);
                      case 3:
                        _context16.next = 5;
                        return (_this3$_customizer2 = _this3._customizer) === null || _this3$_customizer2 === void 0 ? void 0 : _this3$_customizer2.rebuildItems();
                      case 5:
                        if (_this3._meshSide) {
                          valuesJson = _this3._meshSide.get("matrix");
                          if (valuesJson && _this3._customizer) {
                            values = JSON.parse(valuesJson);
                            matrix = new _this3._customizer.paper.Matrix(values);
                            _this3._customizer.paper.view.matrix = matrix;
                            _this3._customizer.paper.view.update();
                          }
                        }
                        _context16.next = 8;
                        return _this3.updateDynamicTextureAsync();
                      case 8:
                        resolve();
                        _context16.next = 12;
                        break;
                      case 11:
                        resolve();
                      case 12:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee16);
                }));
                return function (_x6) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 11:
              console.log("refreshAsync finish", this._isRefreshing, this._mesh.name);
              this._isRefreshing = false;
            case 13:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function refreshAsync(_x5) {
        return _refreshAsync.apply(this, arguments);
      }
      return refreshAsync;
    }()
  }, {
    key: "updateDynamicTextureAsync",
    value: function () {
      var _updateDynamicTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              if (!this.isFirstRender) {
                _context18.next = 6;
                break;
              }
              console.log('First render...');
              _context18.next = 4;
              return this.updateDynamicTextureInternalAsync();
            case 4:
              this.isFirstRender = false;
              return _context18.abrupt("return");
            case 6:
              // any other render, use debounced
              if (!this._debouncedUpdateDynamicTexture) this._debouncedUpdateDynamicTexture = (0,_Helpers_debounce__WEBPACK_IMPORTED_MODULE_0__.debounce)(this.updateDynamicTextureInternalAsync, 150);
              this._debouncedUpdateDynamicTexture();
            case 8:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function updateDynamicTextureAsync() {
        return _updateDynamicTextureAsync.apply(this, arguments);
      }
      return updateDynamicTextureAsync;
    }()
  }, {
    key: "updateDynamicTextureInternalAsync",
    value: function () {
      var _updateDynamicTextureInternalAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var config, diffuseEnabled, diffuseBlendMode, diffuseBlendLevel, opacityEnabled, opacityConfig, normalmapEnabled, normalmapConfig, innerShadowEnabled, innerShadowConfig, outerShadowEnabled, outerShadowConfig, dynamicTexturePropertyName, materialTextureName, opacityTexturePropertyName, oldTexture, dataUrl, isBlank, blob, URL, blobTextureURL;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              Logger.info("updateDynamicTextureInternal");
              if (!(!this._side || !this._meshSide || !this._canvas || !this._canvasMesh || !this._dynamicMaterial)) {
                _context19.next = 3;
                break;
              }
              return _context19.abrupt("return");
            case 3:
              config = this.getDesignConfig();
              _context19.next = 6;
              return this.checkDynamicMaterialAsync();
            case 6:
              _context19.next = 8;
              return this.checkNormalmapMaterialAsync();
            case 8:
              diffuseEnabled = config.getDiffuseEnabled();
              diffuseBlendMode = config.getDiffuseBlendMode();
              diffuseBlendLevel = config.getDiffuseLevel();
              if (diffuseBlendMode !== "normal" && diffuseBlendMode !== "multiply" && diffuseBlendMode !== "overlay") diffuseBlendMode = "normal";
              opacityEnabled = config.getOpacityEnabled();
              opacityConfig = config.getOrCreateOpacityConfig();
              normalmapEnabled = config.getNormalmapEnabled();
              normalmapConfig = config.getOrCreateNormalmapConfig();
              innerShadowEnabled = config.getInnerShadowEnabled();
              innerShadowConfig = config.getOrCreateInnerShadowConfig();
              outerShadowEnabled = config.getOuterShadowEnabled();
              outerShadowConfig = config.getOrCreateOuterShadowConfig();
              dynamicTexturePropertyName = "diffuseTexture";
              materialTextureName = this._meshSide.get("materialTexture");
              if (materialTextureName) dynamicTexturePropertyName = materialTextureName;else {
                dynamicTexturePropertyName = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial);
              }
              opacityTexturePropertyName = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial);
              oldTexture = this._dynamicTexture;
              if (oldTexture) oldTexture.dispose();

              // Recupero l'immagine del design
              dataUrl = this._canvas.toDataURL();
              isBlank = dataUrl == this._blankDataUrl;
              blob = this.dataURItoBlob(dataUrl);
              URL = window.URL || window.webkitURL;
              blobTextureURL = URL.createObjectURL(blob);
              this._dynamicTexture = new BABYLON.Texture(blobTextureURL, this._scene);
              this._dynamicTexture.hasAlpha = true;
              _context19.next = 35;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
            case 35:
              if (!(!isBlank && this._dynamicTexture)) {
                _context19.next = 78;
                break;
              }
              if (!normalmapEnabled) {
                _context19.next = 39;
                break;
              }
              _context19.next = 39;
              return this.updateNormalmapTextureAsync(normalmapConfig);
            case 39:
              if (!innerShadowEnabled) {
                _context19.next = 42;
                break;
              }
              _context19.next = 42;
              return this.updateInnerShadowTextureAsync(innerShadowConfig);
            case 42:
              if (!outerShadowEnabled) {
                _context19.next = 45;
                break;
              }
              _context19.next = 45;
              return this.updateOuterShadowTextureAsync(outerShadowConfig);
            case 45:
              if (!opacityEnabled) {
                _context19.next = 48;
                break;
              }
              _context19.next = 48;
              return this.updateOpacityTextureAsync();
            case 48:
              if (!(this._originalDiffuseTexture && diffuseEnabled && diffuseBlendMode !== "normal")) {
                _context19.next = 51;
                break;
              }
              _context19.next = 51;
              return this.combineDiffuseTexturesAsync(diffuseBlendMode, diffuseBlendLevel);
            case 51:
              if (!this._showDesign) {
                _context19.next = 78;
                break;
              }
              // Imposta la texture dinamica (diffuse)
              if (diffuseEnabled && dynamicTexturePropertyName) {
                if (diffuseBlendMode === "normal" || !this._originalDiffuseTexture || !this._combinedDiffuseTexture) {
                  this._dynamicTexture.coordinatesIndex = this._coordinatesIndex;
                  this.setTextureWrapping(this._dynamicTexture);
                  this._dynamicMaterial[dynamicTexturePropertyName] = this._dynamicTexture;
                } else if (this._combinedDiffuseTexture) {
                  this._combinedDiffuseTexture.coordinatesIndex = this._coordinatesIndex;
                  this.setTextureWrapping(this._combinedDiffuseTexture);
                  this._dynamicMaterial[dynamicTexturePropertyName] = this._combinedDiffuseTexture;
                }
                this._dynamicMaterial[dynamicTexturePropertyName].hasAlpha = false;
                this._dynamicMaterial[dynamicTexturePropertyName].hasAlpha = true;
              }
              if (!diffuseEnabled && dynamicTexturePropertyName && !this.compareTextures(this._dynamicMaterial[dynamicTexturePropertyName], this._originalDiffuseTexture)) {
                this._dynamicMaterial[dynamicTexturePropertyName] = this._originalDiffuseTexture;
              }

              // Opacity
              if (opacityEnabled && opacityTexturePropertyName && this._dynamicOpacityTexture) {
                this._dynamicOpacityTexture.coordinatesIndex = this._coordinatesIndex;
                this.setTextureWrapping(this._dynamicOpacityTexture);
                if (this._dynamicMaterial instanceof BABYLON.ShaderMaterial) {
                  this._dynamicMaterial.setTexture(opacityTexturePropertyName, this._dynamicOpacityTexture);
                } else {
                  this._dynamicMaterial[opacityTexturePropertyName] = this._dynamicOpacityTexture;
                }
              }

              // Qui andrebbe salvata anche la vecchia texture di opacità per poterla ripristinata
              if (!opacityEnabled && opacityTexturePropertyName) {
                this._dynamicMaterial[opacityTexturePropertyName] = null;
              }
              if (this._canvasMesh.material !== this._dynamicMaterial) this._canvasMesh.material = this._dynamicMaterial;

              // Imposta la normalmap
              if (!(normalmapEnabled && this._normalmapTexture)) {
                _context19.next = 62;
                break;
              }
              _context19.next = 60;
              return this.setNormalmapTextureAsync(normalmapConfig);
            case 60:
              _context19.next = 64;
              break;
            case 62:
              this.resetMeshNormalmapTexture();
              this.resetDesignNormalmapTexture();
            case 64:
              if (!(innerShadowEnabled && this._innerShadowTexture)) {
                _context19.next = 69;
                break;
              }
              _context19.next = 67;
              return this.setInnerShadowTextureAsync(innerShadowConfig);
            case 67:
              _context19.next = 70;
              break;
            case 69:
              this.removeInnerShadowTexture();
            case 70:
              if (!(outerShadowEnabled && this._outerShadowTexture)) {
                _context19.next = 75;
                break;
              }
              _context19.next = 73;
              return this.setOuterShadowTextureAsync(outerShadowConfig);
            case 73:
              _context19.next = 76;
              break;
            case 75:
              this.removeOuterShadowTexture();
            case 76:
              this.disposeOldDynamicMaterial();
              this._canvasMesh.isVisible = this._currentVisibliity && config.getShowDesign();
            case 78:
              if (isBlank) {
                this._canvasMesh.isVisible = false;
              }
              this.fireRenderingNeededEvent();
            case 80:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function updateDynamicTextureInternalAsync() {
        return _updateDynamicTextureInternalAsync.apply(this, arguments);
      }
      return updateDynamicTextureInternalAsync;
    }()
  }, {
    key: "resetDynamicTextures",
    value: function resetDynamicTextures() {
      // DynamicMaterial
      if (this._dynamicMaterial) {
        // Diffuse
        var dynamicTexturePropertyName = "diffuseTexture";
        var materialTextureName = this._meshSide ? this._meshSide.get("materialTexture") : null;
        if (materialTextureName) dynamicTexturePropertyName = materialTextureName;else {
          dynamicTexturePropertyName = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial);
        }
        if (dynamicTexturePropertyName && !this.compareTextures(this._dynamicMaterial[dynamicTexturePropertyName], this._originalDiffuseTexture)) {
          this._dynamicMaterial[dynamicTexturePropertyName] = this._originalDiffuseTexture || new BABYLON.Texture(this._blankDataUrl, this._scene);
          this._dynamicMaterial[dynamicTexturePropertyName].hasAlpha = false;
          this._dynamicMaterial[dynamicTexturePropertyName].hasAlpha = true;
        }

        // Normal
        this.resetDesignNormalmapTexture();

        // Opacity
        var opacityTexturePropertyName = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial);
        if (opacityTexturePropertyName) {
          this._dynamicMaterial[opacityTexturePropertyName] = null;
        }

        // InnerShadow
        this.removeInnerShadowTexture();
      }

      // NormalmapMaterial
      if (this._normalmapMaterial) {
        this.resetMeshNormalmapTexture();
        this.removeOuterShadowTexture();
      }
    }
  }, {
    key: "updateOpacityTextureAsync",
    value: function () {
      var _updateOpacityTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!this._dynamicTexture) {
                _context20.next = 9;
                break;
              }
              _context20.next = 3;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
            case 3:
              // Genero la maschera di opacità a partire dalla texture dinamic
              if (!this._dynamicOpacityTexture) {
                this._dynamicOpacityTexture = new _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_2__.ForegroundBackgroundProceduralTexture("dynamicOpacity", this._textureWidth, this._scene, this._dynamicTexture);
                this._dynamicOpacityTexture.backColor = new BABYLON.Vector3(0, 0, 0);
                this._dynamicOpacityTexture.foreColor = new BABYLON.Vector3(1, 1, 1);
                this._dynamicOpacityTexture.refreshRate = 0;
                this._dynamicOpacityTexture.getAlphaFromRGB = true;
              }
              if (!this._dynamicOpacityTexture) {
                _context20.next = 9;
                break;
              }
              this._dynamicOpacityTexture.baseTexture = this._dynamicTexture;
              _context20.next = 8;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicOpacityTexture);
            case 8:
              this._dynamicOpacityTexture.render();
            case 9:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function updateOpacityTextureAsync() {
        return _updateOpacityTextureAsync.apply(this, arguments);
      }
      return updateOpacityTextureAsync;
    }()
  }, {
    key: "combineDiffuseTexturesAsync",
    value: function () {
      var _combineDiffuseTexturesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(blendMode, blendLevel) {
        var baseTexture, blendTexture;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              if (!(!this._originalDiffuseTexture || !this._dynamicTexture)) {
                _context21.next = 2;
                break;
              }
              return _context21.abrupt("return");
            case 2:
              _context21.next = 4;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._originalDiffuseTexture);
            case 4:
              _context21.next = 6;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
            case 6:
              baseTexture = blendLevel === 0 ? this._dynamicTexture : this._originalDiffuseTexture;
              blendTexture = blendLevel === 0 ? this._originalDiffuseTexture : this._dynamicTexture;
              if (!this._combinedDiffuseTexture) {
                if (blendMode == "multiply") this._combinedDiffuseTexture = new _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_3__.MultiplyProceduralTexture("multiplyDiffuse", this._textureWidth, this._scene, baseTexture, blendTexture);else this._combinedDiffuseTexture = new _ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_4__.OverlayProceduralTexture("overlayDiffuse", this._textureWidth, this._scene, baseTexture, blendTexture);
                this._combinedDiffuseTexture.refreshRate = 0;
              }
              if (!this._combinedDiffuseTexture) {
                _context21.next = 15;
                break;
              }
              this._combinedDiffuseTexture.baseTexture = baseTexture;
              this._combinedDiffuseTexture.blendTexture = blendTexture;
              _context21.next = 14;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._combinedDiffuseTexture);
            case 14:
              this._combinedDiffuseTexture.render();
            case 15:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function combineDiffuseTexturesAsync(_x7, _x8) {
        return _combineDiffuseTexturesAsync.apply(this, arguments);
      }
      return combineDiffuseTexturesAsync;
    }() // NORMAL MAP
  }, {
    key: "updateNormalmapTextureAsync",
    value: function () {
      var _updateNormalmapTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(config) {
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              if (!this._dynamicTexture) {
                _context22.next = 8;
                break;
              }
              _context22.next = 3;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
            case 3:
              if (!this._proceduralNormalMap) {
                this._proceduralNormalMap = new _NormalMap_ProceduralNormalMap__WEBPACK_IMPORTED_MODULE_1__.ProceduralNormalMap(this._dynamicTexture, this._textureWidth, config, this._scene);
              }
              _context22.next = 6;
              return this._proceduralNormalMap.getNormalMapTextureAsync(this._dynamicTexture, config);
            case 6:
              this._normalmapTexture = _context22.sent;
              if (this._normalmapTexture) this._normalmapTexture.coordinatesIndex = this._coordinatesIndex; // Canale UV di riferimento da settare da parte dell'utente
            case 8:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function updateNormalmapTextureAsync(_x9) {
        return _updateNormalmapTextureAsync.apply(this, arguments);
      }
      return updateNormalmapTextureAsync;
    }() // Aggiorna i materiali con la normalmapTexture
    // La complicazione principale qui è che le normalmap eventualmente devono essere combinate con quelle preesistenti
    // sul materiale. Inoltre, essendo i materiali clonati (per non modificare quelli originari) è necessario controllare
    // che le texture siano pronte
  }, {
    key: "setNormalmapTextureAsync",
    value: function () {
      var _setNormalmapTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(config) {
        var meshNormalmapTexture, designNormalmapTexture, propName, _this$_originalMateri, _propName;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              meshNormalmapTexture = this._normalmapTexture;
              designNormalmapTexture = this._normalmapTexture;
              if (!config.get("showOnMesh")) {
                _context23.next = 7;
                break;
              }
              if (!(this._originalMeshNormalmapTexture && this._normalmapTexture)) {
                _context23.next = 7;
                break;
              }
              _context23.next = 6;
              return this.combineMeshNormalmapTexturesAsync();
            case 6:
              if (this._meshCombinedNormalmapTexture) meshNormalmapTexture = this._meshCombinedNormalmapTexture;
            case 7:
              if (!config.get("showOnDesign")) {
                _context23.next = 12;
                break;
              }
              if (!(this._originalDesignNormalmapTexture && this._normalmapTexture)) {
                _context23.next = 12;
                break;
              }
              _context23.next = 11;
              return this.combineDesignNormalmapTexturesAsync();
            case 11:
              if (this._designCombinedNormalmapTexture) designNormalmapTexture = this._designCombinedNormalmapTexture;
            case 12:
              if (this._normalmapMaterial && meshNormalmapTexture) {
                meshNormalmapTexture.coordinatesIndex = this._coordinatesIndex;
                this.setTextureWrapping(meshNormalmapTexture);
                propName = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
                if (config.get("showOnMesh")) this._normalmapMaterial[propName] = meshNormalmapTexture;else this.resetMeshNormalmapTexture();
                if (this._mesh.material !== this._normalmapMaterial) {
                  this._mesh.material = this._normalmapMaterial;
                  if (!this._mesh.metadata) this._mesh.metadata = {};
                  this._mesh.metadata.originalNormalmapMaterialID = (_this$_originalMateri = this._originalMaterial) === null || _this$_originalMateri === void 0 ? void 0 : _this$_originalMateri.id;
                }
              }
              if (this._dynamicMaterial && designNormalmapTexture) {
                designNormalmapTexture.coordinatesIndex = this._coordinatesIndex;
                this.setTextureWrapping(designNormalmapTexture);
                _propName = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
                if (config.get("showOnDesign")) this._dynamicMaterial[_propName] = designNormalmapTexture;else this.resetDesignNormalmapTexture();
              }
            case 14:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function setNormalmapTextureAsync(_x10) {
        return _setNormalmapTextureAsync.apply(this, arguments);
      }
      return setNormalmapTextureAsync;
    }()
  }, {
    key: "combineMeshNormalmapTexturesAsync",
    value: function () {
      var _combineMeshNormalmapTexturesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              if (!(!this._originalMeshNormalmapTexture || !this._normalmapTexture)) {
                _context24.next = 2;
                break;
              }
              return _context24.abrupt("return");
            case 2:
              _context24.next = 4;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._originalMeshNormalmapTexture);
            case 4:
              _context24.next = 6;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._normalmapTexture);
            case 6:
              if (!this._meshCombinedNormalmapTexture) {
                this._meshCombinedNormalmapTexture = new _ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_4__.OverlayProceduralTexture("overlayMeshNormal", this._textureWidth, this._scene, this._originalMeshNormalmapTexture, this._normalmapTexture);
                this._meshCombinedNormalmapTexture.refreshRate = 0;
              }
              if (!this._meshCombinedNormalmapTexture) {
                _context24.next = 13;
                break;
              }
              this._meshCombinedNormalmapTexture.baseTexture = this._originalMeshNormalmapTexture;
              this._meshCombinedNormalmapTexture.blendTexture = this._normalmapTexture;
              _context24.next = 12;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._meshCombinedNormalmapTexture);
            case 12:
              this._meshCombinedNormalmapTexture.render();
            case 13:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function combineMeshNormalmapTexturesAsync() {
        return _combineMeshNormalmapTexturesAsync.apply(this, arguments);
      }
      return combineMeshNormalmapTexturesAsync;
    }()
  }, {
    key: "resetMeshNormalmapTexture",
    value: function resetMeshNormalmapTexture() {
      if (this._normalmapMaterial) {
        var propName = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
        if (!this.compareTextures(this._normalmapMaterial[propName], this._originalMeshNormalmapTexture)) {
          if (!this._originalMeshNormalmapTexture) this._normalmapMaterial[propName] = null;else this._normalmapMaterial[propName] = this._originalMeshNormalmapTexture;
        }
      }
    }
  }, {
    key: "resetDesignNormalmapTexture",
    value: function resetDesignNormalmapTexture() {
      if (this._dynamicMaterial) {
        var propName = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
        if (!this.compareTextures(this._dynamicMaterial[propName], this._originalDesignNormalmapTexture)) {
          if (!this._originalDesignNormalmapTexture) this._dynamicMaterial[propName] = null;else this._dynamicMaterial[propName] = this._originalDesignNormalmapTexture;
        }
      }
    }
  }, {
    key: "combineDesignNormalmapTexturesAsync",
    value: function () {
      var _combineDesignNormalmapTexturesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              if (!(!this._originalDesignNormalmapTexture || !this._normalmapTexture)) {
                _context25.next = 2;
                break;
              }
              return _context25.abrupt("return");
            case 2:
              _context25.next = 4;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._originalDesignNormalmapTexture);
            case 4:
              _context25.next = 6;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._normalmapTexture);
            case 6:
              if (!this._designCombinedNormalmapTexture) {
                this._designCombinedNormalmapTexture = new _ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_4__.OverlayProceduralTexture("overlayDesignNormal", this._textureWidth, this._scene, this._originalDesignNormalmapTexture, this._normalmapTexture);
                this._designCombinedNormalmapTexture.refreshRate = 0;
              }
              if (!this._designCombinedNormalmapTexture) {
                _context25.next = 13;
                break;
              }
              this._designCombinedNormalmapTexture.baseTexture = this._originalDesignNormalmapTexture;
              this._designCombinedNormalmapTexture.blendTexture = this._normalmapTexture;
              _context25.next = 12;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._designCombinedNormalmapTexture);
            case 12:
              this._designCombinedNormalmapTexture.render();
            case 13:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function combineDesignNormalmapTexturesAsync() {
        return _combineDesignNormalmapTexturesAsync.apply(this, arguments);
      }
      return combineDesignNormalmapTexturesAsync;
    }() // INNER SHADOW
  }, {
    key: "updateInnerShadowTextureAsync",
    value: function () {
      var _updateInnerShadowTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(config) {
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              if (!this._dynamicTexture) {
                _context26.next = 13;
                break;
              }
              _context26.next = 3;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
            case 3:
              if (this._innerShadowGenerator) {
                _context26.next = 11;
                break;
              }
              this._innerShadowGenerator = new _Shadows_InnerShadow__WEBPACK_IMPORTED_MODULE_6__.InnerShadow(this._dynamicTexture, this._textureWidth, config, this._scene);
              _context26.next = 7;
              return this._innerShadowGenerator.getInnerShadowTextureAsync(this._dynamicTexture);
            case 7:
              this._innerShadowTexture = _context26.sent;
              this._innerShadowTexture.coordinatesIndex = this._coordinatesIndex;
              _context26.next = 13;
              break;
            case 11:
              _context26.next = 13;
              return this._innerShadowGenerator.updateAsync(this._dynamicTexture, config);
            case 13:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function updateInnerShadowTextureAsync(_x11) {
        return _updateInnerShadowTextureAsync.apply(this, arguments);
      }
      return updateInnerShadowTextureAsync;
    }()
  }, {
    key: "setInnerShadowTextureAsync",
    value: function () {
      var _setInnerShadowTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(config) {
        var designLightmapTexture;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              designLightmapTexture = this._innerShadowTexture;
              if (!(this._originalDesignLightmapTexture && this._innerShadowTexture)) {
                _context27.next = 5;
                break;
              }
              _context27.next = 4;
              return this.combineDesignLightmapTexturesAsync();
            case 4:
              if (this._designCombinedLightmapTexture) designLightmapTexture = this._designCombinedLightmapTexture;
            case 5:
              if (designLightmapTexture) {
                designLightmapTexture.coordinatesIndex = this._coordinatesIndex;
                this.setTextureWrapping(designLightmapTexture);
                this.setMaterialLightmap(this._dynamicMaterial, designLightmapTexture);
              }
            case 6:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function setInnerShadowTextureAsync(_x12) {
        return _setInnerShadowTextureAsync.apply(this, arguments);
      }
      return setInnerShadowTextureAsync;
    }()
  }, {
    key: "combineDesignLightmapTexturesAsync",
    value: function () {
      var _combineDesignLightmapTexturesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              if (!(!this._originalDesignLightmapTexture || !this._innerShadowTexture)) {
                _context28.next = 2;
                break;
              }
              return _context28.abrupt("return");
            case 2:
              _context28.next = 4;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._originalDesignLightmapTexture);
            case 4:
              _context28.next = 6;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._innerShadowTexture);
            case 6:
              if (!this._designCombinedLightmapTexture) {
                this._designCombinedLightmapTexture = new _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_3__.MultiplyProceduralTexture("overlayDesignLightmaps", this._textureWidth, this._scene, this._originalDesignLightmapTexture, this._innerShadowTexture);
                this._designCombinedLightmapTexture.refreshRate = 0;
              }
              if (!this._designCombinedLightmapTexture) {
                _context28.next = 13;
                break;
              }
              this._designCombinedLightmapTexture.baseTexture = this._originalDesignLightmapTexture;
              this._designCombinedLightmapTexture.blendTexture = this._innerShadowTexture;
              _context28.next = 12;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._designCombinedLightmapTexture);
            case 12:
              this._designCombinedLightmapTexture.render();
            case 13:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function combineDesignLightmapTexturesAsync() {
        return _combineDesignLightmapTexturesAsync.apply(this, arguments);
      }
      return combineDesignLightmapTexturesAsync;
    }()
  }, {
    key: "removeInnerShadowTexture",
    value: function removeInnerShadowTexture() {
      if (this._dynamicMaterial) {
        var current = this.getMaterialLightmap(this._dynamicMaterial);
        var original = this._originalDesignLightmapTexture;
        if (!this.compareTextures(current, original)) {
          this.setMaterialLightmap(this._dynamicMaterial, original);
        }
      }
    }

    // OUTER SHADOW
  }, {
    key: "updateOuterShadowTextureAsync",
    value: function () {
      var _updateOuterShadowTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(config) {
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              if (!this._dynamicTexture) {
                _context29.next = 13;
                break;
              }
              _context29.next = 3;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
            case 3:
              if (this._outerShadowGenerator) {
                _context29.next = 11;
                break;
              }
              this._outerShadowGenerator = new _Shadows_OuterShadow__WEBPACK_IMPORTED_MODULE_7__.OuterShadow(this._dynamicTexture, this._textureWidth, config, this._scene);
              _context29.next = 7;
              return this._outerShadowGenerator.getOuterShadowTextureAsync(this._dynamicTexture);
            case 7:
              this._outerShadowTexture = _context29.sent;
              this._outerShadowTexture.coordinatesIndex = this._coordinatesIndex;
              _context29.next = 13;
              break;
            case 11:
              _context29.next = 13;
              return this._outerShadowGenerator.updateAsync(this._dynamicTexture, config);
            case 13:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function updateOuterShadowTextureAsync(_x13) {
        return _updateOuterShadowTextureAsync.apply(this, arguments);
      }
      return updateOuterShadowTextureAsync;
    }()
  }, {
    key: "setOuterShadowTextureAsync",
    value: function () {
      var _setOuterShadowTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(config) {
        var meshLightmapTexture;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              meshLightmapTexture = this._outerShadowTexture;
              if (!(this._originalMeshLightmapTexture && this._outerShadowTexture)) {
                _context30.next = 5;
                break;
              }
              _context30.next = 4;
              return this.combineMeshLightmapTexturesAsync();
            case 4:
              if (this._meshCombinedLightmapTexture) meshLightmapTexture = this._meshCombinedLightmapTexture;
            case 5:
              if (meshLightmapTexture) {
                meshLightmapTexture.coordinatesIndex = this._coordinatesIndex;
                this.setTextureWrapping(meshLightmapTexture);
                this.setMaterialLightmap(this._normalmapMaterial, meshLightmapTexture);
                if (this._mesh.material !== this._normalmapMaterial) this._mesh.material = this._normalmapMaterial;
              }
            case 6:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function setOuterShadowTextureAsync(_x14) {
        return _setOuterShadowTextureAsync.apply(this, arguments);
      }
      return setOuterShadowTextureAsync;
    }()
  }, {
    key: "combineMeshLightmapTexturesAsync",
    value: function () {
      var _combineMeshLightmapTexturesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              if (!(!this._originalMeshLightmapTexture || !this._outerShadowTexture || this._isDisposed)) {
                _context31.next = 2;
                break;
              }
              return _context31.abrupt("return");
            case 2:
              _context31.next = 4;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._originalMeshLightmapTexture);
            case 4:
              _context31.next = 6;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._outerShadowTexture);
            case 6:
              if (!this._meshCombinedLightmapTexture) {
                this._meshCombinedLightmapTexture = new _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_3__.MultiplyProceduralTexture("overlayMeshLightmap", this._textureWidth, this._scene, this._originalMeshLightmapTexture, this._outerShadowTexture);
                this._meshCombinedLightmapTexture.refreshRate = 0;
              }
              if (!this._meshCombinedLightmapTexture) {
                _context31.next = 13;
                break;
              }
              this._meshCombinedLightmapTexture.baseTexture = this._originalMeshLightmapTexture;
              this._meshCombinedLightmapTexture.blendTexture = this._outerShadowTexture;
              _context31.next = 12;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._meshCombinedLightmapTexture);
            case 12:
              this._meshCombinedLightmapTexture.render();
            case 13:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function combineMeshLightmapTexturesAsync() {
        return _combineMeshLightmapTexturesAsync.apply(this, arguments);
      }
      return combineMeshLightmapTexturesAsync;
    }()
  }, {
    key: "removeOuterShadowTexture",
    value: function removeOuterShadowTexture() {
      if (this._normalmapMaterial) {
        var current = this.getMaterialLightmap(this._normalmapMaterial);
        var original = this._originalMeshLightmapTexture;
        if (!this.compareTextures(current, original)) {
          this.setMaterialLightmap(this._normalmapMaterial, original);
        }
      }
    }
  }, {
    key: "compareTextures",
    value: function compareTextures(a, b) {
      if (typeof a === "undefined" && typeof b === "undefined") return true;
      if (a === null && b === null) return true;
      if (!a || !b) return false;
      return a === b;
    }
  }, {
    key: "dataURItoBlob",
    value: function dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      var bb = new Blob([ab], {
        type: mimeString
      });
      return bb;
    }
  }, {
    key: "downloadImage",
    value: function downloadImage(data, filename) {
      var blob = this.dataURItoBlob(data);
      var url = window.URL.createObjectURL(blob);
      var fileNameToSaveAs = filename || "image.png";
      var downloadLink = document.createElement("a");
      downloadLink.download = fileNameToSaveAs;
      downloadLink.innerHTML = "Download File";
      downloadLink.href = url;
      downloadLink.onclick = function (ev) {
        document.body.removeChild(downloadLink);
      };
      downloadLink.style.display = "none";
      downloadLink.setAttribute("type", "hidden");
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }
  }, {
    key: "setDesignMeshVisibility",
    value: function setDesignMeshVisibility(visibile) {
      this._currentVisibliity = visibile;
      if (this._canvasMesh) {
        this._canvasMesh.isVisible = visibile;
      }
    }
  }, {
    key: "getItemsInfo",
    value: function getItemsInfo() {
      if (this._customizer) {
        return this._customizer.getItemsInfo();
      }
      return [];
    }
  }, {
    key: "removeItem",
    value: function removeItem(itemGuid) {
      if (this._customizer) this._customizer.removeItemByGuid(itemGuid);
    }
  }, {
    key: "addItemText",
    value: function addItemText(settings) {
      if (this._customizer) this._customizer.addTextElement(null, settings, false);
    }
  }, {
    key: "setItemText",
    value: function setItemText(itemGuid, text) {
      if (this._customizer) this._customizer.modifyTextElementContentByGuid(itemGuid, text);
    }
  }, {
    key: "setItemBold",
    value: function setItemBold(guid, bold) {
      if (this._customizer) {
        var item = this._customizer.findItemByGuid(guid);
        if (item) {
          var info = this._customizer.getTextItemInfo(item);
          var data = info.fontWeight.split(' ');
          var style = [data.length > 1 ? data[0] : 'normal'];
          style.push(bold ? 'bold' : 'normal');
          this._customizer.modifyTextElementFontWeight(item, style.join(' '));
        }
      }
    }
  }, {
    key: "setItemItalic",
    value: function setItemItalic(guid, italic) {
      if (this._customizer) {
        var item = this._customizer.findItemByGuid(guid);
        if (item) {
          var info = this._customizer.getTextItemInfo(item);
          var data = info.fontWeight.split(' ');
          var style = [italic ? 'italic' : 'normal'];
          style.push(data.length > 1 ? data[1] : data[0]);
          this._customizer.modifyTextElementFontWeight(item, style.join(' '));
        }
      }
    }
  }, {
    key: "setItemColor",
    value: function setItemColor(guid, color) {
      if (this._customizer) this._customizer.modifyTextElementFillColorByGuid(guid, color);
    }
  }, {
    key: "setItemFontFamily",
    value: function setItemFontFamily(guid, fontFamily) {
      if (this._customizer) this._customizer.modifyTextElementFontFamilyByGuid(guid, fontFamily);
    }
  }, {
    key: "addItemImage",
    value: function () {
      var _addItemImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(imageID) {
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (!this._customizer) {
                _context32.next = 3;
                break;
              }
              _context32.next = 3;
              return this._customizer.insertImageById(imageID);
            case 3:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function addItemImage(_x15) {
        return _addItemImage.apply(this, arguments);
      }
      return addItemImage;
    }()
  }, {
    key: "setItemImage",
    value: function () {
      var _setItemImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(guid, image) {
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (!this._customizer) {
                _context33.next = 3;
                break;
              }
              _context33.next = 3;
              return this._customizer.replaceImageByGuid(guid, image);
            case 3:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function setItemImage(_x16, _x17) {
        return _setItemImage.apply(this, arguments);
      }
      return setItemImage;
    }()
  }, {
    key: "setItemTextOnPath",
    value: function setItemTextOnPath(guid, value) {
      if (this._customizer) {
        var item = this._customizer.findItemByGuid(guid);
        if (value) {
          this._customizer.convertToTextOnPath(item);
        } else {
          this._customizer.convertToTextArea(item);
        }
      }
    }
  }, {
    key: "removeItemImage",
    value: function removeItemImage(guid) {
      if (this._customizer) this._customizer.removeImageByGuid(guid);
    }
  }, {
    key: "containsItem",
    value: function containsItem(guid) {
      if (this._customizer) {
        var item = this._customizer.findItemByGuid(guid);
        return item != null && item != undefined;
      }
      return false;
    }

    // -------------------------------------------------------------
    // Events 
    // -------------------------------------------------------------
  }, {
    key: "addNotifyMessageListener",
    value: function addNotifyMessageListener(listener) {
      if (this._customizer) {
        var customizer = this._customizer;
        var wrapperListener = function wrapperListener(itemGuid, type, title, message, closable, onClick, onClose, data) {
          listener(customizer.side.getSideID(), itemGuid, type, title, message, closable, data.requiredWidth, data.requiredHeight);
        };
        customizer.addNotifyMessageListeners(wrapperListener);
      }
    }
  }, {
    key: "addRemoveMessageListener",
    value: function addRemoveMessageListener(listener) {
      if (this._customizer) {
        var customizer = this._customizer;
        var wrapperListener = function wrapperListener(itemGuid) {
          listener(customizer.side.getSideID(), itemGuid);
        };
        customizer.addRemoveMessageListeners(wrapperListener);
      }
    }
  }, {
    key: "setEventMessages",
    value: function setEventMessages(eventMessages) {
      if (this._customizer) {
        var customizer = this._customizer;
        customizer.setCustomizedMessages(eventMessages);
      }
    }
  }, {
    key: "fireRenderingNeededEvent",
    value: function fireRenderingNeededEvent() {
      for (var i = 0; i < this._renderingNeededListeners.length; ++i) {
        this._renderingNeededListeners[i]();
      }
    }
  }, {
    key: "addRenderingNeededListener",
    value: function addRenderingNeededListener(listenerFunction) {
      this._renderingNeededListeners.push(listenerFunction);
    }

    // -------------------------------------------------------------
    // Design view transformation
    // -------------------------------------------------------------
  }, {
    key: "translateDesignView",
    value: function translateDesignView(dx, dy) {
      if (this._meshSide && this._customizer) {
        // Aggiorno la vista
        //this.customizer.translateView(dx, dy);

        // Aggiorno la matrice memorizzata nel modello
        var valuesJson = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
        var values = JSON.parse(valuesJson);
        var newValues = this._customizer.getTranslatedMatrixValues(values, dx, dy);
        var newValuesJson = JSON.stringify(newValues);
        this._meshSide.set("matrix", newValuesJson);
      }
    }
  }, {
    key: "rotateDesignView",
    value: function rotateDesignView(angle, centerX, centerY) {
      if (this._meshSide && this._customizer) {
        // Aggiorno la vista
        //this.customizer.rotateView(angle, centerX, centerY);

        // Aggiorno la matrice memorizzata nel modello
        var valuesJson = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
        var values = JSON.parse(valuesJson);
        var newValues = this._customizer.getRotatedMatrixValues(values, angle, centerX, centerY);
        var newValuesJson = JSON.stringify(newValues);
        this._meshSide.set("matrix", newValuesJson);
      }
    }
  }, {
    key: "scaleDesignView",
    value: function scaleDesignView(hor, ver, centerX, centerY) {
      if (this._meshSide && this._customizer) {
        // Aggiorno la vista
        //this.customizer.scaleView(hor, ver, centerX, centerY);

        // Aggiorno la matrice memorizzata nel modello
        var valuesJson = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
        var values = JSON.parse(valuesJson);
        var newValues = this._customizer.getScaledMatrixValues(values, hor, ver, centerX, centerY);
        var newValuesJson = JSON.stringify(newValues);
        this._meshSide.set("matrix", newValuesJson);
      }
    }
  }, {
    key: "setDesignViewTextureUVChannelAsync",
    value: function () {
      var _setDesignViewTextureUVChannelAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(uvChannel) {
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              if (!this._meshSide) {
                _context34.next = 4;
                break;
              }
              this._meshSide.set("uvChannel", uvChannel);
              _context34.next = 4;
              return this.updateDynamicTextureAsync();
            case 4:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function setDesignViewTextureUVChannelAsync(_x18) {
        return _setDesignViewTextureUVChannelAsync.apply(this, arguments);
      }
      return setDesignViewTextureUVChannelAsync;
    }()
  }, {
    key: "setDesignViewFormFactorAsync",
    value: function () {
      var _setDesignViewFormFactorAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(percWidth, percHeight) {
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              if (!this._meshSide) {
                _context35.next = 5;
                break;
              }
              this._meshSide.set("percWidth", percWidth);
              this._meshSide.set("percHeight", percHeight);
              _context35.next = 5;
              return this.refreshAsync();
            case 5:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function setDesignViewFormFactorAsync(_x19, _x20) {
        return _setDesignViewFormFactorAsync.apply(this, arguments);
      }
      return setDesignViewFormFactorAsync;
    }()
  }], [{
    key: "createMeshDesignManagerAsync",
    value: function () {
      var _createMeshDesignManagerAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(scene, zkScene, mesh, subMesh, zkModel, zkDesign) {
        var showDesign,
          effect,
          designTextureResolution,
          meshDesignManager,
          _args36 = arguments;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              showDesign = _args36.length > 6 && _args36[6] !== undefined ? _args36[6] : true;
              effect = _args36.length > 7 ? _args36[7] : undefined;
              designTextureResolution = _args36.length > 8 && _args36[8] !== undefined ? _args36[8] : 1024;
              meshDesignManager = new MeshDesignManager(scene, zkScene, mesh, subMesh, zkModel, zkDesign, showDesign, effect, designTextureResolution);
              _context36.next = 6;
              return meshDesignManager.initAsync();
            case 6:
              return _context36.abrupt("return", meshDesignManager);
            case 7:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }));
      function createMeshDesignManagerAsync(_x21, _x22, _x23, _x24, _x25, _x26) {
        return _createMeshDesignManagerAsync.apply(this, arguments);
      }
      return createMeshDesignManagerAsync;
    }()
  }]);
  return MeshDesignManager;
}();
// Lato del modello (relativo ad un determinato colore) collegato alla mesh
// Il lato esatto viene individuato in base agli item inseriti nel design (se ci sono)
// Se il design non prevede item per il lato per nessun colore, il lato sarà null e sulla mesh non verrà
// disegnato nulla
_defineProperty(MeshDesignManager, "DEFAULT_SIZE", 1024);

/***/ }),

/***/ "../../3D/src/Components/DesignManagers/SceneDesignManager.ts":
/*!********************************************************************!*\
  !*** ../../3D/src/Components/DesignManagers/SceneDesignManager.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SceneDesignManager": () => (/* binding */ SceneDesignManager)
/* harmony export */ });
/* harmony import */ var _MeshDesignManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./MeshDesignManager */ "../../3D/src/Components/DesignManagers/MeshDesignManager.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var SceneDesignManager = /*#__PURE__*/function () {
  function SceneDesignManager(scene, zkScene, zkModel, zkDesign) {
    var showDesign = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var designTextureResolution = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1024;
    _classCallCheck(this, SceneDesignManager);
    _defineProperty(this, "_grids", []);
    _defineProperty(this, "_meshDesignManagers", []);
    _defineProperty(this, "_renderingNeededListeners", []);
    _defineProperty(this, "_designNotifyMessageListeners", []);
    _defineProperty(this, "_designRemoveMessageListeners", []);
    _defineProperty(this, "_designEventMessages", []);
    _defineProperty(this, "_meshDesignManagersRefreshing", new Set());
    this._scene = scene;
    this._zkScene = zkScene;
    this._zkModel = zkModel;
    this._zkDesign = zkDesign;
    this._showDesign = showDesign;
    this._designTextureResolution = designTextureResolution;
    this.init();
  }
  _createClass(SceneDesignManager, [{
    key: "showDesign",
    get: function get() {
      return this._showDesign;
    },
    set: function set(value) {
      if (this._showDesign != value) {
        this._showDesign = value;
        this._meshDesignManagers.forEach(function (m) {
          return m.showDesign = value;
        });
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._meshDesignManagers.forEach(function (m) {
        return m.dispose();
      });
    }
  }, {
    key: "init",
    value: function init() {
      // do nothing
    }
  }, {
    key: "isForModels",
    value: function isForModels(scene, zkModel, zkDesign) {
      return this._scene == scene && this._zkModel == zkModel && this._zkDesign == zkDesign;
    }
  }, {
    key: "getDefaultModelScene",
    value: function getDefaultModelScene() {
      if (this._zkModel) {
        var modelScene = this._zkModel.get("scenes").findWhere({
          isDefault: true
        });
        if (modelScene) return modelScene;
      }
      return null;
    }
  }, {
    key: "getModelSceneMeshSide",
    value: function getModelSceneMeshSide(meshID) {
      var submeshID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (this._scene && this._zkModel) {
        var scene = this.getDefaultModelScene();
        if (scene) {
          for (var j = 0; j < scene.get("meshSides").length; j++) {
            var meshSide = scene.get("meshSides").at(j);
            if (meshSide.get("meshID") == meshID && meshSide.get("subMeshID") == submeshID) return meshSide;
          }
        }
      }
      return null;
    }
  }, {
    key: "refreshAsync",
    value: function () {
      var _refreshAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var scene, meshDesignManager, mesh, meshSide, i, found, k, meshVisible, meshID, j, _meshID, submeshIdx;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this._scene && this._zkModel && this._zkDesign)) {
                _context.next = 36;
                break;
              }
              scene = this.getDefaultModelScene();
              if (!scene) {
                _context.next = 36;
                break;
              }
              meshDesignManager = null;
              mesh = null;
              meshSide = null; // Removed sceneID check otherwise it will not work when creating the scene in the customizer
              // backoffice
              //let sceneID = scene.get("sceneID");
              // Elimino tutti i gestori non più necessari
              i = 0;
            case 7:
              if (!(i < this._meshDesignManagers.length)) {
                _context.next = 25;
                break;
              }
              meshDesignManager = this._meshDesignManagers[i];
              found = false;
              k = 0;
            case 11:
              if (!(k < scene.get("meshSides").length)) {
                _context.next = 19;
                break;
              }
              meshSide = scene.get("meshSides").at(k);
              if (!(meshSide.get("meshID") == meshDesignManager.getMeshID() && meshSide.get("subMeshID") == meshDesignManager.getSubMeshIdx())) {
                _context.next = 16;
                break;
              }
              found = true;
              return _context.abrupt("break", 19);
            case 16:
              k++;
              _context.next = 11;
              break;
            case 19:
              meshVisible = true;
              if (found) {
                meshID = meshDesignManager.getMeshID();
                if (meshID) {
                  mesh = this._scene.getMeshByID(meshID);
                  if (mesh) {
                    meshVisible = mesh.isVisible;
                  }
                }
              }
              if (!found || !meshVisible) {
                // qui forziamo la rimozione della mesh dall'elenco di mesh da refreshare perchè
                // in alcuni casi il refresh del customizer ts avendo il debounce non completa la promise restando appesa
                // le soluzioni erano 2, rimuovere manualmente la mesh qui dal _meshDesignManagersRefreshing
                // oppure rimuovere il debounce dal metodo refresh del customizer ts
                // this._meshDesignManagersRefreshing.delete(mesh?.id);

                meshDesignManager.dispose();
                this._meshDesignManagers.splice(i--, 1);
              }
            case 22:
              i++;
              _context.next = 7;
              break;
            case 25:
              j = 0;
            case 26:
              if (!(j < scene.get("meshSides").length)) {
                _context.next = 36;
                break;
              }
              meshSide = scene.get("meshSides").at(j);
              _meshID = meshSide.get("meshID");
              submeshIdx = meshSide.get("subMeshID");
              if (!_meshID) {
                _context.next = 33;
                break;
              }
              _context.next = 33;
              return this.refreshMeshDesignAsync(_meshID, submeshIdx);
            case 33:
              j++;
              _context.next = 26;
              break;
            case 36:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function refreshAsync() {
        return _refreshAsync.apply(this, arguments);
      }
      return refreshAsync;
    }()
  }, {
    key: "isValidEffectForMesh",
    value: function isValidEffectForMesh(meshID, submeshID, effect) {
      // lascio i controlli in modo che finiscano nel javascript
      if (effect && effect instanceof MPlaza.ModelSceneMeshDesignEffect) {
        var modelScene = effect.getParentModel();
        if (modelScene && modelScene instanceof MPlaza.ModelScene) {
          return modelScene.isEffectForMesh(meshID, submeshID, effect.get("effectID"));
        }
      }
      return false;
    }
  }, {
    key: "refreshMeshDesignAsync",
    value: function () {
      var _refreshMeshDesignAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(meshID) {
        var _this = this;
        var submeshID,
          effect,
          guid,
          mesh,
          validEffect,
          subMesh,
          meshDesignManager,
          _iterator,
          _step,
          listener,
          _iterator2,
          _step2,
          _listener,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              submeshID = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 0;
              effect = _args2.length > 2 ? _args2[2] : undefined;
              guid = Zakeke.generateUUID();
              mesh = this._scene.getMeshByID(meshID); // if (this._meshDesignManagersRefreshing.has(meshID))
              //     return;
              // this._meshDesignManagersRefreshing.add(meshID);
              validEffect = effect;
              if (effect && !this.isValidEffectForMesh(meshID, submeshID, effect)) validEffect = undefined;
              if (!(mesh && mesh.isVisible)) {
                _context2.next = 27;
                break;
              }
              subMesh = null;
              if (mesh.subMeshes && mesh.subMeshes.length > 0 && submeshID >= 0 && submeshID < mesh.subMeshes.length) {
                subMesh = mesh.subMeshes[submeshID];
              }
              meshDesignManager = this.getMeshDesignMananger(mesh, subMesh);
              if (meshDesignManager) {
                _context2.next = 24;
                break;
              }
              _context2.next = 13;
              return _MeshDesignManager__WEBPACK_IMPORTED_MODULE_0__.MeshDesignManager.createMeshDesignManagerAsync(this._scene, this._zkScene, mesh, subMesh, this._zkModel, this._zkDesign, this._showDesign, validEffect, this._designTextureResolution);
            case 13:
              meshDesignManager = _context2.sent;
              meshDesignManager.addRenderingNeededListener(function () {
                return _this.fireRenderingNeededEvent();
              });
              meshDesignManager.setCustomizerGrids(this._grids);
              meshDesignManager.setEventMessages(this._designEventMessages);
              _iterator = _createForOfIteratorHelper(this._designNotifyMessageListeners);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  listener = _step.value;
                  meshDesignManager.addNotifyMessageListener(listener);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _iterator2 = _createForOfIteratorHelper(this._designRemoveMessageListeners);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _listener = _step2.value;
                  meshDesignManager.addRemoveMessageListener(_listener);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              this._meshDesignManagers.push(meshDesignManager);
              _context2.next = 27;
              break;
            case 24:
              meshDesignManager.showDesign = this._showDesign;
              _context2.next = 27;
              return meshDesignManager.refreshAsync(validEffect);
            case 27:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function refreshMeshDesignAsync(_x) {
        return _refreshMeshDesignAsync.apply(this, arguments);
      }
      return refreshMeshDesignAsync;
    }()
  }, {
    key: "getMeshDesignMananger",
    value: function getMeshDesignMananger(mesh, subMesh) {
      for (var i = 0; i < this._meshDesignManagers.length; i++) {
        var meshDesignManager = this._meshDesignManagers[i];
        if (meshDesignManager.isForMesh(mesh, subMesh)) return meshDesignManager;
      }
      return null;
    }
  }, {
    key: "clearMeshDesignManagers",
    value: function clearMeshDesignManagers() {
      this._meshDesignManagers = [];
    }
  }, {
    key: "setCustomizerGrids",
    value: function setCustomizerGrids(grids) {
      this._grids = grids;
      this._meshDesignManagers.forEach(function (meshDesignMangaer) {
        return meshDesignMangaer.setCustomizerGrids(grids);
      });
    }
  }, {
    key: "getItemsInfo",
    value: function getItemsInfo() {
      var infoArray = [];
      for (var i = 0; i < this._meshDesignManagers.length; i++) {
        var meshDesignManager = this._meshDesignManagers[i];
        var tempArray = meshDesignManager.getItemsInfo();
        for (var j = 0; j < tempArray.length; j++) {
          var info = tempArray[j];
          var found = false;
          for (var k = 0; k < infoArray.length; k++) {
            if (infoArray[k].itemGuid == info.itemGuid) {
              found = true;
              break;
            }
          }
          if (!found) infoArray.push(info);
        }
      }
      return infoArray;
    }
  }, {
    key: "execOnMeshManagersContainingItem",
    value: function () {
      var _execOnMeshManagersContainingItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(guid, func) {
        var _iterator3, _step3, _manager;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(this._meshDesignManagers);
              _context3.prev = 1;
              _iterator3.s();
            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context3.next = 10;
                break;
              }
              _manager = _step3.value;
              if (!_manager.containsItem(guid)) {
                _context3.next = 8;
                break;
              }
              _context3.next = 8;
              return func(_manager);
            case 8:
              _context3.next = 3;
              break;
            case 10:
              _context3.next = 15;
              break;
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](1);
              _iterator3.e(_context3.t0);
            case 15:
              _context3.prev = 15;
              _iterator3.f();
              return _context3.finish(15);
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 12, 15, 18]]);
      }));
      function execOnMeshManagersContainingItem(_x2, _x3) {
        return _execOnMeshManagersContainingItem.apply(this, arguments);
      }
      return execOnMeshManagersContainingItem;
    }()
  }, {
    key: "removeItem",
    value: function removeItem(guid) {
      this.execOnMeshManagersContainingItem(guid, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(manager) {
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", manager.removeItem(guid));
              case 1:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "addItemText",
    value: function addItemText(settings, sideID) {
      var meshDesignManager = this._meshDesignManagers.find(function (x) {
        return x.side != null && x.side.get("sideID") === sideID;
      });
      if (meshDesignManager) meshDesignManager.addItemText(settings);
    }
  }, {
    key: "addItemImage",
    value: function () {
      var _addItemImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(imageID, sideID) {
        var meshDesignManager;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              meshDesignManager = this._meshDesignManagers.find(function (x) {
                return x.side != null && x.side.get("sideID") === sideID;
              });
              if (!meshDesignManager) {
                _context5.next = 4;
                break;
              }
              _context5.next = 4;
              return meshDesignManager.addItemImage(imageID);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function addItemImage(_x5, _x6) {
        return _addItemImage.apply(this, arguments);
      }
      return addItemImage;
    }()
  }, {
    key: "setItemText",
    value: function setItemText(guid, text) {
      this.execOnMeshManagersContainingItem(guid, /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(manager) {
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", manager.setItemText(guid, text));
              case 1:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x7) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "setItemItalic",
    value: function setItemItalic(guid, italic) {
      this.execOnMeshManagersContainingItem(guid, /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(manager) {
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", manager.setItemItalic(guid, italic));
              case 1:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        return function (_x8) {
          return _ref3.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "setItemBold",
    value: function setItemBold(guid, bold) {
      this.execOnMeshManagersContainingItem(guid, /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(manager) {
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", manager.setItemBold(guid, bold));
              case 1:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        return function (_x9) {
          return _ref4.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "setItemColor",
    value: function setItemColor(guid, color) {
      this.execOnMeshManagersContainingItem(guid, /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(manager) {
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", manager.setItemColor(guid, color));
              case 1:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        return function (_x10) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "setItemFontFamily",
    value: function setItemFontFamily(guid, fontFamily) {
      this.execOnMeshManagersContainingItem(guid, /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(manager) {
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", manager.setItemFontFamily(guid, fontFamily));
              case 1:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        return function (_x11) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "setItemImage",
    value: function () {
      var _setItemImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(guid, image) {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.execOnMeshManagersContainingItem(guid, /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(manager) {
                  return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        return _context11.abrupt("return", manager.setItemImage(guid, image));
                      case 1:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee11);
                }));
                return function (_x14) {
                  return _ref7.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function setItemImage(_x12, _x13) {
        return _setItemImage.apply(this, arguments);
      }
      return setItemImage;
    }()
  }, {
    key: "setItemTextOnPath",
    value: function setItemTextOnPath(guid, areaId, value) {
      var meshDesignManager = this._meshDesignManagers.find(function (x) {
        return x.side != null && x.side.get("sideID") === areaId;
      });
      if (meshDesignManager) meshDesignManager.setItemTextOnPath(guid, value);
    }
  }, {
    key: "removeItemImage",
    value: function removeItemImage(guid) {
      this.execOnMeshManagersContainingItem(guid, /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(manager) {
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", manager.removeItemImage(guid));
              case 1:
              case "end":
                return _context13.stop();
            }
          }, _callee13);
        }));
        return function (_x15) {
          return _ref8.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "setDesignVisibility",
    value: function setDesignVisibility(meshId, visibile) {
      var mesh = this._scene.getMeshByID(meshId);
      if (mesh) {
        var _manager2 = this.getMeshDesignMananger(mesh, mesh.subMeshes.length > 0 ? mesh.subMeshes[0] : null);
        if (_manager2) _manager2.setDesignMeshVisibility(visibile);
      }
    }
  }, {
    key: "getDesignItemsJson",
    value: function getDesignItemsJson() {
      var json = "";
      for (var i = 0; i < this._zkDesign.get("designItems").length; i++) {
        if (json) json += "\n";
        json += this._zkDesign.get("designItems").at(i).get("json");
      }
      return json;
    }
  }, {
    key: "getDesignID",
    value: function getDesignID() {
      return this._zkDesign.getDesignID();
    }

    // -------------------------------------------------------------
    // Events 
    // -------------------------------------------------------------
  }, {
    key: "fireRenderingNeededEvent",
    value: function fireRenderingNeededEvent() {
      for (var i = 0; i < this._renderingNeededListeners.length; ++i) {
        this._renderingNeededListeners[i]();
      }
    }
  }, {
    key: "addRenderingNeededListener",
    value: function addRenderingNeededListener(listenerFunction) {
      this._renderingNeededListeners.push(listenerFunction);
    }
  }, {
    key: "addNotifyMessageListener",
    value: function addNotifyMessageListener(listener) {
      this._designNotifyMessageListeners.push(listener);
      var _iterator4 = _createForOfIteratorHelper(this._meshDesignManagers),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var meshDesignManager = _step4.value;
          meshDesignManager.addNotifyMessageListener(listener);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "addRemoveMessageListener",
    value: function addRemoveMessageListener(listener) {
      this._designRemoveMessageListeners.push(listener);
      var _iterator5 = _createForOfIteratorHelper(this._meshDesignManagers),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var meshDesignManager = _step5.value;
          meshDesignManager.addRemoveMessageListener(listener);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "setEventMessages",
    value: function setEventMessages(eventMessages) {
      this._designEventMessages = eventMessages;
      var _iterator6 = _createForOfIteratorHelper(this._meshDesignManagers),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var meshDesignManager = _step6.value;
          meshDesignManager.setEventMessages(eventMessages);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }

    // -------------------------------------------------------------
    // Design view transformation
    // -------------------------------------------------------------
  }, {
    key: "translateDesignView",
    value: function translateDesignView(mesh, submesh, dx, dy) {
      var meshDesignManager = this.getMeshDesignMananger(mesh, submesh);
      if (meshDesignManager) meshDesignManager.translateDesignView(dx, dy);
    }
  }, {
    key: "rotateDesignView",
    value: function rotateDesignView(mesh, submesh, angle, centerX, centerY) {
      var meshDesignManager = this.getMeshDesignMananger(mesh, submesh);
      if (meshDesignManager) meshDesignManager.rotateDesignView(angle, centerX, centerY);
    }
  }, {
    key: "scaleDesignView",
    value: function scaleDesignView(mesh, submesh, hor, ver, centerX, centerY) {
      var meshDesignManager = this.getMeshDesignMananger(mesh, submesh);
      if (meshDesignManager) meshDesignManager.scaleDesignView(hor, ver, centerX, centerY);
    }
  }, {
    key: "setDesignViewTextureUVChannelAsync",
    value: function () {
      var _setDesignViewTextureUVChannelAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(mesh, submesh, uvChannel) {
        var meshDesignManager;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              meshDesignManager = this.getMeshDesignMananger(mesh, submesh);
              if (!meshDesignManager) {
                _context14.next = 4;
                break;
              }
              _context14.next = 4;
              return meshDesignManager.setDesignViewTextureUVChannelAsync(uvChannel);
            case 4:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function setDesignViewTextureUVChannelAsync(_x16, _x17, _x18) {
        return _setDesignViewTextureUVChannelAsync.apply(this, arguments);
      }
      return setDesignViewTextureUVChannelAsync;
    }()
  }, {
    key: "setDesignViewFormFactorAsync",
    value: function () {
      var _setDesignViewFormFactorAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(mesh, submesh, percWidth, percHeight) {
        var meshDesignManager;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              meshDesignManager = this.getMeshDesignMananger(mesh, submesh);
              if (!meshDesignManager) {
                _context15.next = 4;
                break;
              }
              _context15.next = 4;
              return meshDesignManager.setDesignViewFormFactorAsync(percWidth, percHeight);
            case 4:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function setDesignViewFormFactorAsync(_x19, _x20, _x21, _x22) {
        return _setDesignViewFormFactorAsync.apply(this, arguments);
      }
      return setDesignViewFormFactorAsync;
    }() // -------------------------------------------------------------
    // Mesh - Side connection
    // -------------------------------------------------------------
  }, {
    key: "connectMeshToModelSideAsync",
    value: function () {
      var _connectMeshToModelSideAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(meshID, submeshID, sideID) {
        var meshSide, mesh, subMesh, scene;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              meshSide = this.getModelSceneMeshSide(meshID, submeshID);
              if (!(!meshSide && this._scene && this._zkModel)) {
                _context16.next = 16;
                break;
              }
              mesh = this._scene.getMeshByID(meshID);
              if (!mesh) {
                _context16.next = 16;
                break;
              }
              subMesh = null;
              if (!(mesh.subMeshes && mesh.subMeshes.length > 0 && submeshID >= 0 && submeshID < mesh.subMeshes.length)) {
                _context16.next = 16;
                break;
              }
              subMesh = mesh.subMeshes[submeshID];
              scene = this.getDefaultModelScene();
              if (!scene) {
                _context16.next = 16;
                break;
              }
              meshSide = new MPlaza.ModelSceneMeshSide();
              meshSide.set("meshID", meshID);
              meshSide.set("subMeshID", submeshID);
              meshSide.set("sideID", sideID);
              scene.get("meshSides").add(meshSide);
              _context16.next = 16;
              return this.refreshAsync();
            case 16:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function connectMeshToModelSideAsync(_x23, _x24, _x25) {
        return _connectMeshToModelSideAsync.apply(this, arguments);
      }
      return connectMeshToModelSideAsync;
    }()
  }, {
    key: "expandCanvasMeshes",
    value: function expandCanvasMeshes() {
      this._meshDesignManagers.forEach(function (m) {
        return m.expandCanvasMesh();
      });
    }
  }, {
    key: "contractCanvasMeshes",
    value: function contractCanvasMeshes() {
      this._meshDesignManagers.forEach(function (m) {
        return m.contractCanvasMesh();
      });
    }
  }]);
  return SceneDesignManager;
}();

/***/ }),

/***/ "../../3D/src/Components/Draco/DracoCompression.ts":
/*!*********************************************************!*\
  !*** ../../3D/src/Components/Draco/DracoCompression.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DracoCompression": () => (/* binding */ DracoCompression)
/* harmony export */ });
/* harmony import */ var _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Misc/WorkerPool */ "../../3D/src/Misc/WorkerPool.ts");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function loadScriptAsync(url) {
  if (typeof importScripts === "function") {
    importScripts(url);
    return Promise.resolve();
  } else {
    return new Promise(function (resolve, reject) {
      BABYLON.Tools.LoadScript(url, function () {
        resolve();
      }, function (message) {
        reject(new Error(message));
      });
    });
  }
}
function loadFileAsync(url) {
  return new Promise(function (resolve, reject) {
    BABYLON.Tools.LoadFile(url, function (data) {
      resolve(data);
    }, undefined, undefined, true, function (request, exception) {
      reject(exception);
    });
  });
}
function createDecoderAsync(wasmUrl, wasmBinary, fallbackUrl) {
  var decoderUrl = wasmBinary && wasmUrl || fallbackUrl;
  if (decoderUrl) {
    return loadScriptAsync(decoderUrl).then(function () {
      return new Promise(function (resolve) {
        DracoDecoderModule({
          wasmBinary: wasmBinary
        }).then(function (module) {
          resolve({
            module: module
          });
        });
      });
    });
  }
  return undefined;
}
function decodeMesh(decoderModule, dataView, attributes, onIndicesData, onAttributeData) {
  var buffer = new decoderModule.DecoderBuffer();
  buffer.Init(dataView, dataView.byteLength);
  var decoder = new decoderModule.Decoder();
  var geometry;
  var status;
  try {
    var type = decoder.GetEncodedGeometryType(buffer);
    switch (type) {
      case decoderModule.TRIANGULAR_MESH:
        geometry = new decoderModule.Mesh();
        status = decoder.DecodeBufferToMesh(buffer, geometry);
        break;
      case decoderModule.POINT_CLOUD:
        geometry = new decoderModule.PointCloud();
        status = decoder.DecodeBufferToPointCloud(buffer, geometry);
        break;
      default:
        throw new Error("Invalid geometry type " + type);
    }
    if (!status.ok() || !geometry.ptr) {
      throw new Error(status.error_msg());
    }
    var numPoints = geometry.num_points();
    if (type === decoderModule.TRIANGULAR_MESH) {
      var numFaces = geometry.num_faces();
      var faceIndices = new decoderModule.DracoInt32Array();
      try {
        var indices = new Uint32Array(numFaces * 3);
        for (var _i = 0; _i < numFaces; _i++) {
          decoder.GetFaceFromMesh(geometry, _i, faceIndices);
          var offset = _i * 3;
          indices[offset + 0] = faceIndices.GetValue(0);
          indices[offset + 1] = faceIndices.GetValue(1);
          indices[offset + 2] = faceIndices.GetValue(2);
        }
        onIndicesData(indices);
      } finally {
        decoderModule.destroy(faceIndices);
      }
    }

    // Positions
    var posAttId = decoder.GetAttributeId(geometry, decoderModule.POSITION);
    var posAttribute = decoder.GetAttributeByUniqueId(geometry, posAttId);
    var posDracoData = new decoderModule.DracoFloat32Array();
    try {
      decoder.GetAttributeFloatForAllPoints(geometry, posAttribute, posDracoData);
      var babylonData = new Float32Array(numPoints * posAttribute.num_components());
      for (var _i2 = 0; _i2 < babylonData.length; _i2++) {
        babylonData[_i2] = posDracoData.GetValue(_i2);
      }
      onAttributeData("position", babylonData);
    } finally {
      decoderModule.destroy(posDracoData);
    }

    // Normals
    var normAttId = decoder.GetAttributeId(geometry, decoderModule.NORMAL);
    if (normAttId !== -1) {
      var normAttribute = decoder.GetAttributeByUniqueId(geometry, normAttId);
      var normDracoData = new decoderModule.DracoFloat32Array();
      try {
        decoder.GetAttributeFloatForAllPoints(geometry, normAttribute, normDracoData);
        var _babylonData = new Float32Array(numPoints * normAttribute.num_components());
        for (var i = 0; i < _babylonData.length; i++) {
          _babylonData[i] = normDracoData.GetValue(i);
        }
        onAttributeData("normal", _babylonData);
      } finally {
        decoderModule.destroy(normDracoData);
      }
    }

    // Colors
    var colorAttId = decoder.GetAttributeId(geometry, decoderModule.COLOR);
    if (colorAttId !== -1) {
      var colorAttribute = decoder.GetAttributeByUniqueId(geometry, colorAttId);
      //var colorDracoData = new decoderModule.DracoUInt32Array();
      var colorDracoData = new decoderModule.DracoFloat32Array();
      try {
        decoder.GetAttributeFloatForAllPoints(geometry, colorAttribute, colorDracoData);
        var _babylonData2 = new Float32Array(numPoints * colorAttribute.num_components());
        for (var i = 0; i < _babylonData2.length; i++) {
          _babylonData2[i] = colorDracoData.GetValue(i);
        }
        onAttributeData("color", _babylonData2);
      } finally {
        decoderModule.destroy(colorDracoData);
      }
    }

    // uvs
    var uvsAttId = decoder.GetAttributeId(geometry, decoderModule.TEX_COORD);
    if (uvsAttId !== -1) {
      var uvsAttribute = decoder.GetAttributeByUniqueId(geometry, uvsAttId);
      var uvsDracoData = new decoderModule.DracoFloat32Array();
      try {
        decoder.GetAttributeFloatForAllPoints(geometry, uvsAttribute, uvsDracoData);
        var _babylonData3 = new Float32Array(numPoints * uvsAttribute.num_components());
        for (var i = 0; i < _babylonData3.length; i++) {
          _babylonData3[i] = uvsDracoData.GetValue(i);
        }
        onAttributeData("uv", _babylonData3);
      } finally {
        decoderModule.destroy(uvsDracoData);
      }

      // uv2s
      var uv2sAttribute = decoder.GetAttributeByUniqueId(geometry, uvsAttId + 1);
      if (uv2sAttribute && uv2sAttribute.size() > 0) {
        var uv2sDracoData = new decoderModule.DracoFloat32Array();
        try {
          decoder.GetAttributeFloatForAllPoints(geometry, uv2sAttribute, uv2sDracoData);
          var _babylonData4 = new Float32Array(numPoints * uv2sAttribute.num_components());
          for (var i = 0; i < _babylonData4.length; i++) {
            _babylonData4[i] = uv2sDracoData.GetValue(i);
          }
          onAttributeData("uv2", _babylonData4);
        } finally {
          decoderModule.destroy(uv2sDracoData);
        }
      }
    }
  } finally {
    if (geometry) {
      decoderModule.destroy(geometry);
    }
    decoderModule.destroy(decoder);
    decoderModule.destroy(buffer);
  }
}
function decodeMesh_OLD(decoderModule, dataView, attributes, onIndicesData, onAttributeData) {
  var buffer = new decoderModule.DecoderBuffer();
  buffer.Init(dataView, dataView.byteLength);
  var decoder = new decoderModule.Decoder();
  var geometry;
  var status;
  try {
    var type = decoder.GetEncodedGeometryType(buffer);
    switch (type) {
      case decoderModule.TRIANGULAR_MESH:
        geometry = new decoderModule.Mesh();
        status = decoder.DecodeBufferToMesh(buffer, geometry);
        break;
      case decoderModule.POINT_CLOUD:
        geometry = new decoderModule.PointCloud();
        status = decoder.DecodeBufferToPointCloud(buffer, geometry);
        break;
      default:
        throw new Error("Invalid geometry type ".concat(type));
    }
    if (!status.ok() || !geometry.ptr) {
      throw new Error(status.error_msg());
    }
    var numPoints = geometry.num_points();
    if (type === decoderModule.TRIANGULAR_MESH) {
      var numFaces = geometry.num_faces();
      var faceIndices = new decoderModule.DracoInt32Array();
      try {
        var indices = new Uint32Array(numFaces * 3);
        for (var i = 0; i < numFaces; i++) {
          decoder.GetFaceFromMesh(geometry, i, faceIndices);
          var offset = i * 3;
          indices[offset + 0] = faceIndices.GetValue(0);
          indices[offset + 1] = faceIndices.GetValue(1);
          indices[offset + 2] = faceIndices.GetValue(2);
        }
        onIndicesData(indices);
      } finally {
        decoderModule.destroy(faceIndices);
      }
    }
    var processAttribute = function processAttribute(kind, attribute) {
      var dracoData = new decoderModule.DracoFloat32Array();
      try {
        decoder.GetAttributeFloatForAllPoints(geometry, attribute, dracoData);
        var babylonData = new Float32Array(numPoints * attribute.num_components());
        for (var _i3 = 0; _i3 < babylonData.length; _i3++) {
          babylonData[_i3] = dracoData.GetValue(_i3);
        }
        onAttributeData(kind, babylonData);
      } finally {
        decoderModule.destroy(dracoData);
      }
    };
    if (attributes) {
      for (var _kind in attributes) {
        var id = attributes[_kind];
        var attribute = decoder.GetAttributeByUniqueId(geometry, id);
        processAttribute(_kind, attribute);
      }
    } else {
      var nativeAttributeTypes = {
        "position": "POSITION",
        "normal": "NORMAL",
        "color": "COLOR",
        "uv": "TEX_COORD"
      };
      for (var _kind2 in nativeAttributeTypes) {
        var _id = decoder.GetAttributeId(geometry, decoderModule[nativeAttributeTypes[_kind2]]);
        if (_id !== -1) {
          var _attribute = decoder.GetAttribute(geometry, _id);
          processAttribute(_kind2, _attribute);

          // generalmente le uv2 sono codificate dopo le uv
          if (_kind2 === "uv") {
            try {
              // uv2
              var uv2sAttribute = decoder.GetAttribute(geometry, _id + 1);
              if (uv2sAttribute && uv2sAttribute.size() > 0 && decoder.GetAttributeId(uv2sAttribute) >= 0) {
                processAttribute("uv2", uv2sAttribute);
              }
            } catch (e) {
              console.log("Unable to decode UV2 draco data: ", e);
            }
          }
        }
      }
    }
  } finally {
    if (geometry) {
      decoderModule.destroy(geometry);
    }
    decoderModule.destroy(decoder);
    decoderModule.destroy(buffer);
  }
}

/**
 * The worker function that gets converted to a blob url to pass into a worker.
 */
function worker() {
  var decoderPromise;
  onmessage = function onmessage(event) {
    var data = event.data;
    switch (data.id) {
      case "init":
        {
          var decoder = data.decoder;
          decoderPromise = createDecoderAsync(decoder.wasmUrl, decoder.wasmBinary, decoder.fallbackUrl);
          postMessage("done");
          break;
        }
      case "decodeMesh":
        {
          if (!decoderPromise) {
            throw new Error("Draco decoder module is not available");
          }
          decoderPromise.then(function (decoder) {
            decodeMesh(decoder.module, data.dataView, data.attributes, function (indices) {
              postMessage({
                id: "indices",
                value: indices
              }, [indices.buffer]);
            }, function (kind, data) {
              postMessage({
                id: kind,
                value: data
              }, [data.buffer]);
            });
            postMessage("done");
          });
          break;
        }
    }
  };
}
function getAbsoluteUrl(url) {
  if ((typeof document === "undefined" ? "undefined" : _typeof(document)) !== "object" || typeof url !== "string") {
    return url;
  }
  return BABYLON.Tools.GetAbsoluteUrl(url);
}

/**
 * Configuration for Draco compression
 */

/**
 * Draco compression (https://google.github.io/draco/)
 *
 * This class wraps the Draco module.
 *
 * **Encoder**
 *
 * The encoder is not currently implemented.
 *
 * **Decoder**
 *
 * By default, the configuration points to a copy of the Draco decoder files for glTF from the babylon.js preview cdn https://preview.babylonjs.com/draco_wasm_wrapper_gltf.js.
 *
 * To update the configuration, use the following code:
 * ```javascript
 *     DracoCompression.Configuration = {
 *         decoder: {
 *             wasmUrl: "<url to the WebAssembly library>",
 *             wasmBinaryUrl: "<url to the WebAssembly binary>",
 *             fallbackUrl: "<url to the fallback JavaScript library>",
 *         }
 *     };
 * ```
 *
 * Draco has two versions, one for WebAssembly and one for JavaScript. The decoder configuration can be set to only support Webssembly or only support the JavaScript version.
 * Decoding will automatically fallback to the JavaScript version if WebAssembly version is not configured or if WebAssembly is not supported by the browser.
 * Use `DracoCompression.DecoderAvailable` to determine if the decoder configuration is available for the current context.
 *
 * To decode Draco compressed data, get the default DracoCompression object and call decodeMeshAsync:
 * ```javascript
 *     var vertexData = await DracoCompression.Default.decodeMeshAsync(data);
 * ```
 *
 * @see https://www.babylonjs-playground.com/#N3EK4B#0
 */
var DracoCompression = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
   */
  function DracoCompression() {
    var numWorkers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DracoCompression.DefaultNumWorkers;
    _classCallCheck(this, DracoCompression);
    var decoder = DracoCompression.Configuration.decoder;
    var decoderWasmBinaryPromise = decoder.wasmUrl && decoder.wasmBinaryUrl && (typeof WebAssembly === "undefined" ? "undefined" : _typeof(WebAssembly)) === "object" ? loadFileAsync(getAbsoluteUrl(decoder.wasmBinaryUrl)) : Promise.resolve(undefined);
    if (numWorkers && typeof Worker === "function") {
      this._workerPoolPromise = decoderWasmBinaryPromise.then(function (decoderWasmBinary) {
        var workerContent = "".concat(loadScriptAsync).concat(createDecoderAsync).concat(decodeMesh, "(").concat(worker, ")()");
        var workerBlobUrl = URL.createObjectURL(new Blob([workerContent], {
          type: "application/javascript"
        }));
        var workerPromises = new Array(numWorkers);
        for (var i = 0; i < workerPromises.length; i++) {
          workerPromises[i] = new Promise(function (resolve, reject) {
            var worker = new Worker(workerBlobUrl);
            var onError = function onError(error) {
              worker.removeEventListener("error", onError);
              worker.removeEventListener("message", onMessage);
              reject(error);
            };
            var onMessage = function onMessage(message) {
              if (message.data === "done") {
                worker.removeEventListener("error", onError);
                worker.removeEventListener("message", onMessage);
                resolve(worker);
              }
            };
            worker.addEventListener("error", onError);
            worker.addEventListener("message", onMessage);
            worker.postMessage({
              id: "init",
              decoder: {
                wasmUrl: getAbsoluteUrl(decoder.wasmUrl),
                wasmBinary: decoderWasmBinary,
                fallbackUrl: getAbsoluteUrl(decoder.fallbackUrl)
              }
            });
          });
        }
        return Promise.all(workerPromises).then(function (workers) {
          return new _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__.WorkerPool(workers);
        });
      });
    } else {
      this._decoderModulePromise = decoderWasmBinaryPromise.then(function (decoderWasmBinary) {
        return createDecoderAsync(decoder.wasmUrl, decoderWasmBinary, decoder.fallbackUrl);
      });
    }
  }

  /**
   * Stop all async operations and release resources.
   */
  _createClass(DracoCompression, [{
    key: "dispose",
    value: function dispose() {
      //if (this._workerPoolPromise) {
      //    this._workerPoolPromise.then((workerPool) => {
      //        workerPool.dispose();
      //    });
      //}

      //delete this._workerPoolPromise;
      //delete this._decoderModulePromise;
    }

    /**
     * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
     * @returns a promise that resolves when ready
     */
  }, {
    key: "whenReadyAsync",
    value: function whenReadyAsync() {
      if (this._workerPoolPromise) {
        return this._workerPoolPromise.then(function () {});
      }
      if (this._decoderModulePromise) {
        return this._decoderModulePromise.then(function () {});
      }
      return Promise.resolve();
    }

    /**
      * Decode Draco compressed mesh data to vertex data.
      * @param data The ArrayBuffer or ArrayBufferView for the Draco compression data
      * @param attributes A map of attributes from vertex buffer kinds to Draco unique ids
      * @returns A promise that resolves with the decoded vertex data
      */
  }, {
    key: "decodeMeshAsync",
    value: function decodeMeshAsync(data, attributes) {
      var dataView = data instanceof ArrayBuffer ? new Uint8Array(data) : data;
      if (this._workerPoolPromise) {
        return this._workerPoolPromise.then(function (workerPool) {
          return new Promise(function (resolve, reject) {
            workerPool.push(function (worker, onComplete) {
              var vertexData = new BABYLON.VertexData();
              var onError = function onError(error) {
                worker.removeEventListener("error", onError);
                worker.removeEventListener("message", onMessage);
                reject(error);
                onComplete();
              };
              var onMessage = function onMessage(message) {
                if (message.data === "done") {
                  worker.removeEventListener("error", onError);
                  worker.removeEventListener("message", onMessage);
                  resolve(vertexData);
                  onComplete();
                } else if (message.data.id === "indices") {
                  vertexData.indices = message.data.value;
                } else {
                  vertexData.set(message.data.value, message.data.id);
                }
              };
              worker.addEventListener("error", onError);
              worker.addEventListener("message", onMessage);
              var dataViewCopy = new Uint8Array(dataView.byteLength);
              dataViewCopy.set(new Uint8Array(dataView.buffer, dataView.byteOffset, dataView.byteLength));
              worker.postMessage({
                id: "decodeMesh",
                dataView: dataViewCopy,
                attributes: attributes
              }, [dataViewCopy.buffer]);
            });
          });
        });
      }
      if (this._decoderModulePromise) {
        return this._decoderModulePromise.then(function (decoder) {
          var vertexData = new BABYLON.VertexData();
          decodeMesh(decoder.module, dataView, attributes, function (indices) {
            vertexData.indices = indices;
          }, function (kind, data) {
            vertexData.set(data, kind);
          });
          return vertexData;
        });
      }
      throw new Error("Draco decoder module is not available");
    }
  }], [{
    key: "DecoderAvailable",
    get:
    /**
     * Returns true if the decoder configuration is available.
     */
    function get() {
      var decoder = DracoCompression.Configuration.decoder;
      return !!(decoder.wasmUrl && decoder.wasmBinaryUrl && (typeof WebAssembly === "undefined" ? "undefined" : _typeof(WebAssembly)) === "object" || decoder.fallbackUrl);
    }

    /**
     * Default number of workers to create when creating the draco compression object.
     */
  }, {
    key: "GetDefaultNumWorkers",
    value: function GetDefaultNumWorkers() {
      if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) !== "object" || !navigator.hardwareConcurrency) {
        return 1;
      }

      // Use 50% of the available logical processors but capped at 4.
      return Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 1);
    }
  }, {
    key: "Default",
    get:
    /**
     * Default instance for the draco compression object.
     */
    function get() {
      if (!DracoCompression._Default) {
        DracoCompression._Default = new DracoCompression();
      }
      return DracoCompression._Default;
    }
  }]);
  return DracoCompression;
}();
/**
 * The configuration. Defaults to the following urls:
 * - wasmUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_wasm_wrapper.js"
 * - wasmBinaryUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.wasm"
 * - fallbackUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.js"
 */
_defineProperty(DracoCompression, "Configuration", {
  decoder: {
    //wasmUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_wasm_wrapper.js"),
    //wasmBinaryUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.wasm"),
    //fallbackUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.js")
    /*
    wasmUrl: "https://preview.babylonjs.com/draco_wasm_wrapper_gltf.js",
    wasmBinaryUrl: "https://preview.babylonjs.com/draco_decoder_gltf.wasm",
    fallbackUrl: "https://preview.babylonjs.com/draco_decoder_gltf.js"
    */
    wasmUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_wasm_wrapper.js",
    wasmBinaryUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.wasm",
    fallbackUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.js"
  }
});
_defineProperty(DracoCompression, "DefaultNumWorkers", DracoCompression.GetDefaultNumWorkers());
_defineProperty(DracoCompression, "_Default", null);

/***/ }),

/***/ "../../3D/src/Components/Environment/EnvironmentManager.ts":
/*!*****************************************************************!*\
  !*** ../../3D/src/Components/Environment/EnvironmentManager.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnvironmentManager": () => (/* binding */ EnvironmentManager)
/* harmony export */ });
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


var EnvironmentManager = /*#__PURE__*/function () {
  function EnvironmentManager(zkScene, scene) {
    var isHologram = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _classCallCheck(this, EnvironmentManager);
    _defineProperty(this, "_originalSceneClearColor", null);
    _defineProperty(this, "_originalCameraAutoRotate", null);
    _defineProperty(this, "_environmentHelper", null);
    _defineProperty(this, "_shadowLight", null);
    _defineProperty(this, "_isHologram", false);
    this._zkScene = zkScene;
    this._scene = scene;
    this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_1__.SceneHelper(this._scene);
    this._isHologram = isHologram;
  }
  _createClass(EnvironmentManager, [{
    key: "scene",
    get: function get() {
      return this._scene;
    }
  }, {
    key: "isHologram",
    get: function get() {
      return this._isHologram;
    },
    set: function set(value) {
      this._isHologram = value;
      this.update();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._shadowLight) this._shadowLight.dispose();
      if (this._environmentHelper) {
        this._environmentHelper.dispose();
        this._environmentHelper = null;
      }
      ;
      this.removeOldSkybox();
    }
  }, {
    key: "update",
    value: function update() {
      this.configureScene();
      this.configureCamera();
      this.configureSkybox();
    }
  }, {
    key: "configureSkybox",
    value: function configureSkybox() {
      this.removeOldSkybox();
      if (!this._isHologram) this.createSkybox();
    }
  }, {
    key: "removeOldSkybox",
    value: function removeOldSkybox() {
      var mesh = this.getSkyboxMesh();
      var material = this.getSkyboxMaterial();
      if (mesh) mesh.dispose();
      if (material) material.dispose();
    }
  }, {
    key: "createSkybox",
    value: function createSkybox() {
      var generalConfig = this.getGeneralConfig();
      var environmentConfig = this.getEnvironmentConfig();
      var skyboxConfig = this.getSkyboxConfig();
      if (skyboxConfig && skyboxConfig.get("createSkybox") != undefined && skyboxConfig.get("createSkybox")) {
        var _skyboxConfig$get, _skyboxConfig$get2;
        var sizeAuto = true;
        if (environmentConfig && environmentConfig.get("sizeAuto") != undefined && environmentConfig.get("sizeAuto") != null && typeof environmentConfig.get("sizeAuto") === "boolean") sizeAuto = environmentConfig.get("sizeAuto");
        var skyboxSize = null;
        if (skyboxConfig.get("size") != undefined && typeof skyboxConfig.get("size") === 'number') skyboxSize = skyboxConfig.get("size");
        var url = null;
        if (skyboxConfig.get("texture") != undefined && typeof skyboxConfig.get("texture") === "string") url = skyboxConfig.get("texture");
        var blur = 0;
        if (skyboxConfig.get("blur") > 0) blur = skyboxConfig.get("blur");
        var extensions = null;
        if (skyboxConfig.get("extensions") != undefined && skyboxConfig.get("extensions") != null && Object.prototype.toString.call(skyboxConfig.get("extensions")) === '[object Array]' && ((_skyboxConfig$get = skyboxConfig.get("extensions")) === null || _skyboxConfig$get === void 0 ? void 0 : _skyboxConfig$get.length) === 6) {
          extensions = skyboxConfig.get("extensions");
        }
        var files = null;
        if (skyboxConfig.get("files") != undefined && skyboxConfig.get("files") != null && Object.prototype.toString.call(skyboxConfig.get("files")) === '[object Array]' && ((_skyboxConfig$get2 = skyboxConfig.get("files")) === null || _skyboxConfig$get2 === void 0 ? void 0 : _skyboxConfig$get2.length) === 6) {
          files = skyboxConfig.get("files");
        }
        if (url) {
          var texture = null;
          if (url.endsWith(".dds")) texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);else if (url.endsWith(".hdr")) texture = new BABYLON.HDRCubeTexture(url, this._scene, 256, false, true, false, true);else if (url.endsWith(".env")) {
            texture = new BABYLON.CubeTexture(url, this._scene, null, false, null, undefined, null, undefined, true, undefined, true);
          } else if (url.endsWith(".basis")) {
            texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);
          } else if (extensions && files) {
            texture = new BABYLON.CubeTexture(url, this._scene, extensions, false, files, undefined);
          } else {
            texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);
          }
          if (texture) {
            var scale = 1000;
            if (skyboxSize != null && skyboxSize > 0) scale = skyboxSize;else scale = (this._scene.activeCamera.maxZ - this._scene.activeCamera.minZ) / 2;
            var hdrSkybox = this._scene.createDefaultSkybox(texture, true, scale, blur, false);
            if (hdrSkybox) {
              hdrSkybox.metadata = {
                isSkyboxMesh: true,
                isRealMesh: false
              };
              hdrSkybox.doNotSerialize = true;
              var material = hdrSkybox.material;
              if (material) {
                material.metadata = {
                  isSkyboxMaterial: true,
                  isRealMaterial: false
                };
                material.doNotSerialize = true;
              }
            }
          }
        }
      }
    }
  }, {
    key: "getSkyboxMesh",
    value: function getSkyboxMesh() {
      var mesh = this._scene.meshes.find(function (m) {
        return m.metadata && m.metadata.isSkyboxMesh;
      });
      return mesh || null;
    }
  }, {
    key: "getSkyboxMaterial",
    value: function getSkyboxMaterial() {
      var material = this._scene.materials.find(function (m) {
        return m.metadata && m.metadata.isSkyboxMaterial;
      });
      if (!material) return null;
      return material;
    }
  }, {
    key: "getSkyboxTexture",
    value: function getSkyboxTexture() {
      var material = this.getSkyboxMaterial();
      if (material) return material.reflectionTexture;
      return null;
    }
  }, {
    key: "update_OLD",
    value: function update_OLD() {
      this.configureScene();
      this.configureCamera();
      this.configureEnvironment();
    }
  }, {
    key: "configureScene",
    value: function configureScene() {
      if (!this._scene) return;
      this._originalSceneClearColor = this._scene.clearColor.clone();
      if (this._isHologram) {
        this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 1);
        return;
      }
      var generalConfig = this.getGeneralConfig();
      if (generalConfig) {
        var alpha = null;
        if (generalConfig.get("backgroundAlpha") != undefined && generalConfig.get("backgroundAlpha") != null && typeof generalConfig.get("backgroundAlpha") === 'number') alpha = generalConfig.get("backgroundAlpha");
        var color = null;
        if (generalConfig.get("backgroundColor") != undefined && typeof generalConfig.get("backgroundColor") === "string" && this.isValidHexColor(generalConfig.get("backgroundColor"))) color = generalConfig.get("backgroundColor");

        // Clear color
        if (alpha || color) {
          this._originalSceneClearColor = this._scene.clearColor;
          var oldcc = this._scene.clearColor;
          if (color != null) {
            var cc = BABYLON.Color3.FromHexString(color);
            oldcc.r = cc.r;
            oldcc.g = cc.g;
            oldcc.b = cc.b;
          }
          if (alpha != null) {
            oldcc.a = alpha;
          }
        }
      }
    }
  }, {
    key: "configureEnvironment",
    value: function configureEnvironment() {
      if (this._environmentHelper) {
        this._environmentHelper.dispose();
        this._environmentHelper = null;
      }
      ;
      if (this._shadowLight) {
        this._shadowLight.dispose();
        this._shadowLight = null;
      }
      if (this._sceneHelper.countSceneMeshes() == 0) return;
      var options = this.buildEnvironmentHelperOptions();
      if (options) {
        this._environmentHelper = this._scene.createDefaultEnvironment(options);

        /*if (this._environmentHelper && options.mainColor != undefined)
            this._environmentHelper.setMainColor(options.mainColor);*/

        // Make all environment not serializable
        var nodes = this.getEnvironmentSceneNodes();
        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          if (node) {
            this.setDoNotSerialize(node);
            if (!node.metadata) node.metadata = {};
            node.metadata.isEnvironmentNode = true;
            if (node instanceof BABYLON.AbstractMesh) {
              node.isPickable = false;
              node.metadata.isRealMesh = false;
            }
            if (node instanceof BABYLON.Material) node.metadata.isRealMaterial = false;
          }
        }
      }
    }
  }, {
    key: "buildEnvironmentHelperOptions",
    value: function buildEnvironmentHelperOptions() {
      var options = null;
      var generalConfig = this.getGeneralConfig();
      var environmentConfig = this.getEnvironmentConfig();
      var skyboxConfig = this.getSkyboxConfig();
      var groundConfig = this.getGroundConfig();
      var cameraConfig = this.getCameraConfig();

      // La environment non viene più gestita come parametro del viewer,
      // bensì come impostazione generale della scena
      /*
      if (generalConfig && generalConfig.get("environmentTexture") != undefined) {
          options = options || {};
          options.environmentTexture = generalConfig.get("environmentTexture");
      } 
      */

      var environmentTexture = null;
      if (generalConfig && generalConfig.get("environmentTexture") != undefined && generalConfig.get("environmentTexture") != null) environmentTexture = generalConfig.get("environmentTexture");
      var contrast = null;
      if (cameraConfig && cameraConfig.get("contrast") != undefined && typeof cameraConfig.get("contrast") === 'number') contrast = cameraConfig.get("contrast");
      var exposure = null;
      if (cameraConfig && cameraConfig.get("exposure") != undefined && typeof cameraConfig.get("exposure") === 'number') exposure = cameraConfig.get("exposure");
      var toneMappingEnabled = null;
      if (cameraConfig && cameraConfig.get("toneMappingEnabled") != undefined && typeof cameraConfig.get("toneMappingEnabled") === 'boolean') toneMappingEnabled = cameraConfig.get("toneMappingEnabled");
      var sizeAuto = null;
      if (environmentConfig && environmentConfig.get("sizeAuto") != undefined && environmentConfig.get("sizeAuto") != null && typeof environmentConfig.get("sizeAuto") === "boolean") sizeAuto = environmentConfig.get("sizeAuto");
      var mainColor = null;
      if (environmentConfig && environmentConfig.get("mainColor") != undefined && typeof environmentConfig.get("mainColor") === "string" && this.isValidHexColor(environmentConfig.get("mainColor"))) mainColor = environmentConfig.get("mainColor");
      var groundSize = null;
      if (groundConfig && groundConfig.get("size") != undefined && typeof groundConfig.get("size") === 'number') groundSize = groundConfig.get("size");
      var groundColor = null;
      if (groundConfig && groundConfig.get("color") != undefined && typeof groundConfig.get("color") === "string" && this.isValidHexColor(groundConfig.get("color"))) groundColor = groundConfig.get("color");
      var enableShadow = null;
      if (groundConfig && groundConfig.get("enableShadow") != undefined && typeof groundConfig.get("enableShadow") === "boolean") enableShadow = groundConfig.get("enableShadow");
      var shadowLevel = null;
      if (groundConfig && groundConfig.get("shadowLevel") != undefined && typeof groundConfig.get("shadowLevel") === 'number') shadowLevel = groundConfig.get("shadowLevel");
      var enableMirror = null;
      if (groundConfig && groundConfig.get("enableMirror") != undefined && typeof groundConfig.get("enableMirror") === "boolean") enableMirror = groundConfig.get("enableMirror");
      var groundTexture = null;
      if (groundConfig && groundConfig.get("texture") != undefined && typeof groundConfig.get("texture") === "string") groundTexture = groundConfig.get("texture");
      var groundOpacity = null;
      if (groundConfig && groundConfig.get("opacity") != undefined && typeof groundConfig.get("opacity") === 'number') groundOpacity = groundConfig.get("opacity");
      var mirrorBlurKernel = null;
      if (groundConfig && groundConfig.get("mirrorBlurKernel") != undefined && typeof groundConfig.get("mirrorBlurKernel") === 'number') mirrorBlurKernel = groundConfig.get("mirrorBlurKernel");
      var skyboxSize = null;
      if (skyboxConfig && skyboxConfig.get("size") != undefined && typeof skyboxConfig.get("size") === 'number') skyboxSize = skyboxConfig.get("size");
      var skyboxColor = null;
      if (skyboxConfig && skyboxConfig.get("color") != undefined && typeof skyboxConfig.get("color") === "string" && this.isValidHexColor(skyboxConfig.get("color"))) skyboxColor = skyboxConfig.get("color");
      var skyboxTexture = null;
      if (skyboxConfig && skyboxConfig.get("texture") != undefined && typeof skyboxConfig.get("texture") === "string") skyboxTexture = skyboxConfig.get("texture");
      var setupImageProcessing = environmentTexture != null || contrast != null || exposure != null || toneMappingEnabled;
      if (skyboxConfig || groundConfig || setupImageProcessing) {
        options = options || {
          createSkybox: skyboxConfig && skyboxConfig.get("createSkybox"),
          createGround: groundConfig && groundConfig.get("createGround")
        };

        // Disabilitato per il momento perché da problemi nel rendering di alcuni material
        options.setupImageProcessing = false;
        if (environmentTexture != null) {
          options.environmentTexture = environmentTexture;
        }
        if (options.createSkybox || options.createGround) {
          // General Environment options
          if (sizeAuto != null) {
            options.sizeAuto = sizeAuto;
          }
          if (mainColor != null) {
            options.mainColor = BABYLON.Color3.FromHexString(mainColor);
          }

          // Ground options
          if (options.createGround) {
            if (!options.sizeAuto && groundSize != null) {
              options.groundSize = groundSize;
            }
            if (!options.mainColor && groundColor != null) options.groundColor = BABYLON.Color3.FromHexString(groundColor);
            if (enableShadow != null) {
              options.enableGroundShadow = enableShadow;
            }
            if (options.enableGroundShadow) {
              this.createShadowLight();
            }
            if (shadowLevel != null) {
              options.groundShadowLevel = shadowLevel;
            }
            if (enableMirror != null) {
              options.enableGroundMirror = enableMirror;
            }
            if (groundTexture != null) {
              options.groundTexture = groundTexture;
            }
            if (groundOpacity != null) {
              options.groundOpacity = groundOpacity;
            }
            if (options.enableGroundMirror && mirrorBlurKernel != null) {
              options.groundMirrorBlurKernel = mirrorBlurKernel;
            }
          }

          // Skybox options
          if (options.createSkybox) {
            if (!options.sizeAuto && skyboxSize != null) {
              options.skyboxSize = skyboxSize;
            }
            if (!options.mainColor && skyboxColor != null) options.skyboxColor = BABYLON.Color3.FromHexString(skyboxColor);
            if (skyboxTexture != null) {
              options.skyboxTexture = skyboxTexture;
            }
          }

          // test
          if (cameraConfig) {
            if (contrast != null) {
              options.cameraContrast = contrast;
            }
            if (exposure != null) {
              options.cameraExposure = exposure;
            }
            if (toneMappingEnabled != null) {
              options.toneMappingEnabled = toneMappingEnabled;
            }
          }
        }
      }

      // TEST
      // Imposto gli url di default, se necessario. Così evito che vengano usati gli url 
      // di default di babylon
      if (options) {
        if (!options.environmentTexture && !this._scene.environmentTexture) options.environmentTexture = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_0__.DefaultAssetUrls.Environment.EnvironmentTextureCDNUrl;
        if (options.createGround != undefined && options.createGround && !options.groundTexture) {
          options.groundTexture = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_0__.DefaultAssetUrls.Environment.GroundTextureCDNUrl;
        }
        if (options.createSkybox != undefined && options.createSkybox && !options.skyboxTexture) {
          options.skyboxTexture = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_0__.DefaultAssetUrls.Environment.SkyboxTextureCDNUrl;
        }
      }
      return options;
    }
  }, {
    key: "createShadowLight",
    value: function createShadowLight() {
      if (this._shadowLight) {
        this._shadowLight.dispose();
        this._shadowLight = null;
      }
      if (this._scene && this._sceneHelper) {
        var bounds = this._sceneHelper.getSceneBoundingInfo();
        if (bounds && bounds.boundingBox) {
          var vectorsWorld = bounds.boundingBox.vectorsWorld;
          var width = Number(vectorsWorld[1].x - vectorsWorld[0].x);
          var height = Number(vectorsWorld[1].y - vectorsWorld[0].y);
          var depth = Number(vectorsWorld[1].z - vectorsWorld[0].z);
          var center = bounds.boundingBox.centerWorld;
          var max = bounds.boundingBox.maximumWorld;
          var x = center.x + width * 2.67;
          var y = center.y + height * 4.5;
          var z = center.z + depth * 1;
          var origin = new BABYLON.Vector3(x, y, z);
          var target = center;
          var direction = target.subtract(origin);
          direction = BABYLON.Vector3.Normalize(direction);
          direction = new BABYLON.Vector3(-2, -3, 1);
          this._shadowLight = new BABYLON.DirectionalLight("shadowLight", direction, this._scene);
          this._shadowLight.position = origin;
          this._shadowLight.intensity = 0.1;
          var generator = new BABYLON.ShadowGenerator(512, this._shadowLight);
          generator.useBlurExponentialShadowMap = true;
          generator.useKernelBlur = true;
          generator.usePercentageCloserFiltering = true;
          generator.blurKernel = 32;
          for (var i = 0; i < this._scene.meshes.length; i++) {
            var mesh = this._scene.meshes[i];
            if (!this.isEnvironmentNode(mesh) && this._sceneHelper.isRealMesh(mesh)) {
              mesh.receiveShadows = false;
              generator.addShadowCaster(mesh);
            }
          }
        }
      }
    }
  }, {
    key: "configureCamera",
    value: function configureCamera() {
      if (!this._scene || !this._scene.activeCamera || !(this._scene.activeCamera instanceof BABYLON.ArcRotateCamera)) return;
      var cameraConfig = this.getCameraConfig();
      if (cameraConfig) {
        var camera = this._scene.activeCamera;
        this._originalCameraAutoRotate = camera.useAutoRotationBehavior;
        var autoRotate = cameraConfig.get("autoRotate");
        camera.useAutoRotationBehavior = autoRotate != undefined && autoRotate;
      }
    }
  }, {
    key: "sanityCheck",
    value: function sanityCheck() {
      return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != undefined && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
    }
  }, {
    key: "getSceneConfig",
    value: function getSceneConfig() {
      if (this.sanityCheck()) {
        var config = this._zkScene.getSceneConfig();
        if (config != undefined && config != null) return config;
      }
      return null;
    }
  }, {
    key: "getGeneralConfig",
    value: function getGeneralConfig() {
      if (this.sanityCheck()) {
        var config = this._zkScene.getGeneralConfig();
        if (config != undefined && config != null) return config;
      }
      return null;
    }
  }, {
    key: "getEnvironmentConfig",
    value: function getEnvironmentConfig() {
      if (this.sanityCheck()) {
        var config = this._zkScene.getEnvironmentConfig();
        if (config != undefined && config != null) return config;
      }
      return null;
    }
  }, {
    key: "getSkyboxConfig",
    value: function getSkyboxConfig() {
      if (this.sanityCheck()) {
        var config = this._zkScene.getSkyboxConfig();
        if (config != undefined && config != null) return config;
      }
      return null;
    }
  }, {
    key: "getGroundConfig",
    value: function getGroundConfig() {
      if (this.sanityCheck()) {
        var config = this._zkScene.getGroundConfig();
        if (config != undefined && config != null) return config;
      }
      return null;
    }
  }, {
    key: "getCameraConfig",
    value: function getCameraConfig() {
      if (this.sanityCheck()) {
        var config = this._zkScene.getCameraConfig();
        if (config != undefined && config != null) return config;
      }
      return null;
    }
  }, {
    key: "isValidHexColor",
    value: function isValidHexColor(hexColor) {
      return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hexColor);
    }
  }, {
    key: "getEnvironmentSceneNodes",
    value: function getEnvironmentSceneNodes() {
      var nodes = [];
      if (this._environmentHelper) {
        if (this._environmentHelper.rootMesh) nodes.push(this._environmentHelper.rootMesh);
        if (this._environmentHelper.skybox) nodes.push(this._environmentHelper.skybox);
        if (this._environmentHelper.skyboxMaterial) nodes.push(this._environmentHelper.skyboxMaterial);
        if (this._environmentHelper.skyboxTexture) nodes.push(this._environmentHelper.skyboxTexture);
        if (this._environmentHelper.ground) nodes.push(this._environmentHelper.ground);
        if (this._environmentHelper.groundMaterial) nodes.push(this._environmentHelper.groundMaterial);
        if (this._environmentHelper.groundTexture) nodes.push(this._environmentHelper.groundTexture);
        if (this._environmentHelper.groundMirror) nodes.push(this._environmentHelper.groundMirror);
        if (this._shadowLight) nodes.push(this._shadowLight);
      }
      return nodes;
    }
  }, {
    key: "isEnvironmentNode",
    value: function isEnvironmentNode(node) {
      var nodes = this.getEnvironmentSceneNodes();
      for (var i = 0; i < nodes.length; i++) {
        if (node == nodes[i]) return true;
      }
      return false;
    }
  }, {
    key: "setDoNotSerialize",
    value: function setDoNotSerialize(node) {
      if (node instanceof BABYLON.AbstractMesh || node instanceof BABYLON.Material || node instanceof BABYLON.Light) {
        node.doNotSerialize = true;
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      if (!this._scene) return;
      if (this._originalSceneClearColor) this._scene.clearColor = this._originalSceneClearColor;
      if (this._originalCameraAutoRotate != null && this._scene.activeCamera && this._scene.activeCamera instanceof BABYLON.ArcRotateCamera) this._scene.activeCamera.useAutoRotationBehavior = this._originalCameraAutoRotate;
      if (this._environmentHelper) this._environmentHelper.updateOptions({});
    }
  }]);
  return EnvironmentManager;
}();

/***/ }),

/***/ "../../3D/src/Components/Glow/GlowManager.ts":
/*!***************************************************!*\
  !*** ../../3D/src/Components/Glow/GlowManager.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GlowManager": () => (/* binding */ GlowManager)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var GlowManager = /*#__PURE__*/function () {
  function GlowManager(zkScene, scene) {
    _classCallCheck(this, GlowManager);
    _defineProperty(this, "_glowLayer", null);
    this._zkScene = zkScene;
    this._scene = scene;
    this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper(this._scene);
    this._glowLayer = this._scene.getGlowLayerByName("glow");
  }
  _createClass(GlowManager, [{
    key: "enabled",
    get: function get() {
      var glowConfig = this.getGlowConfig();
      var enabled = null;
      if (glowConfig && glowConfig.get("enabled") != undefined && typeof glowConfig.get("enabled") === 'boolean') enabled = glowConfig.get("enabled");
      return false;
    },
    set: function set(value) {
      var glowConfig = this.getOrCreateGlowConfig();
      if (glowConfig) glowConfig.set("enabled", value);
      this.update();
    }
  }, {
    key: "intensity",
    get: function get() {
      var glowConfig = this.getGlowConfig();
      var intensity = null;
      if (glowConfig && glowConfig.get("intensity") != undefined && typeof glowConfig.get("intensity") === 'number') intensity = glowConfig.get("intensity");
      return 1;
    },
    set: function set(value) {
      var glowConfig = this.getOrCreateGlowConfig();
      if (glowConfig) glowConfig.set("intensity", value);
      this.update();
    }
  }, {
    key: "blurSize",
    get: function get() {
      var glowConfig = this.getGlowConfig();
      var intensity = null;
      if (glowConfig && glowConfig.get("blurSize") != undefined && typeof glowConfig.get("blurSize") === 'number') intensity = glowConfig.get("blurSize");
      return 1;
    },
    set: function set(value) {
      var glowConfig = this.getOrCreateGlowConfig();
      if (glowConfig) glowConfig.set("blurSize", value);
      this.update();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.destroyGlowLayer();
    }
  }, {
    key: "destroyGlowLayer",
    value: function destroyGlowLayer() {
      if (this._glowLayer) {
        this._glowLayer.dispose();
        this._glowLayer = null;
      }
    }
  }, {
    key: "createOrUpdateGlowLayer",
    value: function createOrUpdateGlowLayer(intensity, blurSize) {
      if (!this._glowLayer) this._glowLayer = new BABYLON.GlowLayer("glow", this._scene);
      if (this._glowLayer) {
        this._glowLayer.intensity = intensity;
        this._glowLayer.blurKernelSize = blurSize;
      }
    }
  }, {
    key: "update",
    value: function update() {
      if (!this._scene) return;
      var glowConfig = this.getGlowConfig();
      if (glowConfig) {
        var enabled = this.enabled;
        var intensity = this.intensity;
        var blurSize = this.blurSize;
        if (enabled) {
          this.createOrUpdateGlowLayer(intensity, blurSize);
        } else {
          this.destroyGlowLayer();
        }
      } else {
        this.destroyGlowLayer();
      }
    }
  }, {
    key: "turnOffGlow",
    value: function turnOffGlow() {
      this.destroyGlowLayer();
    }
  }, {
    key: "turnOnGlow",
    value: function turnOnGlow() {
      this.update();
    }
  }, {
    key: "sanityCheck",
    value: function sanityCheck() {
      return this._scene && this._scene instanceof BABYLON.Scene && this._zkScene && this._zkScene instanceof Zakeke.Scene && this._zkScene.get("config") != undefined && this._zkScene.get("config") != null && this._zkScene.get("config") instanceof Zakeke.SceneConfig;
    }
  }, {
    key: "isGlowEnabledForMesh",
    value: function isGlowEnabledForMesh(mesh) {
      if (mesh) return mesh.metadata && mesh.metadata.enableGlow;
      return false;
    }

    // La possibilità di abilitare solo alcune mesh al glow viene disabilitata
    // perché c'è il problema che l'effetto glow è visibile attraverso le mesh
    // per cui il glow è diabilitato
  }, {
    key: "enableGlowForMesh",
    value: function enableGlowForMesh(mesh) {}
  }, {
    key: "disableGlowForMesh",
    value: function disableGlowForMesh(mesh) {}
  }, {
    key: "getGlowConfig",
    value: function getGlowConfig() {
      if (this.sanityCheck()) {
        var config = this._zkScene.getGlowConfig();
        if (config) return config;
      }
      return null;
    }
  }, {
    key: "getOrCreateGlowConfig",
    value: function getOrCreateGlowConfig() {
      if (this.sanityCheck()) {
        return this._zkScene.getOrCreateGlowConfig();
      }
      return null;
    }
  }]);
  return GlowManager;
}();

/***/ }),

/***/ "../../3D/src/Components/IncrementalFiles/IncrementalFiles.ts":
/*!********************************************************************!*\
  !*** ../../3D/src/Components/IncrementalFiles/IncrementalFiles.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IncrementalFiles": () => (/* binding */ IncrementalFiles)
/* harmony export */ });
/* harmony import */ var _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Misc/WorkerPool */ "../../3D/src/Misc/WorkerPool.ts");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

//import { MakeIncremental } from "./MakeIncremental";

function loadScriptAsync(url) {
  if (typeof importScripts === "function") {
    importScripts(url);
    return Promise.resolve();
  } else {
    return new Promise(function (resolve, reject) {
      BABYLON.Tools.LoadScript(url, function () {
        resolve();
      }, function (message) {
        reject(new Error(message));
      });
    });
  }
}
function importWorkerScriptsAsync(urls) {
  if (urls.length == 0) return Promise.resolve();
  var promises = [];
  for (var i = 0; i < urls.length; i++) {
    promises.push(loadScriptAsync(urls[i]));
  }
  return new Promise(function (resolve) {
    Promise.all(promises).then(function () {
      return resolve();
    });
  });
}
function makeIncrementalFiles(sceneJson, version, options) {
  var makeIncremental = new MakeIncremental();
  var files = makeIncremental.getSceneIncrementalFiles(sceneJson, version, options);
  return files;
}

/**
 * The worker function that gets converted to a blob url to pass into a worker.
 */
function worker() {
  var initializerPromise;
  onmessage = function onmessage(event) {
    var data = event.data;
    switch (data.id) {
      case "init":
        {
          var urls = data.urls;
          initializerPromise = importWorkerScriptsAsync(urls);
          postMessage("done");
          break;
        }
      case "makeIncremental":
        {
          if (!initializerPromise) {
            throw new Error("Worker not initialized");
          }
          initializerPromise.then(function () {
            var sceneJson = data.sceneJson;
            var version = data.version;
            var options = data.options;
            var files = makeIncrementalFiles(sceneJson, version, options);
            postMessage({
              id: "result",
              files: files
            });
            postMessage("done");
          });
          break;
        }
    }
  };
}
function getAbsoluteUrl(url) {
  if ((typeof document === "undefined" ? "undefined" : _typeof(document)) !== "object" || typeof url !== "string") {
    return url;
  }
  return BABYLON.Tools.GetAbsoluteUrl(url);
}

// La classe si occupa di eseguire la suddivisione (ed eventuale compressione Draco)
// in un worker thread. Per la reale suddivisione utilizza la classe MakeIncrmental
var IncrementalFiles = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
  */
  function IncrementalFiles() {
    var numWorkers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IncrementalFiles.DefaultNumWorkers;
    _classCallCheck(this, IncrementalFiles);
    var scriptUrls = ['/Scripts/libs/underscore/underscore.js', '/Scripts/libs/backbone/backbone.js', '/Scripts/libs/backbone/backbone-associations.js', '/Scripts/libs/msgpack/msgpack.min.js', '/Scripts/libs/draco/draco_encoder.js', '/Scripts/composer/models/model.js', '/Scripts/composer/helpers/utils.js', '/Scripts/3D/dist/MakeIncremental.js'].map(function (url) {
      return getAbsoluteUrl(url);
    });
    if (numWorkers && typeof Worker === "function") {
      var workerContent = "".concat(loadScriptAsync).concat(importWorkerScriptsAsync).concat(makeIncrementalFiles, "(").concat(worker, ")()");
      var workerBlobUrl = URL.createObjectURL(new Blob([workerContent], {
        type: "application/javascript"
      }));
      var workerPromises = new Array(numWorkers);
      for (var i = 0; i < workerPromises.length; i++) {
        workerPromises[i] = new Promise(function (resolve, reject) {
          var worker = new Worker(workerBlobUrl);
          var onError = function onError(error) {
            worker.removeEventListener("error", onError);
            worker.removeEventListener("message", onMessage);
            reject(error);
          };
          var onMessage = function onMessage(message) {
            if (message.data === "done") {
              worker.removeEventListener("error", onError);
              worker.removeEventListener("message", onMessage);
              resolve(worker);
            }
          };
          worker.addEventListener("error", onError);
          worker.addEventListener("message", onMessage);
          worker.postMessage({
            id: "init",
            urls: scriptUrls
          });
        });
      }
      this._workerPoolPromise = Promise.all(workerPromises).then(function (workers) {
        return new _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__.WorkerPool(workers);
      });
    }
  }
  _createClass(IncrementalFiles, [{
    key: "dispose",
    value: function dispose() {
      //if (this._workerPoolPromise) {
      //    this._workerPoolPromise.then((workerPool) => {
      //        workerPool.dispose();
      //    });
      //}

      //delete this._workerPoolPromise;
    }

    /**
     * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
     * @returns a promise that resolves when ready
     */
  }, {
    key: "whenReadyAsync",
    value: function whenReadyAsync() {
      if (this._workerPoolPromise) {
        return this._workerPoolPromise.then(function () {});
      }
      return Promise.resolve();
    }
  }, {
    key: "getIncrementalFilesAsync",
    value: function getIncrementalFilesAsync(sceneJson, version, options) {
      if (this._workerPoolPromise) {
        return this._workerPoolPromise.then(function (workerPool) {
          return new Promise(function (resolve, reject) {
            workerPool.push(function (worker, onComplete) {
              var files = [];
              var onError = function onError(error) {
                worker.removeEventListener("error", onError);
                worker.removeEventListener("message", onMessage);
                reject(error);
                onComplete();
              };
              var onMessage = function onMessage(message) {
                if (message.data === "done") {
                  worker.removeEventListener("error", onError);
                  worker.removeEventListener("message", onMessage);
                  resolve(files);
                  onComplete();
                } else if (message.data.id === "result") {
                  files = message.data.files;
                }
              };
              worker.addEventListener("error", onError);
              worker.addEventListener("message", onMessage);
              worker.postMessage({
                id: "makeIncremental",
                sceneJson: sceneJson,
                version: version,
                options: options
              });
            });
          });
        });
      }
      throw new Error("Incremental file worker is not available");
    }
  }], [{
    key: "GetDefaultNumWorkers",
    value: function GetDefaultNumWorkers() {
      if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) !== "object" || !navigator.hardwareConcurrency) {
        return 1;
      }

      // Use 50% of the available logical processors but capped at 4.
      return Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
    }
  }, {
    key: "Default",
    get:
    /**
     * Default instance for the incremental file maker
     */
    function get() {
      if (!IncrementalFiles._Default) {
        IncrementalFiles._Default = new IncrementalFiles();
      }
      return IncrementalFiles._Default;
    }
  }]);
  return IncrementalFiles;
}();
/**
 * Default number of workers to create when splitting files
 */
_defineProperty(IncrementalFiles, "DefaultNumWorkers", IncrementalFiles.GetDefaultNumWorkers());
_defineProperty(IncrementalFiles, "_Default", null);

/***/ }),

/***/ "../../3D/src/Components/IncrementalFiles/MakeIncremental.ts":
/*!*******************************************************************!*\
  !*** ../../3D/src/Components/IncrementalFiles/MakeIncremental.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MakeIncremental": () => (/* binding */ MakeIncremental)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// Classe che si occupa di spezzare il file di scena in tanti file più piccoli
// per il caricamento incrementale. Un file può essere ottenuto sia dalla geometria
// di una mesh che da un materiale. Nel caso di geometria, se abilitata, avverrà
// la compressione Draco dei dati.
var MakeIncremental = /*#__PURE__*/function () {
  function MakeIncremental() {
    _classCallCheck(this, MakeIncremental);
  }
  _createClass(MakeIncremental, [{
    key: "getSceneIncrementalFiles",
    value:
    // Spezzo la scena in tanti file per un caricamento incrementale delle mesh
    // la funzione accetta il JSON ottenuto dalla serializzazione della scena
    // e restituisce un elenco di oggetti Zakeke.IncrementalFileInfo
    // Se abilitata la codifica Draco, la proprietà "data" conterrà l'ArrayBuffer
    // con i byte dell'oggetto serializzato contenente, tra l'altro, i dati codificati con Draco
    function getSceneIncrementalFiles(sceneJson, version, options) {
      var _this = this;
      var files = [];
      var dracoOptions = {
        useDraco: options.useDraco || false,
        dracoEncodingSpeed: options.dracoEncodingSpeed || 5,
        dracoDecodingSpeed: options.dracoDecodingSpeed || 5
      };
      var excludedMeshes = options.excludedMeshes || [];
      sceneJson.autoClear = true;
      // Test -
      //sceneJson.useDelayedTextureLoading = false;
      // lascio il valore impostato sulla scena

      var doNotDelayLoadingForGeometries = [];

      // Parsing meshes
      sceneJson.meshes.forEach(function (mesh) {
        if (!excludedMeshes.some(function (meshCheck) {
          return meshCheck.test(mesh.name);
        })) {
          // Do not delay load visibile object

          // TEST Ritardo il caricamento anche degli oggetti visibili
          /*
          if (mesh.isVisible) {
              if (mesh.geometryId)
                  doNotDelayLoadingForGeometries.push(mesh.geometryId);
              return;
          }
          */

          // Escludo le mesh con submesh per un bug di Babylon JS in fase di caricamento
          if (mesh.subMeshes && mesh.subMeshes.length > 1) {
            if (mesh.geometryId) doNotDelayLoadingForGeometries.push(mesh.geometryId);
            return;
          }

          // Do not delay load collisions object
          if (mesh.checkCollisions) {
            if (mesh.geometryId) {
              doNotDelayLoadingForGeometries.push(mesh.geometryId);
            }
          } else {
            var incrementalFileInfo = _this.extractIncrementalFile(version, mesh, true, dracoOptions);
            if (incrementalFileInfo) files.push(incrementalFileInfo);
          }
        }
      });

      // Parsing vertexData
      var geometries = sceneJson.geometries;
      if (geometries) {
        var vertexData = geometries.vertexData;
        vertexData.forEach(function (geometry) {
          var id = geometry.id;
          if (!doNotDelayLoadingForGeometries.some(function (g) {
            return g === id;
          })) {
            var incrementalFileInfo = _this.extractIncrementalFile(version, geometry, false, dracoOptions);
            if (incrementalFileInfo) files.push(incrementalFileInfo);
          }
        });
      }

      // Delayed Material Loading
      // I materiali non indicati vengono salvati in file a parte per un cricamento ritardato
      if (sceneJson.metadata && sceneJson.metadata.delayedMaterials) {
        var ids = Object.keys(sceneJson.metadata.delayedMaterials);
        var _loop = function _loop(_i) {
          var material = sceneJson.materials[_i];
          if (ids.some(function (id) {
            return id === material.id;
          })) {
            var info = sceneJson.metadata.delayedMaterials[material.id];
            var incrementalFileInfo = _this.extractIncrementalMaterialFile(version, material, info.file);
            if (incrementalFileInfo) {
              files.push(incrementalFileInfo);
              sceneJson.materials.splice(_i--, 1);
            }
          }
          i = _i;
        };
        for (var i = 0; i < sceneJson.materials.length; i++) {
          _loop(i);
        }
      }

      // Creo il file principale della scena incrementale con quel che resta
      // dopo aver inserito i dati delle mesh in file separati
      var file = new Zakeke.IncrementalFileInfo();
      file.name = "scene_" + version + ".incremental.babylon";
      file.isScene = true;
      file.dracoEncoded = false;
      file.data = JSON.stringify(sceneJson, null, 0);
      files.push(file);
      return files;
    }
  }, {
    key: "extractIncrementalFile",
    value: function extractIncrementalFile(version, meshOrGeometry, isMesh, dracoOptions) {
      var file = null;

      //Logger.info("Extracting " + isMesh ? meshOrGeometry.name : meshOrGeometry.id);

      if (meshOrGeometry.positions && meshOrGeometry.normals && meshOrGeometry.indices) {
        // Create delay loading file
        file = this.createDelayLoadingFile(version, meshOrGeometry, isMesh, dracoOptions);
        if (file && file.data) {
          meshOrGeometry.delayLoadingFile = file.name;

          //Logger.info("Delay loading file: " + meshOrGeometry.delayLoadingFile);

          // Compute bounding boxes
          var positions = meshOrGeometry.positions.map(function (v) {
            return parseFloat(v);
          });
          var minimum = [Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE];
          var maximum = [Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE];
          for (var index = 0; index < positions.length; index += 3) {
            var x = positions[index];
            var y = positions[index + 1];
            var z = positions[index + 2];
            if (x < minimum[0]) {
              minimum[0] = x;
            }
            if (x > maximum[0]) {
              maximum[0] = x;
            }
            if (y < minimum[1]) {
              minimum[1] = y;
            }
            if (y > maximum[1]) {
              maximum[1] = y;
            }
            if (z < minimum[2]) {
              minimum[2] = z;
            }
            if (z > maximum[2]) {
              maximum[2] = z;
            }
          }
          meshOrGeometry.boundingBoxMinimum = minimum;
          meshOrGeometry.boundingBoxMaximum = maximum;

          // Erasing infos
          meshOrGeometry.positions = null;
          meshOrGeometry.normals = null;
          meshOrGeometry.indices = null;
          if (meshOrGeometry.uvs) {
            meshOrGeometry.hasUVs = true;
            meshOrGeometry.uvs = null;
          }
          if (meshOrGeometry.uv2s) {
            meshOrGeometry.hasUVs2 = true;
            meshOrGeometry.uv2s = null;
          }
          if (meshOrGeometry.colors) {
            meshOrGeometry.hasColors = true;
            meshOrGeometry.colors = null;
          }

          // Added tangents
          if (meshOrGeometry.tangents) {
            meshOrGeometry.hasTangents = true;
            meshOrGeometry.tangents = null;
          }
          if (meshOrGeometry.matricesIndices) {
            meshOrGeometry.hasMatricesIndices = true;
            meshOrGeometry.matricesIndices = null;
          }
          if (meshOrGeometry.matricesWeights) {
            meshOrGeometry.hasMatricesWeights = true;
            meshOrGeometry.matricesWeights = null;
          }
          if (isMesh && meshOrGeometry.subMeshes) {
            meshOrGeometry.subMeshes = null;
          }
        }
      }
      if (file && file.data) return file;else return null;
    }
  }, {
    key: "createDelayLoadingFile",
    value: function createDelayLoadingFile(version, meshOrGeometry, isMesh, dracoOptions) {
      var file = new Zakeke.IncrementalFileInfo();
      file.isScene = false;

      // Per ora uso la codifica draco, se abilitata, solo nel caso di geometria
      // e se la geometria ha un solo canale per le texture
      //var dracoEncode = dracoOptions.useDraco && !isMesh && !meshOrGeometry.uv2s && !(meshOrGeometry.matricesIndices || meshOrGeometry.matricesWeights);
      var dracoEncode = dracoOptions.useDraco && !isMesh && !(meshOrGeometry.matricesIndices || meshOrGeometry.matricesWeights || meshOrGeometry.tangents) && meshOrGeometry.indices.length > 0 && meshOrGeometry.positions.length > 0 && meshOrGeometry.normals.length > 0;
      file.dracoEncoded = dracoEncode;
      var encodedName = (isMesh ? meshOrGeometry.name : meshOrGeometry.id).replace("+", "_").replace(" ", "_");
      var namepart = dracoEncode ? "draco" : "";
      file.name = "scene_" + version + "." + encodedName + (isMesh ? ".babylonmesh" + namepart + "data" : ".babylongeometry" + namepart + "data");
      if (dracoEncode) file.data = this.createDracoDelayLoadingFileData(meshOrGeometry, dracoOptions);else file.data = this.createPlainDelayLoadingFileData(meshOrGeometry, isMesh);
      return file;
    }
  }, {
    key: "createPlainDelayLoadingFileData",
    value: function createPlainDelayLoadingFileData(meshOrGeometry, isMesh) {
      var result = {
        positions: meshOrGeometry.positions,
        indices: meshOrGeometry.indices,
        normals: meshOrGeometry.normals
      };
      if (meshOrGeometry.uvs) {
        result.uvs = meshOrGeometry.uvs;
      }
      if (meshOrGeometry.uv2s) {
        result.uv2s = meshOrGeometry.uv2s;
      }
      if (meshOrGeometry.colors) {
        result.colors = meshOrGeometry.colors;
      }
      if (meshOrGeometry.tangents) {
        result.tangents = meshOrGeometry.tangents;
      }
      if (meshOrGeometry.matricesIndices) {
        result.matricesIndices = meshOrGeometry.matricesIndices;
      }
      if (meshOrGeometry.matricesWeights) {
        result.matricesWeights = meshOrGeometry.matricesWeights;
      }
      if (isMesh && meshOrGeometry.subMeshes) {
        result.subMeshes = meshOrGeometry.subMeshes;
      }
      var json = JSON.stringify(result, null, 0);
      return json;
    }
  }, {
    key: "createDracoDelayLoadingFileData",
    value: function createDracoDelayLoadingFileData(geometry, dracoOptions) {
      var start = new Date().getTime();
      var dracoData = this.getDracoEncodedGeometry(geometry, dracoOptions);
      var elapsed = new Date().getTime() - start;
      //Logger.info("Draco Encoding - " + geometry.id + "\t" + elapsed + " ms");
      if (dracoData) {
        var result = {
          type: "draco",
          data: dracoData
        };

        // Serializzo tutto in formato binario
        return msgpack.encode(result);
      }
      return null;
    }
  }, {
    key: "getDracoEncodedGeometry",
    value: function getDracoEncodedGeometry(geometry, dracoOptions) {
      if (!geometry) return null;
      var positions = geometry.positions;
      var normals = geometry.normals;
      var colors = geometry.colors;
      var uvs = geometry.uvs;
      var uv2s = geometry.uv2s;
      var indices = geometry.indices;
      var mesh = {
        indices: new Uint32Array(indices),
        positions: new Float32Array(positions),
        normals: new Float32Array(normals)
      };
      if (uvs) mesh.uvs = new Float32Array(uvs);
      if (uv2s) mesh.uv2s = new Float32Array(uv2s);
      if (colors) mesh.colors = new Float32Array(colors);
      var encoderModule = DracoEncoderModule();
      var encoder = new encoderModule.Encoder();
      var meshBuilder = new encoderModule.MeshBuilder();
      var dracoMesh = new encoderModule.Mesh();
      var numFaces = mesh.indices.length / 3;
      var numPoints = mesh.positions.length / 3;
      meshBuilder.AddFacesToMesh(dracoMesh, numFaces, mesh.indices);
      meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.POSITION, numPoints, 3, mesh.positions);
      if (mesh.normals) {
        meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.NORMAL, numPoints, 3, mesh.normals);
      }
      if (mesh.colors) {
        meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.COLOR, numPoints, 4, mesh.colors);
      }
      if (mesh.uvs) {
        meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.TEX_COORD, numPoints, 2, mesh.uvs);
      }
      // Attenzione! E' importante passare il secondo canale per ultimo e subito dopo il primo
      // In fase di decoding si supporrà che questa sia la posizione.
      if (mesh.uv2s) {
        meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.TEX_COORD, numPoints, 2, mesh.uv2s);
      }
      encoder.SetSpeedOptions(dracoOptions.dracoEncodingSpeed, dracoOptions.dracoDecodingSpeed);
      encoder.SetAttributeQuantization(encoderModule.POSITION, 14);
      encoder.SetAttributeQuantization(encoderModule.TEX_COORD, 12);
      encoder.SetAttributeQuantization(encoderModule.NORMAL, 10);
      encoder.SetAttributeQuantization(encoderModule.COLOR, 10);
      encoder.SetAttributeQuantization(encoderModule.GENERIC, 8);
      encoder.SetEncodingMethod(encoderModule.MESH_EDGEBREAKER_ENCODING);
      var encodedData = new encoderModule.DracoInt8Array();
      var encodedLen = encoder.EncodeMeshToDracoBuffer(dracoMesh, encodedData);
      var outputBuffer = new ArrayBuffer(encodedLen);
      var outputData = new Int8Array(outputBuffer);
      for (var i = 0; i < encodedLen; ++i) {
        outputData[i] = encodedData.GetValue(i);
      }
      encoderModule.destroy(dracoMesh);
      encoderModule.destroy(encodedData);
      encoderModule.destroy(encoder);
      encoderModule.destroy(meshBuilder);
      return outputBuffer;
    }
  }, {
    key: "extractIncrementalMaterialFile",
    value: function extractIncrementalMaterialFile(version, material, fileName) {
      //Logger.info("Extracting material " + material.id);
      var file = this.createDelayLoadingMaterialFile(version, material, fileName);
      //Logger.info("Delay loading material file: " + file.name);
      return file;
    }
  }, {
    key: "createDelayLoadingMaterialFile",
    value: function createDelayLoadingMaterialFile(version, material, fileName) {
      var file = new Zakeke.IncrementalFileInfo();
      file.isScene = false;
      file.dracoEncoded = false;
      file.name = fileName;
      file.data = this.createMaterialFileData(material);
      return file;
    }
  }, {
    key: "createMaterialFileData",
    value: function createMaterialFileData(material) {
      var json = JSON.stringify(material, null, 0);
      return json;
    }
  }]);
  return MakeIncremental;
}();

/***/ }),

/***/ "../../3D/src/Components/InfoPointsManager/InfoPointsManager.ts":
/*!**********************************************************************!*\
  !*** ../../3D/src/Components/InfoPointsManager/InfoPointsManager.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "InfoPointsManager": () => (/* binding */ InfoPointsManager)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

// Classe che ha la responsabilità di gestire gli info points della scena
// Nella presente implementazione, gli info points sono "agganciati" alle mesh
// e hanno la possibilità di visualizzare le eventuali immagini di anteprima dei materiali
var InfoPointsManager = /*#__PURE__*/function () {
  function InfoPointsManager(zkScene, scene, style) {
    _classCallCheck(this, InfoPointsManager);
    _defineProperty(this, "_meshesInfoPoints", {});
    _defineProperty(this, "_infoPoints", []);
    _defineProperty(this, "_imageUrls", []);
    _defineProperty(this, "_currentIdx", 0);
    _defineProperty(this, "_imagePanel", null);
    _defineProperty(this, "_loadingText", null);
    _defineProperty(this, "_image", null);
    _defineProperty(this, "_closeImageButton", null);
    _defineProperty(this, "_moveNextImageButton", null);
    _defineProperty(this, "_movePrevImageButton", null);
    _defineProperty(this, "_isOnMoveNextButton", false);
    _defineProperty(this, "_isOnMovePrevButton", false);
    _defineProperty(this, "_lastCameraPosition", null);
    _defineProperty(this, "onBeforeShowImages", null);
    _defineProperty(this, "onAfterShowImages", null);
    _defineProperty(this, "_infoPointsShown", true);
    _defineProperty(this, "_canShowInfoPointsContent", true);
    // Eventi
    _defineProperty(this, "_infoPointPickedListeners", []);
    _defineProperty(this, "_infoPointContentShownListeners", []);
    _defineProperty(this, "_infoPointContentHiddenListeners", []);
    _defineProperty(this, "_renderingNeededListeners", []);
    _defineProperty(this, "CLOSE_SVG", "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-close' style='fill:§color§'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/g%3E%3C/svg%3E");
    _defineProperty(this, "CHEVRON_LEFT_SVG", "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-left'%3E%3Cpath fill='§color§' d='M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z' /%3E%3C/g%3E%3C/svg%3E");
    _defineProperty(this, "CHEVRON_RIGHT_SVG", "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-right'%3E%3Cpath fill='§color§' d='M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z' /%3E%3C/g%3E%3C/svg%3E");
    this._zkScene = zkScene;
    this._scene = scene;
    this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper(scene);
    this._style = {};
    this.setDefaultStyle();
    if (style) this.setStyle(style);
    this._rootContainer = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", true, this._scene);
  }
  _createClass(InfoPointsManager, [{
    key: "infoPointsShown",
    get: function get() {
      return this._infoPointsShown;
    }
  }, {
    key: "canShowInfoPointsContent",
    get: function get() {
      return this._canShowInfoPointsContent;
    },
    set: function set(value) {
      this._canShowInfoPointsContent = value;
      this.hideImages();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._renderingNeededListeners = [];
      this._rootContainer.dispose();
    }
  }, {
    key: "setDefaultStyle",
    value: function setDefaultStyle() {
      this._style.infoPointsStyle = {
        borderColor: "#ffffff",
        innerPointColor: "#ffffff",
        color: "#a01c20",
        highlightColor: "#bb2025"
      };
      this._style.imagePanelStyle = {
        backgroundColor: this._scene.clearColor.toHexString(),
        loadingTextColor: "#ffffff",
        buttonsBorderColor: "#a01c20",
        buttonsColor: "#a01c20",
        buttonsBorderHighlightColor: "#bb2025",
        buttonsHighlightColor: "#bb2025",
        buttonsIconColor: "white"
      };
    }
  }, {
    key: "setStyle",
    value: function setStyle(style) {
      if (style) {
        if (style.infoPointsStyle) {
          if (!this._style.infoPointsStyle) this._style.infoPointsStyle = {};
          if (style.infoPointsStyle.borderColor) this._style.infoPointsStyle.borderColor = style.infoPointsStyle.borderColor;
          if (style.infoPointsStyle.innerPointColor) this._style.infoPointsStyle.innerPointColor = style.infoPointsStyle.innerPointColor;
          if (style.infoPointsStyle.color) this._style.infoPointsStyle.color = style.infoPointsStyle.color;
          if (style.infoPointsStyle.highlightColor) this._style.infoPointsStyle.highlightColor = style.infoPointsStyle.highlightColor;
        }
        if (style.imagePanelStyle) {
          if (!this._style.imagePanelStyle) this._style.imagePanelStyle = {};
          if (style.imagePanelStyle.backgroundColor) this._style.imagePanelStyle.backgroundColor = style.imagePanelStyle.backgroundColor;
          if (style.imagePanelStyle.loadingTextColor) this._style.imagePanelStyle.loadingTextColor = style.imagePanelStyle.loadingTextColor;
          if (style.imagePanelStyle.buttonsBorderColor) this._style.imagePanelStyle.buttonsBorderColor = style.imagePanelStyle.buttonsBorderColor;
          if (style.imagePanelStyle.buttonsColor) this._style.imagePanelStyle.buttonsColor = style.imagePanelStyle.buttonsColor;
          if (style.imagePanelStyle.buttonsBorderHighlightColor) this._style.imagePanelStyle.buttonsBorderHighlightColor = style.imagePanelStyle.buttonsBorderHighlightColor;
          if (style.imagePanelStyle.buttonsHighlightColor) this._style.imagePanelStyle.buttonsHighlightColor = style.imagePanelStyle.buttonsHighlightColor;
          if (style.imagePanelStyle.buttonsIconColor) this._style.imagePanelStyle.buttonsIconColor = style.imagePanelStyle.buttonsIconColor;
        }
      } else {
        this.setDefaultStyle();
      }
    }
  }, {
    key: "applyStyle",
    value: function applyStyle(style) {
      this.setStyle(style);
      this.refresh();
    }
  }, {
    key: "showInfoPoints",
    value: function showInfoPoints() {
      this.hideImages();
      this.getAllInfoPoints().forEach(function (i) {
        return i.isVisible = true;
      });
      this._infoPointsShown = true;
      this.fireRenderingNeededEvent();
    }
  }, {
    key: "hideInfoPoints",
    value: function hideInfoPoints() {
      this.hideImages();
      this.getAllInfoPoints().forEach(function (i) {
        return i.isVisible = false;
      });
      this._infoPointsShown = false;
      this.fireRenderingNeededEvent();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.hideImages();
      this.refreshInfoPoints();
      this.updateGuiElementsStyle();
      this.fireRenderingNeededEvent();
    }
  }, {
    key: "getAllInfoPoints",
    value: function getAllInfoPoints() {
      var infoPoints = [];
      for (var prop in this._meshesInfoPoints) infoPoints.push(this._meshesInfoPoints[prop]);
      return infoPoints;
    }
  }, {
    key: "refreshInfoPoints",
    value: function refreshInfoPoints() {
      for (var i = 0; i < this._scene.meshes.length; i++) {
        var mesh = this._scene.meshes[i];
        var canShowOnMesh = mesh.metadata && mesh.metadata.showInfoPoints && (mesh.isVisible || mesh.metadata.forceShowInfoPoints);
        var material = mesh.material;
        var urls = material ? this.getMaterialPhotoUrls(material) : [];
        if (canShowOnMesh && urls.length > 0) {
          var infoPoint = this.getOrCreateMeshInfoPoint(mesh);
          this.updateInfoPointUrls(infoPoint, urls);
        } else {
          this.removeMeshInfoPoints(mesh);
        }
      }
    }
  }, {
    key: "removeMeshInfoPoints",
    value: function removeMeshInfoPoints(mesh) {
      if (this._meshesInfoPoints.hasOwnProperty(mesh.id)) {
        var infoPoint = this._meshesInfoPoints[mesh.id];
        infoPoint.dispose();
        delete this._meshesInfoPoints[mesh.id];
      }
    }
  }, {
    key: "getOrCreateMeshInfoPoint",
    value: function getOrCreateMeshInfoPoint(mesh) {
      if (this._meshesInfoPoints.hasOwnProperty(mesh.id)) return this._meshesInfoPoints[mesh.id];
      var meshInfoPoint = this.createMeshInfoPoint(mesh);
      this._meshesInfoPoints[mesh.id] = meshInfoPoint;
      return meshInfoPoint;
    }
  }, {
    key: "updateInfoPointUrls",
    value: function updateInfoPointUrls(infoPoint, urls) {
      if (!infoPoint.metadata) infoPoint.metadata = {};
      infoPoint.metadata.urls = urls;
    }
  }, {
    key: "createMeshInfoPoint",
    value: function createMeshInfoPoint(mesh) {
      var _this$_style$infoPoin,
        _this$_style$infoPoin2,
        _this = this,
        _this$_style$infoPoin5,
        _this$_style$infoPoin6;
      var circleOut = new BABYLON.GUI.Ellipse("infoPoint");
      circleOut.width = "29px";
      circleOut.height = "29px";
      circleOut.color = ((_this$_style$infoPoin = this._style.infoPointsStyle) === null || _this$_style$infoPoin === void 0 ? void 0 : _this$_style$infoPoin.borderColor) || "#dddddd";
      circleOut.thickness = 4;
      circleOut.background = ((_this$_style$infoPoin2 = this._style.infoPointsStyle) === null || _this$_style$infoPoin2 === void 0 ? void 0 : _this$_style$infoPoin2.color) || "#a01c20";
      circleOut.alpha = 1;
      circleOut.onPointerEnterObservable.add(function (data) {
        var _this$_style$infoPoin3;
        circleOut.background = ((_this$_style$infoPoin3 = _this._style.infoPointsStyle) === null || _this$_style$infoPoin3 === void 0 ? void 0 : _this$_style$infoPoin3.highlightColor) || "#bb2025";
        _this.fireRenderingNeededEvent();
      });
      circleOut.onPointerOutObservable.add(function (data) {
        var _this$_style$infoPoin4;
        circleOut.background = ((_this$_style$infoPoin4 = _this._style.infoPointsStyle) === null || _this$_style$infoPoin4 === void 0 ? void 0 : _this$_style$infoPoin4.color) || "#a01c20";
        _this.fireRenderingNeededEvent();
      });
      this._rootContainer.addControl(circleOut);
      var circleIn = new BABYLON.GUI.Ellipse("innerPoint");
      circleIn.width = 0.29;
      circleIn.height = 0.29;
      circleIn.color = ((_this$_style$infoPoin5 = this._style.infoPointsStyle) === null || _this$_style$infoPoin5 === void 0 ? void 0 : _this$_style$infoPoin5.innerPointColor) || "White";
      circleIn.thickness = 0;
      circleIn.background = ((_this$_style$infoPoin6 = this._style.infoPointsStyle) === null || _this$_style$infoPoin6 === void 0 ? void 0 : _this$_style$infoPoin6.innerPointColor) || "White";
      circleOut.addControl(circleIn);
      circleOut.linkWithMesh(mesh);
      circleOut.linkOffsetY = 0;
      circleOut.shadowBlur = 6;
      circleOut.shadowOffsetX = 2;
      circleOut.shadowOffsetY = 2;
      circleOut.isPointerBlocker = true;
      circleOut.hoverCursor = "pointer";
      circleOut.onPointerClickObservable.add(function (data) {
        if (circleOut.metadata && circleOut.metadata.urls) {
          var args = {
            meshID: mesh.id,
            materialID: mesh.material ? mesh.material.id : null,
            materialPhotoUrl: circleOut.metadata.urls
          };
          _this.fireInfoPointPickedEvent(args);
          _this.showImages(circleOut.metadata.urls);
        }
        _this.fireRenderingNeededEvent();
      });
      return circleOut;
    }
  }, {
    key: "getMaterialInfoPoint",
    value: function getMaterialInfoPoint(materialID) {
      for (var i = 0; i < this._infoPoints.length; i++) {
        var infoPoint = this._infoPoints[i];
        if (infoPoint.metadata && infoPoint.metadata.materialID && infoPoint.metadata.materialID === materialID) return infoPoint;
      }
      return null;
    }
  }, {
    key: "getMaterialPhotoUrls",
    value: function getMaterialPhotoUrls(material) {
      return this._zkScene.get("materialPhotos").getMaterialPhotoUrls(material.id);
    }
  }, {
    key: "getOrCreateImagePanel",
    value: function getOrCreateImagePanel() {
      if (!this._imagePanel) this.createImagePanel();
      return this._imagePanel;
    }
  }, {
    key: "createImagePanel",
    value: function createImagePanel() {
      var _this$_style$imagePan;
      var imagePanel = new BABYLON.GUI.Rectangle("imagePanel");
      imagePanel.background = ((_this$_style$imagePan = this._style.imagePanelStyle) === null || _this$_style$imagePan === void 0 ? void 0 : _this$_style$imagePan.backgroundColor) || this._scene.clearColor.toHexString();
      imagePanel.width = 1;
      imagePanel.height = 1;
      imagePanel.zIndex = 10000;
      imagePanel.isVisible = false;
      this._imagePanel = imagePanel;
      this._rootContainer.addControl(imagePanel);
      this.addCloseButton(imagePanel);
      this.addMoveNextImageButton(imagePanel);
      this.addMovePrevImageButton(imagePanel);
      return imagePanel;
    }
  }, {
    key: "addCloseButton",
    value: function addCloseButton(imagePanel) {
      var _this$_style$imagePan2,
        _this$_style$imagePan3,
        _this2 = this,
        _this$_style$imagePan4;
      var closePanel = new BABYLON.GUI.StackPanel("closePanel");
      closePanel.height = "48px";
      closePanel.width = "48px";
      closePanel.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
      closePanel.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_TOP;
      closePanel.isVertical = false;
      closePanel.zIndex = 10003;
      imagePanel.addControl(closePanel);
      var closeRect = new BABYLON.GUI.Rectangle("closeRect");
      closeRect.width = "24px";
      closeRect.height = "24px";
      closeRect.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
      closeRect.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
      closeRect.background = ((_this$_style$imagePan2 = this._style.imagePanelStyle) === null || _this$_style$imagePan2 === void 0 ? void 0 : _this$_style$imagePan2.buttonsColor) || "#a01c20";
      closeRect.color = ((_this$_style$imagePan3 = this._style.imagePanelStyle) === null || _this$_style$imagePan3 === void 0 ? void 0 : _this$_style$imagePan3.buttonsBorderColor) || "#a01c20";
      closeRect.isPointerBlocker = true;
      closeRect.hoverCursor = "pointer";
      closeRect.onPointerEnterObservable.add(function (data) {
        var _this2$_style$imagePa, _this2$_style$imagePa2;
        closeRect.background = ((_this2$_style$imagePa = _this2._style.imagePanelStyle) === null || _this2$_style$imagePa === void 0 ? void 0 : _this2$_style$imagePa.buttonsHighlightColor) || "#bb2025";
        closeRect.color = ((_this2$_style$imagePa2 = _this2._style.imagePanelStyle) === null || _this2$_style$imagePa2 === void 0 ? void 0 : _this2$_style$imagePa2.buttonsBorderHighlightColor) || "#bb2025";
        _this2.fireRenderingNeededEvent();
      });
      closeRect.onPointerOutObservable.add(function (data) {
        var _this2$_style$imagePa3, _this2$_style$imagePa4;
        closeRect.background = ((_this2$_style$imagePa3 = _this2._style.imagePanelStyle) === null || _this2$_style$imagePa3 === void 0 ? void 0 : _this2$_style$imagePa3.buttonsColor) || "#a01c20";
        closeRect.color = ((_this2$_style$imagePa4 = _this2._style.imagePanelStyle) === null || _this2$_style$imagePa4 === void 0 ? void 0 : _this2$_style$imagePa4.buttonsBorderColor) || "#a01c20";
        _this2.fireRenderingNeededEvent();
      });
      closeRect.onPointerClickObservable.add(function (data) {
        _this2.hideImages();
        _this2.fireRenderingNeededEvent();
      });
      closePanel.addControl(closeRect);
      var closeIcon = new BABYLON.GUI.Image("close", this.getCloseSvg(((_this$_style$imagePan4 = this._style.imagePanelStyle) === null || _this$_style$imagePan4 === void 0 ? void 0 : _this$_style$imagePan4.buttonsIconColor) || "white"));
      closeIcon.width = 1;
      closeIcon.height = 1;
      closeIcon.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM;
      closeRect.addControl(closeIcon);
      this._closeImageButton = closePanel;
    }
  }, {
    key: "addMoveNextImageButton",
    value: function addMoveNextImageButton(imagePanel) {
      var _this$_style$imagePan5,
        _this$_style$imagePan6,
        _this3 = this,
        _this$_style$imagePan7;
      var rightPanel = new BABYLON.GUI.StackPanel("rightPanel");
      rightPanel.width = "48px";
      rightPanel.height = "48px";
      rightPanel.paddingRight = "24px";
      rightPanel.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
      rightPanel.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
      rightPanel.isVertical = false;
      rightPanel.zIndex = 10003;
      rightPanel.alpha = 0.3;
      rightPanel.isVisible = false;
      imagePanel.addControl(rightPanel);
      var rightRect = new BABYLON.GUI.Rectangle("rightRect");
      rightRect.width = "24px";
      rightRect.height = "48px";
      rightRect.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
      rightRect.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
      rightRect.background = ((_this$_style$imagePan5 = this._style.imagePanelStyle) === null || _this$_style$imagePan5 === void 0 ? void 0 : _this$_style$imagePan5.buttonsColor) || "#a01c20";
      rightRect.color = ((_this$_style$imagePan6 = this._style.imagePanelStyle) === null || _this$_style$imagePan6 === void 0 ? void 0 : _this$_style$imagePan6.buttonsBorderColor) || "#a01c20";
      rightRect.isPointerBlocker = true;
      rightRect.hoverCursor = "pointer";
      rightRect.onPointerEnterObservable.add(function (data) {
        var _this3$_style$imagePa, _this3$_style$imagePa2;
        _this3._isOnMoveNextButton = true;
        rightRect.background = ((_this3$_style$imagePa = _this3._style.imagePanelStyle) === null || _this3$_style$imagePa === void 0 ? void 0 : _this3$_style$imagePa.buttonsHighlightColor) || "#bb2025";
        rightRect.color = ((_this3$_style$imagePa2 = _this3._style.imagePanelStyle) === null || _this3$_style$imagePa2 === void 0 ? void 0 : _this3$_style$imagePa2.buttonsBorderHighlightColor) || "#bb2025";
        _this3.updateMoveNextImageButton();
        _this3.fireRenderingNeededEvent();
      });
      rightRect.onPointerOutObservable.add(function (data) {
        var _this3$_style$imagePa3, _this3$_style$imagePa4;
        _this3._isOnMoveNextButton = false;
        rightRect.background = ((_this3$_style$imagePa3 = _this3._style.imagePanelStyle) === null || _this3$_style$imagePa3 === void 0 ? void 0 : _this3$_style$imagePa3.buttonsColor) || "#a01c20";
        rightRect.color = ((_this3$_style$imagePa4 = _this3._style.imagePanelStyle) === null || _this3$_style$imagePa4 === void 0 ? void 0 : _this3$_style$imagePa4.buttonsBorderColor) || "#a01c20";
        _this3.updateMoveNextImageButton();
        _this3.fireRenderingNeededEvent();
      });
      rightRect.onPointerClickObservable.add(function (data) {
        _this3.moveNextImage();
        _this3.fireRenderingNeededEvent();
      });
      rightPanel.addControl(rightRect);
      var rightIcon = new BABYLON.GUI.Image("move-next", this.getChevronRightSvg(((_this$_style$imagePan7 = this._style.imagePanelStyle) === null || _this$_style$imagePan7 === void 0 ? void 0 : _this$_style$imagePan7.buttonsIconColor) || "white"));
      rightIcon.width = 1;
      rightIcon.height = 1;
      rightIcon.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM;
      rightIcon.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
      rightRect.addControl(rightIcon);
      this._moveNextImageButton = rightPanel;
    }
  }, {
    key: "addMovePrevImageButton",
    value: function addMovePrevImageButton(imagePanel) {
      var _this$_style$imagePan8,
        _this$_style$imagePan9,
        _this4 = this,
        _this$_style$imagePan10;
      var leftPanel = new BABYLON.GUI.StackPanel("leftPanel");
      leftPanel.width = "48px";
      leftPanel.height = "48px";
      leftPanel.paddingLeft = "24px";
      leftPanel.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
      leftPanel.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
      leftPanel.isVertical = false;
      leftPanel.alpha = 0.3;
      leftPanel.zIndex = 10003;
      leftPanel.isVisible = false;
      imagePanel.addControl(leftPanel);
      var leftRect = new BABYLON.GUI.Rectangle("leftRect");
      leftRect.width = "24px";
      leftRect.height = "48px";
      leftRect.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
      leftRect.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
      leftRect.background = ((_this$_style$imagePan8 = this._style.imagePanelStyle) === null || _this$_style$imagePan8 === void 0 ? void 0 : _this$_style$imagePan8.buttonsColor) || "#a01c20";
      leftRect.color = ((_this$_style$imagePan9 = this._style.imagePanelStyle) === null || _this$_style$imagePan9 === void 0 ? void 0 : _this$_style$imagePan9.buttonsBorderColor) || "#a01c20";
      leftRect.isPointerBlocker = true;
      leftRect.hoverCursor = "pointer";
      leftRect.onPointerEnterObservable.add(function (data) {
        var _this4$_style$imagePa, _this4$_style$imagePa2;
        _this4._isOnMovePrevButton = true;
        leftRect.background = ((_this4$_style$imagePa = _this4._style.imagePanelStyle) === null || _this4$_style$imagePa === void 0 ? void 0 : _this4$_style$imagePa.buttonsHighlightColor) || "#bb2025";
        leftRect.color = ((_this4$_style$imagePa2 = _this4._style.imagePanelStyle) === null || _this4$_style$imagePa2 === void 0 ? void 0 : _this4$_style$imagePa2.buttonsBorderHighlightColor) || "#bb2025";
        _this4.updateMovePrevImageButton();
        _this4.fireRenderingNeededEvent();
      });
      leftRect.onPointerOutObservable.add(function (data) {
        var _this4$_style$imagePa3, _this4$_style$imagePa4;
        _this4._isOnMovePrevButton = false;
        leftRect.background = ((_this4$_style$imagePa3 = _this4._style.imagePanelStyle) === null || _this4$_style$imagePa3 === void 0 ? void 0 : _this4$_style$imagePa3.buttonsColor) || "#a01c20";
        leftRect.color = ((_this4$_style$imagePa4 = _this4._style.imagePanelStyle) === null || _this4$_style$imagePa4 === void 0 ? void 0 : _this4$_style$imagePa4.buttonsBorderColor) || "#a01c20";
        _this4.updateMovePrevImageButton();
        _this4.fireRenderingNeededEvent();
      });
      leftRect.onPointerClickObservable.add(function (data) {
        _this4.movePrevImage();
        _this4.fireRenderingNeededEvent();
      });
      leftPanel.addControl(leftRect);
      var leftIcon = new BABYLON.GUI.Image("move-prev", this.getChevronLeftSvg(((_this$_style$imagePan10 = this._style.imagePanelStyle) === null || _this$_style$imagePan10 === void 0 ? void 0 : _this$_style$imagePan10.buttonsIconColor) || "white"));
      leftIcon.width = 1;
      leftIcon.height = 1;
      leftIcon.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM;
      leftIcon.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
      leftRect.addControl(leftIcon);
      this._movePrevImageButton = leftPanel;
    }
  }, {
    key: "updateMoveNextImageButton",
    value: function updateMoveNextImageButton() {
      if (this._moveNextImageButton) {
        if (this._imageUrls.length <= 1) this._moveNextImageButton.isVisible = false;else {
          this._moveNextImageButton.isVisible = true;
          this._moveNextImageButton.alpha = this.canMoveNextImage() ? this._isOnMoveNextButton ? 1 : 0.3 : 0.1;
        }
      }
    }
  }, {
    key: "updateMovePrevImageButton",
    value: function updateMovePrevImageButton() {
      if (this._movePrevImageButton) {
        if (this._imageUrls.length <= 1) this._movePrevImageButton.isVisible = false;else {
          this._movePrevImageButton.isVisible = true;
          this._movePrevImageButton.alpha = this.canMovePrevImage() ? this._isOnMovePrevButton ? 1 : 0.3 : 0.1;
        }
      }
    }
  }, {
    key: "showImages",
    value: function showImages(urls) {
      if (!this._canShowInfoPointsContent) return;
      this._currentIdx = 0;
      this._imageUrls = urls;
      this._isOnMoveNextButton = false;
      this._isOnMovePrevButton = false;
      this.getOrCreateImagePanel();
      if (this._imagePanel) {
        if (this.onBeforeShowImages) this.onBeforeShowImages();
        this.updateMoveNextImageButton();
        this.updateMovePrevImageButton();
        this._imagePanel.isVisible = true;
        this.showCurrentImage();
        this.fireInfoPointContentShownEvent();
      }
      this.fireRenderingNeededEvent();
    }
  }, {
    key: "moveNextImage",
    value: function moveNextImage() {
      if (this.canMoveNextImage()) {
        this._currentIdx++;
        this.showCurrentImage();
        this.updateMoveNextImageButton();
        this.updateMovePrevImageButton();
        this.fireRenderingNeededEvent();
      }
    }
  }, {
    key: "movePrevImage",
    value: function movePrevImage() {
      if (this.canMovePrevImage()) {
        this._currentIdx--;
        this.showCurrentImage();
        this.updateMoveNextImageButton();
        this.updateMovePrevImageButton();
        this.fireRenderingNeededEvent();
      }
    }
  }, {
    key: "showCurrentImage",
    value: function showCurrentImage() {
      if (this._currentIdx >= 0 && this._currentIdx < this._imageUrls.length) this.showImage(this._imageUrls[this._currentIdx]);
    }
  }, {
    key: "canMoveNextImage",
    value: function canMoveNextImage() {
      return this._imageUrls.length > 0 && this._currentIdx < this._imageUrls.length - 1;
    }
  }, {
    key: "canMovePrevImage",
    value: function canMovePrevImage() {
      return this._imageUrls.length > 0 && this._currentIdx > 0;
    }
  }, {
    key: "hideImages",
    value: function hideImages() {
      if (this._imagePanel) {
        this._imagePanel.isVisible = false;
        if (this.onAfterShowImages) this.onAfterShowImages();
        this.fireInfoPointContentHiddenEvent();
        this.fireRenderingNeededEvent();
      }
    }
  }, {
    key: "showImage",
    value: function showImage(url) {
      var _this5 = this;
      if (this._imagePanel) {
        if (this._image) {
          this._imagePanel.removeControl(this._image);
          this._image.isVisible = false;
          this._image.dispose();
          this._image = null;
        }
        this.showLoadingText();
        var image = new BABYLON.GUI.Image("but", url);
        image.width = 1;
        image.height = 1;
        image.isVisible = true;
        image.zIndex = 10002;
        image.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM;
        image.onImageLoadedObservable.add(function (data) {
          _this5.hideLoadingText();
        });
        this._imagePanel.addControl(image);
        this._image = image;
        this.fireRenderingNeededEvent();
      }

      /*
      if (this._imagePanel) {
          const image = new BABYLON.GUI.Image("but", url);
          image.width = 1;
          image.height = 1;
          image.isVisible = true;
          image.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM;
          this._imagePanel.addControl(image);
          if (this._image) {
              this._imagePanel.removeControl(this._image);
              this._image.isVisible = false;
              this._image.dispose();
              this._image = null;
          }
          this._image = image;
      }
      */
    }

    /**
     * Update info points visibility and return true if at least one info point has been updated.
     * 
     * @return {boolean} Return true if any info point has been updated.
     */
  }, {
    key: "updateInfoPointsVisibility",
    value: function updateInfoPointsVisibility() {
      var ret = false;
      if (this._scene.activeCamera) {
        if (!this._lastCameraPosition || !this._lastCameraPosition.equals(this._scene.activeCamera.position)) {
          this._lastCameraPosition = this._scene.activeCamera.position.clone();
          for (var _meshID in this._meshesInfoPoints) {
            var mesh = this._scene.getMeshByID(_meshID);
            if (mesh) {
              this.updateMeshInfoPointVisibility(mesh, this._meshesInfoPoints[_meshID]);
              ret = true;
            }
          }
        }
      }
      return ret;
    }
  }, {
    key: "drawRay",
    value: function drawRay(origin, forward) {
      var direction = forward.subtract(origin);
      direction = direction.normalize();
      var length = forward.subtract(origin).length() * 2;
      var ray = new BABYLON.Ray(origin, direction, length);

      // debug
      BABYLON.RayHelper.CreateAndShow(ray, this._scene, new BABYLON.Color3(1, 1, 0.1));
    }
  }, {
    key: "updateMeshInfoPointVisibility",
    value: function updateMeshInfoPointVisibility(mesh, infoPoint) {
      if (this._scene.activeCamera) {
        var forward = this._sceneHelper.getMeshHierarchyCenter(mesh);
        var origin = this._scene.activeCamera.position;
        var direction = forward.subtract(origin);
        direction = direction.normalize();
        var length = forward.subtract(origin).length() * 2;
        var ray = new BABYLON.Ray(origin, direction, length);
        var hit = this._scene.pickWithRay(ray);
        if (hit && hit.pickedMesh) {
          infoPoint.alpha = hit.pickedMesh === mesh ? 1 : 0.2;
        }
      }
    }
  }, {
    key: "getCloseSvg",
    value: function getCloseSvg(color) {
      return this.getSvg(this.CLOSE_SVG, color);
    }
  }, {
    key: "getChevronLeftSvg",
    value: function getChevronLeftSvg(color) {
      return this.getSvg(this.CHEVRON_LEFT_SVG, color);
    }
  }, {
    key: "getChevronRightSvg",
    value: function getChevronRightSvg(color) {
      return this.getSvg(this.CHEVRON_RIGHT_SVG, color);
    }
  }, {
    key: "getSvg",
    value: function getSvg(svg, color) {
      return svg.replace("§color§", encodeURIComponent(color));
    }

    // -------------------------------------------------------------
    // Events 
    // -------------------------------------------------------------
    // picked
  }, {
    key: "fireInfoPointPickedEvent",
    value: function fireInfoPointPickedEvent(e) {
      for (var i = 0; i < this._infoPointPickedListeners.length; i++) this._infoPointPickedListeners[i](e);
    }
  }, {
    key: "addInfoPointPickedListener",
    value: function addInfoPointPickedListener(listenerFunction) {
      this._infoPointPickedListeners.push(listenerFunction);
    }
  }, {
    key: "addInfoPointPickedListenerRange",
    value: function addInfoPointPickedListenerRange(listenerFunctions) {
      var _this$_infoPointPicke;
      (_this$_infoPointPicke = this._infoPointPickedListeners).push.apply(_this$_infoPointPicke, _toConsumableArray(listenerFunctions));
    }

    // Content shown
  }, {
    key: "fireInfoPointContentShownEvent",
    value: function fireInfoPointContentShownEvent() {
      for (var i = 0; i < this._infoPointContentShownListeners.length; i++) this._infoPointContentShownListeners[i]();
    }
  }, {
    key: "addInfoPointContentShownListener",
    value: function addInfoPointContentShownListener(listenerFunction) {
      this._infoPointContentShownListeners.push(listenerFunction);
    }
  }, {
    key: "addInfoPointContentShownListenerRange",
    value: function addInfoPointContentShownListenerRange(listenerFunctions) {
      var _this$_infoPointConte;
      (_this$_infoPointConte = this._infoPointContentShownListeners).push.apply(_this$_infoPointConte, _toConsumableArray(listenerFunctions));
    }

    // content hidden
  }, {
    key: "fireInfoPointContentHiddenEvent",
    value: function fireInfoPointContentHiddenEvent() {
      for (var i = 0; i < this._infoPointContentHiddenListeners.length; i++) this._infoPointContentHiddenListeners[i]();
    }
  }, {
    key: "addInfoPointContentHiddenListener",
    value: function addInfoPointContentHiddenListener(listenerFunction) {
      this._infoPointContentHiddenListeners.push(listenerFunction);
    }
  }, {
    key: "addInfoPointContentHiddenListenerRange",
    value: function addInfoPointContentHiddenListenerRange(listenerFunctions) {
      var _this$_infoPointConte2;
      (_this$_infoPointConte2 = this._infoPointContentHiddenListeners).push.apply(_this$_infoPointConte2, _toConsumableArray(listenerFunctions));
    }

    // Rendering Needed
  }, {
    key: "fireRenderingNeededEvent",
    value: function fireRenderingNeededEvent() {
      for (var i = 0; i < this._renderingNeededListeners.length; ++i) {
        this._renderingNeededListeners[i]();
      }
    }
  }, {
    key: "addRenderingNeededListener",
    value: function addRenderingNeededListener(listenerFunction) {
      this._renderingNeededListeners.push(listenerFunction);
    }
  }, {
    key: "showLoadingText",
    value: function showLoadingText() {
      if (this._loadingText) {
        this._loadingText.isVisible = true;
        return;
      }
      if (this._imagePanel) {
        var _this$_style$imagePan11;
        this._loadingText = new BABYLON.GUI.TextBlock("loading");
        this._loadingText.text = "Loading...";
        this._loadingText.left = 0.5;
        this._loadingText.top = 0.7;
        this._loadingText.zIndex = 10001;
        this._loadingText.color = ((_this$_style$imagePan11 = this._style.imagePanelStyle) === null || _this$_style$imagePan11 === void 0 ? void 0 : _this$_style$imagePan11.loadingTextColor) || "white";
        this._imagePanel.addControl(this._loadingText);
        this.fireRenderingNeededEvent();
      }
    }
  }, {
    key: "hideLoadingText",
    value: function hideLoadingText() {
      if (this._loadingText) this._loadingText.isVisible = false;
      this.fireRenderingNeededEvent();
    }
  }, {
    key: "updateGuiElementsStyle",
    value: function updateGuiElementsStyle() {
      this.updateMeshInfoPointsStyle();
      this.updateImagePanelStyle();
      this.fireRenderingNeededEvent();
    }
  }, {
    key: "updateMeshInfoPointsStyle",
    value: function updateMeshInfoPointsStyle() {
      var _this6 = this;
      this.getAllInfoPoints().forEach(function (infoPoint) {
        var _this6$_style$infoPoi, _this6$_style$infoPoi2;
        infoPoint.color = ((_this6$_style$infoPoi = _this6._style.infoPointsStyle) === null || _this6$_style$infoPoi === void 0 ? void 0 : _this6$_style$infoPoi.borderColor) || "#dddddd";
        infoPoint.background = ((_this6$_style$infoPoi2 = _this6._style.infoPointsStyle) === null || _this6$_style$infoPoi2 === void 0 ? void 0 : _this6$_style$infoPoi2.color) || "#a01c20";
        var circleIn = infoPoint.getChildByName("innerPoint");
        if (circleIn && circleIn instanceof BABYLON.GUI.Container) {
          var _this6$_style$infoPoi3;
          circleIn.background = ((_this6$_style$infoPoi3 = _this6._style.infoPointsStyle) === null || _this6$_style$infoPoi3 === void 0 ? void 0 : _this6$_style$infoPoi3.innerPointColor) || "White";
        }
      });
    }
  }, {
    key: "updateImagePanelStyle",
    value: function updateImagePanelStyle() {
      if (this._imagePanel) {
        var _this$_style$imagePan12;
        this._imagePanel.background = ((_this$_style$imagePan12 = this._style.imagePanelStyle) === null || _this$_style$imagePan12 === void 0 ? void 0 : _this$_style$imagePan12.backgroundColor) || this._scene.clearColor.toHexString();
        var closePanel = this._imagePanel.getChildByName("closePanel");
        if (closePanel && closePanel instanceof BABYLON.GUI.Container) {
          var closeRect = closePanel.getChildByName("closeRect");
          if (closeRect && closeRect instanceof BABYLON.GUI.Container) {
            var _this$_style$imagePan13, _this$_style$imagePan14;
            closeRect.background = ((_this$_style$imagePan13 = this._style.imagePanelStyle) === null || _this$_style$imagePan13 === void 0 ? void 0 : _this$_style$imagePan13.buttonsColor) || "#a01c20";
            closeRect.color = ((_this$_style$imagePan14 = this._style.imagePanelStyle) === null || _this$_style$imagePan14 === void 0 ? void 0 : _this$_style$imagePan14.buttonsBorderColor) || "#a01c20";
          }
        }
        var rightPanel = this._imagePanel.getChildByName("rightPanel");
        if (rightPanel && rightPanel instanceof BABYLON.GUI.Container) {
          var rightRect = rightPanel.getChildByName("rightRect");
          if (rightRect && rightRect instanceof BABYLON.GUI.Container) {
            var _this$_style$imagePan15, _this$_style$imagePan16;
            rightRect.background = ((_this$_style$imagePan15 = this._style.imagePanelStyle) === null || _this$_style$imagePan15 === void 0 ? void 0 : _this$_style$imagePan15.buttonsColor) || "#a01c20";
            rightRect.color = ((_this$_style$imagePan16 = this._style.imagePanelStyle) === null || _this$_style$imagePan16 === void 0 ? void 0 : _this$_style$imagePan16.buttonsBorderColor) || "#a01c20";
          }
        }
        var leftPanel = this._imagePanel.getChildByName("leftPanel");
        if (leftPanel && leftPanel instanceof BABYLON.GUI.Container) {
          var leftRect = leftPanel.getChildByName("leftRect");
          if (leftRect && leftRect instanceof BABYLON.GUI.Container) {
            var _this$_style$imagePan17, _this$_style$imagePan18;
            leftRect.background = ((_this$_style$imagePan17 = this._style.imagePanelStyle) === null || _this$_style$imagePan17 === void 0 ? void 0 : _this$_style$imagePan17.buttonsColor) || "#a01c20";
            leftRect.color = ((_this$_style$imagePan18 = this._style.imagePanelStyle) === null || _this$_style$imagePan18 === void 0 ? void 0 : _this$_style$imagePan18.buttonsBorderColor) || "#a01c20";
          }
        }
        if (this._loadingText) {
          var _this$_style$imagePan19;
          this._loadingText.color = ((_this$_style$imagePan19 = this._style.imagePanelStyle) === null || _this$_style$imagePan19 === void 0 ? void 0 : _this$_style$imagePan19.loadingTextColor) || "white";
        }
      }
    }
  }]);
  return InfoPointsManager;
}();

/***/ }),

/***/ "../../3D/src/Components/MaterialsPreview/MaterialsPreview.ts":
/*!********************************************************************!*\
  !*** ../../3D/src/Components/MaterialsPreview/MaterialsPreview.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MaterialPreviewData": () => (/* binding */ MaterialPreviewData),
/* harmony export */   "MaterialsPreview": () => (/* binding */ MaterialsPreview)
/* harmony export */ });
/* harmony import */ var _Helpers_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Helpers/utils */ "../../3D/src/Helpers/utils.ts");
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }



var MaterialPreviewData = /*#__PURE__*/function () {
  function MaterialPreviewData() {
    _classCallCheck(this, MaterialPreviewData);
    this.previewFiles = {};
  }
  _createClass(MaterialPreviewData, [{
    key: "downloadFiles",
    value: function downloadFiles() {
      function endsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
      }
      for (var key in this.previewFiles) {
        var blob = null;
        var data = this.previewFiles[key];
        if (typeof data == "string") blob = _Helpers_utils__WEBPACK_IMPORTED_MODULE_0__.Utils.dataURItoBlob(data);else blob = data;
        if (blob) {
          var mimeType = null;
          if (endsWith(key, ".jpeg" || 0)) {
            mimeType = {
              type: "image/jpeg"
            };
          } else if (endsWith(key, ".png")) {
            mimeType = {
              type: "image/png"
            };
          }
          if (mimeType) {
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.setAttribute("type", "hidden");
            link.download = key;
            link.href = window.URL.createObjectURL(new Blob([blob], mimeType));
            link.click();
          }
        }
      }
    }
  }]);
  return MaterialPreviewData;
}();
var MaterialsPreview = /*#__PURE__*/function () {
  function MaterialsPreview() {
    _classCallCheck(this, MaterialsPreview);
  }
  _createClass(MaterialsPreview, null, [{
    key: "getPreviewsAsync",
    value: function () {
      var _getPreviewsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(scene, rootUrl, materialIDs, options) {
        var createBlobs,
          previewMaker,
          previews,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              createBlobs = _args.length > 4 && _args[4] !== undefined ? _args[4] : true;
              _context.next = 3;
              return scene.whenReadyAsync();
            case 3:
              previewMaker = new MaterialPreviewMaker(scene, rootUrl, materialIDs, options);
              _context.next = 6;
              return previewMaker.getPreviewsAsync(createBlobs);
            case 6:
              previews = _context.sent;
              previewMaker.dispose();
              return _context.abrupt("return", previews);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getPreviewsAsync(_x, _x2, _x3, _x4) {
        return _getPreviewsAsync.apply(this, arguments);
      }
      return getPreviewsAsync;
    }()
  }, {
    key: "downloadPreviewsAsync",
    value: function () {
      var _downloadPreviewsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(scene, rootUrl, materialsIDs, options) {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return MaterialsPreview.getPreviewsAsync(scene, rootUrl, materialsIDs, options);
            case 2:
              data = _context2.sent;
              data.downloadFiles();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function downloadPreviewsAsync(_x5, _x6, _x7, _x8) {
        return _downloadPreviewsAsync.apply(this, arguments);
      }
      return downloadPreviewsAsync;
    }()
  }]);
  return MaterialsPreview;
}();
var MaterialPreviewMaker = /*#__PURE__*/function () {
  function MaterialPreviewMaker(scene, rootUrl, materialIDs, options) {
    _classCallCheck(this, MaterialPreviewMaker);
    _defineProperty(this, "_width", 256);
    _defineProperty(this, "_height", 256);
    _defineProperty(this, "_crop", false);
    _defineProperty(this, "_materials", []);
    _defineProperty(this, "_localEngine", null);
    _defineProperty(this, "_hostingScene", null);
    _defineProperty(this, "_hostingSceneHelper", null);
    _defineProperty(this, "_hostingMesh", null);
    this._scene = scene;
    this._rootUrl = rootUrl;
    this._materialIDs = materialIDs;
    this._options = options || {};
    this.setupPreviewSize();
    if (this._options.crop != undefined) this._crop = this._options.crop;
    this.readMaterials();
  }
  _createClass(MaterialPreviewMaker, [{
    key: "dispose",
    value: function dispose() {
      this.disposeHostingScene();
      this.disposeLocalEngine();
    }
  }, {
    key: "getLocalEngine",
    value: function getLocalEngine() {
      if (!this._localEngine) {
        var localCanvas = document.createElement('canvas');
        localCanvas.id = "MaterialPreviewCanvas";
        localCanvas.width = 1024;
        localCanvas.height = 1024;
        this._localEngine = new BABYLON.Engine(localCanvas, true, {
          premultipliedAlpha: false,
          preserveDrawingBuffer: true
        });
        this._localEngine.setSize(this._width, this._height);
        //this._localEngine.setViewport(new BABYLON.Viewport(0, 0, 1, 1));
      }

      return this._localEngine;
    }
  }, {
    key: "disposeLocalEngine",
    value: function disposeLocalEngine() {
      if (this._localEngine) this._localEngine.dispose();
    }
  }, {
    key: "disposeHostingScene",
    value: function disposeHostingScene() {
      if (this._hostingSceneHelper) {
        this._hostingSceneHelper.dispose();
        this._hostingSceneHelper = null;
      }
      if (this._hostingScene) {
        this._hostingScene.dispose();
        this._hostingScene = null;
      }
    }
  }, {
    key: "setupPreviewSize",
    value: function setupPreviewSize() {
      var options = this._options;
      if (options.width != undefined && options.height == undefined) {
        this._width = options.width;
        this._height = options.width;
      } else if (options.width == undefined && options.height != undefined) {
        this._width = options.height;
        this._height = options.height;
      } else if (options.width != undefined && options.height != undefined) {
        this._width = options.width;
        this._height = options.height;
      }
    }
  }, {
    key: "readMaterials",
    value: function readMaterials() {
      var _this = this;
      this._materialIDs.forEach(function (id) {
        var material = _this._scene.getMaterialByID(id);
        if (material) _this._materials.push(material);
      });
    }
  }, {
    key: "downloadPreviewsAsync",
    value: function () {
      var _downloadPreviewsAsync2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var container;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.getPreviewsAsync();
            case 2:
              container = _context3.sent;
              container.downloadFiles();
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function downloadPreviewsAsync() {
        return _downloadPreviewsAsync2.apply(this, arguments);
      }
      return downloadPreviewsAsync;
    }()
  }, {
    key: "getPreviewsAsync",
    value: function () {
      var _getPreviewsAsync2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this2 = this;
        var createBlobs,
          files,
          engine,
          camera,
          is_firefox,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              createBlobs = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : true;
              files = [];
              engine = this.getLocalEngine();
              this._hostingScene = new BABYLON.Scene(engine);
              this._hostingSceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_2__.SceneHelper(this._hostingScene);
              this._hostingSceneHelper.setupCamera();

              // Antialiasing
              camera = this._hostingScene.activeCamera;
              if (camera) {
                is_firefox = /firefox/i.test(navigator.userAgent);
                if (!is_firefox) new BABYLON.PassPostProcess("scale_pass", 4.0, camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE);
                new BABYLON.PassPostProcess("scale_pass", 2.0, camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE);
                new BABYLON.PassPostProcess("scale_pass", 1.0, camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE);
              }
              return _context5.abrupt("return", new Promise(function (resolve) {
                var environmentTexture = new BABYLON.CubeTexture(_Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Environment.EnvironmentTextureCDNUrl, _this2._hostingScene, null, false, null, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  var container, i, sourceMaterial;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!(!_this2._hostingScene || !_this2._hostingSceneHelper)) {
                          _context4.next = 2;
                          break;
                        }
                        return _context4.abrupt("return");
                      case 2:
                        _this2._hostingScene.environmentTexture = environmentTexture;
                        _this2._hostingSceneHelper.setupLights();
                        _this2._hostingMesh = _this2._hostingSceneHelper.createSphere(null);
                        _this2._hostingSceneHelper.adjustCamera(undefined, undefined, undefined, false);
                        container = new MaterialPreviewData();
                        i = 0;
                      case 8:
                        if (!(i < _this2._materials.length)) {
                          _context4.next = 15;
                          break;
                        }
                        sourceMaterial = _this2._materials[i];
                        _context4.next = 12;
                        return _this2.createMaterialPreviewFileAsync(sourceMaterial, container, createBlobs);
                      case 12:
                        i++;
                        _context4.next = 8;
                        break;
                      case 15:
                        _this2.disposeHostingScene();
                        _this2.disposeLocalEngine();
                        resolve(container);
                      case 18:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                })), null, undefined, true, undefined, true);
              }));
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getPreviewsAsync() {
        return _getPreviewsAsync2.apply(this, arguments);
      }
      return getPreviewsAsync;
    }()
  }, {
    key: "createMaterialPreviewFileAsync",
    value: function () {
      var _createMaterialPreviewFileAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(sourceMaterial, container) {
        var createBlobs,
          sourceJsonObj,
          newMaterial,
          previewData,
          cropped,
          filename,
          data,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              createBlobs = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : true;
              if (!(this._hostingScene && this._hostingSceneHelper && this._hostingMesh)) {
                _context6.next = 23;
                break;
              }
              sourceJsonObj = sourceMaterial.serialize();
              newMaterial = BABYLON.Material.Parse(sourceJsonObj, this._hostingScene, this._rootUrl);
              if (!newMaterial) {
                _context6.next = 23;
                break;
              }
              this._hostingMesh.material = newMaterial;
              _context6.next = 8;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_2__.SceneHelper.whenMeshMaterialIsReady(this._hostingMesh);
            case 8:
              this._hostingScene.render();
              _context6.next = 11;
              return this._hostingSceneHelper.takeContentScreenshotAsync(this._width, this._height);
            case 11:
              previewData = _context6.sent;
              if (!this._crop) {
                _context6.next = 17;
                break;
              }
              _context6.next = 15;
              return _Helpers_utils__WEBPACK_IMPORTED_MODULE_0__.Utils.trimImageAsync(previewData);
            case 15:
              cropped = _context6.sent;
              if (cropped) previewData = cropped;
            case 17:
              filename = newMaterial.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
              filename = this.getNextIncrementalName(filename, ".png", container) + ".png";
              Logger.info("preview: " + filename);
              data = previewData;
              if (createBlobs) data = _Helpers_utils__WEBPACK_IMPORTED_MODULE_0__.Utils.dataURItoBlob(previewData);
              container.previewFiles[filename] = data;
            case 23:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function createMaterialPreviewFileAsync(_x9, _x10) {
        return _createMaterialPreviewFileAsync.apply(this, arguments);
      }
      return createMaterialPreviewFileAsync;
    }()
  }, {
    key: "getNextIncrementalName",
    value: function getNextIncrementalName(name, ext, previewData) {
      var newName = name;
      if (name) {
        var nameWithoutSuffix;
        var incremental = 0;
        while (previewData.previewFiles.hasOwnProperty(newName + ext)) {
          if (!nameWithoutSuffix) {
            nameWithoutSuffix = name;
            var idx = name.lastIndexOf("_");
            if (idx > 0) {
              var numText = name.substring(idx + 1);
              var num = parseInt(numText);
              if (num.toString() === numText) {
                nameWithoutSuffix = name.substring(0, idx);
              }
            }
          }
          incremental++;
          newName = nameWithoutSuffix + "_" + incremental;
        }
      }
      return newName;
    }
  }]);
  return MaterialPreviewMaker;
}();

/***/ }),

/***/ "../../3D/src/Components/MeshExpander/MeshExpander.ts":
/*!************************************************************!*\
  !*** ../../3D/src/Components/MeshExpander/MeshExpander.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MeshExpander": () => (/* binding */ MeshExpander)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// La classe espande una mesh muovendo tutti i vertici della geometria lungo la tangente
// risultante delle tangenti alle facce che hanno i vertici come spigoli
var MeshExpander = /*#__PURE__*/function () {
  function MeshExpander() {
    _classCallCheck(this, MeshExpander);
    _defineProperty(this, "_mesh", null);
    _defineProperty(this, "_scene", null);
    _defineProperty(this, "_facesOfVertices", null);
    _defineProperty(this, "_meshVerticesPositions", null);
    _defineProperty(this, "_meshVerticesNormals", null);
    _defineProperty(this, "_meshIndices", null);
    _defineProperty(this, "_meshPositions", null);
    _defineProperty(this, "_meshFacesNormals", null);
    _defineProperty(this, "_sharedFacesOfVertices", {});
  }
  _createClass(MeshExpander, [{
    key: "dispose",
    value: function dispose() {
      // ...
    }
  }, {
    key: "resetDataModel",
    value: function resetDataModel() {
      this._facesOfVertices = null;
      this._meshVerticesPositions = null;
      this._meshVerticesNormals = null;
      this._meshIndices = null;
      this._meshPositions = null;
      this._meshFacesNormals = null;
      this._sharedFacesOfVertices = {};
    }
  }, {
    key: "prepareDataModel",
    value: function prepareDataModel() {
      this.resetDataModel();
      if (this._mesh && this._scene) {
        this._facesOfVertices = [];
        this._sharedFacesOfVertices = {};
        this._meshVerticesPositions = this._mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);
        this._meshVerticesNormals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
        this._meshIndices = this._mesh.getIndices();
        this._meshPositions = [];
        this._meshFacesNormals = [];
        if (this._meshVerticesPositions && this._meshVerticesNormals && this._meshIndices) {
          for (var index = 0; index < this._meshVerticesPositions.length; index += 3) {
            this._meshPositions.push(new BABYLON.Vector3(this._meshVerticesPositions[index], this._meshVerticesPositions[index + 1], this._meshVerticesPositions[index + 2]));
          }
          for (var _index = 0; _index < this._mesh.getTotalIndices() / 3; _index++) {
            this._computeFaceNormal(_index);
          }
          this._getFacesOfVertices();
        }
      }
    }
  }, {
    key: "_getFaceVerticesIndex",
    value: function _getFaceVerticesIndex(faceID) {
      if (this._meshIndices) {
        return {
          v1: this._meshIndices[faceID * 3],
          v2: this._meshIndices[faceID * 3 + 1],
          v3: this._meshIndices[faceID * 3 + 2]
        };
      }
      return null;
    }

    // La normale ad una faccia è calcolata come prodotto vettoriale (cross product)
    // tra i vettori che connettono gli spigoli
  }, {
    key: "_computeFaceNormal",
    value: function _computeFaceNormal(face) {
      if (this._meshPositions && this._meshIndices && this._meshFacesNormals) {
        var faceInfo = this._getFaceVerticesIndex(face);
        if (faceInfo) {
          var v1v2 = this._meshPositions[faceInfo.v1].subtract(this._meshPositions[faceInfo.v2]);
          var v3v2 = this._meshPositions[faceInfo.v3].subtract(this._meshPositions[faceInfo.v2]);
          this._meshFacesNormals[face] = BABYLON.Vector3.Normalize(BABYLON.Vector3.Cross(v1v2, v3v2));
        }
      }
    }
  }, {
    key: "_getPositionKey",
    value: function _getPositionKey(vector) {
      return "".concat(vector.x, "_").concat(vector.y, "_").concat(vector.z);
    }

    // Determina le facce di ogni vertice sia considerando vertici uguali ripetuti più volte (_facesOfVertices)
    // che quelle condivise da uno stesso vertice ripetuto (_sharedFacesOfVertices). Queste ultime saranno
    // quelle che verranno considerate per il calcolo della normale risultante da tutte le facce che hanno
    // un vertice come spigolo.
  }, {
    key: "_getFacesOfVertices",
    value: function _getFacesOfVertices() {
      if (this._mesh && this._meshPositions && this._meshIndices) {
        this._sharedFacesOfVertices = {};
        this._facesOfVertices = [];
        for (var index = 0; index < this._meshPositions.length; index++) {
          this._facesOfVertices[index] = [];
          var position = this._meshPositions[index];
          var _key = this._getPositionKey(position);
          if (!this._sharedFacesOfVertices.hasOwnProperty(_key)) this._sharedFacesOfVertices[_key] = new Set();
        }
        for (var _index2 = 0; _index2 < this._meshIndices.length; _index2++) {
          var vertexIndex = this._meshIndices[_index2];
          var faceID = _index2 / 3 | 0;
          this._facesOfVertices[vertexIndex].push(faceID);
          var _position = this._meshPositions[vertexIndex];
          var _key2 = this._getPositionKey(_position);
          if (this._sharedFacesOfVertices.hasOwnProperty(_key2)) this._sharedFacesOfVertices[_key2].add(faceID);
        }
      }
    }
  }, {
    key: "expandMesh",
    value: function expandMesh(mesh) {
      var delta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.01;
      if (mesh instanceof BABYLON.Mesh) {
        this._mesh = mesh;
        this._scene = mesh.getScene();
        this.prepareDataModel();
        if (this._meshPositions && this._meshVerticesPositions && this._meshVerticesNormals) {
          for (var index = 0; index < this._meshPositions.length; index++) {
            var position = this._meshPositions[index];

            // Qui avviene lo spostamento vero e proprio del vertice lungo la normale
            var normal = this._getVertexComputedNormal(index);
            if (normal) {
              var scaledNormal = normal.scale(delta);
              position.addInPlace(scaledNormal);
              this._meshVerticesPositions[index * 3] = position.x;
              this._meshVerticesPositions[index * 3 + 1] = position.y;
              this._meshVerticesPositions[index * 3 + 2] = position.z;
            }
          }
          //this._reComputeNormals();
          this._mesh.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.PositionKind, true);
          //this._mesh.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.NormalKind, true);
          this._mesh.updateVerticesData(BABYLON.VertexBuffer.PositionKind, this._meshVerticesPositions);
          //this._mesh.updateVerticesData(BABYLON.VertexBuffer.NormalKind, this._meshVerticesNormals);

          this._mesh.computeWorldMatrix(true);
        }
      }
    }
  }, {
    key: "_reComputeNormals",
    value: function _reComputeNormals() {
      var faces = [];
      if (this._meshPositions && this._facesOfVertices) {
        for (var vertexIndex = 0; vertexIndex < this._meshPositions.length; vertexIndex++) {
          var faceOfVertices = this._facesOfVertices[vertexIndex];
          for (var index = 0; index < faceOfVertices.length; index++) {
            faces[faceOfVertices[index]] = true;
          }
        }
        var face;
        for (face in faces) {
          this._computeFaceNormal(face);
        }
        for (face in faces) {
          var faceInfo = this._getFaceVerticesIndex(face);
          if (faceInfo) {
            this._computeNormal(faceInfo.v1);
            this._computeNormal(faceInfo.v2);
            this._computeNormal(faceInfo.v3);
          }
        }
      }
    }
  }, {
    key: "_getVertexComputedNormal",
    value: function _getVertexComputedNormal(vertexIndex) {
      var normal = null;
      if (this._meshPositions && this._meshFacesNormals) {
        var meshPositions = this._meshPositions;
        var meshFacesNormals = this._meshFacesNormals;
        var position = meshPositions[vertexIndex];
        var _key3 = this._getPositionKey(position);
        if (this._sharedFacesOfVertices.hasOwnProperty(_key3)) {
          var faces = this._sharedFacesOfVertices[_key3];
          normal = BABYLON.Vector3.Zero();
          faces.forEach(function (faceID) {
            var faceNormal = meshFacesNormals[faceID];
            if (normal && faceNormal) {
              normal = normal.add(faceNormal);
            }
          });
          normal = BABYLON.Vector3.Normalize(normal.scale(1 / faces.size));
        }
      }
      return normal;
    }
  }, {
    key: "_computeNormal",
    value: function _computeNormal(vertexIndex) {
      var normal = this._getVertexComputedNormal(vertexIndex);
      if (normal && this._meshVerticesNormals) {
        this._meshVerticesNormals[vertexIndex * 3] = normal.x;
        this._meshVerticesNormals[vertexIndex * 3 + 1] = normal.y;
        this._meshVerticesNormals[vertexIndex * 3 + 2] = normal.z;
      }
    }
  }]);
  return MeshExpander;
}();

/***/ }),

/***/ "../../3D/src/Components/NormalMap/ProceduralNormalMap.ts":
/*!****************************************************************!*\
  !*** ../../3D/src/Components/NormalMap/ProceduralNormalMap.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProceduralNormalMap": () => (/* binding */ ProceduralNormalMap)
/* harmony export */ });
/* harmony import */ var _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ProceduralTextures/BlurXProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ProceduralTextures/BlurYProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_NormalMapProceduralTexture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ProceduralTextures/NormalMapProceduralTexture */ "../../3D/src/Components/ProceduralTextures/NormalMapProceduralTexture.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }



var ProceduralNormalMap = /*#__PURE__*/function () {
  function ProceduralNormalMap(baseTexture, size, config, scene) {
    _classCallCheck(this, ProceduralNormalMap);
    _defineProperty(this, "_bias", 50.0);
    _defineProperty(this, "_invertR", false);
    _defineProperty(this, "_invertG", false);
    _defineProperty(this, "_preBlurEnabled", false);
    _defineProperty(this, "_preBlur", 3);
    _defineProperty(this, "_postBlurEnabled", false);
    _defineProperty(this, "_postBlur", 3);
    _defineProperty(this, "_bevel", true);
    _defineProperty(this, "_intensity", 0.5);
    _defineProperty(this, "_activeTextures", []);
    _defineProperty(this, "_preBlurXTexture", null);
    _defineProperty(this, "_preBlurYTexture", null);
    _defineProperty(this, "_normalMapTexture", null);
    _defineProperty(this, "_postBlurXTexture", null);
    _defineProperty(this, "_postBlurYTexture", null);
    this._baseTexture = baseTexture;
    this._size = size;
    this._scene = scene;
    this.init(config);
  }
  _createClass(ProceduralNormalMap, [{
    key: "init",
    value: function init(config) {
      this._bias = config.get("bias");
      this._invertR = config.get("invertR");
      this._invertG = config.get("invertG");
      this._bevel = config.get("bevel");
      this._intensity = config.get("intensity");
      this._preBlurEnabled = config.get("preBlurEnabled");
      this._preBlur = config.get("preBlur");
      this._postBlurEnabled = config.get("postBlurEnabled");
      this._postBlur = config.get("postBlur");
      while (this._activeTextures.length > 0) {
        this._activeTextures.pop();
      }
      this.updateTextures();
    }
  }, {
    key: "updateTextures",
    value: function updateTextures() {
      var texture = this.updatePreBlurTexture();
      texture = this.updateNormalmapTexture(texture);
      texture = this.updatePostBlurTexture(texture);
    }
  }, {
    key: "updatePreBlurTexture",
    value: function updatePreBlurTexture() {
      var resultTexture = this._baseTexture;
      if (this._preBlurEnabled) {
        if (!this._preBlurXTexture) this._preBlurXTexture = new _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BlurXProceduralTexture("preBlurX", this._size, this._scene, this._baseTexture, undefined, false);else this._preBlurXTexture.baseTexture = this._baseTexture;
        this._preBlurXTexture.beginInit();
        this._preBlurXTexture.blur = this._preBlur;
        this._preBlurXTexture.refreshRate = 0;
        this._preBlurXTexture.endInit();
        this._activeTextures.push(this._preBlurXTexture);
        if (!this._preBlurYTexture) this._preBlurYTexture = new _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_1__.BlurYProceduralTexture("preBlurY", this._size, this._scene, this._preBlurXTexture, undefined, false);else this._preBlurYTexture.baseTexture = this._preBlurXTexture;
        this._preBlurYTexture.beginInit();
        this._preBlurYTexture.blur = this._preBlur;
        this._preBlurYTexture.refreshRate = 0;
        this._preBlurYTexture.endInit();
        this._activeTextures.push(this._preBlurYTexture);
        resultTexture = this._preBlurYTexture;
      }
      return resultTexture;
    }
  }, {
    key: "updateNormalmapTexture",
    value: function updateNormalmapTexture(baseTexture) {
      if (!this._normalMapTexture) this._normalMapTexture = new _ProceduralTextures_NormalMapProceduralTexture__WEBPACK_IMPORTED_MODULE_2__.NormalMapProceduralTexture("procNormal", this._size, this._scene, baseTexture, undefined, false);else this._normalMapTexture.baseTexture = baseTexture;
      this._normalMapTexture.beginInit();
      this._normalMapTexture.bias = this._bias;
      this._normalMapTexture.invertR = this._invertR;
      this._normalMapTexture.invertG = this._invertG;
      this._normalMapTexture.bevel = this._bevel;
      this._normalMapTexture.intensity = this._intensity;
      this._normalMapTexture.refreshRate = 0;
      this._normalMapTexture.endInit();
      this._activeTextures.push(this._normalMapTexture);
      return this._normalMapTexture;
    }
  }, {
    key: "updatePostBlurTexture",
    value: function updatePostBlurTexture(baseTexture) {
      var resultTexture = baseTexture;
      if (this._postBlurEnabled) {
        if (!this._postBlurXTexture) this._postBlurXTexture = new _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BlurXProceduralTexture("postBlurX", this._size, this._scene, baseTexture, undefined, false);else this._postBlurXTexture.baseTexture = baseTexture;
        if (this._postBlurXTexture) {
          this._postBlurXTexture.beginInit();
          this._postBlurXTexture.blur = this._postBlur;
          this._postBlurXTexture.refreshRate = 0;
          this._postBlurXTexture.endInit();
          this._activeTextures.push(this._postBlurXTexture);
          if (!this._postBlurYTexture) this._postBlurYTexture = new _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_1__.BlurYProceduralTexture("postBlurY", this._size, this._scene, this._postBlurXTexture, undefined, false);else this._postBlurYTexture.baseTexture = this._postBlurXTexture;
          if (this._postBlurYTexture) {
            this._postBlurYTexture.beginInit();
            this._postBlurYTexture.blur = this._postBlur;
            this._postBlurYTexture.refreshRate = 0;
            this._postBlurYTexture.endInit();
            this._activeTextures.push(this._postBlurYTexture);
            resultTexture = this._postBlurYTexture;
          }
        }
      }
      return resultTexture;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._preBlurXTexture) {
        this._preBlurXTexture.dispose();
        this._preBlurXTexture = null;
      }
      if (this._preBlurYTexture) {
        this._preBlurYTexture.dispose();
        this._preBlurYTexture = null;
      }
      if (this._normalMapTexture) {
        this._normalMapTexture.dispose();
        this._normalMapTexture = null;
      }
      if (this._postBlurXTexture) {
        this._postBlurXTexture.dispose();
        this._postBlurXTexture = null;
      }
      if (this._postBlurYTexture) {
        this._postBlurYTexture.dispose();
        this._postBlurYTexture = null;
      }
    }
  }, {
    key: "getNormalMapTextureAsync",
    value: function () {
      var _getNormalMapTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(baseTexture, config) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.updateAsync(baseTexture, config);
            case 2:
              if (!(this._activeTextures.length > 0)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", this._activeTextures[this._activeTextures.length - 1]);
            case 4:
              return _context.abrupt("return", null);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getNormalMapTextureAsync(_x, _x2) {
        return _getNormalMapTextureAsync.apply(this, arguments);
      }
      return getNormalMapTextureAsync;
    }()
  }, {
    key: "updateAsync",
    value: function () {
      var _updateAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(baseTexture, config) {
        var i;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.init(config);
              if (!(this._activeTextures.length > 0)) {
                _context2.next = 11;
                break;
              }
              this._activeTextures[0].baseTexture = baseTexture;
              i = 0;
            case 4:
              if (!(i < this._activeTextures.length)) {
                _context2.next = 11;
                break;
              }
              _context2.next = 7;
              return this._activeTextures[i].isReadyAsync();
            case 7:
              this._activeTextures[i].render();
            case 8:
              i++;
              _context2.next = 4;
              break;
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateAsync(_x3, _x4) {
        return _updateAsync.apply(this, arguments);
      }
      return updateAsync;
    }()
  }]);
  return ProceduralNormalMap;
}();

/***/ }),

/***/ "../../3D/src/Components/Preview3D/Preview3DConfigurationManager.ts":
/*!**************************************************************************!*\
  !*** ../../3D/src/Components/Preview3D/Preview3DConfigurationManager.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Preview3DConfigurationManager": () => (/* binding */ Preview3DConfigurationManager)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var Preview3DConfigurationManager = /*#__PURE__*/function () {
  function Preview3DConfigurationManager(zkModel, zkScene, scene) {
    _classCallCheck(this, Preview3DConfigurationManager);
    this._zkModel = zkModel;
    this._zkScene = zkScene;
    this._scene = scene;
    this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper(scene);
  }

  // restituisce tutti materiali della scena per cui è possibile specificare se sono
  // variabili o meno in base alle varianti del prodotto. Da tale elenco verranno esclusi
  // tutti i materiali che sono stati già clonati per rappresentare la variazione.
  // verranno esclusi anche tutti i materiali che comunque sono stati marcati (metadata)
  // come materiali creati ad hoc per una preview di prodotto (isForPreview = true)
  // e verranno esclusi tutti i materiali non assegnati a nessuna mesh. 
  // Verranno considerati quindi tutti i materiali non clonati assegnati ad almeno una mesh (direttamente
  // o indirettamente)
  _createClass(Preview3DConfigurationManager, [{
    key: "getPossibleVariableMaterials",
    value: function getPossibleVariableMaterials() {
      var allMaterials = this._sceneHelper.getAllMaterials();
      var variableMaterials = [];
      for (var i = 0; i < allMaterials.length; i++) {
        var material = allMaterials[i];
        var meshes = this.getMeshesUsingMaterial(material.id);
        var isForVariant = this.isSceneMaterialForVariant(material);
        if (meshes.length > 0 && !isForVariant) {
          variableMaterials.push(material);
        }
      }
      return variableMaterials;
      /*
      const allMaterials: BABYLON.Material[] = this._sceneHelper.getAllMaterials();
      const preview3D = this._zkModel.getPreview3D();
      if (preview3D) {
          const variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
          if (variantsAttributeOptions) {
              const optionsMaterials = variantsAttributeOptions.getOptionsMaterialIDs();
              for (let i = 0; i < allMaterials.length; i++) {
                  let material = allMaterials[i];
                  if (optionsMaterials.indexOf(material.id) !== -1 ||
                      this.isSceneMaterialForVariant(material))
                      allMaterials.splice(i--, 1);
              }
          }
      }
      return allMaterials;
      */
    }

    // Restituisce l'elenco dei materiali della scena già selezionati come variabili
  }, {
    key: "getVariableMaterials",
    value: function getVariableMaterials() {
      var materials = [];
      var preview3D = this._zkModel.getPreview3D();
      if (preview3D) {
        var variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
        if (variantsAttributeOptions) {
          for (var i = 0; i < variantsAttributeOptions.get("variableMaterials").length; i++) {
            var materialID = variantsAttributeOptions.get("variableMaterials").at(i).get("materialID");
            var material = this._scene.getMaterialByID(materialID);
            if (material) materials.push(material);
          }
        }
      }
      return materials;
    }
  }, {
    key: "getVariableMaterialsSelection",
    value: function getVariableMaterialsSelection() {
      var variableMaterials = this.getVariableMaterials();
      var variableMaterialsIds = variableMaterials.map(function (m) {
        return m.id;
      });
      var allMaterials = this.getPossibleVariableMaterials();
      var selection = allMaterials.map(function (m) {
        return {
          id: m.id,
          name: m.name,
          selected: variableMaterialsIds.indexOf(m.id) != -1
        };
      });
      return selection;
    }
  }, {
    key: "getVariantMaterialsWithOriginal",
    value: function getVariantMaterialsWithOriginal(modelColor) {
      var materials = [];
      var preview3D = this._zkModel.getPreview3D();
      if (preview3D && modelColor && modelColor instanceof MPlaza.Color) {
        var variantID = this.getVariantID(modelColor);
        var variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
        if (variantsAttributeOptions) {
          var variantOption = variantsAttributeOptions.getVariantOption(variantID);
          if (variantOption) {
            for (var i = 0; i < variantOption.get("materials").length; i++) {
              var variantOptionMaterial = variantOption.get("materials").at(i);
              var materialID = variantOptionMaterial.get("optionMaterialID");
              var material = this._scene.getMaterialByID(materialID);
              var variableMaterialID = variantOptionMaterial.get("variableMaterialID");
              var variableMaterial = this._scene.getMaterialByID(variableMaterialID);
              if (material && variableMaterial) materials.push({
                material: material,
                variableMaterial: variableMaterial
              });
            }
          }
        }
      }
      return materials;
    }

    // Per tutti i materiali impostati come variabili, verifica che questi materiali esistano ancora.
    // Se un materiale esiste, aggiorna l'indicazione delle mesh alle quali è impostato e le azioni per opzione.
    // Se un materiale non esiste, lo elimina tra i materiali variabili.
  }, {
    key: "updateVariableMaterials",
    value: function updateVariableMaterials() {
      var _this = this;
      var preview3D = this._zkModel.getPreview3D();
      if (preview3D) {
        var variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
        if (variantsAttributeOptions) {
          var materialsToSet = [];
          var materialsToUnset = [];
          for (var i = 0; i < variantsAttributeOptions.get("variableMaterials").length; i++) {
            var variableMaterial = variantsAttributeOptions.get("variableMaterials").at(i);
            var materialID = variableMaterial.get("materialID");
            var material = this._scene.getMaterialByID(materialID);
            if (material) materialsToSet.push(materialID);else materialsToUnset.push(materialID);
          }
          materialsToSet.forEach(function (id) {
            return _this.setVariableMaterialID(id);
          });
          materialsToUnset.forEach(function (id) {
            return _this.unsetVariableMaterialID(id);
          });
        }
      }
    }

    // Imposta un materiale come NON variabile per variante. Questo significa che vanno eliminate
    // tutte le eventuali azioni relative al materiale ed eventualmente le opzioni
  }, {
    key: "unsetVariableMaterialID",
    value: function unsetVariableMaterialID(materialID) {
      var preview3D = this._zkModel.getPreview3D();
      if (preview3D) {
        var variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
        if (variantsAttributeOptions) {
          var attribute = this._zkModel.getAttributeByGuid(variantsAttributeOptions.get("attributeGuid"));

          // ripristino il materiale originale sulle mesh di riferimento
          var variableMaterial = variantsAttributeOptions.get("variableMaterials").getVariableMaterial(materialID);
          if (variableMaterial) {
            var material = this._scene.getMaterialByID(materialID);
            if (material) {
              for (var i = 0; i < variableMaterial.get("meshes").length; i++) {
                var mesh = this._scene.getMeshByID(variableMaterial.get("meshes")[i]);
                if (mesh) this._sceneHelper.applyMaterial(material, mesh);
              }
            }
          }

          // elimino dall'elenco dei materiali variabili
          variantsAttributeOptions.removeVariableMaterial(materialID);

          // elimino tutte le azioni, opzione per opzione
          var variantOptionsToRemove = [];
          for (var _i = 0; _i < variantsAttributeOptions.get("variantOptions").length; _i++) {
            var variantOption = variantsAttributeOptions.get("variantOptions").at(_i);
            var option = null;
            if (attribute) option = attribute.getOptionByGuid(variantOption.get("optionGuid"));
            var variantOptionMaterialsToRemove = [];
            for (var j = 0; j < variantOption.get("materials").length; j++) {
              var variantOptionMaterial = variantOption.get("materials").at(j);
              if (variantOptionMaterial.get("variableMaterialID") === materialID) {
                for (var k = 0; k < variantOptionMaterial.get("actions").length; k++) {
                  var variantOptionMaterialAction = variantOptionMaterial.get("actions").at(k);
                  if (option) {
                    var action = option.get("actions").getActionByGuid(variantOptionMaterialAction.get("actionGuid"));
                    if (action) option.get("actions").remove(action);
                  }
                }

                // Elimino il materiale creato proprio per l'azione dell'opzione
                this.deleteSceneMaterial(variantOptionMaterial.get("optionMaterialID"));
                variantOptionMaterialsToRemove.push(variantOptionMaterial);
              }
            }
            variantOption.get("materials").remove(variantOptionMaterialsToRemove);
            if (variantOption.get("materials").length === 0) {
              variantOptionsToRemove.push(variantOption);
            }
          }
          for (var _i2 = 0; _i2 < variantOptionsToRemove.length; _i2++) this.removeVariantOption(variantsAttributeOptions, variantOptionsToRemove[_i2]);
        }
      }
    }

    // Imposta un materiale come variabile. Vengono generati i materiali cloni per le varie opzioni
    // e create le azioni di trasformazione della scena che impostano il materiale sulle varie mesh
  }, {
    key: "setVariableMaterialID",
    value: function setVariableMaterialID(materialID) {
      var material = this._scene.getMaterialByID(materialID);
      if (material) {
        var meshes = this.getMeshesUsingMaterial(material.id);
        var meshIDs = meshes.map(function (m) {
          return m.id;
        });
        var preview3D = this._zkModel.getOrCreatePreview3D();
        var variantsAttributeOptions = preview3D.getOrCreateVariantsAttributeOptions();
        var attribute = this.getOrCreateVariantAttribute(variantsAttributeOptions);

        // Imposto l'elenco delle mesh che hanno il materiale in questione
        variantsAttributeOptions.setVariableMaterial(materialID, meshIDs);

        // Variante per variante verifico l'opzione associata
        var variantIDs = [];
        for (var i = 0; i < this._zkModel.get("colors").length; i++) {
          var modelColor = this._zkModel.get("colors").at(i);
          var variantID = this.getVariantID(modelColor);
          variantIDs.push(variantID);
          this.checkVariantOption(variantsAttributeOptions, material, meshes, modelColor);
        }

        // elimino le opzioni associate a varianti non più esistenti
        for (var _i3 = 0; _i3 < variantsAttributeOptions.get("variantOptions").length; _i3++) {
          var variantOption = variantsAttributeOptions.get("variantOptions").at(_i3);
          if (variantIDs.indexOf(variantOption.get("variantID")) === -1) this.removeVariantOption(variantsAttributeOptions, variantOption);
        }
      }
    }
  }, {
    key: "checkVariantOption",
    value: function checkVariantOption(variantsAttributeOptions, material, meshes, modelColor) {
      var variantID = this.getVariantID(modelColor);
      var variantOption = variantsAttributeOptions.get("variantOptions").getVariantOption(variantID);
      if (!variantOption) {
        variantOption = this.createVariantOption(variantsAttributeOptions, modelColor);
      }
      this.checkVariantOptionMaterial(variantsAttributeOptions, variantOption, material, meshes, modelColor);
    }
  }, {
    key: "createVariantOption",
    value: function createVariantOption(variantsAttributeOptions, modelColor) {
      var variantID = this.getVariantID(modelColor);
      var attribute = this.getOrCreateVariantAttribute(variantsAttributeOptions);
      var option = this.getOrCreateVariantAttributeOption(variantsAttributeOptions, modelColor, attribute);
      var variantOption = new MPlaza.VariantOption();
      variantOption.set("variantID", variantID);
      variantOption.set("optionGuid", option.get("optionGuid"));
      variantsAttributeOptions.get("variantOptions").push(variantOption);
      return variantOption;
    }
  }, {
    key: "removeVariantOption",
    value: function removeVariantOption(variantsAttributeOptions, variantOption) {
      // Elimino l'opzione dall'attributo
      var attribute = this._zkModel.getAttributeByGuid(variantsAttributeOptions.get("attributeGuid"));
      if (attribute) {
        var option = attribute.getOptionByGuid(variantOption.get("optionGuid"));
        if (option) {
          attribute.get("options").remove(option);
        }
      }

      // Elimino i materiali clonati dalla scena
      for (var i = 0; i < variantOption.get("materials").length; i++) {
        var variantOptionMaterial = variantOption.get("materials").at(i);
        var materialID = variantOptionMaterial.get("optionMaterialID");
        this.deleteSceneMaterial(materialID);
      }
      variantsAttributeOptions.get("variantOptions").remove(variantOption);
    }
  }, {
    key: "getOrCreateVariantAttribute",
    value: function getOrCreateVariantAttribute(variantsAttributeOptions) {
      var attribute = null;
      if (variantsAttributeOptions.get("attributeGuid")) attribute = this._zkModel.getAttributeByGuid(variantsAttributeOptions.get("attributeGuid"));
      if (!attribute) {
        // verifico se già esite un attributo con codice variants_attribute
        attribute = this._zkModel.get("attributes").getAttributeByCode("variants_attribute");
      }
      if (!attribute) {
        // Per forza di cose elimino tutte le eventuali opzioni esistenti (non dovrebbero essercene)
        for (var i = 0; i < variantsAttributeOptions.get("variantOptions").length; i++) {
          this.removeVariantOption(variantsAttributeOptions, variantsAttributeOptions.get("variantOptions").at(i));
        }
        attribute = new MPlaza.Attribute();
        attribute.set("attributeGuid", MPlaza.generateUUID());
        attribute.set("name", "Variants attribute");
        attribute.set("attributeCode", "variants_attribute");
        attribute.set("attributeTypeID", MPlaza.AttributeType.Options);
        variantsAttributeOptions.set("attributeGuid", attribute.get("attributeGuid"));
        this._zkModel.get("attributes").push(attribute);
      }
      return attribute;
    }
  }, {
    key: "getOrCreateVariantAttributeOption",
    value: function getOrCreateVariantAttributeOption(variantsAttributeOptions, modelColor, attribute) {
      var variantID = this.getVariantID(modelColor);
      var option = attribute.getOptionByCode(variantID);
      if (!option) {
        option = new MPlaza.AttributeOption();
        option.set("optionCode", variantID);
        option.set("name", modelColor.get("name"));
        attribute.get("options").push(option);
      }
      return option;
    }
  }, {
    key: "getVariantID",
    value: function getVariantID(modelColor) {
      return "".concat(modelColor.getModelID(), "_").concat(modelColor.getColorID());
    }
  }, {
    key: "checkVariantOptionMaterial",
    value: function checkVariantOptionMaterial(variantsAttributeOptions, variantOption, material, meshes, modelColor) {
      var variantID = this.getVariantID(modelColor);
      var variantOptionMaterial = null;
      for (var i = 0; i < variantOption.get("materials").length; i++) {
        var mat = variantOption.get("materials").at(i);
        if (mat.get("variableMaterialID") === material.id) {
          variantOptionMaterial = mat;
          break;
        }
      }
      if (!variantOptionMaterial) {
        // verifico se esiste nella scena già un materiale predisposto per la variante
        // questo perme di creare un materiale manualmente ed utilizzarlo come materiale di variante,
        // ovviamente impostato opportunamente i metadati del materiale
        var optionMaterial = this.getSceneMaterialForVariant(variantID, material.id);
        if (!optionMaterial) {
          // creo il materiale per l'opzione come clone del material passato
          var name = "".concat(material.name, " - ").concat(modelColor.get("name"));
          optionMaterial = this.cloneSceneMaterial(material.id, undefined, name);
          if (optionMaterial) this.setupSceneMaterialForVariant(optionMaterial, variantID, material.id);
        }
        if (optionMaterial) {
          variantOptionMaterial = new MPlaza.VariantOptionMaterial();
          variantOptionMaterial.set("optionMaterialID", optionMaterial.id);
          variantOptionMaterial.set("variableMaterialID", material.id);
          variantOption.get("materials").push(variantOptionMaterial);
        }
      }
      if (variantOptionMaterial) this.checkVariantOptionActions(variantsAttributeOptions, variantOption, variantOptionMaterial, material, meshes, modelColor);
    }

    // Una materiale creato per una variante viene marcato con dei metadati. Questo significa che i materiali creati in altro modo
    // e con i materiali giusti verrano riconosciuti e utilizzati per le azioni delle opzioni
  }, {
    key: "setupSceneMaterialForVariant",
    value: function setupSceneMaterialForVariant(material, variantID, variableMaterialID) {
      var metadata = this.getOrCreateSceneMaterialMetadata(material.id);
      metadata.isForPreview = true;
      metadata.autoCreate = true;
      metadata.variantID = variantID;
      metadata.variableMaterialID = variableMaterialID;
    }
  }, {
    key: "getSceneMaterialForVariant",
    value: function getSceneMaterialForVariant(variantID, variableMaterialID) {
      var materials = this._sceneHelper.getAllMaterials();
      for (var i = 0; i < materials.length; i++) {
        var material = materials[i];
        var metadata = this.getSceneMaterialMetadata(material.id);
        if (metadata && metadata.isForPreview && metadata.variantID === variantID && metadata.variableMaterialID === variableMaterialID) {
          return materials[i];
        }
      }
      return null;
    }
  }, {
    key: "isSceneMaterialForVariant",
    value: function isSceneMaterialForVariant(material) {
      if (!material) return false;
      var metadata = this.getSceneMaterialMetadata(material.id);
      return metadata && metadata.isForPreview;
    }
  }, {
    key: "canDeleteSceneMaterialForVariant",
    value: function canDeleteSceneMaterialForVariant(material) {
      if (!material) return false;
      var metadata = this.getSceneMaterialMetadata(material.id);
      if (!metadata) return true;
      if (metadata.isForPreview === undefined || metadata.isForPreview === null) return true;
      if (metadata.autoCreate === undefined || metadata.autoCreate === null) return true;
      return metadata.isForPreview && metadata.autoCreate;
    }
  }, {
    key: "getSceneMaterialMetadata",
    value: function getSceneMaterialMetadata(materialID) {
      return this._sceneHelper.getSceneMaterialMetadata(materialID);
    }
  }, {
    key: "getOrCreateSceneMaterialMetadata",
    value: function getOrCreateSceneMaterialMetadata(materialID) {
      return this._sceneHelper.getOrCreateSceneMaterialMetadata(materialID);
    }
  }, {
    key: "removeSceneMaterialMetadata",
    value: function removeSceneMaterialMetadata(materialID) {
      this._sceneHelper.removeSceneMaterialMetadata(materialID);
    }

    // Clona un materiale
  }, {
    key: "cloneSceneMaterial",
    value: function cloneSceneMaterial(id, newId, newName) {
      var material = this._scene.getMaterialByID(id);
      var newMaterial = null;
      if (material) {
        var materialName = newName || "".concat(material.name, " - clone");
        newMaterial = material.clone(materialName);
        if (newMaterial) {
          var materialId = newId || MPlaza.generateUUID();
          newMaterial.id = materialId;

          // Verifico se il materiale originario deriva da un materiale di libreria.
          // Nel caso, devo impostare il mapping in modo da copiare anche le relative textures
          var mapping = this._zkScene.getMappingForSceneMaterial(material.id);
          if (mapping) {
            var libraryMaterialID = mapping.get("libraryMaterialID");
            this._zkScene.mapLibraryMaterial(libraryMaterialID, newMaterial.id);
            var textures = this._sceneHelper.getTexturesForMaterial(newMaterial);
            for (var i = 0; i < textures.length; i++) {
              var texture = textures[i];
              texture["materialMapping"] = {
                libraryMaterialID: libraryMaterialID,
                sceneMaterialID: newMaterial.id
              };
            }
          }
        }
      }
      return newMaterial;
    }
  }, {
    key: "deleteSceneMaterial",
    value: function deleteSceneMaterial(materialID) {
      var material = this._scene.getMaterialByID(materialID);
      if (material && this.canDeleteSceneMaterialForVariant(material)) {
        this.removeSceneMaterialMetadata(materialID);
        var libraryMaterialID = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(materialID);
        if (libraryMaterialID) this._zkScene.unregisterShaderMaterial(libraryMaterialID);
        this._zkScene.removeMappingForSceneMaterial(material.id);
        var textures = this._sceneHelper.getTexturesExclusivelyForMaterial(material);
        material.dispose();
        for (var i = 0; i < textures.length; i++) textures[i].dispose();
      }
    }
  }, {
    key: "checkVariantOptionActions",
    value: function checkVariantOptionActions(variantsAttributeOptions, variantOption, variantOptionMaterial, material, meshes, modelColor) {
      // verifico che ci siano tutte e solo le azioni per le mesh

      var meshIDs = [];
      meshes.forEach(function (m) {
        return meshIDs.push(m.id);
      });
      var attribute = this.getOrCreateVariantAttribute(variantsAttributeOptions);
      var option = this.getOrCreateVariantAttributeOption(variantsAttributeOptions, modelColor, attribute);
      for (var i = 0; i < meshes.length; i++) {
        var mesh = meshes[i];
        var variantOptionMaterialAction = variantOptionMaterial.get("actions").getActionForMesh(mesh.id);
        if (!variantOptionMaterialAction) {
          // creo l'azione
          var action = new MPlaza.AttributeSceneAction();
          action.set("name", "");
          action.set("actionTypeID", MPlaza.SceneActionType.SetMeshMaterial);
          action.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh);
          action.set("selector", mesh.id);
          action.set("value", variantOptionMaterial.get("optionMaterialID"));
          option.get("actions").push(action);
          variantOptionMaterialAction = new MPlaza.VariantOptionMaterialAction();
          variantOptionMaterialAction.set("actionGuid", action.get("actionGuid"));
          variantOptionMaterialAction.set("meshID", mesh.id);
          variantOptionMaterial.get("actions").push(variantOptionMaterialAction);
        }
      }

      // Elimino le azioni sulle mesh che non usano più il materiale dell'opzione
      var actionsToRemove = [];
      for (var _i4 = 0; _i4 < variantOptionMaterial.get("actions").length; _i4++) {
        var _variantOptionMaterialAction = variantOptionMaterial.get("actions").at(_i4);
        if (meshIDs.indexOf(_variantOptionMaterialAction.get("meshID")) === -1) {
          // elimino l'azione tra quelle dell'opzione
          var _action = option.getActionByGuid(_variantOptionMaterialAction.get("actionGuid"));
          if (_action) {
            option.get("actions").remove(_action);
          }
          actionsToRemove.push(_variantOptionMaterialAction);
        }
      }
      variantOptionMaterial.get("actions").remove(actionsToRemove);
    }
  }, {
    key: "getVariantMaterials",
    value: function getVariantMaterials(modelColor) {
      var materials = [];
      var preview3D = this._zkModel.getPreview3D();
      if (preview3D && modelColor && modelColor instanceof MPlaza.Color) {
        var variantID = this.getVariantID(modelColor);
        var variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
        if (variantsAttributeOptions) {
          var variantOption = variantsAttributeOptions.getVariantOption(variantID);
          if (variantOption) {
            for (var i = 0; i < variantOption.get("materials").length; i++) {
              var variantOptionMaterial = variantOption.get("materials").at(i);
              var materialID = variantOptionMaterial.get("optionMaterialID");
              var material = this._scene.getMaterialByID(materialID);
              if (material) materials.push(material);
            }
          }
        }
      }
      return materials;
    }
  }, {
    key: "getSelectedAttributeOption",
    value: function getSelectedAttributeOption(selectedModelColor) {
      var res = {
        attributeID: null,
        attributeGuid: null,
        optionID: null,
        optionGuid: null
      };
      var preview3D = this._zkModel.getPreview3D();
      if (preview3D && selectedModelColor && selectedModelColor instanceof MPlaza.Color) {
        var variantID = this.getVariantID(selectedModelColor);
        var variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
        if (variantsAttributeOptions && variantsAttributeOptions.get("attributeGuid")) {
          var attribute = this._zkModel.getAttributeByGuid(variantsAttributeOptions.get("attributeGuid"));
          if (attribute) {
            var variantOption = variantsAttributeOptions.getVariantOption(variantID);
            if (variantOption) {
              var option = attribute.getOptionByGuid(variantOption.get("optionGuid"));
              if (option) {
                res.attributeID = attribute.get("attributeID");
                res.attributeGuid = attribute.get("attributeGuid");
                res.optionID = option.get("optionID");
                res.optionGuid = option.get("optionGuid");
              }
            }
          }
        }
      }
      return res;
    }
  }, {
    key: "resetOriginaMaterialsOnMeshes",
    value: function resetOriginaMaterialsOnMeshes() {
      var preview3D = this._zkModel.getPreview3D();
      if (preview3D) {
        var variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
        if (variantsAttributeOptions) {
          for (var i = 0; i < variantsAttributeOptions.get("variableMaterials").length; i++) {
            var variableMaterial = variantsAttributeOptions.get("variableMaterials").at(i);
            var materialID = variableMaterial.get("materialID");
            var meshes = variableMaterial.get("meshes");
            var material = this._scene.getMaterialByID(materialID);
            if (material) {
              for (var j = 0; j < meshes.length; j++) {
                var mesh = this._scene.getMeshByID(variableMaterial.get("meshes")[j]);
                if (mesh) this._sceneHelper.applyMaterial(material, mesh);
              }
            }
          }
        }
      }
    }

    // Una mesh usa un materiale se sulla mesh è impostato direttamente quel materiale o se sulla mesh è
    // attualmente impostato un materiale creato ad hoc per la preview 3D e che deriva dal materiale in oggetto (clone)
  }, {
    key: "getMeshesUsingMaterial",
    value: function getMeshesUsingMaterial(materialID) {
      var meshes = [];
      var allMeshes = this._sceneHelper.getSceneMeshes();
      for (var i = 0; i < allMeshes.length; i++) {
        var mesh = allMeshes[i];
        if (this._sceneHelper.isMeshUsingMaterial(mesh, materialID)) {
          meshes.push(mesh);
        } else {
          var meshMaterials = this._sceneHelper.getMeshMaterials(mesh);
          for (var j = 0; j < meshMaterials.length; j++) {
            var meshMaterial = meshMaterials[j];
            var metadata = this.getSceneMaterialMetadata(meshMaterial.id);
            if (metadata && metadata.isForPreview && metadata.variableMaterialID && metadata.variableMaterialID === materialID) {
              meshes.push(mesh);
              break;
            }
          }
        }
      }
      return meshes;
    }
  }]);
  return Preview3DConfigurationManager;
}();

/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts":
/*!***************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BaseProceduralTexture": () => (/* binding */ BaseProceduralTexture)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var BaseProceduralTexture = /*#__PURE__*/function (_BABYLON$ProceduralTe) {
  _inherits(BaseProceduralTexture, _BABYLON$ProceduralTe);
  var _super = _createSuper(BaseProceduralTexture);
  function BaseProceduralTexture(name, size, fragment, scene, baseTexture, fallbackTexture, generateMipMaps) {
    var _this;
    _classCallCheck(this, BaseProceduralTexture);
    _this = _super.call(this, name, size, fragment, scene, fallbackTexture, generateMipMaps);
    _defineProperty(_assertThisInitialized(_this), "_initializing", false);
    _this._baseTexture = baseTexture;
    _this.updateShaderUniforms();
    return _this;
  }
  _createClass(BaseProceduralTexture, [{
    key: "initializing",
    get: function get() {
      return this._initializing;
    }
  }, {
    key: "baseTexture",
    get: function get() {
      return this._baseTexture;
    },
    set: function set(texture) {
      this._baseTexture = texture;
      this.updateShaderUniforms();
    }
  }, {
    key: "isReadyAsync",
    value: function isReadyAsync() {
      return _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.whenTextureIsReadyAsync(this);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(BaseProceduralTexture.prototype), "dispose", this).call(this);
      if (this._baseTexture) this._baseTexture.dispose();
    }
  }, {
    key: "beginInit",
    value: function beginInit() {
      this._initializing = true;
    }
  }, {
    key: "endInit",
    value: function endInit() {
      this._initializing = false;
      this.updateShaderUniforms();
    }
  }, {
    key: "updateShaderUniforms",
    value: function updateShaderUniforms() {
      if (this._initializing) return;
      this.setBaseTextureUniform();
    }
  }, {
    key: "setBaseTextureUniform",
    value: function setBaseTextureUniform() {
      this.setTexture("uSampler", this._baseTexture);
    }
  }]);
  return BaseProceduralTexture;
}(BABYLON.ProceduralTexture);

/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/BlendProceduralTexture.ts":
/*!****************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/BlendProceduralTexture.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlendProceduralTexture": () => (/* binding */ BlendProceduralTexture)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BlendProceduralTexture = /*#__PURE__*/function (_BABYLON$ProceduralTe) {
  _inherits(BlendProceduralTexture, _BABYLON$ProceduralTe);
  var _super = _createSuper(BlendProceduralTexture);
  function BlendProceduralTexture(name, size) {
    var _this;
    var scene = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var fallbackTexture = arguments.length > 3 ? arguments[3] : undefined;
    var generateMipMaps = arguments.length > 4 ? arguments[4] : undefined;
    _classCallCheck(this, BlendProceduralTexture);
    _this = _super.call(this, name, size, BlendProceduralTexture.FRAGMENT_SHADER, scene, fallbackTexture, generateMipMaps);
    _defineProperty(_assertThisInitialized(_this), "_baseTexture", null);
    _defineProperty(_assertThisInitialized(_this), "_blendTexture", null);
    _this.updateShaderUniforms();
    return _this;
  }
  _createClass(BlendProceduralTexture, [{
    key: "dispose",
    value: function dispose() {
      if (this._baseTexture) this._baseTexture.dispose();
      if (this._blendTexture) this._blendTexture.dispose();
    }
  }, {
    key: "updateShaderUniforms",
    value: function updateShaderUniforms() {
      if (this._baseTexture) {
        this.setTexture("uSampler", this._baseTexture);
        this.setInt("hasSampler", 1);
        this.setVector2("uSamplerScale", new BABYLON.Vector2(this._baseTexture.uScale, this._baseTexture.vScale));
      } else {
        this.setInt("hasSampler", 0);
        this.setVector2("uSamplerScale", new BABYLON.Vector2(1, 1));
      }
      if (this._blendTexture) {
        this.setTexture("uBlendSampler", this._blendTexture);
        this.setInt("hasBlend", 1);
        this.setVector2("uBlendScale", new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale));
      } else {
        this.setInt("hasBlend", 0);
        this.setVector2("uBlendScale", new BABYLON.Vector2(1, 1));
      }
      this.setFloat("size", this.getRenderSize());
    }
  }, {
    key: "render",
    value: function render(useCameraPostProcess) {
      _get(_getPrototypeOf(BlendProceduralTexture.prototype), "render", this).call(this, useCameraPostProcess);
    }
  }, {
    key: "resize",
    value: function resize(size, generateMipMaps) {
      _get(_getPrototypeOf(BlendProceduralTexture.prototype), "resize", this).call(this, size, generateMipMaps);

      // We need to update the "size" uniform
      this.updateShaderUniforms();
    }
  }, {
    key: "isReady",
    value: function isReady() {
      /*
      if (!this._baseTexture || !this._baseTexture.isReady()) {
          return false;
      }
      */

      if (this._baseTexture && !this._baseTexture.isReady()) return false;
      if (this._blendTexture && !this._blendTexture.isReady()) return false;
      return _get(_getPrototypeOf(BlendProceduralTexture.prototype), "isReady", this).call(this);
    }

    //@BABYLON.serializeAsTexture()
  }, {
    key: "baseTexture",
    get: function get() {
      return this._baseTexture;
    },
    set: function set(texture) {
      this._baseTexture = texture;
      this.updateShaderUniforms();
    }

    //@BABYLON.serializeAsTexture()
  }, {
    key: "blendTexture",
    get: function get() {
      return this._blendTexture;
    },
    set: function set(texture) {
      this._blendTexture = texture;
      this.updateShaderUniforms();
    }

    /**
     * Serializes this normal map procedural texture
     * @returns a serialized normal map procedural texture object
     */
  }, {
    key: "serialize",
    value: function serialize() {
      var serializationObject = BABYLON.SerializationHelper.Serialize(this, _get(_getPrototypeOf(BlendProceduralTexture.prototype), "serialize", this).call(this));
      serializationObject.customType = BlendProceduralTexture.CUSTOM_TYPE;
      if (this.baseTexture) serializationObject.baseTexture = this.baseTexture.serialize();else serializationObject.baseTexture = null;
      if (this.blendTexture) serializationObject.blendTexture = this.blendTexture.serialize();else serializationObject.blendTexture = null;
      return serializationObject;
    }

    /**
     * Creates a Normal Map Procedural Texture from parsed normal map procedural texture data
     * @param parsedTexture defines parsed texture data
     * @param scene defines the current scene
     * @param rootUrl defines the root URL containing normal map procedural texture information
     * @returns a parsed Normal Map Procedural Texture
     */
  }], [{
    key: "Parse",
    value: function Parse(parsedTexture, scene, rootUrl) {
      var texture = BABYLON.SerializationHelper.Parse(function () {
        return new BlendProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps);
      }, parsedTexture, scene, rootUrl);
      if (parsedTexture.baseTexture) texture.baseTexture = BABYLON.Texture.Parse(parsedTexture.baseTexture, scene, rootUrl);
      if (parsedTexture.blendTexture) texture.blendTexture = BABYLON.Texture.Parse(parsedTexture.blendTexture, scene, rootUrl);
      return texture;
    }
  }]);
  return BlendProceduralTexture;
}(BABYLON.ProceduralTexture);
_defineProperty(BlendProceduralTexture, "FRAGMENT_SHADER", "zakeke_BlendProceduralTexture");
_defineProperty(BlendProceduralTexture, "CUSTOM_TYPE", "Zakeke.BlendProceduralTexture");
var shaderLines = ['precision mediump float;', 'varying vec2 vUV;', 'uniform sampler2D uSampler;', 'uniform sampler2D uBlendSampler;', 'uniform vec2 uSamplerScale;', 'uniform vec2 uBlendScale;', 'uniform bool hasSampler;', 'uniform bool hasBlend;', 'float BlendOverlayf(float base, float blend)', '{', '   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));', '}', 'vec4 BlendOverlay(vec4 base, vec4 blend)', '{', '   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));', '}', 'void main(void) {', '   if (!hasSampler && !hasBlend)', '   {', '       gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);', '       return;', '   }', '   if (hasSampler && !hasBlend)', '   {', '       gl_FragColor = texture2D(uSampler, vUV.xy*uSamplerScale);', '       return;', '   }', '   if (!hasSampler && hasBlend)', '   {', '       gl_FragColor = texture2D(uBlendSampler, vUV.xy*uBlendScale);', '       return;', '   }', '   vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);', '   vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);', '   gl_FragColor = BlendOverlay(base, blend);', '}'];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore["".concat(BlendProceduralTexture.FRAGMENT_SHADER, "PixelShader")] = shader;
BABYLON.RegisterClass("Zakeke.BlendProceduralTexture", BlendProceduralTexture);

/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts":
/*!****************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlurXProceduralTexture": () => (/* binding */ BlurXProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var BlurXProceduralTexture = /*#__PURE__*/function (_BaseProceduralTextur) {
  _inherits(BlurXProceduralTexture, _BaseProceduralTextur);
  var _super = _createSuper(BlurXProceduralTexture);
  function BlurXProceduralTexture(name, size, scene, baseTexture, fallbackTexture, generateMipMaps) {
    var _this;
    _classCallCheck(this, BlurXProceduralTexture);
    _this = _super.call(this, name, size, BlurXProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
    _defineProperty(_assertThisInitialized(_this), "_blur", 1 / 512);
    _this.updateShaderUniforms();
    return _this;
  }
  _createClass(BlurXProceduralTexture, [{
    key: "blur",
    get:
    //@BABYLON.serialize()
    function get() {
      return this._blur / (1 / 7000);
    },
    set: function set(value) {
      this._blur = 1 / 7000 * value;
      this.updateShaderUniforms();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(BlurXProceduralTexture.prototype), "dispose", this).call(this);
    }
  }, {
    key: "updateShaderUniforms",
    value: function updateShaderUniforms() {
      _get(_getPrototypeOf(BlurXProceduralTexture.prototype), "updateShaderUniforms", this).call(this);
      if (this.initializing) return;
      var blur = this._blur != undefined ? this._blur : 1 / 512;
      this.setFloat("blur", blur);
    }

    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
  }, {
    key: "render",
    value: function render(useCameraPostProcess) {
      _get(_getPrototypeOf(BlurXProceduralTexture.prototype), "render", this).call(this, useCameraPostProcess);
    }

    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
  }, {
    key: "resize",
    value: function resize(size, generateMipMaps) {
      _get(_getPrototypeOf(BlurXProceduralTexture.prototype), "resize", this).call(this, size, generateMipMaps);
      // We need to update the "size" uniform
      this.updateShaderUniforms();
    }

    //public serialize(): any {
    //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
    //    serializationObject.customType = BlurXProceduralTexture.CUSTOM_TYPE;
    //    return serializationObject;
    //}

    //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurXProceduralTexture {
    //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurXProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
    //    return texture;
    //}
  }]);
  return BlurXProceduralTexture;
}(_BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture);
_defineProperty(BlurXProceduralTexture, "FRAGMENT_SHADER", "zakeke_BlurXProceduralTexture");
_defineProperty(BlurXProceduralTexture, "CUSTOM_TYPE", "Zakeke.BlurXProceduralTexture");
var shaderLines = ['precision mediump float;', 'varying vec2 vUV;', 'varying vec4 vColor;', 'uniform float blur;', 'uniform sampler2D uSampler;', 'void main(void) {', '   vec4 sum = vec4(0.0);', '   sum += texture2D(uSampler, vec2(vUV.x - 4.0*blur, vUV.y)) * 0.05;', '   sum += texture2D(uSampler, vec2(vUV.x - 3.0*blur, vUV.y)) * 0.09;', '   sum += texture2D(uSampler, vec2(vUV.x - 2.0*blur, vUV.y)) * 0.12;', '   sum += texture2D(uSampler, vec2(vUV.x - blur, vUV.y)) * 0.15;', '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;', '   sum += texture2D(uSampler, vec2(vUV.x + blur, vUV.y)) * 0.15;', '   sum += texture2D(uSampler, vec2(vUV.x + 2.0*blur, vUV.y)) * 0.12;', '   sum += texture2D(uSampler, vec2(vUV.x + 3.0*blur, vUV.y)) * 0.09;', '   sum += texture2D(uSampler, vec2(vUV.x + 4.0*blur, vUV.y)) * 0.05;', '   gl_FragColor = sum;', '}'];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore["".concat(BlurXProceduralTexture.FRAGMENT_SHADER, "PixelShader")] = shader;

/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts":
/*!****************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlurYProceduralTexture": () => (/* binding */ BlurYProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var BlurYProceduralTexture = /*#__PURE__*/function (_BaseProceduralTextur) {
  _inherits(BlurYProceduralTexture, _BaseProceduralTextur);
  var _super = _createSuper(BlurYProceduralTexture);
  function BlurYProceduralTexture(name, size, scene, baseTexture, fallbackTexture, generateMipMaps) {
    var _this;
    _classCallCheck(this, BlurYProceduralTexture);
    _this = _super.call(this, name, size, BlurYProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
    _defineProperty(_assertThisInitialized(_this), "_blur", 1 / 512);
    _this.updateShaderUniforms();
    return _this;
  }
  _createClass(BlurYProceduralTexture, [{
    key: "blur",
    get: function get() {
      return this._blur / (1 / 7000);
    },
    set: function set(value) {
      this._blur = 1 / 7000 * value;
      this.updateShaderUniforms();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(BlurYProceduralTexture.prototype), "dispose", this).call(this);
    }
  }, {
    key: "updateShaderUniforms",
    value: function updateShaderUniforms() {
      _get(_getPrototypeOf(BlurYProceduralTexture.prototype), "updateShaderUniforms", this).call(this);
      if (this.initializing) return;
      var blur = this._blur != undefined ? this._blur : 1 / 512;
      this.setFloat("blur", blur);
    }

    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
  }, {
    key: "render",
    value: function render(useCameraPostProcess) {
      _get(_getPrototypeOf(BlurYProceduralTexture.prototype), "render", this).call(this, useCameraPostProcess);
    }

    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
  }, {
    key: "resize",
    value: function resize(size, generateMipMaps) {
      _get(_getPrototypeOf(BlurYProceduralTexture.prototype), "resize", this).call(this, size, generateMipMaps);
      // We need to update the "size" uniform
      this.updateShaderUniforms();
    }

    //public serialize(): any {
    //    var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
    //    serializationObject.customType = BlurYProceduralTexture.CUSTOM_TYPE;
    //    return serializationObject;
    //}

    //public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): BlurYProceduralTexture {
    //    var texture = BABYLON.SerializationHelper.Parse(() => new BlurYProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
    //    return texture;
    //}
  }]);
  return BlurYProceduralTexture;
}(_BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture);
_defineProperty(BlurYProceduralTexture, "FRAGMENT_SHADER", "zakeke_BlurYProceduralTexture");
_defineProperty(BlurYProceduralTexture, "CUSTOM_TYPE", "Zakeke.BlurYProceduralTexture");
var shaderLines = ['precision mediump float;', 'varying vec2 vUV;', 'varying vec4 vColor;', 'uniform float blur;', 'uniform sampler2D uSampler;', 'void main(void) {', '   vec4 sum = vec4(0.0);', '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 4.0*blur)) * 0.05;', '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 3.0*blur)) * 0.09;', '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 2.0*blur)) * 0.12;', '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - blur)) * 0.15;', '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;', '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + blur)) * 0.15;', '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 2.0*blur)) * 0.12;', '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 3.0*blur)) * 0.09;', '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 4.0*blur)) * 0.05;', '   gl_FragColor = sum;', '}'];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore["".concat(BlurYProceduralTexture.FRAGMENT_SHADER, "PixelShader")] = shader;

/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts":
/*!*******************************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ForegroundBackgroundProceduralTexture": () => (/* binding */ ForegroundBackgroundProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var ForegroundBackgroundProceduralTexture = /*#__PURE__*/function (_BaseProceduralTextur) {
  _inherits(ForegroundBackgroundProceduralTexture, _BaseProceduralTextur);
  var _super = _createSuper(ForegroundBackgroundProceduralTexture);
  function ForegroundBackgroundProceduralTexture(name, size, scene, baseTexture, fallbackTexture, generateMipMaps) {
    var _this;
    _classCallCheck(this, ForegroundBackgroundProceduralTexture);
    _this = _super.call(this, name, size, ForegroundBackgroundProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
    _defineProperty(_assertThisInitialized(_this), "_foreColor", new BABYLON.Vector3(1, 1, 1));
    _defineProperty(_assertThisInitialized(_this), "_backColor", new BABYLON.Vector3(0, 0, 0));
    _this.updateShaderUniforms();
    return _this;
  }
  _createClass(ForegroundBackgroundProceduralTexture, [{
    key: "foreColor",
    get:
    //@BABYLON.serializeAsVector3()
    function get() {
      return this._foreColor;
    },
    set: function set(value) {
      this._foreColor = value;
      this.updateShaderUniforms();
    }

    //@BABYLON.serializeAsVector3()
  }, {
    key: "backColor",
    get: function get() {
      return this._backColor;
    },
    set: function set(value) {
      this._backColor = value;
      this.updateShaderUniforms();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ForegroundBackgroundProceduralTexture.prototype), "dispose", this).call(this);
    }
  }, {
    key: "updateShaderUniforms",
    value: function updateShaderUniforms() {
      _get(_getPrototypeOf(ForegroundBackgroundProceduralTexture.prototype), "updateShaderUniforms", this).call(this);
      if (this.initializing) return;
      var foreColor = this._foreColor || new BABYLON.Vector3(1, 1, 1);
      var backColor = this._backColor || new BABYLON.Vector3(0, 0, 0);
      this.setVector3("foreColor", foreColor);
      this.setVector3("backColor", backColor);
    }

    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
  }, {
    key: "render",
    value: function render(useCameraPostProcess) {
      _get(_getPrototypeOf(ForegroundBackgroundProceduralTexture.prototype), "render", this).call(this, useCameraPostProcess);
    }

    /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  }, {
    key: "resize",
    value: function resize(size, generateMipMaps) {
      _get(_getPrototypeOf(ForegroundBackgroundProceduralTexture.prototype), "resize", this).call(this, size, generateMipMaps);
      // We need to update the "size" uniform
      this.updateShaderUniforms();
    }

    /*
    public serialize(): any {
        var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
        serializationObject.customType = ForegroundBackgroundProceduralTexture.CUSTOM_TYPE;
        return serializationObject;
    }
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): ForegroundBackgroundProceduralTexture {
        var texture = BABYLON.SerializationHelper.Parse(() => new ForegroundBackgroundProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
        return texture;
    }
    */
  }]);
  return ForegroundBackgroundProceduralTexture;
}(_BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture);
_defineProperty(ForegroundBackgroundProceduralTexture, "FRAGMENT_SHADER", "zakeke_ForegroundBackgroundProceduralTexture");
_defineProperty(ForegroundBackgroundProceduralTexture, "CUSTOM_TYPE", "Zakeke.ForegroundBackgroundProceduralTexture");
var shaderLines = ['precision mediump float;', 'varying vec2 vUV;', 'uniform sampler2D uSampler;', 'uniform vec3 foreColor;', 'uniform vec3 backColor;', 'void main(void) {', '   // background color', '   vec4 background = vec4(backColor.xyz, 1);', '   vec4 foreground = vec4(foreColor.xyz, 1);', '   // texel', '	vec4 t0 = texture2D(uSampler, vUV.xy);', '   // change in white', '   t0 = vec4(foreground.xyz, t0.a);', '   gl_FragColor = mix(background, t0, t0.a);', '}'];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore["".concat(ForegroundBackgroundProceduralTexture.FRAGMENT_SHADER, "PixelShader")] = shader;

/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/MoveProceduralTexture.ts":
/*!***************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/MoveProceduralTexture.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MoveProceduralTexture": () => (/* binding */ MoveProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var MoveProceduralTexture = /*#__PURE__*/function (_BaseProceduralTextur) {
  _inherits(MoveProceduralTexture, _BaseProceduralTextur);
  var _super = _createSuper(MoveProceduralTexture);
  function MoveProceduralTexture(name, size, scene, baseTexture, fallbackTexture, generateMipMaps) {
    var _this;
    _classCallCheck(this, MoveProceduralTexture);
    _this = _super.call(this, name, size, MoveProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
    _defineProperty(_assertThisInitialized(_this), "_offset", new BABYLON.Vector2(0, 0));
    _this.updateShaderUniforms();
    return _this;
  }
  _createClass(MoveProceduralTexture, [{
    key: "offset",
    get:
    //@BABYLON.serializeAsVector2()
    function get() {
      return this._offset;
    },
    set: function set(value) {
      this._offset = value;
      this.updateShaderUniforms();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(MoveProceduralTexture.prototype), "dispose", this).call(this);
    }
  }, {
    key: "updateShaderUniforms",
    value: function updateShaderUniforms() {
      _get(_getPrototypeOf(MoveProceduralTexture.prototype), "updateShaderUniforms", this).call(this);
      if (this.initializing) return;
      var size = this.getRenderSize();
      var offset = this._offset || new BABYLON.Vector2();
      this.setVector2("offset", new BABYLON.Vector2(offset.x / size, offset.y / size));
    }

    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
  }, {
    key: "render",
    value: function render(useCameraPostProcess) {
      _get(_getPrototypeOf(MoveProceduralTexture.prototype), "render", this).call(this, useCameraPostProcess);
    }

    /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
  }, {
    key: "resize",
    value: function resize(size, generateMipMaps) {
      _get(_getPrototypeOf(MoveProceduralTexture.prototype), "resize", this).call(this, size, generateMipMaps);
      // We need to update the "size" uniform
      this.updateShaderUniforms();
    }

    /*
    public serialize(): any {
        var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
        serializationObject.customType = MoveProceduralTexture.CUSTOM_TYPE;
        return serializationObject;
    }
      public static Parse(parsedTexture: any, scene: BABYLON.Scene, rootUrl: string): MoveProceduralTexture {
        var texture = BABYLON.SerializationHelper.Parse(() => new MoveProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
        return texture;
    }
    */
  }]);
  return MoveProceduralTexture;
}(_BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture);
_defineProperty(MoveProceduralTexture, "FRAGMENT_SHADER", "zakeke_MoveProceduralTexture");
_defineProperty(MoveProceduralTexture, "CUSTOM_TYPE", "Zakeke.MoveProceduralTexture");
var shaderLines = ['precision mediump float;', 'varying vec2 vUV;', 'uniform sampler2D uSampler;', 'uniform vec2 offset;', 'void main(void) {', '   // translated texel', '   gl_FragColor = texture2D(uSampler, vec2(vUV.x - offset.x, vUV.y + offset.y));',
//'   gl_FragColor = texture2D(uSampler, vUV.xy - offset);',
'}'];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore["".concat(MoveProceduralTexture.FRAGMENT_SHADER, "PixelShader")] = shader;

/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/MultiplyProceduralTexture.ts":
/*!*******************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/MultiplyProceduralTexture.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MultiplyProceduralTexture": () => (/* binding */ MultiplyProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var MultiplyProceduralTexture = /*#__PURE__*/function (_BaseProceduralTextur) {
  _inherits(MultiplyProceduralTexture, _BaseProceduralTextur);
  var _super = _createSuper(MultiplyProceduralTexture);
  function MultiplyProceduralTexture(name, size, scene, baseTexture, blendTexture, fallbackTexture, generateMipMaps) {
    var _this;
    _classCallCheck(this, MultiplyProceduralTexture);
    _this = _super.call(this, name, size, MultiplyProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
    _this._blendTexture = blendTexture;
    _this.updateShaderUniforms();
    return _this;
  }
  _createClass(MultiplyProceduralTexture, [{
    key: "blendTexture",
    get:
    //@BABYLON.serializeAsTexture()
    function get() {
      return this._blendTexture;
    },
    set: function set(texture) {
      this._blendTexture = texture;
      this.updateShaderUniforms();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(MultiplyProceduralTexture.prototype), "dispose", this).call(this);
      if (this._blendTexture) this._blendTexture.dispose();
    }
  }, {
    key: "updateShaderUniforms",
    value: function updateShaderUniforms() {
      _get(_getPrototypeOf(MultiplyProceduralTexture.prototype), "updateShaderUniforms", this).call(this);
      if (this.initializing) return;
      var baseScale = new BABYLON.Vector2(1, 1);
      if (this.baseTexture) baseScale = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale);
      this.setVector2("uSamplerScale", baseScale);
      this.setTexture("uBlendSampler", this._blendTexture);
      var blendScale = new BABYLON.Vector2(1, 1);
      if (this._blendTexture) blendScale = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale);
      this.setVector2("uBlendScale", blendScale);
    }

    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
  }, {
    key: "render",
    value: function render(useCameraPostProcess) {
      _get(_getPrototypeOf(MultiplyProceduralTexture.prototype), "render", this).call(this, useCameraPostProcess);
    }

    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
  }, {
    key: "resize",
    value: function resize(size, generateMipMaps) {
      _get(_getPrototypeOf(MultiplyProceduralTexture.prototype), "resize", this).call(this, size, generateMipMaps);
      // We need to update the "size" uniform
      this.updateShaderUniforms();
    }
  }]);
  return MultiplyProceduralTexture;
}(_BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture);
_defineProperty(MultiplyProceduralTexture, "FRAGMENT_SHADER", "zakeke_MultiplyProceduralTexture");
_defineProperty(MultiplyProceduralTexture, "CUSTOM_TYPE", "Zakeke.MultiplyProceduralTexture");
var shaderLines = ['precision mediump float;', 'varying vec2 vUV;', 'uniform sampler2D uSampler;', 'uniform sampler2D uBlendSampler;', 'uniform vec2 uSamplerScale;', 'uniform vec2 uBlendScale;', 'void main(void) {', '	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);', '	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);', '   gl_FragColor = base * blend;', '}'];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore["".concat(MultiplyProceduralTexture.FRAGMENT_SHADER, "PixelShader")] = shader;

/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/NormalMapProceduralTexture.ts":
/*!********************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/NormalMapProceduralTexture.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NormalMapProceduralTexture": () => (/* binding */ NormalMapProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var NormalMapProceduralTexture = /*#__PURE__*/function (_BaseProceduralTextur) {
  _inherits(NormalMapProceduralTexture, _BaseProceduralTextur);
  var _super = _createSuper(NormalMapProceduralTexture);
  function NormalMapProceduralTexture(name, size, scene, baseTexture, fallbackTexture, generateMipMaps) {
    var _this;
    _classCallCheck(this, NormalMapProceduralTexture);
    _this = _super.call(this, name, size, NormalMapProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
    _defineProperty(_assertThisInitialized(_this), "_bias", 50.0);
    _defineProperty(_assertThisInitialized(_this), "_invertR", false);
    _defineProperty(_assertThisInitialized(_this), "_invertG", false);
    _defineProperty(_assertThisInitialized(_this), "_bevel", false);
    _defineProperty(_assertThisInitialized(_this), "_intensity", 0.5);
    _this.updateShaderUniforms();
    return _this;
  }
  _createClass(NormalMapProceduralTexture, [{
    key: "bias",
    get: function get() {
      if (this._bias == undefined) return 50.0;
      return this._bias;
    },
    set: function set(value) {
      this._bias = value;
      this.updateShaderUniforms();
    }
  }, {
    key: "invertR",
    get: function get() {
      if (this._invertR == undefined) return false;
      return this._invertR;
    },
    set: function set(value) {
      this._invertR = value;
      this.updateShaderUniforms();
    }
  }, {
    key: "invertG",
    get: function get() {
      if (this._invertG == undefined) return false;
      return this._invertG;
    },
    set: function set(value) {
      this._invertG = value;
      this.updateShaderUniforms();
    }
  }, {
    key: "bevel",
    get: function get() {
      if (this._bevel == undefined) return false;
      return this._bevel;
    },
    set: function set(value) {
      this._bevel = value;
      this.updateShaderUniforms();
    }
  }, {
    key: "intensity",
    get: function get() {
      if (this._intensity == undefined) return 0.5;
      return this._intensity;
    },
    set: function set(value) {
      this._intensity = value;
      this.updateShaderUniforms();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(NormalMapProceduralTexture.prototype), "dispose", this).call(this);
    }
  }, {
    key: "updateShaderUniforms",
    value: function updateShaderUniforms() {
      _get(_getPrototypeOf(NormalMapProceduralTexture.prototype), "updateShaderUniforms", this).call(this);
      if (this.initializing) return;
      var size = this.getRenderSize();
      var dim = size < 1024 ? size * 2 : size;
      this.setFloat("size", size);
      this.setVector2("u_textureSize", new BABYLON.Vector2(size, size));
      this.setVector3("dimensions", new BABYLON.Vector3(dim, dim, 0));
      this.setFloat("bias", this.bias);
      this.setFloat("invertR", this.invertR ? -1.0 : 1.0);
      this.setFloat("invertG", this.invertG ? -1.0 : 1.0);
      this.setFloat("bevel", this.bevel ? 1.0 : 0.0);
      this.setFloat("intensity", this.intensity);
    }

    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
  }, {
    key: "render",
    value: function render(useCameraPostProcess) {
      _get(_getPrototypeOf(NormalMapProceduralTexture.prototype), "render", this).call(this, useCameraPostProcess);
    }

    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
  }, {
    key: "resize",
    value: function resize(size, generateMipMaps) {
      _get(_getPrototypeOf(NormalMapProceduralTexture.prototype), "resize", this).call(this, size, generateMipMaps);
      // We need to update the "size" uniform
      this.updateShaderUniforms();
    }
  }]);
  return NormalMapProceduralTexture;
}(_BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture);
_defineProperty(NormalMapProceduralTexture, "FRAGMENT_SHADER", "zakeke_normalMapProceduralTexture");
_defineProperty(NormalMapProceduralTexture, "CUSTOM_TYPE", "Zakeke.NormalMapProceduralTexture");
var shaderLines = ['precision mediump float;', 'varying vec2 vUV;', 'uniform vec3 dimensions;', 'uniform sampler2D uSampler;', 'uniform vec2 u_textureSize;', 'uniform float bias;', 'uniform float invertR;', 'uniform float invertG;', 'uniform float bevel;', 'uniform float intensity;', 'void main(void) {', '   vec2 step = vec2(1.0, 1.0) / dimensions.xy;', '   vec4 black = vec4(0, 0, 0, 1);', '	vec4 bk = vec4(1, 1, 1, 1);', '	vec4 t0 = texture2D(uSampler, vUV.xy + vec2(0.0, 0.0));', '	vec4 t1 = texture2D(uSampler, vUV.xy + vec2(step.x, 0.0));', '	vec4 t2 = texture2D(uSampler, vUV.xy + vec2(-step.x, 0.0));', '	vec4 t3 = texture2D(uSampler, vUV.xy + vec2(0.0, step.y));', '	vec4 t4 = texture2D(uSampler, vUV.xy + vec2(0.0, -step.y));', '   if (bevel != 0.0) ', '   {', '      t0 = vec4(0, 0, 0, t0.a);', '      t1 = vec4(0, 0, 0, t1.a);', '      t2 = vec4(0, 0, 0, t2.a);', '      t3 = vec4(0, 0, 0, t3.a);', '      t4 = vec4(0, 0, 0, t4.a);', '   }', '	t0 = mix(bk, t0, t0.a);', '	t1 = mix(bk, t1, t1.a);', '	t2 = mix(bk, t2, t2.a);', '	t3 = mix(bk, t3, t3.a);', '	t4 = mix(bk, t4, t4.a);', '	float d0 = abs(t0.r);', '	float d1 = abs(t1.r);', '	float d2 = abs(t2.r);', '	float d3 = abs(t3.r);', '	float d4 = abs(t4.r);', '	float dx = ((d2 - d0) + (d0 - d1)) * intensity;', '	float dy = ((d4 - d0) + (d0 - d3)) * intensity;', '	vec4 normal = vec4(normalize(vec3(dx * invertR, dy * invertG, 1.0 - ((bias - 0.1) / 100.0))), 1.0);', '	gl_FragColor = vec4(normal.xyz * 0.5 + 0.5, 1.0);', '}'];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore["".concat(NormalMapProceduralTexture.FRAGMENT_SHADER, "PixelShader")] = shader;

/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/OpacityProceduralTexture.ts":
/*!******************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/OpacityProceduralTexture.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OpacityProceduralTexture": () => (/* binding */ OpacityProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var OpacityProceduralTexture = /*#__PURE__*/function (_BaseProceduralTextur) {
  _inherits(OpacityProceduralTexture, _BaseProceduralTextur);
  var _super = _createSuper(OpacityProceduralTexture);
  function OpacityProceduralTexture(name, size, scene, baseTexture, blendTexture, fallbackTexture, generateMipMaps) {
    var _this;
    _classCallCheck(this, OpacityProceduralTexture);
    _this = _super.call(this, name, size, OpacityProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
    _defineProperty(_assertThisInitialized(_this), "_opacity", 1.0);
    _this.updateShaderUniforms();
    return _this;
  }
  _createClass(OpacityProceduralTexture, [{
    key: "opacity",
    get: function get() {
      if (this._opacity == undefined) return 1.0;
      return this._opacity;
    },
    set: function set(value) {
      this._opacity = value;
      this.updateShaderUniforms();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(OpacityProceduralTexture.prototype), "dispose", this).call(this);
    }
  }, {
    key: "updateShaderUniforms",
    value: function updateShaderUniforms() {
      _get(_getPrototypeOf(OpacityProceduralTexture.prototype), "updateShaderUniforms", this).call(this);
      if (this.initializing) return;
      this.setFloat("opacity", this.opacity);
    }

    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
  }, {
    key: "render",
    value: function render(useCameraPostProcess) {
      _get(_getPrototypeOf(OpacityProceduralTexture.prototype), "render", this).call(this, useCameraPostProcess);
    }

    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
  }, {
    key: "resize",
    value: function resize(size, generateMipMaps) {
      _get(_getPrototypeOf(OpacityProceduralTexture.prototype), "resize", this).call(this, size, generateMipMaps);
      // We need to update the "size" uniform
      this.updateShaderUniforms();
    }
  }]);
  return OpacityProceduralTexture;
}(_BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture);
_defineProperty(OpacityProceduralTexture, "FRAGMENT_SHADER", "zakeke_OpacityProceduralTexture");
_defineProperty(OpacityProceduralTexture, "CUSTOM_TYPE", "Zakeke.OpacityProceduralTexture");
var shaderLines = ['precision mediump float;', 'varying vec2 vUV;', 'uniform sampler2D uSampler;', 'uniform float opacity;', 'void main(void) {', '	vec4 color = texture2D(uSampler, vUV.xy);', '   color.a = opacity;', '   gl_FragColor = color;', '}'];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore["".concat(OpacityProceduralTexture.FRAGMENT_SHADER, "PixelShader")] = shader;

/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/OverlayProceduralTexture.ts":
/*!******************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/OverlayProceduralTexture.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OverlayProceduralTexture": () => (/* binding */ OverlayProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var OverlayProceduralTexture = /*#__PURE__*/function (_BaseProceduralTextur) {
  _inherits(OverlayProceduralTexture, _BaseProceduralTextur);
  var _super = _createSuper(OverlayProceduralTexture);
  function OverlayProceduralTexture(name, size, scene, baseTexture, blendTexture, fallbackTexture, generateMipMaps) {
    var _this;
    _classCallCheck(this, OverlayProceduralTexture);
    _this = _super.call(this, name, size, OverlayProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
    _this._blendTexture = blendTexture;
    _this.updateShaderUniforms();
    return _this;
  }
  _createClass(OverlayProceduralTexture, [{
    key: "blendTexture",
    get:
    //@BABYLON.serializeAsTexture()
    function get() {
      return this._blendTexture;
    },
    set: function set(texture) {
      this._blendTexture = texture;
      this.updateShaderUniforms();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(OverlayProceduralTexture.prototype), "dispose", this).call(this);
      if (this._blendTexture) this._blendTexture.dispose();
    }
  }, {
    key: "updateShaderUniforms",
    value: function updateShaderUniforms() {
      _get(_getPrototypeOf(OverlayProceduralTexture.prototype), "updateShaderUniforms", this).call(this);
      if (this.initializing) return;
      var baseScale = new BABYLON.Vector2(1, 1);
      if (this.baseTexture) baseScale = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale);
      this.setVector2("uSamplerScale", baseScale);
      this.setTexture("uBlendSampler", this._blendTexture);
      var blendScale = new BABYLON.Vector2(1, 1);
      if (this._blendTexture) blendScale = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale);
      this.setVector2("uBlendScale", blendScale);
    }

    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
  }, {
    key: "render",
    value: function render(useCameraPostProcess) {
      _get(_getPrototypeOf(OverlayProceduralTexture.prototype), "render", this).call(this, useCameraPostProcess);
    }

    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
  }, {
    key: "resize",
    value: function resize(size, generateMipMaps) {
      _get(_getPrototypeOf(OverlayProceduralTexture.prototype), "resize", this).call(this, size, generateMipMaps);
      // We need to update the "size" uniform
      this.updateShaderUniforms();
    }
  }]);
  return OverlayProceduralTexture;
}(_BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture);
_defineProperty(OverlayProceduralTexture, "FRAGMENT_SHADER", "zakeke_OverlayProceduralTexture");
_defineProperty(OverlayProceduralTexture, "CUSTOM_TYPE", "Zakeke.OverlayProceduralTexture");
var shaderLines = ['precision mediump float;', 'varying vec2 vUV;', 'uniform sampler2D uSampler;', 'uniform sampler2D uBlendSampler;', 'uniform vec2 uSamplerScale;', 'uniform vec2 uBlendScale;', 'float BlendOverlayf(float base, float blend)', '{', '   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));', '}', 'vec4 BlendOverlay(vec4 base, vec4 blend)', '{', '   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));', '}', 'void main(void) {', '	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);', '	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);', '   gl_FragColor = BlendOverlay(base, blend);', '}'];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore["".concat(OverlayProceduralTexture.FRAGMENT_SHADER, "PixelShader")] = shader;

/***/ }),

/***/ "../../3D/src/Components/SceneHelper.ts":
/*!**********************************************!*\
  !*** ../../3D/src/Components/SceneHelper.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SceneHelper": () => (/* binding */ SceneHelper)
/* harmony export */ });
/* harmony import */ var _gltf_transform_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @gltf-transform/core */ "../../../node_modules/@gltf-transform/core/dist/core.modern.js");
/* harmony import */ var _zakeke_zakeke_resizable_canvas__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @zakeke/zakeke-resizable-canvas */ "../../../node_modules/@zakeke/zakeke-resizable-canvas/dist/index.js");
/* harmony import */ var _composer_Components_ChunkedTask__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../composer/Components/ChunkedTask */ "../Components/ChunkedTask.ts");
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
/* harmony import */ var _Misc_StringTools__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Misc/StringTools */ "../../3D/src/Misc/StringTools.ts");
/* harmony import */ var _MeshExpander_MeshExpander__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./MeshExpander/MeshExpander */ "../../3D/src/Components/MeshExpander/MeshExpander.ts");
/* harmony import */ var _USDZ_UsdzHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./USDZ/UsdzHelper */ "../../3D/src/Components/USDZ/UsdzHelper.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }







var SceneHelper = /*#__PURE__*/function () {
  function SceneHelper(scene) {
    _classCallCheck(this, SceneHelper);
    _defineProperty(this, "_hemiLight", null);
    _defineProperty(this, "_pointLight", null);
    _defineProperty(this, "_onPrePointerObservableObserver", null);
    _defineProperty(this, "_isPointerDown", false);
    _defineProperty(this, "_radiusScale", 0.85);
    _defineProperty(this, "_positionScale", 0.5);
    _defineProperty(this, "_limitLowerRadius", true);
    _defineProperty(this, "_zoomEnabled", true);
    _defineProperty(this, "_minZoomPerc", null);
    _defineProperty(this, "_maxZoomPerc", null);
    _defineProperty(this, "_cameraPivot", null);
    _defineProperty(this, "_resizableCanvas3DGenerator", new _zakeke_zakeke_resizable_canvas__WEBPACK_IMPORTED_MODULE_0__.Preview3DGenerator());
    _defineProperty(this, "_defHemiLightID", "f90aba65-3b60-44ac-87f4-1b6441aee44b");
    _defineProperty(this, "_defPointLightID", "b6491635-c471-45a4-bbb8-3f08556e5b3c");
    _defineProperty(this, "_targetAnimationID", "6225769c-0113-4236-ab17-c39d24013de4");
    _defineProperty(this, "_radiusAnimationID", "6f946c2f-af8d-46ab-9bea-9e22dedc4e9d");
    _defineProperty(this, "_alphaAnimationID", "10713520-fe06-4cbf-bc6a-bab881d516e6");
    _defineProperty(this, "_betaAnimationID", "6096ba34-852a-4423-bab3-dc97c1a9268f");
    _defineProperty(this, "_dummyMaterialID", "081796b8-0908-44dc-a38a-d786b14cA6fc");
    // Dictionary per i materiali in stati di caricamento
    _defineProperty(this, "_loadingMaterials", {});
    this._scene = scene;
    this._engine = scene.getEngine();
    this._camera = scene.activeCamera;
    this._canvas = scene.getEngine().getRenderingCanvas();
    this.init();
  }
  _createClass(SceneHelper, [{
    key: "camera",
    get: function get() {
      return this._camera;
    }
  }, {
    key: "materialRequiresDelayedLoading",
    value: function materialRequiresDelayedLoading(materialID) {
      var material = this._scene.getMaterialByID(materialID);
      if (material) return false;
      if (this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(materialID)) return true;
      if (this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(materialID)) return true;
      return false;
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;
      this._onPrePointerObservableObserver = this._scene.onPrePointerObservable.add(function (pointerInfoPre) {
        if (pointerInfoPre.type === BABYLON.PointerEventTypes.POINTERDOWN) {
          _this._isPointerDown = true;
          return;
        }
        if (pointerInfoPre.type === BABYLON.PointerEventTypes.POINTERUP) {
          _this._isPointerDown = false;
        }
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._scene && this._onPrePointerObservableObserver) {
        this._scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver);
      }
    }
  }, {
    key: "switchFullScreen",
    value: function switchFullScreen(parent) {
      if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
        this.quitFullscreen(parent ? parent : this._canvas);
      } else {
        this.launchFullscreen(parent ? parent : this._canvas);
      }
      if (this._canvas) {
        this._canvas.width = document.body.clientWidth; //document.width is obsolete
        this._canvas.height = document.body.clientHeight; //document.height is obsolete
        this.adjustCamera(undefined, true, true, false);
      }
    }
  }, {
    key: "quitFullscreen",
    value: function quitFullscreen(element) {
      var exitFullscreen = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen;
      if (exitFullscreen) exitFullscreen.call(document);
    }
  }, {
    key: "launchFullscreen",
    value: function launchFullscreen(element) {
      var requestFullScreen = element.requestFullscreen || element.webkitRequestFullscreen || element.msRequestFullscreen || element.mozRequestFullScreen;
      if (requestFullScreen) requestFullScreen.call(element);
    }
  }, {
    key: "getMeshHierarchySize",
    value: function getMeshHierarchySize(mesh) {
      var boundingBox = mesh.getHierarchyBoundingVectors(true);
      var size = boundingBox.max.subtract(boundingBox.min);
      return size;
    }
  }, {
    key: "getMeshHierarchyCenter",
    value: function getMeshHierarchyCenter(mesh) {
      var boundingBox = mesh.getHierarchyBoundingVectors(true);
      var size = boundingBox.max.subtract(boundingBox.min);
      var center = boundingBox.min.add(size.scale(0.5));
      return center;
    }
  }, {
    key: "getSceneBoundingInfo",
    value: function getSceneBoundingInfo() {
      if (!this._scene) return null;
      var worldExtends = this.getWorldExtends();
      if (worldExtends) return new BABYLON.BoundingInfo(worldExtends.min, worldExtends.max);
      return null;
    }
  }, {
    key: "userIsMoving",
    value: function userIsMoving() {
      if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera)) {
        return false;
      }
      return this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0 || this._isPointerDown;
    }
  }, {
    key: "cameraIsMoving",
    value: function cameraIsMoving() {
      if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera)) {
        return false;
      }
      return this._camera.inertialAlphaOffset !== 0 || this._camera.inertialBetaOffset !== 0 || this._camera.inertialRadiusOffset !== 0 || this._camera.inertialPanningX !== 0 || this._camera.inertialPanningY !== 0;
    }
  }, {
    key: "cameraLimitsReached",
    value: function cameraLimitsReached() {
      if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera)) {
        return false;
      }
      return this._camera.lowerRadiusLimit !== undefined && this._camera.lowerRadiusLimit !== null && this._camera.radius === this._camera.lowerRadiusLimit || this._camera.upperRadiusLimit !== undefined && this._camera.upperRadiusLimit !== null && this._camera.radius === this._camera.upperRadiusLimit;
    }
  }, {
    key: "restoreCameraState",
    value: function restoreCameraState() {
      if (this._camera) {
        this._camera.restoreState();
      }
    }
  }, {
    key: "isTextureWithUrl",
    value: function isTextureWithUrl(texture) {
      return texture && (texture instanceof BABYLON.Texture || texture instanceof BABYLON.CubeTexture || texture instanceof BABYLON.HDRCubeTexture || texture instanceof BABYLON.ColorGradingTexture || texture instanceof BABYLON.EquiRectangularCubeTexture);
    }
  }, {
    key: "getTextureUrl",
    value: function getTextureUrl(texture) {
      if (texture && (texture instanceof BABYLON.Texture || texture instanceof BABYLON.CubeTexture || texture instanceof BABYLON.HDRCubeTexture || texture instanceof BABYLON.ColorGradingTexture || texture instanceof BABYLON.EquiRectangularCubeTexture)) {
        var textureUrl = texture.url;
        if (texture.getInternalTexture) {
          var internalTexture = texture.getInternalTexture();
          if (internalTexture && internalTexture.url) {
            textureUrl = internalTexture.url;
          }
        }
        return textureUrl;
      }
      return null;
    }
  }, {
    key: "isEditControl",
    value: function isEditControl(mesh) {
      return mesh && (mesh.name == "EditoControl" || mesh.metadata && mesh.metadata.isEditControl);
    }
  }, {
    key: "isRealMesh",
    value: function isRealMesh(mesh) {
      return !(this.isEditControl(mesh) || mesh.metadata && (mesh.metadata.boundingBox || mesh.metadata.isAxis || mesh.metadata.isGround || mesh.metadata.isEnvironmentNode || mesh.metadata.hasOwnProperty("isRealMesh") && !mesh.metadata.isRealMesh));
    }
  }, {
    key: "meshHasParent",
    value: function meshHasParent(meshID, parentID) {
      if (this._scene) {
        var _mesh = this._scene.getMeshByID(meshID);
        if (_mesh) {
          while (_mesh.parent) {
            if (_mesh.parent.id === parentID) return true;
            _mesh = _mesh.parent;
          }
        }
      }
      return false;
    }
  }, {
    key: "countSceneMeshes",
    value: function countSceneMeshes() {
      var _this2 = this;
      var count = 0;
      if (this._scene) {
        this._scene.meshes.forEach(function (mesh) {
          if (_this2.isRealMesh(mesh)) count++;
        });
      }
      return count;
    }
  }, {
    key: "sceneHasRealMeshes",
    value: function sceneHasRealMeshes() {
      for (var i = 0; i < this._scene.meshes.length; i++) {
        if (this.isRealMesh(this._scene.meshes[i])) return true;
      }
      return false;
    }
  }, {
    key: "getSceneMeshes",
    value: function getSceneMeshes() {
      var _this3 = this;
      var meshes = [];
      if (this._scene) {
        this._scene.meshes.forEach(function (mesh) {
          if (_this3.isRealMesh(mesh)) meshes.push(mesh);
        });
      }
      return meshes;
    }
  }, {
    key: "getSceneMeshesByName",
    value: function getSceneMeshesByName(name) {
      var meshes = [];
      if (this._scene) {
        var escapeRegExp = function escapeRegExp(string) {
          return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
        };

        if (name) {
          var regExp = new RegExp(escapeRegExp(name).replace(/\\\*/g, ".*"), "i");
          for (var i = 0; i < this._scene.meshes.length; i++) {
            var _mesh2 = this._scene.meshes[i];
            if (this.isRealMesh(_mesh2) && _mesh2.name && regExp.test(_mesh2.name)) meshes.push(_mesh2);
          }
        }
      }
      return meshes;
    }
  }, {
    key: "getVisibleMeshes",
    value: function getVisibleMeshes() {
      var _this4 = this;
      var meshes = [];
      this._scene.meshes.forEach(function (mesh) {
        if (_this4.isRealMesh(mesh) && mesh.isVisible) meshes.push(mesh);
      });
      return meshes;
    }
  }, {
    key: "getInvisibleMeshes",
    value: function getInvisibleMeshes() {
      var _this5 = this;
      var meshes = [];
      this._scene.meshes.forEach(function (mesh) {
        if (_this5.isRealMesh(mesh) && !mesh.isVisible) meshes.push(mesh);
      });
      return meshes;
    }
  }, {
    key: "getSubMesh",
    value: function getSubMesh(mesh, submeshIdx) {
      if (mesh.subMeshes && mesh.subMeshes.length > 0 && submeshIdx >= 0 && submeshIdx < mesh.subMeshes.length) {
        return mesh.subMeshes[submeshIdx];
      }
      return null;
    }
  }, {
    key: "getMeshHierarchy",
    value: function getMeshHierarchy(parentID) {
      var meshes = [];
      var parent = this._scene.getMeshByID(parentID);
      if (!parent) return meshes;
      var addMesh = function addMesh(mesh) {
        meshes.push(mesh);
        var children = mesh.getChildMeshes();
        for (var i = 0; i < children.length; i++) addMesh(children[i]);
      };
      addMesh(parent);
      return meshes;
    }
  }, {
    key: "isCanvasMesh",
    value: function isCanvasMesh(mesh) {
      if (!mesh) return false;
      if (!mesh.metadata) return false;
      if (mesh.metadata.hasOwnProperty("iscanvasMesh") && typeof mesh.metadata.iscanvasMesh === "boolean") return mesh.metadata.iscanvasMesh;
      return false;
    }
  }, {
    key: "isAREnabledForMesh",
    value: function isAREnabledForMesh(mesh) {
      if (!mesh) return false;
      if (!mesh.metadata) return true;
      if (mesh.metadata.AR === undefined || mesh.metadata.AR === null || typeof mesh.metadata.AR !== "boolean") return true;
      return mesh.metadata.AR;
    }
  }, {
    key: "isTryOnEnabledForMesh",
    value: function isTryOnEnabledForMesh(mesh) {
      if (!mesh) return false;
      if (!mesh.metadata) return true;
      if (mesh.metadata.TryOn === undefined || mesh.metadata.TryOn === null || typeof mesh.metadata.TryOn !== "boolean") return true;
      return mesh.metadata.TryOn;
    }
  }, {
    key: "getMeshesForAR",
    value: function getMeshesForAR() {
      var _this6 = this;
      var meshes = [];
      if (this._scene) {
        this._scene.meshes.forEach(function (mesh) {
          if ((_this6.isRealMesh(mesh) || _this6.isCanvasMesh(mesh)) && mesh.isVisible && _this6.isAREnabledForMesh(mesh)) meshes.push(mesh);
        });
      }
      return meshes;
    }
  }, {
    key: "checkMaterialsForAR",
    value: function checkMaterialsForAR() {
      var materials = this.getMeshesMaterials(this.getMeshesForAR());
      for (var i = 0; i < materials.length; i++) {
        var material = materials[i];
        if (!(material instanceof BABYLON.PBRMaterial) && !(material instanceof BABYLON.PBRMetallicRoughnessMaterial) && !(material instanceof BABYLON.StandardMaterial)) return false;
      }
      return true;
    }
  }, {
    key: "getMeshesMaterials",
    value: function getMeshesMaterials(meshes) {
      var ids = [];
      var materials = [];
      for (var i = 0; i < meshes.length; i++) {
        var _mesh3 = meshes[i];
        if (_mesh3.material) {
          if (_mesh3.material instanceof BABYLON.MultiMaterial) {
            for (var k = 0; k < _mesh3.material.subMaterials.length; k++) {
              var subMaterial = _mesh3.material.subMaterials[k];
              if (subMaterial && ids.indexOf(subMaterial.id) === -1) {
                materials.push(subMaterial);
                ids.push(subMaterial.id);
              }
            }
          } else {
            if (ids.indexOf(_mesh3.material.id) === -1) {
              materials.push(_mesh3.material);
              ids.push(_mesh3.material.id);
            }
          }
        }
      }
      return materials;
    }
  }, {
    key: "getMeshMaterials",
    value: function getMeshMaterials(mesh) {
      var materials = [];
      if (mesh && mesh.material) {
        if (mesh.material instanceof BABYLON.MultiMaterial) {
          for (var k = 0; k < mesh.material.subMaterials.length; k++) {
            var subMaterial = mesh.material.subMaterials[k];
            if (subMaterial) materials.push(subMaterial);
          }
        } else {
          materials.push(mesh.material);
        }
      }
      return materials;
    }
  }, {
    key: "getHiddenMeshTotalVertices",
    value: function getHiddenMeshTotalVertices() {
      return this.getTotalVertices(function (mesh) {
        return !mesh.isVisible;
      });
    }
  }, {
    key: "getTotalVertices",
    value: function getTotalVertices(predicate) {
      var _this7 = this;
      var tot = 0;
      if (this._scene) {
        this._scene.meshes.forEach(function (mesh) {
          if (!_this7.isRealMesh(mesh)) return;
          if (predicate && !predicate(mesh)) return;
          tot += mesh.getTotalVertices();
        });
      }
      return tot;
    }
  }, {
    key: "getHiddenMeshTotalIndices",
    value: function getHiddenMeshTotalIndices() {
      return this.getTotalIndices(function (mesh) {
        return !mesh.isVisible;
      });
    }
  }, {
    key: "getTotalIndices",
    value: function getTotalIndices(predicate) {
      var _this8 = this;
      var tot = 0;
      if (this._scene) {
        this._scene.meshes.forEach(function (mesh) {
          if (!_this8.isRealMesh(mesh)) return;
          if (predicate && !predicate(mesh)) return;
          tot += mesh.getTotalIndices();
        });
      }
      return tot;
    }
  }, {
    key: "getAllMaterials",
    value: function getAllMaterials() {
      var materials = [];
      if (this._scene) {
        this._scene.materials.forEach(function (material) {
          if (material.metadata) {
            if (material.metadata.isRealMaterial !== undefined && !material.metadata.isRealMaterial) return;
            if (material.metadata.isEnvironmentNode !== undefined && material.metadata.isEnvironmentNode) return;
          }
          if (material.id === "groundMaterial") return;
          if (material.id === "default material") return;
          materials.push(material);
        });
      }
      return materials;
    }
  }, {
    key: "getMeshesUsingMaterial",
    value: function getMeshesUsingMaterial(materialID) {
      var meshes = [];
      var allMeshes = this.getSceneMeshes();
      for (var i = 0; i < allMeshes.length; i++) {
        var _mesh4 = allMeshes[i];
        if (this.isMeshUsingMaterial(_mesh4, materialID)) meshes.push(_mesh4);
      }
      return meshes;
    }
  }, {
    key: "isMeshUsingMaterial",
    value: function isMeshUsingMaterial(mesh, materialID) {
      if (mesh.material) {
        if (mesh.material.id === materialID) {
          return true;
        } else if (mesh.material instanceof BABYLON.MultiMaterial) {
          for (var k = 0; k < mesh.material.subMaterials.length; k++) {
            var subMaterial = mesh.material.subMaterials[k];
            if (subMaterial && subMaterial.id === materialID) {
              return true;
            }
          }
        }
      }
      return false;
    }
  }, {
    key: "getAllUnusedMaterials",
    value: function getAllUnusedMaterials() {
      var materials = this.getAllMaterials();
      var unusedMaterials = [];
      for (var i = 0; i < materials.length; i++) {
        var material = materials[i];
        var meshes = this.getMeshesUsingMaterial(material.id);
        if (meshes.length === 0) unusedMaterials.push(material);
      }
      return unusedMaterials;
    }
  }, {
    key: "getSceneScreenshotAsync",
    value: function () {
      var _getSceneScreenshotAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(width, height) {
        var size;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this._camera) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", "");
            case 2:
              size = {
                width: width,
                height: height
              };
              _context.next = 5;
              return BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, size, "image/png");
            case 5:
              return _context.abrupt("return", _context.sent);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getSceneScreenshotAsync(_x, _x2) {
        return _getSceneScreenshotAsync.apply(this, arguments);
      }
      return getSceneScreenshotAsync;
    }()
  }, {
    key: "containsPBRMaterials",
    value: function containsPBRMaterials() {
      if (this._scene) {
        for (var i = 0; i < this._scene.materials.length; i++) {
          var material = this._scene.materials[i];
          if (material instanceof BABYLON.PBRBaseMaterial) return true;
        }
      }
      return false;
    }
  }, {
    key: "getMeshesForTryOn",
    value: function getMeshesForTryOn() {
      var _this9 = this;
      var meshes = [];
      if (this._scene) {
        this._scene.meshes.forEach(function (mesh) {
          if ((_this9.isRealMesh(mesh) || _this9.isCanvasMesh(mesh)) && mesh.isVisible && _this9.isTryOnEnabledForMesh(mesh)) {
            meshes.push(mesh);
          }
        });
      }
      return meshes;
    }
  }, {
    key: "setupLights",
    value: function setupLights() {
      var _this10 = this;
      this._hemiLight = null;
      this._pointLight = null;
      var firstHemiLight = null;
      var firstPointLight = null;
      this._scene.lights.forEach(function (light) {
        if (light instanceof BABYLON.HemisphericLight) {
          if (firstHemiLight === null) firstHemiLight = light;
          if (light.id === _this10._defHemiLightID) _this10._hemiLight = light;
        }
        if (light instanceof BABYLON.PointLight) {
          if (firstPointLight === null) firstPointLight = light;
          if (light.id === _this10._defPointLightID) _this10._pointLight = light;
        }
      });
      if (this._hemiLight === null) {
        if (firstHemiLight !== null) {
          this._hemiLight = firstHemiLight;
        } else {
          this._hemiLight = new BABYLON.HemisphericLight('Default Hemispheric Light', BABYLON.Vector3.Up(), this._scene);
          this._hemiLight.intensity = 0.5;
        }
        if (this._hemiLight) this._hemiLight.id = this._defHemiLightID;
      }
      if (this._pointLight === null) {
        if (firstPointLight !== null) {
          this._pointLight = firstPointLight;
        } else {
          this._pointLight = new BABYLON.PointLight("Default Point Light", new BABYLON.Vector3(0, 5, 0), this._scene);
          this._pointLight.intensity = 0.5;
        }
        if (this._pointLight) this._pointLight.id = this._defPointLightID;
      }
    }
  }, {
    key: "getDefaultHemisphericLight",
    value: function getDefaultHemisphericLight() {
      return this._hemiLight;
    }
  }, {
    key: "getDefaultPointLight",
    value: function getDefaultPointLight() {
      return this._pointLight;
    }
  }, {
    key: "isDefaultLight",
    value: function isDefaultLight(light) {
      return light.id == this._defHemiLightID || light.id == this._defPointLightID;
    }
  }, {
    key: "setupCamera",
    value: function setupCamera() {
      if (this._scene) {
        var sceneCamera = this._scene.cameras.find(function (c) {
          return c instanceof BABYLON.ArcRotateCamera;
        });
        if (!sceneCamera) {
          this._camera = new BABYLON.ArcRotateCamera("camera1", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene);
          this._camera.setPosition(new BABYLON.Vector3(0, 3, -8));
        } else {
          this._camera = sceneCamera;
        }
        this.setupCameraLimits();
        if (this._canvas) this._camera.attachControl(this._canvas, false);
      }
    }
  }, {
    key: "setCameraRadiusParameters",
    value: function setCameraRadiusParameters(radius) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        this._camera.lowerRadiusLimit = radius * (this._zoomEnabled ? 0.01 : 1);
        this._camera.upperRadiusLimit = radius * (this._zoomEnabled ? 3 : 1);
        this._camera.wheelPrecision = 100 / radius;
        this._camera.pinchPrecision = 100 / radius;
        this._camera.minZ = radius * 0.01;
        this._camera.maxZ = radius * 1000;
        this._camera.speed = radius * 0.2;
        this._camera.wheelDeltaPercentage = 0.01;
        this._camera.pinchDeltaPercentage = 0.0006;
        this._camera.panningSensibility = 0.000001;
        this._camera.wheelPrecision = 100 / radius;
        this._camera.panningAxis = BABYLON.Vector3.Zero(); // elimino il panning del tutto
        this._camera.panningInertia = 0;
      }
    }
  }, {
    key: "removeCameraLimits",
    value: function removeCameraLimits() {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        this._camera.lowerRadiusLimit = null;
        this._camera.upperRadiusLimit = null;
        this._camera.minZ = 1;
        this._camera.maxZ = 10000.0;
      }
    }
  }, {
    key: "getWorldExtends",
    value: function getWorldExtends() {
      var _this11 = this;
      if (this._scene) return this._scene.getWorldExtends(function (mesh) {
        return _this11.isRealMesh(mesh) && mesh.isVisible;
      });
      return null;
    }
  }, {
    key: "getCameraWorldExtends",
    value: function getCameraWorldExtends() {
      var _this12 = this;
      var worldExtends = null;
      if (this._scene) {
        var pivotMesh = this._cameraPivot;
        if (!pivotMesh) {
          for (var i = 0; i < this._scene.meshes.length; i++) {
            var _mesh5 = this._scene.meshes[i];
            if (_mesh5.metadata && _mesh5.metadata.isCameraPivot !== undefined && _mesh5.metadata.isCameraPivot) {
              pivotMesh = _mesh5;
              break;
            }
          }
        }
        if (pivotMesh) {
          worldExtends = this._scene.getWorldExtends(function (mesh) {
            return mesh === pivotMesh || _this12.meshHasParent(mesh.id, pivotMesh.id);
          });
        }
      }
      if (!worldExtends) worldExtends = this.getWorldExtends();
      return worldExtends;
    }
  }, {
    key: "setupCameraLimits",
    value: function setupCameraLimits(worldExtends) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        if (worldExtends === undefined || worldExtends === null) {
          var we = this.getCameraWorldExtends();
          if (we) worldExtends = we;
        }
        if (!worldExtends) return;
        var worldSize = worldExtends.max.subtract(worldExtends.min);
        if (isFinite(worldSize.length())) {
          this.removeCameraLimits();
          var radius = this.calculateCameraRadius(worldExtends);
          this.setCameraRadiusParameters(radius);
          if (this._limitLowerRadius) {
            if (this._scene.meshes.length && this._zoomEnabled) {
              // Enable camera's behaviors
              this._camera.useFramingBehavior = true;
              var framingBehavior = this._camera.getBehaviorByName("Framing");
              if (framingBehavior && framingBehavior instanceof BABYLON.FramingBehavior) {
                framingBehavior.framingTime = 0;
                framingBehavior.elevationReturnTime = -1;
                framingBehavior.radiusScale = this._radiusScale;

                // test position scale
                framingBehavior.positionScale = this._positionScale;
                this._camera.lowerRadiusLimit = null;
                framingBehavior.zoomOnBoundingInfo(worldExtends.min, worldExtends.max);
                if (this._minZoomPerc !== null && this._minZoomPerc !== undefined && this._minZoomPerc > 0) this._camera.lowerRadiusLimit = radius * this._minZoomPerc;
                if (this._maxZoomPerc !== null && this._maxZoomPerc !== undefined && this._maxZoomPerc > 0) this._camera.upperRadiusLimit = radius * this._maxZoomPerc;
              }
            }
          } else {
            this._camera.lowerRadiusLimit = null;
          }
        }
      }
    }
  }, {
    key: "adjustCamera",
    value: function adjustCamera(currentPluginName) {
      var _this13 = this;
      var keepAlpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var keepBeta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var animate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera)) return;
      var worldExtends = this.getCameraWorldExtends();
      if (!worldExtends) return;
      var worldSize = worldExtends.max.subtract(worldExtends.min);
      if (!isFinite(worldSize.length())) return;
      var worldCenter = worldExtends.min.add(worldSize.scale(0.5));
      this.removeCameraLimits();
      var radius = this.calculateCameraRadius(worldExtends);
      var alpha = this._camera.alpha;
      if (!keepAlpha) {
        alpha = -(Math.PI / 2);
        if (currentPluginName && currentPluginName === "gltf") {
          // glTF assets use a +Z forward convention while the default camera faces +Z. Rotate the camera to look at the front of the asset.
          alpha += Math.PI;
        }
      }
      var beta = this._camera.beta;
      if (!keepBeta) beta = Math.PI / 2 - 0.3;
      var target = worldCenter.clone();

      // position scale
      var bottom = worldExtends.min.y;
      var top = worldExtends.max.y;
      var zoomTargetY = bottom + (top - bottom) * this._positionScale;
      target.y = zoomTargetY;
      if (!animate) {
        this._camera.alpha = alpha;
        this._camera.beta = beta;
        this._camera.radius = radius;
        this._camera.target = target;
        this.setupCameraLimits(worldExtends);
      } else {
        this.animateCameraToFinalParamters(alpha, beta, radius, target, 2, function () {
          _this13.setupCameraLimits(worldExtends);
        });
      }
    }
  }, {
    key: "normalizeAngleOfView",
    value: function normalizeAngleOfView(alpha, beta) {
      var target = BABYLON.Vector3.Zero();
      var ghost = new BABYLON.ArcRotateCamera("ghostCamera", alpha, beta, 1, target, this._scene);
      var position = ghost.position;
      ghost.dispose();
      return this.computeCameraAngleOfView(target, position);
    }
  }, {
    key: "computeCameraAngleOfView",
    value: function computeCameraAngleOfView(target, position) {
      // creo una ghost camera per recuperare alpha, beta e radius nuovi
      var ghost = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, target, this._scene);
      ghost.setPosition(position);
      var endAlpha = ghost.alpha;
      var endBeta = ghost.beta;
      ghost.dispose();
      return {
        alpha: endAlpha,
        beta: endBeta
      };
    }
  }, {
    key: "moveCamera",
    value: function moveCamera(endTarget, endPosition) {
      // creo una ghost camera per recuperare alpha, beta e radius nuovi
      var ghost = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, endTarget, this._scene);
      ghost.setPosition(endPosition);
      var endAlpha = ghost.alpha;
      var endBeta = ghost.beta;
      var endRadius = ghost.radius;
      ghost.dispose();
      this.moveCameraToFinalParameters(endAlpha, endBeta, endRadius, endTarget);
    }
  }, {
    key: "animateCamera",
    value: function animateCamera(endTarget, endPosition, seconds, callback) {
      // creo una ghost camera per recuperare alpha, beta e radius nuovi
      var ghost = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, endTarget, this._scene);
      ghost.setPosition(endPosition);
      var endAlpha = ghost.alpha;
      var endBeta = ghost.beta;
      var endRadius = ghost.radius;
      ghost.dispose();
      this.animateCameraToFinalParamters(endAlpha, endBeta, endRadius, endTarget, seconds, callback);
    }

    // riporta angle nel range -180, + 180
  }, {
    key: "wrapPi",
    value: function wrapPi(angle) {
      if (Math.abs(angle) > Math.PI) {
        var twoppi = 2.0 * Math.PI;
        var revolutions = Math.floor((angle + Math.PI) * (1.0 / twoppi));
        angle -= revolutions * twoppi;
      }
      return angle;
    }
  }, {
    key: "wrap2Pi",
    value: function wrap2Pi(angle) {
      var a = angle % (Math.PI * 2);
      if (a < 0) {
        a += Math.PI * 2;
      }
      return a;
    }
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      this.zoom(0.85);
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      this.zoom(1.15);
    }
  }, {
    key: "zoom",
    value: function zoom(perc) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var radius = this._camera.radius;
        var lowerRadius = this._camera.lowerRadiusLimit !== null && this._camera.lowerRadiusLimit !== undefined ? this._camera.lowerRadiusLimit : 0;
        var min = Math.max(0, lowerRadius);
        var max = Number.MAX_VALUE;
        if (this._camera.upperRadiusLimit != null) max = this._camera.upperRadiusLimit;
        var newRadius = Math.max(min, Math.min(max, radius * perc));
        if (newRadius !== radius) {
          this.animateCameraToFinalParamters(this._camera.alpha, this._camera.beta, newRadius, this._camera.target, 0.5);
        }
      }
    }
  }, {
    key: "moveCameraToFinalParameters",
    value: function moveCameraToFinalParameters(alpha, beta, radius, target) {
      if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera)) return;
      this._camera.target = target;
      this._camera.alpha = alpha;
      this._camera.beta = beta;
      this._camera.radius = radius;
    }
  }, {
    key: "animateCameraToFinalParamters",
    value: function animateCameraToFinalParamters(endAlpha, endBeta, endRadius, endTarget, seconds, callback) {
      var _this14 = this;
      if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera)) return;
      var removeOldAnimations = function removeOldAnimations() {
        if (_this14._camera) {
          _this14._scene.stopAnimation(_this14._camera);
          for (var i = 0; i < _this14._camera.animations.length; i++) {
            var anim = _this14._camera.animations[i];
            _this14._camera.animations.splice(i--, 1);
          }
        }
      };
      removeOldAnimations();

      // resetting the alpha and beta to a much simpler version
      var alpha1 = this._camera.alpha;
      if (!this._camera.lowerAlphaLimit && !this._camera.upperAlphaLimit) {
        alpha1 = this.wrap2Pi(this._camera.alpha);
      }
      var beta1 = this._camera.beta;
      if (!this._camera.lowerBetaLimit && !this._camera.upperBetaLimit) {
        beta1 = this.wrap2Pi(this._camera.beta);
      }

      // used to find the shortest curve IE. if angle == 3PI/2 => take the -1PI/2 instead
      var alpha2 = isFinite(endAlpha) ? this.wrapPi(endAlpha) : alpha1;
      if (Math.abs(alpha1 - alpha2) > Math.PI) {
        alpha2 += Math.PI * 2;
      }
      var beta2 = isFinite(endBeta) ? this.wrapPi(endBeta) : beta1;
      if (Math.abs(beta1 - beta2) > Math.PI) {
        beta2 += Math.PI * 2;
      }
      var duration = 2;
      if (seconds && typeof seconds === 'number' && seconds > 0) duration = seconds;
      var fps = 60;
      var numFrames = Math.floor(duration * fps);

      // Target
      var targetVect = this._camera.target.subtract(endTarget);
      var targetDist = targetVect.length();
      var targetPerc = targetDist / this._camera.radius;
      var keys = [];

      // easing function
      var easingFunction = new BABYLON.CubicEase();
      easingFunction.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
      var targetAnimation = null;
      if (this._camera.target !== endTarget) {
        if (targetPerc >= 0.005) {
          targetAnimation = new BABYLON.Animation("camTargetAnimation", "target", fps, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);

          // keys
          keys = [{
            frame: 0,
            value: this._camera.target
          }, {
            frame: numFrames,
            value: endTarget
          }];
          targetAnimation.setKeys(keys);
          targetAnimation.setEasingFunction(easingFunction);
        } else {
          this._camera.target = endTarget;
        }
      }

      // Alpha
      var alphaAnimation = null;
      if (alpha1 !== alpha2) {
        //Logger.info("alpha1: " + alpha1 + " - alpha2: " + alpha2);
        alphaAnimation = new BABYLON.Animation("camAlphaAnimation", "alpha", fps, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);

        // keys
        keys = [{
          frame: 0,
          value: alpha1
        }, {
          frame: numFrames,
          value: alpha2
        }];
        alphaAnimation.setKeys(keys);
        alphaAnimation.setEasingFunction(easingFunction);
      }

      // Beta
      var betaAnimation = null;
      ;
      if (beta1 !== beta2) {
        betaAnimation = new BABYLON.Animation("camBetaAnimation", "beta", fps, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);

        // keys
        keys = [{
          frame: 0,
          value: beta1
        }, {
          frame: numFrames,
          value: beta2
        }];
        betaAnimation.setKeys(keys);
        betaAnimation.setEasingFunction(easingFunction);
      }

      // Radius
      var deltaPerc = Math.abs(this._camera.radius - endRadius) / this._camera.radius;
      var radiusAnimation = null;
      if (this._camera.radius !== endRadius) {
        if (deltaPerc >= 0.005) {
          radiusAnimation = new BABYLON.Animation("camRadiusAnimation", "radius", fps, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);

          // keys
          keys = [{
            frame: 0,
            value: this._camera.radius
          }, {
            frame: numFrames,
            value: endRadius
          }];
          radiusAnimation.setKeys(keys);
          radiusAnimation.setEasingFunction(easingFunction);
        } else {
          this._camera.radius = endRadius;
        }
      }
      var oldAnimationCounts = this._camera.animations.length;
      if (targetAnimation) this._camera.animations.push(targetAnimation);
      if (alphaAnimation) this._camera.animations.push(alphaAnimation);
      if (betaAnimation) this._camera.animations.push(betaAnimation);
      if (radiusAnimation) this._camera.animations.push(radiusAnimation);
      if (this._camera.animations.length > oldAnimationCounts) {
        //Logger.info("starting camera animations");
        var animatable = this._scene.beginAnimation(this._camera, 0, numFrames, false, 1);

        // Remove animations from camera
        animatable.onAnimationEnd = function () {
          removeOldAnimations();
          _this14.setupShaderMaterialsCameraPosition();
          if (callback) callback();
        };
      } else {
        if (callback) callback();
      }
    }

    //Returns the frustum slope based on the canvas ratio and camera FOV
    //returns The frustum slope represented as a Vector2 with X and Y slopes
  }, {
    key: "getFrustumSlope",
    value: function getFrustumSlope() {
      // Calculate the viewport ratio
      // Aspect Ratio is Height/Width.
      var camera = this._camera;
      if (!camera) {
        return BABYLON.Vector2.Zero();
      }
      var engine = this._engine;
      var aspectRatio = engine.getAspectRatio(camera);
      // Camera FOV is the vertical field of view (top-bottom) in radians.
      // Slope of the frustum top/bottom planes in view space, relative to the forward vector.
      var frustumSlopeY = Math.tan(camera.fov / 2);
      // Slope of the frustum left/right planes in view space, relative to the forward vector.
      // Provides the amount that one side (e.g. left) of the frustum gets wider for every unit
      // along the forward vector.
      var frustumSlopeX = frustumSlopeY * aspectRatio;
      return new BABYLON.Vector2(frustumSlopeX, frustumSlopeY);
    }
  }, {
    key: "calculateCameraRadius",
    value: function calculateCameraRadius(worldExtends) {
      if (worldExtends === undefined || worldExtends === null) {
        var we = this.getCameraWorldExtends();
        if (we) worldExtends = we;
      }
      if (!worldExtends) return 1;
      var worldSize = worldExtends.max.subtract(worldExtends.min);
      var radius = this.calculateLowerRadiusFromModelBoundingSphere(worldExtends.min, worldExtends.max);
      if (!isFinite(radius)) {
        radius = 1;
      }
      return radius;
    }

    // Calculates the lowest radius for the camera based on the bounding box of the mesh.
  }, {
    key: "calculateLowerRadiusFromModelBoundingSphere",
    value: function calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld) {
      var size = maximumWorld.subtract(minimumWorld);
      var boxVectorGlobalDiagonal = size.length();
      var frustumSlope = this.getFrustumSlope();

      // Formula for setting distance
      // (Good explanation: http://stackoverflow.com/questions/2866350/move-camera-to-fit-3d-scene)
      var radiusWithoutFraming = boxVectorGlobalDiagonal * 0.5;
      // Horizon distance
      var radiusScale = this._radiusScale;
      var radius = radiusWithoutFraming * radiusScale;
      var distanceForHorizontalFrustum = radius * Math.sqrt(1.0 + 1.0 / (frustumSlope.x * frustumSlope.x));
      var distanceForVerticalFrustum = radius * Math.sqrt(1.0 + 1.0 / (frustumSlope.y * frustumSlope.y));
      var distance = Math.max(distanceForHorizontalFrustum, distanceForVerticalFrustum);
      var camera = this._camera;
      if (!camera || !(camera instanceof BABYLON.ArcRotateCamera)) {
        return 0;
      }

      // Don't exceed the upper radius limit
      if (camera.upperRadiusLimit) {
        distance = distance > camera.upperRadiusLimit ? camera.upperRadiusLimit : distance;
      }
      return distance;
    }
  }, {
    key: "getWorldCenter",
    value: function getWorldCenter(worldExtends) {
      if (worldExtends === undefined || worldExtends === null) {
        var we = this.getCameraWorldExtends();
        if (we) worldExtends = we;
      }
      if (!worldExtends) return null;
      var worldSize = worldExtends.max.subtract(worldExtends.min);
      if (!isFinite(worldSize.length())) return null;
      var worldCenter = worldExtends.min.add(worldSize.scale(0.5));
      return worldCenter;
    }
  }, {
    key: "getCameraWorldCenter",
    value: function getCameraWorldCenter(worldExtends) {
      if (worldExtends === undefined || worldExtends === null) {
        var we = this.getCameraWorldExtends();
        if (we) worldExtends = we;
      }
      if (!worldExtends) return null;
      var worldSize = worldExtends.max.subtract(worldExtends.min);
      if (!isFinite(worldSize.length())) return null;
      var worldCenter = worldExtends.min.add(worldSize.scale(0.5));
      return worldCenter;
    }
  }, {
    key: "getCameraRadius",
    value: function getCameraRadius(worldExtends) {
      if (worldExtends === undefined || worldExtends === null) {
        var we = this.getCameraWorldExtends();
        if (we) worldExtends = we;
      }
      if (!worldExtends) return null;
      var worldSize = worldExtends.max.subtract(worldExtends.min);
      if (!isFinite(worldSize.length())) return null;
      var radius = this.calculateCameraRadius(worldExtends);
      return radius;
    }
  }, {
    key: "setCameraLimitLowerRadius",
    value: function setCameraLimitLowerRadius(limitLowerRadius) {
      var adjustCamera = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._limitLowerRadius = limitLowerRadius;
      this.setupCameraLimits();
      if (adjustCamera && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
        var target = this._camera.target.clone();
        var worldExtends = this.getCameraWorldExtends();
        if (worldExtends) {
          var bottom = worldExtends.min.y;
          var top = worldExtends.max.y;
          var zoomTargetY = bottom + (top - bottom) * this._positionScale;
          target.y = zoomTargetY;
          this.animateCameraToFinalParamters(this._camera.alpha, this._camera.beta, this._camera.radius, target, 0.5);
        }
      }
    }
  }, {
    key: "setCameraPositionScale",
    value: function setCameraPositionScale(positionScale) {
      var adjustCamera = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._positionScale = positionScale;
      if (adjustCamera && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
        var target = this._camera.target.clone();
        var worldExtends = this.getCameraWorldExtends();
        if (worldExtends) {
          var bottom = worldExtends.min.y;
          var top = worldExtends.max.y;
          var zoomTargetY = bottom + (top - bottom) * this._positionScale;
          target.y = zoomTargetY;
          this.animateCameraToFinalParamters(this._camera.alpha, this._camera.beta, this._camera.radius, target, 0.5);
        }
      }
    }
  }, {
    key: "getCameraPivot",
    value: function getCameraPivot() {
      return this._cameraPivot;
    }
  }, {
    key: "setCameraPivot",
    value: function setCameraPivot(mesh) {
      this._cameraPivot = mesh;
      this.adjustCamera(undefined, true, true, true);
    }
  }, {
    key: "setZoomEnabled",
    value: function setZoomEnabled(enabled) {
      this._zoomEnabled = enabled;
      this.adjustCamera(undefined, true, true, true);
    }
  }, {
    key: "setMinZoomPerc",
    value: function setMinZoomPerc(minZoomPerc) {
      var newVal = minZoomPerc === undefined || minZoomPerc === null ? null : minZoomPerc;
      if (newVal !== this._minZoomPerc) {
        this._minZoomPerc = newVal;
        this.adjustCamera(undefined, true, true, false);
      }
    }
  }, {
    key: "setMaxZoomPerc",
    value: function setMaxZoomPerc(maxZoomPerc) {
      var newVal = maxZoomPerc === undefined || maxZoomPerc === null ? null : maxZoomPerc;
      if (newVal !== this._maxZoomPerc) {
        this._maxZoomPerc = newVal;
        this.adjustCamera(undefined, true, true, false);
      }
    }
  }, {
    key: "setCameraAlphaLimits",
    value: function setCameraAlphaLimits(lower, upper) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        //const alpha = this.wrapPi(this._camera.alpha);
        var alpha = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).alpha;
        this.setCameraLowerAlphaLimit(lower);
        this.setCameraUpperAlphaLimit(upper);
        this._camera.alpha = alpha;
      }
    }
  }, {
    key: "setCameraLowerAlphaLimit",
    value: function setCameraLowerAlphaLimit(angle) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        if (angle === null || angle === undefined) {
          this._camera.lowerAlphaLimit = null;
        } else {
          var a = this.normalizeAngleOfView(angle, this._camera.beta).alpha;
          if (this._camera.upperAlphaLimit && a > this._camera.upperAlphaLimit) this._camera.upperAlphaLimit += Math.PI * 2;
          this._camera.lowerAlphaLimit = a;
        }
      }
    }
  }, {
    key: "setCameraUpperAlphaLimit",
    value: function setCameraUpperAlphaLimit(angle) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        if (angle === null || angle === undefined) {
          this._camera.upperAlphaLimit = null;
        } else {
          var a = this.normalizeAngleOfView(angle, this._camera.beta).alpha;
          if (this._camera.lowerAlphaLimit && a < this._camera.lowerAlphaLimit) a += Math.PI * 2;
          this._camera.upperAlphaLimit = a;
        }
      }
    }
  }, {
    key: "setCameraLowerBetaLimit",
    value: function setCameraLowerBetaLimit(angle) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        if (angle === null || angle === undefined) {
          this._camera.lowerBetaLimit = 0.01;
        } else {
          var a = this.normalizeAngleOfView(this._camera.alpha, angle).beta;
          if (this._camera.upperBetaLimit && a > this._camera.upperBetaLimit) this._camera.upperBetaLimit += Math.PI * 2;
          this._camera.lowerBetaLimit = a;
        }
      }
    }
  }, {
    key: "setCameraUpperBetaLimit",
    value: function setCameraUpperBetaLimit(angle) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        if (angle === null || angle === undefined) {
          this._camera.upperBetaLimit = Math.PI - 0.01;
        } else {
          var a = this.normalizeAngleOfView(this._camera.alpha, angle).beta;
          if (this._camera.lowerBetaLimit && a < this._camera.lowerBetaLimit) this._camera.lowerBetaLimit -= Math.PI * 2;
          this._camera.upperBetaLimit = a;
        }
      }
    }
  }, {
    key: "setCameraBetaLimits",
    value: function setCameraBetaLimits(lower, upper) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var beta = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).beta;
        this.setCameraLowerBetaLimit(lower);
        this.setCameraUpperBetaLimit(upper);
        this._camera.beta = beta;
      }
    }
  }, {
    key: "zoomOnMesh",
    value: function zoomOnMesh(mesh) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        // Enable camera's behaviors
        this._camera.useFramingBehavior = true;
        var framingBehavior = this._camera.getBehaviorByName("Framing");
        if (framingBehavior && framingBehavior instanceof BABYLON.FramingBehavior) {
          framingBehavior.framingTime = 0;
          framingBehavior.elevationReturnTime = -1;
          framingBehavior.radiusScale = this._radiusScale;

          // test position scale
          framingBehavior.positionScale = this._positionScale;
          framingBehavior.zoomOnMeshHierarchy(mesh);
        }
      }
    }
  }, {
    key: "takeScreenshotAsync",
    value: function () {
      var _takeScreenshotAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(width, height) {
        var size;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this._camera) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", "");
            case 2:
              size = {
                width: width,
                height: height
              };
              _context2.next = 5;
              return BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, size, "image/png");
            case 5:
              return _context2.abrupt("return", _context2.sent);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function takeScreenshotAsync(_x3, _x4) {
        return _takeScreenshotAsync.apply(this, arguments);
      }
      return takeScreenshotAsync;
    }()
  }, {
    key: "takeContentScreenshotAsync",
    value: function () {
      var _takeContentScreenshotAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(width, height) {
        var oldClearColor, size, promise, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this._camera) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", "");
            case 2:
              // rendo lo sfondo trasparente
              oldClearColor = this._scene.clearColor.clone();
              this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
              this._scene.render(); // Forzo il ridisegno
              size = {
                width: width,
                height: height
              };
              promise = BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, size, "image/png");
              this._scene.render(); // Forzo il ridisegno
              this._scene.getEngine().endFrame();
              _context3.next = 11;
              return promise;
            case 11:
              data = _context3.sent;
              this._scene.clearColor = oldClearColor;
              return _context3.abrupt("return", data);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function takeContentScreenshotAsync(_x5, _x6) {
        return _takeContentScreenshotAsync.apply(this, arguments);
      }
      return takeContentScreenshotAsync;
    }()
  }, {
    key: "takeMaterialScreenshotAsync",
    value: function () {
      var _takeMaterialScreenshotAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(materialID, width, height) {
        var material, meshes, i, mesh, oldClearColor, sphere, newCamera, size, data, _i;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              material = this._scene.getMaterialByID(materialID);
              if (material) {
                _context4.next = 3;
                break;
              }
              return _context4.abrupt("return", "");
            case 3:
              // Devo nascondere tutte le mesh attuali
              // Creare una sfera e applicarci il materiale
              // scattare la screenshot
              // eliiminare la sfera e riposizionare il tutto come era.
              meshes = this.getVisibleMeshes(); // Mesh da nascondere e rivisualizzare
              for (i = 0; i < meshes.length; i++) {
                mesh = meshes[i];
                mesh.isVisible = false;
              }

              // rendo lo sfondo trasparente
              oldClearColor = this._scene.clearColor.clone();
              this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);

              // Creo una sfera temporanea
              sphere = BABYLON.Mesh.CreateSphere("temp_sphere", 32, 2, this._scene);
              sphere.material = material;

              // Creo una nuova camera temporanea
              newCamera = new BABYLON.ArcRotateCamera("temp_camera", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene);
              newCamera.setPosition(new BABYLON.Vector3(0, 0, -4));
              this._scene.activeCamera = newCamera;
              this._scene.render(); // Forzo il ridisegno
              size = {
                width: width,
                height: height
              };
              _context4.next = 16;
              return BABYLON.Tools.CreateScreenshotAsync(this._engine, newCamera, size, "image/png");
            case 16:
              data = _context4.sent;
              this._scene.clearColor = oldClearColor;
              sphere.dispose();

              // mostro le mesh precedentemente nascoste
              for (_i = 0; _i < meshes.length; _i++) {
                mesh = meshes[_i];
                mesh.isVisible = true;
              }

              // riattivo la vecchia camera
              this._scene.activeCamera = this._camera;
              newCamera.dispose();
              return _context4.abrupt("return", data);
            case 23:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function takeMaterialScreenshotAsync(_x7, _x8, _x9) {
        return _takeMaterialScreenshotAsync.apply(this, arguments);
      }
      return takeMaterialScreenshotAsync;
    }()
  }, {
    key: "getScenePBRMaterials",
    value: function getScenePBRMaterials() {
      var materials = [];
      if (this._scene) {
        this._scene.materials.forEach(function (material) {
          if (material instanceof BABYLON.PBRBaseMaterial) materials.push(material);
        });
      }
      return materials;
    }
  }, {
    key: "resetPBRMaterialsImageProcessingConfiguration",
    value: function resetPBRMaterialsImageProcessingConfiguration() {
      var _this15 = this;
      var materials = this.getScenePBRMaterials();
      materials.forEach(function (material) {
        _this15.adjustPBRMaterialImageProcessingConfiguration(material);
      });
    }
  }, {
    key: "adjustPBRMaterialImageProcessingConfiguration",
    value: function adjustPBRMaterialImageProcessingConfiguration(material) {
      if (material instanceof BABYLON.PBRMaterial && material.imageProcessingConfiguration) {
        //if (material.imageProcessingConfiguration.isEnabled !== undefined)
        //    material.imageProcessingConfiguration.isEnabled = undefined;

        material.imageProcessingConfiguration.colorGradingWithGreenDepth = false;
        material.imageProcessingConfiguration.colorGradingBGR = false;
        material.imageProcessingConfiguration.exposure = 1;
        material.imageProcessingConfiguration.toneMappingEnabled = false;
        material.imageProcessingConfiguration.contrast = 1;
      }
    }
  }, {
    key: "animateMeshToFinalParameters",
    value: function animateMeshToFinalParameters(mesh, p, rE, rQ, s) {
      var _this16 = this;
      var seconds = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2;
      var callback = arguments.length > 6 ? arguments[6] : undefined;
      if (this._scene && mesh) {
        var _id = mesh.id;
        var removeOldAnimations = function removeOldAnimations() {
          _this16._scene.stopAnimation(mesh);
          for (var i = 0; i < mesh.animations.length; i++) {
            mesh.animations.splice(i--, 1);
          }
        };
        removeOldAnimations();
        var duration = seconds;
        var fps = 60;
        var numFrames = Math.floor(duration * fps);
        var keys;

        // Position
        var positionAnimation = null;
        if (mesh.position !== p) {
          positionAnimation = new BABYLON.Animation("positionAnimation", "position", fps, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);

          // keys
          keys = [{
            frame: 0,
            value: mesh.position
          }, {
            frame: numFrames,
            value: p
          }];
          positionAnimation.setKeys(keys);
        }

        // Rotation
        var eulerAnimation = null;
        var quaternionAnimation = null;
        if (mesh.rotationQuaternion == null) {
          // Euler
          var endE;
          if (rE != null) {
            endE = rE.clone();
          } else {
            endE = rQ.toEulerAngles().clone();
          }
          if (mesh.rotation != endE) {
            eulerAnimation = new BABYLON.Animation("eulerAnimation", "rotation", fps, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);

            // keys
            keys = [{
              frame: 0,
              value: mesh.rotation
            }, {
              frame: numFrames,
              value: endE
            }];
            eulerAnimation.setKeys(keys);
          }
        } else {
          // Quaternion
          var endQ;
          if (rQ != null) {
            endQ = rQ.clone();
          } else {
            endQ = BABYLON.Quaternion.Identity();
            endQ.copyFrom(BABYLON.Quaternion.RotationYawPitchRoll(rE.y, rE.x, rE.z));
          }
          quaternionAnimation = new BABYLON.Animation("quaternionAnimation", "rotationQuaternion", fps, BABYLON.Animation.ANIMATIONTYPE_QUATERNION, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);

          // keys
          keys = [{
            frame: 0,
            value: mesh.rotationQuaternion
          }, {
            frame: numFrames,
            value: endQ
          }];
          quaternionAnimation.setKeys(keys);
        }

        // Scaling
        var scalingAnimation = null;
        if (mesh.scaling !== s) {
          scalingAnimation = new BABYLON.Animation("scalingAnimation", "scaling", fps, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);

          // keys
          keys = [{
            frame: 0,
            value: mesh.scaling
          }, {
            frame: numFrames,
            value: s
          }];
          scalingAnimation.setKeys(keys);
        }
        var oldAnimationCounts = mesh.animations.length;
        if (positionAnimation) mesh.animations.push(positionAnimation);
        if (eulerAnimation) mesh.animations.push(eulerAnimation);
        if (quaternionAnimation) mesh.animations.push(quaternionAnimation);
        if (scalingAnimation) mesh.animations.push(scalingAnimation);
        if (mesh.animations.length > oldAnimationCounts) {
          //Logger.info("starting camera animations");
          var animatable = this._scene.beginAnimation(mesh, 0, numFrames, false, 1);

          // Remove animations from camera
          animatable.onAnimationEnd = function () {
            removeOldAnimations();
            if (callback) callback();
          };
        }
      }
    }
  }, {
    key: "getMaterialsUsingTexture",
    value: function getMaterialsUsingTexture(texture) {
      var _this17 = this;
      // costruisco una mappa texture uid --> [materials]
      var map = this.getTextureMaterialsMap();
      this._scene.materials.forEach(function (material) {
        var txts = _this17.getTexturesForMaterial(material);
        txts.forEach(function (txt) {
          if (!map.hasOwnProperty(txt.uid)) map[txt.uid] = [];
          map[txt.uid].push(material);
        });
      });
      if (map.hasOwnProperty(texture.uid)) return map[texture.uid];
      return [];
    }
  }, {
    key: "getTextureMaterialsMap",
    value: function getTextureMaterialsMap() {
      var _this18 = this;
      var map = {};
      if (this._scene) {
        this._scene.materials.forEach(function (material) {
          var txts = _this18.getTexturesForMaterial(material);
          txts.forEach(function (txt) {
            if (!map.hasOwnProperty(txt.uid)) map[txt.uid] = [];
            map[txt.uid].push(material);
          });
        });
      }
      return map;
    }

    // Recupera tutte le texture di un materiale
  }, {
    key: "getTexturesForMaterial",
    value: function getTexturesForMaterial(material) {
      return material.getActiveTextures();
    }
  }, {
    key: "getTexturesExclusivelyForMaterial",
    value: function getTexturesExclusivelyForMaterial(material) {
      var allTextures = this.getTexturesForMaterial(material);
      var map = this.getTextureMaterialsMap();
      for (var i = 0; i < allTextures.length; i++) {
        var texture = allTextures[i];
        var allMaterials = map.hasOwnProperty(texture.uid) ? map[texture.uid] : [];
        if (allMaterials.length > 1) allTextures.splice(i--, 1);
      }
      return allTextures;
    }
  }, {
    key: "getStandardMaterialTextures",
    value: function getStandardMaterialTextures(material) {
      return material.getActiveTextures();
    }
  }, {
    key: "getPBRBaseSimpleMaterialTextures",
    value: function getPBRBaseSimpleMaterialTextures(material) {
      return material.getActiveTextures();
    }
  }, {
    key: "getPBRMaterialTextures",
    value: function getPBRMaterialTextures(material) {
      return material.getActiveTextures();
    }
  }, {
    key: "getPBRMetallicRoughnessMaterialTextures",
    value: function getPBRMetallicRoughnessMaterialTextures(material) {
      return material.getActiveTextures();
    }
  }, {
    key: "getPBRSpecularGlossinessMaterialTextures",
    value: function getPBRSpecularGlossinessMaterialTextures(material) {
      return material.getActiveTextures();
    }
  }, {
    key: "getNewPBRMaterialTextures",
    value: function getNewPBRMaterialTextures(material) {
      return material.getActiveTextures();
    }
  }, {
    key: "createMeshesFromSubMeshes",
    value: function createMeshesFromSubMeshes(mesh) {
      var children = mesh.getChildMeshes();
      for (var i = 0; i < children.length; i++) this.createMeshesFromSubMeshes(children[i]);
      var newMeshes = [];
      if (mesh.subMeshes && mesh.subMeshes.length > 0) {
        for (var _i2 = 0; _i2 < mesh.subMeshes.length; _i2++) {
          var newMesh = this.createMeshFromSubMesh(mesh, _i2);
          if (newMesh) newMeshes.push(newMesh);
        }
      }
      var vertexData = new BABYLON.VertexData();
      vertexData.positions = [];
      vertexData.indices = [];
      vertexData.normals = [];
      vertexData.uvs = [];
      vertexData.uvs2 = [];
      vertexData.applyToMesh(mesh, true);
      mesh.subMeshes = [];
      mesh.material = null;
      newMeshes.forEach(function (child) {
        child.parent = mesh;
      });
    }
  }, {
    key: "createMeshFromSubMesh",
    value: function createMeshFromSubMesh(mesh, idx, name) {
      var newMesh = null;
      var submesh = mesh.subMeshes[idx];
      var positionsData = mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);
      var normalsData = mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
      var indicesData = mesh.getIndices();
      if (positionsData && normalsData && indicesData) {
        var positions = positionsData.slice(3 * submesh.verticesStart, 3 * (submesh.verticesStart + submesh.verticesCount));
        var normals = normalsData.slice(3 * submesh.verticesStart, 3 * (submesh.verticesStart + submesh.verticesCount));
        var indices = indicesData.slice(submesh.indexStart, submesh.indexStart + submesh.indexCount);
        var uvs = null;
        if (mesh.isVerticesDataPresent(BABYLON.VertexBuffer.UVKind)) {
          var uvsData = mesh.getVerticesData(BABYLON.VertexBuffer.UVKind);
          if (uvsData) uvs = uvsData.slice(2 * submesh.verticesStart, 2 * (submesh.verticesStart + submesh.verticesCount));
        }
        var uvs2 = null;
        if (mesh.isVerticesDataPresent(BABYLON.VertexBuffer.UV2Kind)) {
          var uvs2Data = mesh.getVerticesData(BABYLON.VertexBuffer.UV2Kind);
          if (uvs2Data) uvs2 = uvs2Data.slice(2 * submesh.verticesStart, 2 * (submesh.verticesStart + submesh.verticesCount));
        }
        for (var k = 0; k < indices.length; k++) indices[k] -= submesh.verticesStart;
        var _newMesh = new BABYLON.Mesh(name || mesh.name + "_part_" + submesh._id, this._scene);
        var vertexData = new BABYLON.VertexData();
        vertexData.positions = positions;
        vertexData.normals = normals;
        vertexData.indices = indices;
        if (uvs) vertexData.uvs = uvs;
        if (uvs2) vertexData.uvs2 = uvs2;
        vertexData.applyToMesh(_newMesh);
        if (mesh.material) _newMesh.material = mesh.material instanceof BABYLON.MultiMaterial ? mesh.material.subMaterials[submesh.materialIndex] : mesh.material;
      }
      return newMesh;
    }
  }, {
    key: "getNextIncrementalName",
    value: function getNextIncrementalName(name) {
      var newName = name;
      if (name) {
        var nameWithoutSuffix;
        var incremental = 0;
        while (this._scene.getMeshByName(newName)) {
          if (!nameWithoutSuffix) {
            nameWithoutSuffix = name;
            var idx = name.lastIndexOf("_");
            if (idx > 0) {
              var numText = name.substring(idx + 1);
              var num = parseInt(numText);
              if (num.toString() === numText) {
                nameWithoutSuffix = name.substring(0, idx);
              }
            }
          }
          incremental++;
          newName = nameWithoutSuffix + "_" + incremental;
        }
      }
      return newName;
    }
  }, {
    key: "createBox",
    value: function createBox(parent, name) {
      var n = name || "Box";
      n = this.getNextIncrementalName(n);
      var mesh = BABYLON.Mesh.CreateBox(n, 5, this._scene);
      mesh.id = Zakeke.generateUUID();
      if (parent) mesh.parent = parent;
      return mesh;
    }
  }, {
    key: "createBoundingBox",
    value: function createBoundingBox(mesh, name) {
      var n = name || "BoundingBox";
      n = this.getNextIncrementalName(n);
      var boundingVectors = mesh ? mesh.getHierarchyBoundingVectors() : this.getWorldExtends();
      if (!boundingVectors) return this.createBox(mesh, name);
      var min = boundingVectors.min;
      var max = boundingVectors.max;
      var totalBounds = new BABYLON.BoundingInfo(min, max);
      var boundSize = max.subtract(min);
      if (!isFinite(boundSize.length())) return this.createBox(mesh, name);
      var width = max.x - min.x;
      var height = max.y - min.y;
      var depth = max.z - min.z;
      var vertexdata = BABYLON.VertexData.CreateBox({
        width: width,
        height: height,
        depth: depth
      });
      var custombb_mesh = new BABYLON.Mesh(n, this._scene);
      vertexdata.applyToMesh(custombb_mesh);
      custombb_mesh.position.copyFrom(totalBounds.boundingBox.centerWorld);
      custombb_mesh.refreshBoundingInfo();
      if (mesh && mesh.parent) custombb_mesh.parent = mesh.parent;
      return custombb_mesh;
    }
  }, {
    key: "createSphere",
    value: function createSphere(parent, name) {
      var n = name || "Sphere";
      n = this.getNextIncrementalName(n);
      var mesh = BABYLON.Mesh.CreateSphere(n, 30, 5, this._scene);
      mesh.id = Zakeke.generateUUID();
      if (parent) mesh.parent = parent;
      return mesh;
    }
  }, {
    key: "createPlane",
    value: function createPlane(parent, name) {
      var n = name || "Plane";
      n = this.getNextIncrementalName(n);
      var mesh = BABYLON.Mesh.CreatePlane(n, 10.0, this._scene);
      mesh.id = Zakeke.generateUUID();
      if (parent) mesh.parent = parent;
      return mesh;
    }
  }, {
    key: "createDisc",
    value: function createDisc(parent, name) {
      var n = name || "Disc";
      n = this.getNextIncrementalName(n);
      var mesh = BABYLON.MeshBuilder.CreateDisc(n, {
        tessellation: 70
      }, this._scene);
      mesh.id = Zakeke.generateUUID();
      if (parent) mesh.parent = parent;
      return mesh;
    }
  }, {
    key: "createCylinder",
    value: function createCylinder(parent, name) {
      var n = name || "Cylinder";
      n = this.getNextIncrementalName(n);
      var mesh = BABYLON.Mesh.CreateCylinder(n, 6, 6, 6, 30, 1, this._scene, false);
      mesh.id = Zakeke.generateUUID();
      if (parent) mesh.parent = parent;
      return mesh;
    }
  }, {
    key: "createTorus",
    value: function createTorus(parent, name) {
      var n = name || "Torus";
      var i = 1;
      n = this.getNextIncrementalName(n);
      var mesh = BABYLON.Mesh.CreateTorus(n, 8, 1, 50, this._scene, false);
      mesh.id = Zakeke.generateUUID();
      if (parent) mesh.parent = parent;
      return mesh;
    }
  }, {
    key: "createKnot",
    value: function createKnot(parent, name) {
      var n = name || "Knot";
      var i = 1;
      n = this.getNextIncrementalName(n);
      var mesh = BABYLON.Mesh.CreateTorusKnot(n, 2, 0.5, 128, 64, 2, 3, this._scene);
      mesh.id = Zakeke.generateUUID();
      if (parent) mesh.parent = parent;
      return mesh;
    }
  }, {
    key: "createRibbon",
    value: function createRibbon(parent, name) {
      var n = name || "Ribbon";
      var i = 1;
      n = this.getNextIncrementalName(n);

      // Creation of a ribbon
      // let's first create many paths along a maths exponential function as an example 
      var exponentialPath = function exponentialPath(p) {
        var path = [];
        for (var i = -10; i < 10; i++) {
          path.push(new BABYLON.Vector3(p, i, Math.sin(p / 3) * 5 * Math.exp(-(i - p) * (i - p) / 60) + i / 3));
        }
        return path;
      };
      // let's populate arrayOfPaths with all these different paths
      var arrayOfPaths = [];
      for (var p = 0; p < 20; p++) {
        arrayOfPaths[p] = exponentialPath(p);
      }

      // (name, array of paths, closeArray, closePath, offset, scene)
      var mesh = BABYLON.Mesh.CreateRibbon("ribbon", arrayOfPaths, false, false, 0, this._scene);
      mesh.id = Zakeke.generateUUID();
      if (parent) mesh.parent = parent;
      return mesh;
    }
  }, {
    key: "createRoundedCubeAsync",
    value: function () {
      var _createRoundedCubeAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RoundedCubeName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RoundedCubeFileName;
              n = name || "Rounded Cube";
              n = this.getNextIncrementalName(n);
              _context5.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context5.abrupt("return", _context5.sent);
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function createRoundedCubeAsync(_x10, _x11, _x12) {
        return _createRoundedCubeAsync.apply(this, arguments);
      }
      return createRoundedCubeAsync;
    }()
  }, {
    key: "createRoundedCylinderAsync",
    value: function () {
      var _createRoundedCylinderAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RoundedCylinderName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RoundedCylinderFileName;
              n = name || "Rounded Cylinder";
              n = this.getNextIncrementalName(n);
              _context6.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context6.abrupt("return", _context6.sent);
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function createRoundedCylinderAsync(_x13, _x14, _x15) {
        return _createRoundedCylinderAsync.apply(this, arguments);
      }
      return createRoundedCylinderAsync;
    }()
  }, {
    key: "createMatBallAsync",
    value: function () {
      var _createMatBallAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.MatBallName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.MatBallFileName;
              n = name || "Mat Ball";
              n = this.getNextIncrementalName(n);
              _context7.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context7.abrupt("return", _context7.sent);
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function createMatBallAsync(_x16, _x17, _x18) {
        return _createMatBallAsync.apply(this, arguments);
      }
      return createMatBallAsync;
    }()
  }, {
    key: "createMaleHeadAsync",
    value: function () {
      var _createMaleHeadAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.MaleHeadName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.MaleHeadFileName;
              n = name || "Male Head";
              n = this.getNextIncrementalName(n);
              _context8.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context8.abrupt("return", _context8.sent);
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function createMaleHeadAsync(_x19, _x20, _x21) {
        return _createMaleHeadAsync.apply(this, arguments);
      }
      return createMaleHeadAsync;
    }()
  }, {
    key: "createFemaleHeadAsync",
    value: function () {
      var _createFemaleHeadAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.FemaleHeadName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.FemaleHeadFileName;
              n = name || "Female Head";
              n = this.getNextIncrementalName(n);
              _context9.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context9.abrupt("return", _context9.sent);
            case 8:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function createFemaleHeadAsync(_x22, _x23, _x24) {
        return _createFemaleHeadAsync.apply(this, arguments);
      }
      return createFemaleHeadAsync;
    }()
  }, {
    key: "createPokemonBallAsync",
    value: function () {
      var _createPokemonBallAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.PokemonBallName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.PokemonBallFileName;
              n = name || "Pokemon Ball";
              n = this.getNextIncrementalName(n);
              _context10.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context10.abrupt("return", _context10.sent);
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function createPokemonBallAsync(_x25, _x26, _x27) {
        return _createPokemonBallAsync.apply(this, arguments);
      }
      return createPokemonBallAsync;
    }()
  }, {
    key: "createShaderBallAsync",
    value: function () {
      var _createShaderBallAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.ShaderBallName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.ShaderBallFileName;
              n = name || "Shader Ball";
              n = this.getNextIncrementalName(n);
              _context11.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context11.abrupt("return", _context11.sent);
            case 8:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function createShaderBallAsync(_x28, _x29, _x30) {
        return _createShaderBallAsync.apply(this, arguments);
      }
      return createShaderBallAsync;
    }()
  }, {
    key: "createBootsAsync",
    value: function () {
      var _createBootsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(parent, name, onProgress) {
        var meshName, rootUrl, folder, filename, n;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.BootsName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              folder = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.BootsFolder;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.BootsFileName;
              n = name || "Boots";
              n = this.getNextIncrementalName(n);
              _context12.next = 8;
              return this.importPrimitiveShapeAsync(meshName, rootUrl + folder, filename, parent, n, onProgress);
            case 8:
              return _context12.abrupt("return", _context12.sent);
            case 9:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function createBootsAsync(_x31, _x32, _x33) {
        return _createBootsAsync.apply(this, arguments);
      }
      return createBootsAsync;
    }()
  }, {
    key: "createSuzanneAsync",
    value: function () {
      var _createSuzanneAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.SuzanneName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.SuzanneFileName;
              n = name || "Suzanne";
              n = this.getNextIncrementalName(n);
              _context13.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context13.abrupt("return", _context13.sent);
            case 8:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function createSuzanneAsync(_x34, _x35, _x36) {
        return _createSuzanneAsync.apply(this, arguments);
      }
      return createSuzanneAsync;
    }()
  }, {
    key: "createStepPyramidAsync",
    value: function () {
      var _createStepPyramidAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.StepPyramidName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.StepPyramidFileName;
              n = name || "Step Pyramid";
              n = this.getNextIncrementalName(n);
              _context14.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context14.abrupt("return", _context14.sent);
            case 8:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function createStepPyramidAsync(_x37, _x38, _x39) {
        return _createStepPyramidAsync.apply(this, arguments);
      }
      return createStepPyramidAsync;
    }()
  }, {
    key: "createTeapotAsync",
    value: function () {
      var _createTeapotAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.TeapotName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.TeapotFileName;
              n = name || "Teapot";
              n = this.getNextIncrementalName(n);
              _context15.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context15.abrupt("return", _context15.sent);
            case 8:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function createTeapotAsync(_x40, _x41, _x42) {
        return _createTeapotAsync.apply(this, arguments);
      }
      return createTeapotAsync;
    }()
  }, {
    key: "createAlloyWheelAsync",
    value: function () {
      var _createAlloyWheelAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(parent, name, onProgress) {
        var meshName, rootUrl, folder, filename, n;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.AlloyWheelName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.RootUrl;
              folder = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.AlloyWheelFolder;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Shapes.AlloyWheelFileName;
              n = name || "Wheel";
              n = this.getNextIncrementalName(n);
              _context16.next = 8;
              return this.importPrimitiveShapeAsync(meshName, rootUrl + folder, filename, parent, n, onProgress);
            case 8:
              return _context16.abrupt("return", _context16.sent);
            case 9:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function createAlloyWheelAsync(_x43, _x44, _x45) {
        return _createAlloyWheelAsync.apply(this, arguments);
      }
      return createAlloyWheelAsync;
    }()
  }, {
    key: "createTryonReferenceGlassesFrameAsync",
    value: function () {
      var _createTryonReferenceGlassesFrameAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(parent, name, onProgress) {
        var meshName, rootUrl, filename, n;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Tryon.ReferenceGlassesFrameName;
              rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Tryon.RootUrl;
              filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_2__.DefaultAssetUrls.Tryon.ReferenceGlassesFrameFileName;
              n = name || "Reference Glasses Frame";
              n = this.getNextIncrementalName(n);
              _context17.next = 7;
              return this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
            case 7:
              return _context17.abrupt("return", _context17.sent);
            case 8:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function createTryonReferenceGlassesFrameAsync(_x46, _x47, _x48) {
        return _createTryonReferenceGlassesFrameAsync.apply(this, arguments);
      }
      return createTryonReferenceGlassesFrameAsync;
    }()
  }, {
    key: "importPrimitiveShapeAsync",
    value: function () {
      var _importPrimitiveShapeAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(meshName, rootUrl, filename, parent, name, onProgress) {
        var meshes, result, i, _mesh6;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              meshes = [];
              _context18.next = 3;
              return BABYLON.SceneLoader.ImportMeshAsync(meshName, rootUrl, filename, this._scene, onProgress);
            case 3:
              result = _context18.sent;
              if (result && result.meshes) {
                meshes = result.meshes;
                for (i = 0; i < meshes.length; i++) {
                  _mesh6 = meshes[i];
                  if (!_mesh6.parent) _mesh6.name = name;
                  _mesh6.id = Zakeke.generateUUID();
                  if (parent) _mesh6.parent = parent;
                }
              }
              return _context18.abrupt("return", meshes);
            case 6:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function importPrimitiveShapeAsync(_x49, _x50, _x51, _x52, _x53, _x54) {
        return _importPrimitiveShapeAsync.apply(this, arguments);
      }
      return importPrimitiveShapeAsync;
    }()
  }, {
    key: "replaceTransformNodeWithMesh",
    value: function replaceTransformNodeWithMesh(transformNode) {
      var newMesh = null;
      if (this._scene) {
        var parent = transformNode.parent;
        var children = transformNode.getChildren();
        newMesh = new BABYLON.Mesh(transformNode.name, this._scene, parent);
        newMesh.id = Zakeke.generateUUID();
        newMesh.scaling = transformNode.scaling.clone();
        newMesh.position = transformNode.position.clone();
        newMesh.rotation = transformNode.rotation.clone();
        if (transformNode.rotationQuaternion) newMesh.rotationQuaternion = transformNode.rotationQuaternion.clone();
        children.forEach(function (c) {
          return c.parent = newMesh;
        });
        transformNode.dispose();
      }
      return newMesh;
    }

    // import 3d model from a remote url
  }, {
    key: "importMeshesFromUrlAsync",
    value: function () {
      var _importMeshesFromUrlAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(url, parent, onProgress) {
        var _this19 = this;
        var currentPluginName, meshes, result, sceneFileName, name, idx, roots, root, _root, _name, _idx;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              // Setting up some GLTF values
              currentPluginName = undefined;
              BABYLON.GLTFFileLoader.IncrementalLoading = false;
              BABYLON.SceneLoader.OnPluginActivatedObservable.add(function (plugin) {
                currentPluginName = plugin.name;
              });
              meshes = [];
              _context19.next = 6;
              return BABYLON.SceneLoader.ImportMeshAsync("", url, undefined, this._scene, onProgress);
            case 6:
              result = _context19.sent;
              if (result) {
                result.meshes.forEach(function (mesh) {
                  mesh.id = Zakeke.generateUUID();
                  meshes.push(mesh);
                  var materials = _this19.getMeshMaterials(mesh);
                  materials.forEach(function (m) {
                    return m.id = Zakeke.generateUUID();
                  });
                });
                // trasformo i TransformNodes in meshes (perché attualmente i transform node non sono gestiti dall'editor)
                result.transformNodes.forEach(function (n) {
                  n.id = Zakeke.generateUUID();
                  var newMesh = _this19.replaceTransformNodeWithMesh(n);
                  if (newMesh) meshes.push(newMesh);
                });
                result.geometries.forEach(function (g) {
                  return g.id = Zakeke.generateUUID();
                });
              }

              // Raggruppo le mesh caricate
              sceneFileName = BABYLON.Tools.GetFilename(url);
              name = sceneFileName;
              idx = sceneFileName.lastIndexOf(".");
              if (idx !== -1) name = sceneFileName.substr(0, idx);
              roots = meshes.filter(function (m) {
                return !m.parent;
              });
              if (roots.length > 1 || roots.length === 1 && roots[0].name !== "__root__") {
                root = new BABYLON.Mesh(name, this._scene);
                root.id = Zakeke.generateUUID();
                root.metadata = {
                  isRealMesh: true,
                  isGroup: true
                };
                roots.forEach(function (m) {
                  return m.parent = root;
                });
              } else if (roots.length === 1) {
                _root = roots[0];
                if (_root.name === "__root__") {
                  _name = BABYLON.Tools.GetFilename(url);
                  _idx = sceneFileName.lastIndexOf(".");
                  if (_idx !== -1) _name = sceneFileName.substring(0, _idx);
                  _root.name = _name;
                }
              }
              this.adjustCamera(currentPluginName, false, false);
              this.setupShaderMaterialsCameraPosition();
              return _context19.abrupt("return", meshes);
            case 17:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function importMeshesFromUrlAsync(_x55, _x56, _x57) {
        return _importMeshesFromUrlAsync.apply(this, arguments);
      }
      return importMeshesFromUrlAsync;
    }()
  }, {
    key: "setupShaderMaterialsCameraPosition",
    value: function setupShaderMaterialsCameraPosition() {
      if (this._scene) {
        for (var i = 0; i < this._scene.materials.length; i++) {
          var material = this._scene.materials[i];
          this.setupShaderMaterialCameraPosition(material);
        }
      }
    }
  }, {
    key: "setupShaderMaterialCameraPosition",
    value: function setupShaderMaterialCameraPosition(material) {
      if (this._scene && material && material instanceof BABYLON.ShaderMaterial) {
        var camera = this._scene.activeCamera;
        if (camera) material.setVector3("cameraPosition", camera.position);
      }
    }
  }, {
    key: "getSceneCmScalingFactor",
    value: function getSceneCmScalingFactor() {
      var scale = null;
      if (this._scene) {
        var _mesh7 = null;
        for (var i = 0; i < this._scene.meshes.length; i++) {
          var m = this._scene.meshes[i];
          if (m.metadata && m.metadata.sizecm) {
            _mesh7 = m;
            break;
          }
        }
        if (_mesh7) {
          var boundingVectors = _mesh7.getHierarchyBoundingVectors();
          var min = boundingVectors.min;
          var max = boundingVectors.max;
          var boundSize = max.subtract(min);
          if (isFinite(boundSize.length())) {
            var width = max.x - min.x;
            var height = max.y - min.y;
            var depth = max.z - min.z;
            var size = _mesh7.metadata.sizecm;
            if (size.width !== undefined && typeof size.width === "number" && !isNaN(size.width) && width !== 0) {
              scale = size.width / width;
            } else if (size.height !== undefined && typeof size.height === "number" && !isNaN(size.height) && height !== 0) {
              scale = size.height / height;
            } else if (size.depth !== undefined && typeof size.depth === "number" && !isNaN(size.depth) && depth !== 0) {
              scale = size.depth / depth;
            }
            return scale;
          }
        }
      }
      return scale;
    }
  }, {
    key: "exportSceneToUsdzAsync",
    value: function () {
      var _exportSceneToUsdzAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(sceneName, sceneRootUrl, sceneID, sceneCode) {
        var arScale,
          meshes,
          filePrefix,
          _args20 = arguments;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              arScale = _args20.length > 4 && _args20[4] !== undefined ? _args20[4] : true;
              meshes = this.getMeshesForAR();
              filePrefix = sceneName || "scene";
              filePrefix = filePrefix.replace(/[^a-z0-9]/gi, '_').toLowerCase();
              _context20.next = 6;
              return this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, sceneID, sceneCode, "usdz", arScale);
            case 6:
              return _context20.abrupt("return", _context20.sent);
            case 7:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function exportSceneToUsdzAsync(_x58, _x59, _x60, _x61) {
        return _exportSceneToUsdzAsync.apply(this, arguments);
      }
      return exportSceneToUsdzAsync;
    }()
  }, {
    key: "exportMeshToUsdzAsync",
    value: function () {
      var _exportMeshToUsdzAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(sceneRootUrl, mesh) {
        var arScale,
          meshes,
          filePrefix,
          _args21 = arguments;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              arScale = _args21.length > 2 && _args21[2] !== undefined ? _args21[2] : true;
              meshes = this.getMeshHierarchy(mesh.id);
              filePrefix = mesh.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
              _context21.next = 5;
              return this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, undefined, undefined, 'usdz', arScale);
            case 5:
              return _context21.abrupt("return", _context21.sent);
            case 6:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function exportMeshToUsdzAsync(_x62, _x63) {
        return _exportMeshToUsdzAsync.apply(this, arguments);
      }
      return exportMeshToUsdzAsync;
    }()
  }, {
    key: "exportSceneToRemoteGlTFAsync",
    value: function () {
      var _exportSceneToRemoteGlTFAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(sceneName, sceneRootUrl, sceneID, sceneCode) {
        var arScale,
          meshes,
          filePrefix,
          _args22 = arguments;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              arScale = _args22.length > 4 && _args22[4] !== undefined ? _args22[4] : true;
              meshes = this.getMeshesForAR();
              filePrefix = sceneName || "scene";
              filePrefix = filePrefix.replace(/[^a-z0-9]/gi, '_').toLowerCase();
              _context22.next = 6;
              return this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, sceneID, sceneCode, "glTF", arScale);
            case 6:
              return _context22.abrupt("return", _context22.sent);
            case 7:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function exportSceneToRemoteGlTFAsync(_x64, _x65, _x66, _x67) {
        return _exportSceneToRemoteGlTFAsync.apply(this, arguments);
      }
      return exportSceneToRemoteGlTFAsync;
    }()
  }, {
    key: "exportMeshToRemoteGlTFAsync",
    value: function () {
      var _exportMeshToRemoteGlTFAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(sceneRootUrl, mesh) {
        var arScale,
          meshes,
          filePrefix,
          _args23 = arguments;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              arScale = _args23.length > 2 && _args23[2] !== undefined ? _args23[2] : true;
              meshes = this.getMeshHierarchy(mesh.id);
              filePrefix = mesh.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
              _context23.next = 5;
              return this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, undefined, undefined, "glTF", arScale);
            case 5:
              return _context23.abrupt("return", _context23.sent);
            case 6:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function exportMeshToRemoteGlTFAsync(_x68, _x69) {
        return _exportMeshToRemoteGlTFAsync.apply(this, arguments);
      }
      return exportMeshToRemoteGlTFAsync;
    }()
  }, {
    key: "exportSceneToRemoteGLBAsync",
    value: function () {
      var _exportSceneToRemoteGLBAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(sceneName, sceneRootUrl, sceneID, sceneCode) {
        var arScale,
          meshes,
          filePrefix,
          _args24 = arguments;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              arScale = _args24.length > 4 && _args24[4] !== undefined ? _args24[4] : true;
              meshes = this.getMeshesForAR();
              filePrefix = sceneName || "scene";
              filePrefix = filePrefix.replace(/[^a-z0-9]/gi, '_').toLowerCase();
              _context24.next = 6;
              return this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, sceneID, sceneCode, "glb", arScale);
            case 6:
              return _context24.abrupt("return", _context24.sent);
            case 7:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function exportSceneToRemoteGLBAsync(_x70, _x71, _x72, _x73) {
        return _exportSceneToRemoteGLBAsync.apply(this, arguments);
      }
      return exportSceneToRemoteGLBAsync;
    }()
  }, {
    key: "exportMeshToRemoteGLBAsync",
    value: function () {
      var _exportMeshToRemoteGLBAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(sceneRootUrl, mesh) {
        var arScale,
          meshes,
          filePrefix,
          _args25 = arguments;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              arScale = _args25.length > 2 && _args25[2] !== undefined ? _args25[2] : true;
              meshes = this.getMeshHierarchy(mesh.id);
              filePrefix = mesh.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
              _context25.next = 5;
              return this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, undefined, undefined, "glb", arScale);
            case 5:
              return _context25.abrupt("return", _context25.sent);
            case 6:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function exportMeshToRemoteGLBAsync(_x74, _x75) {
        return _exportMeshToRemoteGLBAsync.apply(this, arguments);
      }
      return exportMeshToRemoteGLBAsync;
    }()
  }, {
    key: "exportSceneToARMultiformatAsync",
    value: function () {
      var _exportSceneToARMultiformatAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(sceneName, sceneRootUrl) {
        var formats,
          arScale,
          meshes,
          filePrefix,
          _args26 = arguments;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              formats = _args26.length > 2 && _args26[2] !== undefined ? _args26[2] : ["usdz", "glb", "png"];
              arScale = _args26.length > 3 && _args26[3] !== undefined ? _args26[3] : true;
              meshes = this.getMeshesForAR();
              filePrefix = sceneName || "scene";
              filePrefix = filePrefix.replace(/[^a-z0-9]/gi, '_').toLowerCase();
              _context26.next = 7;
              return this.exportMeshesToARMultiformatAsync(filePrefix, sceneRootUrl, meshes, formats, arScale);
            case 7:
              return _context26.abrupt("return", _context26.sent);
            case 8:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function exportSceneToARMultiformatAsync(_x76, _x77) {
        return _exportSceneToARMultiformatAsync.apply(this, arguments);
      }
      return exportSceneToARMultiformatAsync;
    }()
  }, {
    key: "exportMeshToARMultiformatAsync",
    value: function () {
      var _exportMeshToARMultiformatAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(sceneRootUrl, mesh) {
        var formats,
          arScale,
          meshes,
          filePrefix,
          _args27 = arguments;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              formats = _args27.length > 2 && _args27[2] !== undefined ? _args27[2] : ["usdz", "glb", "png"];
              arScale = _args27.length > 3 && _args27[3] !== undefined ? _args27[3] : true;
              meshes = this.getMeshHierarchy(mesh.id);
              filePrefix = mesh.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
              _context27.next = 6;
              return this.exportMeshesToARMultiformatAsync(filePrefix, sceneRootUrl, meshes, formats, arScale);
            case 6:
              return _context27.abrupt("return", _context27.sent);
            case 7:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function exportMeshToARMultiformatAsync(_x78, _x79) {
        return _exportMeshToARMultiformatAsync.apply(this, arguments);
      }
      return exportMeshToARMultiformatAsync;
    }()
  }, {
    key: "getGltfBlobForARExport",
    value: function () {
      var _getGltfBlobForARExport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(filePrefix, sceneRootUrl, meshes) {
        var options, gltf, zip, serverImages, key, _blob, blob;
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              // Opzioni di serializzazione
              options = {
                meshes: meshes,
                materials: this.getMeshesMaterials(meshes),
                transformNodes: undefined,
                lights: undefined,
                exportTextureUrls: sceneRootUrl !== null && sceneRootUrl !== undefined,
                rootUrl: sceneRootUrl,
                shouldExportNode: function shouldExportNode(node) {
                  for (var i = 0; i < meshes.length; i++) if (meshes[i] === node) return true;
                  return false;
                }
              };
              _context28.next = 3;
              return BABYLON.GLTF2Export.GLTFAsync(this._scene, filePrefix, options);
            case 3:
              gltf = _context28.sent;
              if (!gltf) {
                _context28.next = 16;
                break;
              }
              zip = new JSZip(); // Evito di fare l'upload delle immagini che posso scaricare lato server
              serverImages = gltf.serverImages && gltf.glTFFiles.hasOwnProperty("TextureUrls.txt") ? gltf.serverImages : [];
              for (key in gltf.glTFFiles) {
                if (serverImages.indexOf(key) === -1) {
                  _blob = gltf.glTFFiles[key];
                  if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_3__.StringTools.EndsWith(key, ".gltf") || _Misc_StringTools__WEBPACK_IMPORTED_MODULE_3__.StringTools.EndsWith(key, ".bin")) {
                    zip.file(key, _blob, {
                      compression: "DEFLATE",
                      compressionOptions: {
                        level: 9 // force a compression and a compression level for this file
                      }
                    });
                  } else {
                    zip.file(key, _blob, {
                      compression: "STORE" // no compression
                    });
                  }
                }
              }
              _context28.next = 10;
              return zip.generateAsync({
                type: "blob"
              });
            case 10:
              blob = _context28.sent;
              if (!blob) {
                _context28.next = 16;
                break;
              }
              blob = blob;
              blob.lastModifiedDate = new Date();
              blob.name = "arobj.zip";
              return _context28.abrupt("return", blob);
            case 16:
              return _context28.abrupt("return", null);
            case 17:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function getGltfBlobForARExport(_x80, _x81, _x82) {
        return _getGltfBlobForARExport.apply(this, arguments);
      }
      return getGltfBlobForARExport;
    }()
  }, {
    key: "exportMeshesToARAsync",
    value: function () {
      var _exportMeshesToARAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(filePrefix, sceneRootUrl, meshes, sceneID, sceneCode) {
        var fileFormat,
          arScale,
          arFileUrl,
          url,
          scale,
          blob,
          taskOptions,
          isOwin,
          chunkedTask,
          uploadResult,
          _args29 = arguments;
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              fileFormat = _args29.length > 5 && _args29[5] !== undefined ? _args29[5] : 'usdz';
              arScale = _args29.length > 6 && _args29[6] !== undefined ? _args29[6] : true;
              arFileUrl = "";
              if (!(sceneID && sceneCode && Zakeke.config)) {
                _context29.next = 14;
                break;
              }
              // Verifico se il file è già disponibile
              url = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + sceneID + "/" + sceneCode + "/" + fileFormat;
              _context29.prev = 5;
              _context29.next = 8;
              return jQuery.ajax({
                url: url,
                data: null,
                cache: false,
                contentType: false,
                processData: false,
                type: 'GET'
              });
            case 8:
              arFileUrl = _context29.sent;
              _context29.next = 14;
              break;
            case 11:
              _context29.prev = 11;
              _context29.t0 = _context29["catch"](5);
              arFileUrl = "";
            case 14:
              if (arFileUrl) {
                _context29.next = 31;
                break;
              }
              // Il file va generato
              scale = this.getSceneCmScalingFactor();
              /* Lascio l'adattamento al servizio di esportazione
              if (fileFormat !== "usdz" && scale)
                  scale /= 100;
              */
              _context29.next = 18;
              return this.getGltfBlobForARExport(filePrefix, sceneRootUrl, meshes);
            case 18:
              blob = _context29.sent;
              if (!blob) {
                _context29.next = 31;
                break;
              }
              taskOptions = {
                flipTextures: true,
                formats: [fileFormat]
              };
              if (sceneID) taskOptions.sceneID = sceneID;
              if (sceneCode) taskOptions.sceneCode = sceneCode;
              if (scale) taskOptions.scale = scale;
              isOwin = true;
              if (window["isOwin"] != undefined) isOwin = window["isOwin"];
              chunkedTask = new _composer_Components_ChunkedTask__WEBPACK_IMPORTED_MODULE_1__.Task("artasks", window["token"], isOwin);
              _context29.next = 29;
              return chunkedTask.upload(blob, taskOptions);
            case 29:
              uploadResult = _context29.sent;
              if (uploadResult && uploadResult.length > 0) {
                arFileUrl = uploadResult[0].arFileUrl;
              }
            case 31:
              return _context29.abrupt("return", arFileUrl);
            case 32:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this, [[5, 11]]);
      }));
      function exportMeshesToARAsync(_x83, _x84, _x85, _x86, _x87) {
        return _exportMeshesToARAsync.apply(this, arguments);
      }
      return exportMeshesToARAsync;
    }()
  }, {
    key: "exportMeshesToARMultiformatAsync",
    value: function () {
      var _exportMeshesToARMultiformatAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(filePrefix, sceneRootUrl, meshes) {
        var formats,
          arScale,
          result,
          scale,
          blob,
          taskOptions,
          isOwin,
          chunkedTask,
          uploadResult,
          i,
          res,
          _args30 = arguments;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              formats = _args30.length > 3 && _args30[3] !== undefined ? _args30[3] : ["usdz", "glb", "png"];
              arScale = _args30.length > 4 && _args30[4] !== undefined ? _args30[4] : true;
              result = [];
              scale = this.getSceneCmScalingFactor();
              _context30.next = 6;
              return this.getGltfBlobForARExport(filePrefix, sceneRootUrl, meshes);
            case 6:
              blob = _context30.sent;
              if (!blob) {
                _context30.next = 17;
                break;
              }
              taskOptions = {
                flipTextures: true,
                formats: formats
              };
              if (scale) taskOptions.scale = scale;
              isOwin = true;
              if (window["isOwin"] !== undefined) isOwin = window["isOwin"];
              chunkedTask = new _composer_Components_ChunkedTask__WEBPACK_IMPORTED_MODULE_1__.Task("artasks", window["token"], isOwin);
              _context30.next = 15;
              return chunkedTask.upload(blob, taskOptions);
            case 15:
              uploadResult = _context30.sent;
              if (uploadResult && uploadResult.length > 0) {
                for (i = 0; i < uploadResult.length; i++) {
                  res = uploadResult[i];
                  result.push(res);
                }
                //result = [...uploadResult];
              }
            case 17:
              return _context30.abrupt("return", result);
            case 18:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function exportMeshesToARMultiformatAsync(_x88, _x89, _x90) {
        return _exportMeshesToARMultiformatAsync.apply(this, arguments);
      }
      return exportMeshesToARMultiformatAsync;
    }() // Metodi per esportazione on-the-fly client side
  }, {
    key: "exportSceneToLocalGlTFBlobsAsync",
    value: function () {
      var _exportSceneToLocalGlTFBlobsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
        var filePrefix, options, gltf, blobs, key;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              filePrefix = Zakeke.generateUUID();
              options = this.getSceneToGltfExportOptions();
              _context31.next = 4;
              return BABYLON.GLTF2Export.GLTFAsync(this._scene, filePrefix, options);
            case 4:
              gltf = _context31.sent;
              blobs = [];
              for (key in gltf.glTFFiles) {
                blobs.push(gltf.glTFFiles[key]);
              }
              return _context31.abrupt("return", blobs);
            case 8:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function exportSceneToLocalGlTFBlobsAsync() {
        return _exportSceneToLocalGlTFBlobsAsync.apply(this, arguments);
      }
      return exportSceneToLocalGlTFBlobsAsync;
    }()
  }, {
    key: "exportSceneToLocalGlTFUrlsAsync",
    value: function () {
      var _exportSceneToLocalGlTFUrlsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
        var urls, filePrefix, options, gltf, key, blob;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              urls = [];
              filePrefix = Zakeke.generateUUID();
              options = this.getSceneToGltfExportOptions();
              _context32.next = 5;
              return BABYLON.GLTF2Export.GLTFAsync(this._scene, filePrefix, options);
            case 5:
              gltf = _context32.sent;
              if (gltf) {
                for (key in gltf.glTFFiles) {
                  blob = gltf.glTFFiles[key];
                  urls.push(this.getGltfFileUrl(key, blob));
                }
              }
              return _context32.abrupt("return", urls);
            case 8:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function exportSceneToLocalGlTFUrlsAsync() {
        return _exportSceneToLocalGlTFUrlsAsync.apply(this, arguments);
      }
      return exportSceneToLocalGlTFUrlsAsync;
    }()
  }, {
    key: "downloadSceneLocalGltfAsync",
    value: function () {
      var _downloadSceneLocalGltfAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
        var filePrefix, options, gltf;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              filePrefix = Zakeke.generateUUID();
              options = this.getSceneToGltfExportOptions();
              _context33.next = 4;
              return BABYLON.GLTF2Export.GLTFAsync(this._scene, filePrefix, options);
            case 4:
              gltf = _context33.sent;
              if (gltf) {
                gltf.downloadFiles();
              }
            case 6:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function downloadSceneLocalGltfAsync() {
        return _downloadSceneLocalGltfAsync.apply(this, arguments);
      }
      return downloadSceneLocalGltfAsync;
    }()
  }, {
    key: "exportSceneToLocalGLBBlobAsync",
    value: function () {
      var _exportSceneToLocalGLBBlobAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var result;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return this.getSceneLocalGLBBlobInfoAsync();
            case 2:
              result = _context34.sent;
              if (!result) {
                _context34.next = 5;
                break;
              }
              return _context34.abrupt("return", result.blob);
            case 5:
              return _context34.abrupt("return", null);
            case 6:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function exportSceneToLocalGLBBlobAsync() {
        return _exportSceneToLocalGLBBlobAsync.apply(this, arguments);
      }
      return exportSceneToLocalGLBBlobAsync;
    }()
  }, {
    key: "exportSceneToLocalGLBBase64Async",
    value: function () {
      var _exportSceneToLocalGLBBase64Async = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35() {
        var dataUrl, info, reader;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              dataUrl = null;
              _context35.next = 3;
              return this.getSceneLocalGLBBlobInfoAsync();
            case 3:
              info = _context35.sent;
              if (info && info.blob instanceof Blob) {
                reader = new FileReader();
                reader.readAsDataURL(info.blob);
                reader.onloadend = function () {
                  var res = reader.result;
                  if (typeof res === "string") dataUrl = res;
                };
              }
              return _context35.abrupt("return", dataUrl);
            case 6:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function exportSceneToLocalGLBBase64Async() {
        return _exportSceneToLocalGLBBase64Async.apply(this, arguments);
      }
      return exportSceneToLocalGLBBase64Async;
    }()
  }, {
    key: "exportSceneToLocalGLBUrlAsync",
    value: function () {
      var _exportSceneToLocalGLBUrlAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36() {
        var url, info;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              url = null;
              _context36.next = 3;
              return this.getSceneLocalGLBBlobInfoAsync();
            case 3:
              info = _context36.sent;
              if (info && info.name && info.blob instanceof Blob) {
                url = this.getGltfFileUrl(info.name, info.blob);
              }
              return _context36.abrupt("return", url);
            case 6:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
      function exportSceneToLocalGLBUrlAsync() {
        return _exportSceneToLocalGLBUrlAsync.apply(this, arguments);
      }
      return exportSceneToLocalGLBUrlAsync;
    }()
  }, {
    key: "downloadSceneLocalGLBAsync",
    value: function () {
      var _downloadSceneLocalGLBAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37() {
        var info, url, link;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              _context37.next = 2;
              return this.getSceneLocalGLBBlobInfoAsync();
            case 2:
              info = _context37.sent;
              if (info && info.name && info.blob instanceof Blob) {
                url = this.getGltfFileUrl(info.name, info.blob);
                link = document.createElement('a');
                document.body.appendChild(link);
                link.setAttribute("type", "hidden");
                link.download = info.name;
                link.href = url;
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
              }
            case 4:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this);
      }));
      function downloadSceneLocalGLBAsync() {
        return _downloadSceneLocalGLBAsync.apply(this, arguments);
      }
      return downloadSceneLocalGLBAsync;
    }()
  }, {
    key: "getSceneLocalGLBBlobInfoAsync",
    value: function () {
      var _getSceneLocalGLBBlobInfoAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38() {
        var _this20 = this;
        var result, filePrefix, options, gltf, _loop, key, _ret;
        return _regeneratorRuntime().wrap(function _callee38$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              result = {
                name: null,
                blob: null
              };
              filePrefix = Zakeke.generateUUID();
              options = this.getSceneToGltfExportOptions();
              _context39.next = 5;
              return BABYLON.GLTF2Export.GLBAsync(this._scene, filePrefix, options);
            case 5:
              gltf = _context39.sent;
              if (!(gltf && gltf.glTFFiles)) {
                _context39.next = 17;
                break;
              }
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var scale, s, quanternion, io, buffer, doc, roots, a1, canRotate, glbArray, glbBlob;
                return _regeneratorRuntime().wrap(function _loop$(_context38) {
                  while (1) switch (_context38.prev = _context38.next) {
                    case 0:
                      if (!_Misc_StringTools__WEBPACK_IMPORTED_MODULE_3__.StringTools.EndsWith(key, ".glb")) {
                        _context38.next = 19;
                        break;
                      }
                      // Using glTF-Transform for gltf scaling and rotation
                      scale = _this20.getSceneCmScalingFactor();
                      s = 1;
                      if (scale) s = scale / 100;
                      quanternion = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.Y, 2 * Math.PI);
                      io = new _gltf_transform_core__WEBPACK_IMPORTED_MODULE_6__.WebIO();
                      _context38.next = 8;
                      return gltf.glTFFiles[key].arrayBuffer();
                    case 8:
                      buffer = _context38.sent;
                      doc = io.readBinary(buffer);
                      roots = doc.getRoot().listNodes().filter(function (n) {
                        return n.getParent() === null || n.getParent() instanceof _gltf_transform_core__WEBPACK_IMPORTED_MODULE_6__.Scene;
                      });
                      a1 = [0, 1, 0, 0];
                      canRotate = roots.every(function (r) {
                        var a2 = r.getRotation();
                        return a1.length === a2.length && a1.every(function (value, index) {
                          return value === a2[index];
                        });
                      });
                      roots.forEach(function (r) {
                        r.setScale([s, s, s]);

                        // La questione rotazione necessita di approfondimento
                        if (canRotate) {
                          r.setRotation([quanternion.x, quanternion.y, quanternion.z, quanternion.w]);
                        }
                      });
                      glbArray = io.writeBinary(doc); // Document → Uint8Array
                      glbBlob = new Blob([glbArray], {
                        type: "model/gltf-binary"
                      }); // ------------------------------
                      result.name = key;
                      //result.blob = gltf.glTFFiles[key];
                      result.blob = glbBlob;
                      return _context38.abrupt("return", "break");
                    case 19:
                    case "end":
                      return _context38.stop();
                  }
                }, _loop);
              });
              _context39.t0 = _regeneratorRuntime().keys(gltf.glTFFiles);
            case 9:
              if ((_context39.t1 = _context39.t0()).done) {
                _context39.next = 17;
                break;
              }
              key = _context39.t1.value;
              return _context39.delegateYield(_loop(), "t2", 12);
            case 12:
              _ret = _context39.t2;
              if (!(_ret === "break")) {
                _context39.next = 15;
                break;
              }
              return _context39.abrupt("break", 17);
            case 15:
              _context39.next = 9;
              break;
            case 17:
              return _context39.abrupt("return", result);
            case 18:
            case "end":
              return _context39.stop();
          }
        }, _callee38, this);
      }));
      function getSceneLocalGLBBlobInfoAsync() {
        return _getSceneLocalGLBBlobInfoAsync.apply(this, arguments);
      }
      return getSceneLocalGLBBlobInfoAsync;
    }() // -----------------------------------------------------------------------
    // Metodi per exportazione della scena in USDZ su client (on-the-fly)
  }, {
    key: "exportSceneToLocalUSDZBlobAsync",
    value: function () {
      var _exportSceneToLocalUSDZBlobAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
        var result;
        return _regeneratorRuntime().wrap(function _callee39$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.next = 2;
              return this.getSceneLocalUSDZBlobInfoAsync();
            case 2:
              result = _context40.sent;
              if (!result) {
                _context40.next = 5;
                break;
              }
              return _context40.abrupt("return", result.blob);
            case 5:
              return _context40.abrupt("return", null);
            case 6:
            case "end":
              return _context40.stop();
          }
        }, _callee39, this);
      }));
      function exportSceneToLocalUSDZBlobAsync() {
        return _exportSceneToLocalUSDZBlobAsync.apply(this, arguments);
      }
      return exportSceneToLocalUSDZBlobAsync;
    }()
  }, {
    key: "exportSceneToLocalUSDZBase64Async",
    value: function () {
      var _exportSceneToLocalUSDZBase64Async = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
        var dataUrl, info, reader;
        return _regeneratorRuntime().wrap(function _callee40$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              dataUrl = null;
              _context41.next = 3;
              return this.getSceneLocalUSDZBlobInfoAsync();
            case 3:
              info = _context41.sent;
              if (info && info.blob instanceof Blob) {
                reader = new FileReader();
                reader.readAsDataURL(info.blob);
                reader.onloadend = function () {
                  var res = reader.result;
                  if (typeof res === "string") dataUrl = res;
                };
              }
              return _context41.abrupt("return", dataUrl);
            case 6:
            case "end":
              return _context41.stop();
          }
        }, _callee40, this);
      }));
      function exportSceneToLocalUSDZBase64Async() {
        return _exportSceneToLocalUSDZBase64Async.apply(this, arguments);
      }
      return exportSceneToLocalUSDZBase64Async;
    }()
  }, {
    key: "exportSceneToLocalUSDZUrlAsync",
    value: function () {
      var _exportSceneToLocalUSDZUrlAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var url, info;
        return _regeneratorRuntime().wrap(function _callee41$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              url = null;
              _context42.next = 3;
              return this.getSceneLocalUSDZBlobInfoAsync();
            case 3:
              info = _context42.sent;
              if (info && info.name && info.blob instanceof Blob) {
                url = this.getUsdzFileUrl(info.name, info.blob);
              }
              return _context42.abrupt("return", url);
            case 6:
            case "end":
              return _context42.stop();
          }
        }, _callee41, this);
      }));
      function exportSceneToLocalUSDZUrlAsync() {
        return _exportSceneToLocalUSDZUrlAsync.apply(this, arguments);
      }
      return exportSceneToLocalUSDZUrlAsync;
    }()
  }, {
    key: "downloadSceneLocalUSDZAsync",
    value: function () {
      var _downloadSceneLocalUSDZAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
        var info, url, link;
        return _regeneratorRuntime().wrap(function _callee42$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              _context43.next = 2;
              return this.getSceneLocalUSDZBlobInfoAsync();
            case 2:
              info = _context43.sent;
              if (info && info.name && info.blob instanceof Blob) {
                url = this.getUsdzFileUrl(info.name, info.blob);
                link = document.createElement('a');
                document.body.appendChild(link);
                link.setAttribute("type", "hidden");
                link.download = info.name;
                link.href = url;
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
              }
            case 4:
            case "end":
              return _context43.stop();
          }
        }, _callee42, this);
      }));
      function downloadSceneLocalUSDZAsync() {
        return _downloadSceneLocalUSDZAsync.apply(this, arguments);
      }
      return downloadSceneLocalUSDZAsync;
    }()
  }, {
    key: "getSceneLocalUSDZBlobInfoAsync",
    value: function () {
      var _getSceneLocalUSDZBlobInfoAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        var result, glbInfo, glbUrl, usdzBlob;
        return _regeneratorRuntime().wrap(function _callee43$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              result = {
                name: null,
                blob: null
              };
              _context44.next = 3;
              return this.getSceneLocalGLBBlobInfoAsync();
            case 3:
              glbInfo = _context44.sent;
              if (!(glbInfo && glbInfo.name && glbInfo.blob && glbInfo.blob instanceof Blob)) {
                _context44.next = 11;
                break;
              }
              glbUrl = this.getGltfFileUrl(glbInfo.name, glbInfo.blob);
              _context44.next = 8;
              return _USDZ_UsdzHelper__WEBPACK_IMPORTED_MODULE_5__.UsdzHelper.convertGlbToUsdz(glbUrl);
            case 8:
              usdzBlob = _context44.sent;
              result.name = glbInfo.name.replace(".glb", ".usdz");
              result.blob = usdzBlob;
            case 11:
              return _context44.abrupt("return", result);
            case 12:
            case "end":
              return _context44.stop();
          }
        }, _callee43, this);
      }));
      function getSceneLocalUSDZBlobInfoAsync() {
        return _getSceneLocalUSDZBlobInfoAsync.apply(this, arguments);
      }
      return getSceneLocalUSDZBlobInfoAsync;
    }() // -----------------------------------------------------------------------
  }, {
    key: "getSceneToGltfExportOptions",
    value: function getSceneToGltfExportOptions() {
      var meshes = this.getMeshesForAR();
      var options = {
        meshes: meshes,
        materials: this.getMeshesMaterials(meshes),
        transformNodes: undefined,
        lights: undefined,
        exportTextureUrls: false,
        rootUrl: null,
        shouldExportNode: function shouldExportNode(node) {
          for (var i = 0; i < meshes.length; i++) if (meshes[i] === node) return true;
          return false;
        }
      };
      return options;
    }
  }, {
    key: "getGltfFileUrl",
    value: function getGltfFileUrl(name, blob) {
      var mimeType = undefined;
      if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_3__.StringTools.EndsWith(name, ".glb")) {
        mimeType = {
          type: "model/gltf-binary"
        };
      } else if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_3__.StringTools.EndsWith(name, ".bin")) {
        mimeType = {
          type: "application/octet-stream"
        };
      } else if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_3__.StringTools.EndsWith(name, ".gltf")) {
        mimeType = {
          type: "model/gltf+json"
        };
      } else if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_3__.StringTools.EndsWith(name, ".jpeg")) {
        mimeType = {
          type: "image/jpeg"
        };
      } else if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_3__.StringTools.EndsWith(name, ".png")) {
        mimeType = {
          type: "image/png"
        };
      }
      return window.URL.createObjectURL(new Blob([blob], mimeType));
    }
  }, {
    key: "getUsdzFileUrl",
    value: function getUsdzFileUrl(name, blob) {
      var mimeType = {
        type: "model/vnd.usdz+zip"
      };
      return window.URL.createObjectURL(new Blob([blob], mimeType));
    }
  }, {
    key: "exportSceneToBabylon",
    value: function exportSceneToBabylon() {
      var serializedScene = BABYLON.SceneSerializer.Serialize(this._scene);
      var json = JSON.stringify(serializedScene);
      return json;
    }
  }, {
    key: "exportVisibleMeshesToBabylon",
    value: function exportVisibleMeshesToBabylon() {
      var meshes = this.getVisibleMeshes();
      var serializedMeshes = BABYLON.SceneSerializer.SerializeMesh(meshes, false, false);
      var json = JSON.stringify(serializedMeshes);
      return json;
    }
  }, {
    key: "downloadImageFromBase64",
    value: function downloadImageFromBase64(base64, name, mimetype) {
      var a = document.createElement("a"); //Create <a>
      a.href = base64; //Image Base64 Goes here
      a.download = name; //File name Here
      a.click(); //Downloaded file
      a.remove();
    }
  }, {
    key: "getStandardMaterialTextureType",
    value: function getStandardMaterialTextureType(material, texture) {
      if (material.diffuseTexture === texture) return "diffuse";
      if (material.emissiveTexture === texture) return "emissive";
      if (material.ambientTexture === texture) return "ambient";
      if (material.lightmapTexture === texture) return "lightmap";
      if (material.opacityTexture === texture) return "opacity";
      if (material.specularTexture === texture) return "specular";
      if (material.reflectionTexture === texture) return "reflection";
      if (material.refractionTexture === texture) return "refraction";
      if (material.bumpTexture === texture) return "bump";
      return null;
    }
  }, {
    key: "getPBRMetallicRoughnessMaterialTextureType",
    value: function getPBRMetallicRoughnessMaterialTextureType(material, texture) {
      if (material.environmentTexture === texture) return "environment";
      if (material.normalTexture === texture) return "normal";
      if (material.emissiveTexture === texture) return "emissive";
      if (material.occlusionTexture === texture) return "occlusion";
      if (material.baseTexture === texture) return "base";
      if (material.metallicRoughnessTexture === texture) return "metallicRoughness";
      return null;
    }
  }, {
    key: "getPBRSpecularGlossinessMaterialTextureType",
    value: function getPBRSpecularGlossinessMaterialTextureType(material, texture) {
      if (material.environmentTexture === texture) return "environment";
      if (material.normalTexture === texture) return "normal";
      if (material.emissiveTexture === texture) return "emissive";
      if (material.occlusionTexture === texture) return "occlusion";
      if (material.diffuseTexture === texture) return "diffuse";
      if (material.specularGlossinessTexture === texture) return "specularGlossiness";
      return null;
    }
  }, {
    key: "getPBRMaterialTextureType",
    value: function getPBRMaterialTextureType(material, texture) {
      if (material.cameraColorGradingTexture === texture) return "cameraColorGrading";
      if (material.albedoTexture === texture) return "albedo";
      if (material.ambientTexture === texture) return "ambient";
      if (material.opacityTexture === texture) return "opacity";
      if (material.reflectionTexture === texture) return "reflection";
      if (material.emissiveTexture === texture) return "emissive";
      if (material.reflectivityTexture === texture) return "reflectivity";
      if (material.metallicTexture === texture) return "metallic";
      if (material.microSurfaceTexture === texture) return "microSurface";
      if (material.bumpTexture === texture) return "bump";
      if (material.lightmapTexture === texture) return "lightmap";
      if (material.refractionTexture === texture) return "refraction";
      if (material.clearCoat) {
        if (material.clearCoat.texture === texture) return "clearCoat";
        if (material.clearCoat.bumpTexture === texture) return "clearCoat_bump";
        if (material.clearCoat.tintTexture === texture) return "clearCoat_tint";
        if (material.clearCoat.textureRoughness === texture) return "clearCoat_textureRoughness";
        if (material.clearCoat.texture === texture) return "clearCoat_texture";
      }
      if (material.anisotropy) {
        if (material.anisotropy.texture === texture) return "anisotropy_texture";
      }
      if (material.sheen) {
        if (material.sheen.texture === texture) return "sheen_texture";
        if (material.sheen.textureRoughness === texture) return "sheen_textureRoughness";
      }
      if (material.subSurface) {
        if (material.subSurface.thicknessTexture === texture) return "subSurface_thickness";
        if (material.subSurface.refractionIntensityTexture === texture) return "subSurface_refractionIntensity";
        if (material.subSurface.translucencyIntensityTexture === texture) return "subSurface_translucencyIntensity";
      }
      return null;
    }
  }, {
    key: "getZakekePBRMaterialTextureType",
    value: function getZakekePBRMaterialTextureType(material, texture) {
      if (material.albedoTexture === texture) return "albedo";
      if (material.bumpTexture === texture) return "bump";
      if (material.reflectionTexture === texture) return "reflection";
      if (material.matCapReflectionTexture === texture) return "matCapReflection";
      if (material.reflectivityTexture === texture) return "reflectivity";
      if (material.microsurfaceTexture === texture) return "microsurface";
      if (material.ambientTexture === texture) return "ambient";
      if (material.aoTexture === texture) return "ao";
      if (material.opacityTexture === texture) return "opacity";
      return null;
    }
  }, {
    key: "getMaterialTextureType",
    value: function getMaterialTextureType(material, texture) {
      if (material instanceof BABYLON.StandardMaterial) return this.getStandardMaterialTextureType(material, texture);
      if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) return this.getPBRMetallicRoughnessMaterialTextureType(material, texture);
      if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) return this.getPBRSpecularGlossinessMaterialTextureType(material, texture);
      if (material instanceof BABYLON.PBRMaterial) return this.getPBRMaterialTextureType(material, texture);
      if (material instanceof Zakeke.PBRMaterial) return this.getZakekePBRMaterialTextureType(material, texture);
      return null;
    }
  }, {
    key: "getMaterialTexture",
    value: function getMaterialTexture(material, type) {
      if (material instanceof BABYLON.StandardMaterial) {
        switch (type) {
          case "diffuse":
            return material.diffuseTexture;
          case "emissive":
            return material.emissiveTexture;
          case "ambient":
            return material.ambientTexture;
          case "lightmap":
            return material.lightmapTexture;
          case "opacity":
            return material.opacityTexture;
          case "specular":
            return material.specularTexture;
          case "reflection":
            return material.reflectionTexture;
          case "refraction":
            return material.refractionTexture;
          case "bump":
            return material.bumpTexture;
        }
      } else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
        switch (type) {
          case "environment":
          case "normal":
          case "emissive":
          case "occlusion":
          case "base":
          case "metallicRoughness":
            return material["".concat(type, "Texture")];
        }
      } else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
        switch (type) {
          case "environment":
          case "normal":
          case "emissive":
          case "occlusion":
          case "diffuse":
          case "specularGlossiness":
            return material["".concat(type, "Texture")];
        }
      } else if (material instanceof BABYLON.PBRMaterial) {
        switch (type) {
          case "cameraColorGrading":
            return material.cameraColorGradingTexture;
          case "albedo":
          case "ambient":
          case "opacity":
          case "reflection":
          case "emissive":
          case "reflectivity":
          case "metallic":
          case "microSurface":
          case "bump":
          case "lightmap":
            return material["".concat(type, "Texture")];
          case "refraction":
            return material.refractionTexture;
          case "environmentBRDF":
            return material.environmentBRDFTexture;
          case "clearCoat_texture":
            return material.clearCoat.texture;
          case "clearCoat_bump":
            return material.clearCoat.bumpTexture;
          case "clearCoat_tint":
            return material.clearCoat.tintTexture;
          case "clearCoat_textureRoughness":
            return material.clearCoat.textureRoughness;
          case "anisotropy_texture":
            return material.anisotropy.texture;
          case "sheen_texture":
            return material.sheen.texture;
          case "sheen_textureRoughness":
            return material.sheen.textureRoughness;
          case "subSurface_thickness":
            return material.subSurface.thicknessTexture;
          case "subSurface_translucencyIntensity":
            return material.subSurface.translucencyIntensityTexture;
          case "subSurface_refractionIntensity":
            return material.subSurface.refractionIntensityTexture;
        }
      } else if (material instanceof Zakeke.PBRMaterial) {
        switch (type) {
          case "albedo":
            return material.albedoTexture;
          case "bump":
            return material.bumpTexture;
          case "reflection":
            return material.reflectionTexture;
          case "matCapReflection":
            return material.matCapReflectionTexture;
          case "reflectivity":
            return material.reflectivityTexture;
          case "microsurface":
            return material.microsurfaceTexture;
          case "ambient":
            return material.ambientTexture;
          case "ao":
            return material.aoTexture;
          case "opacity":
            return material.opacityTexture;
        }
      }
      return null;
    }
  }, {
    key: "applyTexture",
    value: function applyTexture(texture, material, type) {
      // Lightmap always on second channel
      if (texture && type == "lightmap") {
        texture.coordinatesIndex = 1;
        if (material instanceof BABYLON.StandardMaterial || material instanceof BABYLON.PBRMaterial || material instanceof BABYLON.PBRBaseSimpleMaterial) material.useLightmapAsShadowmap = true;
      }
      if (material instanceof BABYLON.StandardMaterial) {
        switch (type) {
          case "diffuse":
            material.diffuseTexture = texture;
            break;
          case "emissive":
            material.emissiveTexture = texture;
            break;
          case "ambient":
            material.ambientTexture = texture;
            break;
          case "lightmap":
            material.lightmapTexture = texture;
            break;
          case "opacity":
            material.opacityTexture = texture;
            break;
          case "specular":
            material.specularTexture = texture;
            break;
          case "reflection":
            material.reflectionTexture = texture;
            break;
          case "refraction":
            material.refractionTexture = texture;
            break;
          case "bump":
            material.bumpTexture = texture;
            break;
        }
      } else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
        switch (type) {
          case "environment":
          case "normal":
          case "emissive":
          case "occlusion":
          case "base":
          case "metallicRoughness":
            material["".concat(type, "Texture")] = texture;
            break;
        }
      } else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
        switch (type) {
          case "environment":
          case "normal":
          case "emissive":
          case "occlusion":
          case "diffuse":
          case "specularGlossiness":
            material["".concat(type, "Texture")] = texture;
            break;
        }
      } else if (material instanceof BABYLON.PBRMaterial) {
        switch (type) {
          case "cameraColorGrading":
            material.cameraColorGradingTexture = texture;
            break;
          case "albedo":
          case "ambient":
          case "opacity":
          case "reflection":
          case "emissive":
          case "reflectivity":
          case "metallic":
          case "microSurface":
          case "bump":
          case "lightmap":
            material["".concat(type, "Texture")] = texture;
            break;
          case "refraction":
            material.refractionTexture = texture;
            break;
          case "environmentBRDF":
            material.environmentBRDFTexture = texture;
            break;
          case "clearCoat_texture":
            material.clearCoat.texture = texture;
            break;
          case "clearCoat_bump":
            material.clearCoat.bumpTexture = texture;
            break;
          case "clearCoat_tint":
            material.clearCoat.tintTexture = texture;
            break;
          case "clearCoat_textureRoughness":
            material.clearCoat.textureRoughness = texture;
            break;
          case "anisotropy_texture":
            material.anisotropy.texture = texture;
            break;
          case "sheen_texture":
            material.sheen.texture = texture;
            break;
          case "sheen_textureRoughness":
            material.sheen.textureRoughness = texture;
            break;
          case "subSurface_thickness":
            material.subSurface.thicknessTexture = texture;
            break;
          case "subSurface_translucencyIntensity":
            material.subSurface.translucencyIntensityTexture = texture;
            break;
          case "subSurface_refractionIntensity":
            material.subSurface.refractionIntensityTexture = texture;
            break;
        }
      } else if (material instanceof BABYLON.ShaderMaterial) {
        if (texture && texture instanceof BABYLON.Texture) material.setTexture(type, texture);else material.removeTexture(type);
      } else if (material instanceof Zakeke.PBRMaterial) {
        switch (type) {
          case "albedo":
            material.albedoTexture = texture;
            break;
          case "bump":
            material.bumpTexture = texture;
            break;
          case "reflection":
            material.reflectionTexture = texture;
            break;
          case "matCapReflection":
            material.matCapReflectionTexture = texture;
            break;
          case "reflectivity":
            material.reflectivityTexture = texture;
            break;
          case "microsurface":
            material.microsurfaceTexture = texture;
            break;
          case "ambient":
            material.ambientTexture = texture;
            break;
          case "ao":
            material.aoTexture = texture;
            break;
          case "opacity":
            material.opacityTexture = texture;
            break;
        }
      }
    }
  }, {
    key: "applyTextureOnSerializedMaterial",
    value: function applyTextureOnSerializedMaterial(serializedTexture, serializedMaterial, textureType, materialType) {
      // Lightmap always on second channel
      if (serializedTexture && textureType == "lightmap") {
        serializedTexture.coordinatesIndex = 1;
        if (materialType === "BABYLON.StandardMaterial" || materialType === "BABYLON.PBRMaterial" || materialType === "BABYLON.PBRBaseSimpleMaterial") serializedMaterial["useLightmapAsShadowmap"] = true;
      }
      if (materialType === "BABYLON.StandardMaterial") {
        serializedMaterial["".concat(textureType, "Texture")] = serializedTexture;
      } else if (materialType === "BABYLON.PBRMetallicRoughnessMaterial") {
        serializedMaterial["".concat(textureType, "Texture")] = serializedTexture;
      } else if (materialType === "BABYLON.PBRSpecularGlossinessMaterial") {
        serializedMaterial["".concat(textureType, "Texture")] = serializedTexture;
      } else if (materialType === "BABYLON.PBRMaterial") {
        switch (textureType) {
          case "cameraColorGrading":
            serializedMaterial["cameraColorGradingTexture"] = serializedTexture;
            break;
          case "albedo":
          case "ambient":
          case "opacity":
          case "reflection":
          case "emissive":
          case "reflectivity":
          case "metallic":
          case "microSurface":
          case "bump":
          case "lightmap":
          case "refraction":
            serializedMaterial["".concat(textureType, "Texture")] = serializedTexture;
            break;
          case "environmentBRDF":
            serializedMaterial.environmentBRDFTexture = serializedTexture;
            break;
          case "clearCoat_texture":
            serializedMaterial.clearCoat.texture = serializedTexture;
            break;
          case "clearCoat_bump":
            serializedMaterial.clearCoat.bumpTexture = serializedTexture;
            break;
          case "clearCoat_tint":
            serializedMaterial.clearCoat.tintTexture = serializedTexture;
            break;
          case "clearCoat_textureRoughness":
            serializedMaterial.clearCoat.textureRoughness = serializedTexture;
            break;
          case "anisotropy_texture":
            serializedMaterial.anisotropy.texture = serializedTexture;
            break;
          case "sheen_texture":
            serializedMaterial.sheen.texture = serializedTexture;
            break;
          case "sheen_textureRoughness":
            serializedMaterial.sheen.textureRoughness = serializedTexture;
            break;
          case "subSurface_thickness":
            serializedMaterial.subSurface.thicknessTexture = serializedTexture;
            break;
          case "subSurface_translucencyIntensity":
            serializedMaterial.subSurface.translucencyIntensityTexture = serializedTexture;
            break;
          case "subSurface_refractionIntensity":
            serializedMaterial.subSurface.refractionIntensityTexture = serializedTexture;
            break;
        }
      } else if (materialType === "Zakeke.PBRMaterial") {
        serializedMaterial["".concat(textureType, "Texture")] = serializedTexture;
      }
    }
  }, {
    key: "getSerializedMaterialTexture",
    value: function getSerializedMaterialTexture(serializedMaterial, textureType, materialType) {
      if (materialType === "BABYLON.StandardMaterial") {
        return serializedMaterial["".concat(textureType, "Texture")];
      } else if (materialType === "BABYLON.PBRMetallicRoughnessMaterial") {
        return serializedMaterial["".concat(textureType, "Texture")];
      } else if (materialType === "BABYLON.PBRSpecularGlossinessMaterial") {
        return serializedMaterial["".concat(textureType, "Texture")];
      } else if (materialType === "BABYLON.PBRMaterial") {
        switch (textureType) {
          case "cameraColorGrading":
            return serializedMaterial["cameraColorGradingTexture"];
          case "albedo":
          case "ambient":
          case "opacity":
          case "reflection":
          case "emissive":
          case "reflectivity":
          case "metallic":
          case "microSurface":
          case "bump":
          case "lightmap":
          case "refraction":
            return serializedMaterial["".concat(textureType, "Texture")];
          case "environmentBRDF":
            return serializedMaterial.environmentBRDFTexture;
          case "clearCoat_texture":
            return serializedMaterial.clearCoat.texture;
          case "clearCoat_bump":
            return serializedMaterial.clearCoat.bumpTexture;
          case "clearCoat_tint":
            return serializedMaterial.clearCoat.tintTexture;
          case "clearCoat_textureRoughness":
            return serializedMaterial.clearCoat.textureRoughness;
          case "anisotropy_texture":
            return serializedMaterial.anisotropy.texture;
          case "sheen_texture":
            return serializedMaterial.sheen.texture;
          case "sheen_textureRoughness":
            return serializedMaterial.sheen.textureRoughness;
          case "subSurface_thickness":
            return serializedMaterial.subSurface.thicknessTexture;
          case "subSurface_translucencyIntensity":
            return serializedMaterial.subSurface.translucencyIntensityTexture;
          case "subSurface_refractionIntensity":
            return serializedMaterial.subSurface.refractionIntensityTexture;
        }
      } else if (materialType === "Zakeke.PBRMaterial") {
        return serializedMaterial["".concat(textureType, "Texture")];
      }
      return null;
    }
  }, {
    key: "getMaterialTypeName",
    value: function getMaterialTypeName(material) {
      if (material instanceof BABYLON.StandardMaterial) return "BABYLON.StandardMaterial";
      if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) return "BABYLON.PBRMetallicRoughnessMaterial";
      if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) return "BABYLON.PBRSpecularGlossinessMaterial";
      if (material instanceof BABYLON.PBRMaterial) return "BABYLON.PBRMaterial";
      if (material instanceof BABYLON.ShaderMaterial) return "BABYLON.ShaderMaterial";
      if (material instanceof Zakeke.PBRMaterial) return "Zakeke.PBRMaterial";
      return "BABYLON.StandardMaterial";
    }
  }, {
    key: "exportMeshToBabylon",
    value: function () {
      var _exportMeshToBabylon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44(mesh) {
        var meshes;
        return _regeneratorRuntime().wrap(function _callee44$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              meshes = this.getMeshHierarchy(mesh.id);
              _context45.next = 3;
              return this.exportMeshesToBabylon(meshes);
            case 3:
              return _context45.abrupt("return", _context45.sent);
            case 4:
            case "end":
              return _context45.stop();
          }
        }, _callee44, this);
      }));
      function exportMeshToBabylon(_x91) {
        return _exportMeshToBabylon.apply(this, arguments);
      }
      return exportMeshToBabylon;
    }()
  }, {
    key: "exportMeshesToBabylon",
    value: function () {
      var _exportMeshesToBabylon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45(meshes) {
        var _this21 = this;
        var materials, meshSerializability, materialSerializability, materialTextures, i, material, materialID, textures, j, texture, textureID, type, base64String, textureData, serializedMeshes, _iterator, _step, _loop2, json;
        return _regeneratorRuntime().wrap(function _callee45$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              materials = this.getMeshesMaterials(meshes); // Save previous serializable property value
              meshSerializability = meshes.map(function (m) {
                return {
                  id: m.id,
                  doNotSerialize: m.doNotSerialize
                };
              });
              materialSerializability = materials.map(function (m) {
                return {
                  id: m.id,
                  doNotSerialize: m.doNotSerialize
                };
              }); // set all serializable
              meshes.forEach(function (m) {
                return m.doNotSerialize = false;
              });
              materials.forEach(function (m) {
                return m.doNotSerialize = false;
              });

              // For dynamic textures (blobs and procedurals) get the data uri to embed in the finale json
              _context47.prev = 5;
              materialTextures = {};
              i = 0;
            case 8:
              if (!(i < materials.length)) {
                _context47.next = 29;
                break;
              }
              material = materials[i];
              materialID = material.id;
              textures = this.getMaterialDynamicTextures(material);
              if (!(textures.length > 0)) {
                _context47.next = 26;
                break;
              }
              materialTextures[materialID] = {
                materialType: this.getMaterialTypeName(material),
                textures: []
              };
              j = 0;
            case 15:
              if (!(j < textures.length)) {
                _context47.next = 26;
                break;
              }
              texture = textures[j];
              textureID = Zakeke.generateUUID();
              type = this.getMaterialTextureType(material, texture);
              _context47.next = 21;
              return this.exportTextureToBase64Async(texture, "image/png");
            case 21:
              base64String = _context47.sent;
              if (type && base64String) {
                textureData = {
                  id: textureID,
                  type: type,
                  base64String: base64String,
                  isProcedural: texture instanceof BABYLON.ProceduralTexture
                };
                materialTextures[materialID].textures.push(textureData);
              }
            case 23:
              j++;
              _context47.next = 15;
              break;
            case 26:
              i++;
              _context47.next = 8;
              break;
            case 29:
              serializedMeshes = BABYLON.SceneSerializer.SerializeMesh(meshes, false, false); // now for each dynamic texture we embed the base64 data uri
              _iterator = _createForOfIteratorHelper(serializedMeshes.materials);
              _context47.prev = 31;
              _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                var serializedMaterial, propertyNames, materialID, materialInfo, materialType, textureInfoArray, _iterator2, _step2, textureInfo, serializedTexture, tempTexture, newTextureJson;
                return _regeneratorRuntime().wrap(function _loop2$(_context46) {
                  while (1) switch (_context46.prev = _context46.next) {
                    case 0:
                      serializedMaterial = _step.value;
                      propertyNames = Object.getOwnPropertyNames(serializedMaterial).filter(function (n) {
                        return n.slice(-"Texture".length) === "Texture" && _typeof(serializedMaterial[n]) === "object";
                      });
                      materialID = serializedMaterial.id;
                      if (!materialTextures.hasOwnProperty(materialID)) {
                        _context46.next = 48;
                        break;
                      }
                      materialInfo = materialTextures[materialID];
                      materialType = materialInfo.materialType;
                      textureInfoArray = materialInfo.textures;
                      _iterator2 = _createForOfIteratorHelper(textureInfoArray);
                      _context46.prev = 8;
                      _iterator2.s();
                    case 10:
                      if ((_step2 = _iterator2.n()).done) {
                        _context46.next = 40;
                        break;
                      }
                      textureInfo = _step2.value;
                      serializedTexture = _this21.getSerializedMaterialTexture(serializedMaterial, textureInfo.type, materialInfo.materialType);
                      if (!serializedTexture) {
                        _context46.next = 36;
                        break;
                      }
                      if (!textureInfo.isProcedural) {
                        _context46.next = 34;
                        break;
                      }
                      tempTexture = new BABYLON.Texture(textureInfo.base64String, _this21._scene, undefined, undefined, undefined, undefined);
                      _context46.next = 18;
                      return SceneHelper.whenTextureIsReadyAsync(tempTexture);
                    case 18:
                      tempTexture.uScale = serializedTexture.uScale;
                      tempTexture.vScale = serializedTexture.vScale;
                      tempTexture.uOffset = serializedTexture.uOffset;
                      tempTexture.vOffset = serializedTexture.vOffset;
                      tempTexture.uAng = serializedTexture.uAng;
                      tempTexture.vAng = serializedTexture.vAng;
                      tempTexture.level = serializedTexture.level;
                      tempTexture.coordinatesIndex = serializedTexture.coordinatesIndex;
                      tempTexture.coordinatesMode = serializedTexture.coordinatesMode;
                      tempTexture.wrapU = serializedTexture.wrapU;
                      tempTexture.wrapV = serializedTexture.wrapV;
                      newTextureJson = tempTexture.serialize();
                      newTextureJson.url = textureInfo.base64String;
                      newTextureJson.name = "prcedural texture";
                      _this21.applyTextureOnSerializedMaterial(newTextureJson, serializedMaterial, textureInfo.type, materialType);
                      tempTexture.dispose();
                    case 34:
                      _context46.next = 38;
                      break;
                    case 36:
                      serializedTexture.url = textureInfo.base64String;
                      serializedTexture.name = "dynamic texture";
                    case 38:
                      _context46.next = 10;
                      break;
                    case 40:
                      _context46.next = 45;
                      break;
                    case 42:
                      _context46.prev = 42;
                      _context46.t0 = _context46["catch"](8);
                      _iterator2.e(_context46.t0);
                    case 45:
                      _context46.prev = 45;
                      _iterator2.f();
                      return _context46.finish(45);
                    case 48:
                    case "end":
                      return _context46.stop();
                  }
                }, _loop2, null, [[8, 42, 45, 48]]);
              });
              _iterator.s();
            case 34:
              if ((_step = _iterator.n()).done) {
                _context47.next = 38;
                break;
              }
              return _context47.delegateYield(_loop2(), "t0", 36);
            case 36:
              _context47.next = 34;
              break;
            case 38:
              _context47.next = 43;
              break;
            case 40:
              _context47.prev = 40;
              _context47.t1 = _context47["catch"](31);
              _iterator.e(_context47.t1);
            case 43:
              _context47.prev = 43;
              _iterator.f();
              return _context47.finish(43);
            case 46:
              json = JSON.stringify(serializedMeshes); // Reset doNotSerialize property value
              meshes.forEach(function (m) {
                var _meshSerializability$;
                return m.doNotSerialize = (_meshSerializability$ = meshSerializability.find(function (s) {
                  return s.id === m.id;
                })) === null || _meshSerializability$ === void 0 ? void 0 : _meshSerializability$.doNotSerialize;
              });
              materials.forEach(function (m) {
                return m.doNotSerialize = materialSerializability.find(function (s) {
                  return s.id === m.id;
                }).doNotSerialize;
              });
              return _context47.abrupt("return", json);
            case 50:
              _context47.prev = 50;
              meshes.forEach(function (m) {
                var _meshSerializability$2;
                return m.doNotSerialize = (_meshSerializability$2 = meshSerializability.find(function (s) {
                  return s.id === m.id;
                })) === null || _meshSerializability$2 === void 0 ? void 0 : _meshSerializability$2.doNotSerialize;
              });
              materials.forEach(function (m) {
                return m.doNotSerialize = materialSerializability.find(function (s) {
                  return s.id === m.id;
                }).doNotSerialize;
              });
              return _context47.finish(50);
            case 54:
            case "end":
              return _context47.stop();
          }
        }, _callee45, this, [[5,, 50, 54], [31, 40, 43, 46]]);
      }));
      function exportMeshesToBabylon(_x92) {
        return _exportMeshesToBabylon.apply(this, arguments);
      }
      return exportMeshesToBabylon;
    }()
  }, {
    key: "exportMeshesForTyOnToBabylon",
    value: function () {
      var _exportMeshesForTyOnToBabylon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        var meshes;
        return _regeneratorRuntime().wrap(function _callee46$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              meshes = this.getMeshesForTryOn();
              _context48.next = 3;
              return this.exportMeshesToBabylon(meshes);
            case 3:
              return _context48.abrupt("return", _context48.sent);
            case 4:
            case "end":
              return _context48.stop();
          }
        }, _callee46, this);
      }));
      function exportMeshesForTyOnToBabylon() {
        return _exportMeshesForTyOnToBabylon.apply(this, arguments);
      }
      return exportMeshesForTyOnToBabylon;
    }()
  }, {
    key: "downloadBlob",
    value: function downloadBlob(blob) {
      var link = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.download = "mesh.json";
      a.href = link;
      a.click();
      URL.revokeObjectURL(link);
    }
  }, {
    key: "downloadMeshBabylonAsync",
    value: function () {
      var _downloadMeshBabylonAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47(mesh) {
        var json, blob;
        return _regeneratorRuntime().wrap(function _callee47$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              _context49.next = 2;
              return this.exportMeshToBabylon(mesh);
            case 2:
              json = _context49.sent;
              if (json) {
                blob = new Blob([json], {
                  type: "application/json"
                });
                this.downloadBlob(blob);
              }
            case 4:
            case "end":
              return _context49.stop();
          }
        }, _callee47, this);
      }));
      function downloadMeshBabylonAsync(_x93) {
        return _downloadMeshBabylonAsync.apply(this, arguments);
      }
      return downloadMeshBabylonAsync;
    }()
  }, {
    key: "downloadMeshesBabylonAsync",
    value: function () {
      var _downloadMeshesBabylonAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48(meshes) {
        var json, blob;
        return _regeneratorRuntime().wrap(function _callee48$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              _context50.next = 2;
              return this.exportMeshesToBabylon(meshes);
            case 2:
              json = _context50.sent;
              if (json) {
                blob = new Blob([json], {
                  type: "application/json"
                });
                this.downloadBlob(blob);
              }
            case 4:
            case "end":
              return _context50.stop();
          }
        }, _callee48, this);
      }));
      function downloadMeshesBabylonAsync(_x94) {
        return _downloadMeshesBabylonAsync.apply(this, arguments);
      }
      return downloadMeshesBabylonAsync;
    }()
  }, {
    key: "loadAllDelayedMaterialsAsync",
    value: function () {
      var _loadAllDelayedMaterialsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49(rootUrl) {
        var results, delayedMaterials, materialID;
        return _regeneratorRuntime().wrap(function _callee49$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              results = [];
              if (!(this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials)) {
                _context51.next = 7;
                break;
              }
              delayedMaterials = {};
              for (materialID in this._scene.metadata.delayedMaterials) {
                delayedMaterials[materialID] = {
                  name: this._scene.metadata.delayedMaterials[materialID].name,
                  file: this._scene.metadata.delayedMaterials[materialID].file
                };
              }
              _context51.next = 6;
              return this.loadMaterialsAsync(rootUrl, delayedMaterials);
            case 6:
              results = _context51.sent;
            case 7:
              return _context51.abrupt("return", results);
            case 8:
            case "end":
              return _context51.stop();
          }
        }, _callee49, this);
      }));
      function loadAllDelayedMaterialsAsync(_x95) {
        return _loadAllDelayedMaterialsAsync.apply(this, arguments);
      }
      return loadAllDelayedMaterialsAsync;
    }()
  }, {
    key: "loadDelayedMaterialsAsync",
    value: function () {
      var _loadDelayedMaterialsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50(rootUrl, materialIDs) {
        var results, delayedMaterials, i;
        return _regeneratorRuntime().wrap(function _callee50$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              results = [];
              if (!(this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials)) {
                _context52.next = 7;
                break;
              }
              delayedMaterials = {};
              for (i = 0; i < materialIDs.length; i++) {
                if (this._scene.metadata.delayedMaterials.hasOwnProperty(materialIDs[i])) {
                  delayedMaterials[materialIDs[i]] = {
                    name: this._scene.metadata.delayedMaterials[materialIDs[i]].name,
                    file: this._scene.metadata.delayedMaterials[materialIDs[i]].file
                  };
                }
              }
              _context52.next = 6;
              return this.loadMaterialsAsync(rootUrl, delayedMaterials);
            case 6:
              results = _context52.sent;
            case 7:
              return _context52.abrupt("return", results);
            case 8:
            case "end":
              return _context52.stop();
          }
        }, _callee50, this);
      }));
      function loadDelayedMaterialsAsync(_x96, _x97) {
        return _loadDelayedMaterialsAsync.apply(this, arguments);
      }
      return loadDelayedMaterialsAsync;
    }()
  }, {
    key: "loadDelayedMaterialAsync",
    value: function () {
      var _loadDelayedMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51(rootUrl, materialID) {
        var delayedMaterials, materials;
        return _regeneratorRuntime().wrap(function _callee51$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              if (!(this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials)) {
                _context53.next = 9;
                break;
              }
              delayedMaterials = {};
              if (!this._scene.metadata.delayedMaterials.hasOwnProperty(materialID)) {
                _context53.next = 9;
                break;
              }
              delayedMaterials[materialID] = {
                name: this._scene.metadata.delayedMaterials[materialID].name,
                file: this._scene.metadata.delayedMaterials[materialID].file
              };
              _context53.next = 6;
              return this.loadMaterialsAsync(rootUrl, delayedMaterials);
            case 6:
              materials = _context53.sent;
              if (!(materials.length > 0)) {
                _context53.next = 9;
                break;
              }
              return _context53.abrupt("return", materials[0]);
            case 9:
              return _context53.abrupt("return", null);
            case 10:
            case "end":
              return _context53.stop();
          }
        }, _callee51, this);
      }));
      function loadDelayedMaterialAsync(_x98, _x99) {
        return _loadDelayedMaterialAsync.apply(this, arguments);
      }
      return loadDelayedMaterialAsync;
    }()
  }, {
    key: "loadMaterialsAsync",
    value: function () {
      var _loadMaterialsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52(rootUrl, delayedMaterials) {
        var newMaterials, promises, materialID, material, info, results, i, result, jsonObj, _material;
        return _regeneratorRuntime().wrap(function _callee52$(_context54) {
          while (1) switch (_context54.prev = _context54.next) {
            case 0:
              newMaterials = [];
              promises = [];
              for (materialID in delayedMaterials) {
                material = this._scene.getMaterialByID(materialID);
                if (!material) {
                  info = delayedMaterials[materialID];
                  promises.push(this.loadMaterialInternalAsync(materialID, rootUrl, info.file));
                } else {
                  newMaterials.push(material);
                }
              }
              _context54.next = 5;
              return Promise.all(promises);
            case 5:
              results = _context54.sent;
              i = 0;
            case 7:
              if (!(i < results.length)) {
                _context54.next = 20;
                break;
              }
              result = results[i];
              jsonObj = JSON.parse(result);
              _material = BABYLON.Material.Parse(jsonObj, this._scene, rootUrl);
              if (!_material) {
                _context54.next = 17;
                break;
              }
              Logger.info("Waiting for material ready: " + _material.id + " - " + _material.name);
              _context54.next = 15;
              return SceneHelper.whenAllMaterialTexturesAreReady(_material);
            case 15:
              Logger.info("Material ready: " + _material.id + " - " + _material.name);
              newMaterials.push(_material);
            case 17:
              i++;
              _context54.next = 7;
              break;
            case 20:
              this.setupShaderMaterialsCameraPosition();
              return _context54.abrupt("return", newMaterials);
            case 22:
            case "end":
              return _context54.stop();
          }
        }, _callee52, this);
      }));
      function loadMaterialsAsync(_x100, _x101) {
        return _loadMaterialsAsync.apply(this, arguments);
      }
      return loadMaterialsAsync;
    }()
  }, {
    key: "loadMaterialInternalAsync",
    value: function loadMaterialInternalAsync(materialID, rootUrl, fileName) {
      var _this22 = this;
      Logger.info("Loading delayed material: " + materialID);
      if (this._loadingMaterials.hasOwnProperty(materialID)) return this._loadingMaterials[materialID];
      var sep = _Misc_StringTools__WEBPACK_IMPORTED_MODULE_3__.StringTools.EndsWith(rootUrl, "/") ? "" : "/";
      var url = rootUrl + sep + fileName;
      var promise = new Promise(function (resolve, reject) {
        BABYLON.Tools.LoadFile(url, function (data) {
          Logger.info("Loaded delayed material: " + materialID);
          resolve(data);
          delete _this22._loadingMaterials[materialID];
        }, undefined, undefined, false, function (request, exception) {
          reject(exception);
          delete _this22._loadingMaterials[materialID];
        });
      });
      this._loadingMaterials[materialID] = promise;
      return promise;
    }
  }, {
    key: "showMesh",
    value: function showMesh(meshID) {
      this.showHideMesh(meshID, true);
    }
  }, {
    key: "hideMesh",
    value: function hideMesh(meshID) {
      this.showHideMesh(meshID, false);
    }
  }, {
    key: "showHideMesh",
    value: function showHideMesh(meshID, show) {
      var showHideWithChildren = function showHideWithChildren(parent, show) {
        parent.isVisible = show;
        var children = parent.getChildMeshes();
        if (children) {
          children.forEach(function (child) {
            showHideWithChildren(child, show);
          });
        }
      };
      var mesh = this._scene.getMeshByID(meshID);
      if (mesh) {
        showHideWithChildren(mesh, show);
      }
    }
  }, {
    key: "changeMaterialColor",
    value: function changeMaterialColor(material, propertyName, nextColor) {
      var mesh = null;
      for (var i = 0; i < this._scene.meshes.length; i++) {
        var m = this._scene.meshes[i];
        if (m.material === material) {
          mesh = m;
          break;
        }
      }

      // Animation gives problems on PBR materials

      //if (mesh) {

      //    var animation = new BABYLON.Animation("colorAnimation", "material." + propertyName, 60, BABYLON.Animation.ANIMATIONTYPE_COLOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);

      //    // keys
      //    var keys = [{
      //        frame: 0,
      //        value: material[propertyName]
      //    }, {
      //        frame: 60,
      //        value: nextColor
      //    }];
      //    animation.setKeys(keys);

      //    mesh.animations.push(animation);

      //    var animatable = this._scene.beginAnimation(mesh, 0, 60, false, 3);

      //    // Remove animations
      //    animatable.onAnimationEnd = function () {
      //        if (mesh) {
      //            for (let i = 0; i < mesh.animations.length; i++) {
      //                var anim = mesh.animations[i];
      //                if (anim === animation)
      //                    mesh.animations.splice(i--, 1);
      //            }
      //        }
      //    };
      //} else {
      //    material[propertyName] = nextColor;
      //}

      material[propertyName] = nextColor;
    }
  }, {
    key: "applyMaterialByName",
    value: function applyMaterialByName(name, mesh) {
      if (this._scene) {
        var material = this._scene.getMaterialByName(name);
        if (material) this.applyMaterial(material, mesh);
      }
    }
  }, {
    key: "applyMaterial",
    value: function applyMaterial(material, mesh) {
      var _this23 = this;
      var applyWithChildren = function applyWithChildren(parent) {
        if (parent.subMeshes && parent.subMeshes.length > 0 && parent.material && parent.material instanceof BABYLON.MultiMaterial) {
          for (var i = 0; i < parent.subMeshes.length; i++) {
            var subMesh = parent.subMeshes[i];
            _this23.applyMaterialToSubMesh(material, parent, subMesh);
          }
        } else {
          parent.material = material;
        }
        var children = parent.getChildMeshes();
        if (children) {
          children.forEach(function (child) {
            applyWithChildren(child);
          });
        }
      };
      if (mesh) {
        applyWithChildren(mesh);
      }
    }
  }, {
    key: "applyMaterialToSubMeshByName",
    value: function applyMaterialToSubMeshByName(name, mesh, subMesh) {
      var material = this._scene.getMaterialByName(name);
      if (material) this.applyMaterialToSubMesh(material, mesh, subMesh);
    }
  }, {
    key: "applyMaterialToSubMesh",
    value: function applyMaterialToSubMesh(material, mesh, subMesh) {
      var idx = subMesh.materialIndex;
      var m = mesh || subMesh.getMesh();
      if (m.material instanceof BABYLON.MultiMaterial && idx >= 0 && idx < m.material.subMaterials.length) {
        m.material.subMaterials[idx] = material;
      }
    }
  }, {
    key: "getSubMeshMaterial",
    value: function getSubMeshMaterial(mesh, subMesh) {
      var idx = subMesh.materialIndex;
      var m = mesh || subMesh.getMesh();
      if (m.material instanceof BABYLON.MultiMaterial && idx >= 0 && idx < m.material.subMaterials.length) {
        return m.material.subMaterials[idx];
      }
      return null;
    }
  }, {
    key: "prefetchTexturesFormMeshAsync",
    value: function () {
      var _prefetchTexturesFormMeshAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53(mesh) {
        var children, i, child;
        return _regeneratorRuntime().wrap(function _callee53$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              if (!mesh.material) {
                _context55.next = 3;
                break;
              }
              _context55.next = 3;
              return this.prefetchTexturesForMaterialAsync(mesh.material);
            case 3:
              children = mesh.getChildMeshes();
              i = 0;
            case 5:
              if (!(i < children.length)) {
                _context55.next = 13;
                break;
              }
              child = children[i];
              if (!child.material) {
                _context55.next = 10;
                break;
              }
              _context55.next = 10;
              return this.prefetchTexturesForMaterialAsync(child.material);
            case 10:
              i++;
              _context55.next = 5;
              break;
            case 13:
            case "end":
              return _context55.stop();
          }
        }, _callee53, this);
      }));
      function prefetchTexturesFormMeshAsync(_x102) {
        return _prefetchTexturesFormMeshAsync.apply(this, arguments);
      }
      return prefetchTexturesFormMeshAsync;
    }()
  }, {
    key: "prefetchTexturesForMaterialAsync",
    value: function () {
      var _prefetchTexturesForMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee54(material) {
        var textures, i;
        return _regeneratorRuntime().wrap(function _callee54$(_context56) {
          while (1) switch (_context56.prev = _context56.next) {
            case 0:
              if (!material) {
                _context56.next = 9;
                break;
              }
              textures = this.getTexturesForMaterial(material);
              i = 0;
            case 3:
              if (!(i < textures.length)) {
                _context56.next = 9;
                break;
              }
              _context56.next = 6;
              return SceneHelper.whenTextureIsReadyAsync(textures[i]);
            case 6:
              i++;
              _context56.next = 3;
              break;
            case 9:
            case "end":
              return _context56.stop();
          }
        }, _callee54, this);
      }));
      function prefetchTexturesForMaterialAsync(_x103) {
        return _prefetchTexturesForMaterialAsync.apply(this, arguments);
      }
      return prefetchTexturesForMaterialAsync;
    }()
  }, {
    key: "checkDelayState",
    value: function checkDelayState(mesh) {
      var _this24 = this;
      if (mesh instanceof BABYLON.Mesh) {
        mesh._checkDelayState();
      }
      var children = mesh.getChildMeshes();
      children.forEach(function (child) {
        return _this24.checkDelayState(child);
      });
    }

    // Crea una nuova mesh data da una minima espansione di quella passata in input
    // in modo che ne costituisca un rivestimento
  }, {
    key: "createEnvelopeMesh",
    value: function createEnvelopeMesh(mesh) {
      var delta = 0.01;
      var boundingVectors = mesh.getHierarchyBoundingVectors();
      if (boundingVectors) {
        var min = boundingVectors.min;
        var max = boundingVectors.max;
        var boundingInfo = new BABYLON.BoundingInfo(min, max);
        var boundingSphere = boundingInfo.boundingSphere;
        var radius = boundingSphere.radius;
        delta = radius * 0.0050;
      }
      var newMesh = this.cloneMesh(mesh.id, true, true);
      if (newMesh && newMesh instanceof BABYLON.Mesh) {
        this.expandMesh(newMesh, delta);
      }
      return newMesh;
    }
  }, {
    key: "expandMesh",
    value: function expandMesh(mesh, delta) {
      var expander = new _MeshExpander_MeshExpander__WEBPACK_IMPORTED_MODULE_4__.MeshExpander();
      if (mesh && mesh instanceof BABYLON.Mesh) {
        expander.expandMesh(mesh, delta);
        var children = mesh.getChildMeshes();
        var _iterator3 = _createForOfIteratorHelper(children),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var child = _step3.value;
            if (child instanceof BABYLON.Mesh) {
              expander.expandMesh(child, delta);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  }, {
    key: "cloneMesh",
    value: function cloneMesh(id) {
      var duplicateGeometry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var updatableGeometry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var newMesh = null;
      if (this._scene) {
        var _mesh8 = this._scene.getMeshByID(id);
        if (_mesh8) {
          var name = this.getNextIncrementalName(_mesh8.name);
          newMesh = _mesh8.clone(name, _mesh8.parent);
          if (newMesh) {
            newMesh.id = Zakeke.generateUUID();
            if (duplicateGeometry) {
              this.duplicateGeometry(_mesh8, newMesh, updatableGeometry);
            }
            var children = newMesh.getChildMeshes();
            var _iterator4 = _createForOfIteratorHelper(children),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var child = _step4.value;
                var originalChild = this._scene.getMeshByID(child.id);
                child.id = Zakeke.generateUUID();
                var parentName = child.parent ? child.parent.name : null;
                if (parentName) {
                  // Clean the sub folder name that use babylon
                  var _index = child.name.indexOf(parentName + ".") + parentName.length + 1;
                  child.name = child.name.substr(_index);
                }
                if (originalChild && duplicateGeometry) {
                  this.duplicateGeometry(originalChild, child, updatableGeometry);
                }
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }
        }
      }
      return newMesh;
    }
  }, {
    key: "duplicateGeometry",
    value: function duplicateGeometry(originalMesh, newMesh) {
      var updatable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (originalMesh instanceof BABYLON.Mesh && newMesh instanceof BABYLON.Mesh) {
        var vertexData = BABYLON.VertexData.ExtractFromMesh(originalMesh, true, true);
        var geometry = new BABYLON.Geometry(Zakeke.generateUUID(), newMesh.getScene(), vertexData, updatable, newMesh);
        return geometry;
      }
      return null;
    }

    // Material metadata
  }, {
    key: "getSceneMaterialMetadata",
    value: function getSceneMaterialMetadata(materialID) {
      // i metadata dei materiali non vengono serializzati in Babylon JS,
      // sono quindi costretto a salvarli nei metadati della scena.
      if (this._scene && this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(materialID)) return this._scene.metadata.materialsMetadata[materialID];
      return null;
    }
  }, {
    key: "getOrCreateSceneMaterialMetadata",
    value: function getOrCreateSceneMaterialMetadata(materialID) {
      var metadata = this.getSceneMaterialMetadata(materialID);
      if (!metadata) {
        metadata = {};
        if (!this._scene.metadata) this._scene.metadata = {};
        if (!this._scene.metadata.materialsMetadata) this._scene.metadata.materialsMetadata = {};
        this._scene.metadata.materialsMetadata[materialID] = metadata;
      }
      return metadata;
    }
  }, {
    key: "removeSceneMaterialMetadata",
    value: function removeSceneMaterialMetadata(materialID) {
      if (this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(materialID)) {
        delete this._scene.metadata.materialsMetadata[materialID];
      }
    }
  }, {
    key: "offloadAllUnusedMaterials",
    value: function offloadAllUnusedMaterials() {
      var _this25 = this;
      var materials = this.getAllUnusedMaterials();
      materials.forEach(function (m) {
        return _this25.offloadMaterial(m.id);
      });
    }

    // Salva la serializzazione del materiale e lo rimuove dalla scena (eliminando anche le relative texture).
    // Lo scopo è quello di liberare la memoria occupata dalle texture
  }, {
    key: "offloadMaterial",
    value: function offloadMaterial(materialID) {
      var material = this._scene.getMaterialByID(materialID);
      if (material && material.id !== "default material") {
        // Verifico che il material non sia assegnato ad alcuna mesh
        var meshes = this.getMeshesUsingMaterial(materialID);
        if (meshes.length === 0) {
          Logger.info("Offloading material: " + material.id + " - " + material.name);

          /* le texture verranno eliminate contestulmente alla dispose del materiale
          const textures = material.getActiveTextures();
          const removableTextures: BABYLON.BaseTexture[] = [];
          textures.forEach(t => {
              const usingTextures: BABYLON.Material[] = this.getMaterialsUsingTexture(t);
              if (usingTextures.length === 1 && usingTextures[0].id === materialID)
                  removableTextures.push(t);
          });
          */

          // Serializzo il materiale e lo salvo nella scena
          if (!this._scene.metadata) this._scene.metadata = {};
          if (!this._scene.metadata.offloadedMaterials) this._scene.metadata.offloadedMaterials = {};
          this._scene.metadata.offloadedMaterials[materialID] = this.getOffloadedMaterialInfo(material);

          // Dispose del materiale e delle relative texture
          Logger.info("Disposing material: " + materialID);
          material.dispose(false, true);
          /*
          for (let i = 0; i < removableTextures.length; i++) {
              const removableTexture = removableTextures[i];
              Logger.info("Disposing texture: ", removableTexture.name);
              removableTexture.dispose();
          }
          */
        }
      }
    }
  }, {
    key: "getOffloadedMaterialInfo",
    value: function getOffloadedMaterialInfo(material) {
      return {
        name: material.name,
        data: material.serialize()
      };
    }

    // Il materiale restituito dalla versione sincrona potrebbe non essere pronto per l'applicazione alla mesh
  }, {
    key: "loadAllOffloadedMaterials",
    value: function loadAllOffloadedMaterials(rootUrl) {
      var results = [];
      if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
        results = this.loadOffloadedMaterials(rootUrl, this._scene.metadata.offloadedMaterials);
      }
      return results;
    }
  }, {
    key: "loadOffloadedMaterialsByIDs",
    value: function loadOffloadedMaterialsByIDs(rootUrl, materialIDs) {
      var results = [];
      if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
        var offloadedMaterials = {};
        for (var i = 0; i < materialIDs.length; i++) {
          if (this._scene.metadata.offloadedMaterials.hasOwnProperty(materialIDs[i])) {
            offloadedMaterials[materialIDs[i]] = {
              name: this._scene.metadata.offloadedMaterials[materialIDs[i]].name,
              data: this._scene.metadata.offloadedMaterials[materialIDs[i]].data
            };
          }
        }
        results = this.loadOffloadedMaterials(rootUrl, offloadedMaterials);
      }
      return results;
    }
  }, {
    key: "loadOffloadedMaterial",
    value: function loadOffloadedMaterial(rootUrl, materialID) {
      if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
        var offloadedMaterials = {};
        if (this._scene.metadata.offloadedMaterials.hasOwnProperty(materialID)) {
          offloadedMaterials[materialID] = {
            name: this._scene.metadata.offloadedMaterials[materialID].name,
            data: this._scene.metadata.offloadedMaterials[materialID].data
          };
          var materials = this.loadOffloadedMaterials(rootUrl, offloadedMaterials);
          if (materials.length > 0) return materials[0];
        }
      }
      return null;
    }
  }, {
    key: "loadOffloadedMaterials",
    value: function loadOffloadedMaterials(rootUrl, offloadedMaterials) {
      var newMaterials = [];
      for (var materialID in offloadedMaterials) {
        var info = offloadedMaterials[materialID];
        var material = this.loadOffloadedMaterialInternal(materialID, info.name, rootUrl, info.data);
        if (material) newMaterials.push(material);
      }
      return newMaterials;
    }

    // Il nome viene passato solo ai fini del log
  }, {
    key: "loadOffloadedMaterialInternal",
    value: function loadOffloadedMaterialInternal(materialID, name, rootUrl, data) {
      var material = this._scene.getMaterialByID(materialID);
      if (material) return material;
      var namePart = name ? " - ".concat(name) : '';
      Logger.info("Loading offloaded material: " + materialID + namePart);
      return BABYLON.Material.Parse(data, this._scene, rootUrl);
    }

    // Nella versione asincrona si aspetta che tutte le texture del materiale caricato siano pronte
  }, {
    key: "loadAllOffloadedMaterialsAsync",
    value: function () {
      var _loadAllOffloadedMaterialsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee55(rootUrl) {
        var results;
        return _regeneratorRuntime().wrap(function _callee55$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              results = [];
              if (!(this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials)) {
                _context57.next = 5;
                break;
              }
              _context57.next = 4;
              return this.loadOffloadedMaterialsAsync(rootUrl, this._scene.metadata.offloadedMaterials);
            case 4:
              results = _context57.sent;
            case 5:
              return _context57.abrupt("return", results);
            case 6:
            case "end":
              return _context57.stop();
          }
        }, _callee55, this);
      }));
      function loadAllOffloadedMaterialsAsync(_x104) {
        return _loadAllOffloadedMaterialsAsync.apply(this, arguments);
      }
      return loadAllOffloadedMaterialsAsync;
    }()
  }, {
    key: "loadOffloadedMaterialsByIDsAsync",
    value: function () {
      var _loadOffloadedMaterialsByIDsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee56(rootUrl, materialIDs) {
        var results, offloadedMaterials, i;
        return _regeneratorRuntime().wrap(function _callee56$(_context58) {
          while (1) switch (_context58.prev = _context58.next) {
            case 0:
              results = [];
              if (!(this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials)) {
                _context58.next = 7;
                break;
              }
              offloadedMaterials = {};
              for (i = 0; i < materialIDs.length; i++) {
                if (this._scene.metadata.offloadedMaterials.hasOwnProperty(materialIDs[i])) {
                  offloadedMaterials[materialIDs[i]] = {
                    name: this._scene.metadata.offloadedMaterials[materialIDs[i]].name,
                    data: this._scene.metadata.offloadedMaterials[materialIDs[i]].data
                  };
                }
              }
              _context58.next = 6;
              return this.loadOffloadedMaterialsAsync(rootUrl, offloadedMaterials);
            case 6:
              results = _context58.sent;
            case 7:
              return _context58.abrupt("return", results);
            case 8:
            case "end":
              return _context58.stop();
          }
        }, _callee56, this);
      }));
      function loadOffloadedMaterialsByIDsAsync(_x105, _x106) {
        return _loadOffloadedMaterialsByIDsAsync.apply(this, arguments);
      }
      return loadOffloadedMaterialsByIDsAsync;
    }()
  }, {
    key: "loadOffloadedMaterialAsync",
    value: function () {
      var _loadOffloadedMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee57(rootUrl, materialID) {
        var offloadedMaterials, materials;
        return _regeneratorRuntime().wrap(function _callee57$(_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              if (!(this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials)) {
                _context59.next = 9;
                break;
              }
              offloadedMaterials = {};
              if (!this._scene.metadata.offloadedMaterials.hasOwnProperty(materialID)) {
                _context59.next = 9;
                break;
              }
              offloadedMaterials[materialID] = {
                name: this._scene.metadata.offloadedMaterials[materialID].name,
                data: this._scene.metadata.offloadedMaterials[materialID].data
              };
              _context59.next = 6;
              return this.loadOffloadedMaterialsAsync(rootUrl, offloadedMaterials);
            case 6:
              materials = _context59.sent;
              if (!(materials.length > 0)) {
                _context59.next = 9;
                break;
              }
              return _context59.abrupt("return", materials[0]);
            case 9:
              return _context59.abrupt("return", null);
            case 10:
            case "end":
              return _context59.stop();
          }
        }, _callee57, this);
      }));
      function loadOffloadedMaterialAsync(_x107, _x108) {
        return _loadOffloadedMaterialAsync.apply(this, arguments);
      }
      return loadOffloadedMaterialAsync;
    }()
  }, {
    key: "loadOffloadedMaterialsAsync",
    value: function () {
      var _loadOffloadedMaterialsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee58(rootUrl, offloadedMaterials) {
        var newMaterials, promises, materialID, info, results;
        return _regeneratorRuntime().wrap(function _callee58$(_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              newMaterials = [];
              promises = [];
              for (materialID in offloadedMaterials) {
                info = offloadedMaterials[materialID];
                promises.push(this.loadOffloadedMaterialInternalAsync(materialID, info.name, rootUrl, info.data));
              }
              _context60.next = 5;
              return Promise.all(promises);
            case 5:
              results = _context60.sent;
              results.forEach(function (result) {
                if (result) newMaterials.push(result);
              });
              return _context60.abrupt("return", newMaterials);
            case 8:
            case "end":
              return _context60.stop();
          }
        }, _callee58, this);
      }));
      function loadOffloadedMaterialsAsync(_x109, _x110) {
        return _loadOffloadedMaterialsAsync.apply(this, arguments);
      }
      return loadOffloadedMaterialsAsync;
    }() // Il nome viene passato solo ai fini del log
  }, {
    key: "loadOffloadedMaterialInternalAsync",
    value: function () {
      var _loadOffloadedMaterialInternalAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee59(materialID, name, rootUrl, data) {
        var material, namePart, newMaterial;
        return _regeneratorRuntime().wrap(function _callee59$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              material = this._scene.getMaterialByID(materialID);
              if (!material) {
                _context61.next = 3;
                break;
              }
              return _context61.abrupt("return", material);
            case 3:
              namePart = name ? " - ".concat(name) : '';
              Logger.info("Loading offloaded material: " + materialID + namePart);
              newMaterial = BABYLON.Material.Parse(data, this._scene, rootUrl);
              if (!newMaterial) {
                _context61.next = 13;
                break;
              }
              Logger.info("Waiting for material ready: " + materialID + namePart);
              _context61.next = 10;
              return SceneHelper.whenAllMaterialTexturesAreReady(newMaterial);
            case 10:
              Logger.info("Material ready: " + materialID + namePart);
              _context61.next = 14;
              break;
            case 13:
              Logger.info("No material was created from offloaded material: " + materialID + namePart);
            case 14:
              return _context61.abrupt("return", newMaterial);
            case 15:
            case "end":
              return _context61.stop();
          }
        }, _callee59, this);
      }));
      function loadOffloadedMaterialInternalAsync(_x111, _x112, _x113, _x114) {
        return _loadOffloadedMaterialInternalAsync.apply(this, arguments);
      }
      return loadOffloadedMaterialInternalAsync;
    }()
  }, {
    key: "loadTextureFiles",
    value: function loadTextureFiles(rootUrl, textureUrls) {
      if (rootUrl) {
        for (var i = 0; i < textureUrls.length; i++) {
          var url = textureUrls[i];
          var isAbsolute = /^(?:\/|[a-z]+:\/\/)/.test(url);
          var absoluteUrl = url;
          if (!isAbsolute) absoluteUrl = rootUrl + url;
          var lastDot = absoluteUrl.lastIndexOf(".");
          var extension = lastDot > -1 ? absoluteUrl.substring(lastDot).toLowerCase() : "";
          var isDDS = extension === ".dds";
          var isEnv = extension === ".env";
          var isPng = extension === ".png";
          var isJpg = extension === ".jpg";
          var isHDR = extension === ".hdr";
          if (isDDS || isEnv || isHDR) {
            BABYLON.Tools.LoadFile(absoluteUrl, function () {});
          } else if (isPng || isJpg) {
            BABYLON.Tools.LoadImage(absoluteUrl, function (img) {}, function () {}, null);
          }
        }
      }
    }

    // Recupera il materiale specificato, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
  }, {
    key: "getOrLoadMaterialAsync",
    value: function () {
      var _getOrLoadMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee60(materialID, rootUrl) {
        var material;
        return _regeneratorRuntime().wrap(function _callee60$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              material = this._scene.getMaterialByID(materialID);
              if (!(!material && this._scene.metadata)) {
                _context62.next = 12;
                break;
              }
              if (!(this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(materialID))) {
                _context62.next = 8;
                break;
              }
              _context62.next = 5;
              return this.loadOffloadedMaterialAsync(rootUrl, materialID);
            case 5:
              material = _context62.sent;
              _context62.next = 12;
              break;
            case 8:
              if (!(this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(materialID))) {
                _context62.next = 12;
                break;
              }
              _context62.next = 11;
              return this.loadDelayedMaterialAsync(rootUrl, materialID);
            case 11:
              material = _context62.sent;
            case 12:
              return _context62.abrupt("return", material);
            case 13:
            case "end":
              return _context62.stop();
          }
        }, _callee60, this);
      }));
      function getOrLoadMaterialAsync(_x115, _x116) {
        return _getOrLoadMaterialAsync.apply(this, arguments);
      }
      return getOrLoadMaterialAsync;
    }()
  }, {
    key: "getOrCreateDummyMaterial",
    value: function getOrCreateDummyMaterial() {
      var material = this._scene.getMaterialByID(this._dummyMaterialID);
      if (!material) {
        material = new BABYLON.StandardMaterial("Dummy Material", this._scene);
        material.id = this._dummyMaterialID;
        material.metadata = {
          isRealMaterial: false
        };
      }
      return material;
    }
  }, {
    key: "isDummyMaterial",
    value: function isDummyMaterial(material) {
      return material.id === this._dummyMaterialID;
    }
  }, {
    key: "meshHasDummyMaterial",
    value: function meshHasDummyMaterial(mesh, recursive) {
      if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material && mesh.material instanceof BABYLON.MultiMaterial) {
        for (var i = 0; i < mesh.subMeshes.length; i++) {
          var _mesh$material$subMat;
          var subMesh = mesh.subMeshes[i];
          var idx = subMesh.materialIndex;
          if (mesh.material.subMaterials[idx] && ((_mesh$material$subMat = mesh.material.subMaterials[idx]) === null || _mesh$material$subMat === void 0 ? void 0 : _mesh$material$subMat.id) === this._dummyMaterialID) return true;
        }
      } else {
        if (mesh.material && mesh.material.id === this._dummyMaterialID) return true;
      }
      if (recursive) {
        for (var _i3 = 0; _i3 < mesh.getChildMeshes().length; _i3++) {
          if (this.meshHasDummyMaterial(mesh.getChildMeshes()[_i3], true)) return true;
        }
      }
      return false;
    }
  }, {
    key: "getMeshDelayedMaterialIDs",
    value: function getMeshDelayedMaterialIDs(mesh) {
      var _this26 = this;
      var materialIDs = [];
      if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material && mesh.material instanceof BABYLON.MultiMaterial) {
        for (var i = 0; i < mesh.subMeshes.length; i++) {
          var _mesh$material$subMat2;
          var subMesh = mesh.subMeshes[i];
          var idx = subMesh.materialIndex;
          if (mesh.material.subMaterials[idx] && ((_mesh$material$subMat2 = mesh.material.subMaterials[idx]) === null || _mesh$material$subMat2 === void 0 ? void 0 : _mesh$material$subMat2.id) === this._dummyMaterialID) {
            var key = "".concat(mesh.id, "_").concat(idx);
            if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(key)) {
              var originalMaterialID = this._scene.metadata.originalMeshMaterials[key];
              if (this._scene.metadata.delayedMaterials.hasOwnProperty(originalMaterialID) && materialIDs.indexOf(originalMaterialID) === -1) {
                materialIDs.push(originalMaterialID);
              }
            }
          }
        }
      } else {
        if (mesh.material && mesh.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(mesh.id)) {
          var _originalMaterialID = this._scene.metadata.originalMeshMaterials[mesh.id];
          if (this._scene.metadata.delayedMaterials.hasOwnProperty(_originalMaterialID) && materialIDs.indexOf(_originalMaterialID) === -1) {
            materialIDs.push(_originalMaterialID);
          }
        }
      }
      mesh.getChildMeshes().forEach(function (child) {
        return Array.prototype.push.apply(materialIDs, _this26.getMeshDelayedMaterialIDs(child));
      });
      return materialIDs;
    }
  }, {
    key: "getMeshOffloadedMaterialIDs",
    value: function getMeshOffloadedMaterialIDs(mesh) {
      var _this27 = this;
      var materialIDs = [];
      if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material && mesh.material instanceof BABYLON.MultiMaterial) {
        for (var i = 0; i < mesh.subMeshes.length; i++) {
          var _mesh$material$subMat3;
          var subMesh = mesh.subMeshes[i];
          var idx = subMesh.materialIndex;
          if (mesh.material.subMaterials[idx] && ((_mesh$material$subMat3 = mesh.material.subMaterials[idx]) === null || _mesh$material$subMat3 === void 0 ? void 0 : _mesh$material$subMat3.id) === this._dummyMaterialID) {
            var key = "".concat(mesh.id, "_").concat(idx);
            if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(key)) {
              var originalMaterialID = this._scene.metadata.originalMeshMaterials[key];
              if (this._scene.metadata.offloadedMaterials.hasOwnProperty(originalMaterialID) && materialIDs.indexOf(originalMaterialID) === -1) {
                materialIDs.push(originalMaterialID);
              }
            }
          }
        }
      } else {
        if (mesh.material && mesh.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(mesh.id)) {
          var _originalMaterialID2 = this._scene.metadata.originalMeshMaterials[mesh.id];
          if (this._scene.metadata.offloadedMaterials.hasOwnProperty(_originalMaterialID2) && materialIDs.indexOf(_originalMaterialID2) === -1) {
            materialIDs.push(_originalMaterialID2);
          }
        }
      }
      mesh.getChildMeshes().forEach(function (child) {
        return Array.prototype.push.apply(materialIDs, _this27.getMeshOffloadedMaterialIDs(child));
      });
      return materialIDs;
    }
  }, {
    key: "setDummyMaterialToInvisibleMeshes",
    value: function setDummyMaterialToInvisibleMeshes() {
      var _this28 = this;
      var meshes = this.getInvisibleMeshes();
      meshes.forEach(function (mesh) {
        _this28.setMeshDummyMaterial(mesh, false);
      });
    }
  }, {
    key: "setMeshDummyMaterial",
    value: function setMeshDummyMaterial(mesh, recursive) {
      var _this29 = this;
      if (!this._scene.metadata) this._scene.metadata = {};
      if (!this._scene.metadata.originalMeshMaterials) this._scene.metadata.originalMeshMaterials = {};
      var dummyMaterial = this.getOrCreateDummyMaterial();
      if (mesh.material) {
        if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material instanceof BABYLON.MultiMaterial) {
          for (var i = 0; i < mesh.subMeshes.length; i++) {
            var subMesh = mesh.subMeshes[i];
            var idx = subMesh.materialIndex;
            var subMeshMaterial = mesh.material.subMaterials[idx];
            if (subMeshMaterial && !this.isDummyMaterial(subMeshMaterial)) {
              var key = "".concat(mesh.id, "_").concat(idx);
              this._scene.metadata.originalMeshMaterials[key] = subMeshMaterial.id;
              mesh.material.subMaterials[idx] = dummyMaterial;
            }
          }
        } else {
          if (mesh.material && !this.isDummyMaterial(mesh.material)) {
            this._scene.metadata.originalMeshMaterials[mesh.id] = mesh.material.id;
            mesh.material = dummyMaterial;
          }
        }
      }
      if (recursive) {
        mesh.getChildMeshes().forEach(function (child) {
          return _this29.setMeshDummyMaterial(child, true);
        });
      }
    }

    // Il metodo è sincrono perché mi aspetto che tutti i materiali originali siano già presenti nella scena
  }, {
    key: "unsetAllDummyMaterials",
    value: function unsetAllDummyMaterials() {
      for (var i = 0; i < this._scene.meshes.length; i++) {
        this.unsetMeshDummyMaterial(this._scene.meshes[i], false);
      }
    }

    // Il metodo è asincrono perché ci sia aspetta che non tutti i materiali siano presenti nella scena, in qual caso verranno caricati
  }, {
    key: "unsetAllDummyMaterialsAsync",
    value: function () {
      var _unsetAllDummyMaterialsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee61(rootUrl) {
        var i;
        return _regeneratorRuntime().wrap(function _callee61$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this._scene.meshes.length)) {
                _context63.next = 7;
                break;
              }
              _context63.next = 4;
              return this.unsetMeshDummyMaterialAsync(this._scene.meshes[i], rootUrl, false);
            case 4:
              i++;
              _context63.next = 1;
              break;
            case 7:
            case "end":
              return _context63.stop();
          }
        }, _callee61, this);
      }));
      function unsetAllDummyMaterialsAsync(_x117) {
        return _unsetAllDummyMaterialsAsync.apply(this, arguments);
      }
      return unsetAllDummyMaterialsAsync;
    }() // Il metodo è sincrono perché mi aspetto che i materiali originali siano tutti gà presenti nella scena
  }, {
    key: "unsetMeshDummyMaterial",
    value: function unsetMeshDummyMaterial(mesh, recursive) {
      var _this30 = this;
      if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
        if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material && mesh.material instanceof BABYLON.MultiMaterial) {
          for (var i = 0; i < mesh.subMeshes.length; i++) {
            var _mesh$material$subMat4;
            var subMesh = mesh.subMeshes[i];
            var idx = subMesh.materialIndex;
            if (mesh.material.subMaterials[idx] && ((_mesh$material$subMat4 = mesh.material.subMaterials[idx]) === null || _mesh$material$subMat4 === void 0 ? void 0 : _mesh$material$subMat4.id) === this._dummyMaterialID) {
              var key = "".concat(mesh.id, "_").concat(idx);
              if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(key)) {
                var originalMaterialID = this._scene.metadata.originalMeshMaterials[key];
                var originalMaterial = this._scene.getMaterialByID(originalMaterialID);
                if (originalMaterial) {
                  mesh.material.subMaterials[idx] = originalMaterial;
                  delete this._scene.metadata.originalMeshMaterials[key];
                }
              }
            }
          }
        } else {
          if (mesh.material && mesh.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(mesh.id)) {
            var _originalMaterialID3 = this._scene.metadata.originalMeshMaterials[mesh.id];
            var _originalMaterial = this._scene.getMaterialByID(_originalMaterialID3);
            if (_originalMaterial) {
              mesh.material = _originalMaterial;
              delete this._scene.metadata.originalMeshMaterials[mesh.id];
            }
          }
        }
        if (recursive) {
          mesh.getChildMeshes().forEach(function (child) {
            return _this30.unsetMeshDummyMaterial(child, true);
          });
        }
      }
    }

    // Il metodo è asincrono perché ci si aspetta che non tutti i materiali siano presenti sulla scena, nel qual caso verranno caricati
  }, {
    key: "unsetMeshDummyMaterialAsync",
    value: function () {
      var _unsetMeshDummyMaterialAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee62(mesh, rootUrl, recursive) {
        var i, _mesh$material$subMat5, subMesh, idx, key, originalMaterialID, originalMaterial, _originalMaterialID4, _originalMaterial2, children, _i4;
        return _regeneratorRuntime().wrap(function _callee62$(_context64) {
          while (1) switch (_context64.prev = _context64.next) {
            case 0:
              if (!(this._scene.metadata && this._scene.metadata.originalMeshMaterials)) {
                _context64.next = 36;
                break;
              }
              if (!(mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material && mesh.material instanceof BABYLON.MultiMaterial)) {
                _context64.next = 20;
                break;
              }
              i = 0;
            case 3:
              if (!(i < mesh.subMeshes.length)) {
                _context64.next = 18;
                break;
              }
              subMesh = mesh.subMeshes[i];
              idx = subMesh.materialIndex;
              if (!(mesh.material.subMaterials[idx] && ((_mesh$material$subMat5 = mesh.material.subMaterials[idx]) === null || _mesh$material$subMat5 === void 0 ? void 0 : _mesh$material$subMat5.id) === this._dummyMaterialID)) {
                _context64.next = 15;
                break;
              }
              key = "".concat(mesh.id, "_").concat(idx);
              if (!this._scene.metadata.originalMeshMaterials.hasOwnProperty(key)) {
                _context64.next = 15;
                break;
              }
              originalMaterialID = this._scene.metadata.originalMeshMaterials[key];
              _context64.next = 12;
              return this.getOrLoadMaterialAsync(originalMaterialID, rootUrl);
            case 12:
              originalMaterial = _context64.sent;
              mesh.material.subMaterials[idx] = originalMaterial;
              delete this._scene.metadata.originalMeshMaterials[key];
            case 15:
              i++;
              _context64.next = 3;
              break;
            case 18:
              _context64.next = 27;
              break;
            case 20:
              if (!(mesh.material && mesh.material.id === this._dummyMaterialID && this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(mesh.id))) {
                _context64.next = 27;
                break;
              }
              _originalMaterialID4 = this._scene.metadata.originalMeshMaterials[mesh.id];
              _context64.next = 24;
              return this.getOrLoadMaterialAsync(_originalMaterialID4, rootUrl);
            case 24:
              _originalMaterial2 = _context64.sent;
              mesh.material = _originalMaterial2;
              delete this._scene.metadata.originalMeshMaterials[mesh.id];
            case 27:
              if (!recursive) {
                _context64.next = 36;
                break;
              }
              children = mesh.getChildMeshes();
              _i4 = 0;
            case 30:
              if (!(_i4 < children.length)) {
                _context64.next = 36;
                break;
              }
              _context64.next = 33;
              return this.unsetMeshDummyMaterialAsync(children[_i4], rootUrl, true);
            case 33:
              _i4++;
              _context64.next = 30;
              break;
            case 36:
            case "end":
              return _context64.stop();
          }
        }, _callee62, this);
      }));
      function unsetMeshDummyMaterialAsync(_x118, _x119, _x120) {
        return _unsetMeshDummyMaterialAsync.apply(this, arguments);
      }
      return unsetMeshDummyMaterialAsync;
    }()
  }, {
    key: "reloadAllLoadingErrorTexturesAsync",
    value: function () {
      var _reloadAllLoadingErrorTexturesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee63(rootUrl) {
        var _iterator5, _step5, texture;
        return _regeneratorRuntime().wrap(function _callee63$(_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              // ricarico sequenzialmente tutte le texture che hanno avuto un problema in fase di caricamento
              _iterator5 = _createForOfIteratorHelper(this._scene.textures);
              _context65.prev = 1;
              _iterator5.s();
            case 3:
              if ((_step5 = _iterator5.n()).done) {
                _context65.next = 9;
                break;
              }
              texture = _step5.value;
              _context65.next = 7;
              return this.reloadLoadingErrorTextureAsync(rootUrl, texture);
            case 7:
              _context65.next = 3;
              break;
            case 9:
              _context65.next = 14;
              break;
            case 11:
              _context65.prev = 11;
              _context65.t0 = _context65["catch"](1);
              _iterator5.e(_context65.t0);
            case 14:
              _context65.prev = 14;
              _iterator5.f();
              return _context65.finish(14);
            case 17:
            case "end":
              return _context65.stop();
          }
        }, _callee63, this, [[1, 11, 14, 17]]);
      }));
      function reloadAllLoadingErrorTexturesAsync(_x121) {
        return _reloadAllLoadingErrorTexturesAsync.apply(this, arguments);
      }
      return reloadAllLoadingErrorTexturesAsync;
    }()
  }, {
    key: "reloadMaterialLoadingErrorTexturesAsync",
    value: function () {
      var _reloadMaterialLoadingErrorTexturesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee64(rootUrl, material) {
        var _iterator6, _step6, texture;
        return _regeneratorRuntime().wrap(function _callee64$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              _iterator6 = _createForOfIteratorHelper(material.getActiveTextures());
              _context66.prev = 1;
              _iterator6.s();
            case 3:
              if ((_step6 = _iterator6.n()).done) {
                _context66.next = 9;
                break;
              }
              texture = _step6.value;
              _context66.next = 7;
              return this.reloadLoadingErrorTextureAsync(rootUrl, texture);
            case 7:
              _context66.next = 3;
              break;
            case 9:
              _context66.next = 14;
              break;
            case 11:
              _context66.prev = 11;
              _context66.t0 = _context66["catch"](1);
              _iterator6.e(_context66.t0);
            case 14:
              _context66.prev = 14;
              _iterator6.f();
              return _context66.finish(14);
            case 17:
            case "end":
              return _context66.stop();
          }
        }, _callee64, this, [[1, 11, 14, 17]]);
      }));
      function reloadMaterialLoadingErrorTexturesAsync(_x122, _x123) {
        return _reloadMaterialLoadingErrorTexturesAsync.apply(this, arguments);
      }
      return reloadMaterialLoadingErrorTexturesAsync;
    }()
  }, {
    key: "reloadLoadingErrorTextureAsync",
    value: function reloadLoadingErrorTextureAsync(rootUrl, texture) {
      if (texture instanceof BABYLON.Texture && texture.url) {
        var internalTexture = texture.getInternalTexture();
        if (texture.loadingError || internalTexture && internalTexture.loadingError) {
          var originalUrl = texture.url;
          var isAbsolute = /^(?:\/|[a-z]+:\/\/)/.test(texture.url);
          var absoluteUrl = texture.url;
          if (!isAbsolute) absoluteUrl = rootUrl + texture.url;
          return new Promise(function (resolve, reject) {
            texture.updateURL(absoluteUrl, null, function () {
              texture.url = originalUrl;
              resolve();
            }, function () {
              texture.url = originalUrl;
              reject();
            });
          });
        }
      }
      return Promise.resolve();
    }
  }, {
    key: "isTextureLoadingError",
    value: function isTextureLoadingError(texture) {
      if (texture.loadingError) return true;
      var internalTexture = texture.getInternalTexture();
      return internalTexture !== null && internalTexture.loadingError;
    }
  }, {
    key: "materialHasLoadingErrorTextues",
    value: function materialHasLoadingErrorTextues(material) {
      var _this31 = this;
      return material.getActiveTextures().some(function (t) {
        return _this31.isTextureLoadingError(t);
      });
    }

    // A dynamic texture is a procedural texture or a texture created from a Blob
  }, {
    key: "getMaterialDynamicTextures",
    value: function getMaterialDynamicTextures(material) {
      var textures = material.getActiveTextures();
      return textures.filter(function (t) {
        return t instanceof BABYLON.ProceduralTexture || t instanceof BABYLON.Texture && t.url && t.url.indexOf("blob:") !== -1;
      });
    }
  }, {
    key: "exportTextureToBase64Async",
    value: function exportTextureToBase64Async(babylonTexture) {
      var _this32 = this;
      var mimeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "image/png";
      var invertY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return Promise.resolve().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee65() {
        var pixels, size;
        return _regeneratorRuntime().wrap(function _callee65$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              _context67.next = 2;
              return _this32.getPixelsFromTexture(babylonTexture);
            case 2:
              pixels = _context67.sent;
              if (pixels) {
                _context67.next = 5;
                break;
              }
              return _context67.abrupt("return", null);
            case 5:
              size = babylonTexture.getSize(); // Preserve texture mime type if defined
              if (!babylonTexture.mimeType) {
                _context67.next = 14;
                break;
              }
              _context67.t0 = babylonTexture.mimeType;
              _context67.next = _context67.t0 === "image/jpeg" ? 10 : _context67.t0 === "image/png" ? 12 : 14;
              break;
            case 10:
              mimeType = "image/jpeg";
              return _context67.abrupt("break", 14);
            case 12:
              mimeType = "image/png";
              return _context67.abrupt("break", 14);
            case 14:
              return _context67.abrupt("return", _this32.createBase64FromCanvasAsync(pixels, size.width, size.height, mimeType, invertY));
            case 15:
            case "end":
              return _context67.stop();
          }
        }, _callee65);
      })));
    }
  }, {
    key: "createBase64FromCanvasAsync",
    value: function createBase64FromCanvasAsync(buffer, width, height, mimeType) {
      var _this33 = this;
      var invertY = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee66(resolve, reject) {
          var textureType, hostingScene, engine, tempTexture, data, base64;
          return _regeneratorRuntime().wrap(function _callee66$(_context68) {
            while (1) switch (_context68.prev = _context68.next) {
              case 0:
                textureType = BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT;
                hostingScene = _this33._scene;
                engine = hostingScene.getEngine(); // Create a temporary texture with the texture buffer data
                tempTexture = engine.createRawTexture(buffer, width, height, BABYLON.Constants.TEXTUREFORMAT_RGBA, false, invertY, BABYLON.Texture.NEAREST_SAMPLINGMODE, null, textureType);
                _context68.next = 6;
                return BABYLON.TextureTools.ApplyPostProcess("pass", tempTexture, hostingScene, textureType, BABYLON.Constants.TEXTURE_NEAREST_SAMPLINGMODE, BABYLON.Constants.TEXTUREFORMAT_RGBA);
              case 6:
                _context68.next = 8;
                return engine._readTexturePixels(tempTexture, width, height);
              case 8:
                data = _context68.sent;
                _context68.next = 11;
                return BABYLON.Tools.DumpDataAsync(width, height, data, mimeType, undefined, true, false);
              case 11:
                base64 = _context68.sent;
                resolve(base64);
              case 13:
              case "end":
                return _context68.stop();
            }
          }, _callee66);
        }));
        return function (_x124, _x125) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getPixelsFromTexture",
    value: function getPixelsFromTexture(babylonTexture) {
      var pixels = babylonTexture.textureType === BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT ? babylonTexture.readPixels() : babylonTexture.readPixels();
      return pixels;
    }
  }, {
    key: "comparePBRMaterials",
    value: function comparePBRMaterials(mat1, mat2) {
      if (mat1.albedoColor && !mat2.albedoColor || !mat1.albedoColor && mat2.albedoColor || mat1.albedoColor && mat2.albedoColor && !mat1.albedoColor.equals(mat2.albedoColor)) console.log("albedoColor");
      if (mat1.allowShaderHotSwapping !== mat2.allowShaderHotSwapping) console.log("allowShaderHotSwapping");
      if (mat1.alphaCutOff !== mat2.alphaCutOff) console.log("alphaCutOff");
      if (mat1.ambientColor && !mat2.ambientColor || !mat1.ambientColor && mat2.ambientColor || mat1.ambientColor && mat2.ambientColor && !mat1.ambientColor.equals(mat2.ambientColor)) console.log("ambientColor");
      if (mat1.ambientTextureStrength !== mat2.ambientTextureStrength) console.log("ambientTextureStrength");
      this.compareAnisotropy(mat1.anisotropy, mat2.anisotropy);
      this.compareBRDF(mat1.brdf, mat2.brdf);
      this.compareClearCoat(mat1.clearCoat, mat2.clearCoat);
      if (mat1.depthFunction !== mat2.depthFunction) console.log("depthFunction");
      this.compareDetailMap(mat1.detailMap, mat2.detailMap);
      if (mat1.directIntensity !== mat2.directIntensity) console.log("directIntensity");
      if (mat1.disableBumpMap !== mat2.disableBumpMap) console.log("disableBumpMap");
      if (mat1.disableColorWrite !== mat2.disableColorWrite) console.log("disableColorWrite");
      if (mat1.disableDepthWrite !== mat2.disableDepthWrite) console.log("disableDepthWrite");
      if (mat1.disableLighting !== mat2.disableLighting) console.log("disableLighting");
      if (mat1.emissiveColor && !mat2.emissiveColor || !mat1.emissiveColor && mat2.emissiveColor || mat1.emissiveColor && mat2.emissiveColor && !mat1.emissiveColor.equals(mat2.emissiveColor)) console.log("emissiveColor");
      if (mat1.emissiveIntensity !== mat2.emissiveIntensity) console.log("emissiveIntensity");
      if (mat1.enableSpecularAntiAliasing !== mat2.enableSpecularAntiAliasing) console.log("enableSpecularAntiAliasing");
      if (mat1.environmentIntensity !== mat2.environmentIntensity) console.log("environmentIntensity");
      if (mat1.forceAlphaTest !== mat2.forceAlphaTest) console.log("forceAlphaTest");
      if (mat1.forceDepthWrite !== mat2.forceDepthWrite) console.log("forceDepthWrite");
      if (mat1.forceIrradianceInFragment !== mat2.forceIrradianceInFragment) console.log("forceIrradianceInFragment");
      if (mat1.forceNormalForward !== mat2.forceNormalForward) console.log("forceNormalForward");
      if (mat1.invertNormalMapX !== mat2.invertNormalMapX) console.log("invertNormalMapX");
      if (mat1.invertNormalMapY !== mat2.invertNormalMapY) console.log("invertNormalMapY");
      if (mat1.maxSimultaneousLights !== mat2.maxSimultaneousLights) console.log("maxSimultaneousLights");
      if (mat1.metallic !== mat2.metallic) console.log("metallic");
      if (mat1.metallicF0Factor !== mat2.metallicF0Factor) console.log("metallicF0Factor");
      if (mat1.metallicReflectanceColor && !mat2.metallicReflectanceColor || !mat1.metallicReflectanceColor && mat2.metallicReflectanceColor || mat1.metallicReflectanceColor && mat2.metallicReflectanceColor && !mat1.metallicReflectanceColor.equals(mat2.metallicReflectanceColor)) console.log("metallicReflectanceColor");
      if (mat1.microSurface !== mat2.microSurface) console.log("microSurface");
      if (mat1.parallaxScaleBias !== mat2.parallaxScaleBias) console.log("parallaxScaleBias");
      if (mat1.pointSize !== mat2.pointSize) console.log("pointSize");
      this.comparePrePassConfiguration(mat1.prePassConfiguration, mat2.prePassConfiguration);
      if (mat1.reflectionColor && !mat2.reflectionColor || !mat1.reflectionColor && mat2.reflectionColor || mat1.reflectionColor && mat2.reflectionColor && !mat1.reflectionColor.equals(mat2.reflectionColor)) console.log("reflectionColor");
      if (mat1.reflectivityColor && !mat2.reflectivityColor || !mat1.reflectivityColor && mat2.reflectivityColor || mat1.reflectivityColor && mat2.reflectivityColor && !mat1.reflectivityColor.equals(mat2.reflectivityColor)) console.log("reflectivityColor");
      if (mat1.roughness !== mat2.roughness) console.log("roughness");
      if (mat1.separateCullingPass !== mat2.separateCullingPass) console.log("separateCullingPass");
      this.compareSheen(mat1.sheen, mat2.sheen);
      if (mat1.sideOrientation !== mat2.sideOrientation) console.log("sideOrientation");
      if (mat1.specularIntensity !== mat2.specularIntensity) console.log("specularIntensity");
      this.compareSubSurface(mat1.subSurface, mat2.subSurface);
      if (mat1.twoSidedLighting !== mat2.twoSidedLighting) console.log("twoSidedLighting");
      if (mat1.unlit !== mat2.unlit) console.log("unlit");
      if (mat1.useAlphaFresnel !== mat2.useAlphaFresnel) console.log("useAlphaFresnel");
      if (mat1.useAlphaFromAlbedoTexture !== mat2.useAlphaFromAlbedoTexture) console.log("useAlphaFromAlbedoTexture");
      if (mat1.useAmbientInGrayScale !== mat2.useAmbientInGrayScale) console.log("useAmbientInGrayScale");
      if (mat1.useAmbientOcclusionFromMetallicTextureRed !== mat2.useAmbientOcclusionFromMetallicTextureRed) console.log("useAmbientOcclusionFromMetallicTextureRed");
      if (mat1.useAutoMicroSurfaceFromReflectivityMap !== mat2.useAutoMicroSurfaceFromReflectivityMap) console.log("useAutoMicroSurfaceFromReflectivityMap");
      if (mat1.useHorizonOcclusion !== mat2.useHorizonOcclusion) console.log("useHorizonOcclusion");
      if (mat1.useLightmapAsShadowmap !== mat2.useLightmapAsShadowmap) console.log("useLightmapAsShadowmap");
      if (mat1.useLinearAlphaFresnel !== mat2.useLinearAlphaFresnel) console.log("useLinearAlphaFresnel");
      if (mat1.useMetallnessFromMetallicTextureBlue !== mat2.useMetallnessFromMetallicTextureBlue) console.log("useMetallnessFromMetallicTextureBlue");
      if (mat1.useMicroSurfaceFromReflectivityMapAlpha !== mat2.useMicroSurfaceFromReflectivityMapAlpha) console.log("useMicroSurfaceFromReflectivityMapAlpha");
      if (mat1.useObjectSpaceNormalMap !== mat2.useObjectSpaceNormalMap) console.log("useObjectSpaceNormalMap");
      if (mat1.useOnlyMetallicFromMetallicReflectanceTexture !== mat2.useOnlyMetallicFromMetallicReflectanceTexture) console.log("useOnlyMetallicFromMetallicReflectanceTexture");
      if (mat1.useParallax !== mat2.useParallax) console.log("useParallax");
      if (mat1.useParallaxOcclusion !== mat2.useParallaxOcclusion) console.log("useParallaxOcclusion");
      if (mat1.useRadianceOcclusion !== mat2.useRadianceOcclusion) console.log("useRadianceOcclusion");
      if (mat1.useRadianceOverAlpha !== mat2.useRadianceOverAlpha) console.log("useRadianceOverAlpha");
      if (mat1.useRoughnessFromMetallicTextureAlpha !== mat2.useRoughnessFromMetallicTextureAlpha) console.log("useRoughnessFromMetallicTextureAlpha");
      if (mat1.useRoughnessFromMetallicTextureGreen !== mat2.useRoughnessFromMetallicTextureGreen) console.log("useRoughnessFromMetallicTextureGreen");
      if (mat1.useSpecularOverAlpha !== mat2.useSpecularOverAlpha) console.log("useSpecularOverAlpha");
      if (mat1.zOffset !== mat2.zOffset) console.log("zOffset");
      if (mat1.zOffsetUnits !== mat2.zOffsetUnits) console.log("zOffsetUnits");

      // Accessors

      if (mat1.alpha !== mat2.alpha) console.log("alpha");
      if (mat1.alphaMode !== mat2.alphaMode) console.log("alphaMode");
      if (mat1.backFaceCulling !== mat2.backFaceCulling) console.log("backFaceCulling");
      this.compareCameraCurve("", mat1.cameraColorCurves, mat2.cameraColorCurves);
      if (mat1.cameraColorCurvesEnabled !== mat2.cameraColorCurvesEnabled) console.log("cameraColorCurvesEnabled");
      if (mat1.cameraColorGradingEnabled !== mat2.cameraColorGradingEnabled) console.log("cameraColorGradingEnabled");
      if (mat1.cameraContrast !== mat2.cameraContrast) console.log("cameraContrast");
      if (mat1.cameraExposure !== mat2.cameraExposure) console.log("cameraExposure");
      if (mat1.cameraToneMappingEnabled !== mat2.cameraToneMappingEnabled) console.log("cameraToneMappingEnabled");
      if (mat1.canRenderToMRT !== mat2.canRenderToMRT) console.log("canRenderToMRT");
      if (mat1.cullBackFaces !== mat2.cullBackFaces) console.log("cullBackFaces");
      if (mat1.fillMode !== mat2.fillMode) console.log("fillMode");
      if (mat1.fogEnabled !== mat2.fogEnabled) console.log("fogEnabled");
      if (mat1.hasRenderTargetTextures !== mat2.hasRenderTargetTextures) console.log("hasRenderTargetTextures");
      this.compareImageProcessingConfiguration(mat1.imageProcessingConfiguration, mat2.imageProcessingConfiguration);
      if (mat1.indexOfRefraction !== mat2.indexOfRefraction) console.log("indexOfRefraction");
      if (mat1.invertRefractionY !== mat2.invertRefractionY) console.log("invertRefractionY");
      if (mat1.isFrozen !== mat2.isFrozen) console.log("isFrozen");
      if (mat1.isPrePassCapable !== mat2.isPrePassCapable) console.log("isPrePassCapable");
      if (mat1.linkRefractionWithTransparency !== mat2.linkRefractionWithTransparency) console.log("linkRefractionWithTransparency");
      if (mat1.needDepthPrePass !== mat2.needDepthPrePass) console.log("needDepthPrePass");
      if (mat1.realTimeFiltering !== mat2.realTimeFiltering) console.log("realTimeFiltering");
      if (mat1.realTimeFilteringQuality !== mat2.realTimeFilteringQuality) console.log("realTimeFilteringQuality");
      if (mat1.transparencyMode !== mat2.transparencyMode) console.log("transparencyMode");
      if (mat1.useGLTFLightFalloff !== mat2.useGLTFLightFalloff) console.log("useGLTFLightFalloff");
      if (mat1.useLogarithmicDepth !== mat2.useLogarithmicDepth) console.log("useLogarithmicDepth");
      if (mat1.usePhysicalLightFalloff !== mat2.usePhysicalLightFalloff) console.log("usePhysicalLightFalloff");
      this.compareTexture("albedo", mat1.albedoTexture, mat2.albedoTexture);
      this.compareTexture("emissive", mat1.emissiveTexture, mat2.emissiveTexture);
    }
  }, {
    key: "compareAnisotropy",
    value: function compareAnisotropy(an1, an2) {
      var prefix = "anisotropy";
      if (an1.direction && !an2.direction || !an1.direction && an2.direction || an1.direction && an2.direction && !an1.direction.equals(an2.direction)) console.log(prefix + " - direction");
      if (an1.intensity !== an2.intensity) console.log(prefix + " - intensity");
      if (an1.isEnabled !== an2.isEnabled) console.log(prefix + " - isEnabled");
    }
  }, {
    key: "compareBRDF",
    value: function compareBRDF(b1, b2) {
      var prefix = "brdf";
      if (b1.useEnergyConservation !== b2.useEnergyConservation) console.log(prefix + " - useEnergyConservation");
      if (b1.useSmithVisibilityHeightCorrelated !== b2.useSmithVisibilityHeightCorrelated) console.log(prefix + " - useSmithVisibilityHeightCorrelated");
      if (b1.useSpecularGlossinessInputEnergyConservation !== b2.useSpecularGlossinessInputEnergyConservation) console.log(prefix + " - useSpecularGlossinessInputEnergyConservation");
      if (b1.useSphericalHarmonics !== b2.useSphericalHarmonics) console.log(prefix + " - useSphericalHarmonics");
    }
  }, {
    key: "compareClearCoat",
    value: function compareClearCoat(c1, c2) {
      var prefix = "clearCoat";
      if (c1.indexOfRefraction !== c2.indexOfRefraction) console.log(prefix + " - indexOfRefraction");
      if (c1.intensity !== c2.intensity) console.log(prefix + " - intensity");
      if (c1.isEnabled !== c2.isEnabled) console.log(prefix + " - isEnabled");
      if (c1.isTintEnabled !== c2.isTintEnabled) console.log(prefix + " - isTintEnabled");
      if (c1.roughness !== c2.roughness) console.log(prefix + " - roughness");
      if (c1.tintColor && !c2.tintColor || !c1.tintColor && c2.tintColor || c1.tintColor && c2.tintColor && !c1.tintColor.equals(c2.tintColor)) console.log(prefix + " - tintColor");
      if (c1.tintColorAtDistance !== c2.tintColorAtDistance) console.log(prefix + " - tintColorAtDistance");
      if (c1.tintThickness !== c2.tintThickness) console.log(prefix + " - tintThickness");
      if (c1.useRoughnessFromMainTexture != c2.useRoughnessFromMainTexture) console.log(prefix + " - useRoughnessFromMainTexture");
    }
  }, {
    key: "compareDetailMap",
    value: function compareDetailMap(m1, m2) {
      var prefix = "detailMap";
      if (m1.bumpLevel !== m2.bumpLevel) console.log(prefix + " - bumpLevel");
      if (m1.diffuseBlendLevel !== m2.diffuseBlendLevel) console.log(prefix + " - diffuseBlendLevel");
      if (m1.isEnabled !== m2.isEnabled) console.log(prefix + " - isEnabled");
      if (m1.normalBlendMethod !== m2.normalBlendMethod) console.log(prefix + " - normalBlendMethod");
      if (m1.roughnessBlendLevel !== m2.roughnessBlendLevel) console.log(prefix + " - roughnessBlendLevel");
    }
  }, {
    key: "comparePrePassConfiguration",
    value: function comparePrePassConfiguration(c1, c2) {
      var prefix = "PrePassConfiguration";
      if (c1.currentViewProjection && !c2.currentViewProjection || !c1.currentViewProjection && c2.currentViewProjection || c1.currentViewProjection && c2.currentViewProjection && !c1.currentViewProjection.equals(c2.currentViewProjection)) console.log(prefix + " - currentViewProjection");
      if (c1.previousViewProjection && !c2.previousViewProjection || !c1.previousViewProjection && c2.previousViewProjection || c1.previousViewProjection && c2.previousViewProjection && !c1.previousViewProjection.equals(c2.previousViewProjection)) console.log(prefix + " - previousViewProjection");
    }
  }, {
    key: "compareSheen",
    value: function compareSheen(s1, s2) {
      var prefix = "Sheen";
      if (s1.albedoScaling !== s2.albedoScaling) console.log(prefix + " - albedoScaling");
      if (s1.color && !s2.color || !s1.color && s2.color || s1.color && s2.color && !s1.color.equals(s2.color)) console.log(prefix + " - color");
      if (s1.intensity !== s2.intensity) console.log(prefix + " - intensity");
      if (s1.isEnabled !== s2.isEnabled) console.log(prefix + " - isEnabled");
      if (s1.linkSheenWithAlbedo !== s2.linkSheenWithAlbedo) console.log(prefix + " - linkSheenWithAlbedo");
      if (s1.roughness !== s2.roughness) console.log(prefix + " - roughness");
      if (s1.useRoughnessFromMainTexture !== s2.useRoughnessFromMainTexture) console.log(prefix + " - useRoughnessFromMainTexture");
    }
  }, {
    key: "compareSubSurface",
    value: function compareSubSurface(s1, s2) {
      var prefix = "SubSurface";
      if (s1.diffusionDistance && !s2.diffusionDistance || !s1.diffusionDistance && s2.diffusionDistance || s1.diffusionDistance && s2.diffusionDistance && !s1.diffusionDistance.equals(s2.diffusionDistance)) console.log(prefix + " - diffusionDistance");
      if (s1.indexOfRefraction !== s2.indexOfRefraction) console.log(prefix + " - indexOfRefraction");
      if (s1.invertRefractionY !== s2.invertRefractionY) console.log(prefix + " - invertRefractionY");
      if (s1.isRefractionEnabled !== s2.isRefractionEnabled) console.log(prefix + " - isRefractionEnabled");
      if (s1.isScatteringEnabled !== s2.isScatteringEnabled) console.log(prefix + " - isScatteringEnabled");
      if (s1.isTranslucencyEnabled !== s2.isTranslucencyEnabled) console.log(prefix + " - isTranslucencyEnabled");
      if (s1.linkRefractionWithTransparency !== s2.linkRefractionWithTransparency) console.log(prefix + " - linkRefractionWithTransparency");
      if (s1.maximumThickness !== s2.maximumThickness) console.log(prefix + " - maximumThickness");
      if (s1.minimumThickness !== s2.minimumThickness) console.log(prefix + " - minimumThickness");
      if (s1.refractionIntensity !== s2.refractionIntensity) console.log(prefix + " - refractionIntensity");
      if (s1.tintColor && !s2.tintColor || !s1.tintColor && s2.tintColor || s1.tintColor && s2.tintColor && !s1.tintColor.equals(s2.tintColor)) console.log(prefix + " - tintColor");
      if (s1.tintColorAtDistance !== s2.tintColorAtDistance) console.log(prefix + " - tintColorAtDistance");
      if (s1.translucencyIntensity !== s2.translucencyIntensity) console.log(prefix + " - translucencyIntensity");
      if (s1.useAlbedoToTintRefraction !== s2.useAlbedoToTintRefraction) console.log(prefix + " - useAlbedoToTintRefraction");
      if (s1.useAlbedoToTintTranslucency !== s2.useAlbedoToTintTranslucency) console.log(prefix + " - useAlbedoToTintTranslucency");
      if (s1.useGltfStyleTextures !== s2.useGltfStyleTextures) console.log(prefix + " - useGltfStyleTextures");
      if (s1.useMaskFromThicknessTexture !== s2.useMaskFromThicknessTexture) console.log(prefix + " - useMaskFromThicknessTexture");
      if (s1.useThicknessAsDepth !== s2.useThicknessAsDepth) console.log(prefix + " - useThicknessAsDepth");
    }
  }, {
    key: "compareCameraCurve",
    value: function compareCameraCurve(pref, c1, c2) {
      if (c1 === null && c2 !== null || c1 !== null && c2 === null) console.log("cameraColorCurves");
      if (c1 && c2) {
        var prefix = pref ? pref + " - cameraColorCurves" : "cameraColorCurves";
        if (c1.globalDensity !== c2.globalDensity) console.log(prefix + " - globalDensity");
        if (c1.globalExposure !== c2.globalExposure) console.log(prefix + "- globalExposure");
        if (c1.globalHue !== c2.globalHue) console.log(prefix + " - globalHue");
        if (c1.globalSaturation !== c2.globalSaturation) console.log(prefix + " - globalSaturation");
        if (c1.highlightsDensity !== c2.highlightsDensity) console.log(prefix + " - highlightsDensity");
        if (c1.highlightsExposure !== c2.highlightsExposure) console.log(prefix + " - highlightsExposure");
        if (c1.highlightsHue !== c2.highlightsHue) console.log(prefix + " - highlightsHue");
        if (c1.highlightsSaturation !== c2.highlightsSaturation) console.log(prefix + " - highlightsSaturation");
        if (c1.midtonesDensity !== c2.midtonesDensity) console.log(prefix + " - midtonesDensity");
        if (c1.midtonesExposure !== c2.midtonesExposure) console.log(prefix + " - midtonesExposure");
        if (c1.midtonesHue !== c2.midtonesHue) console.log(prefix + " - midtonesHue");
        if (c1.midtonesSaturation !== c2.midtonesSaturation) console.log(prefix + " - midtonesSaturation");
        if (c1.shadowsDensity !== c2.shadowsDensity) console.log(prefix + " - shadowsDensity");
        if (c1.shadowsExposure !== c2.shadowsExposure) console.log(prefix + " - shadowsExposure");
        if (c1.shadowsHue !== c2.shadowsHue) console.log(prefix + " - shadowsHue");
        if (c1.shadowsSaturation !== c2.shadowsSaturation) console.log(prefix + " - shadowsSaturation");
      }
    }
  }, {
    key: "compareImageProcessingConfiguration",
    value: function compareImageProcessingConfiguration(c1, c2) {
      var prefix = "imageProcessingConfiguration";
      this.compareCameraCurve(prefix, c1.colorCurves, c2.colorCurves);
      if (c1.vignetteCameraFov !== c2.vignetteCameraFov) console.log(prefix + " - vignetteCameraFov");
      if (c1.vignetteCentreX !== c2.vignetteCentreX) console.log(prefix + " - vignetteCentreX");
      if (c1.vignetteCentreY !== c2.vignetteCentreY) console.log(prefix + " - vignetteCentreY");
      if (c1.vignetteColor && !c2.vignetteColor || !c1.vignetteColor && c2.vignetteColor || c1.vignetteColor && c2.vignetteColor && !c1.vignetteColor.equals(c2.vignetteColor)) console.log(prefix + " - vignetteColor");
      if (c1.vignetteStretch !== c2.vignetteStretch) console.log(prefix + " - vignetteStretch");
      if (c1.vignetteWeight !== c2.vignetteWeight) console.log(prefix + " - vignetteWeight");

      // Accessors

      if (c1.applyByPostProcess !== c2.applyByPostProcess) console.log(prefix + " - applyByPostProcess");
      if (c1.colorCurvesEnabled !== c2.colorCurvesEnabled) console.log(prefix + " - colorCurvesEnabled");
      if (c1.colorGradingBGR !== c2.colorGradingBGR) console.log(prefix + " - colorGradingBGR");
      if (c1.colorGradingEnabled !== c2.colorGradingEnabled) console.log(prefix + " - colorGradingEnabled");
      if (c1.colorGradingWithGreenDepth !== c2.colorGradingWithGreenDepth) console.log(prefix + " - colorGradingWithGreenDepth");
      if (c1.contrast !== c2.contrast) console.log(prefix + " - contrast");
      if (c1.exposure !== c2.exposure) console.log(prefix + " - exposure");
      if (c1.isEnabled !== c2.isEnabled) console.log(prefix + " - isEnabled");
      if (c1.toneMappingEnabled !== c2.toneMappingEnabled) console.log(prefix + " - toneMappingEnabled");
      if (c1.toneMappingType !== c2.toneMappingType) console.log(prefix + " - toneMappingType");
      if (c1.vignetteBlendMode !== c2.vignetteBlendMode) console.log(prefix + " - vignetteBlendMode");
      if (c1.vignetteEnabled !== c2.vignetteEnabled) console.log(prefix + " - vignetteEnabled");
    }
  }, {
    key: "compareTexture",
    value: function compareTexture(type, t1, t2) {
      if (t1 && !t2 || !t1 && t2) {
        console.log(type);
        return;
      }
      if (t1 instanceof BABYLON.Texture && !(t2 instanceof BABYLON.Texture) || t2 instanceof BABYLON.Texture && !(t1 instanceof BABYLON.Texture)) {
        console.log(type);
        return;
      }
      if (t1 && t2) {
        if (t1.anisotropicFilteringLevel !== t2.anisotropicFilteringLevel) console.log(type + " - anisotropicFilteringLevel");
        if (t1 instanceof BABYLON.Texture && t2 instanceof BABYLON.Texture) {
          if (t1.homogeneousRotationInUVTransform !== t2.homogeneousRotationInUVTransform) console.log(type + " - homogeneousRotationInUVTransform");
          if (t1.uAng !== t2.uAng) console.log(type + " - uAng");
          if (t1.uOffset !== t2.uOffset) console.log(type + " - uOffset");
          if (t1.uRotationCenter !== t2.uRotationCenter) console.log(type + " - uRotationCenterSearch");
          if (t1.uScale !== t2.uScale) console.log(type + " - uScale");
          if (t1.vAng !== t2.vAng) console.log(type + " - vAng");
          if (t1.vOffset !== t2.vOffset) console.log(type + " - vOffset");
          if (t1.vRotationCenter !== t2.vRotationCenter) console.log(type + " - vRotationCenterSearch");
          if (t1.vScale !== t2.vScale) console.log(type + " - vScale");
          if (t1.wAng !== t2.wAng) console.log(type + " - wAng");
          if (t1.wRotationCenter !== t2.wRotationCenter) console.log(type + " - wRotationCenterSearch");
          if (t1.invertY !== t2.invertY) console.log(type + " - invertY");
          if (t1.mimeType !== t2.mimeType) console.log(type + " - mimeType");
        }
        if (t1.invertZ !== t2.invertZ) console.log(type + " - invertZ");
        if (t1.isRenderTarget !== t2.isRenderTarget) console.log(type + " - isRenderTarget");
        if (t1.level !== t2.level) console.log(type + " - level");
        if (t1.wrapR !== t2.wrapR) console.log(type + " - wrapR");

        // Accessor

        if (t1.canRescale !== t2.canRescale) console.log(type + " - canRescale");
        if (t1.coordinatesIndex !== t2.coordinatesIndex) console.log(type + " - coordinatesIndex");
        if (t1.coordinatesMode !== t2.coordinatesMode) console.log(type + " - coordinatesMode");
        if (t1.gammaSpace !== t2.gammaSpace) console.log(type + " - gammaSpace");
        if (t1.getAlphaFromRGB !== t2.getAlphaFromRGB) console.log(type + " - getAlphaFromRGB");
        if (t1.hasAlpha !== t2.hasAlpha) console.log(type + "- hasAlpha");
        if (t1.is2DArray !== t2.is2DArray) console.log(type + " - is2DArray");
        if (t1.is3D !== t2.is3D) console.log(type + " - is3D");
        if (t1.isBlocking !== t2.isBlocking) console.log(type + " - isBlocking");
        if (t1.isCube !== t2.isCube) console.log(type + " - isCube");
        if (t1.isRGBD !== t2.isRGBD) console.log(type + " - isRGBD");
        if (t1.linearSpecularLOD !== t2.linearSpecularLOD) console.log(type + " - linearSpecularLOD");
        if (t1.lodGenerationOffset !== t2.lodGenerationOffset) console.log(type + " - lodGenerationOffset");
        if (t1.lodGenerationScale !== t2.lodGenerationScale) console.log(type + " - lodGenerationScale");
        if (t1.noMipmap !== t2.noMipmap) console.log(type + " - noMipmap");
        if (t1.samplingMode !== t2.samplingMode) console.log(type + " - samplingMode");
        if (t1.textureFormat !== t2.textureFormat) console.log(type + " - textureFormat");
        if (t1.textureType !== t2.textureType) console.log(type + " - textureType");
        if (t1.wrapU !== t2.wrapU) console.log(type + " - wrapU");
        if (t1.wrapV !== t2.wrapV) console.log(type + " - wrapV");
      }
    }

    /**
     * Clear the scene and generate a canvas mesh
     * @param meshID The mesh ID to use, must be passed from the scene editor to update correctly the MeshSide
     * @param width The width of the canvas
     * @param height The height of the canvas
     * @param depth The depth of the canvas
     * @param borderRadius The border radius of the canvas
     * @returns The id of the generated mesh
     */
  }, {
    key: "showResizableCanvas",
    value: function () {
      var _showResizableCanvas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee67(width, height, depth, borderRadius, type, borderColor, columns, rows) {
        var serializedMesh, loadedMeshes, groupMesh, scale, light;
        return _regeneratorRuntime().wrap(function _callee67$(_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              if (!this._scene) {
                _context69.next = 13;
                break;
              }
              this.clearMeshes();

              // Generate the canvas mesh
              serializedMesh = this._resizableCanvas3DGenerator.generatePreview3D({
                width: width,
                height: height,
                depth: depth,
                borderRadius: borderRadius,
                radiusResolution: 0.1,
                type: type,
                borderColor: borderColor,
                columns: columns,
                rows: rows,
                useCheckerTexture: false
              }, this._scene);
              _context69.next = 5;
              return BABYLON.SceneLoader.ImportMeshAsync('', '', 'data:' + JSON.stringify(serializedMesh));
            case 5:
              loadedMeshes = _context69.sent;
              // Scale to a max of 2 for a better light
              groupMesh = loadedMeshes.meshes[0];
              scale = 2 / Math.max(width, height);
              groupMesh.scaling.scaleInPlace(scale);

              // Move the group a little back
              groupMesh.position.z = -0.5;

              // For canvas we need a better and more intense light 
              // to avoid that the material looks gray
              light = this.getDefaultHemisphericLight();
              if (light) {
                light.intensity = 1;
                light.direction = new BABYLON.Vector3(0, 1, -1);
              }
              return _context69.abrupt("return", loadedMeshes.meshes);
            case 13:
              return _context69.abrupt("return", null);
            case 14:
            case "end":
              return _context69.stop();
          }
        }, _callee67, this);
      }));
      function showResizableCanvas(_x126, _x127, _x128, _x129, _x130, _x131, _x132, _x133) {
        return _showResizableCanvas.apply(this, arguments);
      }
      return showResizableCanvas;
    }()
    /**
     * Remove all meshes from the scene
     */
  }, {
    key: "clearMeshes",
    value: function clearMeshes() {
      // Clean the scene
      this._scene.meshes.forEach(function (m) {
        return m.dispose();
      });
      this._scene.meshes = [];
    }
  }], [{
    key: "checkAllMaterialTextureReady",
    value: function checkAllMaterialTextureReady(material) {
      var textures = material.getActiveTextures();
      for (var i = 0; i < textures.length; i++) {
        var texture = textures[i];
        if (!texture.isReady()) return false;else {
          if (texture instanceof BABYLON.ProceduralTexture) texture.getEffect();
        }
      }
      return true;
    }
  }, {
    key: "whenAllMaterialTexturesAreReady",
    value: function whenAllMaterialTexturesAreReady(material) {
      var _this34 = this;
      return new Promise(function (resolve, reject) {
        if (_this34.checkAllMaterialTextureReady(material)) resolve();else {
          var t = setInterval(function () {
            if (_this34.checkAllMaterialTextureReady(material)) {
              clearInterval(t);
              resolve();
            }
          }, 5);
        }
      });
    }
  }, {
    key: "whenTextureIsReadyAsync",
    value: function whenTextureIsReadyAsync(texture) {
      return new Promise(function (resolve, reject) {
        if (texture.isReady()) resolve();else {
          var t = setInterval(function () {
            if (texture.isReady()) {
              clearInterval(t);
              if (texture instanceof BABYLON.ProceduralTexture) texture.getEffect();
              resolve();
            }
          }, 5);
        }
      });
    }
  }, {
    key: "whenMeshMaterialIsReady",
    value: function whenMeshMaterialIsReady(mesh) {
      return new Promise(function (resolve, reject) {
        var t = setInterval(function () {
          if (!mesh.material || mesh.material.isReady(mesh)) {
            clearInterval(t);
            resolve();
          }
        }, 5);
      });
    }
  }, {
    key: "whenMaterialIsReadyForSubMeshAsync",
    value: function whenMaterialIsReadyForSubMeshAsync(material, mesh, subMesh) {
      return new Promise(function (resolve, reject) {
        if (material.isReadyForSubMesh(mesh, subMesh)) {
          Logger.info("Material ".concat(material.name, " ready"));
          resolve();
        } else {
          Logger.info("Material ".concat(material.name, " NOT ready"));
          var t = setInterval(function () {
            if (material.isReadyForSubMesh(mesh, subMesh) && (!mesh.material || mesh.material != material || mesh.material.isReady(mesh))) {
              Logger.info("Material ".concat(material.name, " ready"));
              clearInterval(t);
              resolve();
            }
          }, 5);
        }
      });
    }
  }, {
    key: "getMeshGeometry",
    value: function getMeshGeometry(mesh) {
      if (mesh.geometry) return mesh.geometry;
      var scene = mesh.getScene();
      var geometries = scene.getGeometries();
      for (var i = 0; i < geometries.length; i++) {
        var geometry = geometries[i];
        if (geometry.meshes.find(function (m) {
          return m === mesh;
        })) return geometry;
      }
      return null;
    }
  }, {
    key: "checkMeshIsReady",
    value: function checkMeshIsReady(mesh) {
      if (mesh instanceof BABYLON.Mesh) {
        mesh._checkDelayState();
        if (mesh.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED) return false;
        if (!mesh.geometry) {
          var scene = mesh.getScene();
          var geometries = scene.getGeometries();
          for (var i = 0; i < geometries.length; i++) {
            var geometry = geometries[i];
            if (geometry.meshes.find(function (m) {
              return m === mesh;
            }) && !geometry.isReady()) {
              return false;
            }
          }
        }
        if (mesh.geometry && !mesh.geometry.isReady()) return false;
        for (var j = 0; j < mesh.getChildMeshes().length; j++) {
          var child = mesh.getChildMeshes()[j];
          if (!this.checkMeshIsReady(child)) return false;
        }
      }
      return mesh.isReady(true);
    }
  }, {
    key: "checkAllMeshesAreReady",
    value: function checkAllMeshesAreReady(meshes) {
      var ret = true;
      for (var i = 0; i < meshes.length; i++) if (!this.checkMeshIsReady(meshes[i])) ret = false;
      return ret;
    }
  }, {
    key: "whenAllMeshesAreReadyAsync",
    value: function whenAllMeshesAreReadyAsync(meshes) {
      var _this35 = this;
      return new Promise(function (resolve, reject) {
        if (_this35.checkAllMeshesAreReady(meshes)) {
          resolve();
        } else {
          var t = setInterval(function () {
            if (_this35.checkAllMeshesAreReady(meshes)) {
              clearInterval(t);
              resolve();
            }
          }, 5);
        }
      });
    }
  }, {
    key: "whenAllVisibleMeshesAreReadyAsync",
    value: function () {
      var _whenAllVisibleMeshesAreReadyAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee68(scene) {
        var meshes;
        return _regeneratorRuntime().wrap(function _callee68$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              meshes = scene.meshes.filter(function (m) {
                return m.isVisible;
              });
              _context70.next = 3;
              return this.whenAllMeshesAreReadyAsync(meshes);
            case 3:
            case "end":
              return _context70.stop();
          }
        }, _callee68, this);
      }));
      function whenAllVisibleMeshesAreReadyAsync(_x134) {
        return _whenAllVisibleMeshesAreReadyAsync.apply(this, arguments);
      }
      return whenAllVisibleMeshesAreReadyAsync;
    }()
  }, {
    key: "whenMeshIsReadyAsync",
    value: function whenMeshIsReadyAsync(mesh) {
      var _this36 = this;
      return new Promise(function (resolve, reject) {
        if (_this36.checkMeshIsReady(mesh)) {
          resolve();
        } else {
          var t = setInterval(function () {
            if (_this36.checkMeshIsReady(mesh)) {
              clearInterval(t);
              resolve();
            }
          }, 5);
        }
      });
    }
  }, {
    key: "visibleMeshesRequireDelayedLoading",
    value: function visibleMeshesRequireDelayedLoading(scene) {
      var meshes = scene.meshes.filter(function (m) {
        return m.isVisible;
      });
      for (var i = 0; i < meshes.length; i++) {
        if (this.meshRequiresDelayedLoading(meshes[i])) return true;
      }
      return false;
    }
  }, {
    key: "meshRequiresDelayedLoading",
    value: function meshRequiresDelayedLoading(mesh) {
      if (mesh instanceof BABYLON.Mesh) {
        if (mesh.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED || mesh.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING) return true;
        var geometry = SceneHelper.getMeshGeometry(mesh);
        if (geometry && (geometry.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING || geometry.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED)) return true;
      }
      return false;
    }
  }]);
  return SceneHelper;
}();

/***/ }),

/***/ "../../3D/src/Components/SceneToBlobs/SceneToBlobs.ts":
/*!************************************************************!*\
  !*** ../../3D/src/Components/SceneToBlobs/SceneToBlobs.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SceneToBlobs": () => (/* binding */ SceneToBlobs)
/* harmony export */ });
/* harmony import */ var _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Misc/WorkerPool */ "../../3D/src/Misc/WorkerPool.ts");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function loadScriptAsync(url) {
  if (typeof importScripts === "function") {
    importScripts(url);
    return Promise.resolve();
  } else {
    return new Promise(function (resolve, reject) {
      BABYLON.Tools.LoadScript(url, function () {
        resolve();
      }, function (message) {
        reject(new Error(message));
      });
    });
  }
}
function importWorkerScriptsAsync(urls) {
  if (urls.length == 0) return Promise.resolve();
  var promises = [];
  for (var i = 0; i < urls.length; i++) {
    promises.push(loadScriptAsync(urls[i]));
  }
  return new Promise(function (resolve) {
    Promise.all(promises).then(function () {
      return resolve();
    });
  });
}
function chunkString(str, size) {
  // Rollup will try to execute this function with str as undefined. IDK
  if (!str) return null;
  return str.match(new RegExp('.[^]{1,' + size + '}', 'g'));
}
function makeBlobs(json, version, onProgress) {
  var name = "scene_" + version + ".babylon";
  var data = json;
  var blobInfos = [];

  // Se il file di scena supera i 5000000 di bytes viene spezzato in blocchi di 800000 che vengono compressi

  if (data.length <= 5000000) {
    // Unico blob. verifico se comprimere i dati 

    var compressed = false;
    if (data.length > 180 && data.length <= 1000000) {
      //Logger.info("Uncompressed file length: " + data.length);
      // compress file content
      data = LZString.compressToUint8Array(data);
      //Logger.info("Compressed file length: " + data.length);
      name = "compressed_" + name;
      compressed = true;
    }
    var blob = null;
    if (!compressed) {
      blob = new Blob([data], {
        type: "text/plain"
      });
    } else {
      var _arrayBuffer = data.buffer;
      blob = new Blob([_arrayBuffer]);
    }
    if (blob) {
      blobInfos.push({
        name: name,
        blob: blob
      });
    }
  } else {
    // separo il file in chunks da comprimere
    var chunks = chunkString(data, 800000);
    if (chunks) {
      for (var i = 0; i < chunks.length; i++) {
        var chunkData = chunks[i];
        var chunkFileName = name + "_part_" + i;
        var _compressed = false;
        if (chunkData.length > 180) {
          //Logger.info("Uncompressed file length: " + chunkData.length);
          // compress file content
          chunkData = LZString.compressToUint8Array(chunkData);
          //Logger.info("Compressed file length: " + chunkData.length);
          chunkFileName = "compressed_" + chunkFileName;
          _compressed = true;
        }
        var _blob = null;
        if (!_compressed) {
          _blob = new Blob([chunkData], {
            type: "text/plain"
          });
        } else {
          var arrayBuffer = chunkData.buffer;
          _blob = new Blob([arrayBuffer]);
        }
        if (_blob) {
          blobInfos.push({
            name: chunkFileName,
            blob: _blob
          });
        }
        onProgress(i / chunks.length * 100);
      }
    }
  }
  return blobInfos;
}
function getAbsoluteUrl(url) {
  if ((typeof document === "undefined" ? "undefined" : _typeof(document)) !== "object" || typeof url !== "string") {
    return url;
  }
  return BABYLON.Tools.GetAbsoluteUrl(url);
}

/**
 * The worker function that gets converted to a blob url to pass into a worker.
 */
function worker() {
  var initializerPromise;
  onmessage = function onmessage(event) {
    var data = event.data;
    switch (data.id) {
      case "init":
        {
          var urls = data.urls;
          initializerPromise = importWorkerScriptsAsync(urls);
          postMessage("done");
          break;
        }
      case "makeBlobs":
        {
          if (!initializerPromise) {
            throw new Error("Worker not initialized");
          }
          initializerPromise.then(function () {
            var json = data.json;
            var version = data.version;
            var blobInfos = makeBlobs(json, version, function (perc) {
              postMessage({
                id: "progress",
                perc: perc
              });
            });
            postMessage({
              id: "result",
              blobInfos: blobInfos
            });
            postMessage("done");
          });
          break;
        }
    }
  };
}
var SceneToBlobs = /*#__PURE__*/function () {
  /**
  * Constructor
  * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
  */
  function SceneToBlobs() {
    var numWorkers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SceneToBlobs.DefaultNumWorkers;
    _classCallCheck(this, SceneToBlobs);
    var scriptUrls = ['/Scripts/libs/lz-string/base64-string.js', '/Scripts/libs/lz-string/lz-string.min.js'].map(function (url) {
      return getAbsoluteUrl(url);
    });
    if (numWorkers && typeof Worker === "function") {
      var workerContent = "".concat(loadScriptAsync).concat(importWorkerScriptsAsync).concat(chunkString).concat(makeBlobs, "(").concat(worker, ")()");
      var workerBlobUrl = URL.createObjectURL(new Blob([workerContent], {
        type: "application/javascript"
      }));
      var workerPromises = new Array(numWorkers);
      for (var i = 0; i < workerPromises.length; i++) {
        workerPromises[i] = new Promise(function (resolve, reject) {
          var worker = new Worker(workerBlobUrl);
          var onError = function onError(error) {
            worker.removeEventListener("error", onError);
            worker.removeEventListener("message", onMessage);
            reject(error);
          };
          var onMessage = function onMessage(message) {
            if (message.data === "done") {
              worker.removeEventListener("error", onError);
              worker.removeEventListener("message", onMessage);
              resolve(worker);
            }
          };
          worker.addEventListener("error", onError);
          worker.addEventListener("message", onMessage);
          worker.postMessage({
            id: "init",
            urls: scriptUrls
          });
        });
      }
      this._workerPoolPromise = Promise.all(workerPromises).then(function (workers) {
        return new _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__.WorkerPool(workers);
      });
    }
  }
  _createClass(SceneToBlobs, [{
    key: "dispose",
    value: function dispose() {
      //if (this._workerPoolPromise) {
      //    this._workerPoolPromise.then((workerPool) => {
      //        workerPool.dispose();
      //    });
      //}

      //delete this._workerPoolPromise;
    }

    /**
    * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
    * @returns a promise that resolves when ready
    */
  }, {
    key: "whenReadyAsync",
    value: function whenReadyAsync() {
      if (this._workerPoolPromise) {
        return this._workerPoolPromise.then(function () {});
      }
      return Promise.resolve();
    }
  }, {
    key: "getSceneBlobsAsync",
    value: function getSceneBlobsAsync(json, version, onProgress) {
      if (this._workerPoolPromise) {
        return this._workerPoolPromise.then(function (workerPool) {
          return new Promise(function (resolve, reject) {
            workerPool.push(function (worker, onComplete) {
              var blobInfos = [];
              var onError = function onError(error) {
                worker.removeEventListener("error", onError);
                worker.removeEventListener("message", onMessage);
                reject(error);
                onComplete();
              };
              var onMessage = function onMessage(message) {
                if (message.data === "done") {
                  worker.removeEventListener("error", onError);
                  worker.removeEventListener("message", onMessage);
                  resolve(blobInfos);
                  onComplete();
                } else if (message.data.id === "progress") {
                  onProgress(message.data.perc);
                } else if (message.data.id === "result") {
                  blobInfos = message.data.blobInfos;
                }
              };
              worker.addEventListener("error", onError);
              worker.addEventListener("message", onMessage);
              worker.postMessage({
                id: "makeBlobs",
                json: json,
                version: version
              });
            });
          });
        });
      }
      throw new Error("SceneToBlob worker is not available");
    }
  }], [{
    key: "GetDefaultNumWorkers",
    value: function GetDefaultNumWorkers() {
      if ((typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) !== "object" || !navigator.hardwareConcurrency) {
        return 1;
      }

      // Use 50% of the available logical processors but capped at 2.
      return Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
    }
  }, {
    key: "Default",
    get:
    /**
     * Default instance for the draco compression object.
     */
    function get() {
      if (!SceneToBlobs._Default) {
        SceneToBlobs._Default = new SceneToBlobs();
      }
      return SceneToBlobs._Default;
    }
  }]);
  return SceneToBlobs;
}();
/**
 * Default number of workers to create when splitting files
 */
_defineProperty(SceneToBlobs, "DefaultNumWorkers", SceneToBlobs.GetDefaultNumWorkers());
_defineProperty(SceneToBlobs, "_Default", null);

/***/ }),

/***/ "../../3D/src/Components/Selector/ElementSelector.ts":
/*!***********************************************************!*\
  !*** ../../3D/src/Components/Selector/ElementSelector.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ElementSelector": () => (/* binding */ ElementSelector)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ElementSelector = /*#__PURE__*/function () {
  function ElementSelector() {
    _classCallCheck(this, ElementSelector);
  }
  _createClass(ElementSelector, [{
    key: "getSubmeshIdx",
    value: function getSubmeshIdx(selectionExpression) {
      var idx = selectionExpression.lastIndexOf("-");
      if (idx != -1) {
        selectionExpression = selectionExpression.substring(0, idx);
        var smidx = Number(selectionExpression.substring(idx + 1));
        if (smidx && !isNaN(smidx)) return smidx;
      }
      return null;
    }
  }, {
    key: "getRegExp",
    value: function getRegExp(selectionExpression, type) {
      var subMeshIndex = 0;
      if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
        var idx = selectionExpression.lastIndexOf("-");
        if (idx != -1) {
          selectionExpression = selectionExpression.substring(0, idx);
          var smidx = Number(selectionExpression.substring(idx + 1));
          if (smidx && !isNaN(smidx)) {
            subMeshIndex = smidx;
          }
        }
      }
      return new RegExp(this.escapeRegExp(selectionExpression).replace(/\\\*/g, ".*"), "i");
    }
  }, {
    key: "getElements",
    value: function getElements(zkScene, scene, filter, expression, type) {
      var elements = [];

      // Le espressioni ammesse sono quelle con i caratteri jolly *
      // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
      // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
      // Es. "classic_*;modern_*;sport_*"

      var parts = expression.split(";");
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var selectionExpression = part;
        var regExp = this.getRegExp(part, type);
        if ((type & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
          var meshes = this.getMeshes(zkScene, scene, filter, regExp, selectionExpression);
          Array.prototype.push.apply(elements, meshes);
        }
        if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
          var subMeshIndex = this.getSubmeshIdx(selectionExpression);
          if (subMeshIndex) {
            var subMeshes = this.getSubMeshes(zkScene, scene, filter, regExp, selectionExpression, subMeshIndex);
            Array.prototype.push.apply(elements, subMeshes);
          }
        }
        if ((type & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
          var materials = this.getMaterials(zkScene, scene, filter, regExp, selectionExpression);
          Array.prototype.push.apply(elements, materials);
        }
        if ((type & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
          var lights = this.getLights(zkScene, scene, filter, regExp, selectionExpression);
          Array.prototype.push.apply(elements, lights);
        }
        if ((type & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
          var cameras = this.getCameras(zkScene, scene, filter, regExp, selectionExpression);
          Array.prototype.push.apply(elements, cameras);
        }
        if ((type & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
          var locations = this.getCameraLocations(zkScene, scene, filter, regExp);
          Array.prototype.push.apply(elements, locations);
        }
      }
      return elements;
    }
  }, {
    key: "getMeshElements",
    value: function getMeshElements(zkScene, scene, filter, expression, type) {
      var elements = [];

      // Le espressioni ammesse sono quelle con i caratteri jolly *
      // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
      // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
      // Es. "classic_*;modern_*;sport_*"

      var parts = expression.split(";");
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var selectionExpression = part;
        var regExp = this.getRegExp(part, type);
        if ((type & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
          var meshes = this.getMeshes(zkScene, scene, filter, regExp, selectionExpression);
          Array.prototype.push.apply(elements, meshes);
        }
      }
      return elements;
    }
  }, {
    key: "getSubMeshElements",
    value: function getSubMeshElements(zkScene, scene, filter, expression, type) {
      var elements = [];

      // Le espressioni ammesse sono quelle con i caratteri jolly *
      // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
      // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
      // Es. "classic_*;modern_*;sport_*"

      var parts = expression.split(";");
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var selectionExpression = part;
        var regExp = this.getRegExp(part, type);
        if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
          var subMeshIndex = this.getSubmeshIdx(selectionExpression);
          if (subMeshIndex) {
            var subMeshes = this.getSubMeshes(zkScene, scene, filter, regExp, selectionExpression, subMeshIndex);
            Array.prototype.push.apply(elements, subMeshes);
          }
        }
      }
      return elements;
    }
  }, {
    key: "getMaterialElements",
    value: function getMaterialElements(zkScene, scene, filter, expression, type) {
      var elements = [];

      // Le espressioni ammesse sono quelle con i caratteri jolly *
      // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
      // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
      // Es. "classic_*;modern_*;sport_*"

      var parts = expression.split(";");
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var selectionExpression = part;
        var regExp = this.getRegExp(part, type);
        if ((type & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
          var materials = this.getMaterials(zkScene, scene, filter, regExp, selectionExpression);
          Array.prototype.push.apply(elements, materials);
        }
      }
      return elements;
    }
  }, {
    key: "getLightElements",
    value: function getLightElements(zkScene, scene, filter, expression, type) {
      var elements = [];

      // Le espressioni ammesse sono quelle con i caratteri jolly *
      // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
      // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
      // Es. "classic_*;modern_*;sport_*"

      var parts = expression.split(";");
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var selectionExpression = part;
        var regExp = this.getRegExp(part, type);
        if ((type & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
          var lights = this.getLights(zkScene, scene, filter, regExp, selectionExpression);
          Array.prototype.push.apply(elements, lights);
        }
      }
      return elements;
    }
  }, {
    key: "getCameraElements",
    value: function getCameraElements(zkScene, scene, filter, expression, type) {
      var elements = [];

      // Le espressioni ammesse sono quelle con i caratteri jolly *
      // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
      // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
      // Es. "classic_*;modern_*;sport_*"

      var parts = expression.split(";");
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var selectionExpression = part;
        var regExp = this.getRegExp(part, type);
        if ((type & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
          var cameras = this.getCameras(zkScene, scene, filter, regExp, selectionExpression);
          Array.prototype.push.apply(elements, cameras);
        }
      }
      return elements;
    }
  }, {
    key: "getCameraLocationElements",
    value: function getCameraLocationElements(zkScene, scene, filter, expression, type) {
      var elements = [];

      // Le espressioni ammesse sono quelle con i caratteri jolly *
      // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
      // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
      // Es. "classic_*;modern_*;sport_*"

      var parts = expression.split(";");
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var selectionExpression = part;
        var regExp = this.getRegExp(part, type);
        if ((type & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
          var locations = this.getCameraLocations(zkScene, scene, filter, regExp);
          Array.prototype.push.apply(elements, locations);
        }
      }
      return elements;
    }
  }, {
    key: "getOffloadedElementIDs",
    value: function getOffloadedElementIDs(zkScene, scene, filter, expression, type) {
      var ids = [];

      // Le espressioni ammesse sono quelle con i caratteri jolly *
      // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
      // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
      // Es. "classic_*;modern_*;sport_*"

      var parts = expression.split(";");
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var selectionExpression = part;
        var subMeshIndex = 0;
        if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
          var idx = part.lastIndexOf("-");
          if (idx != -1) {
            selectionExpression = part.substring(0, idx);
            var smidx = Number(part.substring(idx + 1));
            if (smidx && !isNaN(smidx)) {
              subMeshIndex = smidx;
            }
          }
        }
        var regExp = new RegExp(this.escapeRegExp(selectionExpression).replace(/\\\*/g, ".*"), "i");
        if ((type & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
          var materialIDs = this.getOffloadedMaterialIDs(zkScene, scene, filter, regExp, selectionExpression);
          Array.prototype.push.apply(ids, materialIDs);
        }
      }
      return ids;
    }
  }, {
    key: "getDelayedElementIDs",
    value: function getDelayedElementIDs(zkScene, scene, filter, expression, type) {
      var ids = [];

      // Le espressioni ammesse sono quelle con i caratteri jolly *
      // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
      // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
      // Es. "classic_*;modern_*;sport_*"

      var parts = expression.split(";");
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var selectionExpression = part;
        var subMeshIndex = 0;
        if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
          var idx = part.lastIndexOf("-");
          if (idx != -1) {
            selectionExpression = part.substring(0, idx);
            var smidx = Number(part.substring(idx + 1));
            if (smidx && !isNaN(smidx)) {
              subMeshIndex = smidx;
            }
          }
        }
        var regExp = new RegExp(this.escapeRegExp(selectionExpression).replace(/\\\*/g, ".*"), "i");
        if ((type & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
          var materialIDs = this.getDelayedMaterialIDs(zkScene, scene, filter, regExp, selectionExpression);
          Array.prototype.push.apply(ids, materialIDs);
        }
      }
      return ids;
    }
  }, {
    key: "getMeshes",
    value: function getMeshes(zkScene, scene, filter, regExp, originalExpression) {
      var meshes = [];
      if (scene && scene instanceof BABYLON.Scene) {
        for (var i = 0; i < scene.meshes.length; i++) {
          var mesh = scene.meshes[i];
          if ((mesh.name && regExp.test(mesh.name) || mesh.id && mesh.id == originalExpression) && this.verifyFilter(mesh.id, filter)) meshes.push(mesh);
        }
      }
      return meshes;
    }
  }, {
    key: "getSubMeshes",
    value: function getSubMeshes(zkScene, scene, filter, regExp, originalExpression, subMeshIndex) {
      var subMeshes = [];
      if (scene && scene instanceof BABYLON.Scene) {
        for (var i = 0; i < scene.meshes.length; i++) {
          var mesh = scene.meshes[i];
          if ((mesh.name && regExp.test(mesh.name) || mesh.id && mesh.id == originalExpression) && this.verifyFilter(mesh.id, filter) && subMeshIndex < mesh.subMeshes.length && subMeshIndex >= 0) subMeshes.push(mesh.subMeshes[subMeshIndex]);
        }
      }
      return subMeshes;
    }
  }, {
    key: "getMaterials",
    value: function getMaterials(zkScene, scene, filter, regExp, originalExpression) {
      var materials = [];

      // Nella selezione considero anche i materiali creati clonati usati per gli effetti sul design
      if (scene && scene instanceof BABYLON.Scene) {
        for (var i = 0; i < scene.materials.length; i++) {
          var material = scene.materials[i];
          if ((material.name && regExp.test(material.name) || material.id && material.id == originalExpression || material.metadata && !material.metadata.isRealMaterial && material.metadata.originalMaterialID == originalExpression) && this.verifyFilter(material.id, filter)) materials.push(material);
        }
      }
      return materials;
    }
  }, {
    key: "getOffloadedMaterialIDs",
    value: function getOffloadedMaterialIDs(zkScene, scene, filter, regExp, originalExpression) {
      var materialIDs = [];
      if (scene && scene instanceof BABYLON.Scene && scene.metadata && scene.metadata.offloadedMaterials) {
        for (var key in scene.metadata.offloadedMaterials) {
          var info = scene.metadata.offloadedMaterials[key];
          if ((info.name && regExp.test(info.name) || key && key == originalExpression) && this.verifyFilter(key, filter)) materialIDs.push(key);
        }
      }
      return materialIDs;
    }
  }, {
    key: "getDelayedMaterialIDs",
    value: function getDelayedMaterialIDs(zkScene, scene, filter, regExp, originalExpression) {
      var materialIDs = [];
      if (scene && scene instanceof BABYLON.Scene && scene.metadata && scene.metadata.delayedMaterials) {
        for (var key in scene.metadata.delayedMaterials) {
          var info = scene.metadata.delayedMaterials[key];
          if ((info.name && regExp.test(info.name) || key && key == originalExpression) && this.verifyFilter(key, filter)) materialIDs.push(key);
        }
      }
      return materialIDs;
    }
  }, {
    key: "getLights",
    value: function getLights(zkScene, scene, filter, regExp, originalExpression) {
      var lights = [];
      if (scene && scene instanceof BABYLON.Scene) {
        for (var i = 0; i < scene.lights.length; i++) {
          var light = scene.lights[i];
          if ((light.name && regExp.test(light.name) || light.id && light.id == originalExpression) && this.verifyFilter(light.id, filter)) lights.push(light);
        }
      }
      return lights;
    }
  }, {
    key: "getCameras",
    value: function getCameras(zkScene, scene, filter, regExp, originalExpression) {
      var cameras = [];
      if (scene && scene instanceof BABYLON.Scene) {
        for (var i = 0; i < scene.cameras.length; i++) {
          var camera = scene.cameras[i];
          if ((camera.name && regExp.test(camera.name) || camera.id && camera.id == originalExpression) && this.verifyFilter(camera.id, filter)) cameras.push(camera);
        }
      }
      return cameras;
    }
  }, {
    key: "getCameraLocations",
    value: function getCameraLocations(zkScene, scene, filter, regExp) {
      var locations = [];
      if (zkScene && zkScene instanceof Zakeke.Scene) {
        for (var i = 0; i < zkScene.get("cameraLocations").length; i++) {
          var cameraLocation = zkScene.get("cameraLocations").at(i);
          var id = cameraLocation.getLocationID();
          var name = cameraLocation.get("name");
          if ((name && regExp.test(name) || id && regExp.test(id)) && this.verifyFilter(id, filter)) locations.push(cameraLocation);
        }
      }
      return locations;
    }
  }, {
    key: "getYesNoElements",
    value: function getYesNoElements(zkScene, scene, filter, expression, type) {
      var elements = {
        yes: [],
        no: []
      };

      // Le espressioni ammesse sono quelle con i caratteri jolly *
      // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
      // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
      // Es. "classic_*;modern_*;sport_*"

      var parts = expression.split(";");
      for (var i = 0; i < parts.length; i++) {
        var part = parts[i];
        var selectionExpression = part;
        var subMeshIndex = 0;
        if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
          var idx = part.lastIndexOf("-");
          if (idx != -1) {
            selectionExpression = part.substring(0, idx);
            var smidx = Number(part.substring(idx + 1));
            if (smidx && !isNaN(smidx)) {
              subMeshIndex = smidx;
            }
          }
        }
        var regExp = new RegExp(this.escapeRegExp(selectionExpression).replace(/\\\*/g, ".*"), "i");
        if ((type & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
          var meshes = this.getYesNoMeshes(zkScene, scene, filter, regExp);
          Array.prototype.push.apply(elements.yes, meshes.yes);
          Array.prototype.push.apply(elements.no, meshes.no);
        }
        if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
          var subMeshes = this.getYesNoSubMeshes(zkScene, scene, filter, regExp, subMeshIndex);
          Array.prototype.push.apply(elements.yes, subMeshes.yes);
          Array.prototype.push.apply(elements.no, subMeshes.no);
        }
        if ((type & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
          var materials = this.getYesNoMaterials(zkScene, scene, filter, regExp);
          Array.prototype.push.apply(elements.yes, materials.yes);
          Array.prototype.push.apply(elements.no, materials.no);
        }
        if ((type & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
          var lights = this.getYesNoLights(zkScene, scene, filter, regExp);
          Array.prototype.push.apply(elements.yes, lights.yes);
          Array.prototype.push.apply(elements.no, lights.no);
        }
        if ((type & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
          var cameras = this.getYesNoCameras(zkScene, scene, filter, regExp);
          Array.prototype.push.apply(elements.yes, cameras.yes);
          Array.prototype.push.apply(elements.no, cameras.no);
        }
        if ((type & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
          var locations = this.getYesNoCameraLocations(zkScene, scene, filter, regExp);
          Array.prototype.push.apply(elements.yes, locations.yes);
          Array.prototype.push.apply(elements.no, locations.no);
        }
      }
      return elements;
    }
  }, {
    key: "getYesNoMeshes",
    value: function getYesNoMeshes(zkScene, scene, filter, regExp) {
      var elements = {
        yes: [],
        no: []
      };
      if (scene && scene instanceof BABYLON.Scene) {
        for (var i = 0; i < scene.meshes.length; i++) {
          var mesh = scene.meshes[i];
          var arr = elements.no;
          if ((mesh.name && regExp.test(mesh.name) || mesh.id && regExp.test(mesh.id)) && this.verifyFilter(mesh.id, filter)) {
            arr = elements.yes;
          }
          arr.push(mesh);
        }
      }
      return elements;
    }
  }, {
    key: "getYesNoSubMeshes",
    value: function getYesNoSubMeshes(zkScene, scene, filter, regExp, subMeshIndex) {
      var elements = {
        yes: [],
        no: []
      };
      if (scene && scene instanceof BABYLON.Scene) {
        for (var i = 0; i < scene.meshes.length; i++) {
          var mesh = scene.meshes[i];
          if ((mesh.name && regExp.test(mesh.name) || mesh.id && regExp.test(mesh.id)) && this.verifyFilter(mesh.id, filter) && mesh.subMeshes) {
            for (var j = 0; j < mesh.subMeshes.length; j++) {
              if (j == subMeshIndex) elements.yes.push(mesh.subMeshes[j]);else elements.no.push(mesh.subMeshes[j]);
            }
          }
        }
      }
      return elements;
    }
  }, {
    key: "getYesNoMaterials",
    value: function getYesNoMaterials(zkScene, scene, filter, regExp) {
      var elements = {
        yes: [],
        no: []
      };
      if (scene && scene instanceof BABYLON.Scene) {
        for (var i = 0; i < scene.materials.length; i++) {
          var material = scene.materials[i];
          if ((material.name && regExp.test(material.name) || material.id && regExp.test(material.id)) && this.verifyFilter(material.id, filter)) {
            elements.yes.push(material);
          } else {
            elements.no.push(material);
          }
        }
      }
      return elements;
    }
  }, {
    key: "getYesNoLights",
    value: function getYesNoLights(zkScene, scene, filter, regExp) {
      var elements = {
        yes: [],
        no: []
      };
      if (scene && scene instanceof BABYLON.Scene) {
        for (var i = 0; i < scene.lights.length; i++) {
          var light = scene.lights[i];
          if ((light.name && regExp.test(light.name) || light.id && regExp.test(light.id)) && this.verifyFilter(light.id, filter)) {
            elements.yes.push(light);
          } else {
            elements.no.push(light);
          }
        }
      }
      return elements;
    }
  }, {
    key: "getYesNoCameras",
    value: function getYesNoCameras(zkScene, scene, filter, regExp) {
      var elements = {
        yes: [],
        no: []
      };
      if (scene && scene instanceof BABYLON.Scene) {
        for (var i = 0; i < scene.cameras.length; i++) {
          var camera = scene.cameras[i];
          if ((camera.name && regExp.test(camera.name) || camera.id && regExp.test(camera.id)) && this.verifyFilter(camera.id, filter)) {
            elements.yes.push(camera);
          } else {
            elements.no.push(camera);
          }
        }
      }
      return elements;
    }
  }, {
    key: "getYesNoCameraLocations",
    value: function getYesNoCameraLocations(zkScene, scene, filter, regExp) {
      var elements = {
        yes: [],
        no: []
      };
      if (zkScene && zkScene instanceof Zakeke.Scene) {
        for (var i = 0; i < zkScene.get("cameraLocations").length; i++) {
          var cameraLocation = zkScene.get("cameraLocations").at(i);
          var id = cameraLocation.getLocationID();
          var name = cameraLocation.get("name");
          if ((name && regExp.test(name) || id && regExp.test(id)) && this.verifyFilter(id, filter)) {
            elements.yes.push(cameraLocation);
          } else {
            elements.no.push(cameraLocation);
          }
        }
      }
      return elements;
    }
  }, {
    key: "escapeRegExp",
    value: function escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
    }
  }, {
    key: "verifyFilter",
    value: function verifyFilter(id, filter) {
      if (!filter) return true;
      if (filter.length == 0) return true;
      return filter.indexOf(id) !== -1;
    }
  }]);
  return ElementSelector;
}();

/***/ }),

/***/ "../../3D/src/Components/Shadows/InnerShadow.ts":
/*!******************************************************!*\
  !*** ../../3D/src/Components/Shadows/InnerShadow.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "InnerShadow": () => (/* binding */ InnerShadow)
/* harmony export */ });
/* harmony import */ var _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ProceduralTextures/ForegroundBackgroundProceduralTexture */ "../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ProceduralTextures/BlurXProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ProceduralTextures/BlurYProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../ProceduralTextures/MoveProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MoveProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../ProceduralTextures/MultiplyProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MultiplyProceduralTexture.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }






var InnerShadow = /*#__PURE__*/function () {
  // Catena di texture procedurali per produrre la lightmap (shadow) finale

  function InnerShadow(baseTexture, size, config, scene) {
    _classCallCheck(this, InnerShadow);
    this._baseTexture = baseTexture;
    this._size = size;
    this._scene = scene;
    this._mask = new _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.ForegroundBackgroundProceduralTexture("mask", this._size, this._scene, this._baseTexture);
    this._mask.backColor = new BABYLON.Vector3(0, 0, 0);
    this._mask.foreColor = new BABYLON.Vector3(1, 1, 1);
    this._mask.refreshRate = 0;
    this._shadow = new _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.ForegroundBackgroundProceduralTexture("shadow", this._size, this._scene, this._baseTexture);
    this._shadow.backColor = new BABYLON.Vector3(0.1, 0.1, 0.1);
    this._shadow.foreColor = new BABYLON.Vector3(1, 1, 1);
    this._shadow.refreshRate = 0;
    this._shadowBlurX = new _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_1__.BlurXProceduralTexture("shadow_blurX", this._size, this._scene, this._shadow);
    this._shadowBlurX.blur = 5;
    this._shadowBlurX.refreshRate = 0;
    this._shadowBlurY = new _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_2__.BlurYProceduralTexture("shadow_blurY", this._size, this._scene, this._shadowBlurX);
    this._shadowBlurY.blur = 5;
    this._shadowBlurY.refreshRate = 0;
    this._shadowMove = new _ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_3__.MoveProceduralTexture("shadow_move", this._size, this._scene, this._shadowBlurY);
    this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5);
    this._shadowMove.refreshRate = 0;
    this._lightmap = new _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_4__.MultiplyProceduralTexture("lightmap", this._size, this._scene, this._shadowMove, this._mask);
    this._lightmap.refreshRate = 0;
    this.updateParameters(config);
  }
  _createClass(InnerShadow, [{
    key: "updateParameters",
    value: function updateParameters(config) {
      if (config) {
        var backColor = new BABYLON.Vector3(0, 0, 0);
        if (config.get("color")) {
          var color = BABYLON.Color3.FromHexString(config.get("color"));
          backColor = new BABYLON.Vector3(color.r, color.g, color.b);
        }
        this._shadow.backColor = backColor;
        var distance = 1;
        var angle = 135;
        if (config.get("angle") !== undefined && config.get("angle") !== null) angle = config.get("angle");
        if (config.get("distance") != undefined && config.get("distance") !== null) distance = config.get("distance");
        var radians = angle * Math.PI / 180;
        radians = this.wrapPi(radians);
        var xDistance = Math.cos(radians) * distance;
        var yDistance = Math.sin(radians) * distance;
        this._shadowMove.offset = new BABYLON.Vector2(-xDistance, yDistance);
        var blur = 5;
        if (config.get("size") !== undefined && config.get("size") !== null) blur = Math.max(0, Math.min(100, config.get("size")));
        this._shadowBlurX.blur = blur;
        this._shadowBlurY.blur = blur;
      }
    }

    // riporta angle nel range -180, + 180
  }, {
    key: "wrapPi",
    value: function wrapPi(angle) {
      if (Math.abs(angle) > Math.PI) {
        var twoppi = 2.0 * Math.PI;
        var revolutions = Math.floor((angle + Math.PI) * (1.0 / twoppi));
        angle -= revolutions * twoppi;
      }
      return angle;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._mask.dispose();
      this._shadow.dispose();
      this._shadowBlurX.dispose();
      this._shadowBlurY.dispose();
      this._shadowMove.dispose();
      this._lightmap.dispose();
    }
  }, {
    key: "getInnerShadowTextureAsync",
    value: function () {
      var _getInnerShadowTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(baseTexture) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.updateAsync(baseTexture);
            case 2:
              return _context.abrupt("return", this._lightmap);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getInnerShadowTextureAsync(_x) {
        return _getInnerShadowTextureAsync.apply(this, arguments);
      }
      return getInnerShadowTextureAsync;
    }()
  }, {
    key: "updateAsync",
    value: function () {
      var _updateAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(baseTexture, config) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.updateParameters(config);
              this._baseTexture = baseTexture;
              _context2.next = 4;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._baseTexture);
            case 4:
              this._mask.baseTexture = this._baseTexture;
              _context2.next = 7;
              return this._mask.isReadyAsync();
            case 7:
              this._mask.render();
              this._shadow.baseTexture = this._baseTexture;
              _context2.next = 11;
              return this._shadow.isReadyAsync();
            case 11:
              this._shadow.render();
              _context2.next = 14;
              return this._shadowBlurX.isReadyAsync();
            case 14:
              this._shadowBlurX.render();
              _context2.next = 17;
              return this._shadowBlurY.isReadyAsync();
            case 17:
              this._shadowBlurY.render();
              _context2.next = 20;
              return this._shadowMove.isReadyAsync();
            case 20:
              this._shadowMove.render();
              _context2.next = 23;
              return this._lightmap.isReadyAsync();
            case 23:
              this._lightmap.render();
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateAsync(_x2, _x3) {
        return _updateAsync.apply(this, arguments);
      }
      return updateAsync;
    }() //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
    //    return new Promise<void>((resolve, reject) => {
    //        if (texture.isReady())
    //            resolve();
    //        else {
    //            let t = setInterval(() => {
    //                if (texture.isReady()) {
    //                    clearInterval(t);
    //                    resolve();
    //                }
    //            }, 5);
    //        }
    //    });
    //}
  }]);
  return InnerShadow;
}();

/***/ }),

/***/ "../../3D/src/Components/Shadows/OuterShadow.ts":
/*!******************************************************!*\
  !*** ../../3D/src/Components/Shadows/OuterShadow.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OuterShadow": () => (/* binding */ OuterShadow)
/* harmony export */ });
/* harmony import */ var _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ProceduralTextures/ForegroundBackgroundProceduralTexture */ "../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ProceduralTextures/BlurXProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ProceduralTextures/BlurYProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../ProceduralTextures/MoveProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MoveProceduralTexture.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }





var OuterShadow = /*#__PURE__*/function () {
  function OuterShadow(baseTexture, size, config, scene) {
    _classCallCheck(this, OuterShadow);
    this._size = size;
    this._baseTexture = baseTexture;
    this._scene = scene;
    this._shadow = new _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.ForegroundBackgroundProceduralTexture("shadow", this._size, this._scene, this._baseTexture);
    this._shadow.backColor = new BABYLON.Vector3(1, 1, 1);
    this._shadow.foreColor = new BABYLON.Vector3(0.2, 0.2, 0.2);
    this._shadow.refreshRate = 0;
    this._shadowBlurX = new _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_1__.BlurXProceduralTexture("shadow_blurX", this._size, this._scene, this._shadow);
    this._shadowBlurX.blur = 15;
    this._shadowBlurX.refreshRate = 0;
    this._shadowBlurY = new _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_2__.BlurYProceduralTexture("shadow_blurY", this._size, this._scene, this._shadowBlurX);
    this._shadowBlurY.blur = 15;
    this._shadowBlurY.refreshRate = 0;
    this._shadowMove = new _ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_3__.MoveProceduralTexture("shadow_move", this._size, this._scene, this._shadowBlurY);
    this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5);
    this._shadowMove.refreshRate = 0;
    this.updateParameters(config);
  }
  _createClass(OuterShadow, [{
    key: "updateParameters",
    value: function updateParameters(config) {
      if (config) {
        var foreColor = new BABYLON.Vector3(0, 0, 0);
        if (config.get("color")) {
          var color = BABYLON.Color3.FromHexString(config.get("color"));
          foreColor = new BABYLON.Vector3(color.r, color.g, color.b);
        }
        this._shadow.foreColor = foreColor;
        var distance = 1;
        var angle = 135;
        if (config.get("angle") !== undefined && config.get("angle") !== null) angle = config.get("angle");
        if (config.get("distance") != undefined && config.get("distance") !== null) distance = config.get("distance");
        var radians = angle * Math.PI / 180;
        radians = this.wrapPi(radians);
        var xDistance = Math.cos(radians) * distance;
        var yDistance = Math.sin(radians) * distance;
        this._shadowMove.offset = new BABYLON.Vector2(-xDistance, yDistance);
        var blur = 5;
        if (config.get("size") !== undefined && config.get("size") !== null) blur = Math.max(0, Math.min(100, config.get("size")));
        this._shadowBlurX.blur = blur;
        this._shadowBlurY.blur = blur;
      }
    }
  }, {
    key: "wrapPi",
    value: function wrapPi(angle) {
      if (Math.abs(angle) > Math.PI) {
        var twoppi = 2.0 * Math.PI;
        var revolutions = Math.floor((angle + Math.PI) * (1.0 / twoppi));
        angle -= revolutions * twoppi;
      }
      return angle;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._shadow.dispose();
      this._shadowBlurX.dispose();
      this._shadowBlurY.dispose();
      this._shadowMove.dispose();
    }
  }, {
    key: "getOuterShadowTextureAsync",
    value: function () {
      var _getOuterShadowTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(baseTexture) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.updateAsync(baseTexture);
            case 2:
              return _context.abrupt("return", this._shadowMove);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getOuterShadowTextureAsync(_x) {
        return _getOuterShadowTextureAsync.apply(this, arguments);
      }
      return getOuterShadowTextureAsync;
    }()
  }, {
    key: "updateAsync",
    value: function () {
      var _updateAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(baseTexture, config) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.updateParameters(config);
              this._baseTexture = baseTexture;
              _context2.next = 4;
              return _SceneHelper__WEBPACK_IMPORTED_MODULE_4__.SceneHelper.whenTextureIsReadyAsync(this._baseTexture);
            case 4:
              this._shadow.baseTexture = this._baseTexture;
              _context2.next = 7;
              return this._shadow.isReadyAsync();
            case 7:
              this._shadow.render();
              _context2.next = 10;
              return this._shadowBlurX.isReadyAsync();
            case 10:
              this._shadowBlurX.render();
              _context2.next = 13;
              return this._shadowBlurY.isReadyAsync();
            case 13:
              this._shadowBlurY.render();
              _context2.next = 16;
              return this._shadowMove.isReadyAsync();
            case 16:
              this._shadowMove.render();
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateAsync(_x2, _x3) {
        return _updateAsync.apply(this, arguments);
      }
      return updateAsync;
    }() //private whenTextureIsReadyAsync(texture: BABYLON.Texture): Promise<void> {
    //    return new Promise<void>((resolve, reject) => {
    //        if (texture.isReady())
    //            resolve();
    //        else {
    //            let t = setInterval(() => {
    //                if (texture.isReady()) {
    //                    clearInterval(t);
    //                    resolve();
    //                }
    //            }, 5);
    //        }
    //    });
    //}
  }]);
  return OuterShadow;
}();

/***/ }),

/***/ "../../3D/src/Components/USDZ/UsdzHelper.ts":
/*!**************************************************!*\
  !*** ../../3D/src/Components/USDZ/UsdzHelper.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UsdzHelper": () => (/* binding */ UsdzHelper)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var UsdzHelper = /*#__PURE__*/function () {
  function UsdzHelper() {
    _classCallCheck(this, UsdzHelper);
  }
  _createClass(UsdzHelper, null, [{
    key: "convertGlbToUsdz",
    value: function () {
      var _convertGlbToUsdz = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(glbUrl) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var usdz = null;

                /* Test without renderer
                const localCanvas = document.createElement('canvas');
                localCanvas.id = "Threejs - usdz converter";
                localCanvas.width = 1024;
                localCanvas.height = 1024;
                  let camera, scene, renderer;
                  renderer = new THREE.WebGLRenderer({ antialias: true, canvas: localCanvas });
                renderer.setPixelRatio(window.devicePixelRatio);
                renderer.setSize(window.innerWidth, window.innerHeight);
                renderer.toneMapping = THREE.ACESFilmicToneMapping;
                renderer.outputEncoding = THREE.sRGBEncoding;
                */

                //document.body.appendChild(renderer.domElement);

                //camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.25, 20);
                //camera.position.set(- 2.5, 0.6, 3.0);

                //const pmremGenerator = new THREE.PMREMGenerator(renderer);

                //scene = new THREE.Scene();
                //scene.background = new THREE.Color(0xf0f0f0);
                //scene.environment = pmremGenerator.fromScene( new RoomEnvironment(), 0.04 ).texture;

                var loader = new THREE.GLTFLoader();
                loader.load(glbUrl, /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(gltf) {
                    var exporter, arraybuffer;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) switch (_context.prev = _context.next) {
                        case 0:
                          //scene.add(gltf.scene);

                          // modifico la geometria in base alle trasformazioni
                          // gltf.scene.scale.multiplyScalar(scalingFactor); // scaling
                          gltf.scene.updateWorldMatrix(true, true);

                          //render();

                          // USDZ
                          exporter = new THREE.USDZExporter();
                          _context.next = 4;
                          return exporter.parse(gltf.scene);
                        case 4:
                          arraybuffer = _context.sent;
                          usdz = new Blob([arraybuffer], {
                            type: 'model/vnd.usdz+zip'
                          });

                          //renderer.dispose();
                          resolve(usdz);
                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }, _callee);
                  }));
                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function convertGlbToUsdz(_x) {
        return _convertGlbToUsdz.apply(this, arguments);
      }
      return convertGlbToUsdz;
    }()
  }]);
  return UsdzHelper;
}();

/***/ }),

/***/ "../../3D/src/Enumerations.ts":
/*!************************************!*\
  !*** ../../3D/src/Enumerations.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EditingMode": () => (/* binding */ EditingMode),
/* harmony export */   "EnvironmentMode": () => (/* binding */ EnvironmentMode),
/* harmony export */   "ZakekeEnvironment": () => (/* binding */ ZakekeEnvironment)
/* harmony export */ });
var EnvironmentMode = /*#__PURE__*/function (EnvironmentMode) {
  EnvironmentMode[EnvironmentMode["Editor"] = 1] = "Editor";
  EnvironmentMode[EnvironmentMode["Viewer"] = 2] = "Viewer";
  return EnvironmentMode;
}({});
var EditingMode = /*#__PURE__*/function (EditingMode) {
  EditingMode["None"] = "None";
  EditingMode["Translate"] = "Translate";
  EditingMode["Rotate"] = "Rotate";
  EditingMode["Scaling"] = "Scaling";
  return EditingMode;
}({});
var ZakekeEnvironment = /*#__PURE__*/function (ZakekeEnvironment) {
  ZakekeEnvironment[ZakekeEnvironment["Customizer"] = 1] = "Customizer";
  ZakekeEnvironment[ZakekeEnvironment["Composer"] = 2] = "Composer";
  ZakekeEnvironment[ZakekeEnvironment["Viewer"] = 3] = "Viewer";
  return ZakekeEnvironment;
}({});

/***/ }),

/***/ "../../3D/src/Helpers/debounce.ts":
/*!****************************************!*\
  !*** ../../3D/src/Helpers/debounce.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "debounce": () => (/* binding */ debounce)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/*
export function debounceAsync<T extends (...args: any[]) => any>(time: number, func: T): (...funcArgs: Parameters<T>) => Promise<ReturnType<T>> {
    let timeout: Timeout;

    return (...args: Parameters<T>): Promise<ReturnType<T>> => new Promise((resolve) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            resolve(func(...args));
        }, time)
    });
}
*/

/**
 * A function that emits a side effect and does not return anything.
 */

function debounce(func) {
  var waitMilliseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    isImmediate: false
  };
  var timeoutId;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var context = this;
    var doLater = function doLater() {
      timeoutId = undefined;
      if (!options.isImmediate) {
        func.apply(context, args);
      }
    };
    var shouldCallNow = options.isImmediate && timeoutId === undefined;
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(doLater, waitMilliseconds);
    if (shouldCallNow) {
      func.apply(context, args);
    }
  };
}
function pippo(_x) {
  return _pippo.apply(this, arguments);
}
function _pippo() {
  _pippo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(name) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return");
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _pippo.apply(this, arguments);
}

/***/ }),

/***/ "../../3D/src/Helpers/utils.ts":
/*!*************************************!*\
  !*** ../../3D/src/Helpers/utils.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Utils": () => (/* binding */ Utils)
/* harmony export */ });
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/// <reference path="../../../typescript_definitions/jquery.d.ts" />

var Utils = /*#__PURE__*/function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }
  _createClass(Utils, null, [{
    key: "isIPhoneX",
    value: function isIPhoneX() {
      // Really basic check for the ios platform
      // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
      var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream'];

      // Get the device pixel ratio
      var ratio = window.devicePixelRatio || 1;

      // Define the users device screen dimensions
      var screen = {
        width: window.screen.width * ratio,
        height: window.screen.height * ratio
      };

      // iPhone X Detection
      if (iOS && screen.width === 1125 && screen.height === 2436) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "isAndroid",
    value: function isAndroid() {
      return /android/i.test(navigator.userAgent);
    }
  }, {
    key: "isiOS",
    value: function isiOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      var userAgent = navigator.userAgent || navigator.vendor || self["opera"];
      return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0, 4));
    }
  }, {
    key: "getViewport",
    value: function getViewport() {
      var m = document.compatMode === 'CSS1Compat';
      return {
        l: window.pageXOffset || (m ? document.documentElement.scrollLeft : document.body.scrollLeft),
        t: window.pageYOffset || (m ? document.documentElement.scrollTop : document.body.scrollTop),
        w: window.innerWidth || (m ? document.documentElement.clientWidth : document.body.clientWidth),
        h: window.innerHeight || (m ? document.documentElement.clientHeight : document.body.clientHeight)
      };
    }
  }, {
    key: "getContrastYIQ",
    value: function getContrastYIQ(r, g, b) {
      var yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 128 ? 'black' : 'white';
    }
  }, {
    key: "getContrastYIQHex",
    value: function getContrastYIQHex(hexcolor) {
      var r = parseInt(hexcolor.substr(0, 2), 16);
      var g = parseInt(hexcolor.substr(2, 2), 16);
      var b = parseInt(hexcolor.substr(4, 2), 16);
      var yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 128 ? 'black' : 'white';
    }
  }, {
    key: "arrayContains",
    value: function arrayContains(array, itemToSearch) {
      if (typeof itemToSearch === "undefined" || _typeof(itemToSearch) === null) return false;
      var contains = function contains(array, needle) {
        // Per spec, the way to identify NaN is that it is not equal to itself
        var findNaN = needle !== needle;
        var indexOf;
        if (!findNaN && typeof Array.prototype.indexOf === 'function') {
          indexOf = Array.prototype.indexOf;
          return indexOf.call(array, needle) > -1;
        } else {
          indexOf = function indexOf(array, needle) {
            var i = -1,
              index = -1;
            for (i = 0; i < array.length; i++) {
              var item = array[i];
              if (findNaN && item !== item || item === needle) {
                index = i;
                break;
              }
            }
            return index;
          };
          return indexOf(array, needle) > -1;
        }
      };
      return contains(array, itemToSearch);
    }
  }, {
    key: "getColorBrightness",
    value: function getColorBrightness(hex) {
      // validate hex string
      hex = String(hex).replace(/[^0-9a-f]/gi, '');
      if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      var r = parseInt(hex.substr(0 * 2, 2), 16);
      var g = parseInt(hex.substr(1 * 2, 2), 16);
      var b = parseInt(hex.substr(2 * 2, 2), 16);
      var brightness = Math.sqrt(r * r * 0.241 + g * g * 0.691 + b * b * 0.068);
      return brightness;
    }
  }, {
    key: "isColorDark",
    value: function isColorDark(hex) {
      return Utils.getColorBrightness(hex) < 130;
    }
  }, {
    key: "changeColorLuminosity",
    value: function changeColorLuminosity(hex) {
      var lum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      // validate hex string
      hex = String(hex).replace(/[^0-9a-f]/gi, '');
      if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      lum = lum || 0;

      // convert to decimal and change luminosity
      var rgb = "#",
        c,
        i;
      for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
        rgb += ("00" + c).substr(c.length);
      }
      return rgb;
    }
  }, {
    key: "cropImageTransparency",
    value: function cropImageTransparency(imageDataURI, targetWidth, targetHeight, callback) {
      var img = new Image();
      var $canvas = $("<canvas>"); // create an offscreen canvas
      var canvas = $canvas[0];
      var context = canvas.getContext("2d");
      img.crossOrigin = "anonymous";
      img.onload = function () {
        $canvas.attr({
          width: img.width,
          height: img.height
        });
        context = canvas.getContext("2d");
        if (context) {
          context.drawImage(img, 0, 0);
          var _dataUrl = Utils.removeBlanks(canvas, img.width, img.height, targetWidth, targetHeight);
          if (callback) callback(_dataUrl);
        } else {
          alert('Get a real browser!');
        }
      };
      img.src = imageDataURI;
    }
  }, {
    key: "trimImageAsync",
    value: function trimImageAsync(imageDataURI) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        var $canvas = $("<canvas>"); // create an offscreen canvas
        var canvas = $canvas[0];
        var context = canvas.getContext("2d");
        img.crossOrigin = "anonymous";
        img.onload = function () {
          $canvas.attr({
            width: img.width,
            height: img.height
          });
          if (context) {
            context.drawImage(img, 0, 0);
            var _dataUrl2 = Utils.trimCanvas(canvas);
            resolve(_dataUrl2);
          } else {
            reject(new Error("HTML5 Canvas not supported"));
          }
        };
        img.src = imageDataURI;
      });
    }
  }, {
    key: "trimCanvas",
    value: function trimCanvas(canvas) {
      console.log('Start trimming canvas...');
      var context = canvas.getContext("2d");
      if (!context) return null;
      var imgWidth = canvas.width;
      var imgHeight = canvas.height;
      var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      var data = imageData.data;
      var getAlpha = function getAlpha(x, y) {
        return data[(imgWidth * y + x) * 4 + 3];
      };
      var isTransparent = function isTransparent(alpha) {
        return alpha < 10;
      };
      var scanY = function scanY(fromTop) {
        var offset = fromTop ? 1 : -1;

        // loop through each row
        for (var y = fromTop ? 0 : imgHeight - 1; fromTop ? y < imgHeight : y > -1; y += offset) {
          // loop through each column
          for (var x = 0; x < imgWidth; x++) {
            if (!isTransparent(getAlpha(x, y))) {
              return y;
            }
          }
        }
        return null; // all image is transparent
      };

      var scanX = function scanX(fromLeft) {
        var offset = fromLeft ? 1 : -1;

        // loop through each column
        for (var x = fromLeft ? 0 : imgWidth - 1; fromLeft ? x < imgWidth : x > -1; x += offset) {
          // loop through each row
          for (var y = 0; y < imgHeight; y++) {
            if (!isTransparent(getAlpha(x, y))) {
              return x;
            }
          }
        }
        return null; // all image is transparent
      };

      var cropTop = scanY(true);
      var cropBottom = scanY(false);
      var cropLeft = scanX(true);
      var cropRight = scanX(false);
      console.log('Trim image scan: ' + cropTop + ', ' + cropBottom + ', ' + cropLeft + ', ' + cropRight);
      if (cropTop != null && cropBottom != null && cropLeft != null && cropRight != null) {
        var cropWidth = cropRight - cropLeft + 1;
        var cropHeight = cropBottom - cropTop + 1;
        var $croppedCanvas = $("<canvas>").attr({
          width: cropWidth,
          height: cropHeight
        });
        var croppedCanvas = $croppedCanvas[0];
        var croppedContext = croppedCanvas.getContext("2d");
        if (!croppedContext) return null;
        croppedContext.drawImage(canvas, cropLeft, cropTop, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

        //var croppedImageData = croppedContext.getImageData(0, 0, croppedCanvas.width, croppedCanvas.height);
        var croppedDataUrl = croppedCanvas.toDataURL();
        return croppedDataUrl;
      } else return null;
    }
  }, {
    key: "cropImageTransparencyAsync",
    value: function cropImageTransparencyAsync(imageDataURI, targetWidth, targetHeight) {
      return new Promise(function (resolve, reject) {
        var img = new Image();
        var $canvas = $("<canvas>"); // create an offscreen canvas
        var canvas = $canvas[0];
        var context = canvas.getContext("2d");
        img.crossOrigin = "anonymous";
        img.onload = function () {
          $canvas.attr({
            width: img.width,
            height: img.height
          });
          context = canvas.getContext("2d");
          if (context) {
            context.drawImage(img, 0, 0);
            var _dataUrl3 = Utils.removeBlanks(canvas, img.width, img.height, targetWidth, targetHeight);
            resolve(_dataUrl3);
          } else {
            reject(new Error("HTML5 Canvas not supported"));
          }
        };
        img.src = imageDataURI;
      });
    }
  }, {
    key: "removeBlanks",
    value: function removeBlanks(canvas, imgWidth, imgHeight, targetWidth, targetHeight) {
      var context = canvas.getContext("2d");
      if (!context) return null;
      var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      var data = imageData.data;
      var getAlpha = function getAlpha(x, y) {
        return data[(imgWidth * y + x) * 4 + 3];
      };
      var getRBGA = function getRBGA(x, y) {
        return {
          red: data[(imgWidth * y + x) * 4],
          green: data[(imgWidth * y + x) * 4 + 1],
          blue: data[(imgWidth * y + x) * 4 + 2],
          alpha: data[(imgWidth * y + x) * 4 + 3]
        };
      };
      var isTransparent = function isTransparent(alpha) {
        return alpha === 0;
      };
      var scanY = function scanY(fromTop) {
        var offset = fromTop ? 1 : -1;

        // loop through each row
        for (var y = fromTop ? 0 : imgHeight - 1; fromTop ? y < imgHeight : y > -1; y += offset) {
          // loop through each column
          for (var x = 0; x < imgWidth; x++) {
            if (!isTransparent(getAlpha(x, y))) {
              return y;
            }
          }
        }
        return null; // all image is transparent
      };

      var scanX = function scanX(fromLeft) {
        var offset = fromLeft ? 1 : -1;

        // loop through each column
        for (var x = fromLeft ? 0 : imgWidth - 1; fromLeft ? x < imgWidth : x > -1; x += offset) {
          // loop through each row
          for (var y = 0; y < imgHeight; y++) {
            if (!isTransparent(getAlpha(x, y))) {
              return x;
            }
          }
        }
        return null; // all image is transparent
      };

      var cropTop = scanY(true);
      var cropBottom = scanY(false);
      var cropLeft = scanX(true);
      var cropRight = scanX(false);
      if (cropTop != null && cropBottom != null && cropLeft != null && cropRight != null) {
        var cropWidth = cropRight - cropLeft;
        var cropHeight = cropBottom - cropTop;

        // Mantain proportions in canvas
        var canvasWidth = targetWidth;
        var canvasHeight = targetHeight;
        var ratioX = canvasWidth / cropWidth;
        var ratioY = canvasHeight / cropHeight;
        var finalWidth = cropWidth * ratioX;
        var finalHeight = cropHeight * ratioX;
        if (finalHeight > canvasHeight) {
          finalWidth = cropWidth * ratioY;
          finalHeight = cropHeight * ratioY;
        }
        var $croppedCanvas = $("<canvas>").attr({
          width: canvasWidth,
          height: canvasHeight
        });
        var croppedCanvas = $croppedCanvas[0];
        var croppedContext = croppedCanvas.getContext("2d");
        if (!croppedContext) return null;
        croppedContext.drawImage(canvas, cropLeft, cropTop, cropWidth, cropHeight, (canvasWidth - finalWidth) / 2, (canvasHeight - finalHeight) / 2, finalWidth, finalHeight);
        var croppedImageData = croppedContext.getImageData(0, 0, croppedCanvas.width, croppedCanvas.height);
        var croppedDataUrl = croppedCanvas.toDataURL();
        return croppedDataUrl;
      } else return null;
    }

    /** Draw an image from data uri on a width * height canvas, create canvas inside method and return the data uri of canvas */
  }, {
    key: "resizeImageFromDataUri",
    value: function resizeImageFromDataUri(dataUrl, width, height, padding) {
      return new Promise(function (resolve) {
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = function () {
          var $canvas = $("<canvas>"); // create an offscreen canvas
          var canvas = $canvas[0];
          var context = canvas.getContext("2d");
          if (context) {
            canvas.width = width;
            canvas.height = height;

            // Fit the image
            var ratio = Math.min(width / img.width, height / img.height);
            var newImageWidth = img.width * ratio;
            var newImageHeight = img.height * ratio;
            context.drawImage(img, 0, 0, img.width, img.height, (width - newImageWidth + padding) / 2, (height - newImageHeight + padding) / 2, newImageWidth - padding, newImageHeight - padding);
            var _dataUrl4 = canvas.toDataURL();
            resolve(_dataUrl4);
          }
        };
        img.src = dataUrl;
      });
    }
  }, {
    key: "getColorImage",
    value: function getColorImage(hex, width, height) {
      var $canvas = $("<canvas>"); // create an offscreen canvas
      $canvas.attr({
        width: width,
        height: height
      });
      var canvas = $canvas[0];
      var context = canvas.getContext("2d");
      if (context) {
        context.fillStyle = hex;
        context.fillRect(0, 0, width, height);
        var dataUrl = canvas.toDataURL();
        return dataUrl;
      } else {
        return null;
      }
    }

    /**
    * Split a string into chunks of the given size
    * @param  {String} str is the String to split
    * @param  {Number} size is the size you of the cuts
    * @return {Array} an Array with the strings
    */
  }, {
    key: "chunkString",
    value: function chunkString(str, size) {
      // Rollup will try to execute this function with str as undefined. IDK
      if (!str) return null;
      return str.match(new RegExp('.[^]{1,' + size + '}', 'g'));
    }
  }, {
    key: "getStringHashCode",
    value: function getStringHashCode(str) {
      var hash = 0,
        i,
        chr;
      if (str.length === 0) return hash;
      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; // Convert to 32bit integer
      }

      return hash;
    }
  }, {
    key: "getAbsoluteUrl",
    value: function getAbsoluteUrl(relative) {
      var tempLink = document.createElement("a");
      tempLink.href = relative;
      var absolute = tempLink.href;
      return absolute;
    }
  }, {
    key: "dataURItoBlob",
    value: function dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      var bb = new Blob([ab], {
        type: mimeString
      });
      return bb;
    }
  }, {
    key: "getRandomString",
    value: function getRandomString(length, keyspace) {
      if (typeof length !== 'number' && length < 1) {
        throw new RangeError('Length must be a positive integer!');
      }
      if (keyspace === undefined) {
        keyspace = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      }
      var result = '';
      var charactersLength = keyspace.length;
      for (var i = 0; i < length; i++) {
        result += keyspace.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    }

    // Flip image vertically using canvas
  }, {
    key: "flipImage",
    value: function () {
      var _flipImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(arrayBuffer, type) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve) {
                var arrayBufferView = new Uint8Array(arrayBuffer);
                var blob = new Blob([arrayBufferView], {
                  type: type
                });
                var urlCreator = window.URL || window.webkitURL;
                var imageUrl = urlCreator.createObjectURL(blob);

                // ArrayBuffer to image
                var image = new Image();
                image.src = imageUrl;
                image.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                  var canvas, ctx;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        canvas = document.createElement('canvas');
                        ctx = canvas.getContext('2d');
                        canvas.width = image.width;
                        canvas.height = image.height;
                        ctx.translate(0, image.height);
                        ctx.scale(1, -1);
                        ctx.drawImage(image, 0, 0);

                        // Canvas to arraybuffer
                        canvas.toBlob(function (blob) {
                          var reader = new FileReader();
                          reader.addEventListener('loadend', function () {
                            var arrayBuffer = reader.result;
                            resolve(arrayBuffer);
                          });
                          reader.readAsArrayBuffer(blob);
                        }, type);
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function flipImage(_x, _x2) {
        return _flipImage.apply(this, arguments);
      }
      return flipImage;
    }()
  }]);
  return Utils;
}();

/***/ }),

/***/ "../../3D/src/Interfaces/IDisposable.ts":
/*!**********************************************!*\
  !*** ../../3D/src/Interfaces/IDisposable.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../../3D/src/Interfaces/ISceneEditor.ts":
/*!***********************************************!*\
  !*** ../../3D/src/Interfaces/ISceneEditor.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../../3D/src/Interfaces/ISupportInitialize.ts":
/*!*****************************************************!*\
  !*** ../../3D/src/Interfaces/ISupportInitialize.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../../3D/src/Layers/AxesLayer.ts":
/*!****************************************!*\
  !*** ../../3D/src/Layers/AxesLayer.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AxesLayer": () => (/* binding */ AxesLayer)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AxesLayer = /*#__PURE__*/function () {
  function AxesLayer(sceneEditor) {
    var _this = this;
    _classCallCheck(this, AxesLayer);
    _defineProperty(this, "_axisRoot", null);
    _defineProperty(this, "_axes", []);
    this._sceneEditor = sceneEditor;
    if (!sceneEditor.engine) throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
    var engine = sceneEditor.engine;
    if (!sceneEditor.scene) throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
    this._editorScene = sceneEditor.scene;
    this._scene = new BABYLON.Scene(engine);
    this._scene.autoClear = false;
    this._scene.postProcessesEnabled = false;
    this._sceneEditor.addPreUpdateListener(function () {
      return _this.onPreUpdate();
    });
    this._sceneEditor.addPostUpdateListener(function () {
      return _this.onPostUpdate();
    });
    this.createAxes();
  }
  _createClass(AxesLayer, [{
    key: "dispose",
    value: function dispose() {
      if (this._scene) {
        this._scene.dispose();
      }
    }
  }, {
    key: "onPreUpdate",
    value: function onPreUpdate() {
      if (!this._scene) return;

      // Update camera
      var camera = this._editorScene.activeCamera;
      if (camera) {
        this._scene.activeCamera = camera;
        if (this._axisRoot) {
          var distance = BABYLON.Vector3.Distance(camera.position, this._axisRoot.position) * 0.03;
          this._axisRoot.scaling = new BABYLON.Vector3(distance, distance, distance);
          this._axisRoot.computeWorldMatrix(true);
        }
      }
    }
  }, {
    key: "onPostUpdate",
    value: function onPostUpdate() {
      // nothing to do
    }
  }, {
    key: "createAxes",
    value: function createAxes() {
      var _this2 = this;
      var size = 10;
      var scene = this._scene;
      var parent = new BABYLON.Mesh("axisRoot", scene);
      parent.isVisible = this._sceneEditor.canShowAxes();
      var makeTextPlane = function makeTextPlane(text, color, size) {
        var dynamicTexture = new BABYLON.DynamicTexture("DynamicTexture", 50, scene, true);
        dynamicTexture.hasAlpha = true;
        dynamicTexture.drawText(text, 5, 40, "bold 36px Arial", color, "transparent", true);
        var plane = BABYLON.MeshBuilder.CreatePlane("TextPlane", {
          size: size,
          updatable: true
        }, scene);
        var material = new BABYLON.StandardMaterial("TextPlaneMaterial", scene);
        material.metadata = {
          isRealMaterial: false
        };
        material.backFaceCulling = false;
        material.specularColor = new BABYLON.Color3(0, 0, 0);
        material.diffuseTexture = dynamicTexture;
        plane.material = material;
        plane.metadata = {
          isRealMesh: false,
          isAxis: true
        };
        plane.parent = parent;
        plane.isVisible = _this2._sceneEditor.canShowAxes();
        return plane;
      };
      var axisX = BABYLON.Mesh.CreateLines("axisX", [BABYLON.Vector3.Zero(), new BABYLON.Vector3(size, 0, 0), new BABYLON.Vector3(size * 0.95, 0.05 * size, 0), new BABYLON.Vector3(size, 0, 0), new BABYLON.Vector3(size * 0.95, -0.05 * size, 0)], scene, true);
      axisX.metadata = {
        isRealMesh: false,
        isAxis: true
      };
      axisX.color = new BABYLON.Color3(1, 0, 0);
      axisX.parent = parent;
      axisX.isVisible = this._sceneEditor.canShowAxes();
      var xChar = makeTextPlane("X", "red", size / 10);
      xChar.position = new BABYLON.Vector3(0.9 * size, -0.05 * size, 0);
      var axisY = BABYLON.Mesh.CreateLines("axisY", [BABYLON.Vector3.Zero(), new BABYLON.Vector3(0, size, 0), new BABYLON.Vector3(-0.05 * size, size * 0.95, 0), new BABYLON.Vector3(0, size, 0), new BABYLON.Vector3(0.05 * size, size * 0.95, 0)], scene, true);
      axisY.metadata = {
        isRealMesh: false,
        isAxis: true
      };
      axisY.color = new BABYLON.Color3(0, 1, 0);
      axisY.parent = parent;
      axisY.isVisible = this._sceneEditor.canShowAxes();
      var yChar = makeTextPlane("Y", "green", size / 10);
      yChar.position = new BABYLON.Vector3(0, 0.9 * size, -0.05 * size);
      var axisZ = BABYLON.Mesh.CreateLines("axisZ", [BABYLON.Vector3.Zero(), new BABYLON.Vector3(0, 0, size), new BABYLON.Vector3(0, -0.05 * size, size * 0.95), new BABYLON.Vector3(0, 0, size), new BABYLON.Vector3(0, 0.05 * size, size * 0.95)], scene, true);
      axisZ.metadata = {
        isRealMesh: false,
        isAxis: true
      };
      axisZ.color = new BABYLON.Color3(0, 0, 1);
      axisZ.parent = parent;
      axisZ.isVisible = this._sceneEditor.canShowAxes();
      var zChar = makeTextPlane("Z", "blue", size / 10);
      zChar.position = new BABYLON.Vector3(0, 0.05 * size, 0.9 * size);
      this._axisRoot = parent;
      this._axes.push(parent, axisX, axisY, axisZ, xChar, yChar, zChar);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      for (var i = 0; i < this._axes.length; i++) {
        var mesh = this._axes[i];
        mesh.isVisible = this._sceneEditor.canShowAxes();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._scene && this._scene.activeCamera) this._scene.render();
    }
  }, {
    key: "getScene",
    value: function getScene() {
      return this._scene;
    }
  }]);
  return AxesLayer;
}();

/***/ }),

/***/ "../../3D/src/Layers/LightsLayer.ts":
/*!******************************************!*\
  !*** ../../3D/src/Layers/LightsLayer.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LightsLayer": () => (/* binding */ LightsLayer)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
var event = { name: pickInfo.pickedMesh.name, id: pickInfo.pickedMesh.id };
*/

var LightsLayer = /*#__PURE__*/function () {
  function LightsLayer(sceneEditor) {
    var _this = this;
    _classCallCheck(this, LightsLayer);
    _defineProperty(this, "_lightMeshes", []);
    _defineProperty(this, "_lightSelectedListeners", []);
    this._sceneEditor = sceneEditor;
    if (!sceneEditor.engine) throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
    var engine = sceneEditor.engine;
    if (!sceneEditor.scene) throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
    this._editorScene = sceneEditor.scene;
    this._scene = new BABYLON.Scene(engine);
    this._scene.autoClear = false;
    this._scene.postProcessesEnabled = false;
    this._scene.onPointerDown = this.onPointerDown;
    this._sceneEditorPreUpdate = function () {
      return _this.onPreUpdate();
    };
    this._sceneEditorPostUpdate = function () {
      return _this.onPostUpdate();
    };
    this._sceneEditor.addPreUpdateListener(this._sceneEditorPreUpdate);
    this._sceneEditor.addPostUpdateListener(this._sceneEditorPostUpdate);
  }
  _createClass(LightsLayer, [{
    key: "dispose",
    value: function dispose() {
      if (this._sceneEditor) {
        this._sceneEditor.removePreUpdateListener(this._sceneEditorPreUpdate);
        this._sceneEditor.removePostUpdateListener(this._sceneEditorPostUpdate);
      }
      if (this._scene) {
        this._scene.dispose();
      }
    }
  }, {
    key: "onPreUpdate",
    value: function onPreUpdate() {
      this._scene.activeCamera = this._editorScene.activeCamera;
    }
  }, {
    key: "onPostUpdate",
    value: function onPostUpdate() {
      var engine = this._scene.getEngine();
      for (var i = 0; i < this._lightMeshes.length; i++) {
        var lightMesh = this._lightMeshes[i];
        var light = this._editorScene.getLightByID(lightMesh.id);
        if (light) {
          this.configureLightMesh(lightMesh, light);
        }
      }
    }
  }, {
    key: "onPointerDown",
    value: function onPointerDown(evt, pickInfo, type) {
      if (pickInfo.hit && pickInfo.pickedMesh) {
        var event = {
          name: pickInfo.pickedMesh.name,
          id: pickInfo.pickedMesh.id
        };
        //Logger.info("Light Picked: " + pickInfo.pickedMesh.id);
        this.fireLightSelectedEvent(event);
      }
    }
  }, {
    key: "refresh",
    value: function refresh() {
      this.updateLightMeshes();
    }
  }, {
    key: "updateLightMeshes",
    value: function updateLightMeshes() {
      if (this._scene && this._sceneEditor) {
        for (var i = 0; i < this._editorScene.lights.length; i++) {
          var light = this._editorScene.lights[i];
          var lightMesh = this._scene.getMeshByID(light.id);
          if (lightMesh) this.configureLightMesh(lightMesh, light);else {
            this._lightMeshes.push(this.createLightMesh(light));
          }
        }
        for (var _i = 0; _i < this._lightMeshes.length; _i++) {
          var _lightMesh = this._lightMeshes[_i];
          var _light = this._editorScene.getLightByID(_lightMesh.id);
          if (!_light) {
            _lightMesh.dispose();
            this._lightMeshes.splice(_i--, 1);
          }
        }
      }
    }
  }, {
    key: "createLightMesh",
    value: function createLightMesh(light) {
      //const lightTexture = new BABYLON.Texture("/Content/css/composer/images/bulb_01.png", this._scene);
      var lightTexture = new BABYLON.Texture(LightsLayer._lightTexture, this._scene);
      lightTexture.hasAlpha = true;
      var material = new BABYLON.StandardMaterial("LightMeshMaterial_" + light.id, this._scene);
      material.emissiveColor = BABYLON.Color3.White();
      material.useAlphaFromDiffuseTexture = true;
      material.disableDepthWrite = false;
      material.diffuseTexture = lightTexture;
      var mesh = BABYLON.Mesh.CreatePlane(light.name, 1, this._scene);
      mesh.id = light.id;
      mesh.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
      mesh.material = material;
      this.configureLightMesh(mesh, light);
      return mesh;
    }
  }, {
    key: "clearLightMeshes",
    value: function clearLightMeshes() {
      if (this._scene) {
        while (this._lightMeshes.length > 0) {
          var lightMesh = this._lightMeshes.pop();
          if (lightMesh) lightMesh.dispose();
        }
      }
    }
  }, {
    key: "configureLightMesh",
    value: function configureLightMesh(lightMesh, light) {
      var camera = this._editorScene.activeCamera;
      if (camera && lightMesh && light) {
        lightMesh.position = light.getAbsolutePosition();
        var distance = BABYLON.Vector3.Distance(camera.position, lightMesh.position) * 0.03;
        lightMesh.scaling = new BABYLON.Vector3(distance, distance, distance);
        lightMesh.computeWorldMatrix(true);
        lightMesh.isVisible = this._sceneEditor.canShowLights();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._scene) this._scene.render();
    }
  }, {
    key: "getScene",
    value: function getScene() {
      return this._scene;
    }
  }, {
    key: "fireLightSelectedEvent",
    value: function fireLightSelectedEvent(evt) {
      for (var i = 0; i < this._lightSelectedListeners.length; ++i) {
        this._lightSelectedListeners[i](evt);
      }
    }
  }, {
    key: "addLightSelectedListener",
    value: function addLightSelectedListener(listener) {
      this._lightSelectedListeners.push(listener);
    }
  }]);
  return LightsLayer;
}();
_defineProperty(LightsLayer, "_lightTexture", "data:image/png;base64,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");

/***/ }),

/***/ "../../3D/src/Misc/Database.ts":
/*!*************************************!*\
  !*** ../../3D/src/Misc/Database.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Database": () => (/* binding */ Database)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Database = /*#__PURE__*/function () {
  /**
   * Creates a new Database
  */
  function Database() {
    _classCallCheck(this, Database);
    // Handling various flavors of prefixed version of IndexedDB
    _defineProperty(this, "_idbFactory", typeof window !== "undefined" ? window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB : indexedDB);
    this._db = null;
    this._hasReachedQuota = false;
    this._isSupported = true;
  }
  _createClass(Database, [{
    key: "openAsync",
    value: function openAsync() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        return _this.open(resolve, reject);
      });
    }

    /**
     * Open the database and make it available
     * @param successCallback defines the callback to call on success
     * @param errorCallback defines the callback to call on error
     */
  }, {
    key: "open",
    value: function open(successCallback, errorCallback) {
      var _this2 = this;
      var handleError = function handleError() {
        _this2._isSupported = false;
        if (errorCallback) {
          errorCallback();
        }
      };
      if (!this._idbFactory) {
        // Your browser doesn't support IndexedDB
        this._isSupported = false;
        if (errorCallback) {
          errorCallback();
        }
      } else {
        // If the DB hasn't been opened or created yet
        if (!this._db) {
          this._hasReachedQuota = false;
          this._isSupported = true;
          var request = this._idbFactory.open("zakeke", 1);

          // Could occur if user is blocking the quota for the DB and/or doesn't grant access to IndexedDB
          request.onerror = function () {
            handleError();
          };

          // executes when a version change transaction cannot complete due to other active transactions
          request.onblocked = function () {
            Logger.info("IDB request blocked. Please reload the page.");
            handleError();
          };

          // DB has been opened successfully
          request.onsuccess = function () {
            _this2._db = request.result;
            successCallback();
          };

          // Initialization of the DB. Creating Scenes & Textures stores
          request.onupgradeneeded = function (event) {
            _this2._db = event.target.result;
            if (_this2._db) {
              try {
                _this2._db.createObjectStore("files", {
                  keyPath: "fileId"
                });
              } catch (ex) {
                Logger.info("Error while creating object stores. Exception: " + ex.message);
                handleError();
              }
            }
          };
        }
        // DB has already been created and opened
        else {
          if (successCallback) {
            successCallback();
          }
        }
      }
    }
  }, {
    key: "loadFileAsync",
    value: function loadFileAsync(fileId) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        if (_this3._isSupported && _this3._db) {
          var targetStore = "files";
          var file;
          var transaction = _this3._db.transaction([targetStore]);
          transaction.oncomplete = function () {
            if (file) {
              resolve(file.data);
            }
            // file was not found in DB
            else {
              resolve(null);
            }
          };
          transaction.onabort = function () {
            resolve(null);
          };
          var getRequest = transaction.objectStore(targetStore).get(fileId);
          getRequest.onsuccess = function (event) {
            file = event.target.result;
          };
          getRequest.onerror = function () {
            Logger.info("Error loading file " + fileId + " from DB.");
            resolve(null);
          };
        } else {
          Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open.");
          reject("IndexedDB not supported or Db is not open");
        }
      });
    }
  }, {
    key: "saveFileAsync",
    value: function saveFileAsync(fileId, data) {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        if (_this4._isSupported) {
          var targetStore = "files";
          if (!_this4._hasReachedQuota && _this4._db) {
            // Open a transaction to the database
            var transaction = _this4._db.transaction([targetStore], "readwrite");

            // the transaction could abort because of a QuotaExceededError error
            transaction.onabort = function (event) {
              //backwards compatibility with ts 1.0, srcElement doesn't have an "error" according to ts 1.3
              var error = event.srcElement["error"];
              if (error && error.name === "QuotaExceededError") {
                _this4._hasReachedQuota = true;
                reject("Quota Exceeded");
              }
            };
            transaction.oncomplete = function () {
              Logger.info("File saved successfully");
              resolve();
            };
            var newFile = {
              fileId: fileId,
              data: data
            };

            // Put the file into the database
            var addRequest = transaction.objectStore(targetStore).put(newFile);
            addRequest.onsuccess = function () {};
            addRequest.onerror = function () {
              Logger.info("Error in DB add file request in Zakeke3D.Database.");
              reject("Error in DB add file request");
            };
          } else {
            var error = _this4._hasReachedQuota ? "Quota has been reached" : "Database closed";
            reject(error);
          }
        } else {
          Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open.");
          reject("IndexedDB not supported or Db is not open");
        }
      });
    }
  }, {
    key: "deleteFileAsync",
    value: function deleteFileAsync(fileId) {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        if (_this5._isSupported && _this5._db) {
          var targetStore = "files";
          var transaction = _this5._db.transaction([targetStore]);
          transaction.oncomplete = function () {
            resolve();
          };
          transaction.onabort = function () {
            reject("aborted cancellation");
          };
          var getRequest = transaction.objectStore(targetStore).get(fileId);
          getRequest.onerror = function () {
            Logger.info("Error deleting file " + fileId + " from DB.");
            reject("Error deleting file from DB");
          };
        } else {
          Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open.");
          reject("IndexedDB not supported or Db is not open");
        }
      });
    }
  }]);
  return Database;
}();

/***/ }),

/***/ "../../3D/src/Misc/DefaultAssetUrls.ts":
/*!*********************************************!*\
  !*** ../../3D/src/Misc/DefaultAssetUrls.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DefaultAssetUrls": () => (/* binding */ DefaultAssetUrls)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DefaultAssetUrls = /*#__PURE__*/_createClass(function DefaultAssetUrls() {
  _classCallCheck(this, DefaultAssetUrls);
});
_defineProperty(DefaultAssetUrls, "Environment", {
  //EnvironmentTextureName: "environmentSpecular.dds",
  EnvironmentTextureName: "environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env",
  GroundTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/backgroundGround9.png",
  SkyboxTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/backgroundSkybox.dds",
  //EnvironmentTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/environmentSpecular.dds"
  EnvironmentTextureCDNUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/environments/environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env"
});
_defineProperty(DefaultAssetUrls, "Tryon", {
  RootUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/tryon/references/",
  ReferenceGlassesFrameName: "Reference Glasses Frame",
  ReferenceGlassesFrameFileName: "Reference_Glasses_Frame_001.json"
});
_defineProperty(DefaultAssetUrls, "Shapes", {
  RootUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/shapes/",
  RoundedCubeName: "Rounded Cube",
  RoundedCubeFileName: "rounded_cube.babylon",
  RoundedCylinderName: "Rounded Cylinder",
  RoundedCylinderFileName: "rounded_cylinder.babylon",
  MatBallName: "Mat Ball",
  MatBallFileName: "mat_ball.babylon",
  MaleHeadName: "Group48944",
  MaleHeadFileName: "DemoHead.babylon",
  FemaleHeadName: "Group12208",
  FemaleHeadFileName: "FemaleHead.babylon",
  PokemonBallName: "PokemonBall",
  PokemonBallFileName: "PokemonBall.babylon",
  ShaderBallName: "Elements",
  ShaderBallFileName: "ShaderBall.babylon",
  BootsFolder: "boots/",
  BootsName: "shoe",
  BootsFileName: "boots.incremental.babylon",
  SuzanneName: "Suzanne",
  SuzanneFileName: "suzanne.babylon",
  StepPyramidName: "Pyramid",
  StepPyramidFileName: "step-pyramid.babylon",
  TeapotName: "Teapot",
  TeapotFileName: "teapot.babylon",
  AlloyWheelName: "Wheel",
  AlloyWheelFolder: "alloy_wheel/",
  AlloyWheelFileName: "alloy_wheel.incremental.babylon"
});

/***/ }),

/***/ "../../3D/src/Misc/Observable.ts":
/*!***************************************!*\
  !*** ../../3D/src/Misc/Observable.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EventState": () => (/* binding */ EventState),
/* harmony export */   "MultiObserver": () => (/* binding */ MultiObserver),
/* harmony export */   "Observable": () => (/* binding */ Observable),
/* harmony export */   "Observer": () => (/* binding */ Observer)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * A class serves as a medium between the observable and its observers
 */
var EventState = /*#__PURE__*/function () {
  /**
   * Create a new EventState
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   */
  function EventState(mask) {
    var skipNextObservers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var target = arguments.length > 2 ? arguments[2] : undefined;
    var currentTarget = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, EventState);
    /**
     * An Observer can set this property to true to prevent subsequent observers of being notified
     */
    _defineProperty(this, "skipNextObservers", false);
    /**
     * Get the mask value that were used to trigger the event corresponding to this EventState object
     */
    _defineProperty(this, "mask", 0);
    this.initalize(mask, skipNextObservers, target, currentTarget);
  }

  /**
   * Initialize the current event state
   * @param mask defines the mask associated with this state
   * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
   * @param target defines the original target of the state
   * @param currentTarget defines the current target of the state
   * @returns the current event state
   */
  _createClass(EventState, [{
    key: "initalize",
    value: function initalize(mask) {
      var skipNextObservers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var target = arguments.length > 2 ? arguments[2] : undefined;
      var currentTarget = arguments.length > 3 ? arguments[3] : undefined;
      this.mask = mask;
      this.skipNextObservers = skipNextObservers;
      this.target = target;
      this.currentTarget = currentTarget;
      return this;
    }
    /**
     * The object that originally notified the event
     */
  }]);
  return EventState;
}();

/**
 * Represent an Observer registered to a given Observable object.
 */
var Observer = /*#__PURE__*/_createClass(
/**
 * Creates a new observer
 * @param callback defines the callback to call when the observer is notified
 * @param mask defines the mask of the observer (used to filter notifications)
 * @param scope defines the current scope used to restore the JS context
 */
function Observer(
/**
 * Defines the callback to call when the observer is notified
 */
callback,
/**
 * Defines the mask of the observer (used to filter notifications)
 */
mask) {
  var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  _classCallCheck(this, Observer);
  /** @hidden */
  _defineProperty(this, "_willBeUnregistered", false);
  /**
   * Gets or sets a property defining that the observer as to be unregistered after the next notification
   */
  _defineProperty(this, "unregisterOnNextCall", false);
  this.callback = callback;
  this.mask = mask;
  this.scope = scope;
});

/**
 * Represent a list of observers registered to multiple Observables object.
 */
var MultiObserver = /*#__PURE__*/function () {
  function MultiObserver() {
    _classCallCheck(this, MultiObserver);
    _defineProperty(this, "_observers", null);
    _defineProperty(this, "_observables", null);
  }
  _createClass(MultiObserver, [{
    key: "dispose",
    value:
    /**
     * Release associated resources
     */
    function dispose() {
      if (this._observers && this._observables) {
        for (var index = 0; index < this._observers.length; index++) {
          this._observables[index].remove(this._observers[index]);
        }
      }
      this._observers = null;
      this._observables = null;
    }

    /**
     * Raise a callback when one of the observable will notify
     * @param observables defines a list of observables to watch
     * @param callback defines the callback to call on notification
     * @param mask defines the mask used to filter notifications
     * @param scope defines the current scope used to restore the JS context
     * @returns the new MultiObserver
     */
  }], [{
    key: "Watch",
    value: function Watch(observables, callback) {
      var mask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var scope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var result = new MultiObserver();
      result._observers = new Array();
      result._observables = observables;
      var _iterator = _createForOfIteratorHelper(observables),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var observable = _step.value;
          var _observer = observable.add(callback, mask, false, scope);
          if (_observer) {
            result._observers.push(_observer);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return result;
    }
  }]);
  return MultiObserver;
}();

/**
 * The Observable class is a simple implementation of the Observable pattern.
 *
 * There's one slight particularity though: a given Observable can notify its observer using a particular mask value, only the Observers registered with this mask value will be notified.
 * This enable a more fine grained execution without having to rely on multiple different Observable objects.
 * For instance you may have a given Observable that have four different types of notifications: Move (mask = 0x01), Stop (mask = 0x02), Turn Right (mask = 0X04), Turn Left (mask = 0X08).
 * A given observer can register itself with only Move and Stop (mask = 0x03), then it will only be notified when one of these two occurs and will never be for Turn Left/Right.
 */
var Observable = /*#__PURE__*/function () {
  /**
   * Creates a new observable
   * @param onObserverAdded defines a callback to call when a new observer is added
   */
  function Observable(onObserverAdded) {
    _classCallCheck(this, Observable);
    _defineProperty(this, "_observers", new Array());
    _defineProperty(this, "_onObserverAdded", null);
    this._eventState = new EventState(0);
    if (onObserverAdded) {
      this._onObserverAdded = onObserverAdded;
    }
  }

  /**
   * Create a new Observer with the specified callback
   * @param callback the callback that will be executed for that Observer
   * @param mask the mask used to filter observers
   * @param insertFirst if true the callback will be inserted at the first position, hence executed before the others ones. If false (default behavior) the callback will be inserted at the last position, executed after all the others already present.
   * @param scope optional scope for the callback to be called from
   * @param unregisterOnFirstCall defines if the observer as to be unregistered after the next notification
   * @returns the new observer created for the callback
   */
  _createClass(Observable, [{
    key: "observers",
    get:
    /**
     * Gets the list of observers
     */
    function get() {
      return this._observers;
    }
  }, {
    key: "add",
    value: function add(callback) {
      var mask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var insertFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var scope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var unregisterOnFirstCall = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      if (!callback) {
        return null;
      }
      var observer = new Observer(callback, mask, scope);
      observer.unregisterOnNextCall = unregisterOnFirstCall;
      if (insertFirst) {
        this._observers.unshift(observer);
      } else {
        this._observers.push(observer);
      }
      if (this._onObserverAdded) {
        this._onObserverAdded(observer);
      }
      return observer;
    }

    /**
     * Create a new Observer with the specified callback and unregisters after the next notification
     * @param callback the callback that will be executed for that Observer
     * @returns the new observer created for the callback
     */
  }, {
    key: "addOnce",
    value: function addOnce(callback) {
      return this.add(callback, undefined, undefined, undefined, true);
    }

    /**
     * Remove an Observer from the Observable object
     * @param observer the instance of the Observer to remove
     * @returns false if it doesn't belong to this Observable
     */
  }, {
    key: "remove",
    value: function remove(observer) {
      if (!observer) {
        return false;
      }
      var index = this._observers.indexOf(observer);
      if (index !== -1) {
        this._deferUnregister(observer);
        return true;
      }
      return false;
    }

    /**
     * Remove a callback from the Observable object
     * @param callback the callback to remove
     * @param scope optional scope. If used only the callbacks with this scope will be removed
     * @returns false if it doesn't belong to this Observable
    */
  }, {
    key: "removeCallback",
    value: function removeCallback(callback, scope) {
      for (var index = 0; index < this._observers.length; index++) {
        var _observer2 = this._observers[index];
        if (_observer2._willBeUnregistered) {
          continue;
        }
        if (_observer2.callback === callback && (!scope || scope === _observer2.scope)) {
          this._deferUnregister(_observer2);
          return true;
        }
      }
      return false;
    }
  }, {
    key: "_deferUnregister",
    value: function _deferUnregister(observer) {
      var _this = this;
      observer.unregisterOnNextCall = false;
      observer._willBeUnregistered = true;
      setTimeout(function () {
        _this._remove(observer);
      }, 0);
    }

    // This should only be called when not iterating over _observers to avoid callback skipping.
    // Removes an observer from the _observer Array.
  }, {
    key: "_remove",
    value: function _remove(observer) {
      if (!observer) {
        return false;
      }
      var index = this._observers.indexOf(observer);
      if (index !== -1) {
        this._observers.splice(index, 1);
        return true;
      }
      return false;
    }

    /**
     * Moves the observable to the top of the observer list making it get called first when notified
     * @param observer the observer to move
     */
  }, {
    key: "makeObserverTopPriority",
    value: function makeObserverTopPriority(observer) {
      this._remove(observer);
      this._observers.unshift(observer);
    }

    /**
     * Moves the observable to the bottom of the observer list making it get called last when notified
     * @param observer the observer to move
     */
  }, {
    key: "makeObserverBottomPriority",
    value: function makeObserverBottomPriority(observer) {
      this._remove(observer);
      this._observers.push(observer);
    }

    /**
     * Notify all Observers by calling their respective callback with the given data
     * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
     * @param eventData defines the data to send to all observers
     * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
     * @param target defines the original target of the state
     * @param currentTarget defines the current target of the state
     * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
     */
  }, {
    key: "notifyObservers",
    value: function notifyObservers(eventData) {
      var mask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var target = arguments.length > 2 ? arguments[2] : undefined;
      var currentTarget = arguments.length > 3 ? arguments[3] : undefined;
      if (!this._observers.length) {
        return true;
      }
      var state = this._eventState;
      state.mask = mask;
      state.target = target;
      state.currentTarget = currentTarget;
      state.skipNextObservers = false;
      state.lastReturnValue = eventData;
      var _iterator2 = _createForOfIteratorHelper(this._observers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var obs = _step2.value;
          if (obs._willBeUnregistered) {
            continue;
          }
          if (obs.mask & mask) {
            if (obs.scope) {
              state.lastReturnValue = obs.callback.apply(obs.scope, [eventData, state]);
            } else {
              state.lastReturnValue = obs.callback(eventData, state);
            }
            if (obs.unregisterOnNextCall) {
              this._deferUnregister(obs);
            }
          }
          if (state.skipNextObservers) {
            return false;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return true;
    }

    /**
     * Calling this will execute each callback, expecting it to be a promise or return a value.
     * If at any point in the chain one function fails, the promise will fail and the execution will not continue.
     * This is useful when a chain of events (sometimes async events) is needed to initialize a certain object
     * and it is crucial that all callbacks will be executed.
     * The order of the callbacks is kept, callbacks are not executed parallel.
     *
     * @param eventData The data to be sent to each callback
     * @param mask is used to filter observers defaults to 0
     * @param target defines the callback target (see EventState)
     * @param currentTarget defines he current object in the bubbling phase
     * @returns {Promise<T>} will return a Promise than resolves when all callbacks executed successfully.
     */
  }, {
    key: "notifyObserversWithPromise",
    value: function notifyObserversWithPromise(eventData) {
      var _this2 = this;
      var mask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var target = arguments.length > 2 ? arguments[2] : undefined;
      var currentTarget = arguments.length > 3 ? arguments[3] : undefined;
      // create an empty promise
      var p = Promise.resolve(eventData);

      // no observers? return this promise.
      if (!this._observers.length) {
        return p;
      }
      var state = this._eventState;
      state.mask = mask;
      state.target = target;
      state.currentTarget = currentTarget;
      state.skipNextObservers = false;

      // execute one callback after another (not using Promise.all, the order is important)
      this._observers.forEach(function (obs) {
        if (state.skipNextObservers) {
          return;
        }
        if (obs._willBeUnregistered) {
          return;
        }
        if (obs.mask & mask) {
          if (obs.scope) {
            p = p.then(function (lastReturnedValue) {
              state.lastReturnValue = lastReturnedValue;
              return obs.callback.apply(obs.scope, [eventData, state]);
            });
          } else {
            p = p.then(function (lastReturnedValue) {
              state.lastReturnValue = lastReturnedValue;
              return obs.callback(eventData, state);
            });
          }
          if (obs.unregisterOnNextCall) {
            _this2._deferUnregister(obs);
          }
        }
      });

      // return the eventData
      return p.then(function () {
        return eventData;
      });
    }

    /**
     * Notify a specific observer
     * @param observer defines the observer to notify
     * @param eventData defines the data to be sent to each callback
     * @param mask is used to filter observers defaults to 0
     */
  }, {
    key: "notifyObserver",
    value: function notifyObserver(observer, eventData) {
      var mask = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var state = this._eventState;
      state.mask = mask;
      state.skipNextObservers = false;
      observer.callback(eventData, state);
    }

    /**
     * Gets a boolean indicating if the observable has at least one observer
     * @returns true is the Observable has at least one Observer registered
     */
  }, {
    key: "hasObservers",
    value: function hasObservers() {
      return this._observers.length > 0;
    }

    /**
    * Clear the list of observers
    */
  }, {
    key: "clear",
    value: function clear() {
      this._observers = new Array();
      this._onObserverAdded = null;
    }

    /**
     * Clone the current observable
     * @returns a new observable
     */
  }, {
    key: "clone",
    value: function clone() {
      var result = new Observable();
      result._observers = this._observers.slice(0);
      return result;
    }

    /**
     * Does this observable handles observer registered with a given mask
     * @param mask defines the mask to be tested
     * @return whether or not one observer registered with the given mask is handeled
    **/
  }, {
    key: "hasSpecificMask",
    value: function hasSpecificMask() {
      var mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var _iterator3 = _createForOfIteratorHelper(this._observers),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var obs = _step3.value;
          if (obs.mask & mask || obs.mask === mask) {
            return true;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return false;
    }
  }]);
  return Observable;
}();

/***/ }),

/***/ "../../3D/src/Misc/StringTools.ts":
/*!****************************************!*\
  !*** ../../3D/src/Misc/StringTools.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StringTools": () => (/* binding */ StringTools)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Helper to manipulate strings
 */
var StringTools = /*#__PURE__*/function () {
  function StringTools() {
    _classCallCheck(this, StringTools);
  }
  _createClass(StringTools, null, [{
    key: "EndsWith",
    value:
    /**
     * Checks for a matching suffix at the end of a string (for ES5 and lower)
     * @param str Source string
     * @param suffix Suffix to search for in the source string
     * @returns Boolean indicating whether the suffix was found (true) or not (false)
     */
    function EndsWith(str, suffix) {
      return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    /**
     * Checks for a matching suffix at the beginning of a string (for ES5 and lower)
     * @param str Source string
     * @param suffix Suffix to search for in the source string
     * @returns Boolean indicating whether the suffix was found (true) or not (false)
     */
  }, {
    key: "StartsWith",
    value: function StartsWith(str, suffix) {
      return str.indexOf(suffix) === 0;
    }

    /**
     * Decodes a buffer into a string
     * @param buffer The buffer to decode
     * @returns The decoded string
     */
  }, {
    key: "Decode",
    value: function Decode(buffer) {
      if (typeof TextDecoder !== "undefined") {
        return new TextDecoder().decode(buffer);
      }
      var result = "";
      for (var i = 0; i < buffer.byteLength; i++) {
        result += String.fromCharCode(buffer[i]);
      }
      return result;
    }

    /**
     * Encode a buffer to a base64 string
     * @param buffer defines the buffer to encode
     * @returns the encoded string
     */
  }, {
    key: "EncodeArrayBufferToBase64",
    value: function EncodeArrayBufferToBase64(buffer) {
      var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      var bytes = ArrayBuffer.isView(buffer) ? new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength) : new Uint8Array(buffer);
      while (i < bytes.length) {
        chr1 = bytes[i++];
        chr2 = i < bytes.length ? bytes[i++] : Number.NaN;
        chr3 = i < bytes.length ? bytes[i++] : Number.NaN;
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
      }
      return output;
    }
  }]);
  return StringTools;
}();

/***/ }),

/***/ "../../3D/src/Misc/WorkerPool.ts":
/*!***************************************!*\
  !*** ../../3D/src/Misc/WorkerPool.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WorkerPool": () => (/* binding */ WorkerPool)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Helper class to push actions to a pool of workers.
 */
var WorkerPool = /*#__PURE__*/function () {
  /**
   * Constructor
   * @param workers Array of workers to use for actions
   */
  function WorkerPool(workers) {
    _classCallCheck(this, WorkerPool);
    // Optionals for Typescript - delete keyword
    _defineProperty(this, "_pendingActions", new Array());
    this._workerInfos = workers.map(function (worker) {
      return {
        worker: worker,
        active: false
      };
    });
  }

  /**
   * Terminates all workers and clears any pending actions.
   */
  _createClass(WorkerPool, [{
    key: "dispose",
    value: function dispose() {
      var _iterator = _createForOfIteratorHelper(this._workerInfos),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var workerInfo = _step.value;
          workerInfo.worker.terminate();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      delete this._workerInfos;
      delete this._pendingActions;
    }

    /**
     * Pushes an action to the worker pool. If all the workers are active, the action will be
     * pended until a worker has completed its action.
     * @param action The action to perform. Call onComplete when the action is complete.
     */
  }, {
    key: "push",
    value: function push(action) {
      var _iterator2 = _createForOfIteratorHelper(this._workerInfos),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var workerInfo = _step2.value;
          if (!workerInfo.active) {
            this._execute(workerInfo, action);
            return;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this._pendingActions.push(action);
    }
  }, {
    key: "_execute",
    value: function _execute(workerInfo, action) {
      var _this = this;
      workerInfo.active = true;
      action(workerInfo.worker, function () {
        workerInfo.active = false;
        var nextAction = _this._pendingActions.shift();
        if (nextAction) {
          _this._execute(workerInfo, nextAction);
        }
      });
    }
  }]);
  return WorkerPool;
}();

/***/ }),

/***/ "../../3D/src/Polyfills/Array/Array.prototype.find.js":
/*!************************************************************!*\
  !*** ../../3D/src/Polyfills/Array/Array.prototype.find.js ***!
  \************************************************************/
/***/ (() => {

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      'use strict';

      if (this == null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      for (var i = 0; i !== length; i++) {
        if (predicate.call(thisArg, this[i], i, list)) {
          return this[i];
        }
      }
      return undefined;
    }
  });
}

/***/ }),

/***/ "../../3D/src/Polyfills/Array/Array.prototype.includes.js":
/*!****************************************************************!*\
  !*** ../../3D/src/Polyfills/Array/Array.prototype.includes.js ***!
  \****************************************************************/
/***/ (() => {

if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement /*, fromIndex*/) {
    'use strict';

    if (this == null) {
      throw new TypeError('Array.prototype.includes called on null or undefined');
    }
    var O = Object(this);
    var len = parseInt(O.length, 10) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1], 10) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {
        k = 0;
      }
    }
    var currentElement;
    while (k < len) {
      currentElement = O[k];
      if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
        // NaN !== NaN
        return true;
      }
      k++;
    }
    return false;
  };
}

/***/ }),

/***/ "../../3D/src/Polyfills/Array/Array.prototype.map.js":
/*!***********************************************************!*\
  !*** ../../3D/src/Polyfills/Array/Array.prototype.map.js ***!
  \***********************************************************/
/***/ (() => {

// Production steps of ECMA-262, Edition 5, 15.4.4.19
// Reference: http://es5.github.io/#x15.4.4.19
if (!Array.prototype.map) {
  Array.prototype.map = function (callback /*, thisArg*/) {
    var T, A, k;
    if (this == null) {
      throw new TypeError('this is null or not defined');
    }

    // 1. Let O be the result of calling ToObject passing the |this| 
    //    value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get internal 
    //    method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (arguments.length > 1) {
      T = arguments[1];
    }

    // 6. Let A be a new array created as if by the expression new Array(len) 
    //    where Array is the standard built-in constructor with that name and 
    //    len is the value of len.
    A = new Array(len);

    // 7. Let k be 0
    k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
      var kValue, mappedValue;

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal 
      //    method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {
        // i. Let kValue be the result of calling the Get internal 
        //    method of O with argument Pk.
        kValue = O[k];

        // ii. Let mappedValue be the result of calling the Call internal 
        //     method of callback with T as the this value and argument 
        //     list containing kValue, k, and O.
        mappedValue = callback.call(T, kValue, k, O);

        // iii. Call the DefineOwnProperty internal method of A with arguments
        // Pk, Property Descriptor
        // { Value: mappedValue,
        //   Writable: true,
        //   Enumerable: true,
        //   Configurable: true },
        // and false.

        // In browsers that support Object.defineProperty, use the following:
        // Object.defineProperty(A, k, {
        //   value: mappedValue,
        //   writable: true,
        //   enumerable: true,
        //   configurable: true
        // });

        // For best browser support, use the following:
        A[k] = mappedValue;
      }
      // d. Increase k by 1.
      k++;
    }

    // 9. return A
    return A;
  };
}

/***/ }),

/***/ "../../3D/src/Polyfills/String/String.prototype.endsWith.js":
/*!******************************************************************!*\
  !*** ../../3D/src/Polyfills/String/String.prototype.endsWith.js ***!
  \******************************************************************/
/***/ (() => {

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }
    return this.substring(this_len - search.length, this_len) === search;
  };
}

/***/ }),

/***/ "../../3D/src/Polyfills/String/String.prototype.startsWith.js":
/*!********************************************************************!*\
  !*** ../../3D/src/Polyfills/String/String.prototype.startsWith.js ***!
  \********************************************************************/
/***/ (() => {

if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function value(search, rawPos) {
      var pos = rawPos > 0 ? rawPos | 0 : 0;
      return this.substring(pos, pos + search.length) === search;
    }
  });
}

/***/ }),

/***/ "../../3D/src/Viewers/MaterialEditor.ts":
/*!**********************************************!*\
  !*** ../../3D/src/Viewers/MaterialEditor.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EditorMeshType": () => (/* binding */ EditorMeshType),
/* harmony export */   "MaterialEditor": () => (/* binding */ MaterialEditor)
/* harmony export */ });
/* harmony import */ var _SceneEditor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./SceneEditor */ "../../3D/src/Viewers/SceneEditor.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

var EditorMeshType = /*#__PURE__*/function (EditorMeshType) {
  EditorMeshType[EditorMeshType["Box"] = 0] = "Box";
  EditorMeshType[EditorMeshType["RoundedBox"] = 1] = "RoundedBox";
  EditorMeshType[EditorMeshType["Sphere"] = 2] = "Sphere";
  EditorMeshType[EditorMeshType["Plane"] = 3] = "Plane";
  EditorMeshType[EditorMeshType["Cylinder"] = 4] = "Cylinder";
  EditorMeshType[EditorMeshType["RoundedCylinder"] = 5] = "RoundedCylinder";
  EditorMeshType[EditorMeshType["Torus"] = 6] = "Torus";
  EditorMeshType[EditorMeshType["Knot"] = 7] = "Knot";
  EditorMeshType[EditorMeshType["Ribbon"] = 8] = "Ribbon";
  EditorMeshType[EditorMeshType["Custom"] = 9] = "Custom";
  return EditorMeshType;
}({});
var MaterialEditor = /*#__PURE__*/function (_SceneEditor) {
  _inherits(MaterialEditor, _SceneEditor);
  var _super = _createSuper(MaterialEditor);
  function MaterialEditor(options) {
    var _this;
    _classCallCheck(this, MaterialEditor);
    _this = _super.call(this, options);
    _defineProperty(_assertThisInitialized(_this), "_zkMaterial", null);
    _defineProperty(_assertThisInitialized(_this), "_material", null);
    _defineProperty(_assertThisInitialized(_this), "_meshType", EditorMeshType.Box);
    _defineProperty(_assertThisInitialized(_this), "_mesh", null);
    _defineProperty(_assertThisInitialized(_this), "_materialCreatedListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_filesInput", null);
    return _this;
  }
  _createClass(MaterialEditor, [{
    key: "zkMaterial",
    get: function get() {
      return this._zkMaterial;
    }
  }, {
    key: "material",
    get: function get() {
      return this._material;
    }
  }, {
    key: "deleteComponents",
    value: function deleteComponents() {
      _get(_getPrototypeOf(MaterialEditor.prototype), "deleteComponents", this).call(this);
      this.deleteEditorMaterial();
      this.deleteEditorMesh();
    }
  }, {
    key: "deleteEditorMaterial",
    value: function deleteEditorMaterial() {
      if (this._material) {
        this._material.dispose();
        this._material = null;
        this.fireMaterialCreatedEvent();
      }
    }
  }, {
    key: "deleteEditorMesh",
    value: function deleteEditorMesh() {
      if (this._mesh) {
        this._mesh.dispose();
        this._mesh = null;
      }

      // Elimino tutte le mesh della scena
      if (this._scene && this._sceneHelper) {
        var meshes = this._sceneHelper.getSceneMeshes();
        meshes.forEach(function (m) {
          return m.dispose();
        });
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(MaterialEditor.prototype), "dispose", this).call(this);
    }
  }, {
    key: "createEmptySceneAsync",
    value: function () {
      var _createEmptySceneAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _get(_getPrototypeOf(MaterialEditor.prototype), "createEmptySceneAsync", this).call(this);
            case 2:
              this.createEditorMaterial(undefined, "Standard");
              _context.next = 5;
              return this.createEditorMeshAsync();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createEmptySceneAsync() {
        return _createEmptySceneAsync.apply(this, arguments);
      }
      return createEmptySceneAsync;
    }()
  }, {
    key: "createEditorMaterial",
    value: function createEditorMaterial(name, type, group) {
      var material = null;
      if (type != "ShaderMaterial") {
        material = _get(_getPrototypeOf(MaterialEditor.prototype), "createMaterial", this).call(this, name, type, group);
      } else {
        material = this.createShaderMaterial();
        if (material) {
          material.id = Zakeke.generateUUID();
          this.checkSceneEmptyEnvironmentTexture();
        }
      }
      this._material = material;
      this.setRenderingNeeded();
      this.fireMaterialCreatedEvent();
      return material;
    }
  }, {
    key: "applyEditorMaterial",
    value: function applyEditorMaterial() {
      if (this._material && this._mesh) this.applyMaterial(this._material, this._mesh);
    }
  }, {
    key: "replaceSceneAsync",
    value: function () {
      var _replaceSceneAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(newScene) {
        var jsonObj, rootUrl;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // Serializzo il materiale per la vecchia scena
              jsonObj = null;
              rootUrl = null;
              if (this._material && this._zkMaterial) {
                jsonObj = this._material.serialize();
                rootUrl = this._zkMaterial.get("rootUrl");
              }
              this.deleteScene();
              this._scene = newScene;
              _context2.next = 7;
              return this.setupSceneAsync();
            case 7:
              // Deserializzo il material sulla nuova scena
              if (jsonObj && rootUrl) {
                this._material = BABYLON.Material.Parse(jsonObj, this._scene, rootUrl);
                this.fireMaterialCreatedEvent();
              } else {
                this.createEditorMaterial(undefined, "Standard");
              }
              this.applyEditorMaterial();
              this.adjustCamera(false);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function replaceSceneAsync(_x) {
        return _replaceSceneAsync.apply(this, arguments);
      }
      return replaceSceneAsync;
    }()
  }, {
    key: "createShaderMaterial",
    value: function createShaderMaterial() {
      var material = null;
      if (this._scene && this._zkMaterial && this._zkMaterial.get("shaders")) {
        var name = this._zkMaterial.get("name") || "ShaderMaterial - " + Zakeke.makeID(5);
        var paths = {
          vertex: this._zkMaterial.get("shaders").get("name"),
          fragment: this._zkMaterial.get("shaders").get("name")
        };
        var options = {
          attributes: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Attribute),
          uniforms: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Uniform),
          samplers: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Sampler)
        };
        material = new BABYLON.ShaderMaterial(name, this._scene, paths, options);
        this.setupShaderMaterialCameraPosition(material);
      }
      return material;
    }
  }, {
    key: "createEditorMaterialFromJson",
    value: function createEditorMaterialFromJson(jsonText, rootUrl) {
      if (this._scene) {
        var jsonObj = JSON.parse(jsonText);
        this._material = BABYLON.Material.Parse(jsonObj, this._scene, rootUrl);
        if (this._material) this.setupShaderMaterialCameraPosition(this._material);
        this.checkSceneEmptyEnvironmentTexture();
        this.fireMaterialCreatedEvent();
      }
    }
  }, {
    key: "createEditorMeshAsync",
    value: function () {
      var _createEditorMeshAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this2 = this;
        var meshes, _meshes;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.deleteEditorMesh();
              _context3.t0 = this._meshType;
              _context3.next = _context3.t0 === EditorMeshType.Box ? 4 : _context3.t0 === EditorMeshType.RoundedBox ? 6 : _context3.t0 === EditorMeshType.Sphere ? 11 : _context3.t0 === EditorMeshType.Plane ? 13 : _context3.t0 === EditorMeshType.Cylinder ? 15 : _context3.t0 === EditorMeshType.RoundedCylinder ? 17 : _context3.t0 === EditorMeshType.Torus ? 22 : _context3.t0 === EditorMeshType.Knot ? 24 : _context3.t0 === EditorMeshType.Ribbon ? 26 : 28;
              break;
            case 4:
              this._mesh = this.createBox(null, "box");
              return _context3.abrupt("break", 28);
            case 6:
              _context3.next = 8;
              return this.createRoundedCubeAsync(null, "rounded box");
            case 8:
              meshes = _context3.sent;
              if (meshes.length == 1) this._mesh = meshes[0];else {
                this._mesh = this.createGroup(null, "rounded box group", meshes);
              }
              return _context3.abrupt("break", 28);
            case 11:
              this._mesh = this.createSphere(null, "sphere");
              return _context3.abrupt("break", 28);
            case 13:
              this._mesh = this.createPlane(null, "plane");
              return _context3.abrupt("break", 28);
            case 15:
              this._mesh = this.createCylinder(null, "cylinder");
              return _context3.abrupt("break", 28);
            case 17:
              _context3.next = 19;
              return this.createRoundedCylinderAsync(null, "rounded cylinder");
            case 19:
              _meshes = _context3.sent;
              if (_meshes.length == 1) this._mesh = _meshes[0];else {
                this._mesh = this.createGroup(null, "rounded cylinder group");
                _meshes.forEach(function (m) {
                  return m.parent = _this2._mesh;
                });
              }
              return _context3.abrupt("break", 28);
            case 22:
              this._mesh = this.createTorus(null, "torus");
              return _context3.abrupt("break", 28);
            case 24:
              this._mesh = this.createKnot(null, "knot");
              return _context3.abrupt("break", 28);
            case 26:
              this._mesh = this.createRibbon(null, "ribbon");
              return _context3.abrupt("break", 28);
            case 28:
              this.applyEditorMaterial();
              this.adjustCamera(false);
            case 30:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createEditorMeshAsync() {
        return _createEditorMeshAsync.apply(this, arguments);
      }
      return createEditorMeshAsync;
    }()
  }, {
    key: "setEditorMeshType",
    value: function () {
      var _setEditorMeshType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(meshType) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this._meshType = meshType;
              _context4.next = 3;
              return this.createEditorMeshAsync();
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function setEditorMeshType(_x2) {
        return _setEditorMeshType.apply(this, arguments);
      }
      return setEditorMeshType;
    }()
  }, {
    key: "updateMaterialModelAsync",
    value: function () {
      var _updateMaterialModelAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, name, json;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(this._zkMaterial && this._material && this._sceneHelper)) {
                _context5.next = 9;
                break;
              }
              _context5.next = 3;
              return this._sceneHelper.takeMaterialScreenshotAsync(this._material.id, 500, 450);
            case 3:
              data = _context5.sent;
              this._zkMaterial.set("imageData", data);
              name = this._zkMaterial.get("name");
              if (name && name != this._material.name) this._material.name = name;
              json = this.getEditorMaterialJson();
              if (json) this._zkMaterial.set("JSON", json);
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateMaterialModelAsync() {
        return _updateMaterialModelAsync.apply(this, arguments);
      }
      return updateMaterialModelAsync;
    }()
  }, {
    key: "getEditorMaterialJson",
    value: function getEditorMaterialJson() {
      if (this._scene && this._sceneHelper && this._material) {
        var sceneHelper = this._sceneHelper;

        // Sistemo il nome delle texture che deve essere relativo al root path
        // .../materialID/textures/materialID/filename.xxx
        this._scene.textures.forEach(function (txt) {
          if (sceneHelper.isTextureWithUrl(txt)) {
            if (txt.url) {
              var idx = txt.url.lastIndexOf("/");
              if (idx !== -1) {
                idx = txt.url.lastIndexOf("/", idx - 1);
                if (idx !== -1) {
                  idx = txt.url.lastIndexOf("/", idx - 1);
                  if (idx != -1) {
                    var newName = txt.url.substring(idx + 1);
                    txt.name = newName;
                    txt.url = txt.name;
                  }
                }
              }
            }
          }
        });
        var jsonObj = this._material.serialize();
        var json = JSON.stringify(jsonObj);
        return json;
      }
      return null;
    }
  }, {
    key: "setMaterialModel",
    value: function setMaterialModel(zkMaterial, type) {
      this._zkMaterial = zkMaterial;
      this.deleteEditorMaterial();
      if (this._zkMaterial && this._zkMaterial instanceof Zakeke.Material) {
        var materialShaders = this._zkMaterial.get("shaders");
        if (materialShaders) {
          var name = materialShaders.get("name");
          var vertex = materialShaders.get("vertex");
          var fragment = materialShaders.get("fragment");
          if (name && vertex && fragment) {
            this.setupShadersStore({
              name: name,
              vertex: vertex,
              fragment: fragment
            });
          }
        }
        var jsonText = this._zkMaterial.get("JSON");
        var rootUrl = this._zkMaterial.get("rootUrl");
        if (jsonText && rootUrl) this.createEditorMaterialFromJson(jsonText, rootUrl);else this.createEditorMaterial(this._zkMaterial.get("name") || undefined, type);
        if (this._material) this._material.id = this._zkMaterial.getMaterialID();
      } else this.createEditorMaterial(undefined, type);
      this.applyEditorMaterial();
      this.adjustCamera(false);
      this.setupShaderMaterialsCameraPosition();
    }
  }, {
    key: "getTexturesUploadUrl",
    value: function getTexturesUploadUrl(materialID) {
      if (this._zkMaterial) return this._zkMaterial.getTexturesUrl();
      return "";
    }
  }, {
    key: "loadEditorMaterialTextureFiles__",
    value: function loadEditorMaterialTextureFiles__(filesToLoad, type, onSuccess, onError) {
      this.loadTextureFiles(filesToLoad, this._material, type, onSuccess, onError);
    }
  }, {
    key: "loadEditorMaterialTextureFiles",
    value: function loadEditorMaterialTextureFiles(filesToLoad, type, onSuccess, onError) {
      var _this3 = this;
      if (!this._material) return;
      var getExtension = function getExtension(name) {
        var idx = name.lastIndexOf(".");
        if (idx !== -1) {
          var ext = name.substring(idx);
          return ext;
        }
      };
      var isCubeImage = function isCubeImage(name, suffix) {
        var idx = name.lastIndexOf(".");
        if (idx !== -1) {
          var nameWithoutExt = name.substring(0, idx);
          return nameWithoutExt.endsWith("_" + suffix);
        }
        return false;
      };
      if (!filesToLoad || filesToLoad.length == 0) return;
      var isCubemap = this.canLoadCubemap(this._material, type) && (filesToLoad.length == 6 || getExtension(filesToLoad[0].name) == ".dds" || getExtension(filesToLoad[0].name) == ".hdr");
      var files = [];
      if (isCubemap && filesToLoad.length == 6) {
        // verfico che ci siano tutte le estensioni accettate dalla cubemap
        var suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
        for (var k = 0; k < filesToLoad.length; k++) {
          var file = filesToLoad[k];
          var lastIdx = -1;
          for (var i = 0; i < suffixes.length; i++) {
            if (isCubeImage(file.name, suffixes[i])) {
              files.push(file);
              lastIdx = i;
              break;
            }
          }
          if (lastIdx !== -1) suffixes.splice(lastIdx, 1);
        }
        if (suffixes.length != 0) {
          var msg = "Immagini per la cube map non valide";
          if (onError) onError(msg);
          Logger.info(msg);
          return;
        }
      } else {
        // Carico solo la prima selezionata
        files.push(filesToLoad[0]);
      }

      // Upload

      var data = new FormData();
      for (var _i = 0; _i < files.length; _i++) {
        data.append('file-' + _i, files[_i]);
      }
      jQuery.ajax({
        url: this.getTexturesUploadUrl(this._material.id),
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        type: 'POST',
        success: function success(data) {
          if (Object.prototype.toString.call(data) === '[object Array]') {
            if (isCubemap) _this3.setEditorMaterialCubeTextureImages(data, type);else _this3.setEditorMaterialTextureImage(data[0], type);
          }
          if (onSuccess) onSuccess();
        },
        error: function error(xhr, textStatus, errorThrown) {
          var msg = "An error occurred: " + textStatus + "nError: " + errorThrown;
          if (onError) onError(msg);
        }
      });
    }
  }, {
    key: "setEditorMaterialTextureImage",
    value: function setEditorMaterialTextureImage(textureImage, type) {
      if (this._scene && this._zkMaterial && this._material && textureImage && textureImage.imageUrl && textureImage.fileObjectID) {
        // salvo i dati dell'immagine con il materiale
        var item = new Zakeke.MaterialTextureImage();
        item.set("textureImageID", Zakeke.generateUUID());
        item.set("fileObjectID", textureImage.fileObjectID);
        item.set("imageUrl", textureImage.imageUrl);
        this._zkMaterial.get("textureImages").push(item);
        var url = textureImage.imageUrl;
        var texture = new BABYLON.Texture(url, this._scene);
        var oldTexture = this.getMaterialTexture(this._material, type);
        if (oldTexture && oldTexture instanceof BABYLON.Texture) {
          texture.uScale = oldTexture.uScale;
          texture.vScale = oldTexture.vScale;
          texture.uOffset = oldTexture.uOffset;
          texture.vOffset = oldTexture.vOffset;
          texture.uAng = oldTexture.uAng;
          texture.vAng = oldTexture.vAng;
          texture.level = oldTexture.level;
          texture.coordinatesIndex = oldTexture.coordinatesIndex;
          texture.coordinatesMode = oldTexture.coordinatesMode;
          texture.hasAlpha = oldTexture.hasAlpha;
          texture.wrapU = oldTexture.wrapU;
          texture.wrapV = oldTexture.wrapV;
        }
        this.applyTexture(texture, this._material, type);
        if (oldTexture && !this.isTextureUsed(oldTexture)) oldTexture.dispose();
      }
    }
  }, {
    key: "setEditorMaterialCubeTextureImages",
    value: function setEditorMaterialCubeTextureImages(textureImages, type) {
      var _this4 = this;
      if (!this._scene || !this._zkMaterial || !this._material || Object.prototype.toString.call(textureImages) != '[object Array]') return;
      var texture = null;
      var onImagesLoad = function onImagesLoad() {
        return _this4.setRenderingNeeded();
      };
      if (textureImages.length == 1) {
        var textureImage = textureImages[0];
        if (textureImage.imageUrl && textureImage.fileObjectID) {
          if (textureImage.imageUrl.endsWith(".dds")) texture = BABYLON.CubeTexture.CreateFromPrefilteredData(textureImage.imageUrl, this._scene);else if (textureImage.imageUrl.endsWith(".hdr")) texture = new BABYLON.HDRCubeTexture(textureImage.imageUrl, this._scene, 512, undefined, undefined, undefined, undefined, onImagesLoad);

          // salvo i dati dell'immagine con il materiale
          var item = new Zakeke.MaterialTextureImage();
          item.set("textureImageID", Zakeke.generateUUID());
          item.set("fileObjectID", textureImage.fileObjectID);
          item.set("imageUrl", textureImage.imageUrl);
          this._zkMaterial.get("textureImages").push(item);
        }
      } else if (textureImages.length == 6) {
        var suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
        var rootUrl = "";
        var files = [];
        var extensions = [];
        var containsSuffix = function containsSuffix(name, suffix) {
          var idx = name.lastIndexOf(".");
          if (idx !== -1) {
            var nameWithoutExt = name.substring(0, idx);
            return nameWithoutExt.endsWith("_" + suffix);
          }
          return false;
        };
        var getRootUrl = function getRootUrl(url, suffix) {
          var idx = url.lastIndexOf(".");
          if (idx !== -1) {
            var nameWithoutExt = url.substring(0, idx);
            if (nameWithoutExt.endsWith("_" + suffix)) {
              var _rootUrl = nameWithoutExt.substring(0, nameWithoutExt.length - ("_" + suffix).length);
              return _rootUrl;
            }
          }
          return null;
        };
        var getFileExtension = function getFileExtension(url, suffix) {
          var idx = url.lastIndexOf("_" + suffix);
          if (idx !== -1) {
            return url.substr(idx);
          }
          return null;
        };
        for (var i = 0; i < suffixes.length; i++) {
          var suffix = suffixes[i];
          for (var k = 0; k < textureImages.length; k++) {
            var _textureImage = textureImages[k];
            var url = _textureImage.imageUrl;
            if (url && containsSuffix(url, suffix)) {
              files.push(url);
              extensions.push(getFileExtension(url, suffix));
              if (!rootUrl) rootUrl = getRootUrl(url, suffix);
              break;
            }
          }
        }

        // salvo i dati delle immagini con il materiale
        for (var _i2 = 0; _i2 < textureImages.length; _i2++) {
          var _textureImage2 = textureImages[_i2];
          if (_textureImage2.imageUrl && _textureImage2.fileObjectID != undefined) {
            var imageUrl = _textureImage2.imageUrl;
            var fileObjectID = _textureImage2.fileObjectID;
            var _item = new Zakeke.MaterialTextureImage();
            _item.set("textureImageID", Zakeke.generateUUID());
            _item.set("fileObjectID", fileObjectID);
            _item.set("imageUrl", imageUrl);
            this._zkMaterial.get("textureImages").push(_item);
          }
        }

        //CubeTexture(rootUrl, scene, extensions, noMipmap, files
        texture = new BABYLON.CubeTexture(rootUrl, this._scene, extensions, false, files);
      }
      if (texture) {
        var oldTexture = this.getMaterialTexture(this._material, type);
        this.applyTexture(texture, this._material, type);
        if (oldTexture && !this.isTextureUsed(oldTexture)) oldTexture.dispose();
      }
    }

    // -------------------------------------------------------------
    // Events
    // -------------------------------------------------------------
  }, {
    key: "fireMaterialCreatedEvent",
    value: function fireMaterialCreatedEvent() {
      for (var i = 0; i < this._materialCreatedListeners.length; ++i) {
        this._materialCreatedListeners[i]();
      }
    }
  }, {
    key: "addMaterialCreatedListener",
    value: function addMaterialCreatedListener(listenerFunction) {
      this._materialCreatedListeners.push(listenerFunction);
    }

    //#region Load Custom Mesh
  }, {
    key: "loadFiles",
    value: function loadFiles(event, onSuccess, onError) {
      var _this5 = this;
      if (!this._engine || !this._scene || !this._sceneHelper) return;
      var engine = this._engine;
      var scene = this._scene;
      var sceneHelper = this._sceneHelper;
      if (!this._filesInput) {
        this._filesInput = new BABYLON.FilesInput(engine, scene, /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(sceneFile, babylonScene) {
            var meshes;
            return _regeneratorRuntime().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return _this5.replaceSceneAsync(babylonScene);
                case 2:
                  meshes = sceneHelper.getSceneMeshes(); // Raggruppo tutte le mesh
                  _this5._meshType = EditorMeshType.Custom;
                  _this5._mesh = _this5.createGroup(null, "group", meshes);
                  _this5.applyEditorMaterial();
                  if (onSuccess) onSuccess();
                case 7:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          return function (_x3, _x4) {
            return _ref.apply(this, arguments);
          };
        }(), null,
        //(progress: BABYLON.SceneLoaderProgressEvent) => { }, // progressCallback
        null,
        //() => { },  // additionalRenderLoopLogicCallback
        null,
        //(remaining: number) => { }, // textureLoadingCallback
        null,
        //(files?: File[]) => { },  // startingProcessingFilesCallback
        null,
        //(sceneFile: File) => { }, // onReloadCallback
        function (sceneFile, babylonScene, message) {
          // errorCallback
          if (onError) onError(message);
        });
      }
      if (this._filesInput) this._filesInput.loadFiles(event);
    }
    //#endregion 
  }], [{
    key: "createMaterialEditorAsync",
    value: function () {
      var _createMaterialEditorAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(options) {
        var editor;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!options) {
                options = {
                  showGround: false,
                  editorBackgroundColor: "#33334c",
                  showHighlight: false
                };
              }
              editor = new MaterialEditor(options);
              _context7.next = 4;
              return editor.initAsync();
            case 4:
              return _context7.abrupt("return", editor);
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function createMaterialEditorAsync(_x5) {
        return _createMaterialEditorAsync.apply(this, arguments);
      }
      return createMaterialEditorAsync;
    }()
  }]);
  return MaterialEditor;
}(_SceneEditor__WEBPACK_IMPORTED_MODULE_0__.SceneEditor);

/***/ }),

/***/ "../../3D/src/Viewers/SceneEditor.ts":
/*!*******************************************!*\
  !*** ../../3D/src/Viewers/SceneEditor.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MaterialGroup": () => (/* binding */ MaterialGroup),
/* harmony export */   "SceneEditor": () => (/* binding */ SceneEditor),
/* harmony export */   "SourceTaskStatus": () => (/* binding */ SourceTaskStatus)
/* harmony export */ });
/* harmony import */ var _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Components/Environment/EnvironmentManager */ "../../3D/src/Components/Environment/EnvironmentManager.ts");
/* harmony import */ var _Components_IncrementalFiles_IncrementalFiles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Components/IncrementalFiles/IncrementalFiles */ "../../3D/src/Components/IncrementalFiles/IncrementalFiles.ts");
/* harmony import */ var _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Components/MaterialsPreview/MaterialsPreview */ "../../3D/src/Components/MaterialsPreview/MaterialsPreview.ts");
/* harmony import */ var _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Components/SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
/* harmony import */ var _Components_SceneToBlobs_SceneToBlobs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Components/SceneToBlobs/SceneToBlobs */ "../../3D/src/Components/SceneToBlobs/SceneToBlobs.ts");
/* harmony import */ var _Enumerations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Enumerations */ "../../3D/src/Enumerations.ts");
/* harmony import */ var _Helpers_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Helpers/utils */ "../../3D/src/Helpers/utils.ts");
/* harmony import */ var _Layers_AxesLayer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Layers/AxesLayer */ "../../3D/src/Layers/AxesLayer.ts");
/* harmony import */ var _Layers_LightsLayer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Layers/LightsLayer */ "../../3D/src/Layers/LightsLayer.ts");
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
/* harmony import */ var _SceneViewer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./SceneViewer */ "../../3D/src/Viewers/SceneViewer.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }











var MaterialGroup = /*#__PURE__*/_createClass(function MaterialGroup(groupName) {
  _classCallCheck(this, MaterialGroup);
  _defineProperty(this, "materials", []);
  _defineProperty(this, "guid", Zakeke.generateUUID());
  this.groupName = groupName;
});
var SourceTaskStatus = /*#__PURE__*/function (SourceTaskStatus) {
  SourceTaskStatus[SourceTaskStatus["uploading"] = 0] = "uploading";
  SourceTaskStatus[SourceTaskStatus["progress"] = 1] = "progress";
  SourceTaskStatus[SourceTaskStatus["checking"] = 2] = "checking";
  SourceTaskStatus[SourceTaskStatus["success"] = 3] = "success";
  SourceTaskStatus[SourceTaskStatus["completed_success"] = 4] = "completed_success";
  SourceTaskStatus[SourceTaskStatus["completed_error"] = 5] = "completed_error";
  return SourceTaskStatus;
}({});
var SceneEditor = /*#__PURE__*/function (_SceneViewer) {
  _inherits(SceneEditor, _SceneViewer);
  var _super = _createSuper(SceneEditor);
  function SceneEditor(options) {
    var _this;
    _classCallCheck(this, SceneEditor);
    _this = _super.call(this, {
      configPreview: true
    });
    _defineProperty(_assertThisInitialized(_this), "_dracoEnabled", true);
    // Sets the desired encoding and decoding speed for the given options.
    //
    //  0 = slowest speed, but the best compression.
    // 10 = fastest, but the worst compression.
    // -1 = undefined.
    //
    // Note that both speed options affect the encoder choice of used methods and
    // algorithms. For example, a requirement for fast decoding may prevent the
    // encoder from using the best compression methods even if the encoding speed
    // is set to 0. In general, the faster of the two options limits the choice of
    // features that can be used by the encoder. Additionally, setting
    // |decoding_speed| to be faster than the |encoding_speed| may allow the
    // encoder to choose the optimal method out of the available features for the
    // given |decoding_speed|.
    _defineProperty(_assertThisInitialized(_this), "_dracoEncodingSpeed", 5);
    _defineProperty(_assertThisInitialized(_this), "_dracoDecodingSpeed", 5);
    _defineProperty(_assertThisInitialized(_this), "_envMode", _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor);
    _defineProperty(_assertThisInitialized(_this), "_selectOnPick", true);
    _defineProperty(_assertThisInitialized(_this), "_showBoundingBox", false);
    _defineProperty(_assertThisInitialized(_this), "_editorBackgroundColor", "#444444");
    _defineProperty(_assertThisInitialized(_this), "_showGround", true);
    _defineProperty(_assertThisInitialized(_this), "_ground", null);
    _defineProperty(_assertThisInitialized(_this), "_showLights", false);
    _defineProperty(_assertThisInitialized(_this), "_lightsLayer", null);
    _defineProperty(_assertThisInitialized(_this), "_showAxes", false);
    _defineProperty(_assertThisInitialized(_this), "_axesLayer", null);
    _defineProperty(_assertThisInitialized(_this), "_showHighlight", true);
    _defineProperty(_assertThisInitialized(_this), "_highlightOver", true);
    _defineProperty(_assertThisInitialized(_this), "_highlightOverColor", "#0082ff");
    _defineProperty(_assertThisInitialized(_this), "_editingMode", _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EditingMode.None);
    _defineProperty(_assertThisInitialized(_this), "_manipulatedNode", null);
    _defineProperty(_assertThisInitialized(_this), "_oldManipulatedNode", null);
    _defineProperty(_assertThisInitialized(_this), "_EditControl", org.ssatguru.babylonjs.component.EditControl);
    _defineProperty(_assertThisInitialized(_this), "_editControl", null);
    _defineProperty(_assertThisInitialized(_this), "_editControlVisible", false);
    _defineProperty(_assertThisInitialized(_this), "_shiftPressed", false);
    _defineProperty(_assertThisInitialized(_this), "_ctrlPressed", false);
    _defineProperty(_assertThisInitialized(_this), "_realMeshVisibility", {});
    _defineProperty(_assertThisInitialized(_this), "_sceneSourceTasks", []);
    _defineProperty(_assertThisInitialized(_this), "_isLoadingSourceFiles", false);
    // Per gli eventi
    _defineProperty(_assertThisInitialized(_this), "_preUpdateListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_postUpdateListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_meshSelectedListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_selectionChangedListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_lightSelectedListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_sceneCreatedListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_cameraLocationCreatedListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_sceneSourceTaskSuccessListeners", []);
    // Per comunicare che l'importazione dei file ha avuto successo
    _defineProperty(_assertThisInitialized(_this), "_sceneSourceTaskErrorListeners", []);
    // Per notificare che l'importazione dei file è andata in errore
    _defineProperty(_assertThisInitialized(_this), "_sceneSourceTasksCheckListeners", []);
    // Eseguita ad ogni tick/controllo della task per avere l'elenco aggiornato delle tasks
    _defineProperty(_assertThisInitialized(_this), "_meshesUpdateListeners", []);
    // Quando qualcosa nella struttura delle mesh cambia, oppure cambia una singola mesh
    _defineProperty(_assertThisInitialized(_this), "_materialsUpdateListeners", []);
    // Quando qualcosa nella struttura del materiali cambia, oppure un singolo materiale
    _defineProperty(_assertThisInitialized(_this), "_lightsUpdateListeners", []);
    // Quando qualcosa nella struttura delle luci cambia, oppure una singola luce
    _defineProperty(_assertThisInitialized(_this), "_cameraLocationsUpdateListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_meshLocationCreatedListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_meshLocationsUpdateListeners", []);
    _defineProperty(_assertThisInitialized(_this), "_arTaskSuccessListeners", []);
    // Per comunicare che la conversione dei file per AR ha avuto successo
    _defineProperty(_assertThisInitialized(_this), "_arTaskErrorListeners", []);
    // Per notificare che la conversione dei file per AR è andata in errore
    _defineProperty(_assertThisInitialized(_this), "_arTasksCheckListeners", []);
    // Eseguita ad ogni tick/controllo del task per avere l'elenco aggiornato dei tasks
    // Materiali iniziali
    _defineProperty(_assertThisInitialized(_this), "_initialMeshMaterials", {});
    // hash meshID -> materialID
    _defineProperty(_assertThisInitialized(_this), "_initialSubMeshMaterials", {});
    // hash subMeshID -> materialID
    // Ultimi material applicati
    _defineProperty(_assertThisInitialized(_this), "_lastMeshMaterials", {});
    // hash meshID -> materialID
    _defineProperty(_assertThisInitialized(_this), "_lastSubMeshMaterials", {});
    // hash subMeshID -> materialID
    _defineProperty(_assertThisInitialized(_this), "_meshOver", null);
    _defineProperty(_assertThisInitialized(_this), "_incrementalFilesMaker", null);
    _defineProperty(_assertThisInitialized(_this), "_sceneToBlobs", null);
    if (options) {
      if (options.showGround != undefined && options.showGround != null) _this._showGround = options.showGround;
      if (options.editorBackgroundColor !== undefined && options.editorBackgroundColor !== null) _this._editorBackgroundColor = options.editorBackgroundColor;
      if (options.showHighlight !== undefined && options.showHighlight !== null) _this._showHighlight = options.showHighlight;
      if (options.highlightColor !== undefined && options.highlightColor !== null) _this._highlightColor = options.highlightColor;
      if (options.highlightOver !== undefined && options.highlightOver != null) _this._highlightOver = options.highlightOver;
      if (options.highlightOverColor !== undefined && options.highlightOverColor != null) _this._highlightOverColor = options.highlightOverColor;
    }
    return _this;
  }
  _createClass(SceneEditor, [{
    key: "realMeshVisibility",
    get:
    // Real mesh visibility
    function get() {
      return this._realMeshVisibility;
    }

    // Environemnt manager
  }, {
    key: "environmentManager",
    get: function get() {
      return this._environmentManager;
    }

    // EnvMode
  }, {
    key: "envMode",
    get: function get() {
      return this._envMode;
    }

    // Source tasks
    ,
    set: function set(value) {
      if (this._envMode != value) {
        this._envMode = value;
        this.refreshEnvironment();
      }
    }

    // SelectOnPick
  }, {
    key: "sceneSourceTasks",
    get: function get() {
      return this._sceneSourceTasks;
    }
  }, {
    key: "selectOnPick",
    get: function get() {
      return this._selectOnPick;
    }
  }, {
    key: "seletOnPick",
    set: function set(value) {
      if (this._selectOnPick != value) this._selectOnPick = value;
    }

    // ShowBoundingBox
  }, {
    key: "showBoundingBox",
    get: function get() {
      return this._showBoundingBox;
    },
    set: function set(value) {
      if (this._showBoundingBox != value) {
        this._showBoundingBox = value;
        this.updateBoundingBox();
        this.setRenderingNeeded();
      }
    }

    // EditorBackgroundColor
  }, {
    key: "editorBackgroundColor",
    get: function get() {
      return this._editorBackgroundColor;
    },
    set: function set(value) {
      if (this._editorBackgroundColor != value) {
        this.setEditorBackgroundColor(value);
      }
    }

    // ShowGround
  }, {
    key: "showGround",
    get: function get() {
      return this._showGround;
    },
    set: function set(value) {
      if (this._showGround != value) {
        this._showGround = value;
        this.refreshGround();
      }
    }

    // ShowLights
  }, {
    key: "showLights",
    get: function get() {
      return this._showLights;
    },
    set: function set(value) {
      if (this._showLights != value) {
        this._showLights = value;
        if (this._lightsLayer) this._lightsLayer.refresh();
        this.setRenderingNeeded();
      }
    }

    // ShowAxes
  }, {
    key: "showAxes",
    get: function get() {
      return this._showAxes;
    },
    set: function set(value) {
      if (this._showAxes != value) {
        this._showAxes = value;
        if (this._axesLayer) this._axesLayer.refresh();
        this.setRenderingNeeded();
      }
    }

    // ShowHighlight
  }, {
    key: "showHighlight",
    get: function get() {
      return this._showHighlight;
    },
    set: function set(value) {
      if (this._showHighlight != value) {
        this._showHighlight = value;
      }
    }

    // HighlightOver
  }, {
    key: "highlightOver",
    get: function get() {
      return this._highlightOver;
    },
    set: function set(value) {
      if (this._highlightOver != value) {
        this._highlightOver = value;
      }
    }

    // HighlightOverColor
  }, {
    key: "highlightOverColor",
    get: function get() {
      return this._highlightOverColor;
    },
    set: function set(value) {
      if (this._highlightOverColor != value) {
        this._highlightOverColor = value;
      }
    }

    // EditingMode
  }, {
    key: "editingMode",
    get: function get() {
      return this._editingMode;
    },
    set: function set(value) {
      if (this._editingMode != value) {
        this.setEditingMode(value);
      }
    }

    // EditingControlVisible
  }, {
    key: "editControlVisible",
    get: function get() {
      return this._editControlVisible;
    },
    set: function set(value) {
      if (this._editControlVisible != value) {
        this.showHideEditControl(value);
      }
    }
  }, {
    key: "createCanvas",
    value: function createCanvas() {
      var _this2 = this;
      var canvas = _get(_getPrototypeOf(SceneEditor.prototype), "createCanvas", this).call(this);
      canvas.addEventListener("keydown", function (e) {
        _this2._shiftPressed = e.key == "Shift";
        _this2._ctrlPressed = e.key == "Control";
      }, false);
      canvas.addEventListener("keyup", function (e) {
        _this2._shiftPressed = !(e.key == "Shift");
        _this2._ctrlPressed = !(e.key == "Control");
      }, false);
      canvas.addEventListener("dblclick", function (e) {
        _this2.setRenderingNeeded();
      });
      return canvas;
    }
  }, {
    key: "deleteComponents",
    value: function deleteComponents() {
      _get(_getPrototypeOf(SceneEditor.prototype), "deleteComponents", this).call(this);
      if (this._editControl) {
        this._editControl.detach();
        this._editControl = null;
      }
      if (this._lightsLayer) {
        this._lightsLayer.dispose();
        this._lightsLayer = null;
      }
      if (this._axesLayer) {
        this._axesLayer.dispose();
        this._axesLayer = null;
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(SceneEditor.prototype), "dispose", this).call(this);
      if (this._incrementalFilesMaker) {
        this._incrementalFilesMaker.dispose();
        delete this._incrementalFilesMaker;
      }
      if (this._sceneToBlobs) {
        this._sceneToBlobs.dispose();
        delete this._sceneToBlobs;
      }
      // ...
    }
  }, {
    key: "createEngine",
    value: function createEngine() {
      _get(_getPrototypeOf(SceneEditor.prototype), "createEngine", this).call(this);

      // Forzo il caricamento totale per i file incrementali
      BABYLON.SceneLoader.ForceFullSceneLoadingForIncremental = true;
    }
  }, {
    key: "createEmptySceneAsync",
    value: function () {
      var _createEmptySceneAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _get(_getPrototypeOf(SceneEditor.prototype), "createEmptySceneAsync", this).call(this);
            case 2:
              if (this._engine) {
                this.fireSceneCreatedEvent();
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createEmptySceneAsync() {
        return _createEmptySceneAsync.apply(this, arguments);
      }
      return createEmptySceneAsync;
    }()
  }, {
    key: "setupSceneAsync",
    value: function () {
      var _setupSceneAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _get(_getPrototypeOf(SceneEditor.prototype), "setupSceneAsync", this).call(this);
            case 2:
              if (this._engine && this._scene) {
                this._scene.setRenderingAutoClearDepthStencil(1, true, true, false);
                this._scene.setRenderingAutoClearDepthStencil(2, true, true, false);
                this._lightsLayer = new _Layers_LightsLayer__WEBPACK_IMPORTED_MODULE_8__.LightsLayer(this);
                this._lightsLayer.addLightSelectedListener(function (event) {
                  _this3.lightsLayer_onLightSelected(event);
                });
                this.setupAxes();
                if (this._zkModel && this._meshLocationsManager) {
                  this._meshLocationsManager.addBeforeSaveMeshLocationListener(function () {
                    return _this3.onBeforeSaveMeshLocation();
                  });
                  this._meshLocationsManager.addAfterSaveMeshLocationListener(function () {
                    return _this3.onAfterSaveMeshLocation();
                  });
                }
                this._scene.onPointerMove = function (evt, pickInfo) {
                  return _this3.onPointerMove(evt, pickInfo);
                };
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function setupSceneAsync() {
        return _setupSceneAsync.apply(this, arguments);
      }
      return setupSceneAsync;
    }()
  }, {
    key: "render",
    value: function render() {
      this.firePreUpdateEvent();
      _get(_getPrototypeOf(SceneEditor.prototype), "render", this).call(this);
      if (this._lightsLayer) this._lightsLayer.render();
      if (this._axesLayer) this._axesLayer.render();
      this.firePostUpdateEvent();
    }
  }, {
    key: "deleteHighlightLayer",
    value: function deleteHighlightLayer() {
      if (this._highlightLayer) {
        this._highlightLayer.dispose();
        this._highlightLayer = null;
      }
      this.setRenderingNeeded();
    }
  }, {
    key: "setupAntialiasPostProcesses",
    value: function setupAntialiasPostProcesses() {
      if (this.antialias && this.getAntialiasEnabled()) {
        this.createAntialiasPostProcesses();
        this.disableAntialiasing();
      }
    }
  }, {
    key: "canEnableAntialiasing",
    value: function canEnableAntialiasing() {
      return this._scene && this._antialias && this.getAntialiasEnabled() && this.envMode === _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Viewer;
    }
  }, {
    key: "setupHighlightLayerIntensity",
    value: function setupHighlightLayerIntensity() {
      if (this._highlightLayer) {
        this._highlightLayer.blurHorizontalSize = this._highlightBlurHorizontalSize;
        this._highlightLayer.blurVerticalSize = this._highlightBlurVerticalSize;
      }
    }
  }, {
    key: "setupAxes",
    value: function setupAxes() {
      this._axesLayer = new _Layers_AxesLayer__WEBPACK_IMPORTED_MODULE_7__.AxesLayer(this);
    }
  }, {
    key: "getMatchSameNameTextures",
    value: function getMatchSameNameTextures() {
      if (this._zkScene) {
        var val = this._zkScene.getMatchSameNameTextures();
        if (val === undefined || val === null) return false;
        return val;
      }
      return false;
    }
  }, {
    key: "setMatchSameNameTextures",
    value: function setMatchSameNameTextures(value) {
      if (this._zkScene) {
        this._zkScene.setMatchSameNameTextures(value);
      }
    }
  }, {
    key: "getAREnabled",
    value: function getAREnabled() {
      var def = false;
      if (this._zkScene) {
        var val = this._zkScene.getAREnabled();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setAREnabled",
    value: function setAREnabled(value) {
      if (this._zkScene) {
        this._zkScene.setAREnabled(value);
      }
    }
  }, {
    key: "getArOnTheFly",
    value: function getArOnTheFly() {
      var def = false;
      if (this._zkScene) {
        var val = this._zkScene.getArOnTheFly();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setArOnTheFly",
    value: function setArOnTheFly(value) {
      if (this._zkScene) {
        this._zkScene.setArOnTheFly(value);
      }
    }
  }, {
    key: "getTryOnEnabled",
    value: function getTryOnEnabled() {
      var def = false;
      if (this._zkScene) {
        var val = this._zkScene.getTryOnEnabled();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setTryOnEnabled",
    value: function setTryOnEnabled(value) {
      if (this._zkScene) {
        this._zkScene.setTryOnEnabled(value);
      }
    }
  }, {
    key: "getUseDelayedMaterialLoading",
    value: function getUseDelayedMaterialLoading() {
      var def = false;
      if (this.zkScene) {
        var val = this.zkScene.getUseDelayedMaterialLoading();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setUseDelayedMaterialLoading",
    value: function setUseDelayedMaterialLoading(value) {
      if (this._zkScene) {
        this._zkScene.setUseDelayedMaterialLoading(value);
      }
    }
  }, {
    key: "getUseDelayedTextureLoading",
    value: function getUseDelayedTextureLoading() {
      var def = false;
      if (this._zkScene) {
        var val = this._zkScene.getUseDelayedTextureLoading();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setUseDelayedTextureLoading",
    value: function setUseDelayedTextureLoading(value) {
      if (this._zkScene) {
        this._zkScene.setUseDelayedTextureLoading(value);
      }
    }
  }, {
    key: "getGlowEnabled",
    value: function getGlowEnabled() {
      if (this._glowManager) return this._glowManager.enabled;
      return false;
    }
  }, {
    key: "setGlowEnabled",
    value: function setGlowEnabled(enabled) {
      if (this._glowManager) {
        this._glowManager.enabled = enabled;
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "getGlowIntensity",
    value: function getGlowIntensity() {
      if (this._glowManager) return this._glowManager.intensity;
      return 1;
    }
  }, {
    key: "setGlowIntensity",
    value: function setGlowIntensity(intensity) {
      if (this._glowManager) {
        this._glowManager.intensity = intensity;
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "getGlowBlurSize",
    value: function getGlowBlurSize() {
      if (this._glowManager) return this._glowManager.blurSize;
      return 16;
    }
  }, {
    key: "setGlowBlurSize",
    value: function setGlowBlurSize(blurSize) {
      if (this._glowManager) {
        this._glowManager.blurSize = blurSize;
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "getInfoPointsEnabled",
    value: function getInfoPointsEnabled() {
      var def = false;
      if (this._zkScene) {
        var val = this._zkScene.getInfoPointsEnabled();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setInfoPointsEnabled",
    value: function setInfoPointsEnabled(value) {
      if (this._zkScene) {
        this._zkScene.setInfoPointsEnabled(value);
      }
      this.refreshInfoPoints();
    }
  }, {
    key: "getInfoPointsBorderColor",
    value: function getInfoPointsBorderColor() {
      var def = "";
      if (this._zkScene) {
        var val = this._zkScene.getInfoPointsBorderColor();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setInfoPointsBorderColor",
    value: function setInfoPointsBorderColor(value) {
      if (this._zkScene) {
        this._zkScene.setInfoPointsBorderColor(value);
        this.refreshInfoPoints();
      }
    }
  }, {
    key: "getInfoPointsInnerPointColor",
    value: function getInfoPointsInnerPointColor() {
      var def = "";
      if (this._zkScene) {
        var val = this._zkScene.getInfoPointsInnerPointColor();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setInfoPointsInnerPointColor",
    value: function setInfoPointsInnerPointColor(value) {
      if (this._zkScene) {
        this._zkScene.setInfoPointsInnerPointColor(value);
        this.refreshInfoPoints();
      }
    }
  }, {
    key: "getInfoPointsColor",
    value: function getInfoPointsColor() {
      var def = "";
      if (this._zkScene) {
        var val = this._zkScene.getInfoPointsColor();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setInfoPointsColor",
    value: function setInfoPointsColor(value) {
      if (this._zkScene) {
        this._zkScene.setInfoPointsColor(value);
        this.refreshInfoPoints();
      }
    }
  }, {
    key: "getInfoPointsHighlightColor",
    value: function getInfoPointsHighlightColor() {
      var def = "";
      if (this._zkScene) {
        var val = this._zkScene.getInfoPointsHighlightColor();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setInfoPointsHighlightColor",
    value: function setInfoPointsHighlightColor(value) {
      if (this._zkScene) {
        this._zkScene.setInfoPointsHighlightColor(value);
        this.refreshInfoPoints();
      }
    }
  }, {
    key: "enableGlowForMesh",
    value: function enableGlowForMesh(mesh) {
      if (this._glowManager) {
        this._glowManager.enableGlowForMesh(mesh);
      }
    }
  }, {
    key: "disableGlowForMesh",
    value: function disableGlowForMesh(mesh) {
      if (this._glowManager) {
        this._glowManager.disableGlowForMesh(mesh);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "enableARForMesh",
    value: function enableARForMesh(mesh) {
      if (mesh) {
        if (!mesh.metadata) mesh.metadata = {};
        mesh.metadata.AR = true;
      }
    }
  }, {
    key: "disableARForMesh",
    value: function disableARForMesh(mesh) {
      if (mesh) {
        if (!mesh.metadata) mesh.metadata = {};
        mesh.metadata.AR = false;
      }
    }
  }, {
    key: "disableTryOnForMesh",
    value: function disableTryOnForMesh(mesh) {
      var _this4 = this;
      if (mesh) {
        if (!mesh.metadata) mesh.metadata = {};
        mesh.metadata.TryOn = false;
        mesh.getChildMeshes().forEach(function (child) {
          return _this4.disableTryOnForMesh(child);
        });
      }
    }
  }, {
    key: "enableTryOnForMesh",
    value: function enableTryOnForMesh(mesh) {
      var _this5 = this;
      if (mesh) {
        if (!mesh.metadata) mesh.metadata = {};
        mesh.metadata.TryOn = true;
        mesh.getChildMeshes().forEach(function (child) {
          return _this5.enableTryOnForMesh(child);
        });
      }
    }
  }, {
    key: "enableInfoPointsForMesh",
    value: function enableInfoPointsForMesh(mesh) {
      if (mesh) {
        if (!mesh.metadata) mesh.metadata = {};
        mesh.metadata.showInfoPoints = true;
        this.refreshInfoPoints();
      }
    }
  }, {
    key: "disableInfoPointsForMesh",
    value: function disableInfoPointsForMesh(mesh) {
      if (mesh && mesh.metadata && mesh.metadata.showInfoPoints !== undefined && mesh.metadata.showInfoPoints !== null) {
        delete mesh.metadata.showInfoPoints;
        this.refreshInfoPoints();
      }
    }
  }, {
    key: "enableForcedInfoPointsVisibilityOnMesh",
    value: function enableForcedInfoPointsVisibilityOnMesh(mesh) {
      if (mesh) {
        if (!mesh.metadata) mesh.metadata = {};
        mesh.metadata.forceShowInfoPoints = true;
        this.refreshInfoPoints();
      }
    }
  }, {
    key: "disableForcedInfoPointsVisibilityOnMesh",
    value: function disableForcedInfoPointsVisibilityOnMesh(mesh) {
      if (mesh && mesh.metadata && mesh.metadata.forceShowInfoPoints !== undefined && mesh.metadata.forceShowInfoPoints !== null) {
        delete mesh.metadata.forceShowInfoPoints;
        this.refreshInfoPoints();
      }
    }
  }, {
    key: "setEditorBackgroundColor",
    value: function setEditorBackgroundColor(hexColor) {
      this._editorBackgroundColor = hexColor;
      this.refreshEnvironment();
    }
  }, {
    key: "setViewerBackgroundAlpha",
    value: function setViewerBackgroundAlpha(alpha) {
      if (this._zkScene) {
        var generalConfig = this._zkScene.getOrCreateGeneralConfig();
        generalConfig.set("backgroundAlpha", alpha);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerBackgroundColor",
    value: function setViewerBackgroundColor(hexColor) {
      if (this._zkScene) {
        var generalConfig = this._zkScene.getOrCreateGeneralConfig();
        generalConfig.set("backgroundColor", hexColor);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerEnvironmentSizeAuto",
    value: function setViewerEnvironmentSizeAuto(sizeAuto) {
      if (this._zkScene) {
        var environmentConfig = this._zkScene.getOrCreateEnvironmentConfig();
        environmentConfig.set("sizeAuto", sizeAuto);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerEnvironmentMainColor",
    value: function setViewerEnvironmentMainColor(hexColor) {
      if (this._zkScene) {
        var environmentConfig = this._zkScene.getOrCreateEnvironmentConfig();
        environmentConfig.set("mainColor", hexColor);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerSkyboxCreateSkybox",
    value: function setViewerSkyboxCreateSkybox(createSkybox) {
      if (this._zkScene) {
        var skyboxConfig = this._zkScene.getOrCreateSkyboxConfig();
        skyboxConfig.set("createSkybox", createSkybox);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerSkyboxSize",
    value: function setViewerSkyboxSize(size) {
      if (this._zkScene) {
        var skyboxConfig = this._zkScene.getOrCreateSkyboxConfig();
        skyboxConfig.set("size", size);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerSkyboxBlur",
    value: function setViewerSkyboxBlur(blur) {
      if (this._zkScene) {
        var blurSize = blur >= 0 ? blur : 0;
        var skyboxConfig = this._zkScene.getOrCreateSkyboxConfig();
        skyboxConfig.set("blur", blurSize);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerSkyboxTexture",
    value: function setViewerSkyboxTexture(url, extensions, files) {
      if (this._zkScene && url != undefined && typeof url === "string") {
        var skyboxConfig = this._zkScene.getOrCreateSkyboxConfig();
        skyboxConfig.set("texture", url);
        skyboxConfig.set("extensions", extensions);
        skyboxConfig.set("files", files);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "removeViewerSkyboxTexture",
    value: function removeViewerSkyboxTexture() {
      if (this._zkScene) {
        var skyboxConfig = this._zkScene.getSkyboxConfig();
        if (skyboxConfig && skyboxConfig.get("texture") != undefined) {
          skyboxConfig.unset("texture");
          this.refreshEnvironment();
        }
      }
    }
  }, {
    key: "setViewerSkyboxColor",
    value: function setViewerSkyboxColor(hexColor) {
      if (this._zkScene && hexColor != undefined && typeof hexColor === "string") {
        var skyboxConfig = this._zkScene.getOrCreateSkyboxConfig();
        skyboxConfig.set("color", hexColor);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerGroundCreateGround",
    value: function setViewerGroundCreateGround(createGround) {
      if (this._zkScene && createGround != undefined && typeof createGround === "boolean") {
        var groundConfig = this._zkScene.getOrCreateGroundConfig();
        groundConfig.set("createGround", createGround);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerGroundSize",
    value: function setViewerGroundSize(size) {
      if (this._zkScene) {
        var groundConfig = this._zkScene.getOrCreateGroundConfig();
        groundConfig.set("size", size);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerGroundTexture",
    value: function setViewerGroundTexture(url) {
      if (this._zkScene && url != undefined && typeof url === "string") {
        var groundConfig = this._zkScene.getOrCreateGroundConfig();
        groundConfig.set("texture", url);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "removeViewerGroundTexture",
    value: function removeViewerGroundTexture() {
      if (this._zkScene) {
        var groundConfig = this._zkScene.getGroundConfig();
        if (groundConfig && groundConfig.get("texture") != undefined) {
          groundConfig.unset("texture");
          this.refreshEnvironment();
        }
      }
    }
  }, {
    key: "setViewerGroundColor",
    value: function setViewerGroundColor(hexColor) {
      if (this._zkScene && hexColor != undefined && typeof hexColor === "string") {
        var groundConfig = this._zkScene.getOrCreateGroundConfig();
        groundConfig.set("color", hexColor);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerGroundOpacity",
    value: function setViewerGroundOpacity(opacity) {
      if (this._zkScene && opacity != undefined && typeof opacity === "number") {
        var groundConfig = this._zkScene.getOrCreateGroundConfig();
        groundConfig.set("opacity", opacity);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerGroundEnableShadow",
    value: function setViewerGroundEnableShadow(enableShadow) {
      if (this._zkScene && enableShadow != undefined && typeof enableShadow === "boolean") {
        var groundConfig = this._zkScene.getOrCreateGroundConfig();
        groundConfig.set("enableShadow", enableShadow);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerGroundShadowLevel",
    value: function setViewerGroundShadowLevel(shadowLevel) {
      if (this._zkScene && shadowLevel != undefined && typeof shadowLevel === "number") {
        var groundConfig = this._zkScene.getOrCreateGroundConfig();
        groundConfig.set("shadowLevel", shadowLevel);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerGroundEnableMirror",
    value: function setViewerGroundEnableMirror(enableMirror) {
      if (this._zkScene && enableMirror != undefined && typeof enableMirror === "boolean") {
        var groundConfig = this._zkScene.getOrCreateGroundConfig();
        groundConfig.set("enableMirror", enableMirror);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerGroundMirrorBlur",
    value: function setViewerGroundMirrorBlur(mirrorBlur) {
      if (this._zkScene && mirrorBlur != undefined && typeof mirrorBlur === "number") {
        var groundConfig = this._zkScene.getOrCreateGroundConfig();
        groundConfig.set("mirrorBlurKernel", mirrorBlur);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerCameraAutoRotate",
    value: function setViewerCameraAutoRotate(autoRotate) {
      if (this._zkScene && autoRotate != undefined && typeof autoRotate === "boolean") {
        var cameraConfig = this._zkScene.getOrCreateCameraConfig();
        cameraConfig.set("autoRotate", autoRotate);
        this.autoRender = autoRotate;
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerCameraContrast",
    value: function setViewerCameraContrast(contrast) {
      if (this._zkScene && contrast != undefined && typeof contrast === "number") {
        var cameraConfig = this._zkScene.getOrCreateCameraConfig();
        cameraConfig.set("contrast", contrast);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerCameraExposure",
    value: function setViewerCameraExposure(exposure) {
      if (this._zkScene && exposure != undefined && typeof exposure === "number") {
        var cameraConfig = this._zkScene.getOrCreateCameraConfig();
        cameraConfig.set("exposure", exposure);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "setViewerCameraToneMappingEnabled",
    value: function setViewerCameraToneMappingEnabled(toneMappingEnabled) {
      if (this._zkScene && toneMappingEnabled != undefined && typeof toneMappingEnabled === "boolean") {
        var cameraConfig = this._zkScene.getOrCreateCameraConfig();
        cameraConfig.set("toneMappingEnabled", toneMappingEnabled);
        this.refreshEnvironment();
      }
    }
  }, {
    key: "resetEditorEnvironment",
    value: function resetEditorEnvironment() {
      this.resetEditorBackground();
      this.resetEditorCamera();
      this.setRenderingNeeded();
    }
  }, {
    key: "resetEditorBackground",
    value: function resetEditorBackground() {
      if (this._scene) {
        this._scene.clearColor = BABYLON.Color3.FromHexString(this._editorBackgroundColor).toColor4();
        this.refreshGround();
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "resetEditorCamera",
    value: function resetEditorCamera() {
      if (this._scene) {
        var camera = this._scene.activeCamera;
        if (camera instanceof BABYLON.ArcRotateCamera) camera.useAutoRotationBehavior = false;
        this._autoRender = false;
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "preSceneContentScreenshot",
    value: function preSceneContentScreenshot() {
      this.resetEditorEnvironment();
      this.removeGround();
    }
  }, {
    key: "postSceneContentScreenshot",
    value: function postSceneContentScreenshot() {}
  }, {
    key: "preSceneMaterialScreenshot",
    value: function preSceneMaterialScreenshot() {
      _get(_getPrototypeOf(SceneEditor.prototype), "preSceneMaterialScreenshot", this).call(this);
      this.adjustSceneForSerialization();
    }
  }, {
    key: "postSceneMaterialScreenshot",
    value: function postSceneMaterialScreenshot() {
      _get(_getPrototypeOf(SceneEditor.prototype), "postSceneMaterialScreenshot", this).call(this);
    }
  }, {
    key: "sceneReadyForSave",
    value: function sceneReadyForSave() {
      if (this._scene) {
        for (var i = 0; i < this._scene.meshes.length; i++) {
          var mesh = this._scene.meshes[i];
          if (!mesh.isReady()) return false;
        }
      }
      return true;
    }
  }, {
    key: "isCurrentCameraPivot",
    value: function isCurrentCameraPivot(meshID) {
      if (this._sceneHelper) {
        var cameraPivot = this._sceneHelper.getCameraPivot();
        return cameraPivot && cameraPivot.id === meshID;
      }
      return false;
    }
  }, {
    key: "getCurrentCameraPivotID",
    value: function getCurrentCameraPivotID() {
      if (this._scene && this._sceneHelper) {
        var cameraPivot = this._sceneHelper.getCameraPivot();
        if (cameraPivot) {
          var mesh = this._scene.getMeshByID(cameraPivot.id);
          if (mesh) return mesh.id;
        }
      }
      return null;
    }

    // Riscritta quella di SceneViewer perché viene salvata l'informazione
    // sul nuovo pivot, non solo modifcato il punto di vista
  }, {
    key: "setCameraPivot",
    value: function setCameraPivot(meshID) {
      if (this._scene && this._sceneHelper) {
        // Elmino il pivot corrente
        for (var i = 0; i < this._scene.meshes.length; i++) {
          var m = this._scene.meshes[i];
          if (m.metadata && m.metadata.isCameraPivot != undefined) delete m.metadata.isCameraPivot;
        }
        if (meshID) {
          var mesh = this._scene.getMeshByID(meshID);
          if (mesh) {
            mesh.metadata = mesh.metadata || {};
            mesh.metadata.isCameraPivot = true;
          }
          this._sceneHelper.setCameraPivot(mesh || null);
        } else {
          this._sceneHelper.setCameraPivot(null);
        }
      }
    }

    // --------------------------------------------------------
    // Funzioni per il salvataggio della scena
    // --------------------------------------------------------
  }, {
    key: "getBlobFromEmbeddedTextureAsync",
    value: function () {
      var _getBlobFromEmbeddedTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(texture) {
        var blob, url, fromData, fromBlob, isBase64, buffer;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              blob = null;
              if (!texture.url) {
                _context3.next = 16;
                break;
              }
              url = texture.url;
              fromData = url.substring(0, 5) === "data:";
              fromBlob = url.substring(0, 5) === "blob:";
              isBase64 = fromData && url.indexOf(";base64,") !== -1;
              if (!(fromData && texture._buffer && (texture._buffer instanceof ArrayBuffer || texture._buffer instanceof Uint8Array || texture._buffer instanceof Blob))) {
                _context3.next = 10;
                break;
              }
              if (texture._buffer instanceof Blob) blob = texture._buffer;else if (texture._buffer instanceof Uint8Array) blob = new Blob([texture._buffer], {
                type: texture.mimeType
              });else if (texture._buffer instanceof ArrayBuffer) blob = new Blob([new Uint8Array(texture._buffer)], {
                type: texture.mimeType
              });
              _context3.next = 16;
              break;
            case 10:
              if (!fromBlob) {
                _context3.next = 15;
                break;
              }
              _context3.next = 13;
              return new Promise(function (resolve) {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';
                xhr.onload = function (e) {
                  if (this.status == 200) {
                    resolve(this.response);
                  }
                };
                xhr.send();
              });
            case 13:
              _context3.next = 16;
              break;
            case 15:
              if (isBase64) {
                buffer = new Uint8Array(BABYLON.Tools.DecodeBase64(url));
                blob = new Blob([buffer], {
                  type: texture.mimeType
                });
              }
            case 16:
              return _context3.abrupt("return", blob);
            case 17:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function getBlobFromEmbeddedTextureAsync(_x) {
        return _getBlobFromEmbeddedTextureAsync.apply(this, arguments);
      }
      return getBlobFromEmbeddedTextureAsync;
    }()
  }, {
    key: "uploadEmbeddedTexturesAsync",
    value: function () {
      var _uploadEmbeddedTexturesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(onProgress) {
        var _this6 = this;
        var textureToUpload, scene, zkScene, sceneHelper, materials, perc, _loop, i;
        return _regeneratorRuntime().wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              textureToUpload = [];
              if (this._zkScene && this._scene && this._sceneHelper) {
                scene = this._scene;
                zkScene = this._zkScene;
                sceneHelper = this._sceneHelper;
                materials = this.getAllMaterials();
                materials.forEach(function (m) {
                  var textures = m.getActiveTextures().filter(function (t) {
                    return t instanceof BABYLON.Texture;
                  });
                  textures.forEach(function (t) {
                    if (t.url) {
                      var fromData = t.url.substring(0, 5) === "data:";
                      var fromBlob = t.url.substring(0, 5) === "blob:";
                      var isBase64 = fromData && t.url.indexOf(";base64,") !== -1;
                      if (fromData || fromBlob || isBase64) {
                        var _type = sceneHelper.getMaterialTextureType(m, t);
                        if (_type) {
                          textureToUpload.push({
                            texture: t,
                            material: m,
                            type: _type
                          });
                        }
                      }
                    }
                  });
                });
              }
              perc = 0;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var info, texture, blob, extension, name, filename, _file, zkTexture, newUrl;
                return _regeneratorRuntime().wrap(function _loop$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      info = textureToUpload[i];
                      texture = info.texture;
                      _context4.next = 4;
                      return _this6.getBlobFromEmbeddedTextureAsync(texture);
                    case 4:
                      blob = _context4.sent;
                      if (!blob) {
                        _context4.next = 20;
                        break;
                      }
                      extension = ".png";
                      if (texture.mimeType === "image/jpeg") extension = ".jpg";
                      name = info.type.replace(' ', '_'); //const filename = `${Utils.getRandomString(8, "0123456789abcdefghijklmnopqrstuvwxyz")}${extension}`;
                      filename = "".concat(name).concat(extension);
                      _file = new File([blob], filename);
                      _context4.next = 13;
                      return _this6.uploadTextureFileAsync(_file, info.material);
                    case 13:
                      zkTexture = _context4.sent;
                      if (!zkTexture) {
                        _context4.next = 19;
                        break;
                      }
                      newUrl = zkTexture.get("url");
                      if (!newUrl) {
                        _context4.next = 19;
                        break;
                      }
                      _context4.next = 19;
                      return new Promise(function (resolve, reject) {
                        texture.updateURL(newUrl, undefined, function () {
                          return resolve();
                        }, function () {
                          return reject();
                        });
                      });
                    case 19:
                      if (onProgress) onProgress(i / textureToUpload.length * 100, "textures");
                    case 20:
                    case "end":
                      return _context4.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 5:
              if (!(i < textureToUpload.length)) {
                _context5.next = 10;
                break;
              }
              return _context5.delegateYield(_loop(), "t0", 7);
            case 7:
              i++;
              _context5.next = 5;
              break;
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this);
      }));
      function uploadEmbeddedTexturesAsync(_x2) {
        return _uploadEmbeddedTexturesAsync.apply(this, arguments);
      }
      return uploadEmbeddedTexturesAsync;
    }()
  }, {
    key: "useIncrementalLoading",
    value: function useIncrementalLoading() {
      if (this._sceneHelper) {
        //var vertices = this.sceneHelper.getHiddenMeshTotalVertices();
        //var indices = this.sceneHelper.getHiddenMeshTotalIndices();
        var vertices = this._sceneHelper.getTotalVertices();
        var indices = this._sceneHelper.getTotalIndices();
        if (vertices + indices >= 1000) return true;
      }
      return false;
    }

    // Prepara il modello backbone zkScene per il salvataggio. Nel dettaglio:
    // 1. Esegue lo screenshot della scena e imposta i byte nel modello zkScene
    // 2. Recupera il JSON della scena da Babylon JS. 
    // 3. Esegue l'upload del file in modo che possa essere salvato nel percorso previsto per la scena corrente.
    // 4. Aggiorna il modello impostando i dati relativi al file "uploadato" (essenzialmente il fileObject)
  }, {
    key: "updateSceneModel",
    value: function updateSceneModel(onSuccess, onError, onProgress) {
      var _this7 = this;
      if (this._zkScene && this._scene) {
        var scene = this._scene;
        var zkScene = this._zkScene;
        this.resetRealVisibility();
        var infoPointsShown = this.infoPointsShown;
        if (infoPointsShown) this.hideInfoPoints();
        this.uploadEmbeddedTexturesAsync(function (perc, type) {
          if (onProgress) onProgress(perc, type);
        }).then(function () {
          _this7.getSceneScreenshotAsync(500, 450).then(function (data) {
            if (infoPointsShown) _this7.showInfoPoints();
            zkScene.set("imageData", data);

            // Incremento la versione
            zkScene.set("version", zkScene.get("version") + 1);

            // Si potrebbe rendere opzionale il caricamento incrementale
            var incremental = _this7.useIncrementalLoading();
            if (!incremental) {
              // Salvo il file di scena per intero
              _this7.uploadSceneFile(function (sceneFileInfo) {
                _this7.onUploadScenFileSuccess(sceneFileInfo);
                if (onSuccess) onSuccess();
              }, function (reason) {
                if (onError) onError(reason);
              }, function (percentage, type) {
                if (onProgress) onProgress(percentage, type);
              });
            } else {
              // Salvo il file di scena in maniera incrementale
              _this7.uploadSceneIncrementalFiles(function (sceneFileInfo) {
                _this7.onUploadScenFileSuccess(sceneFileInfo);
                if (onSuccess) onSuccess();
              }, function (reason) {
                if (onError) onError(reason);
              }, function (percentage) {
                if (onProgress) onProgress(percentage);
              });
            }
          });
        })["catch"](function (reason) {
          if (onError) onError(reason);
        });
      }
    }

    // Aggiorna il modello con i dati sul file di scena salvato
  }, {
    key: "onUploadScenFileSuccess",
    value: function onUploadScenFileSuccess(sceneFileInfo) {
      if (this._zkScene && sceneFileInfo && (sceneFileInfo.hasOwnProperty("fileObjectID") || sceneFileInfo.hasOwnProperty("fileLength")) && sceneFileInfo.hasOwnProperty("rootUrl") && sceneFileInfo.hasOwnProperty("sceneFileName") && (sceneFileInfo.hasOwnProperty("manifestFileObjectID") || sceneFileInfo.hasOwnProperty("manifestFileLength")) && (sceneFileInfo.hasOwnProperty("incrementalsFileObjectID") || sceneFileInfo.hasOwnProperty("incrementalsFileLength"))) {
        // Aggiorno il modello in modo che riporti i dati del file di scena salvato
        this._zkScene.set("fileObjectID", sceneFileInfo.fileObjectID);
        this._zkScene.set("fileLength", sceneFileInfo.fileLength);
        this._zkScene.set("url", sceneFileInfo.url);
        this._zkScene.set("rootUrl", sceneFileInfo.rootUrl);
        this._zkScene.set("sceneFileName", sceneFileInfo.sceneFileName);
        this._zkScene.set("manifestFileObjectID", sceneFileInfo.manifestFileObjectID);
        this._zkScene.set("manifestFileLength", sceneFileInfo.manifestFileLength);
        this._zkScene.set("manifestFileUrl", sceneFileInfo.manifestFileUrl);
        this._zkScene.set("incrementalsFileObjectID", sceneFileInfo.incrementalsFileObjectID);
        this._zkScene.set("incrementalsFileLength", sceneFileInfo.incrementalsFileLength);
        this._zkScene.set("incrementalsFileUrl", sceneFileInfo.incrementalsFileUrl);
      } else Logger.info("le informazioni sul file di scena salvato sono vuote o incorrette");
    }
  }, {
    key: "uploadSceneFile",
    value: function uploadSceneFile(onSuccess, onError, onProgress) {
      if (!this._scene || !this._zkScene) {
        if (onError) onError("No scene to upload");
        return;
      }
      var scene = this._scene;
      var zkScene = this._zkScene;
      var version = zkScene.get("version");
      var json = this.getSceneJson();
      var param = {
        json: json,
        version: version
      };
      this.getSceneFileBlobsAsync(json, version, function (percentage) {
        if (onProgress) onProgress(percentage, "optimize");
      }).then(function (blobInfos) {
        // Blobs ricevuti, ora va fallo l'upload sul server
        var formData = new FormData();
        for (var i = 0; i < blobInfos.length; i++) {
          var blobInfo = blobInfos[i];
          formData.append('file_' + i, blobInfo.blob, blobInfo.name);
        }
        jQuery.ajax({
          url: zkScene.getSceneFileUploadUrl(),
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          type: 'POST',
          xhr: function xhr() {
            var xhr = new XMLHttpRequest();

            //Upload progress
            xhr.upload.addEventListener("progress", function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total;
                if (onProgress) onProgress(percentComplete * 100, "upload");
              }
            }, false);
            return xhr;
          },
          success: function success(data) {
            if (onSuccess) onSuccess(data);
          },
          error: function error(xhr, ajaxOptions, thrownError) {
            if (onError) onError(thrownError);
          }
        });
      });
    }
  }, {
    key: "getSceneFileBlobsAsync",
    value: function () {
      var _getSceneFileBlobsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(json, version, onProgress) {
        var blobInfos;
        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              blobInfos = [];
              if (!this._sceneToBlobs) {
                this._sceneToBlobs = _Components_SceneToBlobs_SceneToBlobs__WEBPACK_IMPORTED_MODULE_4__.SceneToBlobs.Default;
              }
              if (!this._sceneToBlobs) {
                _context6.next = 8;
                break;
              }
              _context6.next = 5;
              return this._sceneToBlobs.whenReadyAsync();
            case 5:
              _context6.next = 7;
              return this._sceneToBlobs.getSceneBlobsAsync(json, version, onProgress);
            case 7:
              blobInfos = _context6.sent;
            case 8:
              return _context6.abrupt("return", blobInfos);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee5, this);
      }));
      function getSceneFileBlobsAsync(_x3, _x4, _x5) {
        return _getSceneFileBlobsAsync.apply(this, arguments);
      }
      return getSceneFileBlobsAsync;
    }() // Serializza in JSON la scena Babylon JS
  }, {
    key: "getSceneJson",
    value: function getSceneJson() {
      var json = "";
      if (this._scene && this._sceneHelper) {
        var oldEnvMode = this._envMode;
        this.setEnvironmentMode(_Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor);

        // Disabilito l'antialiasing per evitare che vengano serializzati anche i PassPostProcess
        this.disableAntialiasing(true);

        // Resetto i limiti di rotazione che comunque sono salvati nella configurazione della scena
        var oldLimits = this.resetCameraRotationLimits();
        this.deleteHighlightLayer();
        var manipulatedNode = this._manipulatedNode;
        this.setManipulatedNode(null);

        // Se useMaterialOffloading e !useDelayedMaterialLoading scarico tutti materiali non utilizzati e li ricarico dopo
        if (this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading()) {
          this._sceneHelper.offloadAllUnusedMaterials();
        }

        // Sulle mesh nascosto imposto un materiale di default in modo da non caricare subiti materiali assegnati a mesh nascoste
        this._sceneHelper.setDummyMaterialToInvisibleMeshes();
        this.adjustSceneForSerialization();
        var serializedScene = BABYLON.SceneSerializer.Serialize(this._scene);
        serializedScene.postProcesses = []; // elimino gli eventuali post process
        json = JSON.stringify(serializedScene);

        // Ricarico gli eventuali materiali scaricati
        if (this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading()) {
          var _this$_zkScene;
          var rootUrl = (_this$_zkScene = this._zkScene) === null || _this$_zkScene === void 0 ? void 0 : _this$_zkScene.get("rootUrl");
          if (rootUrl) this._sceneHelper.loadAllOffloadedMaterials(rootUrl);
        }

        // Ripristino i materiali originali sulle mesh nascoste
        this._sceneHelper.unsetAllDummyMaterials();
        if (oldEnvMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) this.setEnvironmentMode(oldEnvMode);
        this.enableAntialiasing();
        this.createHighlightLayer();
        this.setManipulatedNode(manipulatedNode);

        // Reimposto i limiti correnti
        this.setCameraRotationLimits(oldLimits);
      }
      return json;
    }
  }, {
    key: "resetCameraRotationLimits",
    value: function resetCameraRotationLimits() {
      var limits = {
        lowerAlphaLimit: null,
        upperAlphaLimit: null,
        lowerBetaLimit: null,
        upperBetaLimit: null
      };
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        limits.lowerAlphaLimit = this._camera.lowerAlphaLimit;
        limits.upperAlphaLimit = this._camera.upperAlphaLimit;
        limits.lowerBetaLimit = this._camera.lowerBetaLimit;
        limits.upperBetaLimit = this._camera.upperBetaLimit;
        this._camera.lowerAlphaLimit = null;
        this._camera.upperAlphaLimit = null;
        this._camera.lowerBetaLimit = 0.01;
        this._camera.upperBetaLimit = Math.PI - 0.01;
      }
      return limits;
    }
  }, {
    key: "setCameraRotationLimits",
    value: function setCameraRotationLimits(limits) {
      limits = limits || {
        lowerAlphaLimit: null,
        upperAlphaLimit: null,
        lowerBetaLimit: 0.01,
        upperBetaLimit: Math.PI - 0.01
      };
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        this._camera.lowerAlphaLimit = limits.lowerAlphaLimit;
        this._camera.upperAlphaLimit = limits.upperAlphaLimit;
        this._camera.lowerBetaLimit = limits.lowerBetaLimit || 0.01;
        this._camera.upperBetaLimit = limits.upperBetaLimit || Math.PI - 0.01;
      }
    }

    // Metodo fondamentale per modificare gli url delle texture ed eliminare le 
    // le texture non più utilizzate. In fase di caricamento della scena, Babylon JS
    // risolve il nome delle texture in base al path della scena. Quindi gli url delle
    // texture vanno, se necessario, trasformanti in path relativi.
  }, {
    key: "adjustSceneForSerialization",
    value: function adjustSceneForSerialization() {
      var _this8 = this;
      if (this._scene && this._sceneHelper && this._zkScene) {
        var sceneHelper = this._sceneHelper;
        this.removeDisabledFresnelParameters();
        var delayedTextures = false;
        if (this._zkScene.getUseDelayedTextureLoading() != undefined) delayedTextures = this._zkScene.getUseDelayedTextureLoading();
        this._scene.useDelayedTextureLoading = delayedTextures;

        // Attenzione!
        // Prima della serializzazione della scena, è necessario sistemare il path delle texture.
        // Sostanzialmente modifico il nome della texture settando il path relativo
        // in modo che poi possa essere risolto come path assoluto relativo alla scena.

        // MatchSameNameTextures indica se nel salvataggio della scena due texture con lo stesso
        // nome possono essere considerate come uguali. In caso affermativo nella scena verrà
        // utilizzato solo l'url di una di esse, evitando qindi di scaricare più volte la stessa
        // immagine
        var matchSameNameTextures = this.getMatchSameNameTextures();
        var sourcesIDs = this._zkScene.getSourcesIDs();
        var libraryMaterialIDs = this._zkScene.getLibraryMaterialIDs();

        // per ogni id di materiale di libreria, contiene una mappa nome file texture --> url
        var libMaps = {};

        // mappa textureName -> url
        var urlMap = {};

        // Contiene gli url delle texture effettivamente usate nella scena. 
        // Consente di eliminare dal modello zkScene tutte le texture non più utilizzate
        var usedTextureUrls = [];
        var onlyDesktopTextureUrls = [];
        var onlyMobileTextureUrls = [];

        // Da rivedere la gestione della mappa d'ambiente di default
        var envUrl = sceneHelper.getTextureUrl(this._scene.environmentTexture);
        //const useDefaultEnvironmentTexture = envUrl != null && envUrl == DefaultAssetUrls.Environment.EnvironmentTextureCDNUrl;
        var useDefaultEnvironmentTexture = envUrl !== null && envUrl.endsWith(_Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__.DefaultAssetUrls.Environment.EnvironmentTextureName);
        this._zkScene.set("useDefaultEnvironmentTexture", useDefaultEnvironmentTexture);

        // La rotazione dell'environmentTexture purtroppo al momento non viene serializzata nella scena.
        // Utilizzo i metadati allora
        if (this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture)) {
          var rotationY = this._scene.environmentTexture.rotationY;
          if (!this._scene.metadata) this._scene.metadata = {};
          this._scene.metadata.environmentTextureRotationY = rotationY;
        }
        this._scene.textures.forEach(function (txt) {
          if (!sceneHelper.isTextureWithUrl(txt)) return;
          var txtUrl = txt.url;
          if (txt.getInternalTexture) {
            var internalTexture = txt.getInternalTexture();
            if (internalTexture && internalTexture.url) {
              txtUrl = internalTexture.url;
            }
          }
          if (txtUrl) {
            var textureUrl = txtUrl;

            // EnvironmentTexture di default
            if (textureUrl === _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__.DefaultAssetUrls.Environment.EnvironmentTextureCDNUrl) {
              // La scena utilizza una environment texture di default
              // Impostanto useDefaultEnvironmnetTexture a true sulla scena
              // faccio in modo che, al momento del salvataggio sul server,
              // il file immagine venga copiato nello stesso percorso della scena
              // nella directory textures/00000000000000000000000000000000/
              txt.url = "textures/" + Zakeke.getEmptyUUID().replace(/-/g, "") + "/" + _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__.DefaultAssetUrls.Environment.EnvironmentTextureName;
              txt.name = txt.url;
              return;
            }

            // Skybox e ground di default. Verranno ricreate al caricamento della scena
            if (textureUrl == _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__.DefaultAssetUrls.Environment.SkyboxTextureCDNUrl || textureUrl == _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__.DefaultAssetUrls.Environment.GroundTextureCDNUrl) return;

            // Altre texture
            var isSource = false;
            if (textureUrl.startsWith("blob:") && txt.metadata && txt.metadata.fileUrl) {
              textureUrl = txt.metadata.fileUrl;
            }

            // Se la texture proviene da una sorgente, 
            // allora devo prendere solo la parte dal codice sorgente in poi
            // name = "{sourceID}/.../{filename.xxx}"
            for (var i = 0; i < sourcesIDs.length; i++) {
              var sourceID = sourcesIDs[i].replace(/-/g, "");
              var idx = textureUrl.indexOf(sourceID);
              if (idx != -1) {
                isSource = true;
                txt.name = textureUrl.substring(idx);
                txt.url = txt.name;
                Logger.info("texture url: " + txt.url);
                break;
              }
            }

            // Texture per materiali di libreria
            // Per i materiali di libreria avremo già un percorso del tipo "textures/{libraryMaterialID}/{filename.xxx}"
            // Sarà sufficiente sostituire "libraryMaterialID" con il nuovo id del materiale assegnato
            // nella scena corrente
            var isLibrary = false;
            if (txt["materialMapping"]) {
              isLibrary = true;
              var libraryMaterialID = txt["materialMapping"].libraryMaterialID.replace(/-/g, "");
              var sceneMaterialID = txt["materialMapping"].sceneMaterialID.replace(/-/g, "");
              var finalUrl = textureUrl;
              var finalName = txt.name;
              var _idx = textureUrl.indexOf(libraryMaterialID);
              if (_idx != -1) {
                var libTxtUrl = textureUrl.replace(new RegExp(libraryMaterialID, 'g'), sceneMaterialID);
                finalUrl = libTxtUrl;
                finalName = libTxtUrl;
                var map = {};
                if (libMaps.hasOwnProperty(libraryMaterialID)) map = libMaps[libraryMaterialID];else {
                  libMaps[libraryMaterialID] = map;
                }
                _idx = libTxtUrl.lastIndexOf("/");
                if (_idx !== -1) {
                  var libTxtName = libTxtUrl.substring(_idx + 1);
                  if (map.hasOwnProperty(libTxtName)) {
                    finalUrl = map[libTxtName];
                    finalName = finalUrl;
                    if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(usedTextureUrls, finalUrl)) usedTextureUrls.push(finalUrl);
                  } else {
                    _idx = libTxtUrl.lastIndexOf("/", _idx - 1);
                    if (_idx !== -1) {
                      _idx = libTxtUrl.lastIndexOf("/", _idx - 1);
                      if (_idx != -1) {
                        finalUrl = libTxtUrl.substring(_idx + 1);
                        finalName = finalUrl;
                        if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(usedTextureUrls, finalUrl)) usedTextureUrls.push(finalUrl);
                        if (matchSameNameTextures) {
                          map[libTxtName] = finalUrl;
                        }
                      }
                    }
                  }
                }
                txt.name = finalName;
                txt.url = finalUrl;
              }
            }

            // Texture caricate dall'utente per un materiale
            // il percorso iniziale sarà del tipo ..../textures/{materialID}/{filename.xxx}
            // imposto il nome a "textures/{materialID}/{filename.xxx}"
            if (!isSource && !isLibrary) {
              var _textureInfo = _this8.extractTextureNameAndUrl(textureUrl, matchSameNameTextures, urlMap);
              if (_textureInfo.url && _textureInfo.name) {
                txt.url = _textureInfo.url;
                txt.name = _textureInfo.name;
                if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(usedTextureUrls, txt.url)) usedTextureUrls.push(txt.url);
              }
              if (txt.metadata && txt.metadata.mobileUrl) {
                var mobileTextureInfo = _this8.extractTextureNameAndUrl(txt.metadata.mobileUrl, matchSameNameTextures, urlMap);
                if (mobileTextureInfo.url && mobileTextureInfo.name) {
                  txt.metadata.mobileUrl = mobileTextureInfo.url;
                  if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(usedTextureUrls, txt.metadata.mobileUrl)) usedTextureUrls.push(txt.metadata.mobileUrl);
                  if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(onlyMobileTextureUrls, txt.metadata.mobileUrl)) onlyMobileTextureUrls.push(txt.metadata.mobileUrl);
                  if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(onlyDesktopTextureUrls, txt.url)) onlyDesktopTextureUrls.push(txt.url);
                }
              }
            }
          }
        });

        // Elimino dal modello zkScene tutte le texture non efettivamente utilizzate nella scena
        var suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
        var clearCubeMapSuffix = function clearCubeMapSuffix(url) {
          var idx = url.lastIndexOf(".");
          var newUrl = url;
          if (idx !== -1) {
            var nameWithoutExt = url.substring(0, idx);
            for (var p = 0; p < suffixes.length; p++) {
              var suffix = suffixes[p];
              idx = nameWithoutExt.lastIndexOf("_" + suffix);
              if (idx != -1) {
                newUrl = nameWithoutExt.substring(0, idx);
                break;
              }
            }
          }
          return newUrl;
        };
        var isUsedTextureUrl = function isUsedTextureUrl(url) {
          var newUrl = clearCubeMapSuffix(url);
          for (var u = 0; u < usedTextureUrls.length; u++) {
            var usedUrl = usedTextureUrls[u];
            if (newUrl.endsWith(usedUrl)) return true;
          }
          return false;
        };
        var isOnlyDesktopTextureUrl = function isOnlyDesktopTextureUrl(url) {
          var newUrl = clearCubeMapSuffix(url);
          for (var u = 0; u < onlyDesktopTextureUrls.length; u++) {
            var usedUrl = onlyDesktopTextureUrls[u];
            if (newUrl.endsWith(usedUrl)) return true;
          }
          return false;
        };
        var isOnlyMobileTextureUrl = function isOnlyMobileTextureUrl(url) {
          var newUrl = clearCubeMapSuffix(url);
          for (var u = 0; u < onlyMobileTextureUrls.length; u++) {
            var usedUrl = onlyMobileTextureUrls[u];
            if (newUrl.endsWith(usedUrl)) return true;
          }
          return false;
        };

        // Elimino le texture e costruisco una mappa delle texture per materiale, utilizzabile in fase di prefetch
        var modelsToRemove = [];
        for (var t = 0; t < this._zkScene.get("textures").length; t++) {
          var zkTexture = this._zkScene.get("textures").at(t);
          var url = zkTexture.get("url");
          if (url) {
            if (!isUsedTextureUrl(url)) modelsToRemove.push(zkTexture);else if (isOnlyDesktopTextureUrl(url)) zkTexture.set("usage", Zakeke.TextureUsage.Desktop);else if (isOnlyMobileTextureUrl(url)) zkTexture.set("usage", Zakeke.TextureUsage.Mobile);else zkTexture.set("usage", Zakeke.TextureUsage.Any);
          } else {
            modelsToRemove.push(zkTexture);
          }

          //if (url && !isUsedTextureUrl(url))
          //    modelsToRemove.push(zkTexture);
        }

        if (modelsToRemove.length > 0) this._zkScene.get("textures").remove(modelsToRemove);

        // Salvo l'elenco delle texture utilizzate in modo che lato backend si evitino
        // le duplicazioni di texture nello spostamento da materiali di libreria a quelli di scena
        this._zkScene.set("usedTextureUrls", usedTextureUrls);
      }
    }

    // Metodo da usare per le texture caricate dall'utente, per trasformre il percorso assoluto
    // del tipo ..../textures/{ materialID }/{filename.xxx} nel percorso relativo textures/{materialID}/{filename.xxx}
    // Utilizza ed aggiorna eventualmente un dictionary per riutilizzare lo stesso percorso a parità di nome
  }, {
    key: "extractTextureNameAndUrl",
    value: function extractTextureNameAndUrl(textureUrl, matchSameNameTextures, urlMap) {
      var info = {
        name: "",
        url: ""
      };
      var idx = textureUrl.lastIndexOf("/");
      if (idx !== -1) {
        var _textureName = textureUrl.substring(idx + 1);
        if (urlMap.hasOwnProperty(_textureName)) {
          info.url = urlMap[_textureName];
          info.name = info.url;
        } else {
          idx = textureUrl.lastIndexOf("/", idx - 1);
          if (idx !== -1) {
            idx = textureUrl.lastIndexOf("/", idx - 1);
            if (idx !== -1) {
              var newName = textureUrl.substring(idx + 1);
              info.url = newName;
              info.name = newName;
              if (matchSameNameTextures) {
                urlMap[_textureName] = newName;
              }
            }
          }
        }
      }
      return info;
    }
  }, {
    key: "removeDisabledFresnelParameters",
    value: function removeDisabledFresnelParameters() {
      var canRemoveFresnelParameters = function canRemoveFresnelParameters(fresnelParameters) {
        return fresnelParameters && fresnelParameters.isEnabled != undefined && !fresnelParameters.isEnabled && fresnelParameters.leftColor != undefined && fresnelParameters.leftColor != null && fresnelParameters.leftColor instanceof BABYLON.Color3 && fresnelParameters.leftColor.equals(BABYLON.Color3.White()) && fresnelParameters.rightColor != undefined && fresnelParameters.rightColor != null && fresnelParameters.rightColor instanceof BABYLON.Color3 && fresnelParameters.rightColor.equals(BABYLON.Color3.Black()) && fresnelParameters.bias != undefined && fresnelParameters.bias == 0 && fresnelParameters.power != undefined && fresnelParameters.power == 1;
      };
      if (this._scene) {
        this._scene.materials.forEach(function (material) {
          if (material instanceof BABYLON.StandardMaterial) {
            if (material.diffuseFresnelParameters && canRemoveFresnelParameters(material.diffuseFresnelParameters)) {
              material.diffuseFresnelParameters = new BABYLON.FresnelParameters();
              material.diffuseFresnelParameters.isEnabled = false;
            }
            if (material.emissiveFresnelParameters && canRemoveFresnelParameters(material.emissiveFresnelParameters)) {
              material.emissiveFresnelParameters = new BABYLON.FresnelParameters();
              material.emissiveFresnelParameters.isEnabled = false;
            }
            if (material.opacityFresnelParameters && canRemoveFresnelParameters(material.opacityFresnelParameters)) {
              material.opacityFresnelParameters = new BABYLON.FresnelParameters();
              material.opacityFresnelParameters.isEnabled = false;
            }
            if (material.reflectionFresnelParameters && canRemoveFresnelParameters(material.reflectionFresnelParameters)) {
              material.reflectionFresnelParameters = new BABYLON.FresnelParameters();
              material.reflectionFresnelParameters.isEnabled = false;
            }
            if (material.refractionFresnelParameters && canRemoveFresnelParameters(material.refractionFresnelParameters)) {
              material.refractionFresnelParameters = new BABYLON.FresnelParameters();
              material.refractionFresnelParameters.isEnabled = false;
            }
          } else if (material instanceof BABYLON.PBRMaterial) {
            // non più presenti su PBRMaterial
            /*
            if (material.opacityFresnelParameters && canRemoveFresnelParameters(material.opacityFresnelParameters))
                material.opacityFresnelParameters = undefined;
              if (material.emissiveFresnelParameters && canRemoveFresnelParameters(material.emissiveFresnelParameters))
                material.emissiveFresnelParameters = undefined;
            */
          } else if (material instanceof Zakeke.PBRMaterial) {
            if (material.opacityFresnelParameters && canRemoveFresnelParameters(material.opacityFresnelParameters)) material.opacityFresnelParameters = undefined;
          }
        });
      }
    }

    // Versione che utilizza un webworker (incapsulato in IncrementalFiles) per produrre i file incrementali (ed eventualmente 
    // codificarli con Draco). In futuro si potrebbe convertire in async.
  }, {
    key: "uploadSceneIncrementalFiles",
    value: function uploadSceneIncrementalFiles(onSuccess, onError, onProgress) {
      var _this9 = this;
      if (!this._scene || !this._zkScene || !this._sceneHelper) {
        if (onError) onError("No scene to upload");
        return;
      }
      var scene = this._scene;
      var zkScene = this._zkScene;
      var sceneHelper = this._sceneHelper;
      var version = zkScene.get("version");
      var oldEnvMode = this.envMode;
      this.setEnvironmentMode(_Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor);

      // Disabilito l'antialiasing per evitare che vengano serializzati anche i PassPostProcess
      this.disableAntialiasing(true);
      var oldLimits = this.resetCameraRotationLimits();
      this.deleteHighlightLayer();
      this.adjustSceneForSerialization();

      // Imposto un materiale fittizio sulle mesh nascoste
      sceneHelper.setDummyMaterialToInvisibleMeshes();

      // Delayed Material Loading
      var delayedMaterialLoading = this.getUseDelayedMaterialLoading();
      var useMaterialOffloading = this.getUseMaterialOffloading();

      // nel caso di delayed loading indico tutti i materiali da utilizzare in modo differito
      var delayedMaterials = {};
      var offloadedMaterials = {};
      if (delayedMaterialLoading) {
        var materials = this.getAllMaterials();
        materials.forEach(function (m) {
          var meshes = _this9.getMeshesUsingMaterial(m.id);
          if (m.id !== "default material" && meshes.length === 0) {
            delayedMaterials[m.id] = {
              name: m.name,
              file: "material_" + version + "_" + m.id.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".json"
            };
          }
        });
      } else if (useMaterialOffloading) {
        var _materials = this.getAllMaterials();
        _materials.forEach(function (m) {
          var meshes = _this9.getMeshesUsingMaterial(m.id);
          if (m.id !== "default material" && meshes.length === 0) {
            offloadedMaterials[m.id] = sceneHelper.getOffloadedMaterialInfo(m);
          }
        });
      }
      if (!this._scene.metadata) this._scene.metadata = {};
      this._scene.metadata.offloadedMaterials = offloadedMaterials;
      this._scene.metadata.delayedMaterials = delayedMaterials;
      var sceneJson = BABYLON.SceneSerializer.Serialize(this._scene);
      sceneJson.postProcesses = []; // elimino gli eventuali post process

      // Ripristino subito i materiali originali sulle mesh nascoste
      if (sceneJson.metadata && sceneJson.metadata.originalMeshMaterials) {
        // quando ripristino i materiali originali vengnono modificati anche i metadati della scena json
        var oldOriginalMeshMaterials = JSON.parse(JSON.stringify(sceneJson.metadata.originalMeshMaterials));
        sceneHelper.unsetAllDummyMaterials();
        sceneJson.metadata.originalMeshMaterials = oldOriginalMeshMaterials;
      }
      var options = {
        useDraco: this._dracoEnabled,
        dracoEncodingSpeed: this._dracoEncodingSpeed,
        dracoDecodingSpeed: this._dracoDecodingSpeed,
        excludedMeshes: [],
        delayMatarialLoading: Object.keys(delayedMaterials),
        offloadedMaterialIDs: Object.keys(offloadedMaterials)
      };
      this.getSceneIncrementalFilesAsync(version, sceneJson, options, onProgress).then(function (incrementalFiles) {
        var formData = new FormData();
        for (var i = 0; i < incrementalFiles.length; i++) {
          var incrementalFileInfo = incrementalFiles[i];
          var name = incrementalFileInfo.name;
          var _data = incrementalFileInfo.data;
          var compressed = false;
          if (!incrementalFileInfo.dracoEncoded && incrementalFileInfo.data.length > 180 && incrementalFileInfo.data.length < 450000) {
            Logger.info("Uncompressed file length: " + incrementalFileInfo.data.length);
            // compress file content
            _data = LZString.compressToUint8Array(incrementalFileInfo.data);
            Logger.info("Compressed file length: " + _data.length);
            name = "compressed_" + incrementalFileInfo.name;
            compressed = true;
          }
          var blob = void 0;
          if (!incrementalFileInfo.dracoEncoded && !compressed) {
            blob = new Blob([_data], {
              type: "text/plain"
            });
          } else {
            var arrayBuffer = _data.buffer;
            blob = new Blob([arrayBuffer]);
          }
          formData.append('file_' + i, blob, name);
        }
        jQuery.ajax({
          url: zkScene.getSceneIncrementalFileUploadUrl(),
          data: formData,
          cache: false,
          contentType: false,
          processData: false,
          type: 'POST',
          xhr: function xhr() {
            var xhr = new XMLHttpRequest();

            //Upload progress
            xhr.upload.addEventListener("progress", function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total;
                if (onProgress) onProgress(percentComplete * 100);
              }
            }, false);
            return xhr;
          },
          success: function success(data) {
            if (onSuccess) onSuccess(data);
          },
          error: function error(xhr, ajaxOptions, thrownError) {
            if (onError) onError(thrownError);
          }
        });
        if (oldEnvMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) _this9.setEnvironmentMode(oldEnvMode);
        _this9.enableAntialiasing();
        _this9.createHighlightLayer();
        _this9.setCameraRotationLimits(oldLimits);
      });
    }

    // Utilizza il web worker MakeIncrementalFiles per ottenere i file incrementali (eventualmente codificati con Draco)
  }, {
    key: "getSceneIncrementalFilesAsync",
    value: function () {
      var _getSceneIncrementalFilesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(version, json, options, onProgress) {
        var files;
        return _regeneratorRuntime().wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              files = [];
              if (!this._incrementalFilesMaker) this._incrementalFilesMaker = _Components_IncrementalFiles_IncrementalFiles__WEBPACK_IMPORTED_MODULE_1__.IncrementalFiles.Default;
              if (!this._incrementalFilesMaker) {
                _context7.next = 8;
                break;
              }
              _context7.next = 5;
              return this._incrementalFilesMaker.whenReadyAsync();
            case 5:
              _context7.next = 7;
              return this._incrementalFilesMaker.getIncrementalFilesAsync(json, version, options);
            case 7:
              files = _context7.sent;
            case 8:
              return _context7.abrupt("return", files);
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee6, this);
      }));
      function getSceneIncrementalFilesAsync(_x6, _x7, _x8, _x9) {
        return _getSceneIncrementalFilesAsync.apply(this, arguments);
      }
      return getSceneIncrementalFilesAsync;
    }() // Fine funzioni salvataggio scena
    // --------------------------------------------------------
  }, {
    key: "setNewSceneModelAsync",
    value: function () {
      var _setNewSceneModelAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(zkModel, zkScene) {
        return _regeneratorRuntime().wrap(function _callee7$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              this._zkModel = zkModel;
              this._zkScene = zkScene;
              _context8.next = 4;
              return this.init3DEngineAsync();
            case 4:
              this.fireMeshesUpdateEvent();
              this.fireMaterialsUpdateEvent();
              this.fireLightsUpdateEvent();
              this.fireCameraLocationsUpdateEvent();
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee7, this);
      }));
      function setNewSceneModelAsync(_x10, _x11) {
        return _setNewSceneModelAsync.apply(this, arguments);
      }
      return setNewSceneModelAsync;
    }()
  }, {
    key: "preSceneFileLoading",
    value: function preSceneFileLoading() {
      this.resetRealVisibility();
    }
  }, {
    key: "postSceneFileLoading",
    value: function postSceneFileLoading() {
      this.fireSceneCreatedEvent();
      this.fireMeshesUpdateEvent();
      this.fireMaterialsUpdateEvent();
      this.fireLightsUpdateEvent();
      this.fireCameraLocationsUpdateEvent();
    }

    // ==============================================================================
    // Importazione Assets 
    // ==============================================================================
    // I file "uploadati" dall'utente non vengono caricati immediatamente nella scena
    // ma viene creato un task di elaborazione lato server il cui stato verrà controllato tramite polling.
    // Per ogni task server di caricamento verrà creato un oggetto task lato client che è utile
    // per il recupero tramite polling delle informazioni.
    // I task lato client avranno uno degli stati:
    //   uploading         - Task avviato per l'uploading dei file
    //   progress          - Task in elaborazione
    //   checking          - Chimata Ajax di controllo stato in corso
    //   success           - Task server completato con successo, si possono importare i relativi file nella scena Babylon JS corrente
    //   completed_success - Task eseguito correttamente e file importati nella scena Babylon JS
    //   completed_error   - Task in errore, può essere eliminato dalla lista dei task da controllare
  }, {
    key: "loadSceneSourceFiles",
    value: function loadSceneSourceFiles(files, onSuccess, onError) {
      var _this10 = this;
      if (this._zkScene) {
        var zkScene = this._zkScene;

        // FormData per i file da uploadare
        var _data2 = new FormData();
        for (var i = 0; i < files.length; i++) {
          _data2.append('file-' + i, files[i]);
        }

        // Creo il task subito e lo metto in coda con lo stato di upload
        var _task = {
          downloadProgress: 0,
          uploadProgress: 0,
          status: SourceTaskStatus.uploading,
          message: "",
          sceneSourceInfo: {},
          taskID: undefined,
          sourceID: undefined
        };
        this._sceneSourceTasks.push(_task);

        // Passo i file sul server creando il relativo task per il recupero dello stato
        jQuery.ajax({
          url: zkScene.getSourceTasksUrl(),
          data: _data2,
          cache: false,
          contentType: false,
          processData: false,
          type: 'POST',
          xhr: function xhr() {
            var xhr = new XMLHttpRequest();
            // Handle progress
            //Upload progress
            xhr.upload.addEventListener("progress", function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total;
                _task.uploadProgress = percentComplete * 100;
                _this10.fireSceneSourceTaskCheckEvent();
              }
            }, false);
            //Download progress
            xhr.addEventListener("progress", function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = evt.loaded / evt.total;
                _task.downloadProgress = percentComplete * 100;
                _this10.fireSceneSourceTaskCheckEvent();
              }
            }, false);
            return xhr;
          },
          success: function success(data) {
            // Ottengo i dati del task (server) di caricamento creato a partire dai file inviati
            // e creo il task lato client
            if (data && data.hasOwnProperty("taskID") && data.hasOwnProperty("sourceID")) {
              // creo un task nello stato progress
              _task.taskID = data.taskID;
              _task.sourceID = data.sourceID;
              _task.status = SourceTaskStatus.progress;
              _this10.fireSceneSourceTaskCheckEvent();
            } else Logger.info("processo di creazione task non andato a buon fine");
            if (onSuccess) onSuccess(_task);
          },
          error: function error(xhr, ajaxOptions, thrownError) {
            _this10._sceneSourceTasks = _this10._sceneSourceTasks.filter(function (x) {
              x !== _task;
            });
            _this10.fireSceneSourceTaskCheckEvent();
            if (onError) onError(thrownError);
          }
        });
        this.fireSceneSourceTaskCheckEvent();
      }
    }

    // Il metodo viene richiamato ogni secondo per il controllo dei task di caricamento file
    // eventualmente presenti in coda
  }, {
    key: "checkSceneSourceTasks",
    value: function checkSceneSourceTasks() {
      var _this11 = this;
      if (this._scene && this._zkScene && this._sceneSourceTasks && this._sceneSourceTasks.length > 0) {
        var zkScene = this._zkScene;
        var _loop2 = function _loop2(_i) {
          var task = _this11._sceneSourceTasks[_i];

          // TASK Definitivamente Completato
          if (task.status == SourceTaskStatus.completed_error || task.status == SourceTaskStatus.completed_success) {
            // Se il task è completato definitivamente lo elimino dalla lista
            _this11._sceneSourceTasks.splice(_i--, 1);
            _this11.fireSceneSourceTaskCheckEvent();
            i = _i;
            return "continue";
          }

          // TASK in chiamata AJAX di controllo o di Upload in corso
          if (task.status == SourceTaskStatus.checking || task.status == SourceTaskStatus.uploading) {
            i = _i;
            return "continue";
          }

          // TASK in elaborazione lato server
          if (task.status == SourceTaskStatus.progress) {
            // Eseguo la chiamata ajax per verificare lo stato del task
            // cambio lo stato in "checking" in modo da non ripetere la chiamata
            task.status = SourceTaskStatus.checking;
            var onError = function onError(task) {
              // Il recupero delle informazioni è andato in errore.
              // Il task può essere eliminato dalla coda
              task.status = SourceTaskStatus.completed_error;
              _this11.fireSceneSourceTaskErrorEvent(task.taskID);
              _this11.fireSceneSourceTaskCheckEvent();
            };

            // Eseguo la chiamata per ottenere lo stato del task lato server.
            // Nel caso in cui il task lato server sia completato, avrò anche le informazioni
            // sui file che sono stati caricati (file di scena sorgente + textures)

            // Mauro - 07/02/2018: Ho transformato la chiamata in una funzione  perchè altrimenti la task nella callback
            // potrebbe essere un'altra e non quella da dove era partita dato che in JS lo scope di una var è per function...
            // lo stesso vale per l'onError
            runAjaxCheck = function runAjaxCheck(task) {
              jQuery.ajax({
                url: zkScene.getSourceTaskResultUrl(task.taskID),
                cache: false,
                contentType: false,
                processData: false,
                type: 'GET',
                success: function success(data) {
                  if (data && data.hasOwnProperty("taskID") && data.hasOwnProperty("state") && data.hasOwnProperty("message") && data.hasOwnProperty("sourceFile")) {
                    if (data.state == 2) {
                      // Il task si è completato con successo, salvo le informazioni
                      // sui file generati sul task client in modo che possano essere 
                      // importati nella scena corrente

                      // file di scena sorgente
                      task.sceneSourceInfo = {
                        sourceID: data.sourceFile.sourceID,
                        fileObjectID: data.sourceFile.fileObjectID,
                        fileLength: data.sourceFile.fileLength,
                        url: data.sourceFile.url,
                        rootUrl: data.sourceFile.rootUrl,
                        sceneFileName: data.sourceFile.sceneFileName,
                        textureFiles: []
                      };

                      // textures
                      for (var _i2 = 0; _i2 < data.sourceFile.textureFiles.length; _i2++) {
                        task.sceneSourceInfo.textureFiles.push({
                          textureID: data.sourceFile.textureFiles[_i2].textureID,
                          fileObjectID: data.sourceFile.textureFiles[_i2].fileObjectID,
                          fileLength: data.sourceFile.textureFiles[_i2].fileLength,
                          url: data.sourceFile.textureFiles[_i2].url
                        });
                      }
                      task.status = SourceTaskStatus.success;
                    } else if (data.state == 3) {
                      // Task server in errore
                      onError(task);
                    } else {
                      // Task server ancora in esecuzione
                      task.status = SourceTaskStatus.progress;
                    }
                  } else {
                    // Risultato non conforme a quello atteso: errore nella chiamata
                    onError(task);
                  }
                },
                error: function error(xhr, ajaxOptions, thrownError) {
                  // Errore nella chiamata ajax
                  onError(task);
                }
              });
            };
            runAjaxCheck(task);
          }

          // TASK con elaborazione server terminata con successo
          if (task.status == SourceTaskStatus.success) {
            // Il task server si è concluso con successo. Il task client contiene
            // i dati sui file generati
            if (!_this11._isLoadingSourceFiles) {
              _this11._isLoadingSourceFiles = true;
              if (task.sceneSourceInfo.rootUrl && task.sceneSourceInfo.sceneFileName) {
                // File di scena sorgente
                _this11.updateSceneModelFromSourceTask(task);

                // Importo i file nella scena Babylon JS corrente
                _this11.loadMeshesFromRemoteFiles(task.sceneSourceInfo.rootUrl, task.sceneSourceInfo.sceneFileName, function (meshes) {
                  if (meshes && Object.prototype.toString.call(meshes) === '[object Array]') {
                    meshes.forEach(function (mesh) {
                      mesh.isPickable = true;
                    });
                  }
                  _this11._isLoadingSourceFiles = false;
                  _this11.fireSceneSourceTaskSuccessEvent(meshes);
                  _this11.fireMeshesUpdateEvent();
                  _this11.fireMaterialsUpdateEvent();
                  _this11.fireLightsUpdateEvent();
                  task.status = SourceTaskStatus.completed_success;
                }, function (reason) {
                  Logger.info("Errore nel caricamento delle mesh: " + reason);
                  _this11._isLoadingSourceFiles = false;
                  _this11.fireSceneSourceTaskErrorEvent(task.taskID);
                  task.status = SourceTaskStatus.completed_error;
                });
              } else {
                Logger.info("Risultato del task di caricamento non valido");
                _this11._isLoadingSourceFiles = false;
                _this11.fireSceneSourceTaskErrorEvent(task.taskID);
                task.status = SourceTaskStatus.completed_error;
              }
              _this11.fireSceneSourceTaskCheckEvent();
            }
          }
          i = _i;
        };
        for (var i = 0; i < this._sceneSourceTasks.length; i++) {
          var runAjaxCheck;
          var _ret = _loop2(i);
          if (_ret === "continue") continue;
        }
      }

      // il metodo verrà richiamato tra mezzo secondo
      setTimeout(function () {
        return _this11.checkSceneSourceTasks();
      }, 500);
    }
  }, {
    key: "updateSceneModelFromSourceTask",
    value: function updateSceneModelFromSourceTask(task) {
      if (this._zkScene) {
        // File di scena sorgente
        var zkSource = new Zakeke.SceneSource();
        zkSource.set("sourceID", task.sceneSourceInfo.sourceID);
        zkSource.set("fileObjectID", task.sceneSourceInfo.fileObjectID);
        zkSource.set("fileLength", task.sceneSourceInfo.fileLength);
        zkSource.set("url", task.sceneSourceInfo.url);
        zkSource.set("rootUrl", task.sceneSourceInfo.rootUrl);
        zkSource.set("sceneFileName", task.sceneSourceInfo.sceneFileName);

        // Textures
        for (var i = 0; i < task.sceneSourceInfo.textureFiles.length; i++) {
          var textureFile = task.sceneSourceInfo.textureFiles[i];
          if (textureFile.textureID && (textureFile.fileObjectID || textureFile.fileLength) && textureFile.url) {
            var zkSourceTexture = new Zakeke.SceneSourceTexture();
            zkSourceTexture.set("textureID", textureFile.textureID);
            zkSourceTexture.set("fileObjectID", textureFile.fileObjectID);
            zkSourceTexture.set("fileLength", textureFile.fileLength);
            zkSourceTexture.set("url", textureFile.url);
            zkSource.get("textures").push(zkSourceTexture);
          }
        }
        this._zkScene.get("sources").push(zkSource);
      }
    }

    // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
    // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
    // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
    // del file di scena
  }, {
    key: "loadMeshesFromRemoteFiles_NEW",
    value: function loadMeshesFromRemoteFiles_NEW(rootUrl, sceneFileName, onSuccess, onError) {
      var _this12 = this;
      if (!this._scene || !this._sceneHelper) {
        if (onError) onError("No scene to fill with imported meshes");
        return;
      }
      var scene = this._scene;
      var sceneHelper = this._sceneHelper;
      var url = rootUrl + sceneFileName;
      sceneHelper.importMeshesFromUrlAsync(url, null, undefined).then(function (meshes) {
        Logger.info("File imported successfully");
        _this12.checkSceneEmptyEnvironmentTexture();
        _this12.refreshEnvironment();
        if (onSuccess) onSuccess(meshes);
      })["catch"](function (error) {
        Logger.info("Error loading file");
        if (onError) onError(error);
      });
      Logger.info("loading finished");
    }

    // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
    // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
    // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
    // del file di scena
  }, {
    key: "loadMeshesFromRemoteFiles",
    value: function loadMeshesFromRemoteFiles(rootUrl, sceneFileName, onSuccess, onError) {
      var _this13 = this;
      if (!this._scene || !this._sceneHelper) {
        if (onError) onError("No scene to fill with imported meshes");
        return;
      }
      var scene = this._scene;
      var sceneHelper = this._sceneHelper;
      var name = sceneFileName;
      var idx = sceneFileName.lastIndexOf(".");
      if (idx !== -1) name = sceneFileName.substr(0, idx);

      // Recupero gli id dei vecchi material in modo da assegnare i nuovi id solo ai nuovi materiali
      var oldMaterialIDs = this._scene.materials.map(function (m) {
        return m.id;
      });

      // Setting up some GLTF values
      var currentPluginName = undefined;
      BABYLON.GLTFFileLoader.IncrementalLoading = false;
      BABYLON.SceneLoader.OnPluginActivatedObservable.add(function (plugin) {
        currentPluginName = plugin.name;
      });
      var loader = new BABYLON.AssetsManager(this._scene);
      var task = loader.addMeshTask("mesh-task", "", rootUrl, sceneFileName);
      task.onSuccess = function (t) {
        Logger.info("task completed successfully");
        var meshes = t.loadedMeshes;

        // creo un gruppo in cui inserire tutte le nuove mesh caricate
        var parent = new BABYLON.Mesh(name, scene);
        parent.id = Zakeke.generateUUID();
        parent.metadata = {
          isRealMesh: true,
          isGroup: true
        };
        meshes.forEach(function (mesh) {
          if (!mesh.parent) mesh.parent = parent;
          if (!mesh.material) mesh.material = new BABYLON.StandardMaterial(mesh.name + "Mat", scene);
          mesh.id = Zakeke.generateUUID();
        });

        // imposto l'id a tutti i nuovi materiali
        scene.materials.forEach(function (material) {
          if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(oldMaterialIDs, material.id)) material.id = Zakeke.generateUUID();
        });
        _this13.checkSceneEmptyEnvironmentTexture();
        _this13.refreshEnvironment();
        sceneHelper.adjustCamera(currentPluginName, false, false);
        sceneHelper.setupShaderMaterialsCameraPosition();
        if (onSuccess) onSuccess(meshes);
      };
      task.onError = function (t, message, exception) {
        Logger.info("task completed with errors");
        if (onError) onError(message);
      };
      loader.onFinish = function () {
        Logger.info("loading finished");
      };

      //loader.loadingUIBackgroundColor = "#2c2b29";
      loader.load();
    }

    // Fine importazione Assets
    // ==============================================================================
  }, {
    key: "isRealMesh",
    value: function isRealMesh(mesh) {
      if (this._sceneHelper) return this._sceneHelper.isRealMesh(mesh);
      return false;
    }
  }, {
    key: "onMeshChanged",
    value: function onMeshChanged(evt) {
      this.updateBoundingBox();
      this.setRenderingNeeded();
    }
  }, {
    key: "onSubMeshChanged",
    value: function onSubMeshChanged(evt) {
      this.updateBoundingBox();
      this.setRenderingNeeded();
    }
  }, {
    key: "onMaterialChanged",
    value: function onMaterialChanged(evt) {
      this.setRenderingNeeded();
    }
  }, {
    key: "onLightChanged",
    value: function onLightChanged(evt) {
      this.setRenderingNeeded();
    }
  }, {
    key: "getSceneMeshesByName",
    value: function getSceneMeshesByName(name) {
      return this._sceneHelper ? this._sceneHelper.getSceneMeshesByName(name) : [];
    }
  }, {
    key: "getSceneMeshes",
    value: function getSceneMeshes() {
      return this._sceneHelper ? this._sceneHelper.getSceneMeshes() : [];
    }
  }, {
    key: "getMeshesUsingMaterial",
    value: function getMeshesUsingMaterial(materialID) {
      return this._sceneHelper ? this._sceneHelper.getMeshesUsingMaterial(materialID) : [];
    }
  }, {
    key: "getMeshesMaterials",
    value: function getMeshesMaterials(meshes) {
      return this._sceneHelper ? this._sceneHelper.getMeshesMaterials(meshes) : [];
    }
  }, {
    key: "getMeshMaterials",
    value: function getMeshMaterials(mesh) {
      return this._sceneHelper ? this._sceneHelper.getMeshMaterials(mesh) : [];
    }
  }, {
    key: "getAllMaterials",
    value: function getAllMaterials() {
      return this._sceneHelper ? this._sceneHelper.getAllMaterials() : [];
    }

    // restituisce un array di gruppi di materiali
    // ogni gruppo è del tipo MaterialGroup, con proprietà 
    // "group"(nome del gruppo) 
    // "materials"(elenco materiali)
  }, {
    key: "getGroupedMaterials",
    value: function getGroupedMaterials() {
      var groups = [];
      var hash = {};
      var materials = this.getAllMaterials();
      for (var i = 0; i < materials.length; i++) {
        var material = materials[i];
        if (material.id == "groundMaterial") continue;
        var _groupName = this.getMaterialGroup(material.id);
        var group = null;
        if (hash.hasOwnProperty(_groupName)) group = hash[_groupName];else {
          group = new MaterialGroup(_groupName);
          groups.push(group);
          hash[_groupName] = group;
        }
        if (group) group.materials.push(material);
      }
      return groups.sort(function (a, b) {
        var nameA = a.groupName.toLowerCase(),
          nameB = b.groupName.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    }

    // Assegna il gruppo ad un array di materiali
  }, {
    key: "setMaterialsGroup",
    value: function setMaterialsGroup(materialIDs, groupName) {
      var fireEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      for (var i = 0; i < materialIDs.length; i++) {
        var _materialID = materialIDs[i];
        this.setMaterialGroup(_materialID, groupName, fireEvent);
      }
    }

    // Assegna il gruppo ad un singolo materiale
  }, {
    key: "setMaterialGroup",
    value: function setMaterialGroup(materialID, groupName) {
      var fireEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!this._scene) return;
      var material = this._scene.getMaterialByID(materialID);
      if (!material) return;
      if (!this._scene.metadata) this._scene.metadata = {};
      if (!this._scene.metadata.groups) this._scene.metadata.groups = {};
      this._scene.metadata.groups[materialID] = groupName;
      if (fireEvent) this.fireMaterialsUpdateEvent();
    }

    // Restituisce il gruppo di un materiale
  }, {
    key: "getMaterialGroup",
    value: function getMaterialGroup(materialID) {
      if (this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(materialID)) {
        return this._scene.metadata.groups[materialID];
      }
      return SceneEditor.EmptyGroupName;
    }

    // Elimina il gruppo di un materiale
  }, {
    key: "removeMaterialGroup",
    value: function removeMaterialGroup(materialID) {
      if (this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(materialID)) {
        delete this._scene.metadata.groups[materialID];
        this.fireMaterialsUpdateEvent();
      }
    }
  }, {
    key: "getMaterialsByGroup",
    value: function getMaterialsByGroup(groupName) {
      var _this14 = this;
      var materials = [];
      var group = !groupName ? SceneEditor.EmptyGroupName : groupName;
      if (this._scene && this._sceneHelper) {
        this._sceneHelper.getAllMaterials().forEach(function (material) {
          var materialGroupName = _this14.getMaterialGroup(material.id);
          if (materialGroupName === group) materials.push(material);
        });
      }
      return materials;
    }
  }, {
    key: "getGroupCenter",
    value: function getGroupCenter(parent) {
      return this._sceneHelper ? this._sceneHelper.getMeshHierarchyCenter(parent) : null;
    }
  }, {
    key: "getGroupBoundingInfo",
    value: function getGroupBoundingInfo(parent) {
      var boundingBox = parent.getHierarchyBoundingVectors(true);
      return new BABYLON.BoundingInfo(boundingBox.min, boundingBox.max);
    }
  }, {
    key: "showHideBoundingBox",
    value: function showHideBoundingBox(show) {
      this._showBoundingBox = show;
      this.updateBoundingBox();
      this.setRenderingNeeded();
    }
  }, {
    key: "updateBoundingBox",
    value: function updateBoundingBox() {
      this.deleteBoundingBox();
      if (!this.showBoundingBox) return;
      this.createSceneBoundingBox(true);
    }
  }, {
    key: "deleteBoundingBox",
    value: function deleteBoundingBox() {
      var bbox = this.getSceneBoundingBox();
      if (bbox) bbox.dispose();
    }
  }, {
    key: "setCameraPositionScale",
    value: function setCameraPositionScale(scale) {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraPositionScale(scale);
        this._sceneHelper.setCameraPositionScale(scale, true);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setCameraLimitLowerRadius",
    value: function setCameraLimitLowerRadius(limit) {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraLimitLowerRadius(limit);
        this._sceneHelper.setCameraLimitLowerRadius(limit, true);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setCameraZoomEnabled",
    value: function setCameraZoomEnabled(enabled) {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraZoomEnabled(enabled);
        this._sceneHelper.setZoomEnabled(enabled);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setCameraUseMinZoomPercentage",
    value: function setCameraUseMinZoomPercentage(value) {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraUseMinZoomPerc(value);
        this._sceneHelper.setMinZoomPerc(value ? this._zkScene.getCameraMinZoomPerc() : undefined);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setCameraMinZoomPercentage",
    value: function setCameraMinZoomPercentage(value) {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraMinZoomPerc(value);
        var use = this._zkScene.getCameraUseMinZoomPerc();
        this._sceneHelper.setMinZoomPerc(use ? value : undefined);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setCameraUseMaxZoomPercentage",
    value: function setCameraUseMaxZoomPercentage(value) {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraUseMaxZoomPerc(value);
        this._sceneHelper.setMaxZoomPerc(value ? this._zkScene.getCameraMaxZoomPerc() : undefined);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setCameraMaxZoomPercentage",
    value: function setCameraMaxZoomPercentage(value) {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraMaxZoomPerc(value);
        var use = this._zkScene.getCameraUseMaxZoomPerc();
        this._sceneHelper.setMaxZoomPerc(use ? value : undefined);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "lockCameraAlphaAngle",
    value: function lockCameraAlphaAngle() {
      if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var angle = this._camera.alpha;
        this._zkScene.setCameraLowerAlphaLimit(angle);
        this._zkScene.setCameraUpperAlphaLimit(angle);
        this._sceneHelper.setCameraAlphaLimits(angle, angle);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "unlockCameraAlphaAngle",
    value: function unlockCameraAlphaAngle() {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraLowerAlphaLimit(null);
        this._zkScene.setCameraUpperAlphaLimit(null);
        this._sceneHelper.setCameraAlphaLimits(null, null);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "lockCameraBetaAngle",
    value: function lockCameraBetaAngle() {
      if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var angle = this._camera.beta;
        this._zkScene.setCameraLowerBetaLimit(angle);
        this._zkScene.setCameraUpperBetaLimit(angle);
        this._sceneHelper.setCameraBetaLimits(angle, angle);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "unlockCameraBetaAngle",
    value: function unlockCameraBetaAngle() {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraLowerBetaLimit(null);
        this._zkScene.setCameraUpperBetaLimit(null);
        this._sceneHelper.setCameraBetaLimits(null, null);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setCameraLowerAlphaLimit",
    value: function setCameraLowerAlphaLimit() {
      if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var angle = this._camera.alpha;
        this._zkScene.setCameraLowerAlphaLimit(angle);
        this._sceneHelper.setCameraLowerAlphaLimit(angle);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "unsetCameraLowerAlphaLimit",
    value: function unsetCameraLowerAlphaLimit() {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraLowerAlphaLimit(null);
        this._sceneHelper.setCameraLowerAlphaLimit(null);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setCameraUpperAlphaLimit",
    value: function setCameraUpperAlphaLimit() {
      if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var angle = this._camera.alpha;
        this._zkScene.setCameraUpperAlphaLimit(angle);
        this._sceneHelper.setCameraUpperAlphaLimit(angle);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "unsetCameraUpperAlphaLimit",
    value: function unsetCameraUpperAlphaLimit() {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraUpperAlphaLimit(null);
        this._sceneHelper.setCameraUpperAlphaLimit(null);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setCameraLowerBetaLimit",
    value: function setCameraLowerBetaLimit() {
      if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var angle = this._camera.beta;
        this._zkScene.setCameraLowerBetaLimit(angle);
        this._sceneHelper.setCameraLowerBetaLimit(angle);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "unsetCameraLowerBetaLimit",
    value: function unsetCameraLowerBetaLimit() {
      if (this._zkScene && this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraLowerBetaLimit(null);
        this._sceneHelper.setCameraLowerBetaLimit(null);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setCameraUpperBetaLimit",
    value: function setCameraUpperBetaLimit() {
      if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var angle = this._camera.beta;
        this._zkScene.setCameraUpperBetaLimit(angle);
        this._sceneHelper.setCameraUpperBetaLimit(angle);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "unsetCameraUpperBetaLimit",
    value: function unsetCameraUpperBetaLimit() {
      if (this._zkScene && this._sceneHelper) {
        this._zkScene.setCameraUpperBetaLimit(null);
        this._sceneHelper.setCameraUpperBetaLimit(null);
        this.setRenderingNeeded();
      }
    }

    // Mesh selection overrides (the selection logic si a little bit different
    // respect the parent SceneViewer one)
  }, {
    key: "selectMesh",
    value: function selectMesh(id) {
      this.selectUnselectMesh(id, true);
    }
  }, {
    key: "unselectMesh",
    value: function unselectMesh(id) {
      this.selectUnselectMesh(id, false);
    }
  }, {
    key: "unselectAllMeshes",
    value: function unselectAllMeshes() {
      var _this15 = this;
      if (this._scene) this._scene.meshes.forEach(function (mesh) {
        return _this15.unselectSingleMesh(mesh);
      });
    }
  }, {
    key: "selectUnselectMesh",
    value: function selectUnselectMesh(id, select) {
      var _this16 = this;
      if (this._scene) {
        this.deleteBoundingBox();
        this.unselectAllMeshes();
        if (select) {
          var selectWithChildren = function selectWithChildren(parent) {
            _this16.selectSingleMesh(parent);
            parent.getChildMeshes().forEach(function (child) {
              return selectWithChildren(child);
            });
          };
          var mesh = this._scene.getMeshByID(id);
          if (mesh) selectWithChildren(mesh);
          this.setManipulatedNode(mesh);
        } else {
          this.setManipulatedNode(null);
        }
        this.fireSelectionChangedEvent();
      }
    }
  }, {
    key: "selectSingleMesh",
    value: function selectSingleMesh(mesh) {
      mesh["selected"] = true;
      this.highlightMesh(mesh, true);
      this.setRenderingNeeded();
    }
  }, {
    key: "unselectSingleMesh",
    value: function unselectSingleMesh(mesh) {
      mesh["selected"] = false;
      this.highlightMesh(mesh, false);
      this.setRenderingNeeded();
    }
  }, {
    key: "isMeshSelected",
    value: function isMeshSelected(mesh) {
      return mesh && mesh["selected"] != undefined && mesh["selected"];
    }

    // Show-hide mesh methods
  }, {
    key: "showMesh",
    value: function showMesh(meshID) {
      this.resetRealVisibility();
      this.showHideMesh(meshID, true, true);
    }
  }, {
    key: "hideMesh",
    value: function hideMesh(meshID) {
      this.resetRealVisibility();
      this.showHideMesh(meshID, false, true);
    }
  }, {
    key: "showHideMesh",
    value: function showHideMesh(meshID, show) {
      var _this17 = this;
      var notifyChanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (this._scene && this._sceneHelper && this._camera) {
        var scene = this._scene;
        var sceneHelper = this._sceneHelper;
        var camera = this._camera;
        var showHideWithChildren = function showHideWithChildren(parent, show) {
          parent.isVisible = show;
          Logger.info(parent.name);
          parent.getChildMeshes().forEach(function (child) {
            return showHideWithChildren(child, show);
          });
        };
        var showHide = function showHide(mesh, show) {
          showHideWithChildren(mesh, show);
          var tryAdjustCamera = !(sceneHelper && camera && mesh.metadata && mesh.metadata.isGroup && mesh.getChildMeshes().length === 0);
          if (tryAdjustCamera && show && !camera.isCompletelyInFrustum(mesh)) {
            sceneHelper.adjustCamera(undefined, false, false);
            sceneHelper.setupShaderMaterialsCameraPosition();
          }
          if (notifyChanges) _this17.fireMeshesUpdateEvent();
          _this17.setRenderingNeeded();
        };
        var mesh = this._scene.getMeshByID(meshID);
        if (mesh) {
          var _this$_zkScene2;
          var rootUrl = (_this$_zkScene2 = this._zkScene) === null || _this$_zkScene2 === void 0 ? void 0 : _this$_zkScene2.get("rootUrl");
          if (rootUrl) {
            sceneHelper.unsetMeshDummyMaterialAsync(mesh, rootUrl, true).then(function () {
              return showHide(mesh, show);
            });
          } else {
            showHide(mesh, show);
          }
        }
        this.refreshInfoPoints();
      }
    }

    // Permette di mostrare esclusivamente la mesh selezionata (e i suoi figli)
    // Lo stato precedente delle mesh viene memorizzato in modo da poter essere
    // ripristinato con la funzione resetRealVisibility
  }, {
    key: "setTemporaryExclusivelyVisible",
    value: function setTemporaryExclusivelyVisible(meshID) {
      var _this18 = this;
      if (this._scene) {
        // Salvo la reale visibilità delle mesh
        this.resetRealVisibility();
        this._realMeshVisibility = {};
        this._scene.meshes.forEach(function (mesh) {
          _this18._realMeshVisibility[mesh.id] = mesh.isVisible;
          if (_this18.isRealMesh(mesh)) mesh.isVisible = false;
        });
        this.showHideMesh(meshID, true, false);
      }
    }

    // Reimposto lo stato di visibilità come era precedentemente alla chiamata
    // a setTempraryExclusiveVisible
  }, {
    key: "resetRealVisibility",
    value: function resetRealVisibility() {
      var _this19 = this;
      if (this._scene && this._sceneHelper && this._realMeshVisibility) {
        var _meshes = this._sceneHelper.getSceneMeshes();
        _meshes.forEach(function (mesh) {
          if (_this19._realMeshVisibility.hasOwnProperty(mesh.id)) {
            mesh.isVisible = _this19._realMeshVisibility[mesh.id];
          }
        });

        /*
        this._scene.meshes.forEach(mesh => mesh.isVisible = this._realMeshVisibility[mesh.id]);
        this._realMeshVisibility = {};
        */
        this.setRenderingNeeded();
      }
    }

    // Funzione per modificare il colore di un materiale in modo progressivo (tramite animazione)
  }, {
    key: "changeMaterialColor",
    value: function changeMaterialColor(material, propertyName, nextColor) {
      if (this._sceneHelper) this._sceneHelper.changeMaterialColor(material, propertyName, nextColor);
    }
  }, {
    key: "renameMesh",
    value: function renameMesh(id, name) {
      if (this._scene) {
        var mesh = this._scene.getMeshByID(id);
        if (mesh) {
          mesh.name = name;
          this.fireMeshesUpdateEvent();
        }
      }
    }

    //#region Events

    // PreUpdateEvent
  }, {
    key: "firePreUpdateEvent",
    value: function firePreUpdateEvent() {
      this._preUpdateListeners.forEach(function (handler) {
        return handler();
      });
    }
  }, {
    key: "addPreUpdateListener",
    value: function addPreUpdateListener(listenerFunction) {
      this._preUpdateListeners.push(listenerFunction);
    }
  }, {
    key: "removePreUpdateListener",
    value: function removePreUpdateListener(listenerFunction) {
      for (var i = 0; i < this._preUpdateListeners.length; i++) {
        var listener = this._preUpdateListeners[i];
        if (listener == listenerFunction) {
          this._preUpdateListeners.splice(i--, 1);
          break;
        }
      }
    }

    // PostUpdateEvent
  }, {
    key: "firePostUpdateEvent",
    value: function firePostUpdateEvent() {
      this._postUpdateListeners.forEach(function (handler) {
        return handler();
      });
    }
  }, {
    key: "addPostUpdateListener",
    value: function addPostUpdateListener(listenerFunction) {
      this._postUpdateListeners.push(listenerFunction);
    }
  }, {
    key: "removePostUpdateListener",
    value: function removePostUpdateListener(listenerFunction) {
      for (var i = 0; i < this._postUpdateListeners.length; i++) {
        var listener = this._postUpdateListeners[i];
        if (listener == listenerFunction) {
          this._postUpdateListeners.splice(i--, 1);
          break;
        }
      }
    }

    // MeshSelected
  }, {
    key: "fireMeshSelectedEvent",
    value: function fireMeshSelectedEvent(e) {
      this._meshSelectedListeners.forEach(function (handler) {
        return handler(e);
      });
    }
  }, {
    key: "addMeshSelectedListener",
    value: function addMeshSelectedListener(listenerFunction) {
      this._meshSelectedListeners.push(listenerFunction);
    }

    // SelectionChanged
  }, {
    key: "fireSelectionChangedEvent",
    value: function fireSelectionChangedEvent() {
      this._selectionChangedListeners.forEach(function (handler) {
        return handler();
      });
    }
  }, {
    key: "addSelectionChangedListener",
    value: function addSelectionChangedListener(listenerFunction) {
      this._selectionChangedListeners.push(listenerFunction);
    }

    // LightsSelected
  }, {
    key: "fireLightSelectedEvent",
    value: function fireLightSelectedEvent(e) {
      this._lightSelectedListeners.forEach(function (handler) {
        return handler(e);
      });
    }
  }, {
    key: "addLightSelectedListener",
    value: function addLightSelectedListener(listenerFunction) {
      this._lightSelectedListeners.push(listenerFunction);
    }

    // SceneCreated
  }, {
    key: "fireSceneCreatedEvent",
    value: function fireSceneCreatedEvent() {
      this._sceneCreatedListeners.forEach(function (handler) {
        return handler();
      });
    }
  }, {
    key: "addSceneCreatedListener",
    value: function addSceneCreatedListener(listenerFunction) {
      this._sceneCreatedListeners.push(listenerFunction);
    }

    // CameraLocationCreated
  }, {
    key: "fireCameraLocationCreatedEvent",
    value: function fireCameraLocationCreatedEvent(e) {
      this._cameraLocationCreatedListeners.forEach(function (handler) {
        return handler(e);
      });
    }
  }, {
    key: "addCameraLocationCreatedListener",
    value: function addCameraLocationCreatedListener(listenerFunction) {
      this._cameraLocationCreatedListeners.push(listenerFunction);
    }

    // CameraLocationsUpdate
  }, {
    key: "fireCameraLocationsUpdateEvent",
    value: function fireCameraLocationsUpdateEvent(locations) {
      if (!locations && this._scene) locations = this.getAllCameraLocations();
      if (!locations) throw "Failed firing positions update event: lights are null and no scene present";
      this._cameraLocationsUpdateListeners.forEach(function (handler) {
        return handler(locations);
      });
    }
  }, {
    key: "addCameraLocationsUpdateListener",
    value: function addCameraLocationsUpdateListener(listenerFunction) {
      this._cameraLocationsUpdateListeners.push(listenerFunction);
    }

    // SceneSourceTaskSuccess
  }, {
    key: "fireSceneSourceTaskSuccessEvent",
    value: function fireSceneSourceTaskSuccessEvent(meshes) {
      this._sceneSourceTaskSuccessListeners.forEach(function (handler) {
        return handler(meshes);
      });
    }
  }, {
    key: "addSceneSourceTaskSuccessListener",
    value: function addSceneSourceTaskSuccessListener(listenerFunction) {
      this._sceneSourceTaskSuccessListeners.push(listenerFunction);
    }

    // SceneSourceTaskError
  }, {
    key: "fireSceneSourceTaskErrorEvent",
    value: function fireSceneSourceTaskErrorEvent(taskID) {
      this._sceneSourceTaskErrorListeners.forEach(function (handler) {
        return handler(taskID);
      });
    }
  }, {
    key: "addSceneSourceTaskErrorListener",
    value: function addSceneSourceTaskErrorListener(listenerFunction) {
      this._sceneSourceTaskErrorListeners.push(listenerFunction);
    }
  }, {
    key: "removeSceneSourceTaskErrorListener",
    value: function removeSceneSourceTaskErrorListener(listenerFunction) {
      var idx = this._sceneSourceTaskErrorListeners.indexOf(listenerFunction);
      if (idx != -1) this._sceneSourceTaskErrorListeners.splice(idx, 1);
    }

    // SceneSourceTaskCheck
  }, {
    key: "fireSceneSourceTaskCheckEvent",
    value: function fireSceneSourceTaskCheckEvent() {
      this._sceneSourceTasksCheckListeners.forEach(function (handler) {
        return handler();
      });
    }
  }, {
    key: "addSceneSourceTaskCheckListener",
    value: function addSceneSourceTaskCheckListener(listenerFunction) {
      this._sceneSourceTasksCheckListeners.push(listenerFunction);
    }

    // MeshesUpdate
  }, {
    key: "fireMeshesUpdateEvent",
    value: function fireMeshesUpdateEvent(meshes) {
      if (!meshes && this._scene) meshes = this.getSceneMeshes();
      if (!meshes) throw "Failed firing mesh update event: meshes are null and no scene present";
      this._meshesUpdateListeners.forEach(function (handler) {
        return handler(meshes);
      });
    }
  }, {
    key: "addMeshesUpdateListener",
    value: function addMeshesUpdateListener(listenerFunction) {
      this._meshesUpdateListeners.push(listenerFunction);
    }

    // MaterialsUpdate
  }, {
    key: "fireMaterialsUpdateEvent",
    value: function fireMaterialsUpdateEvent(materials) {
      if (!materials && this._scene) materials = this.getGroupedMaterials();
      if (!materials) throw "Failed firing materials update event: materials are null and no scene present";
      this._materialsUpdateListeners.forEach(function (handler) {
        return handler(materials);
      });
    }
  }, {
    key: "addMaterialsUpdateListener",
    value: function addMaterialsUpdateListener(listenerFunction) {
      this._materialsUpdateListeners.push(listenerFunction);
    }

    // LighsUpdate
  }, {
    key: "fireLightsUpdateEvent",
    value: function fireLightsUpdateEvent(lights) {
      if (!lights && this._scene) lights = this.getAllLights();
      if (!lights) throw "Failed firing lights update event: lights are null and no scene present";
      this._lightsUpdateListeners.forEach(function (handler) {
        return handler(lights);
      });
    }
  }, {
    key: "addLightsUpdateListener",
    value: function addLightsUpdateListener(listernerFunction) {
      this._lightsUpdateListeners.push(listernerFunction);
    }

    // MeshLocationCreated
  }, {
    key: "fireMeshLocationCreatedEvent",
    value: function fireMeshLocationCreatedEvent(location) {
      this._meshLocationCreatedListeners.forEach(function (handler) {
        return handler(location);
      });
    }
  }, {
    key: "addMeshLocationCreatedListener",
    value: function addMeshLocationCreatedListener(listenerFunction) {
      this._meshLocationCreatedListeners.push(listenerFunction);
    }

    // MeshLocationsUpdate
  }, {
    key: "fireMeshLocationsUpdateEvent",
    value: function fireMeshLocationsUpdateEvent(locations) {
      if (!locations && this._scene) locations = this.getAllMeshLocations();
      if (locations) this._meshLocationsUpdateListeners.forEach(function (handler) {
        return handler(locations);
      });else throw "Failed firing mesh positions update event: positions are null and no scene present";
    }
  }, {
    key: "addMeshLocatonsUpdateListener",
    value: function addMeshLocatonsUpdateListener(listenerFunction) {
      this._meshLocationsUpdateListeners.push(listenerFunction);
    }

    // ArTaskSuccess
  }, {
    key: "fireArTaskSuccessEvent",
    value: function fireArTaskSuccessEvent() {
      this._arTaskSuccessListeners.forEach(function (handler) {
        return handler();
      });
    }
  }, {
    key: "addArTaskSuccessListener",
    value: function addArTaskSuccessListener(listenerFunction) {
      this._arTaskSuccessListeners.push(listenerFunction);
    }

    // ArTaskError
  }, {
    key: "fireArTaskErrorEvent",
    value: function fireArTaskErrorEvent() {
      this._arTaskErrorListeners.forEach(function (handler) {
        return handler();
      });
    }
  }, {
    key: "addArTaskErrorListener",
    value: function addArTaskErrorListener(listenerFunction) {
      this._arTaskErrorListeners.push(listenerFunction);
    }

    // ArTaskCheck
  }, {
    key: "fireArTaskCheckEvent",
    value: function fireArTaskCheckEvent() {
      this._arTasksCheckListeners.forEach(function (handler) {
        return handler();
      });
    }
  }, {
    key: "addArTaskCheckListener",
    value: function addArTaskCheckListener(listenerFunction) {
      this._arTasksCheckListeners.push(listenerFunction);
    }

    // Clear
  }, {
    key: "clearListeners",
    value: function clearListeners() {
      this._meshSelectedListeners = [];
      this._selectionChangedListeners = [];
      this._lightSelectedListeners = [];
      this._sceneCreatedListeners = [];
      this._cameraLocationCreatedListeners = [];
      this._sceneSourceTaskSuccessListeners = [];
      this._sceneSourceTaskErrorListeners = [];
      this._sceneSourceTasksCheckListeners = [];
      this._meshesUpdateListeners = [];
      this._materialsUpdateListeners = [];
      this._lightsUpdateListeners = [];
      this._cameraLocationsUpdateListeners = [];
      this._meshLocationCreatedListeners = [];
      this._meshLocationsUpdateListeners = [];
      this._arTaskSuccessListeners = [];
      this._arTaskErrorListeners = [];
      this._arTasksCheckListeners = [];
    }

    //#endregion

    //#region Interazione utente (Pointer Down/Move)
  }, {
    key: "onPointerDown",
    value: function onPointerDown(evt, pickInfo) {
      if (!this._scene || !this._sceneHelper || this._envMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) {
        return;
      }
      if (this._selectOnPick) {
        if (pickInfo && pickInfo.hit && pickInfo.pickedMesh && pickInfo.pickedMesh !== this._ground) {
          this.selectMesh(pickInfo.pickedMesh.id);
          var screenPoint = this.convertSceneToScreenPoint(this._scene.pointerX, this._scene.pointerY);
          if (screenPoint) {
            var event = {
              name: pickInfo.pickedMesh.name,
              id: pickInfo.pickedMesh.id,
              scenePointerX: this._scene.pointerX,
              scenePointerY: this._scene.pointerY,
              screenPointerX: screenPoint.X,
              screenPointerY: screenPoint.Y
            };
            this.fireMeshSelectedEvent(event);
          }
        }
      }
    }
  }, {
    key: "onPointerMove",
    value: function onPointerMove(evt, pickInfo) {
      if (!this._scene || !this._sceneHelper || this._envMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) return;
      this.highlightMeshOver(false);
      if (!this._highlightOver) {
        this._meshOver = null;
        return;
      }
      var info = this._scene.pick(this._scene.pointerX, this._scene.pointerY);
      if (info && info.hit && info.pickedMesh && this._sceneHelper.isRealMesh(info.pickedMesh)) {
        this._meshOver = info.pickedMesh;
        this.highlightMeshOver(true);
      }
    }
    //#endregion

    //#region Element Selection
  }, {
    key: "getSubMesh",
    value: function getSubMesh(mesh, submeshIdx) {
      if (this._sceneHelper) return this._sceneHelper.getSubMesh(mesh, submeshIdx);
      return null;
    }
  }, {
    key: "getLightByID",
    value: function getLightByID(id) {
      if (this._scene) return this._scene.getLightByID(id);
      return null;
    }
    //#endregion

    //#region Apply material
  }, {
    key: "applyMaterialByName",
    value: function applyMaterialByName(name, mesh) {
      if (this._sceneHelper) this._sceneHelper.applyMaterialByName(name, mesh);
    }
  }, {
    key: "applyMaterial",
    value: function applyMaterial(material, mesh) {
      if (this._sceneHelper) {
        this._sceneHelper.applyMaterial(material, mesh);
        this.setLongRenderingNeeded();
      }
    }
  }, {
    key: "applyMaterialToSubMeshByName",
    value: function applyMaterialToSubMeshByName(name, mesh, subMesh) {
      if (this._sceneHelper) this._sceneHelper.applyMaterialToSubMeshByName(name, mesh, subMesh);
    }
  }, {
    key: "applyMaterialToSubMesh",
    value: function applyMaterialToSubMesh(material, mesh, subMesh) {
      if (this._sceneHelper) this._sceneHelper.applyMaterialToSubMesh(material, mesh, subMesh);
    }
  }, {
    key: "resetMeshMaterial",
    value: function resetMeshMaterial(mesh, initial) {
      var _this20 = this;
      var hash = initial ? this._initialMeshMaterials : this._lastMeshMaterials;
      var resetWithChildren = function resetWithChildren(parent) {
        if (parent.subMeshes && parent.subMeshes.length > 0 && parent.material && parent.material instanceof BABYLON.MultiMaterial) {
          for (var i = 0; i < parent.subMeshes.length; i++) {
            var subMesh = parent.subMeshes[i];
            _this20.resetSubMeshMaterial(parent, subMesh, initial);
          }
        } else {
          if (hash.hasOwnProperty(parent.id)) {
            var _materialID2 = hash[parent.id];
            if (_materialID2) {
              var material = _this20.getMaterialByID(_materialID2);
              if (material) parent.material = material;
            }
          }
        }
        parent.getChildMeshes().forEach(function (child) {
          return resetWithChildren(child);
        });
      };
    }
  }, {
    key: "resetSubMeshMaterial",
    value: function resetSubMeshMaterial(mesh, subMesh, initial) {
      var hash = initial ? this._initialSubMeshMaterials : this._lastSubMeshMaterials;
      if (mesh && subMesh && mesh.material instanceof BABYLON.MultiMaterial) {
        var idx = subMesh.materialIndex;
        if (idx >= 0 && idx < mesh.material.subMaterials.length) {
          var key = "".concat(mesh.id, "_").concat(idx);
          if (hash.hasOwnProperty(key)) {
            var _materialID3 = hash[key];
            var material = this.getMaterialByID(_materialID3);
            if (material) mesh.material.subMaterials[idx] = material;
          }
        }
      }
      this.setRenderingNeeded();
    }
    //#endregion
  }, {
    key: "getExtension",
    value: function getExtension(name) {
      var idx = name.lastIndexOf(".");
      if (idx !== -1) {
        var ext = name.substring(idx).toLowerCase();
        return ext;
      }
    }

    //#region Caricamento texture da file esterni
  }, {
    key: "loadMobileTextureFilesAsync",
    value: function loadMobileTextureFilesAsync(filesToLoad, material, type) {
      var _this21 = this;
      return new Promise(function (resolve, reject) {
        _this21.loadMobileTextureFiles(filesToLoad, material, type, function () {
          return resolve();
        }, function (reason) {
          return reject();
        });
      });
    }
  }, {
    key: "loadMobileTextureFiles",
    value: function loadMobileTextureFiles(filesToLoad, material, type, onSuccess, onError) {
      var _this22 = this;
      var isCubemap = filesToLoad.length === 6 || this.getExtension(filesToLoad[0].name) === ".dds" || this.getExtension(filesToLoad[0].name) === ".hdr" || this.getExtension(filesToLoad[0].name) === ".env" || this.getExtension(filesToLoad[0].name) === ".basis";
      this.uploadTextureFiles(filesToLoad, material, type, function (zkSceneTextures) {
        if (zkSceneTextures.length > 0) {
          if (isCubemap) _this22.setMobileCubeTextureImages(zkSceneTextures, material, type);else _this22.setMobileTextureImage(zkSceneTextures[0], material, type);
        }
        if (onSuccess) onSuccess();
      }, onError, false);
    }
  }, {
    key: "loadTextureFilesAsync",
    value: function loadTextureFilesAsync(filesToLoad, material, type) {
      var _this23 = this;
      return new Promise(function (resolve, reject) {
        _this23.loadTextureFiles(filesToLoad, material, type, function () {
          return resolve();
        }, function (reason) {
          return reject(reason);
        });
      });
    }

    // Per il caso di texture di ambiente si suppone che material sia null e che type sia
    // uno di "environment", "skybox", "ground"
  }, {
    key: "loadTextureFiles",
    value: function loadTextureFiles(filesToLoad, material, type, onSuccess, onError) {
      var _this24 = this;
      var isCubemap = filesToLoad.length === 6 || this.getExtension(filesToLoad[0].name) === ".dds" || this.getExtension(filesToLoad[0].name) === ".hdr" || this.getExtension(filesToLoad[0].name) === ".env" || this.getExtension(filesToLoad[0].name) === ".basis";
      this.uploadTextureFiles(filesToLoad, material, type, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(zkSceneTextures) {
          return _regeneratorRuntime().wrap(function _callee10$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                if (!(zkSceneTextures.length > 0)) {
                  _context11.next = 12;
                  break;
                }
                if (!isCubemap) {
                  _context11.next = 6;
                  break;
                }
                _context11.next = 4;
                return _this24.setCubeTextureImages(zkSceneTextures, material, type);
              case 4:
                _context11.next = 11;
                break;
              case 6:
                _context11.next = 8;
                return _this24.setTextureImage(zkSceneTextures[0], material, type);
              case 8:
                if (!(!material[type + "Texture"].metadata || !material[type + "Texture"].metadata.mobileUrl)) {
                  _context11.next = 11;
                  break;
                }
                _context11.next = 11;
                return new Promise( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(resolve) {
                    return _regeneratorRuntime().wrap(function _callee9$(_context10) {
                      while (1) switch (_context10.prev = _context10.next) {
                        case 0:
                          _this24.uploadTextureFiles(filesToLoad, material, type, /*#__PURE__*/function () {
                            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(zkSceneTextures) {
                              return _regeneratorRuntime().wrap(function _callee8$(_context9) {
                                while (1) switch (_context9.prev = _context9.next) {
                                  case 0:
                                    _this24.setMobileTextureImage(zkSceneTextures[0], material, type);
                                    resolve();
                                  case 2:
                                  case "end":
                                    return _context9.stop();
                                }
                              }, _callee8);
                            }));
                            return function (_x14) {
                              return _ref3.apply(this, arguments);
                            };
                          }(), onError, true);
                        case 1:
                        case "end":
                          return _context10.stop();
                      }
                    }, _callee9);
                  }));
                  return function (_x13) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              case 11:
                if (onSuccess) {
                  onSuccess();
                }
              case 12:
              case "end":
                return _context11.stop();
            }
          }, _callee10);
        }));
        return function (_x12) {
          return _ref.apply(this, arguments);
        };
      }(), onError, false);
    }
  }, {
    key: "uploadTextureFileAsync",
    value: function uploadTextureFileAsync(fileToLoad, material) {
      var _this25 = this;
      return new Promise(function (resolve, reject) {
        if (!_this25._scene || !_this25._zkScene || !fileToLoad) {
          resolve(null);
          return;
        }
        var materialID = material ? material.id : Zakeke.getEmptyUUID();

        // Crea l'oggetto backbone relativo alla texture caricata
        var createZkSceneTexture = function createZkSceneTexture(data) {
          if (_this25._zkScene && data && data.textureID && data.materialID && (data.fileObjectID || data.fileLength) && data.url) {
            var zkSceneTexture = new Zakeke.SceneTexture();
            zkSceneTexture.set("textureID", data.textureID);
            zkSceneTexture.set("materialID", data.materialID);
            zkSceneTexture.set("fileObjectID", data.fileObjectID);
            zkSceneTexture.set("fileLength", data.fileLength);
            zkSceneTexture.set("url", data.url);
            _this25._zkScene.get("textures").push(zkSceneTexture);
            return zkSceneTexture;
          }
          return null;
        };

        // Upload dei file
        var data = new FormData();
        data.append('file', fileToLoad);
        jQuery.ajax({
          url: _this25.getTexturesUploadUrl(materialID),
          data: data,
          cache: false,
          contentType: false,
          processData: false,
          type: 'POST',
          success: function () {
            var _success = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(data) {
              var zkSceneTextures, zkSceneTexture;
              return _regeneratorRuntime().wrap(function _callee11$(_context12) {
                while (1) switch (_context12.prev = _context12.next) {
                  case 0:
                    zkSceneTextures = [];
                    if (Object.prototype.toString.call(data) === '[object Array]') {
                      zkSceneTexture = createZkSceneTexture(data[0]);
                      if (zkSceneTexture) resolve(zkSceneTexture);else reject("Immagine non valida");
                    } else reject("Immagine non valida");
                  case 2:
                  case "end":
                    return _context12.stop();
                }
              }, _callee11);
            }));
            function success(_x15) {
              return _success.apply(this, arguments);
            }
            return success;
          }(),
          error: function error(xhr, textStatus, errorThrown) {
            var msg = "An error occurred: " + textStatus + " Error: " + errorThrown;
            reject(msg);
          }
        });
      });
    }
  }, {
    key: "uploadTextureFiles",
    value: function uploadTextureFiles(filesToLoad, material, type, onSuccess, onError, resize) {
      var _this26 = this;
      if (!this._scene || !this._zkScene || !filesToLoad || filesToLoad.length == 0) return;
      var materialID = material ? material.id : Zakeke.getEmptyUUID();

      // Crea l'oggetto backbone relativo alla texture caricata
      var createZkSceneTexture = function createZkSceneTexture(data) {
        if (_this26._zkScene && data && data.textureID && data.materialID && (data.fileObjectID || data.fileLength) && data.url) {
          var zkSceneTexture = new Zakeke.SceneTexture();
          zkSceneTexture.set("textureID", data.textureID);
          zkSceneTexture.set("materialID", data.materialID);
          zkSceneTexture.set("fileObjectID", data.fileObjectID);
          zkSceneTexture.set("fileLength", data.fileLength);
          zkSceneTexture.set("url", data.url);
          _this26._zkScene.get("textures").push(zkSceneTexture);
          return zkSceneTexture;
        }
        return null;
      };

      // Recupero estensione file
      var getExtension = function getExtension(name) {
        var idx = name.lastIndexOf(".");
        if (idx !== -1) return name.substring(idx);
        return null;
      };

      // Determina se il nome ha uno dei suffissi standard per le cubmap
      // Le immagini per le cubemap sono 6 e il nome presenta uno dei suffissi "px,py,pz,nx,ny,nz"
      var isCubeImage = function isCubeImage(name, suffix) {
        var idx = name.lastIndexOf(".");
        if (idx !== -1) {
          var nameWithoutExt = name.substring(0, idx);
          return nameWithoutExt.endsWith("_" + suffix);
        }
        return false;
      };

      // Viene identificata come cubemap anche una mappa d'ambiente nel formato dds o hdr
      var firstFileExt = getExtension(filesToLoad[0].name);
      var isCubemap = this.canLoadCubemap(material, type) && (filesToLoad.length == 6 || firstFileExt === ".dds" || firstFileExt === ".hdr" || firstFileExt === ".env" || firstFileExt === ".basis");
      var files = [];
      if (isCubemap && filesToLoad.length == 6) {
        // verfico che ci siano tutte le estensioni accettate dalla cubemap
        var suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
        for (var k = 0; k < filesToLoad.length; k++) {
          var _file2 = filesToLoad[k];
          var lastIdx = -1;
          for (var i = 0; i < suffixes.length; i++) {
            if (isCubeImage(_file2.name, suffixes[i])) {
              files.push(_file2);
              lastIdx = i;
              break;
            }
          }
          if (lastIdx !== -1) suffixes.splice(lastIdx, 1);
        }
        if (suffixes.length != 0) {
          var msg = "Immagini per la cube map non valide";
          if (onError) onError(msg);
          Logger.info(msg);
          return;
        }
      } else {
        // Carico solo la prima selezionata
        files.push(filesToLoad[0]);
      }

      // Upload dei file
      var data = new FormData();
      for (var _i3 = 0; _i3 < files.length; _i3++) {
        data.append('file-' + _i3, files[_i3]);
      }
      jQuery.ajax({
        url: this.getTexturesUploadUrl(materialID) + "?resize=" + resize,
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        type: 'POST',
        success: function () {
          var _success2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(data) {
            var zkSceneTextures, _i4, zkSceneTexture, _msg;
            return _regeneratorRuntime().wrap(function _callee12$(_context13) {
              while (1) switch (_context13.prev = _context13.next) {
                case 0:
                  // Costruisco l'array di Zakeke.SceneTexture
                  zkSceneTextures = [];
                  if (!(Object.prototype.toString.call(data) === '[object Array]')) {
                    _context13.next = 14;
                    break;
                  }
                  _i4 = 0;
                case 3:
                  if (!(_i4 < data.length)) {
                    _context13.next = 14;
                    break;
                  }
                  zkSceneTexture = createZkSceneTexture(data[_i4]);
                  if (zkSceneTexture) {
                    _context13.next = 10;
                    break;
                  }
                  _msg = "Immagini non valide";
                  if (!onError) {
                    _context13.next = 10;
                    break;
                  }
                  onError(_msg);
                  return _context13.abrupt("return");
                case 10:
                  if (zkSceneTexture) zkSceneTextures.push(zkSceneTexture);
                case 11:
                  _i4++;
                  _context13.next = 3;
                  break;
                case 14:
                  if (onSuccess) onSuccess(zkSceneTextures);
                case 15:
                case "end":
                  return _context13.stop();
              }
            }, _callee12);
          }));
          function success(_x16) {
            return _success2.apply(this, arguments);
          }
          return success;
        }(),
        error: function error(xhr, textStatus, errorThrown) {
          var msg = "An error occurred: " + textStatus + " Error: " + errorThrown;
          if (onError) onError(msg);
        }
      });
    }
  }, {
    key: "getTexturesUploadUrl",
    value: function getTexturesUploadUrl(materialID) {
      if (this._zkScene) return this._zkScene.getTexturesUrl(materialID);
      return "";
    }
  }, {
    key: "removeAllMaterialPhotos",
    value: function removeAllMaterialPhotos(material) {
      if (this._zkScene) {
        var toRemove = [];
        for (var i = 0; i < this._zkScene.get("materialPhotos").length; i++) {
          if (this._zkScene.get("materialPhotos").at(i).get("materialID") === material.id) toRemove.push(this._zkScene.get("materialPhotos").at(i));
        }
        if (toRemove.length > 0) this._zkScene.get("materialPhotos").remove(toRemove);
      }
    }
  }, {
    key: "removeMaterialPhotoAtIndex",
    value: function removeMaterialPhotoAtIndex(material, index) {
      if (this._zkScene) {
        var materialPhotos = [];
        for (var i = 0; i < this._zkScene.get("materialPhotos").length; i++) {
          if (this._zkScene.get("materialPhotos").at(i).get("materialID") === material.id) materialPhotos.push(this._zkScene.get("materialPhotos").at(i));
        }
        if (materialPhotos.length > 0) {
          var materialPhoto = materialPhotos[index];
          this._zkScene.get("materialPhotos").remove(materialPhoto);
        }
      }
    }
  }, {
    key: "loadMaterialPhotoFiles",
    value: function loadMaterialPhotoFiles(filesToLoad, material, onSuccess, onError) {
      var _this27 = this;
      this.uploadMaterialPhotoFiles(filesToLoad, material, function (zkSceneMaterialPhotos) {
        _this27.refreshInfoPoints();
        if (onSuccess) onSuccess();
      }, onError);
    }
  }, {
    key: "uploadMaterialPhotoFiles",
    value: function uploadMaterialPhotoFiles(filesToLoad, material, onSuccess, onError) {
      var _this28 = this;
      if (!this._scene || !this._zkScene || !filesToLoad || filesToLoad.length === 0) return;
      var materialID = material.id;

      // Crea l'oggetto backbone relativo alla photo caricata
      var createZkSceneMaterialPhoto = function createZkSceneMaterialPhoto(data) {
        if (_this28._zkScene && data && data.photoID && data.materialID && (data.fileObjectID || data.fileLength) && data.url) {
          var zkSceneMaterialPhoto = new Zakeke.SceneMaterialPhoto();
          zkSceneMaterialPhoto.set("photoID", data.photoID);
          zkSceneMaterialPhoto.set("materialID", data.materialID);
          zkSceneMaterialPhoto.set("fileObjectID", data.fileObjectID);
          zkSceneMaterialPhoto.set("fileLength", data.fileLength);
          zkSceneMaterialPhoto.set("url", data.url);
          _this28._zkScene.get("materialPhotos").push(zkSceneMaterialPhoto);
          return zkSceneMaterialPhoto;
        }
        return null;
      };

      // Recupero estensione file
      var getExtension = function getExtension(name) {
        var idx = name.lastIndexOf(".");
        if (idx !== -1) return name.substring(idx);
        return null;
      };

      // Upload dei file
      var data = new FormData();
      for (var i = 0; i < filesToLoad.length; i++) {
        var ext = getExtension(filesToLoad[i].name);
        if (ext === ".png" || ext === ".jpg") data.append('file-' + i, filesToLoad[i]);
      }
      jQuery.ajax({
        url: this.getMaterialPhotosUploadUrl(materialID),
        data: data,
        cache: false,
        contentType: false,
        processData: false,
        type: 'POST',
        success: function success(data) {
          // Costruisco l'array di Zakeke.SceneMaterialPhoto
          var zkSceneMaterialPhotos = [];
          if (Object.prototype.toString.call(data) === '[object Array]') {
            for (var _i5 = 0; _i5 < data.length; _i5++) {
              var zkSceneMaterialPhoto = createZkSceneMaterialPhoto(data[_i5]);
              if (!zkSceneMaterialPhoto) {
                var msg = "Immagini non valide";
                if (onError) {
                  onError(msg);
                  return;
                }
              }
              if (zkSceneMaterialPhoto) zkSceneMaterialPhotos.push(zkSceneMaterialPhoto);
            }
          }
          if (onSuccess) onSuccess(zkSceneMaterialPhotos);
        },
        error: function error(xhr, textStatus, errorThrown) {
          var msg = "An error occurred: " + textStatus + " Error: " + errorThrown;
          if (onError) onError(msg);
        }
      });
    }
  }, {
    key: "getMaterialPhotosUploadUrl",
    value: function getMaterialPhotosUploadUrl(materialID) {
      if (this._zkScene) return this._zkScene.getMaterialPhotosUrl(materialID);
      return "";
    }

    // Verifica se il material può caricare una cubemap per il tipo di proprietà specificato (type)
  }, {
    key: "canLoadCubemap",
    value: function canLoadCubemap(material, type) {
      // Environment
      if (!material) return type == "environment" || type == "skybox";

      // Material
      if (material instanceof BABYLON.StandardMaterial && (type == "reflection" || type == "refraction")) return true;
      if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
        return type === "environment";
      }
      if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
        return type === "environment";
      }
      if (material instanceof BABYLON.PBRMaterial) {
        return type === "reflection";
      }
      if (material instanceof Zakeke.PBRMaterial) {
        return type === "reflection";
      }
      /*
      if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
          return type == "environment" ||
              type == "normal" ||
              type == "emissive" ||
              type == "occlusion" ||
              type == "base" ||
              type == "metallicRoughness";
      }
        if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
          return type == "environment" ||
              type == "normal" ||
              type == "emissive" ||
              type == "occlusion" ||
              type == "diffuse" ||
              type == "specularGlossiness";
      }
        if (material instanceof BABYLON.PBRMaterial) {
          return type === "albedo" ||
              type === "ambient" ||
              type === "opacity" ||
              type === "reflection" ||
              type === "emissive" ||
              type === "reflectivity" ||
              type === "metallic" ||
              type === "microsurface" ||
              type === "lightmap" ||
              type === "refraction";
      }
        if (material instanceof Zakeke.PBRMaterial) {
          return type === "albedo" ||
              type === "reflection" ||
              type === "matCapReflection" ||
              type === "reflectivity" ||
              type === "microsurface" ||
              type === "ambient" ||
              type === "ao" ||
              type === "opacity";
      }
      */

      if (material instanceof BABYLON.ShaderMaterial) return true;
      return false;
    }

    // Aggiorna la configurazione di ambiente impostando l'url di una texture caricata
  }, {
    key: "setEnvironmentTexture",
    value: function setEnvironmentTexture(url, type, extensions, files, onLoad) {
      if (type === "environment") {
        // La mappa d'ambiente di default la imposto direttamente sulla scena
        // in modo che valga sia per la modalità editor che per la modalità viewer
        this.setSceneEnvironmentTexture(url, undefined, extensions, files, onLoad);
        //this.setViewerEnvironmentTexture(url);
      } else if (type === "skybox") {
        this.setViewerSkyboxTexture(url, extensions, files);
      } else if (type === "ground") {
        this.setViewerGroundTexture(url);
      }
    }
  }, {
    key: "removeSceneEnvironmentTexture",
    value: function removeSceneEnvironmentTexture() {
      if (this._scene && this._scene.environmentTexture) {
        this._scene.environmentTexture.dispose();
        this._scene.environmentTexture = null;
        if (this._scene.metadata && this._scene.metadata.environmentTextureRotationY != undefined) delete this._scene.metadata.environmentTextureRotationY;
      }
      this.setRenderingNeeded();
    }
  }, {
    key: "setSceneEnvironmentTextureRotationY",
    value: function setSceneEnvironmentTextureRotationY(rotationY) {
      if (this._scene && this._scene.environmentTexture && (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture)) {
        this._scene.environmentTexture.rotationY = rotationY * Math.PI / 180;
        this.setLongRenderingNeeded();
      }
    }

    // Crea e imposta la singola texture sul materiale per il tipo di proprietà specificato
  }, {
    key: "setTextureImage",
    value: function () {
      var _setTextureImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(zkSceneTexture, material, type) {
        var _this29 = this;
        return _regeneratorRuntime().wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", new Promise(function (resolve) {
                if (_this29._scene && zkSceneTexture && zkSceneTexture instanceof Zakeke.SceneTexture) {
                  var url = zkSceneTexture.get("url");
                  if (url) {
                    // Caso environment
                    if (!material) {
                      _this29.setEnvironmentTexture(url, type);
                    } else {
                      // Crea la texture
                      var oldTexture = _this29.getMaterialTexture(material, type);
                      var invertY = true;
                      if (oldTexture && oldTexture instanceof BABYLON.Texture) invertY = oldTexture.invertY;
                      var texture = new BABYLON.Texture(url, _this29._scene, undefined, invertY, undefined, function () {
                        return _this29.setRenderingNeeded();
                      });
                      if (oldTexture && oldTexture instanceof BABYLON.Texture) {
                        texture.uScale = oldTexture.uScale;
                        texture.vScale = oldTexture.vScale;
                        texture.uOffset = oldTexture.uOffset;
                        texture.vOffset = oldTexture.vOffset;
                        texture.uAng = oldTexture.uAng;
                        texture.vAng = oldTexture.vAng;
                        texture.level = oldTexture.level;
                        texture.coordinatesIndex = oldTexture.coordinatesIndex;
                        texture.coordinatesMode = oldTexture.coordinatesMode;
                        texture.hasAlpha = oldTexture.hasAlpha;
                        texture.wrapU = oldTexture.wrapU;
                        texture.wrapV = oldTexture.wrapV;
                        texture.gammaSpace = oldTexture.gammaSpace;
                      }
                      _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_3__.SceneHelper.whenTextureIsReadyAsync(texture).then(function () {
                        // Applica la texture
                        _this29.applyTexture(texture, material, type);
                        if (oldTexture && !_this29.isTextureUsed(oldTexture)) oldTexture.dispose();
                        _this29.setRenderingNeeded();
                        resolve();
                      });
                    }
                  }
                }
              }));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee13);
      }));
      function setTextureImage(_x17, _x18, _x19) {
        return _setTextureImage.apply(this, arguments);
      }
      return setTextureImage;
    }() // Crea la cubemap e la imposta sul materiale e tipo di poprietà specificato
  }, {
    key: "setCubeTextureImages",
    value: function () {
      var _setCubeTextureImages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(zkSceneTextures, material, type) {
        var _this30 = this;
        return _regeneratorRuntime().wrap(function _callee14$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", new Promise(function (resolve) {
                if (!_this30._scene || Object.prototype.toString.call(zkSceneTextures) != '[object Array]') resolve();

                // controllo che si tratti effettivamente di un array di Zakeke.SceneTexture
                for (var i = 0; i < zkSceneTextures.length; i++) {
                  var zkSceneTexture = zkSceneTextures[i];
                  if (!zkSceneTexture || !(zkSceneTexture instanceof Zakeke.SceneTexture)) resolve();
                }
                var onImagesLoad = function onImagesLoad() {
                  return _this30.setLongRenderingNeeded();
                };

                // Crea la texture o aggiorna la configurazione di ambiente
                var texture = null;
                var textureInfo = _this30.getCubeTextureInfo(zkSceneTextures);
                if (textureInfo.url && _this30._scene) {
                  if (zkSceneTextures.length === 1) {
                    // Caso environment dds, hdr, env, basis
                    var url = textureInfo.url;
                    if (url) {
                      if (!material) {
                        _this30.setEnvironmentTexture(url, type);
                      } else {
                        if (url.endsWith(".dds")) texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, _this30._scene);else if (url.endsWith(".hdr"))
                          //texture = new BABYLON.HDRCubeTexture(url, this._scene, 512, undefined, undefined, undefined, undefined, onImagesLoad);
                          texture = new BABYLON.HDRCubeTexture(url, _this30._scene, 128, undefined, undefined, undefined, undefined, onImagesLoad);else if (url.endsWith(".env")) {
                          //texture = new BABYLON.CubeTexture(url, this._scene);
                          //texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene, undefined, undefined);
                          texture = new BABYLON.CubeTexture(url, _this30._scene, null, false, null, onImagesLoad, null, undefined, true, undefined, true);
                          //texture = new BABYLON.CubeTexture(url, this._scene, undefined, undefined, undefined, undefined, onImagesLoad);
                        } else if (url.endsWith(".basis")) {
                          texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, _this30._scene);
                        }
                      }
                    }
                  } else if (zkSceneTextures.length === 6 && textureInfo.files.length === 6 && textureInfo.extensions.length === 6) {
                    // Caso cubemap px, nx, py, ny, pz, nz
                    if (!material) _this30.setEnvironmentTexture(textureInfo.url, type, textureInfo.extensions, textureInfo.files, onImagesLoad);else texture = new BABYLON.CubeTexture(textureInfo.url, _this30._scene, textureInfo.extensions, false, textureInfo.files, onImagesLoad);
                  }
                }

                // Applica la texture
                if (texture) {
                  _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_3__.SceneHelper.whenTextureIsReadyAsync(texture).then(function () {
                    if (material) {
                      var oldTexture = _this30.getMaterialTexture(material, type);
                      _this30.applyTexture(texture, material, type);
                      if (oldTexture && !_this30.isTextureUsed(oldTexture)) oldTexture.dispose();
                      _this30.setRenderingNeeded();
                      resolve();
                    }
                  });
                } else {
                  resolve();
                }
              }));
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee14);
      }));
      function setCubeTextureImages(_x20, _x21, _x22) {
        return _setCubeTextureImages.apply(this, arguments);
      }
      return setCubeTextureImages;
    }()
  }, {
    key: "setMobileTextureImage",
    value: function setMobileTextureImage(zkSceneTexture, material, type) {
      if (this._scene && this._sceneHelper) {
        var url = zkSceneTexture.get("url");
        if (url) {
          var texture = null;
          if (!material) {
            texture = this._scene.environmentTexture;
          } else texture = this.getMaterialTexture(material, type);
          if (texture !== null && this._sceneHelper.isTextureWithUrl(texture)) {
            if (!texture.metadata) texture.metadata = {};
            texture.metadata.mobileUrl = url;
          }
        }
      }
    }
  }, {
    key: "setMobileCubeTextureImages",
    value: function setMobileCubeTextureImages(zkSceneTextures, material, type) {
      if (!this._scene || Object.prototype.toString.call(zkSceneTextures) != '[object Array]') return;

      // controllo che si tratti effettivamente di un array di Zakeke.SceneTexture
      for (var i = 0; i < zkSceneTextures.length; i++) {
        var zkSceneTexture = zkSceneTextures[i];
        if (!zkSceneTexture || !(zkSceneTexture instanceof Zakeke.SceneTexture)) return;
      }
      var textureInfo = this.getCubeTextureInfo(zkSceneTextures);
      if (textureInfo.url) {
        var texture = null;
        if (!material) texture = this._scene.environmentTexture;else texture = this.getMaterialTexture(material, type);
        if (texture && texture instanceof BABYLON.CubeTexture) {
          if (!texture.metadata) texture.metadata = {};
          texture.metadata.mobileUrl = textureInfo.url;
          if (textureInfo.files.length === 6) {
            texture.metadata.mobileFiles = textureInfo.files;
            texture.metadata.mobileExtensions = textureInfo.extensions;
          }
        }
      }
    }

    // Costruisce l'url della cubemap da utilizzare per la costruzione della texture di Babylon JS
    // Nel caso di cubemap con 6 immagini (_px _nx...), restituisce l'url senza il suffisso
  }, {
    key: "getCubeTextureInfo",
    value: function getCubeTextureInfo(zkSceneTextures) {
      var textureInfo = {
        url: null,
        files: [],
        extensions: []
      };
      if (zkSceneTextures.length === 1) {
        // Caso mappa d'ambiente (dds, hdr o basis)
        textureInfo.url = zkSceneTextures[0].get("url") || null;
      } else if (zkSceneTextures.length === 6) {
        // Caso cubemap composta da sei immagini
        var suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
        var rootUrl = null;
        var files = [];
        var extensions = [];
        var containsPrefix = function containsPrefix(name, suffix) {
          var idx = name.lastIndexOf(".");
          if (idx !== -1) {
            var nameWithoutExt = name.substring(0, idx);
            return nameWithoutExt.endsWith("_" + suffix);
          }
          return false;
        };
        var getRootUrl = function getRootUrl(url, suffix) {
          var idx = url.lastIndexOf(".");
          if (idx !== -1) {
            var nameWithoutExt = url.substring(0, idx);
            if (nameWithoutExt.endsWith("_" + suffix)) {
              var _rootUrl = nameWithoutExt.substring(0, nameWithoutExt.length - ("_" + suffix).length);
              return _rootUrl;
            }
          }
          return null;
        };
        var getFileExtension = function getFileExtension(url, suffix) {
          var idx = url.lastIndexOf("_" + suffix);
          if (idx !== -1) {
            return url.substr(idx);
          }
          return null;
        };
        for (var i = 0; i < suffixes.length; i++) {
          var suffix = suffixes[i];
          for (var k = 0; k < zkSceneTextures.length; k++) {
            var url = zkSceneTextures[k].get("url");
            if (url) {
              if (containsPrefix(url, suffix)) {
                files.push(url);
                var ext = getFileExtension(url, suffix);
                if (ext) extensions.push(ext);
                if (!rootUrl) rootUrl = getRootUrl(url, suffix);
                break;
              }
            }
          }
        }
        textureInfo.url = rootUrl;
        textureInfo.files = files;
        textureInfo.extensions = extensions;
      }
      return textureInfo;
    }
  }, {
    key: "isTextureUsed",
    value: function isTextureUsed(texture) {
      if (this._scene && texture) {
        for (var i = 0; i < this._scene.materials.length; i++) {
          var material = this._scene.materials[i];
          var textures = material.getActiveTextures();
          for (var j = 0; j < textures.length; j++) {
            var matTexture = textures[j];
            if (matTexture.uid === texture.uid) return true;
          }
        }
      }
      return false;
    }
  }, {
    key: "changeTextureInvertYAsync",
    value: function () {
      var _changeTextureInvertYAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(material, type, invertY) {
        var _this31 = this;
        var oldTexture, url, absoluteUrl, isAbsolute, rootUrl, texture;
        return _regeneratorRuntime().wrap(function _callee15$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!(this._scene && this._sceneHelper)) {
                _context16.next = 19;
                break;
              }
              oldTexture = this._sceneHelper.getMaterialTexture(material, type);
              if (!(oldTexture && oldTexture instanceof BABYLON.Texture && oldTexture.invertY != invertY)) {
                _context16.next = 19;
                break;
              }
              // Costruisco una nuova texture passando il giusto parametro nel costruttore
              url = oldTexture.url;
              if (!url) {
                _context16.next = 19;
                break;
              }
              absoluteUrl = url;
              isAbsolute = /^(?:\/|[a-z]+:\/\/)/.test(url);
              if (isAbsolute) {
                _context16.next = 12;
                break;
              }
              _context16.next = 10;
              return this.getSceneRootUrl();
            case 10:
              rootUrl = _context16.sent;
              if (rootUrl) {
                absoluteUrl = rootUrl + url;
              }
            case 12:
              texture = new BABYLON.Texture(absoluteUrl, this._scene, undefined, invertY, undefined, function () {
                return _this31.setRenderingNeeded();
              });
              if (oldTexture && oldTexture instanceof BABYLON.Texture) {
                texture.uScale = oldTexture.uScale;
                texture.vScale = oldTexture.vScale;
                texture.uOffset = oldTexture.uOffset;
                texture.vOffset = oldTexture.vOffset;
                texture.uAng = oldTexture.uAng;
                texture.vAng = oldTexture.vAng;
                texture.level = oldTexture.level;
                texture.coordinatesIndex = oldTexture.coordinatesIndex;
                texture.coordinatesMode = oldTexture.coordinatesMode;
                texture.hasAlpha = oldTexture.hasAlpha;
                texture.wrapU = oldTexture.wrapU;
                texture.wrapV = oldTexture.wrapV;
                texture.gammaSpace = oldTexture.gammaSpace;
              }
              _context16.next = 16;
              return _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_3__.SceneHelper.whenTextureIsReadyAsync(texture);
            case 16:
              this.applyTexture(texture, material, type);
              if (oldTexture && !this.isTextureUsed(oldTexture)) oldTexture.dispose();
              this.setRenderingNeeded();
            case 19:
            case "end":
              return _context16.stop();
          }
        }, _callee15, this);
      }));
      function changeTextureInvertYAsync(_x23, _x24, _x25) {
        return _changeTextureInvertYAsync.apply(this, arguments);
      }
      return changeTextureInvertYAsync;
    }()
  }, {
    key: "applyTextureByName",
    value: function applyTextureByName(name, material, type) {
      if (this._scene) {
        var texture = this._scene.textures.find(function (t) {
          return t.name === name;
        });
        if (texture) this.applyTexture(texture, material, type);
      }
    }
  }, {
    key: "applyTexture",
    value: function applyTexture(texture, material, type) {
      // Lightmap always on second channel
      if (texture && type == "lightmap") {
        texture.coordinatesIndex = 1;
        if (material instanceof BABYLON.StandardMaterial || material instanceof BABYLON.PBRMaterial || material instanceof BABYLON.PBRBaseSimpleMaterial) material.useLightmapAsShadowmap = true;
      }

      // Verificare nome proprietà dinamica

      if (material instanceof BABYLON.StandardMaterial) {
        switch (type) {
          case "diffuse":
            material.diffuseTexture = texture;
            break;
          case "emissive":
            material.emissiveTexture = texture;
            break;
          case "ambient":
            material.ambientTexture = texture;
            break;
          case "lightmap":
            material.lightmapTexture = texture;
            break;
          case "opacity":
            material.opacityTexture = texture;
            break;
          case "specular":
            material.specularTexture = texture;
            break;
          case "reflection":
            material.reflectionTexture = texture;
            break;
          case "refraction":
            material.refractionTexture = texture;
            break;
          case "bump":
            material.bumpTexture = texture;
            break;
        }
      } else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
        switch (type) {
          /*
          case "environment":
              material.environmentTexture = texture;
              break;
          case "normal":
              material.normalTexture = texture;
              break;
          case "emissive":
              material.emissiveTexture = texture;
              break;
          case "occlusion":
              material.occlusionTexture = texture;
              break;
          case "base":
              material.baseTexture = texture;
              break;
          case "metallicRoughness":
              material.metallicRoughnessTexture = texture;
              break;
          */
          case "environment":
          case "normal":
          case "emissive":
          case "occlusion":
          case "base":
          case "metallicRoughness":
            material["".concat(type, "Texture")] = texture;
            break;
        }
      } else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
        switch (type) {
          /*
          case "environment":
              material.environmentTexture = texture;
              break;
          case "normal":
              material.normalTexture = texture;
              break;
          case "emissive":
              material.emissiveTexture = texture;
              break;
          case "occlusion":
              material.occlusionTexture = texture;
              break;
          case "diffuse":
              material.diffuseTexture = texture;
              break;
          case "specularGlossiness":
              material.specularGlossinessTexture = texture;
              break;
          */
          case "environment":
          case "normal":
          case "emissive":
          case "occlusion":
          case "diffuse":
          case "specularGlossiness":
            material["".concat(type, "Texture")] = texture;
            break;
        }
      } else if (material instanceof BABYLON.PBRMaterial) {
        switch (type) {
          case "cameraColorGrading":
            material.cameraColorGradingTexture = texture;
            break;
          /*
          case "albedo":
              material.albedoTexture = texture;
              break;
          case "ambient":
              material.ambientTexture = texture;
              break;
          case "opacity":
              material.opacityTexture = texture;
              break;
          case "reflection":
              material.reflectionTexture = texture;
              break;
          case "emissive":
              material.emissiveTexture = texture;
              break;
          case "reflectivity":
              material.reflectivityTexture = texture;
              break;
          case "metallic":
              material.metallicTexture = texture;
              break;
          case "microSurface":
              material.microSurfaceTexture = texture;
              break;
          case "bump":
              material.bumpTexture = texture;
              break;
          case "lightmap":
              material.lightmapTexture = texture;
              break;
          */
          case "albedo":
          case "ambient":
          case "opacity":
          case "reflection":
          case "emissive":
          case "reflectivity":
          case "metallic":
          case "microSurface":
          case "bump":
          case "lightmap":
            material["".concat(type, "Texture")] = texture;
            break;
          case "refraction":
            material.refractionTexture = texture;
            break;
          case "environmentBRDF":
            material.environmentBRDFTexture = texture;
            break;
          case "clearCoat_texture":
            material.clearCoat.texture = texture;
            break;
          case "clearCoat_bump":
            material.clearCoat.bumpTexture = texture;
            break;
          case "clearCoat_tint":
            material.clearCoat.tintTexture = texture;
            break;
          case "clearCoat_textureRoughness":
            material.clearCoat.textureRoughness = texture;
            break;
          case "anisotropy_texture":
            material.anisotropy.texture = texture;
            break;
          case "sheen_texture":
            material.sheen.texture = texture;
            break;
          case "sheen_textureRoughness":
            material.sheen.textureRoughness = texture;
            break;
          case "subSurface_thickness":
            material.subSurface.thicknessTexture = texture;
            break;
          case "subSurface_translucencyIntensity":
            material.subSurface.translucencyIntensityTexture = texture;
            break;
          case "subSurface_refractionIntensity":
            material.subSurface.refractionIntensityTexture = texture;
            break;
        }
      } else if (material instanceof BABYLON.ShaderMaterial) {
        if (texture && texture instanceof BABYLON.Texture) material.setTexture(type, texture);else material.removeTexture(type);
      } else if (material instanceof Zakeke.PBRMaterial) {
        switch (type) {
          case "albedo":
            material.albedoTexture = texture;
            break;
          case "bump":
            material.bumpTexture = texture;
            break;
          case "reflection":
            material.reflectionTexture = texture;
            break;
          case "matCapReflection":
            material.matCapReflectionTexture = texture;
            break;
          case "reflectivity":
            material.reflectivityTexture = texture;
            break;
          case "microsurface":
            material.microsurfaceTexture = texture;
            break;
          case "ambient":
            material.ambientTexture = texture;
            break;
          case "ao":
            material.aoTexture = texture;
            break;
          case "opacity":
            material.opacityTexture = texture;
            break;
        }
      }
      this.setLongRenderingNeeded();
    }
  }, {
    key: "getMaterialTexture",
    value: function getMaterialTexture(material, type) {
      if (material instanceof BABYLON.StandardMaterial) {
        switch (type) {
          case "diffuse":
            return material.diffuseTexture;
          case "emissive":
            return material.emissiveTexture;
          case "ambient":
            return material.ambientTexture;
          case "lightmap":
            return material.lightmapTexture;
          case "opacity":
            return material.opacityTexture;
          case "specular":
            return material.specularTexture;
          case "reflection":
            return material.reflectionTexture;
          case "refraction":
            return material.refractionTexture;
          case "bump":
            return material.bumpTexture;
        }
      } else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
        switch (type) {
          case "environment":
            return material.environmentTexture;
          case "normal":
            return material.normalTexture;
          case "emissive":
            return material.emissiveTexture;
          case "occlusion":
            return material.occlusionTexture;
          case "base":
            return material.baseTexture;
          case "metallicRoughness":
            return material.metallicRoughnessTexture;
        }
      } else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
        switch (type) {
          case "environment":
            return material.environmentTexture;
          case "normal":
            return material.normalTexture;
          case "emissive":
            return material.emissiveTexture;
          case "occlusion":
            return material.occlusionTexture;
          case "diffuse":
            return material.diffuseTexture;
          case "specularGlossiness":
            return material.specularGlossinessTexture;
        }
      } else if (material instanceof BABYLON.PBRMaterial) {
        switch (type) {
          case "cameraColorGrading":
            return material.cameraColorGradingTexture;
          case "albedo":
            return material.albedoTexture;
          case "ambient":
            return material.ambientTexture;
          case "opacity":
            return material.opacityTexture;
          case "reflection":
            return material.reflectionTexture;
          case "emissive":
            return material.emissiveTexture;
          case "reflectivity":
            return material.reflectivityTexture;
          case "metallic":
            return material.metallicTexture;
          case "microSurface":
            return material.microSurfaceTexture;
          case "bump":
            return material.bumpTexture;
          case "lightmap":
            return material.lightmapTexture;
          case "refraction":
            return material.refractionTexture;
          case "clearCoat":
            return material.clearCoat.texture;
          case "clearCoat_bump":
            return material.clearCoat.bumpTexture;
          case "clearCoat_tint":
            return material.clearCoat.tintTexture;
          case "clearCoat_textureRoughness":
            return material.clearCoat.textureRoughness;
          case "clearCoat_texture":
            return material.clearCoat.texture;
          case "anisotropy_texture":
            return material.anisotropy.texture;
          case "sheen_texture":
            return material.sheen.texture;
          case "sheen_textureRoughness":
            return material.sheen.textureRoughness;
          case "subSurface_thickness":
            return material.subSurface.thicknessTexture;
          case "subSurface_refractionIntensity":
            return material.subSurface.refractionIntensityTexture;
          case "subSurface_translucencyIntensity":
            return material.subSurface.translucencyIntensityTexture;
        }
      } else if (material instanceof Zakeke.PBRMaterial) {
        switch (type) {
          case "albedo":
            return material.albedoTexture;
          case "bump":
            return material.bumpTexture;
          case "reflection":
            return material.reflectionTexture;
          case "matCapReflection":
            return material.matCapReflectionTexture;
          case "reflectivity":
            return material.reflectivityTexture;
          case "microsurface":
            return material.microsurfaceTexture;
          case "ambient":
            return material.ambientTexture;
          case "ao":
            return material.aoTexture;
          case "opacity":
            return material.opacityTexture;
        }
      }
      return null;
    }
  }, {
    key: "removeMaterialTexture",
    value: function removeMaterialTexture(material, type) {
      this.applyTexture(null, material, type);
    }
  }, {
    key: "removeMaterialMobileTexture",
    value: function removeMaterialMobileTexture(material, type) {
      var texture = this.getMaterialTexture(material, type);
      if (texture && texture.metadata && texture.metadata.mobileUrl) {
        delete texture.metadata.mobileUrl;
        if (texture.metadata.hasOwnProperty("mobileFiles")) delete texture.metadata.mobileFiles;
        if (texture.metadata.hasOwnProperty("mobileExtensions")) delete texture.metadata.mobileExtensions;
        if (Object.keys(texture.metadata).length === 0 && texture.metadata.constructor === Object) delete texture.metadata;
      }
    }
    //#endregion

    //#region Operazioni sugli elementi della scena

    /**
     * Create a group of meshes
     * @param parentId Id of the parent node of the group
     * @param name Name of the group
     * @param children Array of meshes to be included in the group
     */
  }, {
    key: "createGroup",
    value: function createGroup(parentId, name, children) {
      if (this._scene) {
        var group = new BABYLON.Mesh(name, this._scene);
        group.id = Zakeke.generateUUID();
        group.metadata = {
          isRealMesh: true,
          isGroup: true
        };
        if (parentId) {
          var parent = this._scene.getMeshByID(parentId);
          if (parent) {
            group.parent = parent;
          }
        }
        if (children) {
          children.forEach(function (m) {
            return m.parent = group;
          });
        }
        this.fireMeshesUpdateEvent();
        return group;
      }
      return null;
    }
  }, {
    key: "deleteMesh",
    value: function deleteMesh(meshID, removeMaterials) {
      var _this32 = this;
      var deleted = {
        meshIDs: [],
        materialIDs: []
      };
      if (this._scene && this._sceneHelper && this._zkScene) {
        var scene = this._scene;
        var sceneHelper = this._sceneHelper;
        var zkScene = this._zkScene;
        var mesh = scene.getMeshByID(meshID);
        if (mesh) {
          var removeMaterialsWithChildren = function removeMaterialsWithChildren(parent) {
            var materials = _this32.getMeshMaterials(parent);
            for (var k = 0; k < materials.length; k++) {
              // Sometimes, for submeshes for example, we can have an array of nulls
              var material = materials[k];
              if (!material) continue;
              var meshesUsingMaterial = _this32.getMeshesUsingMaterial(material.id);
              if (meshesUsingMaterial.length === 1) {
                if (meshesUsingMaterial.every(function (meshItem) {
                  return sceneHelper.meshHasParent(meshItem.id, mesh.id);
                })) {
                  deleted.materialIDs.push(materials[k].id);
                  materials[k].dispose();
                }
              }
            }

            // Faccio lo stesso per i figli
            parent.getChildMeshes().forEach(function (child) {
              return removeMaterialsWithChildren(child);
            });
          };
          if (removeMaterials) {
            removeMaterialsWithChildren(mesh);
            this.fireMaterialsUpdateEvent();
          }
          var cameraPivot = sceneHelper.getCameraPivot();
          if (cameraPivot && cameraPivot === mesh) {
            this.setCameraPivot(null);
          }
          if (this.isMeshSelected(mesh)) this.unselectMesh(mesh.id);
          mesh.dispose();
          deleted.meshIDs.push(meshID);
        }
        this.fireMeshesUpdateEvent();
        this.setRenderingNeeded();
        deleted.materialIDs.forEach(function (materialID) {
          var libraryMaterialID = zkScene.getLibraryShaderMaterialIDForSceneMaterial(materialID);
          if (libraryMaterialID) zkScene.unregisterShaderMaterial(libraryMaterialID);
        });
      }
      return deleted;
    }

    // Cancella tutte le mesh
  }, {
    key: "deleteAllMeshes",
    value: function deleteAllMeshes() {
      if (this._scene && this._sceneHelper) {
        for (var i = 0; i < this._scene.meshes.length; i++) {
          var mesh = this._scene.meshes[i];
          if (this._sceneHelper.isRealMesh(mesh)) {
            this._scene.meshes.splice(i--, 1);
            mesh.dispose();
          }
        }
        this.setCameraPivot(null);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "deleteDuplicatedMeshesWithDifferentParent",
    value: function deleteDuplicatedMeshesWithDifferentParent(parentID, removeMaterials) {
      var _this33 = this;
      var deleted = {
        meshIDs: [],
        materialIDs: []
      };
      if (this._scene && this._sceneHelper && this._zkScene) {
        var scene = this._scene;
        var sceneHelper = this._sceneHelper;
        var zkScene = this._zkScene;
        var removeIfDuplicated = function removeIfDuplicated(mesh) {
          var others = _this33.getSceneMeshesByName(mesh.name);
          var found = false;
          for (var i = 0; i < others.length; i++) {
            var other = others[i];
            if (other.id != mesh.id && !sceneHelper.meshHasParent(other.id, parentID)) {
              // Elimino anche il materiale se la mesh è l'unica ad utilizzarlo
              if (removeMaterials) {
                var materials = _this33.getMeshMaterials(other);
                for (var k = 0; k < materials.length; k++) {
                  var meshesUsingMaterial = _this33.getMeshesUsingMaterial(materials[k].id);
                  if (meshesUsingMaterial.length == 1) {
                    deleted.materialIDs.push(materials[k].id);
                    materials[k].dispose();
                  }
                }
              }
              deleted.meshIDs.push(other.id);
              other.dispose();
              others.splice(i--, 1);
              found = true;
              break;
            }
          }
          if (!found) {
            mesh.getChildMeshes().forEach(function (child) {
              return removeIfDuplicated(child);
            });
          }
        };
        var parent = scene.getMeshByID(parentID);
        if (parent) {
          parent.getChildMeshes().forEach(function (child) {
            return removeIfDuplicated(child);
          });
        }
        this.setRenderingNeeded();
        deleted.materialIDs.forEach(function (materialID) {
          var libraryMaterialID = zkScene.getLibraryShaderMaterialIDForSceneMaterial(materialID);
          if (libraryMaterialID) zkScene.unregisterShaderMaterial(libraryMaterialID);
        });
      }
      return deleted;
    }

    // Cancella tutte le mesh figlie di quella in input 
    // che hanno lo stesso nome di altre mesh con id diverso
    // Questa funzione può essere utile per elminiare oggetti duplicati importati
    // con file diversi
  }, {
    key: "deleteDuplicatedChildMeshes",
    value: function deleteDuplicatedChildMeshes(parentID, removeMaterials) {
      var _this34 = this;
      var deleted = {
        meshIDs: [],
        materialIDs: []
      };
      if (this._scene && this._sceneHelper && this._zkScene) {
        var scene = this._scene;
        var sceneHelper = this._sceneHelper;
        var zkScene = this._zkScene;
        var removeIfDuplicated = function removeIfDuplicated(mesh) {
          var others = _this34.getSceneMeshesByName(mesh.name);
          var found = false;
          for (var i = 0; i < others.length; i++) {
            var other = others[i];
            if (other.id != mesh.id && !sceneHelper.meshHasParent(other.id, parentID)) {
              // Elimino anche il materiale se la mesh è l'unica ad utilizzarlo
              if (removeMaterials) {
                var materials = _this34.getMeshMaterials(mesh);
                for (var k = 0; k < materials.length; k++) {
                  var meshesUsingMaterial = _this34.getMeshesUsingMaterial(materials[k].id);
                  if (meshesUsingMaterial.length == 1) {
                    deleted.materialIDs.push(materials[k].id);
                    materials[k].dispose();
                  }
                }
              }
              deleted.meshIDs.push(mesh.id);
              mesh.dispose();
              found = true;
              break;
            }
          }
          if (!found) {
            var childMeshes = mesh.getChildMeshes();
            for (var _i6 = 0; _i6 < childMeshes.length; _i6++) {
              removeIfDuplicated(childMeshes[_i6]);
            }
          }
        };
        var parent = scene.getMeshByID(parentID);
        if (parent) {
          parent.getChildMeshes().forEach(function (child) {
            return removeIfDuplicated(child);
          });
        }
        this.setRenderingNeeded();
        deleted.materialIDs.forEach(function (materialID) {
          var libraryMaterialID = zkScene.getLibraryShaderMaterialIDForSceneMaterial(materialID);
          if (libraryMaterialID) zkScene.unregisterShaderMaterial(libraryMaterialID);
        });
      }
      return deleted;
    }
  }, {
    key: "deleteMaterial",
    value: function deleteMaterial(materialID) {
      if (this._scene && this._sceneHelper) {
        var material = this._scene.getMaterialByID(materialID);
        if (material) {
          this.deleteMaterialInternal(material);
          this.fireMaterialsUpdateEvent();
          this.setRenderingNeeded();
        }
      }
    }
  }, {
    key: "deleteMaterialInternal",
    value: function deleteMaterialInternal(material) {
      if (this._scene && this._sceneHelper && material) {
        var _materialID4 = material.id;
        if (this._zkScene) {
          var libraryMaterialID = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(material.id);
          if (libraryMaterialID) this._zkScene.unregisterShaderMaterial(libraryMaterialID);
        }
        var textures = this._sceneHelper.getTexturesExclusivelyForMaterial(material);
        material.dispose();
        for (var i = 0; i < textures.length; i++) textures[i].dispose();
        this._sceneHelper.removeSceneMaterialMetadata(_materialID4);
      }
    }
  }, {
    key: "deleteAllMaterials",
    value: function deleteAllMaterials() {
      if (this._scene) {
        while (this._scene.materials.length > 0) {
          var material = this._scene.materials.pop();
          if (material) this.deleteMaterialInternal(material);
        }
        this.fireMaterialsUpdateEvent();
        this.setRenderingNeeded();
        this.fireMaterialsUpdateEvent();
      }
    }
  }, {
    key: "renameMaterial",
    value: function renameMaterial(id, name) {
      if (this._scene) {
        var material = this._scene.getMaterialByID(id);
        if (material) material.name = name;
        this.fireMaterialsUpdateEvent();
      }
    }
  }, {
    key: "cloneMesh",
    value: function cloneMesh(id) {
      var newMesh = null;
      if (this._scene && this._sceneHelper) {
        newMesh = this._sceneHelper.cloneMesh(id, false, false);
        this.setRenderingNeeded();
        this.fireMeshesUpdateEvent();
      }
      return newMesh;
    }

    // Same as clone but with duplicated geometry data too
  }, {
    key: "duplicateMesh",
    value: function duplicateMesh(id) {
      var updatable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var newMesh = null;
      if (this._scene && this._sceneHelper) {
        newMesh = this._sceneHelper.cloneMesh(id, true, updatable);
        this.setRenderingNeeded();
        this.fireMeshesUpdateEvent();
      }
      return newMesh;
    }
  }, {
    key: "cloneMaterial",
    value: function cloneMaterial(id, newId, newName) {
      var newMaterial = null;
      if (this._scene && this._sceneHelper) {
        var material = this._scene.getMaterialByID(id);
        if (material) {
          var materialName = newName ? newName : material.name + " - clone";
          newMaterial = material.clone(materialName);
          if (newMaterial) {
            var materialId = newId ? newId : Zakeke.generateUUID();
            newMaterial.id = materialId;

            // Verifico se il materiale originario deriva da un materiale di libreria.
            // Nel caso, devo impostare il mapping in modo da copiare anche le relative textures
            if (this._zkScene) {
              var mapping = this._zkScene.getMappingForSceneMaterial(material.id);
              if (mapping) {
                var libraryMaterialID = mapping.get("libraryMaterialID");
                this._zkScene.mapLibraryMaterial(libraryMaterialID, newMaterial.id);
                var textures = this._sceneHelper.getTexturesForMaterial(newMaterial);
                for (var i = 0; i < textures.length; i++) {
                  var texture = textures[i];
                  texture["materialMapping"] = {
                    libraryMaterialID: libraryMaterialID,
                    sceneMaterialID: newMaterial.id
                  };
                }
              }
            }
          }
        }
        this.setRenderingNeeded();
        this.fireMaterialsUpdateEvent();
      }
      return newMaterial;
    }
  }, {
    key: "createMaterial",
    value: function createMaterial(name, type, group) {
      var material = null;
      if (this._scene) {
        var materialName = name || "new material";
        var materialType = type || "Standard";
        if (materialType === "Standard") material = new BABYLON.StandardMaterial(materialName, this._scene);else if (materialType === "PBRMetallicRoughness") {
          material = new BABYLON.PBRMetallicRoughnessMaterial(materialName, this._scene);
          material.subSurface.indexOfRefraction = 1;
          material["_imageProcessingConfiguration"].contrast = 1;
        } else if (materialType === "PBRSpecularGlossiness") material = new BABYLON.PBRSpecularGlossinessMaterial(materialName, this._scene);else if (materialType === "PBR") {
          material = new BABYLON.PBRMaterial(materialName, this._scene);
          material.enableSpecularAntiAliasing = true;
          material.metallic = 0.9;
          material.roughness = 0.3;
          material.indexOfRefraction = 1;
        } else if (materialType === "NewPBR") material = new Zakeke.PBRMaterial(materialName, this._scene);
        if (material) {
          material.id = Zakeke.generateUUID();
          if (group) {
            if (!material.metadata) material.metadata = {};
            material.metadata.group = group;
          }
        }
        this.checkSceneEmptyEnvironmentTexture();
        this.setRenderingNeeded();
        this.fireMaterialsUpdateEvent();
      }
      return material;
    }
  }, {
    key: "changeMeshParent",
    value: function changeMeshParent(meshID, newParentID) {
      if (this._scene) {
        var child = this._scene.getMeshByID(meshID);
        if (child && (!child.parent || child.parent.id != newParentID)) {
          var newParent = this._scene.getMeshByID(newParentID);
          child.parent = newParent;
          this.setRenderingNeeded();
          this.fireMeshesUpdateEvent();
        }
      }
    }
  }, {
    key: "removeMeshParent",
    value: function removeMeshParent(meshID) {
      if (this._scene) {
        var child = this._scene.getMeshByID(meshID);
        if (child) {
          child.parent = null;
          this.fireMeshesUpdateEvent();
        }
      }
    }
  }, {
    key: "setManipulatedNode",
    value: function setManipulatedNode(node) {
      // If we are just click on another object then don't re-create the edit control
      if (node === this._manipulatedNode) return;
      this._manipulatedNode = node;
      this.showHideEditControl(this._editControlVisible); // Refresh edit control
      this.setRenderingNeeded();
    }
  }, {
    key: "importLibraryMaterial",
    value: function importLibraryMaterial(zkMaterial) {
      if (this._scene && this._sceneHelper && this._zkScene && zkMaterial && zkMaterial instanceof Zakeke.Material) {
        if (zkMaterial.get("shaders")) this.checkShaderMaterial(zkMaterial);
        var jsonText = zkMaterial.get("JSON") || zkMaterial.get("json");
        var rootUrl = zkMaterial.get("rootUrl");
        if (jsonText && rootUrl) {
          var jsonObj = JSON.parse(jsonText);
          var material = BABYLON.Material.Parse(jsonObj, this._scene, rootUrl);
          if (material) {
            material.id = Zakeke.generateUUID();
            this._zkScene.mapLibraryMaterial(zkMaterial.getMaterialID(), material.id);
            if (zkMaterial.get("shaders")) {
              var shaders = zkMaterial.get("shaders");
              //shaders.get("name"), shaders.get("vertex"), shaders.get("fragment")
              var shaderName = shaders.get("name");
              var vertex = shaders.get("vertex");
              var fragment = shaders.get("fragment");
              if (shaderName && vertex && fragment) {
                this._zkScene.registerShaderMaterial(zkMaterial.getMaterialID(), shaderName, vertex, fragment);
              }
              this.setupShaderMaterialCameraPosition(material);
            }
            var textures = this._sceneHelper.getTexturesForMaterial(material);
            for (var i = 0; i < textures.length; i++) {
              var texture = textures[i];
              texture["materialMapping"] = {
                libraryMaterialID: zkMaterial.getMaterialID(),
                sceneMaterialID: material.id
              };
            }
          }
        }
        this.fireMaterialsUpdateEvent();
        this.setRenderingNeeded();
      }
    }

    //#endregion

    //#region Recupero Texture
    // I metodi per il recupero delle texture sono stati spostati in SceneHelper
    // Li lascio qui solo momentaneamente
  }, {
    key: "getTexturesForMaterial",
    value: function getTexturesForMaterial(material) {
      return this._sceneHelper ? this._sceneHelper.getTexturesForMaterial(material) : [];
    }
  }, {
    key: "getStandardMaterialTextures",
    value: function getStandardMaterialTextures(material) {
      return this._sceneHelper ? this._sceneHelper.getStandardMaterialTextures(material) : [];
    }
  }, {
    key: "getPBRBaseSimpleMaterialTextures",
    value: function getPBRBaseSimpleMaterialTextures(material) {
      return this._sceneHelper ? this._sceneHelper.getPBRBaseSimpleMaterialTextures(material) : [];
    }
  }, {
    key: "getPBRMaterialTextures",
    value: function getPBRMaterialTextures(material) {
      return this._sceneHelper ? this._sceneHelper.getPBRMaterialTextures(material) : [];
    }
  }, {
    key: "getNewPBRMaterialTextures",
    value: function getNewPBRMaterialTextures(material) {
      return this._sceneHelper ? this._sceneHelper.getNewPBRMaterialTextures(material) : [];
    }
  }, {
    key: "getPBRMetallicRoughnessMaterialTextures",
    value: function getPBRMetallicRoughnessMaterialTextures(material) {
      return this._sceneHelper ? this._sceneHelper.getPBRMetallicRoughnessMaterialTextures(material) : [];
    }
  }, {
    key: "getPBRSpecularGlossinessMaterialTextures",
    value: function getPBRSpecularGlossinessMaterialTextures(material) {
      return this._sceneHelper ? this._sceneHelper.getPBRSpecularGlossinessMaterialTextures(material) : [];
    }
    //#endregion

    //#region Camera Location
  }, {
    key: "removeCameraLocation",
    value: function removeCameraLocation(cameraLocation) {
      var _this$_zkScene3;
      (_this$_zkScene3 = this._zkScene) === null || _this$_zkScene3 === void 0 ? void 0 : _this$_zkScene3.get("cameraLocations").remove(cameraLocation);
      this.fireCameraLocationsUpdateEvent();
    }
  }, {
    key: "saveCameraLocation",
    value: function saveCameraLocation(name) {
      if (this._zkScene && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var position = this._camera.position;
        var target = this._camera.target;
        var zkCameraLocation = new Zakeke.SceneCameraLocation();
        zkCameraLocation.set("name", name);
        zkCameraLocation.set("px", position.x);
        zkCameraLocation.set("py", position.y);
        zkCameraLocation.set("pz", position.z);
        zkCameraLocation.set("tx", target.x);
        zkCameraLocation.set("ty", target.y);
        zkCameraLocation.set("tz", target.z);
        this._zkScene.get("cameraLocations").push(zkCameraLocation);
        this.fireCameraLocationCreatedEvent(zkCameraLocation);
        this.fireCameraLocationsUpdateEvent();
      }
    }
  }, {
    key: "clearCameraLocations",
    value: function clearCameraLocations() {
      if (this._zkScene) {
        var items = this._zkScene.get("cameraLocations");
        while (items.length > 0) items.remove(items.at(0));
        this.fireCameraLocationsUpdateEvent();
      }
    }

    //public setCameraLocation(locationID: string) {
    //    if (this._sceneHelper && this._zkScene) {
    //        const zkCameraLocation = this._zkScene.getCameraLocation(locationID);
    //        if (zkCameraLocation) {
    //            const position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
    //            const target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
    //            this._sceneHelper.animateCamera(target, position, 0.5);
    //        }
    //    }
    //    this.setRenderingNeeded();
    //}
  }, {
    key: "getAllCameraLocations",
    value: function getAllCameraLocations() {
      var locations = [];
      if (this._zkScene) {
        for (var i = 0; i < this._zkScene.get("cameraLocations").length; i++) locations.push(this._zkScene.get("cameraLocations").at(i));
      }
      return locations;
    }
    //#endregion

    //#region Collapse / Explode (Mesh Locations)
  }, {
    key: "saveMeshLocation",
    value: function saveMeshLocation(name) {
      if (this._meshLocationsManager) {
        this._meshLocationsManager.saveMeshLocation(name);
      }
    }
  }, {
    key: "saveExplodedMeshLocation",
    value: function saveExplodedMeshLocation() {
      if (this._meshLocationsManager) {
        this._meshLocationsManager.saveExplodedMeshLocation();
      }
    }
  }, {
    key: "saveCollapsedMeshLocation",
    value: function saveCollapsedMeshLocation() {
      if (this._meshLocationsManager) {
        this._meshLocationsManager.saveCollapsedMeshLocation();
      }
    }
  }, {
    key: "onBeforeSaveMeshLocation",
    value: function onBeforeSaveMeshLocation() {
      this._oldManipulatedNode = this._manipulatedNode;
      this.setManipulatedNode(null);
    }
  }, {
    key: "onAfterSaveMeshLocation",
    value: function onAfterSaveMeshLocation() {
      this.fireMeshLocationsUpdateEvent();
      this.setManipulatedNode(this._oldManipulatedNode);
    }
  }, {
    key: "clearMeshLocations",
    value: function clearMeshLocations() {
      if (this._meshLocationsManager) {
        this._meshLocationsManager.clearMeshLocations();
      }
    }
  }, {
    key: "getAllMeshLocations",
    value: function getAllMeshLocations() {
      var locations = [];
      if (this._zkScene) {
        for (var i = 0; i < this._zkScene.get("meshLocations").length; i++) locations.push(this._zkScene.get("meshLocations").at(i));
      }
      return locations;
    }
    //#endregion

    //#region Material Library
    // Nota Bene
    // E' un po' incasinato, c'è da mettere ordine, primo abbozzo di implementazione. 
    // Il problema principale è la gestione delle texture
    // che possono provenire da fonti diverse (sorgenti, librerie e caricate singolarmente dall'utente).
    // In breve: innanzitutto scatta una screenshot del materiale. per fare questo nasconde tutte le mesh,
    // crea una sfera temporanea e una camera temporanea prende la screenshot e poi rattiva le mesh così
    // come erano inialmente. Poi, clona il materiale iniziale (babylon) e lo associa ad un nuovo materiale lato server (zkMaterial).
    // Recupera le texture (babylon) associate al materiale di scena.
    // Per copiare le immagini lato server, recupera i fileObjectID per ognuna delle texture. 
    // (Per una texture babylon possono esserci più file fileObjectID associati. Ad esempio, per una cubemap, ci saranno 6 fileObjectID associati.)
    // Per ogni fileObjectID, memorizza su skMaterial anche la provenienza, in modo che lato server il path possa essere costruito correttamente.
    // Salva il nuovo zkMaterial (lato server avverrà la copia dei file di immagini texture).
    // Alla fine elimina il nuovo materiale creato come clone.
  }, {
    key: "makeLibraryMaterial",
    value: function makeLibraryMaterial(id, name) {
      var _this35 = this;
      return new Promise(function (resolve, reject) {
        _this35.getMaterialScreenShotForLibrary(id, function (data) {
          if (data) {
            _this35.createLibraryMaterial(id, name, data, resolve);
          } else {
            reject('No data generated for screenshot');
          }
        });
      });
    }
  }, {
    key: "getMaterialScreenShotForLibrary",
    value: function getMaterialScreenShotForLibrary(id, callback) {
      var _this36 = this;
      if (this._scene && this._sceneHelper) {
        this.resetEditorEnvironment();
        this.removeGround();
        if (this._environmentManager) {
          this._environmentManager.dispose();
          this._environmentManager = null;
        }
        var width = 500;
        var height = 500;
        this._sceneHelper.takeMaterialScreenshotAsync(id, width, height).then(function (data) {
          _Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.cropImageTransparency(data, width, height, function (croppedData) {
            _this36.refreshEnvironment();
            if (callback) callback(croppedData);
          });
        });
      } else {
        if (callback) callback(null);
      }
    }
  }, {
    key: "createLibraryMaterial",
    value: function createLibraryMaterial(id, name, screenshotImageData, callback) {
      var _this37 = this;
      // Clone del materiale originale
      var newMaterial = null;

      // Function da chiamare in chiusura di tutto il processo
      var complete = function complete() {
        if (newMaterial) _this37.deleteMaterial(newMaterial.id);
        if (callback) callback();
      };
      if (!this._scene || !this._sceneHelper || !this._zkScene) {
        complete();
        return;
      }
      var scene = this._scene;
      var sceneHelper = this._sceneHelper;
      var zkScene = this._zkScene;

      // Materiale da rendere di libreria
      var material = scene.getMaterialByID(id);
      if (!material) {
        complete();
        return;
      }

      // Creo il nuovo modello di materiale da libreria
      var zkMaterial = new Zakeke.Material();
      zkMaterial.set("name", name);
      zkMaterial.set("imageData", screenshotImageData);
      var originalMaterialID = id;
      var pathOriginalMaterialID = originalMaterialID.replace(/-/g, "");
      var newMaterialID = zkMaterial.getMaterialID();
      var pathNewMaterialID = newMaterialID.replace(/-/g, "");

      // Clono il materiale da serializzare per il salvataggio in libreria
      newMaterial = this.cloneMaterial(id, newMaterialID, name);
      if (!newMaterial) {
        complete();
        return;
      }
      var sourcesIDs = zkScene.getSourcesIDs();
      var allLibraryMaterialIDs = zkScene.getLibraryMaterialIDs();

      // recupero le texture (babylon js) del materiale
      var sceneTextures = sceneHelper.getTexturesForMaterial(newMaterial);

      // recupero i materiali di libreria dai quali derivano le texture del materiale da salvare
      var libraryMaterialIDs = [];
      for (var i = 0; i < sceneTextures.length; i++) {
        var sceneTexture = sceneTextures[i];
        if (sceneTexture["materialMapping"]) {
          var libraryMaterialID = sceneTexture["materialMapping"].libraryMaterialID;
          if (libraryMaterialID) libraryMaterialIDs.push(libraryMaterialID);
        }
      }

      // Materiali di libreria legati al materiale da salvare anch'esso in libreria
      var zkMaterials = new Zakeke.Materials();
      var suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
      var removeCubeTextureSuffix = function removeCubeTextureSuffix(url) {
        var idx = url.lastIndexOf(".");
        if (idx !== -1) {
          var nameWithoutExt = url.substring(0, idx);
          if (suffixes.some(function (suffix) {
            return nameWithoutExt.endsWith("_" + suffix);
          })) {
            return nameWithoutExt.substring(0, nameWithoutExt.length - 3);
          }
        }
        return url;
      };
      var checkTextureUrl = function checkTextureUrl(fileUrl, url) {
        var cleared = removeCubeTextureSuffix(fileUrl);
        return cleared.endsWith(url);
      };

      // La funzione si occupa di modificare l'url delle texture del nuovo materiale
      // e di salvare il materiale serializzato come materiale di libreria
      var saveInLibrary = function saveInLibrary() {
        for (var _i7 = 0; _i7 < sceneTextures.length; _i7++) {
          var _sceneTexture = sceneTextures[_i7];
          if (_sceneTexture && sceneHelper.isTextureWithUrl(_sceneTexture) && _sceneTexture.url) {
            var sourceID = null;
            var pathSourceID = null;
            var _libraryMaterialID = null;
            var pathLibraryMaterialID = null;

            // Verifico se nell'url è presente un codice sorgente 
            // (nel qual caso la texture deriva da una sorgente)
            for (var k = 0; k < sourcesIDs.length; k++) {
              var sID = sourcesIDs[k].replace(/-/g, "");
              var _idx2 = _sceneTexture.url.indexOf(sID);
              if (_idx2 != -1) {
                sourceID = sourcesIDs[k];
                pathSourceID = sID;
                break;
              }
            }

            // Verifico se si tratta di una texture proveniente da una libreria di materiali
            if (sourceID == null) {
              if (_sceneTexture["materialMapping"]) {
                _libraryMaterialID = _sceneTexture["materialMapping"].libraryMaterialID;
                if (_libraryMaterialID) pathLibraryMaterialID = _libraryMaterialID.replace(/-/g, "");
              }
            }

            // Ora devo recuperare i fileObjects relativi 
            var fileObjectsData = [];

            // Recupero dei fileObjects
            if (_libraryMaterialID) {
              for (var _k = 0; _k < zkMaterials.length; _k++) {
                if (zkMaterials.at(_k).getMaterialID() == _libraryMaterialID) {
                  var zkLibraryMaterial = zkMaterials.at(_k);
                  for (var w = 0; w < zkLibraryMaterial.get("textureImages").length; w++) {
                    var libraryTexture = zkLibraryMaterial.get("textureImages").at(w);
                    if (checkTextureUrl(libraryTexture.get("imageUrl"), _sceneTexture.url)) {
                      fileObjectsData.push({
                        fileObjectID: libraryTexture.get("fileObjectID"),
                        url: libraryTexture.get("imageUrl"),
                        fileLength: libraryTexture.get("fileLength")
                      });
                    }
                  }
                }
              }
            } else if (sourceID) {
              var sceneSource = zkScene.get("sources").findSource(sourceID);
              if (sceneSource) {
                for (var _k2 = 0; _k2 < sceneSource.get("textures").length; _k2++) {
                  var sourceTexture = sceneSource.get("textures").at(_k2);
                  if (checkTextureUrl(sourceTexture.get("url"), _sceneTexture.url)) {
                    fileObjectsData.push({
                      fileObjectID: sourceTexture.get("fileObjectID"),
                      url: sourceTexture.get("url"),
                      fileLength: sourceTexture.get("fileLength")
                    });
                  }
                }
              }
            } else {
              for (var _k3 = 0; _k3 < zkScene.get("textures").length; _k3++) {
                var txt = zkScene.get("textures").at(_k3);
                if (checkTextureUrl(txt.get("url"), _sceneTexture.url)) {
                  fileObjectsData.push({
                    fileObjectID: txt.get("fileObjectID"),
                    url: txt.get("url"),
                    fileLength: txt.get("fileLength")
                  });
                }
              }
            }

            // A questo punto per ogni file object devo creare un oggetto MaterialSourceTextureImage
            // e aggiungerlo al nuovo zkMaterial
            for (var j = 0; j < fileObjectsData.length; j++) {
              var sourceTextureImage = new Zakeke.MaterialSourceTextureImage();
              sourceTextureImage.set("fileObjectID", fileObjectsData[j].fileObjectID);
              sourceTextureImage.set("url", fileObjectsData[j].url || "");
              sourceTextureImage.set("fileLength", fileObjectsData[j].fileLength || -1);
              if (_libraryMaterialID) {
                sourceTextureImage.set("materialID", _libraryMaterialID);
              } else if (sourceID) {
                sourceTextureImage.set("sceneID", zkScene.getSceneID());
                sourceTextureImage.set("sourceID", sourceID);
              } else {
                sourceTextureImage.set("sceneID", zkScene.getSceneID());
                sourceTextureImage.set("materialID", originalMaterialID);
              }
              zkMaterial.get("sourceTextureImages").push(sourceTextureImage);
            }

            // Ora devo sostituire il nome alla texture corrente
            var oldString = "";
            var newString = "";
            var _name = _sceneTexture.name;
            if (sourceID && pathSourceID) {
              var _idx3 = _sceneTexture.url.indexOf(pathSourceID);
              if (_idx3 != -1) {
                _name = _sceneTexture.url.substring(_idx3);
              }
              oldString = pathSourceID;
              newString = "textures/" + pathNewMaterialID;
              _sceneTexture.name = _name.replace(new RegExp(oldString, 'g'), newString);
            } else if (_libraryMaterialID && pathLibraryMaterialID) {
              oldString = pathLibraryMaterialID;
              newString = pathNewMaterialID;
              _sceneTexture.name = _name.replace(new RegExp('textures\/([A-Za-z0-9]*)\/(.*)', 'g'), 'textures/' + newString + '/$2');
            } else {
              var idx = _sceneTexture.url.lastIndexOf("/");
              if (idx !== -1) {
                idx = _sceneTexture.url.lastIndexOf("/", idx - 1);
                if (idx !== -1) {
                  idx = _sceneTexture.url.lastIndexOf("/", idx - 1);
                  if (idx != -1) {
                    _name = _sceneTexture.url.substring(idx + 1);
                  }
                }
              }
              oldString = pathOriginalMaterialID;
              newString = pathNewMaterialID;
              _sceneTexture.name = _name.replace(new RegExp('textures\/([A-Za-z0-9]*)\/(.*)', 'g'), 'textures/' + newString + '/$2');
            }
            _sceneTexture.url = _sceneTexture.name;
          }
        }

        // Ora che le texture sono state "sistemate", posso serializzare e salvare
        if (newMaterial) {
          var jsonObj = newMaterial.serialize();
          var json = JSON.stringify(jsonObj);
          zkMaterial.set("JSON", json);
          zkMaterial.save(null, {
            success: function success(model, response, options) {
              complete();
            },
            error: function error(model, response, options) {
              complete();
            }
          });
        } else complete();
        // ---------------------------------
      };

      // Leggo tutti i materiali di libreria interessati
      if (libraryMaterialIDs.length > 0) {
        var _data3 = {
          ids: libraryMaterialIDs.join(',')
        };
        try {
          zkMaterials.fetch({
            success: function success(collection, response, options) {
              zkMaterials = collection;
              saveInLibrary();
            },
            error: function error(collection, response, options) {
              Logger.info("Errore nel salvataggio del materiale di libreria");
              complete();
            },
            data: _data3
          });
        } catch (e) {}
      } else {
        saveInLibrary();
      }
    }

    //#endregion

    //#region Lights
  }, {
    key: "lightsLayer_onLightSelected",
    value: function lightsLayer_onLightSelected(event) {
      this.fireLightSelectedEvent(event);
    }
  }, {
    key: "isDefaultLight",
    value: function isDefaultLight(light) {
      return this._sceneHelper ? this._sceneHelper.isDefaultLight(light) : false;
    }
  }, {
    key: "createLight",
    value: function createLight(name, type) {
      var light = null;
      if (this._scene) {
        var lightName = name || "new light";
        var lightType = type || "Point";
        var position = BABYLON.Vector3.Zero();
        var direction = BABYLON.Vector3.Zero();
        var angle = 25 * Math.PI / 180;
        var exponent = 2;
        if (lightType == "Point") light = new BABYLON.PointLight(lightName, position, this._scene);else if (lightType == "Directional") light = new BABYLON.DirectionalLight(lightName, direction, this._scene);else if (lightType == "Spot") light = new BABYLON.SpotLight(lightName, position, direction, angle, exponent, this._scene);else if (lightType == "Hemispheric") light = new BABYLON.HemisphericLight(lightName, direction, this._scene);
        if (light) light.id = Zakeke.generateUUID();
        if (this._lightsLayer) this._lightsLayer.refresh();
        this.setRenderingNeeded();
        this.fireLightsUpdateEvent();
      }
      return light;
    }
  }, {
    key: "cloneLight",
    value: function cloneLight(id, newId, newName) {
      var newLight = null;
      if (this._scene) {
        var light = this._scene.getLightByID(id);
        if (light) {
          var lightName = newName ? newName : light.name + " - clone";
          newLight = light.clone(lightName);
          if (newLight) {
            newLight.name = lightName; // Sometimes the clone parameter don't work

            var lightId = newId ? newId : Zakeke.generateUUID();
            newLight.id = lightId;
            if (this._lightsLayer) this._lightsLayer.refresh();
          }
        }
        this.setRenderingNeeded();
        this.fireLightsUpdateEvent();
      }
      return newLight;
    }
  }, {
    key: "renameLight",
    value: function renameLight(id, name) {
      if (this._scene) {
        var light = this._scene.getLightByID(id);
        if (light) {
          light.name = name;
          if (this._lightsLayer) this._lightsLayer.refresh();
        }
        this.fireLightsUpdateEvent();
      }
    }
  }, {
    key: "deleteLight",
    value: function deleteLight(id) {
      if (this._scene) {
        var light = this._scene.getLightByID(id);
        if (light) {
          light.dispose();
          // Per un bug di Babylon che sarà fixato a breve devo segnalare le mesh come da aggiornare per l'illuminazione
          this._scene.meshes.forEach(function (mesh) {
            return mesh._markSubMeshesAsLightDirty();
          });
          if (this._lightsLayer) this._lightsLayer.refresh();
        }
        this.setRenderingNeeded();
        this.fireLightsUpdateEvent();
      }
    }
  }, {
    key: "getAllLights",
    value: function getAllLights() {
      return this._scene ? this._scene.lights : [];
    }
  }, {
    key: "canShowLights",
    value: function canShowLights() {
      return this._showLights && this._envMode == _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor;
    }
  }, {
    key: "showHideLights",
    value: function showHideLights(show) {
      this._showLights = show;
      if (this._lightsLayer) this._lightsLayer.refresh();
      this.setRenderingNeeded();
    }

    //#endregion

    //#region Ground
  }, {
    key: "canShowGround",
    value: function canShowGround() {
      return this._showGround && this._envMode == _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor;
    }
  }, {
    key: "removeGround",
    value: function removeGround() {
      if (this._ground) {
        this._ground.dispose();
        this._ground = null;
      }
      this.setRenderingNeeded();
    }
  }, {
    key: "refreshGround",
    value: function refreshGround() {
      var _this38 = this;
      if (!this._scene) return;
      this.removeGround();
      if (!this.canShowGround()) {
        this.setRenderingNeeded();
        return;
      }
      var mainColor = this._scene.clearColor;
      var mainColorHex = mainColor.toHexString();
      var lum = _Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.isColorDark(mainColorHex) ? 0.8 : -0.5;
      var gridColor = BABYLON.Color3.FromHexString(_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.changeColorLuminosity(mainColorHex, lum));
      var size = 1000;
      var gridRatio = 1;
      if (this.countSceneMeshes() > 0) {
        var worldExtends = this._scene.getWorldExtends(function (mesh) {
          return _this38.isRealMesh(mesh);
        });
        var worldSize = worldExtends.max.subtract(worldExtends.min);
        var radius = worldSize.length() * 1.5;
        if (isFinite(radius)) {
          size = radius * 20;
          gridRatio = size / 100;
        }
      }
      this._ground = BABYLON.Mesh.CreateGround("ground", size, size, 10, this._scene);
      this._ground.doNotSerialize = true;
      this._ground.isVisible = this.showGround;
      this._ground.isPickable = false;
      this._ground.metadata = {
        isRealMesh: false,
        isGround: true
      };
      var gridMaterial = new BABYLON.GridMaterial("groundMaterial", this._scene);
      gridMaterial.doNotSerialize = true;
      gridMaterial.backFaceCulling = false;
      gridMaterial.mainColor = new BABYLON.Color3(mainColor.r, mainColor.g, mainColor.b);
      gridMaterial.opacity = 1;
      gridMaterial.gridRatio = gridRatio;
      gridMaterial.lineColor = gridColor;
      gridMaterial.metadata = {
        isRealMaterial: false
      };
      this._ground.material = gridMaterial;
      this.setRenderingNeeded();
    }
  }, {
    key: "showHideGround",
    value: function showHideGround(show) {
      this.showGround = show;
      this.refreshGround();
    }
    //#endregion

    //#region Axes
  }, {
    key: "canShowAxes",
    value: function canShowAxes() {
      return this._showAxes && this._envMode == _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor;
    }
  }, {
    key: "showHideAxes",
    value: function showHideAxes(show) {
      this._showAxes = show;
      if (this._axesLayer) this._axesLayer.refresh();
      this.setRenderingNeeded();
    }
    //#endregion

    //#region Highlights
  }, {
    key: "showHideHighlight",
    value: function showHideHighlight(show) {
      this._showHighlight = show;
      var mesh = this.getSelectedRootMesh();
      this.highlightMesh(mesh, show);
      this.setRenderingNeeded();
    }
  }, {
    key: "setHighlightOver",
    value: function setHighlightOver(highlight) {
      this._highlightOver = highlight;
    }
  }, {
    key: "highlightMesh",
    value: function highlightMesh(mesh, highlight) {
      if (!this._showHighlight || this._envMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) {
        this.deleteHighlightLayer();
        return;
      }
      if (mesh && mesh instanceof BABYLON.Mesh) {
        if (highlight) {
          if (!this._highlightLayer) this.createHighlightLayer();
          if (this._highlightLayer) this._highlightLayer.addMesh(mesh, BABYLON.Color3.FromHexString(this._highlightColor));
        } else {
          if (this._highlightLayer) {
            this._highlightLayer.removeMesh(mesh);
          }
        }
      }
      this.setLongRenderingNeeded();
    }
  }, {
    key: "highlightMeshOver",
    value: function highlightMeshOver(highlight) {
      if (!this._showHighlight || this._envMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) {
        this.deleteHighlightLayer();
        return;
      }
      if (this._meshOver && this._meshOver instanceof BABYLON.Mesh && !this.isMeshSelected(this._meshOver)) {
        if (highlight && this._highlightOver) {
          if (!this._highlightLayer) this.createHighlightLayer();
          if (this._highlightLayer && !this._highlightLayer.hasMesh(this._meshOver)) this._highlightLayer.addMesh(this._meshOver, BABYLON.Color3.FromHexString(this.highlightOverColor));
        } else {
          if (this._highlightLayer) this._highlightLayer.removeMesh(this._meshOver);
        }
      }
      this.setLongRenderingNeeded();
    }
    //#endregion

    //#region Edit control (Gizmo)
  }, {
    key: "showHideEditControl",
    value: function showHideEditControl(show) {
      if (this._scene && this._camera && this._canvas) {
        this._editControlVisible = show;
        if (this._editControl && (!show || this._manipulatedNode == null)) {
          this._editControl.detach();
          this._editControl = null;
        }
        if (show && this._manipulatedNode) {
          if (!this._editControl) {
            this._editControl = new this._EditControl(this._manipulatedNode, this._camera, this._canvas, 0.75, true);
            //set rotational snap valie in radians
            this._editControl.setRotSnapValue(3.14 / 18);
            //set transalation snap value in meters
            this._editControl.setTransSnapValue(0.5);
            //set scale snap value in scale ratio
            this._editControl.setScaleSnapValue(0.25);
          } else {
            this._editControl.switchTo(this._manipulatedNode);
          }
          this.setEditingMode(this._editingMode);
        }
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setEditingMode",
    value: function setEditingMode(mode) {
      this._editingMode = mode;
      if (this._editControl) {
        if (mode === _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EditingMode.Translate) this._editControl.enableTranslation();else if (mode === _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EditingMode.Rotate) this._editControl.enableRotation();else if (mode === _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EditingMode.Scaling) this._editControl.enableScaling();
      }
      this.setRenderingNeeded();
    }
  }, {
    key: "undoEditing",
    value: function undoEditing() {
      if (this._editControl) {
        this._editControl.undo();
      }
    }
  }, {
    key: "redoEditing",
    value: function redoEditing() {
      if (this._editControl) {
        this._editControl.redo();
      }
    }
    //#endregion

    //#region Environment
  }, {
    key: "setEnvironmentMode",
    value: function setEnvironmentMode(newMode) {
      if (newMode != this._envMode) {
        this._envMode = newMode;
        this.refreshEnvironment();
      }
    }
  }, {
    key: "refreshEnvironment",
    value: function refreshEnvironment() {
      if (!this._scene) return;
      this.setRenderingNeeded();
      if (this._envMode == _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) {
        this.disableAntialiasing();
        this.resetEditorEnvironment();
        if (this._environmentManager) {
          this._environmentManager.dispose();
          this._environmentManager = null;
        }
      } else {
        this.deleteHighlightLayer();
        this.refreshGround();
        if (this._zkScene) {
          if (!this._environmentManager || this._environmentManager.scene != this._scene) this._environmentManager = new _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_0__.EnvironmentManager(this._zkScene, this._scene);
          this._environmentManager.update();
          this.setLongRenderingNeeded();
        }
      }
      this.refreshGround();
      if (this._lightsLayer) this._lightsLayer.refresh();
      if (this._axesLayer) this._axesLayer.refresh();
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) this.autoRender = this._camera.useAutoRotationBehavior;
      this.setRenderingNeeded();
    }
    //#endregion

    //#region Zoom & Move camera
  }, {
    key: "zoomOnMesh",
    value: function zoomOnMesh(mesh) {
      if (this._sceneHelper) this._sceneHelper.zoomOnMesh(mesh);
    }

    // Sperimentale (è difficile capire come muovere la camera per inquadrare un oggetto)
  }, {
    key: "moveCameraToMeshPosition",
    value: function moveCameraToMeshPosition(mesh) {
      if (this._scene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var center = this._sceneHelper.getMeshHierarchyCenter(mesh);
        var target = this._camera.target;
        var radius = this._camera.radius;
        var direction = center.subtract(target);
        var length = direction.length();
        if (isFinite(length)) {
          var radiusVector = direction.normalize();
          var newPosition = target.add(radiusVector.scale(radius));
          var rayPick = new BABYLON.Ray(newPosition, radiusVector.scale(-1), radius);
          var meshFound = this._scene.pickWithRay(rayPick, function (item) {
            return item === mesh;
          });
          if (meshFound && meshFound.hit) {
            var scale = new BABYLON.Vector3();
            var rotation = new BABYLON.Quaternion();
            var position = new BABYLON.Vector3();
            mesh.getWorldMatrix().decompose(scale, rotation, position);
            var size = 0.1 / scale.length() * 100;
            var nlines = [];
            var v = meshFound.pickedPoint;
            var n = meshFound.getNormal();
            if (n) {
              radiusVector = n.normalize();
              newPosition = target.add(radiusVector.scale(radius));
            }

            // draw
            //nlines.push([v, v.add(n.scale(size))]);
            //var meshLines = {};
            //meshLines.normals = BABYLON.MeshBuilder.CreateLineSystem("normalLines", { lines: nlines }, this.scene);
          }

          this._sceneHelper.animateCamera(target, newPosition, 1);
        }
        this.setRenderingNeeded();
      }
    }

    //#endregion

    //#region Scene & Mesh Export: USDZ, glTF, Obj, AR
  }, {
    key: "exportMeshToOBJ",
    value: function exportMeshToOBJ(meshID) {
      if (!this._scene) return;
      var mesh = this._scene.getMeshByID(meshID);
      if (!mesh || !(mesh instanceof BABYLON.Mesh)) return;
      var objText = BABYLON.OBJExport.OBJ([mesh]);
      this.saveTextAsFile(objText, mesh.name + ".obj");
    }
  }, {
    key: "exportMeshGeometryToJson",
    value: function exportMeshGeometryToJson(meshID) {
      if (!this._scene) return;
      var mesh = this._scene.getMeshByID(meshID);
      if (!mesh || !(mesh instanceof BABYLON.Mesh)) return;
      var result = {
        positions: mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind),
        normals: mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind),
        colors: mesh.getVerticesData(BABYLON.VertexBuffer.ColorKind),
        uvs: mesh.getVerticesData(BABYLON.VertexBuffer.UVKind),
        uvs2: mesh.getVerticesData(BABYLON.VertexBuffer.UV2Kind),
        indices: mesh.getIndices()
      };
      var json = JSON.stringify(result, null, 0);
      this.saveTextAsFile(json, mesh.name + ".json");
    }
  }, {
    key: "enableDisableARForMesh",
    value: function enableDisableARForMesh(meshID, value) {
      var mesh = this.getMeshByID(meshID);
      if (mesh) {
        if (!mesh.metadata) mesh.metadata = {};
        mesh.metadata.AR = value;
      }
    }
  }, {
    key: "isAREnabledForMesh",
    value: function isAREnabledForMesh(meshID) {
      var mesh = this.getMeshByID(meshID);
      if (mesh && mesh.metadata) {
        if (mesh.metadata.AR !== undefined) return mesh.metadata.AR;else return true;
      }
      return false;
    }
  }, {
    key: "enableDisableTryOnForMesh",
    value: function enableDisableTryOnForMesh(meshID, value) {
      var mesh = this.getMeshByID(meshID);
      if (mesh) {
        if (!mesh.metadata) mesh.metadata = {};
        mesh.metadata.AR = value;
      }
    }
  }, {
    key: "isTryOnEnabledForMesh",
    value: function isTryOnEnabledForMesh(meshID) {
      var mesh = this.getMeshByID(meshID);
      if (mesh && mesh.metadata) {
        if (mesh.metadata.TryOn !== undefined) return mesh.metadata.TryOn;else return true;
      }
      return false;
    }

    //#endregion

    //#region Utilities
  }, {
    key: "splitSubMeshes",
    value: function splitSubMeshes(meshID) {
      if (this._scene && this._sceneHelper) {
        var mesh = this._scene.getMeshByID(meshID);
        if (mesh) this._sceneHelper.createMeshesFromSubMeshes(mesh);
      }
    }
  }, {
    key: "flipMeshFaces",
    value: function flipMeshFaces(meshID) {
      var parent = this.getMeshByID(meshID);
      if (!parent) return;
      var flip = function flip(mesh) {
        if (mesh instanceof BABYLON.Mesh) mesh.flipFaces(true);
        mesh.getChildMeshes().forEach(function (child) {
          return flip(child);
        });
      };
      flip(parent);
    }
  }, {
    key: "convertSceneToScreenPoint",
    value: function convertSceneToScreenPoint(sceneX, sceneY) {
      if (this._canvas) {
        var offX = 0;
        var offY = 0;
        var node = this._canvas;
        do {
          offX += node.offsetLeft;
          offY += node.offsetTop;
          node = node.offsetParent;
        } while (node);
        return {
          X: sceneX + offX,
          Y: sceneY + offY
        };
      }
      return null;
    }
  }, {
    key: "saveTextAsFile",
    value: function saveTextAsFile(text, filename) {
      var textToSave = text;
      var textToSaveAsBlob = new Blob([textToSave], {
        type: "text/plain"
      });
      var textToSaveAsURL = window.URL.createObjectURL(textToSaveAsBlob);
      var fileNameToSaveAs = filename;
      this.downloadFile(fileNameToSaveAs, textToSaveAsURL);
    }
  }, {
    key: "saveBytesAsFile",
    value: function saveBytesAsFile(data, filename) {
      var blob = new Blob([data]);
      var url = window.URL.createObjectURL(blob);
      var fileNameToSaveAs = filename;
      this.downloadFile(filename, url);
    }
  }, {
    key: "saveBlobAsFile",
    value: function saveBlobAsFile(blob, filename, mimetype) {
      var url = null;
      if (!mimetype) url = window.URL.createObjectURL(new Blob([blob]));else url = window.URL.createObjectURL(new Blob([blob], {
        type: mimetype
      }));
      this.downloadFile(filename, url);
    }
  }, {
    key: "downloadFile",
    value: function downloadFile(filename, url) {
      var downloadLink = document.createElement("a");
      downloadLink.download = filename;
      downloadLink.innerHTML = "Download File";
      downloadLink.href = url;
      downloadLink.onclick = function (ev) {
        document.body.removeChild(downloadLink);
      };
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }
    //#endregion

    //#region Draco
    // Test Draco encoding
  }, {
    key: "exportDracoEncodedToFile",
    value: function exportDracoEncodedToFile(meshID) {
      if (!this._scene) return;
      var mesh = this._scene.getMeshByID(meshID);
      if (!mesh) return;

      // ArrayBuffer con la codifica Draco della geometria
      var dracoData = this.getDracoEncodedGeometry(mesh);
      if (dracoData) this.saveBytesAsFile(dracoData, mesh.name + "_draco.dat");
    }

    // Funzione utile per testare la codifica Draco delle geometrie
    // La codifica reale delle mesh avviene durante il salvataggio e se ne
    // occupa la classe MakeIncremental, utilizzata in un worker thread
  }, {
    key: "getDracoEncodedGeometry",
    value: function getDracoEncodedGeometry(originalMesh) {
      var outputBuffer = null;
      if (this._scene && originalMesh && originalMesh instanceof BABYLON.Mesh) {
        var positions = originalMesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);
        var normals = originalMesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
        var colors = originalMesh.getVerticesData(BABYLON.VertexBuffer.ColorKind);
        var uvs = originalMesh.getVerticesData(BABYLON.VertexBuffer.UVKind);
        var uvs2 = originalMesh.getVerticesData(BABYLON.VertexBuffer.UV2Kind);
        var indices = originalMesh.getIndices();
        var mesh = {};
        if (indices) mesh.indices = new Uint32Array(indices);
        if (positions) mesh.positions = new Float32Array(positions);
        if (normals) mesh.normals = new Float32Array(normals);
        if (uvs) mesh.uvs = new Float32Array(uvs);
        if (uvs2) mesh.uvs2 = new Float32Array(uvs2);
        if (colors) mesh.colors = new Uint32Array(colors);
        var encoderModule = DracoEncoderModule();
        var encoder = new encoderModule.Encoder();
        var meshBuilder = new encoderModule.MeshBuilder();
        var dracoMesh = new encoderModule.Mesh();
        var numFaces = mesh.indices.length / 3;
        var numPoints = mesh.positions.length / 3;
        meshBuilder.AddFacesToMesh(dracoMesh, numFaces, mesh.indices);
        meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.POSITION, numPoints, 3, mesh.positions);
        if (mesh.normals) {
          meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.NORMAL, numPoints, 3, mesh.normals);
        }
        if (mesh.colors) {
          meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.COLOR, numPoints, 4, mesh.colors);
        }
        if (mesh.uvs) {
          meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.TEX_COORD, numPoints, 2, mesh.uvs);
        }
        if (mesh.uvs2) {
          meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.TEX_COORD, numPoints, 2, mesh.uvs2);
        }
        encoder.SetSpeedOptions(5, 5);
        encoder.SetAttributeQuantization(encoderModule.POSITION, 14);
        encoder.SetAttributeQuantization(encoderModule.TEX_COORD, 12);
        encoder.SetAttributeQuantization(encoderModule.NORMAL, 10);
        encoder.SetAttributeQuantization(encoderModule.COLOR, 10);
        encoder.SetAttributeQuantization(encoderModule.GENERIC, 8);
        encoder.SetEncodingMethod(encoderModule.MESH_EDGEBREAKER_ENCODING);
        var encodedData = new encoderModule.DracoInt8Array();
        var encodedLen = encoder.EncodeMeshToDracoBuffer(dracoMesh, encodedData);
        outputBuffer = new ArrayBuffer(encodedLen);
        var outputData = new Int8Array(outputBuffer);
        for (var i = 0; i < encodedLen; ++i) {
          outputData[i] = encodedData.GetValue(i);
        }
        encoderModule.destroy(dracoMesh);
        encoderModule.destroy(encodedData);
        encoderModule.destroy(encoder);
        encoderModule.destroy(meshBuilder);
      }
      return outputBuffer;
    }

    // Decodifica dei dati Draco ereditata da SceneViewer

    //#endregion

    //#region Mesh Creation
    // Crea una mesh (cubo) custom specificandone la geometria
    // utile per comprendere il modo in cui Babylon JS organizza i dati delle geomtrie
  }, {
    key: "createCustomMesh",
    value: function createCustomMesh() {
      var customMesh = null;
      if (this._scene) {
        customMesh = new BABYLON.Mesh("custom", this._scene);
        var positions = [-5, 2, -3, -7, -2, -3, -3, -2, -3, 5, 2, 3, 7, -2, 3, 3, -2, 3];
        var indices = [0, 1, 2, 3, 4, 5];
        var colors = [1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0, 1]; //color array added
        var uvs = [0, 1, 0, 0, 1, 0];

        //Empty array to contain calculated values or normals added
        var normals = [];

        //Calculations of normals added
        BABYLON.VertexData.ComputeNormals(positions, indices, normals);
        var vertexData = new BABYLON.VertexData();
        vertexData.positions = positions;
        vertexData.indices = indices;
        vertexData.colors = colors; //Assignment of colors to vertexData
        vertexData.normals = normals; //Assignment of normal to vertexData added
        vertexData.uvs = uvs;
        vertexData.applyToMesh(customMesh);
      }
      return customMesh;
    }
  }, {
    key: "createBox",
    value: function createBox(parentID, name) {
      var mesh = null;
      var parent = null;
      if (this._scene && this._sceneHelper) {
        if (parentID) parent = this._scene.getMeshByID(parentID);
        mesh = this._sceneHelper.createBox(parent, name);
        this.setLongRenderingNeeded();
      }
      return mesh;
    }
  }, {
    key: "getSceneBoundingBox",
    value: function getSceneBoundingBox() {
      var bbox = null;
      if (this._scene) {
        for (var i = 0; i < this._scene.meshes.length; i++) {
          var mesh = this._scene.meshes[i];
          if (mesh && mesh.metadata && mesh.metadata.sceneBoundingBox) {
            bbox = mesh;
            break;
          }
        }
      }
      return bbox;
    }
  }, {
    key: "getOrCreateSceneBoundingBox",
    value: function getOrCreateSceneBoundingBox() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var bbox = this.getSceneBoundingBox();
      if (!bbox) {
        bbox = this.createBoundingBox(null, "SceneBoundingBox", visible);
        if (bbox) {
          if (!bbox.metadata) bbox.metadata = {};
          bbox.metadata.boundingBox = true;
          bbox.metadata.sceneBoundingBox = true;
        }
      }
      return bbox;
    }
  }, {
    key: "createSceneBoundingBox",
    value: function createSceneBoundingBox() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var bbox = this.getSceneBoundingBox();
      if (bbox) bbox.isVisible = visible;else {
        bbox = this.createBoundingBox(null, "SceneBoundingBox", visible);
        if (bbox) {
          if (!bbox.metadata) bbox.metadata = {};
          bbox.metadata.boundingBox = true;
          bbox.metadata.sceneBoundingBox = true;
        }
      }
      return bbox;
    }
  }, {
    key: "createBoundingBox",
    value: function createBoundingBox(meshID, name) {
      var visible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var mesh = null;
      if (meshID) mesh = this.getMeshByID(meshID);
      if (this._sceneHelper) {
        var newMesh = this._sceneHelper.createBoundingBox(mesh, name);
        if (newMesh) newMesh.isVisible = visible;
        this.setLongRenderingNeeded();
        return newMesh;
      }
      return null;
    }
  }, {
    key: "createSphere",
    value: function createSphere(parentID, name) {
      var mesh = null;
      var parent = null;
      if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
      if (this._sceneHelper) {
        mesh = this._sceneHelper.createSphere(parent, name);
        this.setLongRenderingNeeded();
      }
      return mesh;
    }
  }, {
    key: "createPlane",
    value: function createPlane(parentID, name) {
      var mesh = null;
      var parent = null;
      if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
      if (this._sceneHelper) {
        mesh = this._sceneHelper.createPlane(parent, name);
        this.setLongRenderingNeeded();
      }
      return mesh;
    }
  }, {
    key: "createDisc",
    value: function createDisc(parentID, name) {
      var mesh = null;
      var parent = null;
      if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
      if (this._sceneHelper) {
        mesh = this._sceneHelper.createDisc(parent, name);
        this.setLongRenderingNeeded();
      }
      return mesh;
    }
  }, {
    key: "createCylinder",
    value: function createCylinder(parentID, name) {
      var mesh = null;
      var parent = null;
      if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
      if (this._sceneHelper) {
        mesh = this._sceneHelper.createCylinder(parent, name);
        this.setLongRenderingNeeded();
      }
      return mesh;
    }
  }, {
    key: "createTorus",
    value: function createTorus(parentID, name) {
      var mesh = null;
      var parent = null;
      if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
      if (this._sceneHelper) {
        mesh = this._sceneHelper.createTorus(parent, name);
        this.setLongRenderingNeeded();
      }
      return mesh;
    }
  }, {
    key: "createKnot",
    value: function createKnot(parentID, name) {
      var mesh = null;
      var parent = null;
      if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
      if (this._sceneHelper) {
        mesh = this._sceneHelper.createKnot(parent, name);
        this.setLongRenderingNeeded();
      }
      return mesh;
    }
  }, {
    key: "createRibbon",
    value: function createRibbon(parentID, name) {
      var mesh = null;
      var parent = null;
      if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
      if (this._sceneHelper) {
        mesh = this._sceneHelper.createRibbon(parent, name);
        this.setLongRenderingNeeded();
      }
      return mesh;
    }
  }, {
    key: "createRoundedCubeAsync",
    value: function () {
      var _createRoundedCubeAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee16$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context17.next = 8;
                break;
              }
              _context17.next = 6;
              return this._sceneHelper.createRoundedCubeAsync(parent, name);
            case 6:
              meshes = _context17.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context17.abrupt("return", meshes);
            case 9:
            case "end":
              return _context17.stop();
          }
        }, _callee16, this);
      }));
      function createRoundedCubeAsync(_x26, _x27) {
        return _createRoundedCubeAsync.apply(this, arguments);
      }
      return createRoundedCubeAsync;
    }()
  }, {
    key: "createRoundedCylinderAsync",
    value: function () {
      var _createRoundedCylinderAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee17$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context18.next = 8;
                break;
              }
              _context18.next = 6;
              return this._sceneHelper.createRoundedCylinderAsync(parent, name);
            case 6:
              meshes = _context18.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context18.abrupt("return", meshes);
            case 9:
            case "end":
              return _context18.stop();
          }
        }, _callee17, this);
      }));
      function createRoundedCylinderAsync(_x28, _x29) {
        return _createRoundedCylinderAsync.apply(this, arguments);
      }
      return createRoundedCylinderAsync;
    }()
  }, {
    key: "createMatBallAsync",
    value: function () {
      var _createMatBallAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee18$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context19.next = 8;
                break;
              }
              _context19.next = 6;
              return this._sceneHelper.createMatBallAsync(parent, name);
            case 6:
              meshes = _context19.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context19.abrupt("return", meshes);
            case 9:
            case "end":
              return _context19.stop();
          }
        }, _callee18, this);
      }));
      function createMatBallAsync(_x30, _x31) {
        return _createMatBallAsync.apply(this, arguments);
      }
      return createMatBallAsync;
    }()
  }, {
    key: "createMaleHeadAsync",
    value: function () {
      var _createMaleHeadAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee19$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context20.next = 8;
                break;
              }
              _context20.next = 6;
              return this._sceneHelper.createMaleHeadAsync(parent, name);
            case 6:
              meshes = _context20.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context20.abrupt("return", meshes);
            case 9:
            case "end":
              return _context20.stop();
          }
        }, _callee19, this);
      }));
      function createMaleHeadAsync(_x32, _x33) {
        return _createMaleHeadAsync.apply(this, arguments);
      }
      return createMaleHeadAsync;
    }()
  }, {
    key: "createFemaleHeadAsync",
    value: function () {
      var _createFemaleHeadAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee20$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context21.next = 8;
                break;
              }
              _context21.next = 6;
              return this._sceneHelper.createFemaleHeadAsync(parent, name);
            case 6:
              meshes = _context21.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context21.abrupt("return", meshes);
            case 9:
            case "end":
              return _context21.stop();
          }
        }, _callee20, this);
      }));
      function createFemaleHeadAsync(_x34, _x35) {
        return _createFemaleHeadAsync.apply(this, arguments);
      }
      return createFemaleHeadAsync;
    }()
  }, {
    key: "createPokemonBallAsync",
    value: function () {
      var _createPokemonBallAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee21$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context22.next = 8;
                break;
              }
              _context22.next = 6;
              return this._sceneHelper.createPokemonBallAsync(parent, name);
            case 6:
              meshes = _context22.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context22.abrupt("return", meshes);
            case 9:
            case "end":
              return _context22.stop();
          }
        }, _callee21, this);
      }));
      function createPokemonBallAsync(_x36, _x37) {
        return _createPokemonBallAsync.apply(this, arguments);
      }
      return createPokemonBallAsync;
    }()
  }, {
    key: "createShaderBallAsync",
    value: function () {
      var _createShaderBallAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee22$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context23.next = 8;
                break;
              }
              _context23.next = 6;
              return this._sceneHelper.createShaderBallAsync(parent, name);
            case 6:
              meshes = _context23.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context23.abrupt("return", meshes);
            case 9:
            case "end":
              return _context23.stop();
          }
        }, _callee22, this);
      }));
      function createShaderBallAsync(_x38, _x39) {
        return _createShaderBallAsync.apply(this, arguments);
      }
      return createShaderBallAsync;
    }()
  }, {
    key: "createBootsAsync",
    value: function () {
      var _createBootsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee23$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context24.next = 8;
                break;
              }
              _context24.next = 6;
              return this._sceneHelper.createBootsAsync(parent, name);
            case 6:
              meshes = _context24.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context24.abrupt("return", meshes);
            case 9:
            case "end":
              return _context24.stop();
          }
        }, _callee23, this);
      }));
      function createBootsAsync(_x40, _x41) {
        return _createBootsAsync.apply(this, arguments);
      }
      return createBootsAsync;
    }()
  }, {
    key: "createSuzanneAsync",
    value: function () {
      var _createSuzanneAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee24$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context25.next = 8;
                break;
              }
              _context25.next = 6;
              return this._sceneHelper.createSuzanneAsync(parent, name);
            case 6:
              meshes = _context25.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context25.abrupt("return", meshes);
            case 9:
            case "end":
              return _context25.stop();
          }
        }, _callee24, this);
      }));
      function createSuzanneAsync(_x42, _x43) {
        return _createSuzanneAsync.apply(this, arguments);
      }
      return createSuzanneAsync;
    }()
  }, {
    key: "createStepPyramidAsync",
    value: function () {
      var _createStepPyramidAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee25$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context26.next = 8;
                break;
              }
              _context26.next = 6;
              return this._sceneHelper.createStepPyramidAsync(parent, name);
            case 6:
              meshes = _context26.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context26.abrupt("return", meshes);
            case 9:
            case "end":
              return _context26.stop();
          }
        }, _callee25, this);
      }));
      function createStepPyramidAsync(_x44, _x45) {
        return _createStepPyramidAsync.apply(this, arguments);
      }
      return createStepPyramidAsync;
    }()
  }, {
    key: "createTeapotAsync",
    value: function () {
      var _createTeapotAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee26$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context27.next = 8;
                break;
              }
              _context27.next = 6;
              return this._sceneHelper.createTeapotAsync(parent, name);
            case 6:
              meshes = _context27.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context27.abrupt("return", meshes);
            case 9:
            case "end":
              return _context27.stop();
          }
        }, _callee26, this);
      }));
      function createTeapotAsync(_x46, _x47) {
        return _createTeapotAsync.apply(this, arguments);
      }
      return createTeapotAsync;
    }()
  }, {
    key: "createAlloyWheelAsync",
    value: function () {
      var _createAlloyWheelAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee27$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context28.next = 8;
                break;
              }
              _context28.next = 6;
              return this._sceneHelper.createAlloyWheelAsync(parent, name);
            case 6:
              meshes = _context28.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context28.abrupt("return", meshes);
            case 9:
            case "end":
              return _context28.stop();
          }
        }, _callee27, this);
      }));
      function createAlloyWheelAsync(_x48, _x49) {
        return _createAlloyWheelAsync.apply(this, arguments);
      }
      return createAlloyWheelAsync;
    }()
  }, {
    key: "createTryonReferenceGlassesFrameAsync",
    value: function () {
      var _createTryonReferenceGlassesFrameAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(parentID, name) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee28$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context29.next = 8;
                break;
              }
              _context29.next = 6;
              return this._sceneHelper.createTryonReferenceGlassesFrameAsync(parent, name);
            case 6:
              meshes = _context29.sent;
              this.setLongRenderingNeeded();
            case 8:
              return _context29.abrupt("return", meshes);
            case 9:
            case "end":
              return _context29.stop();
          }
        }, _callee28, this);
      }));
      function createTryonReferenceGlassesFrameAsync(_x50, _x51) {
        return _createTryonReferenceGlassesFrameAsync.apply(this, arguments);
      }
      return createTryonReferenceGlassesFrameAsync;
    }()
  }, {
    key: "importMeshesFromUrlAsync",
    value: function () {
      var _importMeshesFromUrlAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(parentID, url) {
        var meshes, parent;
        return _regeneratorRuntime().wrap(function _callee29$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              meshes = [];
              parent = null;
              if (this._scene && parentID) parent = this._scene.getMeshById(parentID);
              if (!this._sceneHelper) {
                _context30.next = 9;
                break;
              }
              _context30.next = 6;
              return this._sceneHelper.importMeshesFromUrlAsync(url, parent);
            case 6:
              meshes = _context30.sent;
              this.checkSceneEmptyEnvironmentTexture();
              this.setLongRenderingNeeded();
            case 9:
              return _context30.abrupt("return", meshes);
            case 10:
            case "end":
              return _context30.stop();
          }
        }, _callee29, this);
      }));
      function importMeshesFromUrlAsync(_x52, _x53) {
        return _importMeshesFromUrlAsync.apply(this, arguments);
      }
      return importMeshesFromUrlAsync;
    }() //#endregion
    //#region 2D Design Rendering
  }, {
    key: "connectMeshToModelSideAsync",
    value: function () {
      var _connectMeshToModelSideAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(meshID, submeshID, sideID) {
        return _regeneratorRuntime().wrap(function _callee30$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              if (this._sceneDesignManager) {
                this._sceneDesignManager.connectMeshToModelSideAsync(meshID, submeshID, sideID);
              }
            case 1:
            case "end":
              return _context31.stop();
          }
        }, _callee30, this);
      }));
      function connectMeshToModelSideAsync(_x54, _x55, _x56) {
        return _connectMeshToModelSideAsync.apply(this, arguments);
      }
      return connectMeshToModelSideAsync;
    }()
  }, {
    key: "clearMeshDesignManagers",
    value: function clearMeshDesignManagers() {
      if (this._sceneDesignManager) {
        this._sceneDesignManager.clearMeshDesignManagers();
      }
    }
  }, {
    key: "getMeshDesignMananger",
    value: function getMeshDesignMananger(mesh, subMesh) {
      if (this._sceneDesignManager && this.scene) {
        var _this$_sceneDesignMan;
        return (_this$_sceneDesignMan = this._sceneDesignManager) === null || _this$_sceneDesignMan === void 0 ? void 0 : _this$_sceneDesignMan.getMeshDesignMananger(mesh, subMesh);
      } else {
        return null;
      }
    }

    // -------------------------------------------------------------
    // Design view transformation
    // -------------------------------------------------------------
  }, {
    key: "translateDesignView",
    value: function translateDesignView(mesh, submesh, dx, dy) {
      if (this._sceneDesignManager) {
        this._sceneDesignManager.translateDesignView(mesh, submesh, dx, dy);
      }
    }
  }, {
    key: "rotateDesignView",
    value: function rotateDesignView(mesh, submesh, angle, centerX, centerY) {
      if (this._sceneDesignManager) {
        this._sceneDesignManager.rotateDesignView(mesh, submesh, angle, centerX, centerY);
      }
    }
  }, {
    key: "scaleDesignView",
    value: function scaleDesignView(mesh, submesh, hor, ver, centerX, centerY) {
      if (this._sceneDesignManager) {
        this._sceneDesignManager.scaleDesignView(mesh, submesh, hor, ver, centerX, centerY);
      }
    }
  }, {
    key: "setDesignViewTextureUVChannelAsync",
    value: function () {
      var _setDesignViewTextureUVChannelAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(mesh, submesh, uvChannel) {
        return _regeneratorRuntime().wrap(function _callee31$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (!this._sceneDesignManager) {
                _context32.next = 3;
                break;
              }
              _context32.next = 3;
              return this._sceneDesignManager.setDesignViewTextureUVChannelAsync(mesh, submesh, uvChannel);
            case 3:
            case "end":
              return _context32.stop();
          }
        }, _callee31, this);
      }));
      function setDesignViewTextureUVChannelAsync(_x57, _x58, _x59) {
        return _setDesignViewTextureUVChannelAsync.apply(this, arguments);
      }
      return setDesignViewTextureUVChannelAsync;
    }()
  }, {
    key: "setDesignViewFormFactorAsync",
    value: function () {
      var _setDesignViewFormFactorAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(mesh, submesh, percWidth, percHeight) {
        return _regeneratorRuntime().wrap(function _callee32$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              if (!this._sceneDesignManager) {
                _context33.next = 3;
                break;
              }
              _context33.next = 3;
              return this._sceneDesignManager.setDesignViewFormFactorAsync(mesh, submesh, percWidth, percHeight);
            case 3:
            case "end":
              return _context33.stop();
          }
        }, _callee32, this);
      }));
      function setDesignViewFormFactorAsync(_x60, _x61, _x62, _x63) {
        return _setDesignViewFormFactorAsync.apply(this, arguments);
      }
      return setDesignViewFormFactorAsync;
    }() //#endregion
    //#region Mesh measuring
  }, {
    key: "setSceneSizeCm",
    value: function setSceneSizeCm(size, sizeType) {
      var mesh = this.getOrCreateSceneBoundingBox(false);
      if (mesh) this.setMeshSizeCm(mesh.id, size, sizeType);
    }
  }, {
    key: "getSceneWidthCm",
    value: function getSceneWidthCm() {
      var mesh = this.getSceneBoundingBox();
      if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.width) return mesh.metadata.sizecm.width;
      return null;
    }
  }, {
    key: "getSceneHeightCm",
    value: function getSceneHeightCm() {
      var mesh = this.getSceneBoundingBox();
      if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.height) return mesh.metadata.sizecm.height;
      return null;
    }
  }, {
    key: "getSceneDepthCm",
    value: function getSceneDepthCm() {
      var mesh = this.getSceneBoundingBox();
      if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.depth) return mesh.metadata.sizecm.depth;
      return null;
    }
  }, {
    key: "setMeshSizeCm",
    value: function setMeshSizeCm(meshId, size, sizeType) {
      var mesh = this.getMeshByID(meshId);
      if (mesh) {
        var sizeObj = null;
        if (size && typeof size === "number" && !isNaN(size)) {
          if (sizeType === "width") sizeObj = {
            width: size
          };else if (sizeType === "height") sizeObj = {
            height: size
          };else if (sizeType === "depth") sizeObj = {
            depth: size
          };
        }
        if (!mesh.metadata) mesh.metadata = {};
        mesh.metadata.sizecm = sizeObj;
      }
    }
  }, {
    key: "getMeshWidthCm",
    value: function getMeshWidthCm(meshID) {
      var mesh = this.getMeshByID(meshID);
      if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.width) return mesh.metadata.sizecm.width;
      return null;
    }
  }, {
    key: "getMeshHeightCm",
    value: function getMeshHeightCm(meshID) {
      var mesh = this.getMeshByID(meshID);
      if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.height) return mesh.metadata.sizecm.height;
      return null;
    }
  }, {
    key: "getMeshDepthCm",
    value: function getMeshDepthCm(meshID) {
      var mesh = this.getMeshByID(meshID);
      if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.depth) return mesh.metadata.sizecm.depth;
      return null;
    }

    //#endregion

    //#region Material Previews
  }, {
    key: "getMaterialsPreviewsAsync",
    value: function () {
      var _getMaterialsPreviewsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(materialIDs, width, height, crop) {
        var createBlobs,
          results,
          rootUrl,
          _data4,
          filename,
          _args34 = arguments;
        return _regeneratorRuntime().wrap(function _callee33$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              createBlobs = _args34.length > 4 && _args34[4] !== undefined ? _args34[4] : true;
              results = [];
              if (!(this._scene && this._sceneHelper && this._zkScene)) {
                _context34.next = 11;
                break;
              }
              _context34.next = 5;
              return this.getSceneRootUrl();
            case 5:
              rootUrl = _context34.sent;
              if (!rootUrl) {
                _context34.next = 11;
                break;
              }
              _context34.next = 9;
              return _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_2__.MaterialsPreview.getPreviewsAsync(this._scene, rootUrl, materialIDs, {
                width: width,
                height: height
              }, true);
            case 9:
              _data4 = _context34.sent;
              for (filename in _data4.previewFiles) results.push(_data4.previewFiles[filename]);
            case 11:
              return _context34.abrupt("return", results);
            case 12:
            case "end":
              return _context34.stop();
          }
        }, _callee33, this);
      }));
      function getMaterialsPreviewsAsync(_x64, _x65, _x66, _x67) {
        return _getMaterialsPreviewsAsync.apply(this, arguments);
      }
      return getMaterialsPreviewsAsync;
    }()
  }, {
    key: "getAllMaterialsPreviewsAsync",
    value: function () {
      var _getAllMaterialsPreviewsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(width, height, crop) {
        var createBlobs,
          results,
          materials,
          materialIDs,
          _args35 = arguments;
        return _regeneratorRuntime().wrap(function _callee34$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              createBlobs = _args35.length > 3 && _args35[3] !== undefined ? _args35[3] : true;
              results = [];
              if (!(this._scene && this._sceneHelper && this._zkScene)) {
                _context35.next = 6;
                break;
              }
              materials = this._sceneHelper.getAllMaterials();
              materialIDs = materials.map(function (m) {
                return m.id;
              });
              return _context35.abrupt("return", this.getMaterialsPreviewsAsync(materialIDs, width, height, crop, createBlobs));
            case 6:
              return _context35.abrupt("return", results);
            case 7:
            case "end":
              return _context35.stop();
          }
        }, _callee34, this);
      }));
      function getAllMaterialsPreviewsAsync(_x68, _x69, _x70) {
        return _getAllMaterialsPreviewsAsync.apply(this, arguments);
      }
      return getAllMaterialsPreviewsAsync;
    }()
  }, {
    key: "downloadMaterialsPreviewsAsync",
    value: function () {
      var _downloadMaterialsPreviewsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(materialIDs, width, height, crop) {
        var rootUrl;
        return _regeneratorRuntime().wrap(function _callee35$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              if (!(this._scene && this._sceneHelper && this._zkScene)) {
                _context36.next = 7;
                break;
              }
              _context36.next = 3;
              return this.getSceneRootUrl();
            case 3:
              rootUrl = _context36.sent;
              if (!rootUrl) {
                _context36.next = 7;
                break;
              }
              _context36.next = 7;
              return _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_2__.MaterialsPreview.downloadPreviewsAsync(this._scene, rootUrl, materialIDs, {
                width: width,
                height: height,
                crop: crop
              });
            case 7:
            case "end":
              return _context36.stop();
          }
        }, _callee35, this);
      }));
      function downloadMaterialsPreviewsAsync(_x71, _x72, _x73, _x74) {
        return _downloadMaterialsPreviewsAsync.apply(this, arguments);
      }
      return downloadMaterialsPreviewsAsync;
    }()
  }, {
    key: "downloadAllMaterialsPreviewsAsync",
    value: function () {
      var _downloadAllMaterialsPreviewsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(width, height, crop) {
        var materials, materialIDs;
        return _regeneratorRuntime().wrap(function _callee36$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              if (!(this._scene && this._sceneHelper && this._zkScene)) {
                _context37.next = 5;
                break;
              }
              materials = this._sceneHelper.getAllMaterials();
              materialIDs = materials.map(function (m) {
                return m.id;
              });
              _context37.next = 5;
              return this.downloadMaterialsPreviewsAsync(materialIDs, width, height, crop);
            case 5:
            case "end":
              return _context37.stop();
          }
        }, _callee36, this);
      }));
      function downloadAllMaterialsPreviewsAsync(_x75, _x76, _x77) {
        return _downloadAllMaterialsPreviewsAsync.apply(this, arguments);
      }
      return downloadAllMaterialsPreviewsAsync;
    }() //#endregion
  }, {
    key: "createEnvelopeMesh",
    value: function createEnvelopeMesh(meshID) {
      if (this._scene && this._sceneHelper) {
        var mesh = this._scene.getMeshByID(meshID);
        if (mesh && mesh instanceof BABYLON.Mesh) {
          return this._sceneHelper.createEnvelopeMesh(mesh);
        }
      }
      return null;
    }
  }, {
    key: "expandMesh",
    value: function expandMesh(meshID, delta) {
      if (this._scene && this._sceneHelper) {
        var mesh = this._scene.getMeshByID(meshID);
        if (mesh && mesh instanceof BABYLON.Mesh) {
          this._sceneHelper.expandMesh(mesh, delta);
        }
      }
    }
  }, {
    key: "enableDisableMeshFacetData",
    value: function enableDisableMeshFacetData(meshID, enable) {
      if (this._scene && this._sceneHelper) {
        var mesh = this._scene.getMeshByID(meshID);
        if (mesh) {
          enable ? mesh.updateFacetData() : mesh.disableFacetData();
        }
      }
    }
  }, {
    key: "enableDisableDepthSortFacets",
    value: function enableDisableDepthSortFacets(meshID, enable) {
      if (this._scene && this._sceneHelper) {
        var mesh = this._scene.getMeshByID(meshID);
        if (mesh) {
          mesh.mustDepthSortFacets = enable;
        }
      }
    }
  }], [{
    key: "createSceneEditorAsync",
    value: function () {
      var _createSceneEditorAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(options) {
        var editor;
        return _regeneratorRuntime().wrap(function _callee37$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              editor = new SceneEditor(options);
              _context38.next = 3;
              return editor.initAsync();
            case 3:
              editor.checkSceneSourceTasks();
              return _context38.abrupt("return", editor);
            case 5:
            case "end":
              return _context38.stop();
          }
        }, _callee37);
      }));
      function createSceneEditorAsync(_x78) {
        return _createSceneEditorAsync.apply(this, arguments);
      }
      return createSceneEditorAsync;
    }()
  }]);
  return SceneEditor;
}(_SceneViewer__WEBPACK_IMPORTED_MODULE_10__.SceneViewer);
_defineProperty(SceneEditor, "EmptyGroupName", "_dummy_");

/***/ }),

/***/ "../../3D/src/Viewers/SceneViewer.ts":
/*!*******************************************!*\
  !*** ../../3D/src/Viewers/SceneViewer.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BroadcastChannelEventType": () => (/* binding */ BroadcastChannelEventType),
/* harmony export */   "SceneViewer": () => (/* binding */ SceneViewer)
/* harmony export */ });
/* harmony import */ var paper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! paper */ "../../../node_modules/paper/dist/paper-full.js");
/* harmony import */ var paper__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(paper__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Components_ActionExecutor_SceneActionExecutor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Components/ActionExecutor/SceneActionExecutor */ "../../3D/src/Components/ActionExecutor/SceneActionExecutor.ts");
/* harmony import */ var _Components_CollapseExplode_MeshLocationsManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Components/CollapseExplode/MeshLocationsManager */ "../../3D/src/Components/CollapseExplode/MeshLocationsManager.ts");
/* harmony import */ var _Components_DesignManagers_MeshDesignManager__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Components/DesignManagers/MeshDesignManager */ "../../3D/src/Components/DesignManagers/MeshDesignManager.ts");
/* harmony import */ var _Components_DesignManagers_SceneDesignManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Components/DesignManagers/SceneDesignManager */ "../../3D/src/Components/DesignManagers/SceneDesignManager.ts");
/* harmony import */ var _Components_Draco_DracoCompression__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Components/Draco/DracoCompression */ "../../3D/src/Components/Draco/DracoCompression.ts");
/* harmony import */ var _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Components/Environment/EnvironmentManager */ "../../3D/src/Components/Environment/EnvironmentManager.ts");
/* harmony import */ var _Components_Glow_GlowManager__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Components/Glow/GlowManager */ "../../3D/src/Components/Glow/GlowManager.ts");
/* harmony import */ var _Components_InfoPointsManager_InfoPointsManager__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Components/InfoPointsManager/InfoPointsManager */ "../../3D/src/Components/InfoPointsManager/InfoPointsManager.ts");
/* harmony import */ var _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Components/MaterialsPreview/MaterialsPreview */ "../../3D/src/Components/MaterialsPreview/MaterialsPreview.ts");
/* harmony import */ var _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Components/SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
/* harmony import */ var _Components_Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Components/Selector/ElementSelector */ "../../3D/src/Components/Selector/ElementSelector.ts");
/* harmony import */ var _Helpers_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Helpers/utils */ "../../3D/src/Helpers/utils.ts");
/* harmony import */ var _Misc_Database__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../Misc/Database */ "../../3D/src/Misc/Database.ts");
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }















var BroadcastChannelEventType = /*#__PURE__*/function (BroadcastChannelEventType) {
  BroadcastChannelEventType["CameraMovement"] = "camera-movement";
  BroadcastChannelEventType["ScriptExecution"] = "script-execution";
  BroadcastChannelEventType["DesignChanged"] = "design-changed";
  return BroadcastChannelEventType;
}({});
var SceneViewer = /*#__PURE__*/function () {
  function SceneViewer(options) {
    var _this2 = this;
    _classCallCheck(this, SceneViewer);
    // Zakeke Scene Model
    _defineProperty(this, "_zkScene", null);
    // Zakeke Product Model
    _defineProperty(this, "_zkModel", null);
    _defineProperty(this, "_canvasID", "zakeke-canvas-viewer3D-" + Zakeke.makeID(5));
    _defineProperty(this, "_canvas", null);
    _defineProperty(this, "_domElement", null);
    _defineProperty(this, "_lastWidth", Number.MIN_VALUE);
    _defineProperty(this, "_lastHeight", Number.MIN_VALUE);
    _defineProperty(this, "_engine", null);
    _defineProperty(this, "_scene", null);
    _defineProperty(this, "_bindedResize", null);
    _defineProperty(this, "_sceneHelper", null);
    _defineProperty(this, "_environmentManager", null);
    _defineProperty(this, "_glowManager", null);
    // Gestisce l'effetto glow sulle mesh con materiali emissivi
    _defineProperty(this, "_sceneActionsExecutor", null);
    // Esegue lo script di configurazione sulla scena
    _defineProperty(this, "_renderingNeeded", false);
    _defineProperty(this, "_renderingPaused", false);
    _defineProperty(this, "_autoRender", false);
    _defineProperty(this, "_antialias", true);
    _defineProperty(this, "_postProcesses", []);
    _defineProperty(this, "_camera", null);
    _defineProperty(this, "_hemiLight", null);
    _defineProperty(this, "_pointLight", null);
    _defineProperty(this, "_highlightColor", "#00ff00");
    _defineProperty(this, "_highlightSize", 2);
    _defineProperty(this, "_highlightLayer", null);
    _defineProperty(this, "_highlightBlurHorizontalSize", 1);
    _defineProperty(this, "_highlightBlurVerticalSize", 1);
    _defineProperty(this, "_highlightAnimationID", null);
    _defineProperty(this, "_highlightCurrentMeshes", []);
    _defineProperty(this, "_highlightNextMeshes", []);
    _defineProperty(this, "_deviceType", MPlaza.DeviceType.All);
    _defineProperty(this, "_destroyed", false);
    _defineProperty(this, "_sceneDesignManager", null);
    _defineProperty(this, "_meshLocationsManager", null);
    // Eventi
    _defineProperty(this, "_groupPickedListeners", []);
    _defineProperty(this, "_focusAttributesListeners", []);
    _defineProperty(this, "_designNotifyMessageListeners", []);
    _defineProperty(this, "_designRemoveMessageListeners", []);
    _defineProperty(this, "_designEventMessages", []);
    _defineProperty(this, "_onDelayLoadingStart", null);
    _defineProperty(this, "_onDelayLoadingProgress", null);
    _defineProperty(this, "_onDelayLoadingSuccess", null);
    _defineProperty(this, "_onDelayLoadingError", null);
    _defineProperty(this, "_infoPointPickedListeners", []);
    _defineProperty(this, "_infoPointContentShownListeners", []);
    _defineProperty(this, "_infoPointContentHiddenListeners", []);
    _defineProperty(this, "_beginAssetsLoadingListeners", []);
    _defineProperty(this, "_endAssetsLoadingListeners", []);
    _defineProperty(this, "_beginSceneLoadingListeners", []);
    _defineProperty(this, "_endSceneLoadingListeners", []);
    _defineProperty(this, "_arFileUrls", {});
    // cache degli url dei file per AR (USDZ, glb, glTF)
    _defineProperty(this, "_designTextureResolution", 1024);
    _defineProperty(this, "_configPreview", false);
    _defineProperty(this, "_defaultBackgroundColor", null);
    _defineProperty(this, "_grids", []);
    _defineProperty(this, "_dracoCompression", null);
    _defineProperty(this, "_infoPointsManager", null);
    _defineProperty(this, "_infoPointsManagerStyle", null);
    _defineProperty(this, "_canShowInfoPoints", true);
    _defineProperty(this, "_canShowInfoPointsContent", true);
    _defineProperty(this, "_broadcastChannel", null);
    _defineProperty(this, "_isHologramSource", false);
    _defineProperty(this, "_isHologram", false);
    _defineProperty(this, "_lastResizableMeshID", '');
    _defineProperty(this, "setCameraLocked", function (isBlocked) {
      if (_this2._zkScene && _this2._sceneHelper && _this2._scene) {
        _this2._sceneHelper.setupCamera();
        _this2._camera = _this2._scene.activeCamera;
        if (_this2._camera) {
          if (isBlocked) {
            _this2._sceneHelper.setCameraLimitLowerRadius(true);
            _this2._sceneHelper.setMinZoomPerc(1);
            _this2._sceneHelper.setMaxZoomPerc(1);
          } else {
            _this2._sceneHelper.setCameraLimitLowerRadius(false);
            _this2._sceneHelper.setMinZoomPerc(1);
            _this2._sceneHelper.setMaxZoomPerc(1.5);
          }
        }
      }
    });
    if (options != undefined) {
      if (typeof options == "boolean") this._configPreview = options;else {
        var _options$designTextur;
        this._designTextureResolution = (_options$designTextur = options === null || options === void 0 ? void 0 : options.designTextureResolution) !== null && _options$designTextur !== void 0 ? _options$designTextur : 1024;
        this._configPreview = options.configPreview;
        if (options.defaultBackgroundColor) this._defaultBackgroundColor = BABYLON.Color4.FromHexString(options.defaultBackgroundColor);
      }
    }
    this._elementSelector = new _Components_Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_11__.ElementSelector();

    // metodo init reso asincrono, necessita factory method
    //this.init();
  }
  _createClass(SceneViewer, [{
    key: "zkScene",
    get: function get() {
      return this._zkScene;
    }
  }, {
    key: "zkModel",
    get: function get() {
      return this._zkModel;
    }
  }, {
    key: "canvas",
    get: function get() {
      return this._canvas;
    }
  }, {
    key: "engine",
    get: function get() {
      return this._engine;
    }
  }, {
    key: "scene",
    get: function get() {
      return this._scene;
    }
  }, {
    key: "autoRender",
    get: function get() {
      return this._autoRender;
    },
    set: function set(value) {
      this._autoRender = value;
    }
  }, {
    key: "antialias",
    get: function get() {
      return this._antialias;
    },
    set: function set(value) {
      this._antialias = value;
    }
  }, {
    key: "isHologramSource",
    get: function get() {
      return this.isHologramSource;
    },
    set: function set(value) {
      this._isHologramSource = value;
      if (value) {
        this._isHologram = false;
        this.detachBroadcastChannelEventHandlers();
      }
    }
  }, {
    key: "isHologram",
    get: function get() {
      return this._isHologram;
    },
    set: function set(value) {
      this._isHologram = value;
      if (value) {
        this._isHologramSource = false;
        this.attachBroadcastChannelEventHandlers();
      } else {
        this.detachBroadcastChannelEventHandlers();
      }
      this.refreshEnvironment();
    }
  }, {
    key: "getAntialiasEnabled",
    value: function getAntialiasEnabled() {
      var def = true;
      if (this._zkScene) {
        var val = this._zkScene.getAntialiasEnabled();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setAntialiasEnabled",
    value: function setAntialiasEnabled(value) {
      if (this._zkScene) {
        this._zkScene.setAntialiasEnabled(value);
        value ? this.enableAntialiasing() : this.disableAntialiasing();
      }
    }

    // Per coerenza con tutto il resto inserisco questi metodi set & get, 
    // andrebbero usate solo le proprietà, ma questo anche in SceneEditor
  }, {
    key: "getARScale",
    value: function getARScale() {
      var def = true;
      if (this._zkScene) {
        var val = this._zkScene.getARScale();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setARScale",
    value: function setARScale(value) {
      if (this._zkScene) {
        this._zkScene.setARScale(value);
      }
    }
  }, {
    key: "getUseMaterialOffloading",
    value: function getUseMaterialOffloading() {
      var def = false;
      if (this.zkScene) {
        var val = this.zkScene.getUseMaterialOffloading();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setUseMaterialOffloading",
    value: function setUseMaterialOffloading(value) {
      if (this._zkScene) {
        this._zkScene.setUseMaterialOffloading(value);
      }
    }
  }, {
    key: "getPrefetchMeshes",
    value: function getPrefetchMeshes() {
      var def = true;
      if (this.zkScene) {
        var val = this.zkScene.getPrefetchMeshes();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setPrefetchMeshes",
    value: function setPrefetchMeshes(value) {
      if (this._zkScene) {
        this._zkScene.setPrefetchMeshes(value);
      }
    }
  }, {
    key: "getPrefetchMaterials",
    value: function getPrefetchMaterials() {
      var def = true;
      if (this.zkScene) {
        var val = this.zkScene.getPrefetchMaterials();
        if (val === undefined || val === null) return def;
        return val;
      }
      return def;
    }
  }, {
    key: "setPrefetchMaterials",
    value: function setPrefetchMaterials(value) {
      if (this._zkScene) {
        this._zkScene.setPrefetchMaterials(value);
      }
    }
  }, {
    key: "getShowHideInfoPoints",
    value: function getShowHideInfoPoints() {
      return this.canShowInfoPoints;
    }
  }, {
    key: "setShowHideInfoPoints",
    value: function setShowHideInfoPoints(value) {
      this.canShowInfoPoints = value;
    }
  }, {
    key: "camera",
    get: function get() {
      return this._camera;
    }
  }, {
    key: "deviceType",
    get: function get() {
      return this._deviceType;
    },
    set: function set(value) {
      this._deviceType = value;
    }
  }, {
    key: "getDeviceType",
    value: function getDeviceType() {
      return this.deviceType;
    }
  }, {
    key: "highlightColor",
    get: function get() {
      return this._highlightColor;
    },
    set: function set(value) {
      this._highlightColor = value;
    }
  }, {
    key: "highlightSize",
    get: function get() {
      return this._highlightSize;
    },
    set: function set(value) {
      this._highlightSize = value;
    }
  }, {
    key: "destroyed",
    get: function get() {
      return this._destroyed;
    }
  }, {
    key: "onDelayLoadingStart",
    get: function get() {
      return this._onDelayLoadingStart;
    },
    set: function set(callback) {
      this._onDelayLoadingStart = callback;
    }
  }, {
    key: "onDelayLoadingProgress",
    get: function get() {
      return this._onDelayLoadingProgress;
    },
    set: function set(callback) {
      this._onDelayLoadingProgress = callback;
    }
  }, {
    key: "onDelayLoadingSuccess",
    get: function get() {
      return this._onDelayLoadingSuccess;
    },
    set: function set(callback) {
      this._onDelayLoadingSuccess = callback;
    }
  }, {
    key: "onDelayLoadingError",
    get: function get() {
      return this._onDelayLoadingError;
    },
    set: function set(callback) {
      this._onDelayLoadingError = callback;
    }
  }, {
    key: "dracoCompression",
    get: function get() {
      if (!this._dracoCompression) {
        this._dracoCompression = _Components_Draco_DracoCompression__WEBPACK_IMPORTED_MODULE_5__.DracoCompression.Default;
        //this._dracoCompression = new DracoCompression(1);
      }

      return this._dracoCompression;
    }
  }, {
    key: "infoPointsShown",
    get: function get() {
      if (this._infoPointsManager) return this._infoPointsManager.infoPointsShown;
      return false;
    }
  }, {
    key: "infoPointsManagerStyle",
    get: function get() {
      return this._infoPointsManagerStyle;
    },
    set: function set(style) {
      this._infoPointsManagerStyle = style;
      this.updateInfoPointsManagerStyle();
    }
  }, {
    key: "canShowInfoPoints",
    get: function get() {
      return this._canShowInfoPoints;
    },
    set: function set(value) {
      this._canShowInfoPoints = value;
      this.refreshInfoPoints();
    }
  }, {
    key: "canShowInfoPointsContent",
    get: function get() {
      return this._canShowInfoPointsContent;
    },
    set: function set(value) {
      this._canShowInfoPointsContent = value;
      if (this._infoPointsManager) this._infoPointsManager.canShowInfoPointsContent = value;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.closeBroadcastChannel();
      this.removeCanvas();
      this.removeDomElement();
      this.deleteScene();
      this.deleteEngine();
    }
  }, {
    key: "initAsync",
    value: function () {
      var _initAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this._bindedResize = this.resize.bind(this);
              Zakeke.Tools.Init();
              BABYLON.Geometry.onDelayLoadingStart = function (evt) {
                if (_this3._onDelayLoadingStart) _this3._onDelayLoadingStart(evt);
              };
              BABYLON.Geometry.onDelayLoadingProgress = function (evt) {
                if (_this3._onDelayLoadingProgress) _this3._onDelayLoadingProgress(evt);
              };
              BABYLON.Geometry.onDelayLoadingSuccess = function (evt) {
                if (_this3._onDelayLoadingSuccess) _this3._onDelayLoadingSuccess(evt);
              };
              BABYLON.Geometry.onDelayLoadingError = function (evt) {
                if (_this3._onDelayLoadingError) _this3._onDelayLoadingError(evt);
              };
              BABYLON.Geometry.dracoDecodingFunction = function (filename, dataToDecode, callback) {
                _this3.dracoDecodingFunction(filename, dataToDecode, callback);
              };
              this.createCanvas();
              this.createDOMElement();
              _context.next = 11;
              return this.init3DEngineAsync();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initAsync() {
        return _initAsync.apply(this, arguments);
      }
      return initAsync;
    }()
  }, {
    key: "init3DEngineAsync",
    value: function () {
      var _init3DEngineAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.createEngine();
              _context2.next = 3;
              return this.createEmptySceneAsync();
            case 3:
              this._destroyed = false;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function init3DEngineAsync() {
        return _init3DEngineAsync.apply(this, arguments);
      }
      return init3DEngineAsync;
    }()
  }, {
    key: "createCanvas",
    value: function createCanvas() {
      var _this4 = this;
      this._canvas = document.createElement('canvas');
      this._canvas.setAttribute("id", this._canvasID);
      this._canvas.setAttribute("touch-action", "none");
      this._canvas.addEventListener("dblclick", function (e) {
        return _this4.setRenderingNeeded();
      });
      return this._canvas;
    }
  }, {
    key: "removeCanvas",
    value: function removeCanvas() {
      if (this._canvas) {
        this._canvas.remove();
        this._canvas = null;
      }
    }
  }, {
    key: "deleteEngine",
    value: function deleteEngine() {
      if (this._engine) {
        this._engine.dispose();
        this._engine = null;
      }
      this._destroyed = true;
      $(window).off("resize", this._bindedResize);
    }
  }, {
    key: "deleteScene",
    value: function deleteScene() {
      this.deleteComponents();
      if (this._scene) {
        this._scene.dispose();
        this._scene = null;
      }
    }
  }, {
    key: "deleteComponents",
    value: function deleteComponents() {
      this.emptyArFileCache();
      this.disposeInfoPointsManager();
      if (this._meshLocationsManager) {
        this._meshLocationsManager.dispose();
        this._meshLocationsManager = null;
      }
      if (this._sceneDesignManager) {
        this._sceneDesignManager.dispose();
        this._sceneDesignManager = null;
      }
      if (this._sceneHelper) {
        this._sceneHelper.dispose();
        this._sceneHelper = null;
      }
      if (this._environmentManager) {
        this._environmentManager.dispose();
        this._environmentManager = null;
      }
      if (this._glowManager) {
        this._glowManager.dispose();
        this._glowManager = null;
      }
      if (this._sceneActionsExecutor) {
        this._sceneActionsExecutor.dispose();
        this._sceneActionsExecutor = null;
      }
      this.disposePostProcesses();
    }
  }, {
    key: "disposeInfoPointsManager",
    value: function disposeInfoPointsManager() {
      if (this._infoPointsManager) {
        this._infoPointsManager.dispose();
        this._infoPointsManager = null;
      }
    }
  }, {
    key: "disposePostProcesses",
    value: function disposePostProcesses() {
      while (this._postProcesses.length > 0) {
        var postProcess = this._postProcesses.pop();
        if (postProcess) postProcess.dispose();
      }
    }
  }, {
    key: "emptyArFileCache",
    value: function emptyArFileCache() {
      this._arFileUrls = {};
    }
  }, {
    key: "resetSceneAsync",
    value: function () {
      var _resetSceneAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.init3DEngineAsync();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function resetSceneAsync() {
        return _resetSceneAsync.apply(this, arguments);
      }
      return resetSceneAsync;
    }()
  }, {
    key: "closeBroadcastChannel",
    value: function closeBroadcastChannel() {
      if (this._broadcastChannel) {
        this._broadcastChannel.close();
        this._broadcastChannel = null;
      }
    }
  }, {
    key: "openBroadcastChannel",
    value: function openBroadcastChannel() {
      if (!this._broadcastChannel && window['BroadcastChannel']) {
        try {
          this._broadcastChannel = new BroadcastChannel("zakeke-broadcast-channel");
        } catch (ex) {
          console.error('Failed opening broadcast channel');
          console.error(ex);
        }
      }
    }
  }, {
    key: "getOrCreateBroadcastChannel",
    value: function getOrCreateBroadcastChannel() {
      this.openBroadcastChannel();
      return this._broadcastChannel;
    }
  }, {
    key: "createEngine",
    value: function createEngine() {
      var _this5 = this;
      this.deleteScene();
      this.deleteEngine();

      // Se preserveDrawingBuffer = false (default) ci sono problemi nel recupero
      // dello screenshot. D'altra parte, preserveDrawingBuffer = true peggiora le 
      // performance in quanto WebGL è costretto a copiare e non a swappare i buffer di disegno (drawing)
      // e di visualizzazione.
      //this.engine = new BABYLON.Engine(this.canvas, true, { preserveDrawingBuffer: false });
      this._engine = new BABYLON.Engine(this._canvas, true, {
        stencil: true,
        preserveDrawingBuffer: true
      });
      this._engine.enableOfflineSupport = false;
      Logger.info("WebGL version: " + this._engine.webGLVersion);

      //BABYLON.SceneLoader.ForceFullSceneLoadingForIncremental = true;

      $(window).resize(this._bindedResize);
      $(window).on("orientationchange", function () {
        setTimeout(function () {
          return _this5._bindedResize();
        }, 100);
      });
    }
  }, {
    key: "createEmptySceneAsync",
    value: function () {
      var _createEmptySceneAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              //this._zkScene = null;
              this.deleteScene();
              if (!this._engine) {
                _context4.next = 6;
                break;
              }
              this._scene = new BABYLON.Scene(this._engine);
              if (this._defaultBackgroundColor) {
                this._scene.clearColor.copyFrom(this._defaultBackgroundColor);
              }
              _context4.next = 6;
              return this.setupSceneAsync();
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createEmptySceneAsync() {
        return _createEmptySceneAsync.apply(this, arguments);
      }
      return createEmptySceneAsync;
    }()
  }, {
    key: "setupSceneAsync",
    value: function () {
      var _setupSceneAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this6 = this;
        var cameraPositionScale, cameraLimitLowerRadius, zoomEnabled, useMinZoomPerc, minZoomPerc, useMaxZoomPerc, maxZoomPerc, lowerAlphaLimit, upperAlphaLimit, lowerBetaLimit, upperBetaLimit;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(this._engine && this._scene)) {
                _context5.next = 35;
                break;
              }
              this._sceneHelper = new _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_10__.SceneHelper(this._scene);
              cameraPositionScale = this._zkScene ? this._zkScene.getCameraPositionScale() : undefined;
              cameraLimitLowerRadius = this._zkScene ? this._zkScene.getCameraLimitLowerRadius() : undefined;
              zoomEnabled = this._zkScene ? this._zkScene.getCameraZoomEnabled() : undefined;
              useMinZoomPerc = this._zkScene ? this._zkScene.getCameraUseMinZoomPerc() : false;
              minZoomPerc = this._zkScene ? this._zkScene.getCameraMinZoomPerc() : 1.0;
              useMaxZoomPerc = this._zkScene ? this._zkScene.getCameraUseMaxZoomPerc() : false;
              maxZoomPerc = this._zkScene ? this._zkScene.getCameraMaxZoomPerc() : 1.5;
              lowerAlphaLimit = this._zkScene ? this._zkScene.getCameraLowerAlphaLimit() : null;
              upperAlphaLimit = this._zkScene ? this._zkScene.getCameraUpperAlphaLimit() : null;
              lowerBetaLimit = this._zkScene ? this._zkScene.getCameraLowerBetaLimit() : null;
              upperBetaLimit = this._zkScene ? this._zkScene.getCameraUpperBetaLimit() : null;
              if (cameraPositionScale != undefined && cameraPositionScale != null) this._sceneHelper.setCameraPositionScale(cameraPositionScale, false);
              if (cameraLimitLowerRadius != undefined && cameraLimitLowerRadius != null) this._sceneHelper.setCameraLimitLowerRadius(cameraLimitLowerRadius, false);
              if (zoomEnabled != undefined && zoomEnabled != null) this._sceneHelper.setZoomEnabled(zoomEnabled);
              this._sceneHelper.setupCamera();
              this._camera = this._scene.activeCamera;
              if (this._camera) {
                if (useMinZoomPerc) this._sceneHelper.setMinZoomPerc(minZoomPerc);else this._sceneHelper.setMinZoomPerc(null);
                if (useMaxZoomPerc) this._sceneHelper.setMaxZoomPerc(maxZoomPerc);else this._sceneHelper.setMaxZoomPerc(null);
                this._sceneHelper.setCameraAlphaLimits(lowerAlphaLimit, upperAlphaLimit);
                this._sceneHelper.setCameraBetaLimits(lowerBetaLimit, upperBetaLimit);
                this._camera.onViewMatrixChangedObservable.add(function () {
                  _this6.notifyCameraMovement();
                });
                this._camera.onRestoreStateObservable.add(function () {
                  _this6.setupShaderMaterialsCameraPosition();
                  _this6.setRenderingNeeded();
                });
              }
              this._sceneHelper.setupLights();
              this.createHighlightLayer();
              this.fixEnvironmentTexture();
              this.refreshEnvironment();
              this.setupGlowManager();
              if (this._zkScene) {
                this._meshLocationsManager = new _Components_CollapseExplode_MeshLocationsManager__WEBPACK_IMPORTED_MODULE_2__.MeshLocationsManager();
                this._meshLocationsManager.setModelAndScene(this._zkScene, this._scene);
                this._meshLocationsManager.addMeshAnimationCompletedListener(function () {
                  return _this6.setRenderingNeeded();
                });
              }
              _context5.next = 27;
              return this.setupSceneActionsExecutorAsync();
            case 27:
              this.setRenderingOnDelayLoaded();
              this.setupAntialiasPostProcesses();
              this._scene.onPointerDown = function (evt, pickInfo) {
                return _this6.onPointerDown(evt, pickInfo);
              };
              this._scene.registerBeforeRender(function () {
                _this6.onBeforeRender();
              });
              this.refreshInfoPoints();

              // Stop the automatic rendering
              this._engine.stopRenderLoop();
              // Render the first frame.
              this.render();
              //start main render loop
              this._engine.runRenderLoop(function () {
                _this6.checkRendering();
              });

              /*
              this.engine.runRenderLoop(function() {
                  this._scene.render();
              });
              */
            case 35:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function setupSceneAsync() {
        return _setupSceneAsync.apply(this, arguments);
      }
      return setupSceneAsync;
    }()
  }, {
    key: "onBeforeRender",
    value: function onBeforeRender() {
      if (this._scene && this._sceneHelper) {
        if (this._camera) {
          var pointLight = this._sceneHelper.getDefaultPointLight();
          if (pointLight) pointLight.position = this._camera.position;
        }
        this._scene.meshes.forEach(function (m) {
          if (m.mustDepthSortFacets && m.isFacetDataEnabled) m.updateFacetData();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._scene && !this._scene.isDisposed && !this._renderingPaused) this._scene.render();
    }

    // Disabilito il post-processing quando la camera è in movimento 
  }, {
    key: "checkRendering",
    value: function checkRendering() {
      if (this._scene) {
        if (this._autoRender || this._renderingNeeded || this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving()) {
          if (this._autoRender || this._scene._activeAnimatables.length !== 0 || this._sceneHelper && this._sceneHelper.userIsMoving() /*&& !this.sceneHelper.cameraLimitsReached()*/) {
            this.disableAntialiasing();
          } else this.enableAntialiasing();
          this.render();
          if (this._renderingNeeded) this._renderingNeeded = false;
        } else {
          if (!this._scene.postProcessesEnabled && this.canEnableAntialiasing()) {
            this.enableAntialiasing();
            this.render();
          }
        }
        if (this._infoPointsManager) {
          var updated = this._infoPointsManager.updateInfoPointsVisibility();
          if (updated) this.render();
        }
      }
    }
  }, {
    key: "setupAntialiasPostProcesses",
    value: function setupAntialiasPostProcesses() {
      if (this._antialias && this.getAntialiasEnabled()) {
        this.createAntialiasPostProcesses();
      }
    }
  }, {
    key: "createAntialiasPostProcesses",
    value: function createAntialiasPostProcesses() {
      if (this._camera && this._postProcesses.length === 0) {
        var is_firefox = /firefox/i.test(navigator.userAgent);
        if (!is_firefox) this._postProcesses.push(new BABYLON.PassPostProcess("scale_pass", 4.0, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE));
        this._postProcesses.push(new BABYLON.PassPostProcess("scale_pass", 2.0, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE));
        this._postProcesses.push(new BABYLON.PassPostProcess("scale_pass", 1.0, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE));
      }
    }
  }, {
    key: "canEnableAntialiasing",
    value: function canEnableAntialiasing() {
      return this._scene && this._antialias && this.getAntialiasEnabled();
    }
  }, {
    key: "enableAntialiasing",
    value: function enableAntialiasing() {
      if (this._scene && this.canEnableAntialiasing()) {
        this.createAntialiasPostProcesses();
        this._scene.postProcessesEnabled = true;
      }
    }
  }, {
    key: "disableAntialiasing",
    value: function disableAntialiasing() {
      var clearPostProcessed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this._scene && this._antialias) {
        this._scene.postProcessesEnabled = false;
      }
      if (clearPostProcessed) this.disposePostProcesses();
    }
  }, {
    key: "setRenderingNeeded",
    value: function setRenderingNeeded() {
      this._renderingNeeded = true;
    }
  }, {
    key: "setLongRenderingNeeded",
    value: function setLongRenderingNeeded() {
      var _this7 = this;
      this.setRenderingNeeded();
      for (var t = 50; t <= 1000; t += 200) {
        setTimeout(function () {
          return _this7.setRenderingNeeded();
        }, t);
      }
    }
  }, {
    key: "refreshRendering",
    value: function refreshRendering() {
      this.setLongRenderingNeeded();
    }
  }, {
    key: "pauseRendering",
    value: function pauseRendering() {
      this._renderingPaused = true;
    }
  }, {
    key: "resumeRendering",
    value: function resumeRendering() {
      this._renderingPaused = false;
      this.setRenderingNeeded();
    }
  }, {
    key: "setLoadingScreen",
    value: function setLoadingScreen(loadingScreen) {
      if (this._engine) this._engine.loadingScreen = loadingScreen;
    }
  }, {
    key: "setRenderingOnDelayLoaded",
    value: function setRenderingOnDelayLoaded() {
      if (this._scene) {
        var _this = this;
        this._scene.getGeometries().forEach(function (geometry) {
          var origCallback = geometry.onGeometryUpdated;
          geometry.onGeometryUpdated = function (geom, kind) {
            _this.setLongRenderingNeeded();
            if (origCallback) origCallback.apply(this, [geom, kind]);
          };
        });
      }
    }
  }, {
    key: "createHighlightLayer",
    value: function createHighlightLayer() {
      if (this._scene) {
        this._highlightLayer = new BABYLON.HighlightLayer("hl1", this._scene);
        this.setupHighlightLayerIntensity();
      }
    }
  }, {
    key: "setupHighlightLayerIntensity",
    value: function setupHighlightLayerIntensity() {
      if (this._highlightLayer) {
        this._highlightLayer.blurHorizontalSize = this._highlightSize;
        this._highlightLayer.blurVerticalSize = this._highlightSize;
        this._highlightBlurHorizontalSize = this._highlightSize;
        this._highlightBlurVerticalSize = this._highlightSize;
      }
    }
  }, {
    key: "createDOMElement",
    value: function createDOMElement() {
      if (this._canvas) {
        this._domElement = document.createElement('div');
        this._domElement.setAttribute("id", "zakeke-canvas-viewer3D-div-" + Zakeke.makeID(5));
        this._domElement.appendChild(this._canvas);
        this._domElement.style.position = "absolute";
        this._domElement.style.width = "100%";
        this._domElement.style.height = "100%";
        this._domElement.style.left = "0";
        this._domElement.style.top = "0";
      }
    }
  }, {
    key: "removeDomElement",
    value: function removeDomElement() {
      if (this._domElement) {
        this.detach();
        this._domElement.remove();
        this._domElement = null;
      }
    }
  }, {
    key: "appendTo",
    value: function appendTo(element) {
      if (this._domElement) {
        if (element.firstChild) element.insertBefore(this._domElement, element.firstChild);else element.appendChild(this._domElement);
        element.appendChild(this._domElement);

        // Senza la doppia chiamata al resize si hanno dei problemi su mobile
        // In particolare gli eventi vengono catturati ad una frequenza molto bassa
        this.resize();
        this.resize();
      }
    }
  }, {
    key: "detach",
    value: function detach() {
      if (this._domElement && this._domElement.parentNode) this._domElement.parentNode.removeChild(this._domElement);
    }
  }, {
    key: "updateView",
    value: function updateView() {
      var adjustCamera = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.resize(adjustCamera);
    }
  }, {
    key: "resize",
    value: function resize() {
      var adjustCamera = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!this._canvas) return;
      this.disableAntialiasing(true);
      var parent = this._canvas.parentNode;
      if (!parent || !(parent instanceof HTMLElement)) return;
      var parentWidth = parent.offsetWidth;
      var parentHeight = parent.offsetHeight;

      // Avoid adjusting camera when we trigger the resize and nothing as changed
      if (parentWidth != this._lastWidth || parentHeight != this._lastHeight) {
        this._canvas.style.width = "100%";
        this._canvas.style.height = "100%";
        if (this._engine) {
          this._engine.resize();
          if (adjustCamera) {
            if (this._scene) this.adjustCamera(false);
            this.setupShaderMaterialsCameraPosition();
          }
          this.setRenderingNeeded();
        }

        //Logger.info("SceneViewer.resize - Canvas width: " + this._canvas.width + " - height: " + this._canvas.height);
      }

      this._lastWidth = parentWidth;
      this._lastHeight = parentHeight;
      this.enableAntialiasing();
    }
  }, {
    key: "switchFullScreen",
    value: function switchFullScreen(parent) {
      if (this._sceneHelper) this._sceneHelper.switchFullScreen(parent);
    }
  }, {
    key: "setupGlowManager",
    value: function setupGlowManager() {
      if (this._glowManager) {
        this._glowManager.dispose();
        this._glowManager = null;
      }
      if (this._zkScene && this._scene) {
        this._glowManager = new _Components_Glow_GlowManager__WEBPACK_IMPORTED_MODULE_7__.GlowManager(this._zkScene, this._scene);
        this._glowManager.update();
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "setupSceneActionsExecutorAsync",
    value: function () {
      var _setupSceneActionsExecutorAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this8 = this;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (this._zkScene && this._scene) {
                this._sceneActionsExecutor = new _Components_ActionExecutor_SceneActionExecutor__WEBPACK_IMPORTED_MODULE_1__.SceneActionsExecutor(this._zkScene, this._scene);
                this._sceneActionsExecutor.deviceType = this.deviceType;
                this._sceneActionsExecutor.useMaterialOffloading = !this._configPreview && this.getUseMaterialOffloading();
                this._sceneActionsExecutor.prefetchMeshes = this.getPrefetchMeshes();
                this._sceneActionsExecutor.prefetchMaterials = this.getPrefetchMaterials();
                this._sceneActionsExecutor.addMeshDesignRefreshRequiredListeners( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(evt) {
                    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                      while (1) switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.next = 2;
                          return _this8.refreshMeshesDesignAsync(evt.meshes, evt.effect);
                        case 2:
                        case "end":
                          return _context6.stop();
                      }
                    }, _callee6);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
                this._sceneActionsExecutor.addBeginAssetsLoadingListener(function () {
                  return _this8.fireBeginAssetsLoadingEvent();
                });
                this._sceneActionsExecutor.addEndAssetsLoadingListener(function () {
                  return _this8.fireEndAssetsLoadingEvent();
                });
              }
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function setupSceneActionsExecutorAsync() {
        return _setupSceneActionsExecutorAsync.apply(this, arguments);
      }
      return setupSceneActionsExecutorAsync;
    }()
  }, {
    key: "restoreCameraState",
    value: function restoreCameraState() {
      if (this._sceneHelper) {
        this._sceneHelper.restoreCameraState();
        this._sceneHelper.setupShaderMaterialsCameraPosition();
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "fixEnvironmentTexture",
    value: function fixEnvironmentTexture() {
      if (this._scene && this._scene.environmentTexture && this._scene.environmentTexture["url"] && typeof this._scene.environmentTexture["url"] === "string") {
        var url = this._scene.environmentTexture["url"];
        var count = (url.match(/http/g) || []).length;
        var newUrl = url;
        if (count > 1) {
          var idx = url.lastIndexOf("http");
          if (idx >= 0) {
            newUrl = url.substring(idx);
          }
        }

        // Le informazioni sulla rotazione e sugli eventuali file della cubemap sono salvati
        // nei metadatadi della scena perché c'è un bug babylon in fase di serializzazione.
        // Li recupero ler settarli sull'environment con l'url sistemato
        var rotationY = undefined;
        var extensions = undefined;
        var files = undefined;
        if (this._scene && this._scene.metadata) {
          if (this._scene.metadata.environmentTextureRotationY !== undefined && typeof this._scene.metadata.environmentTextureRotationY === "number") {
            rotationY = this._scene.metadata.environmentTextureRotationY;
          }
          if (this._scene.metadata.environmentTextureExtensions) extensions = this._scene.metadata.environmentTextureExtensions;
          if (this._scene.metadata.environmentTextureFiles) files = this._scene.metadata.environmentTextureFiles;
        }
        this.setSceneEnvironmentTexture(newUrl, rotationY, extensions, files);
      } else {
        this.checkSceneEmptyEnvironmentTexture();
      }
    }
  }, {
    key: "checkSceneEmptyEnvironmentTexture",
    value: function checkSceneEmptyEnvironmentTexture() {
      // Controlla se la scena contiene materiali PBR ma ha la EnvironmentTexture vuota
      if (this._scene && this._sceneHelper && this._sceneHelper.containsPBRMaterials() && !this._scene.environmentTexture) {
        this.setDefaultSceneEnvironmentTexture();
      }
    }
  }, {
    key: "setDefaultSceneEnvironmentTexture",
    value: function setDefaultSceneEnvironmentTexture() {
      var url = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_14__.DefaultAssetUrls.Environment.EnvironmentTextureCDNUrl;
      this.setSceneEnvironmentTexture(url);
    }
  }, {
    key: "setSceneEnvironmentTexture",
    value: function setSceneEnvironmentTexture(url, rotationY, extensions, files, onLoad) {
      var _this9 = this;
      if (this._scene && this._sceneHelper) {
        if (this._scene.environmentTexture && this._sceneHelper.isTextureWithUrl(this._scene.environmentTexture) && this._scene.environmentTexture.url && this._scene.environmentTexture.url != url) {
          this._scene.environmentTexture.dispose();
          this._scene.environmentTexture = null;
        }
        var onImagesLoad = function onImagesLoad() {
          if (onLoad) onLoad();
          _this9.setLongRenderingNeeded();
        };
        if (!this._scene.metadata) this._scene.metadata = {};
        delete this._scene.metadata.environmentTextureType;
        delete this._scene.metadata.environmentTextureSize;
        delete this._scene.metadata.environmentTextureExtensions;
        delete this._scene.metadata.environmentTextureFiles;

        //const environmentTexture = new BABYLON.CubeTexture(url, this._scene, undefined, undefined, undefined, undefined, () => { this.setLongRenderingNeeded() });
        var environmentTexture = null;
        if (url.endsWith(".dds")) environmentTexture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);else if (url.endsWith(".hdr")) {
          environmentTexture = new BABYLON.HDRCubeTexture(url, this._scene, 128, undefined, undefined, undefined, undefined, onImagesLoad);
          this._scene.metadata.environmentTextureType = "BABYLON.HDRCubeTexture";
          this._scene.metadata.environmentTextureSize = 128;
        } else if (url.endsWith(".env")) {
          //texture = new BABYLON.CubeTexture(url, this._scene);
          //texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene, undefined, undefined);
          environmentTexture = new BABYLON.CubeTexture(url, this._scene, null, false, null, onImagesLoad, null, undefined, true, undefined, true);
          //texture = new BABYLON.CubeTexture(url, this._scene, undefined, undefined, undefined, undefined, onImagesLoad);
        } else if (url.endsWith(".basis")) {
          environmentTexture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);
        } else if (extensions && extensions.length === 6 && files && files.length === 6) {
          environmentTexture = new BABYLON.CubeTexture(url, this._scene, extensions, false, files, onImagesLoad);
          this._scene.metadata.environmentTextureExtensions = extensions;
          this._scene.metadata.environmentTextureFiles = files;
        }
        if (environmentTexture) {
          _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_10__.SceneHelper.whenTextureIsReadyAsync(environmentTexture).then(function () {
            if (environmentTexture && _this9._scene) {
              if (rotationY != undefined) environmentTexture.rotationY = rotationY;else {
                if (_this9._scene.metadata && _this9._scene.metadata.environmentTextureRotationY != undefined) delete _this9._scene.metadata.environmentTextureRotationY;
              }
              _this9._scene.environmentTexture = environmentTexture;

              // TEST Default SkyBox
              //this._scene.createDefaultSkybox(this._scene.environmentTexture, true, (this._scene.activeCamera!.maxZ - this._scene.activeCamera!.minZ) / 2, 0.3, false);
              //this._scene.createDefaultSkybox(this._scene.environmentTexture, true, (this._scene.activeCamera!.maxZ - this._scene.activeCamera!.minZ) / 2, 0.1, false);

              _this9.setRenderingNeeded();
            }
          });
        }
      }
    }
  }, {
    key: "loadSceneFromModelAsync",
    value: function () {
      var _loadSceneFromModelAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(zkModel, zkScene, onProgress) {
        var rootUrl, sceneFileName;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (zkModel && zkModel instanceof MPlaza.Model) {
                this._zkModel = zkModel;
              }
              if (!(zkScene && zkScene instanceof Zakeke.Scene)) {
                _context8.next = 9;
                break;
              }
              this._zkScene = zkScene;
              this.checkSceneShaderMaterials(zkScene);
              rootUrl = zkScene.get("rootUrl");
              sceneFileName = zkScene.get("sceneFileName");
              if (!(rootUrl && sceneFileName)) {
                _context8.next = 9;
                break;
              }
              _context8.next = 9;
              return this.loadSceneFromRemoteFilesAsync(rootUrl, sceneFileName, onProgress);
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function loadSceneFromModelAsync(_x2, _x3, _x4) {
        return _loadSceneFromModelAsync.apply(this, arguments);
      }
      return loadSceneFromModelAsync;
    }()
  }, {
    key: "loadSceneFromModelDataAsync",
    value: function () {
      var _loadSceneFromModelDataAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(zkModel, zkScene, sceneJson, onProgress) {
        var sceneFileName, rootUrl;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (zkModel && zkModel instanceof MPlaza.Model) {
                this._zkModel = zkModel;
              }
              if (!(zkScene && zkScene instanceof Zakeke.Scene)) {
                _context9.next = 9;
                break;
              }
              this._zkScene = zkScene;
              this.checkSceneShaderMaterials(zkScene);
              sceneFileName = "data:" + sceneJson;
              rootUrl = zkScene.get("rootUrl");
              if (!rootUrl) {
                _context9.next = 9;
                break;
              }
              _context9.next = 9;
              return this.loadSceneFromRemoteFilesAsync(rootUrl, sceneFileName, onProgress);
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function loadSceneFromModelDataAsync(_x5, _x6, _x7, _x8) {
        return _loadSceneFromModelDataAsync.apply(this, arguments);
      }
      return loadSceneFromModelDataAsync;
    }()
  }, {
    key: "preSceneFileLoading",
    value: function preSceneFileLoading() {}
  }, {
    key: "postSceneFileLoading",
    value: function postSceneFileLoading() {}

    // Carica la scena Babylon JS tramite rootUrl e sceneFilename
    // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
    // il path in base a rootUrl e al nome della texture
    // textureUrl = rootUrl + texture.name
  }, {
    key: "loadSceneFromRemoteFilesAsync",
    value: function () {
      var _loadSceneFromRemoteFilesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(rootUrl, sceneFileName, onProgress) {
        var _this10 = this;
        var newScene, requireDelayLoading, i, texture, skyboxTexture;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (this._engine) {
                _context10.next = 2;
                break;
              }
              throw new Error("Unable to load scene when the 3D engine is null");
            case 2:
              _context10.prev = 2;
              this.fireBeginSceneLoadingEvent();
              this.preSceneFileLoading();
              this.pauseRendering();

              // Per problema useDelayedTextureLoading
              this._engine["sceneFileRootUrl"] = rootUrl;
              _context10.next = 9;
              return BABYLON.SceneLoader.LoadAsync(rootUrl, sceneFileName, this._engine, onProgress);
            case 9:
              newScene = _context10.sent;
              if (!this._destroyed) {
                _context10.next = 14;
                break;
              }
              Logger.info("Loading scene engine destroyed");
              newScene.dispose();
              return _context10.abrupt("return");
            case 14:
              _context10.next = 16;
              return new Promise(function (resolve) {
                return newScene.executeWhenReady(function () {
                  return resolve();
                });
              });
            case 16:
              if (!this._destroyed) {
                _context10.next = 20;
                break;
              }
              Logger.info("Loading scene engine destroyed");
              newScene.dispose();
              throw new Error("Engine destroyed while loading scene");
            case 20:
              requireDelayLoading = _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_10__.SceneHelper.visibleMeshesRequireDelayedLoading(newScene);
              if (requireDelayLoading) this.fireBeginAssetsLoadingEvent();
              _context10.next = 24;
              return _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_10__.SceneHelper.whenAllVisibleMeshesAreReadyAsync(newScene);
            case 24:
              if (requireDelayLoading) this.fireEndAssetsLoadingEvent();
              this.deleteScene();
              this._scene = newScene;

              // useDelayedTextureLoading
              for (i = 0; i < this._scene.textures.length; i++) {
                texture = this._scene.textures[i];
                if (texture instanceof BABYLON.Texture) {
                  if (texture.onLoadObservable) {
                    texture.onLoadObservable.add(function (txt) {
                      _this10.setLongRenderingNeeded();
                    });
                  }
                }
              }
              _context10.next = 30;
              return this.setupSceneAsync();
            case 30:
              if (!this._sceneHelper) {
                _context10.next = 45;
                break;
              }
              if (!(this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials)) {
                _context10.next = 34;
                break;
              }
              _context10.next = 34;
              return this._sceneHelper.loadAllDelayedMaterialsAsync(rootUrl);
            case 34:
              // Carico gli eventuali materiali offloaded
              if (this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
                this._sceneHelper.loadAllOffloadedMaterials(rootUrl);
              }

              // Ripristino i materiali originali per le mesh nascoste
              if (this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
                this._sceneHelper.unsetAllDummyMaterials();
              }
              this._sceneHelper.setupShaderMaterialsCameraPosition();

              // Trying to reload texture with loading errors
              _context10.prev = 37;
              _context10.next = 40;
              return this.reloadAllLoadingErrorTexturesAsync();
            case 40:
              _context10.next = 45;
              break;
            case 42:
              _context10.prev = 42;
              _context10.t0 = _context10["catch"](37);
              console.error(_context10.t0);
            case 45:
              if (!this._environmentManager) {
                _context10.next = 50;
                break;
              }
              skyboxTexture = this._environmentManager.getSkyboxTexture();
              if (!skyboxTexture) {
                _context10.next = 50;
                break;
              }
              _context10.next = 50;
              return _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_10__.SceneHelper.whenTextureIsReadyAsync(skyboxTexture);
            case 50:
              _context10.prev = 50;
              this.resumeRendering();
              this.postSceneFileLoading();
              this.fireEndSceneLoadingEvent();
              return _context10.finish(50);
            case 55:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this, [[2,, 50, 55], [37, 42]]);
      }));
      function loadSceneFromRemoteFilesAsync(_x9, _x10, _x11) {
        return _loadSceneFromRemoteFilesAsync.apply(this, arguments);
      }
      return loadSceneFromRemoteFilesAsync;
    }()
  }, {
    key: "getSkyboxTexture",
    value: function getSkyboxTexture() {
      var _this$_environmentMan;
      return (_this$_environmentMan = this._environmentManager) === null || _this$_environmentMan === void 0 ? void 0 : _this$_environmentMan.getSkyboxTexture();
    }

    // Carica la scena Babylon JS tramite rootUrl e sceneFilename
    // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
    // il path in base a rootUrl e al nome della texture
    // textureUrl = rootUrl + texture.name
  }, {
    key: "loadSceneFromRemoteFilesAsync_OLD",
    value: function () {
      var _loadSceneFromRemoteFilesAsync_OLD = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(rootUrl, sceneFileName, onProgress) {
        var _this11 = this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(resolve, reject) {
                  var newScene;
                  return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                    while (1) switch (_context12.prev = _context12.next) {
                      case 0:
                        if (!_this11._engine) reject();
                        _this11.preSceneFileLoading();

                        // Per problema useDelayedTextureLoading
                        _this11._engine["sceneFileRootUrl"] = rootUrl;
                        _context12.next = 5;
                        return BABYLON.SceneLoader.LoadAsync(rootUrl, sceneFileName, _this11._engine, onProgress);
                      case 5:
                        newScene = _context12.sent;
                        if (!_this11._destroyed) {
                          _context12.next = 10;
                          break;
                        }
                        Logger.info("Loading scene engine destroyed");
                        newScene.dispose();
                        return _context12.abrupt("return");
                      case 10:
                        newScene.executeWhenReady( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
                          var requireDelayLoading, i, texture;
                          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                            while (1) switch (_context11.prev = _context11.next) {
                              case 0:
                                if (_this11._destroyed) {
                                  Logger.info("Loading scene engine destroyed");
                                  newScene.dispose();
                                  reject();
                                }
                                requireDelayLoading = _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_10__.SceneHelper.visibleMeshesRequireDelayedLoading(newScene);
                                if (requireDelayLoading) _this11.fireBeginAssetsLoadingEvent();
                                _context11.next = 5;
                                return _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_10__.SceneHelper.whenAllVisibleMeshesAreReadyAsync(newScene);
                              case 5:
                                if (requireDelayLoading) _this11.fireEndAssetsLoadingEvent();
                                _this11.deleteScene();
                                _this11._scene = newScene;

                                // useDelayedTextureLoading
                                for (i = 0; i < _this11._scene.textures.length; i++) {
                                  texture = _this11._scene.textures[i];
                                  if (texture instanceof BABYLON.Texture) {
                                    if (texture.onLoadObservable) {
                                      texture.onLoadObservable.add(function (txt) {
                                        _this11.setLongRenderingNeeded();
                                      });
                                    }
                                  }
                                }
                                _context11.next = 11;
                                return _this11.setupSceneAsync();
                              case 11:
                                if (!_this11._sceneHelper) {
                                  _context11.next = 18;
                                  break;
                                }
                                if (!(_this11._configPreview && _this11._scene.metadata && _this11._scene.metadata.delayedMaterials)) {
                                  _context11.next = 15;
                                  break;
                                }
                                _context11.next = 15;
                                return _this11._sceneHelper.loadAllDelayedMaterialsAsync(rootUrl);
                              case 15:
                                // Carico gli eventuali materiali offloaded
                                if (_this11._configPreview && _this11._scene.metadata && _this11._scene.metadata.offloadedMaterials) {
                                  _this11._sceneHelper.loadAllOffloadedMaterials(rootUrl);
                                }

                                // Ripristino i materiali originali per le mesh nascoste
                                if (_this11._configPreview && _this11._scene.metadata && _this11._scene.metadata.originalMeshMaterials) {
                                  _this11._sceneHelper.unsetAllDummyMaterials();
                                }
                                _this11._sceneHelper.setupShaderMaterialsCameraPosition();
                              case 18:
                                _this11.postSceneFileLoading();
                                resolve();
                              case 20:
                              case "end":
                                return _context11.stop();
                            }
                          }, _callee11);
                        })));
                      case 11:
                      case "end":
                        return _context12.stop();
                    }
                  }, _callee12);
                }));
                return function (_x15, _x16) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      function loadSceneFromRemoteFilesAsync_OLD(_x12, _x13, _x14) {
        return _loadSceneFromRemoteFilesAsync_OLD.apply(this, arguments);
      }
      return loadSceneFromRemoteFilesAsync_OLD;
    }()
  }, {
    key: "checkSceneShaderMaterials",
    value: function checkSceneShaderMaterials(zkScene) {
      if (zkScene instanceof Zakeke.Scene && zkScene.get("shaderMaterials")) {
        for (var i = 0; i < zkScene.get("shaderMaterials").length; i++) {
          var shaderMaterial = zkScene.get("shaderMaterials").at(i);
          var name = shaderMaterial.get("name");
          var vertex = shaderMaterial.get("vertex");
          var fragment = shaderMaterial.get("fragment");
          if (name && vertex && fragment) {
            var shaderInfo = {
              name: name,
              vertex: vertex,
              fragment: fragment
            };
            this.setupShadersStore(shaderInfo);
          }
        }
      }
    }
  }, {
    key: "checkShaderMaterial",
    value: function checkShaderMaterial(zkMaterial) {
      if (zkMaterial && zkMaterial instanceof Zakeke.Material) {
        var shaders = zkMaterial.get("shaders");
        if (shaders) {
          var name = zkMaterial.get("shaders").get("name");
          var vertex = zkMaterial.get("shaders").get("vertex");
          var fragment = zkMaterial.get("shaders").get("fragment");
          if (name && vertex && fragment) {
            var shaderInfo = {
              name: name,
              vertex: vertex,
              fragment: fragment
            };
            this.setupShadersStore(shaderInfo);
          }
        }
      }
    }
  }, {
    key: "setupShadersStore",
    value: function setupShadersStore(shaderInfo) {
      if (shaderInfo && shaderInfo.hasOwnProperty("name") && shaderInfo.hasOwnProperty("vertex") && shaderInfo.hasOwnProperty("fragment")) {
        var vertexPath = shaderInfo.name + "VertexShader";
        var fragmentPath = shaderInfo.name + "FragmentShader";
        BABYLON.Effect.ShadersStore[vertexPath] = shaderInfo.vertex;
        BABYLON.Effect.ShadersStore[fragmentPath] = shaderInfo.fragment;
      }
    }
  }, {
    key: "isRealMesh",
    value: function isRealMesh(mesh) {
      if (this._sceneHelper) return this._sceneHelper.isRealMesh(mesh);
      return false;
    }
  }, {
    key: "countSceneMeshes",
    value: function countSceneMeshes() {
      return this._sceneHelper ? this._sceneHelper.countSceneMeshes() : 0;
    }
  }, {
    key: "getVisibleMeshes",
    value: function getVisibleMeshes() {
      return this._sceneHelper ? this._sceneHelper.getVisibleMeshes() : [];
    }
  }, {
    key: "getSceneBoundingInfo",
    value: function getSceneBoundingInfo() {
      if (this._sceneHelper) return this._sceneHelper.getSceneBoundingInfo();
      return null;
    }
  }, {
    key: "selectMesh",
    value: function selectMesh(id) {
      this.selectUnselectMesh(id, true);
    }
  }, {
    key: "unselectMesh",
    value: function unselectMesh(id) {
      this.selectUnselectMesh(id, false);
    }
  }, {
    key: "unselectAllMeshes",
    value: function unselectAllMeshes() {
      var _this12 = this;
      if (this._scene) {
        this._scene.meshes.forEach(function (mesh) {
          return _this12.unselectSingleMesh(mesh);
        });
        this.fireFocusAttributesEvent({
          groups: []
        });
      }
    }
  }, {
    key: "selectUnselectMesh",
    value: function selectUnselectMesh(id, select) {
      var _this13 = this;
      if (this._scene) {
        this._scene.meshes.forEach(function (mesh) {
          return _this13.unselectSingleMesh(mesh);
        });
        if (select) {
          var selectWithChildren = function selectWithChildren(parent) {
            _this13.selectSingleMesh(parent);
            var children = parent.getChildMeshes();
            if (children) {
              children.forEach(function (child) {
                return selectWithChildren(child);
              });
            }
          };
          var mesh = this._scene.getMeshByID(id);
          if (mesh) {
            selectWithChildren(mesh);
            var group = this.getGroupForMesh(mesh);
            if (group) {
              this.highlightGroupForMesh(mesh);
              this.fireGroupPickedEvent({
                groupID: group.get("groupID")
              });
            }
            var groups = this.getVisibleHiddenAttributesForMesh(mesh);
            this.fireFocusAttributesEvent({
              groups: groups
            });
            if (groups.length > 0) this.highlightMeshes([mesh]);
          }
        }
      }
    }
  }, {
    key: "selectSingleMesh",
    value: function selectSingleMesh(mesh) {
      this.setRenderingNeeded();
      mesh["selected"] = true;
    }
  }, {
    key: "unselectSingleMesh",
    value: function unselectSingleMesh(mesh) {
      this.setRenderingNeeded();
      mesh["selected"] = false;
    }
  }, {
    key: "selectMeshesWithMaterial",
    value: function selectMeshesWithMaterial(materialID) {
      this.selectUnselectMeshesWithMaterial(materialID, true);
    }
  }, {
    key: "unselectMeshesWithMaterial",
    value: function unselectMeshesWithMaterial(materialID) {
      this.selectUnselectMeshesWithMaterial(materialID, false);
    }
  }, {
    key: "selectUnselectMeshesWithMaterial",
    value: function selectUnselectMeshesWithMaterial(materialID, select) {
      var _this14 = this;
      if (!this._scene) return;
      this._scene.meshes.forEach(function (mesh) {
        return _this14.unselectSingleMesh(mesh);
      });
      if (select) {
        var checkMeshWithChildren = function checkMeshWithChildren(parent) {
          if (parent.material && parent.material.id === materialID) _this14.selectSingleMesh(parent);
          var children = parent.getChildMeshes();
          if (children) {
            children.forEach(function (child) {
              checkMeshWithChildren(child);
            });
          }
        };
        this._scene.meshes.forEach(function (mesh) {
          checkMeshWithChildren(mesh);
        });
      }
    }
  }, {
    key: "onPointerDown",
    value: function onPointerDown(evt, pickInfo) {
      if (pickInfo.hit && pickInfo.pickedMesh) {
        this.selectMesh(pickInfo.pickedMesh.id);
      } else {
        this.unselectAllMeshes();
      }
    }
  }, {
    key: "getSelectedRootMesh",
    value: function getSelectedRootMesh() {
      if (this._scene) {
        for (var i = 0; i < this._scene.meshes.length; i++) {
          var mesh = this._scene.meshes[i];
          if (mesh["selected"]) {
            var parent = mesh.parent;
            if (!parent || !parent["selected"]) return mesh;
          }
        }
      }
      return null;
    }
  }, {
    key: "getMeshByID",
    value: function getMeshByID(id) {
      if (this._scene) return this._scene.getMeshByID(id);
      return null;
    }
  }, {
    key: "getMeshByName",
    value: function getMeshByName(id) {
      if (this._scene) return this._scene.getMeshByName(id);
      return null;
    }
  }, {
    key: "getMaterialByID",
    value: function getMaterialByID(id) {
      if (this._scene) return this._scene.getMaterialByID(id);
      return null;
    }
  }, {
    key: "setCameraLocation",
    value: function setCameraLocation(locationID) {
      var onlyAngleOfView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var animate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (this._zkScene && this._sceneHelper) {
        var zkCameraLocation = this._zkScene.getCameraLocation(locationID);
        if (zkCameraLocation) {
          var position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
          var target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
          if (animate) {
            // Animation
            if (!onlyAngleOfView) {
              this._sceneHelper.animateCamera(target, position, 0.5);
            } else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
              var angleOfView = this._sceneHelper.computeCameraAngleOfView(target, position);
              this._sceneHelper.animateCameraToFinalParamters(angleOfView.alpha, angleOfView.beta, this._camera.radius, this._camera.target, 0.5);
            }
          } else {
            // No animation
            if (!onlyAngleOfView) {
              this._sceneHelper.moveCamera(target, position);
            } else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
              var _angleOfView = this._sceneHelper.computeCameraAngleOfView(target, position);
              this._sceneHelper.moveCameraToFinalParameters(_angleOfView.alpha, _angleOfView.beta, this._camera.radius, this._camera.target);
            }
          }
        }
      }
      this.setRenderingNeeded();
    }
  }, {
    key: "adjustCamera",
    value: function adjustCamera(animate) {
      if (this._sceneHelper) {
        if (animate != undefined && animate != null && typeof animate === "boolean") this._sceneHelper.adjustCamera(undefined, undefined, undefined, animate);else this._sceneHelper.adjustCamera();
        this.setupShaderMaterialsCameraPosition();
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "zoomIn",
    value: function zoomIn() {
      if (this._sceneHelper) this._sceneHelper.zoomIn();
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      if (this._sceneHelper) this._sceneHelper.zoomOut();
    }
  }, {
    key: "zoom",
    value: function zoom(perc) {
      if (this._sceneHelper) this._sceneHelper.zoom(perc);
    }
  }, {
    key: "setCameraPivot",
    value: function setCameraPivot(meshID) {
      if (this._scene && this._sceneHelper) {
        var mesh = meshID ? this._scene.getMeshByID(meshID) : null;
        this._sceneHelper.setCameraPivot(mesh);
      }
    }
  }, {
    key: "setCameraZoomEnabled",
    value: function setCameraZoomEnabled(enabled) {
      if (this._scene && this._sceneHelper) {
        this._sceneHelper.setZoomEnabled(enabled);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "executeScriptAsync",
    value: function () {
      var _executeScriptAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(script) {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!this._sceneActionsExecutor) {
                _context14.next = 7;
                break;
              }
              _context14.next = 3;
              return this._sceneActionsExecutor.executeScriptAsync(script);
            case 3:
              this.notifyScriptExecution(script);
              this.setupShaderMaterialsCameraPosition();
              this.refreshInfoPoints();
              this.setLongRenderingNeeded();
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function executeScriptAsync(_x17) {
        return _executeScriptAsync.apply(this, arguments);
      }
      return executeScriptAsync;
    }()
  }, {
    key: "executeActionsAsync",
    value: function () {
      var _executeActionsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(attributeID, selectedValue, actions) {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!this._sceneActionsExecutor) {
                _context15.next = 7;
                break;
              }
              _context15.next = 3;
              return this._sceneActionsExecutor.executeActionsAsync(attributeID, selectedValue, actions);
            case 3:
              this.notifyActionExecution(attributeID, selectedValue, actions);
              this.setupShaderMaterialsCameraPosition();
              this.refreshInfoPoints();
              this.setLongRenderingNeeded();
            case 7:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function executeActionsAsync(_x18, _x19, _x20) {
        return _executeActionsAsync.apply(this, arguments);
      }
      return executeActionsAsync;
    }()
  }, {
    key: "prefetchMeshesForUnselectedOptionsAsync",
    value: function () {
      var _prefetchMeshesForUnselectedOptionsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(actions) {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!this._sceneActionsExecutor) {
                _context16.next = 3;
                break;
              }
              _context16.next = 3;
              return this._sceneActionsExecutor.prefetchMeshesForUnselectedOptionsAsync(actions);
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function prefetchMeshesForUnselectedOptionsAsync(_x21) {
        return _prefetchMeshesForUnselectedOptionsAsync.apply(this, arguments);
      }
      return prefetchMeshesForUnselectedOptionsAsync;
    }()
  }, {
    key: "prefetchDataForUnselectedOptionsAsync",
    value: function () {
      var _prefetchDataForUnselectedOptionsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(actions) {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              if (!this._sceneActionsExecutor) {
                _context17.next = 3;
                break;
              }
              _context17.next = 3;
              return this._sceneActionsExecutor.prefetchDataForUnselectedOptionsAsync(actions);
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function prefetchDataForUnselectedOptionsAsync(_x22) {
        return _prefetchDataForUnselectedOptionsAsync.apply(this, arguments);
      }
      return prefetchDataForUnselectedOptionsAsync;
    }()
  }, {
    key: "refreshEnvironment",
    value: function refreshEnvironment() {
      if (this._zkScene && this._scene) {
        if (!this._environmentManager || this._environmentManager.scene != this._scene || this._environmentManager.isHologram != this._isHologram) this._environmentManager = new _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_6__.EnvironmentManager(this._zkScene, this._scene, this._isHologram);
        this._environmentManager.update();
        this.setLongRenderingNeeded();
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) this._autoRender = this._camera.useAutoRotationBehavior;
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "highlightMeshes",
    value: function highlightMeshes(meshes) {
      var _this15 = this;
      if (!meshes || Object.prototype.toString.call(meshes) !== '[object Array]' || this._highlightSize == 0) return;
      var startHorSize = this._highlightBlurHorizontalSize;
      var startVerSize = this._highlightBlurVerticalSize;
      var addWithChildren = function addWithChildren(parent) {
        if (parent.isVisible && _this15._highlightLayer) _this15._highlightLayer.addMesh(parent, BABYLON.Color3.FromHexString(_this15._highlightColor));
        var children = parent.getChildMeshes();
        children.forEach(function (child) {
          if (child instanceof BABYLON.Mesh) addWithChildren(child);
        });
      };
      var removeWithChildren = function removeWithChildren(parent) {
        if (_this15._highlightLayer) _this15._highlightLayer.removeMesh(parent);
        var children = parent.getChildMeshes();
        children.forEach(function (child) {
          if (child instanceof BABYLON.Mesh) removeWithChildren(child);
        });
      };

      // Ferma l'eventuale highlighting in corso e ne avvia un altro
      var stop = function stop() {
        if (_this15._highlightAnimationID) {
          // Ferma l'animazione corrente
          clearInterval(_this15._highlightAnimationID);
          _this15._highlightAnimationID = null;
        }

        // riporta le mesh evidenziate allo stato normale
        if (_this15._highlightCurrentMeshes) _this15._highlightCurrentMeshes.forEach(function (mesh) {
          if (mesh instanceof BABYLON.Mesh) removeWithChildren(mesh);
        });

        // Riporta i valori normali di highlighting
        if (_this15._highlightLayer) {
          _this15._highlightLayer.blurHorizontalSize = startHorSize;
          _this15._highlightLayer.blurVerticalSize = startVerSize;
        }

        // Eventualmente lancia l'highlight in attesa
        if (_this15._highlightNextMeshes) {
          var nextMeshes = _this15._highlightNextMeshes;
          _this15._highlightNextMeshes = [];
          _this15.highlightMeshes(nextMeshes);
        }
      };
      if (this._highlightAnimationID) {
        // Animazione in corso. metto la mesh in coda e stoppo l'animazione
        this._highlightNextMeshes = meshes;
        stop();
        return;
      }
      if (!this._highlightLayer) this.createHighlightLayer();
      if (this._highlightLayer) {
        this._highlightCurrentMeshes = meshes;
        meshes.forEach(function (mesh) {
          if (mesh instanceof BABYLON.Mesh) addWithChildren(mesh);
        });
        var duration = 800.0; // durata totale dell'animazione in millisecondi
        var step = 20.0; // tempo tra un frame e l'altro in millisecondi
        var delta = step / duration; // percentuale di decremento del blur

        var horSize = startHorSize;
        var verSize = startVerSize;
        this._highlightAnimationID = window.setInterval(function () {
          if (_this15._highlightLayer) {
            horSize -= startHorSize * delta;
            verSize -= startVerSize * delta;
            horSize = Math.max(0, horSize);
            verSize = Math.max(0, verSize);
            if (horSize >= 0) _this15._highlightLayer.blurHorizontalSize = horSize;
            if (verSize >= 0) _this15._highlightLayer.blurVerticalSize = verSize;
            if (horSize == 0 || verSize == 0) stop();
            _this15.setRenderingNeeded();
          }
        }, step);
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "highlightGroupForMesh",
    value: function highlightGroupForMesh(mesh) {
      var zkGroup = this.getGroupForMesh(mesh);
      this.highlightGroup(zkGroup);
    }
  }, {
    key: "highlightGroupByID",
    value: function highlightGroupByID(groupID) {
      if (this._zkModel) {
        var group = this._zkModel.get("attributeGroups").findWhere({
          groupID: groupID
        });
        group ? this.highlightGroup(group) : this.highlightGroup(null);
      }
    }
  }, {
    key: "highlightGroup",
    value: function highlightGroup(zkGroup) {
      if (this._zkScene && this._scene && zkGroup) {
        var selector = zkGroup.get("meshSelector");
        if (selector) {
          var meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, selector, MPlaza.SceneElementType.Mesh);
          this.highlightMeshes(meshes);
        }
      }
    }
  }, {
    key: "getGroupForMesh",
    value: function getGroupForMesh(mesh) {
      if (this._zkModel && this._zkScene && this._scene && mesh && this._sceneHelper) {
        var groups = this._zkModel.get("attributeGroups");
        for (var i = 0; i < groups.length; i++) {
          var group = groups.at(i);
          var selector = group.get("meshSelector");
          if (selector) {
            var meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, selector, MPlaza.SceneElementType.Mesh);
            for (var k = 0; k < meshes.length; k++) {
              var groupMesh = meshes[k];
              if (mesh.id == groupMesh.id || this._sceneHelper.meshHasParent(mesh.id, groupMesh.id)) {
                return group;
              }
            }
          }
        }
      }
      return null;
    }
  }, {
    key: "highlightAttributeByID",
    value: function highlightAttributeByID(attributeID) {
      if (this._zkModel) {
        var attribute = this._zkModel.get("attributes").findWhere({
          attributeID: attributeID
        });
        attribute ? this.highlightAttribute(attribute) : this.highlightAttribute(null);
      }
    }
  }, {
    key: "highlightAttribute",
    value: function highlightAttribute(zkAttribute) {
      if (this._zkScene && this._scene && zkAttribute) {
        var selector = zkAttribute.get("meshSelector");
        if (selector) {
          var meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, selector, MPlaza.SceneElementType.Mesh);
          this.highlightMeshes(meshes);
        }
      }
    }
  }, {
    key: "getVisibleHiddenAttributesForMesh",
    value: function getVisibleHiddenAttributesForMesh(mesh) {
      var _this16 = this;
      var groups = [];
      var getOrCreateGroup = function getOrCreateGroup(groupId) {
        var group = groups.find(function (x) {
          return x.groupId == groupId;
        });
        if (!group) {
          group = {
            groupId: groupId,
            visibleAttributes: [],
            hiddenAttributes: []
          };
          groups.push(group);
        }
        return group;
      };
      if (this._zkModel && this._zkScene && this._scene && mesh) {
        var attributes = this._zkModel.get("attributes");
        for (var i = 0; i < attributes.length; i++) {
          var attribute = attributes.at(i);
          var attributeID = attribute.get("attributeID");
          var selector = attribute.get("meshSelector");
          if (selector) {
            var group = getOrCreateGroup(attribute.get("groupID"));
            var meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, selector, MPlaza.SceneElementType.Mesh);

            // If this attribute selector contains this mesh, then is in visible attributes, else is hidden.
            var found = meshes.find(function (attributeMesh) {
              if (_this16._sceneHelper) return mesh.id == attributeMesh.id || _this16._sceneHelper.meshHasParent(mesh.id, attributeMesh.id);else return false;
            });
            if (found) group.visibleAttributes.push(attributeID);else group.hiddenAttributes.push(attributeID);
          }
        }
      }

      // If all attributes are hidden for a group and there are no visible attributes than we clicked on a mesh
      // that is not attached to any attribute. Then filter them because that
      // mean that nothing must be done

      return groups.filter(function (x) {
        return x.visibleAttributes.length > 0;
      });
    }

    // -------------------------------------------------------------
    // Events 
    // -------------------------------------------------------------
  }, {
    key: "fireGroupPickedEvent",
    value: function fireGroupPickedEvent(e) {
      for (var i = 0; i < this._groupPickedListeners.length; i++) this._groupPickedListeners[i](e);
    }
  }, {
    key: "addGroupPickedListener",
    value: function addGroupPickedListener(listenerFunction) {
      this._groupPickedListeners.push(listenerFunction);
    }
  }, {
    key: "fireFocusAttributesEvent",
    value: function fireFocusAttributesEvent(e) {
      for (var i = 0; i < this._focusAttributesListeners.length; i++) this._focusAttributesListeners[i](e);
    }
  }, {
    key: "addFocusAttributesListener",
    value: function addFocusAttributesListener(listenerFunction) {
      this._focusAttributesListeners.push(listenerFunction);
    }
  }, {
    key: "addNotifyMessageListener",
    value: function addNotifyMessageListener(listener) {
      this._designNotifyMessageListeners.push(listener);
      if (this._sceneDesignManager) this._sceneDesignManager.addNotifyMessageListener(listener);
    }
  }, {
    key: "addRemoveMessageListener",
    value: function addRemoveMessageListener(listener) {
      this._designRemoveMessageListeners.push(listener);
      if (this._sceneDesignManager) this._sceneDesignManager.addRemoveMessageListener(listener);
    }
  }, {
    key: "setEventMessages",
    value: function setEventMessages(eventMessages) {
      this._designEventMessages = eventMessages;
      if (this._sceneDesignManager) this._sceneDesignManager.setEventMessages(eventMessages);
    }
  }, {
    key: "addInfoPointPickedListener",
    value: function addInfoPointPickedListener(listenerFunction) {
      this._infoPointPickedListeners.push(listenerFunction);
      if (this._infoPointsManager) this._infoPointsManager.addInfoPointPickedListener(listenerFunction);
    }
  }, {
    key: "addInfoPointContentShownListener",
    value: function addInfoPointContentShownListener(listenerFunction) {
      this._infoPointContentShownListeners.push(listenerFunction);
      if (this._infoPointsManager) this._infoPointsManager.addInfoPointContentShownListener(listenerFunction);
    }
  }, {
    key: "addInfoPointContentHiddenListener",
    value: function addInfoPointContentHiddenListener(listenerFunction) {
      this._infoPointContentHiddenListeners.push(listenerFunction);
      if (this._infoPointsManager) this._infoPointsManager.addInfoPointContentHiddenListener(listenerFunction);
    }

    // begin assets loading
  }, {
    key: "addBeginAssetsLoadingListener",
    value: function addBeginAssetsLoadingListener(callback) {
      this._beginAssetsLoadingListeners.push(callback);
    }
  }, {
    key: "fireBeginAssetsLoadingEvent",
    value: function fireBeginAssetsLoadingEvent() {
      Logger.info("Begin Assets Loading");
      for (var i = 0; i < this._beginAssetsLoadingListeners.length; ++i) {
        this._beginAssetsLoadingListeners[i]();
      }
    }
  }, {
    key: "addEndAssetsLoadingListener",
    value: function addEndAssetsLoadingListener(callback) {
      this._endAssetsLoadingListeners.push(callback);
    }
  }, {
    key: "fireEndAssetsLoadingEvent",
    value: function fireEndAssetsLoadingEvent() {
      Logger.info("End Assets Loading");
      for (var i = 0; i < this._endAssetsLoadingListeners.length; ++i) {
        this._endAssetsLoadingListeners[i]();
      }
    }
  }, {
    key: "addBeginSceneLoadingListener",
    value: function addBeginSceneLoadingListener(callback) {
      this._beginAssetsLoadingListeners.push(callback);
    }
  }, {
    key: "fireBeginSceneLoadingEvent",
    value: function fireBeginSceneLoadingEvent() {
      Logger.info("Begin Scene Loading");
      for (var i = 0; i < this._beginAssetsLoadingListeners.length; ++i) {
        this._beginAssetsLoadingListeners[i]();
      }
    }
  }, {
    key: "addEndSceneLoadingListener",
    value: function addEndSceneLoadingListener(callback) {
      this._endAssetsLoadingListeners.push(callback);
    }
  }, {
    key: "fireEndSceneLoadingEvent",
    value: function fireEndSceneLoadingEvent() {
      Logger.info("End Scene Loading");
      for (var i = 0; i < this._endAssetsLoadingListeners.length; ++i) {
        this._endAssetsLoadingListeners[i]();
      }
    }
    // --------------------------------------------------------------
  }, {
    key: "getSceneScreenshotAsync",
    value: function () {
      var _getSceneScreenshotAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(width, height) {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              if (!this._sceneHelper) {
                _context18.next = 5;
                break;
              }
              this.setRenderingNeeded();
              _context18.next = 4;
              return this._sceneHelper.takeScreenshotAsync(width, height);
            case 4:
              return _context18.abrupt("return", _context18.sent);
            case 5:
              return _context18.abrupt("return", null);
            case 6:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function getSceneScreenshotAsync(_x23, _x24) {
        return _getSceneScreenshotAsync.apply(this, arguments);
      }
      return getSceneScreenshotAsync;
    }()
  }, {
    key: "getSceneContentScreenshotAsync",
    value: function () {
      var _getSceneContentScreenshotAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(width, height) {
        var padding,
          zkDesign,
          legacyScreenshot,
          camera,
          dataUrl,
          canvas,
          originalWidth,
          originalHeight,
          originalCameraPosition,
          originalCameraTarget,
          cameraTransform,
          image,
          _args19 = arguments;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              padding = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : 0;
              zkDesign = _args19.length > 3 ? _args19[3] : undefined;
              legacyScreenshot = _args19.length > 4 ? _args19[4] : undefined;
              camera = _args19.length > 5 ? _args19[5] : undefined;
              if (!(!this._sceneHelper || !this.scene || !this.zkModel || !this.zkScene)) {
                _context19.next = 6;
                break;
              }
              return _context19.abrupt("return", null);
            case 6:
              this.preSceneContentScreenshot();
              if (this._environmentManager) {
                this._environmentManager.dispose();
                this._environmentManager = null;
              }
              this.setRenderingNeeded();

              //const canvasMeshesOriginalMeshesIds: string[] = this.scene.meshes.filter(x => x.metadata?.iscanvasMesh).map(x => x.metadata.originalMeshID);
              dataUrl = '';
              if (!legacyScreenshot) {
                _context19.next = 16;
                break;
              }
              _context19.next = 13;
              return this._sceneHelper.takeContentScreenshotAsync(width, height);
            case 13:
              dataUrl = _context19.sent;
              _context19.next = 35;
              break;
            case 16:
              canvas = this._canvas;
              if (!canvas) {
                _context19.next = 35;
                break;
              }
              // Resize this canvas to 1024x1024
              originalWidth = canvas.width;
              originalHeight = canvas.height;
              canvas.width = 1024;
              canvas.height = 1024;

              // Get current camera position and target
              originalCameraPosition = this.scene.activeCamera.position.clone();
              originalCameraTarget = this.scene.activeCamera.target.clone();
              cameraTransform = camera ? {
                position: new BABYLON.Vector3(camera.get("px"), camera.get("py"), camera.get("pz")),
                target: new BABYLON.Vector3(camera.get("tx"), camera.get("ty"), camera.get("tz"))
              } : {
                position: this._scene.activeCamera.position,
                target: this._scene.activeCamera.target
              }; // Set current camera transform
              this._scene.activeCamera.position = cameraTransform.position;
              this._scene.activeCamera.target = cameraTransform.target;

              // Render the scene
              this._scene.render();
              _context19.next = 30;
              return this._sceneHelper.takeContentScreenshotAsync(width, height);
            case 30:
              dataUrl = _context19.sent;
              // Reset camera transform
              this._scene.activeCamera.position = originalCameraPosition;
              this._scene.activeCamera.target = originalCameraTarget;

              // Reset canvas size
              canvas.width = originalWidth;
              canvas.height = originalHeight;
            case 35:
              _context19.next = 37;
              return _Helpers_utils__WEBPACK_IMPORTED_MODULE_12__.Utils.trimImageAsync(dataUrl);
            case 37:
              image = _context19.sent;
              if (!image) {
                console.error('Failed trimming image.', dataUrl);
                image = dataUrl;
              }

              // Place on a fixed size canvas
              _context19.next = 41;
              return _Helpers_utils__WEBPACK_IMPORTED_MODULE_12__.Utils.resizeImageFromDataUri(image, width, height, padding);
            case 41:
              image = _context19.sent;
              if (image) {
                _context19.next = 44;
                break;
              }
              throw new Error('Failed resizing image.');
            case 44:
              this.refreshEnvironment();
              this.postSceneContentScreenshot();
              return _context19.abrupt("return", image);
            case 47:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function getSceneContentScreenshotAsync(_x25, _x26) {
        return _getSceneContentScreenshotAsync.apply(this, arguments);
      }
      return getSceneContentScreenshotAsync;
    }()
  }, {
    key: "preSceneContentScreenshot",
    value: function preSceneContentScreenshot() {}
  }, {
    key: "postSceneContentScreenshot",
    value: function postSceneContentScreenshot() {}
  }, {
    key: "preSceneMaterialScreenshot",
    value: function preSceneMaterialScreenshot() {
      if (this._environmentManager) {
        this._environmentManager.dispose();
        this._environmentManager = null;
      }
    }
  }, {
    key: "postSceneMaterialScreenshot",
    value: function postSceneMaterialScreenshot() {
      this.refreshEnvironment();
    }
  }, {
    key: "getMaterialScreenshotAsync",
    value: function () {
      var _getMaterialScreenshotAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(materialID, width, height) {
        var dataUri, rootUrl, previewData, keys, data, cropped;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!(!this._scene || !this._sceneHelper)) {
                _context20.next = 2;
                break;
              }
              return _context20.abrupt("return", null);
            case 2:
              this.preSceneMaterialScreenshot();
              dataUri = null;
              _context20.next = 6;
              return this.getSceneRootUrl();
            case 6:
              rootUrl = _context20.sent;
              if (!rootUrl) {
                _context20.next = 15;
                break;
              }
              _context20.next = 10;
              return _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_9__.MaterialsPreview.getPreviewsAsync(this._scene, rootUrl, [materialID], {
                width: width,
                height: height,
                crop: true
              }, false);
            case 10:
              previewData = _context20.sent;
              keys = Object.keys(previewData.previewFiles);
              if (keys.length == 1) dataUri = previewData.previewFiles[keys[0]];
              _context20.next = 22;
              break;
            case 15:
              _context20.next = 17;
              return this._sceneHelper.takeMaterialScreenshotAsync(materialID, width, height);
            case 17:
              data = _context20.sent;
              _context20.next = 20;
              return _Helpers_utils__WEBPACK_IMPORTED_MODULE_12__.Utils.trimImageAsync(data);
            case 20:
              cropped = _context20.sent;
              if (cropped) dataUri = cropped;
            case 22:
              this.postSceneMaterialScreenshot();
              return _context20.abrupt("return", dataUri);
            case 24:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function getMaterialScreenshotAsync(_x27, _x28, _x29) {
        return _getMaterialScreenshotAsync.apply(this, arguments);
      }
      return getMaterialScreenshotAsync;
    }() // Used to avoid multiple listeners when using react redraw
  }, {
    key: "clearListeners",
    value: function clearListeners() {
      this._groupPickedListeners = [];
      this._focusAttributesListeners = [];
    }

    // Il parametro showDesign è stato aggiunto per impedire la visualizzazione dei design sugli oggetti.
    // Un utilizzo di questo parametro viene fatto quando si vogliono ottenere le informazioni sugli item
    // del design senza volerli visualizzare perché ad esempio potrebbero essere elementi di testo con
    // dei font ancora non caricati. In tal caso andrebbero prima caricati i font e poi visualizzato il design
  }, {
    key: "renderDesignAsync",
    value: function () {
      var _renderDesignAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(zkDesign) {
        var _this17 = this;
        var showDesign,
          _iterator,
          _step,
          listener,
          _iterator2,
          _step2,
          _listener,
          _args21 = arguments;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              showDesign = _args21.length > 1 && _args21[1] !== undefined ? _args21[1] : true;
              if (!(this._scene && this._zkScene && this._zkModel && zkDesign)) {
                _context21.next = 21;
                break;
              }
              if (!(this._sceneDesignManager && this._sceneDesignManager.isForModels(this._scene, this._zkModel, zkDesign))) {
                _context21.next = 8;
                break;
              }
              this._sceneDesignManager.showDesign = showDesign;
              _context21.next = 6;
              return this._sceneDesignManager.refreshAsync();
            case 6:
              _context21.next = 20;
              break;
            case 8:
              this.emptyArFileCache();
              if (this._sceneDesignManager) {
                this._sceneDesignManager.dispose();
                this._sceneDesignManager = null;
              }
              this._sceneDesignManager = new _Components_DesignManagers_SceneDesignManager__WEBPACK_IMPORTED_MODULE_4__.SceneDesignManager(this._scene, this._zkScene, this._zkModel, zkDesign, showDesign, this._designTextureResolution);
              this._sceneDesignManager.addRenderingNeededListener(function () {
                _this17.setLongRenderingNeeded();
                _this17.notifyDesignChanged(zkDesign);
              });
              this._sceneDesignManager.setCustomizerGrids(this._grids);
              this._sceneDesignManager.setEventMessages(this._designEventMessages);
              _iterator = _createForOfIteratorHelper(this._designNotifyMessageListeners);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  listener = _step.value;
                  this._sceneDesignManager.addNotifyMessageListener(listener);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _iterator2 = _createForOfIteratorHelper(this._designRemoveMessageListeners);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _listener = _step2.value;
                  this._sceneDesignManager.addRemoveMessageListener(_listener);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _context21.next = 20;
              return this._sceneDesignManager.refreshAsync();
            case 20:
              this.setLongRenderingNeeded();
            case 21:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function renderDesignAsync(_x30) {
        return _renderDesignAsync.apply(this, arguments);
      }
      return renderDesignAsync;
    }()
  }, {
    key: "resetDesign",
    value: function resetDesign() {
      if (this._scene && this._zkScene && this._zkModel) {
        if (this._sceneDesignManager) {
          this._sceneDesignManager.dispose();
          this._sceneDesignManager = null;
        }
        this.setLongRenderingNeeded();
      }
    }
  }, {
    key: "clearMeshDesignManagers",
    value: function clearMeshDesignManagers() {
      if (this._sceneDesignManager) {
        this._sceneDesignManager.clearMeshDesignManagers();
      }
    }
  }, {
    key: "refreshMeshesDesignAsync",
    value: function () {
      var _refreshMeshesDesignAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(meshes, effect) {
        var _this18 = this;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (meshes && Object.prototype.toString.call(meshes) === '[object Array]') {
                meshes.forEach( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(mesh) {
                    return _regeneratorRuntime().wrap(function _callee22$(_context22) {
                      while (1) switch (_context22.prev = _context22.next) {
                        case 0:
                          _context22.next = 2;
                          return _this18.refreshMeshDesignAsync(mesh.id, undefined, effect || undefined);
                        case 2:
                          return _context22.abrupt("return", _context22.sent);
                        case 3:
                        case "end":
                          return _context22.stop();
                      }
                    }, _callee22);
                  }));
                  return function (_x33) {
                    return _ref4.apply(this, arguments);
                  };
                }());
              }
            case 1:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }));
      function refreshMeshesDesignAsync(_x31, _x32) {
        return _refreshMeshesDesignAsync.apply(this, arguments);
      }
      return refreshMeshesDesignAsync;
    }()
  }, {
    key: "refreshMeshDesignAsync",
    value: function () {
      var _refreshMeshDesignAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(meshID) {
        var _this$_sceneDesignMan;
        var submeshID,
          effect,
          _args24 = arguments;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              submeshID = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : 0;
              effect = _args24.length > 2 ? _args24[2] : undefined;
              (_this$_sceneDesignMan = this._sceneDesignManager) === null || _this$_sceneDesignMan === void 0 ? void 0 : _this$_sceneDesignMan.refreshMeshDesignAsync(meshID, submeshID, effect);
            case 3:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function refreshMeshDesignAsync(_x34) {
        return _refreshMeshDesignAsync.apply(this, arguments);
      }
      return refreshMeshDesignAsync;
    }()
  }, {
    key: "setCustomizerGrids",
    value: function setCustomizerGrids(grids) {
      var _this$_sceneDesignMan2;
      this._grids = grids;
      (_this$_sceneDesignMan2 = this._sceneDesignManager) === null || _this$_sceneDesignMan2 === void 0 ? void 0 : _this$_sceneDesignMan2.setCustomizerGrids(grids);
    }
  }, {
    key: "removeDesignItem",
    value: function removeDesignItem(guid) {
      var _this$_sceneDesignMan3;
      (_this$_sceneDesignMan3 = this._sceneDesignManager) === null || _this$_sceneDesignMan3 === void 0 ? void 0 : _this$_sceneDesignMan3.removeItem(guid);
    }
  }, {
    key: "addDesignItemText",
    value: function addDesignItemText(settings, sideId) {
      var _this$_sceneDesignMan4;
      return (_this$_sceneDesignMan4 = this._sceneDesignManager) === null || _this$_sceneDesignMan4 === void 0 ? void 0 : _this$_sceneDesignMan4.addItemText(settings, sideId);
    }
  }, {
    key: "addDesignItemImage",
    value: function () {
      var _addDesignItemImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(imageID, sideId) {
        var _this$_sceneDesignMan5;
        return _regeneratorRuntime().wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return (_this$_sceneDesignMan5 = this._sceneDesignManager) === null || _this$_sceneDesignMan5 === void 0 ? void 0 : _this$_sceneDesignMan5.addItemImage(imageID, sideId);
            case 2:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function addDesignItemImage(_x35, _x36) {
        return _addDesignItemImage.apply(this, arguments);
      }
      return addDesignItemImage;
    }()
  }, {
    key: "getDesignItemsInfo",
    value: function getDesignItemsInfo() {
      var _this$_sceneDesignMan6;
      return ((_this$_sceneDesignMan6 = this._sceneDesignManager) === null || _this$_sceneDesignMan6 === void 0 ? void 0 : _this$_sceneDesignMan6.getItemsInfo()) || [];
    }
  }, {
    key: "setDesignItemText",
    value: function setDesignItemText(guid, text) {
      var _this$_sceneDesignMan7;
      (_this$_sceneDesignMan7 = this._sceneDesignManager) === null || _this$_sceneDesignMan7 === void 0 ? void 0 : _this$_sceneDesignMan7.setItemText(guid, text);
    }
  }, {
    key: "setDesignItemBold",
    value: function setDesignItemBold(guid, bold) {
      var _this$_sceneDesignMan8;
      (_this$_sceneDesignMan8 = this._sceneDesignManager) === null || _this$_sceneDesignMan8 === void 0 ? void 0 : _this$_sceneDesignMan8.setItemBold(guid, bold);
    }
  }, {
    key: "setDesignItemItalic",
    value: function setDesignItemItalic(guid, italic) {
      var _this$_sceneDesignMan9;
      (_this$_sceneDesignMan9 = this._sceneDesignManager) === null || _this$_sceneDesignMan9 === void 0 ? void 0 : _this$_sceneDesignMan9.setItemItalic(guid, italic);
    }
  }, {
    key: "setDesignItemColor",
    value: function setDesignItemColor(guid, color) {
      var _this$_sceneDesignMan10;
      (_this$_sceneDesignMan10 = this._sceneDesignManager) === null || _this$_sceneDesignMan10 === void 0 ? void 0 : _this$_sceneDesignMan10.setItemColor(guid, color);
    }
  }, {
    key: "setDesignItemFontFamily",
    value: function setDesignItemFontFamily(guid, fontFamily) {
      var _this$_sceneDesignMan11;
      (_this$_sceneDesignMan11 = this._sceneDesignManager) === null || _this$_sceneDesignMan11 === void 0 ? void 0 : _this$_sceneDesignMan11.setItemFontFamily(guid, fontFamily);
    }
  }, {
    key: "setDesignItemImage",
    value: function () {
      var _setDesignItemImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26(guid, image) {
        var _this$_sceneDesignMan12;
        return _regeneratorRuntime().wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return (_this$_sceneDesignMan12 = this._sceneDesignManager) === null || _this$_sceneDesignMan12 === void 0 ? void 0 : _this$_sceneDesignMan12.setItemImage(guid, image);
            case 2:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function setDesignItemImage(_x37, _x38) {
        return _setDesignItemImage.apply(this, arguments);
      }
      return setDesignItemImage;
    }()
  }, {
    key: "setItemTextOnPath",
    value: function setItemTextOnPath(guid, areaId, value) {
      var _this$_sceneDesignMan13;
      (_this$_sceneDesignMan13 = this._sceneDesignManager) === null || _this$_sceneDesignMan13 === void 0 ? void 0 : _this$_sceneDesignMan13.setItemTextOnPath(guid, areaId, value);
    }
  }, {
    key: "removeDesignItemImage",
    value: function removeDesignItemImage(guid) {
      var _this$_sceneDesignMan14;
      (_this$_sceneDesignMan14 = this._sceneDesignManager) === null || _this$_sceneDesignMan14 === void 0 ? void 0 : _this$_sceneDesignMan14.removeItemImage(guid);
    }
  }, {
    key: "setDesignVisibility",
    value: function setDesignVisibility(meshId, opacity) {
      var _this$_sceneDesignMan15;
      (_this$_sceneDesignMan15 = this._sceneDesignManager) === null || _this$_sceneDesignMan15 === void 0 ? void 0 : _this$_sceneDesignMan15.setDesignVisibility(meshId, opacity);
    }
  }, {
    key: "setupShaderMaterialsCameraPosition",
    value: function setupShaderMaterialsCameraPosition() {
      if (this._scene) {
        for (var i = 0; i < this._scene.materials.length; i++) {
          var material = this._scene.materials[i];
          this.setupShaderMaterialCameraPosition(material);
        }
      }
    }
  }, {
    key: "setupShaderMaterialCameraPosition",
    value: function setupShaderMaterialCameraPosition(material) {
      if (this._scene && this._scene.activeCamera && material && material instanceof BABYLON.ShaderMaterial) {
        material.setVector3("cameraPosition", this._scene.activeCamera.position);
      }
    }
  }, {
    key: "setMeshLocation",
    value: function setMeshLocation(locationID) {
      if (this._meshLocationsManager) {
        this._meshLocationsManager.setMeshLocationByID(locationID);
      }
    }
  }, {
    key: "explodeMeshes",
    value: function () {
      var _explodeMeshes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              if (!this._meshLocationsManager) {
                _context27.next = 3;
                break;
              }
              _context27.next = 3;
              return this._meshLocationsManager.explodeMeshes();
            case 3:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function explodeMeshes() {
        return _explodeMeshes.apply(this, arguments);
      }
      return explodeMeshes;
    }()
  }, {
    key: "collapseMeshes",
    value: function () {
      var _collapseMeshes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
        return _regeneratorRuntime().wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              if (!this._meshLocationsManager) {
                _context28.next = 3;
                break;
              }
              _context28.next = 3;
              return this._meshLocationsManager.collapseMeshes();
            case 3:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function collapseMeshes() {
        return _collapseMeshes.apply(this, arguments);
      }
      return collapseMeshes;
    }()
  }, {
    key: "dracoDecodingFunction",
    value: function dracoDecodingFunction(filename, fileBytes, callback) {
      this.decodeDracoFile(filename, fileBytes, callback);
    }
  }, {
    key: "decodeDracoFile",
    value: function decodeDracoFile(filename, fileBytes, callback) {
      var start = new Date().getTime();
      var fileContentView = new Uint8Array(fileBytes);
      var fileContent = msgpack.decode(fileContentView);
      //var dracoCompression = new DracoCompression();
      this.dracoCompression.decodeMeshAsync(fileContent.data).then(function (vertexData) {
        var result = {};

        // Da testare il passaggio diretto di VertexData
        if (vertexData) {
          if (vertexData.indices) result.indices = vertexData.indices;
          if (vertexData.positions) result.positions = vertexData.positions;
          if (vertexData.normals) result.normals = vertexData.normals;
          if (vertexData.uvs) result.uvs = vertexData.uvs;
          if (vertexData.uvs2) result.uvs2 = vertexData.uvs2;
        }
        var date = new Date();
        var time = date.getTime();
        var elapsed = time - start;
        var timeText = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + "." + date.getMilliseconds();
        Logger.info("Draco Decoding [" + timeText + "] - " + filename + "\t" + fileBytes.byteLength + "\t" + elapsed + " ms");
        if (callback) callback(result);
      });
    }
  }, {
    key: "exportSceneToBabylon",
    value: function exportSceneToBabylon() {
      if (!this._zkScene || !this._sceneHelper) return null;
      return this._sceneHelper.exportSceneToBabylon();
    }
  }, {
    key: "exportVisibleMeshesToBabylon",
    value: function exportVisibleMeshesToBabylon() {
      if (!this._zkScene || !this._sceneHelper) return null;
      return this._sceneHelper.exportVisibleMeshesToBabylon();
    }
  }, {
    key: "exportMeshesForTyOnToBabylon",
    value: function () {
      var _exportMeshesForTyOnToBabylon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
        return _regeneratorRuntime().wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              if (!(!this._zkScene || !this._sceneHelper)) {
                _context29.next = 2;
                break;
              }
              return _context29.abrupt("return", null);
            case 2:
              _context29.next = 4;
              return this._sceneHelper.exportMeshesForTyOnToBabylon();
            case 4:
              return _context29.abrupt("return", _context29.sent);
            case 5:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function exportMeshesForTyOnToBabylon() {
        return _exportMeshesForTyOnToBabylon.apply(this, arguments);
      }
      return exportMeshesForTyOnToBabylon;
    }()
  }, {
    key: "exportMeshToBabylon",
    value: function () {
      var _exportMeshToBabylon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(meshID) {
        var mesh;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              if (!(!this._scene || !this._zkScene || !this._sceneHelper)) {
                _context30.next = 2;
                break;
              }
              return _context30.abrupt("return", null);
            case 2:
              mesh = this._scene.getMeshById(meshID);
              if (!mesh) {
                _context30.next = 7;
                break;
              }
              _context30.next = 6;
              return this._sceneHelper.exportMeshToBabylon(mesh);
            case 6:
              return _context30.abrupt("return", _context30.sent);
            case 7:
              return _context30.abrupt("return", null);
            case 8:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function exportMeshToBabylon(_x39) {
        return _exportMeshToBabylon.apply(this, arguments);
      }
      return exportMeshToBabylon;
    }()
  }, {
    key: "downloadMeshToBabylon",
    value: function () {
      var _downloadMeshToBabylon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(meshID) {
        var mesh;
        return _regeneratorRuntime().wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              if (!(!this._scene || !this._zkScene || !this._sceneHelper)) {
                _context31.next = 2;
                break;
              }
              return _context31.abrupt("return");
            case 2:
              mesh = this._scene.getMeshById(meshID);
              if (!mesh) {
                _context31.next = 6;
                break;
              }
              _context31.next = 6;
              return this._sceneHelper.downloadMeshBabylonAsync(mesh);
            case 6:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function downloadMeshToBabylon(_x40) {
        return _downloadMeshToBabylon.apply(this, arguments);
      }
      return downloadMeshToBabylon;
    }()
  }, {
    key: "saveSceneOnDatabaseAsync",
    value: function () {
      var _saveSceneOnDatabaseAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32(fileId) {
        var json, db;
        return _regeneratorRuntime().wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              json = this.exportSceneToBabylon();
              if (!json) {
                _context32.next = 7;
                break;
              }
              db = new _Misc_Database__WEBPACK_IMPORTED_MODULE_13__.Database(); // carico il file json da IndexedDB
              _context32.next = 5;
              return db.openAsync();
            case 5:
              _context32.next = 7;
              return db.saveFileAsync(fileId, json);
            case 7:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function saveSceneOnDatabaseAsync(_x41) {
        return _saveSceneOnDatabaseAsync.apply(this, arguments);
      }
      return saveSceneOnDatabaseAsync;
    }()
  }, {
    key: "saveVisibleMeshesOnDatabaseAsync",
    value: function () {
      var _saveVisibleMeshesOnDatabaseAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(fileId) {
        var json, db;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return this.exportMeshesForTyOnToBabylon();
            case 2:
              json = _context33.sent;
              if (!json) {
                _context33.next = 9;
                break;
              }
              db = new _Misc_Database__WEBPACK_IMPORTED_MODULE_13__.Database(); // carico il file json da IndexedDB
              _context33.next = 7;
              return db.openAsync();
            case 7:
              _context33.next = 9;
              return db.saveFileAsync(fileId, json);
            case 9:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function saveVisibleMeshesOnDatabaseAsync(_x42) {
        return _saveVisibleMeshesOnDatabaseAsync.apply(this, arguments);
      }
      return saveVisibleMeshesOnDatabaseAsync;
    }()
  }, {
    key: "saveGlbOnDatabaseAsync",
    value: function () {
      var _saveGlbOnDatabaseAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34(fileId) {
        var data, db;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              data = null;
              _context34.next = 3;
              return this.exportSceneToLocalGLBAsync();
            case 3:
              data = _context34.sent;
              if (!data) {
                _context34.next = 10;
                break;
              }
              db = new _Misc_Database__WEBPACK_IMPORTED_MODULE_13__.Database();
              _context34.next = 8;
              return db.openAsync();
            case 8:
              _context34.next = 10;
              return db.saveFileAsync(fileId, data);
            case 10:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function saveGlbOnDatabaseAsync(_x43) {
        return _saveGlbOnDatabaseAsync.apply(this, arguments);
      }
      return saveGlbOnDatabaseAsync;
    }()
  }, {
    key: "getArFileUrlCacheKey",
    value: function getArFileUrlCacheKey(sceneID, sceneCode) {
      var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'usdz';
      var key = "scene_" + sceneID;
      if (sceneCode) key += "_code_" + sceneCode;
      if (this._sceneDesignManager) {
        var json = this._sceneDesignManager.getDesignItemsJson();
        if (json) {
          var hash = CryptoJS.SHA1(json).toString();
          key += "_design_" + this._sceneDesignManager.getDesignID() + "_" + hash;
        }
      }
      key += "_" + format;
      return key;
    }
  }, {
    key: "getCachedArFileUrl",
    value: function getCachedArFileUrl(sceneID, sceneCode) {
      var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'usdz';
      var key = this.getArFileUrlCacheKey(sceneID, sceneCode, format);
      if (this._arFileUrls.hasOwnProperty(key)) return this._arFileUrls[key];
      return null;
    }
  }, {
    key: "cacheArFileUrl",
    value: function cacheArFileUrl(sceneID, sceneCode, format, url) {
      if (url) {
        var key = this.getArFileUrlCacheKey(sceneID, sceneCode || undefined, format);
        this._arFileUrls[key] = url;
      }
    }
  }, {
    key: "exportSceneToUsdzAsync",
    value: function () {
      var _exportSceneToUsdzAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(sceneID, sceneCode, useCacheWithDesign) {
        var _this$_zkScene;
        var format, url, sceneName, sceneRootUrl, sn, sru;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              if (!(!this._zkScene || !this._sceneHelper)) {
                _context35.next = 2;
                break;
              }
              return _context35.abrupt("return", null);
            case 2:
              format = "usdz";
              url = null;
              if (sceneID && (!this._sceneDesignManager || useCacheWithDesign)) url = this.getCachedArFileUrl(sceneID, sceneCode, format);
              if (!url) {
                _context35.next = 7;
                break;
              }
              return _context35.abrupt("return", url);
            case 7:
              sceneName = null;
              sceneRootUrl = null;
              sn = this._zkScene.get("name");
              if (sn) sceneName = sn;
              sru = this._zkScene.get("rootUrl");
              if (sru) sceneRootUrl = sru;
              if (this._sceneDesignManager) this._sceneDesignManager.expandCanvasMeshes();
              _context35.next = 16;
              return this._sceneHelper.exportSceneToUsdzAsync(sceneName, sceneRootUrl, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneID, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneCode, (_this$_zkScene = this._zkScene) === null || _this$_zkScene === void 0 ? void 0 : _this$_zkScene.getARScale());
            case 16:
              url = _context35.sent;
              if (this._sceneDesignManager) this._sceneDesignManager.contractCanvasMeshes();
              if (url && sceneID && !this._sceneDesignManager) this.cacheArFileUrl(sceneID, sceneCode || null, format, url);
              return _context35.abrupt("return", url);
            case 20:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this);
      }));
      function exportSceneToUsdzAsync(_x44, _x45, _x46) {
        return _exportSceneToUsdzAsync.apply(this, arguments);
      }
      return exportSceneToUsdzAsync;
    }()
  }, {
    key: "exportMeshToUsdzAsync",
    value: function () {
      var _exportMeshToUsdzAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(meshID) {
        var mesh, sceneRootUrl, sru, url;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              mesh = this.getMeshByID(meshID);
              if (!(mesh && this._zkScene && this._sceneHelper)) {
                _context36.next = 10;
                break;
              }
              sceneRootUrl = null;
              sru = this._zkScene.get("rootUrl");
              if (sru) sceneRootUrl = sru;
              _context36.next = 7;
              return this._sceneHelper.exportMeshToUsdzAsync(sceneRootUrl, mesh, this.getARScale());
            case 7:
              url = _context36.sent;
              Logger.info("USDZ: " + url);
              return _context36.abrupt("return", url);
            case 10:
              return _context36.abrupt("return", null);
            case 11:
            case "end":
              return _context36.stop();
          }
        }, _callee36, this);
      }));
      function exportMeshToUsdzAsync(_x47) {
        return _exportMeshToUsdzAsync.apply(this, arguments);
      }
      return exportMeshToUsdzAsync;
    }()
  }, {
    key: "exportSceneToRemoteGlTFAsync",
    value: function () {
      var _exportSceneToRemoteGlTFAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(sceneID, sceneCode, useCacheWithDesign) {
        var _this$_zkScene2;
        var format, url, sceneName, sceneRootUrl, sn, sru;
        return _regeneratorRuntime().wrap(function _callee37$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              if (this._sceneHelper) {
                _context37.next = 2;
                break;
              }
              return _context37.abrupt("return", null);
            case 2:
              format = "glTF";
              url = null;
              if (sceneID && (!this._sceneDesignManager || useCacheWithDesign)) url = this.getCachedArFileUrl(sceneID, sceneCode, format);
              if (!url) {
                _context37.next = 7;
                break;
              }
              return _context37.abrupt("return", url);
            case 7:
              sceneName = null;
              sceneRootUrl = null;
              if (this._zkScene) {
                sn = this._zkScene.get("name");
                if (sn) sceneName = sn;
                sru = this._zkScene.get("rootUrl");
                if (sru) sceneRootUrl = sru;
              }
              if (this._sceneDesignManager) this._sceneDesignManager.expandCanvasMeshes();
              _context37.next = 13;
              return this._sceneHelper.exportSceneToRemoteGlTFAsync(sceneName, sceneRootUrl, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneID, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneCode, (_this$_zkScene2 = this._zkScene) === null || _this$_zkScene2 === void 0 ? void 0 : _this$_zkScene2.getARScale());
            case 13:
              url = _context37.sent;
              if (this._sceneDesignManager) this._sceneDesignManager.contractCanvasMeshes();
              if (url && sceneID && !this._sceneDesignManager) this.cacheArFileUrl(sceneID, sceneCode || null, format, url);
              Logger.info("GlTF: " + url);
              return _context37.abrupt("return", url);
            case 18:
            case "end":
              return _context37.stop();
          }
        }, _callee37, this);
      }));
      function exportSceneToRemoteGlTFAsync(_x48, _x49, _x50) {
        return _exportSceneToRemoteGlTFAsync.apply(this, arguments);
      }
      return exportSceneToRemoteGlTFAsync;
    }()
  }, {
    key: "exportMeshToRemoteGlTFAsync",
    value: function () {
      var _exportMeshToRemoteGlTFAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(meshID) {
        var mesh, sceneRootUrl, sru, url;
        return _regeneratorRuntime().wrap(function _callee38$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              mesh = this.getMeshByID(meshID);
              if (!(mesh && this._zkScene && this._sceneHelper)) {
                _context38.next = 10;
                break;
              }
              sceneRootUrl = null;
              sru = this._zkScene.get("rootUrl");
              if (sru) sceneRootUrl = sru;
              _context38.next = 7;
              return this._sceneHelper.exportMeshToRemoteGlTFAsync(sceneRootUrl, mesh, this.getARScale());
            case 7:
              url = _context38.sent;
              Logger.info("GlTF: " + url);
              return _context38.abrupt("return", url);
            case 10:
              return _context38.abrupt("return", null);
            case 11:
            case "end":
              return _context38.stop();
          }
        }, _callee38, this);
      }));
      function exportMeshToRemoteGlTFAsync(_x51) {
        return _exportMeshToRemoteGlTFAsync.apply(this, arguments);
      }
      return exportMeshToRemoteGlTFAsync;
    }()
  }, {
    key: "exportSceneToRemoteGLBAsync",
    value: function () {
      var _exportSceneToRemoteGLBAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39(sceneID, sceneCode, useCacheWithDesign) {
        var _this$_zkScene3;
        var format, url, sceneName, sceneRootUrl, sn, sru;
        return _regeneratorRuntime().wrap(function _callee39$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              if (this._sceneHelper) {
                _context39.next = 2;
                break;
              }
              return _context39.abrupt("return", null);
            case 2:
              format = "glb";
              url = null;
              if (sceneID && (!this._sceneDesignManager || useCacheWithDesign)) url = this.getCachedArFileUrl(sceneID, sceneCode, format);
              if (!url) {
                _context39.next = 7;
                break;
              }
              return _context39.abrupt("return", url);
            case 7:
              sceneName = null;
              sceneRootUrl = null;
              if (this._zkScene) {
                sn = this._zkScene.get("name");
                if (sn) sceneName = sn;
                sru = this._zkScene.get("rootUrl");
                if (sru) sceneRootUrl = sru;
              }
              if (this._sceneDesignManager) this._sceneDesignManager.expandCanvasMeshes();
              _context39.next = 13;
              return this._sceneHelper.exportSceneToRemoteGLBAsync(sceneName, sceneRootUrl, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneID, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneCode, (_this$_zkScene3 = this._zkScene) === null || _this$_zkScene3 === void 0 ? void 0 : _this$_zkScene3.getARScale());
            case 13:
              url = _context39.sent;
              if (this._sceneDesignManager) this._sceneDesignManager.contractCanvasMeshes();
              if (url && sceneID && !this._sceneDesignManager) this.cacheArFileUrl(sceneID, sceneCode || null, format, url);
              Logger.info("GLB: " + url);
              return _context39.abrupt("return", url);
            case 18:
            case "end":
              return _context39.stop();
          }
        }, _callee39, this);
      }));
      function exportSceneToRemoteGLBAsync(_x52, _x53, _x54) {
        return _exportSceneToRemoteGLBAsync.apply(this, arguments);
      }
      return exportSceneToRemoteGLBAsync;
    }()
  }, {
    key: "exportMeshToRemoteGLBAsync",
    value: function () {
      var _exportMeshToRemoteGLBAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40(meshID) {
        var mesh, sceneRootUrl, sru, url;
        return _regeneratorRuntime().wrap(function _callee40$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              mesh = this.getMeshByID(meshID);
              if (!(mesh && this._zkScene && this._sceneHelper)) {
                _context40.next = 10;
                break;
              }
              sceneRootUrl = null;
              sru = this._zkScene.get("rootUrl");
              if (sru) sceneRootUrl = sru;
              _context40.next = 7;
              return this._sceneHelper.exportMeshToRemoteGLBAsync(sceneRootUrl, mesh, this.getARScale());
            case 7:
              url = _context40.sent;
              Logger.info("GlTF: " + url);
              return _context40.abrupt("return", url);
            case 10:
              return _context40.abrupt("return", null);
            case 11:
            case "end":
              return _context40.stop();
          }
        }, _callee40, this);
      }));
      function exportMeshToRemoteGLBAsync(_x55) {
        return _exportMeshToRemoteGLBAsync.apply(this, arguments);
      }
      return exportMeshToRemoteGLBAsync;
    }() // Esporta la scena nei formati glb e usdz utili per visualizzarli con model-viewer
    // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  }, {
    key: "exportSceneToARAsync",
    value: function () {
      var _exportSceneToARAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41() {
        var result, sceneName, sceneRootUrl, sn, sru;
        return _regeneratorRuntime().wrap(function _callee41$(_context41) {
          while (1) switch (_context41.prev = _context41.next) {
            case 0:
              result = [];
              if (this._sceneHelper) {
                _context41.next = 3;
                break;
              }
              return _context41.abrupt("return", result);
            case 3:
              sceneName = null;
              sceneRootUrl = null;
              if (this._zkScene) {
                sn = this._zkScene.get("name");
                if (sn) sceneName = sn;
                sru = this._zkScene.get("rootUrl");
                if (sru) sceneRootUrl = sru;
              }
              if (this._sceneDesignManager) this._sceneDesignManager.expandCanvasMeshes();
              _context41.next = 9;
              return this._sceneHelper.exportSceneToARMultiformatAsync(sceneName, sceneRootUrl, ["usdz", "glb"]);
            case 9:
              result = _context41.sent;
              if (this._sceneDesignManager) this._sceneDesignManager.contractCanvasMeshes();
              return _context41.abrupt("return", result);
            case 12:
            case "end":
              return _context41.stop();
          }
        }, _callee41, this);
      }));
      function exportSceneToARAsync() {
        return _exportSceneToARAsync.apply(this, arguments);
      }
      return exportSceneToARAsync;
    }() // Esporta la mesh nei formati glb e usdz utili per visualizzarli con model-viewer
    // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
  }, {
    key: "exportMeshToARAsync",
    value: function () {
      var _exportMeshToARAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42(meshID) {
        var result, mesh, sceneRootUrl, sru;
        return _regeneratorRuntime().wrap(function _callee42$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              result = [];
              mesh = this.getMeshByID(meshID);
              if (!(mesh && this._zkScene && this._sceneHelper)) {
                _context42.next = 9;
                break;
              }
              sceneRootUrl = null;
              sru = this._zkScene.get("rootUrl");
              if (sru) sceneRootUrl = sru;
              _context42.next = 8;
              return this._sceneHelper.exportMeshToARMultiformatAsync(sceneRootUrl, mesh, ["usdz", "glb"], this.getARScale());
            case 8:
              result = _context42.sent;
            case 9:
              return _context42.abrupt("return", result);
            case 10:
            case "end":
              return _context42.stop();
          }
        }, _callee42, this);
      }));
      function exportMeshToARAsync(_x56) {
        return _exportMeshToARAsync.apply(this, arguments);
      }
      return exportMeshToARAsync;
    }()
  }, {
    key: "isAREnabled",
    value: function isAREnabled() {
      if (!this._zkScene) return false;
      var enabled = this._zkScene.getAREnabled();
      return enabled !== null && enabled !== undefined && enabled && this._sceneHelper != null && this._sceneHelper.getMeshesForAR().length > 0 && this._sceneHelper.checkMaterialsForAR();
    }
  }, {
    key: "exportSceneToLocalGLBAsync",
    value: function () {
      var _exportSceneToLocalGLBAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43() {
        var result;
        return _regeneratorRuntime().wrap(function _callee43$(_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              if (this._sceneDesignManager) this._sceneDesignManager.expandCanvasMeshes();
              result = null;
              if (!this._sceneHelper) {
                _context43.next = 6;
                break;
              }
              _context43.next = 5;
              return this._sceneHelper.exportSceneToLocalGLBBlobAsync();
            case 5:
              result = _context43.sent;
            case 6:
              if (this._sceneDesignManager) this._sceneDesignManager.contractCanvasMeshes();
              return _context43.abrupt("return", result);
            case 8:
            case "end":
              return _context43.stop();
          }
        }, _callee43, this);
      }));
      function exportSceneToLocalGLBAsync() {
        return _exportSceneToLocalGLBAsync.apply(this, arguments);
      }
      return exportSceneToLocalGLBAsync;
    }()
  }, {
    key: "downloadSceneLocalGLBAsync",
    value: function () {
      var _downloadSceneLocalGLBAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
        return _regeneratorRuntime().wrap(function _callee44$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              if (this._sceneDesignManager) this._sceneDesignManager.expandCanvasMeshes();
              if (!this._sceneHelper) {
                _context44.next = 4;
                break;
              }
              _context44.next = 4;
              return this._sceneHelper.downloadSceneLocalGLBAsync();
            case 4:
              if (this._sceneDesignManager) this._sceneDesignManager.contractCanvasMeshes();
            case 5:
            case "end":
              return _context44.stop();
          }
        }, _callee44, this);
      }));
      function downloadSceneLocalGLBAsync() {
        return _downloadSceneLocalGLBAsync.apply(this, arguments);
      }
      return downloadSceneLocalGLBAsync;
    }()
  }, {
    key: "exportSceneToLocalUSDZAsync",
    value: function () {
      var _exportSceneToLocalUSDZAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45() {
        var result;
        return _regeneratorRuntime().wrap(function _callee45$(_context45) {
          while (1) switch (_context45.prev = _context45.next) {
            case 0:
              if (this._sceneDesignManager) this._sceneDesignManager.expandCanvasMeshes();
              result = null;
              if (!this._sceneHelper) {
                _context45.next = 6;
                break;
              }
              _context45.next = 5;
              return this._sceneHelper.exportSceneToLocalUSDZUrlAsync();
            case 5:
              result = _context45.sent;
            case 6:
              if (this._sceneDesignManager) this._sceneDesignManager.contractCanvasMeshes();
              return _context45.abrupt("return", result);
            case 8:
            case "end":
              return _context45.stop();
          }
        }, _callee45, this);
      }));
      function exportSceneToLocalUSDZAsync() {
        return _exportSceneToLocalUSDZAsync.apply(this, arguments);
      }
      return exportSceneToLocalUSDZAsync;
    }()
  }, {
    key: "downloadSceneLocalUSDZAsync",
    value: function () {
      var _downloadSceneLocalUSDZAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46() {
        return _regeneratorRuntime().wrap(function _callee46$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              if (this._sceneDesignManager) this._sceneDesignManager.expandCanvasMeshes();
              if (!this._sceneHelper) {
                _context46.next = 4;
                break;
              }
              _context46.next = 4;
              return this._sceneHelper.downloadSceneLocalUSDZAsync();
            case 4:
              if (this._sceneDesignManager) this._sceneDesignManager.contractCanvasMeshes();
            case 5:
            case "end":
              return _context46.stop();
          }
        }, _callee46, this);
      }));
      function downloadSceneLocalUSDZAsync() {
        return _downloadSceneLocalUSDZAsync.apply(this, arguments);
      }
      return downloadSceneLocalUSDZAsync;
    }()
  }, {
    key: "getSceneRootUrl",
    value: function getSceneRootUrl() {
      var _this19 = this;
      return new Promise(function (resolve, reject) {
        var rootUrl = null;
        if (_this19._zkScene) {
          rootUrl = _this19._zkScene.get("rootUrl") || null;
          if (rootUrl) resolve(rootUrl);else {
            jQuery.ajax({
              url: _this19._zkScene.getSceneRootUrlApiUrl(),
              type: 'GET',
              success: function success(data) {
                rootUrl = data;
                resolve(rootUrl);
              },
              error: function error(xhr, textStatus, errorThrown) {
                reject(errorThrown);
              }
            });
          }
        } else {
          resolve(rootUrl);
        }
      });
    }
  }, {
    key: "refreshInfoPoints",
    value: function refreshInfoPoints() {
      var _this20 = this;
      var enabled = this._zkScene && this._zkScene.getInfoPointsEnabled() && this.canShowInfoPoints;
      if (!enabled) {
        this.disposeInfoPointsManager();
        this.setLongRenderingNeeded();
        return;
      }
      var style = this.getInfoPointsManagerStyle();
      var antialias = null;
      if (!this._infoPointsManager) {
        if (this._scene && this._zkScene) {
          this._infoPointsManager = new _Components_InfoPointsManager_InfoPointsManager__WEBPACK_IMPORTED_MODULE_8__.InfoPointsManager(this._zkScene, this._scene, style);
          if (this._infoPointPickedListeners && this._infoPointPickedListeners.length > 0) this._infoPointsManager.addInfoPointPickedListenerRange(this._infoPointPickedListeners);
          if (this._infoPointContentShownListeners && this._infoPointContentShownListeners.length > 0) this._infoPointsManager.addInfoPointContentShownListenerRange(this._infoPointContentShownListeners);
          if (this._infoPointContentShownListeners && this._infoPointContentShownListeners.length > 0) this._infoPointsManager.addInfoPointContentShownListenerRange(this._infoPointContentShownListeners);
          this._infoPointsManager.onBeforeShowImages = function () {
            if (antialias === null) antialias = _this20.antialias;
            _this20.antialias = false;
            _this20.disableAntialiasing();
          };
          this._infoPointsManager.onAfterShowImages = function () {
            _this20.antialias = antialias;
            antialias = null;
            _this20.enableAntialiasing();
            _this20.setLongRenderingNeeded();
          };
          this._infoPointsManager.addRenderingNeededListener(function () {
            return _this20.setRenderingNeeded();
          });
        }
      }
      if (this._infoPointsManager) {
        this.updateInfoPointsManagerStyle();
        this._infoPointsManager.canShowInfoPointsContent = this.canShowInfoPointsContent;
        this._infoPointsManager.refresh();
      }
      this.setLongRenderingNeeded();
    }
  }, {
    key: "getInfoPointsManagerStyle",
    value: function getInfoPointsManagerStyle() {
      var style = this._infoPointsManagerStyle ? this._infoPointsManagerStyle : {};
      if (this._zkScene) {
        var pointsStyle = this._zkScene.getInfoPointsStyleConfig();
        if (pointsStyle) {
          if (!style.infoPointsStyle) style.infoPointsStyle = {};
          if (pointsStyle.get("borderColor")) style.infoPointsStyle.borderColor = pointsStyle.get("borderColor");
          if (pointsStyle.get("innerPointColor")) style.infoPointsStyle.innerPointColor = pointsStyle.get("innerPointColor");
          if (pointsStyle.get("color")) style.infoPointsStyle.color = pointsStyle.get("color");
          if (pointsStyle.get("highlightColor")) style.infoPointsStyle.highlightColor = pointsStyle.get("highlightColor");
        }
      }
      return style;
    }
  }, {
    key: "updateInfoPointsManagerStyle",
    value: function updateInfoPointsManagerStyle() {
      if (this._infoPointsManager) {
        var style = this.getInfoPointsManagerStyle();
        this._infoPointsManager.applyStyle(style);
      }
    }
  }, {
    key: "showInfoPoints",
    value: function showInfoPoints() {
      if (this._infoPointsManager) {
        this._infoPointsManager.showInfoPoints();
        this.render();
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "hideInfoPoints",
    value: function hideInfoPoints() {
      if (this._infoPointsManager) {
        this._infoPointsManager.hideInfoPoints();
        this.render();
        this.setRenderingNeeded();
      }
    }

    // try to reload all textures with loading errors
  }, {
    key: "reloadAllLoadingErrorTexturesAsync",
    value: function () {
      var _reloadAllLoadingErrorTexturesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47() {
        var rootUrl;
        return _regeneratorRuntime().wrap(function _callee47$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              if (!(this._zkScene && this._sceneHelper)) {
                _context47.next = 5;
                break;
              }
              rootUrl = this._zkScene.get("rootUrl");
              if (!rootUrl) {
                _context47.next = 5;
                break;
              }
              _context47.next = 5;
              return this._sceneHelper.reloadAllLoadingErrorTexturesAsync(rootUrl);
            case 5:
            case "end":
              return _context47.stop();
          }
        }, _callee47, this);
      }));
      function reloadAllLoadingErrorTexturesAsync() {
        return _reloadAllLoadingErrorTexturesAsync.apply(this, arguments);
      }
      return reloadAllLoadingErrorTexturesAsync;
    }() // try to reload the material textures with loading errors
  }, {
    key: "reloadMaterialLoadingErrorTexturesAsync",
    value: function () {
      var _reloadMaterialLoadingErrorTexturesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48(material) {
        var rootUrl;
        return _regeneratorRuntime().wrap(function _callee48$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              if (!(this._zkScene && this._sceneHelper)) {
                _context48.next = 5;
                break;
              }
              rootUrl = this._zkScene.get("rootUrl");
              if (!rootUrl) {
                _context48.next = 5;
                break;
              }
              _context48.next = 5;
              return this._sceneHelper.reloadMaterialLoadingErrorTexturesAsync(rootUrl, material);
            case 5:
            case "end":
              return _context48.stop();
          }
        }, _callee48, this);
      }));
      function reloadMaterialLoadingErrorTexturesAsync(_x57) {
        return _reloadMaterialLoadingErrorTexturesAsync.apply(this, arguments);
      }
      return reloadMaterialLoadingErrorTexturesAsync;
    }() // try to reload the texture having loading errors
  }, {
    key: "reloadLoadingErrorTextureAsync",
    value: function () {
      var _reloadLoadingErrorTextureAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49(texture) {
        var rootUrl;
        return _regeneratorRuntime().wrap(function _callee49$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              if (!(this._zkScene && this._sceneHelper)) {
                _context49.next = 5;
                break;
              }
              rootUrl = this._zkScene.get("rootUrl");
              if (!rootUrl) {
                _context49.next = 5;
                break;
              }
              _context49.next = 5;
              return this._sceneHelper.reloadLoadingErrorTextureAsync(rootUrl, texture);
            case 5:
            case "end":
              return _context49.stop();
          }
        }, _callee49, this);
      }));
      function reloadLoadingErrorTextureAsync(_x58) {
        return _reloadLoadingErrorTextureAsync.apply(this, arguments);
      }
      return reloadLoadingErrorTextureAsync;
    }() // were there any loading errors for the texture?
  }, {
    key: "isTextureLoadingError",
    value: function isTextureLoadingError(texture) {
      return this._sceneHelper ? this._sceneHelper.isTextureLoadingError(texture) : false;
    }

    // the material has some texture with loading errors
  }, {
    key: "materialHasLoadingErrorTextues",
    value: function materialHasLoadingErrorTextues(material) {
      return this._sceneHelper ? this._sceneHelper.materialHasLoadingErrorTextues(material) : false;
    }
  }, {
    key: "notifyCameraMovement",
    value: function notifyCameraMovement() {
      if (this._isHologramSource && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
        var bc = this.getOrCreateBroadcastChannel();
        if (!bc) return;
        bc.postMessage({
          type: BroadcastChannelEventType.CameraMovement,
          target: {
            x: this._camera.target.x,
            y: this._camera.target.y,
            z: this._camera.target.z
          },
          alpha: this._camera.alpha,
          beta: this._camera.beta,
          radius: this._camera.radius
        });
      }
    }
  }, {
    key: "notifyScriptExecution",
    value: function notifyScriptExecution(script) {
      if (this._isHologramSource) {
        var scriptJson = script.map(function (s) {
          return {
            attributeID: s.attributeID,
            selectedValue: s.selectedValue,
            actions: s.actions.map(function (a) {
              return a.toJSON();
            })
            /*
            actions: s.actions.map(a => ({
                attributeGuid: a.get("actionGuid"),
                name: a.get("name"),
                actionTypeID: a.get("actionTypeID"),
                sceneElementTypeID: a.get("sceneElementTypeID"),
                selector: a.get("selector"),
                propertyName: a.get("propertyName"),
                value: a.get("value"),
                execOrder: a.get("execOrder"),
                deviceTypes: a.get("deviceTypes")
            }))
            */
          };
        });

        var bc = this.getOrCreateBroadcastChannel();
        if (!bc) return;
        bc.postMessage({
          type: BroadcastChannelEventType.ScriptExecution,
          script: scriptJson
        });
      }
    }
  }, {
    key: "notifyDesignChanged",
    value: function notifyDesignChanged(zkDesign) {
      if (this._isHologramSource) {
        var bc = this.getOrCreateBroadcastChannel();
        if (!bc) return;
        bc.postMessage({
          type: BroadcastChannelEventType.DesignChanged,
          design: zkDesign.toJSON()
        });
      }
    }
  }, {
    key: "notifyActionExecution",
    value: function notifyActionExecution(attributeID, selectedValue, actions) {
      this.notifyScriptExecution([{
        attributeID: attributeID,
        selectedValue: selectedValue,
        actions: actions
      }]);
    }
  }, {
    key: "attachBroadcastChannelEventHandlers",
    value: function attachBroadcastChannelEventHandlers() {
      var _this21 = this;
      if (this._isHologram && !this._isHologramSource) {
        var bc = this.getOrCreateBroadcastChannel();
        if (!bc) return;
        bc.onmessage = function (event) {
          return _this21.onBroadcastMessageReceived(event);
        };
      }
    }
  }, {
    key: "detachBroadcastChannelEventHandlers",
    value: function detachBroadcastChannelEventHandlers() {
      if (this._broadcastChannel) this._broadcastChannel.onmessage = null;
    }
  }, {
    key: "onBroadcastMessageReceived",
    value: function onBroadcastMessageReceived(event) {
      if (this._isHologram && event && event.data && event.data.type) {
        if (event.data.type === BroadcastChannelEventType.CameraMovement) {
          this.processCameraMovementEvent(event);
        } else if (event.data.type === BroadcastChannelEventType.ScriptExecution) {
          this.processScriptExecution(event);
        } else if (event.data.type === BroadcastChannelEventType.DesignChanged) {
          this.processDesignChanged(event);
        }
      }
    }
  }, {
    key: "processCameraMovementEvent",
    value: function processCameraMovementEvent(event) {
      if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera && event && event.data) {
        this._camera.target = new BABYLON.Vector3(event.data.target.x, event.data.target.y, event.data.target.z);
        this._camera.alpha = event.data.alpha;
        this._camera.beta = event.data.beta;
        this._camera.radius = event.data.radius;
        this.setRenderingNeeded();
      }
    }
  }, {
    key: "processScriptExecution",
    value: function processScriptExecution(event) {
      if (event && event.data && event.data.script && Object.prototype.toString.call(event.data.script) === '[object Array]') {
        var composerScript = event.data.script.map(function (s) {
          return {
            attributeID: s.attributeID,
            selectedValue: s.selectedValue,
            actions: s.actions.map(function (a) {
              return new MPlaza.AttributeSceneAction(a);
            })
          };
        });
        this.executeScriptAsync(composerScript);
      }
    }
  }, {
    key: "processDesignChanged",
    value: function processDesignChanged(event) {
      if (event && event.data && event.data.design) {
        var zkDesign = new MPlaza.Design(event.data.design);
        this.renderDesignAsync(zkDesign);
      }
    }
  }, {
    key: "showResizableCanvasModel",
    value: function () {
      var _showResizableCanvasModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50(args) {
        var meshes, paperScope, matrix, canvasSize, matrixJson;
        return _regeneratorRuntime().wrap(function _callee50$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!(this._scene && this._zkScene && this._zkModel && this._sceneHelper)) {
                _context50.next = 14;
                break;
              }
              _context50.next = 3;
              return this._sceneHelper.showResizableCanvas(args.width, args.height, args.depth, args.borderRadius, args.type, args.borderColor, args.columns, args.rows);
            case 3:
              meshes = _context50.sent;
              if (meshes) {
                _context50.next = 6;
                break;
              }
              return _context50.abrupt("return", {
                meshes: [],
                matrixJson: ''
              });
            case 6:
              paperScope = new (paper__WEBPACK_IMPORTED_MODULE_0___default().PaperScope)();
              paperScope.setup(new paperScope.Size(1, 1));
              matrix = new paperScope.Matrix(); // Move to center
              canvasSize = _Components_DesignManagers_MeshDesignManager__WEBPACK_IMPORTED_MODULE_3__.MeshDesignManager.DEFAULT_SIZE;
              matrix.translate(canvasSize / 2, canvasSize / 2);

              // Fill the canvas size so 0,0 1,1 of the UV will match the printing area
              matrix.scale(canvasSize / args.width, canvasSize / args.height);
              matrixJson = JSON.stringify(matrix.values);
              return _context50.abrupt("return", {
                meshes: meshes,
                matrixJson: matrixJson
              });
            case 14:
              return _context50.abrupt("return", {
                meshes: [],
                matrixJson: ''
              });
            case 15:
            case "end":
              return _context50.stop();
          }
        }, _callee50, this);
      }));
      function showResizableCanvasModel(_x59) {
        return _showResizableCanvasModel.apply(this, arguments);
      }
      return showResizableCanvasModel;
    }()
  }, {
    key: "showResizableCanvasPerCurrentSide",
    value: function () {
      var _showResizableCanvasPerCurrentSide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51(args) {
        var _this22 = this;
        var meshID, result, meshSides, resizableMeshSides, mesh, meshSide;
        return _regeneratorRuntime().wrap(function _callee51$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              console.log('showResizableCanvasPerCurrentSide', args);

              // Must be unique for configuration or the mesh sides will cache the old mesh
              meshID = "resizable-canvas-".concat(args.width, "-").concat(args.height, "-").concat(args.colorId, "-sideIdPlaceholder-").concat(args.columns, "-").concat(args.rows, "-").concat(args.type, "-").concat(args.borderColor);
              if (!(this._lastResizableMeshID === meshID)) {
                _context51.next = 4;
                break;
              }
              return _context51.abrupt("return");
            case 4:
              this._lastResizableMeshID = meshID;
              _context51.next = 7;
              return this.showResizableCanvasModel(args);
            case 7:
              result = _context51.sent;
              if (!(result.meshes.length === 0)) {
                _context51.next = 10;
                break;
              }
              return _context51.abrupt("return");
            case 10:
              meshSides = this._zkModel.get('scenes').at(0).get('meshSides');
              resizableMeshSides = meshSides.filter(function (x) {
                return x.get('isResizable');
              }); // Remove all resizableMeshSides
              resizableMeshSides.forEach(function (x) {
                return meshSides.remove(x);
              });
              mesh = result.meshes.find(function (x) {
                return x.name === 'front';
              });
              if (mesh) {
                _context51.next = 16;
                break;
              }
              return _context51.abrupt("return");
            case 16:
              mesh.id = meshID.replace('sideIdPlaceholder', args.currentSideId.toString());
              meshSide = new MPlaza.ModelSceneMeshSide({
                sideID: args.currentSideId,
                meshID: mesh.id,
                uvChannel: 0,
                percWidth: 1,
                percHeight: 1,
                subMeshID: 0,
                matrix: result.matrixJson,
                isResizable: true
              });
              meshSides.push(meshSide);
              setTimeout(function () {
                return _this22.adjustCamera(false);
              }, 100);
            case 20:
            case "end":
              return _context51.stop();
          }
        }, _callee51, this);
      }));
      function showResizableCanvasPerCurrentSide(_x60) {
        return _showResizableCanvasPerCurrentSide.apply(this, arguments);
      }
      return showResizableCanvasPerCurrentSide;
    }()
  }, {
    key: "showResizableCanvasPerVariant",
    value: function () {
      var _showResizableCanvasPerVariant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52(args) {
        var _this23 = this;
        var meshID, result, index, doubleSided, sides, meshSides, resizableMeshSides, _iterator3, _step3, mesh, sideId, meshSide;
        return _regeneratorRuntime().wrap(function _callee52$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              console.log('showResizableCanvasPerVariant', args);
              if (this.zkModel) {
                _context52.next = 3;
                break;
              }
              return _context52.abrupt("return");
            case 3:
              // Must be unique for configuration or the mesh sides will cache the old mesh
              meshID = "resizable-canvas-".concat(args.width, "-").concat(args.height, "-").concat(args.colorId, "-sideIdPlaceholder-").concat(args.columns, "-").concat(args.rows, "-").concat(args.type, "-").concat(args.borderColor);
              if (!(this._lastResizableMeshID === meshID)) {
                _context52.next = 6;
                break;
              }
              return _context52.abrupt("return");
            case 6:
              this._lastResizableMeshID = meshID;
              _context52.next = 9;
              return this.showResizableCanvasModel(args);
            case 9:
              result = _context52.sent;
              if (!(result.meshes.length === 0)) {
                _context52.next = 12;
                break;
              }
              return _context52.abrupt("return");
            case 12:
              index = 0;
              doubleSided = args.sidesIds.length > 1;
              sides = ['front', 'back', 'borders'];
              if (args.type === 'colored') {
                if (doubleSided) {
                  sides = ['front', 'back'];
                } else {
                  sides = ['front'];
                }
              } else if (args.type === 'mirrored') {
                if (doubleSided) {
                  sides = ['front', 'back', 'borders'];
                } else {
                  sides = ['front', 'borders'];
                }
              }
              meshSides = this._zkModel.get('scenes').at(0).get('meshSides');
              resizableMeshSides = meshSides.filter(function (x) {
                return x.get('isResizable');
              }); // Remove all resizableMeshSides
              resizableMeshSides.forEach(function (x) {
                return meshSides.remove(x);
              });

              // Meshes contains this list of merged meshes: [borders, front, back]
              _iterator3 = _createForOfIteratorHelper(result.meshes);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  mesh = _step3.value;
                  if (mesh) {
                    if (sides.includes(mesh.name)) {
                      sideId = !doubleSided || mesh.name === 'front' ? args.sidesIds[0] : args.sidesIds[1];
                      mesh.id = meshID.replace('sideIdPlaceholder', sideId.toString()) + index++;
                      meshSide = new MPlaza.ModelSceneMeshSide({
                        sideID: sideId,
                        meshID: mesh.id,
                        uvChannel: 0,
                        percWidth: 1,
                        percHeight: 1,
                        subMeshID: 0,
                        matrix: result.matrixJson,
                        isResizable: true
                      });
                      meshSides.push(meshSide);
                    }
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              setTimeout(function () {
                return _this23.adjustCamera(false);
              }, 100);
            case 22:
            case "end":
              return _context52.stop();
          }
        }, _callee52, this);
      }));
      function showResizableCanvasPerVariant(_x61) {
        return _showResizableCanvasPerVariant.apply(this, arguments);
      }
      return showResizableCanvasPerVariant;
    }()
  }, {
    key: "clearResizableProduct",
    value: function clearResizableProduct() {
      if (!this.zkModel || !this._sceneHelper) return;
      this._sceneHelper.clearMeshes();
      var meshSides = this._zkModel.get('scenes').at(0).get('meshSides');
      var resizableMeshSides = meshSides.filter(function (x) {
        return x.get('isResizable');
      });
      resizableMeshSides.forEach(function (x) {
        return meshSides.remove(x);
      });
    }
  }], [{
    key: "createSceneViewerAsync",
    value: function () {
      var _createSceneViewerAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53(options) {
        var sceneViewer;
        return _regeneratorRuntime().wrap(function _callee53$(_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              sceneViewer = new SceneViewer(options);
              _context53.next = 3;
              return sceneViewer.initAsync();
            case 3:
              return _context53.abrupt("return", sceneViewer);
            case 4:
            case "end":
              return _context53.stop();
          }
        }, _callee53);
      }));
      function createSceneViewerAsync(_x62) {
        return _createSceneViewerAsync.apply(this, arguments);
      }
      return createSceneViewerAsync;
    }()
  }]);
  return SceneViewer;
}();

/***/ }),

/***/ "../../3D/src/index.ts":
/*!*****************************!*\
  !*** ../../3D/src/index.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AndroidAR": () => (/* reexport safe */ _Components_AR_AndroidAR__WEBPACK_IMPORTED_MODULE_33__.AndroidAR),
/* harmony export */   "AxesLayer": () => (/* reexport safe */ _Layers_AxesLayer__WEBPACK_IMPORTED_MODULE_41__.AxesLayer),
/* harmony export */   "BlendProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_BlendProceduralTexture__WEBPACK_IMPORTED_MODULE_14__.BlendProceduralTexture),
/* harmony export */   "BlurXProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_6__.BlurXProceduralTexture),
/* harmony export */   "BlurYProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_7__.BlurYProceduralTexture),
/* harmony export */   "BroadcastChannelEventType": () => (/* reexport safe */ _Viewers_SceneViewer__WEBPACK_IMPORTED_MODULE_48__.BroadcastChannelEventType),
/* harmony export */   "Database": () => (/* reexport safe */ _Misc_Database__WEBPACK_IMPORTED_MODULE_47__.Database),
/* harmony export */   "DefaultAssetUrls": () => (/* reexport safe */ _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_43__.DefaultAssetUrls),
/* harmony export */   "DracoCompression": () => (/* reexport safe */ _Components_Draco_DracoCompression__WEBPACK_IMPORTED_MODULE_27__.DracoCompression),
/* harmony export */   "EditingMode": () => (/* reexport safe */ _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EditingMode),
/* harmony export */   "EditorMeshType": () => (/* reexport safe */ _Viewers_MaterialEditor__WEBPACK_IMPORTED_MODULE_50__.EditorMeshType),
/* harmony export */   "ElementSelector": () => (/* reexport safe */ _Components_Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_28__.ElementSelector),
/* harmony export */   "EnvironmentManager": () => (/* reexport safe */ _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_29__.EnvironmentManager),
/* harmony export */   "EnvironmentMode": () => (/* reexport safe */ _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode),
/* harmony export */   "EventState": () => (/* reexport safe */ _Misc_Observable__WEBPACK_IMPORTED_MODULE_45__.EventState),
/* harmony export */   "ForegroundBackgroundProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_8__.ForegroundBackgroundProceduralTexture),
/* harmony export */   "GlowManager": () => (/* reexport safe */ _Components_Glow_GlowManager__WEBPACK_IMPORTED_MODULE_17__.GlowManager),
/* harmony export */   "IncrementalFiles": () => (/* reexport safe */ _Components_IncrementalFiles_IncrementalFiles__WEBPACK_IMPORTED_MODULE_19__.IncrementalFiles),
/* harmony export */   "InfoPointsManager": () => (/* reexport safe */ _Components_InfoPointsManager_InfoPointsManager__WEBPACK_IMPORTED_MODULE_34__.InfoPointsManager),
/* harmony export */   "InnerShadow": () => (/* reexport safe */ _Components_Shadows_InnerShadow__WEBPACK_IMPORTED_MODULE_22__.InnerShadow),
/* harmony export */   "LightsLayer": () => (/* reexport safe */ _Layers_LightsLayer__WEBPACK_IMPORTED_MODULE_42__.LightsLayer),
/* harmony export */   "MakeIncremental": () => (/* reexport safe */ _Components_IncrementalFiles_MakeIncremental__WEBPACK_IMPORTED_MODULE_18__.MakeIncremental),
/* harmony export */   "MaterialEditor": () => (/* reexport safe */ _Viewers_MaterialEditor__WEBPACK_IMPORTED_MODULE_50__.MaterialEditor),
/* harmony export */   "MaterialGroup": () => (/* reexport safe */ _Viewers_SceneEditor__WEBPACK_IMPORTED_MODULE_49__.MaterialGroup),
/* harmony export */   "MaterialPreviewData": () => (/* reexport safe */ _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_20__.MaterialPreviewData),
/* harmony export */   "MaterialsPreview": () => (/* reexport safe */ _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_20__.MaterialsPreview),
/* harmony export */   "MeshDesignManager": () => (/* reexport safe */ _Components_DesignManagers_MeshDesignManager__WEBPACK_IMPORTED_MODULE_24__.MeshDesignManager),
/* harmony export */   "MeshExpander": () => (/* reexport safe */ _Components_MeshExpander_MeshExpander__WEBPACK_IMPORTED_MODULE_30__.MeshExpander),
/* harmony export */   "MeshLocationsManager": () => (/* reexport safe */ _Components_CollapseExplode_MeshLocationsManager__WEBPACK_IMPORTED_MODULE_16__.MeshLocationsManager),
/* harmony export */   "MoveProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_9__.MoveProceduralTexture),
/* harmony export */   "MultiObserver": () => (/* reexport safe */ _Misc_Observable__WEBPACK_IMPORTED_MODULE_45__.MultiObserver),
/* harmony export */   "MultiplyProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_10__.MultiplyProceduralTexture),
/* harmony export */   "NormalMapProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_NormalMapProceduralTexture__WEBPACK_IMPORTED_MODULE_11__.NormalMapProceduralTexture),
/* harmony export */   "Observable": () => (/* reexport safe */ _Misc_Observable__WEBPACK_IMPORTED_MODULE_45__.Observable),
/* harmony export */   "Observer": () => (/* reexport safe */ _Misc_Observable__WEBPACK_IMPORTED_MODULE_45__.Observer),
/* harmony export */   "OpacityProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_OpacityProceduralTexture__WEBPACK_IMPORTED_MODULE_12__.OpacityProceduralTexture),
/* harmony export */   "OuterShadow": () => (/* reexport safe */ _Components_Shadows_OuterShadow__WEBPACK_IMPORTED_MODULE_23__.OuterShadow),
/* harmony export */   "OverlayProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_13__.OverlayProceduralTexture),
/* harmony export */   "Preview3DConfigurationManager": () => (/* reexport safe */ _Components_Preview3D_Preview3DConfigurationManager__WEBPACK_IMPORTED_MODULE_26__.Preview3DConfigurationManager),
/* harmony export */   "ProceduralNormalMap": () => (/* reexport safe */ _Components_NormalMap_ProceduralNormalMap__WEBPACK_IMPORTED_MODULE_21__.ProceduralNormalMap),
/* harmony export */   "SceneActionsExecutor": () => (/* reexport safe */ _Components_ActionExecutor_SceneActionExecutor__WEBPACK_IMPORTED_MODULE_15__.SceneActionsExecutor),
/* harmony export */   "SceneDesignManager": () => (/* reexport safe */ _Components_DesignManagers_SceneDesignManager__WEBPACK_IMPORTED_MODULE_25__.SceneDesignManager),
/* harmony export */   "SceneEditor": () => (/* reexport safe */ _Viewers_SceneEditor__WEBPACK_IMPORTED_MODULE_49__.SceneEditor),
/* harmony export */   "SceneHelper": () => (/* reexport safe */ _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_31__.SceneHelper),
/* harmony export */   "SceneToBlobs": () => (/* reexport safe */ _Components_SceneToBlobs_SceneToBlobs__WEBPACK_IMPORTED_MODULE_32__.SceneToBlobs),
/* harmony export */   "SceneViewer": () => (/* reexport safe */ _Viewers_SceneViewer__WEBPACK_IMPORTED_MODULE_48__.SceneViewer),
/* harmony export */   "SourceTaskStatus": () => (/* reexport safe */ _Viewers_SceneEditor__WEBPACK_IMPORTED_MODULE_49__.SourceTaskStatus),
/* harmony export */   "StringTools": () => (/* reexport safe */ _Misc_StringTools__WEBPACK_IMPORTED_MODULE_44__.StringTools),
/* harmony export */   "Task": () => (/* reexport safe */ _composer_Components_ChunkedTask__WEBPACK_IMPORTED_MODULE_51__.Task),
/* harmony export */   "UsdzHelper": () => (/* reexport safe */ _Components_USDZ_UsdzHelper__WEBPACK_IMPORTED_MODULE_35__.UsdzHelper),
/* harmony export */   "Utils": () => (/* reexport safe */ _Helpers_utils__WEBPACK_IMPORTED_MODULE_37__.Utils),
/* harmony export */   "WorkerPool": () => (/* reexport safe */ _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_46__.WorkerPool),
/* harmony export */   "ZakekeEnvironment": () => (/* reexport safe */ _Enumerations__WEBPACK_IMPORTED_MODULE_5__.ZakekeEnvironment),
/* harmony export */   "debounce": () => (/* reexport safe */ _Helpers_debounce__WEBPACK_IMPORTED_MODULE_36__.debounce)
/* harmony export */ });
/* harmony import */ var _Polyfills_Array_Array_prototype_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Polyfills/Array/Array.prototype.find */ "../../3D/src/Polyfills/Array/Array.prototype.find.js");
/* harmony import */ var _Polyfills_Array_Array_prototype_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Polyfills_Array_Array_prototype_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Polyfills_Array_Array_prototype_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Polyfills/Array/Array.prototype.includes */ "../../3D/src/Polyfills/Array/Array.prototype.includes.js");
/* harmony import */ var _Polyfills_Array_Array_prototype_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Polyfills_Array_Array_prototype_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Polyfills_Array_Array_prototype_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Polyfills/Array/Array.prototype.map */ "../../3D/src/Polyfills/Array/Array.prototype.map.js");
/* harmony import */ var _Polyfills_Array_Array_prototype_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Polyfills_Array_Array_prototype_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Polyfills_String_String_prototype_startsWith__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Polyfills/String/String.prototype.startsWith */ "../../3D/src/Polyfills/String/String.prototype.startsWith.js");
/* harmony import */ var _Polyfills_String_String_prototype_startsWith__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Polyfills_String_String_prototype_startsWith__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Polyfills_String_String_prototype_endsWith__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Polyfills/String/String.prototype.endsWith */ "../../3D/src/Polyfills/String/String.prototype.endsWith.js");
/* harmony import */ var _Polyfills_String_String_prototype_endsWith__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Polyfills_String_String_prototype_endsWith__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Enumerations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Enumerations */ "../../3D/src/Enumerations.ts");
/* harmony import */ var _Components_ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Components/ProceduralTextures/BlurXProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Components/ProceduralTextures/BlurYProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Components/ProceduralTextures/ForegroundBackgroundProceduralTexture */ "../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Components/ProceduralTextures/MoveProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MoveProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Components/ProceduralTextures/MultiplyProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MultiplyProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_NormalMapProceduralTexture__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Components/ProceduralTextures/NormalMapProceduralTexture */ "../../3D/src/Components/ProceduralTextures/NormalMapProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_OpacityProceduralTexture__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Components/ProceduralTextures/OpacityProceduralTexture */ "../../3D/src/Components/ProceduralTextures/OpacityProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Components/ProceduralTextures/OverlayProceduralTexture */ "../../3D/src/Components/ProceduralTextures/OverlayProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_BlendProceduralTexture__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Components/ProceduralTextures/BlendProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlendProceduralTexture.ts");
/* harmony import */ var _Components_ActionExecutor_SceneActionExecutor__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Components/ActionExecutor/SceneActionExecutor */ "../../3D/src/Components/ActionExecutor/SceneActionExecutor.ts");
/* harmony import */ var _Components_CollapseExplode_MeshLocationsManager__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./Components/CollapseExplode/MeshLocationsManager */ "../../3D/src/Components/CollapseExplode/MeshLocationsManager.ts");
/* harmony import */ var _Components_Glow_GlowManager__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Components/Glow/GlowManager */ "../../3D/src/Components/Glow/GlowManager.ts");
/* harmony import */ var _Components_IncrementalFiles_MakeIncremental__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Components/IncrementalFiles/MakeIncremental */ "../../3D/src/Components/IncrementalFiles/MakeIncremental.ts");
/* harmony import */ var _Components_IncrementalFiles_IncrementalFiles__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./Components/IncrementalFiles/IncrementalFiles */ "../../3D/src/Components/IncrementalFiles/IncrementalFiles.ts");
/* harmony import */ var _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./Components/MaterialsPreview/MaterialsPreview */ "../../3D/src/Components/MaterialsPreview/MaterialsPreview.ts");
/* harmony import */ var _Components_NormalMap_ProceduralNormalMap__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./Components/NormalMap/ProceduralNormalMap */ "../../3D/src/Components/NormalMap/ProceduralNormalMap.ts");
/* harmony import */ var _Components_Shadows_InnerShadow__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./Components/Shadows/InnerShadow */ "../../3D/src/Components/Shadows/InnerShadow.ts");
/* harmony import */ var _Components_Shadows_OuterShadow__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./Components/Shadows/OuterShadow */ "../../3D/src/Components/Shadows/OuterShadow.ts");
/* harmony import */ var _Components_DesignManagers_MeshDesignManager__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./Components/DesignManagers/MeshDesignManager */ "../../3D/src/Components/DesignManagers/MeshDesignManager.ts");
/* harmony import */ var _Components_DesignManagers_SceneDesignManager__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./Components/DesignManagers/SceneDesignManager */ "../../3D/src/Components/DesignManagers/SceneDesignManager.ts");
/* harmony import */ var _Components_Preview3D_Preview3DConfigurationManager__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./Components/Preview3D/Preview3DConfigurationManager */ "../../3D/src/Components/Preview3D/Preview3DConfigurationManager.ts");
/* harmony import */ var _Components_Draco_DracoCompression__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./Components/Draco/DracoCompression */ "../../3D/src/Components/Draco/DracoCompression.ts");
/* harmony import */ var _Components_Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./Components/Selector/ElementSelector */ "../../3D/src/Components/Selector/ElementSelector.ts");
/* harmony import */ var _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./Components/Environment/EnvironmentManager */ "../../3D/src/Components/Environment/EnvironmentManager.ts");
/* harmony import */ var _Components_MeshExpander_MeshExpander__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./Components/MeshExpander/MeshExpander */ "../../3D/src/Components/MeshExpander/MeshExpander.ts");
/* harmony import */ var _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./Components/SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
/* harmony import */ var _Components_SceneToBlobs_SceneToBlobs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./Components/SceneToBlobs/SceneToBlobs */ "../../3D/src/Components/SceneToBlobs/SceneToBlobs.ts");
/* harmony import */ var _Components_AR_AndroidAR__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./Components/AR/AndroidAR */ "../../3D/src/Components/AR/AndroidAR.ts");
/* harmony import */ var _Components_InfoPointsManager_InfoPointsManager__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./Components/InfoPointsManager/InfoPointsManager */ "../../3D/src/Components/InfoPointsManager/InfoPointsManager.ts");
/* harmony import */ var _Components_USDZ_UsdzHelper__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./Components/USDZ/UsdzHelper */ "../../3D/src/Components/USDZ/UsdzHelper.ts");
/* harmony import */ var _Helpers_debounce__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./Helpers/debounce */ "../../3D/src/Helpers/debounce.ts");
/* harmony import */ var _Helpers_utils__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./Helpers/utils */ "../../3D/src/Helpers/utils.ts");
/* harmony import */ var _Interfaces_IDisposable__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./Interfaces/IDisposable */ "../../3D/src/Interfaces/IDisposable.ts");
/* harmony import */ var _Interfaces_ISupportInitialize__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./Interfaces/ISupportInitialize */ "../../3D/src/Interfaces/ISupportInitialize.ts");
/* harmony import */ var _Interfaces_ISceneEditor__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./Interfaces/ISceneEditor */ "../../3D/src/Interfaces/ISceneEditor.ts");
/* harmony import */ var _Layers_AxesLayer__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./Layers/AxesLayer */ "../../3D/src/Layers/AxesLayer.ts");
/* harmony import */ var _Layers_LightsLayer__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./Layers/LightsLayer */ "../../3D/src/Layers/LightsLayer.ts");
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
/* harmony import */ var _Misc_StringTools__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./Misc/StringTools */ "../../3D/src/Misc/StringTools.ts");
/* harmony import */ var _Misc_Observable__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./Misc/Observable */ "../../3D/src/Misc/Observable.ts");
/* harmony import */ var _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./Misc/WorkerPool */ "../../3D/src/Misc/WorkerPool.ts");
/* harmony import */ var _Misc_Database__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./Misc/Database */ "../../3D/src/Misc/Database.ts");
/* harmony import */ var _Viewers_SceneViewer__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./Viewers/SceneViewer */ "../../3D/src/Viewers/SceneViewer.ts");
/* harmony import */ var _Viewers_SceneEditor__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./Viewers/SceneEditor */ "../../3D/src/Viewers/SceneEditor.ts");
/* harmony import */ var _Viewers_MaterialEditor__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./Viewers/MaterialEditor */ "../../3D/src/Viewers/MaterialEditor.ts");
/* harmony import */ var _composer_Components_ChunkedTask__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../../composer/Components/ChunkedTask */ "../Components/ChunkedTask.ts");
/// <reference path="../../libs/babylonjs/5.0.0-alpha.57/babylon.d.ts" />
/// <reference path="../../libs/babylonjs/5.0.0-alpha.57/babylonjs.serializers.d.ts" />
/// <reference path="../../libs/babylonjs/5.0.0-alpha.57/babylonjs.loaders.d.ts" />
/// <reference path="../../libs/babylonjs/5.0.0-alpha.57/babylonjs.materials.d.ts" />
/// <reference path="../../libs/babylonjs/5.0.0-alpha.57/babylon.gui.d.ts" />
/// <reference path="../../libs/jszip/jszip.d.ts" />
/// <reference path="./declarations/General/Backbone.Model.d.ts" />
/// <reference path="./declarations/MPlaza/All.d.ts" />
/// <reference path="./declarations/Zakeke/All.d.ts" />







// root


// Components































// helpers



// interfaces




// Layers



// misc






// Viewers




// ChunkedTasks


/***/ }),

/***/ "../Components/ChunkedTask.ts":
/*!************************************!*\
  !*** ../Components/ChunkedTask.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Task": () => (/* binding */ Task)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "../../../node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// ChunckedTask


var Task = /*#__PURE__*/_createClass(function Task(tasksUrl, token) {
  var _this = this;
  var isOwin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  _classCallCheck(this, Task);
  _defineProperty(this, "upload", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file, options) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.uploadFileChunked(file, file.type, Zakeke.generateUUID(), options);
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "uploadFileChunked", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(imageFile, mimeType, fileID, options, progressCallaback) {
      var status, taskID, responseTaskImage;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this.resumableUpload(imageFile, mimeType, fileID, progressCallaback);
          case 2:
            status = _context2.sent;
            if (!(status === 'OK')) {
              _context2.next = 16;
              break;
            }
            _context2.next = 6;
            return _this.createTask(fileID, options);
          case 6:
            taskID = _context2.sent;
            if (!(taskID !== -1)) {
              _context2.next = 15;
              break;
            }
            _context2.next = 10;
            return _this.getResultFromTask(taskID);
          case 10:
            responseTaskImage = _context2.sent;
            if (!responseTaskImage) {
              _context2.next = 13;
              break;
            }
            return _context2.abrupt("return", responseTaskImage.files);
          case 13:
            _context2.next = 16;
            break;
          case 15:
            throw "Upload failed";
          case 16:
            return _context2.abrupt("return", null);
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4, _x5, _x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }());
  _defineProperty(this, "resumableUpload", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(imageFile, mimeType, fileID, progressCallback) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var r = new Resumable({
                target: Zakeke.config.baseApiUrl + "filechunks/upload",
                generateUniqueIdentifier: function generateUniqueIdentifier() {
                  return fileID;
                },
                maxFiles: 1,
                testChunks: false,
                headers: _this.headers,
                query: {
                  'resumableType': mimeType
                },
                simultaneousUploads: 3
              });

              // Adding file
              r.addFile(imageFile);

              // Event Upload handlers
              r.on('fileError', function (file, message) {
                resolve('KO');
                console.error('fileError', file, message);
              });
              r.on('error', function (message, file) {
                resolve('KO');
                console.error('error', message, file);
              });
              r.on('progress', function () {
                var percentage = r.progress() * 100;
                if (progressCallback) progressCallback(percentage);
              });
              r.on('fileAdded', function (file, event) {
                r.upload();
              });
              r.on('complete', function () {
                resolve('OK');
              });
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x8, _x9, _x10, _x11) {
      return _ref3.apply(this, arguments);
    };
  }());
  _defineProperty(this, "createTask", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(fileID, options) {
      var imageTask, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            imageTask = {
              'fileID': fileID,
              'options': options
            };
            _context4.next = 3;
            return axios__WEBPACK_IMPORTED_MODULE_0___default().post(Zakeke.config.baseApiUrl + _this.tasksUrl, imageTask, {
              headers: _this.headers
            });
          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response ? response.data.taskID : -1);
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x12, _x13) {
      return _ref4.apply(this, arguments);
    };
  }());
  _defineProperty(this, "getResultFromTask", /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(taskID) {
      var times, response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            times = 0;
          case 1:
            _context5.prev = 1;
            _context5.next = 4;
            return axios__WEBPACK_IMPORTED_MODULE_0___default().get(Zakeke.config.baseApiUrl + _this.tasksUrl + "/results/" + taskID, {
              headers: _this.headers
            });
          case 4:
            response = _context5.sent;
            if (!(response && response.data.state === 2)) {
              _context5.next = 9;
              break;
            }
            return _context5.abrupt("return", response.data);
          case 9:
            if (!(response && response.data.state === 3)) {
              _context5.next = 11;
              break;
            }
            return _context5.abrupt("return", null);
          case 11:
            _context5.next = 16;
            break;
          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", null);
          case 16:
            times++;
            if (!(times > 200)) {
              _context5.next = 19;
              break;
            }
            return _context5.abrupt("return", null);
          case 19:
            _context5.next = 21;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 1000);
            });
          case 21:
            _context5.next = 1;
            break;
          case 23:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 13]]);
    }));
    return function (_x14) {
      return _ref5.apply(this, arguments);
    };
  }());
  this.tasksUrl = tasksUrl;
  this.token = token;
  if (isOwin) {
    this.headers = {
      'Authorization': 'Bearer ' + this.token,
      "Accept-Language": "en-US"
    };
  } else {
    this.headers = {
      'X-Auth-Token': this.token,
      "Accept-Language": "en-US"
    };
  }
});

/***/ }),

/***/ "./src/api.ts":
/*!********************!*\
  !*** ./src/api.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "axiosApi": () => (/* binding */ axiosApi),
/* harmony export */   "setupApi": () => (/* binding */ setupApi)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers */ "./src/helpers.tsx");



var axiosApi;
function setupApi(culture, token) {
  console.log(Zakeke.config);
  axiosApi = axios__WEBPACK_IMPORTED_MODULE_2__["default"].create({
    baseURL: Zakeke.config.cloudFlareApiUrl || Zakeke.config.baseApiUrl,
    timeout: 120000,
    withCredentials: true,
    headers: {
      "Authorization": "Bearer " + token,
      "Accept-Language": culture
    }
  });
  $.ajaxSetup({
    xhrFields: {
      withCredentials: true
    },
    headers: {
      "Authorization": "Bearer " + token,
      "Accept-Language": culture
    }
  });
  axiosApi.interceptors.response.use(function (response) {
    // Convert all to camelCase
    if (response.data && (lodash__WEBPACK_IMPORTED_MODULE_0___default().isObject(response.data) || lodash__WEBPACK_IMPORTED_MODULE_0___default().isArray(response.data))) response.data = _helpers__WEBPACK_IMPORTED_MODULE_1__.StringHelper.pascalToCamel(response.data);
    return response;
  }, function (error) {
    // Convert all to camelCase
    if (error.response && error.response.data) {
      error.response.data = _helpers__WEBPACK_IMPORTED_MODULE_1__.StringHelper.pascalToCamel(error.response.data);
    }
    return Promise.reject(error);
  });
}

/***/ }),

/***/ "./src/components/customizer.tsx":
/*!***************************************!*\
  !*** ./src/components/customizer.tsx ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeDesigner": () => (/* binding */ ZakekeDesigner)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
/* harmony import */ var _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../hooks/useZakeke */ "./src/hooks/useZakeke.ts");
var _templateObject;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





var ZakekeDesignerContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\toutline: none !important;\n\n\tcanvas {\n\t\toutline: none !important;\n\t}\n"])));
// Persistent mode will keep the SceneEditor alive after unmount.
// You should save the current editor with the ref
var ZakekeDesigner = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function (props, ref) {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState((0,_helpers__WEBPACK_IMPORTED_MODULE_2__.uuid)()),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    guid = _React$useState2[0];
  var _useZakeke = (0,_hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__.useZakeke)(),
    designUpdate = _useZakeke.designUpdate,
    internalProduct = _useZakeke.internalProduct,
    currentTemplate = _useZakeke.currentTemplate,
    internalCurrentTemplate = _useZakeke.internalCurrentTemplate;
  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    customizer = _React$useState4[0],
    setCustomizer = _React$useState4[1];
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var container = document.getElementById('zakeke-designer-container-' + guid);
    var newCustomizer = new MPlaza.Customizer(false, false, null, true);
    newCustomizer.showSideImage = false;
    newCustomizer.addItemChangedListener(handleItemChanged);
    newCustomizer.addItemRemovedListener(handleItemRemoved);

    // Hide DPI warnings
    newCustomizer.setCustomizedMessages([{
      Description: '',
      EventID: MPlaza.EventMessages.DPIWarning,
      Visible: false
    }]);
    newCustomizer.appendTo(container);
    setCustomizer(newCustomizer);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (internalProduct) {
      var side = internalProduct.get('colors').at(0).get('sides').find(function (x) {
        return x.get('sideID') == props.areaId;
      });
      if (side && customizer && internalCurrentTemplate) {
        customizer.model = internalProduct;
        customizer.setDesign(internalCurrentTemplate);
        customizer.setSide(side).then(function () {
          customizer.adaptZoomToSideAreas(false);
        });
      }
    }
  }, [props.areaId, currentTemplate, !!customizer]);
  var handleItemChanged = function handleItemChanged() {
    designUpdate();
  };
  var handleItemRemoved = function handleItemRemoved() {
    designUpdate();
  };
  var zoomIn = function zoomIn() {
    if (customizer) customizer.zoomIn();
  };
  var zoomOut = function zoomOut() {
    if (customizer) customizer.zoomOut();
  };

  // Expose the zoom methods to ref
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, function () {
    return {
      zoomIn: zoomIn,
      zoomOut: zoomOut
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZakekeDesignerContainer, {
    id: 'zakeke-designer-container-' + guid
  });
});

/***/ }),

/***/ "./src/components/sceneViewer.tsx":
/*!****************************************!*\
  !*** ./src/components/sceneViewer.tsx ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeViewer": () => (/* binding */ ZakekeViewer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
/* harmony import */ var _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../hooks/useZakeke */ "./src/hooks/useZakeke.ts");
var _templateObject;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }





var ZakekeViewerContainer = styled_components__WEBPACK_IMPORTED_MODULE_1___default().div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\toutline: none !important;\n\n\tcanvas {\n\t\toutline: none !important;\n\t}\n"])));

// Persistent mode will keep the SceneEditor alive after unmount.
// You should save the current editor with the ref
var ZakekeViewer = function ZakekeViewer(_ref) {
  var className = _ref.className;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState((0,_helpers__WEBPACK_IMPORTED_MODULE_2__.uuid)()),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    guid = _React$useState2[0];
  var _useZakeke = (0,_hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__.useZakeke)(),
    isViewerReady = _useZakeke.isViewerReady,
    internalAppendViewer = _useZakeke.internalAppendViewer;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isViewerReady) internalAppendViewer(document.getElementById('zakeke-viewer-container-' + guid));
  }, [isViewerReady]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZakekeViewerContainer, {
    id: 'zakeke-viewer-container-' + guid,
    className: className
  });
};

/***/ }),

/***/ "./src/environment.tsx":
/*!*****************************!*\
  !*** ./src/environment.tsx ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeEnvironment": () => (/* binding */ ZakekeEnvironment)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! . */ "./src/index.tsx");
/* harmony import */ var _3D_src__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../3D/src */ "../../3D/src/index.ts");
/* harmony import */ var _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased */ "../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx");
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./api */ "./src/api.ts");
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
/* harmony import */ var _fontsManager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./fontsManager */ "./src/fontsManager.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./helpers */ "./src/helpers.tsx");
/* harmony import */ var _imageUploadTask__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./imageUploadTask */ "./src/imageUploadTask.ts");
/* harmony import */ var _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./integrations/Integration */ "./src/integrations/Integration.ts");
/* harmony import */ var _integrations_helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./integrations/helpers */ "./src/integrations/helpers.ts");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./models */ "./src/models.ts");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }












var ZakekeEnvironment = /*#__PURE__*/function () {
  function ZakekeEnvironment() {
    var _this = this;
    _classCallCheck(this, ZakekeEnvironment);
    _defineProperty(this, "platformAttributesSelection", []);
    _defineProperty(this, "previewWidth", 768);
    _defineProperty(this, "previewHeight", 768);
    _defineProperty(this, "clientPreviewWidth", 1024);
    _defineProperty(this, "clientPreviewHeight", 1024);
    _defineProperty(this, "shareUrlPrefix", null);
    _defineProperty(this, "events", []);
    _defineProperty(this, "zkProduct", null);
    _defineProperty(this, "zkScene", null);
    _defineProperty(this, "zkCurrentTemplate", null);
    _defineProperty(this, "zkTemplates", []);
    _defineProperty(this, "internalIsFullscreen", false);
    _defineProperty(this, "highlightSettings", null);
    _defineProperty(this, "previousMeshesVisibleStates", {});
    _defineProperty(this, "lastCameraLocation", null);
    _defineProperty(this, "enableShareCompositionUrl", false);
    _defineProperty(this, "sharedCompositionDocId", null);
    _defineProperty(this, "templateId", null);
    _defineProperty(this, "loadedComposition", null);
    _defineProperty(this, "savedCompositions", null);
    _defineProperty(this, "isDraftEditor", false);
    _defineProperty(this, "isViewerMode", false);
    _defineProperty(this, "isTemplateEditor", false);
    _defineProperty(this, "draftCompositionDocId", null);
    _defineProperty(this, "undoStack", []);
    _defineProperty(this, "redoStack", []);
    _defineProperty(this, "currentAttributesSelection", null);
    _defineProperty(this, "currentCompositionInfo", null);
    _defineProperty(this, "copyrightMessageLocalStorageKey", '');
    _defineProperty(this, "sellerSettings", null);
    _defineProperty(this, "themeCompositions", null);
    _defineProperty(this, "currency", 'EUR');
    _defineProperty(this, "groups", []);
    _defineProperty(this, "fonts", []);
    _defineProperty(this, "disableTextColors", false);
    _defineProperty(this, "textColors", []);
    /**
     * Get the current text default color.
     */
    _defineProperty(this, "defaultColor", '');
    _defineProperty(this, "quantity", 1);
    _defineProperty(this, "quantityRule", null);
    _defineProperty(this, "culture", 'en-US');
    _defineProperty(this, "price", 0);
    _defineProperty(this, "isOutOfStock", false);
    _defineProperty(this, "compositionId", null);
    _defineProperty(this, "templates", []);
    _defineProperty(this, "currentTemplate", null);
    _defineProperty(this, "product", null);
    _defineProperty(this, "templateMacroCategories", null);
    _defineProperty(this, "cameras", []);
    _defineProperty(this, "isExplodedMode", false);
    _defineProperty(this, "isAssetsLoading", false);
    _defineProperty(this, "additionalCustomProperties", []);
    _defineProperty(this, "nftSettings", null);
    _defineProperty(this, "eventMessages", null);
    _defineProperty(this, "visibleEventMessages", []);
    _defineProperty(this, "internalTranslations", {
      statics: [],
      dynamics: []
    });
    _defineProperty(this, "integrationVersion", 1);
    _defineProperty(this, "translations", null);
    _defineProperty(this, "useLegacyScreenshot", false);
    _defineProperty(this, "parseParameters", function (parameters) {
      console.info('Parameters', parameters);
      var parseSingleParameter = function parseSingleParameter(key, value) {
        var _parseInt;
        if (!value) return;
        switch (key) {
          case 'name':
            _this.productName = decodeURIComponent(value.toString().replace(/\+/g, '%20'));
            break;
          case 'ecommerce':
            _this.platform = decodeURIComponent(value);
            break;
          case 'qty':
            _this.quantity = parseFloat(decodeURIComponent(value));
            break;
          case 'culture':
            _this.culture = decodeURIComponent(value);
            break;
          case 'currency':
            _this.currency = decodeURIComponent(value);
            break;
          case 'token':
            _this.token = decodeURIComponent(value);
            break;
          case 'compositionId':
            _this.compositionId = decodeURIComponent(value);
            break;
          case 'modelCode':
            _this.productCode = decodeURIComponent(value.toString().replace(/\+/g, '%20'));
            break;
          case 'previewWidth':
            _this.previewWidth = parseInt(decodeURIComponent(value.toString().replace(/\+/g, '%20')));
            break;
          case 'previewHeight':
            _this.previewHeight = parseInt(decodeURIComponent(value.toString().replace(/\+/g, '%20')));
            break;
          case 'shareUrlPrefix':
            _this.shareUrlPrefix = decodeURIComponent(value.toString().replace(/\+/g, '%20'));
            break;
          case 'sharedCompositionDocId':
            _this.sharedCompositionDocId = decodeURIComponent(value.toString().replace(/\+/g, '%20'));
            break;
          case 'templateId':
            _this.templateId = decodeURIComponent(value.toString().replace(/\+/g, '%20'));
            break;
          case 'isDraftEditor':
            _this.isDraftEditor = true;
            break;
          case 'enableShareCompositionUrl':
            _this.enableShareCompositionUrl = true;
            break;
          case 'draftCompositionDocId':
            _this.draftCompositionDocId = value;
            break;
          case 'viewerMode':
            _this.isViewerMode = true;
            break;
          case 'isTemplateEditor':
            _this.isTemplateEditor = true;
            break;
          case 'legacyScreenshot':
            _this.useLegacyScreenshot = value == '1';
            break;
          case 'integrationVersion':
            _this.integrationVersion = (_parseInt = parseInt(value)) !== null && _parseInt !== void 0 ? _parseInt : 1;
        }
      };

      // From parameters or URL
      if (parameters) {
        for (var _key in parameters) {
          var value = parameters[_key];
          parseSingleParameter(_key, value);

          // Attributes collection
          if (_key.indexOf('attributes') == 0) {
            var _iterator = _createForOfIteratorHelper(value),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var attr = _step.value;
                // For each attribute/option
                _this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__.PlatformAttributeSelection(JSON.stringify(attr[0]), JSON.stringify(attr[1]), '', '', true, true));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }
      } else {
        var queryString = window.location.href.substring(window.location.href.lastIndexOf('?') + 1);
        var pieces = queryString.split('&');
        for (var i = 0; i < pieces.length; i++) {
          var index = pieces[i].indexOf('=');
          if (index == -1) {
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.ParametersParseFailException(pieces[i]);
          }
          var _key2 = decodeURIComponent(pieces[i].substring(0, index));
          var _value = pieces[i].substring(index + 1);
          parseSingleParameter(_key2, _value);

          // Attributes collection
          if (_key2.indexOf('attributes') == 0) {
            var _data = decodeURIComponent(_value.replace(/\+/g, '%20'));
            if (_data && _data != '') {
              var json = JSON.parse(_data);
              var _iterator2 = _createForOfIteratorHelper(json),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var _attr = _step2.value;
                  _this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__.PlatformAttributeSelection(JSON.stringify(_attr[0]), JSON.stringify(_attr[1]), '', '', true, true));
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          }
        }
      }

      // Parameter validation
      var requiredParams = {
        'culture (in xx_XX format)': _this.culture,
        currency: _this.currency,
        'name (product name)': _this.productName,
        ecommerce: _this.platform,
        'qty (product quantity)': _this.quantity,
        token: _this.token,
        modelCode: _this.productCode
      };
      for (var _key3 in requiredParams) {
        if (!requiredParams[_key3]) throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Missing parameter: ' + _key3);
      }
      window['token'] = _this.token;
      window['isOwin'] = true;
      return true;
    });
    // Get product
    _defineProperty(this, "getProduct", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(!_this.productCode || _this.productCode == '')) {
              _context.next = 2;
              break;
            }
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Loading product but no SKU found');
          case 2:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var zkModel = new MPlaza.Model();
              zkModel.set('modelID', 1);
              zkModel.fetch({
                success: function success() {
                  resolve(zkModel);
                },
                error: function error() {
                  reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Failed loading product'));
                },
                data: {
                  c: _this.productCode
                }
              });
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    // Get scene
    _defineProperty(this, "getScene", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(product) {
        var zkScene;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (product) {
                _context2.next = 2;
                break;
              }
              throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Loading scene but no product found');
            case 2:
              if (!(product.get('scenes').length == 0)) {
                _context2.next = 4;
                break;
              }
              throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("The product don't have any scene configured");
            case 4:
              zkScene = new Zakeke.Scene();
              zkScene.set('sceneID', product.get('scenes').at(0).get('sceneID'));
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                zkScene.fetch({
                  success: function success(zkScene) {
                    resolve(zkScene);
                  },
                  error: function error() {
                    reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Failed loading scene'));
                  }
                });
              }));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    // Get composer models
    _defineProperty(this, "getComposerModels", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(!_this.productCode || _this.productCode == '')) {
              _context3.next = 2;
              break;
            }
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Loading product but no SKU found');
          case 2:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var models = new Zakeke.ComposerModels();
              models.set('modelID', 1);
              models.fetch({
                success: function success() {
                  resolve(models);
                },
                error: function error() {
                  reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Failed loading product'));
                },
                data: {
                  c: _this.productCode
                }
              });
            }));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    // Get fonts
    _defineProperty(this, "getFonts", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var _this$zkProduct$get$a, _this$zkProduct;
      var fonts, productFonts;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('fontfamilies/');
          case 2:
            fonts = _context4.sent.data;
            productFonts = (_this$zkProduct$get$a = (_this$zkProduct = _this.zkProduct) === null || _this$zkProduct === void 0 ? void 0 : _this$zkProduct.get('printTypes').at(0).get('fonts').map(function (x) {
              return x.get('fontFamilyID');
            })) !== null && _this$zkProduct$get$a !== void 0 ? _this$zkProduct$get$a : [];
            if (productFonts.length > 0) fonts = fonts.filter(function (font) {
              return productFonts.indexOf(font.fontFamilyID) != -1;
            });
            return _context4.abrupt("return", fonts);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    // Get settings
    _defineProperty(this, "getSettings", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var settings;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('customizerinfo/');
          case 2:
            settings = _context5.sent.data;
            return _context5.abrupt("return", settings);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })));
    _defineProperty(this, "getSellerSetting", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(resolve, reject) {
                var sellerSetting;
                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('sellerSetting/');
                    case 2:
                      sellerSetting = _context6.sent.data;
                      resolve(sellerSetting);
                    case 4:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return function (_x2, _x3) {
                return _ref7.apply(this, arguments);
              };
            }()));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    })));
    // Create quote for composition
    _defineProperty(this, "createQuote", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(formData) {
        var _name;
        var quote, quoteCreated;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              quote = new _models__WEBPACK_IMPORTED_MODULE_11__.Quote();
              quote.formData = JSON.stringify(formData);
              quote.quantity = _this.quantity;
              quote.compositionDocID = _this.composition.get('docID');
              _context8.next = 6;
              return _this.getPrice();
            case 6:
              quote.modelPrice = _context8.sent.price;
              quote.variantName = (_name = _this.product.name) !== null && _name !== void 0 ? _name : '';
              _context8.next = 10;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'quotes', quote);
            case 10:
              quoteCreated = _context8.sent.data;
              return _context8.abrupt("return", quoteCreated);
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      return function (_x4) {
        return _ref8.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getPrice", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var price, isOutOfStock, result, objectResult;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            price = 0;
            isOutOfStock = false;
            console.log('Get price from store (integration version ' + _this.integrationVersion + ')...');
            _context9.next = 5;
            return _this.integration.getPrice(_this.composition, _this.zkCurrentTemplate, _this.zkProduct, _this.platformAttributesSelection, _this.composition.getPrice(_this.zkProduct, _this.quantity), _this.settings.additionalFeatures.prices3dConfigurator, _this.settings.isPricingAdvancedEnabled, _this.quantity, 0);
          case 5:
            result = _context9.sent;
            if (_this.integrationVersion === 1) {
              price = result;
            } else if (_this.integrationVersion === 2) {
              objectResult = result;
              price = objectResult.price;
              isOutOfStock = objectResult.isOutOfStock;
            }
            console.log('Price from store: ' + price);
            return _context9.abrupt("return", {
              price: price,
              isOutOfStock: isOutOfStock
            });
          case 9:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    })));
    _defineProperty(this, "getTranslations", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var response;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('sellerLocalizations/customizer-localizations');
          case 3:
            response = _context10.sent;
            if (!response) {
              _context10.next = 8;
              break;
            }
            return _context10.abrupt("return", response.data);
          case 8:
            console.log('getTranslations response is empty');
          case 9:
            _context10.next = 14;
            break;
          case 11:
            _context10.prev = 11;
            _context10.t0 = _context10["catch"](0);
            console.error(_context10.t0);
          case 14:
          case "end":
            return _context10.stop();
        }
      }, _callee10, null, [[0, 11]]);
    })));
    _defineProperty(this, "loadLocalization", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
      var lang;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            lang = _this.culture; // Try zh-TW
            if (Zakeke.config.avaibleLanguages.indexOf(lang) == -1) lang = _this.culture.substring(0, 2);

            // Try zh
            if (Zakeke.config.avaibleLanguages.lastIndexOf(lang) == -1) lang = 'en';
            _context11.next = 5;
            return _this.loadScript(Zakeke.config.baseUrl + "Scripts/localizations/".concat(lang.toLowerCase(), "/composer.js"));
          case 5:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    })));
    _defineProperty(this, "getTemplateMacroCategories", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var response, categories;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('compositionmacrocategories');
          case 2:
            response = _context12.sent;
            categories = response.data.map(function (macroCategory) {
              var allCategories = macroCategory.category.map(function (category) {
                return {
                  categoryName: category.name,
                  categoryID: category.categoryID
                };
              });
              return {
                macroCategoryName: macroCategory.name,
                macroCategoryID: macroCategory.macroCategoryID,
                categories: allCategories
              };
            });
            return _context12.abrupt("return", categories);
          case 5:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    })));
    _defineProperty(this, "loadScript", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(src) {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.onload = resolve;
                script.src = src;
                document.body.appendChild(script);
              }));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return function (_x5) {
        return _ref13.apply(this, arguments);
      };
    }());
    _defineProperty(this, "validationNFTEmail", function (email) {
      var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return EMAIL_REGEX.test(email);
    });
    _defineProperty(this, "validationNFTWalletAddress", function (address) {
      var NFT_WALLET_ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
      return NFT_WALLET_ADDRESS_REGEX.test(address);
    });
    _defineProperty(this, "saveCustomerWalletInfo", /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(docID, email, walletAddress) {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'customerwalletdocs', {
                email: email,
                walletAddress: walletAddress,
                zakekeEnvironment: 2,
                //configurator
                compositionDocID: docID
              });
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      return function (_x6, _x7, _x8) {
        return _ref14.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setCopyrightMessageAccepted", function (copyrightMandatoryCheckbox) {
      try {
        if (copyrightMandatoryCheckbox) window.localStorage.setItem(_this.copyrightMessageLocalStorageKey, copyrightMandatoryCheckbox.toString());else window.localStorage.removeItem(_this.copyrightMessageLocalStorageKey);
      } catch (e) {}
    });
    _defineProperty(this, "getCopyrightMessageAccepted", function () {
      var copyrightMessageAccepted = false;
      try {
        copyrightMessageAccepted = window.localStorage.getItem(_this.copyrightMessageLocalStorageKey) ? true : false;
      } catch (e) {}
      return copyrightMessageAccepted;
    });
    /**
     * @private
     */
    _defineProperty(this, "boot", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(parameters) {
        var composerModels, promises;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _this.parseParameters(parameters);
              (0,_api__WEBPACK_IMPORTED_MODULE_4__.setupApi)(_this.culture, _this.token);
              _context15.next = 4;
              return _this.loadLocalization();
            case 4:
              _this.trigger('change');
              _context15.next = 7;
              return _this.getComposerModels();
            case 7:
              composerModels = _context15.sent;
              _this.zkScene = composerModels.get('scene');
              _this.zkProduct = composerModels.get('model');
              _this.product = _models__WEBPACK_IMPORTED_MODULE_11__.Product.fromProduct(_this.zkProduct);
              _this.quantityRule = _this.zkProduct.get('quantityRule') ? _models__WEBPACK_IMPORTED_MODULE_11__.ProductQuantityRule.fromQuantityRule(_this.zkProduct.get('quantityRule')) : null;
              promises = [_this.getSettings(), _this.getTranslations(), (0,_integrations_helpers__WEBPACK_IMPORTED_MODULE_10__.integrationFor)(_this.platform), _this.getSellerSetting(), _this.getTemplateMacroCategories(), _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__.DesignPriceCalculatorRuleFactory.create(_this.zkProduct, Zakeke.config.baseApiUrl, _this.token, true, Zakeke.config.cloudFlareApiUrl), _this.getFonts(), _this.getTemplates()];
              _context15.next = 15;
              return Promise.all(promises).then(function (_ref16) {
                var _this$zkScene$get$map, _this$zkScene;
                var _ref17 = _slicedToArray(_ref16, 8),
                  customizerInfo = _ref17[0],
                  translations = _ref17[1],
                  integration = _ref17[2],
                  sellerSettings = _ref17[3],
                  templateMacroCategories = _ref17[4],
                  pricingCalculator = _ref17[5],
                  fonts = _ref17[6],
                  zkTemplates = _ref17[7];
                _this.settings = customizerInfo;
                _this.copyrightMessageLocalStorageKey = _this.settings.userID + '_copyright_accepted';
                _this.eventMessages = _this.settings.eventMessages.map(function (message) {
                  return ___WEBPACK_IMPORTED_MODULE_1__.EventMessage.fromMessage(message);
                });
                _this.nftSettings = _this.settings.nftSettings;
                _this.translations = translations;
                var staticTranslations = new Map(_this.internalTranslations.statics.map(function (staticTranslation) {
                  return [staticTranslation.original, staticTranslation.localization];
                }));
                var dynamicTranslations = new Map(_this.internalTranslations.dynamics.map(function (staticTranslation) {
                  return [staticTranslation.original, staticTranslation.localization];
                }));
                _this.translations = {
                  statics: staticTranslations,
                  dynamics: dynamicTranslations
                };
                _helpers__WEBPACK_IMPORTED_MODULE_7__.T.translations = _this.translations;
                _this.integration = integration;
                _this.sellerSettings = sellerSettings ? _models__WEBPACK_IMPORTED_MODULE_11__.SellerSettings.fromSellerSettings(sellerSettings) : null;
                _this.templateMacroCategories = templateMacroCategories;
                _this.pricingCalculator = pricingCalculator;
                _this.pricingCalculator.colorID = _this.zkProduct.get('colors').at(0).get('colorID');
                _this.integration.setPricingCalculator(_this.pricingCalculator);
                _this.fonts = fonts;
                _this.defaultColor = _this.getDefaultColor();
                _this.disableTextColors = _this.getDisableTextColors();
                _this.textColors = _this.getTextColors();
                _this.zkTemplates = zkTemplates;
                _this.templates = _this.zkTemplates.map(function (zkTemplate) {
                  return _models__WEBPACK_IMPORTED_MODULE_11__.Template.fromTemplate(zkTemplate);
                });
                _this.cameras = (_this$zkScene$get$map = (_this$zkScene = _this.zkScene) === null || _this$zkScene === void 0 ? void 0 : _this$zkScene.get('cameraLocations').map(function (x) {
                  return _models__WEBPACK_IMPORTED_MODULE_11__.Camera.fromZkCamera(x);
                })) !== null && _this$zkScene$get$map !== void 0 ? _this$zkScene$get$map : [];
              });
            case 15:
              if (_this.zkScene) {
                _context15.next = 17;
                break;
              }
              throw new Error('Product has no 3D scene.');
            case 17:
              _this.trigger('change');
              _context15.next = 20;
              return _3D_src__WEBPACK_IMPORTED_MODULE_2__.SceneViewer.createSceneViewerAsync();
            case 20:
              _this.viewer = _context15.sent;
              _this.viewer.isHologramSource = true;
              _this.viewer.addBeginAssetsLoadingListener(function () {
                _this.isAssetsLoading = true;
                _this.trigger('change');
              });
              _this.viewer.addEndAssetsLoadingListener(function () {
                _this.isAssetsLoading = false;
                _this.trigger('change');
              });
              if (_this.highlightSettings) {
                _this.viewer.highlightColor = _this.highlightSettings.color;
                _this.viewer.highlightSize = _this.highlightSettings.size;
              }
              _this.viewer.setLoadingScreen({
                displayLoadingUI: function displayLoadingUI() {
                  return null;
                },
                hideLoadingUI: function hideLoadingUI() {
                  return null;
                },
                loadingUIBackgroundColor: 'black',
                loadingUIText: 'black'
              });
              _this.viewer.infoPointsManagerStyle = {
                imagePanelStyle: {
                  backgroundColor: 'white',
                  loadingTextColor: '#cccccc',
                  buttonsBorderColor: '#dddddd',
                  buttonsBorderHighlightColor: '#eeeeee',
                  buttonsColor: '#888888',
                  buttonsHighlightColor: '#555555',
                  buttonsIconColor: 'white'
                }
              };

              // Set transparent background
              _this.zkScene.getOrCreateEnvironmentConfig().set('mainColor', '#000000');
              _this.zkScene.getOrCreateGeneralConfig().set('backgroundColor', '#000000');
              _this.zkScene.getOrCreateGeneralConfig().set('backgroundAlpha', 0);

              // Pricing calculator
              _context15.next = 32;
              return _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__.DesignPriceCalculatorRuleFactory.create(_this.zkProduct, Zakeke.config.baseApiUrl, _this.token, true, Zakeke.config.cloudFlareApiUrl);
            case 32:
              _this.pricingCalculator = _context15.sent;
              _context15.next = 35;
              return _this.viewer.loadSceneFromModelAsync(_this.zkProduct, _this.zkScene);
            case 35:
              _this.trigger('change');
              _context15.next = 38;
              return _this.handleSceneLoaded();
            case 38:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      return function (_x9) {
        return _ref15.apply(this, arguments);
      };
    }());
    _defineProperty(this, "appendViewer", function (container) {
      if (_this.viewer) _this.viewer.appendTo(container);
    });
    _defineProperty(this, "setHighlightSettings", function (settings) {
      _this.highlightSettings = settings;
      if (_this.viewer) {
        _this.viewer.highlightColor = settings.color;
        _this.viewer.highlightSize = settings.size;
      }
    });
    /*public renderDesign = _.throttle(async () => {
    	if (this.viewer && this.zkCurrentTemplate) {
    		await this.viewer.renderDesignAsync(this.zkCurrentTemplate);
    		this.fireItemsChange();
    	}
    }, 300);*/
    _defineProperty(this, "renderDesign", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            if (!(_this.viewer && _this.zkCurrentTemplate)) {
              _context16.next = 4;
              break;
            }
            _context16.next = 3;
            return _this.viewer.renderDesignAsync(_this.zkCurrentTemplate);
          case 3:
            _this.debouncedChange();
          case 4:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    })));
    _defineProperty(this, "debouncedChange", (0,lodash__WEBPACK_IMPORTED_MODULE_0__.debounce)(function () {
      return _this.trigger('change');
    }, 300));
    _defineProperty(this, "resize", function () {
      if (!_this.viewer) return;

      //this.viewer.updateView(false);

      // Restore last camera locazione
      if (_this.lastCameraLocation && _this.lastCameraLocation !== Zakeke.getEmptyUUID()) {
        console.log('Restoring last camera location ' + _this.lastCameraLocation + ' ...');
        _this.setCamera(_this.lastCameraLocation, false, false);
      } else {
        _this.viewer.adjustCamera(false);
      }
    });
    _defineProperty(this, "buildRecapProps", lodash__WEBPACK_IMPORTED_MODULE_0___default().debounce(function (selectedOptions) {
      if (!_this.sellerSettings || !_this.sellerSettings.isCompositionRecapEnabled) return;
      var storeAttr = _this.zkProduct.get('attributes');
      var storeGroups = _this.zkProduct.get('attributeGroups');
      var storeSteps = _this.zkProduct.get('attributeSteps');
      var recapProps = {};
      selectedOptions.forEach(function (item) {
        var _this$selection;
        var currentAttr = storeAttr.find(function (attr) {
          return attr.get('attributeID') == item.attributeID;
        });
        var currentOption = currentAttr.get('options').find(function (opt) {
          return opt.get('optionID') == item.optionID;
        });
        var currentGroup = storeGroups.find(function (group) {
          return group.get('groupID') == currentAttr.get('groupID');
        });
        var currentStep = storeSteps.find(function (step) {
          return step.get('stepID') == currentAttr.get('stepID');
        });
        var label = '';
        var isOptionEnabled = false;
        (_this$selection = _this.selection) === null || _this$selection === void 0 ? void 0 : _this$selection.get('groups').each(function (group) {
          group.get('attributes').each(function (attr) {
            var option = attr.get('options').find(function (x) {
              return x.get('optionID') == currentOption.get('optionID');
            });
            if (option && attr.get('enabled')) {
              var _currentGroup$get, _currentStep$get, _currentAttr$get, _currentOption$get;
              isOptionEnabled = _this.isOptionEnabled(currentOption.get('optionID'));
              label = group.get('groupID') !== -1 ? _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(group.get('name')) + ' ' + _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentAttr.get('name')) : _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentAttr.get('name'));
              recapProps["".concat(label)] = {
                groupDisplayOrder: (_currentGroup$get = currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.get('displayOrder')) !== null && _currentGroup$get !== void 0 ? _currentGroup$get : 0,
                stepDisplayOrder: (_currentStep$get = currentStep === null || currentStep === void 0 ? void 0 : currentStep.get('displayOrder')) !== null && _currentStep$get !== void 0 ? _currentStep$get : 0,
                attributeDisplayOrder: (_currentAttr$get = currentAttr === null || currentAttr === void 0 ? void 0 : currentAttr.get('displayOrder')) !== null && _currentAttr$get !== void 0 ? _currentAttr$get : 0,
                optionDisplayOrder: (_currentOption$get = currentOption === null || currentOption === void 0 ? void 0 : currentOption.get('displayOrder')) !== null && _currentOption$get !== void 0 ? _currentOption$get : 0,
                value: _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentOption.get('name'))
              };
            }
          });
        });
      });
      _this.currentAttributesSelection = recapProps;
    }, 200));
    _defineProperty(this, "updateRecapAndAdditionalCustomProperties", function () {
      var _this$selection2;
      var selectedOptions = [];
      (_this$selection2 = _this.selection) === null || _this$selection2 === void 0 ? void 0 : _this$selection2.getAllAttributeSelections().forEach(function (attribute) {
        attribute.get('options').forEach(function (option) {
          if (option.get('selected')) {
            selectedOptions.push({
              attributeID: option.get('attributeID'),
              optionID: option.get('optionID')
            });
          }
        });
      });
      _this.getCurrentExtensionFields(selectedOptions);
      _this.buildRecapProps(selectedOptions);
      _this.trigger('change');
    });
    _defineProperty(this, "getCurrentExtensionFields", function (options) {
      var propsValues = [];
      var propsMap = {};
      var storeAttr = _this.zkProduct.get('attributes');
      options.forEach(function (item) {
        var currentAttr = storeAttr.find(function (attr) {
          return attr.get('attributeID') == item.attributeID;
        });
        var currentOption = currentAttr.get('options').find(function (opt) {
          return opt.get('optionID') == item.optionID;
        });
        if (currentOption.get('extensionFields').length) {
          currentOption.get('extensionFields').forEach(function (item) {
            if (propsValues.length === 0 || propsValues.indexOf(item.name) == -1) {
              propsValues.push(item.name);
              propsMap[item.name] = {
                value: 0,
                label: item.label,
                formatString: item.formatString
              };
            }
            var val;
            if (item.dataTypeID === _models__WEBPACK_IMPORTED_MODULE_11__.AdditionalCustomPropertyDataType.Integer) {
              val = parseInt(item.value);
            } else {
              val = parseFloat(item.value);
            }
            propsMap[item.name].value += val;
          });
        }
      });
      var itemsArray = Object.keys(propsMap).map(function (key) {
        return propsMap[key];
      });
      _this.additionalCustomProperties = itemsArray;
    });
    _defineProperty(this, "handleSceneLoaded", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
      var currentCompositionId, _this$sellerSettings, _this$sellerSettings2;
      return _regeneratorRuntime().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            window.addEventListener('resize', _this.resize);
            console.log('Scene loaded');
            _this.selection = Zakeke.ComposerSelection.CreateComposerSelection(_this.zkProduct);
            currentCompositionId = _this.templateId || _this.draftCompositionDocId || _this.sharedCompositionDocId || _this.compositionId;
            if (_this.initialSelection == undefined) {
              _this.initialSelection = _this.cloneSelection(_this.selection);
            }
            _context17.next = 7;
            return _this.internalLoadComposition(currentCompositionId);
          case 7:
            _this.trigger('change');
            _this.buildStructure();

            // Trigger quantity update
            _this.setQuantity(_this.quantity);
            _this.renderDesign();
            _this.viewer.addNotifyMessageListener(function (areaID, itemGuid, type, title, message, closable, requiredWidth, requiredHeight) {
              _this.visibleEventMessages.push({
                areaID: areaID,
                itemGuid: itemGuid,
                type: type,
                title: title,
                message: message,
                closable: closable,
                requiredWidth: requiredWidth,
                requiredHeight: requiredHeight
              });
              _this.trigger('change');
            });
            _this.viewer.addRemoveMessageListener(function (areaID, itemGuid) {
              _this.visibleEventMessages = _this.visibleEventMessages.filter(function (x) {
                return x.areaID !== areaID && x.itemGuid !== itemGuid;
              });
              _this.trigger('change');
            });
            _this.viewer.setEventMessages(_this.settings.eventMessages.map(function (x) {
              return {
                AddToCartDisabledIfVisible: x.addToCartDisabledIfVisible,
                AdditionalData: x.additionalData,
                Closeable: x.closeable,
                Description: x.description,
                EnableCheckForSellerImages: x.enableCheckForSellerImages,
                EventID: x.eventID,
                Visible: x.visible
              };
            }));
            if (_this.sellerSettings) {
              _this.addHotjarScript((_this$sellerSettings = _this.sellerSettings) === null || _this$sellerSettings === void 0 ? void 0 : _this$sellerSettings.hotjarSiteID);
              _this.addGoogleTagManagerID((_this$sellerSettings2 = _this.sellerSettings) === null || _this$sellerSettings2 === void 0 ? void 0 : _this$sellerSettings2.googleTagManagerID);
            }
            if (_this.sharedCompositionDocId) {
              _this.composition.set('docID', null);
              _this.composition.set('designDocID', null);
            }
            _this.registerView();
            if (_this.isTemplateEditor) {
              _context17.next = 20;
              break;
            }
            _context17.next = 20;
            return _this.updateSavedCompositions();
          case 20:
            setTimeout(function () {
              return _this.updateRecapAndAdditionalCustomProperties();
            }, 1000);
          case 21:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    })));
    _defineProperty(this, "getComposition", /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(id) {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", new Promise(function (resolve, reject) {
                var composition = new MPlaza.Composition();
                composition.set('docID', id);
                composition.fetch({
                  success: function success(model) {
                    resolve(model);
                  },
                  error: function error() {
                    reject();
                  },
                  data: {
                    frombackoffice: _this.isDraftEditor ? true : false
                  }
                });
              }));
            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
      return function (_x10) {
        return _ref20.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getDesign", /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(id) {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", new Promise(function (resolve, reject) {
                var design = new MPlaza.Design();
                design.set('docID', id);
                design.fetch({
                  success: function success(model) {
                    resolve(model);
                  },
                  error: function error() {
                    reject();
                  },
                  data: {
                    frombackoffice: _this.isDraftEditor ? true : false
                  }
                });
                design.addEventListener('change', _this.updatePrice);
              }));
            case 1:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      return function (_x11) {
        return _ref21.apply(this, arguments);
      };
    }());
    _defineProperty(this, "internalLoadDesign", /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(id) {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return _this.getDesign(_this.composition.get('designDocID'));
            case 2:
              _this.zkCurrentTemplate = _context20.sent;
              _context20.next = 5;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.downloadFontsOfDesign)(_this.zkCurrentTemplate, _this.fonts);
            case 5:
              _this.renderDesign();
            case 6:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x12) {
        return _ref22.apply(this, arguments);
      };
    }());
    _defineProperty(this, "loadComposition", /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(id) {
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return _this.internalLoadComposition(id);
            case 2:
              _this.buildStructure();
            case 3:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      }));
      return function (_x13) {
        return _ref23.apply(this, arguments);
      };
    }());
    _defineProperty(this, "internalLoadComposition", /*#__PURE__*/function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(id) {
        var _iterator3, _step3, _loop;
        return _regeneratorRuntime().wrap(function _callee22$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              if (!id) {
                _context23.next = 14;
                break;
              }
              _context23.next = 3;
              return _this.getComposition(id);
            case 3:
              _this.composition = _context23.sent;
              if (_this.templateId) {
                _this.loadedComposition = {
                  templateName: _this.composition.get('name'),
                  attributesOptions: _this.composition.get('compositionItems').map(function (compositionItem) {
                    return {
                      attributeID: compositionItem.get('attributeID'),
                      optionID: compositionItem.get('selectedOptionID')
                    };
                  }),
                  selectedCategoryID: _this.composition.get('categories').length > 0 ? _this.composition.get('categories').at(0).get('categoryID') : null
                };
              }
              _this.selection.setupOnComposition(_this.composition);
              if (!_this.composition.get('designDocID')) {
                _context23.next = 11;
                break;
              }
              _context23.next = 9;
              return _this.internalLoadDesign(_this.composition.get('designDocID'));
            case 9:
              _context23.next = 12;
              break;
            case 11:
              if (_this.templates.length > 0) {
                _this.setTemplate(_this.templates[0].id);
              }
            case 12:
              _context23.next = 32;
              break;
            case 14:
              _this.composition = _this.selection.buildComposition();
              // Select initial values from platform
              _iterator3 = _createForOfIteratorHelper(_this.platformAttributesSelection);
              _context23.prev = 16;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var platformSelection;
                return _regeneratorRuntime().wrap(function _loop$(_context22) {
                  while (1) switch (_context22.prev = _context22.next) {
                    case 0:
                      platformSelection = _step3.value;
                      // Search the attribute
                      _this.zkProduct.get('attributes').each(function (attribute) {
                        if ((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(attribute.get('attributeCode'))) {
                          try {
                            if ((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.compare)(JSON.parse(attribute.get('attributeCode')), JSON.parse(platformSelection.attributeCode))) {
                              var option = attribute.get('options').find(function (option) {
                                return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.compare)(JSON.parse(option.get('optionCode')), JSON.parse(platformSelection.optionCode));
                              });
                              if (option) {
                                _this.selection.selectAttributeValue(attribute.get('attributeID'), option.get('optionID').toString());

                                // Update here the labels because events are not attached yet (attached below)
                                platformSelection.attributeLabel = attribute.get('name');
                                platformSelection.optionLabel = option.get('name');
                              }
                            }
                          } catch (ex) {
                            console.error('Failed parsing attribute from data:', platformSelection);
                            console.error(ex);
                          }
                        }
                      });
                    case 2:
                    case "end":
                      return _context22.stop();
                  }
                }, _loop);
              });
              _iterator3.s();
            case 19:
              if ((_step3 = _iterator3.n()).done) {
                _context23.next = 23;
                break;
              }
              return _context23.delegateYield(_loop(), "t0", 21);
            case 21:
              _context23.next = 19;
              break;
            case 23:
              _context23.next = 28;
              break;
            case 25:
              _context23.prev = 25;
              _context23.t1 = _context23["catch"](16);
              _iterator3.e(_context23.t1);
            case 28:
              _context23.prev = 28;
              _iterator3.f();
              return _context23.finish(28);
            case 31:
              if (_this.templates.length > 0) _this.setTemplate(_this.templates[0].id);
            case 32:
              _context23.next = 34;
              return _this.sync3DAndPlatformSelectionWithCurrentSelection();
            case 34:
              _this.updateComposition();
              _this.updateRecapAndAdditionalCustomProperties();
            case 36:
            case "end":
              return _context23.stop();
          }
        }, _callee22, null, [[16, 25, 28, 31]]);
      }));
      return function (_x14) {
        return _ref24.apply(this, arguments);
      };
    }());
    _defineProperty(this, "sync3DAndPlatformSelectionWithCurrentSelection", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
      var script;
      return _regeneratorRuntime().wrap(function _callee23$(_context24) {
        while (1) switch (_context24.prev = _context24.next) {
          case 0:
            // Add all composition attributes to the platformAttributes that we will send to the plugin
            _this.selection.get('groups').each(function (group) {
              group.get('attributes').each(function (attribute) {
                // Here we check if this attributes was already passed from the parameters.
                // If yes, we ignore it because the correct value was already selected in the previous rows.
                // else we add it to the list of attributes selections

                var oldAttribute = _this.platformAttributesSelection.find(function (x) {
                  return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attribute.get('attributeCode'));
                });
                if (!oldAttribute) {
                  var selectedOption = attribute.get('options').findWhere({
                    selected: true
                  });
                  if (selectedOption) _this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_9__.PlatformAttributeSelection(attribute.get('attributeCode'), selectedOption.get('optionCode'), attribute.get('name'), selectedOption.get('name'), attribute.get('enabled'), selectedOption.get('enabled')));
                }
              });
            });
            script = _this.selection.getAllAttributeTransformationScript();
            _this.viewer.adjustCamera(false);
            _context24.next = 5;
            return _this.viewer.executeScriptAsync(script);
          case 5:
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
          case 10:
          case "end":
            return _context24.stop();
        }
      }, _callee23);
    })));
    _defineProperty(this, "cloneSelection", function (selection) {
      var clone = new Zakeke.ComposerSelection();
      clone.set('zkModel', _this.zkProduct);
      clone.set('attributeDependencies', selection.get('attributeDependencies'));
      clone.set('optionDependencies', selection.get('optionDependencies'));
      clone.get('groups').reset();
      selection.get('groups').each(function (group) {
        var cloneGroup = new Zakeke.AttributeGroupSelection();
        for (var _key4 in group.attributes) {
          cloneGroup.set(_key4, group.attributes[_key4]);
        }
        clone.get('groups').add(cloneGroup);
      });
      var idx = 0;
      clone.get('groups').each(function (group) {
        group.set('attributes', selection.get('groups').at(idx).get('attributes').clone());
        group.get('attributes').reset();
        selection.get('groups').at(idx).get('attributes').each(function (attribute) {
          var cloneAttribute = new Zakeke.AttributeSelection();
          for (var _key5 in attribute.attributes) {
            cloneAttribute.set(_key5, attribute.attributes[_key5]);
          }
          group.get('attributes').add(cloneAttribute);
        });
        var idx2 = 0;
        group.get('attributes').each(function (attribute) {
          attribute.set('options', selection.get('groups').at(idx).get('attributes').at(idx2).get('options').clone());
          attribute.get('options').reset();
          selection.get('groups').at(idx).get('attributes').at(idx2).get('options').each(function (option) {
            var cloneOption = new Zakeke.OptionSelection();
            for (var _key6 in option.attributes) {
              cloneOption.set(_key6, option.attributes[_key6]);
            }
            attribute.get('options').add(cloneOption);
          });
          idx2++;
        });
        idx++;
      });
      return clone;
    });
    _defineProperty(this, "undo", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
      var selection, script;
      return _regeneratorRuntime().wrap(function _callee24$(_context25) {
        while (1) switch (_context25.prev = _context25.next) {
          case 0:
            selection = _this.undoStack && _this.undoStack.length > 0 ? _this.undoStack.pop() : null;
            if (selection) {
              _context25.next = 3;
              break;
            }
            return _context25.abrupt("return");
          case 3:
            _this.redoStack.push(_this.selection);
            _this.selection = selection;
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            _this.selection.attachEvents();
            script = _this.selection.getAllAttributeTransformationScript();
            _context25.next = 14;
            return _this.viewer.executeScriptAsync(script);
          case 14:
            _this.buildStructure();
            _this.updateComposition();
            _this.updateRecapAndAdditionalCustomProperties();
          case 17:
          case "end":
            return _context25.stop();
        }
      }, _callee24);
    })));
    _defineProperty(this, "redo", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
      var selection, script;
      return _regeneratorRuntime().wrap(function _callee25$(_context26) {
        while (1) switch (_context26.prev = _context26.next) {
          case 0:
            selection = _this.redoStack && _this.redoStack.length > 0 ? _this.redoStack.pop() : null;
            if (selection) {
              _context26.next = 3;
              break;
            }
            return _context26.abrupt("return");
          case 3:
            _this.undoStack.push(_this.selection);
            _this.selection = selection;
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            _this.selection.attachEvents();
            script = _this.selection.getAllAttributeTransformationScript();
            _context26.next = 14;
            return _this.viewer.executeScriptAsync(script);
          case 14:
            _this.buildStructure();
            _this.updateComposition();
            _this.updateRecapAndAdditionalCustomProperties();
          case 17:
          case "end":
            return _context26.stop();
        }
      }, _callee25);
    })));
    _defineProperty(this, "reset", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
      var script;
      return _regeneratorRuntime().wrap(function _callee26$(_context27) {
        while (1) switch (_context27.prev = _context27.next) {
          case 0:
            if (_this.initialSelection) {
              _context27.next = 2;
              break;
            }
            return _context27.abrupt("return");
          case 2:
            _this.undoStack = [];
            _this.redoStack = [];
            _this.selection = _this.cloneSelection(_this.initialSelection);
            _this.selection.attachEvents();
            _this.selection.on('attributeSelectionChanged', function (e) {
              _this.handleAttributeSelectionChanged(e);
            });
            _this.selection.on('attributeEnabled', function (e) {
              _this.handleAttributeEnabled(e.attributeID);
            });
            _this.selection.on('attributeDisabled', function (e) {
              _this.handleAttributeDisabled(e.attributeID);
            });
            _this.selection.on('attributeOptionEnabled', function (e) {
              _this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            _this.selection.on('attributeOptionDisabled', function (e) {
              _this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            script = _this.selection.getAllAttributeTransformationScript();
            _context27.next = 14;
            return _this.viewer.executeScriptAsync(script);
          case 14:
            _this.buildStructure();
            _this.updateComposition();
            _this.updateRecapAndAdditionalCustomProperties();
          case 17:
          case "end":
            return _context27.stop();
        }
      }, _callee26);
    })));
    _defineProperty(this, "handleAttributeSelectionChanged", /*#__PURE__*/function () {
      var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(e) {
        var attribute, option, platformSelection;
        return _regeneratorRuntime().wrap(function _callee27$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.next = 2;
              return _this.viewer.executeActionsAsync(e.attributeID, e.selectedValue, e.actions);
            case 2:
              _this.updateComposition();
              attribute = _this.zkProduct.get('attributes').find(function (attribute) {
                return attribute.get('attributeID') == e.attributeID;
              });
              if (attribute) {
                option = attribute.get('options').find(function (option) {
                  return option.get('optionID') == e.selectedValue;
                });
                if (option) {
                  // Change platform selection
                  platformSelection = _this.platformAttributesSelection.find(function (x) {
                    return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attribute.get('attributeCode'));
                  });
                  if (platformSelection) {
                    platformSelection.optionCode = option.get('optionCode');
                    platformSelection.optionLabel = option.get('name');
                  }
                  _this.setOptionSelectionEnabled(attribute.get('attributeID'), option.get('optionID'), _this.isOptionEnabled(option.get('optionID')));
                }
              }
              _this.buildStructure();
              _this.renderDesign();
            case 7:
            case "end":
              return _context28.stop();
          }
        }, _callee27);
      }));
      return function (_x15) {
        return _ref29.apply(this, arguments);
      };
    }());
    _defineProperty(this, "handleAttributeEnabled", function (attributeId) {
      _this.updateComposition();
      _this.setAttributeSelectionEnabled(attributeId, true);
      _this.buildStructure();
      _this.renderDesign();
    });
    _defineProperty(this, "handleAttributeDisabled", function (attributeId) {
      _this.updateComposition();
      _this.setAttributeSelectionEnabled(attributeId, false);
      _this.buildStructure();
      _this.renderDesign();
    });
    _defineProperty(this, "handleAttributeOptionEnabled", function (attributeId, optionId) {
      _this.updateComposition();
      _this.setOptionSelectionEnabled(attributeId, optionId, true);
      _this.buildStructure();
      _this.renderDesign();
    });
    _defineProperty(this, "handleAttributeOptionDisabled", function (attributeId, optionId) {
      _this.updateComposition();
      _this.setOptionSelectionEnabled(attributeId, optionId, false);
      _this.buildStructure();
      _this.renderDesign();
    });
    // Set the current attribute platform selection as enabled or not
    _defineProperty(this, "setAttributeSelectionEnabled", function (attributeId, isEnabled) {
      var attribute = _this.zkProduct.get('attributes').find(function (attribute) {
        return attribute.get('attributeID') == attributeId;
      });
      if (attribute) {
        var attributePlatformSelection = _this.platformAttributesSelection.find(function (selection) {
          return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(selection.attributeCode, attribute.get('attributeCode'));
        });
        if (attributePlatformSelection) {
          attributePlatformSelection.attributeIsEnabled = isEnabled;
        }

        // Set all options as disabled too in platfrom attributes
        attribute.get('options').each(function (option) {
          _this.setOptionSelectionEnabled(attributeId, option.get('optionID'), isEnabled);
        });
      }
    });
    // Set the current option platform selection as enabled or not but only if it's the selected option
    _defineProperty(this, "setOptionSelectionEnabled", function (attributeId, optionId, isEnabled) {
      var attribute = _this.zkProduct.get('attributes').find(function (attribute) {
        return attribute.get('attributeID') == attributeId;
      });
      if (attribute) {
        var option = attribute.get('options').find(function (option) {
          return option.get('optionID') == optionId;
        });
        if (option) {
          var attributePlatformSelection = _this.platformAttributesSelection.find(function (selection) {
            return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(selection.attributeCode, attribute.get('attributeCode'));
          });
          if (attributePlatformSelection && (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(attributePlatformSelection.optionCode, option.get('optionCode'))) {
            attributePlatformSelection.optionIsEnabled = isEnabled;
          }
        }
      }
      _this.updateRecapAndAdditionalCustomProperties();
    });
    _defineProperty(this, "isOptionEnabled", function (optionId) {
      var enabled = false;
      _this.selection.get('groups').each(function (group) {
        group.get('attributes').each(function (attr) {
          var option = attr.get('options').find(function (x) {
            return x.get('optionID') == optionId;
          });
          if (option) enabled = option.get('enabled');
        });
      });
      return enabled;
    });
    _defineProperty(this, "updateComposition", function () {
      _this.selection.updateComposition(_this.composition);
      _this.updatePrice();
    });
    _defineProperty(this, "_updatePrice", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
      var price, isOutOfStock, result;
      return _regeneratorRuntime().wrap(function _callee28$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            price = 0;
            isOutOfStock = false;
            if (!(_this.composition && _this.zkProduct)) {
              _context29.next = 8;
              break;
            }
            _context29.next = 5;
            return _this.getPrice();
          case 5:
            result = _context29.sent;
            price = result.price;
            isOutOfStock = result.isOutOfStock;
          case 8:
            _this.price = price;
            _this.isOutOfStock = isOutOfStock;
            _this.trigger('change');
          case 11:
          case "end":
            return _context29.stop();
        }
      }, _callee28);
    })));
    _defineProperty(this, "updatePrice", lodash__WEBPACK_IMPORTED_MODULE_0___default().debounce(this._updatePrice, 300));
    _defineProperty(this, "buildStructure", function () {
      var data = [];
      if (_this.selection) {
        for (var i = 0; i < _this.selection.get('groups').length; i++) {
          var group = _this.selection.get('groups').at(i);
          var groupData = _this.createGroupFromSelection(group);
          data.push(groupData);
        }
        data.sort(function (a, b) {
          return a.displayOrder - b.displayOrder;
        });
      }
      _this.groups = data;
      _this.trigger('change');
    });
    _defineProperty(this, "createGroupFromSelection", function (groupSelection) {
      var zakekeGroup = _this.zkProduct.get('attributeGroups').get(groupSelection.get('groupID'));
      var imageUrl = zakekeGroup ? zakekeGroup.get('imageUrl') : null;
      var group = new _models__WEBPACK_IMPORTED_MODULE_11__.Group();
      group.id = zakekeGroup ? zakekeGroup.get('groupID') : -1;
      group.guid = zakekeGroup ? zakekeGroup.get('groupGuid') : '-1';
      group.name = zakekeGroup ? zakekeGroup.get('name') : 'Other';
      group.imageUrl = imageUrl;
      group.enabled = true;
      group.cameraLocationId = zakekeGroup ? zakekeGroup.get('sceneCameraLocationID') : null;
      group.steps = _this.zkProduct.get('attributeSteps').filter(function (step) {
        return step.get('groupID') == group.id;
      }).map(function (step) {
        return _this.createStep(step, groupSelection);
      });
      if (zakekeGroup) {
        group.displayOrder = zakekeGroup.get('displayOrder');
        group.direction = zakekeGroup.get('direction');
        group.attributesAlwaysOpened = zakekeGroup.get('attributesAlwaysOpened');
      }
      var _loop2 = function _loop2() {
        var attributeSelection = groupSelection.get('attributes').at(i);
        var zakekeAttribute = _this.zkProduct.get('attributes').find(function (attribute) {
          return attribute.get('attributeID') == attributeSelection.get('attributeID');
        });
        if (zakekeAttribute.get('stepID') == -1) {
          var attribute = _this.createAttributeFromSelection(attributeSelection);
          group.attributes.push(attribute);
        }
      };
      for (var i = 0; i < groupSelection.get('attributes').length; i++) {
        _loop2();
      }
      group.attributes.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });

      // template groups
      var _loop3 = function _loop3() {
        var zakekeTemplateGroup = _this.zkProduct.get('templateGroups').at(k);
        var templateGroupSelection = groupSelection.get('templateGroups').find(function (templGr) {
          return templGr.get('templateGroupID') == zakekeTemplateGroup.get('templateGroupID');
        });
        if (templateGroupSelection && zakekeTemplateGroup.get('stepID') == null) {
          var templateGroup = _this.createTemplateGroupFromSelection(templateGroupSelection);
          group.templateGroups.push(templateGroup);
        }
      };
      for (var k = 0; k < _this.zkProduct.get('templateGroups').length; k++) {
        _loop3();
      }
      group.templateGroups.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });
      return group;
    });
    _defineProperty(this, "createAttributeFromSelection", function (attributeSelection) {
      var zakekeAttribute = _this.zkProduct.get('attributes').get(attributeSelection.get('attributeID'));
      var attribute = new _models__WEBPACK_IMPORTED_MODULE_11__.Attribute();
      attribute.id = zakekeAttribute.get('attributeID');
      attribute.guid = zakekeAttribute.get('attributeGuid');
      attribute.code = zakekeAttribute.get('attributeCode');
      attribute.name = zakekeAttribute.get('name') || '';
      attribute.description = zakekeAttribute.get('description') || '';
      attribute.optionShapeType = zakekeAttribute.get('optionPreviewShapeID') == 1 ? _models__WEBPACK_IMPORTED_MODULE_11__.AttributeOptionShapeType.Round : _models__WEBPACK_IMPORTED_MODULE_11__.AttributeOptionShapeType.Square;
      attribute.displayOrder = zakekeAttribute.get('displayOrder');
      attribute.enabled = attributeSelection.get('enabled');
      attribute.groupId = zakekeAttribute.get('groupID');
      attribute.stepId = zakekeAttribute.get('stepID');
      attribute.hideOptionsLabel = zakekeAttribute.get('hideOptionsLabel');
      attribute.cameraLocationId = zakekeAttribute ? zakekeAttribute.get('sceneCameraLocationID') : null;

      // Options
      for (var i = 0; i < attributeSelection.get('options').length; i++) {
        var optionSelection = attributeSelection.get('options').at(i);
        var option = _this.createOptionFromSelection(optionSelection);
        option.attribute = attribute;
        attribute.options.push(option);
      }
      if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.Options) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Select;
      } else if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.Color) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
        attribute.value = attributeSelection.get('selectedValue');
      } else if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.Number) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
        attribute.value = attributeSelection.get('selectedValue');
        attribute.numberFormat = '';
      } else if (attributeSelection.get('attributeTypeID') == MPlaza.AttributeType.String) {
        attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
        attribute.value = attributeSelection.get('selectedValue');
        attribute.numberFormat = '';
      }
      attribute.options.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });
      return attribute;
    });
    _defineProperty(this, "createOptionFromSelection", function (optionSelection) {
      var zakekeOption = _this.zkProduct.get('attributes').get(optionSelection.get('attributeID')).get('options').get(optionSelection.get('optionID'));
      var option = new _models__WEBPACK_IMPORTED_MODULE_11__.Option();
      var pricings = _this.zkProduct.get('attributes').get(optionSelection.get('attributeID')).get('pricings');
      if (pricings.length > 0) {
        var _pricings$find;
        var optionPrice = (_pricings$find = pricings.find(function (price) {
          return price.get('selectedOptionID') === optionSelection.get('optionID');
        })) === null || _pricings$find === void 0 ? void 0 : _pricings$find.get('price');
        if (optionPrice) option.pricings = [{
          fromQuantity: 0,
          price: optionPrice
        }];
      }
      option.id = zakekeOption.get('optionID');
      option.guid = zakekeOption.get('optionGuid');
      option.code = zakekeOption.get('optionCode');
      option.name = zakekeOption.get('name') || '';
      option.description = zakekeOption.get('description') || '';
      option.imageUrl = zakekeOption.get('imageUrl');
      option.displayOrder = zakekeOption.get('displayOrder');
      option.selected = optionSelection.get('selected');
      option.enabled = optionSelection.get('enabled');
      return option;
    });
    _defineProperty(this, "createTemplateGroupFromSelection", function (templateGroupSelection) {
      var _zakekeTemplateGroup$;
      var zakekeTemplateGroup = _this.zkProduct.get('templateGroups').find(function (templateGroup) {
        return templateGroup.get('templateGroupID') === templateGroupSelection.get('templateGroupID');
      });
      if (!zakekeTemplateGroup) return new ___WEBPACK_IMPORTED_MODULE_1__.ThemeTemplateGroup();
      var templateGroup = new ___WEBPACK_IMPORTED_MODULE_1__.ThemeTemplateGroup();
      templateGroup.templateGroupID = zakekeTemplateGroup.get('templateGroupID');
      templateGroup.name = (_zakekeTemplateGroup$ = zakekeTemplateGroup.get('name')) !== null && _zakekeTemplateGroup$ !== void 0 ? _zakekeTemplateGroup$ : '';
      templateGroup.groupID = zakekeTemplateGroup.get('groupID');
      templateGroup.stepID = zakekeTemplateGroup.get('stepID');
      templateGroup.displayOrder = zakekeTemplateGroup.get('displayOrder');
      var _loop4 = function _loop4() {
        var macroCategorySelection = templateGroupSelection.get('macrocategory').at(i);
        var zakekeMacroCategory = zakekeTemplateGroup.get('macrocategory').find(function (macroCategory) {
          return macroCategory.get('macroCategoryID') === macroCategorySelection.get('macroCategoryID');
        });
        if (!zakekeMacroCategory) return {
          v: templateGroup
        };
        var macroCategory = new ___WEBPACK_IMPORTED_MODULE_1__.PreSetConfigurationsMacroCategory();
        macroCategory.id = zakekeMacroCategory.get('macroCategoryID');
        macroCategory.name = zakekeMacroCategory.get('name');
        var _loop5 = function _loop5() {
          var categorySelection = macroCategorySelection.get('category').at(j);
          var zakekeCategory = zakekeMacroCategory.get('category').find(function (category) {
            return category.get('categoryID') === categorySelection.get('categoryID');
          });
          if (!zakekeCategory) return {
            v: {
              v: templateGroup
            }
          };
          var category = new ___WEBPACK_IMPORTED_MODULE_1__.PreSetConfigurationsCategory();
          category.id = zakekeCategory.get('categoryID');
          category.name = zakekeCategory.get('name');
          var _loop6 = function _loop6() {
            var compositionSelection = categorySelection.get('composition').at(k);
            var zakekeComposition = zakekeCategory.get('composition').find(function (composition) {
              return composition.get('compositionID') === compositionSelection.get('compositionID');
            });
            if (!zakekeComposition) return {
              v: {
                v: {
                  v: templateGroup
                }
              }
            };
            var composition = new ___WEBPACK_IMPORTED_MODULE_1__.PreSetConfigurations();
            composition.name = zakekeComposition.get('name');
            composition.previewImageUrl = zakekeComposition.get('previewImageUrl');
            composition.compositionID = zakekeComposition.get('compositionID');
            category.composition.push(composition);
          };
          for (k = 0; k < categorySelection.get('composition').length; k++) {
            var _ret3 = _loop6();
            if (_typeof(_ret3) === "object") return _ret3.v;
          }
          macroCategory.category.push(category);
        };
        for (j = 0; j < macroCategorySelection.get('category').length; j++) {
          var _ret2 = _loop5();
          if (_typeof(_ret2) === "object") return _ret2.v;
        }
        templateGroup.macroCategory.push(macroCategory);
      };
      for (var i = 0; i < templateGroupSelection.get('macrocategory').length; i++) {
        var j, k;
        var _ret = _loop4();
        if (_typeof(_ret) === "object") return _ret.v;
      }
      return templateGroup;
    });
    _defineProperty(this, "saveDesignBackbone", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
      return _regeneratorRuntime().wrap(function _callee29$(_context30) {
        while (1) switch (_context30.prev = _context30.next) {
          case 0:
            return _context30.abrupt("return", new Promise(function (resolve, reject) {
              var design = _this.zkCurrentTemplate;
              if (!design) {
                resolve();
                return;
              }
              design.save(null, {
                success: function success(model) {
                  _this.composition.set('designDocID', model.get('docID'));
                  resolve();
                },
                error: function error() {
                  reject();
                },
                headers: {
                  fromBackOffice: _this.isDraftEditor ? true : false
                }
              });
            }));
          case 1:
          case "end":
            return _context30.stop();
        }
      }, _callee29);
    })));
    _defineProperty(this, "saveCompositionBackbone", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
      return _regeneratorRuntime().wrap(function _callee30$(_context31) {
        while (1) switch (_context31.prev = _context31.next) {
          case 0:
            return _context31.abrupt("return", new Promise(function (resolve, reject) {
              _this.composition.save(null, {
                success: function success() {
                  resolve();
                },
                error: function error() {
                  reject();
                },
                headers: {
                  fromBackOffice: _this.isDraftEditor ? true : false
                }
              });
            }));
          case 1:
          case "end":
            return _context31.stop();
        }
      }, _callee30);
    })));
    // Events
    _defineProperty(this, "trigger", function (event) {
      for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key7 = 1; _key7 < _len; _key7++) {
        params[_key7 - 1] = arguments[_key7];
      }
      var _iterator4 = _createForOfIteratorHelper(_this.events.filter(function (x) {
          return x.event == event;
        })),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var handler = _step4.value;
          if (handler.callback) handler.callback.apply(_this, params);else console.error("Event handler can't be null or undefined");
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    });
    _defineProperty(this, "on", function (event, callback) {
      _this.events.push(new _models__WEBPACK_IMPORTED_MODULE_11__.ZakekeEvent(event, callback));
    });
    _defineProperty(this, "off", function (event, callback) {
      _this.events = _this.events.filter(function (x) {
        return x.event == event && x.callback == callback;
      });
    });
    _defineProperty(this, "setTemplate", function (templateId) {
      _this.zkCurrentTemplate = _this.zkTemplates.find(function (x) {
        return x.get('templateDesignID') == templateId;
      });
      _this.currentTemplate = _this.templates.find(function (x) {
        return x.id == templateId;
      }) || null;
      _this.renderDesign();
    });
    _defineProperty(this, "getTemplateUploadRestrictictions", function (templateId, areaId) {
      var _getUploadRestriction, _getUploadRestriction2, _getUploadRestriction3, _getUploadRestriction4, _getUploadRestriction5, _getUploadRestriction6, _getUploadRestriction7;
      var design = _this.zkTemplates.find(function (x) {
        return x.get('templateDesignID') == templateId;
      });
      if (!design) throw 'Template does not exists with id ' + templateId;
      var designSide = design.getDesignSide(_this.zkProduct.get('colors').at(0).get('sides').get(areaId));
      var getUploadRestriction = function getUploadRestriction(restriction) {
        var _designSide$get, _design$get;
        if (designSide && designSide.get('uploadRestrictions')) return (_designSide$get = designSide.get('uploadRestrictions')) === null || _designSide$get === void 0 ? void 0 : _designSide$get[restriction];else if (design.get('uploadRestrictions')) (_design$get = design.get('uploadRestrictions')) === null || _design$get === void 0 ? void 0 : _design$get[restriction];else return null;
      };
      var pdfAddonEnabled = _this.settings.addons.find(function (x) {
        return x.addonName === 'PDF' || x.addonName === 'PDF_EPS';
      });
      var epsAddonEnabled = _this.settings.addons.find(function (x) {
        return x.addonName === 'EPS' || x.addonName === 'PDF_EPS';
      });
      return {
        isUserImageAllowed: (_getUploadRestriction = getUploadRestriction('isUserImageAllowed')) !== null && _getUploadRestriction !== void 0 ? _getUploadRestriction : true,
        isJpgAllowed: (_getUploadRestriction2 = getUploadRestriction('isJpgAllowed')) !== null && _getUploadRestriction2 !== void 0 ? _getUploadRestriction2 : true,
        isPngAllowed: (_getUploadRestriction3 = getUploadRestriction('isPngAllowed')) !== null && _getUploadRestriction3 !== void 0 ? _getUploadRestriction3 : true,
        isSvgAllowed: (_getUploadRestriction4 = getUploadRestriction('isSvgAllowed')) !== null && _getUploadRestriction4 !== void 0 ? _getUploadRestriction4 : true,
        isPdfAllowed: ((_getUploadRestriction5 = getUploadRestriction('isPdfAllowed')) !== null && _getUploadRestriction5 !== void 0 ? _getUploadRestriction5 : true) && !!pdfAddonEnabled,
        isEpsAllowed: ((_getUploadRestriction6 = getUploadRestriction('isEpsAllowed')) !== null && _getUploadRestriction6 !== void 0 ? _getUploadRestriction6 : true) && !!epsAddonEnabled,
        isPdfWithRasterAllowed: ((_getUploadRestriction7 = getUploadRestriction('isPdfWithRasterAllowed')) !== null && _getUploadRestriction7 !== void 0 ? _getUploadRestriction7 : true) && !!pdfAddonEnabled
      };
    });
    // Get template
    _defineProperty(this, "getTemplates", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
      return _regeneratorRuntime().wrap(function _callee32$(_context33) {
        while (1) switch (_context33.prev = _context33.next) {
          case 0:
            return _context33.abrupt("return", new Promise( /*#__PURE__*/function () {
              var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31(resolve, reject) {
                var templatesList, templates, _iterator5, _step5, _template, template;
                return _regeneratorRuntime().wrap(function _callee31$(_context32) {
                  while (1) switch (_context32.prev = _context32.next) {
                    case 0:
                      _context32.next = 2;
                      return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('designs/templates/' + _this.zkProduct.get('modelID'));
                    case 2:
                      templatesList = _context32.sent.data;
                      templates = []; // Build a new design
                      if (!(templatesList.length > 0)) {
                        _context32.next = 26;
                        break;
                      }
                      _iterator5 = _createForOfIteratorHelper(templatesList[0].categories[0].templates);
                      _context32.prev = 6;
                      _iterator5.s();
                    case 8:
                      if ((_step5 = _iterator5.n()).done) {
                        _context32.next = 18;
                        break;
                      }
                      _template = _step5.value;
                      _context32.next = 12;
                      return _this.getTemplate(_template.designID);
                    case 12:
                      template = _context32.sent;
                      _context32.next = 15;
                      return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.downloadFontsOfDesign)(template, _this.fonts);
                    case 15:
                      templates.push(template);
                    case 16:
                      _context32.next = 8;
                      break;
                    case 18:
                      _context32.next = 23;
                      break;
                    case 20:
                      _context32.prev = 20;
                      _context32.t0 = _context32["catch"](6);
                      _iterator5.e(_context32.t0);
                    case 23:
                      _context32.prev = 23;
                      _iterator5.f();
                      return _context32.finish(23);
                    case 26:
                      resolve(templates);
                    case 27:
                    case "end":
                      return _context32.stop();
                  }
                }, _callee31, null, [[6, 20, 23, 26]]);
              }));
              return function (_x16, _x17) {
                return _ref34.apply(this, arguments);
              };
            }()));
          case 1:
          case "end":
            return _context33.stop();
        }
      }, _callee32);
    })));
    _defineProperty(this, "saveProduct", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33() {
      return _regeneratorRuntime().wrap(function _callee33$(_context34) {
        while (1) switch (_context34.prev = _context34.next) {
          case 0:
            return _context34.abrupt("return", new Promise(function (resolve, reject) {
              _this.zkProduct && _this.zkProduct.save(null, {
                success: function success(model, response, options) {
                  resolve();
                },
                error: function error(model, response, options) {
                  reject(response);
                }
              });
            }));
          case 1:
          case "end":
            return _context34.stop();
        }
      }, _callee33);
    })));
    // Get single template
    _defineProperty(this, "getTemplate", /*#__PURE__*/function () {
      var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(templateId) {
        return _regeneratorRuntime().wrap(function _callee35$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              return _context36.abrupt("return", new Promise(function (resolve, reject) {
                var design = new MPlaza.Design();
                design.set('docID', templateId);
                design.fetch({
                  success: function () {
                    var _success = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
                      return _regeneratorRuntime().wrap(function _callee34$(_context35) {
                        while (1) switch (_context35.prev = _context35.next) {
                          case 0:
                            resolve(design);
                          case 1:
                          case "end":
                            return _context35.stop();
                        }
                      }, _callee34);
                    }));
                    function success() {
                      return _success.apply(this, arguments);
                    }
                    return success;
                  }(),
                  error: function error() {
                    return null;
                  },
                  data: {
                    template: true
                  }
                });
                design.addEventListener('change', _this.updatePrice);
              }));
            case 1:
            case "end":
              return _context36.stop();
          }
        }, _callee35);
      }));
      return function (_x18) {
        return _ref36.apply(this, arguments);
      };
    }());
    // Public methods
    _defineProperty(this, "updateView", function () {
      _this.viewer.updateView();
    });
    _defineProperty(this, "selectOption", function (optionId) {
      var clone = _this.cloneSelection(_this.selection);
      _this.undoStack.push(clone);
      var option;
      var attribute;
      _this.zkProduct.get('attributes').each(function (attr) {
        var _option = attr.get('options').find(function (option) {
          return option.get('optionID') == optionId;
        });
        if (_option) {
          option = _option;
          attribute = attr;
        }
      });
      if (option) {
        // Don' t reselect it.
        if (option.selected) return;
        _this.selection.selectAttributeValue(attribute.get('attributeID'), optionId.toString());
      } else {
        throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception('Invalid option with id ' + optionId);
      }
    });
    // Focus a group executing some camera movements
    _defineProperty(this, "focusGroup", function (groupId) {
      var sceneGroup = _this.groups.find(function (x) {
        return x.id == groupId;
      });
      if (sceneGroup && sceneGroup.cameraLocationId) {
        _this.viewer.setCameraLocation(sceneGroup.cameraLocationId);
        _this.lastCameraLocation = sceneGroup.cameraLocationId;
      }
    });
    _defineProperty(this, "focusAttribute", /*#__PURE__*/function () {
      var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(attributeId) {
        var unselectedOptionsActions, attribute;
        return _regeneratorRuntime().wrap(function _callee36$(_context37) {
          while (1) switch (_context37.prev = _context37.next) {
            case 0:
              unselectedOptionsActions = _this.selection.getAttributeUnselectedOptionsSceneActions(attributeId);
              _context37.next = 3;
              return _this.viewer.prefetchDataForUnselectedOptionsAsync(unselectedOptionsActions);
            case 3:
              attribute = _this.zkProduct.get('attributes').find(function (attribute) {
                return attribute.get('attributeID') == attributeId;
              });
              if (attribute && attribute.get('sceneCameraLocationID') && attribute.get('sceneCameraLocationID') != Zakeke.getEmptyUUID()) {
                _this.viewer.setCameraLocation(attribute.get('sceneCameraLocationID'));
                _this.lastCameraLocation = attribute.get('sceneCameraLocationID');
              }
            case 5:
            case "end":
              return _context37.stop();
          }
        }, _callee36);
      }));
      return function (_x19) {
        return _ref37.apply(this, arguments);
      };
    }());
    _defineProperty(this, "base64StringToFile", function (base64String, filename) {
      var _arr$0$match$, _arr$, _arr$$match;
      var arr = base64String.split(','),
        mime = (_arr$0$match$ = (_arr$ = arr[0]) === null || _arr$ === void 0 ? void 0 : (_arr$$match = _arr$.match(/:(.*?);/)) === null || _arr$$match === void 0 ? void 0 : _arr$$match[1]) !== null && _arr$0$match$ !== void 0 ? _arr$0$match$ : '',
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    });
    _defineProperty(this, "saveTemplate", /*#__PURE__*/function () {
      var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee37(templateName, selectedCategoryID, attributeOptions) {
        var attributes, compositionItems, categories, mapping, templateGroup, group, step, attributesWithoutGroup;
        return _regeneratorRuntime().wrap(function _callee37$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              attributes = Array.from(attributeOptions.keys());
              compositionItems = _this.composition.get('compositionItems');
              compositionItems.toArray().forEach(function (compositionItem) {
                if (!attributes.includes(compositionItem.get('attributeID'))) compositionItems.remove(compositionItem);
              });
              _this.composition.set('name', templateName);
              _this.composition.set('compositionItems', compositionItems);
              _this.composition.set('isTemplate', true);
              categories = new MPlaza.CompositionCategoriesMapping();
              if (selectedCategoryID) {
                mapping = new MPlaza.CompositionCategoryMapping();
                mapping.set('categoryID', selectedCategoryID);
                mapping.set('name', ' ');
                categories.add(mapping);
              }
              _this.composition.set('categories', categories);
              if (!(_this.zkProduct.get('templateGroups').length === 0)) {
                _context38.next = 16;
                break;
              }
              templateGroup = new MPlaza.TemplateGroup();
              templateGroup.set('name', 'Pre-set configurations');
              if (_this.zkProduct.get('attributeGroups').length > 0) {
                group = new MPlaza.AttributeGroup();
                group.set('name', 'Pre-set configurations');
                group.set('displayOrder', _this.zkProduct.get('attributeGroups').at(0).get('displayOrder') - 1);
                _this.zkProduct.get('attributeGroups').unshift(group);
                templateGroup.set('groupGuid', group.get('groupGuid'));
              } else {
                if (_this.zkProduct.get('attributeSteps') && _this.zkProduct.get('attributeSteps').length > 0) {
                  step = new MPlaza.AttributeStep();
                  step.set('name', 'Pre-set configurations');
                  step.set('groupGuid', Zakeke.generateUUID());
                  step.set('displayOrder', _this.zkProduct.get('attributeSteps').at(0).get('displayOrder') - 1);
                  _this.zkProduct.get('attributeSteps').unshift(step);
                  templateGroup.set('stepGuid', step.get('stepGuid'));
                } else {
                  attributesWithoutGroup = _this.zkProduct.get('attributes').filter(function (attr) {
                    return attr.get('groupID') === -1;
                  }).sort((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.ascComparator)(function (x) {
                    return x.get('displayOrder');
                  }));
                  if (attributesWithoutGroup.length > 0) templateGroup.set('displayOrder', attributesWithoutGroup[0].get('displayOrder') - 1);
                }
              }
              _this.zkProduct.get('templateGroups').add(templateGroup);
              _context38.next = 16;
              return _this.saveProduct();
            case 16:
              _context38.next = 18;
              return _this.addToCart([], undefined, undefined, undefined);
            case 18:
              _context38.next = 20;
              return _this.reset();
            case 20:
            case "end":
              return _context38.stop();
          }
        }, _callee37);
      }));
      return function (_x20, _x21, _x22) {
        return _ref38.apply(this, arguments);
      };
    }());
    _defineProperty(this, "addToCart", /*#__PURE__*/function () {
      var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee38(additionalProperties, onBeforeSendDataToParent, legacyScreenshot, nftForm) {
        var _this$zkScene2;
        var compositionClientPreviews, sortedBuyScreenshotCameras, buyScreenshotCameras, _iterator6, _step6, camera, preview, formData, file, previewCameraFile;
        return _regeneratorRuntime().wrap(function _callee38$(_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _context39.next = 2;
              return _this.setExplodedMode(false);
            case 2:
              _this.composition.set('compositionClientPreviews', []);
              compositionClientPreviews = [];
              sortedBuyScreenshotCameras = [];
              buyScreenshotCameras = (_this$zkScene2 = _this.zkScene) === null || _this$zkScene2 === void 0 ? void 0 : _this$zkScene2.get('cameraLocations').filter(function (x) {
                var _x$get;
                return ((_x$get = x.get('name')) === null || _x$get === void 0 ? void 0 : _x$get.toLowerCase().indexOf('buy_screenshot_camera_')) !== -1;
              });
              if (buyScreenshotCameras) sortedBuyScreenshotCameras = (0,lodash__WEBPACK_IMPORTED_MODULE_0__.sortBy)(buyScreenshotCameras, function (a) {
                return a.get('name');
              });
              if (!(sortedBuyScreenshotCameras && sortedBuyScreenshotCameras.length > 0)) {
                _context39.next = 38;
                break;
              }
              _iterator6 = _createForOfIteratorHelper(sortedBuyScreenshotCameras);
              _context39.prev = 9;
              _iterator6.s();
            case 11:
              if ((_step6 = _iterator6.n()).done) {
                _context39.next = 29;
                break;
              }
              camera = _step6.value;
              _context39.next = 15;
              return _this.viewer.getSceneContentScreenshotAsync(_this.clientPreviewWidth, _this.clientPreviewHeight, 0, _this.zkCurrentTemplate, legacyScreenshot, camera);
            case 15:
              preview = _context39.sent;
              formData = new FormData();
              if (preview) {
                _context39.next = 19;
                break;
              }
              return _context39.abrupt("return");
            case 19:
              file = _this.base64StringToFile(preview, camera + '.png');
              formData.set('file', file);
              _context39.next = 23;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'designs/upload-client-preview', formData);
            case 23:
              previewCameraFile = _context39.sent.data;
              compositionClientPreviews.push({
                fileObjectID: previewCameraFile.id,
                cameraName: camera.get('name'),
                url: previewCameraFile.url
              });
              _context39.next = 27;
              return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.sleep)(1);
            case 27:
              _context39.next = 11;
              break;
            case 29:
              _context39.next = 34;
              break;
            case 31:
              _context39.prev = 31;
              _context39.t0 = _context39["catch"](9);
              _iterator6.e(_context39.t0);
            case 34:
              _context39.prev = 34;
              _iterator6.f();
              return _context39.finish(34);
            case 37:
              _this.composition.set('compositionClientPreviews', compositionClientPreviews);
            case 38:
              if (_this.composition.get('isDraft') && !_this.isDraftEditor) {
                _this.composition.set('docID', null);
                _this.composition.set('designDocID', null);
                _this.composition.set('isDraft', false);
                if (_this.zkCurrentTemplate) _this.zkCurrentTemplate.set('docID', null);
              }

              // Save composition
              _context39.next = 41;
              return _this.saveComposition(undefined, legacyScreenshot);
            case 41:
              if (!nftForm) {
                _context39.next = 44;
                break;
              }
              _context39.next = 44;
              return _this.saveCustomerWalletInfo(_this.composition.get('docID'), nftForm.email, nftForm.walletAddress);
            case 44:
              if (!onBeforeSendDataToParent) {
                _context39.next = 47;
                break;
              }
              _context39.next = 47;
              return onBeforeSendDataToParent({
                composition: _this.composition.id,
                preview: _this.composition.get('previewImageUrl'),
                attributes: _this.platformAttributesSelection,
                designItems: _this.getDesignItemsInfo(),
                quantity: _this.quantity,
                additionalProperties: additionalProperties
              });
            case 47:
              // Add to cart
              _this.integration.addToCart(_this.composition, _this.zkCurrentTemplate, _this.zkProduct, _this.platformAttributesSelection, _this.getDesignItemsInfo(), _this.quantity, additionalProperties, nftForm && _this.settings.ecommerceID === 3 ? _this.nftSettings ? _this.nftSettings.priceToAdd : 0 : 0);
            case 48:
            case "end":
              return _context39.stop();
          }
        }, _callee38, null, [[9, 31, 34, 37]]);
      }));
      return function (_x23, _x24, _x25, _x26) {
        return _ref39.apply(this, arguments);
      };
    }());
    _defineProperty(this, "zoomIn", function () {
      if (_this.viewer) _this.viewer.zoomIn();
    });
    _defineProperty(this, "zoomOut", function () {
      if (_this.viewer) _this.viewer.zoomOut();
    });
    _defineProperty(this, "isFullscreenEnabled", function () {
      return !_helpers__WEBPACK_IMPORTED_MODULE_7__.iOS;
    });
    _defineProperty(this, "switchFullscreen", function () {
      var interval = null;
      _this.viewer.switchFullScreen(document.getElementById('zakeke-viewer-container'));
      if (!interval) {
        //eslint-disable-next-line
        interval = setInterval(function () {
          if (_this.isFullscreenMode && _this.internalIsFullscreen == false) {
            setTimeout(function () {
              _this.viewer.updateView();
              _this.internalIsFullscreen = true;
              console.info('Fullscreen enabled');
            }, 10);
          }
          if (!_this.isFullscreenMode && _this.internalIsFullscreen == true) {
            clearInterval(interval);
            interval = null;
            setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee39() {
              return _regeneratorRuntime().wrap(function _callee39$(_context40) {
                while (1) switch (_context40.prev = _context40.next) {
                  case 0:
                    _this.internalIsFullscreen = false;

                    // Update layout for two seconds
                    _context40.next = 3;
                    return _this.extendedUpdate();
                  case 3:
                    _this.viewer.updateView();
                    console.info('Fullscreen disabled');
                  case 5:
                  case "end":
                    return _context40.stop();
                }
              }, _callee39);
            })), 10);
          }
        }, 100);
      }
    });
    _defineProperty(this, "openSecondScreen", function () {
      var url = Zakeke.config.baseUrl + 'en/SecondScreen?token=' + _this.token + '&modelID=' + _this.zkProduct.get('modelID');
      window.open(url);
    });
    _defineProperty(this, "extendedUpdate", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee40() {
      return _regeneratorRuntime().wrap(function _callee40$(_context41) {
        while (1) switch (_context41.prev = _context41.next) {
          case 0:
            return _context41.abrupt("return", new Promise(function (resolve, reject) {
              var count = 0;
              var interval = setInterval(function () {
                _this.viewer.updateView();
                if (++count > 20) {
                  // After two seconds
                  clearInterval(interval);
                  resolve();
                }
              }, 100);
            }));
          case 1:
          case "end":
            return _context41.stop();
        }
      }, _callee40);
    })));
    _defineProperty(this, "exportSceneToUsdz", /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee41(hash) {
        return _regeneratorRuntime().wrap(function _callee41$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              if (!(_this.viewer && _this.viewer.zkScene)) {
                _context42.next = 2;
                break;
              }
              return _context42.abrupt("return", _this.viewer.exportSceneToUsdzAsync(_this.viewer.zkScene.get('sceneID'), hash));
            case 2:
            case "end":
              return _context42.stop();
          }
        }, _callee41);
      }));
      return function (_x27) {
        return _ref42.apply(this, arguments);
      };
    }());
    _defineProperty(this, "exportSceneToGlb", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee42() {
      return _regeneratorRuntime().wrap(function _callee42$(_context43) {
        while (1) switch (_context43.prev = _context43.next) {
          case 0:
            return _context43.abrupt("return", _this.viewer.exportSceneToLocalGLBAsync());
          case 1:
          case "end":
            return _context43.stop();
        }
      }, _callee42);
    })));
    _defineProperty(this, "setExplodedMode", /*#__PURE__*/function () {
      var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee43(explodedMode) {
        return _regeneratorRuntime().wrap(function _callee43$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              if (!_this.viewer) {
                _context44.next = 8;
                break;
              }
              if (!explodedMode) {
                _context44.next = 6;
                break;
              }
              _context44.next = 4;
              return _this.viewer.explodeMeshes();
            case 4:
              _context44.next = 8;
              break;
            case 6:
              _context44.next = 8;
              return _this.viewer.collapseMeshes();
            case 8:
              _this.isExplodedMode = explodedMode;
            case 9:
            case "end":
              return _context44.stop();
          }
        }, _callee43);
      }));
      return function (_x28) {
        return _ref44.apply(this, arguments);
      };
    }());
    _defineProperty(this, "hasExplodedMode", function () {
      var zkScene = _this.zkScene;
      if (zkScene) return !!zkScene.getFirstExplodedMeshLocation();else return false;
    });
    _defineProperty(this, "setBackgroundColor", function (color, alpha) {
      var zkScene = _this.zkScene;
      if (color.indexOf('rgb') == 0) {
        var values = color.replace('rgb(', '').replace(')', '').split(',');
        color = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.rgb2hex)(values[0], values[1], values[2]);
      }
      if (_this.viewer && zkScene) {
        zkScene.getOrCreateEnvironmentConfig().set('mainColor', color);
        zkScene.getOrCreateGeneralConfig().set('backgroundColor', color);
        zkScene.getOrCreateGeneralConfig().set('backgroundAlpha', alpha);
        _this.viewer.refreshEnvironment();
      }
    });
    _defineProperty(this, "getCurrentSelection", function () {
      return lodash__WEBPACK_IMPORTED_MODULE_0___default().cloneDeep(_this.platformAttributesSelection);
    });
    _defineProperty(this, "getScreenshot", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee44() {
      var width,
        height,
        legacyScreenshot,
        backgroundColor,
        padding,
        url,
        _args45 = arguments;
      return _regeneratorRuntime().wrap(function _callee44$(_context45) {
        while (1) switch (_context45.prev = _context45.next) {
          case 0:
            width = _args45.length > 0 && _args45[0] !== undefined ? _args45[0] : 1024;
            height = _args45.length > 1 && _args45[1] !== undefined ? _args45[1] : 1024;
            legacyScreenshot = _args45.length > 2 ? _args45[2] : undefined;
            backgroundColor = _args45.length > 3 && _args45[3] !== undefined ? _args45[3] : null;
            padding = _args45.length > 4 && _args45[4] !== undefined ? _args45[4] : 0;
            _context45.next = 7;
            return _this.viewer.getSceneContentScreenshotAsync(width, height, padding, _this.zkCurrentTemplate, legacyScreenshot);
          case 7:
            url = _context45.sent;
            if (url) {
              _context45.next = 10;
              break;
            }
            throw new Error('Failed generating screenshot');
          case 10:
            if (!backgroundColor) {
              _context45.next = 13;
              break;
            }
            _context45.next = 13;
            return new Promise(function (resolve) {
              var img = new Image();
              img.onload = function () {
                var canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext('2d');
                if (ctx) {
                  ctx.fillStyle = backgroundColor;
                  ctx.fillRect(0, 0, img.width, img.height);
                  ctx.drawImage(img, 0, 0);
                  url = canvas.toDataURL();
                  resolve();
                }
              };
              img.src = url;
            });
          case 13:
            return _context45.abrupt("return", url);
          case 14:
          case "end":
            return _context45.stop();
        }
      }, _callee44);
    })));
    _defineProperty(this, "fireItemsChange", function () {
      _this.trigger('change');
    });
    _defineProperty(this, "removeItem", /*#__PURE__*/function () {
      var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee45(guid) {
        return _regeneratorRuntime().wrap(function _callee45$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              return _context46.abrupt("return", new Promise(function (resolve, reject) {
                if (_this.viewer) {
                  _this.viewer.removeDesignItem(guid);
                  _this.fireItemsChange();
                  resolve();
                } else {
                  reject('Called remove item but no viewer or viewer not ready');
                }
              }));
            case 1:
            case "end":
              return _context46.stop();
          }
        }, _callee45);
      }));
      return function (_x29) {
        return _ref46.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemText", function (guid, text) {
      if (_this.viewer) {
        _this.viewer.setDesignItemText(guid, text);
      } else throw 'Called set item text but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemItalic", function (guid, italic) {
      if (_this.viewer) {
        _this.viewer.setDesignItemItalic(guid, italic);
      } else throw 'Called set item italic but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemBold", function (guid, bold) {
      if (_this.viewer) {
        _this.viewer.setDesignItemBold(guid, bold);
      } else throw 'Called set item bold but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemColor", function (guid, color) {
      if (_this.viewer) {
        _this.viewer.setDesignItemColor(guid, color);
      } else throw 'Called set item color but no viewer or viewer not ready';
    });
    _defineProperty(this, "setItemFontFamily", /*#__PURE__*/function () {
      var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee46(guid, fontFamily) {
        var font;
        return _regeneratorRuntime().wrap(function _callee46$(_context47) {
          while (1) switch (_context47.prev = _context47.next) {
            case 0:
              if (!_this.viewer) {
                _context47.next = 12;
                break;
              }
              font = _this.fonts.find(function (x) {
                return x.name === fontFamily;
              });
              if (!font) {
                _context47.next = 9;
                break;
              }
              _context47.next = 5;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([font]);
            case 5:
              _this.viewer.setDesignItemFontFamily(guid, fontFamily);
              _this.fireItemsChange();
              _context47.next = 10;
              break;
            case 9:
              console.warn("No font found for ".concat(fontFamily));
            case 10:
              _context47.next = 13;
              break;
            case 12:
              throw 'Called set item font family but no viewer or viewer not ready';
            case 13:
            case "end":
              return _context47.stop();
          }
        }, _callee46);
      }));
      return function (_x30, _x31) {
        return _ref47.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemTextOnPath", function (guid, areaId, value) {
      if (_this.viewer) {
        _this.viewer.setItemTextOnPath(guid, areaId, value);
        _this.fireItemsChange();
      } else throw 'Called toggleItemTextOnPath but no viewer or viewer not ready';
    });
    _defineProperty(this, "createImage", /*#__PURE__*/function () {
      var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee47(file, progress) {
        var imageTask, result, image;
        return _regeneratorRuntime().wrap(function _callee47$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              if (!_this.viewer) {
                _context48.next = 9;
                break;
              }
              imageTask = new _imageUploadTask__WEBPACK_IMPORTED_MODULE_8__["default"](_this.culture, _this.token);
              _context48.next = 4;
              return imageTask.upload(file, progress);
            case 4:
              result = _context48.sent;
              image = result ? result[0] : null;
              return _context48.abrupt("return", image);
            case 9:
              throw 'Called create image but no viewer or viewer not ready';
            case 10:
            case "end":
              return _context48.stop();
          }
        }, _callee47);
      }));
      return function (_x32, _x33) {
        return _ref48.apply(this, arguments);
      };
    }());
    _defineProperty(this, "createImageFromUrl", /*#__PURE__*/function () {
      var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee48(url) {
        var result;
        return _regeneratorRuntime().wrap(function _callee48$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              if (!_this.viewer) {
                _context49.next = 7;
                break;
              }
              _context49.next = 3;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'images/import/url', {
                url: url
              });
            case 3:
              result = _context49.sent.data;
              return _context49.abrupt("return", result);
            case 7:
              throw 'Called create image from url but no viewer or viewer not ready';
            case 8:
            case "end":
              return _context49.stop();
          }
        }, _callee48);
      }));
      return function (_x34) {
        return _ref49.apply(this, arguments);
      };
    }());
    _defineProperty(this, "addItemImage", /*#__PURE__*/function () {
      var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee49(id, areaId) {
        return _regeneratorRuntime().wrap(function _callee49$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              if (!_this.viewer) {
                _context50.next = 8;
                break;
              }
              _context50.next = 3;
              return _this.viewer.addDesignItemImage(id, areaId);
            case 3:
              _context50.next = 5;
              return _this.renderDesign();
            case 5:
              _this.fireItemsChange();
              _context50.next = 9;
              break;
            case 8:
              throw 'Called add item text but no viewer or viewer not ready';
            case 9:
            case "end":
              return _context50.stop();
          }
        }, _callee49);
      }));
      return function (_x35, _x36) {
        return _ref50.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemImageFromFile", /*#__PURE__*/function () {
      var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee50(guid, file, progress) {
        var image;
        return _regeneratorRuntime().wrap(function _callee50$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              if (!_this.viewer) {
                _context51.next = 9;
                break;
              }
              _context51.next = 3;
              return _this.createImage(file, progress);
            case 3:
              image = _context51.sent;
              _context51.next = 6;
              return _this.setItemImage(guid, image.imageID);
            case 6:
              _this.fireItemsChange();
              _context51.next = 10;
              break;
            case 9:
              throw 'Called set item image but no viewer or viewer not ready';
            case 10:
            case "end":
              return _context51.stop();
          }
        }, _callee50);
      }));
      return function (_x37, _x38, _x39) {
        return _ref51.apply(this, arguments);
      };
    }());
    // For preview only!!
    _defineProperty(this, "setItemImageFromBase64", /*#__PURE__*/function () {
      var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee51(guid, base64) {
        var image;
        return _regeneratorRuntime().wrap(function _callee51$(_context52) {
          while (1) switch (_context52.prev = _context52.next) {
            case 0:
              if (!_this.viewer) {
                _context52.next = 9;
                break;
              }
              image = new MPlaza.Image();
              image.set('imageID', -1);
              image.set('previewUrl', base64);
              _context52.next = 6;
              return _this.viewer.setDesignItemImage(guid, image);
            case 6:
              _this.fireItemsChange();
              _context52.next = 10;
              break;
            case 9:
              throw 'Called set item image but no viewer or viewer not ready';
            case 10:
            case "end":
              return _context52.stop();
          }
        }, _callee51);
      }));
      return function (_x40, _x41) {
        return _ref52.apply(this, arguments);
      };
    }());
    _defineProperty(this, "setItemImage", /*#__PURE__*/function () {
      var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee54(guid, id) {
        return _regeneratorRuntime().wrap(function _callee54$(_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              return _context55.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee53(resolve, reject) {
                  var image;
                  return _regeneratorRuntime().wrap(function _callee53$(_context54) {
                    while (1) switch (_context54.prev = _context54.next) {
                      case 0:
                        if (!_this.viewer) {
                          _context54.next = 6;
                          break;
                        }
                        image = new MPlaza.Image();
                        image.set('imageID', id);
                        image.fetch({
                          success: function () {
                            var _success2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee52(model, response, opts) {
                              return _regeneratorRuntime().wrap(function _callee52$(_context53) {
                                while (1) switch (_context53.prev = _context53.next) {
                                  case 0:
                                    _context53.next = 2;
                                    return _this.viewer.setDesignItemImage(guid, image);
                                  case 2:
                                    _this.fireItemsChange();
                                    resolve();
                                  case 4:
                                  case "end":
                                    return _context53.stop();
                                }
                              }, _callee52);
                            }));
                            function success(_x46, _x47, _x48) {
                              return _success2.apply(this, arguments);
                            }
                            return success;
                          }(),
                          error: function error(model, response, opts) {
                            return null;
                          }
                        });
                        _context54.next = 7;
                        break;
                      case 6:
                        throw 'Called set item image but no viewer or viewer not ready';
                      case 7:
                      case "end":
                        return _context54.stop();
                    }
                  }, _callee53);
                }));
                return function (_x44, _x45) {
                  return _ref54.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context55.stop();
          }
        }, _callee54);
      }));
      return function (_x42, _x43) {
        return _ref53.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getMacroCategories", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee55() {
      var macroCategories, _iterator7, _step7, macroCategory;
      return _regeneratorRuntime().wrap(function _callee55$(_context56) {
        while (1) switch (_context56.prev = _context56.next) {
          case 0:
            _context56.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('imagemacrocategories/');
          case 2:
            macroCategories = _context56.sent.data;
            macroCategories = macroCategories.filter(function (x) {
              return x.hasImages;
            });
            _iterator7 = _createForOfIteratorHelper(macroCategories);
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                macroCategory = _step7.value;
                macroCategory.categories = macroCategory.categories.filter(function (x) {
                  return x.hasImages;
                });
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
            return _context56.abrupt("return", macroCategories);
          case 7:
          case "end":
            return _context56.stop();
        }
      }, _callee55);
    })));
    _defineProperty(this, "getImages", /*#__PURE__*/function () {
      var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee56(categoryId) {
        return _regeneratorRuntime().wrap(function _callee56$(_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              _context57.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('images/', {
                params: {
                  type: 'lib',
                  c: categoryId
                }
              });
            case 2:
              return _context57.abrupt("return", _context57.sent.data);
            case 3:
            case "end":
              return _context57.stop();
          }
        }, _callee56);
      }));
      return function (_x49) {
        return _ref56.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getPDF", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee57() {
      var _this$product;
      var data, items, areas, selectedOptions, params, pdf;
      return _regeneratorRuntime().wrap(function _callee57$(_context58) {
        while (1) switch (_context58.prev = _context58.next) {
          case 0:
            _context58.next = 2;
            return _this.getScreenshot(2048, 2048);
          case 2:
            data = _context58.sent;
            items = _this.getDesignItemsInfo();
            areas = (_this$product = _this.product) === null || _this$product === void 0 ? void 0 : _this$product.areas.filter(function (x) {
              return _this.isAreaVisible(x.id);
            }).map(function (x) {
              return {
                name: x.name,
                textItems: items.filter(function (i) {
                  return i.areaId == x.id && i.type === ___WEBPACK_IMPORTED_MODULE_1__.ItemType.Text;
                })
              };
            }).filter(function (x) {
              return x.textItems.length > 0;
            });
            selectedOptions = _this.platformAttributesSelection.filter(function (x) {
              return x.attributeIsEnabled && x.attributeIsEnabled;
            }).map(function (_ref58) {
              var attributeLabel = _ref58.attributeLabel,
                attributeCode = _ref58.attributeCode,
                optionCode = _ref58.optionCode,
                optionLabel = _ref58.optionLabel;
              return {
                attributeLabel: attributeLabel,
                attributeCode: !(0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(attributeCode) ? attributeCode : '',
                optionLabel: optionLabel,
                optionCode: !(0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(optionCode) ? optionCode : ''
              };
            });
            params = {
              environment: 2,
              productName: _this.zkProduct.get('name'),
              previewImage: data,
              sides: [],
              areas: areas,
              selectedOptions: selectedOptions
            };
            _context58.next = 9;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'previewdesigns/pdf', params, {
              transformResponse: function transformResponse(res) {
                return res;
              },
              responseType: 'text'
            });
          case 9:
            pdf = _context58.sent.data.replace(/"/g, '');
            return _context58.abrupt("return", pdf);
          case 11:
          case "end":
            return _context58.stop();
        }
      }, _callee57);
    })));
    _defineProperty(this, "rewriteShareUrl", function (url) {
      var path = url.split('/SharedPreview')[1];
      if (_this.shareUrlPrefix) {
        return _this.shareUrlPrefix + path;
      }
      if (document.referrer && _this.settings.referrerID === 2) {
        var regex = /(apps\/configurator\/)([\s\S]*)/gm;
        var firstPart = document.referrer.replace(regex, '$1');
        if (!firstPart.endsWith('/')) firstPart += '/';
        return firstPart + path;
      }
      return url;
    });
    _defineProperty(this, "getShareCompositionUrl", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee58() {
      var _this$composition$get;
      var isDraft, docID, result;
      return _regeneratorRuntime().wrap(function _callee58$(_context59) {
        while (1) switch (_context59.prev = _context59.next) {
          case 0:
            // salvo (e riassegno dopo la creazione dello share url) l'id , per evitare problemi in caso di add to cart e edit
            // in questo modo ogni composizione condivisa è sempre diversa da quella di partenza
            isDraft = (_this$composition$get = _this.composition.get('isDraft')) !== null && _this$composition$get !== void 0 ? _this$composition$get : false;
            _this.composition.set('isDraft', false);
            _context59.next = 4;
            return _this.saveCompositionCopy();
          case 4:
            docID = _context59.sent;
            _this.composition.set('isDraft', isDraft);
            _context59.next = 8;
            return _this.integration.getSharedCompositionUrl(docID);
          case 8:
            result = _context59.sent;
            return _context59.abrupt("return", result.url);
          case 10:
          case "end":
            return _context59.stop();
        }
      }, _callee58);
    })));
    _defineProperty(this, "saveCompositionCopy", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee59() {
      var docId, designDocId, currentTemplate, newCompositionDocId;
      return _regeneratorRuntime().wrap(function _callee59$(_context60) {
        while (1) switch (_context60.prev = _context60.next) {
          case 0:
            docId = null;
            designDocId = null;
            currentTemplate = _this.zkCurrentTemplate;
            if (currentTemplate) {
              designDocId = currentTemplate.get('docID');
              currentTemplate.set('docID', null);
            }
            docId = _this.composition.get('docID');
            _this.composition.set('docID', null);
            _this.composition.set('designDocID', null);
            _context60.next = 9;
            return _this.saveComposition();
          case 9:
            newCompositionDocId = _this.composition.get('docID');
            _this.composition.set('docID', docId);
            _this.composition.set('designDocID', designDocId);
            if (currentTemplate) currentTemplate.set('docID', designDocId);
            return _context60.abrupt("return", newCompositionDocId);
          case 14:
          case "end":
            return _context60.stop();
        }
      }, _callee59);
    })));
    _defineProperty(this, "getOnlineScreenshot", /*#__PURE__*/function () {
      var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee60(width, height, legacyScreenshot, backgroundColor) {
        var padding,
          preview,
          originalUrl,
          rewrittenUrl,
          _args61 = arguments;
        return _regeneratorRuntime().wrap(function _callee60$(_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              padding = _args61.length > 4 && _args61[4] !== undefined ? _args61[4] : 30;
              _context61.next = 3;
              return _this.getScreenshot(width, height, legacyScreenshot, backgroundColor, padding);
            case 3:
              preview = _context61.sent;
              _context61.next = 6;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'designs/save-share-preview', {
                preview: preview
              });
            case 6:
              originalUrl = _context61.sent.data.url;
              rewrittenUrl = _this.rewriteShareUrl(originalUrl);
              return _context61.abrupt("return", {
                originalUrl: originalUrl,
                rewrittenUrl: rewrittenUrl
              });
            case 9:
            case "end":
              return _context61.stop();
          }
        }, _callee60);
      }));
      return function (_x50, _x51, _x52, _x53) {
        return _ref61.apply(this, arguments);
      };
    }());
    // AR - Augmented Reality
    _defineProperty(this, "isSceneArOnTheFly", function () {
      var _this$zkScene3;
      if (_this.viewer) return (_this$zkScene3 = _this.zkScene) === null || _this$zkScene3 === void 0 ? void 0 : _this$zkScene3.getArOnTheFly();
      return false;
    });
    _defineProperty(this, "isArDeviceCompliant", function () {
      return _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_AR_DEVICE_COMPLIANT;
    });
    _defineProperty(this, "isAndroidOrIOS", function () {
      return _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID || _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS;
    });
    _defineProperty(this, "isAndroid", _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID);
    _defineProperty(this, "isIOS", _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS);
    _defineProperty(this, "buildModelViewerUrl", function (fileInfos) {
      var url = Zakeke.config.baseUrl + 'ModelViewer';
      var link = new URL(url);
      var search = '';
      var _iterator8 = _createForOfIteratorHelper(fileInfos),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var file = _step8.value;
          if (file.format && file.arFileUrl) {
            var encodedUrl = encodeURIComponent(file.arFileUrl);
            var searchFile = '';
            switch (file.format) {
              case 'gltf':
              case 'glb':
                searchFile = 'gltf=' + encodedUrl;
                break;
              case 'usdz':
                searchFile = 'usdz=' + encodedUrl;
                break;
              case 'png':
                searchFile = 'poster=' + encodedUrl;
                break;
            }
            if (searchFile) search += (search ? '&' : '') + searchFile;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      search += '&arScale=' + (_this.zkScene.getARScale() ? 1 : 0);
      link.search += search;
      var pageUrl = link.toString();
      return pageUrl;
    });
    _defineProperty(this, "isSceneArEnabled", function () {
      if (_this.zkScene) return _this.zkScene.getAREnabled() || false;
      return false;
    });
    _defineProperty(this, "getPregeneratedARUrl", function (fileType) {
      var _this$zkScene4, _this$zkScene4$get, _this$zkScene4$get$fi;
      return (_this$zkScene4 = _this.zkScene) === null || _this$zkScene4 === void 0 ? void 0 : (_this$zkScene4$get = _this$zkScene4.get('arFiles')) === null || _this$zkScene4$get === void 0 ? void 0 : (_this$zkScene4$get$fi = _this$zkScene4$get.find(function (x) {
        return x.get('fileType') == fileType;
      })) === null || _this$zkScene4$get$fi === void 0 ? void 0 : _this$zkScene4$get$fi.get('url');
    });
    _defineProperty(this, "getQrCodeArUrl", /*#__PURE__*/function () {
      var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee61(device) {
        var fileInfos, url, glb, usdz;
        return _regeneratorRuntime().wrap(function _callee61$(_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              fileInfos = [];
              if (!(device == 'Android')) {
                _context62.next = 11;
                break;
              }
              _context62.t0 = _this.getPregeneratedARUrl('glb');
              if (_context62.t0) {
                _context62.next = 7;
                break;
              }
              _context62.next = 6;
              return _this.viewer.exportSceneToRemoteGLBAsync();
            case 6:
              _context62.t0 = _context62.sent;
            case 7:
              url = _context62.t0;
              if (url) fileInfos = [{
                format: 'gltf',
                arFileUrl: url
              }];
              _context62.next = 20;
              break;
            case 11:
              glb = _this.getPregeneratedARUrl('glb');
              usdz = _this.getPregeneratedARUrl('usdz');
              if (!(glb && usdz)) {
                _context62.next = 17;
                break;
              }
              fileInfos = [{
                format: 'glb',
                arFileUrl: glb
              }, {
                format: 'usdz',
                arFileUrl: usdz
              }];
              _context62.next = 20;
              break;
            case 17:
              _context62.next = 19;
              return _this.viewer.exportSceneToARAsync();
            case 19:
              fileInfos = _context62.sent;
            case 20:
              if (!(fileInfos.length == 0)) {
                _context62.next = 22;
                break;
              }
              return _context62.abrupt("return", '');
            case 22:
              return _context62.abrupt("return", _this.buildModelViewerUrl(fileInfos));
            case 23:
            case "end":
              return _context62.stop();
          }
        }, _callee61);
      }));
      return function (_x54) {
        return _ref62.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getMobileArUrl", /*#__PURE__*/function () {
      var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee62(onFlyArUrl) {
        var url;
        return _regeneratorRuntime().wrap(function _callee62$(_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              url = null;
              if (!_this.isSceneArOnTheFly()) {
                _context63.next = 7;
                break;
              }
              _context63.next = 4;
              return _this.getMobileLocalArUrl(onFlyArUrl);
            case 4:
              url = _context63.sent;
              _context63.next = 16;
              break;
            case 7:
              if (!_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
                _context63.next = 13;
                break;
              }
              _context63.next = 10;
              return _this.viewer.exportSceneToUsdzAsync(_this.zkScene.get('sceneID'), _this.selection.getCompositionHashCode());
            case 10:
              url = _context63.sent;
              _context63.next = 16;
              break;
            case 13:
              _context63.next = 15;
              return _this.viewer.exportSceneToRemoteGLBAsync(_this.zkScene.get('sceneID'), _this.selection.getCompositionHashCode());
            case 15:
              url = _context63.sent;
            case 16:
              return _context63.abrupt("return", url);
            case 17:
            case "end":
              return _context63.stop();
          }
        }, _callee62);
      }));
      return function (_x55) {
        return _ref63.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getMobileLocalArUrl", function (onFlyArUrl) {
      return new Promise(function (resolve) {
        if (_this.zkScene && _this.viewer) {
          var fileId = _this.zkScene.getSceneID();
          _this.viewer.getSceneRootUrl().then( /*#__PURE__*/function () {
            var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee63(rootUrl) {
              var url;
              return _regeneratorRuntime().wrap(function _callee63$(_context64) {
                while (1) switch (_context64.prev = _context64.next) {
                  case 0:
                    if (rootUrl) {
                      _context64.next = 2;
                      break;
                    }
                    return _context64.abrupt("return");
                  case 2:
                    if (!_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
                      _context64.next = 9;
                      break;
                    }
                    _context64.next = 5;
                    return _this.viewer.exportSceneToLocalUSDZAsync();
                  case 5:
                    url = _context64.sent;
                    if (!url) {
                      (0,lodash__WEBPACK_IMPORTED_MODULE_0__.reject)(url);
                    } else {
                      resolve(url);
                    }
                    _context64.next = 12;
                    break;
                  case 9:
                    if (onFlyArUrl) {
                      _context64.next = 11;
                      break;
                    }
                    throw new Error('no url defined for the ar on fly');
                  case 11:
                    _this.viewer.saveGlbOnDatabaseAsync(fileId).then(function () {
                      var link = new URL(onFlyArUrl);
                      var search = 'id=' + fileId;
                      search += '&rootUrl=' + encodeURIComponent(rootUrl);
                      search += '&productId=' + _this.product.id;
                      search += '&environment=' + _this.product.environment;
                      search += '&token=' + _this.token;
                      link.search += search;
                      var pageUrl = link.toString();
                      resolve(pageUrl);
                    });
                  case 12:
                  case "end":
                    return _context64.stop();
                }
              }, _callee63);
            }));
            return function (_x56) {
              return _ref64.apply(this, arguments);
            };
          }());
        }
      });
    });
    _defineProperty(this, "openArMobile", function (url) {
      if (_this.viewer && _this.zkScene) {
        if (_this.isSceneArOnTheFly() && _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID) window.open(url);else if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
          if (url && !_this.zkScene.getARScale()) url += '#allowsContentScaling=0';
          var anchor = document.createElement('a');
          anchor.setAttribute('rel', 'ar');
          anchor.setAttribute('href', url);
          anchor.appendChild(document.createElement('img'));
          anchor.click();
        } else if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID) {
          _3D_src__WEBPACK_IMPORTED_MODULE_2__.AndroidAR.openSceneViewer(url, function () {
            alert('Device not supported.');
          }, _this.zkScene.getARScale());
        }
      }
    });
    _defineProperty(this, "registerView", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee64() {
      return _regeneratorRuntime().wrap(function _callee64$(_context65) {
        while (1) switch (_context65.prev = _context65.next) {
          case 0:
            if (!(!_this.zkProduct || _this.isViewerMode)) {
              _context65.next = 2;
              break;
            }
            return _context65.abrupt("return");
          case 2:
            _context65.prev = 2;
            _context65.next = 5;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'viewscount/addview', {
              productID: _this.zkProduct.get('modelID'),
              environment: _this.zkProduct.get('environment'),
              ecommerceID: _this.settings.ecommerceID
            });
          case 5:
            _context65.next = 10;
            break;
          case 7:
            _context65.prev = 7;
            _context65.t0 = _context65["catch"](2);
            console.error('Failed registering view', _context65.t0);
          case 10:
          case "end":
            return _context65.stop();
        }
      }, _callee64, null, [[2, 7]]);
    })));
    // Manipulate scene
    _defineProperty(this, "getMeshIDbyName", function (name) {
      var _this$viewer, _this$viewer$getMeshB;
      return (_this$viewer = _this.viewer) === null || _this$viewer === void 0 ? void 0 : (_this$viewer$getMeshB = _this$viewer.getMeshByName(name)) === null || _this$viewer$getMeshB === void 0 ? void 0 : _this$viewer$getMeshB.id;
    });
    /**
     * Hide a mesh and its children and save the state
     * @param meshId The mesh and childs to hide
     */
    _defineProperty(this, "hideMeshAndSaveState", function (meshId) {
      if (_this.viewer.scene) {
        var rootMesh = _this.viewer.getMeshByID(meshId);

        // Add mesh and all submesh visibility to previousMeshVisibileStates
        if (rootMesh) {
          var meshes = [rootMesh].concat(_toConsumableArray(rootMesh.getChildMeshes()));
          var _iterator9 = _createForOfIteratorHelper(meshes),
            _step9;
          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var mesh = _step9.value;
              _this.previousMeshesVisibleStates[mesh.id] = mesh.isVisible;
              mesh.isVisible = false;
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
          _this.viewer.setRenderingNeeded();
        }
      }
    });
    /**
     * Restore a mesh visibility state from a previous saved one (see hideMeshAndSaveState)
     * @param meshId The mesh and childs to show
     */
    _defineProperty(this, "restoreMeshVisibility", function (meshId) {
      if (_this.viewer.scene) {
        var rootMesh = _this.viewer.getMeshByID(meshId);

        // Add mesh and all submesh visibility to previousMeshVisibileStates
        if (rootMesh && _this.previousMeshesVisibleStates[rootMesh.id] !== undefined) {
          var meshes = [rootMesh].concat(_toConsumableArray(rootMesh.getChildMeshes()));
          var _iterator10 = _createForOfIteratorHelper(meshes),
            _step10;
          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var mesh = _step10.value;
              mesh.isVisible = _this.previousMeshesVisibleStates[mesh.id];
              delete _this.previousMeshesVisibleStates[mesh.id];
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
          _this.viewer.setRenderingNeeded();
        }
      }
    });
    /**
     * Change opacity for a specific mesh
     * @param meshId The mesh to change the opacity
     * @param opacity The opacity to set
     */
    _defineProperty(this, "setMeshDesignVisibility", function (meshId, visible) {
      if (_this.viewer) {
        _this.viewer.setDesignVisibility(meshId, visible);
        _this.viewer.setRenderingNeeded();
      }
    });
    // Events
    _defineProperty(this, "addFocusAttributesListener", function (listenerFunction) {
      if (_this.viewer) _this.viewer.addFocusAttributesListener(listenerFunction);
    });
    _defineProperty(this, "clearListeners", function () {
      if (_this.viewer) _this.viewer.clearListeners();
    });
    _defineProperty(this, "setCameraLocked", function (isBlocked) {
      return _this.viewer.setCameraLocked(isBlocked);
    });
    _defineProperty(this, "isSceneTryOnEnabled", function () {
      var _this$zkScene$getTryO;
      if (_this.viewer) if (_this.zkScene) return (_this$zkScene$getTryO = _this.zkScene.getTryOnEnabled()) !== null && _this$zkScene$getTryO !== void 0 ? _this$zkScene$getTryO : false;
      return false;
    });
    _defineProperty(this, "getTryOnUrl", function (tryOnUrl) {
      return new Promise(function (resolve) {
        if (_this.zkScene && _this.viewer) {
          var fileId = _this.zkScene.getSceneID();
          _this.viewer.getSceneRootUrl().then(function (rootUrl) {
            if (!rootUrl) return;
            var attachmentPoint = 'noseBridge';

            // Salvo le mesh su IndexedDB
            _this.viewer.saveVisibleMeshesOnDatabaseAsync(fileId).then(function () {
              var url = tryOnUrl !== null && tryOnUrl !== void 0 ? tryOnUrl : 'https://zakekecdn.blob.core.windows.net/cdn/c/tryon/index.html';
              var link = new URL(url);
              var search = 'id=' + fileId;
              search += '&rootUrl=' + encodeURIComponent(rootUrl);
              search += '&attachmentPoint=' + attachmentPoint;
              search += '&productId=' + _this.zkProduct.get('modelID');
              search += '&environment=' + _this.zkProduct.get('environment');
              search += '&token=' + _this.token;
              link.search += search;
              var pageUrl = link.toString();
              resolve(pageUrl);
            });
          });
        }
      });
    });
    _defineProperty(this, "getDisableTextColors", function () {
      try {
        var _get$at$get$get, _get$at$get;
        var disableTextColors = (_get$at$get$get = (_get$at$get = _this.zkProduct.get('printTypes').at(0).get('printTypeRestrictions')) === null || _get$at$get === void 0 ? void 0 : _get$at$get.get('disableTextColors')) !== null && _get$at$get$get !== void 0 ? _get$at$get$get : false;
        return disableTextColors;
      } catch (ex) {
        console.log(ex);
        throw 'Failed loading restrictions';
      }
    });
    _defineProperty(this, "getTextColors", function () {
      try {
        var _get$at$get$get2, _get$at$get2;
        var textColors = (_get$at$get$get2 = (_get$at$get2 = _this.zkProduct.get('printTypes').at(0).get('printTypeRestrictions')) === null || _get$at$get2 === void 0 ? void 0 : _get$at$get2.get('textColors')) !== null && _get$at$get$get2 !== void 0 ? _get$at$get$get2 : [];
        var defaultColor = {
          colorCode: _this.defaultColor,
          isDefault: true
        };
        if (!textColors.find(function (color) {
          return color.colorCode === defaultColor.colorCode;
        })) textColors.push(defaultColor);
        return textColors;
      } catch (ex) {
        console.log(ex);
        throw 'Failed loading restrictions';
      }
    });
    _defineProperty(this, "getDefaultColor", function () {
      try {
        var _get$at$get$get3, _get$at$get3;
        var defaultColor = (_get$at$get$get3 = (_get$at$get3 = _this.zkProduct.get('printTypes').at(0).get('printTypeRestrictions')) === null || _get$at$get3 === void 0 ? void 0 : _get$at$get3.get('defaultColor')) !== null && _get$at$get$get3 !== void 0 ? _get$at$get$get3 : '#000000';
        return defaultColor;
      } catch (ex) {
        console.log(ex);
        throw 'Failed loading restrictions';
      }
    });
    _defineProperty(this, "saveComposition", /*#__PURE__*/function () {
      var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee65(customPreviewSize, legacyScreenshot) {
        var _this$zkScene5, _customPreviewSize$cu, _customPreviewSize$cu2;
        var buyScreenshotCamera, data, design, designItems, itemsNotPlaceholders, nonStaticElementsCount;
        return _regeneratorRuntime().wrap(function _callee65$(_context66) {
          while (1) switch (_context66.prev = _context66.next) {
            case 0:
              console.log('Saving...');
              buyScreenshotCamera = (_this$zkScene5 = _this.zkScene) === null || _this$zkScene5 === void 0 ? void 0 : _this$zkScene5.get('cameraLocations').find(function (x) {
                var _x$get2;
                return ((_x$get2 = x.get('name')) === null || _x$get2 === void 0 ? void 0 : _x$get2.toLowerCase()) === 'buy_screenshot_camera';
              });
              if (!buyScreenshotCamera) _this.viewer.restoreCameraState();
              _context66.next = 5;
              return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.sleep)(1);
            case 5:
              _context66.next = 7;
              return _this.viewer.getSceneContentScreenshotAsync((_customPreviewSize$cu = customPreviewSize === null || customPreviewSize === void 0 ? void 0 : customPreviewSize.customCartPreviewHeight) !== null && _customPreviewSize$cu !== void 0 ? _customPreviewSize$cu : _this.previewWidth, (_customPreviewSize$cu2 = customPreviewSize === null || customPreviewSize === void 0 ? void 0 : customPreviewSize.customCartPreviewWidth) !== null && _customPreviewSize$cu2 !== void 0 ? _customPreviewSize$cu2 : _this.previewHeight, 0, _this.zkCurrentTemplate, legacyScreenshot, buyScreenshotCamera);
            case 7:
              data = _context66.sent;
              _this.composition.set('previewImageData', data);

              // Save composition
              if (!(!_this.composition.get('isTemplate') && _this.zkCurrentTemplate)) {
                _context66.next = 23;
                break;
              }
              design = _this.zkCurrentTemplate;
              designItems = design.get('designItems');
              itemsNotPlaceholders = designItems.filter(function (designItem) {
                return !JSON.parse(designItem.get('json'))[1].data.isTemplateElement;
              });
              itemsNotPlaceholders.forEach(function (item) {
                if (item.get('areas').length > 0 && !_this.isAreaVisible(item.get('areas').at(0).get('sideID'))) designItems.remove(item);
              });
              nonStaticElementsCount = designItems === null || designItems === void 0 ? void 0 : designItems.toArray().map(function (designItem) {
                return !designItem.get('constraints') || designItem.get('constraints').get('canResize') || designItem.get('constraints').get('canMove') || designItem.get('constraints').get('canDelete') || designItem.get('constraints').get('canRotate') || designItem.get('constraints').get('canEdit') || designItem.get('constraints').get('isPrintable')
                //  && designItem.get('areas').length > 0 &&
                // this.isAreaVisible(designItem.get('areas').at(0).get('sideID'))
                ;
              }).filter(function (x) {
                return x;
              }).length;
              if (!(nonStaticElementsCount > 0)) {
                _context66.next = 20;
                break;
              }
              _context66.next = 18;
              return _this.saveDesignBackbone();
            case 18:
              _context66.next = 21;
              break;
            case 20:
              _this.composition.set('designDocID', null);
            case 21:
              _context66.next = 24;
              break;
            case 23:
              _this.composition.set('designDocID', null);
            case 24:
              _context66.next = 26;
              return _this.saveCompositionBackbone();
            case 26:
              console.log('Composition saved!');
            case 27:
            case "end":
              return _context66.stop();
          }
        }, _callee65);
      }));
      return function (_x57, _x58) {
        return _ref66.apply(this, arguments);
      };
    }());
    _defineProperty(this, "bootstrapComposition", /*#__PURE__*/function () {
      var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee66(composition) {
        return _regeneratorRuntime().wrap(function _callee66$(_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              _this.selection = Zakeke.ComposerSelection.CreateComposerSelection(_this.zkProduct);
              _this.composition = composition;
              _context67.next = 4;
              return _this.internalLoadComposition(_this.composition.id);
            case 4:
              if (!_this.currentCompositionInfo) _this.currentCompositionInfo = {
                compositionId: '',
                compositionName: '',
                compositionTags: []
              };
              _this.currentCompositionInfo.compositionId = _this.compositionId;
              _this.currentCompositionInfo.compositionName = _this.composition.get('name');
              _this.currentCompositionInfo.compositionTags = _this.composition.get('tags');
            case 8:
            case "end":
              return _context67.stop();
          }
        }, _callee66);
      }));
      return function (_x59) {
        return _ref67.apply(this, arguments);
      };
    }());
    _defineProperty(this, "loadSavedComposition", /*#__PURE__*/function () {
      var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee67(docID) {
        var _this$savedCompositio;
        var composition;
        return _regeneratorRuntime().wrap(function _callee67$(_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              composition = (_this$savedCompositio = _this.savedCompositions) === null || _this$savedCompositio === void 0 ? void 0 : _this$savedCompositio.find(function (x) {
                return x.docID == docID;
              });
              if (!composition) {
                _context68.next = 4;
                break;
              }
              _context68.next = 4;
              return _this.bootstrapComposition(new MPlaza.Composition(composition));
            case 4:
            case "end":
              return _context68.stop();
          }
        }, _callee67);
      }));
      return function (_x60) {
        return _ref68.apply(this, arguments);
      };
    }());
    _defineProperty(this, "updateSavedCompositions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee68() {
      var savedCompositions, themeCompositions;
      return _regeneratorRuntime().wrap(function _callee68$(_context69) {
        while (1) switch (_context69.prev = _context69.next) {
          case 0:
            _context69.next = 2;
            return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.baseApiUrl + "compositiondocs/product/".concat(_this.zkProduct.get('modelID')), {
              params: {
                draft: true
              }
            });
          case 2:
            savedCompositions = _context69.sent.data;
            _this.savedCompositions = savedCompositions;
            if (savedCompositions) {
              themeCompositions = _this.themeCompositionsFromSavedCompositions(savedCompositions);
              _this.themeCompositions = themeCompositions;
            }
            _this.trigger('change');
          case 6:
          case "end":
            return _context69.stop();
        }
      }, _callee68);
    })));
    _defineProperty(this, "themeCompositionsFromSavedCompositions", function (compositions) {
      var themeCompositions = compositions.map(function (composition) {
        return {
          name: composition.name,
          docID: composition.docID,
          previewImageUrl: composition.previewImageUrl,
          tags: composition.tags
        };
      });
      return themeCompositions;
    });
    _defineProperty(this, "saveDraftsComposition", /*#__PURE__*/function () {
      var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee69(name, tags, isCopy) {
        return _regeneratorRuntime().wrap(function _callee69$(_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              _this.composition.set('name', name);
              _this.composition.set('tags', tags);
              _this.composition.set('isDraft', true);
              if (!isCopy) {
                _context70.next = 8;
                break;
              }
              _context70.next = 6;
              return _this.saveCompositionCopy();
            case 6:
              _context70.next = 10;
              break;
            case 8:
              _context70.next = 10;
              return _this.saveComposition(undefined);
            case 10:
              return _context70.abrupt("return", _this.updateSavedCompositions());
            case 11:
            case "end":
              return _context70.stop();
          }
        }, _callee69);
      }));
      return function (_x61, _x62, _x63) {
        return _ref70.apply(this, arguments);
      };
    }());
    _defineProperty(this, "deleteSavedComposition", /*#__PURE__*/function () {
      var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee70(docId) {
        return _regeneratorRuntime().wrap(function _callee70$(_context71) {
          while (1) switch (_context71.prev = _context71.next) {
            case 0:
              _context71.next = 2;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi["delete"](Zakeke.config.baseApiUrl + "compositiondocs/".concat(docId));
            case 2:
              _this.updateSavedCompositions();
            case 3:
            case "end":
              return _context71.stop();
          }
        }, _callee70);
      }));
      return function (_x64) {
        return _ref71.apply(this, arguments);
      };
    }());
    _defineProperty(this, "applyTemplate", /*#__PURE__*/function () {
      var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee71(templateGroupCompositionId) {
        var result, compositionItems, compositionItemsFromTemplate, newCompositionItems;
        return _regeneratorRuntime().wrap(function _callee71$(_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              _context72.prev = 0;
              _context72.next = 3;
              return _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get('proxycompositions/' + templateGroupCompositionId, {
                params: {
                  template: true
                }
              });
            case 3:
              _context72.next = 5;
              return _context72.sent.data;
            case 5:
              result = _context72.sent;
              compositionItems = _this.composition.get('compositionItems');
              compositionItemsFromTemplate = new MPlaza.CompositionItems(result.compositionItems);
              newCompositionItems = new MPlaza.CompositionItems();
              compositionItems.toArray().forEach(function (currentCompositionItem) {
                var templateCompositionItem = compositionItemsFromTemplate.find(function (compositionItem) {
                  return compositionItem.get('attributeID') === currentCompositionItem.get('attributeID');
                });
                newCompositionItems.add(templateCompositionItem !== null && templateCompositionItem !== void 0 ? templateCompositionItem : currentCompositionItem);
              });
              _this.composition.set('compositionItems', newCompositionItems);

              // await this.bootstrapComposition(this.composition);
              _this.selection.setupOnComposition(_this.composition);
              _context72.next = 14;
              return _this.sync3DAndPlatformSelectionWithCurrentSelection();
            case 14:
              _context72.next = 19;
              break;
            case 16:
              _context72.prev = 16;
              _context72.t0 = _context72["catch"](0);
              console.error(_context72.t0);
            case 19:
            case "end":
              return _context72.stop();
          }
        }, _callee71, null, [[0, 16]]);
      }));
      return function (_x65) {
        return _ref72.apply(this, arguments);
      };
    }());
  }
  _createClass(ZakekeEnvironment, [{
    key: "internalProduct",
    get: function get() {
      return this.zkProduct;
    }
  }, {
    key: "internalScene",
    get: function get() {
      return this.zkScene;
    }
  }, {
    key: "internalCurrentTemplate",
    get: function get() {
      return this.zkCurrentTemplate;
    }
  }, {
    key: "isFullscreenMode",
    get: function get() {
      var doc = document;
      return Boolean(doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement);
    }
  }, {
    key: "isViewerReady",
    get: function get() {
      return !!this.viewer;
    }
  }, {
    key: "addHotjarScript",
    value: function addHotjarScript(siteID) {
      if (siteID && siteID.length > 0 && this.platform && this.platform.toLowerCase() !== 'preview') {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = "(function(h,o,t,j,a,r){\n                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};\n                    h._hjSettings={hjid:".concat(siteID, ",hjsv:6};\n                    a=o.getElementsByTagName('head')[0];\n                    r=o.createElement('script');r.async=1;\n                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;\n                    a.appendChild(r);\n                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');");
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    }
  }, {
    key: "addGoogleTagManagerID",
    value: function addGoogleTagManagerID(siteID) {
      if (siteID && siteID.length > 0 && this.platform && this.platform.toLowerCase() !== 'preview') {
        $('head').append('<script>' + "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n                })(window,document,'script','dataLayer','".concat(siteID, "')") + '</script>');
        var noscript = document.createElement('noscript');
        var iframe = document.createElement('iframe');
        iframe.src = "https://www.googletagmanager.com/ns.html?id=".concat(siteID);
        iframe.height = '0';
        iframe.width = '0';
        iframe.style.cssText = 'display:none;visibility:hidden';
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);
      }
    }
  }, {
    key: "setQuantity",
    value: function setQuantity(quantity) {
      // Adapt quantity to rules
      var quantityRule = this.zkProduct.get('quantityRule');
      if (quantityRule) {
        var min = quantityRule.get('minQuantity');
        var max = quantityRule.get('maxQuantity');
        var step = quantityRule.get('step');
        if (min && quantity < min) quantity = min;
        if (max && quantity > max) quantity = max;
        if (step) {
          quantity = Math.round(quantity / step) * step;
          if (quantity < step) quantity = step;
        }
      }
      this.quantity = quantity;
      this.trigger('change');
      this.updatePrice();
    }
  }, {
    key: "createStep",
    value: function createStep(zkStep, groupSelection) {
      var _zkStep$get,
        _zkStep$get2,
        _this2 = this;
      var step = new _models__WEBPACK_IMPORTED_MODULE_11__.Step();
      step.id = zkStep.get('stepID');
      step.guid = zkStep.get('stepGuid');
      step.name = (_zkStep$get = zkStep.get('name')) !== null && _zkStep$get !== void 0 ? _zkStep$get : '';
      step.cameraLocationID = (_zkStep$get2 = zkStep.get('cameraLocationID')) !== null && _zkStep$get2 !== void 0 ? _zkStep$get2 : null;
      step.displayOrder = zkStep.get('displayOrder');

      // The attributes in a step must have the group ID too or the group selection will be empty
      var _loop7 = function _loop7() {
        var zakekeAttribute = _this2.zkProduct.get('attributes').at(i);
        var attributeSelection = groupSelection.get('attributes').find(function (attr) {
          return attr.get('attributeID') == zakekeAttribute.get('attributeID');
        });
        if (attributeSelection && zakekeAttribute.get('stepID') == zkStep.get('stepID')) {
          var attribute = _this2.createAttributeFromSelection(attributeSelection);
          step.attributes.push(attribute);
        }
      };
      for (var i = 0; i < this.zkProduct.get('attributes').length; i++) {
        _loop7();
      }
      step.attributes.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });

      // Template groups
      var _loop8 = function _loop8() {
        var zakekeTemplateGroup = _this2.zkProduct.get('templateGroups').at(k);
        var templateGroupSelection = groupSelection.get('templateGroups').find(function (templGr) {
          return templGr.get('templateGroupID') == zakekeTemplateGroup.get('templateGroupID');
        });
        if (templateGroupSelection && zakekeTemplateGroup.get('stepID') == zkStep.get('stepID')) {
          var templateGroup = _this2.createTemplateGroupFromSelection(templateGroupSelection);
          step.templateGroups.push(templateGroup);
        }
      };
      for (var k = 0; k < this.zkProduct.get('templateGroups').length; k++) {
        _loop8();
      }
      step.templateGroups.sort(function (a, b) {
        return a.displayOrder - b.displayOrder;
      });
      return step;
    }
  }, {
    key: "setCamera",
    value: function setCamera(cameraLocationId, onlyAngleOfView, animate) {
      this.viewer.setCameraLocation(cameraLocationId, onlyAngleOfView, animate);
      this.lastCameraLocation = cameraLocationId;
    }
  }, {
    key: "getCameraByName",
    value: function getCameraByName(name) {
      var _this$zkScene6;
      var location = (_this$zkScene6 = this.zkScene) === null || _this$zkScene6 === void 0 ? void 0 : _this$zkScene6.get('cameraLocations').find(function (x) {
        return x.get('name') == name;
      });
      return location;
    }
  }, {
    key: "setCameraLocation",
    value: function setCameraLocation(name) {
      var animate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var location = this.getCameraByName(name);
      if (!location) throw new Error("Camera with name ".concat(name, " does not exists."));
      this.viewer.setCameraLocation(location.get('locationID'), false, animate);
      this.lastCameraLocation = location.get('locationID');
    }
  }, {
    key: "getDesignItemsInfo",
    value: function getDesignItemsInfo() {
      var items = [];
      if (this.viewer) {
        var _this$viewer$getDesig, _this$viewer$getDesig2;
        items = (_this$viewer$getDesig = (_this$viewer$getDesig2 = this.viewer.getDesignItemsInfo()) === null || _this$viewer$getDesig2 === void 0 ? void 0 : _this$viewer$getDesig2.map(function (item) {
          return item instanceof MPlaza.ImageItemInfo ? new _models__WEBPACK_IMPORTED_MODULE_11__.ImageItem(item) : new _models__WEBPACK_IMPORTED_MODULE_11__.TextItem(item);
        })) !== null && _this$viewer$getDesig !== void 0 ? _this$viewer$getDesig : [];
      }
      return items;
    }
  }, {
    key: "isAreaVisible",
    value: function isAreaVisible(areaId) {
      // Get the mesh side
      // in this case areaId is sideId
      var meshSides = this.zkProduct.get('scenes').at(0).get('meshSides').filter(function (x) {
        return x.get('sideID') == areaId;
      });
      var _iterator11 = _createForOfIteratorHelper(meshSides),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var meshSide = _step11.value;
          var meshId = meshSide.get('meshID');
          if (meshId) {
            var mesh = this.viewer.scene.getMeshByID(meshId);
            if (mesh && mesh.isVisible) return true;
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      return false;
    }
  }, {
    key: "addItemText",
    value: function () {
      var _addItemText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee72(settings, areaId) {
        var font;
        return _regeneratorRuntime().wrap(function _callee72$(_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              if (!this.viewer) {
                _context73.next = 12;
                break;
              }
              // First download the font
              font = this.fonts.find(function (x) {
                return x.name === settings.fontFamily;
              });
              if (!font) {
                _context73.next = 9;
                break;
              }
              _context73.next = 5;
              return (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([font]);
            case 5:
              this.viewer.addDesignItemText(_objectSpread(_objectSpread({}, settings), {}, {
                content: settings.text
              }), areaId);
              this.renderDesign();
              _context73.next = 10;
              break;
            case 9:
              console.warn("No font found for ".concat(settings.fontFamily));
            case 10:
              _context73.next = 13;
              break;
            case 12:
              throw 'Called add item text but no viewer or viewer not ready';
            case 13:
            case "end":
              return _context73.stop();
          }
        }, _callee72, this);
      }));
      function addItemText(_x66, _x67) {
        return _addItemText.apply(this, arguments);
      }
      return addItemText;
    }()
  }, {
    key: "setCameraPivot",
    value: function setCameraPivot(meshID) {
      this.viewer.setCameraPivot(meshID);
    }
  }, {
    key: "resetCameraPivot",
    value: function resetCameraPivot() {
      this.viewer.setCameraPivot(null);
    }
  }, {
    key: "setCameraZoomEnabled",
    value: function setCameraZoomEnabled(enabled) {
      this.viewer.setCameraZoomEnabled(enabled);
    }
  }, {
    key: "setCameraByName",
    value: function setCameraByName(name, onlyAngleOfView, animate) {
      if (this.zkScene) {
        var location = this.zkScene.get('cameraLocations').find(function (x) {
          return x.get('name') == name;
        });
        if (location) this.viewer.setCameraLocation(location.get('locationID'), onlyAngleOfView, animate);
      }
    }
  }, {
    key: "findObjectByName",
    value: function findObjectByName(name) {
      if (this.viewer && this.viewer.scene) return this.viewer.scene.meshes.find(function (x) {
        return x.name == name;
      });else return null;
    }
  }, {
    key: "hightlightGroup",
    value: function hightlightGroup(groupId) {
      var _this$viewer2;
      (_this$viewer2 = this.viewer) === null || _this$viewer2 === void 0 ? void 0 : _this$viewer2.highlightGroupByID(groupId);
    }
  }, {
    key: "highlightAttribute",
    value: function highlightAttribute(attributeId) {
      var _this$viewer3;
      (_this$viewer3 = this.viewer) === null || _this$viewer3 === void 0 ? void 0 : _this$viewer3.highlightAttributeByID(attributeId);
    }
  }]);
  return ZakekeEnvironment;
}();

/***/ }),

/***/ "./src/exceptions.tsx":
/*!****************************!*\
  !*** ./src/exceptions.tsx ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Exception": () => (/* binding */ Exception),
/* harmony export */   "NonSquarePixelException": () => (/* binding */ NonSquarePixelException),
/* harmony export */   "ParametersParseFailException": () => (/* binding */ ParametersParseFailException),
/* harmony export */   "UnsupportedPlatformException": () => (/* binding */ UnsupportedPlatformException),
/* harmony export */   "UploadFailedExpection": () => (/* binding */ UploadFailedExpection)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
// Exceptions
var Exception = /*#__PURE__*/_createClass(function Exception(message) {
  _classCallCheck(this, Exception);
  this.message = message;
});
var ParametersParseFailException = /*#__PURE__*/function (_Exception) {
  _inherits(ParametersParseFailException, _Exception);
  var _super = _createSuper(ParametersParseFailException);
  function ParametersParseFailException(parameter) {
    var _this;
    _classCallCheck(this, ParametersParseFailException);
    _this = _super.call(this, "Failed parsing parameters: " + parameter);
    _this.parameter = parameter;
    return _this;
  }
  return _createClass(ParametersParseFailException);
}(Exception);
var UnsupportedPlatformException = /*#__PURE__*/function (_Exception2) {
  _inherits(UnsupportedPlatformException, _Exception2);
  var _super2 = _createSuper(UnsupportedPlatformException);
  function UnsupportedPlatformException(platform) {
    var _this2;
    _classCallCheck(this, UnsupportedPlatformException);
    _this2 = _super2.call(this, "Platform " + platform.toString() + " not supported.");
    _this2.platform = platform;
    return _this2;
  }
  return _createClass(UnsupportedPlatformException);
}(Exception);
var UploadFailedExpection = /*#__PURE__*/function (_Exception3) {
  _inherits(UploadFailedExpection, _Exception3);
  var _super3 = _createSuper(UploadFailedExpection);
  function UploadFailedExpection() {
    _classCallCheck(this, UploadFailedExpection);
    return _super3.call(this, "Upload failed.");
  }
  return _createClass(UploadFailedExpection);
}(Exception);
var NonSquarePixelException = /*#__PURE__*/function (_Exception4) {
  _inherits(NonSquarePixelException, _Exception4);
  var _super4 = _createSuper(NonSquarePixelException);
  function NonSquarePixelException() {
    _classCallCheck(this, NonSquarePixelException);
    return _super4.call(this, "The image is not supported (non-square pixels)");
  }
  return _createClass(NonSquarePixelException);
}(Exception);

/***/ }),

/***/ "./src/fontsManager.ts":
/*!*****************************!*\
  !*** ./src/fontsManager.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "downloadFontsOfDesign": () => (/* binding */ downloadFontsOfDesign),
/* harmony export */   "loadFonts": () => (/* binding */ loadFonts)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/** 
 * Download a list of font families so that are available for the browser
 */
function loadFonts(_x) {
  return _loadFonts.apply(this, arguments);
}

/**
 * Downlod all fonts used in a design
 * 
 * @param design Design to load fonts for
 * @param downloadedFonts A list of downloaded fonts
 */
function _loadFonts() {
  _loadFonts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fontFamilies) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            WebFont.load({
              timeout: 200000,
              custom: {
                families: fontFamilies.map(function (x) {
                  return x.name + (x.variations && x.variations != "" ? ":" + x.variations : "");
                }),
                urls: fontFamilies.map(function (x) {
                  return x.cssUrl;
                })
              },
              active: function active() {
                resolve();
              }
            });
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _loadFonts.apply(this, arguments);
}
function downloadFontsOfDesign(_x2, _x3) {
  return _downloadFontsOfDesign.apply(this, arguments);
}
function _downloadFontsOfDesign() {
  _downloadFontsOfDesign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(design, downloadedFonts) {
    var fonts, _iterator, _step, item, data, attributes, fontFamily, fontFamilies;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          // Get all the fonts first
          fonts = [];
          _iterator = _createForOfIteratorHelper(design.get("designItems").models);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              item = _step.value;
              data = JSON.parse(item.get("json"));
              attributes = data[1]; //Get the global font family or from the first letter (in case of curved text)
              fontFamily = attributes.fontFamily || (attributes.children && attributes.children.length > 0 && attributes.children[0].length > 1 ? attributes.children[0][1].fontFamily : null);
              if (fontFamily) fonts.push(fontFamily.replace(/"/g, ""));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          fontFamilies = fonts.map(function (fontName) {
            return downloadedFonts.find(function (fontFamily) {
              return fontFamily.name == fontName;
            }) || null;
          }).filter(function (x) {
            return x != null;
          });
          if (!(fontFamilies.length > 0)) {
            _context2.next = 7;
            break;
          }
          _context2.next = 7;
          return loadFonts(fontFamilies);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _downloadFontsOfDesign.apply(this, arguments);
}

/***/ }),

/***/ "./src/helpers.tsx":
/*!*************************!*\
  !*** ./src/helpers.tsx ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Browser": () => (/* binding */ Browser),
/* harmony export */   "IS_ANDROID": () => (/* binding */ IS_ANDROID),
/* harmony export */   "IS_AR_DEVICE_COMPLIANT": () => (/* binding */ IS_AR_DEVICE_COMPLIANT),
/* harmony export */   "IS_IOS": () => (/* binding */ IS_IOS),
/* harmony export */   "Pagination": () => (/* binding */ Pagination),
/* harmony export */   "StringHelper": () => (/* binding */ StringHelper),
/* harmony export */   "T": () => (/* binding */ T),
/* harmony export */   "ascComparator": () => (/* binding */ ascComparator),
/* harmony export */   "compare": () => (/* binding */ compare),
/* harmony export */   "copy": () => (/* binding */ copy),
/* harmony export */   "dataURLtoFile": () => (/* binding */ dataURLtoFile),
/* harmony export */   "getPlatformSettings": () => (/* binding */ getPlatformSettings),
/* harmony export */   "hex2rgb": () => (/* binding */ hex2rgb),
/* harmony export */   "hslToRgb": () => (/* binding */ hslToRgb),
/* harmony export */   "hsvToRgb": () => (/* binding */ hsvToRgb),
/* harmony export */   "hue2rgb": () => (/* binding */ hue2rgb),
/* harmony export */   "iOS": () => (/* binding */ iOS),
/* harmony export */   "isPlatformCode": () => (/* binding */ isPlatformCode),
/* harmony export */   "isValidJSON": () => (/* binding */ isValidJSON),
/* harmony export */   "matchCodes": () => (/* binding */ matchCodes),
/* harmony export */   "rgb2hex": () => (/* binding */ rgb2hex),
/* harmony export */   "rgbToHsl": () => (/* binding */ rgbToHsl),
/* harmony export */   "rgbToHsv": () => (/* binding */ rgbToHsv),
/* harmony export */   "sleep": () => (/* binding */ sleep),
/* harmony export */   "uuid": () => (/* binding */ uuid)
/* harmony export */ });
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var T = /*#__PURE__*/function () {
  function T() {
    _classCallCheck(this, T);
  }
  _createClass(T, null, [{
    key: "_",
    value: function _(str, domain) {
      var _this$translations;
      if ((_this$translations = this.translations) !== null && _this$translations !== void 0 && _this$translations.statics) {
        var _this$translations2;
        var keys = Array.from((_this$translations2 = this.translations) === null || _this$translations2 === void 0 ? void 0 : _this$translations2.statics.keys());
        for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
          var _key = _keys[_i];
          if (_key.toLowerCase() === str.toLowerCase()) return this.translations.statics.get(_key);
        }
      }
      var gt = window.gt;
      return gt ? gt.dgettext(domain, str) : str;
    }
  }, {
    key: "_d",
    value: function _d(str) {
      var _this$translations3;
      var string = str;
      if ((_this$translations3 = this.translations) !== null && _this$translations3 !== void 0 && _this$translations3.dynamics) {
        var _this$translations4;
        var keys = Array.from((_this$translations4 = this.translations) === null || _this$translations4 === void 0 ? void 0 : _this$translations4.dynamics.keys());
        for (var _i2 = 0, _keys2 = keys; _i2 < _keys2.length; _i2++) {
          var _key2 = _keys2[_i2];
          if (_key2.toLowerCase() === str.toLowerCase()) {
            if (this.translations.dynamics.get(_key2)) string = this.translations.dynamics.get(_key2);
          }
        }
      }
      return string;
    }
  }]);
  return T;
}();
_defineProperty(T, "translations", null);
function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
}
var StringHelper = /*#__PURE__*/function () {
  function StringHelper() {
    _classCallCheck(this, StringHelper);
  }
  _createClass(StringHelper, null, [{
    key: "padLeft",
    value: function padLeft(str, width, _char) {
      var newStr = str.toString();
      for (var i = 0; i < width - newStr.length; i++) newStr = _char + newStr;
      return newStr;
    }
  }, {
    key: "padRight",
    value: function padRight(str, width, _char2) {
      var newStr = str.toString();
      for (var i = 0; i < width - newStr.length; i++) newStr = newStr + _char2;
      return newStr;
    }
  }, {
    key: "format",
    value: function format(str) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key3 = 1; _key3 < _len; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      return args.reduce(function (prev, current, idx) {
        return prev.replace("{".concat(idx, "}"), current);
      }, str);
    }
  }, {
    key: "camelToSnake",
    value: function camelToSnake(o) {
      var newO = {},
        origKey,
        newKey,
        value;
      if (o instanceof Array) {
        newO = [];
        for (origKey in o) {
          value = o[origKey];
          if (_typeof(value) === 'object') {
            value = StringHelper.camelToSnake(value);
          }
          newO.push(value);
        }
      } else {
        newO = {};
        for (origKey in o) {
          if (o.hasOwnProperty(origKey)) {
            newKey = origKey.replace(/\.?([A-Z]+)/g, function (x, y) {
              return '_' + y.toLowerCase();
            }).replace(/^_/, '');
            value = o[origKey];
            if (value) if (value && value instanceof Array || value !== null && value.constructor === Object) {
              value = StringHelper.camelToSnake(value);
            }
            newO[newKey] = value;
          }
        }
      }
      return newO;
    }
  }, {
    key: "pascalToCamel",
    value: function pascalToCamel(o) {
      var newO = {},
        origKey,
        newKey,
        value;
      if (o instanceof Array) {
        newO = [];
        for (origKey in o) {
          value = o[origKey];
          if (_typeof(value) === 'object') {
            value = StringHelper.pascalToCamel(value);
          }
          newO.push(value);
        }
      } else {
        newO = {};
        for (origKey in o) {
          if (o.hasOwnProperty(origKey)) {
            newKey = origKey.replace(/^([A-Z])/g, function (x, y) {
              return y.toLowerCase();
            });
            value = o[origKey];
            if (value) if (value && value instanceof Array || value !== null && value.constructor === Object) {
              value = StringHelper.pascalToCamel(value);
            }
            newO[newKey] = value;
          }
        }
      }
      return newO;
    }
  }]);
  return StringHelper;
}();
var Browser = /*#__PURE__*/function () {
  function Browser() {
    _classCallCheck(this, Browser);
  }
  _createClass(Browser, null, [{
    key: "openWindow",
    value: function openWindow(url, width, height) {
      return window.open(url, 'width=' + width + ',height=' + height + ';menubar=no,location=no,status=no,toolbar=no');
    }
  }]);
  return Browser;
}();
var Pagination = /*#__PURE__*/function () {
  function Pagination() {
    _classCallCheck(this, Pagination);
  }
  _createClass(Pagination, null, [{
    key: "nextPage",
    value: function nextPage(headerLink) {
      var matches = /.*<(.*)>; rel="next".*/.exec(headerLink);
      if (!matches) {
        return null;
      }
      return matches[1];
    }
  }]);
  return Pagination;
}();
function hex2rgb(c) {
  var c = c.substring(1); // strip #
  var rgb = parseInt(c, 16); // convert rrggbb to decimal
  var r = rgb >> 16 & 0xff; // extract red
  var g = rgb >> 8 & 0xff; // extract green
  var b = rgb >> 0 & 0xff; // extract blue

  return {
    r: r,
    g: g,
    b: b
  };
}
function rgb2hex(r, g, b) {
  return '#' + ('0' + parseInt(r).toString(16)).slice(-2) + ('0' + parseInt(g).toString(16)).slice(-2) + ('0' + parseInt(b).toString(16)).slice(-2);
}
function rgbToHsl(r, g, b) {
  r /= 255, g /= 255, b /= 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return [h, s, l];
}
function hslToRgb(h, s, l) {
  var r, g, b;
  if (s == 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return [r * 255, g * 255, b * 255];
}
function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function rgbToHsv(r, g, b) {
  r /= 255, g /= 255, b /= 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    v = max;
  var d = max - min;
  s = max == 0 ? 0 : d / max;
  if (max == min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return [h, s, v];
}
function hsvToRgb(h, s, v) {
  var r, g, b;
  var i = Math.floor(h * 6);
  var f = h * 6 - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0:
      r = v, g = t, b = p;
      break;
    case 1:
      r = q, g = v, b = p;
      break;
    case 2:
      r = p, g = v, b = t;
      break;
    case 3:
      r = p, g = q, b = v;
      break;
    case 4:
      r = t, g = p, b = v;
      break;
    case 5:
      r = v, g = p, b = q;
      break;
  }
  return [r * 255, g * 255, b * 255];
}
var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
function copy(obj) {
  if (!obj) {
    return obj;
  }
  var bObject, v, k;
  bObject = Array.isArray(obj) ? [] : {};
  for (k in obj) {
    v = obj[k];
    bObject[k] = _typeof(v) === 'object' ? copy(v) : v;
  }
  return bObject;
}
function compare(_obj1, _obj2) {
  if (!_obj1 || !_obj2) {
    return false;
  }
  var obj1 = copy(_obj1);
  var obj2 = copy(_obj2);

  // Special DIS case, where the code is a object with id and other parameters.
  // We need to expand it
  try {
    var idJson1 = JSON.parse(obj1.id);
    if (_typeof(idJson1) === 'object' && idJson1.id) {
      obj1 = idJson1;
      console.log('Code is a valid json with Id for obj1, use json instead', obj1, obj2);
    }
    var idJson2 = JSON.parse(obj2.id);
    if (_typeof(idJson2) === 'object' && idJson2.id) {
      obj2 = idJson2;
      console.log('Code is a valid json with Id for obj2, use json instead', obj1, obj2);
    }
  } catch (ex) {}

  // Remove dummy property
  delete obj1.zakekePlatform;
  delete obj2.zakekePlatform;
  delete obj1.label;
  delete obj2.label;
  delete obj1.isGlobal;
  delete obj2.isGlobal;
  if (Object.keys(obj1).length != Object.keys(obj2).length) return false;
  var v, k;
  var same = true;
  for (k in obj1) {
    v = obj1[k];
    if (typeof obj2[k] === 'undefined') same = false;
    if (v != obj2[k]) same = false;

    // Check if are valid json
    if (_typeof(v) === 'object' && _typeof(obj2[k]) === 'object') {
      same = compare(v, obj2[k]);
    }
    if (isValidJSON(v) || isValidJSON(obj2[k])) {
      try {
        var a = _typeof(v) === 'object' ? v : JSON.parse(v);
        var b = _typeof(obj2[k]) === 'object' ? obj2[k] : JSON.parse(obj2[k]);
        if (_typeof(a) == 'object' && _typeof(b) == 'object') same = compare(a, b);
      } catch (_unused) {}
    }
    if (!same) break;
  }
  return same;
}
function isValidJSON(code) {
  try {
    JSON.parse(code);
    return true;
  } catch (ex) {}
  return false;
}
function isPlatformCode(code) {
  var json = null;
  try {
    json = JSON.parse(code);
    return json.zakekePlatform;
  } catch (ex) {}
  return false;
}
function matchCodes(code1, code2) {
  if (isPlatformCode(code1) && isPlatformCode(code2)) return compare(JSON.parse(code1), JSON.parse(code2));else return code1 == code2;
}
function getPlatformSettings() {
  return CURRENT_REDUX_STORE.getState().platformSettings;
}
var IS_ANDROID = /android/i.test(navigator.userAgent);
var IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
var IS_AR_DEVICE_COMPLIANT = function () {
  var tempAnchor = document.createElement('a');
  return Boolean(tempAnchor.relList && tempAnchor.relList.supports && tempAnchor.relList.supports('ar'));
}();
function uuid() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
  });
  return uuid;
}
function sleep(_x) {
  return _sleep.apply(this, arguments);
}
function _sleep() {
  _sleep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ms) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            return setTimeout(resolve, ms);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _sleep.apply(this, arguments);
}
function ascComparator(getProp) {
  // map(x => x) is for converting backbone objects in normal array
  return function (a, b) {
    var propA = getProp(a);
    var propB = getProp(b);
    if (propA < propB) return -1;
    if (propB < propA) return 1;
    return 0;
  };
}

/***/ }),

/***/ "./src/hooks/useZakeke.ts":
/*!********************************!*\
  !*** ./src/hooks/useZakeke.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "useZakeke": () => (/* binding */ useZakeke)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../state/provider */ "./src/state/provider.tsx");
/**
 * Use Zakeke hook
 * @module useZakeke
 */




/**
 * The entry point to use all Zakeke features
 * @returns {import("../state/providerValue").Zakeke} Contains all the data and methods to control a Zakeke configuration
 */
var useZakeke = function useZakeke() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_state_provider__WEBPACK_IMPORTED_MODULE_1__.context);
  if (!value) throw new Error('Corrupted Zakeke state');
  return value;
};

/***/ }),

/***/ "./src/imageUploadTask.ts":
/*!********************************!*\
  !*** ./src/imageUploadTask.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ImageUploadTask)
/* harmony export */ });
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./api */ "./src/api.ts");
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


var ImageUploadTask = /*#__PURE__*/_createClass(function ImageUploadTask(culture, token) {
  var _this = this;
  _classCallCheck(this, ImageUploadTask);
  _defineProperty(this, "upload", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file, onProgress) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.uploadFileChunked(file, file.type, Zakeke.generateUUID(), {}, onProgress);
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "uploadFileChunked", /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(imageFile, mimeType, fileID, options, progressCallaback) {
      var status, taskID, responseTaskImage;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this.resumableUpload(imageFile, mimeType, fileID, progressCallaback);
          case 2:
            status = _context2.sent;
            if (!(status === 'OK')) {
              _context2.next = 21;
              break;
            }
            _context2.next = 6;
            return _this.createImageTask(fileID, options);
          case 6:
            taskID = _context2.sent;
            if (!(taskID !== -1)) {
              _context2.next = 20;
              break;
            }
            _context2.next = 10;
            return _this.getImageFromTask(taskID);
          case 10:
            responseTaskImage = _context2.sent;
            if (!options.IsPreview) {
              _context2.next = 16;
              break;
            }
            if (!responseTaskImage) {
              _context2.next = 14;
              break;
            }
            return _context2.abrupt("return", responseTaskImage.previewUrls);
          case 14:
            _context2.next = 18;
            break;
          case 16:
            if (!(responseTaskImage && responseTaskImage.images)) {
              _context2.next = 18;
              break;
            }
            return _context2.abrupt("return", responseTaskImage.images);
          case 18:
            _context2.next = 21;
            break;
          case 20:
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_1__.UploadFailedExpection();
          case 21:
            return _context2.abrupt("return", null);
          case 22:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4, _x5, _x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }());
  _defineProperty(this, "resumableUpload", /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(imageFile, mimeType, fileID, progressCallback) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              var headersRequest = {
                'Authorization': 'Bearer ' + _this.token,
                "Accept-Language": _this.culture
              };
              var r = new Resumable({
                target: Zakeke.config.baseImagesUploadApiUrl + "filechunks/upload",
                generateUniqueIdentifier: function generateUniqueIdentifier() {
                  return fileID;
                },
                maxFiles: 1,
                testChunks: false,
                headers: headersRequest,
                query: {
                  'resumableType': mimeType
                },
                simultaneousUploads: 3
              });

              // Adding file
              r.addFile(imageFile);

              // Event Upload handlers
              r.on('fileError', function (file, message) {
                resolve('KO');
                console.error('fileError', file, message);
              });
              r.on('error', function (message, file) {
                resolve('KO');
                console.error('error', message, file);
              });
              r.on('progress', function () {
                var percentage = r.progress() * 100;
                if (progressCallback) progressCallback(percentage);
              });
              r.on('fileAdded', function (file, event) {
                r.upload();
              });
              r.on('complete', function () {
                resolve('OK');
              });
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x8, _x9, _x10, _x11) {
      return _ref3.apply(this, arguments);
    };
  }());
  _defineProperty(this, "createImageTask", /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(fileID, options) {
      var imageTask, response;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            imageTask = {
              'fileID': fileID,
              'options': options
            };
            _context4.next = 3;
            return _api__WEBPACK_IMPORTED_MODULE_0__.axiosApi.post(Zakeke.config.baseImagesUploadApiUrl + "imagetasks", imageTask);
          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response ? response.data.taskID : -1);
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x12, _x13) {
      return _ref4.apply(this, arguments);
    };
  }());
  _defineProperty(this, "getImageFromTask", /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(taskID) {
      var times, response, _response;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            times = 0;
          case 1:
            _context5.prev = 1;
            _context5.next = 4;
            return _api__WEBPACK_IMPORTED_MODULE_0__.axiosApi.get(Zakeke.config.baseImagesUploadApiUrl + "imagetasks/results/" + taskID);
          case 4:
            response = _context5.sent;
            if (!(response && response.data.state === 2)) {
              _context5.next = 9;
              break;
            }
            return _context5.abrupt("return", response.data);
          case 9:
            if (!(response && response.data.state === 3)) {
              _context5.next = 11;
              break;
            }
            return _context5.abrupt("return", null);
          case 11:
            _context5.next = 20;
            break;
          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](1);
            if (!(((_response = _context5.t0.response) === null || _response === void 0 ? void 0 : _response.status) == 406)) {
              _context5.next = 19;
              break;
            }
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_1__.NonSquarePixelException();
          case 19:
            return _context5.abrupt("return", null);
          case 20:
            times++;
            if (!(times > 100)) {
              _context5.next = 23;
              break;
            }
            return _context5.abrupt("return", null);
          case 23:
            _context5.next = 25;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 1000);
            });
          case 25:
            _context5.next = 1;
            break;
          case 27:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 13]]);
    }));
    return function (_x14) {
      return _ref5.apply(this, arguments);
    };
  }());
  this.culture = culture;
  this.token = token;
});


/***/ }),

/***/ "./src/index.tsx":
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AdditionalCustomPropertyDataType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.AdditionalCustomPropertyDataType),
/* harmony export */   "Attribute": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Attribute),
/* harmony export */   "AttributeOptionShapeType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.AttributeOptionShapeType),
/* harmony export */   "AttributeType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.AttributeType),
/* harmony export */   "Camera": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Camera),
/* harmony export */   "Composition": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Composition),
/* harmony export */   "CompositionItem": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.CompositionItem),
/* harmony export */   "EventMessage": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.EventMessage),
/* harmony export */   "EventMessageType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.EventMessageType),
/* harmony export */   "Group": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Group),
/* harmony export */   "ImageItem": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ImageItem),
/* harmony export */   "ItemType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ItemType),
/* harmony export */   "Option": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Option),
/* harmony export */   "Platform": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Platform),
/* harmony export */   "PlatformPriceType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.PlatformPriceType),
/* harmony export */   "PlatformSettings": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.PlatformSettings),
/* harmony export */   "PreSetConfigurations": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.PreSetConfigurations),
/* harmony export */   "PreSetConfigurationsCategory": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.PreSetConfigurationsCategory),
/* harmony export */   "PreSetConfigurationsMacroCategory": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.PreSetConfigurationsMacroCategory),
/* harmony export */   "Product": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Product),
/* harmony export */   "ProductArea": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ProductArea),
/* harmony export */   "ProductQuantityRule": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ProductQuantityRule),
/* harmony export */   "Quote": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Quote),
/* harmony export */   "QuoteRule": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.QuoteRule),
/* harmony export */   "SellerSettings": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.SellerSettings),
/* harmony export */   "Step": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Step),
/* harmony export */   "Template": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Template),
/* harmony export */   "TemplateArea": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.TemplateArea),
/* harmony export */   "TemplateConstraints": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.TemplateConstraints),
/* harmony export */   "TextItem": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.TextItem),
/* harmony export */   "ThemeTemplateGroup": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ThemeTemplateGroup),
/* harmony export */   "User": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.User),
/* harmony export */   "Variant": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Variant),
/* harmony export */   "ZakekeDesigner": () => (/* reexport safe */ _components_customizer__WEBPACK_IMPORTED_MODULE_0__.ZakekeDesigner),
/* harmony export */   "ZakekeEnvironment": () => (/* reexport safe */ _environment__WEBPACK_IMPORTED_MODULE_2__.ZakekeEnvironment),
/* harmony export */   "ZakekeEvent": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ZakekeEvent),
/* harmony export */   "ZakekeProvider": () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_5__.ZakekeProvider),
/* harmony export */   "ZakekeViewer": () => (/* reexport safe */ _components_sceneViewer__WEBPACK_IMPORTED_MODULE_1__.ZakekeViewer),
/* harmony export */   "context": () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_5__.context),
/* harmony export */   "useInternalState": () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_5__.useInternalState),
/* harmony export */   "useZakeke": () => (/* reexport safe */ _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__.useZakeke)
/* harmony export */ });
/* harmony import */ var _components_customizer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./components/customizer */ "./src/components/customizer.tsx");
/* harmony import */ var _components_sceneViewer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/sceneViewer */ "./src/components/sceneViewer.tsx");
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./environment */ "./src/environment.tsx");
/* harmony import */ var _hooks_useZakeke__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./hooks/useZakeke */ "./src/hooks/useZakeke.ts");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./models */ "./src/models.ts");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./state/provider */ "./src/state/provider.tsx");







/***/ }),

/***/ "./src/integrations/Integration.ts":
/*!*****************************************!*\
  !*** ./src/integrations/Integration.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PlatformAttributeSelection": () => (/* binding */ PlatformAttributeSelection)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var PlatformAttributeSelection = /*#__PURE__*/_createClass(function PlatformAttributeSelection(attributeCode, optionCode, attributeLabel, optionLabel, attributeIsEnabled, optionIsEnabled) {
  _classCallCheck(this, PlatformAttributeSelection);
  this.attributeCode = attributeCode;
  this.optionCode = optionCode;
  this.attributeLabel = attributeLabel;
  this.optionLabel = optionLabel;
  this.attributeIsEnabled = attributeIsEnabled;
  this.optionIsEnabled = optionIsEnabled;
});

/***/ }),

/***/ "./src/integrations/generic.ts":
/*!*************************************!*\
  !*** ./src/integrations/generic.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MerchantIntegrationGeneric)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["AddToCart"] = "AddToCart";
  MessageType["Price"] = "Price";
  MessageType["Close"] = "Close";
  MessageType["SharedComposition"] = "SharedComposition";
  return MessageType;
}(MessageType || {});
var MerchantIntegrationGeneric = /*#__PURE__*/function () {
  function MerchantIntegrationGeneric() {
    var _this = this;
    _classCallCheck(this, MerchantIntegrationGeneric);
    _defineProperty(this, "callbacks", new Map());
    _defineProperty(this, "messageIds", 0);
    _defineProperty(this, "pricingCalculator", null);
    window.addEventListener('message', function (event) {
      var eventType = event.data.zakekeMessageType;
      if (eventType === MessageType.Price || eventType === MessageType.SharedComposition) {
        var messageId = event.data.messageId;
        if (!_this.callbacks.has(messageId)) {
          return;
        }
        var callback = _this.callbacks.get(messageId);
        _this.callbacks["delete"](messageId);
        callback(event.data.message);
      }
    });
  }
  _createClass(MerchantIntegrationGeneric, [{
    key: "addToCart",
    value: function addToCart(composition, design, model, attributes, designItems, quantity, additionalProperties, shopifyNFTPrice) {
      var designPrice = this.pricingCalculator && design ? this.pricingCalculator.calculate(design, quantity) : 0;
      designPrice += shopifyNFTPrice;
      window.parent.postMessage({
        zakekeMessageType: MessageType.AddToCart,
        message: {
          composition: composition.id,
          preview: composition.get('previewImageUrl'),
          designPrice: designPrice,
          attributes: attributes,
          designItems: designItems,
          quantity: quantity,
          additionalProperties: additionalProperties
        }
      }, '*');
    }
  }, {
    key: "getPrice",
    value: function getPrice(composition, design, model, attributes, compositionPrice, isCustomPricingConfiguratorEnabled, isCustomPricingRuleBasedEnabled, quantity) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var messageId = _this2.messageIds++;
        _this2.callbacks.set(messageId, resolve);
        console.log('Calculating price...');
        var designPrice = _this2.pricingCalculator && design ? _this2.pricingCalculator.calculate(design, quantity) : 0;
        var conditions = _this2.pricingCalculator && design ? _this2.pricingCalculator.getMatchedConditions(design, quantity, true) : [];

        // Subscription does not contain custom price
        if (!isCustomPricingRuleBasedEnabled) {
          designPrice = 0;
          conditions = [];
        }
        if (!isCustomPricingConfiguratorEnabled) compositionPrice = 0;
        console.log("Calculated Zakeke price:");
        console.log("- Composition price: " + compositionPrice);
        console.log("- Design price: " + designPrice);
        window.parent.postMessage({
          zakekeMessageType: MessageType.Price,
          messageId: messageId,
          message: {
            attributes: attributes,
            compositionPrice: compositionPrice + designPrice,
            designPrice: designPrice,
            conditions: conditions,
            quantity: quantity
          }
        }, '*');
      });
    }
  }, {
    key: "getSharedCompositionUrl",
    value: function getSharedCompositionUrl(compositionDocID) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var messageId = _this3.messageIds++;
        _this3.callbacks.set(messageId, resolve);
        console.log("getSharedCompositionUrl generic ts");
        window.parent.postMessage({
          zakekeMessageType: MessageType.SharedComposition,
          messageId: messageId,
          message: {
            compositionDocID: compositionDocID
          }
        }, '*');
      });
    }
  }, {
    key: "close",
    value: function close() {
      window.parent.postMessage({
        zakekeMessageType: MessageType.Close
      }, '*');
    }
  }, {
    key: "setPricingCalculator",
    value: function setPricingCalculator(pricingCalculator) {
      this.pricingCalculator = pricingCalculator;
    }
  }]);
  return MerchantIntegrationGeneric;
}();


/***/ }),

/***/ "./src/integrations/helpers.ts":
/*!*************************************!*\
  !*** ./src/integrations/helpers.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "integrationFor": () => (/* binding */ integrationFor)
/* harmony export */ });
/* harmony import */ var _preview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./preview */ "./src/integrations/preview.ts");
/* harmony import */ var _generic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./generic */ "./src/integrations/generic.ts");


function integrationFor(platform) {
  return new Promise(function (resolve, reject) {
    switch (platform) {
      case "preview":
        resolve(new _preview__WEBPACK_IMPORTED_MODULE_0__["default"]());
        break;
      default:
        resolve(new _generic__WEBPACK_IMPORTED_MODULE_1__["default"]());
    }
  });
}

/***/ }),

/***/ "./src/integrations/preview.ts":
/*!*************************************!*\
  !*** ./src/integrations/preview.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MerchantIntegrationPreview)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MessageType = /*#__PURE__*/function (MessageType) {
  MessageType["Close"] = "Close";
  return MessageType;
}(MessageType || {});
var MerchantIntegrationPreview = /*#__PURE__*/function () {
  function MerchantIntegrationPreview() {
    _classCallCheck(this, MerchantIntegrationPreview);
  }
  _createClass(MerchantIntegrationPreview, [{
    key: "addToCart",
    value: function addToCart(composition, design, model, attributes, designItems, quantity, additionalProperties) {
      // Not implemented
    }
  }, {
    key: "getPrice",
    value: function getPrice(composition, design, model, attributes, compositionPrice, isCustomPricingConfiguratorEnabled, isCustomPricingRuleBasedEnabled, quantity) {
      return new Promise(function (resolve, reject) {
        resolve({
          price: isCustomPricingConfiguratorEnabled ? compositionPrice : 0,
          isOutOfStock: false
        });
      });
    }
  }, {
    key: "getSharedCompositionUrl",
    value: function getSharedCompositionUrl(compositionDocID) {
      return new Promise(function (resolve, reject) {});
    }
  }, {
    key: "setPricingCalculator",
    value: function setPricingCalculator(pricingCalculator) {
      // Not implemented
    }
  }, {
    key: "close",
    value: function close() {
      window.parent.postMessage({
        zakekeMessageType: MessageType.Close
      }, '*');
    }
  }]);
  return MerchantIntegrationPreview;
}();


/***/ }),

/***/ "./src/models.ts":
/*!***********************!*\
  !*** ./src/models.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AdditionalCustomPropertyDataType": () => (/* binding */ AdditionalCustomPropertyDataType),
/* harmony export */   "Attribute": () => (/* binding */ Attribute),
/* harmony export */   "AttributeOptionShapeType": () => (/* binding */ AttributeOptionShapeType),
/* harmony export */   "AttributeType": () => (/* binding */ AttributeType),
/* harmony export */   "Camera": () => (/* binding */ Camera),
/* harmony export */   "Composition": () => (/* binding */ Composition),
/* harmony export */   "CompositionItem": () => (/* binding */ CompositionItem),
/* harmony export */   "EventMessage": () => (/* binding */ EventMessage),
/* harmony export */   "EventMessageType": () => (/* binding */ EventMessageType),
/* harmony export */   "Group": () => (/* binding */ Group),
/* harmony export */   "ImageItem": () => (/* binding */ ImageItem),
/* harmony export */   "ItemType": () => (/* binding */ ItemType),
/* harmony export */   "Option": () => (/* binding */ Option),
/* harmony export */   "Platform": () => (/* binding */ Platform),
/* harmony export */   "PlatformPriceType": () => (/* binding */ PlatformPriceType),
/* harmony export */   "PlatformSettings": () => (/* binding */ PlatformSettings),
/* harmony export */   "PreSetConfigurations": () => (/* binding */ PreSetConfigurations),
/* harmony export */   "PreSetConfigurationsCategory": () => (/* binding */ PreSetConfigurationsCategory),
/* harmony export */   "PreSetConfigurationsMacroCategory": () => (/* binding */ PreSetConfigurationsMacroCategory),
/* harmony export */   "Product": () => (/* binding */ Product),
/* harmony export */   "ProductArea": () => (/* binding */ ProductArea),
/* harmony export */   "ProductQuantityRule": () => (/* binding */ ProductQuantityRule),
/* harmony export */   "Quote": () => (/* binding */ Quote),
/* harmony export */   "QuoteRule": () => (/* binding */ QuoteRule),
/* harmony export */   "SellerSettings": () => (/* binding */ SellerSettings),
/* harmony export */   "Step": () => (/* binding */ Step),
/* harmony export */   "Template": () => (/* binding */ Template),
/* harmony export */   "TemplateArea": () => (/* binding */ TemplateArea),
/* harmony export */   "TemplateConstraints": () => (/* binding */ TemplateConstraints),
/* harmony export */   "TextItem": () => (/* binding */ TextItem),
/* harmony export */   "ThemeTemplateGroup": () => (/* binding */ ThemeTemplateGroup),
/* harmony export */   "User": () => (/* binding */ User),
/* harmony export */   "Variant": () => (/* binding */ Variant),
/* harmony export */   "ZakekeEvent": () => (/* binding */ ZakekeEvent)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }


/**
 * @internal
 */
var Platform = /*#__PURE__*/function (Platform) {
  Platform[Platform["Magento1"] = 5] = "Magento1";
  Platform[Platform["Magento2"] = 1] = "Magento2";
  Platform[Platform["Shopify"] = 3] = "Shopify";
  Platform[Platform["WooCommerce"] = 2] = "WooCommerce";
  return Platform;
}({});

/**
 * @internal
 */
var PlatformPriceType = /*#__PURE__*/function (PlatformPriceType) {
  PlatformPriceType[PlatformPriceType["Standard"] = 0] = "Standard";
  PlatformPriceType[PlatformPriceType["Inline"] = 1] = "Inline";
  return PlatformPriceType;
}({});

/**
 * Represents a user.
 */
var User = /*#__PURE__*/_createClass(
/**
 * The user's ID.
 */
function User(id,
/**
 * The user's username.
 */
username,
/**
 * The user's name.
 */
name) {
  _classCallCheck(this, User);
  this.id = id;
  this.username = username;
  this.name = name;
});

/**
 * @internal
 */
var ZakekeEnvironment = /*#__PURE__*/function (ZakekeEnvironment) {
  ZakekeEnvironment[ZakekeEnvironment["Customizer"] = 1] = "Customizer";
  ZakekeEnvironment[ZakekeEnvironment["Composer"] = 2] = "Composer";
  ZakekeEnvironment[ZakekeEnvironment["Viewer"] = 3] = "Viewer";
  return ZakekeEnvironment;
}(ZakekeEnvironment || {});
/**
 * Represents a product.
 */
var Product = /*#__PURE__*/function () {
  function Product() {
    _classCallCheck(this, Product);
    /**
     * The product ID.
     */
    /**
     * The product SKU.
     */
    /**
     * The product name.
     */
    /**
     * The URL of the preview of the product.
     */
    /**
     * Additional metadata for the product.
     */
    /**
     * The customizable areas of the product.
     */
    _defineProperty(this, "areas", []);
    /**
     * The quantity rule for the product.
     */
    _defineProperty(this, "quantityRule", null);
    /**
     * The quote rule for the product.
     */
    _defineProperty(this, "quoteRule", null);
    /**
     * @internal
     */
    _defineProperty(this, "environment", null);
    /**
     * @internal
     */
    _defineProperty(this, "isShowSecondScreenEnabled", false);
  }
  _createClass(Product, null, [{
    key: "fromProduct",
    value:
    /**
     * Creates a `Product` instance from a Zakeke product object.
     * @param zkProduct The Zakeke product object.
     * @returns The created `Product` instance.
     */
    function fromProduct(zkProduct) {
      var product = new Product();
      product.id = zkProduct.id;
      product.sku = zkProduct.get("code");
      product.name = zkProduct.get("name");
      product.previewUrl = zkProduct.get("largeImageUrl");
      product.quantityRule = zkProduct.get("quantityRule") ? ProductQuantityRule.fromQuantityRule(zkProduct.get("quantityRule")) : null;
      product.areas = zkProduct.get("colors").length > 0 ? zkProduct.get("colors").at(0).get("sides").map(function (side) {
        return ProductArea.fromSide(side);
      }) : [];
      product.quoteRule = zkProduct.get("quoteRule") ? new QuoteRule(zkProduct.get("quoteRule")) : null;
      product.environment = zkProduct.get("environment");
      product.isShowSecondScreenEnabled = zkProduct.get("isShowSecondScreenEnabled");
      return product;
    }
  }]);
  return Product;
}();

/**
 * Represents a quote rule, the one saved in the backoffice for the get a quote feature.
 */
var QuoteRule = /*#__PURE__*/_createClass(
/**
 * The quote rule ID.
 */

/**
 * The name of the quote rule.
 */

/**
 * The seller ID associated with the quote rule.
 */

/**
 * The form controls data of the quote rule.
 */

/**
 * Indicates whether the quote rule is valid for all products.
 */

/**
 * Indicates whether adding to cart is allowed for the quote rule.
 */

/**
 * The products associated with the quote rule.
 */

/**
 * Creates a `QuoteRule` instance from a quote rule object.
 * @param quoteRule The quote rule object.
 */
function QuoteRule(quoteRule) {
  _classCallCheck(this, QuoteRule);
  this.quoteRuleID = quoteRule.quoteRuleID;
  this.name = quoteRule.name;
  this.sellerID = quoteRule.sellerID;
  this.formControlsData = quoteRule.formControlsData;
  this.isValidForAllProducts = quoteRule.isValidForAllProducts;
  this.allowAddToCart = quoteRule.allowAddToCart;
  this.products = quoteRule.products;
});

/**
 * @internal
 */
var Quote = /*#__PURE__*/_createClass(function Quote() {
  _classCallCheck(this, Quote);
  /**
   * The quote ID.
   */
  /**
   * The seller ID associated with the quote.
   */
  /**
   * The subject of the quote.
   */
  /**
   * The status ID of the quote.
   */
  _defineProperty(this, "statusID", 1);
  /**
   * The quantity of the quote.
   */
  _defineProperty(this, "quantity", 1);
  /**
   * The model price of the quote.
   */
  _defineProperty(this, "modelPrice", 0);
}
/**
 * The variant name of the quote.
 */
);

/**
 * Represents The customizable areas of the product (the one created in the backoffice for the 2D customization part).
 */
var ProductArea = /*#__PURE__*/function () {
  function ProductArea() {
    _classCallCheck(this, ProductArea);
  }
  _createClass(ProductArea, null, [{
    key: "fromSide",
    value:
    /**
     * The area ID.
     */

    /**
     * The name of the area.
     */

    /**
     * The ID of the camera location.
     */

    /**
     * Creates a `ProductArea` instance from a model side object.
     * @param modelSide The model side object.
     * @returns The created `ProductArea` instance.
     */
    function fromSide(modelSide) {
      var area = new ProductArea();
      area.id = modelSide.id;
      area.name = modelSide.get("name");
      area.cameraLocationID = modelSide.get("cameraLocationID");
      return area;
    }
  }]);
  return ProductArea;
}();

/**
 * Represents the quantity rule of a product, with this you'll define the min, max and the step for selecting product quantities during the configuration.
 */
var ProductQuantityRule = /*#__PURE__*/function () {
  function ProductQuantityRule() {
    _classCallCheck(this, ProductQuantityRule);
    /**
     * The minimum quantity allowed.
     */
    _defineProperty(this, "minQuantity", null);
    /**
     * The maximum quantity allowed.
     */
    _defineProperty(this, "maxQuantity", null);
    /**
     * The step value for the quantity.
     */
    _defineProperty(this, "step", null);
  }
  _createClass(ProductQuantityRule, null, [{
    key: "fromQuantityRule",
    value:
    /**
     * Creates a `ProductQuantityRule` instance from a quantity rule object.
     * @param quantityRule The quantity rule object.
     * @returns The created `ProductQuantityRule` instance.
     * @throws An error if the quantity rule is invalid.
     */
    function fromQuantityRule(quantityRule) {
      if (!quantityRule) throw "Invalid quantity rule";
      var rule = new ProductQuantityRule();
      rule.minQuantity = quantityRule.get("minQuantity");
      rule.maxQuantity = quantityRule.get("maxQuantity");
      rule.step = quantityRule.get("step");
      return rule;
    }
  }]);
  return ProductQuantityRule;
}();

/**
 * Represents a variant of a product.
 */
var Variant = /*#__PURE__*/_createClass(
/**
 * The variant ID.
 */
function Variant(id,
/**
 * The SKU of the variant.
 */
sku,
/**
 * The name of the variant.
 */
name,
/**
 * The price of the variant.
 */
price,
/**
 * The metadata of the variant.
 */
metadata) {
  _classCallCheck(this, Variant);
  this.id = id;
  this.sku = sku;
  this.name = name;
  this.price = price;
  this.metadata = metadata;
});

/**
 * @internal
 */
var ZakekeEvent = /*#__PURE__*/_createClass(
/**
 * The name of the event.
 */
function ZakekeEvent(event, callback) {
  _classCallCheck(this, ZakekeEvent);
  this.event = event;
  this.callback = callback;
});

/**
 * Represents the constraints for a template saved for the product.
 */
var TemplateConstraints = /*#__PURE__*/_createClass(function TemplateConstraints() {
  _classCallCheck(this, TemplateConstraints);
  /**
   * Indicates whether user images are allowed.
   */
  _defineProperty(this, "isUserImageAllowed", true);
});

/**
 * Represents a customizable area of a template saved for the product.
 */
var TemplateArea = /*#__PURE__*/function () {
  function TemplateArea() {
    _classCallCheck(this, TemplateArea);
    /**
     * The ID of the area.
     */
    _defineProperty(this, "id", -1);
    /**
     * The upload restrictions for the area.
     */
    _defineProperty(this, "uploadRestrictions", new TemplateConstraints());
    /**
     * Indicates whether seller images are disabled for the area.
     */
    _defineProperty(this, "disableSellerImages", false);
    /**
     * Indicates whether adding images is allowed for the area.
     */
    _defineProperty(this, "canAddImage", true);
    /**
     * Indicates whether adding text is allowed for the area.
     */
    _defineProperty(this, "canAddText", true);
  }
  _createClass(TemplateArea, null, [{
    key: "fromTemplateArea",
    value:
    /**
     * Creates a `TemplateArea` instance from a Zakeke side object.
     * @param zkSide The Zakeke side object.
     * @returns The created `TemplateArea` instance.
     */
    function fromTemplateArea(zkSide) {
      var side = new TemplateArea();
      side.id = zkSide.get("sideID");
      side.disableSellerImages = zkSide.get("disableSellerImages");
      side.canAddImage = zkSide.get("canAddImage");
      side.canAddText = zkSide.get("canAddText");
      if (zkSide.get("uploadRestrictions")) side.uploadRestrictions = lodash__WEBPACK_IMPORTED_MODULE_0___default().mergeWith(new TemplateConstraints(), zkSide.get("uploadRestrictions"), function (a, b) {
        return b != undefined ? b : a;
      });
      return side;
    }
  }]);
  return TemplateArea;
}();

/**
 * Represents a template of the product (this will contain the 2D design of the configuration).
 */
var Template = /*#__PURE__*/function () {
  function Template() {
    _classCallCheck(this, Template);
    /** The ID of the template. */
    _defineProperty(this, "id", -1);
    /** The name of the template. */
    _defineProperty(this, "name", "");
    /** The areas of the template. */
    _defineProperty(this, "areas", []);
  }
  _createClass(Template, null, [{
    key: "fromTemplate",
    value:
    /**
     * Creates a Template object from a zkTemplate.
     * @param zkTemplate The zkTemplate object.
     * @returns The created Template object.
     */
    function fromTemplate(zkTemplate) {
      var template = new Template();
      template.id = zkTemplate.get("templateDesignID");
      template.name = zkTemplate.get("name");
      template.areas = zkTemplate.get("sides").map(function (x) {
        return TemplateArea.fromTemplateArea(x);
      });
      return template;
    }
  }]);
  return Template;
}();

/**
 * Represents the type of an item that can be added in the 2D configuration.
 */
var ItemType = /*#__PURE__*/function (ItemType) {
  ItemType[ItemType["Text"] = 0] = "Text";
  ItemType[ItemType["Image"] = 1] = "Image";
  return ItemType;
}({});

/**
 * Represents an item that can be added in the 2D configuration.
 */

/**
 * Represents a text item.
 */
var TextItem = /*#__PURE__*/_createClass(
/**
 * Creates a TextItem object from an item.
 * @param item The item object.
 */
function TextItem(item) {
  var _item$item$data$isTem;
  _classCallCheck(this, TextItem);
  /** The type of the item. */
  /** The ID of the area to which the item belongs. */
  /** The GUID of the item. */
  /** The name of the item. */
  /** The text content of the item. */
  /** The stroke color of the item. */
  /** The stroke width of the item. */
  /** The fill color of the item. */
  /** The font family of the item. */
  /** The font size of the item. */
  /** The font weight of the item. */
  /** The font style of the item. */
  /** The font stretch of the item. */
  /** The justification of the item. */
  /** Indicates if the text is on a path. */
  /** Indicates if the item is a template element. */
  /** The constraints of the item. */
  _defineProperty(this, "constraints", null);
  this.type = ItemType.Text;
  this.areaId = item.sideID;
  this.guid = item.itemGuid;
  this.name = item.designItem.get("name");
  this.text = item.text;
  this.strokeColor = item.strokeColor;
  this.strokeWidth = item.strokeWidth;
  this.fillColor = item.fillColor;
  this.fontFamily = item.fontFamily;
  this.fontSize = item.fontSize;
  this.fontWeight = item.fontWeight;
  this.fontStyle = item.fontStyle;
  this.fontStretch = item.fontStretch;
  this.justification = item.justification;
  this.isTextOnPath = item.isTextOnPath;
  this.isTemplateElement = (_item$item$data$isTem = item.item.data.isTemplateElement) !== null && _item$item$data$isTem !== void 0 ? _item$item$data$isTem : false;
  this.constraints = item.constraints;
});

/**
 * Represents an image item that can be added in the 2D configuration.
 */
var ImageItem = /*#__PURE__*/_createClass(
/**
 * Creates an ImageItem object from an item.
 * @param item The item object.
 */
function ImageItem(item) {
  _classCallCheck(this, ImageItem);
  /** The type of the item. */
  /** The ID of the image. */
  /** The ID of the area to which the item belongs. */
  /** The GUID of the item. */
  /** The name of the item. */
  /** The URL of the image. */
  /** Indicates if the item is deleted. */
  /** The constraints of the item. */
  _defineProperty(this, "constraints", null);
  this.type = ItemType.Image;
  this.imageID = item.imageID;
  this.areaId = item.sideID;
  this.guid = item.itemGuid;
  this.name = item.designItem.get("name");
  this.url = item.url;
  this.deleted = !item.visible;
  this.constraints = item.constraints;
});

/**
 * @internal
 */
var PlatformSettings = /*#__PURE__*/function () {
  /**
   * Creates a new PlatformSettings object.
   * @param ecommerceId The ecommerce ID.
   * @param currencyId The currency ID.
   * @param apiKey The API key.
   * @param apiSecret The API secret.
   * @param accessKey The access key.
   * @param accessSecret The access secret.
   * @param remoteUrl The remote URL.
   * @param username The username.
   * @param password The password.
   * @param adminPath The admin path.
   */
  function PlatformSettings(ecommerceId, currencyId, apiKey, apiSecret, accessKey, accessSecret, remoteUrl, username, password, adminPath) {
    _classCallCheck(this, PlatformSettings);
    this.ecommerceId = ecommerceId;
    this.currencyId = currencyId;
    this.apiKey = apiKey;
    this.apiSecret = apiSecret;
    this.accessKey = accessKey;
    this.accessSecret = accessSecret;
    this.remoteUrl = remoteUrl;
    this.username = username;
    this.password = password;
    this.adminPath = adminPath;
  }
  _createClass(PlatformSettings, [{
    key: "platform",
    get:
    /**
     * Gets the platform of the settings.
     */
    function get() {
      return this.ecommerceId;
    }

    /**
     * Creates a PlatformSettings object from settings data.
     * @param settings The platform settings data.
     * @returns The created PlatformSettings object.
     */
  }], [{
    key: "fromData",
    value: function fromData(settings) {
      if (!settings) throw new _exceptions__WEBPACK_IMPORTED_MODULE_1__.Exception("Cannot create platform settings from null");
      return new PlatformSettings(settings.ecommerceId, settings.currencyId, settings.apiKey, settings.accessSecret, settings.accessKey, settings.accessSecret, settings.remoteUrl, settings.username, settings.password, settings.adminPath);
    }
  }]);
  return PlatformSettings;
}();

/**
 * @internal
 */
/** An empty PlatformSettings object. */
_defineProperty(PlatformSettings, "Empty", new PlatformSettings(-1, -1, "", "", "", "", "", "", "", ""));
/**
 * Represents a type of message created and enabled in the backoffice.
 */
var EventMessage = /*#__PURE__*/function () {
  function EventMessage() {
    _classCallCheck(this, EventMessage);
    /** The event ID of the message. */
    _defineProperty(this, "eventID", -1);
    /** The description of the message. */
    _defineProperty(this, "description", "");
    /** Indicates if the message is closeable. */
    _defineProperty(this, "closeable", false);
    /** Indicates if the message is visible. */
    _defineProperty(this, "visible", false);
    /** Indicates if adding to cart is disabled when the message is visible. */
    _defineProperty(this, "addToCartDisabledIfVisible", false);
    /** Indicates if checking for seller images is enabled. */
    _defineProperty(this, "enableCheckForSellerImages", false);
  }
  _createClass(EventMessage, null, [{
    key: "fromMessage",
    value:
    /**
     * Creates an EventMessage instance from a message object.
     * @param message - The message object.
     * @returns The created EventMessage instance.
     */
    function fromMessage(message) {
      var eventMessage = new EventMessage();
      eventMessage.eventID = message.eventID;
      eventMessage.description = message.description;
      eventMessage.closeable = message.closeable;
      eventMessage.visible = message.visible;
      eventMessage.addToCartDisabledIfVisible = message.addToCartDisabledIfVisible;
      eventMessage.additionalData = message.additionalData !== "" && message.additionalData !== null ? JSON.parse(message.additionalData) : "";
      eventMessage.enableCheckForSellerImages = message.enableCheckForSellerImages;
      return eventMessage;
    }
  }]);
  return EventMessage;
}();

/**
 * Represents an event message type.
 */
var EventMessageType = /*#__PURE__*/function (EventMessageType) {
  EventMessageType[EventMessageType["Undefined"] = -1] = "Undefined";
  EventMessageType[EventMessageType["ImageQualityWarning"] = 1] = "ImageQualityWarning";
  EventMessageType[EventMessageType["Welcome"] = 3] = "Welcome";
  EventMessageType[EventMessageType["AddToCart"] = 4] = "AddToCart";
  EventMessageType[EventMessageType["Copyright"] = 8] = "Copyright";
  return EventMessageType;
}({});

/**
 * Represents a camera saved in the scene editor section for the product.
 */
var Camera = /*#__PURE__*/function () {
  function Camera() {
    _classCallCheck(this, Camera);
    /** The ID of the camera. */
    _defineProperty(this, "id", '');
    /** The name of the camera. */
    _defineProperty(this, "name", '');
  }
  _createClass(Camera, null, [{
    key: "fromZkCamera",
    value:
    /**
     * Creates a Camera instance from a ZkCamera.
     * @param zkCamera - The ZkCamera object.
     * @returns The created Camera instance.
     */
    function fromZkCamera(zkCamera) {
      var camera = new Camera();
      camera.id = zkCamera.get('locationID');
      camera.name = zkCamera.get('name');
      return camera;
    }
  }]);
  return Camera;
}();

/**
 * Represents a Group created and saved in the Composer section for the product.
 */
var Group = /*#__PURE__*/_createClass(function Group() {
  _classCallCheck(this, Group);
  /**
   * The ID of the group.
   */
  _defineProperty(this, "id", -1);
  /**
   * The GUID of the group.
   */
  _defineProperty(this, "guid", "");
  /**
   * The name of the group.
   */
  _defineProperty(this, "name", "Group");
  /**
   * Indicates if the group is enabled.
   */
  _defineProperty(this, "enabled", false);
  /**
   * The URL of the group's image.
   */
  _defineProperty(this, "imageUrl", null);
  /**
   * The attributes of the group.
   */
  _defineProperty(this, "attributes", []);
  /**
   * The steps of the group.
   */
  _defineProperty(this, "steps", []);
  /**
   * The template groups associated with the group.
   */
  _defineProperty(this, "templateGroups", []);
  /**
   * The ID of the camera location assigned to the group.
   */
  _defineProperty(this, "cameraLocationId", null);
  /**
   * The display order of the group.
   */
  _defineProperty(this, "displayOrder", 1);
  /**
   * The direction of the group (if 0 the attributes of the group will be shown as tabs , 1 will be shown as accordion).
   */
  _defineProperty(this, "direction", 0);
  /**
   * Indicates if the attributes of the group are always opened (valid in case of group.direction = 1).
   */
  _defineProperty(this, "attributesAlwaysOpened", false);
});

/**
 * Represents a Step.
 */
var Step = /*#__PURE__*/_createClass(function Step() {
  _classCallCheck(this, Step);
  /**
   * The ID of the step.
   */
  _defineProperty(this, "id", -1);
  /**
   * The GUID of the step.
   */
  _defineProperty(this, "guid", "");
  /**
   * The name of the step.
   */
  _defineProperty(this, "name", "Step");
  /**
   * The ID of the camera location associated to the step.
   */
  _defineProperty(this, "cameraLocationID", null);
  /**
   * The display order of the step.
   */
  _defineProperty(this, "displayOrder", 1);
  /**
   * The attributes of the step.
   */
  _defineProperty(this, "attributes", []);
  /**
   * The template groups associated with the step.
   */
  _defineProperty(this, "templateGroups", []);
});

/**
 * @internal
 */
var AttributeType = /*#__PURE__*/function (AttributeType) {
  AttributeType[AttributeType["Select"] = 0] = "Select";
  AttributeType[AttributeType["Input"] = 1] = "Input";
  AttributeType[AttributeType["Colorpicker"] = 2] = "Colorpicker";
  return AttributeType;
}({});

/**
 * Represents the shape type of the attribute's options's icons.
 */
var AttributeOptionShapeType = /*#__PURE__*/function (AttributeOptionShapeType) {
  AttributeOptionShapeType[AttributeOptionShapeType["Round"] = 1] = "Round";
  AttributeOptionShapeType[AttributeOptionShapeType["Square"] = 2] = "Square";
  return AttributeOptionShapeType;
}({});

/**
 * Represents an Attribute.
 */
var Attribute = /*#__PURE__*/_createClass(function Attribute() {
  _classCallCheck(this, Attribute);
  /**
   * The ID of the attribute.
   */
  _defineProperty(this, "id", -1);
  /**
   * The GUID of the attribute.
   */
  _defineProperty(this, "guid", "");
  /**
   * The code of the attribute.
   */
  _defineProperty(this, "code", "");
  /**
   * The name of the attribute.
   */
  _defineProperty(this, "name", "Attribute");
  /**
   * The description of the attribute.
   */
  _defineProperty(this, "description", '');
  /**
   * Indicates if the attribute is enabled.
   */
  _defineProperty(this, "enabled", false);
  /**
   * The URL of the attribute's image.
   */
  _defineProperty(this, "imageUrl", null);
  /**
   * The ID of the group to which the attribute is associated.
   */
  _defineProperty(this, "groupId", -1);
  /**
   * The ID of the step to which the attribute is associated.
   */
  _defineProperty(this, "stepId", -1);
  /**
   * The options of the attribute.
   */
  _defineProperty(this, "options", []);
  /**
   * @internal
   */
  _defineProperty(this, "value", null);
  /**
   * @internal
   */
  _defineProperty(this, "numberFormat", "");
  /**
   * @internal
   */
  _defineProperty(this, "type", AttributeType.Select);
  /**
   * The shape type of the attribute options.
   */
  _defineProperty(this, "optionShapeType", AttributeOptionShapeType.Round);
  /**
   * The display order of the attribute.
   */
  _defineProperty(this, "displayOrder", 1);
  /**
   * Indicates if the options names should be hidden.
   */
  _defineProperty(this, "hideOptionsLabel", false);
  /**
   * The ID of the camera location associated to the attribute.
   */
  _defineProperty(this, "cameraLocationId", null);
});

/**
 * Represents pricing information for the product.
 */

/**
 * Represents an Option.
 */
var Option = /*#__PURE__*/_createClass(function Option() {
  _classCallCheck(this, Option);
  /**
   * The ID of the option.
   */
  _defineProperty(this, "id", -1);
  /**
   * The GUID of the option.
   */
  _defineProperty(this, "guid", "");
  /**
   * The code of the option.
   */
  _defineProperty(this, "code", "");
  /**
   * The name of the option.
   */
  _defineProperty(this, "name", "Option");
  /**
   * The description of the option.
   */
  _defineProperty(this, "description", '');
  /**
   * Indicates if the option is enabled.
   */
  _defineProperty(this, "enabled", false);
  /**
   * Indicates if the option is selected.
   */
  _defineProperty(this, "selected", false);
  /**
   * The URL of the option's image.
   */
  _defineProperty(this, "imageUrl", null);
  /**
   * The display order of the option.
   */
  _defineProperty(this, "displayOrder", 1);
  /**
   * The pricings of the option.
   */
  _defineProperty(this, "pricings", []);
});

/**
 * Represents a Pre-set configuration saved for the product.
 */
var PreSetConfigurations = /*#__PURE__*/_createClass(function PreSetConfigurations() {
  _classCallCheck(this, PreSetConfigurations);
  /**
   * The ID of the template composition.
   */
  _defineProperty(this, "compositionID", -1);
  /**
   * The name of the template composition.
   */
  _defineProperty(this, "name", "");
  /**
   * The preview image URL of the template composition.
   */
  _defineProperty(this, "previewImageUrl", "");
});

/**
 * Represents a Category in which assigned pre-set configurations.
 */
var PreSetConfigurationsCategory = /*#__PURE__*/_createClass(function PreSetConfigurationsCategory() {
  _classCallCheck(this, PreSetConfigurationsCategory);
  /**
   * The ID of the category.
   */
  _defineProperty(this, "id", -1);
  /**
   * The name of the category.
   */
  _defineProperty(this, "name", "");
  /**
   * The pre-set configurations saved in the category
   */
  _defineProperty(this, "composition", []);
});

/**
 * Represents a Macro Category in which assigned categories containing pre-set configurations.
 */
var PreSetConfigurationsMacroCategory = /*#__PURE__*/_createClass(function PreSetConfigurationsMacroCategory() {
  _classCallCheck(this, PreSetConfigurationsMacroCategory);
  /**
   * The ID of the theme macro category.
   */
  _defineProperty(this, "id", -1);
  /**
   * The name of the theme macro category.
   */
  _defineProperty(this, "name", "");
  /**
   * The theme categories associated with the theme macro category.
   */
  _defineProperty(this, "category", []);
});

/**
 * Represents a Theme Template Group.
 */
var ThemeTemplateGroup = /*#__PURE__*/_createClass(function ThemeTemplateGroup() {
  _classCallCheck(this, ThemeTemplateGroup);
  /**
   * The ID of the theme template group.
   */
  _defineProperty(this, "templateGroupID", -1);
  /**
   * The name of the theme template group.
   */
  _defineProperty(this, "name", "");
  /**
   * The ID of the group associated with the theme template group.
   */
  _defineProperty(this, "groupID", -1);
  /**
   * The ID of the step associated with the theme template group.
   */
  _defineProperty(this, "stepID", -1);
  /**
   * The display order of the theme template group.
   */
  _defineProperty(this, "displayOrder", -1);
  /**
   * The macro categories associated with the theme template group.
   */
  _defineProperty(this, "macroCategory", []);
});

/**
 * Represents settings saved in the backoffice used in the UI.
 */
var SellerSettings = /*#__PURE__*/function () {
  function SellerSettings() {
    _classCallCheck(this, SellerSettings);
    /**
     * The label for the customize button.
     */
    _defineProperty(this, "customizeButtonLabel", "");
    /**
     * The image's URL of the customize button.
     */
    _defineProperty(this, "customizeButtonIconUrl", "");
    /**
     * Indicates if the composition recap is enabled.
     */
    _defineProperty(this, "isCompositionRecapEnabled", false);
    /**
     * Indicates if the composition recap is visible from the start.
     */
    _defineProperty(this, "isCompositionRecapVisibleFromStart", false);
    /**
     * Indicates if the user can close the composition recap.
     */
    _defineProperty(this, "canUserCloseCompositionRecap", true);
    // minimumFractionDigits: number = 1;
    /**
     * The text shown below the price.
     */
    _defineProperty(this, "priceInfoText", "");
    /**
     * Indicates if the price should be hidden.
     */
    _defineProperty(this, "hidePrice", false);
    /**
     * The Hotjar site ID.
     */
    _defineProperty(this, "hotjarSiteID", null);
    /**
     * The Google Tag Manager ID.
     */
    _defineProperty(this, "googleTagManagerID", null);
    /**
     * Indicates if the draft composition can be saved.
     */
    _defineProperty(this, "canSaveDraftComposition", false);
    /**
     * Indicates if undo and redo actions are allowed.
     */
    _defineProperty(this, "canUndoRedo", false);
    /**
     * The type of sharing.
     */
    _defineProperty(this, "shareType", null);
  }
  _createClass(SellerSettings, null, [{
    key: "fromSellerSettings",
    value:
    /**
     * Creates a SellerSettings instance from the provided zkSellerSettings object.
     * @param zkSellerSettings - The zkSellerSettings object.
     * @returns A new instance of SellerSettings.
     */
    function fromSellerSettings(zkSellerSettings) {
      var sellerSettings = new SellerSettings();
      sellerSettings.customizeButtonLabel = zkSellerSettings.customizeButtonLabel;
      sellerSettings.customizeButtonIconUrl = zkSellerSettings.customizeButtonIconUrl;
      sellerSettings.isCompositionRecapEnabled = zkSellerSettings.isCompositionRecapEnabled;
      sellerSettings.isCompositionRecapVisibleFromStart = zkSellerSettings.isCompositionRecapVisibleFromStart;
      sellerSettings.canUserCloseCompositionRecap = zkSellerSettings.canUserCloseCompositionRecap;
      // sellerSettings.minimumFractionDigits = zkSellerSettings.minimumFractionDigits;
      sellerSettings.priceInfoText = zkSellerSettings.priceInfoText;
      sellerSettings.hidePrice = zkSellerSettings.hidePrice;
      sellerSettings.hotjarSiteID = zkSellerSettings.hotjarSiteID;
      sellerSettings.googleTagManagerID = zkSellerSettings.googleTagManagerID;
      sellerSettings.canSaveDraftComposition = zkSellerSettings.canSaveDraftComposition;
      sellerSettings.canUndoRedo = zkSellerSettings.canUndoRedo;
      sellerSettings.shareType = zkSellerSettings.shareType;
      return sellerSettings;
    }
  }]);
  return SellerSettings;
}();

/** Represents the configuration done on the product */

var Composition = /*#__PURE__*/function () {
  function Composition() {
    _classCallCheck(this, Composition);
    /** The name of the composition. */
    _defineProperty(this, "name", "");
    /** The docID of the composition. */
    _defineProperty(this, "docID", '');
    /** The ID of the composition. */
    _defineProperty(this, "compositionID", -1);
    /** The items in the composition, these will be attributes/options selected */
    _defineProperty(this, "compositionItems", []);
    /** The URL of the composition's image preview. */
    _defineProperty(this, "previewImageUrl", "");
    /** The ID of the design associated with the composition. Can be null. */
    _defineProperty(this, "designID", null);
    /** The tags associated with the composition. */
    _defineProperty(this, "tags", []);
  }
  _createClass(Composition, null, [{
    key: "fromJSON",
    value:
    /**
     * Creates a Composition instance from a JSON object.
     * @param json - The JSON object representing the Composition.
     * @returns A new Composition instance.
     */
    function fromJSON(json) {
      var composition = new Composition();
      lodash__WEBPACK_IMPORTED_MODULE_0___default().assign(composition, json);
      return composition;
    }
  }]);
  return Composition;
}();
var CompositionItem = /*#__PURE__*/_createClass(function CompositionItem() {
  _classCallCheck(this, CompositionItem);
  /** The ID of the attribute. */
  _defineProperty(this, "attributeID", -1);
  /** The name of the attribute. */
  _defineProperty(this, "attributeName", "");
  /** The code of the attribute. */
  _defineProperty(this, "attributeCode", "");
  /** The name of the selected option. */
  _defineProperty(this, "selectedOptionName", "");
  /** The code of the selected option. */
  _defineProperty(this, "selectedOptionCode", "");
});
/** Represents the type of the additional custom property */

var AdditionalCustomPropertyDataType = /*#__PURE__*/function (AdditionalCustomPropertyDataType) {
  AdditionalCustomPropertyDataType[AdditionalCustomPropertyDataType["Money"] = 1] = "Money";
  AdditionalCustomPropertyDataType[AdditionalCustomPropertyDataType["Integer"] = 2] = "Integer";
  AdditionalCustomPropertyDataType[AdditionalCustomPropertyDataType["Decimal"] = 3] = "Decimal";
  return AdditionalCustomPropertyDataType;
}({});

/** Represent the additional custom property saved in the backoffice */

/***/ }),

/***/ "./src/state/boot.tsx":
/*!****************************!*\
  !*** ./src/state/boot.tsx ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! qs */ "./node_modules/qs/lib/index.js");
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! .. */ "./src/index.tsx");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




// Handle boot when provider is ready
var Boot = function Boot(_ref) {
  var children = _ref.children;
  var internalState = (0,___WEBPACK_IMPORTED_MODULE_2__.useInternalState)();
  var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(internalState);
  stateRef.current = internalState;
  var boot = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(parameters) {
      var _stateRef$current, _stateRef$current2, _stateRef$current4, _stateRef$current5;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            (_stateRef$current = stateRef.current) === null || _stateRef$current === void 0 ? void 0 : _stateRef$current.dispatch({
              type: 'IS_SCENE_LOADING',
              isLoading: true
            });

            // Register to environment changes
            (_stateRef$current2 = stateRef.current) === null || _stateRef$current2 === void 0 ? void 0 : _stateRef$current2.state.environment.on('change', function () {
              var _stateRef$current3;
              return (_stateRef$current3 = stateRef.current) === null || _stateRef$current3 === void 0 ? void 0 : _stateRef$current3.dispatch({
                type: 'UPDATE'
              });
            });
            _context.next = 4;
            return (_stateRef$current4 = stateRef.current) === null || _stateRef$current4 === void 0 ? void 0 : _stateRef$current4.state.environment.boot(parameters);
          case 4:
            (_stateRef$current5 = stateRef.current) === null || _stateRef$current5 === void 0 ? void 0 : _stateRef$current5.dispatch({
              type: 'IS_SCENE_LOADING',
              isLoading: false
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var handleMessageReceived = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
      var _stateRef$current6;
      var _stateRef$current7;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (e.data.type == 'load' && !((_stateRef$current6 = stateRef.current) !== null && _stateRef$current6 !== void 0 && _stateRef$current6.state.parametersReceived)) {
              (_stateRef$current7 = stateRef.current) === null || _stateRef$current7 === void 0 ? void 0 : _stateRef$current7.dispatch({
                type: 'PARAMETERS_RECEIVED'
              });
              boot(e.data.parameters);
              window.parent.postMessage({
                zakekeType: 'loaded',
                message: {
                  integrationVersion: 2
                }
              }, '*');
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var query = qs__WEBPACK_IMPORTED_MODULE_0___default().parse(window.location.search);
    if (query && query.ecommerce && query.ecommerce == 'preview') {
      boot(null);
    } else {
      window.addEventListener('message', handleMessageReceived);
    }
    return function () {
      return window.removeEventListener('message', handleMessageReceived);
    };
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, children);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Boot);

/***/ }),

/***/ "./src/state/createProviderValue.ts":
/*!******************************************!*\
  !*** ./src/state/createProviderValue.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createProviderValue": () => (/* binding */ createProviderValue)
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var createProviderValue = function createProviderValue(state, dispatch) {
  if (!state.environment) throw new Error('Invalid Zakeke environment.');
  return {
    price: state.environment.price,
    isOutOfStock: state.environment.isOutOfStock,
    currency: state.environment.currency,
    culture: state.environment.culture,
    quantity: state.environment.quantity,
    quantityRule: state.environment.quantityRule,
    internalProduct: state.environment.internalProduct,
    internalScene: state.environment.internalScene,
    internalCurrentTemplate: state.environment.internalCurrentTemplate,
    draftCompositions: state.environment.themeCompositions,
    currentAttributesSelection: state.environment.currentAttributesSelection,
    isSceneLoading: state.isSceneLoading,
    isAddToCartLoading: state.isAddToCartLoading,
    fonts: state.environment.fonts,
    disableTextColors: state.environment.disableTextColors,
    defaultColor: state.environment.defaultColor,
    textColors: state.environment.textColors,
    groups: state.environment.groups,
    templates: state.environment.templates,
    loadedComposition: state.environment.loadedComposition,
    currentTemplate: state.environment.currentTemplate,
    isViewerReady: state.environment.isViewerReady,
    translations: state.environment.translations,
    items: state.environment.getDesignItemsInfo(),
    productName: state.environment.productName,
    productCode: state.environment.productCode,
    product: state.environment.product,
    cameras: state.environment.cameras,
    sellerSettings: state.environment.sellerSettings,
    eventMessages: state.environment.eventMessages,
    visibleEventMessages: state.environment.visibleEventMessages,
    isAssetsLoading: state.environment.isAssetsLoading,
    additionalCustomProperties: state.environment.additionalCustomProperties,
    currentCompositionInfo: state.environment.currentCompositionInfo,
    nftSettings: state.environment.nftSettings,
    useLegacyScreenshot: state.environment.useLegacyScreenshot,
    saveComposition: state.environment.saveComposition,
    loadComposition: state.environment.loadComposition,
    getPDF: state.environment.getPDF.bind(state.environment),
    getOnlineScreenshot: state.environment.getOnlineScreenshot.bind(state.environment),
    reset: state.environment.reset.bind(state.environment),
    undo: state.environment.undo.bind(state.environment),
    redo: state.environment.redo.bind(state.environment),
    setCamera: state.environment.setCamera.bind(state.environment),
    setCameraByName: state.environment.setCameraByName.bind(state.environment),
    setCameraZoomEnabled: state.environment.setCameraZoomEnabled.bind(state.environment),
    resetCameraPivot: state.environment.resetCameraPivot.bind(state.environment),
    setCameraPivot: state.environment.setCameraPivot.bind(state.environment),
    setQuantity: state.environment.setQuantity.bind(state.environment),
    getImages: state.environment.getImages.bind(state.environment),
    openSecondScreen: state.environment.openSecondScreen.bind(state.environment),
    getMacroCategories: state.environment.getMacroCategories.bind(state.environment),
    createQuote: state.environment.createQuote,
    previewOnly__setItemImageFromBase64: function () {
      var _previewOnly__setItemImageFromBase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(guid, base64) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", dispatch({
                type: 'SET_ITEM_IMAGE_FROM_BASE64',
                guid: guid,
                base64: base64
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function previewOnly__setItemImageFromBase64(_x, _x2) {
        return _previewOnly__setItemImageFromBase.apply(this, arguments);
      }
      return previewOnly__setItemImageFromBase64;
    }(),
    setItemImageFromFile: function () {
      var _setItemImageFromFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(guid, file) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", dispatch({
                type: 'SET_ITEM_IMAGE_FROM_FILE',
                guid: guid,
                file: file
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function setItemImageFromFile(_x3, _x4) {
        return _setItemImageFromFile.apply(this, arguments);
      }
      return setItemImageFromFile;
    }(),
    addItemImage: function () {
      var _addItemImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(imageId, areaId) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", dispatch({
                type: 'ADD_ITEM_IMAGE',
                imageId: imageId,
                areaId: areaId
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function addItemImage(_x5, _x6) {
        return _addItemImage.apply(this, arguments);
      }
      return addItemImage;
    }(),
    createImage: state.environment.createImage.bind(state.environment),
    createImageFromUrl: state.environment.createImageFromUrl.bind(state.environment),
    setItemImage: function () {
      var _setItemImage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(guid, imageId) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", dispatch({
                type: 'SET_ITEM_IMAGE',
                guid: guid,
                imageId: imageId
              }));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function setItemImage(_x7, _x8) {
        return _setItemImage.apply(this, arguments);
      }
      return setItemImage;
    }(),
    setItemFontFamily: function setItemFontFamily(guid, fontFamily) {
      return dispatch({
        type: 'SET_ITEM_FONT_FAMILY',
        guid: guid,
        fontFamily: fontFamily
      });
    },
    setItemColor: function setItemColor(guid, color) {
      return dispatch({
        type: 'SET_ITEM_COLOR',
        guid: guid,
        color: color
      });
    },
    setItemBold: function setItemBold(guid, bold) {
      return dispatch({
        type: 'SET_ITEM_BOLD',
        guid: guid,
        bold: bold
      });
    },
    setItemItalic: function setItemItalic(guid, italic) {
      return dispatch({
        type: 'SET_ITEM_ITALIC',
        guid: guid,
        italic: italic
      });
    },
    setItemTextOnPath: function setItemTextOnPath(guid, areaId, value) {
      return dispatch({
        type: 'SET_ITEM_TEXT_PATH',
        guid: guid,
        areaId: areaId,
        value: value
      });
    },
    setItemText: function setItemText(guid, text) {
      return dispatch({
        type: 'SET_ITEM_TEXT',
        guid: guid,
        text: text
      });
    },
    addItemText: function () {
      var _addItemText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(settings, areaId) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", dispatch({
                type: 'ADD_ITEM_TEXT',
                settings: settings,
                areaId: areaId
              }));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function addItemText(_x9, _x10) {
        return _addItemText.apply(this, arguments);
      }
      return addItemText;
    }(),
    removeItem: function () {
      var _removeItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(guid) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", dispatch({
                type: 'REMOVE_ITEM',
                guid: guid
              }));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function removeItem(_x11) {
        return _removeItem.apply(this, arguments);
      }
      return removeItem;
    }(),
    isFullscreenMode: state.environment.isFullscreenMode,
    switchFullscreen: function switchFullscreen() {
      return dispatch({
        type: 'SWITCH_FULLSCREEN'
      });
    },
    zoomIn: function zoomIn() {
      return dispatch({
        type: 'ZOOM_IN'
      });
    },
    zoomOut: function zoomOut() {
      return dispatch({
        type: 'ZOOM_OUT'
      });
    },
    setHighlightSettings: function setHighlightSettings(settings) {
      return dispatch({
        type: 'SET_HIGHLIGHT_SETTINGS',
        settings: settings
      });
    },
    updateView: function updateView(adjustCamera) {
      return dispatch({
        type: 'UPDATE_VIEW',
        adjustCamera: adjustCamera
      });
    },
    hasExplodedMode: state.environment.hasExplodedMode,
    isExplodedMode: state.environment.isExplodedMode,
    setExplodedMode: function setExplodedMode(exploded) {
      return dispatch({
        type: 'SET_EXPLODED_MODE',
        exploded: exploded
      });
    },
    internalAppendViewer: function internalAppendViewer(container) {
      return dispatch({
        type: 'APPEND_VIEWER',
        container: container
      });
    },
    designUpdate: function designUpdate() {
      return dispatch({
        type: 'DESIGN_UPDATE'
      });
    },
    selectOption: function selectOption(optionId) {
      return dispatch({
        type: 'SELECT_OPTION',
        optionId: optionId
      });
    },
    isAreaVisible: state.environment.isAreaVisible.bind(state.environment),
    setTemplate: function setTemplate(templateId) {
      return dispatch({
        type: 'SET_TEMPLATE',
        templateId: templateId
      });
    },
    saveTemplate: state.environment.saveTemplate,
    addToCart: function () {
      var _addToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _state$environment;
        var _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              dispatch({
                type: 'IS_ADD_TO_CART_LOADING',
                isLoading: true
              });
              _context7.next = 3;
              return (_state$environment = state.environment).addToCart.apply(_state$environment, _args7);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function addToCart() {
        return _addToCart.apply(this, arguments);
      }
      return addToCart;
    }(),
    // save compositions
    loadSavedComposition: state.environment.loadSavedComposition,
    saveDraftsComposition: state.environment.saveDraftsComposition,
    deleteSavedComposition: state.environment.deleteSavedComposition,
    // Scene manipulation
    getMeshIDbyName: state.environment.getMeshIDbyName.bind(state.environment),
    hideMeshAndSaveState: state.environment.hideMeshAndSaveState.bind(state.environment),
    restoreMeshVisibility: state.environment.restoreMeshVisibility.bind(state.environment),
    setMeshDesignVisibility: state.environment.setMeshDesignVisibility.bind(state.environment),
    exportSceneToGlb: state.environment.exportSceneToGlb,
    // Events
    clearListeners: state.environment.clearListeners,
    addFocusAttributesListener: state.environment.addFocusAttributesListener,
    focusAttribute: state.environment.focusAttribute,
    // Highlight
    highlightGroup: state.environment.hightlightGroup.bind(state.environment),
    highlightAttribute: state.environment.highlightAttribute.bind(state.environment),
    // AR
    getQrCodeArUrl: state.environment.getQrCodeArUrl,
    getMobileArUrl: state.environment.getMobileArUrl,
    openArMobile: state.environment.openArMobile,
    isSceneArEnabled: state.environment.isSceneArEnabled,
    isArDeviceCompliant: state.environment.isArDeviceCompliant,
    IS_ANDROID: _helpers__WEBPACK_IMPORTED_MODULE_0__.IS_ANDROID,
    IS_IOS: _helpers__WEBPACK_IMPORTED_MODULE_0__.IS_IOS,
    setBackgroundColor: state.environment.setBackgroundColor.bind(state.environment),
    // TRY ON
    getTryOnUrl: state.environment.getTryOnUrl.bind(state.environment),
    isSceneTryOnEnabled: state.environment.isSceneTryOnEnabled.bind(state.environment),
    setCameraLocked: state.environment.setCameraLocked.bind(state.environment),
    getTemplateUploadRestrictictions: state.environment.getTemplateUploadRestrictictions.bind(state.environment),
    getShareCompositionUrl: state.environment.getShareCompositionUrl.bind(state.environment),
    // copyright message
    getCopyrightMessageAccepted: state.environment.getCopyrightMessageAccepted.bind(state.environment),
    setCopyrightMessageAccepted: state.environment.setCopyrightMessageAccepted.bind(state.environment),
    // nft form
    validationNFTEmail: state.environment.validationNFTEmail.bind(state.environment),
    validationNFTWalletAddress: state.environment.validationNFTWalletAddress.bind(state.environment),
    templateMacroCategories: state.environment.templateMacroCategories,
    applyTemplate: state.environment.applyTemplate.bind(state.environment)
  };
};

/***/ }),

/***/ "./src/state/provider.tsx":
/*!********************************!*\
  !*** ./src/state/provider.tsx ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeProvider": () => (/* binding */ ZakekeProvider),
/* harmony export */   "context": () => (/* binding */ context),
/* harmony export */   "useInternalState": () => (/* binding */ useInternalState)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _boot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./boot */ "./src/state/boot.tsx");
/* harmony import */ var _createProviderValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./createProviderValue */ "./src/state/createProviderValue.ts");
/* harmony import */ var _reducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reducer */ "./src/state/reducer.ts");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createContext(null);
var internalContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createContext(null);

// Use zakeke hook
var useInternalState = function useInternalState() {
  var value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(internalContext);
  if (!value) throw 'Corrupted Zakeke state';
  return value;
};

// ZakekeProvider
var ZakekeProvider = function ZakekeProvider(_ref) {
  var environment = _ref.environment,
    children = _ref.children;
  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(_reducer__WEBPACK_IMPORTED_MODULE_3__.reducer, {
      environment: environment,
      isAddToCartLoading: false,
      isSceneLoading: false,
      parametersReceived: false
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];

  // Create the provider value exposed to developer
  var value = (0,_createProviderValue__WEBPACK_IMPORTED_MODULE_2__.createProviderValue)(state, dispatch);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(context.Provider, {
    value: value
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(internalContext.Provider, {
    value: {
      state: state,
      dispatch: dispatch
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_boot__WEBPACK_IMPORTED_MODULE_1__["default"], null, children)));
};


/***/ }),

/***/ "./src/state/reducer.ts":
/*!******************************!*\
  !*** ./src/state/reducer.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "reducer": () => (/* binding */ reducer)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

// Reducer
function reducer(prevState, action) {
  var newState = lodash__WEBPACK_IMPORTED_MODULE_0___default().clone(prevState);
  switch (action.type) {
    case 'BOOT_COMPLETED':
    case 'UPDATE':
      break;
    case 'DESIGN_UPDATE':
      newState.environment.renderDesign();
      break;
    case 'PARAMETERS_RECEIVED':
      newState.parametersReceived = true;
      break;
    case 'UPDATE_VIEW':
      newState.environment.updateView();
      break;
    case 'SWITCH_FULLSCREEN':
      newState.environment.switchFullscreen();
      break;
    case 'SELECT_OPTION':
      newState.environment.selectOption(action.optionId);
      break;
    case 'APPEND_VIEWER':
      newState.environment.appendViewer(action.container);
      break;
    case 'SET_HIGHLIGHT_SETTINGS':
      newState.environment.setHighlightSettings(action.settings);
    case 'IS_SCENE_LOADING':
      newState.isSceneLoading = action.isLoading;
      break;
    case 'IS_ADD_TO_CART_LOADING':
      newState.isAddToCartLoading = action.isLoading;
      break;
    case 'SET_TEMPLATE':
      newState.environment.setTemplate(action.templateId);
      break;
    case 'SET_ITEM_IMAGE_FROM_BASE64':
      newState.environment.setItemImageFromBase64(action.guid, action.base64);
      break;
    case 'SET_ITEM_IMAGE_FROM_FILE':
      newState.environment.setItemImageFromFile(action.guid, action.file);
      break;
    case 'ADD_ITEM_IMAGE':
      newState.environment.addItemImage(action.imageId, action.areaId);
      break;
    case 'SET_ITEM_IMAGE':
      newState.environment.setItemImage(action.guid, action.imageId);
      break;
    case 'SET_ITEM_FONT_FAMILY':
      newState.environment.setItemFontFamily(action.guid, action.fontFamily);
      break;
    case 'SET_ITEM_COLOR':
      newState.environment.setItemColor(action.guid, action.color);
      break;
    case 'SET_ITEM_BOLD':
      newState.environment.setItemBold(action.guid, action.bold);
      break;
    case 'SET_ITEM_ITALIC':
      newState.environment.setItemItalic(action.guid, action.italic);
      break;
    case 'SET_ITEM_TEXT_PATH':
      newState.environment.setItemTextOnPath(action.guid, action.areaId, action.value);
      break;
    case 'SET_ITEM_TEXT':
      newState.environment.setItemText(action.guid, action.text);
      break;
    case 'ADD_ITEM_TEXT':
      newState.environment.addItemText(action.settings, action.areaId);
      break;
    case 'REMOVE_ITEM':
      newState.environment.removeItem(action.guid);
      break;
    case 'ZOOM_IN':
      newState.environment.zoomIn();
      break;
    case 'ZOOM_OUT':
      newState.environment.zoomOut();
      break;
    case 'SET_EXPLODED_MODE':
      newState.environment.setExplodedMode(action.exploded);
      break;
    default:
      throw new Error("Invalid reducer action ".concat(action.type, "."));
  }
  return newState;
}

/***/ }),

/***/ "../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx":
/*!*********************************************************************!*\
  !*** ../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DesignPriceCalculatorRuleBased": () => (/* binding */ DesignPriceCalculatorRuleBased),
/* harmony export */   "DesignPriceCalculatorRuleFactory": () => (/* binding */ DesignPriceCalculatorRuleFactory)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "../../../node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "../../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_rectangle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/rectangle */ "../../utils/rectangle.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }



var PricingElements = /*#__PURE__*/function (PricingElements) {
  PricingElements[PricingElements["Tutti"] = 1] = "Tutti";
  PricingElements[PricingElements["AllElementsNoTemplateItems"] = 18] = "AllElementsNoTemplateItems";
  PricingElements[PricingElements["AllTexts"] = 8] = "AllTexts";
  PricingElements[PricingElements["AllCustomText"] = 9] = "AllCustomText";
  PricingElements[PricingElements["SingleElement"] = 10] = "SingleElement";
  PricingElements[PricingElements["AllImages"] = 11] = "AllImages";
  PricingElements[PricingElements["UploadedImages"] = 12] = "UploadedImages";
  PricingElements[PricingElements["AllTextArt"] = 13] = "AllTextArt";
  PricingElements[PricingElements["AllCustomTextArt"] = 14] = "AllCustomTextArt";
  PricingElements[PricingElements["AllCustomElements"] = 15] = "AllCustomElements";
  PricingElements[PricingElements["ClipartImages"] = 16] = "ClipartImages";
  PricingElements[PricingElements["TemplatesImages"] = 17] = "TemplatesImages";
  return PricingElements;
}(PricingElements || {});
var operatorsFunctions = function operatorsFunctions(operator) {
  var _find;
  var func = (_find = [{
    operator: ">",
    func: function func(a, b) {
      return a > b;
    }
  }, {
    operator: "<",
    func: function func(a, b) {
      return a < b;
    }
  }, {
    operator: "=",
    func: function func(a, b) {
      return a == b;
    }
  }, {
    operator: ">=",
    func: function func(a, b) {
      return a >= b;
    }
  }, {
    operator: "<=",
    func: function func(a, b) {
      return a <= b;
    }
  }].find(function (of) {
    return of.operator == operator;
  })) === null || _find === void 0 ? void 0 : _find.func;
  if (func == null) throw new Error("Function  for operator ".concat(operator, " not found"));
  return func;
};
// type PricingRuleConditionsModel = Pick<pricing_model['rules'][0], 'conditions'>;
// type PricingRuleConditionModel = Pick<PricingRuleConditionsModel[0],''>;

var DesignPriceCalculatorRuleFactory = /*#__PURE__*/_createClass(function DesignPriceCalculatorRuleFactory() {
  _classCallCheck(this, DesignPriceCalculatorRuleFactory);
});
_defineProperty(DesignPriceCalculatorRuleFactory, "create", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(product, apiUrl, token, isOwin, cloudFlareApiUrl, clientLang) {
    var calculator;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          calculator = new DesignPriceCalculatorRuleBased(apiUrl, token, isOwin, cloudFlareApiUrl, clientLang);
          _context2.next = 3;
          return calculator.init(product)["catch"](function (e) {
            return console.log(e);
          });
        case 3:
          return _context2.abrupt("return", calculator);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x3, _x4, _x5, _x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}());
var DesignPriceCalculatorRuleBased = /*#__PURE__*/_createClass(function DesignPriceCalculatorRuleBased(apiUrl, token, isOwin, cloudFlareApiUrl, clientLang) {
  var _this = this;
  _classCallCheck(this, DesignPriceCalculatorRuleBased);
  _defineProperty(this, "colorID", -1);
  _defineProperty(this, "config", {
    isOwin: true,
    apiUrl: 'https://test-api.zakeke.com/api/graphql',
    cloudFlareApiUrl: null,
    token: "Gw6IL2Q7e66r3osC16_T6XSlsrnuUAHmw59Y3-qJv2LaPPV-nuzDkC0eOGAU8ef_i94HLlu8vDVXpk9MAWBtwrXWN7_XizPAeIfKXArfol19Ek7wmZMR3zRQWwHChqPmYDJMrI3WeCIQGRJxsR7q8hh5xywTqdOwVi6LT7_8-qP9jkc_tdBUPiMUrT6HI1i1ygnEGEk6Eoa97zvbVGRE3NRt-W5nXKGv4_INB_VBdpOihHVXIzl7PtchqPyBr7AaW5Hdrbh_KoFwEhLTcTixXpxfzOcjecbyqFHw20fNFlg2ny6Cb375i7hpnFWD7Q4lj9xI3R6jbkpFHsQEFfBK-UF1f9vli0liCWQ3WdAYGQEmUYx7QjCy240GuR_cK6c28JHoabSGQdW91K7KEAug4o19nokKfzbWoZM7WD4T4RVXNB_ob_gjeYKsK7EJIt6qGiPpnJEbSeFCjz1EhE31Jw6MO-oawNSASxgYk1D6Z3XkLw1G",
    clientLang: null
  });
  _defineProperty(this, "init", function (product) {
    _this.product = product;
    return new Promise(function (resolve, reject) {
      try {
        _this.getPricings(product, function (pricings, properties) {
          _this.pricings = pricings;
          _this.properties = properties;
          resolve();
        });
      } catch (error) {
        reject(error);
      }
    });
  });
  _defineProperty(this, "getPricings", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(product, callback) {
      var query, axiosConfig, requestData, responseCF, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!_this.pricings) {
              _context.next = 4;
              break;
            }
            callback(_this.pricings, _this.properties);
            _context.next = 30;
            break;
          case 4:
            query = {
              name: 'pricingsConfigurationQuery',
              query: "query pricingsQuery($first: Int!, $productID: Long!, $languageCulture: String) {\n                                    pricingProperties { propertyID functionName }\n                                    pricingsDetailed(first: $first, productID: $productID, isForFrontEnd: true, languageCulture: $languageCulture) {\n                                        edges {\n                                            node {\n                                                id\n                                                description\n                                                infoPricingText\n                                                priceDescriptionEnabled\n                                                priceStructure\n                                                products {\n                                                    productID\n                                                }\n                                                printTypes {\n                                                    printTypeID\n                                                }\n                                                rules {\n                                                    ruleID\n                                                    propertyID\n                                                    allMatchType\n                                                    elementID\n                                                    elementTitle\n                                                    isSetupPrice\n                                                    priceType\n                                                    targets {\n                                                        area\n                                                        color\n                                                        side\n                                                        targetID\n                                                    }\n                                                    conditions {\n                                                        conditionID\n                                                        formula\n                                                        position\n                                                        priceToAdd\n                                                        quantity\n                                                    }\n                                                }\n                                            }\n                                        }\n                                    }\n                                }",
              variables: {
                first: 50,
                productID: product.get('modelID'),
                languageCulture: _this.config.clientLang
              }
            };
            axiosConfig = {
              'headers': {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              }
            };
            if (_this.config.isOwin) {
              axiosConfig['headers']['Authorization'] = 'Bearer ' + _this.config.token;
            } else {
              axiosConfig['headers']['X-Auth-Token'] = _this.config.token;
            }
            requestData = {
              type: 'POST',
              url: _this.config.apiUrl,
              data: JSON.stringify(query),
              contentType: "application/json",
              dataType: 'json'
            };
            if (_this.config.isOwin) {
              requestData['Authorization'] = 'Bearer ' + _this.config.token;
            } else {
              requestData['X-Auth-Token'] = _this.config.token;
            }
            _context.prev = 9;
            if (!(typeof _this.config.cloudFlareApiUrl !== 'undefined' && _this.config.cloudFlareApiUrl !== null && _this.config.cloudFlareApiUrl !== '')) {
              _context.next = 16;
              break;
            }
            _context.next = 13;
            return axios__WEBPACK_IMPORTED_MODULE_0___default().post(_this.config.cloudFlareApiUrl, query, axiosConfig);
          case 13:
            responseCF = _context.sent;
            callback(responseCF.data.data.pricingsDetailed.edges.map(function (edge) {
              return edge.node;
            }), responseCF.data.data.pricingProperties);
            return _context.abrupt("return");
          case 16:
            _context.next = 20;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](9);
          case 20:
            _context.prev = 20;
            _context.next = 23;
            return axios__WEBPACK_IMPORTED_MODULE_0___default().post(_this.config.apiUrl, query, axiosConfig);
          case 23:
            response = _context.sent;
            callback(response.data.data.pricingsDetailed.edges.map(function (edge) {
              return edge.node;
            }), response.data.data.pricingProperties);
            _context.next = 30;
            break;
          case 27:
            _context.prev = 27;
            _context.t1 = _context["catch"](20);
            console.log(_context.t1);
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[9, 18], [20, 27]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  _defineProperty(this, "getPricing", function (design) {
    if (_this.pricings) {
      // cerco prima il pricing associato al prodotto
      var _pricings = _this.pricings.filter(function (pricing) {
        return pricing.products.filter(function (p) {
          return p.productID == _this.product.get('modelID');
        }).length > 0;
      });
      // se non trovo il pricing associato al prodotto cerco quello associato al print type
      if (_pricings.length == 0) _pricings = _this.pricings.filter(function (pricing) {
        return pricing.printTypes.filter(function (p) {
          return p.printTypeID == design.get('printTypeID');
        }).length > 0;
      });
      // console.log("pricing", (pricings.length>0) ? pricings[0] : pricings);
      return _pricings.length > 0 ? _pricings[0] : undefined;
    }
  });
  _defineProperty(this, "distinct", function (value, index, self) {
    return self.indexOf(value) === index;
  });
  _defineProperty(this, "ElementSizeFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0,
      items: pContext.items
    };

    //qui dentro il mio context contiene già tutti gli item di tipo text, image o textart (eventualmente saranno già filtrati dagli 
    //elements della rule. In ogni caso il calcolo della size in cm sarà lo stesso:
    //quidni basta fare width / side.ppcm e sai i cm (width viene preso dal json del designitem)
    //e height / side.ppcm;
    //poi confronto i valore ottenuti ognuno col valore corrispondente dell'action (che quindi in questo caso ha 2 valori)            

    if (!formula.values || formula.values.length == 0) throw "values missing in formula";
    if (formula.values == null || formula.values.length == 0) throw "ElementSize invalid value";
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      var myJson = JSON.parse(item.get('json'))[1];
      var width = myJson.data.transformsData.dimensions.width;
      var height = myJson.data.transformsData.dimensions.height;

      //qui dentro tutti i designItemAreas del'item stanno per forza sullo stesso lato, quindi basta prendere il primo
      var sideID = item.get('areas').at(0).get('sideID');
      var modelSide = pContext.sides.find(function (s) {
        return s.get('sideID') == sideID;
      });
      if (width != null && height != null && modelSide != null && modelSide.get('ppcm') > 0) {
        var itemWidth = width / modelSide.get('ppcm');
        var itemHeight = height / modelSide.get('ppcm');
        var itemArea = itemHeight * itemWidth;
        if (operatorsFunctions(formula.operator)(itemArea, formula.values[0])) {
          result.result = true;
          result.multiplier += 1;
          result.items = result.items.filter(function (x) {
            return x != item;
          });
        }
      }
    });
    return result;
  });
  _defineProperty(this, "NumberOfElementsSimplifiedFunction", function (pContext, formula) {
    return {
      result: pContext.items.length > 0,
      multiplier: pContext.items.length,
      items: pContext.items
    };
  });
  _defineProperty(this, "LinesLengthFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso la lunghezza dei caratteri inseriti con il valore inserito nella action dal seller

    //per ora sono escluse le textart
    var result = {
      result: false,
      multiplier: 0
    };

    //qui dentro il mio context contiene già item di tipo text (o di custom text)
    //in ogni deisgnitem prendo gli elemnti di testo e conto il i caratteri
    if (!formula.values || formula.values.length == 0) throw "values missing in formula";
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      var myJson = JSON.parse(item.get('json'))[1];
      var isText = myJson.data.isText;
      var isTextArea = myJson.data.isTextArea;
      var isTextOnPath = myJson.data.isTextOnPath;
      var isTextArt = myJson.data.isTextArt;
      var testo = "";
      if (isText != null && isText) testo = myJson.content.toString();else if (isTextArea != null && isTextArea || isTextOnPath != null && isTextOnPath) testo = myJson.data.text.toString();
      if (isTextArt != null && isTextArt) testo = item.get("textArt").get("text");
      if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo)) {
        //zero fine riga significa una riga
        var numLines = testo.split("\n").length;
        if (operatorsFunctions(formula.operator)(numLines, formula.values[0])) {
          result.result = true;
          result.multiplier += 1;
        }
      }
    });
    return result;
  });
  _defineProperty(this, "AmountOfElementsFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso saranno il numero di elementi e il valore inserito nella action dal seller

    var result = {
      result: false,
      multiplier: 0
    };

    ////in questa funzione si contano tutti gli items quindi non ci saranno items da escludere nella eventuale successiva action
    //result.MatchedItems = items;        
    if (!formula.values || formula.values.length == 0) throw "values missing in formula";
    if (operatorsFunctions(formula.operator)(pContext.items.length, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "AmountOfUsedColorsFunction", function (pContext, formula) {
    /*, i colori sono univoci ma per elemento: devi calcolare quelli per design:
              esempio:
              immagine1 = ['rosso', 'verde']
        immagine2 = ['verde', 'giallo']
              effettivamente hai usato 3 colori, rosso, verde e giallo.
     */
    var result = {
      result: false,
      multiplier: 0
    };
    if (!formula.values || formula.values.length == 0) throw "values missing in formula";
    ////in questa funzione si contano tutti gli items quindi non ci saranno items da escludere nella eventuale successiva action
    ////a prescindere dal risultato 

    // let colors: string[] = [];

    // pContext.items.forEach(item => {
    //     if (item.get('itemColors') && !isEmpty(item.get('itemColors'))) 
    //         colors.push(item.get('itemColors'));
    // });

    var colors = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniq)(pContext.items.filter(function (item) {
      return item.get('itemColors') && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(item.get('itemColors'));
    }).flatMap(function (item) {
      return item.get('itemColors');
    }));
    if (operatorsFunctions(formula.operator)(colors.filter(_this.distinct).length, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "CanvasSizeFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0
    };
    if (!formula.values || formula.values.length == 0) throw "values missing in formula";
    if (pContext.sides && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(pContext.sides)) {
      var areas = pContext.sides.flatMap(function (s) {
        return s.get('areas').models;
      });
      var customizedAreas = [];

      //prendiamo le aree con almeno un item (ricorda che gli items del context sono già filtrati per target/elements)
      areas.forEach(function (area) {
        //per ogni area cerco, fra tutti gli items quelli che stanno su quell'area.
        if (pContext.items.filter(function (i) {
          return i.get('areas').filter(function (a) {
            return a.get('colorID') == area.getColorID() && a.get('sideID') == area.getSideID() && a.get('areaID') == area.get('areaID');
          }).length > 0;
        }).length > 0) {
          customizedAreas = [].concat(_toConsumableArray(customizedAreas), [area]);
        }
      });

      //a questo punto , per ogni area mi calcolo le misure in cm (dividendo i bound dell'area per i ppcm del side a cui appartiene
      //e eseguo la funzione con l'operatore e i due values del seller
      customizedAreas.forEach(function (area) {
        var width = area.get('boundsWidth');
        var height = area.get('boundsHeight');
        var modelSide = pContext.sides.find(function (s) {
          return s.get('sideID') == area.getSideID();
        });
        if (modelSide != null && modelSide.get('ppcm') > 0) {
          var areaWidth = width / modelSide.get('ppcm');
          var areaHeight = height / modelSide.get('ppcm');

          // Round 2 decs
          areaWidth = Math.round(areaWidth * 100) / 100;
          areaHeight = Math.round(areaHeight * 100) / 100;
          if (operatorsFunctions(formula.operator)(areaWidth, formula.values[0]) && operatorsFunctions(formula.operator)(areaHeight, formula.values[1])) {
            result.result = true;
            result.multiplier += 1;
          }
        }
      });
    }
    return result;
  });
  _defineProperty(this, "DesignSizeFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0
    };
    var itemsArea = 0;
    if (!formula.values || formula.values.length == 0) throw "values missing in formula";
    if (pContext.sides && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(pContext.sides)) {
      var areas = pContext.sides.flatMap(function (s) {
        return s.get('areas').models;
      });

      //prendiamo le aree con almeno un item (ricorda che gli items del context sono già filtrati per target/elements)
      areas.forEach(function (area) {
        //per ogni area cerco, fra tutti gli items quelli che stanno su quell'area.
        var items = pContext.items.filter(function (i) {
          return i.get('areas').filter(function (a) {
            return a.get('colorID') == area.getColorID() && a.get('sideID') == area.getSideID() && a.get('areaID') == area.get('areaID');
          }).length > 0;
        });
        // seconda versione somma delle aree di ogni item
        var modelSide = pContext.sides.find(function (s) {
          return s.get('sideID') == area.getSideID();
        });
        if (modelSide != null && modelSide.get('ppcm') > 0) {
          var itemsRectangles = items.map(function (item) {
            var json = JSON.parse(item.get('json'))[1];
            var width = json.data.transformsData.dimensions.width;
            var height = json.data.transformsData.dimensions.height;
            var xPosition = json.data.transformsData.position.x;
            var yPosition = json.data.transformsData.position.y;
            return new _utils_rectangle__WEBPACK_IMPORTED_MODULE_2__.Rectangle(width, height, xPosition, yPosition);
          });
          itemsArea = itemsArea + (0,_utils_rectangle__WEBPACK_IMPORTED_MODULE_2__.rectanglesDistinctArea)(itemsRectangles, modelSide.get('ppcm'));
          console.log("itemsArea", itemsArea);
        }
      });
    }
    if (itemsArea > 0 && operatorsFunctions(formula.operator)(itemsArea, formula.values[0])) {
      result.result = true;
      result.multiplier += 1;
    }
    return result;
  });
  _defineProperty(this, "DesignTextLengthFunction", function (pContext, formula) {
    var result = {
      result: false,
      multiplier: 0
    };

    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso saranno il totale dei caratteri di tutto il design (quindi non sul singolo item) 
    //e il valore inserito nella action dal seller

    if (!formula.values || formula.values.length == 0) throw "values missing in formula";
    var totalLength = 0;
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      var myJson = JSON.parse(item.get('json'))[1];
      var isText = myJson.data.isText;
      var isTextArea = myJson.data.isTextArea;
      var isTextOnPath = myJson.data.isTextOnPath;
      var isTextArt = myJson.data.isTextArt;
      var testo = "";
      if (isText != null && isText) testo = myJson.content.toString();else if (isTextArea != null && isTextArea || isTextOnPath != null && isTextOnPath) testo = myJson.data.text.toString();else if (isTextArt != null && isTextArt) testo = item.get("textArt").get("text");
      if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo)) {
        totalLength += testo.trim().split(" ").join("").replace(/(\r\n|\n|\r)/gm, "").length;
      }
    });

    //questo è un caso  in cui il moltiplicatore può essere solo zero oppure uno e i matcheditems non devono influenzare
    //l'eventuale action successiva
    if (operatorsFunctions(formula.operator)(totalLength, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "CustomizedSidesFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso saranno il numero di elementi e il valore inserito nella action dal seller

    var result = {
      result: false,
      multiplier: 0
    };
    if (!formula.values || formula.values.length == 0) throw "values missing in formula";

    //var modelSides = ((ModelSideInfoList)pContext["sides"]).ToList();

    var customizedSides = 0;

    //elimina il foreach
    pContext.sides.forEach(function (side) {
      //dato un certo side e un certo designItem, per sapere se quel side ha elementi personalizzati 

      if (pContext.items.filter(function (item) {
        return item.get('areas').filter(function (area) {
          return area.get('sideID') == side.get('sideID');
        }).length > 0;
      }).length > 0) {
        customizedSides++;
      }
    });

    // We must check that we have at last one side to check.
    // If pContext.sides.length == 0 then this mean that the current rule is not valid for this
    // variation

    if (pContext.sides.length > 0 && operatorsFunctions(formula.operator)(customizedSides, formula.values[0])) {
      result.result = true;
      result.multiplier = 1;
    }
    return result;
  });
  _defineProperty(this, "TextLengthFunction", function (pContext, formula) {
    //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
    //in questo caso la lunghezza dei caratteri inseriti con il valore inserito nella action dal seller

    //per ora sono escluse le textart
    var result = {
      result: false,
      multiplier: 0
    };

    //qui dentro il mio context contiene già item di tipo text (o di custom text)
    //in ogni deisgnitem prendo gli elemnti di testo e conto il i caratteri

    if (!formula.values || formula.values.length == 0) throw "values missing in formula";
    pContext.items.forEach(function (item) {
      //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
      // Newtonsoft.Json.Linq.JToken myJson =
      //                    Newtonsoft.Json.JsonConvert.DeserializeObject<List<Newtonsoft.Json.Linq.JToken>>(
      //                        item.Json)[1];
      var myJson = JSON.parse(item.get('json'))[1];
      var isText = myJson.data.isText;
      var isTextArea = myJson.data.isTextArea;
      var isTextOnPath = myJson.data.isTextOnPath;
      var isTextArt = myJson.data.isTextArt;
      var testo = "";
      if (isText != null && isText) testo = myJson.content.toString();else if (isTextArea != null && isTextArea || isTextOnPath != null && isTextOnPath) testo = myJson.data.text.toString();else if (isTextArt != null && isTextArt) testo = item.get("textArt").get("text");
      if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo) && operatorsFunctions(formula.operator)(testo.trim().split(" ").join("").length, formula.values[0])) {
        result.result = true;
        result.multiplier += 1;
      }
    });
    return result;
  });
  _defineProperty(this, "conditionsToConditionsGroupByFormula", function (conditions) {
    var gb = lodash__WEBPACK_IMPORTED_MODULE_1___default().groupBy(conditions, function (c) {
      return c !== null && c !== void 0 && c.formula ? c === null || c === void 0 ? void 0 : c.formula : "";
    });
    return Object.keys(gb).map(function (k) {
      var _gb$k$;
      return {
        formula: k,
        position: (_gb$k$ = gb[k][0]) === null || _gb$k$ === void 0 ? void 0 : _gb$k$.position,
        conditions: gb[k]
      };
    });
  });
  _defineProperty(this, "getFunctionName", function (properties, rule) {
    try {
      return properties === null || properties === void 0 ? void 0 : properties.filter(function (p) {
        return p.propertyID == rule.propertyID;
      }).map(function (p) {
        return p.functionName;
      })[0];
    } catch (error) {
      throw "function or operator don't exist in dictionaries";
    }
  });
  _defineProperty(this, "clearPricings", function () {
    _this.pricing = undefined;
    _this.pricings = undefined;
  });
  // property functions    
  // functions = [
  //     {"TextLength":  this.TextLengthFunction},
  //     {"ElementSize":  this.ElementSizeFunction},
  //     {"LinesLength":  this.LinesLengthFunction},                    
  //     {"AmountOfElements":  this.AmountOfElementsFunction},
  //     {"AmountOfUsedColors":  this.AmountOfUsedColorsFunction},
  //     {"CanvasSize":  this.CanvasSizeFunction},
  //     {"DesignTextLength":  this.DesignTextLengthFunction},
  //     {"CustomizedSides":  this.CustomizedSidesFunction},
  //     {"DesignSizeFunction":  this.DesignSizeFunction}, new
  // ]
  _defineProperty(this, "GetContextForRule", function (rule, product, design) {
    var context = {
      sides: [],
      items: []
    };
    var allItems = design.get('designItems').toArray();
    var selectedItems = []; // Item1, item 2, Item3, Item4

    //verifichiamo prima i targets e poi gli elements
    var colorName = ""; //ci serve per i target

    var colore = product.get('colors').find(function (c) {
      return c.get('colorID') == _this.colorID;
    });
    if (colore == null || colore == undefined) return context;
    colorName = colore.get('name');
    var sides = colore.get('sides');
    context.sides = [];
    if (rule.targets.length == 0) {
      // Se non ho target vuol dire che non sto filtrando per nulla 
      //e quindi devo prendere TUTTI gli item di TUTTO il prodotto personalizzato (a prescindere da area, lato o  variante)
      selectedItems = allItems;
      context.sides = sides.toArray();
    } else {
      rule.targets.forEach(function (target) {
        var skip = false;
        var side = null;
        var currentItems = allItems;

        // Se il target filtra per variante e la mia non corrisponde, salto completamente questo target e non aggiungo nulla ai selectedtItems
        //altrimenti per ora mi tengo tutti gli items del design (che ora stanno in sideItems)
        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.color) && target.color.toLowerCase() != colorName.toLowerCase()) {
          skip = true; //continue;
        } else {
          // Add sides of this color
          var _iterator = _createForOfIteratorHelper(sides.toArray()),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _side = _step.value;
              if (context.sides.indexOf(_side) === -1) context.sides.push(_side);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        // se c'è un filtro per side name selezioni gli item che stanno solo su quel side
        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.side)) {
          side = sides.find(function (s) {
            return s.get('name').toLowerCase() == target.side.toLowerCase();
          });
          if (side == null || !side.get('areas')) skip = true; //continue;
          else {
            var areaItems = [];

            // All items that touches the area filter
            var filter = function filter(item, area) {
              return item.get('areas').filter(function (a) {
                return a.get('modelID') == product.get('modelID') && a.get('colorID') == area.getSide().getColor().get('colorID') && a.get('sideID') == area.getSide().get('sideID') && a.get('areaID') == area.get('areaID');
              }).length > 0;
            };
            side.get('areas').forEach(function (area) {
              areaItems = areaItems.concat(allItems.filter(function (item) {
                return filter(item, area);
              }));
            });
            currentItems = areaItems;
          }
        }

        // se c'è un filtro per area name selezioni gli item che stanno su quell'area
        if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.area)) {
          var _areaItems = [];

          //se ci sono due lati, e un area su ogni lato con lo stesso nome. IN questo caso li voglio tutti e due gli item
          var areas = [];
          sides.forEach(function (side) {
            areas = areas.concat(side.get('areas').filter(function (a) {
              return a.get('name').toLowerCase() == target.area.toLowerCase();
            }));
          });
          areas.forEach(function (area) {
            //currentItems potrebbe essere già filtrato per lato, altrimenti contiene tutti gli item (allItems)
            _areaItems = _toConsumableArray(currentItems.filter(function (i) {
              return i.get('areas').filter(function (a) {
                return a.get('modelID') == product.get('modelID') && a.get('colorID') == area.getSide().getColor().get('colorID') && a.get('sideID') == area.getSide().get('sideID') && a.get('areaID') == area.get('areaID');
              }).length > 0;
            }));
          });

          //raggruppiamo alla fine
          currentItems = _areaItems;
        }

        //eliminiamo eventuali duplicati (raggruppa su ItemGuid perchè su cosmos (a livello di carrello siamo ancora su cosmosDb)
        //l'itemId non esiste ancora
        // currentItems = currentItems.GroupBy(c => c.ItemGuid, (key, c) => c.FirstOrDefault()).ToList();
        if (!skip) {
          selectedItems = [].concat(_toConsumableArray(selectedItems), _toConsumableArray(currentItems));
        }
      } //fine foreach target
      );
    }

    //chiedi come mettere gli id corretti nell'enumerativo degli elemnts
    if (rule.elementID == PricingElements.AllTexts) {
      selectedItems = selectedItems.filter(function (p) {
        var j = JSON.parse(p.get('json'))[1];
        return j.data.isText != null && j.data.isText || j.data.isTextArea != null && j.data.isTextArea || j.data.isTextOnPath != null && j.data.isTextOnPath || j.data.isTextArt != null && j.data.isTextArt;
      });
    } else if (rule.elementID == PricingElements.AllElementsNoTemplateItems) {
      selectedItems = selectedItems.filter(function (p) {
        var j = JSON.parse(p.get('json'))[1];
        return !j.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.AllCustomText) {
      //per gestire i vecchi casi in cui isTemplateElement non c'era: i null li considero custom
      selectedItems = selectedItems.filter(function (p) {
        var j = JSON.parse(p.get('json'))[1];
        return j.data.isTemplateElement != null && !j.data.isTemplateElement && (j.data.isText != null && j.data.isText || j.data.isTextArea != null && j.data.isTextArea || j.data.isTextOnPath != null && j.data.isTextOnPath || j.data.isTextArt != null && j.data.isTextArt) || j.data.isTemplateElement == null && (j.data.isText != null && j.data.isText || j.data.isTextArea != null && j.data.isTextArea || j.data.isTextOnPath != null && j.data.isTextOnPath || j.data.isTextArt != null && j.data.isTextArt);
      });
    } else if (rule.elementID == PricingElements.AllImages) {
      selectedItems = selectedItems.filter(function (i) {
        return i.get('imageID') > 0;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return !json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.UploadedImages) {
      selectedItems = selectedItems.filter(function (p) {
        if (p.get('imageID') > 0) {
          if (p.get('imageVisitorCode') || p.get('imageCustomerCode')) return true;
          if (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) return true;
        }
        return false;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return !json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.ClipartImages) {
      selectedItems = selectedItems.filter(function (p) {
        if (p.get('imageID') > 0) {
          if (p.get('imageVisitorCode') && p.get('imageCustomerCode')) return true;
          if (p.get('imageVisitorID') <= 0 && p.get('imageCustomerID') <= 0) return true;
        }
        return false;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return !json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.TemplatesImages) {
      selectedItems = selectedItems.filter(function (p) {
        return p.get('imageID') > 0;
      }).filter(function (i) {
        var json = JSON.parse(i.get('json'))[1];
        return json.data.isTemplateElement;
      });
    } else if (rule.elementID == PricingElements.SingleElement) {
      selectedItems = selectedItems.filter(function (i) {
        return i.get('name').toLowerCase() == rule.elementTitle.toLowerCase();
      });
    } else if (rule.elementID == PricingElements.AllTextArt) {
      selectedItems = selectedItems.filter(function (p) {
        var json = JSON.parse(p.get('json'))[1];
        return json.data.isTextArt != null && json.data.isTextArt;
      });
    } else if (rule.elementID == PricingElements.AllCustomTextArt) {
      //selectedtItems = selectedtItems.Where(x => x.isTexArt == true && item.isCustom);
    } else if (rule.elementID == PricingElements.AllCustomElements) {
      selectedItems = selectedItems.filter(function (p) {
        var json = JSON.parse(p.get('json'))[1];
        return p.get('imageID') > 0 && !json.data.isTemplateElement && (p.get('imageVisitorCode') || p.get('imageCustomerCode') || p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) || json.data.isTemplateElement != null && !json.data.isTemplateElement && (json.data.isText != null && json.data.isText || json.data.isTextArea != null && json.data.isTextArea || json.data.isTextOnPath != null && json.data.isTextOnPath || json.data.isTextArt != null && json.data.isTextArt) || json.data.isTemplateElement == null && (json.data.isText != null && json.data.isText || json.data.isTextArea != null && json.data.isTextArea || json.data.isTextOnPath != null && json.data.isTextOnPath || json.data.isTextArt != null && json.data.isTextArt);
      });
    } else if (rule.elementID == PricingElements.UploadedImages) {
      selectedItems = selectedItems.filter(function (p) {
        if (p.get('imageID') > 0) {
          if (p.get('imageVisitorCode') || p.get('imageCustomerCode')) return true;
          if (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0) return true;
        }
        return false;
      });
    }

    // eseguo una distinct
    var selectedItemsGroupByItemGuild = lodash__WEBPACK_IMPORTED_MODULE_1___default().groupBy(selectedItems, function (c) {
      return c.get('itemGuid');
    });
    context.items = Object.keys(selectedItemsGroupByItemGuild).map(function (k) {
      return selectedItemsGroupByItemGuild[k][0];
    });
    return context;
  });
  _defineProperty(this, "isUsingAmountOfColors", function (design) {
    _this.pricing = _this.getPricing(design);
    if (_this.pricing) return _this.pricing.rules.find(function (r) {
      return r.propertyID == 10;
    }) != undefined;else return false;
  });
  _defineProperty(this, "getPremiumPhotosPrice", function (design, quantity) {
    // Aggiungo il prezzo delle immagini esterne utilizzate
    var imageItemsGroups = [];
    var price = 0;
    var _loop = function _loop() {
      var _item$get;
      var item = design.get('designItems').at(i);
      if (item.get("imageID") > 0 && item.get("imagePrice") > 0 && item.get("providerImageID") != null && ((_item$get = item.get("providerImageID")) === null || _item$get === void 0 ? void 0 : _item$get.length) > 0 && !imageItemsGroups.find(function (x) {
        return x.get("providerImageID") === item.get("providerImageID");
      })) {
        imageItemsGroups.push(item);
        var pricePerImage = item.get("imagePrice");
        if (!_this.product.get("hasAdditionalFeeOnImagesProvider")) pricePerImage = item.get("applyImagePriceForQuantity") === null || item.get("applyImagePriceForQuantity") ? item.get("imagePrice") * quantity : item.get("imagePrice");else pricePerImage = item.get("imagePrice") * quantity;
        price += pricePerImage;
      }
    };
    for (var i = 0; i < design.get('designItems').length; i++) {
      _loop();
    }
    Logger.info('Premium photo price: ', price);
    return price;
  });
  /**
   * Get Image Price
   * 
   * Metodo che calcola il prezzo per le immagini nel design a cui a backoffice
   * è stato valorizzato un prezzo
   * 
   * @author f.checchia
   *
   * @param design Il design in input
   * @param {number} quantity La quantità del prodotto che si sta acquistando
   * 
   * @return {number} Il prezzo complessivo delle immagini per la quantità
   *
   * */
  _defineProperty(this, "getImagePrice", function (design, quantity) {
    // Aggiungo il prezzo delle immagini utilizzate
    var price = 0;
    for (var i = 0; i < design.get('designItems').length; i++) {
      var item = design.get('designItems').at(i);
      if (item.get("imageID") > 0 && item.get("imagePrice") > 0 && !item.get("providerImageID")) {
        var pricePerImage = item.get("imagePrice");
        pricePerImage = item.get("imagePrice") * quantity;
        price += pricePerImage;
      }
    }
    Logger.info('Image price: ', price);
    return price;
  });
  _defineProperty(this, "getMatchedConditions", function (design, quantity, includePercentage) {
    _this.pricing = _this.getPricing(design);
    if (!_this.pricing) return [];
    var matchedConditions = [];
    _this.pricing.rules.forEach(function (rule) {
      if (!includePercentage && rule.priceType == 1) return;
      var context = _this.GetContextForRule(rule, _this.product, design);

      // If we don't have sides to check, we are in the wrong
      // variant probably, just skip it.
      if (context.sides.length === 0) return;
      var conditionsGroupByformula = _this.conditionsToConditionsGroupByFormula(rule.conditions);
      var forEachBreakException = {};
      try {
        conditionsGroupByformula.sort(function (c1, c2) {
          return c1 && c2 && c1.position > c2.position ? 1 : -1;
        }).forEach(function (conditionGroupByFormula) {
          //per ogni gruppo (le cui conditions avranno tutte la stessa formula) estraggo dalla formula l'operatore e il values e richiamo la function
          var formulaObject = JSON.parse(conditionGroupByFormula.formula);
          if (!formulaObject.operator) throw "operator missing in formula";

          // if (!formulaObject.values || formulaObject.values.length == 0) throw ("values missing in formula");

          // conditionGroupByFormula.conditions.forEach( condition => {
          var functionName = _this.getFunctionName(_this.properties, rule) + "Function";

          //richiama la funzione col nome preso dalla property e con l'operatore preso dalla conditions (che in questo gruppo hanno la stessa formula)
          var result = _this[functionName](context, formulaObject);

          // //sia nel caso any che all mi calcolo il prezzo da aggiungere. 
          // //Nel caso any se il risultato è true non vado alla successiva condition
          if (result.result) {
            //in ogni gruppo prendo il priceToAdd della condition con la quantità più vicina alla quantità acquistata.                        
            var condition = conditionGroupByFormula.conditions.filter(function (g) {
              return g.quantity <= quantity;
            }).sort(function (c1, c2) {
              return c2.quantity - c1.quantity;
            })[0];

            //controlla condition: se è null vai avanti
            if (condition != null) {
              var priceToAdd = condition.priceToAdd;
              var isSetupPrice = rule.isSetupPrice;
              var multiplier = result.multiplier;
              var priceType = rule.priceType;
              matchedConditions.push({
                priceToAdd: priceToAdd,
                isSetupPrice: isSetupPrice,
                multiplier: multiplier,
                priceType: priceType
              });

              // If some itemes were not matched with this condition, we must continue to check 
              // for other conditions
              var functionMatchedAllItems = !result.items || result.items.length == 0;
              if (!rule.allMatchType && result.items) context.items = result.items;
              if (!rule.allMatchType && functionMatchedAllItems) throw forEachBreakException;
            }
          }
        });
      } catch (e) {
        if (e !== forEachBreakException) throw e;
      }
    });
    return matchedConditions;
  });
  _defineProperty(this, "calculate", function (design, quantity) {
    var matchedConditions = [];
    var totalPriceToAdd = _this.getPremiumPhotosPrice(design, quantity);
    totalPriceToAdd += _this.getImagePrice(design, quantity);
    matchedConditions = _this.getMatchedConditions(design, quantity, false);
    matchedConditions.forEach(function (matchedCondition) {
      var conditionPrice = matchedCondition.priceToAdd * matchedCondition.multiplier;
      if (!matchedCondition.isSetupPrice) conditionPrice *= quantity;
      totalPriceToAdd += conditionPrice;
    });
    Logger.info('Total custom price: ', totalPriceToAdd);
    return totalPriceToAdd;
  });
  _defineProperty(this, "getPricingAdditionalInfo", function (design) {
    if (!design) return;
    var pricing = _this.getPricing(design);
    if (!pricing) return;
    return {
      description: pricing.description,
      priceDescriptionEnabled: pricing.priceDescriptionEnabled,
      infoPricingText: pricing.infoPricingText,
      priceStructure: pricing.priceStructure
    };
  });
  if (apiUrl !== undefined) this.config.apiUrl = apiUrl + "graphql";
  if (token !== undefined) this.config.token = token;
  if (isOwin !== undefined) this.config.isOwin = isOwin;
  if (cloudFlareApiUrl) this.config.cloudFlareApiUrl = cloudFlareApiUrl + "graphql";
  if (clientLang) this.config.clientLang = clientLang;
});

/***/ }),

/***/ "../../utils/rectangle.ts":
/*!********************************!*\
  !*** ../../utils/rectangle.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rectangle": () => (/* binding */ Rectangle),
/* harmony export */   "rectangleArea": () => (/* binding */ rectangleArea),
/* harmony export */   "rectanglesDistinctArea": () => (/* binding */ rectanglesDistinctArea)
/* harmony export */ });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Rectangle = /*#__PURE__*/_createClass(function Rectangle(width, height, x, y) {
  var _this = this;
  _classCallCheck(this, Rectangle);
  _defineProperty(this, "maxX", function () {
    return _this.x + _this.width;
  });
  _defineProperty(this, "maxY", function () {
    return _this.y + _this.height;
  });
  _defineProperty(this, "area", function () {
    return _this.width * _this.height;
  });
  _defineProperty(this, "areaPPCM", function (ppcm) {
    return _this.width / ppcm * (_this.height / ppcm);
  });
  _defineProperty(this, "equals", function (rectangleToCompare) {
    return _this.width == rectangleToCompare.width && _this.height == rectangleToCompare.height && _this.x == rectangleToCompare.x && _this.y == rectangleToCompare.y;
  });
  this.width = width;
  this.height = height;
  this.x = x;
  this.y = y;
});
var distinct = function distinct(n, i, array) {
  return array.indexOf(n) === i;
};
var rectangleArea = function rectangleArea(r) {
  return r.width * r.height;
};
var rectangleSplitAtXPosition = function rectangleSplitAtXPosition(rectangle, x) {
  if (x <= rectangle.x || x >= rectangle.x + rectangle.width) {
    return [rectangle];
  }
  var rect1 = new Rectangle(x - rectangle.x, rectangle.height, rectangle.x, rectangle.y);
  var rect2 = new Rectangle(rectangle.maxX() - x, rectangle.height, x, rectangle.y);
  return [rect1, rect2];
};
var rectangleSplitAtYPosition = function rectangleSplitAtYPosition(rectangle, y) {
  if (y <= rectangle.y || y >= rectangle.y + rectangle.height) {
    return [rectangle];
  }
  var rect1 = new Rectangle(rectangle.width, y - rectangle.y, rectangle.x, rectangle.y);
  var rect2 = new Rectangle(rectangle.width, rectangle.maxY() - y, rectangle.x, y);
  return [rect1, rect2];
};
var rectangleIncludeXPosition = function rectangleIncludeXPosition(rectangle, x) {
  return rectangle.x < x && rectangle.maxX() > x;
};
var rectangleIncludeYPosition = function rectangleIncludeYPosition(rectangle, y) {
  return rectangle.y < y && rectangle.maxY() > y;
};
var rectangleNotIncludeXPosition = function rectangleNotIncludeXPosition(rectangle, x) {
  return rectangle.x >= x || rectangle.maxX() <= x;
};
var rectangleNotIncludeYPosition = function rectangleNotIncludeYPosition(rectangle, y) {
  return rectangle.y >= y || rectangle.maxY() <= y;
};
var rectanglesDistinctArea = function rectanglesDistinctArea(rectangles, ppcm) {
  // all x values
  var xPositions = rectangles.reduce(function (acc, rectangle) {
    return [].concat(_toConsumableArray(acc), [rectangle.x, rectangle.maxX()]);
  }, []).filter(distinct).sort(function (v1, v2) {
    return v1 - v2;
  });
  var rectanglesOutputByXPosition = _toConsumableArray(rectangles);
  xPositions.forEach(function (xPosition) {
    var rectanglesToDivide = rectanglesOutputByXPosition.filter(function (rectangle) {
      return rectangleIncludeXPosition(rectangle, xPosition);
    });
    var rectanglesToNotDivide = rectanglesOutputByXPosition.filter(function (rectangle) {
      return rectangleNotIncludeXPosition(rectangle, xPosition);
    });
    var rectanglesDivided = rectanglesToDivide.map(function (rectangle) {
      return rectangleSplitAtXPosition(rectangle, xPosition);
    }).reduce(function (acc, val) {
      return acc.concat(val);
    }, []); // flatMap
    rectanglesOutputByXPosition = [].concat(_toConsumableArray(rectanglesToNotDivide), _toConsumableArray(rectanglesDivided));
  });
  var yPositions = rectanglesOutputByXPosition.reduce(function (acc, rectangle) {
    return [].concat(_toConsumableArray(acc), [rectangle.y, rectangle.maxY()]);
  }, []).filter(distinct).sort(function (v1, v2) {
    return v1 - v2;
  });
  var rectanglesOutputByYPosition = _toConsumableArray(rectanglesOutputByXPosition);
  yPositions.forEach(function (yPosition) {
    var rectanglesToDivide = rectanglesOutputByYPosition.filter(function (rectangle) {
      return rectangleIncludeYPosition(rectangle, yPosition);
    });
    var rectanglesToNotDivide = rectanglesOutputByYPosition.filter(function (rectangle) {
      return rectangleNotIncludeYPosition(rectangle, yPosition);
    });
    var rectanglesDivided = rectanglesToDivide.map(function (rectangle) {
      return rectangleSplitAtYPosition(rectangle, yPosition);
    }).reduce(function (acc, val) {
      return acc.concat(val);
    }, []); // flatMap
    rectanglesOutputByYPosition = [].concat(_toConsumableArray(rectanglesToNotDivide), _toConsumableArray(rectanglesDivided));
  });
  return rectanglesOutputByYPosition.filter(function (rect, index, arr) {
    return arr.findIndex(function (r) {
      return r.equals(rect);
    }) == index;
  }) // distinct rectangle
  .reduce(function (acc, rect) {
    return ppcm ? acc + rect.areaPPCM(ppcm) : acc + rect.area();
  }, 0); // sum all rectangles area
};

/***/ }),

/***/ "../../../node_modules/gl-matrix/esm/common.js":
/*!*****************************************************!*\
  !*** ../../../node_modules/gl-matrix/esm/common.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ARRAY_TYPE": () => (/* binding */ ARRAY_TYPE),
/* harmony export */   "EPSILON": () => (/* binding */ EPSILON),
/* harmony export */   "RANDOM": () => (/* binding */ RANDOM),
/* harmony export */   "equals": () => (/* binding */ equals),
/* harmony export */   "setMatrixArrayType": () => (/* binding */ setMatrixArrayType),
/* harmony export */   "toRadian": () => (/* binding */ toRadian)
/* harmony export */ });
/**
 * Common utilities
 * @module glMatrix
 */
// Configuration Constants
var EPSILON = 0.000001;
var ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
var RANDOM = Math.random;
/**
 * Sets the type of array used when creating new vectors and matrices
 *
 * @param {Float32ArrayConstructor | ArrayConstructor} type Array type, such as Float32Array or Array
 */

function setMatrixArrayType(type) {
  ARRAY_TYPE = type;
}
var degree = Math.PI / 180;
/**
 * Convert Degree To Radian
 *
 * @param {Number} a Angle in Degrees
 */

function toRadian(a) {
  return a * degree;
}
/**
 * Tests whether or not the arguments have approximately the same value, within an absolute
 * or relative tolerance of glMatrix.EPSILON (an absolute tolerance is used for values less
 * than or equal to 1.0, and a relative tolerance is used for larger values)
 *
 * @param {Number} a The first number to test.
 * @param {Number} b The second number to test.
 * @returns {Boolean} True if the numbers are approximately equal, false otherwise.
 */

function equals(a, b) {
  return Math.abs(a - b) <= EPSILON * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function () {
  var y = 0,
      i = arguments.length;

  while (i--) {
    y += arguments[i] * arguments[i];
  }

  return Math.sqrt(y);
};

/***/ }),

/***/ "../../../node_modules/gl-matrix/esm/mat4.js":
/*!***************************************************!*\
  !*** ../../../node_modules/gl-matrix/esm/mat4.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "add": () => (/* binding */ add),
/* harmony export */   "adjoint": () => (/* binding */ adjoint),
/* harmony export */   "clone": () => (/* binding */ clone),
/* harmony export */   "copy": () => (/* binding */ copy),
/* harmony export */   "create": () => (/* binding */ create),
/* harmony export */   "determinant": () => (/* binding */ determinant),
/* harmony export */   "equals": () => (/* binding */ equals),
/* harmony export */   "exactEquals": () => (/* binding */ exactEquals),
/* harmony export */   "frob": () => (/* binding */ frob),
/* harmony export */   "fromQuat": () => (/* binding */ fromQuat),
/* harmony export */   "fromQuat2": () => (/* binding */ fromQuat2),
/* harmony export */   "fromRotation": () => (/* binding */ fromRotation),
/* harmony export */   "fromRotationTranslation": () => (/* binding */ fromRotationTranslation),
/* harmony export */   "fromRotationTranslationScale": () => (/* binding */ fromRotationTranslationScale),
/* harmony export */   "fromRotationTranslationScaleOrigin": () => (/* binding */ fromRotationTranslationScaleOrigin),
/* harmony export */   "fromScaling": () => (/* binding */ fromScaling),
/* harmony export */   "fromTranslation": () => (/* binding */ fromTranslation),
/* harmony export */   "fromValues": () => (/* binding */ fromValues),
/* harmony export */   "fromXRotation": () => (/* binding */ fromXRotation),
/* harmony export */   "fromYRotation": () => (/* binding */ fromYRotation),
/* harmony export */   "fromZRotation": () => (/* binding */ fromZRotation),
/* harmony export */   "frustum": () => (/* binding */ frustum),
/* harmony export */   "getRotation": () => (/* binding */ getRotation),
/* harmony export */   "getScaling": () => (/* binding */ getScaling),
/* harmony export */   "getTranslation": () => (/* binding */ getTranslation),
/* harmony export */   "identity": () => (/* binding */ identity),
/* harmony export */   "invert": () => (/* binding */ invert),
/* harmony export */   "lookAt": () => (/* binding */ lookAt),
/* harmony export */   "mul": () => (/* binding */ mul),
/* harmony export */   "multiply": () => (/* binding */ multiply),
/* harmony export */   "multiplyScalar": () => (/* binding */ multiplyScalar),
/* harmony export */   "multiplyScalarAndAdd": () => (/* binding */ multiplyScalarAndAdd),
/* harmony export */   "ortho": () => (/* binding */ ortho),
/* harmony export */   "orthoNO": () => (/* binding */ orthoNO),
/* harmony export */   "orthoZO": () => (/* binding */ orthoZO),
/* harmony export */   "perspective": () => (/* binding */ perspective),
/* harmony export */   "perspectiveFromFieldOfView": () => (/* binding */ perspectiveFromFieldOfView),
/* harmony export */   "perspectiveNO": () => (/* binding */ perspectiveNO),
/* harmony export */   "perspectiveZO": () => (/* binding */ perspectiveZO),
/* harmony export */   "rotate": () => (/* binding */ rotate),
/* harmony export */   "rotateX": () => (/* binding */ rotateX),
/* harmony export */   "rotateY": () => (/* binding */ rotateY),
/* harmony export */   "rotateZ": () => (/* binding */ rotateZ),
/* harmony export */   "scale": () => (/* binding */ scale),
/* harmony export */   "set": () => (/* binding */ set),
/* harmony export */   "str": () => (/* binding */ str),
/* harmony export */   "sub": () => (/* binding */ sub),
/* harmony export */   "subtract": () => (/* binding */ subtract),
/* harmony export */   "targetTo": () => (/* binding */ targetTo),
/* harmony export */   "translate": () => (/* binding */ translate),
/* harmony export */   "transpose": () => (/* binding */ transpose)
/* harmony export */ });
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common.js */ "../../../node_modules/gl-matrix/esm/common.js");

/**
 * 4x4 Matrix<br>Format: column-major, when typed out it looks like row-major<br>The matrices are being post multiplied.
 * @module mat4
 */

/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */

function create() {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(16);

  if (_common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
  }

  out[0] = 1;
  out[5] = 1;
  out[10] = 1;
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */

function clone(a) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(16);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Create a new mat4 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} A new mat4
 */

function fromValues(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(16);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Set the components of a mat4 to the given values
 *
 * @param {mat4} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} out
 */

function set(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */

function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    var a01 = a[1],
        a02 = a[2],
        a03 = a[3];
    var a12 = a[6],
        a13 = a[7];
    var a23 = a[11];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a01;
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a02;
    out[9] = a12;
    out[11] = a[14];
    out[12] = a03;
    out[13] = a13;
    out[14] = a23;
  } else {
    out[0] = a[0];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a[1];
    out[5] = a[5];
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a[2];
    out[9] = a[6];
    out[10] = a[10];
    out[11] = a[14];
    out[12] = a[3];
    out[13] = a[7];
    out[14] = a[11];
    out[15] = a[15];
  }

  return out;
}
/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function invert(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
  return out;
}
/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function adjoint(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
  out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
  out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
  out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
  out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
  out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
  out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
  out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
  out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
  out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
  out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
  out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
  out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
  out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
  out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
  out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
  return out;
}
/**
 * Calculates the determinant of a mat4
 *
 * @param {ReadonlyMat4} a the source matrix
 * @returns {Number} determinant of a
 */

function determinant(a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
/**
 * Multiplies two mat4s
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function multiply(out, a, b) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15]; // Cache only the current line of the second matrix

  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[4];
  b1 = b[5];
  b2 = b[6];
  b3 = b[7];
  out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[8];
  b1 = b[9];
  b2 = b[10];
  b3 = b[11];
  out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[12];
  b1 = b[13];
  b2 = b[14];
  b3 = b[15];
  out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  return out;
}
/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to translate
 * @param {ReadonlyVec3} v vector to translate by
 * @returns {mat4} out
 */

function translate(out, a, v) {
  var x = v[0],
      y = v[1],
      z = v[2];
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;

  if (a === out) {
    out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
    out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
    out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
    out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
  } else {
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a03;
    out[4] = a10;
    out[5] = a11;
    out[6] = a12;
    out[7] = a13;
    out[8] = a20;
    out[9] = a21;
    out[10] = a22;
    out[11] = a23;
    out[12] = a00 * x + a10 * y + a20 * z + a[12];
    out[13] = a01 * x + a11 * y + a21 * z + a[13];
    out[14] = a02 * x + a12 * y + a22 * z + a[14];
    out[15] = a03 * x + a13 * y + a23 * z + a[15];
  }

  return out;
}
/**
 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {ReadonlyVec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/

function scale(out, a, v) {
  var x = v[0],
      y = v[1],
      z = v[2];
  out[0] = a[0] * x;
  out[1] = a[1] * x;
  out[2] = a[2] * x;
  out[3] = a[3] * x;
  out[4] = a[4] * y;
  out[5] = a[5] * y;
  out[6] = a[6] * y;
  out[7] = a[7] * y;
  out[8] = a[8] * z;
  out[9] = a[9] * z;
  out[10] = a[10] * z;
  out[11] = a[11] * z;
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Rotates a mat4 by the given angle around the given axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */

function rotate(out, a, rad, axis) {
  var x = axis[0],
      y = axis[1],
      z = axis[2];
  var len = Math.hypot(x, y, z);
  var s, c, t;
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;
  var b00, b01, b02;
  var b10, b11, b12;
  var b20, b21, b22;

  if (len < _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON) {
    return null;
  }

  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;
  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c;
  a00 = a[0];
  a01 = a[1];
  a02 = a[2];
  a03 = a[3];
  a10 = a[4];
  a11 = a[5];
  a12 = a[6];
  a13 = a[7];
  a20 = a[8];
  a21 = a[9];
  a22 = a[10];
  a23 = a[11]; // Construct the elements of the rotation matrix

  b00 = x * x * t + c;
  b01 = y * x * t + z * s;
  b02 = z * x * t - y * s;
  b10 = x * y * t - z * s;
  b11 = y * y * t + c;
  b12 = z * y * t + x * s;
  b20 = x * z * t + y * s;
  b21 = y * z * t - x * s;
  b22 = z * z * t + c; // Perform rotation-specific matrix multiplication

  out[0] = a00 * b00 + a10 * b01 + a20 * b02;
  out[1] = a01 * b00 + a11 * b01 + a21 * b02;
  out[2] = a02 * b00 + a12 * b01 + a22 * b02;
  out[3] = a03 * b00 + a13 * b01 + a23 * b02;
  out[4] = a00 * b10 + a10 * b11 + a20 * b12;
  out[5] = a01 * b10 + a11 * b11 + a21 * b12;
  out[6] = a02 * b10 + a12 * b11 + a22 * b12;
  out[7] = a03 * b10 + a13 * b11 + a23 * b12;
  out[8] = a00 * b20 + a10 * b21 + a20 * b22;
  out[9] = a01 * b20 + a11 * b21 + a21 * b22;
  out[10] = a02 * b20 + a12 * b21 + a22 * b22;
  out[11] = a03 * b20 + a13 * b21 + a23 * b22;

  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }

  return out;
}
/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateX(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[4] = a10 * c + a20 * s;
  out[5] = a11 * c + a21 * s;
  out[6] = a12 * c + a22 * s;
  out[7] = a13 * c + a23 * s;
  out[8] = a20 * c - a10 * s;
  out[9] = a21 * c - a11 * s;
  out[10] = a22 * c - a12 * s;
  out[11] = a23 * c - a13 * s;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateY(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[0] = a00 * c - a20 * s;
  out[1] = a01 * c - a21 * s;
  out[2] = a02 * c - a22 * s;
  out[3] = a03 * c - a23 * s;
  out[8] = a00 * s + a20 * c;
  out[9] = a01 * s + a21 * c;
  out[10] = a02 * s + a22 * c;
  out[11] = a03 * s + a23 * c;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateZ(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];

  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication


  out[0] = a00 * c + a10 * s;
  out[1] = a01 * c + a11 * s;
  out[2] = a02 * c + a12 * s;
  out[3] = a03 * c + a13 * s;
  out[4] = a10 * c - a00 * s;
  out[5] = a11 * c - a01 * s;
  out[6] = a12 * c - a02 * s;
  out[7] = a13 * c - a03 * s;
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.scale(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Scaling vector
 * @returns {mat4} out
 */

function fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = v[1];
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = v[2];
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotate(dest, dest, rad, axis);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */

function fromRotation(out, rad, axis) {
  var x = axis[0],
      y = axis[1],
      z = axis[2];
  var len = Math.hypot(x, y, z);
  var s, c, t;

  if (len < _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON) {
    return null;
  }

  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;
  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c; // Perform rotation-specific matrix multiplication

  out[0] = x * x * t + c;
  out[1] = y * x * t + z * s;
  out[2] = z * x * t - y * s;
  out[3] = 0;
  out[4] = x * y * t - z * s;
  out[5] = y * y * t + c;
  out[6] = z * y * t + x * s;
  out[7] = 0;
  out[8] = x * z * t + y * s;
  out[9] = y * z * t - x * s;
  out[10] = z * z * t + c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateX(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromXRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = c;
  out[6] = s;
  out[7] = 0;
  out[8] = 0;
  out[9] = -s;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateY(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromYRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = c;
  out[1] = 0;
  out[2] = -s;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = s;
  out[9] = 0;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateZ(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromZRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = 0;
  out[4] = -s;
  out[5] = c;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function fromRotationTranslation(out, q, v) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - (yy + zz);
  out[1] = xy + wz;
  out[2] = xz - wy;
  out[3] = 0;
  out[4] = xy - wz;
  out[5] = 1 - (xx + zz);
  out[6] = yz + wx;
  out[7] = 0;
  out[8] = xz + wy;
  out[9] = yz - wx;
  out[10] = 1 - (xx + yy);
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 from a dual quat.
 *
 * @param {mat4} out Matrix
 * @param {ReadonlyQuat2} a Dual Quaternion
 * @returns {mat4} mat4 receiving operation result
 */

function fromQuat2(out, a) {
  var translation = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(3);
  var bx = -a[0],
      by = -a[1],
      bz = -a[2],
      bw = a[3],
      ax = a[4],
      ay = a[5],
      az = a[6],
      aw = a[7];
  var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense

  if (magnitude > 0) {
    translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
    translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
    translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
  } else {
    translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
    translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
    translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
  }

  fromRotationTranslation(out, a, translation);
  return out;
}
/**
 * Returns the translation vector component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslation,
 *  the returned vector will be the same as the translation vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive translation component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */

function getTranslation(out, mat) {
  out[0] = mat[12];
  out[1] = mat[13];
  out[2] = mat[14];
  return out;
}
/**
 * Returns the scaling factor component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslationScale
 *  with a normalized Quaternion paramter, the returned vector will be
 *  the same as the scaling vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive scaling factor component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */

function getScaling(out, mat) {
  var m11 = mat[0];
  var m12 = mat[1];
  var m13 = mat[2];
  var m21 = mat[4];
  var m22 = mat[5];
  var m23 = mat[6];
  var m31 = mat[8];
  var m32 = mat[9];
  var m33 = mat[10];
  out[0] = Math.hypot(m11, m12, m13);
  out[1] = Math.hypot(m21, m22, m23);
  out[2] = Math.hypot(m31, m32, m33);
  return out;
}
/**
 * Returns a quaternion representing the rotational component
 *  of a transformation matrix. If a matrix is built with
 *  fromRotationTranslation, the returned quaternion will be the
 *  same as the quaternion originally supplied.
 * @param {quat} out Quaternion to receive the rotation component
 * @param {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {quat} out
 */

function getRotation(out, mat) {
  var scaling = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(3);
  getScaling(scaling, mat);
  var is1 = 1 / scaling[0];
  var is2 = 1 / scaling[1];
  var is3 = 1 / scaling[2];
  var sm11 = mat[0] * is1;
  var sm12 = mat[1] * is2;
  var sm13 = mat[2] * is3;
  var sm21 = mat[4] * is1;
  var sm22 = mat[5] * is2;
  var sm23 = mat[6] * is3;
  var sm31 = mat[8] * is1;
  var sm32 = mat[9] * is2;
  var sm33 = mat[10] * is3;
  var trace = sm11 + sm22 + sm33;
  var S = 0;

  if (trace > 0) {
    S = Math.sqrt(trace + 1.0) * 2;
    out[3] = 0.25 * S;
    out[0] = (sm23 - sm32) / S;
    out[1] = (sm31 - sm13) / S;
    out[2] = (sm12 - sm21) / S;
  } else if (sm11 > sm22 && sm11 > sm33) {
    S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
    out[3] = (sm23 - sm32) / S;
    out[0] = 0.25 * S;
    out[1] = (sm12 + sm21) / S;
    out[2] = (sm31 + sm13) / S;
  } else if (sm22 > sm33) {
    S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
    out[3] = (sm31 - sm13) / S;
    out[0] = (sm12 + sm21) / S;
    out[1] = 0.25 * S;
    out[2] = (sm23 + sm32) / S;
  } else {
    S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
    out[3] = (sm12 - sm21) / S;
    out[0] = (sm31 + sm13) / S;
    out[1] = (sm23 + sm32) / S;
    out[2] = 0.25 * S;
  }

  return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @returns {mat4} out
 */

function fromRotationTranslationScale(out, q, v, s) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  var sx = s[0];
  var sy = s[1];
  var sz = s[2];
  out[0] = (1 - (yy + zz)) * sx;
  out[1] = (xy + wz) * sx;
  out[2] = (xz - wy) * sx;
  out[3] = 0;
  out[4] = (xy - wz) * sy;
  out[5] = (1 - (xx + zz)) * sy;
  out[6] = (yz + wx) * sy;
  out[7] = 0;
  out[8] = (xz + wy) * sz;
  out[9] = (yz - wx) * sz;
  out[10] = (1 - (xx + yy)) * sz;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale, rotating and scaling around the given origin
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     mat4.translate(dest, origin);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *     mat4.translate(dest, negativeOrigin);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @param {ReadonlyVec3} o The origin vector around which to scale and rotate
 * @returns {mat4} out
 */

function fromRotationTranslationScaleOrigin(out, q, v, s, o) {
  // Quaternion math
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  var sx = s[0];
  var sy = s[1];
  var sz = s[2];
  var ox = o[0];
  var oy = o[1];
  var oz = o[2];
  var out0 = (1 - (yy + zz)) * sx;
  var out1 = (xy + wz) * sx;
  var out2 = (xz - wy) * sx;
  var out4 = (xy - wz) * sy;
  var out5 = (1 - (xx + zz)) * sy;
  var out6 = (yz + wx) * sy;
  var out8 = (xz + wy) * sz;
  var out9 = (yz - wx) * sz;
  var out10 = (1 - (xx + yy)) * sz;
  out[0] = out0;
  out[1] = out1;
  out[2] = out2;
  out[3] = 0;
  out[4] = out4;
  out[5] = out5;
  out[6] = out6;
  out[7] = 0;
  out[8] = out8;
  out[9] = out9;
  out[10] = out10;
  out[11] = 0;
  out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
  out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
  out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
  out[15] = 1;
  return out;
}
/**
 * Calculates a 4x4 matrix from the given quaternion
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyQuat} q Quaternion to create matrix from
 *
 * @returns {mat4} out
 */

function fromQuat(out, q) {
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var yx = y * x2;
  var yy = y * y2;
  var zx = z * x2;
  var zy = z * y2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - yy - zz;
  out[1] = yx + wz;
  out[2] = zx - wy;
  out[3] = 0;
  out[4] = yx - wz;
  out[5] = 1 - xx - zz;
  out[6] = zy + wx;
  out[7] = 0;
  out[8] = zx + wy;
  out[9] = zy - wx;
  out[10] = 1 - xx - yy;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */

function frustum(out, left, right, bottom, top, near, far) {
  var rl = 1 / (right - left);
  var tb = 1 / (top - bottom);
  var nf = 1 / (near - far);
  out[0] = near * 2 * rl;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = near * 2 * tb;
  out[6] = 0;
  out[7] = 0;
  out[8] = (right + left) * rl;
  out[9] = (top + bottom) * tb;
  out[10] = (far + near) * nf;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[14] = far * near * 2 * nf;
  out[15] = 0;
  return out;
}
/**
 * Generates a perspective projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */

function perspectiveNO(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
      nf;
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;

  if (far != null && far !== Infinity) {
    nf = 1 / (near - far);
    out[10] = (far + near) * nf;
    out[14] = 2 * far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -2 * near;
  }

  return out;
}
/**
 * Alias for {@link mat4.perspectiveNO}
 * @function
 */

var perspective = perspectiveNO;
/**
 * Generates a perspective projection matrix suitable for WebGPU with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [0, 1],
 * which matches WebGPU/Vulkan/DirectX/Metal's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */

function perspectiveZO(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
      nf;
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;

  if (far != null && far !== Infinity) {
    nf = 1 / (near - far);
    out[10] = far * nf;
    out[14] = far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -near;
  }

  return out;
}
/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Object} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function perspectiveFromFieldOfView(out, fov, near, far) {
  var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
  var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
  var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
  var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
  var xScale = 2.0 / (leftTan + rightTan);
  var yScale = 2.0 / (upTan + downTan);
  out[0] = xScale;
  out[1] = 0.0;
  out[2] = 0.0;
  out[3] = 0.0;
  out[4] = 0.0;
  out[5] = yScale;
  out[6] = 0.0;
  out[7] = 0.0;
  out[8] = -((leftTan - rightTan) * xScale * 0.5);
  out[9] = (upTan - downTan) * yScale * 0.5;
  out[10] = far / (near - far);
  out[11] = -1.0;
  out[12] = 0.0;
  out[13] = 0.0;
  out[14] = far * near / (near - far);
  out[15] = 0.0;
  return out;
}
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function orthoNO(out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right);
  var bt = 1 / (bottom - top);
  var nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 2 * nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = (far + near) * nf;
  out[15] = 1;
  return out;
}
/**
 * Alias for {@link mat4.orthoNO}
 * @function
 */

var ortho = orthoNO;
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [0, 1],
 * which matches WebGPU/Vulkan/DirectX/Metal's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function orthoZO(out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right);
  var bt = 1 / (bottom - top);
  var nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = near * nf;
  out[15] = 1;
  return out;
}
/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis.
 * If you want a matrix that actually makes an object look at another object, you should use targetTo instead.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */

function lookAt(out, eye, center, up) {
  var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
  var eyex = eye[0];
  var eyey = eye[1];
  var eyez = eye[2];
  var upx = up[0];
  var upy = up[1];
  var upz = up[2];
  var centerx = center[0];
  var centery = center[1];
  var centerz = center[2];

  if (Math.abs(eyex - centerx) < _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON && Math.abs(eyey - centery) < _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON && Math.abs(eyez - centerz) < _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON) {
    return identity(out);
  }

  z0 = eyex - centerx;
  z1 = eyey - centery;
  z2 = eyez - centerz;
  len = 1 / Math.hypot(z0, z1, z2);
  z0 *= len;
  z1 *= len;
  z2 *= len;
  x0 = upy * z2 - upz * z1;
  x1 = upz * z0 - upx * z2;
  x2 = upx * z1 - upy * z0;
  len = Math.hypot(x0, x1, x2);

  if (!len) {
    x0 = 0;
    x1 = 0;
    x2 = 0;
  } else {
    len = 1 / len;
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }

  y0 = z1 * x2 - z2 * x1;
  y1 = z2 * x0 - z0 * x2;
  y2 = z0 * x1 - z1 * x0;
  len = Math.hypot(y0, y1, y2);

  if (!len) {
    y0 = 0;
    y1 = 0;
    y2 = 0;
  } else {
    len = 1 / len;
    y0 *= len;
    y1 *= len;
    y2 *= len;
  }

  out[0] = x0;
  out[1] = y0;
  out[2] = z0;
  out[3] = 0;
  out[4] = x1;
  out[5] = y1;
  out[6] = z1;
  out[7] = 0;
  out[8] = x2;
  out[9] = y2;
  out[10] = z2;
  out[11] = 0;
  out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
  out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
  out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
  out[15] = 1;
  return out;
}
/**
 * Generates a matrix that makes something look at something else.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */

function targetTo(out, eye, target, up) {
  var eyex = eye[0],
      eyey = eye[1],
      eyez = eye[2],
      upx = up[0],
      upy = up[1],
      upz = up[2];
  var z0 = eyex - target[0],
      z1 = eyey - target[1],
      z2 = eyez - target[2];
  var len = z0 * z0 + z1 * z1 + z2 * z2;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
    z0 *= len;
    z1 *= len;
    z2 *= len;
  }

  var x0 = upy * z2 - upz * z1,
      x1 = upz * z0 - upx * z2,
      x2 = upx * z1 - upy * z0;
  len = x0 * x0 + x1 * x1 + x2 * x2;

  if (len > 0) {
    len = 1 / Math.sqrt(len);
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }

  out[0] = x0;
  out[1] = x1;
  out[2] = x2;
  out[3] = 0;
  out[4] = z1 * x2 - z2 * x1;
  out[5] = z2 * x0 - z0 * x2;
  out[6] = z0 * x1 - z1 * x0;
  out[7] = 0;
  out[8] = z0;
  out[9] = z1;
  out[10] = z2;
  out[11] = 0;
  out[12] = eyex;
  out[13] = eyey;
  out[14] = eyez;
  out[15] = 1;
  return out;
}
/**
 * Returns a string representation of a mat4
 *
 * @param {ReadonlyMat4} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function str(a) {
  return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
/**
 * Returns Frobenius norm of a mat4
 *
 * @param {ReadonlyMat4} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
/**
 * Adds two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  out[9] = a[9] + b[9];
  out[10] = a[10] + b[10];
  out[11] = a[11] + b[11];
  out[12] = a[12] + b[12];
  out[13] = a[13] + b[13];
  out[14] = a[14] + b[14];
  out[15] = a[15] + b[15];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  out[9] = a[9] - b[9];
  out[10] = a[10] - b[10];
  out[11] = a[11] - b[11];
  out[12] = a[12] - b[12];
  out[13] = a[13] - b[13];
  out[14] = a[14] - b[14];
  out[15] = a[15] - b[15];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat4} out
 */

function multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  out[9] = a[9] * b;
  out[10] = a[10] * b;
  out[11] = a[11] * b;
  out[12] = a[12] * b;
  out[13] = a[13] * b;
  out[14] = a[14] * b;
  out[15] = a[15] * b;
  return out;
}
/**
 * Adds two mat4's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat4} out the receiving vector
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat4} out
 */

function multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  out[6] = a[6] + b[6] * scale;
  out[7] = a[7] + b[7] * scale;
  out[8] = a[8] + b[8] * scale;
  out[9] = a[9] + b[9] * scale;
  out[10] = a[10] + b[10] * scale;
  out[11] = a[11] + b[11] * scale;
  out[12] = a[12] + b[12] * scale;
  out[13] = a[13] + b[13] * scale;
  out[14] = a[14] + b[14] * scale;
  out[15] = a[15] + b[15] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3];
  var a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7];
  var a8 = a[8],
      a9 = a[9],
      a10 = a[10],
      a11 = a[11];
  var a12 = a[12],
      a13 = a[13],
      a14 = a[14],
      a15 = a[15];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3];
  var b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7];
  var b8 = b[8],
      b9 = b[9],
      b10 = b[10],
      b11 = b[11];
  var b12 = b[12],
      b13 = b[13],
      b14 = b[14],
      b15 = b[15];
  return Math.abs(a0 - b0) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
/**
 * Alias for {@link mat4.multiply}
 * @function
 */

var mul = multiply;
/**
 * Alias for {@link mat4.subtract}
 * @function
 */

var sub = subtract;

/***/ }),

/***/ "../../../node_modules/gl-matrix/esm/vec3.js":
/*!***************************************************!*\
  !*** ../../../node_modules/gl-matrix/esm/vec3.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "add": () => (/* binding */ add),
/* harmony export */   "angle": () => (/* binding */ angle),
/* harmony export */   "bezier": () => (/* binding */ bezier),
/* harmony export */   "ceil": () => (/* binding */ ceil),
/* harmony export */   "clone": () => (/* binding */ clone),
/* harmony export */   "copy": () => (/* binding */ copy),
/* harmony export */   "create": () => (/* binding */ create),
/* harmony export */   "cross": () => (/* binding */ cross),
/* harmony export */   "dist": () => (/* binding */ dist),
/* harmony export */   "distance": () => (/* binding */ distance),
/* harmony export */   "div": () => (/* binding */ div),
/* harmony export */   "divide": () => (/* binding */ divide),
/* harmony export */   "dot": () => (/* binding */ dot),
/* harmony export */   "equals": () => (/* binding */ equals),
/* harmony export */   "exactEquals": () => (/* binding */ exactEquals),
/* harmony export */   "floor": () => (/* binding */ floor),
/* harmony export */   "forEach": () => (/* binding */ forEach),
/* harmony export */   "fromValues": () => (/* binding */ fromValues),
/* harmony export */   "hermite": () => (/* binding */ hermite),
/* harmony export */   "inverse": () => (/* binding */ inverse),
/* harmony export */   "len": () => (/* binding */ len),
/* harmony export */   "length": () => (/* binding */ length),
/* harmony export */   "lerp": () => (/* binding */ lerp),
/* harmony export */   "max": () => (/* binding */ max),
/* harmony export */   "min": () => (/* binding */ min),
/* harmony export */   "mul": () => (/* binding */ mul),
/* harmony export */   "multiply": () => (/* binding */ multiply),
/* harmony export */   "negate": () => (/* binding */ negate),
/* harmony export */   "normalize": () => (/* binding */ normalize),
/* harmony export */   "random": () => (/* binding */ random),
/* harmony export */   "rotateX": () => (/* binding */ rotateX),
/* harmony export */   "rotateY": () => (/* binding */ rotateY),
/* harmony export */   "rotateZ": () => (/* binding */ rotateZ),
/* harmony export */   "round": () => (/* binding */ round),
/* harmony export */   "scale": () => (/* binding */ scale),
/* harmony export */   "scaleAndAdd": () => (/* binding */ scaleAndAdd),
/* harmony export */   "set": () => (/* binding */ set),
/* harmony export */   "sqrDist": () => (/* binding */ sqrDist),
/* harmony export */   "sqrLen": () => (/* binding */ sqrLen),
/* harmony export */   "squaredDistance": () => (/* binding */ squaredDistance),
/* harmony export */   "squaredLength": () => (/* binding */ squaredLength),
/* harmony export */   "str": () => (/* binding */ str),
/* harmony export */   "sub": () => (/* binding */ sub),
/* harmony export */   "subtract": () => (/* binding */ subtract),
/* harmony export */   "transformMat3": () => (/* binding */ transformMat3),
/* harmony export */   "transformMat4": () => (/* binding */ transformMat4),
/* harmony export */   "transformQuat": () => (/* binding */ transformQuat),
/* harmony export */   "zero": () => (/* binding */ zero)
/* harmony export */ });
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common.js */ "../../../node_modules/gl-matrix/esm/common.js");

/**
 * 3 Dimensional Vector
 * @module vec3
 */

/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */

function create() {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(3);

  if (_common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }

  return out;
}
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {ReadonlyVec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */

function clone(a) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(3);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Calculates the length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate length of
 * @returns {Number} length of a
 */

function length(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return Math.hypot(x, y, z);
}
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */

function fromValues(x, y, z) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(3);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the source vector
 * @returns {vec3} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */

function set(out, x, y, z) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  return out;
}
/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  return out;
}
/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  return out;
}
/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to ceil
 * @returns {vec3} out
 */

function ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  return out;
}
/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to floor
 * @returns {vec3} out
 */

function floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  return out;
}
/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  return out;
}
/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  return out;
}
/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to round
 * @returns {vec3} out
 */

function round(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  return out;
}
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */

function scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  return out;
}
/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */

function scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} distance between a and b
 */

function distance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return Math.hypot(x, y, z);
}
/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} squared distance between a and b
 */

function squaredDistance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return x * x + y * y + z * z;
}
/**
 * Calculates the squared length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function squaredLength(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return x * x + y * y + z * z;
}
/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to negate
 * @returns {vec3} out
 */

function negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  return out;
}
/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to invert
 * @returns {vec3} out
 */

function inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  return out;
}
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to normalize
 * @returns {vec3} out
 */

function normalize(out, a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var len = x * x + y * y + z * z;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  out[2] = a[2] * len;
  return out;
}
/**
 * Calculates the dot product of two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function cross(out, a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2];
  var bx = b[0],
      by = b[1],
      bz = b[2];
  out[0] = ay * bz - az * by;
  out[1] = az * bx - ax * bz;
  out[2] = ax * by - ay * bx;
  return out;
}
/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function lerp(out, a, b, t) {
  var ax = a[0];
  var ay = a[1];
  var az = a[2];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  return out;
}
/**
 * Performs a hermite interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function hermite(out, a, b, c, d, t) {
  var factorTimes2 = t * t;
  var factor1 = factorTimes2 * (2 * t - 3) + 1;
  var factor2 = factorTimes2 * (t - 2) + t;
  var factor3 = factorTimes2 * (t - 1);
  var factor4 = factorTimes2 * (3 - 2 * t);
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Performs a bezier interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function bezier(out, a, b, c, d, t) {
  var inverseFactor = 1 - t;
  var inverseFactorTimesTwo = inverseFactor * inverseFactor;
  var factorTimes2 = t * t;
  var factor1 = inverseFactorTimesTwo * inverseFactor;
  var factor2 = 3 * t * inverseFactorTimesTwo;
  var factor3 = 3 * factorTimes2 * inverseFactor;
  var factor4 = factorTimes2 * t;
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */

function random(out, scale) {
  scale = scale || 1.0;
  var r = _common_js__WEBPACK_IMPORTED_MODULE_0__.RANDOM() * 2.0 * Math.PI;
  var z = _common_js__WEBPACK_IMPORTED_MODULE_0__.RANDOM() * 2.0 - 1.0;
  var zScale = Math.sqrt(1.0 - z * z) * scale;
  out[0] = Math.cos(r) * zScale;
  out[1] = Math.sin(r) * zScale;
  out[2] = z * scale;
  return out;
}
/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec3} out
 */

function transformMat4(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  var w = m[3] * x + m[7] * y + m[11] * z + m[15];
  w = w || 1.0;
  out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
  out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
  out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
  return out;
}
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat3} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */

function transformMat3(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  out[0] = x * m[0] + y * m[3] + z * m[6];
  out[1] = x * m[1] + y * m[4] + z * m[7];
  out[2] = x * m[2] + y * m[5] + z * m[8];
  return out;
}
/**
 * Transforms the vec3 with a quat
 * Can also be used for dual quaternions. (Multiply it with the real part)
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec3} out
 */

function transformQuat(out, a, q) {
  // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3];
  var x = a[0],
      y = a[1],
      z = a[2]; // var qvec = [qx, qy, qz];
  // var uv = vec3.cross([], qvec, a);

  var uvx = qy * z - qz * y,
      uvy = qz * x - qx * z,
      uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);

  var uuvx = qy * uvz - qz * uvy,
      uuvy = qz * uvx - qx * uvz,
      uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);

  var w2 = qw * 2;
  uvx *= w2;
  uvy *= w2;
  uvz *= w2; // vec3.scale(uuv, uuv, 2);

  uuvx *= 2;
  uuvy *= 2;
  uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));

  out[0] = x + uvx + uuvx;
  out[1] = y + uvy + uuvy;
  out[2] = z + uvz + uuvz;
  return out;
}
/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateX(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0];
  r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
  r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateY(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
  r[1] = p[1];
  r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateZ(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
  r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
  r[2] = p[2]; //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Get the angle between two 3D vectors
 * @param {ReadonlyVec3} a The first operand
 * @param {ReadonlyVec3} b The second operand
 * @returns {Number} The angle in radians
 */

function angle(a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2],
      bx = b[0],
      by = b[1],
      bz = b[2],
      mag1 = Math.sqrt(ax * ax + ay * ay + az * az),
      mag2 = Math.sqrt(bx * bx + by * by + bz * bz),
      mag = mag1 * mag2,
      cosine = mag && dot(a, b) / mag;
  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
/**
 * Set the components of a vec3 to zero
 *
 * @param {vec3} out the receiving vector
 * @returns {vec3} out
 */

function zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  out[2] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec3} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function str(a) {
  return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2];
  return Math.abs(a0 - b0) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
/**
 * Alias for {@link vec3.subtract}
 * @function
 */

var sub = subtract;
/**
 * Alias for {@link vec3.multiply}
 * @function
 */

var mul = multiply;
/**
 * Alias for {@link vec3.divide}
 * @function
 */

var div = divide;
/**
 * Alias for {@link vec3.distance}
 * @function
 */

var dist = distance;
/**
 * Alias for {@link vec3.squaredDistance}
 * @function
 */

var sqrDist = squaredDistance;
/**
 * Alias for {@link vec3.length}
 * @function
 */

var len = length;
/**
 * Alias for {@link vec3.squaredLength}
 * @function
 */

var sqrLen = squaredLength;
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach = function () {
  var vec = create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 3;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
    }

    return a;
  };
}();

/***/ }),

/***/ "../../../node_modules/is-buffer/index.js":
/*!************************************************!*\
  !*** ../../../node_modules/is-buffer/index.js ***!
  \************************************************/
/***/ ((module) => {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),

/***/ "../../../node_modules/lodash/lodash.js":
/*!**********************************************!*\
  !*** ../../../node_modules/lodash/lodash.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));


/***/ }),

/***/ "../../../node_modules/paper/dist/paper-full.js":
/*!******************************************************!*\
  !*** ../../../node_modules/paper/dist/paper-full.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Paper.js v0.12.17 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Thu Nov 3 21:15:36 2022 +0100
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */

var paper = function(self, undefined) {

self = self || __webpack_require__(/*! ./node/self.js */ "?a736");
var window = self.window,
	document = self.document;

var Base = new function() {
	var hidden = /^(statics|enumerable|beans|preserve)$/,
		array = [],
		slice = array.slice,
		create = Object.create,
		describe = Object.getOwnPropertyDescriptor,
		define = Object.defineProperty,

		forEach = array.forEach || function(iter, bind) {
			for (var i = 0, l = this.length; i < l; i++) {
				iter.call(bind, this[i], i, this);
			}
		},

		forIn = function(iter, bind) {
			for (var i in this) {
				if (this.hasOwnProperty(i))
					iter.call(bind, this[i], i, this);
			}
		},

		set = Object.assign || function(dst) {
			for (var i = 1, l = arguments.length; i < l; i++) {
				var src = arguments[i];
				for (var key in src) {
					if (src.hasOwnProperty(key))
						dst[key] = src[key];
				}
			}
			return dst;
		},

		each = function(obj, iter, bind) {
			if (obj) {
				var desc = describe(obj, 'length');
				(desc && typeof desc.value === 'number' ? forEach : forIn)
					.call(obj, iter, bind = bind || obj);
			}
			return bind;
		};

	function inject(dest, src, enumerable, beans, preserve) {
		var beansNames = {};

		function field(name, val) {
			val = val || (val = describe(src, name))
					&& (val.get ? val : val.value);
			if (typeof val === 'string' && val[0] === '#')
				val = dest[val.substring(1)] || val;
			var isFunc = typeof val === 'function',
				res = val,
				prev = preserve || isFunc && !val.base
						? (val && val.get ? name in dest : dest[name])
						: null,
				bean;
			if (!preserve || !prev) {
				if (isFunc && prev)
					val.base = prev;
				if (isFunc && beans !== false
						&& (bean = name.match(/^([gs]et|is)(([A-Z])(.*))$/)))
					beansNames[bean[3].toLowerCase() + bean[4]] = bean[2];
				if (!res || isFunc || !res.get || typeof res.get !== 'function'
						|| !Base.isPlainObject(res)) {
					res = { value: res, writable: true };
				}
				if ((describe(dest, name)
						|| { configurable: true }).configurable) {
					res.configurable = true;
					res.enumerable = enumerable != null ? enumerable : !bean;
				}
				define(dest, name, res);
			}
		}
		if (src) {
			for (var name in src) {
				if (src.hasOwnProperty(name) && !hidden.test(name))
					field(name);
			}
			for (var name in beansNames) {
				var part = beansNames[name],
					set = dest['set' + part],
					get = dest['get' + part] || set && dest['is' + part];
				if (get && (beans === true || get.length === 0))
					field(name, { get: get, set: set });
			}
		}
		return dest;
	}

	function Base() {
		for (var i = 0, l = arguments.length; i < l; i++) {
			var src = arguments[i];
			if (src)
				set(this, src);
		}
		return this;
	}

	return inject(Base, {
		inject: function(src) {
			if (src) {
				var statics = src.statics === true ? src : src.statics,
					beans = src.beans,
					preserve = src.preserve;
				if (statics !== src)
					inject(this.prototype, src, src.enumerable, beans, preserve);
				inject(this, statics, null, beans, preserve);
			}
			for (var i = 1, l = arguments.length; i < l; i++)
				this.inject(arguments[i]);
			return this;
		},

		extend: function() {
			var base = this,
				ctor,
				proto;
			for (var i = 0, obj, l = arguments.length;
					i < l && !(ctor && proto); i++) {
				obj = arguments[i];
				ctor = ctor || obj.initialize;
				proto = proto || obj.prototype;
			}
			ctor = ctor || function() {
				base.apply(this, arguments);
			};
			proto = ctor.prototype = proto || create(this.prototype);
			define(proto, 'constructor',
					{ value: ctor, writable: true, configurable: true });
			inject(ctor, this);
			if (arguments.length)
				this.inject.apply(ctor, arguments);
			ctor.base = base;
			return ctor;
		}
	}).inject({
		enumerable: false,

		initialize: Base,

		set: Base,

		inject: function() {
			for (var i = 0, l = arguments.length; i < l; i++) {
				var src = arguments[i];
				if (src) {
					inject(this, src, src.enumerable, src.beans, src.preserve);
				}
			}
			return this;
		},

		extend: function() {
			var res = create(this);
			return res.inject.apply(res, arguments);
		},

		each: function(iter, bind) {
			return each(this, iter, bind);
		},

		clone: function() {
			return new this.constructor(this);
		},

		statics: {
			set: set,
			each: each,
			create: create,
			define: define,
			describe: describe,

			clone: function(obj) {
				return set(new obj.constructor(), obj);
			},

			isPlainObject: function(obj) {
				var ctor = obj != null && obj.constructor;
				return ctor && (ctor === Object || ctor === Base
						|| ctor.name === 'Object');
			},

			pick: function(a, b) {
				return a !== undefined ? a : b;
			},

			slice: function(list, begin, end) {
				return slice.call(list, begin, end);
			}
		}
	});
};

if (true)
	module.exports = Base;

Base.inject({
	enumerable: false,

	toString: function() {
		return this._id != null
			?  (this._class || 'Object') + (this._name
				? " '" + this._name + "'"
				: ' @' + this._id)
			: '{ ' + Base.each(this, function(value, key) {
				if (!/^_/.test(key)) {
					var type = typeof value;
					this.push(key + ': ' + (type === 'number'
							? Formatter.instance.number(value)
							: type === 'string' ? "'" + value + "'" : value));
				}
			}, []).join(', ') + ' }';
	},

	getClassName: function() {
		return this._class || '';
	},

	importJSON: function(json) {
		return Base.importJSON(json, this);
	},

	exportJSON: function(options) {
		return Base.exportJSON(this, options);
	},

	toJSON: function() {
		return Base.serialize(this);
	},

	set: function(props, exclude) {
		if (props)
			Base.filter(this, props, exclude, this._prioritize);
		return this;
	}
}, {

beans: false,
statics: {
	exports: {},

	extend: function extend() {
		var res = extend.base.apply(this, arguments),
			name = res.prototype._class;
		if (name && !Base.exports[name])
			Base.exports[name] = res;
		return res;
	},

	equals: function(obj1, obj2) {
		if (obj1 === obj2)
			return true;
		if (obj1 && obj1.equals)
			return obj1.equals(obj2);
		if (obj2 && obj2.equals)
			return obj2.equals(obj1);
		if (obj1 && obj2
				&& typeof obj1 === 'object' && typeof obj2 === 'object') {
			if (Array.isArray(obj1) && Array.isArray(obj2)) {
				var length = obj1.length;
				if (length !== obj2.length)
					return false;
				while (length--) {
					if (!Base.equals(obj1[length], obj2[length]))
						return false;
				}
			} else {
				var keys = Object.keys(obj1),
					length = keys.length;
				if (length !== Object.keys(obj2).length)
					return false;
				while (length--) {
					var key = keys[length];
					if (!(obj2.hasOwnProperty(key)
							&& Base.equals(obj1[key], obj2[key])))
						return false;
				}
			}
			return true;
		}
		return false;
	},

	read: function(list, start, options, amount) {
		if (this === Base) {
			var value = this.peek(list, start);
			list.__index++;
			return value;
		}
		var proto = this.prototype,
			readIndex = proto._readIndex,
			begin = start || readIndex && list.__index || 0,
			length = list.length,
			obj = list[begin];
		amount = amount || length - begin;
		if (obj instanceof this
			|| options && options.readNull && obj == null && amount <= 1) {
			if (readIndex)
				list.__index = begin + 1;
			return obj && options && options.clone ? obj.clone() : obj;
		}
		obj = Base.create(proto);
		if (readIndex)
			obj.__read = true;
		obj = obj.initialize.apply(obj, begin > 0 || begin + amount < length
				? Base.slice(list, begin, begin + amount)
				: list) || obj;
		if (readIndex) {
			list.__index = begin + obj.__read;
			var filtered = obj.__filtered;
			if (filtered) {
				list.__filtered = filtered;
				obj.__filtered = undefined;
			}
			obj.__read = undefined;
		}
		return obj;
	},

	peek: function(list, start) {
		return list[list.__index = start || list.__index || 0];
	},

	remain: function(list) {
		return list.length - (list.__index || 0);
	},

	readList: function(list, start, options, amount) {
		var res = [],
			entry,
			begin = start || 0,
			end = amount ? begin + amount : list.length;
		for (var i = begin; i < end; i++) {
			res.push(Array.isArray(entry = list[i])
					? this.read(entry, 0, options)
					: this.read(list, i, options, 1));
		}
		return res;
	},

	readNamed: function(list, name, start, options, amount) {
		var value = this.getNamed(list, name),
			hasValue = value !== undefined;
		if (hasValue) {
			var filtered = list.__filtered;
			if (!filtered) {
				var source = this.getSource(list);
				filtered = list.__filtered = Base.create(source);
				filtered.__unfiltered = source;
			}
			filtered[name] = undefined;
		}
		return this.read(hasValue ? [value] : list, start, options, amount);
	},

	readSupported: function(list, dest) {
		var source = this.getSource(list),
			that = this,
			read = false;
		if (source) {
			Object.keys(source).forEach(function(key) {
				if (key in dest) {
					var value = that.readNamed(list, key);
					if (value !== undefined) {
						dest[key] = value;
					}
					read = true;
				}
			});
		}
		return read;
	},

	getSource: function(list) {
		var source = list.__source;
		if (source === undefined) {
			var arg = list.length === 1 && list[0];
			source = list.__source = arg && Base.isPlainObject(arg)
				? arg : null;
		}
		return source;
	},

	getNamed: function(list, name) {
		var source = this.getSource(list);
		if (source) {
			return name ? source[name] : list.__filtered || source;
		}
	},

	hasNamed: function(list, name) {
		return !!this.getNamed(list, name);
	},

	filter: function(dest, source, exclude, prioritize) {
		var processed;

		function handleKey(key) {
			if (!(exclude && key in exclude) &&
				!(processed && key in processed)) {
				var value = source[key];
				if (value !== undefined)
					dest[key] = value;
			}
		}

		if (prioritize) {
			var keys = {};
			for (var i = 0, key, l = prioritize.length; i < l; i++) {
				if ((key = prioritize[i]) in source) {
					handleKey(key);
					keys[key] = true;
				}
			}
			processed = keys;
		}

		Object.keys(source.__unfiltered || source).forEach(handleKey);
		return dest;
	},

	isPlainValue: function(obj, asString) {
		return Base.isPlainObject(obj) || Array.isArray(obj)
				|| asString && typeof obj === 'string';
	},

	serialize: function(obj, options, compact, dictionary) {
		options = options || {};

		var isRoot = !dictionary,
			res;
		if (isRoot) {
			options.formatter = new Formatter(options.precision);
			dictionary = {
				length: 0,
				definitions: {},
				references: {},
				add: function(item, create) {
					var id = '#' + item._id,
						ref = this.references[id];
					if (!ref) {
						this.length++;
						var res = create.call(item),
							name = item._class;
						if (name && res[0] !== name)
							res.unshift(name);
						this.definitions[id] = res;
						ref = this.references[id] = [id];
					}
					return ref;
				}
			};
		}
		if (obj && obj._serialize) {
			res = obj._serialize(options, dictionary);
			var name = obj._class;
			if (name && !obj._compactSerialize && (isRoot || !compact)
					&& res[0] !== name) {
				res.unshift(name);
			}
		} else if (Array.isArray(obj)) {
			res = [];
			for (var i = 0, l = obj.length; i < l; i++)
				res[i] = Base.serialize(obj[i], options, compact, dictionary);
		} else if (Base.isPlainObject(obj)) {
			res = {};
			var keys = Object.keys(obj);
			for (var i = 0, l = keys.length; i < l; i++) {
				var key = keys[i];
				res[key] = Base.serialize(obj[key], options, compact,
						dictionary);
			}
		} else if (typeof obj === 'number') {
			res = options.formatter.number(obj, options.precision);
		} else {
			res = obj;
		}
		return isRoot && dictionary.length > 0
				? [['dictionary', dictionary.definitions], res]
				: res;
	},

	deserialize: function(json, create, _data, _setDictionary, _isRoot) {
		var res = json,
			isFirst = !_data,
			hasDictionary = isFirst && json && json.length
				&& json[0][0] === 'dictionary';
		_data = _data || {};
		if (Array.isArray(json)) {
			var type = json[0],
				isDictionary = type === 'dictionary';
			if (json.length == 1 && /^#/.test(type)) {
				return _data.dictionary[type];
			}
			type = Base.exports[type];
			res = [];
			for (var i = type ? 1 : 0, l = json.length; i < l; i++) {
				res.push(Base.deserialize(json[i], create, _data,
						isDictionary, hasDictionary));
			}
			if (type) {
				var args = res;
				if (create) {
					res = create(type, args, isFirst || _isRoot);
				} else {
					res = new type(args);
				}
			}
		} else if (Base.isPlainObject(json)) {
			res = {};
			if (_setDictionary)
				_data.dictionary = res;
			for (var key in json)
				res[key] = Base.deserialize(json[key], create, _data);
		}
		return hasDictionary ? res[1] : res;
	},

	exportJSON: function(obj, options) {
		var json = Base.serialize(obj, options);
		return options && options.asString == false
				? json
				: JSON.stringify(json);
	},

	importJSON: function(json, target) {
		return Base.deserialize(
				typeof json === 'string' ? JSON.parse(json) : json,
				function(ctor, args, isRoot) {
					var useTarget = isRoot && target
							&& target.constructor === ctor,
						obj = useTarget ? target
							: Base.create(ctor.prototype);
					if (args.length === 1 && obj instanceof Item
							&& (useTarget || !(obj instanceof Layer))) {
						var arg = args[0];
						if (Base.isPlainObject(arg)) {
							arg.insert = false;
							if (useTarget) {
								args = args.concat([Item.INSERT]);
							}
						}
					}
					(useTarget ? obj.set : ctor).apply(obj, args);
					if (useTarget)
						target = null;
					return obj;
				});
	},

	push: function(list, items) {
		var itemsLength = items.length;
		if (itemsLength < 4096) {
			list.push.apply(list, items);
		} else {
			var startLength = list.length;
			list.length += itemsLength;
			for (var i = 0; i < itemsLength; i++) {
				list[startLength + i] = items[i];
			}
		}
		return list;
	},

	splice: function(list, items, index, remove) {
		var amount = items && items.length,
			append = index === undefined;
		index = append ? list.length : index;
		if (index > list.length)
			index = list.length;
		for (var i = 0; i < amount; i++)
			items[i]._index = index + i;
		if (append) {
			Base.push(list, items);
			return [];
		} else {
			var args = [index, remove];
			if (items)
				Base.push(args, items);
			var removed = list.splice.apply(list, args);
			for (var i = 0, l = removed.length; i < l; i++)
				removed[i]._index = undefined;
			for (var i = index + amount, l = list.length; i < l; i++)
				list[i]._index = i;
			return removed;
		}
	},

	capitalize: function(str) {
		return str.replace(/\b[a-z]/g, function(match) {
			return match.toUpperCase();
		});
	},

	camelize: function(str) {
		return str.replace(/-(.)/g, function(match, chr) {
			return chr.toUpperCase();
		});
	},

	hyphenate: function(str) {
		return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
	}
}});

var Emitter = {
	on: function(type, func) {
		if (typeof type !== 'string') {
			Base.each(type, function(value, key) {
				this.on(key, value);
			}, this);
		} else {
			var types = this._eventTypes,
				entry = types && types[type],
				handlers = this._callbacks = this._callbacks || {};
			handlers = handlers[type] = handlers[type] || [];
			if (handlers.indexOf(func) === -1) {
				handlers.push(func);
				if (entry && entry.install && handlers.length === 1)
					entry.install.call(this, type);
			}
		}
		return this;
	},

	off: function(type, func) {
		if (typeof type !== 'string') {
			Base.each(type, function(value, key) {
				this.off(key, value);
			}, this);
			return;
		}
		var types = this._eventTypes,
			entry = types && types[type],
			handlers = this._callbacks && this._callbacks[type],
			index;
		if (handlers) {
			if (!func || (index = handlers.indexOf(func)) !== -1
					&& handlers.length === 1) {
				if (entry && entry.uninstall)
					entry.uninstall.call(this, type);
				delete this._callbacks[type];
			} else if (index !== -1) {
				handlers.splice(index, 1);
			}
		}
		return this;
	},

	once: function(type, func) {
		return this.on(type, function handler() {
			func.apply(this, arguments);
			this.off(type, handler);
		});
	},

	emit: function(type, event) {
		var handlers = this._callbacks && this._callbacks[type];
		if (!handlers)
			return false;
		var args = Base.slice(arguments, 1),
			setTarget = event && event.target && !event.currentTarget;
		handlers = handlers.slice();
		if (setTarget)
			event.currentTarget = this;
		for (var i = 0, l = handlers.length; i < l; i++) {
			if (handlers[i].apply(this, args) == false) {
				if (event && event.stop)
					event.stop();
				break;
		   }
		}
		if (setTarget)
			delete event.currentTarget;
		return true;
	},

	responds: function(type) {
		return !!(this._callbacks && this._callbacks[type]);
	},

	attach: '#on',
	detach: '#off',
	fire: '#emit',

	_installEvents: function(install) {
		var types = this._eventTypes,
			handlers = this._callbacks,
			key = install ? 'install' : 'uninstall';
		if (types) {
			for (var type in handlers) {
				if (handlers[type].length > 0) {
					var entry = types[type],
						func = entry && entry[key];
					if (func)
						func.call(this, type);
				}
			}
		}
	},

	statics: {
		inject: function inject(src) {
			var events = src._events;
			if (events) {
				var types = {};
				Base.each(events, function(entry, key) {
					var isString = typeof entry === 'string',
						name = isString ? entry : key,
						part = Base.capitalize(name),
						type = name.substring(2).toLowerCase();
					types[type] = isString ? {} : entry;
					name = '_' + name;
					src['get' + part] = function() {
						return this[name];
					};
					src['set' + part] = function(func) {
						var prev = this[name];
						if (prev)
							this.off(type, prev);
						if (func)
							this.on(type, func);
						this[name] = func;
					};
				});
				src._eventTypes = types;
			}
			return inject.base.apply(this, arguments);
		}
	}
};

var PaperScope = Base.extend({
	_class: 'PaperScope',

	initialize: function PaperScope() {
		paper = this;
		this.settings = new Base({
			applyMatrix: true,
			insertItems: true,
			handleSize: 4,
			hitTolerance: 0
		});
		this.project = null;
		this.projects = [];
		this.tools = [];
		this._id = PaperScope._id++;
		PaperScope._scopes[this._id] = this;
		var proto = PaperScope.prototype;
		if (!this.support) {
			var ctx = CanvasProvider.getContext(1, 1) || {};
			proto.support = {
				nativeDash: 'setLineDash' in ctx || 'mozDash' in ctx,
				nativeBlendModes: BlendMode.nativeModes
			};
			CanvasProvider.release(ctx);
		}
		if (!this.agent) {
			var user = self.navigator.userAgent.toLowerCase(),
				os = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(user)||[])[0],
				platform = os === 'darwin' ? 'mac' : os,
				agent = proto.agent = proto.browser = { platform: platform };
			if (platform)
				agent[platform] = true;
			user.replace(
				/(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
				function(match, n, v1, v2, rv) {
					if (!agent.chrome) {
						var v = n === 'opera' ? v2 :
								/^(node|trident)$/.test(n) ? rv : v1;
						agent.version = v;
						agent.versionNumber = parseFloat(v);
						n = { trident: 'msie', jsdom: 'node' }[n] || n;
						agent.name = n;
						agent[n] = true;
					}
				}
			);
			if (agent.chrome)
				delete agent.webkit;
			if (agent.atom)
				delete agent.chrome;
		}
	},

	version: "0.12.17",

	getView: function() {
		var project = this.project;
		return project && project._view;
	},

	getPaper: function() {
		return this;
	},

	execute: function(code, options) {
			var exports = paper.PaperScript.execute(code, this, options);
			View.updateFocus();
			return exports;
	},

	install: function(scope) {
		var that = this;
		Base.each(['project', 'view', 'tool'], function(key) {
			Base.define(scope, key, {
				configurable: true,
				get: function() {
					return that[key];
				}
			});
		});
		for (var key in this)
			if (!/^_/.test(key) && this[key])
				scope[key] = this[key];
	},

	setup: function(element) {
		paper = this;
		this.project = new Project(element);
		return this;
	},

	createCanvas: function(width, height) {
		return CanvasProvider.getCanvas(width, height);
	},

	activate: function() {
		paper = this;
	},

	clear: function() {
		var projects = this.projects,
			tools = this.tools;
		for (var i = projects.length - 1; i >= 0; i--)
			projects[i].remove();
		for (var i = tools.length - 1; i >= 0; i--)
			tools[i].remove();
	},

	remove: function() {
		this.clear();
		delete PaperScope._scopes[this._id];
	},

	statics: new function() {
		function handleAttribute(name) {
			name += 'Attribute';
			return function(el, attr) {
				return el[name](attr) || el[name]('data-paper-' + attr);
			};
		}

		return {
			_scopes: {},
			_id: 0,

			get: function(id) {
				return this._scopes[id] || null;
			},

			getAttribute: handleAttribute('get'),
			hasAttribute: handleAttribute('has')
		};
	}
});

var PaperScopeItem = Base.extend(Emitter, {

	initialize: function(activate) {
		this._scope = paper;
		this._index = this._scope[this._list].push(this) - 1;
		if (activate || !this._scope[this._reference])
			this.activate();
	},

	activate: function() {
		if (!this._scope)
			return false;
		var prev = this._scope[this._reference];
		if (prev && prev !== this)
			prev.emit('deactivate');
		this._scope[this._reference] = this;
		this.emit('activate', prev);
		return true;
	},

	isActive: function() {
		return this._scope[this._reference] === this;
	},

	remove: function() {
		if (this._index == null)
			return false;
		Base.splice(this._scope[this._list], null, this._index, 1);
		if (this._scope[this._reference] == this)
			this._scope[this._reference] = null;
		this._scope = null;
		return true;
	},

	getView: function() {
		return this._scope.getView();
	}
});

var CollisionDetection = {
	findItemBoundsCollisions: function(items1, items2, tolerance) {
		function getBounds(items) {
			var bounds = new Array(items.length);
			for (var i = 0; i < items.length; i++) {
				var rect = items[i].getBounds();
				bounds[i] = [rect.left, rect.top, rect.right, rect.bottom];
			}
			return bounds;
		}

		var bounds1 = getBounds(items1),
			bounds2 = !items2 || items2 === items1
				? bounds1
				: getBounds(items2);
		return this.findBoundsCollisions(bounds1, bounds2, tolerance || 0);
	},

	findCurveBoundsCollisions: function(curves1, curves2, tolerance, bothAxis) {
		function getBounds(curves) {
			var min = Math.min,
				max = Math.max,
				bounds = new Array(curves.length);
			for (var i = 0; i < curves.length; i++) {
				var v = curves[i];
				bounds[i] = [
					min(v[0], v[2], v[4], v[6]),
					min(v[1], v[3], v[5], v[7]),
					max(v[0], v[2], v[4], v[6]),
					max(v[1], v[3], v[5], v[7])
				];
			}
			return bounds;
		}

		var bounds1 = getBounds(curves1),
			bounds2 = !curves2 || curves2 === curves1
				? bounds1
				: getBounds(curves2);
		if (bothAxis) {
			var hor = this.findBoundsCollisions(
					bounds1, bounds2, tolerance || 0, false, true),
				ver = this.findBoundsCollisions(
					bounds1, bounds2, tolerance || 0, true, true),
				list = [];
			for (var i = 0, l = hor.length; i < l; i++) {
				list[i] = { hor: hor[i], ver: ver[i] };
			}
			return list;
		}
		return this.findBoundsCollisions(bounds1, bounds2, tolerance || 0);
	},

	findBoundsCollisions: function(boundsA, boundsB, tolerance,
		sweepVertical, onlySweepAxisCollisions) {
		var self = !boundsB || boundsA === boundsB,
			allBounds = self ? boundsA : boundsA.concat(boundsB),
			lengthA = boundsA.length,
			lengthAll = allBounds.length;

		function binarySearch(indices, coord, value) {
			var lo = 0,
				hi = indices.length;
			while (lo < hi) {
				var mid = (hi + lo) >>> 1;
				if (allBounds[indices[mid]][coord] < value) {
					lo = mid + 1;
				} else {
					hi = mid;
				}
			}
			return lo - 1;
		}

		var pri0 = sweepVertical ? 1 : 0,
			pri1 = pri0 + 2,
			sec0 = sweepVertical ? 0 : 1,
			sec1 = sec0 + 2;
		var allIndicesByPri0 = new Array(lengthAll);
		for (var i = 0; i < lengthAll; i++) {
			allIndicesByPri0[i] = i;
		}
		allIndicesByPri0.sort(function(i1, i2) {
			return allBounds[i1][pri0] - allBounds[i2][pri0];
		});
		var activeIndicesByPri1 = [],
			allCollisions = new Array(lengthA);
		for (var i = 0; i < lengthAll; i++) {
			var curIndex = allIndicesByPri0[i],
				curBounds = allBounds[curIndex],
				origIndex = self ? curIndex : curIndex - lengthA,
				isCurrentA = curIndex < lengthA,
				isCurrentB = self || !isCurrentA,
				curCollisions = isCurrentA ? [] : null;
			if (activeIndicesByPri1.length) {
				var pruneCount = binarySearch(activeIndicesByPri1, pri1,
						curBounds[pri0] - tolerance) + 1;
				activeIndicesByPri1.splice(0, pruneCount);
				if (self && onlySweepAxisCollisions) {
					curCollisions = curCollisions.concat(activeIndicesByPri1);
					for (var j = 0; j < activeIndicesByPri1.length; j++) {
						var activeIndex = activeIndicesByPri1[j];
						allCollisions[activeIndex].push(origIndex);
					}
				} else {
					var curSec1 = curBounds[sec1],
						curSec0 = curBounds[sec0];
					for (var j = 0; j < activeIndicesByPri1.length; j++) {
						var activeIndex = activeIndicesByPri1[j],
							activeBounds = allBounds[activeIndex],
							isActiveA = activeIndex < lengthA,
							isActiveB = self || activeIndex >= lengthA;

						if (
							onlySweepAxisCollisions ||
							(
								isCurrentA && isActiveB ||
								isCurrentB && isActiveA
							) && (
								curSec1 >= activeBounds[sec0] - tolerance &&
								curSec0 <= activeBounds[sec1] + tolerance
							)
						) {
							if (isCurrentA && isActiveB) {
								curCollisions.push(
									self ? activeIndex : activeIndex - lengthA);
							}
							if (isCurrentB && isActiveA) {
								allCollisions[activeIndex].push(origIndex);
							}
						}
					}
				}
			}
			if (isCurrentA) {
				if (boundsA === boundsB) {
					curCollisions.push(curIndex);
				}
				allCollisions[curIndex] = curCollisions;
			}
			if (activeIndicesByPri1.length) {
				var curPri1 = curBounds[pri1],
					index = binarySearch(activeIndicesByPri1, pri1, curPri1);
				activeIndicesByPri1.splice(index + 1, 0, curIndex);
			} else {
				activeIndicesByPri1.push(curIndex);
			}
		}
		for (var i = 0; i < allCollisions.length; i++) {
			var collisions = allCollisions[i];
			if (collisions) {
				collisions.sort(function(i1, i2) { return i1 - i2; });
			}
		}
		return allCollisions;
	}
};

var Formatter = Base.extend({
	initialize: function(precision) {
		this.precision = Base.pick(precision, 5);
		this.multiplier = Math.pow(10, this.precision);
	},

	number: function(val) {
		return this.precision < 16
				? Math.round(val * this.multiplier) / this.multiplier : val;
	},

	pair: function(val1, val2, separator) {
		return this.number(val1) + (separator || ',') + this.number(val2);
	},

	point: function(val, separator) {
		return this.number(val.x) + (separator || ',') + this.number(val.y);
	},

	size: function(val, separator) {
		return this.number(val.width) + (separator || ',')
				+ this.number(val.height);
	},

	rectangle: function(val, separator) {
		return this.point(val, separator) + (separator || ',')
				+ this.size(val, separator);
	}
});

Formatter.instance = new Formatter();

var Numerical = new function() {

	var abscissas = [
		[  0.5773502691896257645091488],
		[0,0.7745966692414833770358531],
		[  0.3399810435848562648026658,0.8611363115940525752239465],
		[0,0.5384693101056830910363144,0.9061798459386639927976269],
		[  0.2386191860831969086305017,0.6612093864662645136613996,0.9324695142031520278123016],
		[0,0.4058451513773971669066064,0.7415311855993944398638648,0.9491079123427585245261897],
		[  0.1834346424956498049394761,0.5255324099163289858177390,0.7966664774136267395915539,0.9602898564975362316835609],
		[0,0.3242534234038089290385380,0.6133714327005903973087020,0.8360311073266357942994298,0.9681602395076260898355762],
		[  0.1488743389816312108848260,0.4333953941292471907992659,0.6794095682990244062343274,0.8650633666889845107320967,0.9739065285171717200779640],
		[0,0.2695431559523449723315320,0.5190961292068118159257257,0.7301520055740493240934163,0.8870625997680952990751578,0.9782286581460569928039380],
		[  0.1252334085114689154724414,0.3678314989981801937526915,0.5873179542866174472967024,0.7699026741943046870368938,0.9041172563704748566784659,0.9815606342467192506905491],
		[0,0.2304583159551347940655281,0.4484927510364468528779129,0.6423493394403402206439846,0.8015780907333099127942065,0.9175983992229779652065478,0.9841830547185881494728294],
		[  0.1080549487073436620662447,0.3191123689278897604356718,0.5152486363581540919652907,0.6872929048116854701480198,0.8272013150697649931897947,0.9284348836635735173363911,0.9862838086968123388415973],
		[0,0.2011940939974345223006283,0.3941513470775633698972074,0.5709721726085388475372267,0.7244177313601700474161861,0.8482065834104272162006483,0.9372733924007059043077589,0.9879925180204854284895657],
		[  0.0950125098376374401853193,0.2816035507792589132304605,0.4580167776572273863424194,0.6178762444026437484466718,0.7554044083550030338951012,0.8656312023878317438804679,0.9445750230732325760779884,0.9894009349916499325961542]
	];

	var weights = [
		[1],
		[0.8888888888888888888888889,0.5555555555555555555555556],
		[0.6521451548625461426269361,0.3478548451374538573730639],
		[0.5688888888888888888888889,0.4786286704993664680412915,0.2369268850561890875142640],
		[0.4679139345726910473898703,0.3607615730481386075698335,0.1713244923791703450402961],
		[0.4179591836734693877551020,0.3818300505051189449503698,0.2797053914892766679014678,0.1294849661688696932706114],
		[0.3626837833783619829651504,0.3137066458778872873379622,0.2223810344533744705443560,0.1012285362903762591525314],
		[0.3302393550012597631645251,0.3123470770400028400686304,0.2606106964029354623187429,0.1806481606948574040584720,0.0812743883615744119718922],
		[0.2955242247147528701738930,0.2692667193099963550912269,0.2190863625159820439955349,0.1494513491505805931457763,0.0666713443086881375935688],
		[0.2729250867779006307144835,0.2628045445102466621806889,0.2331937645919904799185237,0.1862902109277342514260976,0.1255803694649046246346943,0.0556685671161736664827537],
		[0.2491470458134027850005624,0.2334925365383548087608499,0.2031674267230659217490645,0.1600783285433462263346525,0.1069393259953184309602547,0.0471753363865118271946160],
		[0.2325515532308739101945895,0.2262831802628972384120902,0.2078160475368885023125232,0.1781459807619457382800467,0.1388735102197872384636018,0.0921214998377284479144218,0.0404840047653158795200216],
		[0.2152638534631577901958764,0.2051984637212956039659241,0.1855383974779378137417166,0.1572031671581935345696019,0.1215185706879031846894148,0.0801580871597602098056333,0.0351194603317518630318329],
		[0.2025782419255612728806202,0.1984314853271115764561183,0.1861610000155622110268006,0.1662692058169939335532009,0.1395706779261543144478048,0.1071592204671719350118695,0.0703660474881081247092674,0.0307532419961172683546284],
		[0.1894506104550684962853967,0.1826034150449235888667637,0.1691565193950025381893121,0.1495959888165767320815017,0.1246289712555338720524763,0.0951585116824927848099251,0.0622535239386478928628438,0.0271524594117540948517806]
	];

	var abs = Math.abs,
		sqrt = Math.sqrt,
		pow = Math.pow,
		log2 = Math.log2 || function(x) {
			return Math.log(x) * Math.LOG2E;
		},
		EPSILON = 1e-12,
		MACHINE_EPSILON = 1.12e-16;

	function clamp(value, min, max) {
		return value < min ? min : value > max ? max : value;
	}

	function getDiscriminant(a, b, c) {
		function split(v) {
			var x = v * 134217729,
				y = v - x,
				hi = y + x,
				lo = v - hi;
			return [hi, lo];
		}

		var D = b * b - a * c,
			E = b * b + a * c;
		if (abs(D) * 3 < E) {
			var ad = split(a),
				bd = split(b),
				cd = split(c),
				p = b * b,
				dp = (bd[0] * bd[0] - p + 2 * bd[0] * bd[1]) + bd[1] * bd[1],
				q = a * c,
				dq = (ad[0] * cd[0] - q + ad[0] * cd[1] + ad[1] * cd[0])
						+ ad[1] * cd[1];
			D = (p - q) + (dp - dq);
		}
		return D;
	}

	function getNormalizationFactor() {
		var norm = Math.max.apply(Math, arguments);
		return norm && (norm < 1e-8 || norm > 1e8)
				? pow(2, -Math.round(log2(norm)))
				: 0;
	}

	return {
		EPSILON: EPSILON,
		MACHINE_EPSILON: MACHINE_EPSILON,
		CURVETIME_EPSILON: 1e-8,
		GEOMETRIC_EPSILON: 1e-7,
		TRIGONOMETRIC_EPSILON: 1e-8,
		ANGULAR_EPSILON: 1e-5,
		KAPPA: 4 * (sqrt(2) - 1) / 3,

		isZero: function(val) {
			return val >= -EPSILON && val <= EPSILON;
		},

		isMachineZero: function(val) {
			return val >= -MACHINE_EPSILON && val <= MACHINE_EPSILON;
		},

		clamp: clamp,

		integrate: function(f, a, b, n) {
			var x = abscissas[n - 2],
				w = weights[n - 2],
				A = (b - a) * 0.5,
				B = A + a,
				i = 0,
				m = (n + 1) >> 1,
				sum = n & 1 ? w[i++] * f(B) : 0;
			while (i < m) {
				var Ax = A * x[i];
				sum += w[i++] * (f(B + Ax) + f(B - Ax));
			}
			return A * sum;
		},

		findRoot: function(f, df, x, a, b, n, tolerance) {
			for (var i = 0; i < n; i++) {
				var fx = f(x),
					dx = fx / df(x),
					nx = x - dx;
				if (abs(dx) < tolerance) {
					x = nx;
					break;
				}
				if (fx > 0) {
					b = x;
					x = nx <= a ? (a + b) * 0.5 : nx;
				} else {
					a = x;
					x = nx >= b ? (a + b) * 0.5 : nx;
				}
			}
			return clamp(x, a, b);
		},

		solveQuadratic: function(a, b, c, roots, min, max) {
			var x1, x2 = Infinity;
			if (abs(a) < EPSILON) {
				if (abs(b) < EPSILON)
					return abs(c) < EPSILON ? -1 : 0;
				x1 = -c / b;
			} else {
				b *= -0.5;
				var D = getDiscriminant(a, b, c);
				if (D && abs(D) < MACHINE_EPSILON) {
					var f = getNormalizationFactor(abs(a), abs(b), abs(c));
					if (f) {
						a *= f;
						b *= f;
						c *= f;
						D = getDiscriminant(a, b, c);
					}
				}
				if (D >= -MACHINE_EPSILON) {
					var Q = D < 0 ? 0 : sqrt(D),
						R = b + (b < 0 ? -Q : Q);
					if (R === 0) {
						x1 = c / a;
						x2 = -x1;
					} else {
						x1 = R / a;
						x2 = c / R;
					}
				}
			}
			var count = 0,
				boundless = min == null,
				minB = min - EPSILON,
				maxB = max + EPSILON;
			if (isFinite(x1) && (boundless || x1 > minB && x1 < maxB))
				roots[count++] = boundless ? x1 : clamp(x1, min, max);
			if (x2 !== x1
					&& isFinite(x2) && (boundless || x2 > minB && x2 < maxB))
				roots[count++] = boundless ? x2 : clamp(x2, min, max);
			return count;
		},

		solveCubic: function(a, b, c, d, roots, min, max) {
			var f = getNormalizationFactor(abs(a), abs(b), abs(c), abs(d)),
				x, b1, c2, qd, q;
			if (f) {
				a *= f;
				b *= f;
				c *= f;
				d *= f;
			}

			function evaluate(x0) {
				x = x0;
				var tmp = a * x;
				b1 = tmp + b;
				c2 = b1 * x + c;
				qd = (tmp + b1) * x + c2;
				q = c2 * x + d;
			}

			if (abs(a) < EPSILON) {
				a = b;
				b1 = c;
				c2 = d;
				x = Infinity;
			} else if (abs(d) < EPSILON) {
				b1 = b;
				c2 = c;
				x = 0;
			} else {
				evaluate(-(b / a) / 3);
				var t = q / a,
					r = pow(abs(t), 1/3),
					s = t < 0 ? -1 : 1,
					td = -qd / a,
					rd = td > 0 ? 1.324717957244746 * Math.max(r, sqrt(td)) : r,
					x0 = x - s * rd;
				if (x0 !== x) {
					do {
						evaluate(x0);
						x0 = qd === 0 ? x : x - q / qd / (1 + MACHINE_EPSILON);
					} while (s * x0 > s * x);
					if (abs(a) * x * x > abs(d / x)) {
						c2 = -d / x;
						b1 = (c2 - c) / x;
					}
				}
			}
			var count = Numerical.solveQuadratic(a, b1, c2, roots, min, max),
				boundless = min == null;
			if (isFinite(x) && (count === 0
					|| count > 0 && x !== roots[0] && x !== roots[1])
					&& (boundless || x > min - EPSILON && x < max + EPSILON))
				roots[count++] = boundless ? x : clamp(x, min, max);
			return count;
		}
	};
};

var UID = {
	_id: 1,
	_pools: {},

	get: function(name) {
		if (name) {
			var pool = this._pools[name];
			if (!pool)
				pool = this._pools[name] = { _id: 1 };
			return pool._id++;
		} else {
			return this._id++;
		}
	}
};

var Point = Base.extend({
	_class: 'Point',
	_readIndex: true,

	initialize: function Point(arg0, arg1) {
		var type = typeof arg0,
			reading = this.__read,
			read = 0;
		if (type === 'number') {
			var hasY = typeof arg1 === 'number';
			this._set(arg0, hasY ? arg1 : arg0);
			if (reading)
				read = hasY ? 2 : 1;
		} else if (type === 'undefined' || arg0 === null) {
			this._set(0, 0);
			if (reading)
				read = arg0 === null ? 1 : 0;
		} else {
			var obj = type === 'string' ? arg0.split(/[\s,]+/) || [] : arg0;
			read = 1;
			if (Array.isArray(obj)) {
				this._set(+obj[0], +(obj.length > 1 ? obj[1] : obj[0]));
			} else if ('x' in obj) {
				this._set(obj.x || 0, obj.y || 0);
			} else if ('width' in obj) {
				this._set(obj.width || 0, obj.height || 0);
			} else if ('angle' in obj) {
				this._set(obj.length || 0, 0);
				this.setAngle(obj.angle || 0);
			} else {
				this._set(0, 0);
				read = 0;
			}
		}
		if (reading)
			this.__read = read;
		return this;
	},

	set: '#initialize',

	_set: function(x, y) {
		this.x = x;
		this.y = y;
		return this;
	},

	equals: function(point) {
		return this === point || point
				&& (this.x === point.x && this.y === point.y
					|| Array.isArray(point)
						&& this.x === point[0] && this.y === point[1])
				|| false;
	},

	clone: function() {
		return new Point(this.x, this.y);
	},

	toString: function() {
		var f = Formatter.instance;
		return '{ x: ' + f.number(this.x) + ', y: ' + f.number(this.y) + ' }';
	},

	_serialize: function(options) {
		var f = options.formatter;
		return [f.number(this.x), f.number(this.y)];
	},

	getLength: function() {
		return Math.sqrt(this.x * this.x + this.y * this.y);
	},

	setLength: function(length) {
		if (this.isZero()) {
			var angle = this._angle || 0;
			this._set(
				Math.cos(angle) * length,
				Math.sin(angle) * length
			);
		} else {
			var scale = length / this.getLength();
			if (Numerical.isZero(scale))
				this.getAngle();
			this._set(
				this.x * scale,
				this.y * scale
			);
		}
	},
	getAngle: function() {
		return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
	},

	setAngle: function(angle) {
		this.setAngleInRadians.call(this, angle * Math.PI / 180);
	},

	getAngleInDegrees: '#getAngle',
	setAngleInDegrees: '#setAngle',

	getAngleInRadians: function() {
		if (!arguments.length) {
			return this.isZero()
					? this._angle || 0
					: this._angle = Math.atan2(this.y, this.x);
		} else {
			var point = Point.read(arguments),
				div = this.getLength() * point.getLength();
			if (Numerical.isZero(div)) {
				return NaN;
			} else {
				var a = this.dot(point) / div;
				return Math.acos(a < -1 ? -1 : a > 1 ? 1 : a);
			}
		}
	},

	setAngleInRadians: function(angle) {
		this._angle = angle;
		if (!this.isZero()) {
			var length = this.getLength();
			this._set(
				Math.cos(angle) * length,
				Math.sin(angle) * length
			);
		}
	},

	getQuadrant: function() {
		return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
	}
}, {
	beans: false,

	getDirectedAngle: function() {
		var point = Point.read(arguments);
		return Math.atan2(this.cross(point), this.dot(point)) * 180 / Math.PI;
	},

	getDistance: function() {
		var args = arguments,
			point = Point.read(args),
			x = point.x - this.x,
			y = point.y - this.y,
			d = x * x + y * y,
			squared = Base.read(args);
		return squared ? d : Math.sqrt(d);
	},

	normalize: function(length) {
		if (length === undefined)
			length = 1;
		var current = this.getLength(),
			scale = current !== 0 ? length / current : 0,
			point = new Point(this.x * scale, this.y * scale);
		if (scale >= 0)
			point._angle = this._angle;
		return point;
	},

	rotate: function(angle, center) {
		if (angle === 0)
			return this.clone();
		angle = angle * Math.PI / 180;
		var point = center ? this.subtract(center) : this,
			sin = Math.sin(angle),
			cos = Math.cos(angle);
		point = new Point(
			point.x * cos - point.y * sin,
			point.x * sin + point.y * cos
		);
		return center ? point.add(center) : point;
	},

	transform: function(matrix) {
		return matrix ? matrix._transformPoint(this) : this;
	},

	add: function() {
		var point = Point.read(arguments);
		return new Point(this.x + point.x, this.y + point.y);
	},

	subtract: function() {
		var point = Point.read(arguments);
		return new Point(this.x - point.x, this.y - point.y);
	},

	multiply: function() {
		var point = Point.read(arguments);
		return new Point(this.x * point.x, this.y * point.y);
	},

	divide: function() {
		var point = Point.read(arguments);
		return new Point(this.x / point.x, this.y / point.y);
	},

	modulo: function() {
		var point = Point.read(arguments);
		return new Point(this.x % point.x, this.y % point.y);
	},

	negate: function() {
		return new Point(-this.x, -this.y);
	},

	isInside: function() {
		return Rectangle.read(arguments).contains(this);
	},

	isClose: function() {
		var args = arguments,
			point = Point.read(args),
			tolerance = Base.read(args);
		return this.getDistance(point) <= tolerance;
	},

	isCollinear: function() {
		var point = Point.read(arguments);
		return Point.isCollinear(this.x, this.y, point.x, point.y);
	},

	isColinear: '#isCollinear',

	isOrthogonal: function() {
		var point = Point.read(arguments);
		return Point.isOrthogonal(this.x, this.y, point.x, point.y);
	},

	isZero: function() {
		var isZero = Numerical.isZero;
		return isZero(this.x) && isZero(this.y);
	},

	isNaN: function() {
		return isNaN(this.x) || isNaN(this.y);
	},

	isInQuadrant: function(q) {
		return this.x * (q > 1 && q < 4 ? -1 : 1) >= 0
			&& this.y * (q > 2 ? -1 : 1) >= 0;
	},

	dot: function() {
		var point = Point.read(arguments);
		return this.x * point.x + this.y * point.y;
	},

	cross: function() {
		var point = Point.read(arguments);
		return this.x * point.y - this.y * point.x;
	},

	project: function() {
		var point = Point.read(arguments),
			scale = point.isZero() ? 0 : this.dot(point) / point.dot(point);
		return new Point(
			point.x * scale,
			point.y * scale
		);
	},

	statics: {
		min: function() {
			var args = arguments,
				point1 = Point.read(args),
				point2 = Point.read(args);
			return new Point(
				Math.min(point1.x, point2.x),
				Math.min(point1.y, point2.y)
			);
		},

		max: function() {
			var args = arguments,
				point1 = Point.read(args),
				point2 = Point.read(args);
			return new Point(
				Math.max(point1.x, point2.x),
				Math.max(point1.y, point2.y)
			);
		},

		random: function() {
			return new Point(Math.random(), Math.random());
		},

		isCollinear: function(x1, y1, x2, y2) {
			return Math.abs(x1 * y2 - y1 * x2)
					<= Math.sqrt((x1 * x1 + y1 * y1) * (x2 * x2 + y2 * y2))
						* 1e-8;
		},

		isOrthogonal: function(x1, y1, x2, y2) {
			return Math.abs(x1 * x2 + y1 * y2)
					<= Math.sqrt((x1 * x1 + y1 * y1) * (x2 * x2 + y2 * y2))
						* 1e-8;
		}
	}
}, Base.each(['round', 'ceil', 'floor', 'abs'], function(key) {
	var op = Math[key];
	this[key] = function() {
		return new Point(op(this.x), op(this.y));
	};
}, {}));

var LinkedPoint = Point.extend({
	initialize: function Point(x, y, owner, setter) {
		this._x = x;
		this._y = y;
		this._owner = owner;
		this._setter = setter;
	},

	_set: function(x, y, _dontNotify) {
		this._x = x;
		this._y = y;
		if (!_dontNotify)
			this._owner[this._setter](this);
		return this;
	},

	getX: function() {
		return this._x;
	},

	setX: function(x) {
		this._x = x;
		this._owner[this._setter](this);
	},

	getY: function() {
		return this._y;
	},

	setY: function(y) {
		this._y = y;
		this._owner[this._setter](this);
	},

	isSelected: function() {
		return !!(this._owner._selection & this._getSelection());
	},

	setSelected: function(selected) {
		this._owner._changeSelection(this._getSelection(), selected);
	},

	_getSelection: function() {
		return this._setter === 'setPosition' ? 4 : 0;
	}
});

var Size = Base.extend({
	_class: 'Size',
	_readIndex: true,

	initialize: function Size(arg0, arg1) {
		var type = typeof arg0,
			reading = this.__read,
			read = 0;
		if (type === 'number') {
			var hasHeight = typeof arg1 === 'number';
			this._set(arg0, hasHeight ? arg1 : arg0);
			if (reading)
				read = hasHeight ? 2 : 1;
		} else if (type === 'undefined' || arg0 === null) {
			this._set(0, 0);
			if (reading)
				read = arg0 === null ? 1 : 0;
		} else {
			var obj = type === 'string' ? arg0.split(/[\s,]+/) || [] : arg0;
			read = 1;
			if (Array.isArray(obj)) {
				this._set(+obj[0], +(obj.length > 1 ? obj[1] : obj[0]));
			} else if ('width' in obj) {
				this._set(obj.width || 0, obj.height || 0);
			} else if ('x' in obj) {
				this._set(obj.x || 0, obj.y || 0);
			} else {
				this._set(0, 0);
				read = 0;
			}
		}
		if (reading)
			this.__read = read;
		return this;
	},

	set: '#initialize',

	_set: function(width, height) {
		this.width = width;
		this.height = height;
		return this;
	},

	equals: function(size) {
		return size === this || size && (this.width === size.width
				&& this.height === size.height
				|| Array.isArray(size) && this.width === size[0]
					&& this.height === size[1]) || false;
	},

	clone: function() {
		return new Size(this.width, this.height);
	},

	toString: function() {
		var f = Formatter.instance;
		return '{ width: ' + f.number(this.width)
				+ ', height: ' + f.number(this.height) + ' }';
	},

	_serialize: function(options) {
		var f = options.formatter;
		return [f.number(this.width),
				f.number(this.height)];
	},

	add: function() {
		var size = Size.read(arguments);
		return new Size(this.width + size.width, this.height + size.height);
	},

	subtract: function() {
		var size = Size.read(arguments);
		return new Size(this.width - size.width, this.height - size.height);
	},

	multiply: function() {
		var size = Size.read(arguments);
		return new Size(this.width * size.width, this.height * size.height);
	},

	divide: function() {
		var size = Size.read(arguments);
		return new Size(this.width / size.width, this.height / size.height);
	},

	modulo: function() {
		var size = Size.read(arguments);
		return new Size(this.width % size.width, this.height % size.height);
	},

	negate: function() {
		return new Size(-this.width, -this.height);
	},

	isZero: function() {
		var isZero = Numerical.isZero;
		return isZero(this.width) && isZero(this.height);
	},

	isNaN: function() {
		return isNaN(this.width) || isNaN(this.height);
	},

	statics: {
		min: function(size1, size2) {
			return new Size(
				Math.min(size1.width, size2.width),
				Math.min(size1.height, size2.height));
		},

		max: function(size1, size2) {
			return new Size(
				Math.max(size1.width, size2.width),
				Math.max(size1.height, size2.height));
		},

		random: function() {
			return new Size(Math.random(), Math.random());
		}
	}
}, Base.each(['round', 'ceil', 'floor', 'abs'], function(key) {
	var op = Math[key];
	this[key] = function() {
		return new Size(op(this.width), op(this.height));
	};
}, {}));

var LinkedSize = Size.extend({
	initialize: function Size(width, height, owner, setter) {
		this._width = width;
		this._height = height;
		this._owner = owner;
		this._setter = setter;
	},

	_set: function(width, height, _dontNotify) {
		this._width = width;
		this._height = height;
		if (!_dontNotify)
			this._owner[this._setter](this);
		return this;
	},

	getWidth: function() {
		return this._width;
	},

	setWidth: function(width) {
		this._width = width;
		this._owner[this._setter](this);
	},

	getHeight: function() {
		return this._height;
	},

	setHeight: function(height) {
		this._height = height;
		this._owner[this._setter](this);
	}
});

var Rectangle = Base.extend({
	_class: 'Rectangle',
	_readIndex: true,
	beans: true,

	initialize: function Rectangle(arg0, arg1, arg2, arg3) {
		var args = arguments,
			type = typeof arg0,
			read;
		if (type === 'number') {
			this._set(arg0, arg1, arg2, arg3);
			read = 4;
		} else if (type === 'undefined' || arg0 === null) {
			this._set(0, 0, 0, 0);
			read = arg0 === null ? 1 : 0;
		} else if (args.length === 1) {
			if (Array.isArray(arg0)) {
				this._set.apply(this, arg0);
				read = 1;
			} else if (arg0.x !== undefined || arg0.width !== undefined) {
				this._set(arg0.x || 0, arg0.y || 0,
						arg0.width || 0, arg0.height || 0);
				read = 1;
			} else if (arg0.from === undefined && arg0.to === undefined) {
				this._set(0, 0, 0, 0);
				if (Base.readSupported(args, this)) {
					read = 1;
				}
			}
		}
		if (read === undefined) {
			var frm = Point.readNamed(args, 'from'),
				next = Base.peek(args),
				x = frm.x,
				y = frm.y,
				width,
				height;
			if (next && next.x !== undefined || Base.hasNamed(args, 'to')) {
				var to = Point.readNamed(args, 'to');
				width = to.x - x;
				height = to.y - y;
				if (width < 0) {
					x = to.x;
					width = -width;
				}
				if (height < 0) {
					y = to.y;
					height = -height;
				}
			} else {
				var size = Size.read(args);
				width = size.width;
				height = size.height;
			}
			this._set(x, y, width, height);
			read = args.__index;
		}
		var filtered = args.__filtered;
		if (filtered)
			this.__filtered = filtered;
		if (this.__read)
			this.__read = read;
		return this;
	},

	set: '#initialize',

	_set: function(x, y, width, height) {
		this.x = x;
		this.y = y;
		this.width = width;
		this.height = height;
		return this;
	},

	clone: function() {
		return new Rectangle(this.x, this.y, this.width, this.height);
	},

	equals: function(rect) {
		var rt = Base.isPlainValue(rect)
				? Rectangle.read(arguments)
				: rect;
		return rt === this
				|| rt && this.x === rt.x && this.y === rt.y
					&& this.width === rt.width && this.height === rt.height
				|| false;
	},

	toString: function() {
		var f = Formatter.instance;
		return '{ x: ' + f.number(this.x)
				+ ', y: ' + f.number(this.y)
				+ ', width: ' + f.number(this.width)
				+ ', height: ' + f.number(this.height)
				+ ' }';
	},

	_serialize: function(options) {
		var f = options.formatter;
		return [f.number(this.x),
				f.number(this.y),
				f.number(this.width),
				f.number(this.height)];
	},

	getPoint: function(_dontLink) {
		var ctor = _dontLink ? Point : LinkedPoint;
		return new ctor(this.x, this.y, this, 'setPoint');
	},

	setPoint: function() {
		var point = Point.read(arguments);
		this.x = point.x;
		this.y = point.y;
	},

	getSize: function(_dontLink) {
		var ctor = _dontLink ? Size : LinkedSize;
		return new ctor(this.width, this.height, this, 'setSize');
	},

	_fw: 1,
	_fh: 1,

	setSize: function() {
		var size = Size.read(arguments),
			sx = this._sx,
			sy = this._sy,
			w = size.width,
			h = size.height;
		if (sx) {
			this.x += (this.width - w) * sx;
		}
		if (sy) {
			this.y += (this.height - h) * sy;
		}
		this.width = w;
		this.height = h;
		this._fw = this._fh = 1;
	},

	getLeft: function() {
		return this.x;
	},

	setLeft: function(left) {
		if (!this._fw) {
			var amount = left - this.x;
			this.width -= this._sx === 0.5 ? amount * 2 : amount;
		}
		this.x = left;
		this._sx = this._fw = 0;
	},

	getTop: function() {
		return this.y;
	},

	setTop: function(top) {
		if (!this._fh) {
			var amount = top - this.y;
			this.height -= this._sy === 0.5 ? amount * 2 : amount;
		}
		this.y = top;
		this._sy = this._fh = 0;
	},

	getRight: function() {
		return this.x + this.width;
	},

	setRight: function(right) {
		if (!this._fw) {
			var amount = right - this.x;
			this.width = this._sx === 0.5 ? amount * 2 : amount;
		}
		this.x = right - this.width;
		this._sx = 1;
		this._fw = 0;
	},

	getBottom: function() {
		return this.y + this.height;
	},

	setBottom: function(bottom) {
		if (!this._fh) {
			var amount = bottom - this.y;
			this.height = this._sy === 0.5 ? amount * 2 : amount;
		}
		this.y = bottom - this.height;
		this._sy = 1;
		this._fh = 0;
	},

	getCenterX: function() {
		return this.x + this.width / 2;
	},

	setCenterX: function(x) {
		if (this._fw || this._sx === 0.5) {
			this.x = x - this.width / 2;
		} else {
			if (this._sx) {
				this.x += (x - this.x) * 2 * this._sx;
			}
			this.width = (x - this.x) * 2;
		}
		this._sx = 0.5;
		this._fw = 0;
	},

	getCenterY: function() {
		return this.y + this.height / 2;
	},

	setCenterY: function(y) {
		if (this._fh || this._sy === 0.5) {
			this.y = y - this.height / 2;
		} else {
			if (this._sy) {
				this.y += (y - this.y) * 2 * this._sy;
			}
			this.height = (y - this.y) * 2;
		}
		this._sy = 0.5;
		this._fh = 0;
	},

	getCenter: function(_dontLink) {
		var ctor = _dontLink ? Point : LinkedPoint;
		return new ctor(this.getCenterX(), this.getCenterY(), this, 'setCenter');
	},

	setCenter: function() {
		var point = Point.read(arguments);
		this.setCenterX(point.x);
		this.setCenterY(point.y);
		return this;
	},

	getArea: function() {
		return this.width * this.height;
	},

	isEmpty: function() {
		return this.width === 0 || this.height === 0;
	},

	contains: function(arg) {
		return arg && arg.width !== undefined
				|| (Array.isArray(arg) ? arg : arguments).length === 4
				? this._containsRectangle(Rectangle.read(arguments))
				: this._containsPoint(Point.read(arguments));
	},

	_containsPoint: function(point) {
		var x = point.x,
			y = point.y;
		return x >= this.x && y >= this.y
				&& x <= this.x + this.width
				&& y <= this.y + this.height;
	},

	_containsRectangle: function(rect) {
		var x = rect.x,
			y = rect.y;
		return x >= this.x && y >= this.y
				&& x + rect.width <= this.x + this.width
				&& y + rect.height <= this.y + this.height;
	},

	intersects: function() {
		var rect = Rectangle.read(arguments),
			epsilon = Base.read(arguments) || 0;
		return rect.x + rect.width > this.x - epsilon
				&& rect.y + rect.height > this.y - epsilon
				&& rect.x < this.x + this.width + epsilon
				&& rect.y < this.y + this.height + epsilon;
	},

	intersect: function() {
		var rect = Rectangle.read(arguments),
			x1 = Math.max(this.x, rect.x),
			y1 = Math.max(this.y, rect.y),
			x2 = Math.min(this.x + this.width, rect.x + rect.width),
			y2 = Math.min(this.y + this.height, rect.y + rect.height);
		return new Rectangle(x1, y1, x2 - x1, y2 - y1);
	},

	unite: function() {
		var rect = Rectangle.read(arguments),
			x1 = Math.min(this.x, rect.x),
			y1 = Math.min(this.y, rect.y),
			x2 = Math.max(this.x + this.width, rect.x + rect.width),
			y2 = Math.max(this.y + this.height, rect.y + rect.height);
		return new Rectangle(x1, y1, x2 - x1, y2 - y1);
	},

	include: function() {
		var point = Point.read(arguments);
		var x1 = Math.min(this.x, point.x),
			y1 = Math.min(this.y, point.y),
			x2 = Math.max(this.x + this.width, point.x),
			y2 = Math.max(this.y + this.height, point.y);
		return new Rectangle(x1, y1, x2 - x1, y2 - y1);
	},

	expand: function() {
		var amount = Size.read(arguments),
			hor = amount.width,
			ver = amount.height;
		return new Rectangle(this.x - hor / 2, this.y - ver / 2,
				this.width + hor, this.height + ver);
	},

	scale: function(hor, ver) {
		return this.expand(this.width * hor - this.width,
				this.height * (ver === undefined ? hor : ver) - this.height);
	}
}, Base.each([
		['Top', 'Left'], ['Top', 'Right'],
		['Bottom', 'Left'], ['Bottom', 'Right'],
		['Left', 'Center'], ['Top', 'Center'],
		['Right', 'Center'], ['Bottom', 'Center']
	],
	function(parts, index) {
		var part = parts.join(''),
			xFirst = /^[RL]/.test(part);
		if (index >= 4)
			parts[1] += xFirst ? 'Y' : 'X';
		var x = parts[xFirst ? 0 : 1],
			y = parts[xFirst ? 1 : 0],
			getX = 'get' + x,
			getY = 'get' + y,
			setX = 'set' + x,
			setY = 'set' + y,
			get = 'get' + part,
			set = 'set' + part;
		this[get] = function(_dontLink) {
			var ctor = _dontLink ? Point : LinkedPoint;
			return new ctor(this[getX](), this[getY](), this, set);
		};
		this[set] = function() {
			var point = Point.read(arguments);
			this[setX](point.x);
			this[setY](point.y);
		};
	}, {
		beans: true
	}
));

var LinkedRectangle = Rectangle.extend({
	initialize: function Rectangle(x, y, width, height, owner, setter) {
		this._set(x, y, width, height, true);
		this._owner = owner;
		this._setter = setter;
	},

	_set: function(x, y, width, height, _dontNotify) {
		this._x = x;
		this._y = y;
		this._width = width;
		this._height = height;
		if (!_dontNotify)
			this._owner[this._setter](this);
		return this;
	}
},
new function() {
	var proto = Rectangle.prototype;

	return Base.each(['x', 'y', 'width', 'height'], function(key) {
		var part = Base.capitalize(key),
			internal = '_' + key;
		this['get' + part] = function() {
			return this[internal];
		};

		this['set' + part] = function(value) {
			this[internal] = value;
			if (!this._dontNotify)
				this._owner[this._setter](this);
		};
	}, Base.each(['Point', 'Size', 'Center',
			'Left', 'Top', 'Right', 'Bottom', 'CenterX', 'CenterY',
			'TopLeft', 'TopRight', 'BottomLeft', 'BottomRight',
			'LeftCenter', 'TopCenter', 'RightCenter', 'BottomCenter'],
		function(key) {
			var name = 'set' + key;
			this[name] = function() {
				this._dontNotify = true;
				proto[name].apply(this, arguments);
				this._dontNotify = false;
				this._owner[this._setter](this);
			};
		}, {
			isSelected: function() {
				return !!(this._owner._selection & 2);
			},

			setSelected: function(selected) {
				var owner = this._owner;
				if (owner._changeSelection) {
					owner._changeSelection(2, selected);
				}
			}
		})
	);
});

var Matrix = Base.extend({
	_class: 'Matrix',

	initialize: function Matrix(arg, _dontNotify) {
		var args = arguments,
			count = args.length,
			ok = true;
		if (count >= 6) {
			this._set.apply(this, args);
		} else if (count === 1 || count === 2) {
			if (arg instanceof Matrix) {
				this._set(arg._a, arg._b, arg._c, arg._d, arg._tx, arg._ty,
						_dontNotify);
			} else if (Array.isArray(arg)) {
				this._set.apply(this,
						_dontNotify ? arg.concat([_dontNotify]) : arg);
			} else {
				ok = false;
			}
		} else if (!count) {
			this.reset();
		} else {
			ok = false;
		}
		if (!ok) {
			throw new Error('Unsupported matrix parameters');
		}
		return this;
	},

	set: '#initialize',

	_set: function(a, b, c, d, tx, ty, _dontNotify) {
		this._a = a;
		this._b = b;
		this._c = c;
		this._d = d;
		this._tx = tx;
		this._ty = ty;
		if (!_dontNotify)
			this._changed();
		return this;
	},

	_serialize: function(options, dictionary) {
		return Base.serialize(this.getValues(), options, true, dictionary);
	},

	_changed: function() {
		var owner = this._owner;
		if (owner) {
			if (owner._applyMatrix) {
				owner.transform(null, true);
			} else {
				owner._changed(25);
			}
		}
	},

	clone: function() {
		return new Matrix(this._a, this._b, this._c, this._d,
				this._tx, this._ty);
	},

	equals: function(mx) {
		return mx === this || mx && this._a === mx._a && this._b === mx._b
				&& this._c === mx._c && this._d === mx._d
				&& this._tx === mx._tx && this._ty === mx._ty;
	},

	toString: function() {
		var f = Formatter.instance;
		return '[[' + [f.number(this._a), f.number(this._c),
					f.number(this._tx)].join(', ') + '], ['
				+ [f.number(this._b), f.number(this._d),
					f.number(this._ty)].join(', ') + ']]';
	},

	reset: function(_dontNotify) {
		this._a = this._d = 1;
		this._b = this._c = this._tx = this._ty = 0;
		if (!_dontNotify)
			this._changed();
		return this;
	},

	apply: function(recursively, _setApplyMatrix) {
		var owner = this._owner;
		if (owner) {
			owner.transform(null, Base.pick(recursively, true), _setApplyMatrix);
			return this.isIdentity();
		}
		return false;
	},

	translate: function() {
		var point = Point.read(arguments),
			x = point.x,
			y = point.y;
		this._tx += x * this._a + y * this._c;
		this._ty += x * this._b + y * this._d;
		this._changed();
		return this;
	},

	scale: function() {
		var args = arguments,
			scale = Point.read(args),
			center = Point.read(args, 0, { readNull: true });
		if (center)
			this.translate(center);
		this._a *= scale.x;
		this._b *= scale.x;
		this._c *= scale.y;
		this._d *= scale.y;
		if (center)
			this.translate(center.negate());
		this._changed();
		return this;
	},

	rotate: function(angle ) {
		angle *= Math.PI / 180;
		var center = Point.read(arguments, 1),
			x = center.x,
			y = center.y,
			cos = Math.cos(angle),
			sin = Math.sin(angle),
			tx = x - x * cos + y * sin,
			ty = y - x * sin - y * cos,
			a = this._a,
			b = this._b,
			c = this._c,
			d = this._d;
		this._a = cos * a + sin * c;
		this._b = cos * b + sin * d;
		this._c = -sin * a + cos * c;
		this._d = -sin * b + cos * d;
		this._tx += tx * a + ty * c;
		this._ty += tx * b + ty * d;
		this._changed();
		return this;
	},

	shear: function() {
		var args = arguments,
			shear = Point.read(args),
			center = Point.read(args, 0, { readNull: true });
		if (center)
			this.translate(center);
		var a = this._a,
			b = this._b;
		this._a += shear.y * this._c;
		this._b += shear.y * this._d;
		this._c += shear.x * a;
		this._d += shear.x * b;
		if (center)
			this.translate(center.negate());
		this._changed();
		return this;
	},

	skew: function() {
		var args = arguments,
			skew = Point.read(args),
			center = Point.read(args, 0, { readNull: true }),
			toRadians = Math.PI / 180,
			shear = new Point(Math.tan(skew.x * toRadians),
				Math.tan(skew.y * toRadians));
		return this.shear(shear, center);
	},

	append: function(mx, _dontNotify) {
		if (mx) {
			var a1 = this._a,
				b1 = this._b,
				c1 = this._c,
				d1 = this._d,
				a2 = mx._a,
				b2 = mx._c,
				c2 = mx._b,
				d2 = mx._d,
				tx2 = mx._tx,
				ty2 = mx._ty;
			this._a = a2 * a1 + c2 * c1;
			this._c = b2 * a1 + d2 * c1;
			this._b = a2 * b1 + c2 * d1;
			this._d = b2 * b1 + d2 * d1;
			this._tx += tx2 * a1 + ty2 * c1;
			this._ty += tx2 * b1 + ty2 * d1;
			if (!_dontNotify)
				this._changed();
		}
		return this;
	},

	prepend: function(mx, _dontNotify) {
		if (mx) {
			var a1 = this._a,
				b1 = this._b,
				c1 = this._c,
				d1 = this._d,
				tx1 = this._tx,
				ty1 = this._ty,
				a2 = mx._a,
				b2 = mx._c,
				c2 = mx._b,
				d2 = mx._d,
				tx2 = mx._tx,
				ty2 = mx._ty;
			this._a = a2 * a1 + b2 * b1;
			this._c = a2 * c1 + b2 * d1;
			this._b = c2 * a1 + d2 * b1;
			this._d = c2 * c1 + d2 * d1;
			this._tx = a2 * tx1 + b2 * ty1 + tx2;
			this._ty = c2 * tx1 + d2 * ty1 + ty2;
			if (!_dontNotify)
				this._changed();
		}
		return this;
	},

	appended: function(mx) {
		return this.clone().append(mx);
	},

	prepended: function(mx) {
		return this.clone().prepend(mx);
	},

	invert: function() {
		var a = this._a,
			b = this._b,
			c = this._c,
			d = this._d,
			tx = this._tx,
			ty = this._ty,
			det = a * d - b * c,
			res = null;
		if (det && !isNaN(det) && isFinite(tx) && isFinite(ty)) {
			this._a = d / det;
			this._b = -b / det;
			this._c = -c / det;
			this._d = a / det;
			this._tx = (c * ty - d * tx) / det;
			this._ty = (b * tx - a * ty) / det;
			res = this;
		}
		return res;
	},

	inverted: function() {
		return this.clone().invert();
	},

	concatenate: '#append',
	preConcatenate: '#prepend',
	chain: '#appended',

	_shiftless: function() {
		return new Matrix(this._a, this._b, this._c, this._d, 0, 0);
	},

	_orNullIfIdentity: function() {
		return this.isIdentity() ? null : this;
	},

	isIdentity: function() {
		return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1
				&& this._tx === 0 && this._ty === 0;
	},

	isInvertible: function() {
		var det = this._a * this._d - this._c * this._b;
		return det && !isNaN(det) && isFinite(this._tx) && isFinite(this._ty);
	},

	isSingular: function() {
		return !this.isInvertible();
	},

	transform: function( src, dst, count) {
		return arguments.length < 3
			? this._transformPoint(Point.read(arguments))
			: this._transformCoordinates(src, dst, count);
	},

	_transformPoint: function(point, dest, _dontNotify) {
		var x = point.x,
			y = point.y;
		if (!dest)
			dest = new Point();
		return dest._set(
				x * this._a + y * this._c + this._tx,
				x * this._b + y * this._d + this._ty,
				_dontNotify);
	},

	_transformCoordinates: function(src, dst, count) {
		for (var i = 0, max = 2 * count; i < max; i += 2) {
			var x = src[i],
				y = src[i + 1];
			dst[i] = x * this._a + y * this._c + this._tx;
			dst[i + 1] = x * this._b + y * this._d + this._ty;
		}
		return dst;
	},

	_transformCorners: function(rect) {
		var x1 = rect.x,
			y1 = rect.y,
			x2 = x1 + rect.width,
			y2 = y1 + rect.height,
			coords = [ x1, y1, x2, y1, x2, y2, x1, y2 ];
		return this._transformCoordinates(coords, coords, 4);
	},

	_transformBounds: function(bounds, dest, _dontNotify) {
		var coords = this._transformCorners(bounds),
			min = coords.slice(0, 2),
			max = min.slice();
		for (var i = 2; i < 8; i++) {
			var val = coords[i],
				j = i & 1;
			if (val < min[j]) {
				min[j] = val;
			} else if (val > max[j]) {
				max[j] = val;
			}
		}
		if (!dest)
			dest = new Rectangle();
		return dest._set(min[0], min[1], max[0] - min[0], max[1] - min[1],
				_dontNotify);
	},

	inverseTransform: function() {
		return this._inverseTransform(Point.read(arguments));
	},

	_inverseTransform: function(point, dest, _dontNotify) {
		var a = this._a,
			b = this._b,
			c = this._c,
			d = this._d,
			tx = this._tx,
			ty = this._ty,
			det = a * d - b * c,
			res = null;
		if (det && !isNaN(det) && isFinite(tx) && isFinite(ty)) {
			var x = point.x - this._tx,
				y = point.y - this._ty;
			if (!dest)
				dest = new Point();
			res = dest._set(
					(x * d - y * c) / det,
					(y * a - x * b) / det,
					_dontNotify);
		}
		return res;
	},

	decompose: function() {
		var a = this._a,
			b = this._b,
			c = this._c,
			d = this._d,
			det = a * d - b * c,
			sqrt = Math.sqrt,
			atan2 = Math.atan2,
			degrees = 180 / Math.PI,
			rotate,
			scale,
			skew;
		if (a !== 0 || b !== 0) {
			var r = sqrt(a * a + b * b);
			rotate = Math.acos(a / r) * (b > 0 ? 1 : -1);
			scale = [r, det / r];
			skew = [atan2(a * c + b * d, r * r), 0];
		} else if (c !== 0 || d !== 0) {
			var s = sqrt(c * c + d * d);
			rotate = Math.asin(c / s)  * (d > 0 ? 1 : -1);
			scale = [det / s, s];
			skew = [0, atan2(a * c + b * d, s * s)];
		} else {
			rotate = 0;
			skew = scale = [0, 0];
		}
		return {
			translation: this.getTranslation(),
			rotation: rotate * degrees,
			scaling: new Point(scale),
			skewing: new Point(skew[0] * degrees, skew[1] * degrees)
		};
	},

	getValues: function() {
		return [ this._a, this._b, this._c, this._d, this._tx, this._ty ];
	},

	getTranslation: function() {
		return new Point(this._tx, this._ty);
	},

	getScaling: function() {
		return this.decompose().scaling;
	},

	getRotation: function() {
		return this.decompose().rotation;
	},

	applyToContext: function(ctx) {
		if (!this.isIdentity()) {
			ctx.transform(this._a, this._b, this._c, this._d,
					this._tx, this._ty);
		}
	}
}, Base.each(['a', 'b', 'c', 'd', 'tx', 'ty'], function(key) {
	var part = Base.capitalize(key),
		prop = '_' + key;
	this['get' + part] = function() {
		return this[prop];
	};
	this['set' + part] = function(value) {
		this[prop] = value;
		this._changed();
	};
}, {}));

var Line = Base.extend({
	_class: 'Line',

	initialize: function Line(arg0, arg1, arg2, arg3, arg4) {
		var asVector = false;
		if (arguments.length >= 4) {
			this._px = arg0;
			this._py = arg1;
			this._vx = arg2;
			this._vy = arg3;
			asVector = arg4;
		} else {
			this._px = arg0.x;
			this._py = arg0.y;
			this._vx = arg1.x;
			this._vy = arg1.y;
			asVector = arg2;
		}
		if (!asVector) {
			this._vx -= this._px;
			this._vy -= this._py;
		}
	},

	getPoint: function() {
		return new Point(this._px, this._py);
	},

	getVector: function() {
		return new Point(this._vx, this._vy);
	},

	getLength: function() {
		return this.getVector().getLength();
	},

	intersect: function(line, isInfinite) {
		return Line.intersect(
				this._px, this._py, this._vx, this._vy,
				line._px, line._py, line._vx, line._vy,
				true, isInfinite);
	},

	getSide: function(point, isInfinite) {
		return Line.getSide(
				this._px, this._py, this._vx, this._vy,
				point.x, point.y, true, isInfinite);
	},

	getDistance: function(point) {
		return Math.abs(this.getSignedDistance(point));
	},

	getSignedDistance: function(point) {
		return Line.getSignedDistance(this._px, this._py, this._vx, this._vy,
				point.x, point.y, true);
	},

	isCollinear: function(line) {
		return Point.isCollinear(this._vx, this._vy, line._vx, line._vy);
	},

	isOrthogonal: function(line) {
		return Point.isOrthogonal(this._vx, this._vy, line._vx, line._vy);
	},

	statics: {
		intersect: function(p1x, p1y, v1x, v1y, p2x, p2y, v2x, v2y, asVector,
				isInfinite) {
			if (!asVector) {
				v1x -= p1x;
				v1y -= p1y;
				v2x -= p2x;
				v2y -= p2y;
			}
			var cross = v1x * v2y - v1y * v2x;
			if (!Numerical.isMachineZero(cross)) {
				var dx = p1x - p2x,
					dy = p1y - p2y,
					u1 = (v2x * dy - v2y * dx) / cross,
					u2 = (v1x * dy - v1y * dx) / cross,
					epsilon = 1e-12,
					uMin = -epsilon,
					uMax = 1 + epsilon;
				if (isInfinite
						|| uMin < u1 && u1 < uMax && uMin < u2 && u2 < uMax) {
					if (!isInfinite) {
						u1 = u1 <= 0 ? 0 : u1 >= 1 ? 1 : u1;
					}
					return new Point(
							p1x + u1 * v1x,
							p1y + u1 * v1y);
				}
			}
		},

		getSide: function(px, py, vx, vy, x, y, asVector, isInfinite) {
			if (!asVector) {
				vx -= px;
				vy -= py;
			}
			var v2x = x - px,
				v2y = y - py,
				ccw = v2x * vy - v2y * vx;
			if (!isInfinite && Numerical.isMachineZero(ccw)) {
				ccw = (v2x * vx + v2x * vx) / (vx * vx + vy * vy);
				if (ccw >= 0 && ccw <= 1)
					ccw = 0;
			}
			return ccw < 0 ? -1 : ccw > 0 ? 1 : 0;
		},

		getSignedDistance: function(px, py, vx, vy, x, y, asVector) {
			if (!asVector) {
				vx -= px;
				vy -= py;
			}
			  return  vx === 0 ? (vy > 0 ? x - px : px - x)
					: vy === 0 ? (vx < 0 ? y - py : py - y)
					: ((x - px) * vy - (y - py) * vx) / (
						vy > vx
							? vy * Math.sqrt(1 + (vx * vx) / (vy * vy))
							: vx * Math.sqrt(1 + (vy * vy) / (vx * vx))
					);
		},

		getDistance: function(px, py, vx, vy, x, y, asVector) {
			return Math.abs(
					Line.getSignedDistance(px, py, vx, vy, x, y, asVector));
		}
	}
});

var Project = PaperScopeItem.extend({
	_class: 'Project',
	_list: 'projects',
	_reference: 'project',
	_compactSerialize: true,

	initialize: function Project(element) {
		PaperScopeItem.call(this, true);
		this._children = [];
		this._namedChildren = {};
		this._activeLayer = null;
		this._currentStyle = new Style(null, null, this);
		this._view = View.create(this,
				element || CanvasProvider.getCanvas(1, 1));
		this._selectionItems = {};
		this._selectionCount = 0;
		this._updateVersion = 0;
	},

	_serialize: function(options, dictionary) {
		return Base.serialize(this._children, options, true, dictionary);
	},

	_changed: function(flags, item) {
		if (flags & 1) {
			var view = this._view;
			if (view) {
				view._needsUpdate = true;
				if (!view._requested && view._autoUpdate)
					view.requestUpdate();
			}
		}
		var changes = this._changes;
		if (changes && item) {
			var changesById = this._changesById,
				id = item._id,
				entry = changesById[id];
			if (entry) {
				entry.flags |= flags;
			} else {
				changes.push(changesById[id] = { item: item, flags: flags });
			}
		}
	},

	clear: function() {
		var children = this._children;
		for (var i = children.length - 1; i >= 0; i--)
			children[i].remove();
	},

	isEmpty: function() {
		return !this._children.length;
	},

	remove: function remove() {
		if (!remove.base.call(this))
			return false;
		if (this._view)
			this._view.remove();
		return true;
	},

	getView: function() {
		return this._view;
	},

	getCurrentStyle: function() {
		return this._currentStyle;
	},

	setCurrentStyle: function(style) {
		this._currentStyle.set(style);
	},

	getIndex: function() {
		return this._index;
	},

	getOptions: function() {
		return this._scope.settings;
	},

	getLayers: function() {
		return this._children;
	},

	getActiveLayer: function() {
		return this._activeLayer || new Layer({ project: this, insert: true });
	},

	getSymbolDefinitions: function() {
		var definitions = [],
			ids = {};
		this.getItems({
			class: SymbolItem,
			match: function(item) {
				var definition = item._definition,
					id = definition._id;
				if (!ids[id]) {
					ids[id] = true;
					definitions.push(definition);
				}
				return false;
			}
		});
		return definitions;
	},

	getSymbols: 'getSymbolDefinitions',

	getSelectedItems: function() {
		var selectionItems = this._selectionItems,
			items = [];
		for (var id in selectionItems) {
			var item = selectionItems[id],
				selection = item._selection;
			if ((selection & 1) && item.isInserted()) {
				items.push(item);
			} else if (!selection) {
				this._updateSelection(item);
			}
		}
		return items;
	},

	_updateSelection: function(item) {
		var id = item._id,
			selectionItems = this._selectionItems;
		if (item._selection) {
			if (selectionItems[id] !== item) {
				this._selectionCount++;
				selectionItems[id] = item;
			}
		} else if (selectionItems[id] === item) {
			this._selectionCount--;
			delete selectionItems[id];
		}
	},

	selectAll: function() {
		var children = this._children;
		for (var i = 0, l = children.length; i < l; i++)
			children[i].setFullySelected(true);
	},

	deselectAll: function() {
		var selectionItems = this._selectionItems;
		for (var i in selectionItems)
			selectionItems[i].setFullySelected(false);
	},

	addLayer: function(layer) {
		return this.insertLayer(undefined, layer);
	},

	insertLayer: function(index, layer) {
		if (layer instanceof Layer) {
			layer._remove(false, true);
			Base.splice(this._children, [layer], index, 0);
			layer._setProject(this, true);
			var name = layer._name;
			if (name)
				layer.setName(name);
			if (this._changes)
				layer._changed(5);
			if (!this._activeLayer)
				this._activeLayer = layer;
		} else {
			layer = null;
		}
		return layer;
	},

	_insertItem: function(index, item, _created) {
		item = this.insertLayer(index, item)
				|| (this._activeLayer || this._insertItem(undefined,
						new Layer(Item.NO_INSERT), true))
						.insertChild(index, item);
		if (_created && item.activate)
			item.activate();
		return item;
	},

	getItems: function(options) {
		return Item._getItems(this, options);
	},

	getItem: function(options) {
		return Item._getItems(this, options, null, null, true)[0] || null;
	},

	importJSON: function(json) {
		this.activate();
		var layer = this._activeLayer;
		return Base.importJSON(json, layer && layer.isEmpty() && layer);
	},

	removeOn: function(type) {
		var sets = this._removeSets;
		if (sets) {
			if (type === 'mouseup')
				sets.mousedrag = null;
			var set = sets[type];
			if (set) {
				for (var id in set) {
					var item = set[id];
					for (var key in sets) {
						var other = sets[key];
						if (other && other != set)
							delete other[item._id];
					}
					item.remove();
				}
				sets[type] = null;
			}
		}
	},

	draw: function(ctx, matrix, pixelRatio) {
		this._updateVersion++;
		ctx.save();
		matrix.applyToContext(ctx);
		var children = this._children,
			param = new Base({
				offset: new Point(0, 0),
				pixelRatio: pixelRatio,
				viewMatrix: matrix.isIdentity() ? null : matrix,
				matrices: [new Matrix()],
				updateMatrix: true
			});
		for (var i = 0, l = children.length; i < l; i++) {
			children[i].draw(ctx, param);
		}
		ctx.restore();

		if (this._selectionCount > 0) {
			ctx.save();
			ctx.strokeWidth = 1;
			var items = this._selectionItems,
				size = this._scope.settings.handleSize,
				version = this._updateVersion;
			for (var id in items) {
				items[id]._drawSelection(ctx, matrix, size, items, version);
			}
			ctx.restore();
		}
	}
});

var Item = Base.extend(Emitter, {
	statics: {
		extend: function extend(src) {
			if (src._serializeFields)
				src._serializeFields = Base.set({},
					this.prototype._serializeFields, src._serializeFields);
			return extend.base.apply(this, arguments);
		},

		INSERT: { insert: true },
		NO_INSERT: { insert: false }
	},

	_class: 'Item',
	_name: null,
	_applyMatrix: true,
	_canApplyMatrix: true,
	_canScaleStroke: false,
	_pivot: null,
	_visible: true,
	_blendMode: 'normal',
	_opacity: 1,
	_locked: false,
	_guide: false,
	_clipMask: false,
	_selection: 0,
	_selectBounds: true,
	_selectChildren: false,
	_serializeFields: {
		name: null,
		applyMatrix: null,
		matrix: new Matrix(),
		pivot: null,
		visible: true,
		blendMode: 'normal',
		opacity: 1,
		locked: false,
		guide: false,
		clipMask: false,
		selected: false,
		data: {}
	},
	_prioritize: ['applyMatrix']
},
new function() {
	var handlers = ['onMouseDown', 'onMouseUp', 'onMouseDrag', 'onClick',
			'onDoubleClick', 'onMouseMove', 'onMouseEnter', 'onMouseLeave'];
	return Base.each(handlers,
		function(name) {
			this._events[name] = {
				install: function(type) {
					this.getView()._countItemEvent(type, 1);
				},

				uninstall: function(type) {
					this.getView()._countItemEvent(type, -1);
				}
			};
		}, {
			_events: {
				onFrame: {
					install: function() {
						this.getView()._animateItem(this, true);
					},

					uninstall: function() {
						this.getView()._animateItem(this, false);
					}
				},

				onLoad: {},
				onError: {}
			},
			statics: {
				_itemHandlers: handlers
			}
		}
	);
}, {
	initialize: function Item() {
	},

	_initialize: function(props, point) {
		var hasProps = props && Base.isPlainObject(props),
			internal = hasProps && props.internal === true,
			matrix = this._matrix = new Matrix(),
			project = hasProps && props.project || paper.project,
			settings = paper.settings;
		this._id = internal ? null : UID.get();
		this._parent = this._index = null;
		this._applyMatrix = this._canApplyMatrix && settings.applyMatrix;
		if (point)
			matrix.translate(point);
		matrix._owner = this;
		this._style = new Style(project._currentStyle, this, project);
		if (internal || hasProps && props.insert == false
			|| !settings.insertItems && !(hasProps && props.insert == true)) {
			this._setProject(project);
		} else {
			(hasProps && props.parent || project)
					._insertItem(undefined, this, true);
		}
		if (hasProps && props !== Item.NO_INSERT && props !== Item.INSERT) {
			this.set(props, {
				internal: true, insert: true, project: true, parent: true
			});
		}
		return hasProps;
	},

	_serialize: function(options, dictionary) {
		var props = {},
			that = this;

		function serialize(fields) {
			for (var key in fields) {
				var value = that[key];
				if (!Base.equals(value, key === 'leading'
						? fields.fontSize * 1.2 : fields[key])) {
					props[key] = Base.serialize(value, options,
							key !== 'data', dictionary);
				}
			}
		}

		serialize(this._serializeFields);
		if (!(this instanceof Group))
			serialize(this._style._defaults);
		return [ this._class, props ];
	},

	_changed: function(flags) {
		var symbol = this._symbol,
			cacheParent = this._parent || symbol,
			project = this._project;
		if (flags & 8) {
			this._bounds = this._position = this._decomposed = undefined;
		}
		if (flags & 16) {
			this._globalMatrix = undefined;
		}
		if (cacheParent
				&& (flags & 72)) {
			Item._clearBoundsCache(cacheParent);
		}
		if (flags & 2) {
			Item._clearBoundsCache(this);
		}
		if (project)
			project._changed(flags, this);
		if (symbol)
			symbol._changed(flags);
	},

	getId: function() {
		return this._id;
	},

	getName: function() {
		return this._name;
	},

	setName: function(name) {

		if (this._name)
			this._removeNamed();
		if (name === (+name) + '')
			throw new Error(
					'Names consisting only of numbers are not supported.');
		var owner = this._getOwner();
		if (name && owner) {
			var children = owner._children,
				namedChildren = owner._namedChildren;
			(namedChildren[name] = namedChildren[name] || []).push(this);
			if (!(name in children))
				children[name] = this;
		}
		this._name = name || undefined;
		this._changed(256);
	},

	getStyle: function() {
		return this._style;
	},

	setStyle: function(style) {
		this.getStyle().set(style);
	}
}, Base.each(['locked', 'visible', 'blendMode', 'opacity', 'guide'],
	function(name) {
		var part = Base.capitalize(name),
			key = '_' + name,
			flags = {
				locked: 256,
				visible: 265
			};
		this['get' + part] = function() {
			return this[key];
		};
		this['set' + part] = function(value) {
			if (value != this[key]) {
				this[key] = value;
				this._changed(flags[name] || 257);
			}
		};
	},
{}), {
	beans: true,

	getSelection: function() {
		return this._selection;
	},

	setSelection: function(selection) {
		if (selection !== this._selection) {
			this._selection = selection;
			var project = this._project;
			if (project) {
				project._updateSelection(this);
				this._changed(257);
			}
		}
	},

	_changeSelection: function(flag, selected) {
		var selection = this._selection;
		this.setSelection(selected ? selection | flag : selection & ~flag);
	},

	isSelected: function() {
		if (this._selectChildren) {
			var children = this._children;
			for (var i = 0, l = children.length; i < l; i++)
				if (children[i].isSelected())
					return true;
		}
		return !!(this._selection & 1);
	},

	setSelected: function(selected) {
		if (this._selectChildren) {
			var children = this._children;
			for (var i = 0, l = children.length; i < l; i++)
				children[i].setSelected(selected);
		}
		this._changeSelection(1, selected);
	},

	isFullySelected: function() {
		var children = this._children,
			selected = !!(this._selection & 1);
		if (children && selected) {
			for (var i = 0, l = children.length; i < l; i++)
				if (!children[i].isFullySelected())
					return false;
			return true;
		}
		return selected;
	},

	setFullySelected: function(selected) {
		var children = this._children;
		if (children) {
			for (var i = 0, l = children.length; i < l; i++)
				children[i].setFullySelected(selected);
		}
		this._changeSelection(1, selected);
	},

	isClipMask: function() {
		return this._clipMask;
	},

	setClipMask: function(clipMask) {
		if (this._clipMask != (clipMask = !!clipMask)) {
			this._clipMask = clipMask;
			if (clipMask) {
				this.setFillColor(null);
				this.setStrokeColor(null);
			}
			this._changed(257);
			if (this._parent)
				this._parent._changed(2048);
		}
	},

	getData: function() {
		if (!this._data)
			this._data = {};
		return this._data;
	},

	setData: function(data) {
		this._data = data;
	},

	getPosition: function(_dontLink) {
		var ctor = _dontLink ? Point : LinkedPoint;
		var position = this._position ||
			(this._position = this._getPositionFromBounds());
		return new ctor(position.x, position.y, this, 'setPosition');
	},

	setPosition: function() {
		this.translate(Point.read(arguments).subtract(this.getPosition(true)));
	},

	_getPositionFromBounds: function(bounds) {
		return this._pivot
				? this._matrix._transformPoint(this._pivot)
				: (bounds || this.getBounds()).getCenter(true);
	},

	getPivot: function() {
		var pivot = this._pivot;
		return pivot
				? new LinkedPoint(pivot.x, pivot.y, this, 'setPivot')
				: null;
	},

	setPivot: function() {
		this._pivot = Point.read(arguments, 0, { clone: true, readNull: true });
		this._position = undefined;
	}
}, Base.each({
		getStrokeBounds: { stroke: true },
		getHandleBounds: { handle: true },
		getInternalBounds: { internal: true }
	},
	function(options, key) {
		this[key] = function(matrix) {
			return this.getBounds(matrix, options);
		};
	},
{
	beans: true,

	getBounds: function(matrix, options) {
		var hasMatrix = options || matrix instanceof Matrix,
			opts = Base.set({}, hasMatrix ? options : matrix,
					this._boundsOptions);
		if (!opts.stroke || this.getStrokeScaling())
			opts.cacheItem = this;
		var rect = this._getCachedBounds(hasMatrix && matrix, opts).rect;
		return !arguments.length
				? new LinkedRectangle(rect.x, rect.y, rect.width, rect.height,
					this, 'setBounds')
				: rect;
	},

	setBounds: function() {
		var rect = Rectangle.read(arguments),
			bounds = this.getBounds(),
			_matrix = this._matrix,
			matrix = new Matrix(),
			center = rect.getCenter();
		matrix.translate(center);
		if (rect.width != bounds.width || rect.height != bounds.height) {
			if (!_matrix.isInvertible()) {
				_matrix.set(_matrix._backup
						|| new Matrix().translate(_matrix.getTranslation()));
				bounds = this.getBounds();
			}
			matrix.scale(
					bounds.width !== 0 ? rect.width / bounds.width : 0,
					bounds.height !== 0 ? rect.height / bounds.height : 0);
		}
		center = bounds.getCenter();
		matrix.translate(-center.x, -center.y);
		this.transform(matrix);
	},

	_getBounds: function(matrix, options) {
		var children = this._children;
		if (!children || !children.length)
			return new Rectangle();
		Item._updateBoundsCache(this, options.cacheItem);
		return Item._getBounds(children, matrix, options);
	},

	_getBoundsCacheKey: function(options, internal) {
		return [
			options.stroke ? 1 : 0,
			options.handle ? 1 : 0,
			internal ? 1 : 0
		].join('');
	},

	_getCachedBounds: function(matrix, options, noInternal) {
		matrix = matrix && matrix._orNullIfIdentity();
		var internal = options.internal && !noInternal,
			cacheItem = options.cacheItem,
			_matrix = internal ? null : this._matrix._orNullIfIdentity(),
			cacheKey = cacheItem && (!matrix || matrix.equals(_matrix))
				&& this._getBoundsCacheKey(options, internal),
			bounds = this._bounds;
		Item._updateBoundsCache(this._parent || this._symbol, cacheItem);
		if (cacheKey && bounds && cacheKey in bounds) {
			var cached = bounds[cacheKey];
			return {
				rect: cached.rect.clone(),
				nonscaling: cached.nonscaling
			};
		}
		var res = this._getBounds(matrix || _matrix, options),
			rect = res.rect || res,
			style = this._style,
			nonscaling = res.nonscaling || style.hasStroke()
				&& !style.getStrokeScaling();
		if (cacheKey) {
			if (!bounds) {
				this._bounds = bounds = {};
			}
			var cached = bounds[cacheKey] = {
				rect: rect.clone(),
				nonscaling: nonscaling,
				internal: internal
			};
		}
		return {
			rect: rect,
			nonscaling: nonscaling
		};
	},

	_getStrokeMatrix: function(matrix, options) {
		var parent = this.getStrokeScaling() ? null
				: options && options.internal ? this
					: this._parent || this._symbol && this._symbol._item,
			mx = parent ? parent.getViewMatrix().invert() : matrix;
		return mx && mx._shiftless();
	},

	statics: {
		_updateBoundsCache: function(parent, item) {
			if (parent && item) {
				var id = item._id,
					ref = parent._boundsCache = parent._boundsCache || {
						ids: {},
						list: []
					};
				if (!ref.ids[id]) {
					ref.list.push(item);
					ref.ids[id] = item;
				}
			}
		},

		_clearBoundsCache: function(item) {
			var cache = item._boundsCache;
			if (cache) {
				item._bounds = item._position = item._boundsCache = undefined;
				for (var i = 0, list = cache.list, l = list.length; i < l; i++){
					var other = list[i];
					if (other !== item) {
						other._bounds = other._position = undefined;
						if (other._boundsCache)
							Item._clearBoundsCache(other);
					}
				}
			}
		},

		_getBounds: function(items, matrix, options) {
			var x1 = Infinity,
				x2 = -x1,
				y1 = x1,
				y2 = x2,
				nonscaling = false;
			options = options || {};
			for (var i = 0, l = items.length; i < l; i++) {
				var item = items[i];
				if (item._visible && !item.isEmpty(true)) {
					var bounds = item._getCachedBounds(
						matrix && matrix.appended(item._matrix), options, true),
						rect = bounds.rect;
					x1 = Math.min(rect.x, x1);
					y1 = Math.min(rect.y, y1);
					x2 = Math.max(rect.x + rect.width, x2);
					y2 = Math.max(rect.y + rect.height, y2);
					if (bounds.nonscaling)
						nonscaling = true;
				}
			}
			return {
				rect: isFinite(x1)
					? new Rectangle(x1, y1, x2 - x1, y2 - y1)
					: new Rectangle(),
				nonscaling: nonscaling
			};
		}
	}

}), {
	beans: true,

	_decompose: function() {
		return this._applyMatrix
			? null
			: this._decomposed || (this._decomposed = this._matrix.decompose());
	},

	getRotation: function() {
		var decomposed = this._decompose();
		return decomposed ? decomposed.rotation : 0;
	},

	setRotation: function(rotation) {
		var current = this.getRotation();
		if (current != null && rotation != null) {
			var decomposed = this._decomposed;
			this.rotate(rotation - current);
			if (decomposed) {
				decomposed.rotation = rotation;
				this._decomposed = decomposed;
			}
		}
	},

	getScaling: function() {
		var decomposed = this._decompose(),
			s = decomposed && decomposed.scaling;
		return new LinkedPoint(s ? s.x : 1, s ? s.y : 1, this, 'setScaling');
	},

	setScaling: function() {
		var current = this.getScaling(),
			scaling = Point.read(arguments, 0, { clone: true, readNull: true });
		if (current && scaling && !current.equals(scaling)) {
			var rotation = this.getRotation(),
				decomposed = this._decomposed,
				matrix = new Matrix(),
				isZero = Numerical.isZero;
			if (isZero(current.x) || isZero(current.y)) {
				matrix.translate(decomposed.translation);
				if (rotation) {
					matrix.rotate(rotation);
				}
				matrix.scale(scaling.x, scaling.y);
				this._matrix.set(matrix);
			} else {
				var center = this.getPosition(true);
				matrix.translate(center);
				if (rotation)
					matrix.rotate(rotation);
				matrix.scale(scaling.x / current.x, scaling.y / current.y);
				if (rotation)
					matrix.rotate(-rotation);
				matrix.translate(center.negate());
				this.transform(matrix);
			}
			if (decomposed) {
				decomposed.scaling = scaling;
				this._decomposed = decomposed;
			}
		}
	},

	getMatrix: function() {
		return this._matrix;
	},

	setMatrix: function() {
		var matrix = this._matrix;
		matrix.set.apply(matrix, arguments);
	},

	getGlobalMatrix: function(_dontClone) {
		var matrix = this._globalMatrix;
		if (matrix) {
			var parent = this._parent;
			var parents = [];
			while (parent) {
				if (!parent._globalMatrix) {
					matrix = null;
					for (var i = 0, l = parents.length; i < l; i++) {
						parents[i]._globalMatrix = null;
					}
					break;
				}
				parents.push(parent);
				parent = parent._parent;
			}
		}
		if (!matrix) {
			matrix = this._globalMatrix = this._matrix.clone();
			var parent = this._parent;
			if (parent)
				matrix.prepend(parent.getGlobalMatrix(true));
		}
		return _dontClone ? matrix : matrix.clone();
	},

	getViewMatrix: function() {
		return this.getGlobalMatrix().prepend(this.getView()._matrix);
	},

	getApplyMatrix: function() {
		return this._applyMatrix;
	},

	setApplyMatrix: function(apply) {
		if (this._applyMatrix = this._canApplyMatrix && !!apply)
			this.transform(null, true);
	},

	getTransformContent: '#getApplyMatrix',
	setTransformContent: '#setApplyMatrix',
}, {
	getProject: function() {
		return this._project;
	},

	_setProject: function(project, installEvents) {
		if (this._project !== project) {
			if (this._project)
				this._installEvents(false);
			this._project = project;
			var children = this._children;
			for (var i = 0, l = children && children.length; i < l; i++)
				children[i]._setProject(project);
			installEvents = true;
		}
		if (installEvents)
			this._installEvents(true);
	},

	getView: function() {
		return this._project._view;
	},

	_installEvents: function _installEvents(install) {
		_installEvents.base.call(this, install);
		var children = this._children;
		for (var i = 0, l = children && children.length; i < l; i++)
			children[i]._installEvents(install);
	},

	getLayer: function() {
		var parent = this;
		while (parent = parent._parent) {
			if (parent instanceof Layer)
				return parent;
		}
		return null;
	},

	getParent: function() {
		return this._parent;
	},

	setParent: function(item) {
		return item.addChild(this);
	},

	_getOwner: '#getParent',

	getChildren: function() {
		return this._children;
	},

	setChildren: function(items) {
		this.removeChildren();
		this.addChildren(items);
	},

	getFirstChild: function() {
		return this._children && this._children[0] || null;
	},

	getLastChild: function() {
		return this._children && this._children[this._children.length - 1]
				|| null;
	},

	getNextSibling: function() {
		var owner = this._getOwner();
		return owner && owner._children[this._index + 1] || null;
	},

	getPreviousSibling: function() {
		var owner = this._getOwner();
		return owner && owner._children[this._index - 1] || null;
	},

	getIndex: function() {
		return this._index;
	},

	equals: function(item) {
		return item === this || item && this._class === item._class
				&& this._style.equals(item._style)
				&& this._matrix.equals(item._matrix)
				&& this._locked === item._locked
				&& this._visible === item._visible
				&& this._blendMode === item._blendMode
				&& this._opacity === item._opacity
				&& this._clipMask === item._clipMask
				&& this._guide === item._guide
				&& this._equals(item)
				|| false;
	},

	_equals: function(item) {
		return Base.equals(this._children, item._children);
	},

	clone: function(options) {
		var copy = new this.constructor(Item.NO_INSERT),
			children = this._children,
			insert = Base.pick(options ? options.insert : undefined,
					options === undefined || options === true),
			deep = Base.pick(options ? options.deep : undefined, true);
		if (children)
			copy.copyAttributes(this);
		if (!children || deep)
			copy.copyContent(this);
		if (!children)
			copy.copyAttributes(this);
		if (insert)
			copy.insertAbove(this);
		var name = this._name,
			parent = this._parent;
		if (name && parent) {
			var children = parent._children,
				orig = name,
				i = 1;
			while (children[name])
				name = orig + ' ' + (i++);
			if (name !== orig)
				copy.setName(name);
		}
		return copy;
	},

	copyContent: function(source) {
		var children = source._children;
		for (var i = 0, l = children && children.length; i < l; i++) {
			this.addChild(children[i].clone(false), true);
		}
	},

	copyAttributes: function(source, excludeMatrix) {
		this.setStyle(source._style);
		var keys = ['_locked', '_visible', '_blendMode', '_opacity',
				'_clipMask', '_guide'];
		for (var i = 0, l = keys.length; i < l; i++) {
			var key = keys[i];
			if (source.hasOwnProperty(key))
				this[key] = source[key];
		}
		if (!excludeMatrix)
			this._matrix.set(source._matrix, true);
		this.setApplyMatrix(source._applyMatrix);
		this.setPivot(source._pivot);
		this.setSelection(source._selection);
		var data = source._data,
			name = source._name;
		this._data = data ? Base.clone(data) : null;
		if (name)
			this.setName(name);
	},

	rasterize: function(arg0, arg1) {
		var resolution,
			insert,
			raster;
		if (Base.isPlainObject(arg0)) {
			resolution = arg0.resolution;
			insert = arg0.insert;
			raster = arg0.raster;
		} else {
			resolution = arg0;
			insert = arg1;
		}
		if (!raster) {
			raster = new Raster(Item.NO_INSERT);
		}
		var bounds = this.getStrokeBounds(),
			scale = (resolution || this.getView().getResolution()) / 72,
			topLeft = bounds.getTopLeft().floor(),
			bottomRight = bounds.getBottomRight().ceil(),
			boundsSize = new Size(bottomRight.subtract(topLeft)),
			rasterSize = boundsSize.multiply(scale);
		raster.setSize(rasterSize, true);

		if (!rasterSize.isZero()) {
			var ctx = raster.getContext(true),
				matrix = new Matrix().scale(scale).translate(topLeft.negate());
			ctx.save();
			matrix.applyToContext(ctx);
			this.draw(ctx, new Base({ matrices: [matrix] }));
			ctx.restore();
		}
		raster._matrix.set(
			new Matrix()
				.translate(topLeft.add(boundsSize.divide(2)))
				.scale(1 / scale)
		);
		if (insert === undefined || insert) {
			raster.insertAbove(this);
		}
		return raster;
	},

	contains: function() {
		var matrix = this._matrix;
		return (
			matrix.isInvertible() &&
			!!this._contains(matrix._inverseTransform(Point.read(arguments)))
		);
	},

	_contains: function(point) {
		var children = this._children;
		if (children) {
			for (var i = children.length - 1; i >= 0; i--) {
				if (children[i].contains(point))
					return true;
			}
			return false;
		}
		return point.isInside(this.getInternalBounds());
	},

	isInside: function() {
		return Rectangle.read(arguments).contains(this.getBounds());
	},

	_asPathItem: function() {
		return new Path.Rectangle({
			rectangle: this.getInternalBounds(),
			matrix: this._matrix,
			insert: false,
		});
	},

	intersects: function(item, _matrix) {
		if (!(item instanceof Item))
			return false;
		return this._asPathItem().getIntersections(item._asPathItem(), null,
				_matrix, true).length > 0;
	}
},
new function() {
	function hitTest() {
		var args = arguments;
		return this._hitTest(
				Point.read(args),
				HitResult.getOptions(args));
	}

	function hitTestAll() {
		var args = arguments,
			point = Point.read(args),
			options = HitResult.getOptions(args),
			all = [];
		this._hitTest(point, new Base({ all: all }, options));
		return all;
	}

	function hitTestChildren(point, options, viewMatrix, _exclude) {
		var children = this._children;
		if (children) {
			for (var i = children.length - 1; i >= 0; i--) {
				var child = children[i];
				var res = child !== _exclude && child._hitTest(point, options,
						viewMatrix);
				if (res && !options.all)
					return res;
			}
		}
		return null;
	}

	Project.inject({
		hitTest: hitTest,
		hitTestAll: hitTestAll,
		_hitTest: hitTestChildren
	});

	return {
		hitTest: hitTest,
		hitTestAll: hitTestAll,
		_hitTestChildren: hitTestChildren,
	};
}, {

	_hitTest: function(point, options, parentViewMatrix) {
		if (this._locked || !this._visible || this._guide && !options.guides
				|| this.isEmpty()) {
			return null;
		}

		var matrix = this._matrix,
			viewMatrix = parentViewMatrix
					? parentViewMatrix.appended(matrix)
					: this.getGlobalMatrix().prepend(this.getView()._matrix),
			tolerance = Math.max(options.tolerance, 1e-12),
			tolerancePadding = options._tolerancePadding = new Size(
					Path._getStrokePadding(tolerance,
						matrix._shiftless().invert()));
		point = matrix._inverseTransform(point);
		if (!point || !this._children &&
			!this.getBounds({ internal: true, stroke: true, handle: true })
				.expand(tolerancePadding.multiply(2))._containsPoint(point)) {
			return null;
		}

		var checkSelf = !(options.guides && !this._guide
				|| options.selected && !this.isSelected()
				|| options.type && options.type !== Base.hyphenate(this._class)
				|| options.class && !(this instanceof options.class)),
			match = options.match,
			that = this,
			bounds,
			res;

		function filter(hit) {
			if (hit && match && !match(hit))
				hit = null;
			if (hit && options.all)
				options.all.push(hit);
			return hit;
		}

		function checkPoint(type, part) {
			var pt = part ? bounds['get' + part]() : that.getPosition();
			if (point.subtract(pt).divide(tolerancePadding).length <= 1) {
				return new HitResult(type, that, {
					name: part ? Base.hyphenate(part) : type,
					point: pt
				});
			}
		}

		var checkPosition = options.position,
			checkCenter = options.center,
			checkBounds = options.bounds;
		if (checkSelf && this._parent
				&& (checkPosition || checkCenter || checkBounds)) {
			if (checkCenter || checkBounds) {
				bounds = this.getInternalBounds();
			}
			res = checkPosition && checkPoint('position') ||
					checkCenter && checkPoint('center', 'Center');
			if (!res && checkBounds) {
				var points = [
					'TopLeft', 'TopRight', 'BottomLeft', 'BottomRight',
					'LeftCenter', 'TopCenter', 'RightCenter', 'BottomCenter'
				];
				for (var i = 0; i < 8 && !res; i++) {
					res = checkPoint('bounds', points[i]);
				}
			}
			res = filter(res);
		}

		if (!res) {
			res = this._hitTestChildren(point, options, viewMatrix)
				|| checkSelf
					&& filter(this._hitTestSelf(point, options, viewMatrix,
						this.getStrokeScaling() ? null
							: viewMatrix._shiftless().invert()))
				|| null;
		}
		if (res && res.point) {
			res.point = matrix.transform(res.point);
		}
		return res;
	},

	_hitTestSelf: function(point, options) {
		if (options.fill && this.hasFill() && this._contains(point))
			return new HitResult('fill', this);
	},

	matches: function(name, compare) {
		function matchObject(obj1, obj2) {
			for (var i in obj1) {
				if (obj1.hasOwnProperty(i)) {
					var val1 = obj1[i],
						val2 = obj2[i];
					if (Base.isPlainObject(val1) && Base.isPlainObject(val2)) {
						if (!matchObject(val1, val2))
							return false;
					} else if (!Base.equals(val1, val2)) {
						return false;
					}
				}
			}
			return true;
		}
		var type = typeof name;
		if (type === 'object') {
			for (var key in name) {
				if (name.hasOwnProperty(key) && !this.matches(key, name[key]))
					return false;
			}
			return true;
		} else if (type === 'function') {
			return name(this);
		} else if (name === 'match') {
			return compare(this);
		} else {
			var value = /^(empty|editable)$/.test(name)
					? this['is' + Base.capitalize(name)]()
					: name === 'type'
						? Base.hyphenate(this._class)
						: this[name];
			if (name === 'class') {
				if (typeof compare === 'function')
					return this instanceof compare;
				value = this._class;
			}
			if (typeof compare === 'function') {
				return !!compare(value);
			} else if (compare) {
				if (compare.test) {
					return compare.test(value);
				} else if (Base.isPlainObject(compare)) {
					return matchObject(compare, value);
				}
			}
			return Base.equals(value, compare);
		}
	},

	getItems: function(options) {
		return Item._getItems(this, options, this._matrix);
	},

	getItem: function(options) {
		return Item._getItems(this, options, this._matrix, null, true)[0]
				|| null;
	},

	statics: {
		_getItems: function _getItems(item, options, matrix, param, firstOnly) {
			if (!param) {
				var obj = typeof options === 'object' && options,
					overlapping = obj && obj.overlapping,
					inside = obj && obj.inside,
					bounds = overlapping || inside,
					rect = bounds && Rectangle.read([bounds]);
				param = {
					items: [],
					recursive: obj && obj.recursive !== false,
					inside: !!inside,
					overlapping: !!overlapping,
					rect: rect,
					path: overlapping && new Path.Rectangle({
						rectangle: rect,
						insert: false
					})
				};
				if (obj) {
					options = Base.filter({}, options, {
						recursive: true, inside: true, overlapping: true
					});
				}
			}
			var children = item._children,
				items = param.items,
				rect = param.rect;
			matrix = rect && (matrix || new Matrix());
			for (var i = 0, l = children && children.length; i < l; i++) {
				var child = children[i],
					childMatrix = matrix && matrix.appended(child._matrix),
					add = true;
				if (rect) {
					var bounds = child.getBounds(childMatrix);
					if (!rect.intersects(bounds))
						continue;
					if (!(rect.contains(bounds)
							|| param.overlapping && (bounds.contains(rect)
								|| param.path.intersects(child, childMatrix))))
						add = false;
				}
				if (add && child.matches(options)) {
					items.push(child);
					if (firstOnly)
						break;
				}
				if (param.recursive !== false) {
					_getItems(child, options, childMatrix, param, firstOnly);
				}
				if (firstOnly && items.length > 0)
					break;
			}
			return items;
		}
	}
}, {

	importJSON: function(json) {
		var res = Base.importJSON(json, this);
		return res !== this ? this.addChild(res) : res;
	},

	addChild: function(item) {
		return this.insertChild(undefined, item);
	},

	insertChild: function(index, item) {
		var res = item ? this.insertChildren(index, [item]) : null;
		return res && res[0];
	},

	addChildren: function(items) {
		return this.insertChildren(this._children.length, items);
	},

	insertChildren: function(index, items) {
		var children = this._children;
		if (children && items && items.length > 0) {
			items = Base.slice(items);
			var inserted = {};
			for (var i = items.length - 1; i >= 0; i--) {
				var item = items[i],
					id = item && item._id;
				if (!item || inserted[id]) {
					items.splice(i, 1);
				} else {
					item._remove(false, true);
					inserted[id] = true;
				}
			}
			Base.splice(children, items, index, 0);
			var project = this._project,
				notifySelf = project._changes;
			for (var i = 0, l = items.length; i < l; i++) {
				var item = items[i],
					name = item._name;
				item._parent = this;
				item._setProject(project, true);
				if (name)
					item.setName(name);
				if (notifySelf)
					item._changed(5);
			}
			this._changed(11);
		} else {
			items = null;
		}
		return items;
	},

	_insertItem: '#insertChild',

	_insertAt: function(item, offset) {
		var owner = item && item._getOwner(),
			res = item !== this && owner ? this : null;
		if (res) {
			res._remove(false, true);
			owner._insertItem(item._index + offset, res);
		}
		return res;
	},

	insertAbove: function(item) {
		return this._insertAt(item, 1);
	},

	insertBelow: function(item) {
		return this._insertAt(item, 0);
	},

	sendToBack: function() {
		var owner = this._getOwner();
		return owner ? owner._insertItem(0, this) : null;
	},

	bringToFront: function() {
		var owner = this._getOwner();
		return owner ? owner._insertItem(undefined, this) : null;
	},

	appendTop: '#addChild',

	appendBottom: function(item) {
		return this.insertChild(0, item);
	},

	moveAbove: '#insertAbove',

	moveBelow: '#insertBelow',

	addTo: function(owner) {
		return owner._insertItem(undefined, this);
	},

	copyTo: function(owner) {
		return this.clone(false).addTo(owner);
	},

	reduce: function(options) {
		var children = this._children;
		if (children && children.length === 1) {
			var child = children[0].reduce(options);
			if (this._parent) {
				child.insertAbove(this);
				this.remove();
			} else {
				child.remove();
			}
			return child;
		}
		return this;
	},

	_removeNamed: function() {
		var owner = this._getOwner();
		if (owner) {
			var children = owner._children,
				namedChildren = owner._namedChildren,
				name = this._name,
				namedArray = namedChildren[name],
				index = namedArray ? namedArray.indexOf(this) : -1;
			if (index !== -1) {
				if (children[name] == this)
					delete children[name];
				namedArray.splice(index, 1);
				if (namedArray.length) {
					children[name] = namedArray[0];
				} else {
					delete namedChildren[name];
				}
			}
		}
	},

	_remove: function(notifySelf, notifyParent) {
		var owner = this._getOwner(),
			project = this._project,
			index = this._index;
		if (this._style)
			this._style._dispose();
		if (owner) {
			if (this._name)
				this._removeNamed();
			if (index != null) {
				if (project._activeLayer === this)
					project._activeLayer = this.getNextSibling()
							|| this.getPreviousSibling();
				Base.splice(owner._children, null, index, 1);
			}
			this._installEvents(false);
			if (notifySelf && project._changes)
				this._changed(5);
			if (notifyParent)
				owner._changed(11, this);
			this._parent = null;
			return true;
		}
		return false;
	},

	remove: function() {
		return this._remove(true, true);
	},

	replaceWith: function(item) {
		var ok = item && item.insertBelow(this);
		if (ok)
			this.remove();
		return ok;
	},

	removeChildren: function(start, end) {
		if (!this._children)
			return null;
		start = start || 0;
		end = Base.pick(end, this._children.length);
		var removed = Base.splice(this._children, null, start, end - start);
		for (var i = removed.length - 1; i >= 0; i--) {
			removed[i]._remove(true, false);
		}
		if (removed.length > 0)
			this._changed(11);
		return removed;
	},

	clear: '#removeChildren',

	reverseChildren: function() {
		if (this._children) {
			this._children.reverse();
			for (var i = 0, l = this._children.length; i < l; i++)
				this._children[i]._index = i;
			this._changed(11);
		}
	},

	isEmpty: function(recursively) {
		var children = this._children;
		var numChildren = children ? children.length : 0;
		if (recursively) {
			for (var i = 0; i < numChildren; i++) {
				if (!children[i].isEmpty(recursively)) {
					return false;
				}
			}
			return true;
		}
		return !numChildren;
	},

	isEditable: function() {
		var item = this;
		while (item) {
			if (!item._visible || item._locked)
				return false;
			item = item._parent;
		}
		return true;
	},

	hasFill: function() {
		return this.getStyle().hasFill();
	},

	hasStroke: function() {
		return this.getStyle().hasStroke();
	},

	hasShadow: function() {
		return this.getStyle().hasShadow();
	},

	_getOrder: function(item) {
		function getList(item) {
			var list = [];
			do {
				list.unshift(item);
			} while (item = item._parent);
			return list;
		}
		var list1 = getList(this),
			list2 = getList(item);
		for (var i = 0, l = Math.min(list1.length, list2.length); i < l; i++) {
			if (list1[i] != list2[i]) {
				return list1[i]._index < list2[i]._index ? 1 : -1;
			}
		}
		return 0;
	},

	hasChildren: function() {
		return this._children && this._children.length > 0;
	},

	isInserted: function() {
		return this._parent ? this._parent.isInserted() : false;
	},

	isAbove: function(item) {
		return this._getOrder(item) === -1;
	},

	isBelow: function(item) {
		return this._getOrder(item) === 1;
	},

	isParent: function(item) {
		return this._parent === item;
	},

	isChild: function(item) {
		return item && item._parent === this;
	},

	isDescendant: function(item) {
		var parent = this;
		while (parent = parent._parent) {
			if (parent === item)
				return true;
		}
		return false;
	},

	isAncestor: function(item) {
		return item ? item.isDescendant(this) : false;
	},

	isSibling: function(item) {
		return this._parent === item._parent;
	},

	isGroupedWith: function(item) {
		var parent = this._parent;
		while (parent) {
			if (parent._parent
				&& /^(Group|Layer|CompoundPath)$/.test(parent._class)
				&& item.isDescendant(parent))
					return true;
			parent = parent._parent;
		}
		return false;
	},

}, Base.each(['rotate', 'scale', 'shear', 'skew'], function(key) {
	var rotate = key === 'rotate';
	this[key] = function() {
		var args = arguments,
			value = (rotate ? Base : Point).read(args),
			center = Point.read(args, 0, { readNull: true });
		return this.transform(new Matrix()[key](value,
				center || this.getPosition(true)));
	};
}, {
	translate: function() {
		var mx = new Matrix();
		return this.transform(mx.translate.apply(mx, arguments));
	},

	transform: function(matrix, _applyRecursively, _setApplyMatrix) {
		var _matrix = this._matrix,
			transformMatrix = matrix && !matrix.isIdentity(),
			applyMatrix = (
				_setApplyMatrix && this._canApplyMatrix ||
				this._applyMatrix && (
					transformMatrix || !_matrix.isIdentity() ||
					_applyRecursively && this._children
				)
			);
		if (!transformMatrix && !applyMatrix)
			return this;
		if (transformMatrix) {
			if (!matrix.isInvertible() && _matrix.isInvertible())
				_matrix._backup = _matrix.getValues();
			_matrix.prepend(matrix, true);
			var style = this._style,
				fillColor = style.getFillColor(true),
				strokeColor = style.getStrokeColor(true);
			if (fillColor)
				fillColor.transform(matrix);
			if (strokeColor)
				strokeColor.transform(matrix);
		}

		if (applyMatrix && (applyMatrix = this._transformContent(
				_matrix, _applyRecursively, _setApplyMatrix))) {
			var pivot = this._pivot;
			if (pivot)
				_matrix._transformPoint(pivot, pivot, true);
			_matrix.reset(true);
			if (_setApplyMatrix && this._canApplyMatrix)
				this._applyMatrix = true;
		}
		var bounds = this._bounds,
			position = this._position;
		if (transformMatrix || applyMatrix) {
			this._changed(25);
		}
		var decomp = transformMatrix && bounds && matrix.decompose();
		if (decomp && decomp.skewing.isZero() && decomp.rotation % 90 === 0) {
			for (var key in bounds) {
				var cache = bounds[key];
				if (cache.nonscaling) {
					delete bounds[key];
				} else if (applyMatrix || !cache.internal) {
					var rect = cache.rect;
					matrix._transformBounds(rect, rect);
				}
			}
			this._bounds = bounds;
			var cached = bounds[this._getBoundsCacheKey(
				this._boundsOptions || {})];
			if (cached) {
				this._position = this._getPositionFromBounds(cached.rect);
			}
		} else if (transformMatrix && position && this._pivot) {
			this._position = matrix._transformPoint(position, position);
		}
		return this;
	},

	_transformContent: function(matrix, applyRecursively, setApplyMatrix) {
		var children = this._children;
		if (children) {
			for (var i = 0, l = children.length; i < l; i++) {
				children[i].transform(matrix, applyRecursively, setApplyMatrix);
			}
			return true;
		}
	},

	globalToLocal: function() {
		return this.getGlobalMatrix(true)._inverseTransform(
				Point.read(arguments));
	},

	localToGlobal: function() {
		return this.getGlobalMatrix(true)._transformPoint(
				Point.read(arguments));
	},

	parentToLocal: function() {
		return this._matrix._inverseTransform(Point.read(arguments));
	},

	localToParent: function() {
		return this._matrix._transformPoint(Point.read(arguments));
	},

	fitBounds: function(rectangle, fill) {
		rectangle = Rectangle.read(arguments);
		var bounds = this.getBounds(),
			itemRatio = bounds.height / bounds.width,
			rectRatio = rectangle.height / rectangle.width,
			scale = (fill ? itemRatio > rectRatio : itemRatio < rectRatio)
					? rectangle.width / bounds.width
					: rectangle.height / bounds.height,
			newBounds = new Rectangle(new Point(),
					new Size(bounds.width * scale, bounds.height * scale));
		newBounds.setCenter(rectangle.getCenter());
		this.setBounds(newBounds);
	}
}), {

	_setStyles: function(ctx, param, viewMatrix) {
		var style = this._style,
			matrix = this._matrix;
		if (style.hasFill()) {
			ctx.fillStyle = style.getFillColor().toCanvasStyle(ctx, matrix);
		}
		if (style.hasStroke()) {
			ctx.strokeStyle = style.getStrokeColor().toCanvasStyle(ctx, matrix);
			ctx.lineWidth = style.getStrokeWidth();
			var strokeJoin = style.getStrokeJoin(),
				strokeCap = style.getStrokeCap(),
				miterLimit = style.getMiterLimit();
			if (strokeJoin)
				ctx.lineJoin = strokeJoin;
			if (strokeCap)
				ctx.lineCap = strokeCap;
			if (miterLimit)
				ctx.miterLimit = miterLimit;
			if (paper.support.nativeDash) {
				var dashArray = style.getDashArray(),
					dashOffset = style.getDashOffset();
				if (dashArray && dashArray.length) {
					if ('setLineDash' in ctx) {
						ctx.setLineDash(dashArray);
						ctx.lineDashOffset = dashOffset;
					} else {
						ctx.mozDash = dashArray;
						ctx.mozDashOffset = dashOffset;
					}
				}
			}
		}
		if (style.hasShadow()) {
			var pixelRatio = param.pixelRatio || 1,
				mx = viewMatrix._shiftless().prepend(
					new Matrix().scale(pixelRatio, pixelRatio)),
				blur = mx.transform(new Point(style.getShadowBlur(), 0)),
				offset = mx.transform(this.getShadowOffset());
			ctx.shadowColor = style.getShadowColor().toCanvasStyle(ctx);
			ctx.shadowBlur = blur.getLength();
			ctx.shadowOffsetX = offset.x;
			ctx.shadowOffsetY = offset.y;
		}
	},

	draw: function(ctx, param, parentStrokeMatrix) {
		var updateVersion = this._updateVersion = this._project._updateVersion;
		if (!this._visible || this._opacity === 0)
			return;
		var matrices = param.matrices,
			viewMatrix = param.viewMatrix,
			matrix = this._matrix,
			globalMatrix = matrices[matrices.length - 1].appended(matrix);
		if (!globalMatrix.isInvertible())
			return;

		viewMatrix = viewMatrix ? viewMatrix.appended(globalMatrix)
				: globalMatrix;

		matrices.push(globalMatrix);
		if (param.updateMatrix) {
			this._globalMatrix = globalMatrix;
		}

		var blendMode = this._blendMode,
			opacity = Numerical.clamp(this._opacity, 0, 1),
			normalBlend = blendMode === 'normal',
			nativeBlend = BlendMode.nativeModes[blendMode],
			direct = normalBlend && opacity === 1
					|| param.dontStart
					|| param.clip
					|| (nativeBlend || normalBlend && opacity < 1)
						&& this._canComposite(),
			pixelRatio = param.pixelRatio || 1,
			mainCtx, itemOffset, prevOffset;
		if (!direct) {
			var bounds = this.getStrokeBounds(viewMatrix);
			if (!bounds.width || !bounds.height) {
				matrices.pop();
				return;
			}
			prevOffset = param.offset;
			itemOffset = param.offset = bounds.getTopLeft().floor();
			mainCtx = ctx;
			ctx = CanvasProvider.getContext(bounds.getSize().ceil().add(1)
					.multiply(pixelRatio));
			if (pixelRatio !== 1)
				ctx.scale(pixelRatio, pixelRatio);
		}
		ctx.save();
		var strokeMatrix = parentStrokeMatrix
				? parentStrokeMatrix.appended(matrix)
				: this._canScaleStroke && !this.getStrokeScaling(true)
					&& viewMatrix,
			clip = !direct && param.clipItem,
			transform = !strokeMatrix || clip;
		if (direct) {
			ctx.globalAlpha = opacity;
			if (nativeBlend)
				ctx.globalCompositeOperation = blendMode;
		} else if (transform) {
			ctx.translate(-itemOffset.x, -itemOffset.y);
		}
		if (transform) {
			(direct ? matrix : viewMatrix).applyToContext(ctx);
		}
		if (clip) {
			param.clipItem.draw(ctx, param.extend({ clip: true }));
		}
		if (strokeMatrix) {
			ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
			var offset = param.offset;
			if (offset)
				ctx.translate(-offset.x, -offset.y);
		}
		this._draw(ctx, param, viewMatrix, strokeMatrix);
		ctx.restore();
		matrices.pop();
		if (param.clip && !param.dontFinish) {
			ctx.clip(this.getFillRule());
		}
		if (!direct) {
			BlendMode.process(blendMode, ctx, mainCtx, opacity,
					itemOffset.subtract(prevOffset).multiply(pixelRatio));
			CanvasProvider.release(ctx);
			param.offset = prevOffset;
		}
	},

	_isUpdated: function(updateVersion) {
		var parent = this._parent;
		if (parent instanceof CompoundPath)
			return parent._isUpdated(updateVersion);
		var updated = this._updateVersion === updateVersion;
		if (!updated && parent && parent._visible
				&& parent._isUpdated(updateVersion)) {
			this._updateVersion = updateVersion;
			updated = true;
		}
		return updated;
	},

	_drawSelection: function(ctx, matrix, size, selectionItems, updateVersion) {
		var selection = this._selection,
			itemSelected = selection & 1,
			boundsSelected = selection & 2
					|| itemSelected && this._selectBounds,
			positionSelected = selection & 4;
		if (!this._drawSelected)
			itemSelected = false;
		if ((itemSelected || boundsSelected || positionSelected)
				&& this._isUpdated(updateVersion)) {
			var layer,
				color = this.getSelectedColor(true) || (layer = this.getLayer())
					&& layer.getSelectedColor(true),
				mx = matrix.appended(this.getGlobalMatrix(true)),
				half = size / 2;
			ctx.strokeStyle = ctx.fillStyle = color
					? color.toCanvasStyle(ctx) : '#009dec';
			if (itemSelected)
				this._drawSelected(ctx, mx, selectionItems);
			if (positionSelected) {
				var pos = this.getPosition(true),
					parent = this._parent,
					point = parent ? parent.localToGlobal(pos) : pos,
					x = point.x,
					y = point.y;
				ctx.beginPath();
				ctx.arc(x, y, half, 0, Math.PI * 2, true);
				ctx.stroke();
				var deltas = [[0, -1], [1, 0], [0, 1], [-1, 0]],
					start = half,
					end = size + 1;
				for (var i = 0; i < 4; i++) {
					var delta = deltas[i],
						dx = delta[0],
						dy = delta[1];
					ctx.moveTo(x + dx * start, y + dy * start);
					ctx.lineTo(x + dx * end, y + dy * end);
					ctx.stroke();
				}
			}
			if (boundsSelected) {
				var coords = mx._transformCorners(this.getInternalBounds());
				ctx.beginPath();
				for (var i = 0; i < 8; i++) {
					ctx[!i ? 'moveTo' : 'lineTo'](coords[i], coords[++i]);
				}
				ctx.closePath();
				ctx.stroke();
				for (var i = 0; i < 8; i++) {
					ctx.fillRect(coords[i] - half, coords[++i] - half,
							size, size);
				}
			}
		}
	},

	_canComposite: function() {
		return false;
	}
}, Base.each(['down', 'drag', 'up', 'move'], function(key) {
	this['removeOn' + Base.capitalize(key)] = function() {
		var hash = {};
		hash[key] = true;
		return this.removeOn(hash);
	};
}, {

	removeOn: function(obj) {
		for (var name in obj) {
			if (obj[name]) {
				var key = 'mouse' + name,
					project = this._project,
					sets = project._removeSets = project._removeSets || {};
				sets[key] = sets[key] || {};
				sets[key][this._id] = this;
			}
		}
		return this;
	}
}), {
	tween: function(from, to, options) {
		if (!options) {
			options = to;
			to = from;
			from = null;
			if (!options) {
				options = to;
				to = null;
			}
		}
		var easing = options && options.easing,
			start = options && options.start,
			duration = options != null && (
				typeof options === 'number' ? options : options.duration
			),
			tween = new Tween(this, from, to, duration, easing, start);
		function onFrame(event) {
			tween._handleFrame(event.time * 1000);
			if (!tween.running) {
				this.off('frame', onFrame);
			}
		}
		if (duration) {
			this.on('frame', onFrame);
		}
		return tween;
	},

	tweenTo: function(to, options) {
		return this.tween(null, to, options);
	},

	tweenFrom: function(from, options) {
		return this.tween(from, null, options);
	}
});

var Group = Item.extend({
	_class: 'Group',
	_selectBounds: false,
	_selectChildren: true,
	_serializeFields: {
		children: []
	},

	initialize: function Group(arg) {
		this._children = [];
		this._namedChildren = {};
		if (!this._initialize(arg))
			this.addChildren(Array.isArray(arg) ? arg : arguments);
	},

	_changed: function _changed(flags) {
		_changed.base.call(this, flags);
		if (flags & 2050) {
			this._clipItem = undefined;
		}
	},

	_getClipItem: function() {
		var clipItem = this._clipItem;
		if (clipItem === undefined) {
			clipItem = null;
			var children = this._children;
			for (var i = 0, l = children.length; i < l; i++) {
				if (children[i]._clipMask) {
					clipItem = children[i];
					break;
				}
			}
			this._clipItem = clipItem;
		}
		return clipItem;
	},

	isClipped: function() {
		return !!this._getClipItem();
	},

	setClipped: function(clipped) {
		var child = this.getFirstChild();
		if (child)
			child.setClipMask(clipped);
	},

	_getBounds: function _getBounds(matrix, options) {
		var clipItem = this._getClipItem();
		return clipItem
			? clipItem._getCachedBounds(clipItem._matrix.prepended(matrix),
				Base.set({}, options, { stroke: false }))
			: _getBounds.base.call(this, matrix, options);
	},

	_hitTestChildren: function _hitTestChildren(point, options, viewMatrix) {
		var clipItem = this._getClipItem();
		return (!clipItem || clipItem.contains(point))
				&& _hitTestChildren.base.call(this, point, options, viewMatrix,
					clipItem);
	},

	_draw: function(ctx, param) {
		var clip = param.clip,
			clipItem = !clip && this._getClipItem();
		param = param.extend({ clipItem: clipItem, clip: false });
		if (clip) {
			ctx.beginPath();
			param.dontStart = param.dontFinish = true;
		} else if (clipItem) {
			clipItem.draw(ctx, param.extend({ clip: true }));
		}
		var children = this._children;
		for (var i = 0, l = children.length; i < l; i++) {
			var item = children[i];
			if (item !== clipItem)
				item.draw(ctx, param);
		}
	}
});

var Layer = Group.extend({
	_class: 'Layer',

	initialize: function Layer() {
		Group.apply(this, arguments);
	},

	_getOwner: function() {
		return this._parent || this._index != null && this._project;
	},

	isInserted: function isInserted() {
		return this._parent ? isInserted.base.call(this) : this._index != null;
	},

	activate: function() {
		this._project._activeLayer = this;
	},

	_hitTestSelf: function() {
	}
});

var Shape = Item.extend({
	_class: 'Shape',
	_applyMatrix: false,
	_canApplyMatrix: false,
	_canScaleStroke: true,
	_serializeFields: {
		type: null,
		size: null,
		radius: null
	},

	initialize: function Shape(props, point) {
		this._initialize(props, point);
	},

	_equals: function(item) {
		return this._type === item._type
			&& this._size.equals(item._size)
			&& Base.equals(this._radius, item._radius);
	},

	copyContent: function(source) {
		this.setType(source._type);
		this.setSize(source._size);
		this.setRadius(source._radius);
	},

	getType: function() {
		return this._type;
	},

	setType: function(type) {
		this._type = type;
	},

	getShape: '#getType',
	setShape: '#setType',

	getSize: function() {
		var size = this._size;
		return new LinkedSize(size.width, size.height, this, 'setSize');
	},

	setSize: function() {
		var size = Size.read(arguments);
		if (!this._size) {
			this._size = size.clone();
		} else if (!this._size.equals(size)) {
			var type = this._type,
				width = size.width,
				height = size.height;
			if (type === 'rectangle') {
				this._radius.set(Size.min(this._radius, size.divide(2).abs()));
			} else if (type === 'circle') {
				width = height = (width + height) / 2;
				this._radius = width / 2;
			} else if (type === 'ellipse') {
				this._radius._set(width / 2, height / 2);
			}
			this._size._set(width, height);
			this._changed(9);
		}
	},

	getRadius: function() {
		var rad = this._radius;
		return this._type === 'circle'
				? rad
				: new LinkedSize(rad.width, rad.height, this, 'setRadius');
	},

	setRadius: function(radius) {
		var type = this._type;
		if (type === 'circle') {
			if (radius === this._radius)
				return;
			var size = radius * 2;
			this._radius = radius;
			this._size._set(size, size);
		} else {
			radius = Size.read(arguments);
			if (!this._radius) {
				this._radius = radius.clone();
			} else {
				if (this._radius.equals(radius))
					return;
				this._radius.set(radius);
				if (type === 'rectangle') {
					var size = Size.max(this._size, radius.multiply(2));
					this._size.set(size);
				} else if (type === 'ellipse') {
					this._size._set(radius.width * 2, radius.height * 2);
				}
			}
		}
		this._changed(9);
	},

	isEmpty: function() {
		return false;
	},

	toPath: function(insert) {
		var path = new Path[Base.capitalize(this._type)]({
			center: new Point(),
			size: this._size,
			radius: this._radius,
			insert: false
		});
		path.copyAttributes(this);
		if (paper.settings.applyMatrix)
			path.setApplyMatrix(true);
		if (insert === undefined || insert)
			path.insertAbove(this);
		return path;
	},

	toShape: '#clone',

	_asPathItem: function() {
		return this.toPath(false);
	},

	_draw: function(ctx, param, viewMatrix, strokeMatrix) {
		var style = this._style,
			hasFill = style.hasFill(),
			hasStroke = style.hasStroke(),
			dontPaint = param.dontFinish || param.clip,
			untransformed = !strokeMatrix;
		if (hasFill || hasStroke || dontPaint) {
			var type = this._type,
				radius = this._radius,
				isCircle = type === 'circle';
			if (!param.dontStart)
				ctx.beginPath();
			if (untransformed && isCircle) {
				ctx.arc(0, 0, radius, 0, Math.PI * 2, true);
			} else {
				var rx = isCircle ? radius : radius.width,
					ry = isCircle ? radius : radius.height,
					size = this._size,
					width = size.width,
					height = size.height;
				if (untransformed && type === 'rectangle' && rx === 0 && ry === 0) {
					ctx.rect(-width / 2, -height / 2, width, height);
				} else {
					var x = width / 2,
						y = height / 2,
						kappa = 1 - 0.5522847498307936,
						cx = rx * kappa,
						cy = ry * kappa,
						c = [
							-x, -y + ry,
							-x, -y + cy,
							-x + cx, -y,
							-x + rx, -y,
							x - rx, -y,
							x - cx, -y,
							x, -y + cy,
							x, -y + ry,
							x, y - ry,
							x, y - cy,
							x - cx, y,
							x - rx, y,
							-x + rx, y,
							-x + cx, y,
							-x, y - cy,
							-x, y - ry
						];
					if (strokeMatrix)
						strokeMatrix.transform(c, c, 32);
					ctx.moveTo(c[0], c[1]);
					ctx.bezierCurveTo(c[2], c[3], c[4], c[5], c[6], c[7]);
					if (x !== rx)
						ctx.lineTo(c[8], c[9]);
					ctx.bezierCurveTo(c[10], c[11], c[12], c[13], c[14], c[15]);
					if (y !== ry)
						ctx.lineTo(c[16], c[17]);
					ctx.bezierCurveTo(c[18], c[19], c[20], c[21], c[22], c[23]);
					if (x !== rx)
						ctx.lineTo(c[24], c[25]);
					ctx.bezierCurveTo(c[26], c[27], c[28], c[29], c[30], c[31]);
				}
			}
			ctx.closePath();
		}
		if (!dontPaint && (hasFill || hasStroke)) {
			this._setStyles(ctx, param, viewMatrix);
			if (hasFill) {
				ctx.fill(style.getFillRule());
				ctx.shadowColor = 'rgba(0,0,0,0)';
			}
			if (hasStroke)
				ctx.stroke();
		}
	},

	_canComposite: function() {
		return !(this.hasFill() && this.hasStroke());
	},

	_getBounds: function(matrix, options) {
		var rect = new Rectangle(this._size).setCenter(0, 0),
			style = this._style,
			strokeWidth = options.stroke && style.hasStroke()
					&& style.getStrokeWidth();
		if (matrix)
			rect = matrix._transformBounds(rect);
		return strokeWidth
				? rect.expand(Path._getStrokePadding(strokeWidth,
					this._getStrokeMatrix(matrix, options)))
				: rect;
	}
},
new function() {
	function getCornerCenter(that, point, expand) {
		var radius = that._radius;
		if (!radius.isZero()) {
			var halfSize = that._size.divide(2);
			for (var q = 1; q <= 4; q++) {
				var dir = new Point(q > 1 && q < 4 ? -1 : 1, q > 2 ? -1 : 1),
					corner = dir.multiply(halfSize),
					center = corner.subtract(dir.multiply(radius)),
					rect = new Rectangle(
							expand ? corner.add(dir.multiply(expand)) : corner,
							center);
				if (rect.contains(point))
					return { point: center, quadrant: q };
			}
		}
	}

	function isOnEllipseStroke(point, radius, padding, quadrant) {
		var vector = point.divide(radius);
		return (!quadrant || vector.isInQuadrant(quadrant)) &&
				vector.subtract(vector.normalize()).multiply(radius)
					.divide(padding).length <= 1;
	}

	return {
		_contains: function _contains(point) {
			if (this._type === 'rectangle') {
				var center = getCornerCenter(this, point);
				return center
						? point.subtract(center.point).divide(this._radius)
							.getLength() <= 1
						: _contains.base.call(this, point);
			} else {
				return point.divide(this.size).getLength() <= 0.5;
			}
		},

		_hitTestSelf: function _hitTestSelf(point, options, viewMatrix,
				strokeMatrix) {
			var hit = false,
				style = this._style,
				hitStroke = options.stroke && style.hasStroke(),
				hitFill = options.fill && style.hasFill();
			if (hitStroke || hitFill) {
				var type = this._type,
					radius = this._radius,
					strokeRadius = hitStroke ? style.getStrokeWidth() / 2 : 0,
					strokePadding = options._tolerancePadding.add(
						Path._getStrokePadding(strokeRadius,
							!style.getStrokeScaling() && strokeMatrix));
				if (type === 'rectangle') {
					var padding = strokePadding.multiply(2),
						center = getCornerCenter(this, point, padding);
					if (center) {
						hit = isOnEllipseStroke(point.subtract(center.point),
								radius, strokePadding, center.quadrant);
					} else {
						var rect = new Rectangle(this._size).setCenter(0, 0),
							outer = rect.expand(padding),
							inner = rect.expand(padding.negate());
						hit = outer._containsPoint(point)
								&& !inner._containsPoint(point);
					}
				} else {
					hit = isOnEllipseStroke(point, radius, strokePadding);
				}
			}
			return hit ? new HitResult(hitStroke ? 'stroke' : 'fill', this)
					: _hitTestSelf.base.apply(this, arguments);
		}
	};
}, {

statics: new function() {
	function createShape(type, point, size, radius, args) {
		var item = Base.create(Shape.prototype);
		item._type = type;
		item._size = size;
		item._radius = radius;
		item._initialize(Base.getNamed(args), point);
		return item;
	}

	return {
		Circle: function() {
			var args = arguments,
				center = Point.readNamed(args, 'center'),
				radius = Base.readNamed(args, 'radius');
			return createShape('circle', center, new Size(radius * 2), radius,
					args);
		},

		Rectangle: function() {
			var args = arguments,
				rect = Rectangle.readNamed(args, 'rectangle'),
				radius = Size.min(Size.readNamed(args, 'radius'),
						rect.getSize(true).divide(2));
			return createShape('rectangle', rect.getCenter(true),
					rect.getSize(true), radius, args);
		},

		Ellipse: function() {
			var args = arguments,
				ellipse = Shape._readEllipse(args),
				radius = ellipse.radius;
			return createShape('ellipse', ellipse.center, radius.multiply(2),
					radius, args);
		},

		_readEllipse: function(args) {
			var center,
				radius;
			if (Base.hasNamed(args, 'radius')) {
				center = Point.readNamed(args, 'center');
				radius = Size.readNamed(args, 'radius');
			} else {
				var rect = Rectangle.readNamed(args, 'rectangle');
				center = rect.getCenter(true);
				radius = rect.getSize(true).divide(2);
			}
			return { center: center, radius: radius };
		}
	};
}});

var Raster = Item.extend({
	_class: 'Raster',
	_applyMatrix: false,
	_canApplyMatrix: false,
	_boundsOptions: { stroke: false, handle: false },
	_serializeFields: {
		crossOrigin: null,
		source: null
	},
	_prioritize: ['crossOrigin'],
	_smoothing: 'low',
	beans: true,

	initialize: function Raster(source, position) {
		if (!this._initialize(source,
				position !== undefined && Point.read(arguments))) {
			var image,
				type = typeof source,
				object = type === 'string'
					? document.getElementById(source)
					: type  === 'object'
						? source
						: null;
			if (object && object !== Item.NO_INSERT) {
				if (object.getContext || object.naturalHeight != null) {
					image = object;
				} else if (object) {
					var size = Size.read(arguments);
					if (!size.isZero()) {
						image = CanvasProvider.getCanvas(size);
					}
				}
			}
			if (image) {
				this.setImage(image);
			} else {
				this.setSource(source);
			}
		}
		if (!this._size) {
			this._size = new Size();
			this._loaded = false;
		}
	},

	_equals: function(item) {
		return this.getSource() === item.getSource();
	},

	copyContent: function(source) {
		var image = source._image,
			canvas = source._canvas;
		if (image) {
			this._setImage(image);
		} else if (canvas) {
			var copyCanvas = CanvasProvider.getCanvas(source._size);
			copyCanvas.getContext('2d').drawImage(canvas, 0, 0);
			this._setImage(copyCanvas);
		}
		this._crossOrigin = source._crossOrigin;
	},

	getSize: function() {
		var size = this._size;
		return new LinkedSize(size ? size.width : 0, size ? size.height : 0,
				this, 'setSize');
	},

	setSize: function(_size, _clear) {
		var size = Size.read(arguments);
		if (!size.equals(this._size)) {
			if (size.width > 0 && size.height > 0) {
				var element = !_clear && this.getElement();
				this._setImage(CanvasProvider.getCanvas(size));
				if (element) {
					this.getContext(true).drawImage(element, 0, 0,
							size.width, size.height);
				}
			} else {
				if (this._canvas)
					CanvasProvider.release(this._canvas);
				this._size = size.clone();
			}
		} else if (_clear) {
			this.clear();
		}
	},

	getWidth: function() {
		return this._size ? this._size.width : 0;
	},

	setWidth: function(width) {
		this.setSize(width, this.getHeight());
	},

	getHeight: function() {
		return this._size ? this._size.height : 0;
	},

	setHeight: function(height) {
		this.setSize(this.getWidth(), height);
	},

	getLoaded: function() {
		return this._loaded;
	},

	isEmpty: function() {
		var size = this._size;
		return !size || size.width === 0 && size.height === 0;
	},

	getResolution: function() {
		var matrix = this._matrix,
			orig = new Point(0, 0).transform(matrix),
			u = new Point(1, 0).transform(matrix).subtract(orig),
			v = new Point(0, 1).transform(matrix).subtract(orig);
		return new Size(
			72 / u.getLength(),
			72 / v.getLength()
		);
	},

	getPpi: '#getResolution',

	getImage: function() {
		return this._image;
	},

	setImage: function(image) {
		var that = this;

		function emit(event) {
			var view = that.getView(),
				type = event && event.type || 'load';
			if (view && that.responds(type)) {
				paper = view._scope;
				that.emit(type, new Event(event));
			}
		}

		this._setImage(image);
		if (this._loaded) {
			setTimeout(emit, 0);
		} else if (image) {
			DomEvent.add(image, {
				load: function(event) {
					that._setImage(image);
					emit(event);
				},
				error: emit
			});
		}
	},

	_setImage: function(image) {
		if (this._canvas)
			CanvasProvider.release(this._canvas);
		if (image && image.getContext) {
			this._image = null;
			this._canvas = image;
			this._loaded = true;
		} else {
			this._image = image;
			this._canvas = null;
			this._loaded = !!(image && image.src && image.complete);
		}
		this._size = new Size(
				image ? image.naturalWidth || image.width : 0,
				image ? image.naturalHeight || image.height : 0);
		this._context = null;
		this._changed(1033);
	},

	getCanvas: function() {
		if (!this._canvas) {
			var ctx = CanvasProvider.getContext(this._size);
			try {
				if (this._image)
					ctx.drawImage(this._image, 0, 0);
				this._canvas = ctx.canvas;
			} catch (e) {
				CanvasProvider.release(ctx);
			}
		}
		return this._canvas;
	},

	setCanvas: '#setImage',

	getContext: function(_change) {
		if (!this._context)
			this._context = this.getCanvas().getContext('2d');
		if (_change) {
			this._image = null;
			this._changed(1025);
		}
		return this._context;
	},

	setContext: function(context) {
		this._context = context;
	},

	getSource: function() {
		var image = this._image;
		return image && image.src || this.toDataURL();
	},

	setSource: function(src) {
		var image = new self.Image(),
			crossOrigin = this._crossOrigin;
		if (crossOrigin)
			image.crossOrigin = crossOrigin;
		if (src)
			image.src = src;
		this.setImage(image);
	},

	getCrossOrigin: function() {
		var image = this._image;
		return image && image.crossOrigin || this._crossOrigin || '';
	},

	setCrossOrigin: function(crossOrigin) {
		this._crossOrigin = crossOrigin;
		var image = this._image;
		if (image)
			image.crossOrigin = crossOrigin;
	},

	getSmoothing: function() {
		return this._smoothing;
	},

	setSmoothing: function(smoothing) {
		this._smoothing = typeof smoothing === 'string'
			? smoothing
			: smoothing ? 'low' : 'off';
		this._changed(257);
	},

	getElement: function() {
		return this._canvas || this._loaded && this._image;
	}
}, {
	beans: false,

	getSubCanvas: function() {
		var rect = Rectangle.read(arguments),
			ctx = CanvasProvider.getContext(rect.getSize());
		ctx.drawImage(this.getCanvas(), rect.x, rect.y,
				rect.width, rect.height, 0, 0, rect.width, rect.height);
		return ctx.canvas;
	},

	getSubRaster: function() {
		var rect = Rectangle.read(arguments),
			raster = new Raster(Item.NO_INSERT);
		raster._setImage(this.getSubCanvas(rect));
		raster.translate(rect.getCenter().subtract(this.getSize().divide(2)));
		raster._matrix.prepend(this._matrix);
		raster.insertAbove(this);
		return raster;
	},

	toDataURL: function() {
		var image = this._image,
			src = image && image.src;
		if (/^data:/.test(src))
			return src;
		var canvas = this.getCanvas();
		return canvas ? canvas.toDataURL.apply(canvas, arguments) : null;
	},

	drawImage: function(image ) {
		var point = Point.read(arguments, 1);
		this.getContext(true).drawImage(image, point.x, point.y);
	},

	getAverageColor: function(object) {
		var bounds, path;
		if (!object) {
			bounds = this.getBounds();
		} else if (object instanceof PathItem) {
			path = object;
			bounds = object.getBounds();
		} else if (typeof object === 'object') {
			if ('width' in object) {
				bounds = new Rectangle(object);
			} else if ('x' in object) {
				bounds = new Rectangle(object.x - 0.5, object.y - 0.5, 1, 1);
			}
		}
		if (!bounds)
			return null;
		var sampleSize = 32,
			width = Math.min(bounds.width, sampleSize),
			height = Math.min(bounds.height, sampleSize);
		var ctx = Raster._sampleContext;
		if (!ctx) {
			ctx = Raster._sampleContext = CanvasProvider.getContext(
					new Size(sampleSize));
		} else {
			ctx.clearRect(0, 0, sampleSize + 1, sampleSize + 1);
		}
		ctx.save();
		var matrix = new Matrix()
				.scale(width / bounds.width, height / bounds.height)
				.translate(-bounds.x, -bounds.y);
		matrix.applyToContext(ctx);
		if (path)
			path.draw(ctx, new Base({ clip: true, matrices: [matrix] }));
		this._matrix.applyToContext(ctx);
		var element = this.getElement(),
			size = this._size;
		if (element)
			ctx.drawImage(element, -size.width / 2, -size.height / 2);
		ctx.restore();
		var pixels = ctx.getImageData(0.5, 0.5, Math.ceil(width),
				Math.ceil(height)).data,
			channels = [0, 0, 0],
			total = 0;
		for (var i = 0, l = pixels.length; i < l; i += 4) {
			var alpha = pixels[i + 3];
			total += alpha;
			alpha /= 255;
			channels[0] += pixels[i] * alpha;
			channels[1] += pixels[i + 1] * alpha;
			channels[2] += pixels[i + 2] * alpha;
		}
		for (var i = 0; i < 3; i++)
			channels[i] /= total;
		return total ? Color.read(channels) : null;
	},

	getPixel: function() {
		var point = Point.read(arguments);
		var data = this.getContext().getImageData(point.x, point.y, 1, 1).data;
		return new Color('rgb', [data[0] / 255, data[1] / 255, data[2] / 255],
				data[3] / 255);
	},

	setPixel: function() {
		var args = arguments,
			point = Point.read(args),
			color = Color.read(args),
			components = color._convert('rgb'),
			alpha = color._alpha,
			ctx = this.getContext(true),
			imageData = ctx.createImageData(1, 1),
			data = imageData.data;
		data[0] = components[0] * 255;
		data[1] = components[1] * 255;
		data[2] = components[2] * 255;
		data[3] = alpha != null ? alpha * 255 : 255;
		ctx.putImageData(imageData, point.x, point.y);
	},

	clear: function() {
		var size = this._size;
		this.getContext(true).clearRect(0, 0, size.width + 1, size.height + 1);
	},

	createImageData: function() {
		var size = Size.read(arguments);
		return this.getContext().createImageData(size.width, size.height);
	},

	getImageData: function() {
		var rect = Rectangle.read(arguments);
		if (rect.isEmpty())
			rect = new Rectangle(this._size);
		return this.getContext().getImageData(rect.x, rect.y,
				rect.width, rect.height);
	},

	putImageData: function(data ) {
		var point = Point.read(arguments, 1);
		this.getContext(true).putImageData(data, point.x, point.y);
	},

	setImageData: function(data) {
		this.setSize(data);
		this.getContext(true).putImageData(data, 0, 0);
	},

	_getBounds: function(matrix, options) {
		var rect = new Rectangle(this._size).setCenter(0, 0);
		return matrix ? matrix._transformBounds(rect) : rect;
	},

	_hitTestSelf: function(point) {
		if (this._contains(point)) {
			var that = this;
			return new HitResult('pixel', that, {
				offset: point.add(that._size.divide(2)).round(),
				color: {
					get: function() {
						return that.getPixel(this.offset);
					}
				}
			});
		}
	},

	_draw: function(ctx, param, viewMatrix) {
		var element = this.getElement();
		if (element && element.width > 0 && element.height > 0) {
			ctx.globalAlpha = Numerical.clamp(this._opacity, 0, 1);

			this._setStyles(ctx, param, viewMatrix);

			var smoothing = this._smoothing,
				disabled = smoothing === 'off';
			DomElement.setPrefixed(
				ctx,
				disabled ? 'imageSmoothingEnabled' : 'imageSmoothingQuality',
				disabled ? false : smoothing
			);

			ctx.drawImage(element,
					-this._size.width / 2, -this._size.height / 2);
		}
	},

	_canComposite: function() {
		return true;
	}
});

var SymbolItem = Item.extend({
	_class: 'SymbolItem',
	_applyMatrix: false,
	_canApplyMatrix: false,
	_boundsOptions: { stroke: true },
	_serializeFields: {
		symbol: null
	},

	initialize: function SymbolItem(arg0, arg1) {
		if (!this._initialize(arg0,
				arg1 !== undefined && Point.read(arguments, 1)))
			this.setDefinition(arg0 instanceof SymbolDefinition ?
					arg0 : new SymbolDefinition(arg0));
	},

	_equals: function(item) {
		return this._definition === item._definition;
	},

	copyContent: function(source) {
		this.setDefinition(source._definition);
	},

	getDefinition: function() {
		return this._definition;
	},

	setDefinition: function(definition) {
		this._definition = definition;
		this._changed(9);
	},

	getSymbol: '#getDefinition',
	setSymbol: '#setDefinition',

	isEmpty: function() {
		return this._definition._item.isEmpty();
	},

	_getBounds: function(matrix, options) {
		var item = this._definition._item;
		return item._getCachedBounds(item._matrix.prepended(matrix), options);
	},

	_hitTestSelf: function(point, options, viewMatrix) {
		var opts = options.extend({ all: false });
		var res = this._definition._item._hitTest(point, opts, viewMatrix);
		if (res)
			res.item = this;
		return res;
	},

	_draw: function(ctx, param) {
		this._definition._item.draw(ctx, param);
	}

});

var SymbolDefinition = Base.extend({
	_class: 'SymbolDefinition',

	initialize: function SymbolDefinition(item, dontCenter) {
		this._id = UID.get();
		this.project = paper.project;
		if (item)
			this.setItem(item, dontCenter);
	},

	_serialize: function(options, dictionary) {
		return dictionary.add(this, function() {
			return Base.serialize([this._class, this._item],
					options, false, dictionary);
		});
	},

	_changed: function(flags) {
		if (flags & 8)
			Item._clearBoundsCache(this);
		if (flags & 1)
			this.project._changed(flags);
	},

	getItem: function() {
		return this._item;
	},

	setItem: function(item, _dontCenter) {
		if (item._symbol)
			item = item.clone();
		if (this._item)
			this._item._symbol = null;
		this._item = item;
		item.remove();
		item.setSelected(false);
		if (!_dontCenter)
			item.setPosition(new Point());
		item._symbol = this;
		this._changed(9);
	},

	getDefinition: '#getItem',
	setDefinition: '#setItem',

	place: function(position) {
		return new SymbolItem(this, position);
	},

	clone: function() {
		return new SymbolDefinition(this._item.clone(false));
	},

	equals: function(symbol) {
		return symbol === this
				|| symbol && this._item.equals(symbol._item)
				|| false;
	}
});

var HitResult = Base.extend({
	_class: 'HitResult',

	initialize: function HitResult(type, item, values) {
		this.type = type;
		this.item = item;
		if (values)
			this.inject(values);
	},

	statics: {
		getOptions: function(args) {
			var options = args && Base.read(args);
			return new Base({
				type: null,
				tolerance: paper.settings.hitTolerance,
				fill: !options,
				stroke: !options,
				segments: !options,
				handles: false,
				ends: false,
				position: false,
				center: false,
				bounds: false,
				guides: false,
				selected: false
			}, options);
		}
	}
});

var Segment = Base.extend({
	_class: 'Segment',
	beans: true,
	_selection: 0,

	initialize: function Segment(arg0, arg1, arg2, arg3, arg4, arg5) {
		var count = arguments.length,
			point, handleIn, handleOut, selection;
		if (count > 0) {
			if (arg0 == null || typeof arg0 === 'object') {
				if (count === 1 && arg0 && 'point' in arg0) {
					point = arg0.point;
					handleIn = arg0.handleIn;
					handleOut = arg0.handleOut;
					selection = arg0.selection;
				} else {
					point = arg0;
					handleIn = arg1;
					handleOut = arg2;
					selection = arg3;
				}
			} else {
				point = [ arg0, arg1 ];
				handleIn = arg2 !== undefined ? [ arg2, arg3 ] : null;
				handleOut = arg4 !== undefined ? [ arg4, arg5 ] : null;
			}
		}
		new SegmentPoint(point, this, '_point');
		new SegmentPoint(handleIn, this, '_handleIn');
		new SegmentPoint(handleOut, this, '_handleOut');
		if (selection)
			this.setSelection(selection);
	},

	_serialize: function(options, dictionary) {
		var point = this._point,
			selection = this._selection,
			obj = selection || this.hasHandles()
					? [point, this._handleIn, this._handleOut]
					: point;
		if (selection)
			obj.push(selection);
		return Base.serialize(obj, options, true, dictionary);
	},

	_changed: function(point) {
		var path = this._path;
		if (!path)
			return;
		var curves = path._curves,
			index = this._index,
			curve;
		if (curves) {
			if ((!point || point === this._point || point === this._handleIn)
					&& (curve = index > 0 ? curves[index - 1] : path._closed
						? curves[curves.length - 1] : null))
				curve._changed();
			if ((!point || point === this._point || point === this._handleOut)
					&& (curve = curves[index]))
				curve._changed();
		}
		path._changed(41);
	},

	getPoint: function() {
		return this._point;
	},

	setPoint: function() {
		this._point.set(Point.read(arguments));
	},

	getHandleIn: function() {
		return this._handleIn;
	},

	setHandleIn: function() {
		this._handleIn.set(Point.read(arguments));
	},

	getHandleOut: function() {
		return this._handleOut;
	},

	setHandleOut: function() {
		this._handleOut.set(Point.read(arguments));
	},

	hasHandles: function() {
		return !this._handleIn.isZero() || !this._handleOut.isZero();
	},

	isSmooth: function() {
		var handleIn = this._handleIn,
			handleOut = this._handleOut;
		return !handleIn.isZero() && !handleOut.isZero()
				&& handleIn.isCollinear(handleOut);
	},

	clearHandles: function() {
		this._handleIn._set(0, 0);
		this._handleOut._set(0, 0);
	},

	getSelection: function() {
		return this._selection;
	},

	setSelection: function(selection) {
		var oldSelection = this._selection,
			path = this._path;
		this._selection = selection = selection || 0;
		if (path && selection !== oldSelection) {
			path._updateSelection(this, oldSelection, selection);
			path._changed(257);
		}
	},

	_changeSelection: function(flag, selected) {
		var selection = this._selection;
		this.setSelection(selected ? selection | flag : selection & ~flag);
	},

	isSelected: function() {
		return !!(this._selection & 7);
	},

	setSelected: function(selected) {
		this._changeSelection(7, selected);
	},

	getIndex: function() {
		return this._index !== undefined ? this._index : null;
	},

	getPath: function() {
		return this._path || null;
	},

	getCurve: function() {
		var path = this._path,
			index = this._index;
		if (path) {
			if (index > 0 && !path._closed
					&& index === path._segments.length - 1)
				index--;
			return path.getCurves()[index] || null;
		}
		return null;
	},

	getLocation: function() {
		var curve = this.getCurve();
		return curve
				? new CurveLocation(curve, this === curve._segment1 ? 0 : 1)
				: null;
	},

	getNext: function() {
		var segments = this._path && this._path._segments;
		return segments && (segments[this._index + 1]
				|| this._path._closed && segments[0]) || null;
	},

	smooth: function(options, _first, _last) {
		var opts = options || {},
			type = opts.type,
			factor = opts.factor,
			prev = this.getPrevious(),
			next = this.getNext(),
			p0 = (prev || this)._point,
			p1 = this._point,
			p2 = (next || this)._point,
			d1 = p0.getDistance(p1),
			d2 = p1.getDistance(p2);
		if (!type || type === 'catmull-rom') {
			var a = factor === undefined ? 0.5 : factor,
				d1_a = Math.pow(d1, a),
				d1_2a = d1_a * d1_a,
				d2_a = Math.pow(d2, a),
				d2_2a = d2_a * d2_a;
			if (!_first && prev) {
				var A = 2 * d2_2a + 3 * d2_a * d1_a + d1_2a,
					N = 3 * d2_a * (d2_a + d1_a);
				this.setHandleIn(N !== 0
					? new Point(
						(d2_2a * p0._x + A * p1._x - d1_2a * p2._x) / N - p1._x,
						(d2_2a * p0._y + A * p1._y - d1_2a * p2._y) / N - p1._y)
					: new Point());
			}
			if (!_last && next) {
				var A = 2 * d1_2a + 3 * d1_a * d2_a + d2_2a,
					N = 3 * d1_a * (d1_a + d2_a);
				this.setHandleOut(N !== 0
					? new Point(
						(d1_2a * p2._x + A * p1._x - d2_2a * p0._x) / N - p1._x,
						(d1_2a * p2._y + A * p1._y - d2_2a * p0._y) / N - p1._y)
					: new Point());
			}
		} else if (type === 'geometric') {
			if (prev && next) {
				var vector = p0.subtract(p2),
					t = factor === undefined ? 0.4 : factor,
					k = t * d1 / (d1 + d2);
				if (!_first)
					this.setHandleIn(vector.multiply(k));
				if (!_last)
					this.setHandleOut(vector.multiply(k - t));
			}
		} else {
			throw new Error('Smoothing method \'' + type + '\' not supported.');
		}
	},

	getPrevious: function() {
		var segments = this._path && this._path._segments;
		return segments && (segments[this._index - 1]
				|| this._path._closed && segments[segments.length - 1]) || null;
	},

	isFirst: function() {
		return !this._index;
	},

	isLast: function() {
		var path = this._path;
		return path && this._index === path._segments.length - 1 || false;
	},

	reverse: function() {
		var handleIn = this._handleIn,
			handleOut = this._handleOut,
			tmp = handleIn.clone();
		handleIn.set(handleOut);
		handleOut.set(tmp);
	},

	reversed: function() {
		return new Segment(this._point, this._handleOut, this._handleIn);
	},

	remove: function() {
		return this._path ? !!this._path.removeSegment(this._index) : false;
	},

	clone: function() {
		return new Segment(this._point, this._handleIn, this._handleOut);
	},

	equals: function(segment) {
		return segment === this || segment && this._class === segment._class
				&& this._point.equals(segment._point)
				&& this._handleIn.equals(segment._handleIn)
				&& this._handleOut.equals(segment._handleOut)
				|| false;
	},

	toString: function() {
		var parts = [ 'point: ' + this._point ];
		if (!this._handleIn.isZero())
			parts.push('handleIn: ' + this._handleIn);
		if (!this._handleOut.isZero())
			parts.push('handleOut: ' + this._handleOut);
		return '{ ' + parts.join(', ') + ' }';
	},

	transform: function(matrix) {
		this._transformCoordinates(matrix, new Array(6), true);
		this._changed();
	},

	interpolate: function(from, to, factor) {
		var u = 1 - factor,
			v = factor,
			point1 = from._point,
			point2 = to._point,
			handleIn1 = from._handleIn,
			handleIn2 = to._handleIn,
			handleOut2 = to._handleOut,
			handleOut1 = from._handleOut;
		this._point._set(
				u * point1._x + v * point2._x,
				u * point1._y + v * point2._y, true);
		this._handleIn._set(
				u * handleIn1._x + v * handleIn2._x,
				u * handleIn1._y + v * handleIn2._y, true);
		this._handleOut._set(
				u * handleOut1._x + v * handleOut2._x,
				u * handleOut1._y + v * handleOut2._y, true);
		this._changed();
	},

	_transformCoordinates: function(matrix, coords, change) {
		var point = this._point,
			handleIn = !change || !this._handleIn.isZero()
					? this._handleIn : null,
			handleOut = !change || !this._handleOut.isZero()
					? this._handleOut : null,
			x = point._x,
			y = point._y,
			i = 2;
		coords[0] = x;
		coords[1] = y;
		if (handleIn) {
			coords[i++] = handleIn._x + x;
			coords[i++] = handleIn._y + y;
		}
		if (handleOut) {
			coords[i++] = handleOut._x + x;
			coords[i++] = handleOut._y + y;
		}
		if (matrix) {
			matrix._transformCoordinates(coords, coords, i / 2);
			x = coords[0];
			y = coords[1];
			if (change) {
				point._x = x;
				point._y = y;
				i = 2;
				if (handleIn) {
					handleIn._x = coords[i++] - x;
					handleIn._y = coords[i++] - y;
				}
				if (handleOut) {
					handleOut._x = coords[i++] - x;
					handleOut._y = coords[i++] - y;
				}
			} else {
				if (!handleIn) {
					coords[i++] = x;
					coords[i++] = y;
				}
				if (!handleOut) {
					coords[i++] = x;
					coords[i++] = y;
				}
			}
		}
		return coords;
	}
});

var SegmentPoint = Point.extend({
	initialize: function SegmentPoint(point, owner, key) {
		var x, y,
			selected;
		if (!point) {
			x = y = 0;
		} else if ((x = point[0]) !== undefined) {
			y = point[1];
		} else {
			var pt = point;
			if ((x = pt.x) === undefined) {
				pt = Point.read(arguments);
				x = pt.x;
			}
			y = pt.y;
			selected = pt.selected;
		}
		this._x = x;
		this._y = y;
		this._owner = owner;
		owner[key] = this;
		if (selected)
			this.setSelected(true);
	},

	_set: function(x, y) {
		this._x = x;
		this._y = y;
		this._owner._changed(this);
		return this;
	},

	getX: function() {
		return this._x;
	},

	setX: function(x) {
		this._x = x;
		this._owner._changed(this);
	},

	getY: function() {
		return this._y;
	},

	setY: function(y) {
		this._y = y;
		this._owner._changed(this);
	},

	isZero: function() {
		var isZero = Numerical.isZero;
		return isZero(this._x) && isZero(this._y);
	},

	isSelected: function() {
		return !!(this._owner._selection & this._getSelection());
	},

	setSelected: function(selected) {
		this._owner._changeSelection(this._getSelection(), selected);
	},

	_getSelection: function() {
		var owner = this._owner;
		return this === owner._point ? 1
			: this === owner._handleIn ? 2
			: this === owner._handleOut ? 4
			: 0;
	}
});

var Curve = Base.extend({
	_class: 'Curve',
	beans: true,

	initialize: function Curve(arg0, arg1, arg2, arg3, arg4, arg5, arg6, arg7) {
		var count = arguments.length,
			seg1, seg2,
			point1, point2,
			handle1, handle2;
		if (count === 3) {
			this._path = arg0;
			seg1 = arg1;
			seg2 = arg2;
		} else if (!count) {
			seg1 = new Segment();
			seg2 = new Segment();
		} else if (count === 1) {
			if ('segment1' in arg0) {
				seg1 = new Segment(arg0.segment1);
				seg2 = new Segment(arg0.segment2);
			} else if ('point1' in arg0) {
				point1 = arg0.point1;
				handle1 = arg0.handle1;
				handle2 = arg0.handle2;
				point2 = arg0.point2;
			} else if (Array.isArray(arg0)) {
				point1 = [arg0[0], arg0[1]];
				point2 = [arg0[6], arg0[7]];
				handle1 = [arg0[2] - arg0[0], arg0[3] - arg0[1]];
				handle2 = [arg0[4] - arg0[6], arg0[5] - arg0[7]];
			}
		} else if (count === 2) {
			seg1 = new Segment(arg0);
			seg2 = new Segment(arg1);
		} else if (count === 4) {
			point1 = arg0;
			handle1 = arg1;
			handle2 = arg2;
			point2 = arg3;
		} else if (count === 8) {
			point1 = [arg0, arg1];
			point2 = [arg6, arg7];
			handle1 = [arg2 - arg0, arg3 - arg1];
			handle2 = [arg4 - arg6, arg5 - arg7];
		}
		this._segment1 = seg1 || new Segment(point1, null, handle1);
		this._segment2 = seg2 || new Segment(point2, handle2, null);
	},

	_serialize: function(options, dictionary) {
		return Base.serialize(this.hasHandles()
				? [this.getPoint1(), this.getHandle1(), this.getHandle2(),
					this.getPoint2()]
				: [this.getPoint1(), this.getPoint2()],
				options, true, dictionary);
	},

	_changed: function() {
		this._length = this._bounds = undefined;
	},

	clone: function() {
		return new Curve(this._segment1, this._segment2);
	},

	toString: function() {
		var parts = [ 'point1: ' + this._segment1._point ];
		if (!this._segment1._handleOut.isZero())
			parts.push('handle1: ' + this._segment1._handleOut);
		if (!this._segment2._handleIn.isZero())
			parts.push('handle2: ' + this._segment2._handleIn);
		parts.push('point2: ' + this._segment2._point);
		return '{ ' + parts.join(', ') + ' }';
	},

	classify: function() {
		return Curve.classify(this.getValues());
	},

	remove: function() {
		var removed = false;
		if (this._path) {
			var segment2 = this._segment2,
				handleOut = segment2._handleOut;
			removed = segment2.remove();
			if (removed)
				this._segment1._handleOut.set(handleOut);
		}
		return removed;
	},

	getPoint1: function() {
		return this._segment1._point;
	},

	setPoint1: function() {
		this._segment1._point.set(Point.read(arguments));
	},

	getPoint2: function() {
		return this._segment2._point;
	},

	setPoint2: function() {
		this._segment2._point.set(Point.read(arguments));
	},

	getHandle1: function() {
		return this._segment1._handleOut;
	},

	setHandle1: function() {
		this._segment1._handleOut.set(Point.read(arguments));
	},

	getHandle2: function() {
		return this._segment2._handleIn;
	},

	setHandle2: function() {
		this._segment2._handleIn.set(Point.read(arguments));
	},

	getSegment1: function() {
		return this._segment1;
	},

	getSegment2: function() {
		return this._segment2;
	},

	getPath: function() {
		return this._path;
	},

	getIndex: function() {
		return this._segment1._index;
	},

	getNext: function() {
		var curves = this._path && this._path._curves;
		return curves && (curves[this._segment1._index + 1]
				|| this._path._closed && curves[0]) || null;
	},

	getPrevious: function() {
		var curves = this._path && this._path._curves;
		return curves && (curves[this._segment1._index - 1]
				|| this._path._closed && curves[curves.length - 1]) || null;
	},

	isFirst: function() {
		return !this._segment1._index;
	},

	isLast: function() {
		var path = this._path;
		return path && this._segment1._index === path._curves.length - 1
				|| false;
	},

	isSelected: function() {
		return this.getPoint1().isSelected()
				&& this.getHandle1().isSelected()
				&& this.getHandle2().isSelected()
				&& this.getPoint2().isSelected();
	},

	setSelected: function(selected) {
		this.getPoint1().setSelected(selected);
		this.getHandle1().setSelected(selected);
		this.getHandle2().setSelected(selected);
		this.getPoint2().setSelected(selected);
	},

	getValues: function(matrix) {
		return Curve.getValues(this._segment1, this._segment2, matrix);
	},

	getPoints: function() {
		var coords = this.getValues(),
			points = [];
		for (var i = 0; i < 8; i += 2)
			points.push(new Point(coords[i], coords[i + 1]));
		return points;
	}
}, {
	getLength: function() {
		if (this._length == null)
			this._length = Curve.getLength(this.getValues(), 0, 1);
		return this._length;
	},

	getArea: function() {
		return Curve.getArea(this.getValues());
	},

	getLine: function() {
		return new Line(this._segment1._point, this._segment2._point);
	},

	getPart: function(from, to) {
		return new Curve(Curve.getPart(this.getValues(), from, to));
	},

	getPartLength: function(from, to) {
		return Curve.getLength(this.getValues(), from, to);
	},

	divideAt: function(location) {
		return this.divideAtTime(location && location.curve === this
				? location.time : this.getTimeAt(location));
	},

	divideAtTime: function(time, _setHandles) {
		var tMin = 1e-8,
			tMax = 1 - tMin,
			res = null;
		if (time >= tMin && time <= tMax) {
			var parts = Curve.subdivide(this.getValues(), time),
				left = parts[0],
				right = parts[1],
				setHandles = _setHandles || this.hasHandles(),
				seg1 = this._segment1,
				seg2 = this._segment2,
				path = this._path;
			if (setHandles) {
				seg1._handleOut._set(left[2] - left[0], left[3] - left[1]);
				seg2._handleIn._set(right[4] - right[6],right[5] - right[7]);
			}
			var x = left[6], y = left[7],
				segment = new Segment(new Point(x, y),
						setHandles && new Point(left[4] - x, left[5] - y),
						setHandles && new Point(right[2] - x, right[3] - y));
			if (path) {
				path.insert(seg1._index + 1, segment);
				res = this.getNext();
			} else {
				this._segment2 = segment;
				this._changed();
				res = new Curve(segment, seg2);
			}
		}
		return res;
	},

	splitAt: function(location) {
		var path = this._path;
		return path ? path.splitAt(location) : null;
	},

	splitAtTime: function(time) {
		return this.splitAt(this.getLocationAtTime(time));
	},

	divide: function(offset, isTime) {
		return this.divideAtTime(offset === undefined ? 0.5 : isTime ? offset
				: this.getTimeAt(offset));
	},

	split: function(offset, isTime) {
		return this.splitAtTime(offset === undefined ? 0.5 : isTime ? offset
				: this.getTimeAt(offset));
	},

	reversed: function() {
		return new Curve(this._segment2.reversed(), this._segment1.reversed());
	},

	clearHandles: function() {
		this._segment1._handleOut._set(0, 0);
		this._segment2._handleIn._set(0, 0);
	},

statics: {
	getValues: function(segment1, segment2, matrix, straight) {
		var p1 = segment1._point,
			h1 = segment1._handleOut,
			h2 = segment2._handleIn,
			p2 = segment2._point,
			x1 = p1.x, y1 = p1.y,
			x2 = p2.x, y2 = p2.y,
			values = straight
				? [ x1, y1, x1, y1, x2, y2, x2, y2 ]
				: [
					x1, y1,
					x1 + h1._x, y1 + h1._y,
					x2 + h2._x, y2 + h2._y,
					x2, y2
				];
		if (matrix)
			matrix._transformCoordinates(values, values, 4);
		return values;
	},

	subdivide: function(v, t) {
		var x0 = v[0], y0 = v[1],
			x1 = v[2], y1 = v[3],
			x2 = v[4], y2 = v[5],
			x3 = v[6], y3 = v[7];
		if (t === undefined)
			t = 0.5;
		var u = 1 - t,
			x4 = u * x0 + t * x1, y4 = u * y0 + t * y1,
			x5 = u * x1 + t * x2, y5 = u * y1 + t * y2,
			x6 = u * x2 + t * x3, y6 = u * y2 + t * y3,
			x7 = u * x4 + t * x5, y7 = u * y4 + t * y5,
			x8 = u * x5 + t * x6, y8 = u * y5 + t * y6,
			x9 = u * x7 + t * x8, y9 = u * y7 + t * y8;
		return [
			[x0, y0, x4, y4, x7, y7, x9, y9],
			[x9, y9, x8, y8, x6, y6, x3, y3]
		];
	},

	getMonoCurves: function(v, dir) {
		var curves = [],
			io = dir ? 0 : 1,
			o0 = v[io + 0],
			o1 = v[io + 2],
			o2 = v[io + 4],
			o3 = v[io + 6];
		if ((o0 >= o1) === (o1 >= o2) && (o1 >= o2) === (o2 >= o3)
				|| Curve.isStraight(v)) {
			curves.push(v);
		} else {
			var a = 3 * (o1 - o2) - o0 + o3,
				b = 2 * (o0 + o2) - 4 * o1,
				c = o1 - o0,
				tMin = 1e-8,
				tMax = 1 - tMin,
				roots = [],
				n = Numerical.solveQuadratic(a, b, c, roots, tMin, tMax);
			if (!n) {
				curves.push(v);
			} else {
				roots.sort();
				var t = roots[0],
					parts = Curve.subdivide(v, t);
				curves.push(parts[0]);
				if (n > 1) {
					t = (roots[1] - t) / (1 - t);
					parts = Curve.subdivide(parts[1], t);
					curves.push(parts[0]);
				}
				curves.push(parts[1]);
			}
		}
		return curves;
	},

	solveCubic: function (v, coord, val, roots, min, max) {
		var v0 = v[coord],
			v1 = v[coord + 2],
			v2 = v[coord + 4],
			v3 = v[coord + 6],
			res = 0;
		if (  !(v0 < val && v3 < val && v1 < val && v2 < val ||
				v0 > val && v3 > val && v1 > val && v2 > val)) {
			var c = 3 * (v1 - v0),
				b = 3 * (v2 - v1) - c,
				a = v3 - v0 - c - b;
			res = Numerical.solveCubic(a, b, c, v0 - val, roots, min, max);
		}
		return res;
	},

	getTimeOf: function(v, point) {
		var p0 = new Point(v[0], v[1]),
			p3 = new Point(v[6], v[7]),
			epsilon = 1e-12,
			geomEpsilon = 1e-7,
			t = point.isClose(p0, epsilon) ? 0
			  : point.isClose(p3, epsilon) ? 1
			  : null;
		if (t === null) {
			var coords = [point.x, point.y],
				roots = [];
			for (var c = 0; c < 2; c++) {
				var count = Curve.solveCubic(v, c, coords[c], roots, 0, 1);
				for (var i = 0; i < count; i++) {
					var u = roots[i];
					if (point.isClose(Curve.getPoint(v, u), geomEpsilon))
						return u;
				}
			}
		}
		return point.isClose(p0, geomEpsilon) ? 0
			 : point.isClose(p3, geomEpsilon) ? 1
			 : null;
	},

	getNearestTime: function(v, point) {
		if (Curve.isStraight(v)) {
			var x0 = v[0], y0 = v[1],
				x3 = v[6], y3 = v[7],
				vx = x3 - x0, vy = y3 - y0,
				det = vx * vx + vy * vy;
			if (det === 0)
				return 0;
			var u = ((point.x - x0) * vx + (point.y - y0) * vy) / det;
			return u < 1e-12 ? 0
				 : u > 0.999999999999 ? 1
				 : Curve.getTimeOf(v,
					new Point(x0 + u * vx, y0 + u * vy));
		}

		var count = 100,
			minDist = Infinity,
			minT = 0;

		function refine(t) {
			if (t >= 0 && t <= 1) {
				var dist = point.getDistance(Curve.getPoint(v, t), true);
				if (dist < minDist) {
					minDist = dist;
					minT = t;
					return true;
				}
			}
		}

		for (var i = 0; i <= count; i++)
			refine(i / count);

		var step = 1 / (count * 2);
		while (step > 1e-8) {
			if (!refine(minT - step) && !refine(minT + step))
				step /= 2;
		}
		return minT;
	},

	getPart: function(v, from, to) {
		var flip = from > to;
		if (flip) {
			var tmp = from;
			from = to;
			to = tmp;
		}
		if (from > 0)
			v = Curve.subdivide(v, from)[1];
		if (to < 1)
			v = Curve.subdivide(v, (to - from) / (1 - from))[0];
		return flip
				? [v[6], v[7], v[4], v[5], v[2], v[3], v[0], v[1]]
				: v;
	},

	isFlatEnough: function(v, flatness) {
		var x0 = v[0], y0 = v[1],
			x1 = v[2], y1 = v[3],
			x2 = v[4], y2 = v[5],
			x3 = v[6], y3 = v[7],
			ux = 3 * x1 - 2 * x0 - x3,
			uy = 3 * y1 - 2 * y0 - y3,
			vx = 3 * x2 - 2 * x3 - x0,
			vy = 3 * y2 - 2 * y3 - y0;
		return Math.max(ux * ux, vx * vx) + Math.max(uy * uy, vy * vy)
				<= 16 * flatness * flatness;
	},

	getArea: function(v) {
		var x0 = v[0], y0 = v[1],
			x1 = v[2], y1 = v[3],
			x2 = v[4], y2 = v[5],
			x3 = v[6], y3 = v[7];
		return 3 * ((y3 - y0) * (x1 + x2) - (x3 - x0) * (y1 + y2)
				+ y1 * (x0 - x2) - x1 * (y0 - y2)
				+ y3 * (x2 + x0 / 3) - x3 * (y2 + y0 / 3)) / 20;
	},

	getBounds: function(v) {
		var min = v.slice(0, 2),
			max = min.slice(),
			roots = [0, 0];
		for (var i = 0; i < 2; i++)
			Curve._addBounds(v[i], v[i + 2], v[i + 4], v[i + 6],
					i, 0, min, max, roots);
		return new Rectangle(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	},

	_addBounds: function(v0, v1, v2, v3, coord, padding, min, max, roots) {
		function add(value, padding) {
			var left = value - padding,
				right = value + padding;
			if (left < min[coord])
				min[coord] = left;
			if (right > max[coord])
				max[coord] = right;
		}

		padding /= 2;
		var minPad = min[coord] + padding,
			maxPad = max[coord] - padding;
		if (    v0 < minPad || v1 < minPad || v2 < minPad || v3 < minPad ||
				v0 > maxPad || v1 > maxPad || v2 > maxPad || v3 > maxPad) {
			if (v1 < v0 != v1 < v3 && v2 < v0 != v2 < v3) {
				add(v0, 0);
				add(v3, 0);
			} else {
				var a = 3 * (v1 - v2) - v0 + v3,
					b = 2 * (v0 + v2) - 4 * v1,
					c = v1 - v0,
					count = Numerical.solveQuadratic(a, b, c, roots),
					tMin = 1e-8,
					tMax = 1 - tMin;
				add(v3, 0);
				for (var i = 0; i < count; i++) {
					var t = roots[i],
						u = 1 - t;
					if (tMin <= t && t <= tMax)
						add(u * u * u * v0
							+ 3 * u * u * t * v1
							+ 3 * u * t * t * v2
							+ t * t * t * v3,
							padding);
				}
			}
		}
	}
}}, Base.each(
	['getBounds', 'getStrokeBounds', 'getHandleBounds'],
	function(name) {
		this[name] = function() {
			if (!this._bounds)
				this._bounds = {};
			var bounds = this._bounds[name];
			if (!bounds) {
				bounds = this._bounds[name] = Path[name](
						[this._segment1, this._segment2], false, this._path);
			}
			return bounds.clone();
		};
	},
{

}), Base.each({
	isStraight: function(p1, h1, h2, p2) {
		if (h1.isZero() && h2.isZero()) {
			return true;
		} else {
			var v = p2.subtract(p1);
			if (v.isZero()) {
				return false;
			} else if (v.isCollinear(h1) && v.isCollinear(h2)) {
				var l = new Line(p1, p2),
					epsilon = 1e-7;
				if (l.getDistance(p1.add(h1)) < epsilon &&
					l.getDistance(p2.add(h2)) < epsilon) {
					var div = v.dot(v),
						s1 = v.dot(h1) / div,
						s2 = v.dot(h2) / div;
					return s1 >= 0 && s1 <= 1 && s2 <= 0 && s2 >= -1;
				}
			}
		}
		return false;
	},

	isLinear: function(p1, h1, h2, p2) {
		var third = p2.subtract(p1).divide(3);
		return h1.equals(third) && h2.negate().equals(third);
	}
}, function(test, name) {
	this[name] = function(epsilon) {
		var seg1 = this._segment1,
			seg2 = this._segment2;
		return test(seg1._point, seg1._handleOut, seg2._handleIn, seg2._point,
				epsilon);
	};

	this.statics[name] = function(v, epsilon) {
		var x0 = v[0], y0 = v[1],
			x3 = v[6], y3 = v[7];
		return test(
				new Point(x0, y0),
				new Point(v[2] - x0, v[3] - y0),
				new Point(v[4] - x3, v[5] - y3),
				new Point(x3, y3), epsilon);
	};
}, {
	statics: {},

	hasHandles: function() {
		return !this._segment1._handleOut.isZero()
				|| !this._segment2._handleIn.isZero();
	},

	hasLength: function(epsilon) {
		return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles())
				&& this.getLength() > (epsilon || 0);
	},

	isCollinear: function(curve) {
		return curve && this.isStraight() && curve.isStraight()
				&& this.getLine().isCollinear(curve.getLine());
	},

	isHorizontal: function() {
		return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y)
				< 1e-8;
	},

	isVertical: function() {
		return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x)
				< 1e-8;
	}
}), {
	beans: false,

	getLocationAt: function(offset, _isTime) {
		return this.getLocationAtTime(
				_isTime ? offset : this.getTimeAt(offset));
	},

	getLocationAtTime: function(t) {
		return t != null && t >= 0 && t <= 1
				? new CurveLocation(this, t)
				: null;
	},

	getTimeAt: function(offset, start) {
		return Curve.getTimeAt(this.getValues(), offset, start);
	},

	getParameterAt: '#getTimeAt',

	getTimesWithTangent: function () {
		var tangent = Point.read(arguments);
		return tangent.isZero()
				? []
				: Curve.getTimesWithTangent(this.getValues(), tangent);
	},

	getOffsetAtTime: function(t) {
		return this.getPartLength(0, t);
	},

	getLocationOf: function() {
		return this.getLocationAtTime(this.getTimeOf(Point.read(arguments)));
	},

	getOffsetOf: function() {
		var loc = this.getLocationOf.apply(this, arguments);
		return loc ? loc.getOffset() : null;
	},

	getTimeOf: function() {
		return Curve.getTimeOf(this.getValues(), Point.read(arguments));
	},

	getParameterOf: '#getTimeOf',

	getNearestLocation: function() {
		var point = Point.read(arguments),
			values = this.getValues(),
			t = Curve.getNearestTime(values, point),
			pt = Curve.getPoint(values, t);
		return new CurveLocation(this, t, pt, null, point.getDistance(pt));
	},

	getNearestPoint: function() {
		var loc = this.getNearestLocation.apply(this, arguments);
		return loc ? loc.getPoint() : loc;
	}

},
new function() {
	var methods = ['getPoint', 'getTangent', 'getNormal', 'getWeightedTangent',
		'getWeightedNormal', 'getCurvature'];
	return Base.each(methods,
		function(name) {
			this[name + 'At'] = function(location, _isTime) {
				var values = this.getValues();
				return Curve[name](values, _isTime ? location
						: Curve.getTimeAt(values, location));
			};

			this[name + 'AtTime'] = function(time) {
				return Curve[name](this.getValues(), time);
			};
		}, {
			statics: {
				_evaluateMethods: methods
			}
		}
	);
},
new function() {

	function getLengthIntegrand(v) {
		var x0 = v[0], y0 = v[1],
			x1 = v[2], y1 = v[3],
			x2 = v[4], y2 = v[5],
			x3 = v[6], y3 = v[7],

			ax = 9 * (x1 - x2) + 3 * (x3 - x0),
			bx = 6 * (x0 + x2) - 12 * x1,
			cx = 3 * (x1 - x0),

			ay = 9 * (y1 - y2) + 3 * (y3 - y0),
			by = 6 * (y0 + y2) - 12 * y1,
			cy = 3 * (y1 - y0);

		return function(t) {
			var dx = (ax * t + bx) * t + cx,
				dy = (ay * t + by) * t + cy;
			return Math.sqrt(dx * dx + dy * dy);
		};
	}

	function getIterations(a, b) {
		return Math.max(2, Math.min(16, Math.ceil(Math.abs(b - a) * 32)));
	}

	function evaluate(v, t, type, normalized) {
		if (t == null || t < 0 || t > 1)
			return null;
		var x0 = v[0], y0 = v[1],
			x1 = v[2], y1 = v[3],
			x2 = v[4], y2 = v[5],
			x3 = v[6], y3 = v[7],
			isZero = Numerical.isZero;
		if (isZero(x1 - x0) && isZero(y1 - y0)) {
			x1 = x0;
			y1 = y0;
		}
		if (isZero(x2 - x3) && isZero(y2 - y3)) {
			x2 = x3;
			y2 = y3;
		}
		var cx = 3 * (x1 - x0),
			bx = 3 * (x2 - x1) - cx,
			ax = x3 - x0 - cx - bx,
			cy = 3 * (y1 - y0),
			by = 3 * (y2 - y1) - cy,
			ay = y3 - y0 - cy - by,
			x, y;
		if (type === 0) {
			x = t === 0 ? x0 : t === 1 ? x3
					: ((ax * t + bx) * t + cx) * t + x0;
			y = t === 0 ? y0 : t === 1 ? y3
					: ((ay * t + by) * t + cy) * t + y0;
		} else {
			var tMin = 1e-8,
				tMax = 1 - tMin;
			if (t < tMin) {
				x = cx;
				y = cy;
			} else if (t > tMax) {
				x = 3 * (x3 - x2);
				y = 3 * (y3 - y2);
			} else {
				x = (3 * ax * t + 2 * bx) * t + cx;
				y = (3 * ay * t + 2 * by) * t + cy;
			}
			if (normalized) {
				if (x === 0 && y === 0 && (t < tMin || t > tMax)) {
					x = x2 - x1;
					y = y2 - y1;
				}
				var len = Math.sqrt(x * x + y * y);
				if (len) {
					x /= len;
					y /= len;
				}
			}
			if (type === 3) {
				var x2 = 6 * ax * t + 2 * bx,
					y2 = 6 * ay * t + 2 * by,
					d = Math.pow(x * x + y * y, 3 / 2);
				x = d !== 0 ? (x * y2 - y * x2) / d : 0;
				y = 0;
			}
		}
		return type === 2 ? new Point(y, -x) : new Point(x, y);
	}

	return { statics: {

		classify: function(v) {

			var x0 = v[0], y0 = v[1],
				x1 = v[2], y1 = v[3],
				x2 = v[4], y2 = v[5],
				x3 = v[6], y3 = v[7],
				a1 = x0 * (y3 - y2) + y0 * (x2 - x3) + x3 * y2 - y3 * x2,
				a2 = x1 * (y0 - y3) + y1 * (x3 - x0) + x0 * y3 - y0 * x3,
				a3 = x2 * (y1 - y0) + y2 * (x0 - x1) + x1 * y0 - y1 * x0,
				d3 = 3 * a3,
				d2 = d3 - a2,
				d1 = d2 - a2 + a1,
				l = Math.sqrt(d1 * d1 + d2 * d2 + d3 * d3),
				s = l !== 0 ? 1 / l : 0,
				isZero = Numerical.isZero,
				serpentine = 'serpentine';
			d1 *= s;
			d2 *= s;
			d3 *= s;

			function type(type, t1, t2) {
				var hasRoots = t1 !== undefined,
					t1Ok = hasRoots && t1 > 0 && t1 < 1,
					t2Ok = hasRoots && t2 > 0 && t2 < 1;
				if (hasRoots && (!(t1Ok || t2Ok)
						|| type === 'loop' && !(t1Ok && t2Ok))) {
					type = 'arch';
					t1Ok = t2Ok = false;
				}
				return {
					type: type,
					roots: t1Ok || t2Ok
							? t1Ok && t2Ok
								? t1 < t2 ? [t1, t2] : [t2, t1]
								: [t1Ok ? t1 : t2]
							: null
				};
			}

			if (isZero(d1)) {
				return isZero(d2)
						? type(isZero(d3) ? 'line' : 'quadratic')
						: type(serpentine, d3 / (3 * d2));
			}
			var d = 3 * d2 * d2 - 4 * d1 * d3;
			if (isZero(d)) {
				return type('cusp', d2 / (2 * d1));
			}
			var f1 = d > 0 ? Math.sqrt(d / 3) : Math.sqrt(-d),
				f2 = 2 * d1;
			return type(d > 0 ? serpentine : 'loop',
					(d2 + f1) / f2,
					(d2 - f1) / f2);
		},

		getLength: function(v, a, b, ds) {
			if (a === undefined)
				a = 0;
			if (b === undefined)
				b = 1;
			if (Curve.isStraight(v)) {
				var c = v;
				if (b < 1) {
					c = Curve.subdivide(c, b)[0];
					a /= b;
				}
				if (a > 0) {
					c = Curve.subdivide(c, a)[1];
				}
				var dx = c[6] - c[0],
					dy = c[7] - c[1];
				return Math.sqrt(dx * dx + dy * dy);
			}
			return Numerical.integrate(ds || getLengthIntegrand(v), a, b,
					getIterations(a, b));
		},

		getTimeAt: function(v, offset, start) {
			if (start === undefined)
				start = offset < 0 ? 1 : 0;
			if (offset === 0)
				return start;
			var abs = Math.abs,
				epsilon = 1e-12,
				forward = offset > 0,
				a = forward ? start : 0,
				b = forward ? 1 : start,
				ds = getLengthIntegrand(v),
				rangeLength = Curve.getLength(v, a, b, ds),
				diff = abs(offset) - rangeLength;
			if (abs(diff) < epsilon) {
				return forward ? b : a;
			} else if (diff > epsilon) {
				return null;
			}
			var guess = offset / rangeLength,
				length = 0;
			function f(t) {
				length += Numerical.integrate(ds, start, t,
						getIterations(start, t));
				start = t;
				return length - offset;
			}
			return Numerical.findRoot(f, ds, start + guess, a, b, 32,
					1e-12);
		},

		getPoint: function(v, t) {
			return evaluate(v, t, 0, false);
		},

		getTangent: function(v, t) {
			return evaluate(v, t, 1, true);
		},

		getWeightedTangent: function(v, t) {
			return evaluate(v, t, 1, false);
		},

		getNormal: function(v, t) {
			return evaluate(v, t, 2, true);
		},

		getWeightedNormal: function(v, t) {
			return evaluate(v, t, 2, false);
		},

		getCurvature: function(v, t) {
			return evaluate(v, t, 3, false).x;
		},

		getPeaks: function(v) {
			var x0 = v[0], y0 = v[1],
				x1 = v[2], y1 = v[3],
				x2 = v[4], y2 = v[5],
				x3 = v[6], y3 = v[7],
				ax =     -x0 + 3 * x1 - 3 * x2 + x3,
				bx =  3 * x0 - 6 * x1 + 3 * x2,
				cx = -3 * x0 + 3 * x1,
				ay =     -y0 + 3 * y1 - 3 * y2 + y3,
				by =  3 * y0 - 6 * y1 + 3 * y2,
				cy = -3 * y0 + 3 * y1,
				tMin = 1e-8,
				tMax = 1 - tMin,
				roots = [];
			Numerical.solveCubic(
					9 * (ax * ax + ay * ay),
					9 * (ax * bx + by * ay),
					2 * (bx * bx + by * by) + 3 * (cx * ax + cy * ay),
					(cx * bx + by * cy),
					roots, tMin, tMax);
			return roots.sort();
		}
	}};
},
new function() {

	function addLocation(locations, include, c1, t1, c2, t2, overlap) {
		var excludeStart = !overlap && c1.getPrevious() === c2,
			excludeEnd = !overlap && c1 !== c2 && c1.getNext() === c2,
			tMin = 1e-8,
			tMax = 1 - tMin;
		if (t1 !== null && t1 >= (excludeStart ? tMin : 0) &&
			t1 <= (excludeEnd ? tMax : 1)) {
			if (t2 !== null && t2 >= (excludeEnd ? tMin : 0) &&
				t2 <= (excludeStart ? tMax : 1)) {
				var loc1 = new CurveLocation(c1, t1, null, overlap),
					loc2 = new CurveLocation(c2, t2, null, overlap);
				loc1._intersection = loc2;
				loc2._intersection = loc1;
				if (!include || include(loc1)) {
					CurveLocation.insert(locations, loc1, true);
				}
			}
		}
	}

	function addCurveIntersections(v1, v2, c1, c2, locations, include, flip,
			recursion, calls, tMin, tMax, uMin, uMax) {
		if (++calls >= 4096 || ++recursion >= 40)
			return calls;
		var fatLineEpsilon = 1e-9,
			q0x = v2[0], q0y = v2[1], q3x = v2[6], q3y = v2[7],
			getSignedDistance = Line.getSignedDistance,
			d1 = getSignedDistance(q0x, q0y, q3x, q3y, v2[2], v2[3]),
			d2 = getSignedDistance(q0x, q0y, q3x, q3y, v2[4], v2[5]),
			factor = d1 * d2 > 0 ? 3 / 4 : 4 / 9,
			dMin = factor * Math.min(0, d1, d2),
			dMax = factor * Math.max(0, d1, d2),
			dp0 = getSignedDistance(q0x, q0y, q3x, q3y, v1[0], v1[1]),
			dp1 = getSignedDistance(q0x, q0y, q3x, q3y, v1[2], v1[3]),
			dp2 = getSignedDistance(q0x, q0y, q3x, q3y, v1[4], v1[5]),
			dp3 = getSignedDistance(q0x, q0y, q3x, q3y, v1[6], v1[7]),
			hull = getConvexHull(dp0, dp1, dp2, dp3),
			top = hull[0],
			bottom = hull[1],
			tMinClip,
			tMaxClip;
		if (d1 === 0 && d2 === 0
				&& dp0 === 0 && dp1 === 0 && dp2 === 0 && dp3 === 0
			|| (tMinClip = clipConvexHull(top, bottom, dMin, dMax)) == null
			|| (tMaxClip = clipConvexHull(top.reverse(), bottom.reverse(),
				dMin, dMax)) == null)
			return calls;
		var tMinNew = tMin + (tMax - tMin) * tMinClip,
			tMaxNew = tMin + (tMax - tMin) * tMaxClip;
		if (Math.max(uMax - uMin, tMaxNew - tMinNew) < fatLineEpsilon) {
			var t = (tMinNew + tMaxNew) / 2,
				u = (uMin + uMax) / 2;
			addLocation(locations, include,
					flip ? c2 : c1, flip ? u : t,
					flip ? c1 : c2, flip ? t : u);
		} else {
			v1 = Curve.getPart(v1, tMinClip, tMaxClip);
			var uDiff = uMax - uMin;
			if (tMaxClip - tMinClip > 0.8) {
				if (tMaxNew - tMinNew > uDiff) {
					var parts = Curve.subdivide(v1, 0.5),
						t = (tMinNew + tMaxNew) / 2;
					calls = addCurveIntersections(
							v2, parts[0], c2, c1, locations, include, !flip,
							recursion, calls, uMin, uMax, tMinNew, t);
					calls = addCurveIntersections(
							v2, parts[1], c2, c1, locations, include, !flip,
							recursion, calls, uMin, uMax, t, tMaxNew);
				} else {
					var parts = Curve.subdivide(v2, 0.5),
						u = (uMin + uMax) / 2;
					calls = addCurveIntersections(
							parts[0], v1, c2, c1, locations, include, !flip,
							recursion, calls, uMin, u, tMinNew, tMaxNew);
					calls = addCurveIntersections(
							parts[1], v1, c2, c1, locations, include, !flip,
							recursion, calls, u, uMax, tMinNew, tMaxNew);
				}
			} else {
				if (uDiff === 0 || uDiff >= fatLineEpsilon) {
					calls = addCurveIntersections(
							v2, v1, c2, c1, locations, include, !flip,
							recursion, calls, uMin, uMax, tMinNew, tMaxNew);
				} else {
					calls = addCurveIntersections(
							v1, v2, c1, c2, locations, include, flip,
							recursion, calls, tMinNew, tMaxNew, uMin, uMax);
				}
			}
		}
		return calls;
	}

	function getConvexHull(dq0, dq1, dq2, dq3) {
		var p0 = [ 0, dq0 ],
			p1 = [ 1 / 3, dq1 ],
			p2 = [ 2 / 3, dq2 ],
			p3 = [ 1, dq3 ],
			dist1 = dq1 - (2 * dq0 + dq3) / 3,
			dist2 = dq2 - (dq0 + 2 * dq3) / 3,
			hull;
		if (dist1 * dist2 < 0) {
			hull = [[p0, p1, p3], [p0, p2, p3]];
		} else {
			var distRatio = dist1 / dist2;
			hull = [
				distRatio >= 2 ? [p0, p1, p3]
				: distRatio <= 0.5 ? [p0, p2, p3]
				: [p0, p1, p2, p3],
				[p0, p3]
			];
		}
		return (dist1 || dist2) < 0 ? hull.reverse() : hull;
	}

	function clipConvexHull(hullTop, hullBottom, dMin, dMax) {
		if (hullTop[0][1] < dMin) {
			return clipConvexHullPart(hullTop, true, dMin);
		} else if (hullBottom[0][1] > dMax) {
			return clipConvexHullPart(hullBottom, false, dMax);
		} else {
			return hullTop[0][0];
		}
	}

	function clipConvexHullPart(part, top, threshold) {
		var px = part[0][0],
			py = part[0][1];
		for (var i = 1, l = part.length; i < l; i++) {
			var qx = part[i][0],
				qy = part[i][1];
			if (top ? qy >= threshold : qy <= threshold) {
				return qy === threshold ? qx
						: px + (threshold - py) * (qx - px) / (qy - py);
			}
			px = qx;
			py = qy;
		}
		return null;
	}

	function getCurveLineIntersections(v, px, py, vx, vy) {
		var isZero = Numerical.isZero;
		if (isZero(vx) && isZero(vy)) {
			var t = Curve.getTimeOf(v, new Point(px, py));
			return t === null ? [] : [t];
		}
		var angle = Math.atan2(-vy, vx),
			sin = Math.sin(angle),
			cos = Math.cos(angle),
			rv = [],
			roots = [];
		for (var i = 0; i < 8; i += 2) {
			var x = v[i] - px,
				y = v[i + 1] - py;
			rv.push(
				x * cos - y * sin,
				x * sin + y * cos);
		}
		Curve.solveCubic(rv, 1, 0, roots, 0, 1);
		return roots;
	}

	function addCurveLineIntersections(v1, v2, c1, c2, locations, include,
			flip) {
		var x1 = v2[0], y1 = v2[1],
			x2 = v2[6], y2 = v2[7],
			roots = getCurveLineIntersections(v1, x1, y1, x2 - x1, y2 - y1);
		for (var i = 0, l = roots.length; i < l; i++) {
			var t1 = roots[i],
				p1 = Curve.getPoint(v1, t1),
				t2 = Curve.getTimeOf(v2, p1);
			if (t2 !== null) {
				addLocation(locations, include,
						flip ? c2 : c1, flip ? t2 : t1,
						flip ? c1 : c2, flip ? t1 : t2);
			}
		}
	}

	function addLineIntersection(v1, v2, c1, c2, locations, include) {
		var pt = Line.intersect(
				v1[0], v1[1], v1[6], v1[7],
				v2[0], v2[1], v2[6], v2[7]);
		if (pt) {
			addLocation(locations, include,
					c1, Curve.getTimeOf(v1, pt),
					c2, Curve.getTimeOf(v2, pt));
		}
	}

	function getCurveIntersections(v1, v2, c1, c2, locations, include) {
		var epsilon = 1e-12,
			min = Math.min,
			max = Math.max;

		if (max(v1[0], v1[2], v1[4], v1[6]) + epsilon >
			min(v2[0], v2[2], v2[4], v2[6]) &&
			min(v1[0], v1[2], v1[4], v1[6]) - epsilon <
			max(v2[0], v2[2], v2[4], v2[6]) &&
			max(v1[1], v1[3], v1[5], v1[7]) + epsilon >
			min(v2[1], v2[3], v2[5], v2[7]) &&
			min(v1[1], v1[3], v1[5], v1[7]) - epsilon <
			max(v2[1], v2[3], v2[5], v2[7])) {
			var overlaps = getOverlaps(v1, v2);
			if (overlaps) {
				for (var i = 0; i < 2; i++) {
					var overlap = overlaps[i];
					addLocation(locations, include,
							c1, overlap[0],
							c2, overlap[1], true);
				}
			} else {
				var straight1 = Curve.isStraight(v1),
					straight2 = Curve.isStraight(v2),
					straight = straight1 && straight2,
					flip = straight1 && !straight2,
					before = locations.length;
				(straight
					? addLineIntersection
					: straight1 || straight2
						? addCurveLineIntersections
						: addCurveIntersections)(
							flip ? v2 : v1, flip ? v1 : v2,
							flip ? c2 : c1, flip ? c1 : c2,
							locations, include, flip,
							0, 0, 0, 1, 0, 1);
				if (!straight || locations.length === before) {
					for (var i = 0; i < 4; i++) {
						var t1 = i >> 1,
							t2 = i & 1,
							i1 = t1 * 6,
							i2 = t2 * 6,
							p1 = new Point(v1[i1], v1[i1 + 1]),
							p2 = new Point(v2[i2], v2[i2 + 1]);
						if (p1.isClose(p2, epsilon)) {
							addLocation(locations, include,
									c1, t1,
									c2, t2);
						}
					}
				}
			}
		}
		return locations;
	}

	function getSelfIntersection(v1, c1, locations, include) {
		var info = Curve.classify(v1);
		if (info.type === 'loop') {
			var roots = info.roots;
			addLocation(locations, include,
					c1, roots[0],
					c1, roots[1]);
		}
	  return locations;
	}

	function getIntersections(curves1, curves2, include, matrix1, matrix2,
			_returnFirst) {
		var epsilon = 1e-7,
			self = !curves2;
		if (self)
			curves2 = curves1;
		var length1 = curves1.length,
			length2 = curves2.length,
			values1 = new Array(length1),
			values2 = self ? values1 : new Array(length2),
			locations = [];

		for (var i = 0; i < length1; i++) {
			values1[i] = curves1[i].getValues(matrix1);
		}
		if (!self) {
			for (var i = 0; i < length2; i++) {
				values2[i] = curves2[i].getValues(matrix2);
			}
		}
		var boundsCollisions = CollisionDetection.findCurveBoundsCollisions(
				values1, values2, epsilon);
		for (var index1 = 0; index1 < length1; index1++) {
			var curve1 = curves1[index1],
				v1 = values1[index1];
			if (self) {
				getSelfIntersection(v1, curve1, locations, include);
			}
			var collisions1 = boundsCollisions[index1];
			if (collisions1) {
				for (var j = 0; j < collisions1.length; j++) {
					if (_returnFirst && locations.length)
						return locations;
					var index2 = collisions1[j];
					if (!self || index2 > index1) {
						var curve2 = curves2[index2],
							v2 = values2[index2];
						getCurveIntersections(
								v1, v2, curve1, curve2, locations, include);
					}
				}
			}
		}
		return locations;
	}

	function getOverlaps(v1, v2) {

		function getSquaredLineLength(v) {
			var x = v[6] - v[0],
				y = v[7] - v[1];
			return x * x + y * y;
		}

		var abs = Math.abs,
			getDistance = Line.getDistance,
			timeEpsilon = 1e-8,
			geomEpsilon = 1e-7,
			straight1 = Curve.isStraight(v1),
			straight2 = Curve.isStraight(v2),
			straightBoth = straight1 && straight2,
			flip = getSquaredLineLength(v1) < getSquaredLineLength(v2),
			l1 = flip ? v2 : v1,
			l2 = flip ? v1 : v2,
			px = l1[0], py = l1[1],
			vx = l1[6] - px, vy = l1[7] - py;
		if (getDistance(px, py, vx, vy, l2[0], l2[1], true) < geomEpsilon &&
			getDistance(px, py, vx, vy, l2[6], l2[7], true) < geomEpsilon) {
			if (!straightBoth &&
				getDistance(px, py, vx, vy, l1[2], l1[3], true) < geomEpsilon &&
				getDistance(px, py, vx, vy, l1[4], l1[5], true) < geomEpsilon &&
				getDistance(px, py, vx, vy, l2[2], l2[3], true) < geomEpsilon &&
				getDistance(px, py, vx, vy, l2[4], l2[5], true) < geomEpsilon) {
				straight1 = straight2 = straightBoth = true;
			}
		} else if (straightBoth) {
			return null;
		}
		if (straight1 ^ straight2) {
			return null;
		}

		var v = [v1, v2],
			pairs = [];
		for (var i = 0; i < 4 && pairs.length < 2; i++) {
			var i1 = i & 1,
				i2 = i1 ^ 1,
				t1 = i >> 1,
				t2 = Curve.getTimeOf(v[i1], new Point(
					v[i2][t1 ? 6 : 0],
					v[i2][t1 ? 7 : 1]));
			if (t2 != null) {
				var pair = i1 ? [t1, t2] : [t2, t1];
				if (!pairs.length ||
					abs(pair[0] - pairs[0][0]) > timeEpsilon &&
					abs(pair[1] - pairs[0][1]) > timeEpsilon) {
					pairs.push(pair);
				}
			}
			if (i > 2 && !pairs.length)
				break;
		}
		if (pairs.length !== 2) {
			pairs = null;
		} else if (!straightBoth) {
			var o1 = Curve.getPart(v1, pairs[0][0], pairs[1][0]),
				o2 = Curve.getPart(v2, pairs[0][1], pairs[1][1]);
			if (abs(o2[2] - o1[2]) > geomEpsilon ||
				abs(o2[3] - o1[3]) > geomEpsilon ||
				abs(o2[4] - o1[4]) > geomEpsilon ||
				abs(o2[5] - o1[5]) > geomEpsilon)
				pairs = null;
		}
		return pairs;
	}

	function getTimesWithTangent(v, tangent) {
		var x0 = v[0], y0 = v[1],
			x1 = v[2], y1 = v[3],
			x2 = v[4], y2 = v[5],
			x3 = v[6], y3 = v[7],
			normalized = tangent.normalize(),
			tx = normalized.x,
			ty = normalized.y,
			ax = 3 * x3 - 9 * x2 + 9 * x1 - 3 * x0,
			ay = 3 * y3 - 9 * y2 + 9 * y1 - 3 * y0,
			bx = 6 * x2 - 12 * x1 + 6 * x0,
			by = 6 * y2 - 12 * y1 + 6 * y0,
			cx = 3 * x1 - 3 * x0,
			cy = 3 * y1 - 3 * y0,
			den = 2 * ax * ty - 2 * ay * tx,
			times = [];
		if (Math.abs(den) < Numerical.CURVETIME_EPSILON) {
			var num = ax * cy - ay * cx,
				den = ax * by - ay * bx;
			if (den != 0) {
				var t = -num / den;
				if (t >= 0 && t <= 1) times.push(t);
			}
		} else {
			var delta = (bx * bx - 4 * ax * cx) * ty * ty +
				(-2 * bx * by + 4 * ay * cx + 4 * ax * cy) * tx * ty +
				(by * by - 4 * ay * cy) * tx * tx,
				k = bx * ty - by * tx;
			if (delta >= 0 && den != 0) {
				var d = Math.sqrt(delta),
					t0 = -(k + d) / den,
					t1 = (-k + d) / den;
				if (t0 >= 0 && t0 <= 1) times.push(t0);
				if (t1 >= 0 && t1 <= 1) times.push(t1);
			}
		}
		return times;
	}

	return {
		getIntersections: function(curve) {
			var v1 = this.getValues(),
				v2 = curve && curve !== this && curve.getValues();
			return v2 ? getCurveIntersections(v1, v2, this, curve, [])
					  : getSelfIntersection(v1, this, []);
		},

		statics: {
			getOverlaps: getOverlaps,
			getIntersections: getIntersections,
			getCurveLineIntersections: getCurveLineIntersections,
			getTimesWithTangent: getTimesWithTangent
		}
	};
});

var CurveLocation = Base.extend({
	_class: 'CurveLocation',

	initialize: function CurveLocation(curve, time, point, _overlap, _distance) {
		if (time >= 0.99999999) {
			var next = curve.getNext();
			if (next) {
				time = 0;
				curve = next;
			}
		}
		this._setCurve(curve);
		this._time = time;
		this._point = point || curve.getPointAtTime(time);
		this._overlap = _overlap;
		this._distance = _distance;
		this._intersection = this._next = this._previous = null;
	},

	_setPath: function(path) {
		this._path = path;
		this._version = path ? path._version : 0;
	},

	_setCurve: function(curve) {
		this._setPath(curve._path);
		this._curve = curve;
		this._segment = null;
		this._segment1 = curve._segment1;
		this._segment2 = curve._segment2;
	},

	_setSegment: function(segment) {
		var curve = segment.getCurve();
		if (curve) {
			this._setCurve(curve);
		} else {
			this._setPath(segment._path);
			this._segment1 = segment;
			this._segment2 = null;
		}
		this._segment = segment;
		this._time = segment === this._segment1 ? 0 : 1;
		this._point = segment._point.clone();
	},

	getSegment: function() {
		var segment = this._segment;
		if (!segment) {
			var curve = this.getCurve(),
				time = this.getTime();
			if (time === 0) {
				segment = curve._segment1;
			} else if (time === 1) {
				segment = curve._segment2;
			} else if (time != null) {
				segment = curve.getPartLength(0, time)
					< curve.getPartLength(time, 1)
						? curve._segment1
						: curve._segment2;
			}
			this._segment = segment;
		}
		return segment;
	},

	getCurve: function() {
		var path = this._path,
			that = this;
		if (path && path._version !== this._version) {
			this._time = this._offset = this._curveOffset = this._curve = null;
		}

		function trySegment(segment) {
			var curve = segment && segment.getCurve();
			if (curve && (that._time = curve.getTimeOf(that._point)) != null) {
				that._setCurve(curve);
				return curve;
			}
		}

		return this._curve
			|| trySegment(this._segment)
			|| trySegment(this._segment1)
			|| trySegment(this._segment2.getPrevious());
	},

	getPath: function() {
		var curve = this.getCurve();
		return curve && curve._path;
	},

	getIndex: function() {
		var curve = this.getCurve();
		return curve && curve.getIndex();
	},

	getTime: function() {
		var curve = this.getCurve(),
			time = this._time;
		return curve && time == null
			? this._time = curve.getTimeOf(this._point)
			: time;
	},

	getParameter: '#getTime',

	getPoint: function() {
		return this._point;
	},

	getOffset: function() {
		var offset = this._offset;
		if (offset == null) {
			offset = 0;
			var path = this.getPath(),
				index = this.getIndex();
			if (path && index != null) {
				var curves = path.getCurves();
				for (var i = 0; i < index; i++)
					offset += curves[i].getLength();
			}
			this._offset = offset += this.getCurveOffset();
		}
		return offset;
	},

	getCurveOffset: function() {
		var offset = this._curveOffset;
		if (offset == null) {
			var curve = this.getCurve(),
				time = this.getTime();
			this._curveOffset = offset = time != null && curve
					&& curve.getPartLength(0, time);
		}
		return offset;
	},

	getIntersection: function() {
		return this._intersection;
	},

	getDistance: function() {
		return this._distance;
	},

	divide: function() {
		var curve = this.getCurve(),
			res = curve && curve.divideAtTime(this.getTime());
		if (res) {
			this._setSegment(res._segment1);
		}
		return res;
	},

	split: function() {
		var curve = this.getCurve(),
			path = curve._path,
			res = curve && curve.splitAtTime(this.getTime());
		if (res) {
			this._setSegment(path.getLastSegment());
		}
		return  res;
	},

	equals: function(loc, _ignoreOther) {
		var res = this === loc;
		if (!res && loc instanceof CurveLocation) {
			var c1 = this.getCurve(),
				c2 = loc.getCurve(),
				p1 = c1._path,
				p2 = c2._path;
			if (p1 === p2) {
				var abs = Math.abs,
					epsilon = 1e-7,
					diff = abs(this.getOffset() - loc.getOffset()),
					i1 = !_ignoreOther && this._intersection,
					i2 = !_ignoreOther && loc._intersection;
				res = (diff < epsilon
						|| p1 && abs(p1.getLength() - diff) < epsilon)
					&& (!i1 && !i2 || i1 && i2 && i1.equals(i2, true));
			}
		}
		return res;
	},

	toString: function() {
		var parts = [],
			point = this.getPoint(),
			f = Formatter.instance;
		if (point)
			parts.push('point: ' + point);
		var index = this.getIndex();
		if (index != null)
			parts.push('index: ' + index);
		var time = this.getTime();
		if (time != null)
			parts.push('time: ' + f.number(time));
		if (this._distance != null)
			parts.push('distance: ' + f.number(this._distance));
		return '{ ' + parts.join(', ') + ' }';
	},

	isTouching: function() {
		var inter = this._intersection;
		if (inter && this.getTangent().isCollinear(inter.getTangent())) {
			var curve1 = this.getCurve(),
				curve2 = inter.getCurve();
			return !(curve1.isStraight() && curve2.isStraight()
					&& curve1.getLine().intersect(curve2.getLine()));
		}
		return false;
	},

	isCrossing: function() {
		var inter = this._intersection;
		if (!inter)
			return false;
		var t1 = this.getTime(),
			t2 = inter.getTime(),
			tMin = 1e-8,
			tMax = 1 - tMin,
			t1Inside = t1 >= tMin && t1 <= tMax,
			t2Inside = t2 >= tMin && t2 <= tMax;
		if (t1Inside && t2Inside)
			return !this.isTouching();
		var c2 = this.getCurve(),
			c1 = c2 && t1 < tMin ? c2.getPrevious() : c2,
			c4 = inter.getCurve(),
			c3 = c4 && t2 < tMin ? c4.getPrevious() : c4;
		if (t1 > tMax)
			c2 = c2.getNext();
		if (t2 > tMax)
			c4 = c4.getNext();
		if (!c1 || !c2 || !c3 || !c4)
			return false;

		var offsets = [];

		function addOffsets(curve, end) {
			var v = curve.getValues(),
				roots = Curve.classify(v).roots || Curve.getPeaks(v),
				count = roots.length,
				offset = Curve.getLength(v,
					end && count ? roots[count - 1] : 0,
					!end && count ? roots[0] : 1);
			offsets.push(count ? offset : offset / 32);
		}

		function isInRange(angle, min, max) {
			return min < max
					? angle > min && angle < max
					: angle > min || angle < max;
		}

		if (!t1Inside) {
			addOffsets(c1, true);
			addOffsets(c2, false);
		}
		if (!t2Inside) {
			addOffsets(c3, true);
			addOffsets(c4, false);
		}
		var pt = this.getPoint(),
			offset = Math.min.apply(Math, offsets),
			v2 = t1Inside ? c2.getTangentAtTime(t1)
					: c2.getPointAt(offset).subtract(pt),
			v1 = t1Inside ? v2.negate()
					: c1.getPointAt(-offset).subtract(pt),
			v4 = t2Inside ? c4.getTangentAtTime(t2)
					: c4.getPointAt(offset).subtract(pt),
			v3 = t2Inside ? v4.negate()
					: c3.getPointAt(-offset).subtract(pt),
			a1 = v1.getAngle(),
			a2 = v2.getAngle(),
			a3 = v3.getAngle(),
			a4 = v4.getAngle();
		return !!(t1Inside
				? (isInRange(a1, a3, a4) ^ isInRange(a2, a3, a4)) &&
				  (isInRange(a1, a4, a3) ^ isInRange(a2, a4, a3))
				: (isInRange(a3, a1, a2) ^ isInRange(a4, a1, a2)) &&
				  (isInRange(a3, a2, a1) ^ isInRange(a4, a2, a1)));
	},

	hasOverlap: function() {
		return !!this._overlap;
	}
}, Base.each(Curve._evaluateMethods, function(name) {
	var get = name + 'At';
	this[name] = function() {
		var curve = this.getCurve(),
			time = this.getTime();
		return time != null && curve && curve[get](time, true);
	};
}, {
	preserve: true
}),
new function() {

	function insert(locations, loc, merge) {
		var length = locations.length,
			l = 0,
			r = length - 1;

		function search(index, dir) {
			for (var i = index + dir; i >= -1 && i <= length; i += dir) {
				var loc2 = locations[((i % length) + length) % length];
				if (!loc.getPoint().isClose(loc2.getPoint(),
						1e-7))
					break;
				if (loc.equals(loc2))
					return loc2;
			}
			return null;
		}

		while (l <= r) {
			var m = (l + r) >>> 1,
				loc2 = locations[m],
				found;
			if (merge && (found = loc.equals(loc2) ? loc2
					: (search(m, -1) || search(m, 1)))) {
				if (loc._overlap) {
					found._overlap = found._intersection._overlap = true;
				}
				return found;
			}
		var path1 = loc.getPath(),
			path2 = loc2.getPath(),
			diff = path1 !== path2
				? path1._id - path2._id
				: (loc.getIndex() + loc.getTime())
				- (loc2.getIndex() + loc2.getTime());
			if (diff < 0) {
				r = m - 1;
			} else {
				l = m + 1;
			}
		}
		locations.splice(l, 0, loc);
		return loc;
	}

	return { statics: {
		insert: insert,

		expand: function(locations) {
			var expanded = locations.slice();
			for (var i = locations.length - 1; i >= 0; i--) {
				insert(expanded, locations[i]._intersection, false);
			}
			return expanded;
		}
	}};
});

var PathItem = Item.extend({
	_class: 'PathItem',
	_selectBounds: false,
	_canScaleStroke: true,
	beans: true,

	initialize: function PathItem() {
	},

	statics: {
		create: function(arg) {
			var data,
				segments,
				compound;
			if (Base.isPlainObject(arg)) {
				segments = arg.segments;
				data = arg.pathData;
			} else if (Array.isArray(arg)) {
				segments = arg;
			} else if (typeof arg === 'string') {
				data = arg;
			}
			if (segments) {
				var first = segments[0];
				compound = first && Array.isArray(first[0]);
			} else if (data) {
				compound = (data.match(/m/gi) || []).length > 1
						|| /z\s*\S+/i.test(data);
			}
			var ctor = compound ? CompoundPath : Path;
			return new ctor(arg);
		}
	},

	_asPathItem: function() {
		return this;
	},

	isClockwise: function() {
		return this.getArea() >= 0;
	},

	setClockwise: function(clockwise) {
		if (this.isClockwise() != (clockwise = !!clockwise))
			this.reverse();
	},

	setPathData: function(data) {

		var parts = data && data.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig),
			coords,
			relative = false,
			previous,
			control,
			current = new Point(),
			start = new Point();

		function getCoord(index, coord) {
			var val = +coords[index];
			if (relative)
				val += current[coord];
			return val;
		}

		function getPoint(index) {
			return new Point(
				getCoord(index, 'x'),
				getCoord(index + 1, 'y')
			);
		}

		this.clear();

		for (var i = 0, l = parts && parts.length; i < l; i++) {
			var part = parts[i],
				command = part[0],
				lower = command.toLowerCase();
			coords = part.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
			var length = coords && coords.length;
			relative = command === lower;
			if (previous === 'z' && !/[mz]/.test(lower))
				this.moveTo(current);
			switch (lower) {
			case 'm':
			case 'l':
				var move = lower === 'm';
				for (var j = 0; j < length; j += 2) {
					this[move ? 'moveTo' : 'lineTo'](current = getPoint(j));
					if (move) {
						start = current;
						move = false;
					}
				}
				control = current;
				break;
			case 'h':
			case 'v':
				var coord = lower === 'h' ? 'x' : 'y';
				current = current.clone();
				for (var j = 0; j < length; j++) {
					current[coord] = getCoord(j, coord);
					this.lineTo(current);
				}
				control = current;
				break;
			case 'c':
				for (var j = 0; j < length; j += 6) {
					this.cubicCurveTo(
							getPoint(j),
							control = getPoint(j + 2),
							current = getPoint(j + 4));
				}
				break;
			case 's':
				for (var j = 0; j < length; j += 4) {
					this.cubicCurveTo(
							/[cs]/.test(previous)
									? current.multiply(2).subtract(control)
									: current,
							control = getPoint(j),
							current = getPoint(j + 2));
					previous = lower;
				}
				break;
			case 'q':
				for (var j = 0; j < length; j += 4) {
					this.quadraticCurveTo(
							control = getPoint(j),
							current = getPoint(j + 2));
				}
				break;
			case 't':
				for (var j = 0; j < length; j += 2) {
					this.quadraticCurveTo(
							control = (/[qt]/.test(previous)
									? current.multiply(2).subtract(control)
									: current),
							current = getPoint(j));
					previous = lower;
				}
				break;
			case 'a':
				for (var j = 0; j < length; j += 7) {
					this.arcTo(current = getPoint(j + 5),
							new Size(+coords[j], +coords[j + 1]),
							+coords[j + 2], +coords[j + 4], +coords[j + 3]);
				}
				break;
			case 'z':
				this.closePath(1e-12);
				current = start;
				break;
			}
			previous = lower;
		}
	},

	_canComposite: function() {
		return !(this.hasFill() && this.hasStroke());
	},

	_contains: function(point) {
		var winding = point.isInside(
				this.getBounds({ internal: true, handle: true }))
					? this._getWinding(point)
					: {};
		return winding.onPath || !!(this.getFillRule() === 'evenodd'
				? winding.windingL & 1 || winding.windingR & 1
				: winding.winding);
	},

	getIntersections: function(path, include, _matrix, _returnFirst) {
		var self = this === path || !path,
			matrix1 = this._matrix._orNullIfIdentity(),
			matrix2 = self ? matrix1
				: (_matrix || path._matrix)._orNullIfIdentity();
		return self || this.getBounds(matrix1).intersects(
				path.getBounds(matrix2), 1e-12)
				? Curve.getIntersections(
						this.getCurves(), !self && path.getCurves(), include,
						matrix1, matrix2, _returnFirst)
				: [];
	},

	getCrossings: function(path) {
		return this.getIntersections(path, function(inter) {
			return inter.isCrossing();
		});
	},

	getNearestLocation: function() {
		var point = Point.read(arguments),
			curves = this.getCurves(),
			minDist = Infinity,
			minLoc = null;
		for (var i = 0, l = curves.length; i < l; i++) {
			var loc = curves[i].getNearestLocation(point);
			if (loc._distance < minDist) {
				minDist = loc._distance;
				minLoc = loc;
			}
		}
		return minLoc;
	},

	getNearestPoint: function() {
		var loc = this.getNearestLocation.apply(this, arguments);
		return loc ? loc.getPoint() : loc;
	},

	interpolate: function(from, to, factor) {
		var isPath = !this._children,
			name = isPath ? '_segments' : '_children',
			itemsFrom = from[name],
			itemsTo = to[name],
			items = this[name];
		if (!itemsFrom || !itemsTo || itemsFrom.length !== itemsTo.length) {
			throw new Error('Invalid operands in interpolate() call: ' +
					from + ', ' + to);
		}
		var current = items.length,
			length = itemsTo.length;
		if (current < length) {
			var ctor = isPath ? Segment : Path;
			for (var i = current; i < length; i++) {
				this.add(new ctor());
			}
		} else if (current > length) {
			this[isPath ? 'removeSegments' : 'removeChildren'](length, current);
		}
		for (var i = 0; i < length; i++) {
			items[i].interpolate(itemsFrom[i], itemsTo[i], factor);
		}
		if (isPath) {
			this.setClosed(from._closed);
			this._changed(9);
		}
	},

	compare: function(path) {
		var ok = false;
		if (path) {
			var paths1 = this._children || [this],
				paths2 = path._children ? path._children.slice() : [path],
				length1 = paths1.length,
				length2 = paths2.length,
				matched = [],
				count = 0;
			ok = true;
			var boundsOverlaps = CollisionDetection.findItemBoundsCollisions(paths1, paths2, Numerical.GEOMETRIC_EPSILON);
			for (var i1 = length1 - 1; i1 >= 0 && ok; i1--) {
				var path1 = paths1[i1];
				ok = false;
				var pathBoundsOverlaps = boundsOverlaps[i1];
				if (pathBoundsOverlaps) {
					for (var i2 = pathBoundsOverlaps.length - 1; i2 >= 0 && !ok; i2--) {
						if (path1.compare(paths2[pathBoundsOverlaps[i2]])) {
							if (!matched[pathBoundsOverlaps[i2]]) {
								matched[pathBoundsOverlaps[i2]] = true;
								count++;
							}
							ok = true;
						}
					}
				}
			}
			ok = ok && count === length2;
		}
		return ok;
	},

});

var Path = PathItem.extend({
	_class: 'Path',
	_serializeFields: {
		segments: [],
		closed: false
	},

	initialize: function Path(arg) {
		this._closed = false;
		this._segments = [];
		this._version = 0;
		var args = arguments,
			segments = Array.isArray(arg)
			? typeof arg[0] === 'object'
				? arg
				: args
			: arg && (arg.size === undefined && (arg.x !== undefined
					|| arg.point !== undefined))
				? args
				: null;
		if (segments && segments.length > 0) {
			this.setSegments(segments);
		} else {
			this._curves = undefined;
			this._segmentSelection = 0;
			if (!segments && typeof arg === 'string') {
				this.setPathData(arg);
				arg = null;
			}
		}
		this._initialize(!segments && arg);
	},

	_equals: function(item) {
		return this._closed === item._closed
				&& Base.equals(this._segments, item._segments);
	},

	copyContent: function(source) {
		this.setSegments(source._segments);
		this._closed = source._closed;
	},

	_changed: function _changed(flags) {
		_changed.base.call(this, flags);
		if (flags & 8) {
			this._length = this._area = undefined;
			if (flags & 32) {
				this._version++;
			} else if (this._curves) {
			   for (var i = 0, l = this._curves.length; i < l; i++)
					this._curves[i]._changed();
			}
		} else if (flags & 64) {
			this._bounds = undefined;
		}
	},

	getStyle: function() {
		var parent = this._parent;
		return (parent instanceof CompoundPath ? parent : this)._style;
	},

	getSegments: function() {
		return this._segments;
	},

	setSegments: function(segments) {
		var fullySelected = this.isFullySelected(),
			length = segments && segments.length;
		this._segments.length = 0;
		this._segmentSelection = 0;
		this._curves = undefined;
		if (length) {
			var last = segments[length - 1];
			if (typeof last === 'boolean') {
				this.setClosed(last);
				length--;
			}
			this._add(Segment.readList(segments, 0, {}, length));
		}
		if (fullySelected)
			this.setFullySelected(true);
	},

	getFirstSegment: function() {
		return this._segments[0];
	},

	getLastSegment: function() {
		return this._segments[this._segments.length - 1];
	},

	getCurves: function() {
		var curves = this._curves,
			segments = this._segments;
		if (!curves) {
			var length = this._countCurves();
			curves = this._curves = new Array(length);
			for (var i = 0; i < length; i++)
				curves[i] = new Curve(this, segments[i],
					segments[i + 1] || segments[0]);
		}
		return curves;
	},

	getFirstCurve: function() {
		return this.getCurves()[0];
	},

	getLastCurve: function() {
		var curves = this.getCurves();
		return curves[curves.length - 1];
	},

	isClosed: function() {
		return this._closed;
	},

	setClosed: function(closed) {
		if (this._closed != (closed = !!closed)) {
			this._closed = closed;
			if (this._curves) {
				var length = this._curves.length = this._countCurves();
				if (closed)
					this._curves[length - 1] = new Curve(this,
						this._segments[length - 1], this._segments[0]);
			}
			this._changed(41);
		}
	}
}, {
	beans: true,

	getPathData: function(_matrix, _precision) {
		var segments = this._segments,
			length = segments.length,
			f = new Formatter(_precision),
			coords = new Array(6),
			first = true,
			curX, curY,
			prevX, prevY,
			inX, inY,
			outX, outY,
			parts = [];

		function addSegment(segment, skipLine) {
			segment._transformCoordinates(_matrix, coords);
			curX = coords[0];
			curY = coords[1];
			if (first) {
				parts.push('M' + f.pair(curX, curY));
				first = false;
			} else {
				inX = coords[2];
				inY = coords[3];
				if (inX === curX && inY === curY
						&& outX === prevX && outY === prevY) {
					if (!skipLine) {
						var dx = curX - prevX,
							dy = curY - prevY;
						parts.push(
							  dx === 0 ? 'v' + f.number(dy)
							: dy === 0 ? 'h' + f.number(dx)
							: 'l' + f.pair(dx, dy));
					}
				} else {
					parts.push('c' + f.pair(outX - prevX, outY - prevY)
							 + ' ' + f.pair( inX - prevX,  inY - prevY)
							 + ' ' + f.pair(curX - prevX, curY - prevY));
				}
			}
			prevX = curX;
			prevY = curY;
			outX = coords[4];
			outY = coords[5];
		}

		if (!length)
			return '';

		for (var i = 0; i < length; i++)
			addSegment(segments[i]);
		if (this._closed && length > 0) {
			addSegment(segments[0], true);
			parts.push('z');
		}
		return parts.join('');
	},

	isEmpty: function() {
		return !this._segments.length;
	},

	_transformContent: function(matrix) {
		var segments = this._segments,
			coords = new Array(6);
		for (var i = 0, l = segments.length; i < l; i++)
			segments[i]._transformCoordinates(matrix, coords, true);
		return true;
	},

	_add: function(segs, index) {
		var segments = this._segments,
			curves = this._curves,
			amount = segs.length,
			append = index == null,
			index = append ? segments.length : index;
		for (var i = 0; i < amount; i++) {
			var segment = segs[i];
			if (segment._path)
				segment = segs[i] = segment.clone();
			segment._path = this;
			segment._index = index + i;
			if (segment._selection)
				this._updateSelection(segment, 0, segment._selection);
		}
		if (append) {
			Base.push(segments, segs);
		} else {
			segments.splice.apply(segments, [index, 0].concat(segs));
			for (var i = index + amount, l = segments.length; i < l; i++)
				segments[i]._index = i;
		}
		if (curves) {
			var total = this._countCurves(),
				start = index > 0 && index + amount - 1 === total ? index - 1
					: index,
				insert = start,
				end = Math.min(start + amount, total);
			if (segs._curves) {
				curves.splice.apply(curves, [start, 0].concat(segs._curves));
				insert += segs._curves.length;
			}
			for (var i = insert; i < end; i++)
				curves.splice(i, 0, new Curve(this, null, null));
			this._adjustCurves(start, end);
		}
		this._changed(41);
		return segs;
	},

	_adjustCurves: function(start, end) {
		var segments = this._segments,
			curves = this._curves,
			curve;
		for (var i = start; i < end; i++) {
			curve = curves[i];
			curve._path = this;
			curve._segment1 = segments[i];
			curve._segment2 = segments[i + 1] || segments[0];
			curve._changed();
		}
		if (curve = curves[this._closed && !start ? segments.length - 1
				: start - 1]) {
			curve._segment2 = segments[start] || segments[0];
			curve._changed();
		}
		if (curve = curves[end]) {
			curve._segment1 = segments[end];
			curve._changed();
		}
	},

	_countCurves: function() {
		var length = this._segments.length;
		return !this._closed && length > 0 ? length - 1 : length;
	},

	add: function(segment1 ) {
		var args = arguments;
		return args.length > 1 && typeof segment1 !== 'number'
			? this._add(Segment.readList(args))
			: this._add([ Segment.read(args) ])[0];
	},

	insert: function(index, segment1 ) {
		var args = arguments;
		return args.length > 2 && typeof segment1 !== 'number'
			? this._add(Segment.readList(args, 1), index)
			: this._add([ Segment.read(args, 1) ], index)[0];
	},

	addSegment: function() {
		return this._add([ Segment.read(arguments) ])[0];
	},

	insertSegment: function(index ) {
		return this._add([ Segment.read(arguments, 1) ], index)[0];
	},

	addSegments: function(segments) {
		return this._add(Segment.readList(segments));
	},

	insertSegments: function(index, segments) {
		return this._add(Segment.readList(segments), index);
	},

	removeSegment: function(index) {
		return this.removeSegments(index, index + 1)[0] || null;
	},

	removeSegments: function(start, end, _includeCurves) {
		start = start || 0;
		end = Base.pick(end, this._segments.length);
		var segments = this._segments,
			curves = this._curves,
			count = segments.length,
			removed = segments.splice(start, end - start),
			amount = removed.length;
		if (!amount)
			return removed;
		for (var i = 0; i < amount; i++) {
			var segment = removed[i];
			if (segment._selection)
				this._updateSelection(segment, segment._selection, 0);
			segment._index = segment._path = null;
		}
		for (var i = start, l = segments.length; i < l; i++)
			segments[i]._index = i;
		if (curves) {
			var index = start > 0 && end === count + (this._closed ? 1 : 0)
					? start - 1
					: start,
				curves = curves.splice(index, amount);
			for (var i = curves.length - 1; i >= 0; i--)
				curves[i]._path = null;
			if (_includeCurves)
				removed._curves = curves.slice(1);
			this._adjustCurves(index, index);
		}
		this._changed(41);
		return removed;
	},

	clear: '#removeSegments',

	hasHandles: function() {
		var segments = this._segments;
		for (var i = 0, l = segments.length; i < l; i++) {
			if (segments[i].hasHandles())
				return true;
		}
		return false;
	},

	clearHandles: function() {
		var segments = this._segments;
		for (var i = 0, l = segments.length; i < l; i++)
			segments[i].clearHandles();
	},

	getLength: function() {
		if (this._length == null) {
			var curves = this.getCurves(),
				length = 0;
			for (var i = 0, l = curves.length; i < l; i++)
				length += curves[i].getLength();
			this._length = length;
		}
		return this._length;
	},

	getArea: function() {
		var area = this._area;
		if (area == null) {
			var segments = this._segments,
				closed = this._closed;
			area = 0;
			for (var i = 0, l = segments.length; i < l; i++) {
				var last = i + 1 === l;
				area += Curve.getArea(Curve.getValues(
						segments[i], segments[last ? 0 : i + 1],
						null, last && !closed));
			}
			this._area = area;
		}
		return area;
	},

	isFullySelected: function() {
		var length = this._segments.length;
		return this.isSelected() && length > 0 && this._segmentSelection
				=== length * 7;
	},

	setFullySelected: function(selected) {
		if (selected)
			this._selectSegments(true);
		this.setSelected(selected);
	},

	setSelection: function setSelection(selection) {
		if (!(selection & 1))
			this._selectSegments(false);
		setSelection.base.call(this, selection);
	},

	_selectSegments: function(selected) {
		var segments = this._segments,
			length = segments.length,
			selection = selected ? 7 : 0;
		this._segmentSelection = selection * length;
		for (var i = 0; i < length; i++)
			segments[i]._selection = selection;
	},

	_updateSelection: function(segment, oldSelection, newSelection) {
		segment._selection = newSelection;
		var selection = this._segmentSelection += newSelection - oldSelection;
		if (selection > 0)
			this.setSelected(true);
	},

	divideAt: function(location) {
		var loc = this.getLocationAt(location),
			curve;
		return loc && (curve = loc.getCurve().divideAt(loc.getCurveOffset()))
				? curve._segment1
				: null;
	},

	splitAt: function(location) {
		var loc = this.getLocationAt(location),
			index = loc && loc.index,
			time = loc && loc.time,
			tMin = 1e-8,
			tMax = 1 - tMin;
		if (time > tMax) {
			index++;
			time = 0;
		}
		var curves = this.getCurves();
		if (index >= 0 && index < curves.length) {
			if (time >= tMin) {
				curves[index++].divideAtTime(time);
			}
			var segs = this.removeSegments(index, this._segments.length, true),
				path;
			if (this._closed) {
				this.setClosed(false);
				path = this;
			} else {
				path = new Path(Item.NO_INSERT);
				path.insertAbove(this);
				path.copyAttributes(this);
			}
			path._add(segs, 0);
			this.addSegment(segs[0]);
			return path;
		}
		return null;
	},

	split: function(index, time) {
		var curve,
			location = time === undefined ? index
				: (curve = this.getCurves()[index])
					&& curve.getLocationAtTime(time);
		return location != null ? this.splitAt(location) : null;
	},

	join: function(path, tolerance) {
		var epsilon = tolerance || 0;
		if (path && path !== this) {
			var segments = path._segments,
				last1 = this.getLastSegment(),
				last2 = path.getLastSegment();
			if (!last2)
				return this;
			if (last1 && last1._point.isClose(last2._point, epsilon))
				path.reverse();
			var first2 = path.getFirstSegment();
			if (last1 && last1._point.isClose(first2._point, epsilon)) {
				last1.setHandleOut(first2._handleOut);
				this._add(segments.slice(1));
			} else {
				var first1 = this.getFirstSegment();
				if (first1 && first1._point.isClose(first2._point, epsilon))
					path.reverse();
				last2 = path.getLastSegment();
				if (first1 && first1._point.isClose(last2._point, epsilon)) {
					first1.setHandleIn(last2._handleIn);
					this._add(segments.slice(0, segments.length - 1), 0);
				} else {
					this._add(segments.slice());
				}
			}
			if (path._closed)
				this._add([segments[0]]);
			path.remove();
		}
		var first = this.getFirstSegment(),
			last = this.getLastSegment();
		if (first !== last && first._point.isClose(last._point, epsilon)) {
			first.setHandleIn(last._handleIn);
			last.remove();
			this.setClosed(true);
		}
		return this;
	},

	reduce: function(options) {
		var curves = this.getCurves(),
			simplify = options && options.simplify,
			tolerance = simplify ? 1e-7 : 0;
		for (var i = curves.length - 1; i >= 0; i--) {
			var curve = curves[i];
			if (!curve.hasHandles() && (!curve.hasLength(tolerance)
					|| simplify && curve.isCollinear(curve.getNext())))
				curve.remove();
		}
		return this;
	},

	reverse: function() {
		this._segments.reverse();
		for (var i = 0, l = this._segments.length; i < l; i++) {
			var segment = this._segments[i];
			var handleIn = segment._handleIn;
			segment._handleIn = segment._handleOut;
			segment._handleOut = handleIn;
			segment._index = i;
		}
		this._curves = null;
		this._changed(9);
	},

	flatten: function(flatness) {
		var flattener = new PathFlattener(this, flatness || 0.25, 256, true),
			parts = flattener.parts,
			length = parts.length,
			segments = [];
		for (var i = 0; i < length; i++) {
			segments.push(new Segment(parts[i].curve.slice(0, 2)));
		}
		if (!this._closed && length > 0) {
			segments.push(new Segment(parts[length - 1].curve.slice(6)));
		}
		this.setSegments(segments);
	},

	simplify: function(tolerance) {
		var segments = new PathFitter(this).fit(tolerance || 2.5);
		if (segments)
			this.setSegments(segments);
		return !!segments;
	},

	smooth: function(options) {
		var that = this,
			opts = options || {},
			type = opts.type || 'asymmetric',
			segments = this._segments,
			length = segments.length,
			closed = this._closed;

		function getIndex(value, _default) {
			var index = value && value.index;
			if (index != null) {
				var path = value.path;
				if (path && path !== that)
					throw new Error(value._class + ' ' + index + ' of ' + path
							+ ' is not part of ' + that);
				if (_default && value instanceof Curve)
					index++;
			} else {
				index = typeof value === 'number' ? value : _default;
			}
			return Math.min(index < 0 && closed
					? index % length
					: index < 0 ? index + length : index, length - 1);
		}

		var loop = closed && opts.from === undefined && opts.to === undefined,
			from = getIndex(opts.from, 0),
			to = getIndex(opts.to, length - 1);

		if (from > to) {
			if (closed) {
				from -= length;
			} else {
				var tmp = from;
				from = to;
				to = tmp;
			}
		}
		if (/^(?:asymmetric|continuous)$/.test(type)) {
			var asymmetric = type === 'asymmetric',
				min = Math.min,
				amount = to - from + 1,
				n = amount - 1,
				padding = loop ? min(amount, 4) : 1,
				paddingLeft = padding,
				paddingRight = padding,
				knots = [];
			if (!closed) {
				paddingLeft = min(1, from);
				paddingRight = min(1, length - to - 1);
			}
			n += paddingLeft + paddingRight;
			if (n <= 1)
				return;
			for (var i = 0, j = from - paddingLeft; i <= n; i++, j++) {
				knots[i] = segments[(j < 0 ? j + length : j) % length]._point;
			}

			var x = knots[0]._x + 2 * knots[1]._x,
				y = knots[0]._y + 2 * knots[1]._y,
				f = 2,
				n_1 = n - 1,
				rx = [x],
				ry = [y],
				rf = [f],
				px = [],
				py = [];
			for (var i = 1; i < n; i++) {
				var internal = i < n_1,
					a = internal ? 1 : asymmetric ? 1 : 2,
					b = internal ? 4 : asymmetric ? 2 : 7,
					u = internal ? 4 : asymmetric ? 3 : 8,
					v = internal ? 2 : asymmetric ? 0 : 1,
					m = a / f;
				f = rf[i] = b - m;
				x = rx[i] = u * knots[i]._x + v * knots[i + 1]._x - m * x;
				y = ry[i] = u * knots[i]._y + v * knots[i + 1]._y - m * y;
			}

			px[n_1] = rx[n_1] / rf[n_1];
			py[n_1] = ry[n_1] / rf[n_1];
			for (var i = n - 2; i >= 0; i--) {
				px[i] = (rx[i] - px[i + 1]) / rf[i];
				py[i] = (ry[i] - py[i + 1]) / rf[i];
			}
			px[n] = (3 * knots[n]._x - px[n_1]) / 2;
			py[n] = (3 * knots[n]._y - py[n_1]) / 2;

			for (var i = paddingLeft, max = n - paddingRight, j = from;
					i <= max; i++, j++) {
				var segment = segments[j < 0 ? j + length : j],
					pt = segment._point,
					hx = px[i] - pt._x,
					hy = py[i] - pt._y;
				if (loop || i < max)
					segment.setHandleOut(hx, hy);
				if (loop || i > paddingLeft)
					segment.setHandleIn(-hx, -hy);
			}
		} else {
			for (var i = from; i <= to; i++) {
				segments[i < 0 ? i + length : i].smooth(opts,
						!loop && i === from, !loop && i === to);
			}
		}
	},

	toShape: function(insert) {
		if (!this._closed)
			return null;

		var segments = this._segments,
			type,
			size,
			radius,
			topCenter;

		function isCollinear(i, j) {
			var seg1 = segments[i],
				seg2 = seg1.getNext(),
				seg3 = segments[j],
				seg4 = seg3.getNext();
			return seg1._handleOut.isZero() && seg2._handleIn.isZero()
					&& seg3._handleOut.isZero() && seg4._handleIn.isZero()
					&& seg2._point.subtract(seg1._point).isCollinear(
						seg4._point.subtract(seg3._point));
		}

		function isOrthogonal(i) {
			var seg2 = segments[i],
				seg1 = seg2.getPrevious(),
				seg3 = seg2.getNext();
			return seg1._handleOut.isZero() && seg2._handleIn.isZero()
					&& seg2._handleOut.isZero() && seg3._handleIn.isZero()
					&& seg2._point.subtract(seg1._point).isOrthogonal(
						seg3._point.subtract(seg2._point));
		}

		function isArc(i) {
			var seg1 = segments[i],
				seg2 = seg1.getNext(),
				handle1 = seg1._handleOut,
				handle2 = seg2._handleIn,
				kappa = 0.5522847498307936;
			if (handle1.isOrthogonal(handle2)) {
				var pt1 = seg1._point,
					pt2 = seg2._point,
					corner = new Line(pt1, handle1, true).intersect(
							new Line(pt2, handle2, true), true);
				return corner && Numerical.isZero(handle1.getLength() /
						corner.subtract(pt1).getLength() - kappa)
					&& Numerical.isZero(handle2.getLength() /
						corner.subtract(pt2).getLength() - kappa);
			}
			return false;
		}

		function getDistance(i, j) {
			return segments[i]._point.getDistance(segments[j]._point);
		}

		if (!this.hasHandles() && segments.length === 4
				&& isCollinear(0, 2) && isCollinear(1, 3) && isOrthogonal(1)) {
			type = Shape.Rectangle;
			size = new Size(getDistance(0, 3), getDistance(0, 1));
			topCenter = segments[1]._point.add(segments[2]._point).divide(2);
		} else if (segments.length === 8 && isArc(0) && isArc(2) && isArc(4)
				&& isArc(6) && isCollinear(1, 5) && isCollinear(3, 7)) {
			type = Shape.Rectangle;
			size = new Size(getDistance(1, 6), getDistance(0, 3));
			radius = size.subtract(new Size(getDistance(0, 7),
					getDistance(1, 2))).divide(2);
			topCenter = segments[3]._point.add(segments[4]._point).divide(2);
		} else if (segments.length === 4
				&& isArc(0) && isArc(1) && isArc(2) && isArc(3)) {
			if (Numerical.isZero(getDistance(0, 2) - getDistance(1, 3))) {
				type = Shape.Circle;
				radius = getDistance(0, 2) / 2;
			} else {
				type = Shape.Ellipse;
				radius = new Size(getDistance(2, 0) / 2, getDistance(3, 1) / 2);
			}
			topCenter = segments[1]._point;
		}

		if (type) {
			var center = this.getPosition(true),
				shape = new type({
					center: center,
					size: size,
					radius: radius,
					insert: false
				});
			shape.copyAttributes(this, true);
			shape._matrix.prepend(this._matrix);
			shape.rotate(topCenter.subtract(center).getAngle() + 90);
			if (insert === undefined || insert)
				shape.insertAbove(this);
			return shape;
		}
		return null;
	},

	toPath: '#clone',

	compare: function compare(path) {
		if (!path || path instanceof CompoundPath)
			return compare.base.call(this, path);
		var curves1 = this.getCurves(),
			curves2 = path.getCurves(),
			length1 = curves1.length,
			length2 = curves2.length;
		if (!length1 || !length2) {
			return length1 == length2;
		}
		var v1 = curves1[0].getValues(),
			values2 = [],
			pos1 = 0, pos2,
			end1 = 0, end2;
		for (var i = 0; i < length2; i++) {
			var v2 = curves2[i].getValues();
			values2.push(v2);
			var overlaps = Curve.getOverlaps(v1, v2);
			if (overlaps) {
				pos2 = !i && overlaps[0][0] > 0 ? length2 - 1 : i;
				end2 = overlaps[0][1];
				break;
			}
		}
		var abs = Math.abs,
			epsilon = 1e-8,
			v2 = values2[pos2],
			start2;
		while (v1 && v2) {
			var overlaps = Curve.getOverlaps(v1, v2);
			if (overlaps) {
				var t1 = overlaps[0][0];
				if (abs(t1 - end1) < epsilon) {
					end1 = overlaps[1][0];
					if (end1 === 1) {
						v1 = ++pos1 < length1 ? curves1[pos1].getValues() : null;
						end1 = 0;
					}
					var t2 = overlaps[0][1];
					if (abs(t2 - end2) < epsilon) {
						if (!start2)
							start2 = [pos2, t2];
						end2 = overlaps[1][1];
						if (end2 === 1) {
							if (++pos2 >= length2)
								pos2 = 0;
							v2 = values2[pos2] || curves2[pos2].getValues();
							end2 = 0;
						}
						if (!v1) {
							return start2[0] === pos2 && start2[1] === end2;
						}
						continue;
					}
				}
			}
			break;
		}
		return false;
	},

	_hitTestSelf: function(point, options, viewMatrix, strokeMatrix) {
		var that = this,
			style = this.getStyle(),
			segments = this._segments,
			numSegments = segments.length,
			closed = this._closed,
			tolerancePadding = options._tolerancePadding,
			strokePadding = tolerancePadding,
			join, cap, miterLimit,
			area, loc, res,
			hitStroke = options.stroke && style.hasStroke(),
			hitFill = options.fill && style.hasFill(),
			hitCurves = options.curves,
			strokeRadius = hitStroke
					? style.getStrokeWidth() / 2
					: hitFill && options.tolerance > 0 || hitCurves
						? 0 : null;
		if (strokeRadius !== null) {
			if (strokeRadius > 0) {
				join = style.getStrokeJoin();
				cap = style.getStrokeCap();
				miterLimit = style.getMiterLimit();
				strokePadding = strokePadding.add(
					Path._getStrokePadding(strokeRadius, strokeMatrix));
			} else {
				join = cap = 'round';
			}
		}

		function isCloseEnough(pt, padding) {
			return point.subtract(pt).divide(padding).length <= 1;
		}

		function checkSegmentPoint(seg, pt, name) {
			if (!options.selected || pt.isSelected()) {
				var anchor = seg._point;
				if (pt !== anchor)
					pt = pt.add(anchor);
				if (isCloseEnough(pt, strokePadding)) {
					return new HitResult(name, that, {
						segment: seg,
						point: pt
					});
				}
			}
		}

		function checkSegmentPoints(seg, ends) {
			return (ends || options.segments)
				&& checkSegmentPoint(seg, seg._point, 'segment')
				|| (!ends && options.handles) && (
					checkSegmentPoint(seg, seg._handleIn, 'handle-in') ||
					checkSegmentPoint(seg, seg._handleOut, 'handle-out'));
		}

		function addToArea(point) {
			area.add(point);
		}

		function checkSegmentStroke(segment) {
			var isJoin = closed || segment._index > 0
					&& segment._index < numSegments - 1;
			if ((isJoin ? join : cap) === 'round') {
				return isCloseEnough(segment._point, strokePadding);
			} else {
				area = new Path({ internal: true, closed: true });
				if (isJoin) {
					if (!segment.isSmooth()) {
						Path._addBevelJoin(segment, join, strokeRadius,
							   miterLimit, null, strokeMatrix, addToArea, true);
					}
				} else if (cap === 'square') {
					Path._addSquareCap(segment, cap, strokeRadius, null,
							strokeMatrix, addToArea, true);
				}
				if (!area.isEmpty()) {
					var loc;
					return area.contains(point)
						|| (loc = area.getNearestLocation(point))
							&& isCloseEnough(loc.getPoint(), tolerancePadding);
				}
			}
		}

		if (options.ends && !options.segments && !closed) {
			if (res = checkSegmentPoints(segments[0], true)
					|| checkSegmentPoints(segments[numSegments - 1], true))
				return res;
		} else if (options.segments || options.handles) {
			for (var i = 0; i < numSegments; i++)
				if (res = checkSegmentPoints(segments[i]))
					return res;
		}
		if (strokeRadius !== null) {
			loc = this.getNearestLocation(point);
			if (loc) {
				var time = loc.getTime();
				if (time === 0 || time === 1 && numSegments > 1) {
					if (!checkSegmentStroke(loc.getSegment()))
						loc = null;
				} else if (!isCloseEnough(loc.getPoint(), strokePadding)) {
					loc = null;
				}
			}
			if (!loc && join === 'miter' && numSegments > 1) {
				for (var i = 0; i < numSegments; i++) {
					var segment = segments[i];
					if (point.getDistance(segment._point)
							<= miterLimit * strokeRadius
							&& checkSegmentStroke(segment)) {
						loc = segment.getLocation();
						break;
					}
				}
			}
		}
		return !loc && hitFill && this._contains(point)
				|| loc && !hitStroke && !hitCurves
					? new HitResult('fill', this)
					: loc
						? new HitResult(hitStroke ? 'stroke' : 'curve', this, {
							location: loc,
							point: loc.getPoint()
						})
						: null;
	}

}, Base.each(Curve._evaluateMethods,
	function(name) {
		this[name + 'At'] = function(offset) {
			var loc = this.getLocationAt(offset);
			return loc && loc[name]();
		};
	},
{
	beans: false,

	getLocationOf: function() {
		var point = Point.read(arguments),
			curves = this.getCurves();
		for (var i = 0, l = curves.length; i < l; i++) {
			var loc = curves[i].getLocationOf(point);
			if (loc)
				return loc;
		}
		return null;
	},

	getOffsetOf: function() {
		var loc = this.getLocationOf.apply(this, arguments);
		return loc ? loc.getOffset() : null;
	},

	getLocationAt: function(offset) {
		if (typeof offset === 'number') {
			var curves = this.getCurves(),
				length = 0;
			for (var i = 0, l = curves.length; i < l; i++) {
				var start = length,
					curve = curves[i];
				length += curve.getLength();
				if (length > offset) {
					return curve.getLocationAt(offset - start);
				}
			}
			if (curves.length > 0 && offset <= this.getLength()) {
				return new CurveLocation(curves[curves.length - 1], 1);
			}
		} else if (offset && offset.getPath && offset.getPath() === this) {
			return offset;
		}
		return null;
	},

	getOffsetsWithTangent: function() {
		var tangent = Point.read(arguments);
		if (tangent.isZero()) {
			return [];
		}

		var offsets = [];
		var curveStart = 0;
		var curves = this.getCurves();
		for (var i = 0, l = curves.length; i < l; i++) {
			var curve = curves[i];
			var curveTimes = curve.getTimesWithTangent(tangent);
			for (var j = 0, m = curveTimes.length; j < m; j++) {
				var offset = curveStart + curve.getOffsetAtTime(curveTimes[j]);
				if (offsets.indexOf(offset) < 0) {
					offsets.push(offset);
				}
			}
			curveStart += curve.length;
		}
		return offsets;
	}
}),
new function() {

	function drawHandles(ctx, segments, matrix, size) {
		if (size <= 0) return;

		var half = size / 2,
			miniSize = size - 2,
			miniHalf = half - 1,
			coords = new Array(6),
			pX, pY;

		function drawHandle(index) {
			var hX = coords[index],
				hY = coords[index + 1];
			if (pX != hX || pY != hY) {
				ctx.beginPath();
				ctx.moveTo(pX, pY);
				ctx.lineTo(hX, hY);
				ctx.stroke();
				ctx.beginPath();
				ctx.arc(hX, hY, half, 0, Math.PI * 2, true);
				ctx.fill();
			}
		}

		for (var i = 0, l = segments.length; i < l; i++) {
			var segment = segments[i],
				selection = segment._selection;
			segment._transformCoordinates(matrix, coords);
			pX = coords[0];
			pY = coords[1];
			if (selection & 2)
				drawHandle(2);
			if (selection & 4)
				drawHandle(4);
			ctx.fillRect(pX - half, pY - half, size, size);
			if (miniSize > 0 && !(selection & 1)) {
				var fillStyle = ctx.fillStyle;
				ctx.fillStyle = '#ffffff';
				ctx.fillRect(pX - miniHalf, pY - miniHalf, miniSize, miniSize);
				ctx.fillStyle = fillStyle;
			}
		}
	}

	function drawSegments(ctx, path, matrix) {
		var segments = path._segments,
			length = segments.length,
			coords = new Array(6),
			first = true,
			curX, curY,
			prevX, prevY,
			inX, inY,
			outX, outY;

		function drawSegment(segment) {
			if (matrix) {
				segment._transformCoordinates(matrix, coords);
				curX = coords[0];
				curY = coords[1];
			} else {
				var point = segment._point;
				curX = point._x;
				curY = point._y;
			}
			if (first) {
				ctx.moveTo(curX, curY);
				first = false;
			} else {
				if (matrix) {
					inX = coords[2];
					inY = coords[3];
				} else {
					var handle = segment._handleIn;
					inX = curX + handle._x;
					inY = curY + handle._y;
				}
				if (inX === curX && inY === curY
						&& outX === prevX && outY === prevY) {
					ctx.lineTo(curX, curY);
				} else {
					ctx.bezierCurveTo(outX, outY, inX, inY, curX, curY);
				}
			}
			prevX = curX;
			prevY = curY;
			if (matrix) {
				outX = coords[4];
				outY = coords[5];
			} else {
				var handle = segment._handleOut;
				outX = prevX + handle._x;
				outY = prevY + handle._y;
			}
		}

		for (var i = 0; i < length; i++)
			drawSegment(segments[i]);
		if (path._closed && length > 0)
			drawSegment(segments[0]);
	}

	return {
		_draw: function(ctx, param, viewMatrix, strokeMatrix) {
			var dontStart = param.dontStart,
				dontPaint = param.dontFinish || param.clip,
				style = this.getStyle(),
				hasFill = style.hasFill(),
				hasStroke = style.hasStroke(),
				dashArray = style.getDashArray(),
				dashLength = !paper.support.nativeDash && hasStroke
						&& dashArray && dashArray.length;

			if (!dontStart)
				ctx.beginPath();

			if (hasFill || hasStroke && !dashLength || dontPaint) {
				drawSegments(ctx, this, strokeMatrix);
				if (this._closed)
					ctx.closePath();
			}

			function getOffset(i) {
				return dashArray[((i % dashLength) + dashLength) % dashLength];
			}

			if (!dontPaint && (hasFill || hasStroke)) {
				this._setStyles(ctx, param, viewMatrix);
				if (hasFill) {
					ctx.fill(style.getFillRule());
					ctx.shadowColor = 'rgba(0,0,0,0)';
				}
				if (hasStroke) {
					if (dashLength) {
						if (!dontStart)
							ctx.beginPath();
						var flattener = new PathFlattener(this, 0.25, 32, false,
								strokeMatrix),
							length = flattener.length,
							from = -style.getDashOffset(), to,
							i = 0;
						while (from > 0) {
							from -= getOffset(i--) + getOffset(i--);
						}
						while (from < length) {
							to = from + getOffset(i++);
							if (from > 0 || to > 0)
								flattener.drawPart(ctx,
										Math.max(from, 0), Math.max(to, 0));
							from = to + getOffset(i++);
						}
					}
					ctx.stroke();
				}
			}
		},

		_drawSelected: function(ctx, matrix) {
			ctx.beginPath();
			drawSegments(ctx, this, matrix);
			ctx.stroke();
			drawHandles(ctx, this._segments, matrix, paper.settings.handleSize);
		}
	};
},
new function() {
	function getCurrentSegment(that) {
		var segments = that._segments;
		if (!segments.length)
			throw new Error('Use a moveTo() command first');
		return segments[segments.length - 1];
	}

	return {
		moveTo: function() {
			var segments = this._segments;
			if (segments.length === 1)
				this.removeSegment(0);
			if (!segments.length)
				this._add([ new Segment(Point.read(arguments)) ]);
		},

		moveBy: function() {
			throw new Error('moveBy() is unsupported on Path items.');
		},

		lineTo: function() {
			this._add([ new Segment(Point.read(arguments)) ]);
		},

		cubicCurveTo: function() {
			var args = arguments,
				handle1 = Point.read(args),
				handle2 = Point.read(args),
				to = Point.read(args),
				current = getCurrentSegment(this);
			current.setHandleOut(handle1.subtract(current._point));
			this._add([ new Segment(to, handle2.subtract(to)) ]);
		},

		quadraticCurveTo: function() {
			var args = arguments,
				handle = Point.read(args),
				to = Point.read(args),
				current = getCurrentSegment(this)._point;
			this.cubicCurveTo(
				handle.add(current.subtract(handle).multiply(1 / 3)),
				handle.add(to.subtract(handle).multiply(1 / 3)),
				to
			);
		},

		curveTo: function() {
			var args = arguments,
				through = Point.read(args),
				to = Point.read(args),
				t = Base.pick(Base.read(args), 0.5),
				t1 = 1 - t,
				current = getCurrentSegment(this)._point,
				handle = through.subtract(current.multiply(t1 * t1))
					.subtract(to.multiply(t * t)).divide(2 * t * t1);
			if (handle.isNaN())
				throw new Error(
					'Cannot put a curve through points with parameter = ' + t);
			this.quadraticCurveTo(handle, to);
		},

		arcTo: function() {
			var args = arguments,
				abs = Math.abs,
				sqrt = Math.sqrt,
				current = getCurrentSegment(this),
				from = current._point,
				to = Point.read(args),
				through,
				peek = Base.peek(args),
				clockwise = Base.pick(peek, true),
				center, extent, vector, matrix;
			if (typeof clockwise === 'boolean') {
				var middle = from.add(to).divide(2),
				through = middle.add(middle.subtract(from).rotate(
						clockwise ? -90 : 90));
			} else if (Base.remain(args) <= 2) {
				through = to;
				to = Point.read(args);
			} else if (!from.equals(to)) {
				var radius = Size.read(args),
					isZero = Numerical.isZero;
				if (isZero(radius.width) || isZero(radius.height))
					return this.lineTo(to);
				var rotation = Base.read(args),
					clockwise = !!Base.read(args),
					large = !!Base.read(args),
					middle = from.add(to).divide(2),
					pt = from.subtract(middle).rotate(-rotation),
					x = pt.x,
					y = pt.y,
					rx = abs(radius.width),
					ry = abs(radius.height),
					rxSq = rx * rx,
					rySq = ry * ry,
					xSq = x * x,
					ySq = y * y;
				var factor = sqrt(xSq / rxSq + ySq / rySq);
				if (factor > 1) {
					rx *= factor;
					ry *= factor;
					rxSq = rx * rx;
					rySq = ry * ry;
				}
				factor = (rxSq * rySq - rxSq * ySq - rySq * xSq) /
						(rxSq * ySq + rySq * xSq);
				if (abs(factor) < 1e-12)
					factor = 0;
				if (factor < 0)
					throw new Error(
							'Cannot create an arc with the given arguments');
				center = new Point(rx * y / ry, -ry * x / rx)
						.multiply((large === clockwise ? -1 : 1) * sqrt(factor))
						.rotate(rotation).add(middle);
				matrix = new Matrix().translate(center).rotate(rotation)
						.scale(rx, ry);
				vector = matrix._inverseTransform(from);
				extent = vector.getDirectedAngle(matrix._inverseTransform(to));
				if (!clockwise && extent > 0)
					extent -= 360;
				else if (clockwise && extent < 0)
					extent += 360;
			}
			if (through) {
				var l1 = new Line(from.add(through).divide(2),
							through.subtract(from).rotate(90), true),
					l2 = new Line(through.add(to).divide(2),
							to.subtract(through).rotate(90), true),
					line = new Line(from, to),
					throughSide = line.getSide(through);
				center = l1.intersect(l2, true);
				if (!center) {
					if (!throughSide)
						return this.lineTo(to);
					throw new Error(
							'Cannot create an arc with the given arguments');
				}
				vector = from.subtract(center);
				extent = vector.getDirectedAngle(to.subtract(center));
				var centerSide = line.getSide(center, true);
				if (centerSide === 0) {
					extent = throughSide * abs(extent);
				} else if (throughSide === centerSide) {
					extent += extent < 0 ? 360 : -360;
				}
			}
			if (extent) {
				var epsilon = 1e-5,
					ext = abs(extent),
					count = ext >= 360
						? 4
						: Math.ceil((ext - epsilon) / 90),
					inc = extent / count,
					half = inc * Math.PI / 360,
					z = 4 / 3 * Math.sin(half) / (1 + Math.cos(half)),
					segments = [];
				for (var i = 0; i <= count; i++) {
					var pt = to,
						out = null;
					if (i < count) {
						out = vector.rotate(90).multiply(z);
						if (matrix) {
							pt = matrix._transformPoint(vector);
							out = matrix._transformPoint(vector.add(out))
									.subtract(pt);
						} else {
							pt = center.add(vector);
						}
					}
					if (!i) {
						current.setHandleOut(out);
					} else {
						var _in = vector.rotate(-90).multiply(z);
						if (matrix) {
							_in = matrix._transformPoint(vector.add(_in))
									.subtract(pt);
						}
						segments.push(new Segment(pt, _in, out));
					}
					vector = vector.rotate(inc);
				}
				this._add(segments);
			}
		},

		lineBy: function() {
			var to = Point.read(arguments),
				current = getCurrentSegment(this)._point;
			this.lineTo(current.add(to));
		},

		curveBy: function() {
			var args = arguments,
				through = Point.read(args),
				to = Point.read(args),
				parameter = Base.read(args),
				current = getCurrentSegment(this)._point;
			this.curveTo(current.add(through), current.add(to), parameter);
		},

		cubicCurveBy: function() {
			var args = arguments,
				handle1 = Point.read(args),
				handle2 = Point.read(args),
				to = Point.read(args),
				current = getCurrentSegment(this)._point;
			this.cubicCurveTo(current.add(handle1), current.add(handle2),
					current.add(to));
		},

		quadraticCurveBy: function() {
			var args = arguments,
				handle = Point.read(args),
				to = Point.read(args),
				current = getCurrentSegment(this)._point;
			this.quadraticCurveTo(current.add(handle), current.add(to));
		},

		arcBy: function() {
			var args = arguments,
				current = getCurrentSegment(this)._point,
				point = current.add(Point.read(args)),
				clockwise = Base.pick(Base.peek(args), true);
			if (typeof clockwise === 'boolean') {
				this.arcTo(point, clockwise);
			} else {
				this.arcTo(point, current.add(Point.read(args)));
			}
		},

		closePath: function(tolerance) {
			this.setClosed(true);
			this.join(this, tolerance);
		}
	};
}, {

	_getBounds: function(matrix, options) {
		var method = options.handle
				? 'getHandleBounds'
				: options.stroke
				? 'getStrokeBounds'
				: 'getBounds';
		return Path[method](this._segments, this._closed, this, matrix, options);
	},

statics: {
	getBounds: function(segments, closed, path, matrix, options, strokePadding) {
		var first = segments[0];
		if (!first)
			return new Rectangle();
		var coords = new Array(6),
			prevCoords = first._transformCoordinates(matrix, new Array(6)),
			min = prevCoords.slice(0, 2),
			max = min.slice(),
			roots = new Array(2);

		function processSegment(segment) {
			segment._transformCoordinates(matrix, coords);
			for (var i = 0; i < 2; i++) {
				Curve._addBounds(
					prevCoords[i],
					prevCoords[i + 4],
					coords[i + 2],
					coords[i],
					i, strokePadding ? strokePadding[i] : 0, min, max, roots);
			}
			var tmp = prevCoords;
			prevCoords = coords;
			coords = tmp;
		}

		for (var i = 1, l = segments.length; i < l; i++)
			processSegment(segments[i]);
		if (closed)
			processSegment(first);
		return new Rectangle(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	},

	getStrokeBounds: function(segments, closed, path, matrix, options) {
		var style = path.getStyle(),
			stroke = style.hasStroke(),
			strokeWidth = style.getStrokeWidth(),
			strokeMatrix = stroke && path._getStrokeMatrix(matrix, options),
			strokePadding = stroke && Path._getStrokePadding(strokeWidth,
				strokeMatrix),
			bounds = Path.getBounds(segments, closed, path, matrix, options,
				strokePadding);
		if (!stroke)
			return bounds;
		var strokeRadius = strokeWidth / 2,
			join = style.getStrokeJoin(),
			cap = style.getStrokeCap(),
			miterLimit = style.getMiterLimit(),
			joinBounds = new Rectangle(new Size(strokePadding));

		function addPoint(point) {
			bounds = bounds.include(point);
		}

		function addRound(segment) {
			bounds = bounds.unite(
					joinBounds.setCenter(segment._point.transform(matrix)));
		}

		function addJoin(segment, join) {
			if (join === 'round' || segment.isSmooth()) {
				addRound(segment);
			} else {
				Path._addBevelJoin(segment, join, strokeRadius, miterLimit,
						matrix, strokeMatrix, addPoint);
			}
		}

		function addCap(segment, cap) {
			if (cap === 'round') {
				addRound(segment);
			} else {
				Path._addSquareCap(segment, cap, strokeRadius, matrix,
						strokeMatrix, addPoint);
			}
		}

		var length = segments.length - (closed ? 0 : 1);
		if (length > 0) {
			for (var i = 1; i < length; i++) {
				addJoin(segments[i], join);
			}
			if (closed) {
				addJoin(segments[0], join);
			} else {
				addCap(segments[0], cap);
				addCap(segments[segments.length - 1], cap);
			}
		}
		return bounds;
	},

	_getStrokePadding: function(radius, matrix) {
		if (!matrix)
			return [radius, radius];
		var hor = new Point(radius, 0).transform(matrix),
			ver = new Point(0, radius).transform(matrix),
			phi = hor.getAngleInRadians(),
			a = hor.getLength(),
			b = ver.getLength();
		var sin = Math.sin(phi),
			cos = Math.cos(phi),
			tan = Math.tan(phi),
			tx = Math.atan2(b * tan, a),
			ty = Math.atan2(b, tan * a);
		return [Math.abs(a * Math.cos(tx) * cos + b * Math.sin(tx) * sin),
				Math.abs(b * Math.sin(ty) * cos + a * Math.cos(ty) * sin)];
	},

	_addBevelJoin: function(segment, join, radius, miterLimit, matrix,
			strokeMatrix, addPoint, isArea) {
		var curve2 = segment.getCurve(),
			curve1 = curve2.getPrevious(),
			point = curve2.getPoint1().transform(matrix),
			normal1 = curve1.getNormalAtTime(1).multiply(radius)
				.transform(strokeMatrix),
			normal2 = curve2.getNormalAtTime(0).multiply(radius)
				.transform(strokeMatrix),
				angle = normal1.getDirectedAngle(normal2);
		if (angle < 0 || angle >= 180) {
			normal1 = normal1.negate();
			normal2 = normal2.negate();
		}
		if (isArea)
			addPoint(point);
		addPoint(point.add(normal1));
		if (join === 'miter') {
			var corner = new Line(point.add(normal1),
					new Point(-normal1.y, normal1.x), true
				).intersect(new Line(point.add(normal2),
					new Point(-normal2.y, normal2.x), true
				), true);
			if (corner && point.getDistance(corner) <= miterLimit * radius) {
				addPoint(corner);
			}
		}
		addPoint(point.add(normal2));
	},

	_addSquareCap: function(segment, cap, radius, matrix, strokeMatrix,
			addPoint, isArea) {
		var point = segment._point.transform(matrix),
			loc = segment.getLocation(),
			normal = loc.getNormal()
					.multiply(loc.getTime() === 0 ? radius : -radius)
					.transform(strokeMatrix);
		if (cap === 'square') {
			if (isArea) {
				addPoint(point.subtract(normal));
				addPoint(point.add(normal));
			}
			point = point.add(normal.rotate(-90));
		}
		addPoint(point.add(normal));
		addPoint(point.subtract(normal));
	},

	getHandleBounds: function(segments, closed, path, matrix, options) {
		var style = path.getStyle(),
			stroke = options.stroke && style.hasStroke(),
			strokePadding,
			joinPadding;
		if (stroke) {
			var strokeMatrix = path._getStrokeMatrix(matrix, options),
				strokeRadius = style.getStrokeWidth() / 2,
				joinRadius = strokeRadius;
			if (style.getStrokeJoin() === 'miter')
				joinRadius = strokeRadius * style.getMiterLimit();
			if (style.getStrokeCap() === 'square')
				joinRadius = Math.max(joinRadius, strokeRadius * Math.SQRT2);
			strokePadding = Path._getStrokePadding(strokeRadius, strokeMatrix);
			joinPadding = Path._getStrokePadding(joinRadius, strokeMatrix);
		}
		var coords = new Array(6),
			x1 = Infinity,
			x2 = -x1,
			y1 = x1,
			y2 = x2;
		for (var i = 0, l = segments.length; i < l; i++) {
			var segment = segments[i];
			segment._transformCoordinates(matrix, coords);
			for (var j = 0; j < 6; j += 2) {
				var padding = !j ? joinPadding : strokePadding,
					paddingX = padding ? padding[0] : 0,
					paddingY = padding ? padding[1] : 0,
					x = coords[j],
					y = coords[j + 1],
					xn = x - paddingX,
					xx = x + paddingX,
					yn = y - paddingY,
					yx = y + paddingY;
				if (xn < x1) x1 = xn;
				if (xx > x2) x2 = xx;
				if (yn < y1) y1 = yn;
				if (yx > y2) y2 = yx;
			}
		}
		return new Rectangle(x1, y1, x2 - x1, y2 - y1);
	}
}});

Path.inject({ statics: new function() {

	var kappa = 0.5522847498307936,
		ellipseSegments = [
			new Segment([-1, 0], [0, kappa ], [0, -kappa]),
			new Segment([0, -1], [-kappa, 0], [kappa, 0 ]),
			new Segment([1, 0], [0, -kappa], [0, kappa ]),
			new Segment([0, 1], [kappa, 0 ], [-kappa, 0])
		];

	function createPath(segments, closed, args) {
		var props = Base.getNamed(args),
			path = new Path(props && (
				props.insert == true ? Item.INSERT
				: props.insert == false ? Item.NO_INSERT
				: null
			));
		path._add(segments);
		path._closed = closed;
		return path.set(props, Item.INSERT);
	}

	function createEllipse(center, radius, args) {
		var segments = new Array(4);
		for (var i = 0; i < 4; i++) {
			var segment = ellipseSegments[i];
			segments[i] = new Segment(
				segment._point.multiply(radius).add(center),
				segment._handleIn.multiply(radius),
				segment._handleOut.multiply(radius)
			);
		}
		return createPath(segments, true, args);
	}

	return {
		Line: function() {
			var args = arguments;
			return createPath([
				new Segment(Point.readNamed(args, 'from')),
				new Segment(Point.readNamed(args, 'to'))
			], false, args);
		},

		Circle: function() {
			var args = arguments,
				center = Point.readNamed(args, 'center'),
				radius = Base.readNamed(args, 'radius');
			return createEllipse(center, new Size(radius), args);
		},

		Rectangle: function() {
			var args = arguments,
				rect = Rectangle.readNamed(args, 'rectangle'),
				radius = Size.readNamed(args, 'radius', 0,
						{ readNull: true }),
				bl = rect.getBottomLeft(true),
				tl = rect.getTopLeft(true),
				tr = rect.getTopRight(true),
				br = rect.getBottomRight(true),
				segments;
			if (!radius || radius.isZero()) {
				segments = [
					new Segment(bl),
					new Segment(tl),
					new Segment(tr),
					new Segment(br)
				];
			} else {
				radius = Size.min(radius, rect.getSize(true).divide(2));
				var rx = radius.width,
					ry = radius.height,
					hx = rx * kappa,
					hy = ry * kappa;
				segments = [
					new Segment(bl.add(rx, 0), null, [-hx, 0]),
					new Segment(bl.subtract(0, ry), [0, hy]),
					new Segment(tl.add(0, ry), null, [0, -hy]),
					new Segment(tl.add(rx, 0), [-hx, 0], null),
					new Segment(tr.subtract(rx, 0), null, [hx, 0]),
					new Segment(tr.add(0, ry), [0, -hy], null),
					new Segment(br.subtract(0, ry), null, [0, hy]),
					new Segment(br.subtract(rx, 0), [hx, 0])
				];
			}
			return createPath(segments, true, args);
		},

		RoundRectangle: '#Rectangle',

		Ellipse: function() {
			var args = arguments,
				ellipse = Shape._readEllipse(args);
			return createEllipse(ellipse.center, ellipse.radius, args);
		},

		Oval: '#Ellipse',

		Arc: function() {
			var args = arguments,
				from = Point.readNamed(args, 'from'),
				through = Point.readNamed(args, 'through'),
				to = Point.readNamed(args, 'to'),
				props = Base.getNamed(args),
				path = new Path(props && props.insert == false
						&& Item.NO_INSERT);
			path.moveTo(from);
			path.arcTo(through, to);
			return path.set(props);
		},

		RegularPolygon: function() {
			var args = arguments,
				center = Point.readNamed(args, 'center'),
				sides = Base.readNamed(args, 'sides'),
				radius = Base.readNamed(args, 'radius'),
				step = 360 / sides,
				three = sides % 3 === 0,
				vector = new Point(0, three ? -radius : radius),
				offset = three ? -1 : 0.5,
				segments = new Array(sides);
			for (var i = 0; i < sides; i++)
				segments[i] = new Segment(center.add(
					vector.rotate((i + offset) * step)));
			return createPath(segments, true, args);
		},

		Star: function() {
			var args = arguments,
				center = Point.readNamed(args, 'center'),
				points = Base.readNamed(args, 'points') * 2,
				radius1 = Base.readNamed(args, 'radius1'),
				radius2 = Base.readNamed(args, 'radius2'),
				step = 360 / points,
				vector = new Point(0, -1),
				segments = new Array(points);
			for (var i = 0; i < points; i++)
				segments[i] = new Segment(center.add(vector.rotate(step * i)
						.multiply(i % 2 ? radius2 : radius1)));
			return createPath(segments, true, args);
		}
	};
}});

var CompoundPath = PathItem.extend({
	_class: 'CompoundPath',
	_serializeFields: {
		children: []
	},
	beans: true,

	initialize: function CompoundPath(arg) {
		this._children = [];
		this._namedChildren = {};
		if (!this._initialize(arg)) {
			if (typeof arg === 'string') {
				this.setPathData(arg);
			} else {
				this.addChildren(Array.isArray(arg) ? arg : arguments);
			}
		}
	},

	insertChildren: function insertChildren(index, items) {
		var list = items,
			first = list[0];
		if (first && typeof first[0] === 'number')
			list = [list];
		for (var i = items.length - 1; i >= 0; i--) {
			var item = list[i];
			if (list === items && !(item instanceof Path))
				list = Base.slice(list);
			if (Array.isArray(item)) {
				list[i] = new Path({ segments: item, insert: false });
			} else if (item instanceof CompoundPath) {
				list.splice.apply(list, [i, 1].concat(item.removeChildren()));
				item.remove();
			}
		}
		return insertChildren.base.call(this, index, list);
	},

	reduce: function reduce(options) {
		var children = this._children;
		for (var i = children.length - 1; i >= 0; i--) {
			var path = children[i].reduce(options);
			if (path.isEmpty())
				path.remove();
		}
		if (!children.length) {
			var path = new Path(Item.NO_INSERT);
			path.copyAttributes(this);
			path.insertAbove(this);
			this.remove();
			return path;
		}
		return reduce.base.call(this);
	},

	isClosed: function() {
		var children = this._children;
		for (var i = 0, l = children.length; i < l; i++) {
			if (!children[i]._closed)
				return false;
		}
		return true;
	},

	setClosed: function(closed) {
		var children = this._children;
		for (var i = 0, l = children.length; i < l; i++) {
			children[i].setClosed(closed);
		}
	},

	getFirstSegment: function() {
		var first = this.getFirstChild();
		return first && first.getFirstSegment();
	},

	getLastSegment: function() {
		var last = this.getLastChild();
		return last && last.getLastSegment();
	},

	getCurves: function() {
		var children = this._children,
			curves = [];
		for (var i = 0, l = children.length; i < l; i++) {
			Base.push(curves, children[i].getCurves());
		}
		return curves;
	},

	getFirstCurve: function() {
		var first = this.getFirstChild();
		return first && first.getFirstCurve();
	},

	getLastCurve: function() {
		var last = this.getLastChild();
		return last && last.getLastCurve();
	},

	getArea: function() {
		var children = this._children,
			area = 0;
		for (var i = 0, l = children.length; i < l; i++)
			area += children[i].getArea();
		return area;
	},

	getLength: function() {
		var children = this._children,
			length = 0;
		for (var i = 0, l = children.length; i < l; i++)
			length += children[i].getLength();
		return length;
	},

	getPathData: function(_matrix, _precision) {
		var children = this._children,
			paths = [];
		for (var i = 0, l = children.length; i < l; i++) {
			var child = children[i],
				mx = child._matrix;
			paths.push(child.getPathData(_matrix && !mx.isIdentity()
					? _matrix.appended(mx) : _matrix, _precision));
		}
		return paths.join('');
	},

	_hitTestChildren: function _hitTestChildren(point, options, viewMatrix) {
		return _hitTestChildren.base.call(this, point,
				options.class === Path || options.type === 'path' ? options
					: Base.set({}, options, { fill: false }),
				viewMatrix);
	},

	_draw: function(ctx, param, viewMatrix, strokeMatrix) {
		var children = this._children;
		if (!children.length)
			return;

		param = param.extend({ dontStart: true, dontFinish: true });
		ctx.beginPath();
		for (var i = 0, l = children.length; i < l; i++)
			children[i].draw(ctx, param, strokeMatrix);

		if (!param.clip) {
			this._setStyles(ctx, param, viewMatrix);
			var style = this._style;
			if (style.hasFill()) {
				ctx.fill(style.getFillRule());
				ctx.shadowColor = 'rgba(0,0,0,0)';
			}
			if (style.hasStroke())
				ctx.stroke();
		}
	},

	_drawSelected: function(ctx, matrix, selectionItems) {
		var children = this._children;
		for (var i = 0, l = children.length; i < l; i++) {
			var child = children[i],
				mx = child._matrix;
			if (!selectionItems[child._id]) {
				child._drawSelected(ctx, mx.isIdentity() ? matrix
						: matrix.appended(mx));
			}
		}
	}
},
new function() {
	function getCurrentPath(that, check) {
		var children = that._children;
		if (check && !children.length)
			throw new Error('Use a moveTo() command first');
		return children[children.length - 1];
	}

	return Base.each(['lineTo', 'cubicCurveTo', 'quadraticCurveTo', 'curveTo',
			'arcTo', 'lineBy', 'cubicCurveBy', 'quadraticCurveBy', 'curveBy',
			'arcBy'],
		function(key) {
			this[key] = function() {
				var path = getCurrentPath(this, true);
				path[key].apply(path, arguments);
			};
		}, {
			moveTo: function() {
				var current = getCurrentPath(this),
					path = current && current.isEmpty() ? current
							: new Path(Item.NO_INSERT);
				if (path !== current)
					this.addChild(path);
				path.moveTo.apply(path, arguments);
			},

			moveBy: function() {
				var current = getCurrentPath(this, true),
					last = current && current.getLastSegment(),
					point = Point.read(arguments);
				this.moveTo(last ? point.add(last._point) : point);
			},

			closePath: function(tolerance) {
				getCurrentPath(this, true).closePath(tolerance);
			}
		}
	);
}, Base.each(['reverse', 'flatten', 'simplify', 'smooth'], function(key) {
	this[key] = function(param) {
		var children = this._children,
			res;
		for (var i = 0, l = children.length; i < l; i++) {
			res = children[i][key](param) || res;
		}
		return res;
	};
}, {}));

PathItem.inject(new function() {
	var min = Math.min,
		max = Math.max,
		abs = Math.abs,
		operators = {
			unite:     { '1': true, '2': true },
			intersect: { '2': true },
			subtract:  { '1': true },
			exclude:   { '1': true, '-1': true }
		};

	function getPaths(path) {
		return path._children || [path];
	}

	function preparePath(path, resolve) {
		var res = path
			.clone(false)
			.reduce({ simplify: true })
			.transform(null, true, true);
		if (resolve) {
			var paths = getPaths(res);
			for (var i = 0, l = paths.length; i < l; i++) {
				var path = paths[i];
				if (!path._closed && !path.isEmpty()) {
					path.closePath(1e-12);
					path.getFirstSegment().setHandleIn(0, 0);
					path.getLastSegment().setHandleOut(0, 0);
				}
			}
			res = res
				.resolveCrossings()
				.reorient(res.getFillRule() === 'nonzero', true);
		}
		return res;
	}

	function createResult(paths, simplify, path1, path2, options) {
		var result = new CompoundPath(Item.NO_INSERT);
		result.addChildren(paths, true);
		result = result.reduce({ simplify: simplify });
		if (!(options && options.insert == false)) {
			result.insertAbove(path2 && path1.isSibling(path2)
					&& path1.getIndex() < path2.getIndex() ? path2 : path1);
		}
		result.copyAttributes(path1, true);
		return result;
	}

	function filterIntersection(inter) {
		return inter.hasOverlap() || inter.isCrossing();
	}

	function traceBoolean(path1, path2, operation, options) {
		if (options && (options.trace == false || options.stroke) &&
				/^(subtract|intersect)$/.test(operation))
			return splitBoolean(path1, path2, operation);
		var _path1 = preparePath(path1, true),
			_path2 = path2 && path1 !== path2 && preparePath(path2, true),
			operator = operators[operation];
		operator[operation] = true;
		if (_path2 && (operator.subtract || operator.exclude)
				^ (_path2.isClockwise() ^ _path1.isClockwise()))
			_path2.reverse();
		var crossings = divideLocations(CurveLocation.expand(
				_path1.getIntersections(_path2, filterIntersection))),
			paths1 = getPaths(_path1),
			paths2 = _path2 && getPaths(_path2),
			segments = [],
			curves = [],
			paths;

		function collectPaths(paths) {
			for (var i = 0, l = paths.length; i < l; i++) {
				var path = paths[i];
				Base.push(segments, path._segments);
				Base.push(curves, path.getCurves());
				path._overlapsOnly = true;
			}
		}

		function getCurves(indices) {
			var list = [];
			for (var i = 0, l = indices && indices.length; i < l; i++) {
				list.push(curves[indices[i]]);
			}
			return list;
		}

		if (crossings.length) {
			collectPaths(paths1);
			if (paths2)
				collectPaths(paths2);

			var curvesValues = new Array(curves.length);
			for (var i = 0, l = curves.length; i < l; i++) {
				curvesValues[i] = curves[i].getValues();
			}
			var curveCollisions = CollisionDetection.findCurveBoundsCollisions(
					curvesValues, curvesValues, 0, true);
			var curveCollisionsMap = {};
			for (var i = 0; i < curves.length; i++) {
				var curve = curves[i],
					id = curve._path._id,
					map = curveCollisionsMap[id] = curveCollisionsMap[id] || {};
				map[curve.getIndex()] = {
					hor: getCurves(curveCollisions[i].hor),
					ver: getCurves(curveCollisions[i].ver)
				};
			}

			for (var i = 0, l = crossings.length; i < l; i++) {
				propagateWinding(crossings[i]._segment, _path1, _path2,
						curveCollisionsMap, operator);
			}
			for (var i = 0, l = segments.length; i < l; i++) {
				var segment = segments[i],
					inter = segment._intersection;
				if (!segment._winding) {
					propagateWinding(segment, _path1, _path2,
							curveCollisionsMap, operator);
				}
				if (!(inter && inter._overlap))
					segment._path._overlapsOnly = false;
			}
			paths = tracePaths(segments, operator);
		} else {
			paths = reorientPaths(
					paths2 ? paths1.concat(paths2) : paths1.slice(),
					function(w) {
						return !!operator[w];
					});
		}
		return createResult(paths, true, path1, path2, options);
	}

	function splitBoolean(path1, path2, operation) {
		var _path1 = preparePath(path1),
			_path2 = preparePath(path2),
			crossings = _path1.getIntersections(_path2, filterIntersection),
			subtract = operation === 'subtract',
			divide = operation === 'divide',
			added = {},
			paths = [];

		function addPath(path) {
			if (!added[path._id] && (divide ||
					_path2.contains(path.getPointAt(path.getLength() / 2))
						^ subtract)) {
				paths.unshift(path);
				return added[path._id] = true;
			}
		}

		for (var i = crossings.length - 1; i >= 0; i--) {
			var path = crossings[i].split();
			if (path) {
				if (addPath(path))
					path.getFirstSegment().setHandleIn(0, 0);
				_path1.getLastSegment().setHandleOut(0, 0);
			}
		}
		addPath(_path1);
		return createResult(paths, false, path1, path2);
	}

	function linkIntersections(from, to) {
		var prev = from;
		while (prev) {
			if (prev === to)
				return;
			prev = prev._previous;
		}
		while (from._next && from._next !== to)
			from = from._next;
		if (!from._next) {
			while (to._previous)
				to = to._previous;
			from._next = to;
			to._previous = from;
		}
	}

	function clearCurveHandles(curves) {
		for (var i = curves.length - 1; i >= 0; i--)
			curves[i].clearHandles();
	}

	function reorientPaths(paths, isInside, clockwise) {
		var length = paths && paths.length;
		if (length) {
			var lookup = Base.each(paths, function (path, i) {
					this[path._id] = {
						container: null,
						winding: path.isClockwise() ? 1 : -1,
						index: i
					};
				}, {}),
				sorted = paths.slice().sort(function (a, b) {
					return abs(b.getArea()) - abs(a.getArea());
				}),
				first = sorted[0];
			var collisions = CollisionDetection.findItemBoundsCollisions(sorted,
					null, Numerical.GEOMETRIC_EPSILON);
			if (clockwise == null)
				clockwise = first.isClockwise();
			for (var i = 0; i < length; i++) {
				var path1 = sorted[i],
					entry1 = lookup[path1._id],
					containerWinding = 0,
					indices = collisions[i];
				if (indices) {
					var point = null;
					for (var j = indices.length - 1; j >= 0; j--) {
						if (indices[j] < i) {
							point = point || path1.getInteriorPoint();
							var path2 = sorted[indices[j]];
							if (path2.contains(point)) {
								var entry2 = lookup[path2._id];
								containerWinding = entry2.winding;
								entry1.winding += containerWinding;
								entry1.container = entry2.exclude
									? entry2.container : path2;
								break;
							}
						}
					}
				}
				if (isInside(entry1.winding) === isInside(containerWinding)) {
					entry1.exclude = true;
					paths[entry1.index] = null;
				} else {
					var container = entry1.container;
					path1.setClockwise(
							container ? !container.isClockwise() : clockwise);
				}
			}
		}
		return paths;
	}

	function divideLocations(locations, include, clearLater) {
		var results = include && [],
			tMin = 1e-8,
			tMax = 1 - tMin,
			clearHandles = false,
			clearCurves = clearLater || [],
			clearLookup = clearLater && {},
			renormalizeLocs,
			prevCurve,
			prevTime;

		function getId(curve) {
			return curve._path._id + '.' + curve._segment1._index;
		}

		for (var i = (clearLater && clearLater.length) - 1; i >= 0; i--) {
			var curve = clearLater[i];
			if (curve._path)
				clearLookup[getId(curve)] = true;
		}

		for (var i = locations.length - 1; i >= 0; i--) {
			var loc = locations[i],
				time = loc._time,
				origTime = time,
				exclude = include && !include(loc),
				curve = loc._curve,
				segment;
			if (curve) {
				if (curve !== prevCurve) {
					clearHandles = !curve.hasHandles()
							|| clearLookup && clearLookup[getId(curve)];
					renormalizeLocs = [];
					prevTime = null;
					prevCurve = curve;
				} else if (prevTime >= tMin) {
					time /= prevTime;
				}
			}
			if (exclude) {
				if (renormalizeLocs)
					renormalizeLocs.push(loc);
				continue;
			} else if (include) {
				results.unshift(loc);
			}
			prevTime = origTime;
			if (time < tMin) {
				segment = curve._segment1;
			} else if (time > tMax) {
				segment = curve._segment2;
			} else {
				var newCurve = curve.divideAtTime(time, true);
				if (clearHandles)
					clearCurves.push(curve, newCurve);
				segment = newCurve._segment1;
				for (var j = renormalizeLocs.length - 1; j >= 0; j--) {
					var l = renormalizeLocs[j];
					l._time = (l._time - time) / (1 - time);
				}
			}
			loc._setSegment(segment);
			var inter = segment._intersection,
				dest = loc._intersection;
			if (inter) {
				linkIntersections(inter, dest);
				var other = inter;
				while (other) {
					linkIntersections(other._intersection, inter);
					other = other._next;
				}
			} else {
				segment._intersection = dest;
			}
		}
		if (!clearLater)
			clearCurveHandles(clearCurves);
		return results || locations;
	}

	function getWinding(point, curves, dir, closed, dontFlip) {
		var curvesList = Array.isArray(curves)
			? curves
			: curves[dir ? 'hor' : 'ver'];
		var ia = dir ? 1 : 0,
			io = ia ^ 1,
			pv = [point.x, point.y],
			pa = pv[ia],
			po = pv[io],
			windingEpsilon = 1e-9,
			qualityEpsilon = 1e-6,
			paL = pa - windingEpsilon,
			paR = pa + windingEpsilon,
			windingL = 0,
			windingR = 0,
			pathWindingL = 0,
			pathWindingR = 0,
			onPath = false,
			onAnyPath = false,
			quality = 1,
			roots = [],
			vPrev,
			vClose;

		function addWinding(v) {
			var o0 = v[io + 0],
				o3 = v[io + 6];
			if (po < min(o0, o3) || po > max(o0, o3)) {
				return;
			}
			var a0 = v[ia + 0],
				a1 = v[ia + 2],
				a2 = v[ia + 4],
				a3 = v[ia + 6];
			if (o0 === o3) {
				if (a0 < paR && a3 > paL || a3 < paR && a0 > paL) {
					onPath = true;
				}
				return;
			}
			var t =   po === o0 ? 0
					: po === o3 ? 1
					: paL > max(a0, a1, a2, a3) || paR < min(a0, a1, a2, a3)
					? 1
					: Curve.solveCubic(v, io, po, roots, 0, 1) > 0
						? roots[0]
						: 1,
				a =   t === 0 ? a0
					: t === 1 ? a3
					: Curve.getPoint(v, t)[dir ? 'y' : 'x'],
				winding = o0 > o3 ? 1 : -1,
				windingPrev = vPrev[io] > vPrev[io + 6] ? 1 : -1,
				a3Prev = vPrev[ia + 6];
			if (po !== o0) {
				if (a < paL) {
					pathWindingL += winding;
				} else if (a > paR) {
					pathWindingR += winding;
				} else {
					onPath = true;
				}
				if (a > pa - qualityEpsilon && a < pa + qualityEpsilon)
					quality /= 2;
			} else {
				if (winding !== windingPrev) {
					if (a0 < paL) {
						pathWindingL += winding;
					} else if (a0 > paR) {
						pathWindingR += winding;
					}
				} else if (a0 != a3Prev) {
					if (a3Prev < paR && a > paR) {
						pathWindingR += winding;
						onPath = true;
					} else if (a3Prev > paL && a < paL) {
						pathWindingL += winding;
						onPath = true;
					}
				}
				quality /= 4;
			}
			vPrev = v;
			return !dontFlip && a > paL && a < paR
					&& Curve.getTangent(v, t)[dir ? 'x' : 'y'] === 0
					&& getWinding(point, curves, !dir, closed, true);
		}

		function handleCurve(v) {
			var o0 = v[io + 0],
				o1 = v[io + 2],
				o2 = v[io + 4],
				o3 = v[io + 6];
			if (po <= max(o0, o1, o2, o3) && po >= min(o0, o1, o2, o3)) {
				var a0 = v[ia + 0],
					a1 = v[ia + 2],
					a2 = v[ia + 4],
					a3 = v[ia + 6],
					monoCurves = paL > max(a0, a1, a2, a3) ||
								 paR < min(a0, a1, a2, a3)
							? [v] : Curve.getMonoCurves(v, dir),
					res;
				for (var i = 0, l = monoCurves.length; i < l; i++) {
					if (res = addWinding(monoCurves[i]))
						return res;
				}
			}
		}

		for (var i = 0, l = curvesList.length; i < l; i++) {
			var curve = curvesList[i],
				path = curve._path,
				v = curve.getValues(),
				res;
			if (!i || curvesList[i - 1]._path !== path) {
				vPrev = null;
				if (!path._closed) {
					vClose = Curve.getValues(
							path.getLastCurve().getSegment2(),
							curve.getSegment1(),
							null, !closed);
					if (vClose[io] !== vClose[io + 6]) {
						vPrev = vClose;
					}
				}

				if (!vPrev) {
					vPrev = v;
					var prev = path.getLastCurve();
					while (prev && prev !== curve) {
						var v2 = prev.getValues();
						if (v2[io] !== v2[io + 6]) {
							vPrev = v2;
							break;
						}
						prev = prev.getPrevious();
					}
				}
			}

			if (res = handleCurve(v))
				return res;

			if (i + 1 === l || curvesList[i + 1]._path !== path) {
				if (vClose && (res = handleCurve(vClose)))
					return res;
				if (onPath && !pathWindingL && !pathWindingR) {
					pathWindingL = pathWindingR = path.isClockwise(closed) ^ dir
							? 1 : -1;
				}
				windingL += pathWindingL;
				windingR += pathWindingR;
				pathWindingL = pathWindingR = 0;
				if (onPath) {
					onAnyPath = true;
					onPath = false;
				}
				vClose = null;
			}
		}
		windingL = abs(windingL);
		windingR = abs(windingR);
		return {
			winding: max(windingL, windingR),
			windingL: windingL,
			windingR: windingR,
			quality: quality,
			onPath: onAnyPath
		};
	}

	function propagateWinding(segment, path1, path2, curveCollisionsMap,
			operator) {
		var chain = [],
			start = segment,
			totalLength = 0,
			winding;
		do {
			var curve = segment.getCurve();
			if (curve) {
				var length = curve.getLength();
				chain.push({ segment: segment, curve: curve, length: length });
				totalLength += length;
			}
			segment = segment.getNext();
		} while (segment && !segment._intersection && segment !== start);
		var offsets = [0.5, 0.25, 0.75],
			winding = { winding: 0, quality: -1 },
			tMin = 1e-3,
			tMax = 1 - tMin;
		for (var i = 0; i < offsets.length && winding.quality < 0.5; i++) {
			var length = totalLength * offsets[i];
			for (var j = 0, l = chain.length; j < l; j++) {
				var entry = chain[j],
					curveLength = entry.length;
				if (length <= curveLength) {
					var curve = entry.curve,
						path = curve._path,
						parent = path._parent,
						operand = parent instanceof CompoundPath ? parent : path,
						t = Numerical.clamp(curve.getTimeAt(length), tMin, tMax),
						pt = curve.getPointAtTime(t),
						dir = abs(curve.getTangentAtTime(t).y) < Math.SQRT1_2;
					var wind = null;
					if (operator.subtract && path2) {
						var otherPath = operand === path1 ? path2 : path1,
							pathWinding = otherPath._getWinding(pt, dir, true);
						if (operand === path1 && pathWinding.winding ||
							operand === path2 && !pathWinding.winding) {
							if (pathWinding.quality < 1) {
								continue;
							} else {
								wind = { winding: 0, quality: 1 };
							}
						}
					}
					wind =  wind || getWinding(
							pt, curveCollisionsMap[path._id][curve.getIndex()],
							dir, true);
					if (wind.quality > winding.quality)
						winding = wind;
					break;
				}
				length -= curveLength;
			}
		}
		for (var j = chain.length - 1; j >= 0; j--) {
			chain[j].segment._winding = winding;
		}
	}

	function tracePaths(segments, operator) {
		var paths = [],
			starts;

		function isValid(seg) {
			var winding;
			return !!(seg && !seg._visited && (!operator
					|| operator[(winding = seg._winding || {}).winding]
						&& !(operator.unite && winding.winding === 2
							&& winding.windingL && winding.windingR)));
		}

		function isStart(seg) {
			if (seg) {
				for (var i = 0, l = starts.length; i < l; i++) {
					if (seg === starts[i])
						return true;
				}
			}
			return false;
		}

		function visitPath(path) {
			var segments = path._segments;
			for (var i = 0, l = segments.length; i < l; i++) {
				segments[i]._visited = true;
			}
		}

		function getCrossingSegments(segment, collectStarts) {
			var inter = segment._intersection,
				start = inter,
				crossings = [];
			if (collectStarts)
				starts = [segment];

			function collect(inter, end) {
				while (inter && inter !== end) {
					var other = inter._segment,
						path = other && other._path;
					if (path) {
						var next = other.getNext() || path.getFirstSegment(),
							nextInter = next._intersection;
						if (other !== segment && (isStart(other)
							|| isStart(next)
							|| next && (isValid(other) && (isValid(next)
								|| nextInter && isValid(nextInter._segment))))
						) {
							crossings.push(other);
						}
						if (collectStarts)
							starts.push(other);
					}
					inter = inter._next;
				}
			}

			if (inter) {
				collect(inter);
				while (inter && inter._previous)
					inter = inter._previous;
				collect(inter, start);
			}
			return crossings;
		}

		segments.sort(function(seg1, seg2) {
			var inter1 = seg1._intersection,
				inter2 = seg2._intersection,
				over1 = !!(inter1 && inter1._overlap),
				over2 = !!(inter2 && inter2._overlap),
				path1 = seg1._path,
				path2 = seg2._path;
			return over1 ^ over2
					? over1 ? 1 : -1
					: !inter1 ^ !inter2
						? inter1 ? 1 : -1
						: path1 !== path2
							? path1._id - path2._id
							: seg1._index - seg2._index;
		});

		for (var i = 0, l = segments.length; i < l; i++) {
			var seg = segments[i],
				valid = isValid(seg),
				path = null,
				finished = false,
				closed = true,
				branches = [],
				branch,
				visited,
				handleIn;
			if (valid && seg._path._overlapsOnly) {
				var path1 = seg._path,
					path2 = seg._intersection._segment._path;
				if (path1.compare(path2)) {
					if (path1.getArea())
						paths.push(path1.clone(false));
					visitPath(path1);
					visitPath(path2);
					valid = false;
				}
			}
			while (valid) {
				var first = !path,
					crossings = getCrossingSegments(seg, first),
					other = crossings.shift(),
					finished = !first && (isStart(seg) || isStart(other)),
					cross = !finished && other;
				if (first) {
					path = new Path(Item.NO_INSERT);
					branch = null;
				}
				if (finished) {
					if (seg.isFirst() || seg.isLast())
						closed = seg._path._closed;
					seg._visited = true;
					break;
				}
				if (cross && branch) {
					branches.push(branch);
					branch = null;
				}
				if (!branch) {
					if (cross)
						crossings.push(seg);
					branch = {
						start: path._segments.length,
						crossings: crossings,
						visited: visited = [],
						handleIn: handleIn
					};
				}
				if (cross)
					seg = other;
				if (!isValid(seg)) {
					path.removeSegments(branch.start);
					for (var j = 0, k = visited.length; j < k; j++) {
						visited[j]._visited = false;
					}
					visited.length = 0;
					do {
						seg = branch && branch.crossings.shift();
						if (!seg || !seg._path) {
							seg = null;
							branch = branches.pop();
							if (branch) {
								visited = branch.visited;
								handleIn = branch.handleIn;
							}
						}
					} while (branch && !isValid(seg));
					if (!seg)
						break;
				}
				var next = seg.getNext();
				path.add(new Segment(seg._point, handleIn,
						next && seg._handleOut));
				seg._visited = true;
				visited.push(seg);
				seg = next || seg._path.getFirstSegment();
				handleIn = next && next._handleIn;
			}
			if (finished) {
				if (closed) {
					path.getFirstSegment().setHandleIn(handleIn);
					path.setClosed(closed);
				}
				if (path.getArea() !== 0) {
					paths.push(path);
				}
			}
		}
		return paths;
	}

	return {
		_getWinding: function(point, dir, closed) {
			return getWinding(point, this.getCurves(), dir, closed);
		},

		unite: function(path, options) {
			return traceBoolean(this, path, 'unite', options);
		},

		intersect: function(path, options) {
			return traceBoolean(this, path, 'intersect', options);
		},

		subtract: function(path, options) {
			return traceBoolean(this, path, 'subtract', options);
		},

		exclude: function(path, options) {
			return traceBoolean(this, path, 'exclude', options);
		},

		divide: function(path, options) {
			return options && (options.trace == false || options.stroke)
					? splitBoolean(this, path, 'divide')
					: createResult([
						this.subtract(path, options),
						this.intersect(path, options)
					], true, this, path, options);
		},

		resolveCrossings: function() {
			var children = this._children,
				paths = children || [this];

			function hasOverlap(seg, path) {
				var inter = seg && seg._intersection;
				return inter && inter._overlap && inter._path === path;
			}

			var hasOverlaps = false,
				hasCrossings = false,
				intersections = this.getIntersections(null, function(inter) {
					return inter.hasOverlap() && (hasOverlaps = true) ||
							inter.isCrossing() && (hasCrossings = true);
				}),
				clearCurves = hasOverlaps && hasCrossings && [];
			intersections = CurveLocation.expand(intersections);
			if (hasOverlaps) {
				var overlaps = divideLocations(intersections, function(inter) {
					return inter.hasOverlap();
				}, clearCurves);
				for (var i = overlaps.length - 1; i >= 0; i--) {
					var overlap = overlaps[i],
						path = overlap._path,
						seg = overlap._segment,
						prev = seg.getPrevious(),
						next = seg.getNext();
					if (hasOverlap(prev, path) && hasOverlap(next, path)) {
						seg.remove();
						prev._handleOut._set(0, 0);
						next._handleIn._set(0, 0);
						if (prev !== seg && !prev.getCurve().hasLength()) {
							next._handleIn.set(prev._handleIn);
							prev.remove();
						}
					}
				}
			}
			if (hasCrossings) {
				divideLocations(intersections, hasOverlaps && function(inter) {
					var curve1 = inter.getCurve(),
						seg1 = inter.getSegment(),
						other = inter._intersection,
						curve2 = other._curve,
						seg2 = other._segment;
					if (curve1 && curve2 && curve1._path && curve2._path)
						return true;
					if (seg1)
						seg1._intersection = null;
					if (seg2)
						seg2._intersection = null;
				}, clearCurves);
				if (clearCurves)
					clearCurveHandles(clearCurves);
				paths = tracePaths(Base.each(paths, function(path) {
					Base.push(this, path._segments);
				}, []));
			}
			var length = paths.length,
				item;
			if (length > 1 && children) {
				if (paths !== children)
					this.setChildren(paths);
				item = this;
			} else if (length === 1 && !children) {
				if (paths[0] !== this)
					this.setSegments(paths[0].removeSegments());
				item = this;
			}
			if (!item) {
				item = new CompoundPath(Item.NO_INSERT);
				item.addChildren(paths);
				item = item.reduce();
				item.copyAttributes(this);
				this.replaceWith(item);
			}
			return item;
		},

		reorient: function(nonZero, clockwise) {
			var children = this._children;
			if (children && children.length) {
				this.setChildren(reorientPaths(this.removeChildren(),
						function(w) {
							return !!(nonZero ? w : w & 1);
						},
						clockwise));
			} else if (clockwise !== undefined) {
				this.setClockwise(clockwise);
			}
			return this;
		},

		getInteriorPoint: function() {
			var bounds = this.getBounds(),
				point = bounds.getCenter(true);
			if (!this.contains(point)) {
				var curves = this.getCurves(),
					y = point.y,
					intercepts = [],
					roots = [];
				for (var i = 0, l = curves.length; i < l; i++) {
					var v = curves[i].getValues(),
						o0 = v[1],
						o1 = v[3],
						o2 = v[5],
						o3 = v[7];
					if (y >= min(o0, o1, o2, o3) && y <= max(o0, o1, o2, o3)) {
						var monoCurves = Curve.getMonoCurves(v);
						for (var j = 0, m = monoCurves.length; j < m; j++) {
							var mv = monoCurves[j],
								mo0 = mv[1],
								mo3 = mv[7];
							if ((mo0 !== mo3) &&
								(y >= mo0 && y <= mo3 || y >= mo3 && y <= mo0)){
								var x = y === mo0 ? mv[0]
									: y === mo3 ? mv[6]
									: Curve.solveCubic(mv, 1, y, roots, 0, 1)
										=== 1
										? Curve.getPoint(mv, roots[0]).x
										: (mv[0] + mv[6]) / 2;
								intercepts.push(x);
							}
						}
					}
				}
				if (intercepts.length > 1) {
					intercepts.sort(function(a, b) { return a - b; });
					point.x = (intercepts[0] + intercepts[1]) / 2;
				}
			}
			return point;
		}
	};
});

var PathFlattener = Base.extend({
	_class: 'PathFlattener',

	initialize: function(path, flatness, maxRecursion, ignoreStraight, matrix) {
		var curves = [],
			parts = [],
			length = 0,
			minSpan = 1 / (maxRecursion || 32),
			segments = path._segments,
			segment1 = segments[0],
			segment2;

		function addCurve(segment1, segment2) {
			var curve = Curve.getValues(segment1, segment2, matrix);
			curves.push(curve);
			computeParts(curve, segment1._index, 0, 1);
		}

		function computeParts(curve, index, t1, t2) {
			if ((t2 - t1) > minSpan
					&& !(ignoreStraight && Curve.isStraight(curve))
					&& !Curve.isFlatEnough(curve, flatness || 0.25)) {
				var halves = Curve.subdivide(curve, 0.5),
					tMid = (t1 + t2) / 2;
				computeParts(halves[0], index, t1, tMid);
				computeParts(halves[1], index, tMid, t2);
			} else {
				var dx = curve[6] - curve[0],
					dy = curve[7] - curve[1],
					dist = Math.sqrt(dx * dx + dy * dy);
				if (dist > 0) {
					length += dist;
					parts.push({
						offset: length,
						curve: curve,
						index: index,
						time: t2,
					});
				}
			}
		}

		for (var i = 1, l = segments.length; i < l; i++) {
			segment2 = segments[i];
			addCurve(segment1, segment2);
			segment1 = segment2;
		}
		if (path._closed)
			addCurve(segment2 || segment1, segments[0]);
		this.curves = curves;
		this.parts = parts;
		this.length = length;
		this.index = 0;
	},

	_get: function(offset) {
		var parts = this.parts,
			length = parts.length,
			start,
			i, j = this.index;
		for (;;) {
			i = j;
			if (!j || parts[--j].offset < offset)
				break;
		}
		for (; i < length; i++) {
			var part = parts[i];
			if (part.offset >= offset) {
				this.index = i;
				var prev = parts[i - 1],
					prevTime = prev && prev.index === part.index ? prev.time : 0,
					prevOffset = prev ? prev.offset : 0;
				return {
					index: part.index,
					time: prevTime + (part.time - prevTime)
						* (offset - prevOffset) / (part.offset - prevOffset)
				};
			}
		}
		return {
			index: parts[length - 1].index,
			time: 1
		};
	},

	drawPart: function(ctx, from, to) {
		var start = this._get(from),
			end = this._get(to);
		for (var i = start.index, l = end.index; i <= l; i++) {
			var curve = Curve.getPart(this.curves[i],
					i === start.index ? start.time : 0,
					i === end.index ? end.time : 1);
			if (i === start.index)
				ctx.moveTo(curve[0], curve[1]);
			ctx.bezierCurveTo.apply(ctx, curve.slice(2));
		}
	}
}, Base.each(Curve._evaluateMethods,
	function(name) {
		this[name + 'At'] = function(offset) {
			var param = this._get(offset);
			return Curve[name](this.curves[param.index], param.time);
		};
	}, {})
);

var PathFitter = Base.extend({
	initialize: function(path) {
		var points = this.points = [],
			segments = path._segments,
			closed = path._closed;
		for (var i = 0, prev, l = segments.length; i < l; i++) {
			var point = segments[i].point;
			if (!prev || !prev.equals(point)) {
				points.push(prev = point.clone());
			}
		}
		if (closed) {
			points.unshift(points[points.length - 1]);
			points.push(points[1]);
		}
		this.closed = closed;
	},

	fit: function(error) {
		var points = this.points,
			length = points.length,
			segments = null;
		if (length > 0) {
			segments = [new Segment(points[0])];
			if (length > 1) {
				this.fitCubic(segments, error, 0, length - 1,
						points[1].subtract(points[0]),
						points[length - 2].subtract(points[length - 1]));
				if (this.closed) {
					segments.shift();
					segments.pop();
				}
			}
		}
		return segments;
	},

	fitCubic: function(segments, error, first, last, tan1, tan2) {
		var points = this.points;
		if (last - first === 1) {
			var pt1 = points[first],
				pt2 = points[last],
				dist = pt1.getDistance(pt2) / 3;
			this.addCurve(segments, [pt1, pt1.add(tan1.normalize(dist)),
					pt2.add(tan2.normalize(dist)), pt2]);
			return;
		}
		var uPrime = this.chordLengthParameterize(first, last),
			maxError = Math.max(error, error * error),
			split,
			parametersInOrder = true;
		for (var i = 0; i <= 4; i++) {
			var curve = this.generateBezier(first, last, uPrime, tan1, tan2);
			var max = this.findMaxError(first, last, curve, uPrime);
			if (max.error < error && parametersInOrder) {
				this.addCurve(segments, curve);
				return;
			}
			split = max.index;
			if (max.error >= maxError)
				break;
			parametersInOrder = this.reparameterize(first, last, uPrime, curve);
			maxError = max.error;
		}
		var tanCenter = points[split - 1].subtract(points[split + 1]);
		this.fitCubic(segments, error, first, split, tan1, tanCenter);
		this.fitCubic(segments, error, split, last, tanCenter.negate(), tan2);
	},

	addCurve: function(segments, curve) {
		var prev = segments[segments.length - 1];
		prev.setHandleOut(curve[1].subtract(curve[0]));
		segments.push(new Segment(curve[3], curve[2].subtract(curve[3])));
	},

	generateBezier: function(first, last, uPrime, tan1, tan2) {
		var epsilon = 1e-12,
			abs = Math.abs,
			points = this.points,
			pt1 = points[first],
			pt2 = points[last],
			C = [[0, 0], [0, 0]],
			X = [0, 0];

		for (var i = 0, l = last - first + 1; i < l; i++) {
			var u = uPrime[i],
				t = 1 - u,
				b = 3 * u * t,
				b0 = t * t * t,
				b1 = b * t,
				b2 = b * u,
				b3 = u * u * u,
				a1 = tan1.normalize(b1),
				a2 = tan2.normalize(b2),
				tmp = points[first + i]
					.subtract(pt1.multiply(b0 + b1))
					.subtract(pt2.multiply(b2 + b3));
			C[0][0] += a1.dot(a1);
			C[0][1] += a1.dot(a2);
			C[1][0] = C[0][1];
			C[1][1] += a2.dot(a2);
			X[0] += a1.dot(tmp);
			X[1] += a2.dot(tmp);
		}

		var detC0C1 = C[0][0] * C[1][1] - C[1][0] * C[0][1],
			alpha1,
			alpha2;
		if (abs(detC0C1) > epsilon) {
			var detC0X = C[0][0] * X[1]    - C[1][0] * X[0],
				detXC1 = X[0]    * C[1][1] - X[1]    * C[0][1];
			alpha1 = detXC1 / detC0C1;
			alpha2 = detC0X / detC0C1;
		} else {
			var c0 = C[0][0] + C[0][1],
				c1 = C[1][0] + C[1][1];
			alpha1 = alpha2 = abs(c0) > epsilon ? X[0] / c0
							: abs(c1) > epsilon ? X[1] / c1
							: 0;
		}

		var segLength = pt2.getDistance(pt1),
			eps = epsilon * segLength,
			handle1,
			handle2;
		if (alpha1 < eps || alpha2 < eps) {
			alpha1 = alpha2 = segLength / 3;
		} else {
			var line = pt2.subtract(pt1);
			handle1 = tan1.normalize(alpha1);
			handle2 = tan2.normalize(alpha2);
			if (handle1.dot(line) - handle2.dot(line) > segLength * segLength) {
				alpha1 = alpha2 = segLength / 3;
				handle1 = handle2 = null;
			}
		}

		return [pt1,
				pt1.add(handle1 || tan1.normalize(alpha1)),
				pt2.add(handle2 || tan2.normalize(alpha2)),
				pt2];
	},

	reparameterize: function(first, last, u, curve) {
		for (var i = first; i <= last; i++) {
			u[i - first] = this.findRoot(curve, this.points[i], u[i - first]);
		}
		for (var i = 1, l = u.length; i < l; i++) {
			if (u[i] <= u[i - 1])
				return false;
		}
		return true;
	},

	findRoot: function(curve, point, u) {
		var curve1 = [],
			curve2 = [];
		for (var i = 0; i <= 2; i++) {
			curve1[i] = curve[i + 1].subtract(curve[i]).multiply(3);
		}
		for (var i = 0; i <= 1; i++) {
			curve2[i] = curve1[i + 1].subtract(curve1[i]).multiply(2);
		}
		var pt = this.evaluate(3, curve, u),
			pt1 = this.evaluate(2, curve1, u),
			pt2 = this.evaluate(1, curve2, u),
			diff = pt.subtract(point),
			df = pt1.dot(pt1) + diff.dot(pt2);
		return Numerical.isMachineZero(df) ? u : u - diff.dot(pt1) / df;
	},

	evaluate: function(degree, curve, t) {
		var tmp = curve.slice();
		for (var i = 1; i <= degree; i++) {
			for (var j = 0; j <= degree - i; j++) {
				tmp[j] = tmp[j].multiply(1 - t).add(tmp[j + 1].multiply(t));
			}
		}
		return tmp[0];
	},

	chordLengthParameterize: function(first, last) {
		var u = [0];
		for (var i = first + 1; i <= last; i++) {
			u[i - first] = u[i - first - 1]
					+ this.points[i].getDistance(this.points[i - 1]);
		}
		for (var i = 1, m = last - first; i <= m; i++) {
			u[i] /= u[m];
		}
		return u;
	},

	findMaxError: function(first, last, curve, u) {
		var index = Math.floor((last - first + 1) / 2),
			maxDist = 0;
		for (var i = first + 1; i < last; i++) {
			var P = this.evaluate(3, curve, u[i - first]);
			var v = P.subtract(this.points[i]);
			var dist = v.x * v.x + v.y * v.y;
			if (dist >= maxDist) {
				maxDist = dist;
				index = i;
			}
		}
		return {
			error: maxDist,
			index: index
		};
	}
});

var TextItem = Item.extend({
	_class: 'TextItem',
	_applyMatrix: false,
	_canApplyMatrix: false,
	_serializeFields: {
		content: null
	},
	_boundsOptions: { stroke: false, handle: false },

	initialize: function TextItem(arg) {
		this._content = '';
		this._lines = [];
		var hasProps = arg && Base.isPlainObject(arg)
				&& arg.x === undefined && arg.y === undefined;
		this._initialize(hasProps && arg, !hasProps && Point.read(arguments));
	},

	_equals: function(item) {
		return this._content === item._content;
	},

	copyContent: function(source) {
		this.setContent(source._content);
	},

	getContent: function() {
		return this._content;
	},

	setContent: function(content) {
		this._content = '' + content;
		this._lines = this._content.split(/\r\n|\n|\r/mg);
		this._changed(521);
	},

	isEmpty: function() {
		return !this._content;
	},

	getCharacterStyle: '#getStyle',
	setCharacterStyle: '#setStyle',

	getParagraphStyle: '#getStyle',
	setParagraphStyle: '#setStyle'
});

var PointText = TextItem.extend({
	_class: 'PointText',

	initialize: function PointText() {
		TextItem.apply(this, arguments);
	},

	getPoint: function() {
		var point = this._matrix.getTranslation();
		return new LinkedPoint(point.x, point.y, this, 'setPoint');
	},

	setPoint: function() {
		var point = Point.read(arguments);
		this.translate(point.subtract(this._matrix.getTranslation()));
	},

	_draw: function(ctx, param, viewMatrix) {
		if (!this._content)
			return;
		this._setStyles(ctx, param, viewMatrix);
		var lines = this._lines,
			style = this._style,
			hasFill = style.hasFill(),
			hasStroke = style.hasStroke(),
			leading = style.getLeading(),
			shadowColor = ctx.shadowColor;
		ctx.font = style.getFontStyle();
		ctx.textAlign = style.getJustification();
		for (var i = 0, l = lines.length; i < l; i++) {
			ctx.shadowColor = shadowColor;
			var line = lines[i];
			if (hasFill) {
				ctx.fillText(line, 0, 0);
				ctx.shadowColor = 'rgba(0,0,0,0)';
			}
			if (hasStroke)
				ctx.strokeText(line, 0, 0);
			ctx.translate(0, leading);
		}
	},

	_getBounds: function(matrix, options) {
		var style = this._style,
			lines = this._lines,
			numLines = lines.length,
			justification = style.getJustification(),
			leading = style.getLeading(),
			width = this.getView().getTextWidth(style.getFontStyle(), lines),
			x = 0;
		if (justification !== 'left')
			x -= width / (justification === 'center' ? 2: 1);
		var rect = new Rectangle(x,
					numLines ? - 0.75 * leading : 0,
					width, numLines * leading);
		return matrix ? matrix._transformBounds(rect, rect) : rect;
	}
});

var Color = Base.extend(new function() {
	var types = {
		gray: ['gray'],
		rgb: ['red', 'green', 'blue'],
		hsb: ['hue', 'saturation', 'brightness'],
		hsl: ['hue', 'saturation', 'lightness'],
		gradient: ['gradient', 'origin', 'destination', 'highlight']
	};

	var componentParsers = {},
		namedColors = {
			transparent: [0, 0, 0, 0]
		},
		colorCtx;

	function fromCSS(string) {
		var match = string.match(
				/^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
			) || string.match(
				/^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
			),
			type = 'rgb',
			components;
		if (match) {
			var amount = match[4] ? 4 : 3;
			components = new Array(amount);
			for (var i = 0; i < amount; i++) {
				var value = match[i + 1];
				components[i] = parseInt(value.length == 1
						? value + value : value, 16) / 255;
			}
		} else if (match = string.match(/^(rgb|hsl)a?\((.*)\)$/)) {
			type = match[1];
			components = match[2].trim().split(/[,\s]+/g);
			var isHSL = type === 'hsl';
			for (var i = 0, l = Math.min(components.length, 4); i < l; i++) {
				var component = components[i];
				var value = parseFloat(component);
				if (isHSL) {
					if (i === 0) {
						var unit = component.match(/([a-z]*)$/)[1];
						value *= ({
							turn: 360,
							rad: 180 / Math.PI,
							grad: 0.9
						}[unit] || 1);
					} else if (i < 3) {
						value /= 100;
					}
				} else if (i < 3) {
					value /= /%$/.test(component) ? 100 : 255;
				}
				components[i] = value;
			}
		} else {
			var color = namedColors[string];
			if (!color) {
				if (window) {
					if (!colorCtx) {
						colorCtx = CanvasProvider.getContext(1, 1, {
							willReadFrequently: true
						});
						colorCtx.globalCompositeOperation = 'copy';
					}
					colorCtx.fillStyle = 'rgba(0,0,0,0)';
					colorCtx.fillStyle = string;
					colorCtx.fillRect(0, 0, 1, 1);
					var data = colorCtx.getImageData(0, 0, 1, 1).data;
					color = namedColors[string] = [
						data[0] / 255,
						data[1] / 255,
						data[2] / 255
					];
				} else {
					color = [0, 0, 0];
				}
			}
			components = color.slice();
		}
		return [type, components];
	}

	var hsbIndices = [
		[0, 3, 1],
		[2, 0, 1],
		[1, 0, 3],
		[1, 2, 0],
		[3, 1, 0],
		[0, 1, 2]
	];

	var converters = {
		'rgb-hsb': function(r, g, b) {
			var max = Math.max(r, g, b),
				min = Math.min(r, g, b),
				delta = max - min,
				h = delta === 0 ? 0
					:   ( max == r ? (g - b) / delta + (g < b ? 6 : 0)
						: max == g ? (b - r) / delta + 2
						:            (r - g) / delta + 4) * 60;
			return [h, max === 0 ? 0 : delta / max, max];
		},

		'hsb-rgb': function(h, s, b) {
			h = (((h / 60) % 6) + 6) % 6;
			var i = Math.floor(h),
				f = h - i,
				i = hsbIndices[i],
				v = [
					b,
					b * (1 - s),
					b * (1 - s * f),
					b * (1 - s * (1 - f))
				];
			return [v[i[0]], v[i[1]], v[i[2]]];
		},

		'rgb-hsl': function(r, g, b) {
			var max = Math.max(r, g, b),
				min = Math.min(r, g, b),
				delta = max - min,
				achromatic = delta === 0,
				h = achromatic ? 0
					:   ( max == r ? (g - b) / delta + (g < b ? 6 : 0)
						: max == g ? (b - r) / delta + 2
						:            (r - g) / delta + 4) * 60,
				l = (max + min) / 2,
				s = achromatic ? 0 : l < 0.5
						? delta / (max + min)
						: delta / (2 - max - min);
			return [h, s, l];
		},

		'hsl-rgb': function(h, s, l) {
			h = (((h / 360) % 1) + 1) % 1;
			if (s === 0)
				return [l, l, l];
			var t3s = [ h + 1 / 3, h, h - 1 / 3 ],
				t2 = l < 0.5 ? l * (1 + s) : l + s - l * s,
				t1 = 2 * l - t2,
				c = [];
			for (var i = 0; i < 3; i++) {
				var t3 = t3s[i];
				if (t3 < 0) t3 += 1;
				if (t3 > 1) t3 -= 1;
				c[i] = 6 * t3 < 1
					? t1 + (t2 - t1) * 6 * t3
					: 2 * t3 < 1
						? t2
						: 3 * t3 < 2
							? t1 + (t2 - t1) * ((2 / 3) - t3) * 6
							: t1;
			}
			return c;
		},

		'rgb-gray': function(r, g, b) {
			return [r * 0.2989 + g * 0.587 + b * 0.114];
		},

		'gray-rgb': function(g) {
			return [g, g, g];
		},

		'gray-hsb': function(g) {
			return [0, 0, g];
		},

		'gray-hsl': function(g) {
			return [0, 0, g];
		},

		'gradient-rgb': function() {
			return [];
		},

		'rgb-gradient': function() {
			return [];
		}

	};

	return Base.each(types, function(properties, type) {
		componentParsers[type] = [];
		Base.each(properties, function(name, index) {
			var part = Base.capitalize(name),
				hasOverlap = /^(hue|saturation)$/.test(name),
				parser = componentParsers[type][index] = type === 'gradient'
					? name === 'gradient'
						? function(value) {
							var current = this._components[0];
							value = Gradient.read(
								Array.isArray(value)
									? value
									: arguments, 0, { readNull: true }
							);
							if (current !== value) {
								if (current)
									current._removeOwner(this);
								if (value)
									value._addOwner(this);
							}
							return value;
						}
						: function() {
							return Point.read(arguments, 0, {
									readNull: name === 'highlight',
									clone: true
							});
						}
					: function(value) {
						return value == null || isNaN(value) ? 0 : +value;
					};
			this['get' + part] = function() {
				return this._type === type
					|| hasOverlap && /^hs[bl]$/.test(this._type)
						? this._components[index]
						: this._convert(type)[index];
			};

			this['set' + part] = function(value) {
				if (this._type !== type
						&& !(hasOverlap && /^hs[bl]$/.test(this._type))) {
					this._components = this._convert(type);
					this._properties = types[type];
					this._type = type;
				}
				this._components[index] = parser.call(this, value);
				this._changed();
			};
		}, this);
	}, {
		_class: 'Color',
		_readIndex: true,

		initialize: function Color(arg) {
			var args = arguments,
				reading = this.__read,
				read = 0,
				type,
				components,
				alpha,
				values;
			if (Array.isArray(arg)) {
				args = arg;
				arg = args[0];
			}
			var argType = arg != null && typeof arg;
			if (argType === 'string' && arg in types) {
				type = arg;
				arg = args[1];
				if (Array.isArray(arg)) {
					components = arg;
					alpha = args[2];
				} else {
					if (reading)
						read = 1;
					args = Base.slice(args, 1);
					argType = typeof arg;
				}
			}
			if (!components) {
				values = argType === 'number'
						? args
						: argType === 'object' && arg.length != null
							? arg
							: null;
				if (values) {
					if (!type)
						type = values.length >= 3
								? 'rgb'
								: 'gray';
					var length = types[type].length;
					alpha = values[length];
					if (reading) {
						read += values === arguments
							? length + (alpha != null ? 1 : 0)
							: 1;
					}
					if (values.length > length)
						values = Base.slice(values, 0, length);
				} else if (argType === 'string') {
					var converted = fromCSS(arg);
					type = converted[0];
					components = converted[1];
					if (components.length === 4) {
						alpha = components[3];
						components.length--;
					}
				} else if (argType === 'object') {
					if (arg.constructor === Color) {
						type = arg._type;
						components = arg._components.slice();
						alpha = arg._alpha;
						if (type === 'gradient') {
							for (var i = 1, l = components.length; i < l; i++) {
								var point = components[i];
								if (point)
									components[i] = point.clone();
							}
						}
					} else if (arg.constructor === Gradient) {
						type = 'gradient';
						values = args;
					} else {
						type = 'hue' in arg
							? 'lightness' in arg
								? 'hsl'
								: 'hsb'
							: 'gradient' in arg || 'stops' in arg
									|| 'radial' in arg
								? 'gradient'
								: 'gray' in arg
									? 'gray'
									: 'rgb';
						var properties = types[type],
							parsers = componentParsers[type];
						this._components = components = [];
						for (var i = 0, l = properties.length; i < l; i++) {
							var value = arg[properties[i]];
							if (value == null && !i && type === 'gradient'
									&& 'stops' in arg) {
								value = {
									stops: arg.stops,
									radial: arg.radial
								};
							}
							value = parsers[i].call(this, value);
							if (value != null)
								components[i] = value;
						}
						alpha = arg.alpha;
					}
				}
				if (reading && type)
					read = 1;
			}
			this._type = type || 'rgb';
			if (!components) {
				this._components = components = [];
				var parsers = componentParsers[this._type];
				for (var i = 0, l = parsers.length; i < l; i++) {
					var value = parsers[i].call(this, values && values[i]);
					if (value != null)
						components[i] = value;
				}
			}
			this._components = components;
			this._properties = types[this._type];
			this._alpha = alpha;
			if (reading)
				this.__read = read;
			return this;
		},

		set: '#initialize',

		_serialize: function(options, dictionary) {
			var components = this.getComponents();
			return Base.serialize(
					/^(gray|rgb)$/.test(this._type)
						? components
						: [this._type].concat(components),
					options, true, dictionary);
		},

		_changed: function() {
			this._canvasStyle = null;
			if (this._owner) {
				if (this._setter) {
					this._owner[this._setter](this);
				} else {
					this._owner._changed(129);
				}
			}
		},

		_convert: function(type) {
			var converter;
			return this._type === type
					? this._components.slice()
					: (converter = converters[this._type + '-' + type])
						? converter.apply(this, this._components)
						: converters['rgb-' + type].apply(this,
							converters[this._type + '-rgb'].apply(this,
								this._components));
		},

		convert: function(type) {
			return new Color(type, this._convert(type), this._alpha);
		},

		getType: function() {
			return this._type;
		},

		setType: function(type) {
			this._components = this._convert(type);
			this._properties = types[type];
			this._type = type;
		},

		getComponents: function() {
			var components = this._components.slice();
			if (this._alpha != null)
				components.push(this._alpha);
			return components;
		},

		getAlpha: function() {
			return this._alpha != null ? this._alpha : 1;
		},

		setAlpha: function(alpha) {
			this._alpha = alpha == null ? null : Math.min(Math.max(alpha, 0), 1);
			this._changed();
		},

		hasAlpha: function() {
			return this._alpha != null;
		},

		equals: function(color) {
			var col = Base.isPlainValue(color, true)
					? Color.read(arguments)
					: color;
			return col === this || col && this._class === col._class
					&& this._type === col._type
					&& this.getAlpha() === col.getAlpha()
					&& Base.equals(this._components, col._components)
					|| false;
		},

		toString: function() {
			var properties = this._properties,
				parts = [],
				isGradient = this._type === 'gradient',
				f = Formatter.instance;
			for (var i = 0, l = properties.length; i < l; i++) {
				var value = this._components[i];
				if (value != null)
					parts.push(properties[i] + ': '
							+ (isGradient ? value : f.number(value)));
			}
			if (this._alpha != null)
				parts.push('alpha: ' + f.number(this._alpha));
			return '{ ' + parts.join(', ') + ' }';
		},

		toCSS: function(hex) {
			var components = this._convert('rgb'),
				alpha = hex || this._alpha == null ? 1 : this._alpha;
			function convert(val) {
				return Math.round((val < 0 ? 0 : val > 1 ? 1 : val) * 255);
			}
			components = [
				convert(components[0]),
				convert(components[1]),
				convert(components[2])
			];
			if (alpha < 1)
				components.push(alpha < 0 ? 0 : alpha);
			return hex
					? '#' + ((1 << 24) + (components[0] << 16)
						+ (components[1] << 8)
						+ components[2]).toString(16).slice(1)
					: (components.length == 4 ? 'rgba(' : 'rgb(')
						+ components.join(',') + ')';
		},

		toCanvasStyle: function(ctx, matrix) {
			if (this._canvasStyle)
				return this._canvasStyle;
			if (this._type !== 'gradient')
				return this._canvasStyle = this.toCSS();
			var components = this._components,
				gradient = components[0],
				stops = gradient._stops,
				origin = components[1],
				destination = components[2],
				highlight = components[3],
				inverse = matrix && matrix.inverted(),
				canvasGradient;
			if (inverse) {
				origin = inverse._transformPoint(origin);
				destination = inverse._transformPoint(destination);
				if (highlight)
					highlight = inverse._transformPoint(highlight);
			}
			if (gradient._radial) {
				var radius = destination.getDistance(origin);
				if (highlight) {
					var vector = highlight.subtract(origin);
					if (vector.getLength() > radius)
						highlight = origin.add(vector.normalize(radius - 0.1));
				}
				var start = highlight || origin;
				canvasGradient = ctx.createRadialGradient(start.x, start.y,
						0, origin.x, origin.y, radius);
			} else {
				canvasGradient = ctx.createLinearGradient(origin.x, origin.y,
						destination.x, destination.y);
			}
			for (var i = 0, l = stops.length; i < l; i++) {
				var stop = stops[i],
					offset = stop._offset;
				canvasGradient.addColorStop(
						offset == null ? i / (l - 1) : offset,
						stop._color.toCanvasStyle());
			}
			return this._canvasStyle = canvasGradient;
		},

		transform: function(matrix) {
			if (this._type === 'gradient') {
				var components = this._components;
				for (var i = 1, l = components.length; i < l; i++) {
					var point = components[i];
					matrix._transformPoint(point, point, true);
				}
				this._changed();
			}
		},

		statics: {
			_types: types,

			random: function() {
				var random = Math.random;
				return new Color(random(), random(), random());
			},

			_setOwner: function(color, owner, setter) {
				if (color) {
					if (color._owner && owner && color._owner !== owner) {
						color = color.clone();
					}
					if (!color._owner ^ !owner) {
						color._owner = owner || null;
						color._setter = setter || null;
					}
				}
				return color;
			}
		}
	});
},
new function() {
	var operators = {
		add: function(a, b) {
			return a + b;
		},

		subtract: function(a, b) {
			return a - b;
		},

		multiply: function(a, b) {
			return a * b;
		},

		divide: function(a, b) {
			return a / b;
		}
	};

	return Base.each(operators, function(operator, name) {
		this[name] = function(color) {
			color = Color.read(arguments);
			var type = this._type,
				components1 = this._components,
				components2 = color._convert(type);
			for (var i = 0, l = components1.length; i < l; i++)
				components2[i] = operator(components1[i], components2[i]);
			return new Color(type, components2,
					this._alpha != null
							? operator(this._alpha, color.getAlpha())
							: null);
		};
	}, {
	});
});

var Gradient = Base.extend({
	_class: 'Gradient',

	initialize: function Gradient(stops, radial) {
		this._id = UID.get();
		if (stops && Base.isPlainObject(stops)) {
			this.set(stops);
			stops = radial = null;
		}
		if (this._stops == null) {
			this.setStops(stops || ['white', 'black']);
		}
		if (this._radial == null) {
			this.setRadial(typeof radial === 'string' && radial === 'radial'
					|| radial || false);
		}
	},

	_serialize: function(options, dictionary) {
		return dictionary.add(this, function() {
			return Base.serialize([this._stops, this._radial],
					options, true, dictionary);
		});
	},

	_changed: function() {
		for (var i = 0, l = this._owners && this._owners.length; i < l; i++) {
			this._owners[i]._changed();
		}
	},

	_addOwner: function(color) {
		if (!this._owners)
			this._owners = [];
		this._owners.push(color);
	},

	_removeOwner: function(color) {
		var index = this._owners ? this._owners.indexOf(color) : -1;
		if (index != -1) {
			this._owners.splice(index, 1);
			if (!this._owners.length)
				this._owners = undefined;
		}
	},

	clone: function() {
		var stops = [];
		for (var i = 0, l = this._stops.length; i < l; i++) {
			stops[i] = this._stops[i].clone();
		}
		return new Gradient(stops, this._radial);
	},

	getStops: function() {
		return this._stops;
	},

	setStops: function(stops) {
		if (stops.length < 2) {
			throw new Error(
					'Gradient stop list needs to contain at least two stops.');
		}
		var _stops = this._stops;
		if (_stops) {
			for (var i = 0, l = _stops.length; i < l; i++)
				_stops[i]._owner = undefined;
		}
		_stops = this._stops = GradientStop.readList(stops, 0, { clone: true });
		for (var i = 0, l = _stops.length; i < l; i++)
			_stops[i]._owner = this;
		this._changed();
	},

	getRadial: function() {
		return this._radial;
	},

	setRadial: function(radial) {
		this._radial = radial;
		this._changed();
	},

	equals: function(gradient) {
		if (gradient === this)
			return true;
		if (gradient && this._class === gradient._class) {
			var stops1 = this._stops,
				stops2 = gradient._stops,
				length = stops1.length;
			if (length === stops2.length) {
				for (var i = 0; i < length; i++) {
					if (!stops1[i].equals(stops2[i]))
						return false;
				}
				return true;
			}
		}
		return false;
	}
});

var GradientStop = Base.extend({
	_class: 'GradientStop',

	initialize: function GradientStop(arg0, arg1) {
		var color = arg0,
			offset = arg1;
		if (typeof arg0 === 'object' && arg1 === undefined) {
			if (Array.isArray(arg0) && typeof arg0[0] !== 'number') {
				color = arg0[0];
				offset = arg0[1];
			} else if ('color' in arg0 || 'offset' in arg0
					|| 'rampPoint' in arg0) {
				color = arg0.color;
				offset = arg0.offset || arg0.rampPoint || 0;
			}
		}
		this.setColor(color);
		this.setOffset(offset);
	},

	clone: function() {
		return new GradientStop(this._color.clone(), this._offset);
	},

	_serialize: function(options, dictionary) {
		var color = this._color,
			offset = this._offset;
		return Base.serialize(offset == null ? [color] : [color, offset],
				options, true, dictionary);
	},

	_changed: function() {
		if (this._owner)
			this._owner._changed(129);
	},

	getOffset: function() {
		return this._offset;
	},

	setOffset: function(offset) {
		this._offset = offset;
		this._changed();
	},

	getRampPoint: '#getOffset',
	setRampPoint: '#setOffset',

	getColor: function() {
		return this._color;
	},

	setColor: function() {
		Color._setOwner(this._color, null);
		this._color = Color._setOwner(Color.read(arguments, 0), this,
				'setColor');
		this._changed();
	},

	equals: function(stop) {
		return stop === this || stop && this._class === stop._class
				&& this._color.equals(stop._color)
				&& this._offset == stop._offset
				|| false;
	}
});

var Style = Base.extend(new function() {
	var itemDefaults = {
		fillColor: null,
		fillRule: 'nonzero',
		strokeColor: null,
		strokeWidth: 1,
		strokeCap: 'butt',
		strokeJoin: 'miter',
		strokeScaling: true,
		miterLimit: 10,
		dashOffset: 0,
		dashArray: [],
		shadowColor: null,
		shadowBlur: 0,
		shadowOffset: new Point(),
		selectedColor: null
	},
	groupDefaults = Base.set({}, itemDefaults, {
		fontFamily: 'sans-serif',
		fontWeight: 'normal',
		fontSize: 12,
		leading: null,
		justification: 'left'
	}),
	textDefaults = Base.set({}, groupDefaults, {
		fillColor: new Color()
	}),
	flags = {
		strokeWidth: 193,
		strokeCap: 193,
		strokeJoin: 193,
		strokeScaling: 201,
		miterLimit: 193,
		fontFamily: 9,
		fontWeight: 9,
		fontSize: 9,
		font: 9,
		leading: 9,
		justification: 9
	},
	item = {
		beans: true
	},
	fields = {
		_class: 'Style',
		beans: true,

		initialize: function Style(style, _owner, _project) {
			this._values = {};
			this._owner = _owner;
			this._project = _owner && _owner._project || _project
					|| paper.project;
			this._defaults = !_owner || _owner instanceof Group ? groupDefaults
					: _owner instanceof TextItem ? textDefaults
					: itemDefaults;
			if (style)
				this.set(style);
		}
	};

	Base.each(groupDefaults, function(value, key) {
		var isColor = /Color$/.test(key),
			isPoint = key === 'shadowOffset',
			part = Base.capitalize(key),
			flag = flags[key],
			set = 'set' + part,
			get = 'get' + part;

		fields[set] = function(value) {
			var owner = this._owner,
				children = owner && owner._children,
				applyToChildren = children && children.length > 0
					&& !(owner instanceof CompoundPath);
			if (applyToChildren) {
				for (var i = 0, l = children.length; i < l; i++)
					children[i]._style[set](value);
			}
			if ((key === 'selectedColor' || !applyToChildren)
					&& key in this._defaults) {
				var old = this._values[key];
				if (old !== value) {
					if (isColor) {
						if (old) {
							Color._setOwner(old, null);
							old._canvasStyle = null;
						}
						if (value && value.constructor === Color) {
							value = Color._setOwner(value, owner,
									applyToChildren && set);
						}
					}
					this._values[key] = value;
					if (owner)
						owner._changed(flag || 129);
				}
			}
		};

		fields[get] = function(_dontMerge) {
			var owner = this._owner,
				children = owner && owner._children,
				applyToChildren = children && children.length > 0
					&& !(owner instanceof CompoundPath),
				value;
			if (applyToChildren && !_dontMerge) {
				for (var i = 0, l = children.length; i < l; i++) {
					var childValue = children[i]._style[get]();
					if (!i) {
						value = childValue;
					} else if (!Base.equals(value, childValue)) {
						return undefined;
					}
				}
			} else if (key in this._defaults) {
				var value = this._values[key];
				if (value === undefined) {
					value = this._defaults[key];
					if (value && value.clone) {
						value = value.clone();
					}
				} else {
					var ctor = isColor ? Color : isPoint ? Point : null;
					if (ctor && !(value && value.constructor === ctor)) {
						this._values[key] = value = ctor.read([value], 0,
								{ readNull: true, clone: true });
					}
				}
			}
			if (value && isColor) {
				value = Color._setOwner(value, owner, applyToChildren && set);
			}
			return value;
		};

		item[get] = function(_dontMerge) {
			return this._style[get](_dontMerge);
		};

		item[set] = function(value) {
			this._style[set](value);
		};
	});

	Base.each({
		Font: 'FontFamily',
		WindingRule: 'FillRule'
	}, function(value, key) {
		var get = 'get' + key,
			set = 'set' + key;
		fields[get] = item[get] = '#get' + value;
		fields[set] = item[set] = '#set' + value;
	});

	Item.inject(item);
	return fields;
}, {
	set: function(style) {
		var isStyle = style instanceof Style,
			values = isStyle ? style._values : style;
		if (values) {
			for (var key in values) {
				if (key in this._defaults) {
					var value = values[key];
					this[key] = value && isStyle && value.clone
							? value.clone() : value;
				}
			}
		}
	},

	equals: function(style) {
		function compare(style1, style2, secondary) {
			var values1 = style1._values,
				values2 = style2._values,
				defaults2 = style2._defaults;
			for (var key in values1) {
				var value1 = values1[key],
					value2 = values2[key];
				if (!(secondary && key in values2) && !Base.equals(value1,
						value2 === undefined ? defaults2[key] : value2))
					return false;
			}
			return true;
		}

		return style === this || style && this._class === style._class
				&& compare(this, style)
				&& compare(style, this, true)
				|| false;
	},

	_dispose: function() {
		var color;
		color = this.getFillColor();
		if (color) color._canvasStyle = null;
		color = this.getStrokeColor();
		if (color) color._canvasStyle = null;
		color = this.getShadowColor();
		if (color) color._canvasStyle = null;
	},

	hasFill: function() {
		var color = this.getFillColor();
		return !!color && color.alpha > 0;
	},

	hasStroke: function() {
		var color = this.getStrokeColor();
		return !!color && color.alpha > 0 && this.getStrokeWidth() > 0;
	},

	hasShadow: function() {
		var color = this.getShadowColor();
		return !!color && color.alpha > 0 && (this.getShadowBlur() > 0
				|| !this.getShadowOffset().isZero());
	},

	getView: function() {
		return this._project._view;
	},

	getFontStyle: function() {
		var fontSize = this.getFontSize();
		return this.getFontWeight()
				+ ' ' + fontSize + (/[a-z]/i.test(fontSize + '') ? ' ' : 'px ')
				+ this.getFontFamily();
	},

	getFont: '#getFontFamily',
	setFont: '#setFontFamily',

	getLeading: function getLeading() {
		var leading = getLeading.base.call(this),
			fontSize = this.getFontSize();
		if (/pt|em|%|px/.test(fontSize))
			fontSize = this.getView().getPixelSize(fontSize);
		return leading != null ? leading : fontSize * 1.2;
	}

});

var DomElement = new function() {
	function handlePrefix(el, name, set, value) {
		var prefixes = ['', 'webkit', 'moz', 'Moz', 'ms', 'o'],
			suffix = name[0].toUpperCase() + name.substring(1);
		for (var i = 0; i < 6; i++) {
			var prefix = prefixes[i],
				key = prefix ? prefix + suffix : name;
			if (key in el) {
				if (set) {
					el[key] = value;
				} else {
					return el[key];
				}
				break;
			}
		}
	}

	return {
		getStyles: function(el) {
			var doc = el && el.nodeType !== 9 ? el.ownerDocument : el,
				view = doc && doc.defaultView;
			return view && view.getComputedStyle(el, '');
		},

		getBounds: function(el, viewport) {
			var doc = el.ownerDocument,
				body = doc.body,
				html = doc.documentElement,
				rect;
			try {
				rect = el.getBoundingClientRect();
			} catch (e) {
				rect = { left: 0, top: 0, width: 0, height: 0 };
			}
			var x = rect.left - (html.clientLeft || body.clientLeft || 0),
				y = rect.top - (html.clientTop || body.clientTop || 0);
			if (!viewport) {
				var view = doc.defaultView;
				x += view.pageXOffset || html.scrollLeft || body.scrollLeft;
				y += view.pageYOffset || html.scrollTop || body.scrollTop;
			}
			return new Rectangle(x, y, rect.width, rect.height);
		},

		getViewportBounds: function(el) {
			var doc = el.ownerDocument,
				view = doc.defaultView,
				html = doc.documentElement;
			return new Rectangle(0, 0,
				view.innerWidth || html.clientWidth,
				view.innerHeight || html.clientHeight
			);
		},

		getOffset: function(el, viewport) {
			return DomElement.getBounds(el, viewport).getPoint();
		},

		getSize: function(el) {
			return DomElement.getBounds(el, true).getSize();
		},

		isInvisible: function(el) {
			return DomElement.getSize(el).equals(new Size(0, 0));
		},

		isInView: function(el) {
			return !DomElement.isInvisible(el)
					&& DomElement.getViewportBounds(el).intersects(
						DomElement.getBounds(el, true));
		},

		isInserted: function(el) {
			return document.body.contains(el);
		},

		getPrefixed: function(el, name) {
			return el && handlePrefix(el, name);
		},

		setPrefixed: function(el, name, value) {
			if (typeof name === 'object') {
				for (var key in name)
					handlePrefix(el, key, true, name[key]);
			} else {
				handlePrefix(el, name, true, value);
			}
		}
	};
};

var DomEvent = {
	add: function(el, events) {
		if (el) {
			for (var type in events) {
				var func = events[type],
					parts = type.split(/[\s,]+/g);
				for (var i = 0, l = parts.length; i < l; i++) {
					var name = parts[i];
					var options = (
						el === document
						&& (name === 'touchstart' || name === 'touchmove')
					) ? { passive: false } : false;
					el.addEventListener(name, func, options);
				}
			}
		}
	},

	remove: function(el, events) {
		if (el) {
			for (var type in events) {
				var func = events[type],
					parts = type.split(/[\s,]+/g);
				for (var i = 0, l = parts.length; i < l; i++)
					el.removeEventListener(parts[i], func, false);
			}
		}
	},

	getPoint: function(event) {
		var pos = event.targetTouches
				? event.targetTouches.length
					? event.targetTouches[0]
					: event.changedTouches[0]
				: event;
		return new Point(
			pos.pageX || pos.clientX + document.documentElement.scrollLeft,
			pos.pageY || pos.clientY + document.documentElement.scrollTop
		);
	},

	getTarget: function(event) {
		return event.target || event.srcElement;
	},

	getRelatedTarget: function(event) {
		return event.relatedTarget || event.toElement;
	},

	getOffset: function(event, target) {
		return DomEvent.getPoint(event).subtract(DomElement.getOffset(
				target || DomEvent.getTarget(event)));
	}
};

DomEvent.requestAnimationFrame = new function() {
	var nativeRequest = DomElement.getPrefixed(window, 'requestAnimationFrame'),
		requested = false,
		callbacks = [],
		timer;

	function handleCallbacks() {
		var functions = callbacks;
		callbacks = [];
		for (var i = 0, l = functions.length; i < l; i++)
			functions[i]();
		requested = nativeRequest && callbacks.length;
		if (requested)
			nativeRequest(handleCallbacks);
	}

	return function(callback) {
		callbacks.push(callback);
		if (nativeRequest) {
			if (!requested) {
				nativeRequest(handleCallbacks);
				requested = true;
			}
		} else if (!timer) {
			timer = setInterval(handleCallbacks, 1000 / 60);
		}
	};
};

var View = Base.extend(Emitter, {
	_class: 'View',

	initialize: function View(project, element) {

		function getSize(name) {
			return element[name] || parseInt(element.getAttribute(name), 10);
		}

		function getCanvasSize() {
			var size = DomElement.getSize(element);
			return size.isNaN() || size.isZero()
					? new Size(getSize('width'), getSize('height'))
					: size;
		}

		var size;
		if (window && element) {
			this._id = element.getAttribute('id');
			if (this._id == null)
				element.setAttribute('id', this._id = 'paper-view-' + View._id++);
			DomEvent.add(element, this._viewEvents);
			var none = 'none';
			DomElement.setPrefixed(element.style, {
				userDrag: none,
				userSelect: none,
				touchCallout: none,
				contentZooming: none,
				tapHighlightColor: 'rgba(0,0,0,0)'
			});

			if (PaperScope.hasAttribute(element, 'resize')) {
				var that = this;
				DomEvent.add(window, this._windowEvents = {
					resize: function() {
						that.setViewSize(getCanvasSize());
					}
				});
			}

			size = getCanvasSize();

			if (PaperScope.hasAttribute(element, 'stats')
					&& typeof Stats !== 'undefined') {
				this._stats = new Stats();
				var stats = this._stats.domElement,
					style = stats.style,
					offset = DomElement.getOffset(element);
				style.position = 'absolute';
				style.left = offset.x + 'px';
				style.top = offset.y + 'px';
				document.body.appendChild(stats);
			}
		} else {
			size = new Size(element);
			element = null;
		}
		this._project = project;
		this._scope = project._scope;
		this._element = element;
		if (!this._pixelRatio)
			this._pixelRatio = window && window.devicePixelRatio || 1;
		this._setElementSize(size.width, size.height);
		this._viewSize = size;
		View._views.push(this);
		View._viewsById[this._id] = this;
		(this._matrix = new Matrix())._owner = this;
		if (!View._focused)
			View._focused = this;
		this._frameItems = {};
		this._frameItemCount = 0;
		this._itemEvents = { native: {}, virtual: {} };
		this._autoUpdate = !paper.agent.node;
		this._needsUpdate = false;
	},

	remove: function() {
		if (!this._project)
			return false;
		if (View._focused === this)
			View._focused = null;
		View._views.splice(View._views.indexOf(this), 1);
		delete View._viewsById[this._id];
		var project = this._project;
		if (project._view === this)
			project._view = null;
		DomEvent.remove(this._element, this._viewEvents);
		DomEvent.remove(window, this._windowEvents);
		this._element = this._project = null;
		this.off('frame');
		this._animate = false;
		this._frameItems = {};
		return true;
	},

	_events: Base.each(
		Item._itemHandlers.concat(['onResize', 'onKeyDown', 'onKeyUp']),
		function(name) {
			this[name] = {};
		}, {
			onFrame: {
				install: function() {
					this.play();
				},

				uninstall: function() {
					this.pause();
				}
			}
		}
	),

	_animate: false,
	_time: 0,
	_count: 0,

	getAutoUpdate: function() {
		return this._autoUpdate;
	},

	setAutoUpdate: function(autoUpdate) {
		this._autoUpdate = autoUpdate;
		if (autoUpdate)
			this.requestUpdate();
	},

	update: function() {
	},

	draw: function() {
		this.update();
	},

	requestUpdate: function() {
		if (!this._requested) {
			var that = this;
			DomEvent.requestAnimationFrame(function() {
				that._requested = false;
				if (that._animate) {
					that.requestUpdate();
					var element = that._element;
					if ((!DomElement.getPrefixed(document, 'hidden')
							|| PaperScope.getAttribute(element, 'keepalive')
								=== 'true') && DomElement.isInView(element)) {
						that._handleFrame();
					}
				}
				if (that._autoUpdate)
					that.update();
			});
			this._requested = true;
		}
	},

	play: function() {
		this._animate = true;
		this.requestUpdate();
	},

	pause: function() {
		this._animate = false;
	},

	_handleFrame: function() {
		paper = this._scope;
		var now = Date.now() / 1000,
			delta = this._last ? now - this._last : 0;
		this._last = now;
		this.emit('frame', new Base({
			delta: delta,
			time: this._time += delta,
			count: this._count++
		}));
		if (this._stats)
			this._stats.update();
	},

	_animateItem: function(item, animate) {
		var items = this._frameItems;
		if (animate) {
			items[item._id] = {
				item: item,
				time: 0,
				count: 0
			};
			if (++this._frameItemCount === 1)
				this.on('frame', this._handleFrameItems);
		} else {
			delete items[item._id];
			if (--this._frameItemCount === 0) {
				this.off('frame', this._handleFrameItems);
			}
		}
	},

	_handleFrameItems: function(event) {
		for (var i in this._frameItems) {
			var entry = this._frameItems[i];
			entry.item.emit('frame', new Base(event, {
				time: entry.time += event.delta,
				count: entry.count++
			}));
		}
	},

	_changed: function() {
		this._project._changed(4097);
		this._bounds = this._decomposed = undefined;
	},

	getElement: function() {
		return this._element;
	},

	getPixelRatio: function() {
		return this._pixelRatio;
	},

	getResolution: function() {
		return this._pixelRatio * 72;
	},

	getViewSize: function() {
		var size = this._viewSize;
		return new LinkedSize(size.width, size.height, this, 'setViewSize');
	},

	setViewSize: function() {
		var size = Size.read(arguments),
			delta = size.subtract(this._viewSize);
		if (delta.isZero())
			return;
		this._setElementSize(size.width, size.height);
		this._viewSize.set(size);
		this._changed();
		this.emit('resize', { size: size, delta: delta });
		if (this._autoUpdate) {
			this.update();
		}
	},

	_setElementSize: function(width, height) {
		var element = this._element;
		if (element) {
			if (element.width !== width)
				element.width = width;
			if (element.height !== height)
				element.height = height;
		}
	},

	getBounds: function() {
		if (!this._bounds)
			this._bounds = this._matrix.inverted()._transformBounds(
					new Rectangle(new Point(), this._viewSize));
		return this._bounds;
	},

	getSize: function() {
		return this.getBounds().getSize();
	},

	isVisible: function() {
		return DomElement.isInView(this._element);
	},

	isInserted: function() {
		return DomElement.isInserted(this._element);
	},

	getPixelSize: function(size) {
		var element = this._element,
			pixels;
		if (element) {
			var parent = element.parentNode,
				temp = document.createElement('div');
			temp.style.fontSize = size;
			parent.appendChild(temp);
			pixels = parseFloat(DomElement.getStyles(temp).fontSize);
			parent.removeChild(temp);
		} else {
			pixels = parseFloat(pixels);
		}
		return pixels;
	},

	getTextWidth: function(font, lines) {
		return 0;
	}
}, Base.each(['rotate', 'scale', 'shear', 'skew'], function(key) {
	var rotate = key === 'rotate';
	this[key] = function() {
		var args = arguments,
			value = (rotate ? Base : Point).read(args),
			center = Point.read(args, 0, { readNull: true });
		return this.transform(new Matrix()[key](value,
				center || this.getCenter(true)));
	};
}, {
	_decompose: function() {
		return this._decomposed || (this._decomposed = this._matrix.decompose());
	},

	translate: function() {
		var mx = new Matrix();
		return this.transform(mx.translate.apply(mx, arguments));
	},

	getCenter: function() {
		return this.getBounds().getCenter();
	},

	setCenter: function() {
		var center = Point.read(arguments);
		this.translate(this.getCenter().subtract(center));
	},

	getZoom: function() {
		var scaling = this._decompose().scaling;
		return (scaling.x + scaling.y) / 2;
	},

	setZoom: function(zoom) {
		this.transform(new Matrix().scale(zoom / this.getZoom(),
			this.getCenter()));
	},

	getRotation: function() {
		return this._decompose().rotation;
	},

	setRotation: function(rotation) {
		var current = this.getRotation();
		if (current != null && rotation != null) {
			this.rotate(rotation - current);
		}
	},

	getScaling: function() {
		var scaling = this._decompose().scaling;
		return new LinkedPoint(scaling.x, scaling.y, this, 'setScaling');
	},

	setScaling: function() {
		var current = this.getScaling(),
			scaling = Point.read(arguments, 0, { clone: true, readNull: true });
		if (current && scaling) {
			this.scale(scaling.x / current.x, scaling.y / current.y);
		}
	},

	getMatrix: function() {
		return this._matrix;
	},

	setMatrix: function() {
		var matrix = this._matrix;
		matrix.set.apply(matrix, arguments);
	},

	transform: function(matrix) {
		this._matrix.append(matrix);
	},

	scrollBy: function() {
		this.translate(Point.read(arguments).negate());
	}
}), {

	projectToView: function() {
		return this._matrix._transformPoint(Point.read(arguments));
	},

	viewToProject: function() {
		return this._matrix._inverseTransform(Point.read(arguments));
	},

	getEventPoint: function(event) {
		return this.viewToProject(DomEvent.getOffset(event, this._element));
	},

}, {
	statics: {
		_views: [],
		_viewsById: {},
		_id: 0,

		create: function(project, element) {
			if (document && typeof element === 'string')
				element = document.getElementById(element);
			var ctor = window ? CanvasView : View;
			return new ctor(project, element);
		}
	}
},
new function() {
	if (!window)
		return;
	var prevFocus,
		tempFocus,
		dragging = false,
		mouseDown = false;

	function getView(event) {
		var target = DomEvent.getTarget(event);
		return target.getAttribute && View._viewsById[
				target.getAttribute('id')];
	}

	function updateFocus() {
		var view = View._focused;
		if (!view || !view.isVisible()) {
			for (var i = 0, l = View._views.length; i < l; i++) {
				if ((view = View._views[i]).isVisible()) {
					View._focused = tempFocus = view;
					break;
				}
			}
		}
	}

	function handleMouseMove(view, event, point) {
		view._handleMouseEvent('mousemove', event, point);
	}

	var navigator = window.navigator,
		mousedown, mousemove, mouseup;
	if (navigator.pointerEnabled || navigator.msPointerEnabled) {
		mousedown = 'pointerdown MSPointerDown';
		mousemove = 'pointermove MSPointerMove';
		mouseup = 'pointerup pointercancel MSPointerUp MSPointerCancel';
	} else {
		mousedown = 'touchstart';
		mousemove = 'touchmove';
		mouseup = 'touchend touchcancel';
		if (!('ontouchstart' in window && navigator.userAgent.match(
				/mobile|tablet|ip(ad|hone|od)|android|silk/i))) {
			mousedown += ' mousedown';
			mousemove += ' mousemove';
			mouseup += ' mouseup';
		}
	}

	var viewEvents = {},
		docEvents = {
			mouseout: function(event) {
				var view = View._focused,
					target = DomEvent.getRelatedTarget(event);
				if (view && (!target || target.nodeName === 'HTML')) {
					var offset = DomEvent.getOffset(event, view._element),
						x = offset.x,
						abs = Math.abs,
						ax = abs(x),
						max = 1 << 25,
						diff = ax - max;
					offset.x = abs(diff) < ax ? diff * (x < 0 ? -1 : 1) : x;
					handleMouseMove(view, event, view.viewToProject(offset));
				}
			},

			scroll: updateFocus
		};

	viewEvents[mousedown] = function(event) {
		var view = View._focused = getView(event);
		if (!dragging) {
			dragging = true;
			view._handleMouseEvent('mousedown', event);
		}
	};

	docEvents[mousemove] = function(event) {
		var view = View._focused;
		if (!mouseDown) {
			var target = getView(event);
			if (target) {
				if (view !== target) {
					if (view)
						handleMouseMove(view, event);
					if (!prevFocus)
						prevFocus = view;
					view = View._focused = tempFocus = target;
				}
			} else if (tempFocus && tempFocus === view) {
				if (prevFocus && !prevFocus.isInserted())
					prevFocus = null;
				view = View._focused = prevFocus;
				prevFocus = null;
				updateFocus();
			}
		}
		if (view)
			handleMouseMove(view, event);
	};

	docEvents[mousedown] = function() {
		mouseDown = true;
	};

	docEvents[mouseup] = function(event) {
		var view = View._focused;
		if (view && dragging)
			view._handleMouseEvent('mouseup', event);
		mouseDown = dragging = false;
	};

	DomEvent.add(document, docEvents);

	DomEvent.add(window, {
		load: updateFocus
	});

	var called = false,
		prevented = false,
		fallbacks = {
			doubleclick: 'click',
			mousedrag: 'mousemove'
		},
		wasInView = false,
		overView,
		downPoint,
		lastPoint,
		downItem,
		overItem,
		dragItem,
		clickItem,
		clickTime,
		dblClick;

	function emitMouseEvent(obj, target, type, event, point, prevPoint,
			stopItem) {
		var stopped = false,
			mouseEvent;

		function emit(obj, type) {
			if (obj.responds(type)) {
				if (!mouseEvent) {
					mouseEvent = new MouseEvent(type, event, point,
							target || obj,
							prevPoint ? point.subtract(prevPoint) : null);
				}
				if (obj.emit(type, mouseEvent)) {
					called = true;
					if (mouseEvent.prevented)
						prevented = true;
					if (mouseEvent.stopped)
						return stopped = true;
				}
			} else {
				var fallback = fallbacks[type];
				if (fallback)
					return emit(obj, fallback);
			}
		}

		while (obj && obj !== stopItem) {
			if (emit(obj, type))
				break;
			obj = obj._parent;
		}
		return stopped;
	}

	function emitMouseEvents(view, hitItem, type, event, point, prevPoint) {
		view._project.removeOn(type);
		prevented = called = false;
		return (dragItem && emitMouseEvent(dragItem, null, type, event,
					point, prevPoint)
			|| hitItem && hitItem !== dragItem
				&& !hitItem.isDescendant(dragItem)
				&& emitMouseEvent(hitItem, null, type === 'mousedrag' ?
					'mousemove' : type, event, point, prevPoint, dragItem)
			|| emitMouseEvent(view, dragItem || hitItem || view, type, event,
					point, prevPoint));
	}

	var itemEventsMap = {
		mousedown: {
			mousedown: 1,
			mousedrag: 1,
			click: 1,
			doubleclick: 1
		},
		mouseup: {
			mouseup: 1,
			mousedrag: 1,
			click: 1,
			doubleclick: 1
		},
		mousemove: {
			mousedrag: 1,
			mousemove: 1,
			mouseenter: 1,
			mouseleave: 1
		}
	};

	return {
		_viewEvents: viewEvents,

		_handleMouseEvent: function(type, event, point) {
			var itemEvents = this._itemEvents,
				hitItems = itemEvents.native[type],
				nativeMove = type === 'mousemove',
				tool = this._scope.tool,
				view = this;

			function responds(type) {
				return itemEvents.virtual[type] || view.responds(type)
						|| tool && tool.responds(type);
			}

			if (nativeMove && dragging && responds('mousedrag'))
				type = 'mousedrag';
			if (!point)
				point = this.getEventPoint(event);

			var inView = this.getBounds().contains(point),
				hit = hitItems && inView && view._project.hitTest(point, {
					tolerance: 0,
					fill: true,
					stroke: true
				}),
				hitItem = hit && hit.item || null,
				handle = false,
				mouse = {};
			mouse[type.substr(5)] = true;

			if (hitItems && hitItem !== overItem) {
				if (overItem) {
					emitMouseEvent(overItem, null, 'mouseleave', event, point);
				}
				if (hitItem) {
					emitMouseEvent(hitItem, null, 'mouseenter', event, point);
				}
				overItem = hitItem;
			}
			if (wasInView ^ inView) {
				emitMouseEvent(this, null, inView ? 'mouseenter' : 'mouseleave',
						event, point);
				overView = inView ? this : null;
				handle = true;
			}
			if ((inView || mouse.drag) && !point.equals(lastPoint)) {
				emitMouseEvents(this, hitItem, nativeMove ? type : 'mousemove',
						event, point, lastPoint);
				handle = true;
			}
			wasInView = inView;
			if (mouse.down && inView || mouse.up && downPoint) {
				emitMouseEvents(this, hitItem, type, event, point, downPoint);
				if (mouse.down) {
					dblClick = hitItem === clickItem
						&& (Date.now() - clickTime < 300);
					downItem = clickItem = hitItem;
					if (!prevented && hitItem) {
						var item = hitItem;
						while (item && !item.responds('mousedrag'))
							item = item._parent;
						if (item)
							dragItem = hitItem;
					}
					downPoint = point;
				} else if (mouse.up) {
					if (!prevented && hitItem === downItem) {
						clickTime = Date.now();
						emitMouseEvents(this, hitItem, dblClick ? 'doubleclick'
								: 'click', event, point, downPoint);
						dblClick = false;
					}
					downItem = dragItem = null;
				}
				wasInView = false;
				handle = true;
			}
			lastPoint = point;
			if (handle && tool) {
				called = tool._handleMouseEvent(type, event, point, mouse)
					|| called;
			}

			if (
				event.cancelable !== false
				&& (called && !mouse.move || mouse.down && responds('mouseup'))
			) {
				event.preventDefault();
			}
		},

		_handleKeyEvent: function(type, event, key, character) {
			var scope = this._scope,
				tool = scope.tool,
				keyEvent;

			function emit(obj) {
				if (obj.responds(type)) {
					paper = scope;
					obj.emit(type, keyEvent = keyEvent
							|| new KeyEvent(type, event, key, character));
				}
			}

			if (this.isVisible()) {
				emit(this);
				if (tool && tool.responds(type))
					emit(tool);
			}
		},

		_countItemEvent: function(type, sign) {
			var itemEvents = this._itemEvents,
				native = itemEvents.native,
				virtual = itemEvents.virtual;
			for (var key in itemEventsMap) {
				native[key] = (native[key] || 0)
						+ (itemEventsMap[key][type] || 0) * sign;
			}
			virtual[type] = (virtual[type] || 0) + sign;
		},

		statics: {
			updateFocus: updateFocus,

			_resetState: function() {
				dragging = mouseDown = called = wasInView = false;
				prevFocus = tempFocus = overView = downPoint = lastPoint =
					downItem = overItem = dragItem = clickItem = clickTime =
					dblClick = null;
			}
		}
	};
});

var CanvasView = View.extend({
	_class: 'CanvasView',

	initialize: function CanvasView(project, canvas) {
		if (!(canvas instanceof window.HTMLCanvasElement)) {
			var size = Size.read(arguments, 1);
			if (size.isZero())
				throw new Error(
						'Cannot create CanvasView with the provided argument: '
						+ Base.slice(arguments, 1));
			canvas = CanvasProvider.getCanvas(size);
		}
		var ctx = this._context = canvas.getContext('2d');
		ctx.save();
		this._pixelRatio = 1;
		if (!/^off|false$/.test(PaperScope.getAttribute(canvas, 'hidpi'))) {
			var deviceRatio = window.devicePixelRatio || 1,
				backingStoreRatio = DomElement.getPrefixed(ctx,
						'backingStorePixelRatio') || 1;
			this._pixelRatio = deviceRatio / backingStoreRatio;
		}
		View.call(this, project, canvas);
		this._needsUpdate = true;
	},

	remove: function remove() {
		this._context.restore();
		return remove.base.call(this);
	},

	_setElementSize: function _setElementSize(width, height) {
		var pixelRatio = this._pixelRatio;
		_setElementSize.base.call(this, width * pixelRatio, height * pixelRatio);
		if (pixelRatio !== 1) {
			var element = this._element,
				ctx = this._context;
			if (!PaperScope.hasAttribute(element, 'resize')) {
				var style = element.style;
				style.width = width + 'px';
				style.height = height + 'px';
			}
			ctx.restore();
			ctx.save();
			ctx.scale(pixelRatio, pixelRatio);
		}
	},

	getContext: function() {
		return this._context;
	},

	getPixelSize: function getPixelSize(size) {
		var agent = paper.agent,
			pixels;
		if (agent && agent.firefox) {
			pixels = getPixelSize.base.call(this, size);
		} else {
			var ctx = this._context,
				prevFont = ctx.font;
			ctx.font = size + ' serif';
			pixels = parseFloat(ctx.font);
			ctx.font = prevFont;
		}
		return pixels;
	},

	getTextWidth: function(font, lines) {
		var ctx = this._context,
			prevFont = ctx.font,
			width = 0;
		ctx.font = font;
		for (var i = 0, l = lines.length; i < l; i++)
			width = Math.max(width, ctx.measureText(lines[i]).width);
		ctx.font = prevFont;
		return width;
	},

	update: function() {
		if (!this._needsUpdate)
			return false;
		var project = this._project,
			ctx = this._context,
			size = this._viewSize;
		ctx.clearRect(0, 0, size.width + 1, size.height + 1);
		if (project)
			project.draw(ctx, this._matrix, this._pixelRatio);
		this._needsUpdate = false;
		return true;
	}
});

var Event = Base.extend({
	_class: 'Event',

	initialize: function Event(event) {
		this.event = event;
		this.type = event && event.type;
	},

	prevented: false,
	stopped: false,

	preventDefault: function() {
		this.prevented = true;
		this.event.preventDefault();
	},

	stopPropagation: function() {
		this.stopped = true;
		this.event.stopPropagation();
	},

	stop: function() {
		this.stopPropagation();
		this.preventDefault();
	},

	getTimeStamp: function() {
		return this.event.timeStamp;
	},

	getModifiers: function() {
		return Key.modifiers;
	}
});

var KeyEvent = Event.extend({
	_class: 'KeyEvent',

	initialize: function KeyEvent(type, event, key, character) {
		this.type = type;
		this.event = event;
		this.key = key;
		this.character = character;
	},

	toString: function() {
		return "{ type: '" + this.type
				+ "', key: '" + this.key
				+ "', character: '" + this.character
				+ "', modifiers: " + this.getModifiers()
				+ " }";
	}
});

var Key = new function() {
	var keyLookup = {
			'\t': 'tab',
			' ': 'space',
			'\b': 'backspace',
			'\x7f': 'delete',
			'Spacebar': 'space',
			'Del': 'delete',
			'Win': 'meta',
			'Esc': 'escape'
		},

		charLookup = {
			'tab': '\t',
			'space': ' ',
			'enter': '\r'
		},

		keyMap = {},
		charMap = {},
		metaFixMap,
		downKey,

		modifiers = new Base({
			shift: false,
			control: false,
			alt: false,
			meta: false,
			capsLock: false,
			space: false
		}).inject({
			option: {
				get: function() {
					return this.alt;
				}
			},

			command: {
				get: function() {
					var agent = paper && paper.agent;
					return agent && agent.mac ? this.meta : this.control;
				}
			}
		});

	function getKey(event) {
		var key = event.key || event.keyIdentifier;
		key = /^U\+/.test(key)
				? String.fromCharCode(parseInt(key.substr(2), 16))
				: /^Arrow[A-Z]/.test(key) ? key.substr(5)
				: key === 'Unidentified'  || key === undefined
					? String.fromCharCode(event.keyCode)
					: key;
		return keyLookup[key] ||
				(key.length > 1 ? Base.hyphenate(key) : key.toLowerCase());
	}

	function handleKey(down, key, character, event) {
		var type = down ? 'keydown' : 'keyup',
			view = View._focused,
			name;
		keyMap[key] = down;
		if (down) {
			charMap[key] = character;
		} else {
			delete charMap[key];
		}
		if (key.length > 1 && (name = Base.camelize(key)) in modifiers) {
			modifiers[name] = down;
			var agent = paper && paper.agent;
			if (name === 'meta' && agent && agent.mac) {
				if (down) {
					metaFixMap = {};
				} else {
					for (var k in metaFixMap) {
						if (k in charMap)
							handleKey(false, k, metaFixMap[k], event);
					}
					metaFixMap = null;
				}
			}
		} else if (down && metaFixMap) {
			metaFixMap[key] = character;
		}
		if (view) {
			view._handleKeyEvent(down ? 'keydown' : 'keyup', event, key,
					character);
		}
	}

	DomEvent.add(document, {
		keydown: function(event) {
			var key = getKey(event),
				agent = paper && paper.agent;
			if (key.length > 1 || agent && (agent.chrome && (event.altKey
						|| agent.mac && event.metaKey
						|| !agent.mac && event.ctrlKey))) {
				handleKey(true, key,
						charLookup[key] || (key.length > 1 ? '' : key), event);
			} else {
				downKey = key;
			}
		},

		keypress: function(event) {
			if (downKey) {
				var key = getKey(event),
					code = event.charCode,
					character = code >= 32 ? String.fromCharCode(code)
						: key.length > 1 ? '' : key;
				if (key !== downKey) {
					key = character.toLowerCase();
				}
				handleKey(true, key, character, event);
				downKey = null;
			}
		},

		keyup: function(event) {
			var key = getKey(event);
			if (key in charMap)
				handleKey(false, key, charMap[key], event);
		}
	});

	DomEvent.add(window, {
		blur: function(event) {
			for (var key in charMap)
				handleKey(false, key, charMap[key], event);
		}
	});

	return {
		modifiers: modifiers,

		isDown: function(key) {
			return !!keyMap[key];
		}
	};
};

var MouseEvent = Event.extend({
	_class: 'MouseEvent',

	initialize: function MouseEvent(type, event, point, target, delta) {
		this.type = type;
		this.event = event;
		this.point = point;
		this.target = target;
		this.delta = delta;
	},

	toString: function() {
		return "{ type: '" + this.type
				+ "', point: " + this.point
				+ ', target: ' + this.target
				+ (this.delta ? ', delta: ' + this.delta : '')
				+ ', modifiers: ' + this.getModifiers()
				+ ' }';
	}
});

var ToolEvent = Event.extend({
	_class: 'ToolEvent',
	_item: null,

	initialize: function ToolEvent(tool, type, event) {
		this.tool = tool;
		this.type = type;
		this.event = event;
	},

	_choosePoint: function(point, toolPoint) {
		return point ? point : toolPoint ? toolPoint.clone() : null;
	},

	getPoint: function() {
		return this._choosePoint(this._point, this.tool._point);
	},

	setPoint: function(point) {
		this._point = point;
	},

	getLastPoint: function() {
		return this._choosePoint(this._lastPoint, this.tool._lastPoint);
	},

	setLastPoint: function(lastPoint) {
		this._lastPoint = lastPoint;
	},

	getDownPoint: function() {
		return this._choosePoint(this._downPoint, this.tool._downPoint);
	},

	setDownPoint: function(downPoint) {
		this._downPoint = downPoint;
	},

	getMiddlePoint: function() {
		if (!this._middlePoint && this.tool._lastPoint) {
			return this.tool._point.add(this.tool._lastPoint).divide(2);
		}
		return this._middlePoint;
	},

	setMiddlePoint: function(middlePoint) {
		this._middlePoint = middlePoint;
	},

	getDelta: function() {
		return !this._delta && this.tool._lastPoint
				? this.tool._point.subtract(this.tool._lastPoint)
				: this._delta;
	},

	setDelta: function(delta) {
		this._delta = delta;
	},

	getCount: function() {
		return this.tool[/^mouse(down|up)$/.test(this.type)
				? '_downCount' : '_moveCount'];
	},

	setCount: function(count) {
		this.tool[/^mouse(down|up)$/.test(this.type) ? 'downCount' : 'count']
			= count;
	},

	getItem: function() {
		if (!this._item) {
			var result = this.tool._scope.project.hitTest(this.getPoint());
			if (result) {
				var item = result.item,
					parent = item._parent;
				while (/^(Group|CompoundPath)$/.test(parent._class)) {
					item = parent;
					parent = parent._parent;
				}
				this._item = item;
			}
		}
		return this._item;
	},

	setItem: function(item) {
		this._item = item;
	},

	toString: function() {
		return '{ type: ' + this.type
				+ ', point: ' + this.getPoint()
				+ ', count: ' + this.getCount()
				+ ', modifiers: ' + this.getModifiers()
				+ ' }';
	}
});

var Tool = PaperScopeItem.extend({
	_class: 'Tool',
	_list: 'tools',
	_reference: 'tool',
	_events: ['onMouseDown', 'onMouseUp', 'onMouseDrag', 'onMouseMove',
			'onActivate', 'onDeactivate', 'onEditOptions', 'onKeyDown',
			'onKeyUp'],

	initialize: function Tool(props) {
		PaperScopeItem.call(this);
		this._moveCount = -1;
		this._downCount = -1;
		this.set(props);
	},

	getMinDistance: function() {
		return this._minDistance;
	},

	setMinDistance: function(minDistance) {
		this._minDistance = minDistance;
		if (minDistance != null && this._maxDistance != null
				&& minDistance > this._maxDistance) {
			this._maxDistance = minDistance;
		}
	},

	getMaxDistance: function() {
		return this._maxDistance;
	},

	setMaxDistance: function(maxDistance) {
		this._maxDistance = maxDistance;
		if (this._minDistance != null && maxDistance != null
				&& maxDistance < this._minDistance) {
			this._minDistance = maxDistance;
		}
	},

	getFixedDistance: function() {
		return this._minDistance == this._maxDistance
			? this._minDistance : null;
	},

	setFixedDistance: function(distance) {
		this._minDistance = this._maxDistance = distance;
	},

	_handleMouseEvent: function(type, event, point, mouse) {
		paper = this._scope;
		if (mouse.drag && !this.responds(type))
			type = 'mousemove';
		var move = mouse.move || mouse.drag,
			responds = this.responds(type),
			minDistance = this.minDistance,
			maxDistance = this.maxDistance,
			called = false,
			tool = this;
		function update(minDistance, maxDistance) {
			var pt = point,
				toolPoint = move ? tool._point : (tool._downPoint || pt);
			if (move) {
				if (tool._moveCount >= 0 && pt.equals(toolPoint)) {
					return false;
				}
				if (toolPoint && (minDistance != null || maxDistance != null)) {
					var vector = pt.subtract(toolPoint),
						distance = vector.getLength();
					if (distance < (minDistance || 0))
						return false;
					if (maxDistance) {
						pt = toolPoint.add(vector.normalize(
								Math.min(distance, maxDistance)));
					}
				}
				tool._moveCount++;
			}
			tool._point = pt;
			tool._lastPoint = toolPoint || pt;
			if (mouse.down) {
				tool._moveCount = -1;
				tool._downPoint = pt;
				tool._downCount++;
			}
			return true;
		}

		function emit() {
			if (responds) {
				called = tool.emit(type, new ToolEvent(tool, type, event))
						|| called;
			}
		}

		if (mouse.down) {
			update();
			emit();
		} else if (mouse.up) {
			update(null, maxDistance);
			emit();
		} else if (responds) {
			while (update(minDistance, maxDistance))
				emit();
		}
		return called;
	}

});

var Tween = Base.extend(Emitter, {
	_class: 'Tween',

	statics: {
		easings: new Base({
			linear: function(t) {
				return t;
			},

			easeInQuad: function(t) {
				return t * t;
			},

			easeOutQuad: function(t) {
				return t * (2 - t);
			},

			easeInOutQuad: function(t) {
				return t < 0.5
					? 2 * t * t
					: -1 + 2 * (2 - t) * t;
			},

			easeInCubic: function(t) {
				return t * t * t;
			},

			easeOutCubic: function(t) {
				return --t * t * t + 1;
			},

			easeInOutCubic: function(t) {
				return t < 0.5
					? 4 * t * t * t
					: (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
			},

			easeInQuart: function(t) {
				return t * t * t * t;
			},

			easeOutQuart: function(t) {
				return 1 - (--t) * t * t * t;
			},

			easeInOutQuart: function(t) {
				return t < 0.5
					? 8 * t * t * t * t
					: 1 - 8 * (--t) * t * t * t;
			},

			easeInQuint: function(t) {
				return t * t * t * t * t;
			},

			easeOutQuint: function(t) {
				return 1 + --t * t * t * t * t;
			},

			easeInOutQuint: function(t) {
				return t < 0.5
					? 16 * t * t * t * t * t
					: 1 + 16 * (--t) * t * t * t * t;
			}
		})
	},

	initialize: function Tween(object, from, to, duration, easing, start) {
		this.object = object;
		var type = typeof easing;
		var isFunction = type === 'function';
		this.type = isFunction
			? type
			: type === 'string'
				? easing
				: 'linear';
		this.easing = isFunction ? easing : Tween.easings[this.type];
		this.duration = duration;
		this.running = false;

		this._then = null;
		this._startTime = null;
		var state = from || to;
		this._keys = state ? Object.keys(state) : [];
		this._parsedKeys = this._parseKeys(this._keys);
		this._from = state && this._getState(from);
		this._to = state && this._getState(to);
		if (start !== false) {
			this.start();
		}
	},

	then: function(then) {
		this._then = then;
		return this;
	},

	start: function() {
		this._startTime = null;
		this.running = true;
		return this;
	},

	stop: function() {
		this.running = false;
		return this;
	},

	update: function(progress) {
		if (this.running) {
			if (progress >= 1) {
				progress = 1;
				this.running = false;
			}

			var factor = this.easing(progress),
				keys = this._keys,
				getValue = function(value) {
					return typeof value === 'function'
						? value(factor, progress)
						: value;
				};
			for (var i = 0, l = keys && keys.length; i < l; i++) {
				var key = keys[i],
					from = getValue(this._from[key]),
					to = getValue(this._to[key]),
					value = (from && to && from.__add && to.__add)
						? to.__subtract(from).__multiply(factor).__add(from)
						: ((to - from) * factor) + from;
				this._setProperty(this._parsedKeys[key], value);
			}

			if (this.responds('update')) {
				this.emit('update', new Base({
					progress: progress,
					factor: factor
				}));
			}
			if (!this.running && this._then) {
				this._then(this.object);
			}
		}
		return this;
	},

	_events: {
		onUpdate: {}
	},

	_handleFrame: function(time) {
		var startTime = this._startTime,
			progress = startTime
				? (time - startTime) / this.duration
				: 0;
		if (!startTime) {
			this._startTime = time;
		}
		this.update(progress);
	},

	_getState: function(state) {
		var keys = this._keys,
			result = {};
		for (var i = 0, l = keys.length; i < l; i++) {
			var key = keys[i],
				path = this._parsedKeys[key],
				current = this._getProperty(path),
				value;
			if (state) {
				var resolved = this._resolveValue(current, state[key]);
				this._setProperty(path, resolved);
				value = this._getProperty(path);
				value = value && value.clone ? value.clone() : value;
				this._setProperty(path, current);
			} else {
				value = current && current.clone ? current.clone() : current;
			}
			result[key] = value;
		}
		return result;
	},

	_resolveValue: function(current, value) {
		if (value) {
			if (Array.isArray(value) && value.length === 2) {
				var operator = value[0];
				return (
					operator &&
					operator.match &&
					operator.match(/^[+\-\*\/]=/)
				)
					? this._calculate(current, operator[0], value[1])
					: value;
			} else if (typeof value === 'string') {
				var match = value.match(/^[+\-*/]=(.*)/);
				if (match) {
					var parsed = JSON.parse(match[1].replace(
						/(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
						'"$2": '
					));
					return this._calculate(current, value[0], parsed);
				}
			}
		}
		return value;
	},

	_calculate: function(left, operator, right) {
		return paper.PaperScript.calculateBinary(left, operator, right);
	},

	_parseKeys: function(keys) {
		var parsed = {};
		for (var i = 0, l = keys.length; i < l; i++) {
			var key = keys[i],
				path = key
					.replace(/\.([^.]*)/g, '/$1')
					.replace(/\[['"]?([^'"\]]*)['"]?\]/g, '/$1');
			parsed[key] = path.split('/');
		}
		return parsed;
	},

	_getProperty: function(path, offset) {
		var obj = this.object;
		for (var i = 0, l = path.length - (offset || 0); i < l && obj; i++) {
			obj = obj[path[i]];
		}
		return obj;
	},

	_setProperty: function(path, value) {
		var dest = this._getProperty(path, 1);
		if (dest) {
			dest[path[path.length - 1]] = value;
		}
	}
});

var Http = {
	request: function(options) {
		var xhr = new self.XMLHttpRequest();
		xhr.open((options.method || 'get').toUpperCase(), options.url,
				Base.pick(options.async, true));
		if (options.mimeType)
			xhr.overrideMimeType(options.mimeType);
		xhr.onload = function() {
			var status = xhr.status;
			if (status === 0 || status === 200) {
				if (options.onLoad) {
					options.onLoad.call(xhr, xhr.responseText);
				}
			} else {
				xhr.onerror();
			}
		};
		xhr.onerror = function() {
			var status = xhr.status,
				message = 'Could not load "' + options.url + '" (Status: '
						+ status + ')';
			if (options.onError) {
				options.onError(message, status);
			} else {
				throw new Error(message);
			}
		};
		return xhr.send(null);
	}
};

var CanvasProvider = Base.exports.CanvasProvider = {
	canvases: [],

	getCanvas: function(width, height, options) {
		if (!window)
			return null;
		var canvas,
			clear = true;
		if (typeof width === 'object') {
			height = width.height;
			width = width.width;
		}
		if (this.canvases.length) {
			canvas = this.canvases.pop();
		} else {
			canvas = document.createElement('canvas');
			clear = false;
		}
		var ctx = canvas.getContext('2d', options || {});
		if (!ctx) {
			throw new Error('Canvas ' + canvas +
					' is unable to provide a 2D context.');
		}
		if (canvas.width === width && canvas.height === height) {
			if (clear)
				ctx.clearRect(0, 0, width + 1, height + 1);
		} else {
			canvas.width = width;
			canvas.height = height;
		}
		ctx.save();
		return canvas;
	},

	getContext: function(width, height, options) {
		var canvas = this.getCanvas(width, height, options);
		return canvas ? canvas.getContext('2d', options || {}) : null;
	},

	release: function(obj) {
		var canvas = obj && obj.canvas ? obj.canvas : obj;
		if (canvas && canvas.getContext) {
			canvas.getContext('2d').restore();
			this.canvases.push(canvas);
		}
	}
};

var BlendMode = new function() {
	var min = Math.min,
		max = Math.max,
		abs = Math.abs,
		sr, sg, sb, sa,
		br, bg, bb, ba,
		dr, dg, db;

	function getLum(r, g, b) {
		return 0.2989 * r + 0.587 * g + 0.114 * b;
	}

	function setLum(r, g, b, l) {
		var d = l - getLum(r, g, b);
		dr = r + d;
		dg = g + d;
		db = b + d;
		var l = getLum(dr, dg, db),
			mn = min(dr, dg, db),
			mx = max(dr, dg, db);
		if (mn < 0) {
			var lmn = l - mn;
			dr = l + (dr - l) * l / lmn;
			dg = l + (dg - l) * l / lmn;
			db = l + (db - l) * l / lmn;
		}
		if (mx > 255) {
			var ln = 255 - l,
				mxl = mx - l;
			dr = l + (dr - l) * ln / mxl;
			dg = l + (dg - l) * ln / mxl;
			db = l + (db - l) * ln / mxl;
		}
	}

	function getSat(r, g, b) {
		return max(r, g, b) - min(r, g, b);
	}

	function setSat(r, g, b, s) {
		var col = [r, g, b],
			mx = max(r, g, b),
			mn = min(r, g, b),
			md;
		mn = mn === r ? 0 : mn === g ? 1 : 2;
		mx = mx === r ? 0 : mx === g ? 1 : 2;
		md = min(mn, mx) === 0 ? max(mn, mx) === 1 ? 2 : 1 : 0;
		if (col[mx] > col[mn]) {
			col[md] = (col[md] - col[mn]) * s / (col[mx] - col[mn]);
			col[mx] = s;
		} else {
			col[md] = col[mx] = 0;
		}
		col[mn] = 0;
		dr = col[0];
		dg = col[1];
		db = col[2];
	}

	var modes = {
		multiply: function() {
			dr = br * sr / 255;
			dg = bg * sg / 255;
			db = bb * sb / 255;
		},

		screen: function() {
			dr = br + sr - (br * sr / 255);
			dg = bg + sg - (bg * sg / 255);
			db = bb + sb - (bb * sb / 255);
		},

		overlay: function() {
			dr = br < 128 ? 2 * br * sr / 255 : 255 - 2 * (255 - br) * (255 - sr) / 255;
			dg = bg < 128 ? 2 * bg * sg / 255 : 255 - 2 * (255 - bg) * (255 - sg) / 255;
			db = bb < 128 ? 2 * bb * sb / 255 : 255 - 2 * (255 - bb) * (255 - sb) / 255;
		},

		'soft-light': function() {
			var t = sr * br / 255;
			dr = t + br * (255 - (255 - br) * (255 - sr) / 255 - t) / 255;
			t = sg * bg / 255;
			dg = t + bg * (255 - (255 - bg) * (255 - sg) / 255 - t) / 255;
			t = sb * bb / 255;
			db = t + bb * (255 - (255 - bb) * (255 - sb) / 255 - t) / 255;
		},

		'hard-light': function() {
			dr = sr < 128 ? 2 * sr * br / 255 : 255 - 2 * (255 - sr) * (255 - br) / 255;
			dg = sg < 128 ? 2 * sg * bg / 255 : 255 - 2 * (255 - sg) * (255 - bg) / 255;
			db = sb < 128 ? 2 * sb * bb / 255 : 255 - 2 * (255 - sb) * (255 - bb) / 255;
		},

		'color-dodge': function() {
			dr = br === 0 ? 0 : sr === 255 ? 255 : min(255, 255 * br / (255 - sr));
			dg = bg === 0 ? 0 : sg === 255 ? 255 : min(255, 255 * bg / (255 - sg));
			db = bb === 0 ? 0 : sb === 255 ? 255 : min(255, 255 * bb / (255 - sb));
		},

		'color-burn': function() {
			dr = br === 255 ? 255 : sr === 0 ? 0 : max(0, 255 - (255 - br) * 255 / sr);
			dg = bg === 255 ? 255 : sg === 0 ? 0 : max(0, 255 - (255 - bg) * 255 / sg);
			db = bb === 255 ? 255 : sb === 0 ? 0 : max(0, 255 - (255 - bb) * 255 / sb);
		},

		darken: function() {
			dr = br < sr ? br : sr;
			dg = bg < sg ? bg : sg;
			db = bb < sb ? bb : sb;
		},

		lighten: function() {
			dr = br > sr ? br : sr;
			dg = bg > sg ? bg : sg;
			db = bb > sb ? bb : sb;
		},

		difference: function() {
			dr = br - sr;
			if (dr < 0)
				dr = -dr;
			dg = bg - sg;
			if (dg < 0)
				dg = -dg;
			db = bb - sb;
			if (db < 0)
				db = -db;
		},

		exclusion: function() {
			dr = br + sr * (255 - br - br) / 255;
			dg = bg + sg * (255 - bg - bg) / 255;
			db = bb + sb * (255 - bb - bb) / 255;
		},

		hue: function() {
			setSat(sr, sg, sb, getSat(br, bg, bb));
			setLum(dr, dg, db, getLum(br, bg, bb));
		},

		saturation: function() {
			setSat(br, bg, bb, getSat(sr, sg, sb));
			setLum(dr, dg, db, getLum(br, bg, bb));
		},

		luminosity: function() {
			setLum(br, bg, bb, getLum(sr, sg, sb));
		},

		color: function() {
			setLum(sr, sg, sb, getLum(br, bg, bb));
		},

		add: function() {
			dr = min(br + sr, 255);
			dg = min(bg + sg, 255);
			db = min(bb + sb, 255);
		},

		subtract: function() {
			dr = max(br - sr, 0);
			dg = max(bg - sg, 0);
			db = max(bb - sb, 0);
		},

		average: function() {
			dr = (br + sr) / 2;
			dg = (bg + sg) / 2;
			db = (bb + sb) / 2;
		},

		negation: function() {
			dr = 255 - abs(255 - sr - br);
			dg = 255 - abs(255 - sg - bg);
			db = 255 - abs(255 - sb - bb);
		}
	};

	var nativeModes = this.nativeModes = Base.each([
		'source-over', 'source-in', 'source-out', 'source-atop',
		'destination-over', 'destination-in', 'destination-out',
		'destination-atop', 'lighter', 'darker', 'copy', 'xor'
	], function(mode) {
		this[mode] = true;
	}, {});

	var ctx = CanvasProvider.getContext(1, 1, { willReadFrequently: true });
	if (ctx) {
		Base.each(modes, function(func, mode) {
			var darken = mode === 'darken',
				ok = false;
			ctx.save();
			try {
				ctx.fillStyle = darken ? '#300' : '#a00';
				ctx.fillRect(0, 0, 1, 1);
				ctx.globalCompositeOperation = mode;
				if (ctx.globalCompositeOperation === mode) {
					ctx.fillStyle = darken ? '#a00' : '#300';
					ctx.fillRect(0, 0, 1, 1);
					ok = ctx.getImageData(0, 0, 1, 1).data[0] !== darken
							? 170 : 51;
				}
			} catch (e) {}
			ctx.restore();
			nativeModes[mode] = ok;
		});
		CanvasProvider.release(ctx);
	}

	this.process = function(mode, srcContext, dstContext, alpha, offset) {
		var srcCanvas = srcContext.canvas,
			normal = mode === 'normal';
		if (normal || nativeModes[mode]) {
			dstContext.save();
			dstContext.setTransform(1, 0, 0, 1, 0, 0);
			dstContext.globalAlpha = alpha;
			if (!normal)
				dstContext.globalCompositeOperation = mode;
			dstContext.drawImage(srcCanvas, offset.x, offset.y);
			dstContext.restore();
		} else {
			var process = modes[mode];
			if (!process)
				return;
			var dstData = dstContext.getImageData(offset.x, offset.y,
					srcCanvas.width, srcCanvas.height),
				dst = dstData.data,
				src = srcContext.getImageData(0, 0,
					srcCanvas.width, srcCanvas.height).data;
			for (var i = 0, l = dst.length; i < l; i += 4) {
				sr = src[i];
				br = dst[i];
				sg = src[i + 1];
				bg = dst[i + 1];
				sb = src[i + 2];
				bb = dst[i + 2];
				sa = src[i + 3];
				ba = dst[i + 3];
				process();
				var a1 = sa * alpha / 255,
					a2 = 1 - a1;
				dst[i] = a1 * dr + a2 * br;
				dst[i + 1] = a1 * dg + a2 * bg;
				dst[i + 2] = a1 * db + a2 * bb;
				dst[i + 3] = sa * alpha + a2 * ba;
			}
			dstContext.putImageData(dstData, offset.x, offset.y);
		}
	};
};

var SvgElement = new function() {
	var svg = 'http://www.w3.org/2000/svg',
		xmlns = 'http://www.w3.org/2000/xmlns',
		xlink = 'http://www.w3.org/1999/xlink',
		attributeNamespace = {
			href: xlink,
			xlink: xmlns,
			xmlns: xmlns + '/',
			'xmlns:xlink': xmlns + '/'
		};

	function create(tag, attributes, formatter) {
		return set(document.createElementNS(svg, tag), attributes, formatter);
	}

	function get(node, name) {
		var namespace = attributeNamespace[name],
			value = namespace
				? node.getAttributeNS(namespace, name)
				: node.getAttribute(name);
		return value === 'null' ? null : value;
	}

	function set(node, attributes, formatter) {
		for (var name in attributes) {
			var value = attributes[name],
				namespace = attributeNamespace[name];
			if (typeof value === 'number' && formatter)
				value = formatter.number(value);
			if (namespace) {
				node.setAttributeNS(namespace, name, value);
			} else {
				node.setAttribute(name, value);
			}
		}
		return node;
	}

	return {
		svg: svg,
		xmlns: xmlns,
		xlink: xlink,

		create: create,
		get: get,
		set: set
	};
};

var SvgStyles = Base.each({
	fillColor: ['fill', 'color'],
	fillRule: ['fill-rule', 'string'],
	strokeColor: ['stroke', 'color'],
	strokeWidth: ['stroke-width', 'number'],
	strokeCap: ['stroke-linecap', 'string'],
	strokeJoin: ['stroke-linejoin', 'string'],
	strokeScaling: ['vector-effect', 'lookup', {
		true: 'none',
		false: 'non-scaling-stroke'
	}, function(item, value) {
		return !value
				&& (item instanceof PathItem
					|| item instanceof Shape
					|| item instanceof TextItem);
	}],
	miterLimit: ['stroke-miterlimit', 'number'],
	dashArray: ['stroke-dasharray', 'array'],
	dashOffset: ['stroke-dashoffset', 'number'],
	fontFamily: ['font-family', 'string'],
	fontWeight: ['font-weight', 'string'],
	fontSize: ['font-size', 'number'],
	justification: ['text-anchor', 'lookup', {
		left: 'start',
		center: 'middle',
		right: 'end'
	}],
	opacity: ['opacity', 'number'],
	blendMode: ['mix-blend-mode', 'style']
}, function(entry, key) {
	var part = Base.capitalize(key),
		lookup = entry[2];
	this[key] = {
		type: entry[1],
		property: key,
		attribute: entry[0],
		toSVG: lookup,
		fromSVG: lookup && Base.each(lookup, function(value, name) {
			this[value] = name;
		}, {}),
		exportFilter: entry[3],
		get: 'get' + part,
		set: 'set' + part
	};
}, {});

new function() {
	var formatter;

	function getTransform(matrix, coordinates, center) {
		var attrs = new Base(),
			trans = matrix.getTranslation();
		if (coordinates) {
			var point;
			if (matrix.isInvertible()) {
				matrix = matrix._shiftless();
				point = matrix._inverseTransform(trans);
				trans = null;
			} else {
				point = new Point();
			}
			attrs[center ? 'cx' : 'x'] = point.x;
			attrs[center ? 'cy' : 'y'] = point.y;
		}
		if (!matrix.isIdentity()) {
			var decomposed = matrix.decompose();
			if (decomposed) {
				var parts = [],
					angle = decomposed.rotation,
					scale = decomposed.scaling,
					skew = decomposed.skewing;
				if (trans && !trans.isZero())
					parts.push('translate(' + formatter.point(trans) + ')');
				if (angle)
					parts.push('rotate(' + formatter.number(angle) + ')');
				if (!Numerical.isZero(scale.x - 1)
						|| !Numerical.isZero(scale.y - 1))
					parts.push('scale(' + formatter.point(scale) +')');
				if (skew.x)
					parts.push('skewX(' + formatter.number(skew.x) + ')');
				if (skew.y)
					parts.push('skewY(' + formatter.number(skew.y) + ')');
				attrs.transform = parts.join(' ');
			} else {
				attrs.transform = 'matrix(' + matrix.getValues().join(',') + ')';
			}
		}
		return attrs;
	}

	function exportGroup(item, options) {
		var attrs = getTransform(item._matrix),
			children = item._children;
		var node = SvgElement.create('g', attrs, formatter);
		for (var i = 0, l = children.length; i < l; i++) {
			var child = children[i];
			var childNode = exportSVG(child, options);
			if (childNode) {
				if (child.isClipMask()) {
					var clip = SvgElement.create('clipPath');
					clip.appendChild(childNode);
					setDefinition(child, clip, 'clip');
					SvgElement.set(node, {
						'clip-path': 'url(#' + clip.id + ')'
					});
				} else {
					node.appendChild(childNode);
				}
			}
		}
		return node;
	}

	function exportRaster(item, options) {
		var attrs = getTransform(item._matrix, true),
			size = item.getSize(),
			image = item.getImage();
		attrs.x -= size.width / 2;
		attrs.y -= size.height / 2;
		attrs.width = size.width;
		attrs.height = size.height;
		attrs.href = options.embedImages == false && image && image.src
				|| item.toDataURL();
		return SvgElement.create('image', attrs, formatter);
	}

	function exportPath(item, options) {
		var matchShapes = options.matchShapes;
		if (matchShapes) {
			var shape = item.toShape(false);
			if (shape)
				return exportShape(shape, options);
		}
		var segments = item._segments,
			length = segments.length,
			type,
			attrs = getTransform(item._matrix);
		if (matchShapes && length >= 2 && !item.hasHandles()) {
			if (length > 2) {
				type = item._closed ? 'polygon' : 'polyline';
				var parts = [];
				for (var i = 0; i < length; i++) {
					parts.push(formatter.point(segments[i]._point));
				}
				attrs.points = parts.join(' ');
			} else {
				type = 'line';
				var start = segments[0]._point,
					end = segments[1]._point;
				attrs.set({
					x1: start.x,
					y1: start.y,
					x2: end.x,
					y2: end.y
				});
			}
		} else {
			type = 'path';
			attrs.d = item.getPathData(null, options.precision);
		}
		return SvgElement.create(type, attrs, formatter);
	}

	function exportShape(item) {
		var type = item._type,
			radius = item._radius,
			attrs = getTransform(item._matrix, true, type !== 'rectangle');
		if (type === 'rectangle') {
			type = 'rect';
			var size = item._size,
				width = size.width,
				height = size.height;
			attrs.x -= width / 2;
			attrs.y -= height / 2;
			attrs.width = width;
			attrs.height = height;
			if (radius.isZero())
				radius = null;
		}
		if (radius) {
			if (type === 'circle') {
				attrs.r = radius;
			} else {
				attrs.rx = radius.width;
				attrs.ry = radius.height;
			}
		}
		return SvgElement.create(type, attrs, formatter);
	}

	function exportCompoundPath(item, options) {
		var attrs = getTransform(item._matrix);
		var data = item.getPathData(null, options.precision);
		if (data)
			attrs.d = data;
		return SvgElement.create('path', attrs, formatter);
	}

	function exportSymbolItem(item, options) {
		var attrs = getTransform(item._matrix, true),
			definition = item._definition,
			node = getDefinition(definition, 'symbol'),
			definitionItem = definition._item,
			bounds = definitionItem.getStrokeBounds();
		if (!node) {
			node = SvgElement.create('symbol', {
				viewBox: formatter.rectangle(bounds)
			});
			node.appendChild(exportSVG(definitionItem, options));
			setDefinition(definition, node, 'symbol');
		}
		attrs.href = '#' + node.id;
		attrs.x += bounds.x;
		attrs.y += bounds.y;
		attrs.width = bounds.width;
		attrs.height = bounds.height;
		attrs.overflow = 'visible';
		return SvgElement.create('use', attrs, formatter);
	}

	function exportGradient(color) {
		var gradientNode = getDefinition(color, 'color');
		if (!gradientNode) {
			var gradient = color.getGradient(),
				radial = gradient._radial,
				origin = color.getOrigin(),
				destination = color.getDestination(),
				attrs;
			if (radial) {
				attrs = {
					cx: origin.x,
					cy: origin.y,
					r: origin.getDistance(destination)
				};
				var highlight = color.getHighlight();
				if (highlight) {
					attrs.fx = highlight.x;
					attrs.fy = highlight.y;
				}
			} else {
				attrs = {
					x1: origin.x,
					y1: origin.y,
					x2: destination.x,
					y2: destination.y
				};
			}
			attrs.gradientUnits = 'userSpaceOnUse';
			gradientNode = SvgElement.create((radial ? 'radial' : 'linear')
					+ 'Gradient', attrs, formatter);
			var stops = gradient._stops;
			for (var i = 0, l = stops.length; i < l; i++) {
				var stop = stops[i],
					stopColor = stop._color,
					alpha = stopColor.getAlpha(),
					offset = stop._offset;
				attrs = {
					offset: offset == null ? i / (l - 1) : offset
				};
				if (stopColor)
					attrs['stop-color'] = stopColor.toCSS(true);
				if (alpha < 1)
					attrs['stop-opacity'] = alpha;
				gradientNode.appendChild(
						SvgElement.create('stop', attrs, formatter));
			}
			setDefinition(color, gradientNode, 'color');
		}
		return 'url(#' + gradientNode.id + ')';
	}

	function exportText(item) {
		var node = SvgElement.create('text', getTransform(item._matrix, true),
				formatter);
		node.textContent = item._content;
		return node;
	}

	var exporters = {
		Group: exportGroup,
		Layer: exportGroup,
		Raster: exportRaster,
		Path: exportPath,
		Shape: exportShape,
		CompoundPath: exportCompoundPath,
		SymbolItem: exportSymbolItem,
		PointText: exportText
	};

	function applyStyle(item, node, isRoot) {
		var attrs = {},
			parent = !isRoot && item.getParent(),
			style = [];

		if (item._name != null)
			attrs.id = item._name;

		Base.each(SvgStyles, function(entry) {
			var get = entry.get,
				type = entry.type,
				value = item[get]();
			if (entry.exportFilter
					? entry.exportFilter(item, value)
					: !parent || !Base.equals(parent[get](), value)) {
				if (type === 'color' && value != null) {
					var alpha = value.getAlpha();
					if (alpha < 1)
						attrs[entry.attribute + '-opacity'] = alpha;
				}
				if (type === 'style') {
					style.push(entry.attribute + ': ' + value);
				} else {
					attrs[entry.attribute] = value == null ? 'none'
							: type === 'color' ? value.gradient
								? exportGradient(value, item)
								: value.toCSS(true)
							: type === 'array' ? value.join(',')
							: type === 'lookup' ? entry.toSVG[value]
							: value;
				}
			}
		});

		if (style.length)
			attrs.style = style.join(';');

		if (attrs.opacity === 1)
			delete attrs.opacity;

		if (!item._visible)
			attrs.visibility = 'hidden';

		return SvgElement.set(node, attrs, formatter);
	}

	var definitions;
	function getDefinition(item, type) {
		if (!definitions)
			definitions = { ids: {}, svgs: {} };
		return item && definitions.svgs[type + '-'
				+ (item._id || item.__id || (item.__id = UID.get('svg')))];
	}

	function setDefinition(item, node, type) {
		if (!definitions)
			getDefinition();
		var typeId = definitions.ids[type] = (definitions.ids[type] || 0) + 1;
		node.id = type + '-' + typeId;
		definitions.svgs[type + '-' + (item._id || item.__id)] = node;
	}

	function exportDefinitions(node, options) {
		var svg = node,
			defs = null;
		if (definitions) {
			svg = node.nodeName.toLowerCase() === 'svg' && node;
			for (var i in definitions.svgs) {
				if (!defs) {
					if (!svg) {
						svg = SvgElement.create('svg');
						svg.appendChild(node);
					}
					defs = svg.insertBefore(SvgElement.create('defs'),
							svg.firstChild);
				}
				defs.appendChild(definitions.svgs[i]);
			}
			definitions = null;
		}
		return options.asString
				? new self.XMLSerializer().serializeToString(svg)
				: svg;
	}

	function exportSVG(item, options, isRoot) {
		var exporter = exporters[item._class],
			node = exporter && exporter(item, options);
		if (node) {
			var onExport = options.onExport;
			if (onExport)
				node = onExport(item, node, options) || node;
			var data = JSON.stringify(item._data);
			if (data && data !== '{}' && data !== 'null')
				node.setAttribute('data-paper-data', data);
		}
		return node && applyStyle(item, node, isRoot);
	}

	function setOptions(options) {
		if (!options)
			options = {};
		formatter = new Formatter(options.precision);
		return options;
	}

	Item.inject({
		exportSVG: function(options) {
			options = setOptions(options);
			return exportDefinitions(exportSVG(this, options, true), options);
		}
	});

	Project.inject({
		exportSVG: function(options) {
			options = setOptions(options);
			var children = this._children,
				view = this.getView(),
				bounds = Base.pick(options.bounds, 'view'),
				mx = options.matrix || bounds === 'view' && view._matrix,
				matrix = mx && Matrix.read([mx]),
				rect = bounds === 'view'
					? new Rectangle([0, 0], view.getViewSize())
					: bounds === 'content'
						? Item._getBounds(children, matrix, { stroke: true })
							.rect
						: Rectangle.read([bounds], 0, { readNull: true }),
				attrs = {
					version: '1.1',
					xmlns: SvgElement.svg,
					'xmlns:xlink': SvgElement.xlink,
				};
			if (rect) {
				attrs.width = rect.width;
				attrs.height = rect.height;
				if (rect.x || rect.x === 0 || rect.y || rect.y === 0)
					attrs.viewBox = formatter.rectangle(rect);
			}
			var node = SvgElement.create('svg', attrs, formatter),
				parent = node;
			if (matrix && !matrix.isIdentity()) {
				parent = node.appendChild(SvgElement.create('g',
						getTransform(matrix), formatter));
			}
			for (var i = 0, l = children.length; i < l; i++) {
				parent.appendChild(exportSVG(children[i], options, true));
			}
			return exportDefinitions(node, options);
		}
	});
};

new function() {

	var definitions = {},
		rootSize;

	function getValue(node, name, isString, allowNull, allowPercent,
			defaultValue) {
		var value = SvgElement.get(node, name) || defaultValue,
			res = value == null
				? allowNull
					? null
					: isString ? '' : 0
				: isString
					? value
					: parseFloat(value);
		return /%\s*$/.test(value)
			? (res / 100) * (allowPercent ? 1
				: rootSize[/x|^width/.test(name) ? 'width' : 'height'])
			: res;
	}

	function getPoint(node, x, y, allowNull, allowPercent, defaultX, defaultY) {
		x = getValue(node, x || 'x', false, allowNull, allowPercent, defaultX);
		y = getValue(node, y || 'y', false, allowNull, allowPercent, defaultY);
		return allowNull && (x == null || y == null) ? null
				: new Point(x, y);
	}

	function getSize(node, w, h, allowNull, allowPercent) {
		w = getValue(node, w || 'width', false, allowNull, allowPercent);
		h = getValue(node, h || 'height', false, allowNull, allowPercent);
		return allowNull && (w == null || h == null) ? null
				: new Size(w, h);
	}

	function convertValue(value, type, lookup) {
		return value === 'none' ? null
				: type === 'number' ? parseFloat(value)
				: type === 'array' ?
					value ? value.split(/[\s,]+/g).map(parseFloat) : []
				: type === 'color' ? getDefinition(value) || value
				: type === 'lookup' ? lookup[value]
				: value;
	}

	function importGroup(node, type, options, isRoot) {
		var nodes = node.childNodes,
			isClip = type === 'clippath',
			isDefs = type === 'defs',
			item = new Group(),
			project = item._project,
			currentStyle = project._currentStyle,
			children = [];
		if (!isClip && !isDefs) {
			item = applyAttributes(item, node, isRoot);
			project._currentStyle = item._style.clone();
		}
		if (isRoot) {
			var defs = node.querySelectorAll('defs');
			for (var i = 0, l = defs.length; i < l; i++) {
				importNode(defs[i], options, false);
			}
		}
		for (var i = 0, l = nodes.length; i < l; i++) {
			var childNode = nodes[i],
				child;
			if (childNode.nodeType === 1
					&& !/^defs$/i.test(childNode.nodeName)
					&& (child = importNode(childNode, options, false))
					&& !(child instanceof SymbolDefinition))
				children.push(child);
		}
		item.addChildren(children);
		if (isClip)
			item = applyAttributes(item.reduce(), node, isRoot);
		project._currentStyle = currentStyle;
		if (isClip || isDefs) {
			item.remove();
			item = null;
		}
		return item;
	}

	function importPoly(node, type) {
		var coords = node.getAttribute('points').match(
					/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g),
			points = [];
		for (var i = 0, l = coords.length; i < l; i += 2)
			points.push(new Point(
					parseFloat(coords[i]),
					parseFloat(coords[i + 1])));
		var path = new Path(points);
		if (type === 'polygon')
			path.closePath();
		return path;
	}

	function importPath(node) {
		return PathItem.create(node.getAttribute('d'));
	}

	function importGradient(node, type) {
		var id = (getValue(node, 'href', true) || '').substring(1),
			radial = type === 'radialgradient',
			gradient;
		if (id) {
			gradient = definitions[id].getGradient();
			if (gradient._radial ^ radial) {
				gradient = gradient.clone();
				gradient._radial = radial;
			}
		} else {
			var nodes = node.childNodes,
				stops = [];
			for (var i = 0, l = nodes.length; i < l; i++) {
				var child = nodes[i];
				if (child.nodeType === 1)
					stops.push(applyAttributes(new GradientStop(), child));
			}
			gradient = new Gradient(stops, radial);
		}
		var origin, destination, highlight,
			scaleToBounds = getValue(node, 'gradientUnits', true) !==
				'userSpaceOnUse';
		if (radial) {
			origin = getPoint(node, 'cx', 'cy', false, scaleToBounds,
				'50%', '50%');
			destination = origin.add(
				getValue(node, 'r', false, false, scaleToBounds, '50%'), 0);
			highlight = getPoint(node, 'fx', 'fy', true, scaleToBounds);
		} else {
			origin = getPoint(node, 'x1', 'y1', false, scaleToBounds,
				'0%', '0%');
			destination = getPoint(node, 'x2', 'y2', false, scaleToBounds,
				'100%', '0%');
		}
		var color = applyAttributes(
				new Color(gradient, origin, destination, highlight), node);
		color._scaleToBounds = scaleToBounds;
		return null;
	}

	var importers = {
		'#document': function (node, type, options, isRoot) {
			var nodes = node.childNodes;
			for (var i = 0, l = nodes.length; i < l; i++) {
				var child = nodes[i];
				if (child.nodeType === 1)
					return importNode(child, options, isRoot);
			}
		},
		g: importGroup,
		svg: importGroup,
		clippath: importGroup,
		polygon: importPoly,
		polyline: importPoly,
		path: importPath,
		lineargradient: importGradient,
		radialgradient: importGradient,

		image: function (node) {
			var raster = new Raster(getValue(node, 'href', true));
			raster.on('load', function() {
				var size = getSize(node);
				this.setSize(size);
				var center = getPoint(node).add(size.divide(2));
				this._matrix.append(new Matrix().translate(center));
			});
			return raster;
		},

		symbol: function(node, type, options, isRoot) {
			return new SymbolDefinition(
					importGroup(node, type, options, isRoot), true);
		},

		defs: importGroup,

		use: function(node) {
			var id = (getValue(node, 'href', true) || '').substring(1),
				definition = definitions[id],
				point = getPoint(node);
			return definition
					? definition instanceof SymbolDefinition
						? definition.place(point)
						: definition.clone().translate(point)
					: null;
		},

		circle: function(node) {
			return new Shape.Circle(
					getPoint(node, 'cx', 'cy'),
					getValue(node, 'r'));
		},

		ellipse: function(node) {
			return new Shape.Ellipse({
				center: getPoint(node, 'cx', 'cy'),
				radius: getSize(node, 'rx', 'ry')
			});
		},

		rect: function(node) {
			return new Shape.Rectangle(new Rectangle(
						getPoint(node),
						getSize(node)
					), getSize(node, 'rx', 'ry'));
			},

		line: function(node) {
			return new Path.Line(
					getPoint(node, 'x1', 'y1'),
					getPoint(node, 'x2', 'y2'));
		},

		text: function(node) {
			var text = new PointText(getPoint(node).add(
					getPoint(node, 'dx', 'dy')));
			text.setContent(node.textContent.trim() || '');
			return text;
		},

		switch: importGroup
	};

	function applyTransform(item, value, name, node) {
		if (item.transform) {
			var transforms = (node.getAttribute(name) || '').split(/\)\s*/g),
				matrix = new Matrix();
			for (var i = 0, l = transforms.length; i < l; i++) {
				var transform = transforms[i];
				if (!transform)
					break;
				var parts = transform.split(/\(\s*/),
					command = parts[0],
					v = parts[1].split(/[\s,]+/g);
				for (var j = 0, m = v.length; j < m; j++)
					v[j] = parseFloat(v[j]);
				switch (command) {
				case 'matrix':
					matrix.append(
							new Matrix(v[0], v[1], v[2], v[3], v[4], v[5]));
					break;
				case 'rotate':
					matrix.rotate(v[0], v[1] || 0, v[2] || 0);
					break;
				case 'translate':
					matrix.translate(v[0], v[1] || 0);
					break;
				case 'scale':
					matrix.scale(v);
					break;
				case 'skewX':
					matrix.skew(v[0], 0);
					break;
				case 'skewY':
					matrix.skew(0, v[0]);
					break;
				}
			}
			item.transform(matrix);
		}
	}

	function applyOpacity(item, value, name) {
		var key = name === 'fill-opacity' ? 'getFillColor' : 'getStrokeColor',
			color = item[key] && item[key]();
		if (color)
			color.setAlpha(parseFloat(value));
	}

	var attributes = Base.set(Base.each(SvgStyles, function(entry) {
		this[entry.attribute] = function(item, value) {
			if (item[entry.set]) {
				item[entry.set](convertValue(value, entry.type, entry.fromSVG));
				if (entry.type === 'color') {
					var color = item[entry.get]();
					if (color) {
						if (color._scaleToBounds) {
							var bounds = item.getBounds();
							color.transform(new Matrix()
								.translate(bounds.getPoint())
								.scale(bounds.getSize()));
						}
					}
				}
			}
		};
	}, {}), {
		id: function(item, value) {
			definitions[value] = item;
			if (item.setName)
				item.setName(value);
		},

		'clip-path': function(item, value) {
			var clip = getDefinition(value);
			if (clip) {
				clip = clip.clone();
				clip.setClipMask(true);
				if (item instanceof Group) {
					item.insertChild(0, clip);
				} else {
					return new Group(clip, item);
				}
			}
		},

		gradientTransform: applyTransform,
		transform: applyTransform,

		'fill-opacity': applyOpacity,
		'stroke-opacity': applyOpacity,

		visibility: function(item, value) {
			if (item.setVisible)
				item.setVisible(value === 'visible');
		},

		display: function(item, value) {
			if (item.setVisible)
				item.setVisible(value !== null);
		},

		'stop-color': function(item, value) {
			if (item.setColor)
				item.setColor(value);
		},

		'stop-opacity': function(item, value) {
			if (item._color)
				item._color.setAlpha(parseFloat(value));
		},

		offset: function(item, value) {
			if (item.setOffset) {
				var percent = value.match(/(.*)%$/);
				item.setOffset(percent ? percent[1] / 100 : parseFloat(value));
			}
		},

		viewBox: function(item, value, name, node, styles) {
			var rect = new Rectangle(convertValue(value, 'array')),
				size = getSize(node, null, null, true),
				group,
				matrix;
			if (item instanceof Group) {
				var scale = size ? size.divide(rect.getSize()) : 1,
				matrix = new Matrix().scale(scale)
						.translate(rect.getPoint().negate());
				group = item;
			} else if (item instanceof SymbolDefinition) {
				if (size)
					rect.setSize(size);
				group = item._item;
			}
			if (group)  {
				if (getAttribute(node, 'overflow', styles) !== 'visible') {
					var clip = new Shape.Rectangle(rect);
					clip.setClipMask(true);
					group.addChild(clip);
				}
				if (matrix)
					group.transform(matrix);
			}
		}
	});

	function getAttribute(node, name, styles) {
		var attr = node.attributes[name],
			value = attr && attr.value;
		if (!value && node.style) {
			var style = Base.camelize(name);
			value = node.style[style];
			if (!value && styles.node[style] !== styles.parent[style])
				value = styles.node[style];
		}
		return !value ? undefined
				: value === 'none' ? null
				: value;
	}

	function applyAttributes(item, node, isRoot) {
		var parent = node.parentNode,
			styles = {
				node: DomElement.getStyles(node) || {},
				parent: !isRoot && !/^defs$/i.test(parent.tagName)
						&& DomElement.getStyles(parent) || {}
			};
		Base.each(attributes, function(apply, name) {
			var value = getAttribute(node, name, styles);
			item = value !== undefined
					&& apply(item, value, name, node, styles) || item;
		});
		return item;
	}

	function getDefinition(value) {
		var match = value && value.match(/\((?:["'#]*)([^"')]+)/),
			name = match && match[1],
			res = name && definitions[window
					? name.replace(window.location.href.split('#')[0] + '#', '')
					: name];
		if (res && res._scaleToBounds) {
			res = res.clone();
			res._scaleToBounds = true;
		}
		return res;
	}

	function importNode(node, options, isRoot) {
		var type = node.nodeName.toLowerCase(),
			isElement = type !== '#document',
			body = document.body,
			container,
			parent,
			next;
		if (isRoot && isElement) {
			rootSize = paper.getView().getSize();
			rootSize = getSize(node, null, null, true) || rootSize;
			container = SvgElement.create('svg', {
				style: 'stroke-width: 1px; stroke-miterlimit: 10'
			});
			parent = node.parentNode;
			next = node.nextSibling;
			container.appendChild(node);
			body.appendChild(container);
		}
		var settings = paper.settings,
			applyMatrix = settings.applyMatrix,
			insertItems = settings.insertItems;
		settings.applyMatrix = false;
		settings.insertItems = false;
		var importer = importers[type],
			item = importer && importer(node, type, options, isRoot) || null;
		settings.insertItems = insertItems;
		settings.applyMatrix = applyMatrix;
		if (item) {
			if (isElement && !(item instanceof Group))
				item = applyAttributes(item, node, isRoot);
			var onImport = options.onImport,
				data = isElement && node.getAttribute('data-paper-data');
			if (onImport)
				item = onImport(node, item, options) || item;
			if (options.expandShapes && item instanceof Shape) {
				item.remove();
				item = item.toPath();
			}
			if (data)
				item._data = JSON.parse(data);
		}
		if (container) {
			body.removeChild(container);
			if (parent) {
				if (next) {
					parent.insertBefore(node, next);
				} else {
					parent.appendChild(node);
				}
			}
		}
		if (isRoot) {
			definitions = {};
			if (item && Base.pick(options.applyMatrix, applyMatrix))
				item.matrix.apply(true, true);
		}
		return item;
	}

	function importSVG(source, options, owner) {
		if (!source)
			return null;
		options = typeof options === 'function' ? { onLoad: options }
				: options || {};
		var scope = paper,
			item = null;

		function onLoad(svg) {
			try {
				var node = typeof svg === 'object'
					? svg
					: new self.DOMParser().parseFromString(
						svg.trim(),
						'image/svg+xml'
					);
				if (!node.nodeName) {
					node = null;
					throw new Error('Unsupported SVG source: ' + source);
				}
				paper = scope;
				item = importNode(node, options, true);
				if (!options || options.insert !== false) {
					owner._insertItem(undefined, item);
				}
				var onLoad = options.onLoad;
				if (onLoad)
					onLoad(item, svg);
			} catch (e) {
				onError(e);
			}
		}

		function onError(message, status) {
			var onError = options.onError;
			if (onError) {
				onError(message, status);
			} else {
				throw new Error(message);
			}
		}

		if (typeof source === 'string' && !/^[\s\S]*</.test(source)) {
			var node = document.getElementById(source);
			if (node) {
				onLoad(node);
			} else {
				Http.request({
					url: source,
					async: true,
					onLoad: onLoad,
					onError: onError
				});
			}
		} else if (typeof File !== 'undefined' && source instanceof File) {
			var reader = new FileReader();
			reader.onload = function() {
				onLoad(reader.result);
			};
			reader.onerror = function() {
				onError(reader.error);
			};
			return reader.readAsText(source);
		} else {
			onLoad(source);
		}

		return item;
	}

	Item.inject({
		importSVG: function(node, options) {
			return importSVG(node, options, this);
		}
	});

	Project.inject({
		importSVG: function(node, options) {
			this.activate();
			return importSVG(node, options, this);
		}
	});
};

Base.exports.PaperScript = function() {
	var global = this,
		acorn = global.acorn;
	if (!acorn && "function" !== 'undefined') {
		try { acorn = __webpack_require__(/*! acorn */ "../../../node_modules/acorn/dist/acorn.js"); } catch(e) {}
	}
	if (!acorn) {
		var exports, module;
		acorn = exports = module = {};

(function(root, mod) {
  if (typeof exports == "object" && typeof module == "object") return mod(exports);
  if (true) return !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (mod),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  mod(root.acorn || (root.acorn = {}));
})(this, function(exports) {
  "use strict";

  exports.version = "0.5.0";

  var options, input, inputLen, sourceFile;

  exports.parse = function(inpt, opts) {
	input = String(inpt); inputLen = input.length;
	setOptions(opts);
	initTokenState();
	return parseTopLevel(options.program);
  };

  var defaultOptions = exports.defaultOptions = {
	ecmaVersion: 5,
	strictSemicolons: false,
	allowTrailingCommas: true,
	forbidReserved: false,
	allowReturnOutsideFunction: false,
	locations: false,
	onComment: null,
	ranges: false,
	program: null,
	sourceFile: null,
	directSourceFile: null
  };

  function setOptions(opts) {
	options = opts || {};
	for (var opt in defaultOptions) if (!Object.prototype.hasOwnProperty.call(options, opt))
	  options[opt] = defaultOptions[opt];
	sourceFile = options.sourceFile || null;
  }

  var getLineInfo = exports.getLineInfo = function(input, offset) {
	for (var line = 1, cur = 0;;) {
	  lineBreak.lastIndex = cur;
	  var match = lineBreak.exec(input);
	  if (match && match.index < offset) {
		++line;
		cur = match.index + match[0].length;
	  } else break;
	}
	return {line: line, column: offset - cur};
  };

  exports.tokenize = function(inpt, opts) {
	input = String(inpt); inputLen = input.length;
	setOptions(opts);
	initTokenState();

	var t = {};
	function getToken(forceRegexp) {
	  lastEnd = tokEnd;
	  readToken(forceRegexp);
	  t.start = tokStart; t.end = tokEnd;
	  t.startLoc = tokStartLoc; t.endLoc = tokEndLoc;
	  t.type = tokType; t.value = tokVal;
	  return t;
	}
	getToken.jumpTo = function(pos, reAllowed) {
	  tokPos = pos;
	  if (options.locations) {
		tokCurLine = 1;
		tokLineStart = lineBreak.lastIndex = 0;
		var match;
		while ((match = lineBreak.exec(input)) && match.index < pos) {
		  ++tokCurLine;
		  tokLineStart = match.index + match[0].length;
		}
	  }
	  tokRegexpAllowed = reAllowed;
	  skipSpace();
	};
	return getToken;
  };

  var tokPos;

  var tokStart, tokEnd;

  var tokStartLoc, tokEndLoc;

  var tokType, tokVal;

  var tokRegexpAllowed;

  var tokCurLine, tokLineStart;

  var lastStart, lastEnd, lastEndLoc;

  var inFunction, labels, strict;

  function raise(pos, message) {
	var loc = getLineInfo(input, pos);
	message += " (" + loc.line + ":" + loc.column + ")";
	var err = new SyntaxError(message);
	err.pos = pos; err.loc = loc; err.raisedAt = tokPos;
	throw err;
  }

  var empty = [];

  var _num = {type: "num"}, _regexp = {type: "regexp"}, _string = {type: "string"};
  var _name = {type: "name"}, _eof = {type: "eof"};

  var _break = {keyword: "break"}, _case = {keyword: "case", beforeExpr: true}, _catch = {keyword: "catch"};
  var _continue = {keyword: "continue"}, _debugger = {keyword: "debugger"}, _default = {keyword: "default"};
  var _do = {keyword: "do", isLoop: true}, _else = {keyword: "else", beforeExpr: true};
  var _finally = {keyword: "finally"}, _for = {keyword: "for", isLoop: true}, _function = {keyword: "function"};
  var _if = {keyword: "if"}, _return = {keyword: "return", beforeExpr: true}, _switch = {keyword: "switch"};
  var _throw = {keyword: "throw", beforeExpr: true}, _try = {keyword: "try"}, _var = {keyword: "var"};
  var _while = {keyword: "while", isLoop: true}, _with = {keyword: "with"}, _new = {keyword: "new", beforeExpr: true};
  var _this = {keyword: "this"};

  var _null = {keyword: "null", atomValue: null}, _true = {keyword: "true", atomValue: true};
  var _false = {keyword: "false", atomValue: false};

  var _in = {keyword: "in", binop: 7, beforeExpr: true};

  var keywordTypes = {"break": _break, "case": _case, "catch": _catch,
					  "continue": _continue, "debugger": _debugger, "default": _default,
					  "do": _do, "else": _else, "finally": _finally, "for": _for,
					  "function": _function, "if": _if, "return": _return, "switch": _switch,
					  "throw": _throw, "try": _try, "var": _var, "while": _while, "with": _with,
					  "null": _null, "true": _true, "false": _false, "new": _new, "in": _in,
					  "instanceof": {keyword: "instanceof", binop: 7, beforeExpr: true}, "this": _this,
					  "typeof": {keyword: "typeof", prefix: true, beforeExpr: true},
					  "void": {keyword: "void", prefix: true, beforeExpr: true},
					  "delete": {keyword: "delete", prefix: true, beforeExpr: true}};

  var _bracketL = {type: "[", beforeExpr: true}, _bracketR = {type: "]"}, _braceL = {type: "{", beforeExpr: true};
  var _braceR = {type: "}"}, _parenL = {type: "(", beforeExpr: true}, _parenR = {type: ")"};
  var _comma = {type: ",", beforeExpr: true}, _semi = {type: ";", beforeExpr: true};
  var _colon = {type: ":", beforeExpr: true}, _dot = {type: "."}, _question = {type: "?", beforeExpr: true};

  var _slash = {binop: 10, beforeExpr: true}, _eq = {isAssign: true, beforeExpr: true};
  var _assign = {isAssign: true, beforeExpr: true};
  var _incDec = {postfix: true, prefix: true, isUpdate: true}, _prefix = {prefix: true, beforeExpr: true};
  var _logicalOR = {binop: 1, beforeExpr: true};
  var _logicalAND = {binop: 2, beforeExpr: true};
  var _bitwiseOR = {binop: 3, beforeExpr: true};
  var _bitwiseXOR = {binop: 4, beforeExpr: true};
  var _bitwiseAND = {binop: 5, beforeExpr: true};
  var _equality = {binop: 6, beforeExpr: true};
  var _relational = {binop: 7, beforeExpr: true};
  var _bitShift = {binop: 8, beforeExpr: true};
  var _plusMin = {binop: 9, prefix: true, beforeExpr: true};
  var _multiplyModulo = {binop: 10, beforeExpr: true};

  exports.tokTypes = {bracketL: _bracketL, bracketR: _bracketR, braceL: _braceL, braceR: _braceR,
					  parenL: _parenL, parenR: _parenR, comma: _comma, semi: _semi, colon: _colon,
					  dot: _dot, question: _question, slash: _slash, eq: _eq, name: _name, eof: _eof,
					  num: _num, regexp: _regexp, string: _string};
  for (var kw in keywordTypes) exports.tokTypes["_" + kw] = keywordTypes[kw];

  function makePredicate(words) {
	words = words.split(" ");
	var f = "", cats = [];
	out: for (var i = 0; i < words.length; ++i) {
	  for (var j = 0; j < cats.length; ++j)
		if (cats[j][0].length == words[i].length) {
		  cats[j].push(words[i]);
		  continue out;
		}
	  cats.push([words[i]]);
	}
	function compareTo(arr) {
	  if (arr.length == 1) return f += "return str === " + JSON.stringify(arr[0]) + ";";
	  f += "switch(str){";
	  for (var i = 0; i < arr.length; ++i) f += "case " + JSON.stringify(arr[i]) + ":";
	  f += "return true}return false;";
	}

	if (cats.length > 3) {
	  cats.sort(function(a, b) {return b.length - a.length;});
	  f += "switch(str.length){";
	  for (var i = 0; i < cats.length; ++i) {
		var cat = cats[i];
		f += "case " + cat[0].length + ":";
		compareTo(cat);
	  }
	  f += "}";

	} else {
	  compareTo(words);
	}
	return new Function("str", f);
  }

  var isReservedWord3 = makePredicate("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile");

  var isReservedWord5 = makePredicate("class enum extends super const export import");

  var isStrictReservedWord = makePredicate("implements interface let package private protected public static yield");

  var isStrictBadIdWord = makePredicate("eval arguments");

  var isKeyword = makePredicate("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this");

  var nonASCIIwhitespace = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/;
  var nonASCIIidentifierStartChars = "\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05f2\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u08a0\u08a2-\u08ac\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0e01-\u0e30\u0e32\u0e33\u0e40-\u0e46\u0e81\u0e82\u0e84\u0e87\u0e88\u0e8a\u0e8d\u0e94-\u0e97\u0e99-\u0e9f\u0ea1-\u0ea3\u0ea5\u0ea7\u0eaa\u0eab\u0ead-\u0eb0\u0eb2\u0eb3\u0ebd\u0ec0-\u0ec4\u0ec6\u0edc-\u0edf\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u1000-\u102a\u103f\u1050-\u1055\u105a-\u105d\u1061\u1065\u1066\u106e-\u1070\u1075-\u1081\u108e\u10a0-\u10c5\u10c7\u10cd\u10d0-\u10fa\u10fc-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1780-\u17b3\u17d7\u17dc\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1950-\u196d\u1970-\u1974\u1980-\u19ab\u19c1-\u19c7\u1a00-\u1a16\u1a20-\u1a54\u1aa7\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bba-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1cf5\u1cf6\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2cf2\u2cf3\u2d00-\u2d25\u2d27\u2d2d\u2d30-\u2d67\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303c\u3041-\u3096\u309d-\u309f\u30a1-\u30fa\u30fc-\u30ff\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\u31f0-\u31ff\u3400-\u4db5\u4e00-\u9fcc\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790-\ua793\ua7a0-\ua7aa\ua7f8-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uaa60-\uaa76\uaa7a\uaa80-\uaaaf\uaab1\uaab5\uaab6\uaab9-\uaabd\uaac0\uaac2\uaadb-\uaadd\uaae0-\uaaea\uaaf2-\uaaf4\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\uf900-\ufa6d\ufa70-\ufad9\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uff66-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc";
  var nonASCIIidentifierChars = "\u0300-\u036f\u0483-\u0487\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u0620-\u0649\u0672-\u06d3\u06e7-\u06e8\u06fb-\u06fc\u0730-\u074a\u0800-\u0814\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0840-\u0857\u08e4-\u08fe\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962-\u0963\u0966-\u096f\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09d7\u09df-\u09e0\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a66-\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2-\u0ae3\u0ae6-\u0aef\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b5f-\u0b60\u0b66-\u0b6f\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0be6-\u0bef\u0c01-\u0c03\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62-\u0c63\u0c66-\u0c6f\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2-\u0ce3\u0ce6-\u0cef\u0d02\u0d03\u0d46-\u0d48\u0d57\u0d62-\u0d63\u0d66-\u0d6f\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e34-\u0e3a\u0e40-\u0e45\u0e50-\u0e59\u0eb4-\u0eb9\u0ec8-\u0ecd\u0ed0-\u0ed9\u0f18\u0f19\u0f20-\u0f29\u0f35\u0f37\u0f39\u0f41-\u0f47\u0f71-\u0f84\u0f86-\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u1000-\u1029\u1040-\u1049\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f-\u109d\u135d-\u135f\u170e-\u1710\u1720-\u1730\u1740-\u1750\u1772\u1773\u1780-\u17b2\u17dd\u17e0-\u17e9\u180b-\u180d\u1810-\u1819\u1920-\u192b\u1930-\u193b\u1951-\u196d\u19b0-\u19c0\u19c8-\u19c9\u19d0-\u19d9\u1a00-\u1a15\u1a20-\u1a53\u1a60-\u1a7c\u1a7f-\u1a89\u1a90-\u1a99\u1b46-\u1b4b\u1b50-\u1b59\u1b6b-\u1b73\u1bb0-\u1bb9\u1be6-\u1bf3\u1c00-\u1c22\u1c40-\u1c49\u1c5b-\u1c7d\u1cd0-\u1cd2\u1d00-\u1dbe\u1e01-\u1f15\u200c\u200d\u203f\u2040\u2054\u20d0-\u20dc\u20e1\u20e5-\u20f0\u2d81-\u2d96\u2de0-\u2dff\u3021-\u3028\u3099\u309a\ua640-\ua66d\ua674-\ua67d\ua69f\ua6f0-\ua6f1\ua7f8-\ua800\ua806\ua80b\ua823-\ua827\ua880-\ua881\ua8b4-\ua8c4\ua8d0-\ua8d9\ua8f3-\ua8f7\ua900-\ua909\ua926-\ua92d\ua930-\ua945\ua980-\ua983\ua9b3-\ua9c0\uaa00-\uaa27\uaa40-\uaa41\uaa4c-\uaa4d\uaa50-\uaa59\uaa7b\uaae0-\uaae9\uaaf2-\uaaf3\uabc0-\uabe1\uabec\uabed\uabf0-\uabf9\ufb20-\ufb28\ufe00-\ufe0f\ufe20-\ufe26\ufe33\ufe34\ufe4d-\ufe4f\uff10-\uff19\uff3f";
  var nonASCIIidentifierStart = new RegExp("[" + nonASCIIidentifierStartChars + "]");
  var nonASCIIidentifier = new RegExp("[" + nonASCIIidentifierStartChars + nonASCIIidentifierChars + "]");

  var newline = /[\n\r\u2028\u2029]/;

  var lineBreak = /\r\n|[\n\r\u2028\u2029]/g;

  var isIdentifierStart = exports.isIdentifierStart = function(code) {
	if (code < 65) return code === 36;
	if (code < 91) return true;
	if (code < 97) return code === 95;
	if (code < 123)return true;
	return code >= 0xaa && nonASCIIidentifierStart.test(String.fromCharCode(code));
  };

  var isIdentifierChar = exports.isIdentifierChar = function(code) {
	if (code < 48) return code === 36;
	if (code < 58) return true;
	if (code < 65) return false;
	if (code < 91) return true;
	if (code < 97) return code === 95;
	if (code < 123)return true;
	return code >= 0xaa && nonASCIIidentifier.test(String.fromCharCode(code));
  };

  function line_loc_t() {
	this.line = tokCurLine;
	this.column = tokPos - tokLineStart;
  }

  function initTokenState() {
	tokCurLine = 1;
	tokPos = tokLineStart = 0;
	tokRegexpAllowed = true;
	skipSpace();
  }

  function finishToken(type, val) {
	tokEnd = tokPos;
	if (options.locations) tokEndLoc = new line_loc_t;
	tokType = type;
	skipSpace();
	tokVal = val;
	tokRegexpAllowed = type.beforeExpr;
  }

  function skipBlockComment() {
	var startLoc = options.onComment && options.locations && new line_loc_t;
	var start = tokPos, end = input.indexOf("*/", tokPos += 2);
	if (end === -1) raise(tokPos - 2, "Unterminated comment");
	tokPos = end + 2;
	if (options.locations) {
	  lineBreak.lastIndex = start;
	  var match;
	  while ((match = lineBreak.exec(input)) && match.index < tokPos) {
		++tokCurLine;
		tokLineStart = match.index + match[0].length;
	  }
	}
	if (options.onComment)
	  options.onComment(true, input.slice(start + 2, end), start, tokPos,
						startLoc, options.locations && new line_loc_t);
  }

  function skipLineComment() {
	var start = tokPos;
	var startLoc = options.onComment && options.locations && new line_loc_t;
	var ch = input.charCodeAt(tokPos+=2);
	while (tokPos < inputLen && ch !== 10 && ch !== 13 && ch !== 8232 && ch !== 8233) {
	  ++tokPos;
	  ch = input.charCodeAt(tokPos);
	}
	if (options.onComment)
	  options.onComment(false, input.slice(start + 2, tokPos), start, tokPos,
						startLoc, options.locations && new line_loc_t);
  }

  function skipSpace() {
	while (tokPos < inputLen) {
	  var ch = input.charCodeAt(tokPos);
	  if (ch === 32) {
		++tokPos;
	  } else if (ch === 13) {
		++tokPos;
		var next = input.charCodeAt(tokPos);
		if (next === 10) {
		  ++tokPos;
		}
		if (options.locations) {
		  ++tokCurLine;
		  tokLineStart = tokPos;
		}
	  } else if (ch === 10 || ch === 8232 || ch === 8233) {
		++tokPos;
		if (options.locations) {
		  ++tokCurLine;
		  tokLineStart = tokPos;
		}
	  } else if (ch > 8 && ch < 14) {
		++tokPos;
	  } else if (ch === 47) {
		var next = input.charCodeAt(tokPos + 1);
		if (next === 42) {
		  skipBlockComment();
		} else if (next === 47) {
		  skipLineComment();
		} else break;
	  } else if (ch === 160) {
		++tokPos;
	  } else if (ch >= 5760 && nonASCIIwhitespace.test(String.fromCharCode(ch))) {
		++tokPos;
	  } else {
		break;
	  }
	}
  }

  function readToken_dot() {
	var next = input.charCodeAt(tokPos + 1);
	if (next >= 48 && next <= 57) return readNumber(true);
	++tokPos;
	return finishToken(_dot);
  }

  function readToken_slash() {
	var next = input.charCodeAt(tokPos + 1);
	if (tokRegexpAllowed) {++tokPos; return readRegexp();}
	if (next === 61) return finishOp(_assign, 2);
	return finishOp(_slash, 1);
  }

  function readToken_mult_modulo() {
	var next = input.charCodeAt(tokPos + 1);
	if (next === 61) return finishOp(_assign, 2);
	return finishOp(_multiplyModulo, 1);
  }

  function readToken_pipe_amp(code) {
	var next = input.charCodeAt(tokPos + 1);
	if (next === code) return finishOp(code === 124 ? _logicalOR : _logicalAND, 2);
	if (next === 61) return finishOp(_assign, 2);
	return finishOp(code === 124 ? _bitwiseOR : _bitwiseAND, 1);
  }

  function readToken_caret() {
	var next = input.charCodeAt(tokPos + 1);
	if (next === 61) return finishOp(_assign, 2);
	return finishOp(_bitwiseXOR, 1);
  }

  function readToken_plus_min(code) {
	var next = input.charCodeAt(tokPos + 1);
	if (next === code) {
	  if (next == 45 && input.charCodeAt(tokPos + 2) == 62 &&
		  newline.test(input.slice(lastEnd, tokPos))) {
		tokPos += 3;
		skipLineComment();
		skipSpace();
		return readToken();
	  }
	  return finishOp(_incDec, 2);
	}
	if (next === 61) return finishOp(_assign, 2);
	return finishOp(_plusMin, 1);
  }

  function readToken_lt_gt(code) {
	var next = input.charCodeAt(tokPos + 1);
	var size = 1;
	if (next === code) {
	  size = code === 62 && input.charCodeAt(tokPos + 2) === 62 ? 3 : 2;
	  if (input.charCodeAt(tokPos + size) === 61) return finishOp(_assign, size + 1);
	  return finishOp(_bitShift, size);
	}
	if (next == 33 && code == 60 && input.charCodeAt(tokPos + 2) == 45 &&
		input.charCodeAt(tokPos + 3) == 45) {
	  tokPos += 4;
	  skipLineComment();
	  skipSpace();
	  return readToken();
	}
	if (next === 61)
	  size = input.charCodeAt(tokPos + 2) === 61 ? 3 : 2;
	return finishOp(_relational, size);
  }

  function readToken_eq_excl(code) {
	var next = input.charCodeAt(tokPos + 1);
	if (next === 61) return finishOp(_equality, input.charCodeAt(tokPos + 2) === 61 ? 3 : 2);
	return finishOp(code === 61 ? _eq : _prefix, 1);
  }

  function getTokenFromCode(code) {
	switch(code) {
	case 46:
	  return readToken_dot();

	case 40: ++tokPos; return finishToken(_parenL);
	case 41: ++tokPos; return finishToken(_parenR);
	case 59: ++tokPos; return finishToken(_semi);
	case 44: ++tokPos; return finishToken(_comma);
	case 91: ++tokPos; return finishToken(_bracketL);
	case 93: ++tokPos; return finishToken(_bracketR);
	case 123: ++tokPos; return finishToken(_braceL);
	case 125: ++tokPos; return finishToken(_braceR);
	case 58: ++tokPos; return finishToken(_colon);
	case 63: ++tokPos; return finishToken(_question);

	case 48:
	  var next = input.charCodeAt(tokPos + 1);
	  if (next === 120 || next === 88) return readHexNumber();
	case 49: case 50: case 51: case 52: case 53: case 54: case 55: case 56: case 57:
	  return readNumber(false);

	case 34: case 39:
	  return readString(code);

	case 47:
	  return readToken_slash(code);

	case 37: case 42:
	  return readToken_mult_modulo();

	case 124: case 38:
	  return readToken_pipe_amp(code);

	case 94:
	  return readToken_caret();

	case 43: case 45:
	  return readToken_plus_min(code);

	case 60: case 62:
	  return readToken_lt_gt(code);

	case 61: case 33:
	  return readToken_eq_excl(code);

	case 126:
	  return finishOp(_prefix, 1);
	}

	return false;
  }

  function readToken(forceRegexp) {
	if (!forceRegexp) tokStart = tokPos;
	else tokPos = tokStart + 1;
	if (options.locations) tokStartLoc = new line_loc_t;
	if (forceRegexp) return readRegexp();
	if (tokPos >= inputLen) return finishToken(_eof);

	var code = input.charCodeAt(tokPos);
	if (isIdentifierStart(code) || code === 92 ) return readWord();

	var tok = getTokenFromCode(code);

	if (tok === false) {
	  var ch = String.fromCharCode(code);
	  if (ch === "\\" || nonASCIIidentifierStart.test(ch)) return readWord();
	  raise(tokPos, "Unexpected character '" + ch + "'");
	}
	return tok;
  }

  function finishOp(type, size) {
	var str = input.slice(tokPos, tokPos + size);
	tokPos += size;
	finishToken(type, str);
  }

  function readRegexp() {
	var content = "", escaped, inClass, start = tokPos;
	for (;;) {
	  if (tokPos >= inputLen) raise(start, "Unterminated regular expression");
	  var ch = input.charAt(tokPos);
	  if (newline.test(ch)) raise(start, "Unterminated regular expression");
	  if (!escaped) {
		if (ch === "[") inClass = true;
		else if (ch === "]" && inClass) inClass = false;
		else if (ch === "/" && !inClass) break;
		escaped = ch === "\\";
	  } else escaped = false;
	  ++tokPos;
	}
	var content = input.slice(start, tokPos);
	++tokPos;
	var mods = readWord1();
	if (mods && !/^[gmsiy]*$/.test(mods)) raise(start, "Invalid regexp flag");
	try {
	  var value = new RegExp(content, mods);
	} catch (e) {
	  if (e instanceof SyntaxError) raise(start, e.message);
	  raise(e);
	}
	return finishToken(_regexp, value);
  }

  function readInt(radix, len) {
	var start = tokPos, total = 0;
	for (var i = 0, e = len == null ? Infinity : len; i < e; ++i) {
	  var code = input.charCodeAt(tokPos), val;
	  if (code >= 97) val = code - 97 + 10;
	  else if (code >= 65) val = code - 65 + 10;
	  else if (code >= 48 && code <= 57) val = code - 48;
	  else val = Infinity;
	  if (val >= radix) break;
	  ++tokPos;
	  total = total * radix + val;
	}
	if (tokPos === start || len != null && tokPos - start !== len) return null;

	return total;
  }

  function readHexNumber() {
	tokPos += 2;
	var val = readInt(16);
	if (val == null) raise(tokStart + 2, "Expected hexadecimal number");
	if (isIdentifierStart(input.charCodeAt(tokPos))) raise(tokPos, "Identifier directly after number");
	return finishToken(_num, val);
  }

  function readNumber(startsWithDot) {
	var start = tokPos, isFloat = false, octal = input.charCodeAt(tokPos) === 48;
	if (!startsWithDot && readInt(10) === null) raise(start, "Invalid number");
	if (input.charCodeAt(tokPos) === 46) {
	  ++tokPos;
	  readInt(10);
	  isFloat = true;
	}
	var next = input.charCodeAt(tokPos);
	if (next === 69 || next === 101) {
	  next = input.charCodeAt(++tokPos);
	  if (next === 43 || next === 45) ++tokPos;
	  if (readInt(10) === null) raise(start, "Invalid number");
	  isFloat = true;
	}
	if (isIdentifierStart(input.charCodeAt(tokPos))) raise(tokPos, "Identifier directly after number");

	var str = input.slice(start, tokPos), val;
	if (isFloat) val = parseFloat(str);
	else if (!octal || str.length === 1) val = parseInt(str, 10);
	else if (/[89]/.test(str) || strict) raise(start, "Invalid number");
	else val = parseInt(str, 8);
	return finishToken(_num, val);
  }

  function readString(quote) {
	tokPos++;
	var out = "";
	for (;;) {
	  if (tokPos >= inputLen) raise(tokStart, "Unterminated string constant");
	  var ch = input.charCodeAt(tokPos);
	  if (ch === quote) {
		++tokPos;
		return finishToken(_string, out);
	  }
	  if (ch === 92) {
		ch = input.charCodeAt(++tokPos);
		var octal = /^[0-7]+/.exec(input.slice(tokPos, tokPos + 3));
		if (octal) octal = octal[0];
		while (octal && parseInt(octal, 8) > 255) octal = octal.slice(0, -1);
		if (octal === "0") octal = null;
		++tokPos;
		if (octal) {
		  if (strict) raise(tokPos - 2, "Octal literal in strict mode");
		  out += String.fromCharCode(parseInt(octal, 8));
		  tokPos += octal.length - 1;
		} else {
		  switch (ch) {
		  case 110: out += "\n"; break;
		  case 114: out += "\r"; break;
		  case 120: out += String.fromCharCode(readHexChar(2)); break;
		  case 117: out += String.fromCharCode(readHexChar(4)); break;
		  case 85: out += String.fromCharCode(readHexChar(8)); break;
		  case 116: out += "\t"; break;
		  case 98: out += "\b"; break;
		  case 118: out += "\u000b"; break;
		  case 102: out += "\f"; break;
		  case 48: out += "\0"; break;
		  case 13: if (input.charCodeAt(tokPos) === 10) ++tokPos;
		  case 10:
			if (options.locations) { tokLineStart = tokPos; ++tokCurLine; }
			break;
		  default: out += String.fromCharCode(ch); break;
		  }
		}
	  } else {
		if (ch === 13 || ch === 10 || ch === 8232 || ch === 8233) raise(tokStart, "Unterminated string constant");
		out += String.fromCharCode(ch);
		++tokPos;
	  }
	}
  }

  function readHexChar(len) {
	var n = readInt(16, len);
	if (n === null) raise(tokStart, "Bad character escape sequence");
	return n;
  }

  var containsEsc;

  function readWord1() {
	containsEsc = false;
	var word, first = true, start = tokPos;
	for (;;) {
	  var ch = input.charCodeAt(tokPos);
	  if (isIdentifierChar(ch)) {
		if (containsEsc) word += input.charAt(tokPos);
		++tokPos;
	  } else if (ch === 92) {
		if (!containsEsc) word = input.slice(start, tokPos);
		containsEsc = true;
		if (input.charCodeAt(++tokPos) != 117)
		  raise(tokPos, "Expecting Unicode escape sequence \\uXXXX");
		++tokPos;
		var esc = readHexChar(4);
		var escStr = String.fromCharCode(esc);
		if (!escStr) raise(tokPos - 1, "Invalid Unicode escape");
		if (!(first ? isIdentifierStart(esc) : isIdentifierChar(esc)))
		  raise(tokPos - 4, "Invalid Unicode escape");
		word += escStr;
	  } else {
		break;
	  }
	  first = false;
	}
	return containsEsc ? word : input.slice(start, tokPos);
  }

  function readWord() {
	var word = readWord1();
	var type = _name;
	if (!containsEsc && isKeyword(word))
	  type = keywordTypes[word];
	return finishToken(type, word);
  }

  function next() {
	lastStart = tokStart;
	lastEnd = tokEnd;
	lastEndLoc = tokEndLoc;
	readToken();
  }

  function setStrict(strct) {
	strict = strct;
	tokPos = tokStart;
	if (options.locations) {
	  while (tokPos < tokLineStart) {
		tokLineStart = input.lastIndexOf("\n", tokLineStart - 2) + 1;
		--tokCurLine;
	  }
	}
	skipSpace();
	readToken();
  }

  function node_t() {
	this.type = null;
	this.start = tokStart;
	this.end = null;
  }

  function node_loc_t() {
	this.start = tokStartLoc;
	this.end = null;
	if (sourceFile !== null) this.source = sourceFile;
  }

  function startNode() {
	var node = new node_t();
	if (options.locations)
	  node.loc = new node_loc_t();
	if (options.directSourceFile)
	  node.sourceFile = options.directSourceFile;
	if (options.ranges)
	  node.range = [tokStart, 0];
	return node;
  }

  function startNodeFrom(other) {
	var node = new node_t();
	node.start = other.start;
	if (options.locations) {
	  node.loc = new node_loc_t();
	  node.loc.start = other.loc.start;
	}
	if (options.ranges)
	  node.range = [other.range[0], 0];

	return node;
  }

  function finishNode(node, type) {
	node.type = type;
	node.end = lastEnd;
	if (options.locations)
	  node.loc.end = lastEndLoc;
	if (options.ranges)
	  node.range[1] = lastEnd;
	return node;
  }

  function isUseStrict(stmt) {
	return options.ecmaVersion >= 5 && stmt.type === "ExpressionStatement" &&
	  stmt.expression.type === "Literal" && stmt.expression.value === "use strict";
  }

  function eat(type) {
	if (tokType === type) {
	  next();
	  return true;
	}
  }

  function canInsertSemicolon() {
	return !options.strictSemicolons &&
	  (tokType === _eof || tokType === _braceR || newline.test(input.slice(lastEnd, tokStart)));
  }

  function semicolon() {
	if (!eat(_semi) && !canInsertSemicolon()) unexpected();
  }

  function expect(type) {
	if (tokType === type) next();
	else unexpected();
  }

  function unexpected() {
	raise(tokStart, "Unexpected token");
  }

  function checkLVal(expr) {
	if (expr.type !== "Identifier" && expr.type !== "MemberExpression")
	  raise(expr.start, "Assigning to rvalue");
	if (strict && expr.type === "Identifier" && isStrictBadIdWord(expr.name))
	  raise(expr.start, "Assigning to " + expr.name + " in strict mode");
  }

  function parseTopLevel(program) {
	lastStart = lastEnd = tokPos;
	if (options.locations) lastEndLoc = new line_loc_t;
	inFunction = strict = null;
	labels = [];
	readToken();

	var node = program || startNode(), first = true;
	if (!program) node.body = [];
	while (tokType !== _eof) {
	  var stmt = parseStatement();
	  node.body.push(stmt);
	  if (first && isUseStrict(stmt)) setStrict(true);
	  first = false;
	}
	return finishNode(node, "Program");
  }

  var loopLabel = {kind: "loop"}, switchLabel = {kind: "switch"};

  function parseStatement() {
	if (tokType === _slash || tokType === _assign && tokVal == "/=")
	  readToken(true);

	var starttype = tokType, node = startNode();

	switch (starttype) {
	case _break: case _continue:
	  next();
	  var isBreak = starttype === _break;
	  if (eat(_semi) || canInsertSemicolon()) node.label = null;
	  else if (tokType !== _name) unexpected();
	  else {
		node.label = parseIdent();
		semicolon();
	  }

	  for (var i = 0; i < labels.length; ++i) {
		var lab = labels[i];
		if (node.label == null || lab.name === node.label.name) {
		  if (lab.kind != null && (isBreak || lab.kind === "loop")) break;
		  if (node.label && isBreak) break;
		}
	  }
	  if (i === labels.length) raise(node.start, "Unsyntactic " + starttype.keyword);
	  return finishNode(node, isBreak ? "BreakStatement" : "ContinueStatement");

	case _debugger:
	  next();
	  semicolon();
	  return finishNode(node, "DebuggerStatement");

	case _do:
	  next();
	  labels.push(loopLabel);
	  node.body = parseStatement();
	  labels.pop();
	  expect(_while);
	  node.test = parseParenExpression();
	  semicolon();
	  return finishNode(node, "DoWhileStatement");

	case _for:
	  next();
	  labels.push(loopLabel);
	  expect(_parenL);
	  if (tokType === _semi) return parseFor(node, null);
	  if (tokType === _var) {
		var init = startNode();
		next();
		parseVar(init, true);
		finishNode(init, "VariableDeclaration");
		if (init.declarations.length === 1 && eat(_in))
		  return parseForIn(node, init);
		return parseFor(node, init);
	  }
	  var init = parseExpression(false, true);
	  if (eat(_in)) {checkLVal(init); return parseForIn(node, init);}
	  return parseFor(node, init);

	case _function:
	  next();
	  return parseFunction(node, true);

	case _if:
	  next();
	  node.test = parseParenExpression();
	  node.consequent = parseStatement();
	  node.alternate = eat(_else) ? parseStatement() : null;
	  return finishNode(node, "IfStatement");

	case _return:
	  if (!inFunction && !options.allowReturnOutsideFunction)
		raise(tokStart, "'return' outside of function");
	  next();

	  if (eat(_semi) || canInsertSemicolon()) node.argument = null;
	  else { node.argument = parseExpression(); semicolon(); }
	  return finishNode(node, "ReturnStatement");

	case _switch:
	  next();
	  node.discriminant = parseParenExpression();
	  node.cases = [];
	  expect(_braceL);
	  labels.push(switchLabel);

	  for (var cur, sawDefault; tokType != _braceR;) {
		if (tokType === _case || tokType === _default) {
		  var isCase = tokType === _case;
		  if (cur) finishNode(cur, "SwitchCase");
		  node.cases.push(cur = startNode());
		  cur.consequent = [];
		  next();
		  if (isCase) cur.test = parseExpression();
		  else {
			if (sawDefault) raise(lastStart, "Multiple default clauses"); sawDefault = true;
			cur.test = null;
		  }
		  expect(_colon);
		} else {
		  if (!cur) unexpected();
		  cur.consequent.push(parseStatement());
		}
	  }
	  if (cur) finishNode(cur, "SwitchCase");
	  next();
	  labels.pop();
	  return finishNode(node, "SwitchStatement");

	case _throw:
	  next();
	  if (newline.test(input.slice(lastEnd, tokStart)))
		raise(lastEnd, "Illegal newline after throw");
	  node.argument = parseExpression();
	  semicolon();
	  return finishNode(node, "ThrowStatement");

	case _try:
	  next();
	  node.block = parseBlock();
	  node.handler = null;
	  if (tokType === _catch) {
		var clause = startNode();
		next();
		expect(_parenL);
		clause.param = parseIdent();
		if (strict && isStrictBadIdWord(clause.param.name))
		  raise(clause.param.start, "Binding " + clause.param.name + " in strict mode");
		expect(_parenR);
		clause.guard = null;
		clause.body = parseBlock();
		node.handler = finishNode(clause, "CatchClause");
	  }
	  node.guardedHandlers = empty;
	  node.finalizer = eat(_finally) ? parseBlock() : null;
	  if (!node.handler && !node.finalizer)
		raise(node.start, "Missing catch or finally clause");
	  return finishNode(node, "TryStatement");

	case _var:
	  next();
	  parseVar(node);
	  semicolon();
	  return finishNode(node, "VariableDeclaration");

	case _while:
	  next();
	  node.test = parseParenExpression();
	  labels.push(loopLabel);
	  node.body = parseStatement();
	  labels.pop();
	  return finishNode(node, "WhileStatement");

	case _with:
	  if (strict) raise(tokStart, "'with' in strict mode");
	  next();
	  node.object = parseParenExpression();
	  node.body = parseStatement();
	  return finishNode(node, "WithStatement");

	case _braceL:
	  return parseBlock();

	case _semi:
	  next();
	  return finishNode(node, "EmptyStatement");

	default:
	  var maybeName = tokVal, expr = parseExpression();
	  if (starttype === _name && expr.type === "Identifier" && eat(_colon)) {
		for (var i = 0; i < labels.length; ++i)
		  if (labels[i].name === maybeName) raise(expr.start, "Label '" + maybeName + "' is already declared");
		var kind = tokType.isLoop ? "loop" : tokType === _switch ? "switch" : null;
		labels.push({name: maybeName, kind: kind});
		node.body = parseStatement();
		labels.pop();
		node.label = expr;
		return finishNode(node, "LabeledStatement");
	  } else {
		node.expression = expr;
		semicolon();
		return finishNode(node, "ExpressionStatement");
	  }
	}
  }

  function parseParenExpression() {
	expect(_parenL);
	var val = parseExpression();
	expect(_parenR);
	return val;
  }

  function parseBlock(allowStrict) {
	var node = startNode(), first = true, strict = false, oldStrict;
	node.body = [];
	expect(_braceL);
	while (!eat(_braceR)) {
	  var stmt = parseStatement();
	  node.body.push(stmt);
	  if (first && allowStrict && isUseStrict(stmt)) {
		oldStrict = strict;
		setStrict(strict = true);
	  }
	  first = false;
	}
	if (strict && !oldStrict) setStrict(false);
	return finishNode(node, "BlockStatement");
  }

  function parseFor(node, init) {
	node.init = init;
	expect(_semi);
	node.test = tokType === _semi ? null : parseExpression();
	expect(_semi);
	node.update = tokType === _parenR ? null : parseExpression();
	expect(_parenR);
	node.body = parseStatement();
	labels.pop();
	return finishNode(node, "ForStatement");
  }

  function parseForIn(node, init) {
	node.left = init;
	node.right = parseExpression();
	expect(_parenR);
	node.body = parseStatement();
	labels.pop();
	return finishNode(node, "ForInStatement");
  }

  function parseVar(node, noIn) {
	node.declarations = [];
	node.kind = "var";
	for (;;) {
	  var decl = startNode();
	  decl.id = parseIdent();
	  if (strict && isStrictBadIdWord(decl.id.name))
		raise(decl.id.start, "Binding " + decl.id.name + " in strict mode");
	  decl.init = eat(_eq) ? parseExpression(true, noIn) : null;
	  node.declarations.push(finishNode(decl, "VariableDeclarator"));
	  if (!eat(_comma)) break;
	}
	return node;
  }

  function parseExpression(noComma, noIn) {
	var expr = parseMaybeAssign(noIn);
	if (!noComma && tokType === _comma) {
	  var node = startNodeFrom(expr);
	  node.expressions = [expr];
	  while (eat(_comma)) node.expressions.push(parseMaybeAssign(noIn));
	  return finishNode(node, "SequenceExpression");
	}
	return expr;
  }

  function parseMaybeAssign(noIn) {
	var left = parseMaybeConditional(noIn);
	if (tokType.isAssign) {
	  var node = startNodeFrom(left);
	  node.operator = tokVal;
	  node.left = left;
	  next();
	  node.right = parseMaybeAssign(noIn);
	  checkLVal(left);
	  return finishNode(node, "AssignmentExpression");
	}
	return left;
  }

  function parseMaybeConditional(noIn) {
	var expr = parseExprOps(noIn);
	if (eat(_question)) {
	  var node = startNodeFrom(expr);
	  node.test = expr;
	  node.consequent = parseExpression(true);
	  expect(_colon);
	  node.alternate = parseExpression(true, noIn);
	  return finishNode(node, "ConditionalExpression");
	}
	return expr;
  }

  function parseExprOps(noIn) {
	return parseExprOp(parseMaybeUnary(), -1, noIn);
  }

  function parseExprOp(left, minPrec, noIn) {
	var prec = tokType.binop;
	if (prec != null && (!noIn || tokType !== _in)) {
	  if (prec > minPrec) {
		var node = startNodeFrom(left);
		node.left = left;
		node.operator = tokVal;
		var op = tokType;
		next();
		node.right = parseExprOp(parseMaybeUnary(), prec, noIn);
		var exprNode = finishNode(node, (op === _logicalOR || op === _logicalAND) ? "LogicalExpression" : "BinaryExpression");
		return parseExprOp(exprNode, minPrec, noIn);
	  }
	}
	return left;
  }

  function parseMaybeUnary() {
	if (tokType.prefix) {
	  var node = startNode(), update = tokType.isUpdate;
	  node.operator = tokVal;
	  node.prefix = true;
	  tokRegexpAllowed = true;
	  next();
	  node.argument = parseMaybeUnary();
	  if (update) checkLVal(node.argument);
	  else if (strict && node.operator === "delete" &&
			   node.argument.type === "Identifier")
		raise(node.start, "Deleting local variable in strict mode");
	  return finishNode(node, update ? "UpdateExpression" : "UnaryExpression");
	}
	var expr = parseExprSubscripts();
	while (tokType.postfix && !canInsertSemicolon()) {
	  var node = startNodeFrom(expr);
	  node.operator = tokVal;
	  node.prefix = false;
	  node.argument = expr;
	  checkLVal(expr);
	  next();
	  expr = finishNode(node, "UpdateExpression");
	}
	return expr;
  }

  function parseExprSubscripts() {
	return parseSubscripts(parseExprAtom());
  }

  function parseSubscripts(base, noCalls) {
	if (eat(_dot)) {
	  var node = startNodeFrom(base);
	  node.object = base;
	  node.property = parseIdent(true);
	  node.computed = false;
	  return parseSubscripts(finishNode(node, "MemberExpression"), noCalls);
	} else if (eat(_bracketL)) {
	  var node = startNodeFrom(base);
	  node.object = base;
	  node.property = parseExpression();
	  node.computed = true;
	  expect(_bracketR);
	  return parseSubscripts(finishNode(node, "MemberExpression"), noCalls);
	} else if (!noCalls && eat(_parenL)) {
	  var node = startNodeFrom(base);
	  node.callee = base;
	  node.arguments = parseExprList(_parenR, false);
	  return parseSubscripts(finishNode(node, "CallExpression"), noCalls);
	} else return base;
  }

  function parseExprAtom() {
	switch (tokType) {
	case _this:
	  var node = startNode();
	  next();
	  return finishNode(node, "ThisExpression");
	case _name:
	  return parseIdent();
	case _num: case _string: case _regexp:
	  var node = startNode();
	  node.value = tokVal;
	  node.raw = input.slice(tokStart, tokEnd);
	  next();
	  return finishNode(node, "Literal");

	case _null: case _true: case _false:
	  var node = startNode();
	  node.value = tokType.atomValue;
	  node.raw = tokType.keyword;
	  next();
	  return finishNode(node, "Literal");

	case _parenL:
	  var tokStartLoc1 = tokStartLoc, tokStart1 = tokStart;
	  next();
	  var val = parseExpression();
	  val.start = tokStart1;
	  val.end = tokEnd;
	  if (options.locations) {
		val.loc.start = tokStartLoc1;
		val.loc.end = tokEndLoc;
	  }
	  if (options.ranges)
		val.range = [tokStart1, tokEnd];
	  expect(_parenR);
	  return val;

	case _bracketL:
	  var node = startNode();
	  next();
	  node.elements = parseExprList(_bracketR, true, true);
	  return finishNode(node, "ArrayExpression");

	case _braceL:
	  return parseObj();

	case _function:
	  var node = startNode();
	  next();
	  return parseFunction(node, false);

	case _new:
	  return parseNew();

	default:
	  unexpected();
	}
  }

  function parseNew() {
	var node = startNode();
	next();
	node.callee = parseSubscripts(parseExprAtom(), true);
	if (eat(_parenL)) node.arguments = parseExprList(_parenR, false);
	else node.arguments = empty;
	return finishNode(node, "NewExpression");
  }

  function parseObj() {
	var node = startNode(), first = true, sawGetSet = false;
	node.properties = [];
	next();
	while (!eat(_braceR)) {
	  if (!first) {
		expect(_comma);
		if (options.allowTrailingCommas && eat(_braceR)) break;
	  } else first = false;

	  var prop = {key: parsePropertyName()}, isGetSet = false, kind;
	  if (eat(_colon)) {
		prop.value = parseExpression(true);
		kind = prop.kind = "init";
	  } else if (options.ecmaVersion >= 5 && prop.key.type === "Identifier" &&
				 (prop.key.name === "get" || prop.key.name === "set")) {
		isGetSet = sawGetSet = true;
		kind = prop.kind = prop.key.name;
		prop.key = parsePropertyName();
		if (tokType !== _parenL) unexpected();
		prop.value = parseFunction(startNode(), false);
	  } else unexpected();

	  if (prop.key.type === "Identifier" && (strict || sawGetSet)) {
		for (var i = 0; i < node.properties.length; ++i) {
		  var other = node.properties[i];
		  if (other.key.name === prop.key.name) {
			var conflict = kind == other.kind || isGetSet && other.kind === "init" ||
			  kind === "init" && (other.kind === "get" || other.kind === "set");
			if (conflict && !strict && kind === "init" && other.kind === "init") conflict = false;
			if (conflict) raise(prop.key.start, "Redefinition of property");
		  }
		}
	  }
	  node.properties.push(prop);
	}
	return finishNode(node, "ObjectExpression");
  }

  function parsePropertyName() {
	if (tokType === _num || tokType === _string) return parseExprAtom();
	return parseIdent(true);
  }

  function parseFunction(node, isStatement) {
	if (tokType === _name) node.id = parseIdent();
	else if (isStatement) unexpected();
	else node.id = null;
	node.params = [];
	var first = true;
	expect(_parenL);
	while (!eat(_parenR)) {
	  if (!first) expect(_comma); else first = false;
	  node.params.push(parseIdent());
	}

	var oldInFunc = inFunction, oldLabels = labels;
	inFunction = true; labels = [];
	node.body = parseBlock(true);
	inFunction = oldInFunc; labels = oldLabels;

	if (strict || node.body.body.length && isUseStrict(node.body.body[0])) {
	  for (var i = node.id ? -1 : 0; i < node.params.length; ++i) {
		var id = i < 0 ? node.id : node.params[i];
		if (isStrictReservedWord(id.name) || isStrictBadIdWord(id.name))
		  raise(id.start, "Defining '" + id.name + "' in strict mode");
		if (i >= 0) for (var j = 0; j < i; ++j) if (id.name === node.params[j].name)
		  raise(id.start, "Argument name clash in strict mode");
	  }
	}

	return finishNode(node, isStatement ? "FunctionDeclaration" : "FunctionExpression");
  }

  function parseExprList(close, allowTrailingComma, allowEmpty) {
	var elts = [], first = true;
	while (!eat(close)) {
	  if (!first) {
		expect(_comma);
		if (allowTrailingComma && options.allowTrailingCommas && eat(close)) break;
	  } else first = false;

	  if (allowEmpty && tokType === _comma) elts.push(null);
	  else elts.push(parseExpression(true));
	}
	return elts;
  }

  function parseIdent(liberal) {
	var node = startNode();
	if (liberal && options.forbidReserved == "everywhere") liberal = false;
	if (tokType === _name) {
	  if (!liberal &&
		  (options.forbidReserved &&
		   (options.ecmaVersion === 3 ? isReservedWord3 : isReservedWord5)(tokVal) ||
		   strict && isStrictReservedWord(tokVal)) &&
		  input.slice(tokStart, tokEnd).indexOf("\\") == -1)
		raise(tokStart, "The keyword '" + tokVal + "' is reserved");
	  node.name = tokVal;
	} else if (liberal && tokType.keyword) {
	  node.name = tokType.keyword;
	} else {
	  unexpected();
	}
	tokRegexpAllowed = false;
	next();
	return finishNode(node, "Identifier");
  }

});

		if (!acorn.version)
			acorn = null;
	}

	function parse(code, options) {
		return (global.acorn || acorn).parse(code, options);
	}

	var binaryOperators = {
		'+': '__add',
		'-': '__subtract',
		'*': '__multiply',
		'/': '__divide',
		'%': '__modulo',
		'==': '__equals',
		'!=': '__equals'
	};

	var unaryOperators = {
		'-': '__negate',
		'+': '__self'
	};

	var fields = Base.each(
		['add', 'subtract', 'multiply', 'divide', 'modulo', 'equals', 'negate'],
		function(name) {
			this['__' + name] = '#' + name;
		},
		{
			__self: function() {
				return this;
			}
		}
	);
	Point.inject(fields);
	Size.inject(fields);
	Color.inject(fields);

	function __$__(left, operator, right) {
		var handler = binaryOperators[operator];
		if (left && left[handler]) {
			var res = left[handler](right);
			return operator === '!=' ? !res : res;
		}
		switch (operator) {
		case '+': return left + right;
		case '-': return left - right;
		case '*': return left * right;
		case '/': return left / right;
		case '%': return left % right;
		case '==': return left == right;
		case '!=': return left != right;
		}
	}

	function $__(operator, value) {
		var handler = unaryOperators[operator];
		if (value && value[handler])
			return value[handler]();
		switch (operator) {
		case '+': return +value;
		case '-': return -value;
		}
	}

	function compile(code, options) {
		if (!code)
			return '';
		options = options || {};

		var insertions = [];

		function getOffset(offset) {
			for (var i = 0, l = insertions.length; i < l; i++) {
				var insertion = insertions[i];
				if (insertion[0] >= offset)
					break;
				offset += insertion[1];
			}
			return offset;
		}

		function getCode(node) {
			return code.substring(getOffset(node.range[0]),
					getOffset(node.range[1]));
		}

		function getBetween(left, right) {
			return code.substring(getOffset(left.range[1]),
					getOffset(right.range[0]));
		}

		function replaceCode(node, str) {
			var start = getOffset(node.range[0]),
				end = getOffset(node.range[1]),
				insert = 0;
			for (var i = insertions.length - 1; i >= 0; i--) {
				if (start > insertions[i][0]) {
					insert = i + 1;
					break;
				}
			}
			insertions.splice(insert, 0, [start, str.length - end + start]);
			code = code.substring(0, start) + str + code.substring(end);
		}

		function handleOverloading(node, parent) {
			switch (node.type) {
			case 'UnaryExpression':
				if (node.operator in unaryOperators
						&& node.argument.type !== 'Literal') {
					var arg = getCode(node.argument);
					replaceCode(node, '$__("' + node.operator + '", '
							+ arg + ')');
				}
				break;
			case 'BinaryExpression':
				if (node.operator in binaryOperators
						&& node.left.type !== 'Literal') {
					var left = getCode(node.left),
						right = getCode(node.right),
						between = getBetween(node.left, node.right),
						operator = node.operator;
					replaceCode(node, '__$__(' + left + ','
							+ between.replace(new RegExp('\\' + operator),
								'"' + operator + '"')
							+ ', ' + right + ')');
				}
				break;
			case 'UpdateExpression':
			case 'AssignmentExpression':
				var parentType = parent && parent.type;
				if (!(
						parentType === 'ForStatement'
						|| parentType === 'BinaryExpression'
							&& /^[=!<>]/.test(parent.operator)
						|| parentType === 'MemberExpression' && parent.computed
				)) {
					if (node.type === 'UpdateExpression') {
						var arg = getCode(node.argument),
							exp = '__$__(' + arg + ', "' + node.operator[0]
									+ '", 1)',
							str = arg + ' = ' + exp;
						if (node.prefix) {
							str = '(' + str + ')';
						} else if (
							parentType === 'AssignmentExpression' ||
							parentType === 'VariableDeclarator' ||
							parentType === 'BinaryExpression'
						) {
							if (getCode(parent.left || parent.id) === arg)
								str = exp;
							str = arg + '; ' + str;
						}
						replaceCode(node, str);
					} else {
						if (/^.=$/.test(node.operator)
								&& node.left.type !== 'Literal') {
							var left = getCode(node.left),
								right = getCode(node.right),
								exp = left + ' = __$__(' + left + ', "'
									+ node.operator[0] + '", ' + right + ')';
							replaceCode(node, /^\(.*\)$/.test(getCode(node))
									? '(' + exp + ')' : exp);
						}
					}
				}
				break;
			}
		}

		function handleExports(node) {
			switch (node.type) {
			case 'ExportDefaultDeclaration':
				replaceCode({
					range: [node.start, node.declaration.start]
				}, 'module.exports = ');
				break;
			case 'ExportNamedDeclaration':
				var declaration = node.declaration;
				var specifiers = node.specifiers;
				if (declaration) {
					var declarations = declaration.declarations;
					if (declarations) {
						declarations.forEach(function(dec) {
							replaceCode(dec, 'module.exports.' + getCode(dec));
						});
						replaceCode({
							range: [
								node.start,
								declaration.start + declaration.kind.length
							]
						}, '');
					}
				} else if (specifiers) {
					var exports = specifiers.map(function(specifier) {
						var name = getCode(specifier);
						return 'module.exports.' + name + ' = ' + name + '; ';
					}).join('');
					if (exports) {
						replaceCode(node, exports);
					}
				}
				break;
			}
		}

		function walkAST(node, parent, paperFeatures) {
			if (node) {
				for (var key in node) {
					if (key !== 'range' && key !== 'loc') {
						var value = node[key];
						if (Array.isArray(value)) {
							for (var i = 0, l = value.length; i < l; i++) {
								walkAST(value[i], node, paperFeatures);
							}
						} else if (value && typeof value === 'object') {
							walkAST(value, node, paperFeatures);
						}
					}
				}
				if (paperFeatures.operatorOverloading !== false) {
					handleOverloading(node, parent);
				}
				if (paperFeatures.moduleExports !== false) {
					handleExports(node);
				}
			}
		}

		function encodeVLQ(value) {
			var res = '',
				base64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
			value = (Math.abs(value) << 1) + (value < 0 ? 1 : 0);
			while (value || !res) {
				var next = value & (32 - 1);
				value >>= 5;
				if (value)
					next |= 32;
				res += base64[next];
			}
			return res;
		}

		var url = options.url || '',
			sourceMaps = options.sourceMaps,
			paperFeatures = options.paperFeatures || {},
			source = options.source || code,
			offset = options.offset || 0,
			agent = paper.agent,
			version = agent.versionNumber,
			offsetCode = false,
			lineBreaks = /\r\n|\n|\r/mg,
			map;
		if (sourceMaps && (agent.chrome && version >= 30
				|| agent.webkit && version >= 537.76
				|| agent.firefox && version >= 23
				|| agent.node)) {
			if (agent.node) {
				offset -= 2;
			} else if (window && url && !window.location.href.indexOf(url)) {
				var html = document.getElementsByTagName('html')[0].innerHTML;
				offset = html.substr(0, html.indexOf(code) + 1).match(
						lineBreaks).length + 1;
			}
			offsetCode = offset > 0 && !(
					agent.chrome && version >= 36 ||
					agent.safari && version >= 600 ||
					agent.firefox && version >= 40 ||
					agent.node);
			var mappings = ['AA' + encodeVLQ(offsetCode ? 0 : offset) + 'A'];
			mappings.length = (code.match(lineBreaks) || []).length + 1
					+ (offsetCode ? offset : 0);
			map = {
				version: 3,
				file: url,
				names:[],
				mappings: mappings.join(';AACA'),
				sourceRoot: '',
				sources: [url],
				sourcesContent: [source]
			};
		}
		if (
			paperFeatures.operatorOverloading !== false ||
			paperFeatures.moduleExports !== false
		) {
			walkAST(parse(code, {
				ranges: true,
				preserveParens: true,
				sourceType: 'module'
			}), null, paperFeatures);
		}
		if (map) {
			if (offsetCode) {
				code = new Array(offset + 1).join('\n') + code;
			}
			if (/^(inline|both)$/.test(sourceMaps)) {
				code += "\n//# sourceMappingURL=data:application/json;base64,"
						+ self.btoa(unescape(encodeURIComponent(
							JSON.stringify(map))));
			}
			code += "\n//# sourceURL=" + (url || 'paperscript');
		}
		return {
			url: url,
			source: source,
			code: code,
			map: map
		};
	}

	function execute(code, scope, options) {
		paper = scope;
		var view = scope.getView(),
			tool = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/
					.test(code) && !/\bnew\s+Tool\b/.test(code)
						? new Tool() : null,
			toolHandlers = tool ? tool._events : [],
			handlers = ['onFrame', 'onResize'].concat(toolHandlers),
			params = [],
			args = [],
			func,
			compiled = typeof code === 'object' ? code : compile(code, options);
		code = compiled.code;
		function expose(scope, hidden) {
			for (var key in scope) {
				if ((hidden || !/^_/.test(key)) && new RegExp('([\\b\\s\\W]|^)'
						+ key.replace(/\$/g, '\\$') + '\\b').test(code)) {
					params.push(key);
					args.push(scope[key]);
				}
			}
		}
		expose({ __$__: __$__, $__: $__, paper: scope, tool: tool },
				true);
		expose(scope);
		code = 'var module = { exports: {} }; ' + code;
		var exports = Base.each(handlers, function(key) {
			if (new RegExp('\\s+' + key + '\\b').test(code)) {
				params.push(key);
				this.push('module.exports.' + key + ' = ' + key + ';');
			}
		}, []).join('\n');
		if (exports) {
			code += '\n' + exports;
		}
		code += '\nreturn module.exports;';
		var agent = paper.agent;
		if (document && (agent.chrome
				|| agent.firefox && agent.versionNumber < 40)) {
			var script = document.createElement('script'),
				head = document.head || document.getElementsByTagName('head')[0];
			if (agent.firefox)
				code = '\n' + code;
			script.appendChild(document.createTextNode(
				'document.__paperscript__ = function(' + params + ') {' +
					code +
				'\n}'
			));
			head.appendChild(script);
			func = document.__paperscript__;
			delete document.__paperscript__;
			head.removeChild(script);
		} else {
			func = Function(params, code);
		}
		var exports = func && func.apply(scope, args);
		var obj = exports || {};
		Base.each(toolHandlers, function(key) {
			var value = obj[key];
			if (value)
				tool[key] = value;
		});
		if (view) {
			if (obj.onResize)
				view.setOnResize(obj.onResize);
			view.emit('resize', {
				size: view.size,
				delta: new Point()
			});
			if (obj.onFrame)
				view.setOnFrame(obj.onFrame);
			view.requestUpdate();
		}
		return exports;
	}

	function loadScript(script) {
		if (/^text\/(?:x-|)paperscript$/.test(script.type)
				&& PaperScope.getAttribute(script, 'ignore') !== 'true') {
			var canvasId = PaperScope.getAttribute(script, 'canvas'),
				canvas = document.getElementById(canvasId),
				src = script.src || script.getAttribute('data-src'),
				async = PaperScope.hasAttribute(script, 'async'),
				scopeAttribute = 'data-paper-scope';
			if (!canvas)
				throw new Error('Unable to find canvas with id "'
						+ canvasId + '"');
			var scope = PaperScope.get(canvas.getAttribute(scopeAttribute))
						|| new PaperScope().setup(canvas);
			canvas.setAttribute(scopeAttribute, scope._id);
			if (src) {
				Http.request({
					url: src,
					async: async,
					mimeType: 'text/plain',
					onLoad: function(code) {
						execute(code, scope, src);
					}
				});
			} else {
				execute(script.innerHTML, scope, script.baseURI);
			}
			script.setAttribute('data-paper-ignore', 'true');
			return scope;
		}
	}

	function loadAll() {
		Base.each(document && document.getElementsByTagName('script'),
				loadScript);
	}

	function load(script) {
		return script ? loadScript(script) : loadAll();
	}

	if (window) {
		if (document.readyState === 'complete') {
			setTimeout(loadAll);
		} else {
			DomEvent.add(window, { load: loadAll });
		}
	}

	return {
		compile: compile,
		execute: execute,
		load: load,
		parse: parse,
		calculateBinary: __$__,
		calculateUnary: $__
	};

}.call(this);

var paper = new (PaperScope.inject(Base.exports, {
	Base: Base,
	Numerical: Numerical,
	Key: Key,
	DomEvent: DomEvent,
	DomElement: DomElement,
	document: document,
	window: window,
	Symbol: SymbolDefinition,
	PlacedSymbol: SymbolItem
}))();

if (paper.agent.node) {
	__webpack_require__(/*! ./node/extend.js */ "?2e46")(paper);
}

if (true) {
	!(__WEBPACK_AMD_DEFINE_FACTORY__ = (paper),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {}

return paper;
}.call(this, typeof self === 'object' ? self : null);


/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "styled-components":
/*!************************************!*\
  !*** external "styled-components" ***!
  \************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_styled_components__;

/***/ }),

/***/ "?4f7e":
/*!********************************!*\
  !*** ./util.inspect (ignored) ***!
  \********************************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?ec06":
/*!********************!*\
  !*** fs (ignored) ***!
  \********************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?f46d":
/*!**********************!*\
  !*** path (ignored) ***!
  \**********************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?2e46":
/*!**********************************!*\
  !*** ./node/extend.js (ignored) ***!
  \**********************************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?a736":
/*!********************************!*\
  !*** ./node/self.js (ignored) ***!
  \********************************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "./node_modules/axios/lib/adapters/adapters.js":
/*!*****************************************************!*\
  !*** ./node_modules/axios/lib/adapters/adapters.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _http_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./http.js */ "./node_modules/axios/lib/helpers/null.js");
/* harmony import */ var _xhr_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./xhr.js */ "./node_modules/axios/lib/adapters/xhr.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");





const knownAdapters = {
  http: _http_js__WEBPACK_IMPORTED_MODULE_0__["default"],
  xhr: _xhr_js__WEBPACK_IMPORTED_MODULE_1__["default"]
}

_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  getAdapter: (adapters) => {
    adapters = _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_3__["default"](
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
});


/***/ }),

/***/ "./node_modules/axios/lib/adapters/xhr.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/adapters/xhr.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _core_settle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./../core/settle.js */ "./node_modules/axios/lib/core/settle.js");
/* harmony import */ var _helpers_cookies_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./../helpers/cookies.js */ "./node_modules/axios/lib/helpers/cookies.js");
/* harmony import */ var _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./../helpers/buildURL.js */ "./node_modules/axios/lib/helpers/buildURL.js");
/* harmony import */ var _core_buildFullPath_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../core/buildFullPath.js */ "./node_modules/axios/lib/core/buildFullPath.js");
/* harmony import */ var _helpers_isURLSameOrigin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./../helpers/isURLSameOrigin.js */ "./node_modules/axios/lib/helpers/isURLSameOrigin.js");
/* harmony import */ var _defaults_transitional_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../defaults/transitional.js */ "./node_modules/axios/lib/defaults/transitional.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _helpers_parseProtocol_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../helpers/parseProtocol.js */ "./node_modules/axios/lib/helpers/parseProtocol.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _helpers_speedometer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/speedometer.js */ "./node_modules/axios/lib/helpers/speedometer.js");
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = (0,_helpers_speedometer_js__WEBPACK_IMPORTED_MODULE_0__["default"])(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isFormData(requestData) && (_platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].isStandardBrowserEnv || _platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].isStandardBrowserWebWorkerEnv)) {
      requestHeaders.setContentType(false); // Let the browser set it
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = (0,_core_buildFullPath_js__WEBPACK_IMPORTED_MODULE_4__["default"])(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), (0,_helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_5__["default"])(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      (0,_core_settle_js__WEBPACK_IMPORTED_MODULE_6__["default"])(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"]('Request aborted', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"]('Network Error', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || _defaults_transitional_js__WEBPACK_IMPORTED_MODULE_8__["default"];
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"](
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ETIMEDOUT : _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (_platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || (0,_helpers_isURLSameOrigin_js__WEBPACK_IMPORTED_MODULE_9__["default"])(fullPath))
        && config.xsrfCookieName && _helpers_cookies_js__WEBPACK_IMPORTED_MODULE_10__["default"].read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_11__["default"](null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = (0,_helpers_parseProtocol_js__WEBPACK_IMPORTED_MODULE_12__["default"])(fullPath);

    if (protocol && _platform_index_js__WEBPACK_IMPORTED_MODULE_3__["default"].protocols.indexOf(protocol) === -1) {
      reject(new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"]('Unsupported protocol ' + protocol + ':', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_7__["default"].ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});


/***/ }),

/***/ "./node_modules/axios/lib/axios.js":
/*!*****************************************!*\
  !*** ./node_modules/axios/lib/axios.js ***!
  \*****************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers/bind.js */ "./node_modules/axios/lib/helpers/bind.js");
/* harmony import */ var _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core/Axios.js */ "./node_modules/axios/lib/core/Axios.js");
/* harmony import */ var _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./core/mergeConfig.js */ "./node_modules/axios/lib/core/mergeConfig.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./defaults/index.js */ "./node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./helpers/formDataToJSON.js */ "./node_modules/axios/lib/helpers/formDataToJSON.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _cancel_CancelToken_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./cancel/CancelToken.js */ "./node_modules/axios/lib/cancel/CancelToken.js");
/* harmony import */ var _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./cancel/isCancel.js */ "./node_modules/axios/lib/cancel/isCancel.js");
/* harmony import */ var _env_data_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./env/data.js */ "./node_modules/axios/lib/env/data.js");
/* harmony import */ var _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./helpers/toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _helpers_spread_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./helpers/spread.js */ "./node_modules/axios/lib/helpers/spread.js");
/* harmony import */ var _helpers_isAxiosError_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./helpers/isAxiosError.js */ "./node_modules/axios/lib/helpers/isAxiosError.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _helpers_HttpStatusCode_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./helpers/HttpStatusCode.js */ "./node_modules/axios/lib/helpers/HttpStatusCode.js");



















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"](defaultConfig);
  const instance = (0,_helpers_bind_js__WEBPACK_IMPORTED_MODULE_1__["default"])(_core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.request, context);

  // Copy axios.prototype to instance
  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].extend(instance, _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype, context, {allOwnKeys: true});

  // Copy context to instance
  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance((0,_core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"])(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(_defaults_index_js__WEBPACK_IMPORTED_MODULE_4__["default"]);

// Expose Axios class to allow class inheritance
axios.Axios = _core_Axios_js__WEBPACK_IMPORTED_MODULE_0__["default"];

// Expose Cancel & CancelToken
axios.CanceledError = _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_5__["default"];
axios.CancelToken = _cancel_CancelToken_js__WEBPACK_IMPORTED_MODULE_6__["default"];
axios.isCancel = _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_7__["default"];
axios.VERSION = _env_data_js__WEBPACK_IMPORTED_MODULE_8__.VERSION;
axios.toFormData = _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_9__["default"];

// Expose AxiosError class
axios.AxiosError = _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_10__["default"];

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = _helpers_spread_js__WEBPACK_IMPORTED_MODULE_11__["default"];

// Expose isAxiosError
axios.isAxiosError = _helpers_isAxiosError_js__WEBPACK_IMPORTED_MODULE_12__["default"];

// Expose mergeConfig
axios.mergeConfig = _core_mergeConfig_js__WEBPACK_IMPORTED_MODULE_3__["default"];

axios.AxiosHeaders = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_13__["default"];

axios.formToJSON = thing => (0,_helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_14__["default"])(_utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isHTMLForm(thing) ? new FormData(thing) : thing);

axios.HttpStatusCode = _helpers_HttpStatusCode_js__WEBPACK_IMPORTED_MODULE_15__["default"];

axios.default = axios;

// this module should only have a default export
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (axios);


/***/ }),

/***/ "./node_modules/axios/lib/cancel/CancelToken.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/cancel/CancelToken.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _CanceledError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new _CanceledError_js__WEBPACK_IMPORTED_MODULE_0__["default"](message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CancelToken);


/***/ }),

/***/ "./node_modules/axios/lib/cancel/CanceledError.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/cancel/CanceledError.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].call(this, message == null ? 'canceled' : message, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].inherits(CanceledError, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"], {
  __CANCEL__: true
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CanceledError);


/***/ }),

/***/ "./node_modules/axios/lib/cancel/isCancel.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/cancel/isCancel.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isCancel)
/* harmony export */ });


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}


/***/ }),

/***/ "./node_modules/axios/lib/core/Axios.js":
/*!**********************************************!*\
  !*** ./node_modules/axios/lib/core/Axios.js ***!
  \**********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../helpers/buildURL.js */ "./node_modules/axios/lib/helpers/buildURL.js");
/* harmony import */ var _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./InterceptorManager.js */ "./node_modules/axios/lib/core/InterceptorManager.js");
/* harmony import */ var _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./dispatchRequest.js */ "./node_modules/axios/lib/core/dispatchRequest.js");
/* harmony import */ var _mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mergeConfig.js */ "./node_modules/axios/lib/core/mergeConfig.js");
/* harmony import */ var _buildFullPath_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./buildFullPath.js */ "./node_modules/axios/lib/core/buildFullPath.js");
/* harmony import */ var _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/validator.js */ "./node_modules/axios/lib/helpers/validator.js");
/* harmony import */ var _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");











const validators = _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__["default"](),
      response: new _InterceptorManager_js__WEBPACK_IMPORTED_MODULE_1__["default"]()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = (0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        }
      } else {
        _helpers_validator_js__WEBPACK_IMPORTED_MODULE_0__["default"].assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    let contextHeaders;

    // Flatten headers
    contextHeaders = headers && _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].merge(
      headers.common,
      headers[config.method]
    );

    contextHeaders && _utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_4__["default"].concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [_dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__["default"].bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = _dispatchRequest_js__WEBPACK_IMPORTED_MODULE_5__["default"].call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = (0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(this.defaults, config);
    const fullPath = (0,_buildFullPath_js__WEBPACK_IMPORTED_MODULE_6__["default"])(config.baseURL, config.url);
    return (0,_helpers_buildURL_js__WEBPACK_IMPORTED_MODULE_7__["default"])(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request((0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

_utils_js__WEBPACK_IMPORTED_MODULE_3__["default"].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request((0,_mergeConfig_js__WEBPACK_IMPORTED_MODULE_2__["default"])(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Axios);


/***/ }),

/***/ "./node_modules/axios/lib/core/AxiosError.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/core/AxiosError.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype);

  _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosError);


/***/ }),

/***/ "./node_modules/axios/lib/core/AxiosHeaders.js":
/*!*****************************************************!*\
  !*** ./node_modules/axios/lib/core/AxiosHeaders.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_parseHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/parseHeaders.js */ "./node_modules/axios/lib/helpers/parseHeaders.js");





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(value)) return;

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders((0,_helpers_parseHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"])(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this, (value, header) => {
      const key = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].freezeMethods(AxiosHeaders.prototype);
_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].freezeMethods(AxiosHeaders);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosHeaders);


/***/ }),

/***/ "./node_modules/axios/lib/core/InterceptorManager.js":
/*!***********************************************************!*\
  !*** ./node_modules/axios/lib/core/InterceptorManager.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InterceptorManager);


/***/ }),

/***/ "./node_modules/axios/lib/core/buildFullPath.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/buildFullPath.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ buildFullPath)
/* harmony export */ });
/* harmony import */ var _helpers_isAbsoluteURL_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/isAbsoluteURL.js */ "./node_modules/axios/lib/helpers/isAbsoluteURL.js");
/* harmony import */ var _helpers_combineURLs_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/combineURLs.js */ "./node_modules/axios/lib/helpers/combineURLs.js");





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !(0,_helpers_isAbsoluteURL_js__WEBPACK_IMPORTED_MODULE_0__["default"])(requestedURL)) {
    return (0,_helpers_combineURLs_js__WEBPACK_IMPORTED_MODULE_1__["default"])(baseURL, requestedURL);
  }
  return requestedURL;
}


/***/ }),

/***/ "./node_modules/axios/lib/core/dispatchRequest.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/core/dispatchRequest.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ dispatchRequest)
/* harmony export */ });
/* harmony import */ var _transformData_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./transformData.js */ "./node_modules/axios/lib/core/transformData.js");
/* harmony import */ var _cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../cancel/isCancel.js */ "./node_modules/axios/lib/cancel/isCancel.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../defaults/index.js */ "./node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../cancel/CanceledError.js */ "./node_modules/axios/lib/cancel/CanceledError.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");
/* harmony import */ var _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../adapters/adapters.js */ "./node_modules/axios/lib/adapters/adapters.js");









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new _cancel_CanceledError_js__WEBPACK_IMPORTED_MODULE_0__["default"](null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(config.headers);

  // Transform request data
  config.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = _adapters_adapters_js__WEBPACK_IMPORTED_MODULE_3__["default"].getAdapter(config.adapter || _defaults_index_js__WEBPACK_IMPORTED_MODULE_4__["default"].adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
      config,
      config.transformResponse,
      response
    );

    response.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!(0,_cancel_isCancel_js__WEBPACK_IMPORTED_MODULE_5__["default"])(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = _transformData_js__WEBPACK_IMPORTED_MODULE_2__["default"].call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}


/***/ }),

/***/ "./node_modules/axios/lib/core/mergeConfig.js":
/*!****************************************************!*\
  !*** ./node_modules/axios/lib/core/mergeConfig.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ mergeConfig)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");





const headersToObject = (thing) => thing instanceof _AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_0__["default"] ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(target) && _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(source)) {
      return _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge.call({caseless}, target, source);
    } else if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isPlainObject(source)) {
      return _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].merge({}, source);
    } else if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  _utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}


/***/ }),

/***/ "./node_modules/axios/lib/core/settle.js":
/*!***********************************************!*\
  !*** ./node_modules/axios/lib/core/settle.js ***!
  \***********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ settle)
/* harmony export */ });
/* harmony import */ var _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"](
      'Request failed with status code ' + response.status,
      [_AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_BAD_REQUEST, _AxiosError_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}


/***/ }),

/***/ "./node_modules/axios/lib/core/transformData.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/transformData.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ transformData)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _defaults_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../defaults/index.js */ "./node_modules/axios/lib/defaults/index.js");
/* harmony import */ var _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosHeaders.js */ "./node_modules/axios/lib/core/AxiosHeaders.js");






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || _defaults_index_js__WEBPACK_IMPORTED_MODULE_0__["default"];
  const context = response || config;
  const headers = _core_AxiosHeaders_js__WEBPACK_IMPORTED_MODULE_1__["default"].from(context.headers);
  let data = context.data;

  _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}


/***/ }),

/***/ "./node_modules/axios/lib/defaults/index.js":
/*!**************************************************!*\
  !*** ./node_modules/axios/lib/defaults/index.js ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _transitional_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./transitional.js */ "./node_modules/axios/lib/defaults/transitional.js");
/* harmony import */ var _helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../helpers/toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _helpers_toURLEncodedForm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../helpers/toURLEncodedForm.js */ "./node_modules/axios/lib/helpers/toURLEncodedForm.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");
/* harmony import */ var _helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers/formDataToJSON.js */ "./node_modules/axios/lib/helpers/formDataToJSON.js");










const DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: _transitional_js__WEBPACK_IMPORTED_MODULE_1__["default"],

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(data);

    if (isObjectPayload && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify((0,_helpers_formDataToJSON_js__WEBPACK_IMPORTED_MODULE_2__["default"])(data)) : data;
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBuffer(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBuffer(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStream(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFile(data) ||
      _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBlob(data)
    ) {
      return data;
    }
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBufferView(data)) {
      return data.buffer;
    }
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return (0,_helpers_toURLEncodedForm_js__WEBPACK_IMPORTED_MODULE_3__["default"])(data, this.formSerializer).toString();
      }

      if ((isFileList = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return (0,_helpers_toFormData_js__WEBPACK_IMPORTED_MODULE_4__["default"])(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__["default"].from(e, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_5__["default"].ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: _platform_index_js__WEBPACK_IMPORTED_MODULE_6__["default"].classes.FormData,
    Blob: _platform_index_js__WEBPACK_IMPORTED_MODULE_6__["default"].classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].merge(DEFAULT_CONTENT_TYPE);
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (defaults);


/***/ }),

/***/ "./node_modules/axios/lib/defaults/transitional.js":
/*!*********************************************************!*\
  !*** ./node_modules/axios/lib/defaults/transitional.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});


/***/ }),

/***/ "./node_modules/axios/lib/env/data.js":
/*!********************************************!*\
  !*** ./node_modules/axios/lib/env/data.js ***!
  \********************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VERSION": () => (/* binding */ VERSION)
/* harmony export */ });
const VERSION = "1.3.6";

/***/ }),

/***/ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js":
/*!****************************************************************!*\
  !*** ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js ***!
  \****************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _toFormData_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && (0,_toFormData_js__WEBPACK_IMPORTED_MODULE_0__["default"])(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (AxiosURLSearchParams);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/HttpStatusCode.js":
/*!**********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/HttpStatusCode.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HttpStatusCode);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/bind.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/helpers/bind.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ bind)
/* harmony export */ });


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/buildURL.js":
/*!****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/buildURL.js ***!
  \****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ buildURL)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../helpers/AxiosURLSearchParams.js */ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js");





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isURLSearchParams(params) ?
      params.toString() :
      new _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_1__["default"](params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/combineURLs.js":
/*!*******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/combineURLs.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ combineURLs)
/* harmony export */ });


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/cookies.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/helpers/cookies.js ***!
  \***************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");





/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(path)) {
          cookie.push('path=' + path);
        }

        if (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })());


/***/ }),

/***/ "./node_modules/axios/lib/helpers/formDataToJSON.js":
/*!**********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/formDataToJSON.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(target) ? target.length : name;

    if (isLast) {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFormData(formData) && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(formData.entries)) {
    const obj = {};

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (formDataToJSON);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isAbsoluteURL.js":
/*!*********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isAbsoluteURL)
/* harmony export */ });


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isAxiosError.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAxiosError.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ isAxiosError)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(payload) && (payload.isAxiosError === true);
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/isURLSameOrigin.js":
/*!***********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \***********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");





/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_platform_index_js__WEBPACK_IMPORTED_MODULE_0__["default"].isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (_utils_js__WEBPACK_IMPORTED_MODULE_1__["default"].isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());


/***/ }),

/***/ "./node_modules/axios/lib/helpers/null.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/helpers/null.js ***!
  \************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// eslint-disable-next-line strict
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (null);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/parseHeaders.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/parseHeaders.js ***!
  \********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./../utils.js */ "./node_modules/axios/lib/utils.js");




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});


/***/ }),

/***/ "./node_modules/axios/lib/helpers/parseProtocol.js":
/*!*********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/parseProtocol.js ***!
  \*********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ parseProtocol)
/* harmony export */ });


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/speedometer.js":
/*!*******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/speedometer.js ***!
  \*******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (speedometer);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/spread.js":
/*!**************************************************!*\
  !*** ./node_modules/axios/lib/helpers/spread.js ***!
  \**************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ spread)
/* harmony export */ });


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/toFormData.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/toFormData.js ***!
  \******************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");
/* harmony import */ var _platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../platform/node/classes/FormData.js */ "./node_modules/axios/lib/helpers/null.js");




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isPlainObject(thing) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(arr) && !arr.some(isVisitable);
}

const predicates = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"], {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (_platform_node_classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__["default"] || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isSpecCompliantForm(formData);

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isBlob(value)) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_2__["default"]('Blob is not supported. Use a Buffer instead.');
    }

    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArrayBuffer(value) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isArray(value) && isFlatArray(value)) ||
        ((_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isFileList(value) || _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].endsWith(key, '[]')) && (arr = _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].forEach(value, function each(el, key) {
      const result = !(_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isUndefined(el) || el === null) && visitor.call(
        formData, el, _utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!_utils_js__WEBPACK_IMPORTED_MODULE_0__["default"].isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (toFormData);


/***/ }),

/***/ "./node_modules/axios/lib/helpers/toURLEncodedForm.js":
/*!************************************************************!*\
  !*** ./node_modules/axios/lib/helpers/toURLEncodedForm.js ***!
  \************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ toURLEncodedForm)
/* harmony export */ });
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils.js */ "./node_modules/axios/lib/utils.js");
/* harmony import */ var _toFormData_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toFormData.js */ "./node_modules/axios/lib/helpers/toFormData.js");
/* harmony import */ var _platform_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../platform/index.js */ "./node_modules/axios/lib/platform/browser/index.js");






function toURLEncodedForm(data, options) {
  return (0,_toFormData_js__WEBPACK_IMPORTED_MODULE_0__["default"])(data, new _platform_index_js__WEBPACK_IMPORTED_MODULE_1__["default"].classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (_platform_index_js__WEBPACK_IMPORTED_MODULE_1__["default"].isNode && _utils_js__WEBPACK_IMPORTED_MODULE_2__["default"].isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}


/***/ }),

/***/ "./node_modules/axios/lib/helpers/validator.js":
/*!*****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/validator.js ***!
  \*****************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _env_data_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../env/data.js */ "./node_modules/axios/lib/env/data.js");
/* harmony import */ var _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../core/AxiosError.js */ "./node_modules/axios/lib/core/AxiosError.js");





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + _env_data_js__WEBPACK_IMPORTED_MODULE_0__.VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"](
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('options must be an object', _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('option ' + opt + ' must be ' + result, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"]('Unknown option ' + opt, _core_AxiosError_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  assertOptions,
  validators
});


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/classes/Blob.js":
/*!*****************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/Blob.js ***!
  \*****************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof Blob !== 'undefined' ? Blob : null);


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/classes/FormData.js":
/*!*********************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/FormData.js ***!
  \*********************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof FormData !== 'undefined' ? FormData : null);


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js":
/*!****************************************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js ***!
  \****************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../helpers/AxiosURLSearchParams.js */ "./node_modules/axios/lib/helpers/AxiosURLSearchParams.js");



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : _helpers_AxiosURLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),

/***/ "./node_modules/axios/lib/platform/browser/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/axios/lib/platform/browser/index.js ***!
  \**********************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _classes_URLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./classes/URLSearchParams.js */ "./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js");
/* harmony import */ var _classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./classes/FormData.js */ "./node_modules/axios/lib/platform/browser/classes/FormData.js");
/* harmony import */ var _classes_Blob_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./classes/Blob.js */ "./node_modules/axios/lib/platform/browser/classes/Blob.js");




/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  isBrowser: true,
  classes: {
    URLSearchParams: _classes_URLSearchParams_js__WEBPACK_IMPORTED_MODULE_0__["default"],
    FormData: _classes_FormData_js__WEBPACK_IMPORTED_MODULE_1__["default"],
    Blob: _classes_Blob_js__WEBPACK_IMPORTED_MODULE_2__["default"]
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});


/***/ }),

/***/ "./node_modules/axios/lib/utils.js":
/*!*****************************************!*\
  !*** ./node_modules/axios/lib/utils.js ***!
  \*****************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers/bind.js */ "./node_modules/axios/lib/helpers/bind.js");




// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = (0,_helpers_bind_js__WEBPACK_IMPORTED_MODULE_0__["default"])(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject
});


/***/ }),

/***/ "../../../node_modules/@zakeke/zakeke-resizable-canvas/dist/index.js":
/*!***************************************************************************!*\
  !*** ../../../node_modules/@zakeke/zakeke-resizable-canvas/dist/index.js ***!
  \***************************************************************************/
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Preview3DGenerator": () => (/* binding */ Qn),
/* harmony export */   "ProductAreaGenerator": () => (/* binding */ Jn),
/* harmony export */   "ProductImageGenerator": () => (/* binding */ Xn)
/* harmony export */ });
var qn = Object.defineProperty;
var Un = (Pt, q, F) => q in Pt ? qn(Pt, q, { enumerable: !0, configurable: !0, writable: !0, value: F }) : Pt[q] = F;
var Be = (Pt, q, F) => (Un(Pt, typeof q != "symbol" ? q + "" : q, F), F);
var Hn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Zn(Pt) {
  if (Pt.__esModule)
    return Pt;
  var q = Pt.default;
  if (typeof q == "function") {
    var F = function $() {
      if (this instanceof $) {
        var tt = [null];
        tt.push.apply(tt, arguments);
        var T = Function.bind.apply(q, tt);
        return new T();
      }
      return q.apply(this, arguments);
    };
    F.prototype = q.prototype;
  } else
    F = {};
  return Object.defineProperty(F, "__esModule", { value: !0 }), Object.keys(Pt).forEach(function($) {
    var tt = Object.getOwnPropertyDescriptor(Pt, $);
    Object.defineProperty(F, $, tt.get ? tt : {
      enumerable: !0,
      get: function() {
        return Pt[$];
      }
    });
  }), F;
}
function Wn(Pt) {
  throw new Error('Could not dynamically require "' + Pt + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var be = {}, Gn = {
  get exports() {
    return be;
  },
  set exports(Pt) {
    be = Pt;
  }
};
const Yn = {}, jn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Yn
}, Symbol.toStringTag, { value: "Module" })), Xi = /* @__PURE__ */ Zn(jn);
/*!
 * Paper.js v0.12.17 - The Swiss Army Knife of Vector Graphics Scripting.
 * http://paperjs.org/
 *
 * Copyright (c) 2011 - 2020, Jürg Lehni & Jonathan Puckey
 * http://juerglehni.com/ & https://puckey.studio/
 *
 * Distributed under the MIT license. See LICENSE file for details.
 *
 * All rights reserved.
 *
 * Date: Thu Nov 3 21:15:36 2022 +0100
 *
 ***
 *
 * Straps.js - Class inheritance library with support for bean-style accessors
 *
 * Copyright (c) 2006 - 2020 Jürg Lehni
 * http://juerglehni.com/
 *
 * Distributed under the MIT license.
 *
 ***
 *
 * Acorn.js
 * https://marijnhaverbeke.nl/acorn/
 *
 * Acorn is a tiny, fast JavaScript parser written in JavaScript,
 * created by Marijn Haverbeke and released under an MIT license.
 *
 */
(function(Pt) {
  (function(q, F) {
    q = q || Xi;
    var $ = q.window, tt = q.document, T = new function() {
      var t = /^(statics|enumerable|beans|preserve)$/, e = [], i = e.slice, n = Object.create, r = Object.getOwnPropertyDescriptor, s = Object.defineProperty, u = e.forEach || function(c, f) {
        for (var b = 0, v = this.length; b < v; b++)
          c.call(f, this[b], b, this);
      }, a = function(c, f) {
        for (var b in this)
          this.hasOwnProperty(b) && c.call(f, this[b], b, this);
      }, o = Object.assign || function(c) {
        for (var f = 1, b = arguments.length; f < b; f++) {
          var v = arguments[f];
          for (var x in v)
            v.hasOwnProperty(x) && (c[x] = v[x]);
        }
        return c;
      }, h = function(c, f, b) {
        if (c) {
          var v = r(c, "length");
          (v && typeof v.value == "number" ? u : a).call(c, f, b = b || c);
        }
        return b;
      };
      function d(c, f, b, v, x) {
        var _ = {};
        function m(w, C) {
          C = C || (C = r(f, w)) && (C.get ? C : C.value), typeof C == "string" && C[0] === "#" && (C = c[C.substring(1)] || C);
          var I = typeof C == "function", M = C, k = x || I && !C.base ? C && C.get ? w in c : c[w] : null, P;
          (!x || !k) && (I && k && (C.base = k), I && v !== !1 && (P = w.match(/^([gs]et|is)(([A-Z])(.*))$/)) && (_[P[3].toLowerCase() + P[4]] = P[2]), (!M || I || !M.get || typeof M.get != "function" || !g.isPlainObject(M)) && (M = { value: M, writable: !0 }), (r(c, w) || { configurable: !0 }).configurable && (M.configurable = !0, M.enumerable = b ?? !P), s(c, w, M));
        }
        if (f) {
          for (var l in f)
            f.hasOwnProperty(l) && !t.test(l) && m(l);
          for (var l in _) {
            var p = _[l], y = c["set" + p], S = c["get" + p] || y && c["is" + p];
            S && (v === !0 || S.length === 0) && m(l, { get: S, set: y });
          }
        }
        return c;
      }
      function g() {
        for (var c = 0, f = arguments.length; c < f; c++) {
          var b = arguments[c];
          b && o(this, b);
        }
        return this;
      }
      return d(g, {
        inject: function(c) {
          if (c) {
            var f = c.statics === !0 ? c : c.statics, b = c.beans, v = c.preserve;
            f !== c && d(this.prototype, c, c.enumerable, b, v), d(this, f, null, b, v);
          }
          for (var x = 1, _ = arguments.length; x < _; x++)
            this.inject(arguments[x]);
          return this;
        },
        extend: function() {
          for (var c = this, f, b, v = 0, x, _ = arguments.length; v < _ && !(f && b); v++)
            x = arguments[v], f = f || x.initialize, b = b || x.prototype;
          return f = f || function() {
            c.apply(this, arguments);
          }, b = f.prototype = b || n(this.prototype), s(
            b,
            "constructor",
            { value: f, writable: !0, configurable: !0 }
          ), d(f, this), arguments.length && this.inject.apply(f, arguments), f.base = c, f;
        }
      }).inject({
        enumerable: !1,
        initialize: g,
        set: g,
        inject: function() {
          for (var c = 0, f = arguments.length; c < f; c++) {
            var b = arguments[c];
            b && d(this, b, b.enumerable, b.beans, b.preserve);
          }
          return this;
        },
        extend: function() {
          var c = n(this);
          return c.inject.apply(c, arguments);
        },
        each: function(c, f) {
          return h(this, c, f);
        },
        clone: function() {
          return new this.constructor(this);
        },
        statics: {
          set: o,
          each: h,
          create: n,
          define: s,
          describe: r,
          clone: function(c) {
            return o(new c.constructor(), c);
          },
          isPlainObject: function(c) {
            var f = c != null && c.constructor;
            return f && (f === Object || f === g || f.name === "Object");
          },
          pick: function(c, f) {
            return c !== F ? c : f;
          },
          slice: function(c, f, b) {
            return i.call(c, f, b);
          }
        }
      });
    }();
    Pt.exports = T, T.inject({
      enumerable: !1,
      toString: function() {
        return this._id != null ? (this._class || "Object") + (this._name ? " '" + this._name + "'" : " @" + this._id) : "{ " + T.each(this, function(t, e) {
          if (!/^_/.test(e)) {
            var i = typeof t;
            this.push(e + ": " + (i === "number" ? St.instance.number(t) : i === "string" ? "'" + t + "'" : t));
          }
        }, []).join(", ") + " }";
      },
      getClassName: function() {
        return this._class || "";
      },
      importJSON: function(t) {
        return T.importJSON(t, this);
      },
      exportJSON: function(t) {
        return T.exportJSON(this, t);
      },
      toJSON: function() {
        return T.serialize(this);
      },
      set: function(t, e) {
        return t && T.filter(this, t, e, this._prioritize), this;
      }
    }, {
      beans: !1,
      statics: {
        exports: {},
        extend: function t() {
          var e = t.base.apply(this, arguments), i = e.prototype._class;
          return i && !T.exports[i] && (T.exports[i] = e), e;
        },
        equals: function(t, e) {
          if (t === e)
            return !0;
          if (t && t.equals)
            return t.equals(e);
          if (e && e.equals)
            return e.equals(t);
          if (t && e && typeof t == "object" && typeof e == "object") {
            if (Array.isArray(t) && Array.isArray(e)) {
              var i = t.length;
              if (i !== e.length)
                return !1;
              for (; i--; )
                if (!T.equals(t[i], e[i]))
                  return !1;
            } else {
              var n = Object.keys(t), i = n.length;
              if (i !== Object.keys(e).length)
                return !1;
              for (; i--; ) {
                var r = n[i];
                if (!(e.hasOwnProperty(r) && T.equals(t[r], e[r])))
                  return !1;
              }
            }
            return !0;
          }
          return !1;
        },
        read: function(t, e, i, n) {
          if (this === T) {
            var r = this.peek(t, e);
            return t.__index++, r;
          }
          var s = this.prototype, u = s._readIndex, a = e || u && t.__index || 0, o = t.length, h = t[a];
          if (n = n || o - a, h instanceof this || i && i.readNull && h == null && n <= 1)
            return u && (t.__index = a + 1), h && i && i.clone ? h.clone() : h;
          if (h = T.create(s), u && (h.__read = !0), h = h.initialize.apply(h, a > 0 || a + n < o ? T.slice(t, a, a + n) : t) || h, u) {
            t.__index = a + h.__read;
            var d = h.__filtered;
            d && (t.__filtered = d, h.__filtered = F), h.__read = F;
          }
          return h;
        },
        peek: function(t, e) {
          return t[t.__index = e || t.__index || 0];
        },
        remain: function(t) {
          return t.length - (t.__index || 0);
        },
        readList: function(t, e, i, n) {
          for (var r = [], s, u = e || 0, a = n ? u + n : t.length, o = u; o < a; o++)
            r.push(Array.isArray(s = t[o]) ? this.read(s, 0, i) : this.read(t, o, i, 1));
          return r;
        },
        readNamed: function(t, e, i, n, r) {
          var s = this.getNamed(t, e), u = s !== F;
          if (u) {
            var a = t.__filtered;
            if (!a) {
              var o = this.getSource(t);
              a = t.__filtered = T.create(o), a.__unfiltered = o;
            }
            a[e] = F;
          }
          return this.read(u ? [s] : t, i, n, r);
        },
        readSupported: function(t, e) {
          var i = this.getSource(t), n = this, r = !1;
          return i && Object.keys(i).forEach(function(s) {
            if (s in e) {
              var u = n.readNamed(t, s);
              u !== F && (e[s] = u), r = !0;
            }
          }), r;
        },
        getSource: function(t) {
          var e = t.__source;
          if (e === F) {
            var i = t.length === 1 && t[0];
            e = t.__source = i && T.isPlainObject(i) ? i : null;
          }
          return e;
        },
        getNamed: function(t, e) {
          var i = this.getSource(t);
          if (i)
            return e ? i[e] : t.__filtered || i;
        },
        hasNamed: function(t, e) {
          return !!this.getNamed(t, e);
        },
        filter: function(t, e, i, n) {
          var r;
          function s(d) {
            if (!(i && d in i) && !(r && d in r)) {
              var g = e[d];
              g !== F && (t[d] = g);
            }
          }
          if (n) {
            for (var u = {}, a = 0, o, h = n.length; a < h; a++)
              (o = n[a]) in e && (s(o), u[o] = !0);
            r = u;
          }
          return Object.keys(e.__unfiltered || e).forEach(s), t;
        },
        isPlainValue: function(t, e) {
          return T.isPlainObject(t) || Array.isArray(t) || e && typeof t == "string";
        },
        serialize: function(t, e, i, n) {
          e = e || {};
          var r = !n, s;
          if (r && (e.formatter = new St(e.precision), n = {
            length: 0,
            definitions: {},
            references: {},
            add: function(g, c) {
              var f = "#" + g._id, b = this.references[f];
              if (!b) {
                this.length++;
                var v = c.call(g), x = g._class;
                x && v[0] !== x && v.unshift(x), this.definitions[f] = v, b = this.references[f] = [f];
              }
              return b;
            }
          }), t && t._serialize) {
            s = t._serialize(e, n);
            var u = t._class;
            u && !t._compactSerialize && (r || !i) && s[0] !== u && s.unshift(u);
          } else if (Array.isArray(t)) {
            s = [];
            for (var a = 0, o = t.length; a < o; a++)
              s[a] = T.serialize(t[a], e, i, n);
          } else if (T.isPlainObject(t)) {
            s = {};
            for (var h = Object.keys(t), a = 0, o = h.length; a < o; a++) {
              var d = h[a];
              s[d] = T.serialize(
                t[d],
                e,
                i,
                n
              );
            }
          } else
            typeof t == "number" ? s = e.formatter.number(t, e.precision) : s = t;
          return r && n.length > 0 ? [["dictionary", n.definitions], s] : s;
        },
        deserialize: function(t, e, i, n, r) {
          var s = t, u = !i, a = u && t && t.length && t[0][0] === "dictionary";
          if (i = i || {}, Array.isArray(t)) {
            var o = t[0], h = o === "dictionary";
            if (t.length == 1 && /^#/.test(o))
              return i.dictionary[o];
            o = T.exports[o], s = [];
            for (var d = o ? 1 : 0, g = t.length; d < g; d++)
              s.push(T.deserialize(
                t[d],
                e,
                i,
                h,
                a
              ));
            if (o) {
              var c = s;
              e ? s = e(o, c, u || r) : s = new o(c);
            }
          } else if (T.isPlainObject(t)) {
            s = {}, n && (i.dictionary = s);
            for (var f in t)
              s[f] = T.deserialize(t[f], e, i);
          }
          return a ? s[1] : s;
        },
        exportJSON: function(t, e) {
          var i = T.serialize(t, e);
          return e && e.asString == !1 ? i : JSON.stringify(i);
        },
        importJSON: function(t, e) {
          return T.deserialize(
            typeof t == "string" ? JSON.parse(t) : t,
            function(i, n, r) {
              var s = r && e && e.constructor === i, u = s ? e : T.create(i.prototype);
              if (n.length === 1 && u instanceof ft && (s || !(u instanceof Kt))) {
                var a = n[0];
                T.isPlainObject(a) && (a.insert = !1, s && (n = n.concat([ft.INSERT])));
              }
              return (s ? u.set : i).apply(u, n), s && (e = null), u;
            }
          );
        },
        push: function(t, e) {
          var i = e.length;
          if (i < 4096)
            t.push.apply(t, e);
          else {
            var n = t.length;
            t.length += i;
            for (var r = 0; r < i; r++)
              t[n + r] = e[r];
          }
          return t;
        },
        splice: function(t, e, i, n) {
          var r = e && e.length, s = i === F;
          i = s ? t.length : i, i > t.length && (i = t.length);
          for (var u = 0; u < r; u++)
            e[u]._index = i + u;
          if (s)
            return T.push(t, e), [];
          var a = [i, n];
          e && T.push(a, e);
          for (var o = t.splice.apply(t, a), u = 0, h = o.length; u < h; u++)
            o[u]._index = F;
          for (var u = i + r, h = t.length; u < h; u++)
            t[u]._index = u;
          return o;
        },
        capitalize: function(t) {
          return t.replace(/\b[a-z]/g, function(e) {
            return e.toUpperCase();
          });
        },
        camelize: function(t) {
          return t.replace(/-(.)/g, function(e, i) {
            return i.toUpperCase();
          });
        },
        hyphenate: function(t) {
          return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        }
      }
    });
    var vt = {
      on: function(t, e) {
        if (typeof t != "string")
          T.each(t, function(s, u) {
            this.on(u, s);
          }, this);
        else {
          var i = this._eventTypes, n = i && i[t], r = this._callbacks = this._callbacks || {};
          r = r[t] = r[t] || [], r.indexOf(e) === -1 && (r.push(e), n && n.install && r.length === 1 && n.install.call(this, t));
        }
        return this;
      },
      off: function(t, e) {
        if (typeof t != "string") {
          T.each(t, function(u, a) {
            this.off(a, u);
          }, this);
          return;
        }
        var i = this._eventTypes, n = i && i[t], r = this._callbacks && this._callbacks[t], s;
        return r && (!e || (s = r.indexOf(e)) !== -1 && r.length === 1 ? (n && n.uninstall && n.uninstall.call(this, t), delete this._callbacks[t]) : s !== -1 && r.splice(s, 1)), this;
      },
      once: function(t, e) {
        return this.on(t, function i() {
          e.apply(this, arguments), this.off(t, i);
        });
      },
      emit: function(t, e) {
        var i = this._callbacks && this._callbacks[t];
        if (!i)
          return !1;
        var n = T.slice(arguments, 1), r = e && e.target && !e.currentTarget;
        i = i.slice(), r && (e.currentTarget = this);
        for (var s = 0, u = i.length; s < u; s++)
          if (i[s].apply(this, n) == !1) {
            e && e.stop && e.stop();
            break;
          }
        return r && delete e.currentTarget, !0;
      },
      responds: function(t) {
        return !!(this._callbacks && this._callbacks[t]);
      },
      attach: "#on",
      detach: "#off",
      fire: "#emit",
      _installEvents: function(t) {
        var e = this._eventTypes, i = this._callbacks, n = t ? "install" : "uninstall";
        if (e) {
          for (var r in i)
            if (i[r].length > 0) {
              var s = e[r], u = s && s[n];
              u && u.call(this, r);
            }
        }
      },
      statics: {
        inject: function t(e) {
          var i = e._events;
          if (i) {
            var n = {};
            T.each(i, function(r, s) {
              var u = typeof r == "string", a = u ? r : s, o = T.capitalize(a), h = a.substring(2).toLowerCase();
              n[h] = u ? {} : r, a = "_" + a, e["get" + o] = function() {
                return this[a];
              }, e["set" + o] = function(d) {
                var g = this[a];
                g && this.off(h, g), d && this.on(h, d), this[a] = d;
              };
            }), e._eventTypes = n;
          }
          return t.base.apply(this, arguments);
        }
      }
    }, yt = T.extend({
      _class: "PaperScope",
      initialize: function t() {
        _t = this, this.settings = new T({
          applyMatrix: !0,
          insertItems: !0,
          handleSize: 4,
          hitTolerance: 0
        }), this.project = null, this.projects = [], this.tools = [], this._id = t._id++, t._scopes[this._id] = this;
        var e = t.prototype;
        if (!this.support) {
          var i = Dt.getContext(1, 1) || {};
          e.support = {
            nativeDash: "setLineDash" in i || "mozDash" in i,
            nativeBlendModes: si.nativeModes
          }, Dt.release(i);
        }
        if (!this.agent) {
          var n = q.navigator.userAgent.toLowerCase(), r = (/(darwin|win|mac|linux|freebsd|sunos)/.exec(n) || [])[0], s = r === "darwin" ? "mac" : r, u = e.agent = e.browser = { platform: s };
          s && (u[s] = !0), n.replace(
            /(opera|chrome|safari|webkit|firefox|msie|trident|atom|node|jsdom)\/?\s*([.\d]+)(?:.*version\/([.\d]+))?(?:.*rv\:v?([.\d]+))?/g,
            function(a, o, h, d, g) {
              if (!u.chrome) {
                var c = o === "opera" ? d : /^(node|trident)$/.test(o) ? g : h;
                u.version = c, u.versionNumber = parseFloat(c), o = { trident: "msie", jsdom: "node" }[o] || o, u.name = o, u[o] = !0;
              }
            }
          ), u.chrome && delete u.webkit, u.atom && delete u.chrome;
        }
      },
      version: "0.12.17",
      getView: function() {
        var t = this.project;
        return t && t._view;
      },
      getPaper: function() {
        return this;
      },
      execute: function(t, e) {
        var i = _t.PaperScript.execute(t, this, e);
        return Tt.updateFocus(), i;
      },
      install: function(t) {
        var e = this;
        T.each(["project", "view", "tool"], function(n) {
          T.define(t, n, {
            configurable: !0,
            get: function() {
              return e[n];
            }
          });
        });
        for (var i in this)
          !/^_/.test(i) && this[i] && (t[i] = this[i]);
      },
      setup: function(t) {
        return _t = this, this.project = new Te(t), this;
      },
      createCanvas: function(t, e) {
        return Dt.getCanvas(t, e);
      },
      activate: function() {
        _t = this;
      },
      clear: function() {
        for (var t = this.projects, e = this.tools, i = t.length - 1; i >= 0; i--)
          t[i].remove();
        for (var i = e.length - 1; i >= 0; i--)
          e[i].remove();
      },
      remove: function() {
        this.clear(), delete yt._scopes[this._id];
      },
      statics: new function() {
        function t(e) {
          return e += "Attribute", function(i, n) {
            return i[e](n) || i[e]("data-paper-" + n);
          };
        }
        return {
          _scopes: {},
          _id: 0,
          get: function(e) {
            return this._scopes[e] || null;
          },
          getAttribute: t("get"),
          hasAttribute: t("has")
        };
      }()
    }), Ct = T.extend(vt, {
      initialize: function(t) {
        this._scope = _t, this._index = this._scope[this._list].push(this) - 1, (t || !this._scope[this._reference]) && this.activate();
      },
      activate: function() {
        if (!this._scope)
          return !1;
        var t = this._scope[this._reference];
        return t && t !== this && t.emit("deactivate"), this._scope[this._reference] = this, this.emit("activate", t), !0;
      },
      isActive: function() {
        return this._scope[this._reference] === this;
      },
      remove: function() {
        return this._index == null ? !1 : (T.splice(this._scope[this._list], null, this._index, 1), this._scope[this._reference] == this && (this._scope[this._reference] = null), this._scope = null, !0);
      },
      getView: function() {
        return this._scope.getView();
      }
    }), qt = {
      findItemBoundsCollisions: function(t, e, i) {
        function n(u) {
          for (var a = new Array(u.length), o = 0; o < u.length; o++) {
            var h = u[o].getBounds();
            a[o] = [h.left, h.top, h.right, h.bottom];
          }
          return a;
        }
        var r = n(t), s = !e || e === t ? r : n(e);
        return this.findBoundsCollisions(r, s, i || 0);
      },
      findCurveBoundsCollisions: function(t, e, i, n) {
        function r(c) {
          for (var f = Math.min, b = Math.max, v = new Array(c.length), x = 0; x < c.length; x++) {
            var _ = c[x];
            v[x] = [
              f(_[0], _[2], _[4], _[6]),
              f(_[1], _[3], _[5], _[7]),
              b(_[0], _[2], _[4], _[6]),
              b(_[1], _[3], _[5], _[7])
            ];
          }
          return v;
        }
        var s = r(t), u = !e || e === t ? s : r(e);
        if (n) {
          for (var a = this.findBoundsCollisions(
            s,
            u,
            i || 0,
            !1,
            !0
          ), o = this.findBoundsCollisions(
            s,
            u,
            i || 0,
            !0,
            !0
          ), h = [], d = 0, g = a.length; d < g; d++)
            h[d] = { hor: a[d], ver: o[d] };
          return h;
        }
        return this.findBoundsCollisions(s, u, i || 0);
      },
      findBoundsCollisions: function(t, e, i, n, r) {
        var s = !e || t === e, u = s ? t : t.concat(e), a = t.length, o = u.length;
        function h(G, Y, X) {
          for (var V = 0, U = G.length; V < U; ) {
            var K = U + V >>> 1;
            u[G[K]][Y] < X ? V = K + 1 : U = K;
          }
          return V - 1;
        }
        for (var d = n ? 1 : 0, g = d + 2, c = n ? 0 : 1, f = c + 2, b = new Array(o), v = 0; v < o; v++)
          b[v] = v;
        b.sort(function(G, Y) {
          return u[G][d] - u[Y][d];
        });
        for (var x = [], _ = new Array(a), v = 0; v < o; v++) {
          var m = b[v], l = u[m], p = s ? m : m - a, y = m < a, S = s || !y, w = y ? [] : null;
          if (x.length) {
            var C = h(
              x,
              g,
              l[d] - i
            ) + 1;
            if (x.splice(0, C), s && r) {
              w = w.concat(x);
              for (var I = 0; I < x.length; I++) {
                var M = x[I];
                _[M].push(p);
              }
            } else
              for (var k = l[f], P = l[c], I = 0; I < x.length; I++) {
                var M = x[I], O = u[M], L = M < a, B = s || M >= a;
                (r || (y && B || S && L) && k >= O[c] - i && P <= O[f] + i) && (y && B && w.push(
                  s ? M : M - a
                ), S && L && _[M].push(p));
              }
          }
          if (y && (t === e && w.push(m), _[m] = w), x.length) {
            var N = l[g], D = h(x, g, N);
            x.splice(D + 1, 0, m);
          } else
            x.push(m);
        }
        for (var v = 0; v < _.length; v++) {
          var Z = _[v];
          Z && Z.sort(function(Y, X) {
            return Y - X;
          });
        }
        return _;
      }
    }, St = T.extend({
      initialize: function(t) {
        this.precision = T.pick(t, 5), this.multiplier = Math.pow(10, this.precision);
      },
      number: function(t) {
        return this.precision < 16 ? Math.round(t * this.multiplier) / this.multiplier : t;
      },
      pair: function(t, e, i) {
        return this.number(t) + (i || ",") + this.number(e);
      },
      point: function(t, e) {
        return this.number(t.x) + (e || ",") + this.number(t.y);
      },
      size: function(t, e) {
        return this.number(t.width) + (e || ",") + this.number(t.height);
      },
      rectangle: function(t, e) {
        return this.point(t, e) + (e || ",") + this.size(t, e);
      }
    });
    St.instance = new St();
    var lt = new function() {
      var t = [
        [0.5773502691896257],
        [0, 0.7745966692414834],
        [0.33998104358485626, 0.8611363115940526],
        [0, 0.5384693101056831, 0.906179845938664],
        [0.2386191860831969, 0.6612093864662645, 0.932469514203152],
        [0, 0.4058451513773972, 0.7415311855993945, 0.9491079123427585],
        [0.1834346424956498, 0.525532409916329, 0.7966664774136267, 0.9602898564975363],
        [0, 0.3242534234038089, 0.6133714327005904, 0.8360311073266358, 0.9681602395076261],
        [0.14887433898163122, 0.4333953941292472, 0.6794095682990244, 0.8650633666889845, 0.9739065285171717],
        [0, 0.26954315595234496, 0.5190961292068118, 0.7301520055740494, 0.8870625997680953, 0.978228658146057],
        [0.1252334085114689, 0.3678314989981802, 0.5873179542866175, 0.7699026741943047, 0.9041172563704749, 0.9815606342467192],
        [0, 0.2304583159551348, 0.44849275103644687, 0.6423493394403402, 0.8015780907333099, 0.9175983992229779, 0.9841830547185881],
        [0.10805494870734367, 0.31911236892788974, 0.5152486363581541, 0.6872929048116855, 0.827201315069765, 0.9284348836635735, 0.9862838086968123],
        [0, 0.20119409399743451, 0.3941513470775634, 0.5709721726085388, 0.7244177313601701, 0.8482065834104272, 0.937273392400706, 0.9879925180204854],
        [0.09501250983763744, 0.2816035507792589, 0.45801677765722737, 0.6178762444026438, 0.755404408355003, 0.8656312023878318, 0.9445750230732326, 0.9894009349916499]
      ], e = [
        [1],
        [0.8888888888888888, 0.5555555555555556],
        [0.6521451548625461, 0.34785484513745385],
        [0.5688888888888889, 0.47862867049936647, 0.23692688505618908],
        [0.46791393457269104, 0.3607615730481386, 0.17132449237917036],
        [0.4179591836734694, 0.3818300505051189, 0.27970539148927664, 0.1294849661688697],
        [0.362683783378362, 0.31370664587788727, 0.22238103445337448, 0.10122853629037626],
        [0.3302393550012598, 0.31234707704000286, 0.26061069640293544, 0.1806481606948574, 0.08127438836157441],
        [0.29552422471475287, 0.26926671930999635, 0.21908636251598204, 0.1494513491505806, 0.06667134430868814],
        [0.2729250867779006, 0.26280454451024665, 0.23319376459199048, 0.18629021092773426, 0.1255803694649046, 0.05566856711617366],
        [0.24914704581340277, 0.2334925365383548, 0.20316742672306592, 0.16007832854334622, 0.10693932599531843, 0.04717533638651183],
        [0.2325515532308739, 0.22628318026289723, 0.2078160475368885, 0.17814598076194574, 0.13887351021978725, 0.09212149983772845, 0.04048400476531588],
        [0.2152638534631578, 0.2051984637212956, 0.18553839747793782, 0.15720316715819355, 0.12151857068790319, 0.08015808715976021, 0.03511946033175186],
        [0.2025782419255613, 0.19843148532711158, 0.1861610000155622, 0.16626920581699392, 0.13957067792615432, 0.10715922046717194, 0.07036604748810812, 0.03075324199611727],
        [0.1894506104550685, 0.18260341504492358, 0.16915651939500254, 0.14959598881657674, 0.12462897125553388, 0.09515851168249279, 0.062253523938647894, 0.027152459411754096]
      ], i = Math.abs, n = Math.sqrt, r = Math.pow, s = Math.log2 || function(g) {
        return Math.log(g) * Math.LOG2E;
      }, u = 1e-12, a = 112e-18;
      function o(g, c, f) {
        return g < c ? c : g > f ? f : g;
      }
      function h(g, c, f) {
        function b(C) {
          var I = C * 134217729, M = C - I, k = M + I, P = C - k;
          return [k, P];
        }
        var v = c * c - g * f, x = c * c + g * f;
        if (i(v) * 3 < x) {
          var _ = b(g), m = b(c), l = b(f), p = c * c, y = m[0] * m[0] - p + 2 * m[0] * m[1] + m[1] * m[1], S = g * f, w = _[0] * l[0] - S + _[0] * l[1] + _[1] * l[0] + _[1] * l[1];
          v = p - S + (y - w);
        }
        return v;
      }
      function d() {
        var g = Math.max.apply(Math, arguments);
        return g && (g < 1e-8 || g > 1e8) ? r(2, -Math.round(s(g))) : 0;
      }
      return {
        EPSILON: u,
        MACHINE_EPSILON: a,
        CURVETIME_EPSILON: 1e-8,
        GEOMETRIC_EPSILON: 1e-7,
        TRIGONOMETRIC_EPSILON: 1e-8,
        ANGULAR_EPSILON: 1e-5,
        KAPPA: 4 * (n(2) - 1) / 3,
        isZero: function(g) {
          return g >= -u && g <= u;
        },
        isMachineZero: function(g) {
          return g >= -a && g <= a;
        },
        clamp: o,
        integrate: function(g, c, f, b) {
          for (var v = t[b - 2], x = e[b - 2], _ = (f - c) * 0.5, m = _ + c, l = 0, p = b + 1 >> 1, y = b & 1 ? x[l++] * g(m) : 0; l < p; ) {
            var S = _ * v[l];
            y += x[l++] * (g(m + S) + g(m - S));
          }
          return _ * y;
        },
        findRoot: function(g, c, f, b, v, x, _) {
          for (var m = 0; m < x; m++) {
            var l = g(f), p = l / c(f), y = f - p;
            if (i(p) < _) {
              f = y;
              break;
            }
            l > 0 ? (v = f, f = y <= b ? (b + v) * 0.5 : y) : (b = f, f = y >= v ? (b + v) * 0.5 : y);
          }
          return o(f, b, v);
        },
        solveQuadratic: function(g, c, f, b, v, x) {
          var _, m = 1 / 0;
          if (i(g) < u) {
            if (i(c) < u)
              return i(f) < u ? -1 : 0;
            _ = -f / c;
          } else {
            c *= -0.5;
            var l = h(g, c, f);
            if (l && i(l) < a) {
              var p = d(i(g), i(c), i(f));
              p && (g *= p, c *= p, f *= p, l = h(g, c, f));
            }
            if (l >= -a) {
              var y = l < 0 ? 0 : n(l), S = c + (c < 0 ? -y : y);
              S === 0 ? (_ = f / g, m = -_) : (_ = S / g, m = f / S);
            }
          }
          var w = 0, C = v == null, I = v - u, M = x + u;
          return isFinite(_) && (C || _ > I && _ < M) && (b[w++] = C ? _ : o(_, v, x)), m !== _ && isFinite(m) && (C || m > I && m < M) && (b[w++] = C ? m : o(m, v, x)), w;
        },
        solveCubic: function(g, c, f, b, v, x, _) {
          var m = d(i(g), i(c), i(f), i(b)), l, p, y, S, w;
          m && (g *= m, c *= m, f *= m, b *= m);
          function C(D) {
            l = D;
            var Z = g * l;
            p = Z + c, y = p * l + f, S = (Z + p) * l + y, w = y * l + b;
          }
          if (i(g) < u)
            g = c, p = f, y = b, l = 1 / 0;
          else if (i(b) < u)
            p = c, y = f, l = 0;
          else {
            C(-(c / g) / 3);
            var I = w / g, M = r(i(I), 1 / 3), k = I < 0 ? -1 : 1, P = -S / g, O = P > 0 ? 1.324717957244746 * Math.max(M, n(P)) : M, L = l - k * O;
            if (L !== l) {
              do
                C(L), L = S === 0 ? l : l - w / S / (1 + a);
              while (k * L > k * l);
              i(g) * l * l > i(b / l) && (y = -b / l, p = (y - f) / l);
            }
          }
          var B = lt.solveQuadratic(g, p, y, v, x, _), N = x == null;
          return isFinite(l) && (B === 0 || B > 0 && l !== v[0] && l !== v[1]) && (N || l > x - u && l < _ + u) && (v[B++] = N ? l : o(l, x, _)), B;
        }
      };
    }(), xt = {
      _id: 1,
      _pools: {},
      get: function(t) {
        if (t) {
          var e = this._pools[t];
          return e || (e = this._pools[t] = { _id: 1 }), e._id++;
        } else
          return this._id++;
      }
    }, E = T.extend({
      _class: "Point",
      _readIndex: !0,
      initialize: function(e, i) {
        var n = typeof e, r = this.__read, s = 0;
        if (n === "number") {
          var u = typeof i == "number";
          this._set(e, u ? i : e), r && (s = u ? 2 : 1);
        } else if (n === "undefined" || e === null)
          this._set(0, 0), r && (s = e === null ? 1 : 0);
        else {
          var a = n === "string" ? e.split(/[\s,]+/) || [] : e;
          s = 1, Array.isArray(a) ? this._set(+a[0], +(a.length > 1 ? a[1] : a[0])) : "x" in a ? this._set(a.x || 0, a.y || 0) : "width" in a ? this._set(a.width || 0, a.height || 0) : "angle" in a ? (this._set(a.length || 0, 0), this.setAngle(a.angle || 0)) : (this._set(0, 0), s = 0);
        }
        return r && (this.__read = s), this;
      },
      set: "#initialize",
      _set: function(t, e) {
        return this.x = t, this.y = e, this;
      },
      equals: function(t) {
        return this === t || t && (this.x === t.x && this.y === t.y || Array.isArray(t) && this.x === t[0] && this.y === t[1]) || !1;
      },
      clone: function() {
        return new E(this.x, this.y);
      },
      toString: function() {
        var t = St.instance;
        return "{ x: " + t.number(this.x) + ", y: " + t.number(this.y) + " }";
      },
      _serialize: function(t) {
        var e = t.formatter;
        return [e.number(this.x), e.number(this.y)];
      },
      getLength: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      },
      setLength: function(t) {
        if (this.isZero()) {
          var e = this._angle || 0;
          this._set(
            Math.cos(e) * t,
            Math.sin(e) * t
          );
        } else {
          var i = t / this.getLength();
          lt.isZero(i) && this.getAngle(), this._set(
            this.x * i,
            this.y * i
          );
        }
      },
      getAngle: function() {
        return this.getAngleInRadians.apply(this, arguments) * 180 / Math.PI;
      },
      setAngle: function(t) {
        this.setAngleInRadians.call(this, t * Math.PI / 180);
      },
      getAngleInDegrees: "#getAngle",
      setAngleInDegrees: "#setAngle",
      getAngleInRadians: function() {
        if (arguments.length) {
          var t = E.read(arguments), e = this.getLength() * t.getLength();
          if (lt.isZero(e))
            return NaN;
          var i = this.dot(t) / e;
          return Math.acos(i < -1 ? -1 : i > 1 ? 1 : i);
        } else
          return this.isZero() ? this._angle || 0 : this._angle = Math.atan2(this.y, this.x);
      },
      setAngleInRadians: function(t) {
        if (this._angle = t, !this.isZero()) {
          var e = this.getLength();
          this._set(
            Math.cos(t) * e,
            Math.sin(t) * e
          );
        }
      },
      getQuadrant: function() {
        return this.x >= 0 ? this.y >= 0 ? 1 : 4 : this.y >= 0 ? 2 : 3;
      }
    }, {
      beans: !1,
      getDirectedAngle: function() {
        var t = E.read(arguments);
        return Math.atan2(this.cross(t), this.dot(t)) * 180 / Math.PI;
      },
      getDistance: function() {
        var t = arguments, e = E.read(t), i = e.x - this.x, n = e.y - this.y, r = i * i + n * n, s = T.read(t);
        return s ? r : Math.sqrt(r);
      },
      normalize: function(t) {
        t === F && (t = 1);
        var e = this.getLength(), i = e !== 0 ? t / e : 0, n = new E(this.x * i, this.y * i);
        return i >= 0 && (n._angle = this._angle), n;
      },
      rotate: function(t, e) {
        if (t === 0)
          return this.clone();
        t = t * Math.PI / 180;
        var i = e ? this.subtract(e) : this, n = Math.sin(t), r = Math.cos(t);
        return i = new E(
          i.x * r - i.y * n,
          i.x * n + i.y * r
        ), e ? i.add(e) : i;
      },
      transform: function(t) {
        return t ? t._transformPoint(this) : this;
      },
      add: function() {
        var t = E.read(arguments);
        return new E(this.x + t.x, this.y + t.y);
      },
      subtract: function() {
        var t = E.read(arguments);
        return new E(this.x - t.x, this.y - t.y);
      },
      multiply: function() {
        var t = E.read(arguments);
        return new E(this.x * t.x, this.y * t.y);
      },
      divide: function() {
        var t = E.read(arguments);
        return new E(this.x / t.x, this.y / t.y);
      },
      modulo: function() {
        var t = E.read(arguments);
        return new E(this.x % t.x, this.y % t.y);
      },
      negate: function() {
        return new E(-this.x, -this.y);
      },
      isInside: function() {
        return et.read(arguments).contains(this);
      },
      isClose: function() {
        var t = arguments, e = E.read(t), i = T.read(t);
        return this.getDistance(e) <= i;
      },
      isCollinear: function() {
        var t = E.read(arguments);
        return E.isCollinear(this.x, this.y, t.x, t.y);
      },
      isColinear: "#isCollinear",
      isOrthogonal: function() {
        var t = E.read(arguments);
        return E.isOrthogonal(this.x, this.y, t.x, t.y);
      },
      isZero: function() {
        var t = lt.isZero;
        return t(this.x) && t(this.y);
      },
      isNaN: function() {
        return isNaN(this.x) || isNaN(this.y);
      },
      isInQuadrant: function(t) {
        return this.x * (t > 1 && t < 4 ? -1 : 1) >= 0 && this.y * (t > 2 ? -1 : 1) >= 0;
      },
      dot: function() {
        var t = E.read(arguments);
        return this.x * t.x + this.y * t.y;
      },
      cross: function() {
        var t = E.read(arguments);
        return this.x * t.y - this.y * t.x;
      },
      project: function() {
        var t = E.read(arguments), e = t.isZero() ? 0 : this.dot(t) / t.dot(t);
        return new E(
          t.x * e,
          t.y * e
        );
      },
      statics: {
        min: function() {
          var t = arguments, e = E.read(t), i = E.read(t);
          return new E(
            Math.min(e.x, i.x),
            Math.min(e.y, i.y)
          );
        },
        max: function() {
          var t = arguments, e = E.read(t), i = E.read(t);
          return new E(
            Math.max(e.x, i.x),
            Math.max(e.y, i.y)
          );
        },
        random: function() {
          return new E(Math.random(), Math.random());
        },
        isCollinear: function(t, e, i, n) {
          return Math.abs(t * n - e * i) <= Math.sqrt((t * t + e * e) * (i * i + n * n)) * 1e-8;
        },
        isOrthogonal: function(t, e, i, n) {
          return Math.abs(t * i + e * n) <= Math.sqrt((t * t + e * e) * (i * i + n * n)) * 1e-8;
        }
      }
    }, T.each(["round", "ceil", "floor", "abs"], function(t) {
      var e = Math[t];
      this[t] = function() {
        return new E(e(this.x), e(this.y));
      };
    }, {})), Zt = E.extend({
      initialize: function(e, i, n, r) {
        this._x = e, this._y = i, this._owner = n, this._setter = r;
      },
      _set: function(t, e, i) {
        return this._x = t, this._y = e, i || this._owner[this._setter](this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(t) {
        this._x = t, this._owner[this._setter](this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(t) {
        this._y = t, this._owner[this._setter](this);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(t) {
        this._owner._changeSelection(this._getSelection(), t);
      },
      _getSelection: function() {
        return this._setter === "setPosition" ? 4 : 0;
      }
    }), W = T.extend({
      _class: "Size",
      _readIndex: !0,
      initialize: function(e, i) {
        var n = typeof e, r = this.__read, s = 0;
        if (n === "number") {
          var u = typeof i == "number";
          this._set(e, u ? i : e), r && (s = u ? 2 : 1);
        } else if (n === "undefined" || e === null)
          this._set(0, 0), r && (s = e === null ? 1 : 0);
        else {
          var a = n === "string" ? e.split(/[\s,]+/) || [] : e;
          s = 1, Array.isArray(a) ? this._set(+a[0], +(a.length > 1 ? a[1] : a[0])) : "width" in a ? this._set(a.width || 0, a.height || 0) : "x" in a ? this._set(a.x || 0, a.y || 0) : (this._set(0, 0), s = 0);
        }
        return r && (this.__read = s), this;
      },
      set: "#initialize",
      _set: function(t, e) {
        return this.width = t, this.height = e, this;
      },
      equals: function(t) {
        return t === this || t && (this.width === t.width && this.height === t.height || Array.isArray(t) && this.width === t[0] && this.height === t[1]) || !1;
      },
      clone: function() {
        return new W(this.width, this.height);
      },
      toString: function() {
        var t = St.instance;
        return "{ width: " + t.number(this.width) + ", height: " + t.number(this.height) + " }";
      },
      _serialize: function(t) {
        var e = t.formatter;
        return [
          e.number(this.width),
          e.number(this.height)
        ];
      },
      add: function() {
        var t = W.read(arguments);
        return new W(this.width + t.width, this.height + t.height);
      },
      subtract: function() {
        var t = W.read(arguments);
        return new W(this.width - t.width, this.height - t.height);
      },
      multiply: function() {
        var t = W.read(arguments);
        return new W(this.width * t.width, this.height * t.height);
      },
      divide: function() {
        var t = W.read(arguments);
        return new W(this.width / t.width, this.height / t.height);
      },
      modulo: function() {
        var t = W.read(arguments);
        return new W(this.width % t.width, this.height % t.height);
      },
      negate: function() {
        return new W(-this.width, -this.height);
      },
      isZero: function() {
        var t = lt.isZero;
        return t(this.width) && t(this.height);
      },
      isNaN: function() {
        return isNaN(this.width) || isNaN(this.height);
      },
      statics: {
        min: function(t, e) {
          return new W(
            Math.min(t.width, e.width),
            Math.min(t.height, e.height)
          );
        },
        max: function(t, e) {
          return new W(
            Math.max(t.width, e.width),
            Math.max(t.height, e.height)
          );
        },
        random: function() {
          return new W(Math.random(), Math.random());
        }
      }
    }, T.each(["round", "ceil", "floor", "abs"], function(t) {
      var e = Math[t];
      this[t] = function() {
        return new W(e(this.width), e(this.height));
      };
    }, {})), Wt = W.extend({
      initialize: function(e, i, n, r) {
        this._width = e, this._height = i, this._owner = n, this._setter = r;
      },
      _set: function(t, e, i) {
        return this._width = t, this._height = e, i || this._owner[this._setter](this), this;
      },
      getWidth: function() {
        return this._width;
      },
      setWidth: function(t) {
        this._width = t, this._owner[this._setter](this);
      },
      getHeight: function() {
        return this._height;
      },
      setHeight: function(t) {
        this._height = t, this._owner[this._setter](this);
      }
    }), et = T.extend({
      _class: "Rectangle",
      _readIndex: !0,
      beans: !0,
      initialize: function(e, i, n, r) {
        var s = arguments, u = typeof e, a;
        if (u === "number" ? (this._set(e, i, n, r), a = 4) : u === "undefined" || e === null ? (this._set(0, 0, 0, 0), a = e === null ? 1 : 0) : s.length === 1 && (Array.isArray(e) ? (this._set.apply(this, e), a = 1) : e.x !== F || e.width !== F ? (this._set(
          e.x || 0,
          e.y || 0,
          e.width || 0,
          e.height || 0
        ), a = 1) : e.from === F && e.to === F && (this._set(0, 0, 0, 0), T.readSupported(s, this) && (a = 1))), a === F) {
          var o = E.readNamed(s, "from"), h = T.peek(s), d = o.x, g = o.y, c, f;
          if (h && h.x !== F || T.hasNamed(s, "to")) {
            var b = E.readNamed(s, "to");
            c = b.x - d, f = b.y - g, c < 0 && (d = b.x, c = -c), f < 0 && (g = b.y, f = -f);
          } else {
            var v = W.read(s);
            c = v.width, f = v.height;
          }
          this._set(d, g, c, f), a = s.__index;
        }
        var x = s.__filtered;
        return x && (this.__filtered = x), this.__read && (this.__read = a), this;
      },
      set: "#initialize",
      _set: function(t, e, i, n) {
        return this.x = t, this.y = e, this.width = i, this.height = n, this;
      },
      clone: function() {
        return new et(this.x, this.y, this.width, this.height);
      },
      equals: function(t) {
        var e = T.isPlainValue(t) ? et.read(arguments) : t;
        return e === this || e && this.x === e.x && this.y === e.y && this.width === e.width && this.height === e.height || !1;
      },
      toString: function() {
        var t = St.instance;
        return "{ x: " + t.number(this.x) + ", y: " + t.number(this.y) + ", width: " + t.number(this.width) + ", height: " + t.number(this.height) + " }";
      },
      _serialize: function(t) {
        var e = t.formatter;
        return [
          e.number(this.x),
          e.number(this.y),
          e.number(this.width),
          e.number(this.height)
        ];
      },
      getPoint: function(t) {
        var e = t ? E : Zt;
        return new e(this.x, this.y, this, "setPoint");
      },
      setPoint: function() {
        var t = E.read(arguments);
        this.x = t.x, this.y = t.y;
      },
      getSize: function(t) {
        var e = t ? W : Wt;
        return new e(this.width, this.height, this, "setSize");
      },
      _fw: 1,
      _fh: 1,
      setSize: function() {
        var t = W.read(arguments), e = this._sx, i = this._sy, n = t.width, r = t.height;
        e && (this.x += (this.width - n) * e), i && (this.y += (this.height - r) * i), this.width = n, this.height = r, this._fw = this._fh = 1;
      },
      getLeft: function() {
        return this.x;
      },
      setLeft: function(t) {
        if (!this._fw) {
          var e = t - this.x;
          this.width -= this._sx === 0.5 ? e * 2 : e;
        }
        this.x = t, this._sx = this._fw = 0;
      },
      getTop: function() {
        return this.y;
      },
      setTop: function(t) {
        if (!this._fh) {
          var e = t - this.y;
          this.height -= this._sy === 0.5 ? e * 2 : e;
        }
        this.y = t, this._sy = this._fh = 0;
      },
      getRight: function() {
        return this.x + this.width;
      },
      setRight: function(t) {
        if (!this._fw) {
          var e = t - this.x;
          this.width = this._sx === 0.5 ? e * 2 : e;
        }
        this.x = t - this.width, this._sx = 1, this._fw = 0;
      },
      getBottom: function() {
        return this.y + this.height;
      },
      setBottom: function(t) {
        if (!this._fh) {
          var e = t - this.y;
          this.height = this._sy === 0.5 ? e * 2 : e;
        }
        this.y = t - this.height, this._sy = 1, this._fh = 0;
      },
      getCenterX: function() {
        return this.x + this.width / 2;
      },
      setCenterX: function(t) {
        this._fw || this._sx === 0.5 ? this.x = t - this.width / 2 : (this._sx && (this.x += (t - this.x) * 2 * this._sx), this.width = (t - this.x) * 2), this._sx = 0.5, this._fw = 0;
      },
      getCenterY: function() {
        return this.y + this.height / 2;
      },
      setCenterY: function(t) {
        this._fh || this._sy === 0.5 ? this.y = t - this.height / 2 : (this._sy && (this.y += (t - this.y) * 2 * this._sy), this.height = (t - this.y) * 2), this._sy = 0.5, this._fh = 0;
      },
      getCenter: function(t) {
        var e = t ? E : Zt;
        return new e(this.getCenterX(), this.getCenterY(), this, "setCenter");
      },
      setCenter: function() {
        var t = E.read(arguments);
        return this.setCenterX(t.x), this.setCenterY(t.y), this;
      },
      getArea: function() {
        return this.width * this.height;
      },
      isEmpty: function() {
        return this.width === 0 || this.height === 0;
      },
      contains: function(t) {
        return t && t.width !== F || (Array.isArray(t) ? t : arguments).length === 4 ? this._containsRectangle(et.read(arguments)) : this._containsPoint(E.read(arguments));
      },
      _containsPoint: function(t) {
        var e = t.x, i = t.y;
        return e >= this.x && i >= this.y && e <= this.x + this.width && i <= this.y + this.height;
      },
      _containsRectangle: function(t) {
        var e = t.x, i = t.y;
        return e >= this.x && i >= this.y && e + t.width <= this.x + this.width && i + t.height <= this.y + this.height;
      },
      intersects: function() {
        var t = et.read(arguments), e = T.read(arguments) || 0;
        return t.x + t.width > this.x - e && t.y + t.height > this.y - e && t.x < this.x + this.width + e && t.y < this.y + this.height + e;
      },
      intersect: function() {
        var t = et.read(arguments), e = Math.max(this.x, t.x), i = Math.max(this.y, t.y), n = Math.min(this.x + this.width, t.x + t.width), r = Math.min(this.y + this.height, t.y + t.height);
        return new et(e, i, n - e, r - i);
      },
      unite: function() {
        var t = et.read(arguments), e = Math.min(this.x, t.x), i = Math.min(this.y, t.y), n = Math.max(this.x + this.width, t.x + t.width), r = Math.max(this.y + this.height, t.y + t.height);
        return new et(e, i, n - e, r - i);
      },
      include: function() {
        var t = E.read(arguments), e = Math.min(this.x, t.x), i = Math.min(this.y, t.y), n = Math.max(this.x + this.width, t.x), r = Math.max(this.y + this.height, t.y);
        return new et(e, i, n - e, r - i);
      },
      expand: function() {
        var t = W.read(arguments), e = t.width, i = t.height;
        return new et(
          this.x - e / 2,
          this.y - i / 2,
          this.width + e,
          this.height + i
        );
      },
      scale: function(t, e) {
        return this.expand(
          this.width * t - this.width,
          this.height * (e === F ? t : e) - this.height
        );
      }
    }, T.each(
      [
        ["Top", "Left"],
        ["Top", "Right"],
        ["Bottom", "Left"],
        ["Bottom", "Right"],
        ["Left", "Center"],
        ["Top", "Center"],
        ["Right", "Center"],
        ["Bottom", "Center"]
      ],
      function(t, e) {
        var i = t.join(""), n = /^[RL]/.test(i);
        e >= 4 && (t[1] += n ? "Y" : "X");
        var r = t[n ? 0 : 1], s = t[n ? 1 : 0], u = "get" + r, a = "get" + s, o = "set" + r, h = "set" + s, d = "get" + i, g = "set" + i;
        this[d] = function(c) {
          var f = c ? E : Zt;
          return new f(this[u](), this[a](), this, g);
        }, this[g] = function() {
          var c = E.read(arguments);
          this[o](c.x), this[h](c.y);
        };
      },
      {
        beans: !0
      }
    )), Ue = et.extend(
      {
        initialize: function(e, i, n, r, s, u) {
          this._set(e, i, n, r, !0), this._owner = s, this._setter = u;
        },
        _set: function(t, e, i, n, r) {
          return this._x = t, this._y = e, this._width = i, this._height = n, r || this._owner[this._setter](this), this;
        }
      },
      new function() {
        var t = et.prototype;
        return T.each(
          ["x", "y", "width", "height"],
          function(e) {
            var i = T.capitalize(e), n = "_" + e;
            this["get" + i] = function() {
              return this[n];
            }, this["set" + i] = function(r) {
              this[n] = r, this._dontNotify || this._owner[this._setter](this);
            };
          },
          T.each(
            [
              "Point",
              "Size",
              "Center",
              "Left",
              "Top",
              "Right",
              "Bottom",
              "CenterX",
              "CenterY",
              "TopLeft",
              "TopRight",
              "BottomLeft",
              "BottomRight",
              "LeftCenter",
              "TopCenter",
              "RightCenter",
              "BottomCenter"
            ],
            function(e) {
              var i = "set" + e;
              this[i] = function() {
                this._dontNotify = !0, t[i].apply(this, arguments), this._dontNotify = !1, this._owner[this._setter](this);
              };
            },
            {
              isSelected: function() {
                return !!(this._owner._selection & 2);
              },
              setSelected: function(e) {
                var i = this._owner;
                i._changeSelection && i._changeSelection(2, e);
              }
            }
          )
        );
      }()
    ), wt = T.extend({
      _class: "Matrix",
      initialize: function t(e, i) {
        var n = arguments, r = n.length, s = !0;
        if (r >= 6 ? this._set.apply(this, n) : r === 1 || r === 2 ? e instanceof t ? this._set(
          e._a,
          e._b,
          e._c,
          e._d,
          e._tx,
          e._ty,
          i
        ) : Array.isArray(e) ? this._set.apply(
          this,
          i ? e.concat([i]) : e
        ) : s = !1 : r ? s = !1 : this.reset(), !s)
          throw new Error("Unsupported matrix parameters");
        return this;
      },
      set: "#initialize",
      _set: function(t, e, i, n, r, s, u) {
        return this._a = t, this._b = e, this._c = i, this._d = n, this._tx = r, this._ty = s, u || this._changed(), this;
      },
      _serialize: function(t, e) {
        return T.serialize(this.getValues(), t, !0, e);
      },
      _changed: function() {
        var t = this._owner;
        t && (t._applyMatrix ? t.transform(null, !0) : t._changed(25));
      },
      clone: function() {
        return new wt(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      },
      equals: function(t) {
        return t === this || t && this._a === t._a && this._b === t._b && this._c === t._c && this._d === t._d && this._tx === t._tx && this._ty === t._ty;
      },
      toString: function() {
        var t = St.instance;
        return "[[" + [
          t.number(this._a),
          t.number(this._c),
          t.number(this._tx)
        ].join(", ") + "], [" + [
          t.number(this._b),
          t.number(this._d),
          t.number(this._ty)
        ].join(", ") + "]]";
      },
      reset: function(t) {
        return this._a = this._d = 1, this._b = this._c = this._tx = this._ty = 0, t || this._changed(), this;
      },
      apply: function(t, e) {
        var i = this._owner;
        return i ? (i.transform(null, T.pick(t, !0), e), this.isIdentity()) : !1;
      },
      translate: function() {
        var t = E.read(arguments), e = t.x, i = t.y;
        return this._tx += e * this._a + i * this._c, this._ty += e * this._b + i * this._d, this._changed(), this;
      },
      scale: function() {
        var t = arguments, e = E.read(t), i = E.read(t, 0, { readNull: !0 });
        return i && this.translate(i), this._a *= e.x, this._b *= e.x, this._c *= e.y, this._d *= e.y, i && this.translate(i.negate()), this._changed(), this;
      },
      rotate: function(t) {
        t *= Math.PI / 180;
        var e = E.read(arguments, 1), i = e.x, n = e.y, r = Math.cos(t), s = Math.sin(t), u = i - i * r + n * s, a = n - i * s - n * r, o = this._a, h = this._b, d = this._c, g = this._d;
        return this._a = r * o + s * d, this._b = r * h + s * g, this._c = -s * o + r * d, this._d = -s * h + r * g, this._tx += u * o + a * d, this._ty += u * h + a * g, this._changed(), this;
      },
      shear: function() {
        var t = arguments, e = E.read(t), i = E.read(t, 0, { readNull: !0 });
        i && this.translate(i);
        var n = this._a, r = this._b;
        return this._a += e.y * this._c, this._b += e.y * this._d, this._c += e.x * n, this._d += e.x * r, i && this.translate(i.negate()), this._changed(), this;
      },
      skew: function() {
        var t = arguments, e = E.read(t), i = E.read(t, 0, { readNull: !0 }), n = Math.PI / 180, r = new E(
          Math.tan(e.x * n),
          Math.tan(e.y * n)
        );
        return this.shear(r, i);
      },
      append: function(t, e) {
        if (t) {
          var i = this._a, n = this._b, r = this._c, s = this._d, u = t._a, a = t._c, o = t._b, h = t._d, d = t._tx, g = t._ty;
          this._a = u * i + o * r, this._c = a * i + h * r, this._b = u * n + o * s, this._d = a * n + h * s, this._tx += d * i + g * r, this._ty += d * n + g * s, e || this._changed();
        }
        return this;
      },
      prepend: function(t, e) {
        if (t) {
          var i = this._a, n = this._b, r = this._c, s = this._d, u = this._tx, a = this._ty, o = t._a, h = t._c, d = t._b, g = t._d, c = t._tx, f = t._ty;
          this._a = o * i + h * n, this._c = o * r + h * s, this._b = d * i + g * n, this._d = d * r + g * s, this._tx = o * u + h * a + c, this._ty = d * u + g * a + f, e || this._changed();
        }
        return this;
      },
      appended: function(t) {
        return this.clone().append(t);
      },
      prepended: function(t) {
        return this.clone().prepend(t);
      },
      invert: function() {
        var t = this._a, e = this._b, i = this._c, n = this._d, r = this._tx, s = this._ty, u = t * n - e * i, a = null;
        return u && !isNaN(u) && isFinite(r) && isFinite(s) && (this._a = n / u, this._b = -e / u, this._c = -i / u, this._d = t / u, this._tx = (i * s - n * r) / u, this._ty = (e * r - t * s) / u, a = this), a;
      },
      inverted: function() {
        return this.clone().invert();
      },
      concatenate: "#append",
      preConcatenate: "#prepend",
      chain: "#appended",
      _shiftless: function() {
        return new wt(this._a, this._b, this._c, this._d, 0, 0);
      },
      _orNullIfIdentity: function() {
        return this.isIdentity() ? null : this;
      },
      isIdentity: function() {
        return this._a === 1 && this._b === 0 && this._c === 0 && this._d === 1 && this._tx === 0 && this._ty === 0;
      },
      isInvertible: function() {
        var t = this._a * this._d - this._c * this._b;
        return t && !isNaN(t) && isFinite(this._tx) && isFinite(this._ty);
      },
      isSingular: function() {
        return !this.isInvertible();
      },
      transform: function(t, e, i) {
        return arguments.length < 3 ? this._transformPoint(E.read(arguments)) : this._transformCoordinates(t, e, i);
      },
      _transformPoint: function(t, e, i) {
        var n = t.x, r = t.y;
        return e || (e = new E()), e._set(
          n * this._a + r * this._c + this._tx,
          n * this._b + r * this._d + this._ty,
          i
        );
      },
      _transformCoordinates: function(t, e, i) {
        for (var n = 0, r = 2 * i; n < r; n += 2) {
          var s = t[n], u = t[n + 1];
          e[n] = s * this._a + u * this._c + this._tx, e[n + 1] = s * this._b + u * this._d + this._ty;
        }
        return e;
      },
      _transformCorners: function(t) {
        var e = t.x, i = t.y, n = e + t.width, r = i + t.height, s = [e, i, n, i, n, r, e, r];
        return this._transformCoordinates(s, s, 4);
      },
      _transformBounds: function(t, e, i) {
        for (var n = this._transformCorners(t), r = n.slice(0, 2), s = r.slice(), u = 2; u < 8; u++) {
          var a = n[u], o = u & 1;
          a < r[o] ? r[o] = a : a > s[o] && (s[o] = a);
        }
        return e || (e = new et()), e._set(
          r[0],
          r[1],
          s[0] - r[0],
          s[1] - r[1],
          i
        );
      },
      inverseTransform: function() {
        return this._inverseTransform(E.read(arguments));
      },
      _inverseTransform: function(t, e, i) {
        var n = this._a, r = this._b, s = this._c, u = this._d, a = this._tx, o = this._ty, h = n * u - r * s, d = null;
        if (h && !isNaN(h) && isFinite(a) && isFinite(o)) {
          var g = t.x - this._tx, c = t.y - this._ty;
          e || (e = new E()), d = e._set(
            (g * u - c * s) / h,
            (c * n - g * r) / h,
            i
          );
        }
        return d;
      },
      decompose: function() {
        var t = this._a, e = this._b, i = this._c, n = this._d, r = t * n - e * i, s = Math.sqrt, u = Math.atan2, a = 180 / Math.PI, o, h, d;
        if (t !== 0 || e !== 0) {
          var g = s(t * t + e * e);
          o = Math.acos(t / g) * (e > 0 ? 1 : -1), h = [g, r / g], d = [u(t * i + e * n, g * g), 0];
        } else if (i !== 0 || n !== 0) {
          var c = s(i * i + n * n);
          o = Math.asin(i / c) * (n > 0 ? 1 : -1), h = [r / c, c], d = [0, u(t * i + e * n, c * c)];
        } else
          o = 0, d = h = [0, 0];
        return {
          translation: this.getTranslation(),
          rotation: o * a,
          scaling: new E(h),
          skewing: new E(d[0] * a, d[1] * a)
        };
      },
      getValues: function() {
        return [this._a, this._b, this._c, this._d, this._tx, this._ty];
      },
      getTranslation: function() {
        return new E(this._tx, this._ty);
      },
      getScaling: function() {
        return this.decompose().scaling;
      },
      getRotation: function() {
        return this.decompose().rotation;
      },
      applyToContext: function(t) {
        this.isIdentity() || t.transform(
          this._a,
          this._b,
          this._c,
          this._d,
          this._tx,
          this._ty
        );
      }
    }, T.each(["a", "b", "c", "d", "tx", "ty"], function(t) {
      var e = T.capitalize(t), i = "_" + t;
      this["get" + e] = function() {
        return this[i];
      }, this["set" + e] = function(n) {
        this[i] = n, this._changed();
      };
    }, {})), Et = T.extend({
      _class: "Line",
      initialize: function(e, i, n, r, s) {
        var u = !1;
        arguments.length >= 4 ? (this._px = e, this._py = i, this._vx = n, this._vy = r, u = s) : (this._px = e.x, this._py = e.y, this._vx = i.x, this._vy = i.y, u = n), u || (this._vx -= this._px, this._vy -= this._py);
      },
      getPoint: function() {
        return new E(this._px, this._py);
      },
      getVector: function() {
        return new E(this._vx, this._vy);
      },
      getLength: function() {
        return this.getVector().getLength();
      },
      intersect: function(t, e) {
        return Et.intersect(
          this._px,
          this._py,
          this._vx,
          this._vy,
          t._px,
          t._py,
          t._vx,
          t._vy,
          !0,
          e
        );
      },
      getSide: function(t, e) {
        return Et.getSide(
          this._px,
          this._py,
          this._vx,
          this._vy,
          t.x,
          t.y,
          !0,
          e
        );
      },
      getDistance: function(t) {
        return Math.abs(this.getSignedDistance(t));
      },
      getSignedDistance: function(t) {
        return Et.getSignedDistance(
          this._px,
          this._py,
          this._vx,
          this._vy,
          t.x,
          t.y,
          !0
        );
      },
      isCollinear: function(t) {
        return E.isCollinear(this._vx, this._vy, t._vx, t._vy);
      },
      isOrthogonal: function(t) {
        return E.isOrthogonal(this._vx, this._vy, t._vx, t._vy);
      },
      statics: {
        intersect: function(t, e, i, n, r, s, u, a, o, h) {
          o || (i -= t, n -= e, u -= r, a -= s);
          var d = i * a - n * u;
          if (!lt.isMachineZero(d)) {
            var g = t - r, c = e - s, f = (u * c - a * g) / d, b = (i * c - n * g) / d, v = 1e-12, x = -v, _ = 1 + v;
            if (h || x < f && f < _ && x < b && b < _)
              return h || (f = f <= 0 ? 0 : f >= 1 ? 1 : f), new E(
                t + f * i,
                e + f * n
              );
          }
        },
        getSide: function(t, e, i, n, r, s, u, a) {
          u || (i -= t, n -= e);
          var o = r - t, h = s - e, d = o * n - h * i;
          return !a && lt.isMachineZero(d) && (d = (o * i + o * i) / (i * i + n * n), d >= 0 && d <= 1 && (d = 0)), d < 0 ? -1 : d > 0 ? 1 : 0;
        },
        getSignedDistance: function(t, e, i, n, r, s, u) {
          return u || (i -= t, n -= e), i === 0 ? n > 0 ? r - t : t - r : n === 0 ? i < 0 ? s - e : e - s : ((r - t) * n - (s - e) * i) / (n > i ? n * Math.sqrt(1 + i * i / (n * n)) : i * Math.sqrt(1 + n * n / (i * i)));
        },
        getDistance: function(t, e, i, n, r, s, u) {
          return Math.abs(
            Et.getSignedDistance(t, e, i, n, r, s, u)
          );
        }
      }
    }), Te = Ct.extend({
      _class: "Project",
      _list: "projects",
      _reference: "project",
      _compactSerialize: !0,
      initialize: function(e) {
        Ct.call(this, !0), this._children = [], this._namedChildren = {}, this._activeLayer = null, this._currentStyle = new ri(null, null, this), this._view = Tt.create(
          this,
          e || Dt.getCanvas(1, 1)
        ), this._selectionItems = {}, this._selectionCount = 0, this._updateVersion = 0;
      },
      _serialize: function(t, e) {
        return T.serialize(this._children, t, !0, e);
      },
      _changed: function(t, e) {
        if (t & 1) {
          var i = this._view;
          i && (i._needsUpdate = !0, !i._requested && i._autoUpdate && i.requestUpdate());
        }
        var n = this._changes;
        if (n && e) {
          var r = this._changesById, s = e._id, u = r[s];
          u ? u.flags |= t : n.push(r[s] = { item: e, flags: t });
        }
      },
      clear: function() {
        for (var t = this._children, e = t.length - 1; e >= 0; e--)
          t[e].remove();
      },
      isEmpty: function() {
        return !this._children.length;
      },
      remove: function t() {
        return t.base.call(this) ? (this._view && this._view.remove(), !0) : !1;
      },
      getView: function() {
        return this._view;
      },
      getCurrentStyle: function() {
        return this._currentStyle;
      },
      setCurrentStyle: function(t) {
        this._currentStyle.set(t);
      },
      getIndex: function() {
        return this._index;
      },
      getOptions: function() {
        return this._scope.settings;
      },
      getLayers: function() {
        return this._children;
      },
      getActiveLayer: function() {
        return this._activeLayer || new Kt({ project: this, insert: !0 });
      },
      getSymbolDefinitions: function() {
        var t = [], e = {};
        return this.getItems({
          class: ve,
          match: function(i) {
            var n = i._definition, r = n._id;
            return e[r] || (e[r] = !0, t.push(n)), !1;
          }
        }), t;
      },
      getSymbols: "getSymbolDefinitions",
      getSelectedItems: function() {
        var t = this._selectionItems, e = [];
        for (var i in t) {
          var n = t[i], r = n._selection;
          r & 1 && n.isInserted() ? e.push(n) : r || this._updateSelection(n);
        }
        return e;
      },
      _updateSelection: function(t) {
        var e = t._id, i = this._selectionItems;
        t._selection ? i[e] !== t && (this._selectionCount++, i[e] = t) : i[e] === t && (this._selectionCount--, delete i[e]);
      },
      selectAll: function() {
        for (var t = this._children, e = 0, i = t.length; e < i; e++)
          t[e].setFullySelected(!0);
      },
      deselectAll: function() {
        var t = this._selectionItems;
        for (var e in t)
          t[e].setFullySelected(!1);
      },
      addLayer: function(t) {
        return this.insertLayer(F, t);
      },
      insertLayer: function(t, e) {
        if (e instanceof Kt) {
          e._remove(!1, !0), T.splice(this._children, [e], t, 0), e._setProject(this, !0);
          var i = e._name;
          i && e.setName(i), this._changes && e._changed(5), this._activeLayer || (this._activeLayer = e);
        } else
          e = null;
        return e;
      },
      _insertItem: function(t, e, i) {
        return e = this.insertLayer(t, e) || (this._activeLayer || this._insertItem(
          F,
          new Kt(ft.NO_INSERT),
          !0
        )).insertChild(t, e), i && e.activate && e.activate(), e;
      },
      getItems: function(t) {
        return ft._getItems(this, t);
      },
      getItem: function(t) {
        return ft._getItems(this, t, null, null, !0)[0] || null;
      },
      importJSON: function(t) {
        this.activate();
        var e = this._activeLayer;
        return T.importJSON(t, e && e.isEmpty() && e);
      },
      removeOn: function(t) {
        var e = this._removeSets;
        if (e) {
          t === "mouseup" && (e.mousedrag = null);
          var i = e[t];
          if (i) {
            for (var n in i) {
              var r = i[n];
              for (var s in e) {
                var u = e[s];
                u && u != i && delete u[r._id];
              }
              r.remove();
            }
            e[t] = null;
          }
        }
      },
      draw: function(t, e, i) {
        this._updateVersion++, t.save(), e.applyToContext(t);
        for (var n = this._children, r = new T({
          offset: new E(0, 0),
          pixelRatio: i,
          viewMatrix: e.isIdentity() ? null : e,
          matrices: [new wt()],
          updateMatrix: !0
        }), s = 0, u = n.length; s < u; s++)
          n[s].draw(t, r);
        if (t.restore(), this._selectionCount > 0) {
          t.save(), t.strokeWidth = 1;
          var a = this._selectionItems, o = this._scope.settings.handleSize, h = this._updateVersion;
          for (var d in a)
            a[d]._drawSelection(t, e, o, a, h);
          t.restore();
        }
      }
    }), ft = T.extend(
      vt,
      {
        statics: {
          extend: function t(e) {
            return e._serializeFields && (e._serializeFields = T.set(
              {},
              this.prototype._serializeFields,
              e._serializeFields
            )), t.base.apply(this, arguments);
          },
          INSERT: { insert: !0 },
          NO_INSERT: { insert: !1 }
        },
        _class: "Item",
        _name: null,
        _applyMatrix: !0,
        _canApplyMatrix: !0,
        _canScaleStroke: !1,
        _pivot: null,
        _visible: !0,
        _blendMode: "normal",
        _opacity: 1,
        _locked: !1,
        _guide: !1,
        _clipMask: !1,
        _selection: 0,
        _selectBounds: !0,
        _selectChildren: !1,
        _serializeFields: {
          name: null,
          applyMatrix: null,
          matrix: new wt(),
          pivot: null,
          visible: !0,
          blendMode: "normal",
          opacity: 1,
          locked: !1,
          guide: !1,
          clipMask: !1,
          selected: !1,
          data: {}
        },
        _prioritize: ["applyMatrix"]
      },
      new function() {
        var t = [
          "onMouseDown",
          "onMouseUp",
          "onMouseDrag",
          "onClick",
          "onDoubleClick",
          "onMouseMove",
          "onMouseEnter",
          "onMouseLeave"
        ];
        return T.each(
          t,
          function(e) {
            this._events[e] = {
              install: function(i) {
                this.getView()._countItemEvent(i, 1);
              },
              uninstall: function(i) {
                this.getView()._countItemEvent(i, -1);
              }
            };
          },
          {
            _events: {
              onFrame: {
                install: function() {
                  this.getView()._animateItem(this, !0);
                },
                uninstall: function() {
                  this.getView()._animateItem(this, !1);
                }
              },
              onLoad: {},
              onError: {}
            },
            statics: {
              _itemHandlers: t
            }
          }
        );
      }(),
      {
        initialize: function() {
        },
        _initialize: function(t, e) {
          var i = t && T.isPlainObject(t), n = i && t.internal === !0, r = this._matrix = new wt(), s = i && t.project || _t.project, u = _t.settings;
          return this._id = n ? null : xt.get(), this._parent = this._index = null, this._applyMatrix = this._canApplyMatrix && u.applyMatrix, e && r.translate(e), r._owner = this, this._style = new ri(s._currentStyle, this, s), n || i && t.insert == !1 || !u.insertItems && !(i && t.insert == !0) ? this._setProject(s) : (i && t.parent || s)._insertItem(F, this, !0), i && t !== ft.NO_INSERT && t !== ft.INSERT && this.set(t, {
            internal: !0,
            insert: !0,
            project: !0,
            parent: !0
          }), i;
        },
        _serialize: function(t, e) {
          var i = {}, n = this;
          function r(s) {
            for (var u in s) {
              var a = n[u];
              T.equals(a, u === "leading" ? s.fontSize * 1.2 : s[u]) || (i[u] = T.serialize(
                a,
                t,
                u !== "data",
                e
              ));
            }
          }
          return r(this._serializeFields), this instanceof jt || r(this._style._defaults), [this._class, i];
        },
        _changed: function(t) {
          var e = this._symbol, i = this._parent || e, n = this._project;
          t & 8 && (this._bounds = this._position = this._decomposed = F), t & 16 && (this._globalMatrix = F), i && t & 72 && ft._clearBoundsCache(i), t & 2 && ft._clearBoundsCache(this), n && n._changed(t, this), e && e._changed(t);
        },
        getId: function() {
          return this._id;
        },
        getName: function() {
          return this._name;
        },
        setName: function(t) {
          if (this._name && this._removeNamed(), t === +t + "")
            throw new Error(
              "Names consisting only of numbers are not supported."
            );
          var e = this._getOwner();
          if (t && e) {
            var i = e._children, n = e._namedChildren;
            (n[t] = n[t] || []).push(this), t in i || (i[t] = this);
          }
          this._name = t || F, this._changed(256);
        },
        getStyle: function() {
          return this._style;
        },
        setStyle: function(t) {
          this.getStyle().set(t);
        }
      },
      T.each(
        ["locked", "visible", "blendMode", "opacity", "guide"],
        function(t) {
          var e = T.capitalize(t), i = "_" + t, n = {
            locked: 256,
            visible: 265
          };
          this["get" + e] = function() {
            return this[i];
          }, this["set" + e] = function(r) {
            r != this[i] && (this[i] = r, this._changed(n[t] || 257));
          };
        },
        {}
      ),
      {
        beans: !0,
        getSelection: function() {
          return this._selection;
        },
        setSelection: function(t) {
          if (t !== this._selection) {
            this._selection = t;
            var e = this._project;
            e && (e._updateSelection(this), this._changed(257));
          }
        },
        _changeSelection: function(t, e) {
          var i = this._selection;
          this.setSelection(e ? i | t : i & ~t);
        },
        isSelected: function() {
          if (this._selectChildren) {
            for (var t = this._children, e = 0, i = t.length; e < i; e++)
              if (t[e].isSelected())
                return !0;
          }
          return !!(this._selection & 1);
        },
        setSelected: function(t) {
          if (this._selectChildren)
            for (var e = this._children, i = 0, n = e.length; i < n; i++)
              e[i].setSelected(t);
          this._changeSelection(1, t);
        },
        isFullySelected: function() {
          var t = this._children, e = !!(this._selection & 1);
          if (t && e) {
            for (var i = 0, n = t.length; i < n; i++)
              if (!t[i].isFullySelected())
                return !1;
            return !0;
          }
          return e;
        },
        setFullySelected: function(t) {
          var e = this._children;
          if (e)
            for (var i = 0, n = e.length; i < n; i++)
              e[i].setFullySelected(t);
          this._changeSelection(1, t);
        },
        isClipMask: function() {
          return this._clipMask;
        },
        setClipMask: function(t) {
          this._clipMask != (t = !!t) && (this._clipMask = t, t && (this.setFillColor(null), this.setStrokeColor(null)), this._changed(257), this._parent && this._parent._changed(2048));
        },
        getData: function() {
          return this._data || (this._data = {}), this._data;
        },
        setData: function(t) {
          this._data = t;
        },
        getPosition: function(t) {
          var e = t ? E : Zt, i = this._position || (this._position = this._getPositionFromBounds());
          return new e(i.x, i.y, this, "setPosition");
        },
        setPosition: function() {
          this.translate(E.read(arguments).subtract(this.getPosition(!0)));
        },
        _getPositionFromBounds: function(t) {
          return this._pivot ? this._matrix._transformPoint(this._pivot) : (t || this.getBounds()).getCenter(!0);
        },
        getPivot: function() {
          var t = this._pivot;
          return t ? new Zt(t.x, t.y, this, "setPivot") : null;
        },
        setPivot: function() {
          this._pivot = E.read(arguments, 0, { clone: !0, readNull: !0 }), this._position = F;
        }
      },
      T.each(
        {
          getStrokeBounds: { stroke: !0 },
          getHandleBounds: { handle: !0 },
          getInternalBounds: { internal: !0 }
        },
        function(t, e) {
          this[e] = function(i) {
            return this.getBounds(i, t);
          };
        },
        {
          beans: !0,
          getBounds: function(t, e) {
            var i = e || t instanceof wt, n = T.set(
              {},
              i ? e : t,
              this._boundsOptions
            );
            (!n.stroke || this.getStrokeScaling()) && (n.cacheItem = this);
            var r = this._getCachedBounds(i && t, n).rect;
            return arguments.length ? r : new Ue(
              r.x,
              r.y,
              r.width,
              r.height,
              this,
              "setBounds"
            );
          },
          setBounds: function() {
            var t = et.read(arguments), e = this.getBounds(), i = this._matrix, n = new wt(), r = t.getCenter();
            n.translate(r), (t.width != e.width || t.height != e.height) && (i.isInvertible() || (i.set(i._backup || new wt().translate(i.getTranslation())), e = this.getBounds()), n.scale(
              e.width !== 0 ? t.width / e.width : 0,
              e.height !== 0 ? t.height / e.height : 0
            )), r = e.getCenter(), n.translate(-r.x, -r.y), this.transform(n);
          },
          _getBounds: function(t, e) {
            var i = this._children;
            return !i || !i.length ? new et() : (ft._updateBoundsCache(this, e.cacheItem), ft._getBounds(i, t, e));
          },
          _getBoundsCacheKey: function(t, e) {
            return [
              t.stroke ? 1 : 0,
              t.handle ? 1 : 0,
              e ? 1 : 0
            ].join("");
          },
          _getCachedBounds: function(t, e, i) {
            t = t && t._orNullIfIdentity();
            var n = e.internal && !i, r = e.cacheItem, s = n ? null : this._matrix._orNullIfIdentity(), u = r && (!t || t.equals(s)) && this._getBoundsCacheKey(e, n), a = this._bounds;
            if (ft._updateBoundsCache(this._parent || this._symbol, r), u && a && u in a) {
              var o = a[u];
              return {
                rect: o.rect.clone(),
                nonscaling: o.nonscaling
              };
            }
            var h = this._getBounds(t || s, e), d = h.rect || h, g = this._style, c = h.nonscaling || g.hasStroke() && !g.getStrokeScaling();
            if (u) {
              a || (this._bounds = a = {});
              var o = a[u] = {
                rect: d.clone(),
                nonscaling: c,
                internal: n
              };
            }
            return {
              rect: d,
              nonscaling: c
            };
          },
          _getStrokeMatrix: function(t, e) {
            var i = this.getStrokeScaling() ? null : e && e.internal ? this : this._parent || this._symbol && this._symbol._item, n = i ? i.getViewMatrix().invert() : t;
            return n && n._shiftless();
          },
          statics: {
            _updateBoundsCache: function(t, e) {
              if (t && e) {
                var i = e._id, n = t._boundsCache = t._boundsCache || {
                  ids: {},
                  list: []
                };
                n.ids[i] || (n.list.push(e), n.ids[i] = e);
              }
            },
            _clearBoundsCache: function(t) {
              var e = t._boundsCache;
              if (e) {
                t._bounds = t._position = t._boundsCache = F;
                for (var i = 0, n = e.list, r = n.length; i < r; i++) {
                  var s = n[i];
                  s !== t && (s._bounds = s._position = F, s._boundsCache && ft._clearBoundsCache(s));
                }
              }
            },
            _getBounds: function(t, e, i) {
              var n = 1 / 0, r = -n, s = n, u = r, a = !1;
              i = i || {};
              for (var o = 0, h = t.length; o < h; o++) {
                var d = t[o];
                if (d._visible && !d.isEmpty(!0)) {
                  var g = d._getCachedBounds(
                    e && e.appended(d._matrix),
                    i,
                    !0
                  ), c = g.rect;
                  n = Math.min(c.x, n), s = Math.min(c.y, s), r = Math.max(c.x + c.width, r), u = Math.max(c.y + c.height, u), g.nonscaling && (a = !0);
                }
              }
              return {
                rect: isFinite(n) ? new et(n, s, r - n, u - s) : new et(),
                nonscaling: a
              };
            }
          }
        }
      ),
      {
        beans: !0,
        _decompose: function() {
          return this._applyMatrix ? null : this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        getRotation: function() {
          var t = this._decompose();
          return t ? t.rotation : 0;
        },
        setRotation: function(t) {
          var e = this.getRotation();
          if (e != null && t != null) {
            var i = this._decomposed;
            this.rotate(t - e), i && (i.rotation = t, this._decomposed = i);
          }
        },
        getScaling: function() {
          var t = this._decompose(), e = t && t.scaling;
          return new Zt(e ? e.x : 1, e ? e.y : 1, this, "setScaling");
        },
        setScaling: function() {
          var t = this.getScaling(), e = E.read(arguments, 0, { clone: !0, readNull: !0 });
          if (t && e && !t.equals(e)) {
            var i = this.getRotation(), n = this._decomposed, r = new wt(), s = lt.isZero;
            if (s(t.x) || s(t.y))
              r.translate(n.translation), i && r.rotate(i), r.scale(e.x, e.y), this._matrix.set(r);
            else {
              var u = this.getPosition(!0);
              r.translate(u), i && r.rotate(i), r.scale(e.x / t.x, e.y / t.y), i && r.rotate(-i), r.translate(u.negate()), this.transform(r);
            }
            n && (n.scaling = e, this._decomposed = n);
          }
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var t = this._matrix;
          t.set.apply(t, arguments);
        },
        getGlobalMatrix: function(t) {
          var e = this._globalMatrix;
          if (e)
            for (var i = this._parent, n = []; i; ) {
              if (!i._globalMatrix) {
                e = null;
                for (var r = 0, s = n.length; r < s; r++)
                  n[r]._globalMatrix = null;
                break;
              }
              n.push(i), i = i._parent;
            }
          if (!e) {
            e = this._globalMatrix = this._matrix.clone();
            var i = this._parent;
            i && e.prepend(i.getGlobalMatrix(!0));
          }
          return t ? e : e.clone();
        },
        getViewMatrix: function() {
          return this.getGlobalMatrix().prepend(this.getView()._matrix);
        },
        getApplyMatrix: function() {
          return this._applyMatrix;
        },
        setApplyMatrix: function(t) {
          (this._applyMatrix = this._canApplyMatrix && !!t) && this.transform(null, !0);
        },
        getTransformContent: "#getApplyMatrix",
        setTransformContent: "#setApplyMatrix"
      },
      {
        getProject: function() {
          return this._project;
        },
        _setProject: function(t, e) {
          if (this._project !== t) {
            this._project && this._installEvents(!1), this._project = t;
            for (var i = this._children, n = 0, r = i && i.length; n < r; n++)
              i[n]._setProject(t);
            e = !0;
          }
          e && this._installEvents(!0);
        },
        getView: function() {
          return this._project._view;
        },
        _installEvents: function t(e) {
          t.base.call(this, e);
          for (var i = this._children, n = 0, r = i && i.length; n < r; n++)
            i[n]._installEvents(e);
        },
        getLayer: function() {
          for (var t = this; t = t._parent; )
            if (t instanceof Kt)
              return t;
          return null;
        },
        getParent: function() {
          return this._parent;
        },
        setParent: function(t) {
          return t.addChild(this);
        },
        _getOwner: "#getParent",
        getChildren: function() {
          return this._children;
        },
        setChildren: function(t) {
          this.removeChildren(), this.addChildren(t);
        },
        getFirstChild: function() {
          return this._children && this._children[0] || null;
        },
        getLastChild: function() {
          return this._children && this._children[this._children.length - 1] || null;
        },
        getNextSibling: function() {
          var t = this._getOwner();
          return t && t._children[this._index + 1] || null;
        },
        getPreviousSibling: function() {
          var t = this._getOwner();
          return t && t._children[this._index - 1] || null;
        },
        getIndex: function() {
          return this._index;
        },
        equals: function(t) {
          return t === this || t && this._class === t._class && this._style.equals(t._style) && this._matrix.equals(t._matrix) && this._locked === t._locked && this._visible === t._visible && this._blendMode === t._blendMode && this._opacity === t._opacity && this._clipMask === t._clipMask && this._guide === t._guide && this._equals(t) || !1;
        },
        _equals: function(t) {
          return T.equals(this._children, t._children);
        },
        clone: function(t) {
          var e = new this.constructor(ft.NO_INSERT), i = this._children, n = T.pick(
            t ? t.insert : F,
            t === F || t === !0
          ), r = T.pick(t ? t.deep : F, !0);
          i && e.copyAttributes(this), (!i || r) && e.copyContent(this), i || e.copyAttributes(this), n && e.insertAbove(this);
          var s = this._name, u = this._parent;
          if (s && u) {
            for (var i = u._children, a = s, o = 1; i[s]; )
              s = a + " " + o++;
            s !== a && e.setName(s);
          }
          return e;
        },
        copyContent: function(t) {
          for (var e = t._children, i = 0, n = e && e.length; i < n; i++)
            this.addChild(e[i].clone(!1), !0);
        },
        copyAttributes: function(t, e) {
          this.setStyle(t._style);
          for (var i = [
            "_locked",
            "_visible",
            "_blendMode",
            "_opacity",
            "_clipMask",
            "_guide"
          ], n = 0, r = i.length; n < r; n++) {
            var s = i[n];
            t.hasOwnProperty(s) && (this[s] = t[s]);
          }
          e || this._matrix.set(t._matrix, !0), this.setApplyMatrix(t._applyMatrix), this.setPivot(t._pivot), this.setSelection(t._selection);
          var u = t._data, a = t._name;
          this._data = u ? T.clone(u) : null, a && this.setName(a);
        },
        rasterize: function(t, e) {
          var i, n, r;
          T.isPlainObject(t) ? (i = t.resolution, n = t.insert, r = t.raster) : (i = t, n = e), r || (r = new he(ft.NO_INSERT));
          var s = this.getStrokeBounds(), u = (i || this.getView().getResolution()) / 72, a = s.getTopLeft().floor(), o = s.getBottomRight().ceil(), h = new W(o.subtract(a)), d = h.multiply(u);
          if (r.setSize(d, !0), !d.isZero()) {
            var g = r.getContext(!0), c = new wt().scale(u).translate(a.negate());
            g.save(), c.applyToContext(g), this.draw(g, new T({ matrices: [c] })), g.restore();
          }
          return r._matrix.set(
            new wt().translate(a.add(h.divide(2))).scale(1 / u)
          ), (n === F || n) && r.insertAbove(this), r;
        },
        contains: function() {
          var t = this._matrix;
          return t.isInvertible() && !!this._contains(t._inverseTransform(E.read(arguments)));
        },
        _contains: function(t) {
          var e = this._children;
          if (e) {
            for (var i = e.length - 1; i >= 0; i--)
              if (e[i].contains(t))
                return !0;
            return !1;
          }
          return t.isInside(this.getInternalBounds());
        },
        isInside: function() {
          return et.read(arguments).contains(this.getBounds());
        },
        _asPathItem: function() {
          return new pt.Rectangle({
            rectangle: this.getInternalBounds(),
            matrix: this._matrix,
            insert: !1
          });
        },
        intersects: function(t, e) {
          return t instanceof ft ? this._asPathItem().getIntersections(
            t._asPathItem(),
            null,
            e,
            !0
          ).length > 0 : !1;
        }
      },
      new function() {
        function t() {
          var n = arguments;
          return this._hitTest(
            E.read(n),
            ie.getOptions(n)
          );
        }
        function e() {
          var n = arguments, r = E.read(n), s = ie.getOptions(n), u = [];
          return this._hitTest(r, new T({ all: u }, s)), u;
        }
        function i(n, r, s, u) {
          var a = this._children;
          if (a)
            for (var o = a.length - 1; o >= 0; o--) {
              var h = a[o], d = h !== u && h._hitTest(
                n,
                r,
                s
              );
              if (d && !r.all)
                return d;
            }
          return null;
        }
        return Te.inject({
          hitTest: t,
          hitTestAll: e,
          _hitTest: i
        }), {
          hitTest: t,
          hitTestAll: e,
          _hitTestChildren: i
        };
      }(),
      {
        _hitTest: function(t, e, i) {
          if (this._locked || !this._visible || this._guide && !e.guides || this.isEmpty())
            return null;
          var n = this._matrix, r = i ? i.appended(n) : this.getGlobalMatrix().prepend(this.getView()._matrix), s = Math.max(e.tolerance, 1e-12), u = e._tolerancePadding = new W(
            pt._getStrokePadding(
              s,
              n._shiftless().invert()
            )
          );
          if (t = n._inverseTransform(t), !t || !this._children && !this.getBounds({ internal: !0, stroke: !0, handle: !0 }).expand(u.multiply(2))._containsPoint(t))
            return null;
          var a = !(e.guides && !this._guide || e.selected && !this.isSelected() || e.type && e.type !== T.hyphenate(this._class) || e.class && !(this instanceof e.class)), o = e.match, h = this, d, g;
          function c(l) {
            return l && o && !o(l) && (l = null), l && e.all && e.all.push(l), l;
          }
          function f(l, p) {
            var y = p ? d["get" + p]() : h.getPosition();
            if (t.subtract(y).divide(u).length <= 1)
              return new ie(l, h, {
                name: p ? T.hyphenate(p) : l,
                point: y
              });
          }
          var b = e.position, v = e.center, x = e.bounds;
          if (a && this._parent && (b || v || x)) {
            if ((v || x) && (d = this.getInternalBounds()), g = b && f("position") || v && f("center", "Center"), !g && x)
              for (var _ = [
                "TopLeft",
                "TopRight",
                "BottomLeft",
                "BottomRight",
                "LeftCenter",
                "TopCenter",
                "RightCenter",
                "BottomCenter"
              ], m = 0; m < 8 && !g; m++)
                g = f("bounds", _[m]);
            g = c(g);
          }
          return g || (g = this._hitTestChildren(t, e, r) || a && c(this._hitTestSelf(
            t,
            e,
            r,
            this.getStrokeScaling() ? null : r._shiftless().invert()
          )) || null), g && g.point && (g.point = n.transform(g.point)), g;
        },
        _hitTestSelf: function(t, e) {
          if (e.fill && this.hasFill() && this._contains(t))
            return new ie("fill", this);
        },
        matches: function(t, e) {
          function i(u, a) {
            for (var o in u)
              if (u.hasOwnProperty(o)) {
                var h = u[o], d = a[o];
                if (T.isPlainObject(h) && T.isPlainObject(d)) {
                  if (!i(h, d))
                    return !1;
                } else if (!T.equals(h, d))
                  return !1;
              }
            return !0;
          }
          var n = typeof t;
          if (n === "object") {
            for (var r in t)
              if (t.hasOwnProperty(r) && !this.matches(r, t[r]))
                return !1;
            return !0;
          } else {
            if (n === "function")
              return t(this);
            if (t === "match")
              return e(this);
            var s = /^(empty|editable)$/.test(t) ? this["is" + T.capitalize(t)]() : t === "type" ? T.hyphenate(this._class) : this[t];
            if (t === "class") {
              if (typeof e == "function")
                return this instanceof e;
              s = this._class;
            }
            if (typeof e == "function")
              return !!e(s);
            if (e) {
              if (e.test)
                return e.test(s);
              if (T.isPlainObject(e))
                return i(e, s);
            }
            return T.equals(s, e);
          }
        },
        getItems: function(t) {
          return ft._getItems(this, t, this._matrix);
        },
        getItem: function(t) {
          return ft._getItems(this, t, this._matrix, null, !0)[0] || null;
        },
        statics: {
          _getItems: function t(e, i, n, r, s) {
            if (!r) {
              var u = typeof i == "object" && i, a = u && u.overlapping, o = u && u.inside, h = a || o, c = h && et.read([h]);
              r = {
                items: [],
                recursive: u && u.recursive !== !1,
                inside: !!o,
                overlapping: !!a,
                rect: c,
                path: a && new pt.Rectangle({
                  rectangle: c,
                  insert: !1
                })
              }, u && (i = T.filter({}, i, {
                recursive: !0,
                inside: !0,
                overlapping: !0
              }));
            }
            var d = e._children, g = r.items, c = r.rect;
            n = c && (n || new wt());
            for (var f = 0, b = d && d.length; f < b; f++) {
              var v = d[f], x = n && n.appended(v._matrix), _ = !0;
              if (c) {
                var h = v.getBounds(x);
                if (!c.intersects(h))
                  continue;
                c.contains(h) || r.overlapping && (h.contains(c) || r.path.intersects(v, x)) || (_ = !1);
              }
              if (_ && v.matches(i) && (g.push(v), s) || (r.recursive !== !1 && t(v, i, x, r, s), s && g.length > 0))
                break;
            }
            return g;
          }
        }
      },
      {
        importJSON: function(t) {
          var e = T.importJSON(t, this);
          return e !== this ? this.addChild(e) : e;
        },
        addChild: function(t) {
          return this.insertChild(F, t);
        },
        insertChild: function(t, e) {
          var i = e ? this.insertChildren(t, [e]) : null;
          return i && i[0];
        },
        addChildren: function(t) {
          return this.insertChildren(this._children.length, t);
        },
        insertChildren: function(t, e) {
          var i = this._children;
          if (i && e && e.length > 0) {
            e = T.slice(e);
            for (var n = {}, r = e.length - 1; r >= 0; r--) {
              var s = e[r], u = s && s._id;
              !s || n[u] ? e.splice(r, 1) : (s._remove(!1, !0), n[u] = !0);
            }
            T.splice(i, e, t, 0);
            for (var a = this._project, o = a._changes, r = 0, h = e.length; r < h; r++) {
              var s = e[r], d = s._name;
              s._parent = this, s._setProject(a, !0), d && s.setName(d), o && s._changed(5);
            }
            this._changed(11);
          } else
            e = null;
          return e;
        },
        _insertItem: "#insertChild",
        _insertAt: function(t, e) {
          var i = t && t._getOwner(), n = t !== this && i ? this : null;
          return n && (n._remove(!1, !0), i._insertItem(t._index + e, n)), n;
        },
        insertAbove: function(t) {
          return this._insertAt(t, 1);
        },
        insertBelow: function(t) {
          return this._insertAt(t, 0);
        },
        sendToBack: function() {
          var t = this._getOwner();
          return t ? t._insertItem(0, this) : null;
        },
        bringToFront: function() {
          var t = this._getOwner();
          return t ? t._insertItem(F, this) : null;
        },
        appendTop: "#addChild",
        appendBottom: function(t) {
          return this.insertChild(0, t);
        },
        moveAbove: "#insertAbove",
        moveBelow: "#insertBelow",
        addTo: function(t) {
          return t._insertItem(F, this);
        },
        copyTo: function(t) {
          return this.clone(!1).addTo(t);
        },
        reduce: function(t) {
          var e = this._children;
          if (e && e.length === 1) {
            var i = e[0].reduce(t);
            return this._parent ? (i.insertAbove(this), this.remove()) : i.remove(), i;
          }
          return this;
        },
        _removeNamed: function() {
          var t = this._getOwner();
          if (t) {
            var e = t._children, i = t._namedChildren, n = this._name, r = i[n], s = r ? r.indexOf(this) : -1;
            s !== -1 && (e[n] == this && delete e[n], r.splice(s, 1), r.length ? e[n] = r[0] : delete i[n]);
          }
        },
        _remove: function(t, e) {
          var i = this._getOwner(), n = this._project, r = this._index;
          return this._style && this._style._dispose(), i ? (this._name && this._removeNamed(), r != null && (n._activeLayer === this && (n._activeLayer = this.getNextSibling() || this.getPreviousSibling()), T.splice(i._children, null, r, 1)), this._installEvents(!1), t && n._changes && this._changed(5), e && i._changed(11, this), this._parent = null, !0) : !1;
        },
        remove: function() {
          return this._remove(!0, !0);
        },
        replaceWith: function(t) {
          var e = t && t.insertBelow(this);
          return e && this.remove(), e;
        },
        removeChildren: function(t, e) {
          if (!this._children)
            return null;
          t = t || 0, e = T.pick(e, this._children.length);
          for (var i = T.splice(this._children, null, t, e - t), n = i.length - 1; n >= 0; n--)
            i[n]._remove(!0, !1);
          return i.length > 0 && this._changed(11), i;
        },
        clear: "#removeChildren",
        reverseChildren: function() {
          if (this._children) {
            this._children.reverse();
            for (var t = 0, e = this._children.length; t < e; t++)
              this._children[t]._index = t;
            this._changed(11);
          }
        },
        isEmpty: function(t) {
          var e = this._children, i = e ? e.length : 0;
          if (t) {
            for (var n = 0; n < i; n++)
              if (!e[n].isEmpty(t))
                return !1;
            return !0;
          }
          return !i;
        },
        isEditable: function() {
          for (var t = this; t; ) {
            if (!t._visible || t._locked)
              return !1;
            t = t._parent;
          }
          return !0;
        },
        hasFill: function() {
          return this.getStyle().hasFill();
        },
        hasStroke: function() {
          return this.getStyle().hasStroke();
        },
        hasShadow: function() {
          return this.getStyle().hasShadow();
        },
        _getOrder: function(t) {
          function e(u) {
            var a = [];
            do
              a.unshift(u);
            while (u = u._parent);
            return a;
          }
          for (var i = e(this), n = e(t), r = 0, s = Math.min(i.length, n.length); r < s; r++)
            if (i[r] != n[r])
              return i[r]._index < n[r]._index ? 1 : -1;
          return 0;
        },
        hasChildren: function() {
          return this._children && this._children.length > 0;
        },
        isInserted: function() {
          return this._parent ? this._parent.isInserted() : !1;
        },
        isAbove: function(t) {
          return this._getOrder(t) === -1;
        },
        isBelow: function(t) {
          return this._getOrder(t) === 1;
        },
        isParent: function(t) {
          return this._parent === t;
        },
        isChild: function(t) {
          return t && t._parent === this;
        },
        isDescendant: function(t) {
          for (var e = this; e = e._parent; )
            if (e === t)
              return !0;
          return !1;
        },
        isAncestor: function(t) {
          return t ? t.isDescendant(this) : !1;
        },
        isSibling: function(t) {
          return this._parent === t._parent;
        },
        isGroupedWith: function(t) {
          for (var e = this._parent; e; ) {
            if (e._parent && /^(Group|Layer|CompoundPath)$/.test(e._class) && t.isDescendant(e))
              return !0;
            e = e._parent;
          }
          return !1;
        }
      },
      T.each(["rotate", "scale", "shear", "skew"], function(t) {
        var e = t === "rotate";
        this[t] = function() {
          var i = arguments, n = (e ? T : E).read(i), r = E.read(i, 0, { readNull: !0 });
          return this.transform(new wt()[t](
            n,
            r || this.getPosition(!0)
          ));
        };
      }, {
        translate: function() {
          var t = new wt();
          return this.transform(t.translate.apply(t, arguments));
        },
        transform: function(t, e, i) {
          var n = this._matrix, r = t && !t.isIdentity(), s = i && this._canApplyMatrix || this._applyMatrix && (r || !n.isIdentity() || e && this._children);
          if (!r && !s)
            return this;
          if (r) {
            !t.isInvertible() && n.isInvertible() && (n._backup = n.getValues()), n.prepend(t, !0);
            var u = this._style, a = u.getFillColor(!0), o = u.getStrokeColor(!0);
            a && a.transform(t), o && o.transform(t);
          }
          if (s && (s = this._transformContent(
            n,
            e,
            i
          ))) {
            var h = this._pivot;
            h && n._transformPoint(h, h, !0), n.reset(!0), i && this._canApplyMatrix && (this._applyMatrix = !0);
          }
          var d = this._bounds, g = this._position;
          (r || s) && this._changed(25);
          var c = r && d && t.decompose();
          if (c && c.skewing.isZero() && c.rotation % 90 === 0) {
            for (var f in d) {
              var b = d[f];
              if (b.nonscaling)
                delete d[f];
              else if (s || !b.internal) {
                var v = b.rect;
                t._transformBounds(v, v);
              }
            }
            this._bounds = d;
            var x = d[this._getBoundsCacheKey(
              this._boundsOptions || {}
            )];
            x && (this._position = this._getPositionFromBounds(x.rect));
          } else
            r && g && this._pivot && (this._position = t._transformPoint(g, g));
          return this;
        },
        _transformContent: function(t, e, i) {
          var n = this._children;
          if (n) {
            for (var r = 0, s = n.length; r < s; r++)
              n[r].transform(t, e, i);
            return !0;
          }
        },
        globalToLocal: function() {
          return this.getGlobalMatrix(!0)._inverseTransform(
            E.read(arguments)
          );
        },
        localToGlobal: function() {
          return this.getGlobalMatrix(!0)._transformPoint(
            E.read(arguments)
          );
        },
        parentToLocal: function() {
          return this._matrix._inverseTransform(E.read(arguments));
        },
        localToParent: function() {
          return this._matrix._transformPoint(E.read(arguments));
        },
        fitBounds: function(t, e) {
          t = et.read(arguments);
          var i = this.getBounds(), n = i.height / i.width, r = t.height / t.width, s = (e ? n > r : n < r) ? t.width / i.width : t.height / i.height, u = new et(
            new E(),
            new W(i.width * s, i.height * s)
          );
          u.setCenter(t.getCenter()), this.setBounds(u);
        }
      }),
      {
        _setStyles: function(t, e, i) {
          var n = this._style, r = this._matrix;
          if (n.hasFill() && (t.fillStyle = n.getFillColor().toCanvasStyle(t, r)), n.hasStroke()) {
            t.strokeStyle = n.getStrokeColor().toCanvasStyle(t, r), t.lineWidth = n.getStrokeWidth();
            var s = n.getStrokeJoin(), u = n.getStrokeCap(), a = n.getMiterLimit();
            if (s && (t.lineJoin = s), u && (t.lineCap = u), a && (t.miterLimit = a), _t.support.nativeDash) {
              var o = n.getDashArray(), h = n.getDashOffset();
              o && o.length && ("setLineDash" in t ? (t.setLineDash(o), t.lineDashOffset = h) : (t.mozDash = o, t.mozDashOffset = h));
            }
          }
          if (n.hasShadow()) {
            var d = e.pixelRatio || 1, g = i._shiftless().prepend(
              new wt().scale(d, d)
            ), c = g.transform(new E(n.getShadowBlur(), 0)), f = g.transform(this.getShadowOffset());
            t.shadowColor = n.getShadowColor().toCanvasStyle(t), t.shadowBlur = c.getLength(), t.shadowOffsetX = f.x, t.shadowOffsetY = f.y;
          }
        },
        draw: function(t, e, i) {
          if (this._updateVersion = this._project._updateVersion, !(!this._visible || this._opacity === 0)) {
            var n = e.matrices, r = e.viewMatrix, s = this._matrix, u = n[n.length - 1].appended(s);
            if (u.isInvertible()) {
              r = r ? r.appended(u) : u, n.push(u), e.updateMatrix && (this._globalMatrix = u);
              var a = this._blendMode, o = lt.clamp(this._opacity, 0, 1), h = a === "normal", d = si.nativeModes[a], g = h && o === 1 || e.dontStart || e.clip || (d || h && o < 1) && this._canComposite(), c = e.pixelRatio || 1, f, b, v;
              if (!g) {
                var x = this.getStrokeBounds(r);
                if (!x.width || !x.height) {
                  n.pop();
                  return;
                }
                v = e.offset, b = e.offset = x.getTopLeft().floor(), f = t, t = Dt.getContext(x.getSize().ceil().add(1).multiply(c)), c !== 1 && t.scale(c, c);
              }
              t.save();
              var _ = i ? i.appended(s) : this._canScaleStroke && !this.getStrokeScaling(!0) && r, m = !g && e.clipItem, l = !_ || m;
              if (g ? (t.globalAlpha = o, d && (t.globalCompositeOperation = a)) : l && t.translate(-b.x, -b.y), l && (g ? s : r).applyToContext(t), m && e.clipItem.draw(t, e.extend({ clip: !0 })), _) {
                t.setTransform(c, 0, 0, c, 0, 0);
                var p = e.offset;
                p && t.translate(-p.x, -p.y);
              }
              this._draw(t, e, r, _), t.restore(), n.pop(), e.clip && !e.dontFinish && t.clip(this.getFillRule()), g || (si.process(
                a,
                t,
                f,
                o,
                b.subtract(v).multiply(c)
              ), Dt.release(t), e.offset = v);
            }
          }
        },
        _isUpdated: function(t) {
          var e = this._parent;
          if (e instanceof fe)
            return e._isUpdated(t);
          var i = this._updateVersion === t;
          return !i && e && e._visible && e._isUpdated(t) && (this._updateVersion = t, i = !0), i;
        },
        _drawSelection: function(t, e, i, n, r) {
          var s = this._selection, u = s & 1, a = s & 2 || u && this._selectBounds, o = s & 4;
          if (this._drawSelected || (u = !1), (u || a || o) && this._isUpdated(r)) {
            var h, d = this.getSelectedColor(!0) || (h = this.getLayer()) && h.getSelectedColor(!0), g = e.appended(this.getGlobalMatrix(!0)), c = i / 2;
            if (t.strokeStyle = t.fillStyle = d ? d.toCanvasStyle(t) : "#009dec", u && this._drawSelected(t, g, n), o) {
              var f = this.getPosition(!0), b = this._parent, v = b ? b.localToGlobal(f) : f, x = v.x, _ = v.y;
              t.beginPath(), t.arc(x, _, c, 0, Math.PI * 2, !0), t.stroke();
              for (var m = [[0, -1], [1, 0], [0, 1], [-1, 0]], l = c, p = i + 1, y = 0; y < 4; y++) {
                var S = m[y], w = S[0], C = S[1];
                t.moveTo(x + w * l, _ + C * l), t.lineTo(x + w * p, _ + C * p), t.stroke();
              }
            }
            if (a) {
              var I = g._transformCorners(this.getInternalBounds());
              t.beginPath();
              for (var y = 0; y < 8; y++)
                t[y ? "lineTo" : "moveTo"](I[y], I[++y]);
              t.closePath(), t.stroke();
              for (var y = 0; y < 8; y++)
                t.fillRect(
                  I[y] - c,
                  I[++y] - c,
                  i,
                  i
                );
            }
          }
        },
        _canComposite: function() {
          return !1;
        }
      },
      T.each(["down", "drag", "up", "move"], function(t) {
        this["removeOn" + T.capitalize(t)] = function() {
          var e = {};
          return e[t] = !0, this.removeOn(e);
        };
      }, {
        removeOn: function(t) {
          for (var e in t)
            if (t[e]) {
              var i = "mouse" + e, n = this._project, r = n._removeSets = n._removeSets || {};
              r[i] = r[i] || {}, r[i][this._id] = this;
            }
          return this;
        }
      }),
      {
        tween: function(t, e, i) {
          i || (i = e, e = t, t = null, i || (i = e, e = null));
          var n = i && i.easing, r = i && i.start, s = i != null && (typeof i == "number" ? i : i.duration), u = new sn(this, t, e, s, n, r);
          function a(o) {
            u._handleFrame(o.time * 1e3), u.running || this.off("frame", a);
          }
          return s && this.on("frame", a), u;
        },
        tweenTo: function(t, e) {
          return this.tween(null, t, e);
        },
        tweenFrom: function(t, e) {
          return this.tween(t, null, e);
        }
      }
    ), jt = ft.extend({
      _class: "Group",
      _selectBounds: !1,
      _selectChildren: !0,
      _serializeFields: {
        children: []
      },
      initialize: function(e) {
        this._children = [], this._namedChildren = {}, this._initialize(e) || this.addChildren(Array.isArray(e) ? e : arguments);
      },
      _changed: function t(e) {
        t.base.call(this, e), e & 2050 && (this._clipItem = F);
      },
      _getClipItem: function() {
        var t = this._clipItem;
        if (t === F) {
          t = null;
          for (var e = this._children, i = 0, n = e.length; i < n; i++)
            if (e[i]._clipMask) {
              t = e[i];
              break;
            }
          this._clipItem = t;
        }
        return t;
      },
      isClipped: function() {
        return !!this._getClipItem();
      },
      setClipped: function(t) {
        var e = this.getFirstChild();
        e && e.setClipMask(t);
      },
      _getBounds: function t(e, i) {
        var n = this._getClipItem();
        return n ? n._getCachedBounds(
          n._matrix.prepended(e),
          T.set({}, i, { stroke: !1 })
        ) : t.base.call(this, e, i);
      },
      _hitTestChildren: function t(e, i, n) {
        var r = this._getClipItem();
        return (!r || r.contains(e)) && t.base.call(
          this,
          e,
          i,
          n,
          r
        );
      },
      _draw: function(t, e) {
        var i = e.clip, n = !i && this._getClipItem();
        e = e.extend({ clipItem: n, clip: !1 }), i ? (t.beginPath(), e.dontStart = e.dontFinish = !0) : n && n.draw(t, e.extend({ clip: !0 }));
        for (var r = this._children, s = 0, u = r.length; s < u; s++) {
          var a = r[s];
          a !== n && a.draw(t, e);
        }
      }
    }), Kt = jt.extend({
      _class: "Layer",
      initialize: function() {
        jt.apply(this, arguments);
      },
      _getOwner: function() {
        return this._parent || this._index != null && this._project;
      },
      isInserted: function t() {
        return this._parent ? t.base.call(this) : this._index != null;
      },
      activate: function() {
        this._project._activeLayer = this;
      },
      _hitTestSelf: function() {
      }
    }), It = ft.extend(
      {
        _class: "Shape",
        _applyMatrix: !1,
        _canApplyMatrix: !1,
        _canScaleStroke: !0,
        _serializeFields: {
          type: null,
          size: null,
          radius: null
        },
        initialize: function(e, i) {
          this._initialize(e, i);
        },
        _equals: function(t) {
          return this._type === t._type && this._size.equals(t._size) && T.equals(this._radius, t._radius);
        },
        copyContent: function(t) {
          this.setType(t._type), this.setSize(t._size), this.setRadius(t._radius);
        },
        getType: function() {
          return this._type;
        },
        setType: function(t) {
          this._type = t;
        },
        getShape: "#getType",
        setShape: "#setType",
        getSize: function() {
          var t = this._size;
          return new Wt(t.width, t.height, this, "setSize");
        },
        setSize: function() {
          var t = W.read(arguments);
          if (!this._size)
            this._size = t.clone();
          else if (!this._size.equals(t)) {
            var e = this._type, i = t.width, n = t.height;
            e === "rectangle" ? this._radius.set(W.min(this._radius, t.divide(2).abs())) : e === "circle" ? (i = n = (i + n) / 2, this._radius = i / 2) : e === "ellipse" && this._radius._set(i / 2, n / 2), this._size._set(i, n), this._changed(9);
          }
        },
        getRadius: function() {
          var t = this._radius;
          return this._type === "circle" ? t : new Wt(t.width, t.height, this, "setRadius");
        },
        setRadius: function(t) {
          var e = this._type;
          if (e === "circle") {
            if (t === this._radius)
              return;
            var i = t * 2;
            this._radius = t, this._size._set(i, i);
          } else if (t = W.read(arguments), !this._radius)
            this._radius = t.clone();
          else {
            if (this._radius.equals(t))
              return;
            if (this._radius.set(t), e === "rectangle") {
              var i = W.max(this._size, t.multiply(2));
              this._size.set(i);
            } else
              e === "ellipse" && this._size._set(t.width * 2, t.height * 2);
          }
          this._changed(9);
        },
        isEmpty: function() {
          return !1;
        },
        toPath: function(t) {
          var e = new pt[T.capitalize(this._type)]({
            center: new E(),
            size: this._size,
            radius: this._radius,
            insert: !1
          });
          return e.copyAttributes(this), _t.settings.applyMatrix && e.setApplyMatrix(!0), (t === F || t) && e.insertAbove(this), e;
        },
        toShape: "#clone",
        _asPathItem: function() {
          return this.toPath(!1);
        },
        _draw: function(t, e, i, n) {
          var r = this._style, s = r.hasFill(), u = r.hasStroke(), a = e.dontFinish || e.clip, o = !n;
          if (s || u || a) {
            var h = this._type, d = this._radius, g = h === "circle";
            if (e.dontStart || t.beginPath(), o && g)
              t.arc(0, 0, d, 0, Math.PI * 2, !0);
            else {
              var c = g ? d : d.width, f = g ? d : d.height, b = this._size, v = b.width, x = b.height;
              if (o && h === "rectangle" && c === 0 && f === 0)
                t.rect(-v / 2, -x / 2, v, x);
              else {
                var _ = v / 2, m = x / 2, l = 1 - 0.5522847498307936, p = c * l, y = f * l, S = [
                  -_,
                  -m + f,
                  -_,
                  -m + y,
                  -_ + p,
                  -m,
                  -_ + c,
                  -m,
                  _ - c,
                  -m,
                  _ - p,
                  -m,
                  _,
                  -m + y,
                  _,
                  -m + f,
                  _,
                  m - f,
                  _,
                  m - y,
                  _ - p,
                  m,
                  _ - c,
                  m,
                  -_ + c,
                  m,
                  -_ + p,
                  m,
                  -_,
                  m - y,
                  -_,
                  m - f
                ];
                n && n.transform(S, S, 32), t.moveTo(S[0], S[1]), t.bezierCurveTo(S[2], S[3], S[4], S[5], S[6], S[7]), _ !== c && t.lineTo(S[8], S[9]), t.bezierCurveTo(S[10], S[11], S[12], S[13], S[14], S[15]), m !== f && t.lineTo(S[16], S[17]), t.bezierCurveTo(S[18], S[19], S[20], S[21], S[22], S[23]), _ !== c && t.lineTo(S[24], S[25]), t.bezierCurveTo(S[26], S[27], S[28], S[29], S[30], S[31]);
              }
            }
            t.closePath();
          }
          !a && (s || u) && (this._setStyles(t, e, i), s && (t.fill(r.getFillRule()), t.shadowColor = "rgba(0,0,0,0)"), u && t.stroke());
        },
        _canComposite: function() {
          return !(this.hasFill() && this.hasStroke());
        },
        _getBounds: function(t, e) {
          var i = new et(this._size).setCenter(0, 0), n = this._style, r = e.stroke && n.hasStroke() && n.getStrokeWidth();
          return t && (i = t._transformBounds(i)), r ? i.expand(pt._getStrokePadding(
            r,
            this._getStrokeMatrix(t, e)
          )) : i;
        }
      },
      new function() {
        function t(i, n, r) {
          var s = i._radius;
          if (!s.isZero())
            for (var u = i._size.divide(2), a = 1; a <= 4; a++) {
              var o = new E(a > 1 && a < 4 ? -1 : 1, a > 2 ? -1 : 1), h = o.multiply(u), d = h.subtract(o.multiply(s)), g = new et(
                r ? h.add(o.multiply(r)) : h,
                d
              );
              if (g.contains(n))
                return { point: d, quadrant: a };
            }
        }
        function e(i, n, r, s) {
          var u = i.divide(n);
          return (!s || u.isInQuadrant(s)) && u.subtract(u.normalize()).multiply(n).divide(r).length <= 1;
        }
        return {
          _contains: function i(n) {
            if (this._type === "rectangle") {
              var r = t(this, n);
              return r ? n.subtract(r.point).divide(this._radius).getLength() <= 1 : i.base.call(this, n);
            } else
              return n.divide(this.size).getLength() <= 0.5;
          },
          _hitTestSelf: function i(n, r, s, u) {
            var a = !1, o = this._style, h = r.stroke && o.hasStroke(), d = r.fill && o.hasFill();
            if (h || d) {
              var g = this._type, c = this._radius, f = h ? o.getStrokeWidth() / 2 : 0, b = r._tolerancePadding.add(
                pt._getStrokePadding(
                  f,
                  !o.getStrokeScaling() && u
                )
              );
              if (g === "rectangle") {
                var v = b.multiply(2), x = t(this, n, v);
                if (x)
                  a = e(
                    n.subtract(x.point),
                    c,
                    b,
                    x.quadrant
                  );
                else {
                  var _ = new et(this._size).setCenter(0, 0), m = _.expand(v), l = _.expand(v.negate());
                  a = m._containsPoint(n) && !l._containsPoint(n);
                }
              } else
                a = e(n, c, b);
            }
            return a ? new ie(h ? "stroke" : "fill", this) : i.base.apply(this, arguments);
          }
        };
      }(),
      {
        statics: new function() {
          function t(e, i, n, r, s) {
            var u = T.create(It.prototype);
            return u._type = e, u._size = n, u._radius = r, u._initialize(T.getNamed(s), i), u;
          }
          return {
            Circle: function() {
              var e = arguments, i = E.readNamed(e, "center"), n = T.readNamed(e, "radius");
              return t(
                "circle",
                i,
                new W(n * 2),
                n,
                e
              );
            },
            Rectangle: function() {
              var e = arguments, i = et.readNamed(e, "rectangle"), n = W.min(
                W.readNamed(e, "radius"),
                i.getSize(!0).divide(2)
              );
              return t(
                "rectangle",
                i.getCenter(!0),
                i.getSize(!0),
                n,
                e
              );
            },
            Ellipse: function() {
              var e = arguments, i = It._readEllipse(e), n = i.radius;
              return t(
                "ellipse",
                i.center,
                n.multiply(2),
                n,
                e
              );
            },
            _readEllipse: function(e) {
              var i, n;
              if (T.hasNamed(e, "radius"))
                i = E.readNamed(e, "center"), n = W.readNamed(e, "radius");
              else {
                var r = et.readNamed(e, "rectangle");
                i = r.getCenter(!0), n = r.getSize(!0).divide(2);
              }
              return { center: i, radius: n };
            }
          };
        }()
      }
    ), he = ft.extend({
      _class: "Raster",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !1, handle: !1 },
      _serializeFields: {
        crossOrigin: null,
        source: null
      },
      _prioritize: ["crossOrigin"],
      _smoothing: "low",
      beans: !0,
      initialize: function(e, i) {
        if (!this._initialize(
          e,
          i !== F && E.read(arguments)
        )) {
          var n, r = typeof e, s = r === "string" ? tt.getElementById(e) : r === "object" ? e : null;
          if (s && s !== ft.NO_INSERT) {
            if (s.getContext || s.naturalHeight != null)
              n = s;
            else if (s) {
              var u = W.read(arguments);
              u.isZero() || (n = Dt.getCanvas(u));
            }
          }
          n ? this.setImage(n) : this.setSource(e);
        }
        this._size || (this._size = new W(), this._loaded = !1);
      },
      _equals: function(t) {
        return this.getSource() === t.getSource();
      },
      copyContent: function(t) {
        var e = t._image, i = t._canvas;
        if (e)
          this._setImage(e);
        else if (i) {
          var n = Dt.getCanvas(t._size);
          n.getContext("2d").drawImage(i, 0, 0), this._setImage(n);
        }
        this._crossOrigin = t._crossOrigin;
      },
      getSize: function() {
        var t = this._size;
        return new Wt(
          t ? t.width : 0,
          t ? t.height : 0,
          this,
          "setSize"
        );
      },
      setSize: function(t, e) {
        var i = W.read(arguments);
        if (i.equals(this._size))
          e && this.clear();
        else if (i.width > 0 && i.height > 0) {
          var n = !e && this.getElement();
          this._setImage(Dt.getCanvas(i)), n && this.getContext(!0).drawImage(
            n,
            0,
            0,
            i.width,
            i.height
          );
        } else
          this._canvas && Dt.release(this._canvas), this._size = i.clone();
      },
      getWidth: function() {
        return this._size ? this._size.width : 0;
      },
      setWidth: function(t) {
        this.setSize(t, this.getHeight());
      },
      getHeight: function() {
        return this._size ? this._size.height : 0;
      },
      setHeight: function(t) {
        this.setSize(this.getWidth(), t);
      },
      getLoaded: function() {
        return this._loaded;
      },
      isEmpty: function() {
        var t = this._size;
        return !t || t.width === 0 && t.height === 0;
      },
      getResolution: function() {
        var t = this._matrix, e = new E(0, 0).transform(t), i = new E(1, 0).transform(t).subtract(e), n = new E(0, 1).transform(t).subtract(e);
        return new W(
          72 / i.getLength(),
          72 / n.getLength()
        );
      },
      getPpi: "#getResolution",
      getImage: function() {
        return this._image;
      },
      setImage: function(t) {
        var e = this;
        function i(n) {
          var r = e.getView(), s = n && n.type || "load";
          r && e.responds(s) && (_t = r._scope, e.emit(s, new We(n)));
        }
        this._setImage(t), this._loaded ? setTimeout(i, 0) : t && Nt.add(t, {
          load: function(n) {
            e._setImage(t), i(n);
          },
          error: i
        });
      },
      _setImage: function(t) {
        this._canvas && Dt.release(this._canvas), t && t.getContext ? (this._image = null, this._canvas = t, this._loaded = !0) : (this._image = t, this._canvas = null, this._loaded = !!(t && t.src && t.complete)), this._size = new W(
          t ? t.naturalWidth || t.width : 0,
          t ? t.naturalHeight || t.height : 0
        ), this._context = null, this._changed(1033);
      },
      getCanvas: function() {
        if (!this._canvas) {
          var t = Dt.getContext(this._size);
          try {
            this._image && t.drawImage(this._image, 0, 0), this._canvas = t.canvas;
          } catch {
            Dt.release(t);
          }
        }
        return this._canvas;
      },
      setCanvas: "#setImage",
      getContext: function(t) {
        return this._context || (this._context = this.getCanvas().getContext("2d")), t && (this._image = null, this._changed(1025)), this._context;
      },
      setContext: function(t) {
        this._context = t;
      },
      getSource: function() {
        var t = this._image;
        return t && t.src || this.toDataURL();
      },
      setSource: function(t) {
        var e = new q.Image(), i = this._crossOrigin;
        i && (e.crossOrigin = i), t && (e.src = t), this.setImage(e);
      },
      getCrossOrigin: function() {
        var t = this._image;
        return t && t.crossOrigin || this._crossOrigin || "";
      },
      setCrossOrigin: function(t) {
        this._crossOrigin = t;
        var e = this._image;
        e && (e.crossOrigin = t);
      },
      getSmoothing: function() {
        return this._smoothing;
      },
      setSmoothing: function(t) {
        this._smoothing = typeof t == "string" ? t : t ? "low" : "off", this._changed(257);
      },
      getElement: function() {
        return this._canvas || this._loaded && this._image;
      }
    }, {
      beans: !1,
      getSubCanvas: function() {
        var t = et.read(arguments), e = Dt.getContext(t.getSize());
        return e.drawImage(
          this.getCanvas(),
          t.x,
          t.y,
          t.width,
          t.height,
          0,
          0,
          t.width,
          t.height
        ), e.canvas;
      },
      getSubRaster: function() {
        var t = et.read(arguments), e = new he(ft.NO_INSERT);
        return e._setImage(this.getSubCanvas(t)), e.translate(t.getCenter().subtract(this.getSize().divide(2))), e._matrix.prepend(this._matrix), e.insertAbove(this), e;
      },
      toDataURL: function() {
        var t = this._image, e = t && t.src;
        if (/^data:/.test(e))
          return e;
        var i = this.getCanvas();
        return i ? i.toDataURL.apply(i, arguments) : null;
      },
      drawImage: function(t) {
        var e = E.read(arguments, 1);
        this.getContext(!0).drawImage(t, e.x, e.y);
      },
      getAverageColor: function(t) {
        var e, i;
        if (t ? t instanceof Ae ? (i = t, e = t.getBounds()) : typeof t == "object" && ("width" in t ? e = new et(t) : "x" in t && (e = new et(t.x - 0.5, t.y - 0.5, 1, 1))) : e = this.getBounds(), !e)
          return null;
        var n = 32, r = Math.min(e.width, n), s = Math.min(e.height, n), u = he._sampleContext;
        u ? u.clearRect(0, 0, n + 1, n + 1) : u = he._sampleContext = Dt.getContext(
          new W(n)
        ), u.save();
        var a = new wt().scale(r / e.width, s / e.height).translate(-e.x, -e.y);
        a.applyToContext(u), i && i.draw(u, new T({ clip: !0, matrices: [a] })), this._matrix.applyToContext(u);
        var o = this.getElement(), h = this._size;
        o && u.drawImage(o, -h.width / 2, -h.height / 2), u.restore();
        for (var d = u.getImageData(
          0.5,
          0.5,
          Math.ceil(r),
          Math.ceil(s)
        ).data, g = [0, 0, 0], c = 0, f = 0, b = d.length; f < b; f += 4) {
          var v = d[f + 3];
          c += v, v /= 255, g[0] += d[f] * v, g[1] += d[f + 1] * v, g[2] += d[f + 2] * v;
        }
        for (var f = 0; f < 3; f++)
          g[f] /= c;
        return c ? Bt.read(g) : null;
      },
      getPixel: function() {
        var t = E.read(arguments), e = this.getContext().getImageData(t.x, t.y, 1, 1).data;
        return new Bt(
          "rgb",
          [e[0] / 255, e[1] / 255, e[2] / 255],
          e[3] / 255
        );
      },
      setPixel: function() {
        var t = arguments, e = E.read(t), i = Bt.read(t), n = i._convert("rgb"), r = i._alpha, s = this.getContext(!0), u = s.createImageData(1, 1), a = u.data;
        a[0] = n[0] * 255, a[1] = n[1] * 255, a[2] = n[2] * 255, a[3] = r != null ? r * 255 : 255, s.putImageData(u, e.x, e.y);
      },
      clear: function() {
        var t = this._size;
        this.getContext(!0).clearRect(0, 0, t.width + 1, t.height + 1);
      },
      createImageData: function() {
        var t = W.read(arguments);
        return this.getContext().createImageData(t.width, t.height);
      },
      getImageData: function() {
        var t = et.read(arguments);
        return t.isEmpty() && (t = new et(this._size)), this.getContext().getImageData(
          t.x,
          t.y,
          t.width,
          t.height
        );
      },
      putImageData: function(t) {
        var e = E.read(arguments, 1);
        this.getContext(!0).putImageData(t, e.x, e.y);
      },
      setImageData: function(t) {
        this.setSize(t), this.getContext(!0).putImageData(t, 0, 0);
      },
      _getBounds: function(t, e) {
        var i = new et(this._size).setCenter(0, 0);
        return t ? t._transformBounds(i) : i;
      },
      _hitTestSelf: function(t) {
        if (this._contains(t)) {
          var e = this;
          return new ie("pixel", e, {
            offset: t.add(e._size.divide(2)).round(),
            color: {
              get: function() {
                return e.getPixel(this.offset);
              }
            }
          });
        }
      },
      _draw: function(t, e, i) {
        var n = this.getElement();
        if (n && n.width > 0 && n.height > 0) {
          t.globalAlpha = lt.clamp(this._opacity, 0, 1), this._setStyles(t, e, i);
          var r = this._smoothing, s = r === "off";
          At.setPrefixed(
            t,
            s ? "imageSmoothingEnabled" : "imageSmoothingQuality",
            s ? !1 : r
          ), t.drawImage(
            n,
            -this._size.width / 2,
            -this._size.height / 2
          );
        }
      },
      _canComposite: function() {
        return !0;
      }
    }), ve = ft.extend({
      _class: "SymbolItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _boundsOptions: { stroke: !0 },
      _serializeFields: {
        symbol: null
      },
      initialize: function(e, i) {
        this._initialize(
          e,
          i !== F && E.read(arguments, 1)
        ) || this.setDefinition(e instanceof $t ? e : new $t(e));
      },
      _equals: function(t) {
        return this._definition === t._definition;
      },
      copyContent: function(t) {
        this.setDefinition(t._definition);
      },
      getDefinition: function() {
        return this._definition;
      },
      setDefinition: function(t) {
        this._definition = t, this._changed(9);
      },
      getSymbol: "#getDefinition",
      setSymbol: "#setDefinition",
      isEmpty: function() {
        return this._definition._item.isEmpty();
      },
      _getBounds: function(t, e) {
        var i = this._definition._item;
        return i._getCachedBounds(i._matrix.prepended(t), e);
      },
      _hitTestSelf: function(t, e, i) {
        var n = e.extend({ all: !1 }), r = this._definition._item._hitTest(t, n, i);
        return r && (r.item = this), r;
      },
      _draw: function(t, e) {
        this._definition._item.draw(t, e);
      }
    }), $t = T.extend({
      _class: "SymbolDefinition",
      initialize: function(e, i) {
        this._id = xt.get(), this.project = _t.project, e && this.setItem(e, i);
      },
      _serialize: function(t, e) {
        return e.add(this, function() {
          return T.serialize(
            [this._class, this._item],
            t,
            !1,
            e
          );
        });
      },
      _changed: function(t) {
        t & 8 && ft._clearBoundsCache(this), t & 1 && this.project._changed(t);
      },
      getItem: function() {
        return this._item;
      },
      setItem: function(t, e) {
        t._symbol && (t = t.clone()), this._item && (this._item._symbol = null), this._item = t, t.remove(), t.setSelected(!1), e || t.setPosition(new E()), t._symbol = this, this._changed(9);
      },
      getDefinition: "#getItem",
      setDefinition: "#setItem",
      place: function(t) {
        return new ve(this, t);
      },
      clone: function() {
        return new $t(this._item.clone(!1));
      },
      equals: function(t) {
        return t === this || t && this._item.equals(t._item) || !1;
      }
    }), ie = T.extend({
      _class: "HitResult",
      initialize: function(e, i, n) {
        this.type = e, this.item = i, n && this.inject(n);
      },
      statics: {
        getOptions: function(t) {
          var e = t && T.read(t);
          return new T({
            type: null,
            tolerance: _t.settings.hitTolerance,
            fill: !e,
            stroke: !e,
            segments: !e,
            handles: !1,
            ends: !1,
            position: !1,
            center: !1,
            bounds: !1,
            guides: !1,
            selected: !1
          }, e);
        }
      }
    }), it = T.extend({
      _class: "Segment",
      beans: !0,
      _selection: 0,
      initialize: function(e, i, n, r, s, u) {
        var a = arguments.length, o, h, d, g;
        a > 0 && (e == null || typeof e == "object" ? a === 1 && e && "point" in e ? (o = e.point, h = e.handleIn, d = e.handleOut, g = e.selection) : (o = e, h = i, d = n, g = r) : (o = [e, i], h = n !== F ? [n, r] : null, d = s !== F ? [s, u] : null)), new Ne(o, this, "_point"), new Ne(h, this, "_handleIn"), new Ne(d, this, "_handleOut"), g && this.setSelection(g);
      },
      _serialize: function(t, e) {
        var i = this._point, n = this._selection, r = n || this.hasHandles() ? [i, this._handleIn, this._handleOut] : i;
        return n && r.push(n), T.serialize(r, t, !0, e);
      },
      _changed: function(t) {
        var e = this._path;
        if (e) {
          var i = e._curves, n = this._index, r;
          i && ((!t || t === this._point || t === this._handleIn) && (r = n > 0 ? i[n - 1] : e._closed ? i[i.length - 1] : null) && r._changed(), (!t || t === this._point || t === this._handleOut) && (r = i[n]) && r._changed()), e._changed(41);
        }
      },
      getPoint: function() {
        return this._point;
      },
      setPoint: function() {
        this._point.set(E.read(arguments));
      },
      getHandleIn: function() {
        return this._handleIn;
      },
      setHandleIn: function() {
        this._handleIn.set(E.read(arguments));
      },
      getHandleOut: function() {
        return this._handleOut;
      },
      setHandleOut: function() {
        this._handleOut.set(E.read(arguments));
      },
      hasHandles: function() {
        return !this._handleIn.isZero() || !this._handleOut.isZero();
      },
      isSmooth: function() {
        var t = this._handleIn, e = this._handleOut;
        return !t.isZero() && !e.isZero() && t.isCollinear(e);
      },
      clearHandles: function() {
        this._handleIn._set(0, 0), this._handleOut._set(0, 0);
      },
      getSelection: function() {
        return this._selection;
      },
      setSelection: function(t) {
        var e = this._selection, i = this._path;
        this._selection = t = t || 0, i && t !== e && (i._updateSelection(this, e, t), i._changed(257));
      },
      _changeSelection: function(t, e) {
        var i = this._selection;
        this.setSelection(e ? i | t : i & ~t);
      },
      isSelected: function() {
        return !!(this._selection & 7);
      },
      setSelected: function(t) {
        this._changeSelection(7, t);
      },
      getIndex: function() {
        return this._index !== F ? this._index : null;
      },
      getPath: function() {
        return this._path || null;
      },
      getCurve: function() {
        var t = this._path, e = this._index;
        return t ? (e > 0 && !t._closed && e === t._segments.length - 1 && e--, t.getCurves()[e] || null) : null;
      },
      getLocation: function() {
        var t = this.getCurve();
        return t ? new le(t, this === t._segment1 ? 0 : 1) : null;
      },
      getNext: function() {
        var t = this._path && this._path._segments;
        return t && (t[this._index + 1] || this._path._closed && t[0]) || null;
      },
      smooth: function(t, e, i) {
        var n = t || {}, r = n.type, s = n.factor, u = this.getPrevious(), a = this.getNext(), o = (u || this)._point, h = this._point, d = (a || this)._point, g = o.getDistance(h), c = h.getDistance(d);
        if (!r || r === "catmull-rom") {
          var f = s === F ? 0.5 : s, b = Math.pow(g, f), v = b * b, x = Math.pow(c, f), _ = x * x;
          if (!e && u) {
            var m = 2 * _ + 3 * x * b + v, l = 3 * x * (x + b);
            this.setHandleIn(l !== 0 ? new E(
              (_ * o._x + m * h._x - v * d._x) / l - h._x,
              (_ * o._y + m * h._y - v * d._y) / l - h._y
            ) : new E());
          }
          if (!i && a) {
            var m = 2 * v + 3 * b * x + _, l = 3 * b * (b + x);
            this.setHandleOut(l !== 0 ? new E(
              (v * d._x + m * h._x - _ * o._x) / l - h._x,
              (v * d._y + m * h._y - _ * o._y) / l - h._y
            ) : new E());
          }
        } else if (r === "geometric") {
          if (u && a) {
            var p = o.subtract(d), y = s === F ? 0.4 : s, S = y * g / (g + c);
            e || this.setHandleIn(p.multiply(S)), i || this.setHandleOut(p.multiply(S - y));
          }
        } else
          throw new Error("Smoothing method '" + r + "' not supported.");
      },
      getPrevious: function() {
        var t = this._path && this._path._segments;
        return t && (t[this._index - 1] || this._path._closed && t[t.length - 1]) || null;
      },
      isFirst: function() {
        return !this._index;
      },
      isLast: function() {
        var t = this._path;
        return t && this._index === t._segments.length - 1 || !1;
      },
      reverse: function() {
        var t = this._handleIn, e = this._handleOut, i = t.clone();
        t.set(e), e.set(i);
      },
      reversed: function() {
        return new it(this._point, this._handleOut, this._handleIn);
      },
      remove: function() {
        return this._path ? !!this._path.removeSegment(this._index) : !1;
      },
      clone: function() {
        return new it(this._point, this._handleIn, this._handleOut);
      },
      equals: function(t) {
        return t === this || t && this._class === t._class && this._point.equals(t._point) && this._handleIn.equals(t._handleIn) && this._handleOut.equals(t._handleOut) || !1;
      },
      toString: function() {
        var t = ["point: " + this._point];
        return this._handleIn.isZero() || t.push("handleIn: " + this._handleIn), this._handleOut.isZero() || t.push("handleOut: " + this._handleOut), "{ " + t.join(", ") + " }";
      },
      transform: function(t) {
        this._transformCoordinates(t, new Array(6), !0), this._changed();
      },
      interpolate: function(t, e, i) {
        var n = 1 - i, r = i, s = t._point, u = e._point, a = t._handleIn, o = e._handleIn, h = e._handleOut, d = t._handleOut;
        this._point._set(
          n * s._x + r * u._x,
          n * s._y + r * u._y,
          !0
        ), this._handleIn._set(
          n * a._x + r * o._x,
          n * a._y + r * o._y,
          !0
        ), this._handleOut._set(
          n * d._x + r * h._x,
          n * d._y + r * h._y,
          !0
        ), this._changed();
      },
      _transformCoordinates: function(t, e, i) {
        var n = this._point, r = !i || !this._handleIn.isZero() ? this._handleIn : null, s = !i || !this._handleOut.isZero() ? this._handleOut : null, u = n._x, a = n._y, o = 2;
        return e[0] = u, e[1] = a, r && (e[o++] = r._x + u, e[o++] = r._y + a), s && (e[o++] = s._x + u, e[o++] = s._y + a), t && (t._transformCoordinates(e, e, o / 2), u = e[0], a = e[1], i ? (n._x = u, n._y = a, o = 2, r && (r._x = e[o++] - u, r._y = e[o++] - a), s && (s._x = e[o++] - u, s._y = e[o++] - a)) : (r || (e[o++] = u, e[o++] = a), s || (e[o++] = u, e[o++] = a))), e;
      }
    }), Ne = E.extend({
      initialize: function(e, i, n) {
        var r, s, u;
        if (!e)
          r = s = 0;
        else if ((r = e[0]) !== F)
          s = e[1];
        else {
          var a = e;
          (r = a.x) === F && (a = E.read(arguments), r = a.x), s = a.y, u = a.selected;
        }
        this._x = r, this._y = s, this._owner = i, i[n] = this, u && this.setSelected(!0);
      },
      _set: function(t, e) {
        return this._x = t, this._y = e, this._owner._changed(this), this;
      },
      getX: function() {
        return this._x;
      },
      setX: function(t) {
        this._x = t, this._owner._changed(this);
      },
      getY: function() {
        return this._y;
      },
      setY: function(t) {
        this._y = t, this._owner._changed(this);
      },
      isZero: function() {
        var t = lt.isZero;
        return t(this._x) && t(this._y);
      },
      isSelected: function() {
        return !!(this._owner._selection & this._getSelection());
      },
      setSelected: function(t) {
        this._owner._changeSelection(this._getSelection(), t);
      },
      _getSelection: function() {
        var t = this._owner;
        return this === t._point ? 1 : this === t._handleIn ? 2 : this === t._handleOut ? 4 : 0;
      }
    }), j = T.extend(
      {
        _class: "Curve",
        beans: !0,
        initialize: function(e, i, n, r, s, u, a, o) {
          var h = arguments.length, d, g, c, f, b, v;
          h === 3 ? (this._path = e, d = i, g = n) : h ? h === 1 ? "segment1" in e ? (d = new it(e.segment1), g = new it(e.segment2)) : "point1" in e ? (c = e.point1, b = e.handle1, v = e.handle2, f = e.point2) : Array.isArray(e) && (c = [e[0], e[1]], f = [e[6], e[7]], b = [e[2] - e[0], e[3] - e[1]], v = [e[4] - e[6], e[5] - e[7]]) : h === 2 ? (d = new it(e), g = new it(i)) : h === 4 ? (c = e, b = i, v = n, f = r) : h === 8 && (c = [e, i], f = [a, o], b = [n - e, r - i], v = [s - a, u - o]) : (d = new it(), g = new it()), this._segment1 = d || new it(c, null, b), this._segment2 = g || new it(f, v, null);
        },
        _serialize: function(t, e) {
          return T.serialize(
            this.hasHandles() ? [
              this.getPoint1(),
              this.getHandle1(),
              this.getHandle2(),
              this.getPoint2()
            ] : [this.getPoint1(), this.getPoint2()],
            t,
            !0,
            e
          );
        },
        _changed: function() {
          this._length = this._bounds = F;
        },
        clone: function() {
          return new j(this._segment1, this._segment2);
        },
        toString: function() {
          var t = ["point1: " + this._segment1._point];
          return this._segment1._handleOut.isZero() || t.push("handle1: " + this._segment1._handleOut), this._segment2._handleIn.isZero() || t.push("handle2: " + this._segment2._handleIn), t.push("point2: " + this._segment2._point), "{ " + t.join(", ") + " }";
        },
        classify: function() {
          return j.classify(this.getValues());
        },
        remove: function() {
          var t = !1;
          if (this._path) {
            var e = this._segment2, i = e._handleOut;
            t = e.remove(), t && this._segment1._handleOut.set(i);
          }
          return t;
        },
        getPoint1: function() {
          return this._segment1._point;
        },
        setPoint1: function() {
          this._segment1._point.set(E.read(arguments));
        },
        getPoint2: function() {
          return this._segment2._point;
        },
        setPoint2: function() {
          this._segment2._point.set(E.read(arguments));
        },
        getHandle1: function() {
          return this._segment1._handleOut;
        },
        setHandle1: function() {
          this._segment1._handleOut.set(E.read(arguments));
        },
        getHandle2: function() {
          return this._segment2._handleIn;
        },
        setHandle2: function() {
          this._segment2._handleIn.set(E.read(arguments));
        },
        getSegment1: function() {
          return this._segment1;
        },
        getSegment2: function() {
          return this._segment2;
        },
        getPath: function() {
          return this._path;
        },
        getIndex: function() {
          return this._segment1._index;
        },
        getNext: function() {
          var t = this._path && this._path._curves;
          return t && (t[this._segment1._index + 1] || this._path._closed && t[0]) || null;
        },
        getPrevious: function() {
          var t = this._path && this._path._curves;
          return t && (t[this._segment1._index - 1] || this._path._closed && t[t.length - 1]) || null;
        },
        isFirst: function() {
          return !this._segment1._index;
        },
        isLast: function() {
          var t = this._path;
          return t && this._segment1._index === t._curves.length - 1 || !1;
        },
        isSelected: function() {
          return this.getPoint1().isSelected() && this.getHandle1().isSelected() && this.getHandle2().isSelected() && this.getPoint2().isSelected();
        },
        setSelected: function(t) {
          this.getPoint1().setSelected(t), this.getHandle1().setSelected(t), this.getHandle2().setSelected(t), this.getPoint2().setSelected(t);
        },
        getValues: function(t) {
          return j.getValues(this._segment1, this._segment2, t);
        },
        getPoints: function() {
          for (var t = this.getValues(), e = [], i = 0; i < 8; i += 2)
            e.push(new E(t[i], t[i + 1]));
          return e;
        }
      },
      {
        getLength: function() {
          return this._length == null && (this._length = j.getLength(this.getValues(), 0, 1)), this._length;
        },
        getArea: function() {
          return j.getArea(this.getValues());
        },
        getLine: function() {
          return new Et(this._segment1._point, this._segment2._point);
        },
        getPart: function(t, e) {
          return new j(j.getPart(this.getValues(), t, e));
        },
        getPartLength: function(t, e) {
          return j.getLength(this.getValues(), t, e);
        },
        divideAt: function(t) {
          return this.divideAtTime(t && t.curve === this ? t.time : this.getTimeAt(t));
        },
        divideAtTime: function(t, e) {
          var i = 1e-8, n = 1 - i, r = null;
          if (t >= i && t <= n) {
            var s = j.subdivide(this.getValues(), t), u = s[0], a = s[1], o = e || this.hasHandles(), h = this._segment1, d = this._segment2, g = this._path;
            o && (h._handleOut._set(u[2] - u[0], u[3] - u[1]), d._handleIn._set(a[4] - a[6], a[5] - a[7]));
            var c = u[6], f = u[7], b = new it(
              new E(c, f),
              o && new E(u[4] - c, u[5] - f),
              o && new E(a[2] - c, a[3] - f)
            );
            g ? (g.insert(h._index + 1, b), r = this.getNext()) : (this._segment2 = b, this._changed(), r = new j(b, d));
          }
          return r;
        },
        splitAt: function(t) {
          var e = this._path;
          return e ? e.splitAt(t) : null;
        },
        splitAtTime: function(t) {
          return this.splitAt(this.getLocationAtTime(t));
        },
        divide: function(t, e) {
          return this.divideAtTime(t === F ? 0.5 : e ? t : this.getTimeAt(t));
        },
        split: function(t, e) {
          return this.splitAtTime(t === F ? 0.5 : e ? t : this.getTimeAt(t));
        },
        reversed: function() {
          return new j(this._segment2.reversed(), this._segment1.reversed());
        },
        clearHandles: function() {
          this._segment1._handleOut._set(0, 0), this._segment2._handleIn._set(0, 0);
        },
        statics: {
          getValues: function(t, e, i, n) {
            var r = t._point, s = t._handleOut, u = e._handleIn, a = e._point, o = r.x, h = r.y, d = a.x, g = a.y, c = n ? [o, h, o, h, d, g, d, g] : [
              o,
              h,
              o + s._x,
              h + s._y,
              d + u._x,
              g + u._y,
              d,
              g
            ];
            return i && i._transformCoordinates(c, c, 4), c;
          },
          subdivide: function(t, e) {
            var i = t[0], n = t[1], r = t[2], s = t[3], u = t[4], a = t[5], o = t[6], h = t[7];
            e === F && (e = 0.5);
            var d = 1 - e, g = d * i + e * r, c = d * n + e * s, f = d * r + e * u, b = d * s + e * a, v = d * u + e * o, x = d * a + e * h, _ = d * g + e * f, m = d * c + e * b, l = d * f + e * v, p = d * b + e * x, y = d * _ + e * l, S = d * m + e * p;
            return [
              [i, n, g, c, _, m, y, S],
              [y, S, l, p, v, x, o, h]
            ];
          },
          getMonoCurves: function(t, e) {
            var i = [], n = e ? 0 : 1, r = t[n + 0], s = t[n + 2], u = t[n + 4], a = t[n + 6];
            if (r >= s == s >= u && s >= u == u >= a || j.isStraight(t))
              i.push(t);
            else {
              var o = 3 * (s - u) - r + a, h = 2 * (r + u) - 4 * s, d = s - r, g = 1e-8, c = 1 - g, f = [], b = lt.solveQuadratic(o, h, d, f, g, c);
              if (!b)
                i.push(t);
              else {
                f.sort();
                var v = f[0], x = j.subdivide(t, v);
                i.push(x[0]), b > 1 && (v = (f[1] - v) / (1 - v), x = j.subdivide(x[1], v), i.push(x[0])), i.push(x[1]);
              }
            }
            return i;
          },
          solveCubic: function(t, e, i, n, r, s) {
            var u = t[e], a = t[e + 2], o = t[e + 4], h = t[e + 6], d = 0;
            if (!(u < i && h < i && a < i && o < i || u > i && h > i && a > i && o > i)) {
              var g = 3 * (a - u), c = 3 * (o - a) - g, f = h - u - g - c;
              d = lt.solveCubic(f, c, g, u - i, n, r, s);
            }
            return d;
          },
          getTimeOf: function(t, e) {
            var i = new E(t[0], t[1]), n = new E(t[6], t[7]), r = 1e-12, s = 1e-7, u = e.isClose(i, r) ? 0 : e.isClose(n, r) ? 1 : null;
            if (u === null)
              for (var a = [e.x, e.y], o = [], h = 0; h < 2; h++)
                for (var d = j.solveCubic(t, h, a[h], o, 0, 1), g = 0; g < d; g++) {
                  var c = o[g];
                  if (e.isClose(j.getPoint(t, c), s))
                    return c;
                }
            return e.isClose(i, s) ? 0 : e.isClose(n, s) ? 1 : null;
          },
          getNearestTime: function(t, e) {
            if (j.isStraight(t)) {
              var i = t[0], n = t[1], r = t[6], s = t[7], u = r - i, a = s - n, o = u * u + a * a;
              if (o === 0)
                return 0;
              var h = ((e.x - i) * u + (e.y - n) * a) / o;
              return h < 1e-12 ? 0 : h > 0.999999999999 ? 1 : j.getTimeOf(
                t,
                new E(i + h * u, n + h * a)
              );
            }
            var d = 100, g = 1 / 0, c = 0;
            function f(x) {
              if (x >= 0 && x <= 1) {
                var _ = e.getDistance(j.getPoint(t, x), !0);
                if (_ < g)
                  return g = _, c = x, !0;
              }
            }
            for (var b = 0; b <= d; b++)
              f(b / d);
            for (var v = 1 / (d * 2); v > 1e-8; )
              !f(c - v) && !f(c + v) && (v /= 2);
            return c;
          },
          getPart: function(t, e, i) {
            var n = e > i;
            if (n) {
              var r = e;
              e = i, i = r;
            }
            return e > 0 && (t = j.subdivide(t, e)[1]), i < 1 && (t = j.subdivide(t, (i - e) / (1 - e))[0]), n ? [t[6], t[7], t[4], t[5], t[2], t[3], t[0], t[1]] : t;
          },
          isFlatEnough: function(t, e) {
            var i = t[0], n = t[1], r = t[2], s = t[3], u = t[4], a = t[5], o = t[6], h = t[7], d = 3 * r - 2 * i - o, g = 3 * s - 2 * n - h, c = 3 * u - 2 * o - i, f = 3 * a - 2 * h - n;
            return Math.max(d * d, c * c) + Math.max(g * g, f * f) <= 16 * e * e;
          },
          getArea: function(t) {
            var e = t[0], i = t[1], n = t[2], r = t[3], s = t[4], u = t[5], a = t[6], o = t[7];
            return 3 * ((o - i) * (n + s) - (a - e) * (r + u) + r * (e - s) - n * (i - u) + o * (s + e / 3) - a * (u + i / 3)) / 20;
          },
          getBounds: function(t) {
            for (var e = t.slice(0, 2), i = e.slice(), n = [0, 0], r = 0; r < 2; r++)
              j._addBounds(
                t[r],
                t[r + 2],
                t[r + 4],
                t[r + 6],
                r,
                0,
                e,
                i,
                n
              );
            return new et(e[0], e[1], i[0] - e[0], i[1] - e[1]);
          },
          _addBounds: function(t, e, i, n, r, s, u, a, o) {
            function h(y, S) {
              var w = y - S, C = y + S;
              w < u[r] && (u[r] = w), C > a[r] && (a[r] = C);
            }
            s /= 2;
            var d = u[r] + s, g = a[r] - s;
            if (t < d || e < d || i < d || n < d || t > g || e > g || i > g || n > g)
              if (e < t != e < n && i < t != i < n)
                h(t, 0), h(n, 0);
              else {
                var c = 3 * (e - i) - t + n, f = 2 * (t + i) - 4 * e, b = e - t, v = lt.solveQuadratic(c, f, b, o), x = 1e-8, _ = 1 - x;
                h(n, 0);
                for (var m = 0; m < v; m++) {
                  var l = o[m], p = 1 - l;
                  x <= l && l <= _ && h(
                    p * p * p * t + 3 * p * p * l * e + 3 * p * l * l * i + l * l * l * n,
                    s
                  );
                }
              }
          }
        }
      },
      T.each(
        ["getBounds", "getStrokeBounds", "getHandleBounds"],
        function(t) {
          this[t] = function() {
            this._bounds || (this._bounds = {});
            var e = this._bounds[t];
            return e || (e = this._bounds[t] = pt[t](
              [this._segment1, this._segment2],
              !1,
              this._path
            )), e.clone();
          };
        },
        {}
      ),
      T.each({
        isStraight: function(t, e, i, n) {
          if (e.isZero() && i.isZero())
            return !0;
          var r = n.subtract(t);
          if (r.isZero())
            return !1;
          if (r.isCollinear(e) && r.isCollinear(i)) {
            var s = new Et(t, n), u = 1e-7;
            if (s.getDistance(t.add(e)) < u && s.getDistance(n.add(i)) < u) {
              var a = r.dot(r), o = r.dot(e) / a, h = r.dot(i) / a;
              return o >= 0 && o <= 1 && h <= 0 && h >= -1;
            }
          }
          return !1;
        },
        isLinear: function(t, e, i, n) {
          var r = n.subtract(t).divide(3);
          return e.equals(r) && i.negate().equals(r);
        }
      }, function(t, e) {
        this[e] = function(i) {
          var n = this._segment1, r = this._segment2;
          return t(
            n._point,
            n._handleOut,
            r._handleIn,
            r._point,
            i
          );
        }, this.statics[e] = function(i, n) {
          var r = i[0], s = i[1], u = i[6], a = i[7];
          return t(
            new E(r, s),
            new E(i[2] - r, i[3] - s),
            new E(i[4] - u, i[5] - a),
            new E(u, a),
            n
          );
        };
      }, {
        statics: {},
        hasHandles: function() {
          return !this._segment1._handleOut.isZero() || !this._segment2._handleIn.isZero();
        },
        hasLength: function(t) {
          return (!this.getPoint1().equals(this.getPoint2()) || this.hasHandles()) && this.getLength() > (t || 0);
        },
        isCollinear: function(t) {
          return t && this.isStraight() && t.isStraight() && this.getLine().isCollinear(t.getLine());
        },
        isHorizontal: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).y) < 1e-8;
        },
        isVertical: function() {
          return this.isStraight() && Math.abs(this.getTangentAtTime(0.5).x) < 1e-8;
        }
      }),
      {
        beans: !1,
        getLocationAt: function(t, e) {
          return this.getLocationAtTime(
            e ? t : this.getTimeAt(t)
          );
        },
        getLocationAtTime: function(t) {
          return t != null && t >= 0 && t <= 1 ? new le(this, t) : null;
        },
        getTimeAt: function(t, e) {
          return j.getTimeAt(this.getValues(), t, e);
        },
        getParameterAt: "#getTimeAt",
        getTimesWithTangent: function() {
          var t = E.read(arguments);
          return t.isZero() ? [] : j.getTimesWithTangent(this.getValues(), t);
        },
        getOffsetAtTime: function(t) {
          return this.getPartLength(0, t);
        },
        getLocationOf: function() {
          return this.getLocationAtTime(this.getTimeOf(E.read(arguments)));
        },
        getOffsetOf: function() {
          var t = this.getLocationOf.apply(this, arguments);
          return t ? t.getOffset() : null;
        },
        getTimeOf: function() {
          return j.getTimeOf(this.getValues(), E.read(arguments));
        },
        getParameterOf: "#getTimeOf",
        getNearestLocation: function() {
          var t = E.read(arguments), e = this.getValues(), i = j.getNearestTime(e, t), n = j.getPoint(e, i);
          return new le(this, i, n, null, t.getDistance(n));
        },
        getNearestPoint: function() {
          var t = this.getNearestLocation.apply(this, arguments);
          return t && t.getPoint();
        }
      },
      new function() {
        var t = [
          "getPoint",
          "getTangent",
          "getNormal",
          "getWeightedTangent",
          "getWeightedNormal",
          "getCurvature"
        ];
        return T.each(
          t,
          function(e) {
            this[e + "At"] = function(i, n) {
              var r = this.getValues();
              return j[e](r, n ? i : j.getTimeAt(r, i));
            }, this[e + "AtTime"] = function(i) {
              return j[e](this.getValues(), i);
            };
          },
          {
            statics: {
              _evaluateMethods: t
            }
          }
        );
      }(),
      new function() {
        function t(n) {
          var r = n[0], s = n[1], u = n[2], a = n[3], o = n[4], h = n[5], d = n[6], g = n[7], c = 9 * (u - o) + 3 * (d - r), f = 6 * (r + o) - 12 * u, b = 3 * (u - r), v = 9 * (a - h) + 3 * (g - s), x = 6 * (s + h) - 12 * a, _ = 3 * (a - s);
          return function(m) {
            var l = (c * m + f) * m + b, p = (v * m + x) * m + _;
            return Math.sqrt(l * l + p * p);
          };
        }
        function e(n, r) {
          return Math.max(2, Math.min(16, Math.ceil(Math.abs(r - n) * 32)));
        }
        function i(n, r, s, u) {
          if (r == null || r < 0 || r > 1)
            return null;
          var a = n[0], o = n[1], h = n[2], d = n[3], g = n[4], c = n[5], f = n[6], b = n[7], v = lt.isZero;
          v(h - a) && v(d - o) && (h = a, d = o), v(g - f) && v(c - b) && (g = f, c = b);
          var x = 3 * (h - a), _ = 3 * (g - h) - x, m = f - a - x - _, l = 3 * (d - o), p = 3 * (c - d) - l, y = b - o - l - p, S, w;
          if (s === 0)
            S = r === 0 ? a : r === 1 ? f : ((m * r + _) * r + x) * r + a, w = r === 0 ? o : r === 1 ? b : ((y * r + p) * r + l) * r + o;
          else {
            var C = 1e-8, I = 1 - C;
            if (r < C ? (S = x, w = l) : r > I ? (S = 3 * (f - g), w = 3 * (b - c)) : (S = (3 * m * r + 2 * _) * r + x, w = (3 * y * r + 2 * p) * r + l), u) {
              S === 0 && w === 0 && (r < C || r > I) && (S = g - h, w = c - d);
              var M = Math.sqrt(S * S + w * w);
              M && (S /= M, w /= M);
            }
            if (s === 3) {
              var g = 6 * m * r + 2 * _, c = 6 * y * r + 2 * p, k = Math.pow(S * S + w * w, 3 / 2);
              S = k !== 0 ? (S * c - w * g) / k : 0, w = 0;
            }
          }
          return s === 2 ? new E(w, -S) : new E(S, w);
        }
        return { statics: {
          classify: function(n) {
            var r = n[0], s = n[1], u = n[2], a = n[3], o = n[4], h = n[5], d = n[6], g = n[7], c = r * (g - h) + s * (o - d) + d * h - g * o, f = u * (s - g) + a * (d - r) + r * g - s * d, b = o * (a - s) + h * (r - u) + u * s - a * r, v = 3 * b, x = v - f, _ = x - f + c, m = Math.sqrt(_ * _ + x * x + v * v), l = m !== 0 ? 1 / m : 0, p = lt.isZero, y = "serpentine";
            _ *= l, x *= l, v *= l;
            function S(M, k, P) {
              var O = k !== F, L = O && k > 0 && k < 1, B = O && P > 0 && P < 1;
              return O && (!(L || B) || M === "loop" && !(L && B)) && (M = "arch", L = B = !1), {
                type: M,
                roots: L || B ? L && B ? k < P ? [k, P] : [P, k] : [L ? k : P] : null
              };
            }
            if (p(_))
              return p(x) ? S(p(v) ? "line" : "quadratic") : S(y, v / (3 * x));
            var w = 3 * x * x - 4 * _ * v;
            if (p(w))
              return S("cusp", x / (2 * _));
            var C = w > 0 ? Math.sqrt(w / 3) : Math.sqrt(-w), I = 2 * _;
            return S(
              w > 0 ? y : "loop",
              (x + C) / I,
              (x - C) / I
            );
          },
          getLength: function(n, r, s, u) {
            if (r === F && (r = 0), s === F && (s = 1), j.isStraight(n)) {
              var a = n;
              s < 1 && (a = j.subdivide(a, s)[0], r /= s), r > 0 && (a = j.subdivide(a, r)[1]);
              var o = a[6] - a[0], h = a[7] - a[1];
              return Math.sqrt(o * o + h * h);
            }
            return lt.integrate(
              u || t(n),
              r,
              s,
              e(r, s)
            );
          },
          getTimeAt: function(n, r, s) {
            if (s === F && (s = r < 0 ? 1 : 0), r === 0)
              return s;
            var u = Math.abs, a = 1e-12, o = r > 0, h = o ? s : 0, d = o ? 1 : s, g = t(n), c = j.getLength(n, h, d, g), f = u(r) - c;
            if (u(f) < a)
              return o ? d : h;
            if (f > a)
              return null;
            var b = r / c, v = 0;
            function x(_) {
              return v += lt.integrate(
                g,
                s,
                _,
                e(s, _)
              ), s = _, v - r;
            }
            return lt.findRoot(
              x,
              g,
              s + b,
              h,
              d,
              32,
              1e-12
            );
          },
          getPoint: function(n, r) {
            return i(n, r, 0, !1);
          },
          getTangent: function(n, r) {
            return i(n, r, 1, !0);
          },
          getWeightedTangent: function(n, r) {
            return i(n, r, 1, !1);
          },
          getNormal: function(n, r) {
            return i(n, r, 2, !0);
          },
          getWeightedNormal: function(n, r) {
            return i(n, r, 2, !1);
          },
          getCurvature: function(n, r) {
            return i(n, r, 3, !1).x;
          },
          getPeaks: function(n) {
            var r = n[0], s = n[1], u = n[2], a = n[3], o = n[4], h = n[5], d = n[6], g = n[7], c = -r + 3 * u - 3 * o + d, f = 3 * r - 6 * u + 3 * o, b = -3 * r + 3 * u, v = -s + 3 * a - 3 * h + g, x = 3 * s - 6 * a + 3 * h, _ = -3 * s + 3 * a, m = 1e-8, l = 1 - m, p = [];
            return lt.solveCubic(
              9 * (c * c + v * v),
              9 * (c * f + x * v),
              2 * (f * f + x * x) + 3 * (b * c + _ * v),
              b * f + x * _,
              p,
              m,
              l
            ), p.sort();
          }
        } };
      }(),
      new function() {
        function t(f, b, v, x, _, m, l) {
          var p = !l && v.getPrevious() === _, y = !l && v !== _ && v.getNext() === _, S = 1e-8, w = 1 - S;
          if (x !== null && x >= (p ? S : 0) && x <= (y ? w : 1) && m !== null && m >= (y ? S : 0) && m <= (p ? w : 1)) {
            var C = new le(v, x, null, l), I = new le(_, m, null, l);
            C._intersection = I, I._intersection = C, (!b || b(C)) && le.insert(f, C, !0);
          }
        }
        function e(f, b, v, x, _, m, l, p, y, S, w, C, I) {
          if (++y >= 4096 || ++p >= 40)
            return y;
          var M = 1e-9, k = b[0], P = b[1], O = b[6], L = b[7], B = Et.getSignedDistance, N = B(k, P, O, L, b[2], b[3]), D = B(k, P, O, L, b[4], b[5]), Z = N * D > 0 ? 3 / 4 : 4 / 9, G = Z * Math.min(0, N, D), Y = Z * Math.max(0, N, D), X = B(k, P, O, L, f[0], f[1]), V = B(k, P, O, L, f[2], f[3]), U = B(k, P, O, L, f[4], f[5]), K = B(k, P, O, L, f[6], f[7]), Q = i(X, V, U, K), J = Q[0], rt = Q[1], nt, ot;
          if (N === 0 && D === 0 && X === 0 && V === 0 && U === 0 && K === 0 || (nt = n(J, rt, G, Y)) == null || (ot = n(
            J.reverse(),
            rt.reverse(),
            G,
            Y
          )) == null)
            return y;
          var ct = S + (w - S) * nt, ut = S + (w - S) * ot;
          if (Math.max(I - C, ut - ct) < M) {
            var Ft = (ct + ut) / 2, Rt = (C + I) / 2;
            t(
              _,
              m,
              l ? x : v,
              l ? Rt : Ft,
              l ? v : x,
              l ? Ft : Rt
            );
          } else {
            f = j.getPart(f, nt, ot);
            var Gt = I - C;
            if (ot - nt > 0.8)
              if (ut - ct > Gt) {
                var kt = j.subdivide(f, 0.5), Ft = (ct + ut) / 2;
                y = e(
                  b,
                  kt[0],
                  x,
                  v,
                  _,
                  m,
                  !l,
                  p,
                  y,
                  C,
                  I,
                  ct,
                  Ft
                ), y = e(
                  b,
                  kt[1],
                  x,
                  v,
                  _,
                  m,
                  !l,
                  p,
                  y,
                  C,
                  I,
                  Ft,
                  ut
                );
              } else {
                var kt = j.subdivide(b, 0.5), Rt = (C + I) / 2;
                y = e(
                  kt[0],
                  f,
                  x,
                  v,
                  _,
                  m,
                  !l,
                  p,
                  y,
                  C,
                  Rt,
                  ct,
                  ut
                ), y = e(
                  kt[1],
                  f,
                  x,
                  v,
                  _,
                  m,
                  !l,
                  p,
                  y,
                  Rt,
                  I,
                  ct,
                  ut
                );
              }
            else
              Gt === 0 || Gt >= M ? y = e(
                b,
                f,
                x,
                v,
                _,
                m,
                !l,
                p,
                y,
                C,
                I,
                ct,
                ut
              ) : y = e(
                f,
                b,
                v,
                x,
                _,
                m,
                l,
                p,
                y,
                ct,
                ut,
                C,
                I
              );
          }
          return y;
        }
        function i(f, b, v, x) {
          var _ = [0, f], m = [1 / 3, b], l = [2 / 3, v], p = [1, x], y = b - (2 * f + x) / 3, S = v - (f + 2 * x) / 3, w;
          if (y * S < 0)
            w = [[_, m, p], [_, l, p]];
          else {
            var C = y / S;
            w = [
              C >= 2 ? [_, m, p] : C <= 0.5 ? [_, l, p] : [_, m, l, p],
              [_, p]
            ];
          }
          return (y || S) < 0 ? w.reverse() : w;
        }
        function n(f, b, v, x) {
          return f[0][1] < v ? r(f, !0, v) : b[0][1] > x ? r(b, !1, x) : f[0][0];
        }
        function r(f, b, v) {
          for (var x = f[0][0], _ = f[0][1], m = 1, l = f.length; m < l; m++) {
            var p = f[m][0], y = f[m][1];
            if (b ? y >= v : y <= v)
              return y === v ? p : x + (v - _) * (p - x) / (y - _);
            x = p, _ = y;
          }
          return null;
        }
        function s(f, b, v, x, _) {
          var m = lt.isZero;
          if (m(x) && m(_)) {
            var l = j.getTimeOf(f, new E(b, v));
            return l === null ? [] : [l];
          }
          for (var p = Math.atan2(-_, x), y = Math.sin(p), S = Math.cos(p), w = [], C = [], I = 0; I < 8; I += 2) {
            var M = f[I] - b, k = f[I + 1] - v;
            w.push(
              M * S - k * y,
              M * y + k * S
            );
          }
          return j.solveCubic(w, 1, 0, C, 0, 1), C;
        }
        function u(f, b, v, x, _, m, l) {
          for (var p = b[0], y = b[1], S = b[6], w = b[7], C = s(f, p, y, S - p, w - y), I = 0, M = C.length; I < M; I++) {
            var k = C[I], P = j.getPoint(f, k), O = j.getTimeOf(b, P);
            O !== null && t(
              _,
              m,
              l ? x : v,
              l ? O : k,
              l ? v : x,
              l ? k : O
            );
          }
        }
        function a(f, b, v, x, _, m) {
          var l = Et.intersect(
            f[0],
            f[1],
            f[6],
            f[7],
            b[0],
            b[1],
            b[6],
            b[7]
          );
          l && t(
            _,
            m,
            v,
            j.getTimeOf(f, l),
            x,
            j.getTimeOf(b, l)
          );
        }
        function o(f, b, v, x, _, m) {
          var l = 1e-12, p = Math.min, y = Math.max;
          if (y(f[0], f[2], f[4], f[6]) + l > p(b[0], b[2], b[4], b[6]) && p(f[0], f[2], f[4], f[6]) - l < y(b[0], b[2], b[4], b[6]) && y(f[1], f[3], f[5], f[7]) + l > p(b[1], b[3], b[5], b[7]) && p(f[1], f[3], f[5], f[7]) - l < y(b[1], b[3], b[5], b[7])) {
            var S = g(f, b);
            if (S)
              for (var w = 0; w < 2; w++) {
                var C = S[w];
                t(
                  _,
                  m,
                  v,
                  C[0],
                  x,
                  C[1],
                  !0
                );
              }
            else {
              var I = j.isStraight(f), M = j.isStraight(b), k = I && M, P = I && !M, O = _.length;
              if ((k ? a : I || M ? u : e)(
                P ? b : f,
                P ? f : b,
                P ? x : v,
                P ? v : x,
                _,
                m,
                P,
                0,
                0,
                0,
                1,
                0,
                1
              ), !k || _.length === O)
                for (var w = 0; w < 4; w++) {
                  var L = w >> 1, B = w & 1, N = L * 6, D = B * 6, Z = new E(f[N], f[N + 1]), G = new E(b[D], b[D + 1]);
                  Z.isClose(G, l) && t(
                    _,
                    m,
                    v,
                    L,
                    x,
                    B
                  );
                }
            }
          }
          return _;
        }
        function h(f, b, v, x) {
          var _ = j.classify(f);
          if (_.type === "loop") {
            var m = _.roots;
            t(
              v,
              x,
              b,
              m[0],
              b,
              m[1]
            );
          }
          return v;
        }
        function d(f, b, v, x, _, m) {
          var l = 1e-7, p = !b;
          p && (b = f);
          for (var y = f.length, S = b.length, w = new Array(y), C = p ? w : new Array(S), I = [], M = 0; M < y; M++)
            w[M] = f[M].getValues(x);
          if (!p)
            for (var M = 0; M < S; M++)
              C[M] = b[M].getValues(_);
          for (var k = qt.findCurveBoundsCollisions(
            w,
            C,
            l
          ), P = 0; P < y; P++) {
            var O = f[P], L = w[P];
            p && h(L, O, I, v);
            var B = k[P];
            if (B)
              for (var N = 0; N < B.length; N++) {
                if (m && I.length)
                  return I;
                var D = B[N];
                if (!p || D > P) {
                  var Z = b[D], G = C[D];
                  o(
                    L,
                    G,
                    O,
                    Z,
                    I,
                    v
                  );
                }
              }
          }
          return I;
        }
        function g(f, b) {
          function v(K) {
            var Q = K[6] - K[0], J = K[7] - K[1];
            return Q * Q + J * J;
          }
          var x = Math.abs, _ = Et.getDistance, m = 1e-8, l = 1e-7, p = j.isStraight(f), y = j.isStraight(b), S = p && y, w = v(f) < v(b), C = w ? b : f, I = w ? f : b, M = C[0], k = C[1], P = C[6] - M, O = C[7] - k;
          if (_(M, k, P, O, I[0], I[1], !0) < l && _(M, k, P, O, I[6], I[7], !0) < l)
            !S && _(M, k, P, O, C[2], C[3], !0) < l && _(M, k, P, O, C[4], C[5], !0) < l && _(M, k, P, O, I[2], I[3], !0) < l && _(M, k, P, O, I[4], I[5], !0) < l && (p = y = S = !0);
          else if (S)
            return null;
          if (p ^ y)
            return null;
          for (var L = [f, b], B = [], N = 0; N < 4 && B.length < 2; N++) {
            var D = N & 1, Z = D ^ 1, G = N >> 1, Y = j.getTimeOf(L[D], new E(
              L[Z][G ? 6 : 0],
              L[Z][G ? 7 : 1]
            ));
            if (Y != null) {
              var X = D ? [G, Y] : [Y, G];
              (!B.length || x(X[0] - B[0][0]) > m && x(X[1] - B[0][1]) > m) && B.push(X);
            }
            if (N > 2 && !B.length)
              break;
          }
          if (B.length !== 2)
            B = null;
          else if (!S) {
            var V = j.getPart(f, B[0][0], B[1][0]), U = j.getPart(b, B[0][1], B[1][1]);
            (x(U[2] - V[2]) > l || x(U[3] - V[3]) > l || x(U[4] - V[4]) > l || x(U[5] - V[5]) > l) && (B = null);
          }
          return B;
        }
        function c(f, b) {
          var v = f[0], x = f[1], _ = f[2], m = f[3], l = f[4], p = f[5], y = f[6], S = f[7], w = b.normalize(), C = w.x, I = w.y, M = 3 * y - 9 * l + 9 * _ - 3 * v, k = 3 * S - 9 * p + 9 * m - 3 * x, P = 6 * l - 12 * _ + 6 * v, O = 6 * p - 12 * m + 6 * x, L = 3 * _ - 3 * v, B = 3 * m - 3 * x, N = 2 * M * I - 2 * k * C, D = [];
          if (Math.abs(N) < lt.CURVETIME_EPSILON) {
            var Z = M * B - k * L, N = M * O - k * P;
            if (N != 0) {
              var G = -Z / N;
              G >= 0 && G <= 1 && D.push(G);
            }
          } else {
            var Y = (P * P - 4 * M * L) * I * I + (-2 * P * O + 4 * k * L + 4 * M * B) * C * I + (O * O - 4 * k * B) * C * C, X = P * I - O * C;
            if (Y >= 0 && N != 0) {
              var V = Math.sqrt(Y), U = -(X + V) / N, K = (-X + V) / N;
              U >= 0 && U <= 1 && D.push(U), K >= 0 && K <= 1 && D.push(K);
            }
          }
          return D;
        }
        return {
          getIntersections: function(f) {
            var b = this.getValues(), v = f && f !== this && f.getValues();
            return v ? o(b, v, this, f, []) : h(b, this, []);
          },
          statics: {
            getOverlaps: g,
            getIntersections: d,
            getCurveLineIntersections: s,
            getTimesWithTangent: c
          }
        };
      }()
    ), le = T.extend(
      {
        _class: "CurveLocation",
        initialize: function(e, i, n, r, s) {
          if (i >= 0.99999999) {
            var u = e.getNext();
            u && (i = 0, e = u);
          }
          this._setCurve(e), this._time = i, this._point = n || e.getPointAtTime(i), this._overlap = r, this._distance = s, this._intersection = this._next = this._previous = null;
        },
        _setPath: function(t) {
          this._path = t, this._version = t ? t._version : 0;
        },
        _setCurve: function(t) {
          this._setPath(t._path), this._curve = t, this._segment = null, this._segment1 = t._segment1, this._segment2 = t._segment2;
        },
        _setSegment: function(t) {
          var e = t.getCurve();
          e ? this._setCurve(e) : (this._setPath(t._path), this._segment1 = t, this._segment2 = null), this._segment = t, this._time = t === this._segment1 ? 0 : 1, this._point = t._point.clone();
        },
        getSegment: function() {
          var t = this._segment;
          if (!t) {
            var e = this.getCurve(), i = this.getTime();
            i === 0 ? t = e._segment1 : i === 1 ? t = e._segment2 : i != null && (t = e.getPartLength(0, i) < e.getPartLength(i, 1) ? e._segment1 : e._segment2), this._segment = t;
          }
          return t;
        },
        getCurve: function() {
          var t = this._path, e = this;
          t && t._version !== this._version && (this._time = this._offset = this._curveOffset = this._curve = null);
          function i(n) {
            var r = n && n.getCurve();
            if (r && (e._time = r.getTimeOf(e._point)) != null)
              return e._setCurve(r), r;
          }
          return this._curve || i(this._segment) || i(this._segment1) || i(this._segment2.getPrevious());
        },
        getPath: function() {
          var t = this.getCurve();
          return t && t._path;
        },
        getIndex: function() {
          var t = this.getCurve();
          return t && t.getIndex();
        },
        getTime: function() {
          var t = this.getCurve(), e = this._time;
          return t && e == null ? this._time = t.getTimeOf(this._point) : e;
        },
        getParameter: "#getTime",
        getPoint: function() {
          return this._point;
        },
        getOffset: function() {
          var t = this._offset;
          if (t == null) {
            t = 0;
            var e = this.getPath(), i = this.getIndex();
            if (e && i != null)
              for (var n = e.getCurves(), r = 0; r < i; r++)
                t += n[r].getLength();
            this._offset = t += this.getCurveOffset();
          }
          return t;
        },
        getCurveOffset: function() {
          var t = this._curveOffset;
          if (t == null) {
            var e = this.getCurve(), i = this.getTime();
            this._curveOffset = t = i != null && e && e.getPartLength(0, i);
          }
          return t;
        },
        getIntersection: function() {
          return this._intersection;
        },
        getDistance: function() {
          return this._distance;
        },
        divide: function() {
          var t = this.getCurve(), e = t && t.divideAtTime(this.getTime());
          return e && this._setSegment(e._segment1), e;
        },
        split: function() {
          var t = this.getCurve(), e = t._path, i = t && t.splitAtTime(this.getTime());
          return i && this._setSegment(e.getLastSegment()), i;
        },
        equals: function(t, e) {
          var i = this === t;
          if (!i && t instanceof le) {
            var n = this.getCurve(), r = t.getCurve(), s = n._path, u = r._path;
            if (s === u) {
              var a = Math.abs, o = 1e-7, h = a(this.getOffset() - t.getOffset()), d = !e && this._intersection, g = !e && t._intersection;
              i = (h < o || s && a(s.getLength() - h) < o) && (!d && !g || d && g && d.equals(g, !0));
            }
          }
          return i;
        },
        toString: function() {
          var t = [], e = this.getPoint(), i = St.instance;
          e && t.push("point: " + e);
          var n = this.getIndex();
          n != null && t.push("index: " + n);
          var r = this.getTime();
          return r != null && t.push("time: " + i.number(r)), this._distance != null && t.push("distance: " + i.number(this._distance)), "{ " + t.join(", ") + " }";
        },
        isTouching: function() {
          var t = this._intersection;
          if (t && this.getTangent().isCollinear(t.getTangent())) {
            var e = this.getCurve(), i = t.getCurve();
            return !(e.isStraight() && i.isStraight() && e.getLine().intersect(i.getLine()));
          }
          return !1;
        },
        isCrossing: function() {
          var t = this._intersection;
          if (!t)
            return !1;
          var e = this.getTime(), i = t.getTime(), n = 1e-8, r = 1 - n, s = e >= n && e <= r, u = i >= n && i <= r;
          if (s && u)
            return !this.isTouching();
          var a = this.getCurve(), o = a && e < n ? a.getPrevious() : a, h = t.getCurve(), d = h && i < n ? h.getPrevious() : h;
          if (e > r && (a = a.getNext()), i > r && (h = h.getNext()), !o || !a || !d || !h)
            return !1;
          var g = [];
          function c(C, I) {
            var M = C.getValues(), k = j.classify(M).roots || j.getPeaks(M), P = k.length, O = j.getLength(
              M,
              I && P ? k[P - 1] : 0,
              !I && P ? k[0] : 1
            );
            g.push(P ? O : O / 32);
          }
          function f(C, I, M) {
            return I < M ? C > I && C < M : C > I || C < M;
          }
          s || (c(o, !0), c(a, !1)), u || (c(d, !0), c(h, !1));
          var b = this.getPoint(), v = Math.min.apply(Math, g), x = s ? a.getTangentAtTime(e) : a.getPointAt(v).subtract(b), _ = s ? x.negate() : o.getPointAt(-v).subtract(b), m = u ? h.getTangentAtTime(i) : h.getPointAt(v).subtract(b), l = u ? m.negate() : d.getPointAt(-v).subtract(b), p = _.getAngle(), y = x.getAngle(), S = l.getAngle(), w = m.getAngle();
          return !!(s ? f(p, S, w) ^ f(y, S, w) && f(p, w, S) ^ f(y, w, S) : f(S, p, y) ^ f(w, p, y) && f(S, y, p) ^ f(w, y, p));
        },
        hasOverlap: function() {
          return !!this._overlap;
        }
      },
      T.each(j._evaluateMethods, function(t) {
        var e = t + "At";
        this[t] = function() {
          var i = this.getCurve(), n = this.getTime();
          return n != null && i && i[e](n, !0);
        };
      }, {
        preserve: !0
      }),
      new function() {
        function t(e, i, n) {
          var r = e.length, s = 0, u = r - 1;
          function a(b, v) {
            for (var x = b + v; x >= -1 && x <= r; x += v) {
              var _ = e[(x % r + r) % r];
              if (!i.getPoint().isClose(
                _.getPoint(),
                1e-7
              ))
                break;
              if (i.equals(_))
                return _;
            }
            return null;
          }
          for (; s <= u; ) {
            var o = s + u >>> 1, h = e[o], d;
            if (n && (d = i.equals(h) ? h : a(o, -1) || a(o, 1)))
              return i._overlap && (d._overlap = d._intersection._overlap = !0), d;
            var g = i.getPath(), c = h.getPath(), f = g !== c ? g._id - c._id : i.getIndex() + i.getTime() - (h.getIndex() + h.getTime());
            f < 0 ? u = o - 1 : s = o + 1;
          }
          return e.splice(s, 0, i), i;
        }
        return { statics: {
          insert: t,
          expand: function(e) {
            for (var i = e.slice(), n = e.length - 1; n >= 0; n--)
              t(i, e[n]._intersection, !1);
            return i;
          }
        } };
      }()
    ), Ae = ft.extend({
      _class: "PathItem",
      _selectBounds: !1,
      _canScaleStroke: !0,
      beans: !0,
      initialize: function() {
      },
      statics: {
        create: function(t) {
          var e, i, n;
          if (T.isPlainObject(t) ? (i = t.segments, e = t.pathData) : Array.isArray(t) ? i = t : typeof t == "string" && (e = t), i) {
            var r = i[0];
            n = r && Array.isArray(r[0]);
          } else
            e && (n = (e.match(/m/gi) || []).length > 1 || /z\s*\S+/i.test(e));
          var s = n ? fe : pt;
          return new s(t);
        }
      },
      _asPathItem: function() {
        return this;
      },
      isClockwise: function() {
        return this.getArea() >= 0;
      },
      setClockwise: function(t) {
        this.isClockwise() != (t = !!t) && this.reverse();
      },
      setPathData: function(t) {
        var e = t && t.match(/[mlhvcsqtaz][^mlhvcsqtaz]*/ig), i, n = !1, r, s, u = new E(), a = new E();
        function o(l, p) {
          var y = +i[l];
          return n && (y += u[p]), y;
        }
        function h(l) {
          return new E(
            o(l, "x"),
            o(l + 1, "y")
          );
        }
        this.clear();
        for (var d = 0, g = e && e.length; d < g; d++) {
          var c = e[d], f = c[0], b = f.toLowerCase();
          i = c.match(/[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g);
          var v = i && i.length;
          switch (n = f === b, r === "z" && !/[mz]/.test(b) && this.moveTo(u), b) {
            case "m":
            case "l":
              for (var x = b === "m", _ = 0; _ < v; _ += 2)
                this[x ? "moveTo" : "lineTo"](u = h(_)), x && (a = u, x = !1);
              s = u;
              break;
            case "h":
            case "v":
              var m = b === "h" ? "x" : "y";
              u = u.clone();
              for (var _ = 0; _ < v; _++)
                u[m] = o(_, m), this.lineTo(u);
              s = u;
              break;
            case "c":
              for (var _ = 0; _ < v; _ += 6)
                this.cubicCurveTo(
                  h(_),
                  s = h(_ + 2),
                  u = h(_ + 4)
                );
              break;
            case "s":
              for (var _ = 0; _ < v; _ += 4)
                this.cubicCurveTo(
                  /[cs]/.test(r) ? u.multiply(2).subtract(s) : u,
                  s = h(_),
                  u = h(_ + 2)
                ), r = b;
              break;
            case "q":
              for (var _ = 0; _ < v; _ += 4)
                this.quadraticCurveTo(
                  s = h(_),
                  u = h(_ + 2)
                );
              break;
            case "t":
              for (var _ = 0; _ < v; _ += 2)
                this.quadraticCurveTo(
                  s = /[qt]/.test(r) ? u.multiply(2).subtract(s) : u,
                  u = h(_)
                ), r = b;
              break;
            case "a":
              for (var _ = 0; _ < v; _ += 7)
                this.arcTo(
                  u = h(_ + 5),
                  new W(+i[_], +i[_ + 1]),
                  +i[_ + 2],
                  +i[_ + 4],
                  +i[_ + 3]
                );
              break;
            case "z":
              this.closePath(1e-12), u = a;
              break;
          }
          r = b;
        }
      },
      _canComposite: function() {
        return !(this.hasFill() && this.hasStroke());
      },
      _contains: function(t) {
        var e = t.isInside(
          this.getBounds({ internal: !0, handle: !0 })
        ) ? this._getWinding(t) : {};
        return e.onPath || !!(this.getFillRule() === "evenodd" ? e.windingL & 1 || e.windingR & 1 : e.winding);
      },
      getIntersections: function(t, e, i, n) {
        var r = this === t || !t, s = this._matrix._orNullIfIdentity(), u = r ? s : (i || t._matrix)._orNullIfIdentity();
        return r || this.getBounds(s).intersects(
          t.getBounds(u),
          1e-12
        ) ? j.getIntersections(
          this.getCurves(),
          !r && t.getCurves(),
          e,
          s,
          u,
          n
        ) : [];
      },
      getCrossings: function(t) {
        return this.getIntersections(t, function(e) {
          return e.isCrossing();
        });
      },
      getNearestLocation: function() {
        for (var t = E.read(arguments), e = this.getCurves(), i = 1 / 0, n = null, r = 0, s = e.length; r < s; r++) {
          var u = e[r].getNearestLocation(t);
          u._distance < i && (i = u._distance, n = u);
        }
        return n;
      },
      getNearestPoint: function() {
        var t = this.getNearestLocation.apply(this, arguments);
        return t && t.getPoint();
      },
      interpolate: function(t, e, i) {
        var n = !this._children, r = n ? "_segments" : "_children", s = t[r], u = e[r], a = this[r];
        if (!s || !u || s.length !== u.length)
          throw new Error("Invalid operands in interpolate() call: " + t + ", " + e);
        var o = a.length, h = u.length;
        if (o < h)
          for (var d = n ? it : pt, g = o; g < h; g++)
            this.add(new d());
        else
          o > h && this[n ? "removeSegments" : "removeChildren"](h, o);
        for (var g = 0; g < h; g++)
          a[g].interpolate(s[g], u[g], i);
        n && (this.setClosed(t._closed), this._changed(9));
      },
      compare: function(t) {
        var e = !1;
        if (t) {
          var i = this._children || [this], n = t._children ? t._children.slice() : [t], r = i.length, s = n.length, u = [], a = 0;
          e = !0;
          for (var o = qt.findItemBoundsCollisions(i, n, lt.GEOMETRIC_EPSILON), h = r - 1; h >= 0 && e; h--) {
            var d = i[h];
            e = !1;
            var g = o[h];
            if (g)
              for (var c = g.length - 1; c >= 0 && !e; c--)
                d.compare(n[g[c]]) && (u[g[c]] || (u[g[c]] = !0, a++), e = !0);
          }
          e = e && a === s;
        }
        return e;
      }
    }), pt = Ae.extend(
      {
        _class: "Path",
        _serializeFields: {
          segments: [],
          closed: !1
        },
        initialize: function(e) {
          this._closed = !1, this._segments = [], this._version = 0;
          var i = arguments, n = Array.isArray(e) ? typeof e[0] == "object" ? e : i : e && e.size === F && (e.x !== F || e.point !== F) ? i : null;
          n && n.length > 0 ? this.setSegments(n) : (this._curves = F, this._segmentSelection = 0, !n && typeof e == "string" && (this.setPathData(e), e = null)), this._initialize(!n && e);
        },
        _equals: function(t) {
          return this._closed === t._closed && T.equals(this._segments, t._segments);
        },
        copyContent: function(t) {
          this.setSegments(t._segments), this._closed = t._closed;
        },
        _changed: function t(e) {
          if (t.base.call(this, e), e & 8) {
            if (this._length = this._area = F, e & 32)
              this._version++;
            else if (this._curves)
              for (var i = 0, n = this._curves.length; i < n; i++)
                this._curves[i]._changed();
          } else
            e & 64 && (this._bounds = F);
        },
        getStyle: function() {
          var t = this._parent;
          return (t instanceof fe ? t : this)._style;
        },
        getSegments: function() {
          return this._segments;
        },
        setSegments: function(t) {
          var e = this.isFullySelected(), i = t && t.length;
          if (this._segments.length = 0, this._segmentSelection = 0, this._curves = F, i) {
            var n = t[i - 1];
            typeof n == "boolean" && (this.setClosed(n), i--), this._add(it.readList(t, 0, {}, i));
          }
          e && this.setFullySelected(!0);
        },
        getFirstSegment: function() {
          return this._segments[0];
        },
        getLastSegment: function() {
          return this._segments[this._segments.length - 1];
        },
        getCurves: function() {
          var t = this._curves, e = this._segments;
          if (!t) {
            var i = this._countCurves();
            t = this._curves = new Array(i);
            for (var n = 0; n < i; n++)
              t[n] = new j(
                this,
                e[n],
                e[n + 1] || e[0]
              );
          }
          return t;
        },
        getFirstCurve: function() {
          return this.getCurves()[0];
        },
        getLastCurve: function() {
          var t = this.getCurves();
          return t[t.length - 1];
        },
        isClosed: function() {
          return this._closed;
        },
        setClosed: function(t) {
          if (this._closed != (t = !!t)) {
            if (this._closed = t, this._curves) {
              var e = this._curves.length = this._countCurves();
              t && (this._curves[e - 1] = new j(
                this,
                this._segments[e - 1],
                this._segments[0]
              ));
            }
            this._changed(41);
          }
        }
      },
      {
        beans: !0,
        getPathData: function(t, e) {
          var i = this._segments, n = i.length, r = new St(e), s = new Array(6), u = !0, a, o, h, d, g, c, f, b, v = [];
          function x(m, l) {
            if (m._transformCoordinates(t, s), a = s[0], o = s[1], u)
              v.push("M" + r.pair(a, o)), u = !1;
            else if (g = s[2], c = s[3], g === a && c === o && f === h && b === d) {
              if (!l) {
                var p = a - h, y = o - d;
                v.push(
                  p === 0 ? "v" + r.number(y) : y === 0 ? "h" + r.number(p) : "l" + r.pair(p, y)
                );
              }
            } else
              v.push("c" + r.pair(f - h, b - d) + " " + r.pair(g - h, c - d) + " " + r.pair(a - h, o - d));
            h = a, d = o, f = s[4], b = s[5];
          }
          if (!n)
            return "";
          for (var _ = 0; _ < n; _++)
            x(i[_]);
          return this._closed && n > 0 && (x(i[0], !0), v.push("z")), v.join("");
        },
        isEmpty: function() {
          return !this._segments.length;
        },
        _transformContent: function(t) {
          for (var e = this._segments, i = new Array(6), n = 0, r = e.length; n < r; n++)
            e[n]._transformCoordinates(t, i, !0);
          return !0;
        },
        _add: function(t, u) {
          for (var i = this._segments, n = this._curves, r = t.length, s = u == null, u = s ? i.length : u, a = 0; a < r; a++) {
            var o = t[a];
            o._path && (o = t[a] = o.clone()), o._path = this, o._index = u + a, o._selection && this._updateSelection(o, 0, o._selection);
          }
          if (s)
            T.push(i, t);
          else {
            i.splice.apply(i, [u, 0].concat(t));
            for (var a = u + r, h = i.length; a < h; a++)
              i[a]._index = a;
          }
          if (n) {
            var d = this._countCurves(), g = u > 0 && u + r - 1 === d ? u - 1 : u, c = g, f = Math.min(g + r, d);
            t._curves && (n.splice.apply(n, [g, 0].concat(t._curves)), c += t._curves.length);
            for (var a = c; a < f; a++)
              n.splice(a, 0, new j(this, null, null));
            this._adjustCurves(g, f);
          }
          return this._changed(41), t;
        },
        _adjustCurves: function(t, e) {
          for (var i = this._segments, n = this._curves, r, s = t; s < e; s++)
            r = n[s], r._path = this, r._segment1 = i[s], r._segment2 = i[s + 1] || i[0], r._changed();
          (r = n[this._closed && !t ? i.length - 1 : t - 1]) && (r._segment2 = i[t] || i[0], r._changed()), (r = n[e]) && (r._segment1 = i[e], r._changed());
        },
        _countCurves: function() {
          var t = this._segments.length;
          return !this._closed && t > 0 ? t - 1 : t;
        },
        add: function(t) {
          var e = arguments;
          return e.length > 1 && typeof t != "number" ? this._add(it.readList(e)) : this._add([it.read(e)])[0];
        },
        insert: function(t, e) {
          var i = arguments;
          return i.length > 2 && typeof e != "number" ? this._add(it.readList(i, 1), t) : this._add([it.read(i, 1)], t)[0];
        },
        addSegment: function() {
          return this._add([it.read(arguments)])[0];
        },
        insertSegment: function(t) {
          return this._add([it.read(arguments, 1)], t)[0];
        },
        addSegments: function(t) {
          return this._add(it.readList(t));
        },
        insertSegments: function(t, e) {
          return this._add(it.readList(e), t);
        },
        removeSegment: function(t) {
          return this.removeSegments(t, t + 1)[0] || null;
        },
        removeSegments: function(t, e, i) {
          t = t || 0, e = T.pick(e, this._segments.length);
          var n = this._segments, r = this._curves, s = n.length, u = n.splice(t, e - t), a = u.length;
          if (!a)
            return u;
          for (var o = 0; o < a; o++) {
            var h = u[o];
            h._selection && this._updateSelection(h, h._selection, 0), h._index = h._path = null;
          }
          for (var o = t, d = n.length; o < d; o++)
            n[o]._index = o;
          if (r) {
            for (var g = t > 0 && e === s + (this._closed ? 1 : 0) ? t - 1 : t, r = r.splice(g, a), o = r.length - 1; o >= 0; o--)
              r[o]._path = null;
            i && (u._curves = r.slice(1)), this._adjustCurves(g, g);
          }
          return this._changed(41), u;
        },
        clear: "#removeSegments",
        hasHandles: function() {
          for (var t = this._segments, e = 0, i = t.length; e < i; e++)
            if (t[e].hasHandles())
              return !0;
          return !1;
        },
        clearHandles: function() {
          for (var t = this._segments, e = 0, i = t.length; e < i; e++)
            t[e].clearHandles();
        },
        getLength: function() {
          if (this._length == null) {
            for (var t = this.getCurves(), e = 0, i = 0, n = t.length; i < n; i++)
              e += t[i].getLength();
            this._length = e;
          }
          return this._length;
        },
        getArea: function() {
          var t = this._area;
          if (t == null) {
            var e = this._segments, i = this._closed;
            t = 0;
            for (var n = 0, r = e.length; n < r; n++) {
              var s = n + 1 === r;
              t += j.getArea(j.getValues(
                e[n],
                e[s ? 0 : n + 1],
                null,
                s && !i
              ));
            }
            this._area = t;
          }
          return t;
        },
        isFullySelected: function() {
          var t = this._segments.length;
          return this.isSelected() && t > 0 && this._segmentSelection === t * 7;
        },
        setFullySelected: function(t) {
          t && this._selectSegments(!0), this.setSelected(t);
        },
        setSelection: function t(e) {
          e & 1 || this._selectSegments(!1), t.base.call(this, e);
        },
        _selectSegments: function(t) {
          var e = this._segments, i = e.length, n = t ? 7 : 0;
          this._segmentSelection = n * i;
          for (var r = 0; r < i; r++)
            e[r]._selection = n;
        },
        _updateSelection: function(t, e, i) {
          t._selection = i;
          var n = this._segmentSelection += i - e;
          n > 0 && this.setSelected(!0);
        },
        divideAt: function(t) {
          var e = this.getLocationAt(t), i;
          return e && (i = e.getCurve().divideAt(e.getCurveOffset())) ? i._segment1 : null;
        },
        splitAt: function(t) {
          var e = this.getLocationAt(t), i = e && e.index, n = e && e.time, r = 1e-8, s = 1 - r;
          n > s && (i++, n = 0);
          var u = this.getCurves();
          if (i >= 0 && i < u.length) {
            n >= r && u[i++].divideAtTime(n);
            var a = this.removeSegments(i, this._segments.length, !0), o;
            return this._closed ? (this.setClosed(!1), o = this) : (o = new pt(ft.NO_INSERT), o.insertAbove(this), o.copyAttributes(this)), o._add(a, 0), this.addSegment(a[0]), o;
          }
          return null;
        },
        split: function(t, e) {
          var i, n = e === F ? t : (i = this.getCurves()[t]) && i.getLocationAtTime(e);
          return n != null ? this.splitAt(n) : null;
        },
        join: function(t, e) {
          var i = e || 0;
          if (t && t !== this) {
            var n = t._segments, r = this.getLastSegment(), s = t.getLastSegment();
            if (!s)
              return this;
            r && r._point.isClose(s._point, i) && t.reverse();
            var u = t.getFirstSegment();
            if (r && r._point.isClose(u._point, i))
              r.setHandleOut(u._handleOut), this._add(n.slice(1));
            else {
              var a = this.getFirstSegment();
              a && a._point.isClose(u._point, i) && t.reverse(), s = t.getLastSegment(), a && a._point.isClose(s._point, i) ? (a.setHandleIn(s._handleIn), this._add(n.slice(0, n.length - 1), 0)) : this._add(n.slice());
            }
            t._closed && this._add([n[0]]), t.remove();
          }
          var o = this.getFirstSegment(), h = this.getLastSegment();
          return o !== h && o._point.isClose(h._point, i) && (o.setHandleIn(h._handleIn), h.remove(), this.setClosed(!0)), this;
        },
        reduce: function(t) {
          for (var e = this.getCurves(), i = t && t.simplify, n = i ? 1e-7 : 0, r = e.length - 1; r >= 0; r--) {
            var s = e[r];
            !s.hasHandles() && (!s.hasLength(n) || i && s.isCollinear(s.getNext())) && s.remove();
          }
          return this;
        },
        reverse: function() {
          this._segments.reverse();
          for (var t = 0, e = this._segments.length; t < e; t++) {
            var i = this._segments[t], n = i._handleIn;
            i._handleIn = i._handleOut, i._handleOut = n, i._index = t;
          }
          this._curves = null, this._changed(9);
        },
        flatten: function(t) {
          for (var e = new Si(this, t || 0.25, 256, !0), i = e.parts, n = i.length, r = [], s = 0; s < n; s++)
            r.push(new it(i[s].curve.slice(0, 2)));
          !this._closed && n > 0 && r.push(new it(i[n - 1].curve.slice(6))), this.setSegments(r);
        },
        simplify: function(t) {
          var e = new Ji(this).fit(t || 2.5);
          return e && this.setSegments(e), !!e;
        },
        smooth: function(t) {
          var e = this, i = t || {}, n = i.type || "asymmetric", r = this._segments, s = r.length, u = this._closed;
          function a(J, rt) {
            var nt = J && J.index;
            if (nt != null) {
              var ot = J.path;
              if (ot && ot !== e)
                throw new Error(J._class + " " + nt + " of " + ot + " is not part of " + e);
              rt && J instanceof j && nt++;
            } else
              nt = typeof J == "number" ? J : rt;
            return Math.min(nt < 0 && u ? nt % s : nt < 0 ? nt + s : nt, s - 1);
          }
          var o = u && i.from === F && i.to === F, h = a(i.from, 0), d = a(i.to, s - 1);
          if (h > d)
            if (u)
              h -= s;
            else {
              var g = h;
              h = d, d = g;
            }
          if (/^(?:asymmetric|continuous)$/.test(n)) {
            var c = n === "asymmetric", f = Math.min, b = d - h + 1, v = b - 1, x = o ? f(b, 4) : 1, _ = x, m = x, l = [];
            if (u || (_ = f(1, h), m = f(1, s - d - 1)), v += _ + m, v <= 1)
              return;
            for (var p = 0, y = h - _; p <= v; p++, y++)
              l[p] = r[(y < 0 ? y + s : y) % s]._point;
            for (var S = l[0]._x + 2 * l[1]._x, w = l[0]._y + 2 * l[1]._y, C = 2, I = v - 1, M = [S], k = [w], P = [C], O = [], L = [], p = 1; p < v; p++) {
              var B = p < I, N = B || c ? 1 : 2, D = B ? 4 : c ? 2 : 7, Z = B ? 4 : c ? 3 : 8, G = B ? 2 : c ? 0 : 1, Y = N / C;
              C = P[p] = D - Y, S = M[p] = Z * l[p]._x + G * l[p + 1]._x - Y * S, w = k[p] = Z * l[p]._y + G * l[p + 1]._y - Y * w;
            }
            O[I] = M[I] / P[I], L[I] = k[I] / P[I];
            for (var p = v - 2; p >= 0; p--)
              O[p] = (M[p] - O[p + 1]) / P[p], L[p] = (k[p] - L[p + 1]) / P[p];
            O[v] = (3 * l[v]._x - O[I]) / 2, L[v] = (3 * l[v]._y - L[I]) / 2;
            for (var p = _, X = v - m, y = h; p <= X; p++, y++) {
              var V = r[y < 0 ? y + s : y], U = V._point, K = O[p] - U._x, Q = L[p] - U._y;
              (o || p < X) && V.setHandleOut(K, Q), (o || p > _) && V.setHandleIn(-K, -Q);
            }
          } else
            for (var p = h; p <= d; p++)
              r[p < 0 ? p + s : p].smooth(
                i,
                !o && p === h,
                !o && p === d
              );
        },
        toShape: function(t) {
          if (!this._closed)
            return null;
          var e = this._segments, i, n, r, s;
          function u(c, f) {
            var b = e[c], v = b.getNext(), x = e[f], _ = x.getNext();
            return b._handleOut.isZero() && v._handleIn.isZero() && x._handleOut.isZero() && _._handleIn.isZero() && v._point.subtract(b._point).isCollinear(
              _._point.subtract(x._point)
            );
          }
          function a(c) {
            var f = e[c], b = f.getPrevious(), v = f.getNext();
            return b._handleOut.isZero() && f._handleIn.isZero() && f._handleOut.isZero() && v._handleIn.isZero() && f._point.subtract(b._point).isOrthogonal(
              v._point.subtract(f._point)
            );
          }
          function o(c) {
            var f = e[c], b = f.getNext(), v = f._handleOut, x = b._handleIn, _ = 0.5522847498307936;
            if (v.isOrthogonal(x)) {
              var m = f._point, l = b._point, p = new Et(m, v, !0).intersect(
                new Et(l, x, !0),
                !0
              );
              return p && lt.isZero(v.getLength() / p.subtract(m).getLength() - _) && lt.isZero(x.getLength() / p.subtract(l).getLength() - _);
            }
            return !1;
          }
          function h(c, f) {
            return e[c]._point.getDistance(e[f]._point);
          }
          if (!this.hasHandles() && e.length === 4 && u(0, 2) && u(1, 3) && a(1) ? (i = It.Rectangle, n = new W(h(0, 3), h(0, 1)), s = e[1]._point.add(e[2]._point).divide(2)) : e.length === 8 && o(0) && o(2) && o(4) && o(6) && u(1, 5) && u(3, 7) ? (i = It.Rectangle, n = new W(h(1, 6), h(0, 3)), r = n.subtract(new W(
            h(0, 7),
            h(1, 2)
          )).divide(2), s = e[3]._point.add(e[4]._point).divide(2)) : e.length === 4 && o(0) && o(1) && o(2) && o(3) && (lt.isZero(h(0, 2) - h(1, 3)) ? (i = It.Circle, r = h(0, 2) / 2) : (i = It.Ellipse, r = new W(h(2, 0) / 2, h(3, 1) / 2)), s = e[1]._point), i) {
            var d = this.getPosition(!0), g = new i({
              center: d,
              size: n,
              radius: r,
              insert: !1
            });
            return g.copyAttributes(this, !0), g._matrix.prepend(this._matrix), g.rotate(s.subtract(d).getAngle() + 90), (t === F || t) && g.insertAbove(this), g;
          }
          return null;
        },
        toPath: "#clone",
        compare: function t(e) {
          if (!e || e instanceof fe)
            return t.base.call(this, e);
          var i = this.getCurves(), n = e.getCurves(), r = i.length, s = n.length;
          if (!r || !s)
            return r == s;
          for (var u = i[0].getValues(), a = [], o = 0, h, d = 0, g, c = 0; c < s; c++) {
            var x = n[c].getValues();
            a.push(x);
            var f = j.getOverlaps(u, x);
            if (f) {
              h = !c && f[0][0] > 0 ? s - 1 : c, g = f[0][1];
              break;
            }
          }
          for (var b = Math.abs, v = 1e-8, x = a[h], _; u && x; ) {
            var f = j.getOverlaps(u, x);
            if (f) {
              var m = f[0][0];
              if (b(m - d) < v) {
                d = f[1][0], d === 1 && (u = ++o < r ? i[o].getValues() : null, d = 0);
                var l = f[0][1];
                if (b(l - g) < v) {
                  if (_ || (_ = [h, l]), g = f[1][1], g === 1 && (++h >= s && (h = 0), x = a[h] || n[h].getValues(), g = 0), !u)
                    return _[0] === h && _[1] === g;
                  continue;
                }
              }
            }
            break;
          }
          return !1;
        },
        _hitTestSelf: function(t, e, i, n) {
          var r = this, s = this.getStyle(), u = this._segments, a = u.length, o = this._closed, h = e._tolerancePadding, d = h, g, c, f, b, v, x, _ = e.stroke && s.hasStroke(), m = e.fill && s.hasFill(), l = e.curves, p = _ ? s.getStrokeWidth() / 2 : m && e.tolerance > 0 || l ? 0 : null;
          p !== null && (p > 0 ? (g = s.getStrokeJoin(), c = s.getStrokeCap(), f = s.getMiterLimit(), d = d.add(
            pt._getStrokePadding(p, n)
          )) : g = c = "round");
          function y(O, L) {
            return t.subtract(O).divide(L).length <= 1;
          }
          function S(O, L, B) {
            if (!e.selected || L.isSelected()) {
              var N = O._point;
              if (L !== N && (L = L.add(N)), y(L, d))
                return new ie(B, r, {
                  segment: O,
                  point: L
                });
            }
          }
          function w(O, L) {
            return (L || e.segments) && S(O, O._point, "segment") || !L && e.handles && (S(O, O._handleIn, "handle-in") || S(O, O._handleOut, "handle-out"));
          }
          function C(O) {
            b.add(O);
          }
          function I(O) {
            var L = o || O._index > 0 && O._index < a - 1;
            if ((L ? g : c) === "round")
              return y(O._point, d);
            if (b = new pt({ internal: !0, closed: !0 }), L ? O.isSmooth() || pt._addBevelJoin(
              O,
              g,
              p,
              f,
              null,
              n,
              C,
              !0
            ) : c === "square" && pt._addSquareCap(
              O,
              c,
              p,
              null,
              n,
              C,
              !0
            ), !b.isEmpty()) {
              var B;
              return b.contains(t) || (B = b.getNearestLocation(t)) && y(B.getPoint(), h);
            }
          }
          if (e.ends && !e.segments && !o) {
            if (x = w(u[0], !0) || w(u[a - 1], !0))
              return x;
          } else if (e.segments || e.handles) {
            for (var M = 0; M < a; M++)
              if (x = w(u[M]))
                return x;
          }
          if (p !== null) {
            if (v = this.getNearestLocation(t), v) {
              var k = v.getTime();
              k === 0 || k === 1 && a > 1 ? I(v.getSegment()) || (v = null) : y(v.getPoint(), d) || (v = null);
            }
            if (!v && g === "miter" && a > 1)
              for (var M = 0; M < a; M++) {
                var P = u[M];
                if (t.getDistance(P._point) <= f * p && I(P)) {
                  v = P.getLocation();
                  break;
                }
              }
          }
          return !v && m && this._contains(t) || v && !_ && !l ? new ie("fill", this) : v ? new ie(_ ? "stroke" : "curve", this, {
            location: v,
            point: v.getPoint()
          }) : null;
        }
      },
      T.each(
        j._evaluateMethods,
        function(t) {
          this[t + "At"] = function(e) {
            var i = this.getLocationAt(e);
            return i && i[t]();
          };
        },
        {
          beans: !1,
          getLocationOf: function() {
            for (var t = E.read(arguments), e = this.getCurves(), i = 0, n = e.length; i < n; i++) {
              var r = e[i].getLocationOf(t);
              if (r)
                return r;
            }
            return null;
          },
          getOffsetOf: function() {
            var t = this.getLocationOf.apply(this, arguments);
            return t ? t.getOffset() : null;
          },
          getLocationAt: function(t) {
            if (typeof t == "number") {
              for (var e = this.getCurves(), i = 0, n = 0, r = e.length; n < r; n++) {
                var s = i, u = e[n];
                if (i += u.getLength(), i > t)
                  return u.getLocationAt(t - s);
              }
              if (e.length > 0 && t <= this.getLength())
                return new le(e[e.length - 1], 1);
            } else if (t && t.getPath && t.getPath() === this)
              return t;
            return null;
          },
          getOffsetsWithTangent: function() {
            var t = E.read(arguments);
            if (t.isZero())
              return [];
            for (var e = [], i = 0, n = this.getCurves(), r = 0, s = n.length; r < s; r++) {
              for (var u = n[r], a = u.getTimesWithTangent(t), o = 0, h = a.length; o < h; o++) {
                var d = i + u.getOffsetAtTime(a[o]);
                e.indexOf(d) < 0 && e.push(d);
              }
              i += u.length;
            }
            return e;
          }
        }
      ),
      new function() {
        function t(i, n, r, s) {
          if (s <= 0)
            return;
          var u = s / 2, a = s - 2, o = u - 1, h = new Array(6), d, g;
          function c(m) {
            var l = h[m], p = h[m + 1];
            (d != l || g != p) && (i.beginPath(), i.moveTo(d, g), i.lineTo(l, p), i.stroke(), i.beginPath(), i.arc(l, p, u, 0, Math.PI * 2, !0), i.fill());
          }
          for (var f = 0, b = n.length; f < b; f++) {
            var v = n[f], x = v._selection;
            if (v._transformCoordinates(r, h), d = h[0], g = h[1], x & 2 && c(2), x & 4 && c(4), i.fillRect(d - u, g - u, s, s), a > 0 && !(x & 1)) {
              var _ = i.fillStyle;
              i.fillStyle = "#ffffff", i.fillRect(d - o, g - o, a, a), i.fillStyle = _;
            }
          }
        }
        function e(i, n, r) {
          var s = n._segments, u = s.length, a = new Array(6), o = !0, h, d, g, c, f, b, v, x;
          function _(l) {
            if (r)
              l._transformCoordinates(r, a), h = a[0], d = a[1];
            else {
              var p = l._point;
              h = p._x, d = p._y;
            }
            if (o)
              i.moveTo(h, d), o = !1;
            else {
              if (r)
                f = a[2], b = a[3];
              else {
                var y = l._handleIn;
                f = h + y._x, b = d + y._y;
              }
              f === h && b === d && v === g && x === c ? i.lineTo(h, d) : i.bezierCurveTo(v, x, f, b, h, d);
            }
            if (g = h, c = d, r)
              v = a[4], x = a[5];
            else {
              var y = l._handleOut;
              v = g + y._x, x = c + y._y;
            }
          }
          for (var m = 0; m < u; m++)
            _(s[m]);
          n._closed && u > 0 && _(s[0]);
        }
        return {
          _draw: function(i, n, r, s) {
            var u = n.dontStart, a = n.dontFinish || n.clip, o = this.getStyle(), h = o.hasFill(), d = o.hasStroke(), g = o.getDashArray(), c = !_t.support.nativeDash && d && g && g.length;
            u || i.beginPath(), (h || d && !c || a) && (e(i, this, s), this._closed && i.closePath());
            function f(l) {
              return g[(l % c + c) % c];
            }
            if (!a && (h || d) && (this._setStyles(i, n, r), h && (i.fill(o.getFillRule()), i.shadowColor = "rgba(0,0,0,0)"), d)) {
              if (c) {
                u || i.beginPath();
                for (var b = new Si(
                  this,
                  0.25,
                  32,
                  !1,
                  s
                ), v = b.length, x = -o.getDashOffset(), _, m = 0; x > 0; )
                  x -= f(m--) + f(m--);
                for (; x < v; )
                  _ = x + f(m++), (x > 0 || _ > 0) && b.drawPart(
                    i,
                    Math.max(x, 0),
                    Math.max(_, 0)
                  ), x = _ + f(m++);
              }
              i.stroke();
            }
          },
          _drawSelected: function(i, n) {
            i.beginPath(), e(i, this, n), i.stroke(), t(i, this._segments, n, _t.settings.handleSize);
          }
        };
      }(),
      new function() {
        function t(e) {
          var i = e._segments;
          if (!i.length)
            throw new Error("Use a moveTo() command first");
          return i[i.length - 1];
        }
        return {
          moveTo: function() {
            var e = this._segments;
            e.length === 1 && this.removeSegment(0), e.length || this._add([new it(E.read(arguments))]);
          },
          moveBy: function() {
            throw new Error("moveBy() is unsupported on Path items.");
          },
          lineTo: function() {
            this._add([new it(E.read(arguments))]);
          },
          cubicCurveTo: function() {
            var e = arguments, i = E.read(e), n = E.read(e), r = E.read(e), s = t(this);
            s.setHandleOut(i.subtract(s._point)), this._add([new it(r, n.subtract(r))]);
          },
          quadraticCurveTo: function() {
            var e = arguments, i = E.read(e), n = E.read(e), r = t(this)._point;
            this.cubicCurveTo(
              i.add(r.subtract(i).multiply(1 / 3)),
              i.add(n.subtract(i).multiply(1 / 3)),
              n
            );
          },
          curveTo: function() {
            var e = arguments, i = E.read(e), n = E.read(e), r = T.pick(T.read(e), 0.5), s = 1 - r, u = t(this)._point, a = i.subtract(u.multiply(s * s)).subtract(n.multiply(r * r)).divide(2 * r * s);
            if (a.isNaN())
              throw new Error(
                "Cannot put a curve through points with parameter = " + r
              );
            this.quadraticCurveTo(a, n);
          },
          arcTo: function() {
            var e = arguments, i = Math.abs, n = Math.sqrt, r = t(this), s = r._point, u = E.read(e), a, o = T.peek(e), h = T.pick(o, !0), d, g, c, f;
            if (typeof h == "boolean")
              var b = s.add(u).divide(2), a = b.add(b.subtract(s).rotate(
                h ? -90 : 90
              ));
            else if (T.remain(e) <= 2)
              a = u, u = E.read(e);
            else if (!s.equals(u)) {
              var v = W.read(e), x = lt.isZero;
              if (x(v.width) || x(v.height))
                return this.lineTo(u);
              var _ = T.read(e), h = !!T.read(e), m = !!T.read(e), b = s.add(u).divide(2), l = s.subtract(b).rotate(-_), p = l.x, y = l.y, S = i(v.width), w = i(v.height), C = S * S, I = w * w, M = p * p, k = y * y, P = n(M / C + k / I);
              if (P > 1 && (S *= P, w *= P, C = S * S, I = w * w), P = (C * I - C * k - I * M) / (C * k + I * M), i(P) < 1e-12 && (P = 0), P < 0)
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              d = new E(S * y / w, -w * p / S).multiply((m === h ? -1 : 1) * n(P)).rotate(_).add(b), f = new wt().translate(d).rotate(_).scale(S, w), c = f._inverseTransform(s), g = c.getDirectedAngle(f._inverseTransform(u)), !h && g > 0 ? g -= 360 : h && g < 0 && (g += 360);
            }
            if (a) {
              var O = new Et(
                s.add(a).divide(2),
                a.subtract(s).rotate(90),
                !0
              ), L = new Et(
                a.add(u).divide(2),
                u.subtract(a).rotate(90),
                !0
              ), B = new Et(s, u), N = B.getSide(a);
              if (d = O.intersect(L, !0), !d) {
                if (!N)
                  return this.lineTo(u);
                throw new Error(
                  "Cannot create an arc with the given arguments"
                );
              }
              c = s.subtract(d), g = c.getDirectedAngle(u.subtract(d));
              var D = B.getSide(d, !0);
              D === 0 ? g = N * i(g) : N === D && (g += g < 0 ? 360 : -360);
            }
            if (g) {
              for (var Z = 1e-5, G = i(g), Y = G >= 360 ? 4 : Math.ceil((G - Z) / 90), X = g / Y, V = X * Math.PI / 360, U = 4 / 3 * Math.sin(V) / (1 + Math.cos(V)), K = [], Q = 0; Q <= Y; Q++) {
                var l = u, J = null;
                if (Q < Y && (J = c.rotate(90).multiply(U), f ? (l = f._transformPoint(c), J = f._transformPoint(c.add(J)).subtract(l)) : l = d.add(c)), !Q)
                  r.setHandleOut(J);
                else {
                  var rt = c.rotate(-90).multiply(U);
                  f && (rt = f._transformPoint(c.add(rt)).subtract(l)), K.push(new it(l, rt, J));
                }
                c = c.rotate(X);
              }
              this._add(K);
            }
          },
          lineBy: function() {
            var e = E.read(arguments), i = t(this)._point;
            this.lineTo(i.add(e));
          },
          curveBy: function() {
            var e = arguments, i = E.read(e), n = E.read(e), r = T.read(e), s = t(this)._point;
            this.curveTo(s.add(i), s.add(n), r);
          },
          cubicCurveBy: function() {
            var e = arguments, i = E.read(e), n = E.read(e), r = E.read(e), s = t(this)._point;
            this.cubicCurveTo(
              s.add(i),
              s.add(n),
              s.add(r)
            );
          },
          quadraticCurveBy: function() {
            var e = arguments, i = E.read(e), n = E.read(e), r = t(this)._point;
            this.quadraticCurveTo(r.add(i), r.add(n));
          },
          arcBy: function() {
            var e = arguments, i = t(this)._point, n = i.add(E.read(e)), r = T.pick(T.peek(e), !0);
            typeof r == "boolean" ? this.arcTo(n, r) : this.arcTo(n, i.add(E.read(e)));
          },
          closePath: function(e) {
            this.setClosed(!0), this.join(this, e);
          }
        };
      }(),
      {
        _getBounds: function(t, e) {
          var i = e.handle ? "getHandleBounds" : e.stroke ? "getStrokeBounds" : "getBounds";
          return pt[i](this._segments, this._closed, this, t, e);
        },
        statics: {
          getBounds: function(t, e, i, n, r, s) {
            var u = t[0];
            if (!u)
              return new et();
            var a = new Array(6), o = u._transformCoordinates(n, new Array(6)), h = o.slice(0, 2), d = h.slice(), g = new Array(2);
            function c(v) {
              v._transformCoordinates(n, a);
              for (var x = 0; x < 2; x++)
                j._addBounds(
                  o[x],
                  o[x + 4],
                  a[x + 2],
                  a[x],
                  x,
                  s ? s[x] : 0,
                  h,
                  d,
                  g
                );
              var _ = o;
              o = a, a = _;
            }
            for (var f = 1, b = t.length; f < b; f++)
              c(t[f]);
            return e && c(u), new et(h[0], h[1], d[0] - h[0], d[1] - h[1]);
          },
          getStrokeBounds: function(t, e, i, n, r) {
            var s = i.getStyle(), u = s.hasStroke(), a = s.getStrokeWidth(), o = u && i._getStrokeMatrix(n, r), h = u && pt._getStrokePadding(
              a,
              o
            ), d = pt.getBounds(
              t,
              e,
              i,
              n,
              r,
              h
            );
            if (!u)
              return d;
            var g = a / 2, c = s.getStrokeJoin(), f = s.getStrokeCap(), b = s.getMiterLimit(), v = new et(new W(h));
            function x(S) {
              d = d.include(S);
            }
            function _(S) {
              d = d.unite(
                v.setCenter(S._point.transform(n))
              );
            }
            function m(S, w) {
              w === "round" || S.isSmooth() ? _(S) : pt._addBevelJoin(
                S,
                w,
                g,
                b,
                n,
                o,
                x
              );
            }
            function l(S, w) {
              w === "round" ? _(S) : pt._addSquareCap(
                S,
                w,
                g,
                n,
                o,
                x
              );
            }
            var p = t.length - (e ? 0 : 1);
            if (p > 0) {
              for (var y = 1; y < p; y++)
                m(t[y], c);
              e ? m(t[0], c) : (l(t[0], f), l(t[t.length - 1], f));
            }
            return d;
          },
          _getStrokePadding: function(t, e) {
            if (!e)
              return [t, t];
            var i = new E(t, 0).transform(e), n = new E(0, t).transform(e), r = i.getAngleInRadians(), s = i.getLength(), u = n.getLength(), a = Math.sin(r), o = Math.cos(r), h = Math.tan(r), d = Math.atan2(u * h, s), g = Math.atan2(u, h * s);
            return [
              Math.abs(s * Math.cos(d) * o + u * Math.sin(d) * a),
              Math.abs(u * Math.sin(g) * o + s * Math.cos(g) * a)
            ];
          },
          _addBevelJoin: function(t, e, i, n, r, s, u, a) {
            var o = t.getCurve(), h = o.getPrevious(), d = o.getPoint1().transform(r), g = h.getNormalAtTime(1).multiply(i).transform(s), c = o.getNormalAtTime(0).multiply(i).transform(s), f = g.getDirectedAngle(c);
            if ((f < 0 || f >= 180) && (g = g.negate(), c = c.negate()), a && u(d), u(d.add(g)), e === "miter") {
              var b = new Et(
                d.add(g),
                new E(-g.y, g.x),
                !0
              ).intersect(new Et(
                d.add(c),
                new E(-c.y, c.x),
                !0
              ), !0);
              b && d.getDistance(b) <= n * i && u(b);
            }
            u(d.add(c));
          },
          _addSquareCap: function(t, e, i, n, r, s, u) {
            var a = t._point.transform(n), o = t.getLocation(), h = o.getNormal().multiply(o.getTime() === 0 ? i : -i).transform(r);
            e === "square" && (u && (s(a.subtract(h)), s(a.add(h))), a = a.add(h.rotate(-90))), s(a.add(h)), s(a.subtract(h));
          },
          getHandleBounds: function(t, e, i, n, r) {
            var s = i.getStyle(), u = r.stroke && s.hasStroke(), a, o;
            if (u) {
              var h = i._getStrokeMatrix(n, r), d = s.getStrokeWidth() / 2, g = d;
              s.getStrokeJoin() === "miter" && (g = d * s.getMiterLimit()), s.getStrokeCap() === "square" && (g = Math.max(g, d * Math.SQRT2)), a = pt._getStrokePadding(d, h), o = pt._getStrokePadding(g, h);
            }
            for (var c = new Array(6), f = 1 / 0, b = -f, v = f, x = b, _ = 0, m = t.length; _ < m; _++) {
              var l = t[_];
              l._transformCoordinates(n, c);
              for (var p = 0; p < 6; p += 2) {
                var y = p ? a : o, S = y ? y[0] : 0, w = y ? y[1] : 0, C = c[p], I = c[p + 1], M = C - S, k = C + S, P = I - w, O = I + w;
                M < f && (f = M), k > b && (b = k), P < v && (v = P), O > x && (x = O);
              }
            }
            return new et(f, v, b - f, x - v);
          }
        }
      }
    );
    pt.inject({ statics: new function() {
      var t = 0.5522847498307936, e = [
        new it([-1, 0], [0, t], [0, -t]),
        new it([0, -1], [-t, 0], [t, 0]),
        new it([1, 0], [0, -t], [0, t]),
        new it([0, 1], [t, 0], [-t, 0])
      ];
      function i(r, s, u) {
        var a = T.getNamed(u), o = new pt(a && (a.insert == !0 ? ft.INSERT : a.insert == !1 ? ft.NO_INSERT : null));
        return o._add(r), o._closed = s, o.set(a, ft.INSERT);
      }
      function n(r, s, u) {
        for (var a = new Array(4), o = 0; o < 4; o++) {
          var h = e[o];
          a[o] = new it(
            h._point.multiply(s).add(r),
            h._handleIn.multiply(s),
            h._handleOut.multiply(s)
          );
        }
        return i(a, !0, u);
      }
      return {
        Line: function() {
          var r = arguments;
          return i([
            new it(E.readNamed(r, "from")),
            new it(E.readNamed(r, "to"))
          ], !1, r);
        },
        Circle: function() {
          var r = arguments, s = E.readNamed(r, "center"), u = T.readNamed(r, "radius");
          return n(s, new W(u), r);
        },
        Rectangle: function() {
          var r = arguments, s = et.readNamed(r, "rectangle"), u = W.readNamed(
            r,
            "radius",
            0,
            { readNull: !0 }
          ), a = s.getBottomLeft(!0), o = s.getTopLeft(!0), h = s.getTopRight(!0), d = s.getBottomRight(!0), g;
          if (!u || u.isZero())
            g = [
              new it(a),
              new it(o),
              new it(h),
              new it(d)
            ];
          else {
            u = W.min(u, s.getSize(!0).divide(2));
            var c = u.width, f = u.height, b = c * t, v = f * t;
            g = [
              new it(a.add(c, 0), null, [-b, 0]),
              new it(a.subtract(0, f), [0, v]),
              new it(o.add(0, f), null, [0, -v]),
              new it(o.add(c, 0), [-b, 0], null),
              new it(h.subtract(c, 0), null, [b, 0]),
              new it(h.add(0, f), [0, -v], null),
              new it(d.subtract(0, f), null, [0, v]),
              new it(d.subtract(c, 0), [b, 0])
            ];
          }
          return i(g, !0, r);
        },
        RoundRectangle: "#Rectangle",
        Ellipse: function() {
          var r = arguments, s = It._readEllipse(r);
          return n(s.center, s.radius, r);
        },
        Oval: "#Ellipse",
        Arc: function() {
          var r = arguments, s = E.readNamed(r, "from"), u = E.readNamed(r, "through"), a = E.readNamed(r, "to"), o = T.getNamed(r), h = new pt(o && o.insert == !1 && ft.NO_INSERT);
          return h.moveTo(s), h.arcTo(u, a), h.set(o);
        },
        RegularPolygon: function() {
          for (var r = arguments, s = E.readNamed(r, "center"), u = T.readNamed(r, "sides"), a = T.readNamed(r, "radius"), o = 360 / u, h = u % 3 === 0, d = new E(0, h ? -a : a), g = h ? -1 : 0.5, c = new Array(u), f = 0; f < u; f++)
            c[f] = new it(s.add(
              d.rotate((f + g) * o)
            ));
          return i(c, !0, r);
        },
        Star: function() {
          for (var r = arguments, s = E.readNamed(r, "center"), u = T.readNamed(r, "points") * 2, a = T.readNamed(r, "radius1"), o = T.readNamed(r, "radius2"), h = 360 / u, d = new E(0, -1), g = new Array(u), c = 0; c < u; c++)
            g[c] = new it(s.add(d.rotate(h * c).multiply(c % 2 ? o : a)));
          return i(g, !0, r);
        }
      };
    }() });
    var fe = Ae.extend(
      {
        _class: "CompoundPath",
        _serializeFields: {
          children: []
        },
        beans: !0,
        initialize: function(e) {
          this._children = [], this._namedChildren = {}, this._initialize(e) || (typeof e == "string" ? this.setPathData(e) : this.addChildren(Array.isArray(e) ? e : arguments));
        },
        insertChildren: function t(e, i) {
          var n = i, r = n[0];
          r && typeof r[0] == "number" && (n = [n]);
          for (var s = i.length - 1; s >= 0; s--) {
            var u = n[s];
            n === i && !(u instanceof pt) && (n = T.slice(n)), Array.isArray(u) ? n[s] = new pt({ segments: u, insert: !1 }) : u instanceof fe && (n.splice.apply(n, [s, 1].concat(u.removeChildren())), u.remove());
          }
          return t.base.call(this, e, n);
        },
        reduce: function t(e) {
          for (var i = this._children, n = i.length - 1; n >= 0; n--) {
            var r = i[n].reduce(e);
            r.isEmpty() && r.remove();
          }
          if (!i.length) {
            var r = new pt(ft.NO_INSERT);
            return r.copyAttributes(this), r.insertAbove(this), this.remove(), r;
          }
          return t.base.call(this);
        },
        isClosed: function() {
          for (var t = this._children, e = 0, i = t.length; e < i; e++)
            if (!t[e]._closed)
              return !1;
          return !0;
        },
        setClosed: function(t) {
          for (var e = this._children, i = 0, n = e.length; i < n; i++)
            e[i].setClosed(t);
        },
        getFirstSegment: function() {
          var t = this.getFirstChild();
          return t && t.getFirstSegment();
        },
        getLastSegment: function() {
          var t = this.getLastChild();
          return t && t.getLastSegment();
        },
        getCurves: function() {
          for (var t = this._children, e = [], i = 0, n = t.length; i < n; i++)
            T.push(e, t[i].getCurves());
          return e;
        },
        getFirstCurve: function() {
          var t = this.getFirstChild();
          return t && t.getFirstCurve();
        },
        getLastCurve: function() {
          var t = this.getLastChild();
          return t && t.getLastCurve();
        },
        getArea: function() {
          for (var t = this._children, e = 0, i = 0, n = t.length; i < n; i++)
            e += t[i].getArea();
          return e;
        },
        getLength: function() {
          for (var t = this._children, e = 0, i = 0, n = t.length; i < n; i++)
            e += t[i].getLength();
          return e;
        },
        getPathData: function(t, e) {
          for (var i = this._children, n = [], r = 0, s = i.length; r < s; r++) {
            var u = i[r], a = u._matrix;
            n.push(u.getPathData(t && !a.isIdentity() ? t.appended(a) : t, e));
          }
          return n.join("");
        },
        _hitTestChildren: function t(e, i, n) {
          return t.base.call(
            this,
            e,
            i.class === pt || i.type === "path" ? i : T.set({}, i, { fill: !1 }),
            n
          );
        },
        _draw: function(t, e, i, n) {
          var r = this._children;
          if (r.length) {
            e = e.extend({ dontStart: !0, dontFinish: !0 }), t.beginPath();
            for (var s = 0, u = r.length; s < u; s++)
              r[s].draw(t, e, n);
            if (!e.clip) {
              this._setStyles(t, e, i);
              var a = this._style;
              a.hasFill() && (t.fill(a.getFillRule()), t.shadowColor = "rgba(0,0,0,0)"), a.hasStroke() && t.stroke();
            }
          }
        },
        _drawSelected: function(t, e, i) {
          for (var n = this._children, r = 0, s = n.length; r < s; r++) {
            var u = n[r], a = u._matrix;
            i[u._id] || u._drawSelected(t, a.isIdentity() ? e : e.appended(a));
          }
        }
      },
      new function() {
        function t(e, i) {
          var n = e._children;
          if (i && !n.length)
            throw new Error("Use a moveTo() command first");
          return n[n.length - 1];
        }
        return T.each(
          [
            "lineTo",
            "cubicCurveTo",
            "quadraticCurveTo",
            "curveTo",
            "arcTo",
            "lineBy",
            "cubicCurveBy",
            "quadraticCurveBy",
            "curveBy",
            "arcBy"
          ],
          function(e) {
            this[e] = function() {
              var i = t(this, !0);
              i[e].apply(i, arguments);
            };
          },
          {
            moveTo: function() {
              var e = t(this), i = e && e.isEmpty() ? e : new pt(ft.NO_INSERT);
              i !== e && this.addChild(i), i.moveTo.apply(i, arguments);
            },
            moveBy: function() {
              var e = t(this, !0), i = e && e.getLastSegment(), n = E.read(arguments);
              this.moveTo(i ? n.add(i._point) : n);
            },
            closePath: function(e) {
              t(this, !0).closePath(e);
            }
          }
        );
      }(),
      T.each(["reverse", "flatten", "simplify", "smooth"], function(t) {
        this[t] = function(e) {
          for (var i = this._children, n, r = 0, s = i.length; r < s; r++)
            n = i[r][t](e) || n;
          return n;
        };
      }, {})
    );
    Ae.inject(new function() {
      var t = Math.min, e = Math.max, i = Math.abs, n = {
        unite: { 1: !0, 2: !0 },
        intersect: { 2: !0 },
        subtract: { 1: !0 },
        exclude: { 1: !0, "-1": !0 }
      };
      function r(_) {
        return _._children || [_];
      }
      function s(_, m) {
        var l = _.clone(!1).reduce({ simplify: !0 }).transform(null, !0, !0);
        if (m) {
          for (var p = r(l), y = 0, S = p.length; y < S; y++) {
            var _ = p[y];
            !_._closed && !_.isEmpty() && (_.closePath(1e-12), _.getFirstSegment().setHandleIn(0, 0), _.getLastSegment().setHandleOut(0, 0));
          }
          l = l.resolveCrossings().reorient(l.getFillRule() === "nonzero", !0);
        }
        return l;
      }
      function u(_, m, l, p, y) {
        var S = new fe(ft.NO_INSERT);
        return S.addChildren(_, !0), S = S.reduce({ simplify: m }), y && y.insert == !1 || S.insertAbove(p && l.isSibling(p) && l.getIndex() < p.getIndex() ? p : l), S.copyAttributes(l, !0), S;
      }
      function a(_) {
        return _.hasOverlap() || _.isCrossing();
      }
      function o(_, m, l, p) {
        if (p && (p.trace == !1 || p.stroke) && /^(subtract|intersect)$/.test(l))
          return h(_, m, l);
        var y = s(_, !0), S = m && _ !== m && s(m, !0), w = n[l];
        w[l] = !0, S && (w.subtract || w.exclude) ^ (S.isClockwise() ^ y.isClockwise()) && S.reverse();
        var C = f(le.expand(
          y.getIntersections(S, a)
        )), I = r(y), M = S && r(S), k = [], P = [], O;
        function L(J) {
          for (var rt = 0, nt = J.length; rt < nt; rt++) {
            var ot = J[rt];
            T.push(k, ot._segments), T.push(P, ot.getCurves()), ot._overlapsOnly = !0;
          }
        }
        function B(J) {
          for (var rt = [], nt = 0, ot = J && J.length; nt < ot; nt++)
            rt.push(P[J[nt]]);
          return rt;
        }
        if (C.length) {
          L(I), M && L(M);
          for (var N = new Array(P.length), D = 0, Z = P.length; D < Z; D++)
            N[D] = P[D].getValues();
          for (var G = qt.findCurveBoundsCollisions(
            N,
            N,
            0,
            !0
          ), Y = {}, D = 0; D < P.length; D++) {
            var X = P[D], V = X._path._id, U = Y[V] = Y[V] || {};
            U[X.getIndex()] = {
              hor: B(G[D].hor),
              ver: B(G[D].ver)
            };
          }
          for (var D = 0, Z = C.length; D < Z; D++)
            v(
              C[D]._segment,
              y,
              S,
              Y,
              w
            );
          for (var D = 0, Z = k.length; D < Z; D++) {
            var K = k[D], Q = K._intersection;
            K._winding || v(
              K,
              y,
              S,
              Y,
              w
            ), Q && Q._overlap || (K._path._overlapsOnly = !1);
          }
          O = x(k, w);
        } else
          O = c(
            M ? I.concat(M) : I.slice(),
            function(J) {
              return !!w[J];
            }
          );
        return u(O, !0, _, m, p);
      }
      function h(_, m, l) {
        var p = s(_), y = s(m), S = p.getIntersections(y, a), w = l === "subtract", C = l === "divide", I = {}, M = [];
        function k(L) {
          if (!I[L._id] && (C || y.contains(L.getPointAt(L.getLength() / 2)) ^ w))
            return M.unshift(L), I[L._id] = !0;
        }
        for (var P = S.length - 1; P >= 0; P--) {
          var O = S[P].split();
          O && (k(O) && O.getFirstSegment().setHandleIn(0, 0), p.getLastSegment().setHandleOut(0, 0));
        }
        return k(p), u(M, !1, _, m);
      }
      function d(_, m) {
        for (var l = _; l; ) {
          if (l === m)
            return;
          l = l._previous;
        }
        for (; _._next && _._next !== m; )
          _ = _._next;
        if (!_._next) {
          for (; m._previous; )
            m = m._previous;
          _._next = m, m._previous = _;
        }
      }
      function g(_) {
        for (var m = _.length - 1; m >= 0; m--)
          _[m].clearHandles();
      }
      function c(_, m, l) {
        var p = _ && _.length;
        if (p) {
          var y = T.each(_, function(G, Y) {
            this[G._id] = {
              container: null,
              winding: G.isClockwise() ? 1 : -1,
              index: Y
            };
          }, {}), S = _.slice().sort(function(G, Y) {
            return i(Y.getArea()) - i(G.getArea());
          }), w = S[0], C = qt.findItemBoundsCollisions(
            S,
            null,
            lt.GEOMETRIC_EPSILON
          );
          l == null && (l = w.isClockwise());
          for (var I = 0; I < p; I++) {
            var M = S[I], k = y[M._id], P = 0, O = C[I];
            if (O) {
              for (var L = null, B = O.length - 1; B >= 0; B--)
                if (O[B] < I) {
                  L = L || M.getInteriorPoint();
                  var N = S[O[B]];
                  if (N.contains(L)) {
                    var D = y[N._id];
                    P = D.winding, k.winding += P, k.container = D.exclude ? D.container : N;
                    break;
                  }
                }
            }
            if (m(k.winding) === m(P))
              k.exclude = !0, _[k.index] = null;
            else {
              var Z = k.container;
              M.setClockwise(
                Z ? !Z.isClockwise() : l
              );
            }
          }
        }
        return _;
      }
      function f(_, m, l) {
        var p = m && [], y = 1e-8, S = 1 - y, w = !1, C = l || [], I = l && {}, M, k, P;
        function O(rt) {
          return rt._path._id + "." + rt._segment1._index;
        }
        for (var L = (l && l.length) - 1; L >= 0; L--) {
          var B = l[L];
          B._path && (I[O(B)] = !0);
        }
        for (var L = _.length - 1; L >= 0; L--) {
          var N = _[L], D = N._time, Z = D, G = m && !m(N), B = N._curve, Y;
          if (B && (B !== k ? (w = !B.hasHandles() || I && I[O(B)], M = [], P = null, k = B) : P >= y && (D /= P)), G) {
            M && M.push(N);
            continue;
          } else
            m && p.unshift(N);
          if (P = Z, D < y)
            Y = B._segment1;
          else if (D > S)
            Y = B._segment2;
          else {
            var X = B.divideAtTime(D, !0);
            w && C.push(B, X), Y = X._segment1;
            for (var V = M.length - 1; V >= 0; V--) {
              var U = M[V];
              U._time = (U._time - D) / (1 - D);
            }
          }
          N._setSegment(Y);
          var K = Y._intersection, Q = N._intersection;
          if (K) {
            d(K, Q);
            for (var J = K; J; )
              d(J._intersection, K), J = J._next;
          } else
            Y._intersection = Q;
        }
        return l || g(C), p || _;
      }
      function b(_, m, l, p, y) {
        var S = Array.isArray(m) ? m : m[l ? "hor" : "ver"], w = l ? 1 : 0, C = w ^ 1, I = [_.x, _.y], M = I[w], k = I[C], P = 1e-9, O = 1e-6, L = M - P, B = M + P, N = 0, D = 0, Z = 0, G = 0, Y = !1, X = !1, V = 1, U = [], K, Q;
        function J(bt) {
          var Lt = bt[C + 0], Jt = bt[C + 6];
          if (!(k < t(Lt, Jt) || k > e(Lt, Jt))) {
            var Vt = bt[w + 0], ee = bt[w + 2], pe = bt[w + 4], ne = bt[w + 6];
            if (Lt === Jt) {
              (Vt < B && ne > L || ne < B && Vt > L) && (Y = !0);
              return;
            }
            var re = k === Lt ? 0 : k === Jt || L > e(Vt, ee, pe, ne) || B < t(Vt, ee, pe, ne) ? 1 : j.solveCubic(bt, C, k, U, 0, 1) > 0 ? U[0] : 1, Qt = re === 0 ? Vt : re === 1 ? ne : j.getPoint(bt, re)[l ? "y" : "x"], te = Lt > Jt ? 1 : -1, me = K[C] > K[C + 6] ? 1 : -1, se = K[w + 6];
            return k !== Lt ? (Qt < L ? Z += te : Qt > B ? G += te : Y = !0, Qt > M - O && Qt < M + O && (V /= 2)) : (te !== me ? Vt < L ? Z += te : Vt > B && (G += te) : Vt != se && (se < B && Qt > B ? (G += te, Y = !0) : se > L && Qt < L && (Z += te, Y = !0)), V /= 4), K = bt, !y && Qt > L && Qt < B && j.getTangent(bt, re)[l ? "x" : "y"] === 0 && b(_, m, !l, p, !0);
          }
        }
        function rt(bt) {
          var Lt = bt[C + 0], Jt = bt[C + 2], Vt = bt[C + 4], ee = bt[C + 6];
          if (k <= e(Lt, Jt, Vt, ee) && k >= t(Lt, Jt, Vt, ee)) {
            for (var pe = bt[w + 0], ne = bt[w + 2], re = bt[w + 4], Qt = bt[w + 6], te = L > e(pe, ne, re, Qt) || B < t(pe, ne, re, Qt) ? [bt] : j.getMonoCurves(bt, l), me, se = 0, Ge = te.length; se < Ge; se++)
              if (me = J(te[se]))
                return me;
          }
        }
        for (var nt = 0, ot = S.length; nt < ot; nt++) {
          var ct = S[nt], ut = ct._path, Ft = ct.getValues(), Rt;
          if ((!nt || S[nt - 1]._path !== ut) && (K = null, ut._closed || (Q = j.getValues(
            ut.getLastCurve().getSegment2(),
            ct.getSegment1(),
            null,
            !p
          ), Q[C] !== Q[C + 6] && (K = Q)), !K)) {
            K = Ft;
            for (var Gt = ut.getLastCurve(); Gt && Gt !== ct; ) {
              var kt = Gt.getValues();
              if (kt[C] !== kt[C + 6]) {
                K = kt;
                break;
              }
              Gt = Gt.getPrevious();
            }
          }
          if (Rt = rt(Ft))
            return Rt;
          if (nt + 1 === ot || S[nt + 1]._path !== ut) {
            if (Q && (Rt = rt(Q)))
              return Rt;
            Y && !Z && !G && (Z = G = ut.isClockwise(p) ^ l ? 1 : -1), N += Z, D += G, Z = G = 0, Y && (X = !0, Y = !1), Q = null;
          }
        }
        return N = i(N), D = i(D), {
          winding: e(N, D),
          windingL: N,
          windingR: D,
          quality: V,
          onPath: X
        };
      }
      function v(_, m, l, p, y) {
        var S = [], w = _, C = 0, P;
        do {
          var I = _.getCurve();
          if (I) {
            var M = I.getLength();
            S.push({ segment: _, curve: I, length: M }), C += M;
          }
          _ = _.getNext();
        } while (_ && !_._intersection && _ !== w);
        for (var k = [0.5, 0.25, 0.75], P = { winding: 0, quality: -1 }, O = 1e-3, L = 1 - O, B = 0; B < k.length && P.quality < 0.5; B++)
          for (var M = C * k[B], N = 0, D = S.length; N < D; N++) {
            var Z = S[N], G = Z.length;
            if (M <= G) {
              var I = Z.curve, Y = I._path, X = Y._parent, V = X instanceof fe ? X : Y, U = lt.clamp(I.getTimeAt(M), O, L), K = I.getPointAtTime(U), Q = i(I.getTangentAtTime(U).y) < Math.SQRT1_2, J = null;
              if (y.subtract && l) {
                var rt = V === m ? l : m, nt = rt._getWinding(K, Q, !0);
                if (V === m && nt.winding || V === l && !nt.winding) {
                  if (nt.quality < 1)
                    continue;
                  J = { winding: 0, quality: 1 };
                }
              }
              J = J || b(
                K,
                p[Y._id][I.getIndex()],
                Q,
                !0
              ), J.quality > P.quality && (P = J);
              break;
            }
            M -= G;
          }
        for (var N = S.length - 1; N >= 0; N--)
          S[N].segment._winding = P;
      }
      function x(_, m) {
        var l = [], p;
        function y(ot) {
          var ct;
          return !!(ot && !ot._visited && (!m || m[(ct = ot._winding || {}).winding] && !(m.unite && ct.winding === 2 && ct.windingL && ct.windingR)));
        }
        function S(ot) {
          if (ot) {
            for (var ct = 0, ut = p.length; ct < ut; ct++)
              if (ot === p[ct])
                return !0;
          }
          return !1;
        }
        function w(ot) {
          for (var ct = ot._segments, ut = 0, Ft = ct.length; ut < Ft; ut++)
            ct[ut]._visited = !0;
        }
        function C(ot, ct) {
          var ut = ot._intersection, Ft = ut, Rt = [];
          ct && (p = [ot]);
          function Gt(kt, bt) {
            for (; kt && kt !== bt; ) {
              var Lt = kt._segment, Jt = Lt && Lt._path;
              if (Jt) {
                var Vt = Lt.getNext() || Jt.getFirstSegment(), ee = Vt._intersection;
                Lt !== ot && (S(Lt) || S(Vt) || Vt && y(Lt) && (y(Vt) || ee && y(ee._segment))) && Rt.push(Lt), ct && p.push(Lt);
              }
              kt = kt._next;
            }
          }
          if (ut) {
            for (Gt(ut); ut && ut._previous; )
              ut = ut._previous;
            Gt(ut, Ft);
          }
          return Rt;
        }
        _.sort(function(ot, ct) {
          var ut = ot._intersection, Ft = ct._intersection, Rt = !!(ut && ut._overlap), Gt = !!(Ft && Ft._overlap), kt = ot._path, bt = ct._path;
          return Rt ^ Gt ? Rt ? 1 : -1 : !ut ^ !Ft ? ut ? 1 : -1 : kt !== bt ? kt._id - bt._id : ot._index - ct._index;
        });
        for (var I = 0, M = _.length; I < M; I++) {
          var k = _[I], P = y(k), O = null, L = !1, B = !0, N = [], D, Z, G;
          if (P && k._path._overlapsOnly) {
            var Y = k._path, X = k._intersection._segment._path;
            Y.compare(X) && (Y.getArea() && l.push(Y.clone(!1)), w(Y), w(X), P = !1);
          }
          for (; P; ) {
            var V = !O, U = C(k, V), K = U.shift(), L = !V && (S(k) || S(K)), Q = !L && K;
            if (V && (O = new pt(ft.NO_INSERT), D = null), L) {
              (k.isFirst() || k.isLast()) && (B = k._path._closed), k._visited = !0;
              break;
            }
            if (Q && D && (N.push(D), D = null), D || (Q && U.push(k), D = {
              start: O._segments.length,
              crossings: U,
              visited: Z = [],
              handleIn: G
            }), Q && (k = K), !y(k)) {
              O.removeSegments(D.start);
              for (var J = 0, rt = Z.length; J < rt; J++)
                Z[J]._visited = !1;
              Z.length = 0;
              do
                k = D && D.crossings.shift(), (!k || !k._path) && (k = null, D = N.pop(), D && (Z = D.visited, G = D.handleIn));
              while (D && !y(k));
              if (!k)
                break;
            }
            var nt = k.getNext();
            O.add(new it(
              k._point,
              G,
              nt && k._handleOut
            )), k._visited = !0, Z.push(k), k = nt || k._path.getFirstSegment(), G = nt && nt._handleIn;
          }
          L && (B && (O.getFirstSegment().setHandleIn(G), O.setClosed(B)), O.getArea() !== 0 && l.push(O));
        }
        return l;
      }
      return {
        _getWinding: function(_, m, l) {
          return b(_, this.getCurves(), m, l);
        },
        unite: function(_, m) {
          return o(this, _, "unite", m);
        },
        intersect: function(_, m) {
          return o(this, _, "intersect", m);
        },
        subtract: function(_, m) {
          return o(this, _, "subtract", m);
        },
        exclude: function(_, m) {
          return o(this, _, "exclude", m);
        },
        divide: function(_, m) {
          return m && (m.trace == !1 || m.stroke) ? h(this, _, "divide") : u([
            this.subtract(_, m),
            this.intersect(_, m)
          ], !0, this, _, m);
        },
        resolveCrossings: function() {
          var _ = this._children, m = _ || [this];
          function l(D, Z) {
            var G = D && D._intersection;
            return G && G._overlap && G._path === Z;
          }
          var p = !1, y = !1, S = this.getIntersections(null, function(D) {
            return D.hasOverlap() && (p = !0) || D.isCrossing() && (y = !0);
          }), w = p && y && [];
          if (S = le.expand(S), p)
            for (var C = f(S, function(D) {
              return D.hasOverlap();
            }, w), I = C.length - 1; I >= 0; I--) {
              var M = C[I], k = M._path, P = M._segment, O = P.getPrevious(), L = P.getNext();
              l(O, k) && l(L, k) && (P.remove(), O._handleOut._set(0, 0), L._handleIn._set(0, 0), O !== P && !O.getCurve().hasLength() && (L._handleIn.set(O._handleIn), O.remove()));
            }
          y && (f(S, p && function(D) {
            var Z = D.getCurve(), G = D.getSegment(), Y = D._intersection, X = Y._curve, V = Y._segment;
            if (Z && X && Z._path && X._path)
              return !0;
            G && (G._intersection = null), V && (V._intersection = null);
          }, w), w && g(w), m = x(T.each(m, function(D) {
            T.push(this, D._segments);
          }, [])));
          var B = m.length, N;
          return B > 1 && _ ? (m !== _ && this.setChildren(m), N = this) : B === 1 && !_ && (m[0] !== this && this.setSegments(m[0].removeSegments()), N = this), N || (N = new fe(ft.NO_INSERT), N.addChildren(m), N = N.reduce(), N.copyAttributes(this), this.replaceWith(N)), N;
        },
        reorient: function(_, m) {
          var l = this._children;
          return l && l.length ? this.setChildren(c(
            this.removeChildren(),
            function(p) {
              return !!(_ ? p : p & 1);
            },
            m
          )) : m !== F && this.setClockwise(m), this;
        },
        getInteriorPoint: function() {
          var _ = this.getBounds(), m = _.getCenter(!0);
          if (!this.contains(m)) {
            for (var l = this.getCurves(), p = m.y, y = [], S = [], w = 0, C = l.length; w < C; w++) {
              var I = l[w].getValues(), M = I[1], k = I[3], P = I[5], O = I[7];
              if (p >= t(M, k, P, O) && p <= e(M, k, P, O))
                for (var L = j.getMonoCurves(I), B = 0, N = L.length; B < N; B++) {
                  var D = L[B], Z = D[1], G = D[7];
                  if (Z !== G && (p >= Z && p <= G || p >= G && p <= Z)) {
                    var Y = p === Z ? D[0] : p === G ? D[6] : j.solveCubic(D, 1, p, S, 0, 1) === 1 ? j.getPoint(D, S[0]).x : (D[0] + D[6]) / 2;
                    y.push(Y);
                  }
                }
            }
            y.length > 1 && (y.sort(function(X, V) {
              return X - V;
            }), m.x = (y[0] + y[1]) / 2);
          }
          return m;
        }
      };
    }());
    var Si = T.extend(
      {
        _class: "PathFlattener",
        initialize: function(t, e, i, n, r) {
          var s = [], u = [], a = 0, o = 1 / (i || 32), h = t._segments, d = h[0], g;
          function c(x, _) {
            var m = j.getValues(x, _, r);
            s.push(m), f(m, x._index, 0, 1);
          }
          function f(x, _, m, l) {
            if (l - m > o && !(n && j.isStraight(x)) && !j.isFlatEnough(x, e || 0.25)) {
              var p = j.subdivide(x, 0.5), y = (m + l) / 2;
              f(p[0], _, m, y), f(p[1], _, y, l);
            } else {
              var S = x[6] - x[0], w = x[7] - x[1], C = Math.sqrt(S * S + w * w);
              C > 0 && (a += C, u.push({
                offset: a,
                curve: x,
                index: _,
                time: l
              }));
            }
          }
          for (var b = 1, v = h.length; b < v; b++)
            g = h[b], c(d, g), d = g;
          t._closed && c(g || d, h[0]), this.curves = s, this.parts = u, this.length = a, this.index = 0;
        },
        _get: function(t) {
          for (var e = this.parts, i = e.length, n, r = this.index; n = r, !(!r || e[--r].offset < t); )
            ;
          for (; n < i; n++) {
            var s = e[n];
            if (s.offset >= t) {
              this.index = n;
              var u = e[n - 1], a = u && u.index === s.index ? u.time : 0, o = u ? u.offset : 0;
              return {
                index: s.index,
                time: a + (s.time - a) * (t - o) / (s.offset - o)
              };
            }
          }
          return {
            index: e[i - 1].index,
            time: 1
          };
        },
        drawPart: function(t, e, i) {
          for (var n = this._get(e), r = this._get(i), s = n.index, u = r.index; s <= u; s++) {
            var a = j.getPart(
              this.curves[s],
              s === n.index ? n.time : 0,
              s === r.index ? r.time : 1
            );
            s === n.index && t.moveTo(a[0], a[1]), t.bezierCurveTo.apply(t, a.slice(2));
          }
        }
      },
      T.each(
        j._evaluateMethods,
        function(t) {
          this[t + "At"] = function(e) {
            var i = this._get(e);
            return j[t](this.curves[i.index], i.time);
          };
        },
        {}
      )
    ), Ji = T.extend({
      initialize: function(t) {
        for (var e = this.points = [], i = t._segments, n = t._closed, r = 0, s, u = i.length; r < u; r++) {
          var a = i[r].point;
          (!s || !s.equals(a)) && e.push(s = a.clone());
        }
        n && (e.unshift(e[e.length - 1]), e.push(e[1])), this.closed = n;
      },
      fit: function(t) {
        var e = this.points, i = e.length, n = null;
        return i > 0 && (n = [new it(e[0])], i > 1 && (this.fitCubic(
          n,
          t,
          0,
          i - 1,
          e[1].subtract(e[0]),
          e[i - 2].subtract(e[i - 1])
        ), this.closed && (n.shift(), n.pop()))), n;
      },
      fitCubic: function(t, e, i, n, r, s) {
        var u = this.points;
        if (n - i === 1) {
          var a = u[i], o = u[n], h = a.getDistance(o) / 3;
          this.addCurve(t, [
            a,
            a.add(r.normalize(h)),
            o.add(s.normalize(h)),
            o
          ]);
          return;
        }
        for (var d = this.chordLengthParameterize(i, n), g = Math.max(e, e * e), c, f = !0, b = 0; b <= 4; b++) {
          var v = this.generateBezier(i, n, d, r, s), x = this.findMaxError(i, n, v, d);
          if (x.error < e && f) {
            this.addCurve(t, v);
            return;
          }
          if (c = x.index, x.error >= g)
            break;
          f = this.reparameterize(i, n, d, v), g = x.error;
        }
        var _ = u[c - 1].subtract(u[c + 1]);
        this.fitCubic(t, e, i, c, r, _), this.fitCubic(t, e, c, n, _.negate(), s);
      },
      addCurve: function(t, e) {
        var i = t[t.length - 1];
        i.setHandleOut(e[1].subtract(e[0])), t.push(new it(e[3], e[2].subtract(e[3])));
      },
      generateBezier: function(t, e, i, n, r) {
        for (var s = 1e-12, u = Math.abs, a = this.points, o = a[t], h = a[e], d = [[0, 0], [0, 0]], g = [0, 0], c = 0, f = e - t + 1; c < f; c++) {
          var b = i[c], v = 1 - b, x = 3 * b * v, _ = v * v * v, m = x * v, l = x * b, p = b * b * b, y = n.normalize(m), S = r.normalize(l), w = a[t + c].subtract(o.multiply(_ + m)).subtract(h.multiply(l + p));
          d[0][0] += y.dot(y), d[0][1] += y.dot(S), d[1][0] = d[0][1], d[1][1] += S.dot(S), g[0] += y.dot(w), g[1] += S.dot(w);
        }
        var C = d[0][0] * d[1][1] - d[1][0] * d[0][1], I, M;
        if (u(C) > s) {
          var k = d[0][0] * g[1] - d[1][0] * g[0], P = g[0] * d[1][1] - g[1] * d[0][1];
          I = P / C, M = k / C;
        } else {
          var O = d[0][0] + d[0][1], L = d[1][0] + d[1][1];
          I = M = u(O) > s ? g[0] / O : u(L) > s ? g[1] / L : 0;
        }
        var B = h.getDistance(o), N = s * B, D, Z;
        if (I < N || M < N)
          I = M = B / 3;
        else {
          var G = h.subtract(o);
          D = n.normalize(I), Z = r.normalize(M), D.dot(G) - Z.dot(G) > B * B && (I = M = B / 3, D = Z = null);
        }
        return [
          o,
          o.add(D || n.normalize(I)),
          h.add(Z || r.normalize(M)),
          h
        ];
      },
      reparameterize: function(t, e, i, n) {
        for (var r = t; r <= e; r++)
          i[r - t] = this.findRoot(n, this.points[r], i[r - t]);
        for (var r = 1, s = i.length; r < s; r++)
          if (i[r] <= i[r - 1])
            return !1;
        return !0;
      },
      findRoot: function(t, e, i) {
        for (var n = [], r = [], s = 0; s <= 2; s++)
          n[s] = t[s + 1].subtract(t[s]).multiply(3);
        for (var s = 0; s <= 1; s++)
          r[s] = n[s + 1].subtract(n[s]).multiply(2);
        var u = this.evaluate(3, t, i), a = this.evaluate(2, n, i), o = this.evaluate(1, r, i), h = u.subtract(e), d = a.dot(a) + h.dot(o);
        return lt.isMachineZero(d) ? i : i - h.dot(a) / d;
      },
      evaluate: function(t, e, i) {
        for (var n = e.slice(), r = 1; r <= t; r++)
          for (var s = 0; s <= t - r; s++)
            n[s] = n[s].multiply(1 - i).add(n[s + 1].multiply(i));
        return n[0];
      },
      chordLengthParameterize: function(t, e) {
        for (var i = [0], n = t + 1; n <= e; n++)
          i[n - t] = i[n - t - 1] + this.points[n].getDistance(this.points[n - 1]);
        for (var n = 1, r = e - t; n <= r; n++)
          i[n] /= i[r];
        return i;
      },
      findMaxError: function(t, e, i, n) {
        for (var r = Math.floor((e - t + 1) / 2), s = 0, u = t + 1; u < e; u++) {
          var a = this.evaluate(3, i, n[u - t]), o = a.subtract(this.points[u]), h = o.x * o.x + o.y * o.y;
          h >= s && (s = h, r = u);
        }
        return {
          error: s,
          index: r
        };
      }
    }), He = ft.extend({
      _class: "TextItem",
      _applyMatrix: !1,
      _canApplyMatrix: !1,
      _serializeFields: {
        content: null
      },
      _boundsOptions: { stroke: !1, handle: !1 },
      initialize: function(e) {
        this._content = "", this._lines = [];
        var i = e && T.isPlainObject(e) && e.x === F && e.y === F;
        this._initialize(i && e, !i && E.read(arguments));
      },
      _equals: function(t) {
        return this._content === t._content;
      },
      copyContent: function(t) {
        this.setContent(t._content);
      },
      getContent: function() {
        return this._content;
      },
      setContent: function(t) {
        this._content = "" + t, this._lines = this._content.split(/\r\n|\n|\r/mg), this._changed(521);
      },
      isEmpty: function() {
        return !this._content;
      },
      getCharacterStyle: "#getStyle",
      setCharacterStyle: "#setStyle",
      getParagraphStyle: "#getStyle",
      setParagraphStyle: "#setStyle"
    }), Qi = He.extend({
      _class: "PointText",
      initialize: function() {
        He.apply(this, arguments);
      },
      getPoint: function() {
        var t = this._matrix.getTranslation();
        return new Zt(t.x, t.y, this, "setPoint");
      },
      setPoint: function() {
        var t = E.read(arguments);
        this.translate(t.subtract(this._matrix.getTranslation()));
      },
      _draw: function(t, e, i) {
        if (this._content) {
          this._setStyles(t, e, i);
          var n = this._lines, r = this._style, s = r.hasFill(), u = r.hasStroke(), a = r.getLeading(), o = t.shadowColor;
          t.font = r.getFontStyle(), t.textAlign = r.getJustification();
          for (var h = 0, d = n.length; h < d; h++) {
            t.shadowColor = o;
            var g = n[h];
            s && (t.fillText(g, 0, 0), t.shadowColor = "rgba(0,0,0,0)"), u && t.strokeText(g, 0, 0), t.translate(0, a);
          }
        }
      },
      _getBounds: function(t, e) {
        var i = this._style, n = this._lines, r = n.length, s = i.getJustification(), u = i.getLeading(), a = this.getView().getTextWidth(i.getFontStyle(), n), o = 0;
        s !== "left" && (o -= a / (s === "center" ? 2 : 1));
        var h = new et(
          o,
          r ? -0.75 * u : 0,
          a,
          r * u
        );
        return t ? t._transformBounds(h, h) : h;
      }
    }), Bt = T.extend(
      new function() {
        var t = {
          gray: ["gray"],
          rgb: ["red", "green", "blue"],
          hsb: ["hue", "saturation", "brightness"],
          hsl: ["hue", "saturation", "lightness"],
          gradient: ["gradient", "origin", "destination", "highlight"]
        }, e = {}, i = {
          transparent: [0, 0, 0, 0]
        }, n;
        function r(a) {
          var o = a.match(
            /^#([\da-f]{2})([\da-f]{2})([\da-f]{2})([\da-f]{2})?$/i
          ) || a.match(
            /^#([\da-f])([\da-f])([\da-f])([\da-f])?$/i
          ), h = "rgb", d;
          if (o) {
            var g = o[4] ? 4 : 3;
            d = new Array(g);
            for (var c = 0; c < g; c++) {
              var f = o[c + 1];
              d[c] = parseInt(f.length == 1 ? f + f : f, 16) / 255;
            }
          } else if (o = a.match(/^(rgb|hsl)a?\((.*)\)$/)) {
            h = o[1], d = o[2].trim().split(/[,\s]+/g);
            for (var b = h === "hsl", c = 0, v = Math.min(d.length, 4); c < v; c++) {
              var x = d[c], f = parseFloat(x);
              if (b)
                if (c === 0) {
                  var _ = x.match(/([a-z]*)$/)[1];
                  f *= {
                    turn: 360,
                    rad: 180 / Math.PI,
                    grad: 0.9
                  }[_] || 1;
                } else
                  c < 3 && (f /= 100);
              else
                c < 3 && (f /= /%$/.test(x) ? 100 : 255);
              d[c] = f;
            }
          } else {
            var m = i[a];
            if (!m)
              if ($) {
                n || (n = Dt.getContext(1, 1, {
                  willReadFrequently: !0
                }), n.globalCompositeOperation = "copy"), n.fillStyle = "rgba(0,0,0,0)", n.fillStyle = a, n.fillRect(0, 0, 1, 1);
                var l = n.getImageData(0, 0, 1, 1).data;
                m = i[a] = [
                  l[0] / 255,
                  l[1] / 255,
                  l[2] / 255
                ];
              } else
                m = [0, 0, 0];
            d = m.slice();
          }
          return [h, d];
        }
        var s = [
          [0, 3, 1],
          [2, 0, 1],
          [1, 0, 3],
          [1, 2, 0],
          [3, 1, 0],
          [0, 1, 2]
        ], u = {
          "rgb-hsb": function(a, o, h) {
            var d = Math.max(a, o, h), g = Math.min(a, o, h), c = d - g, f = c === 0 ? 0 : (d == a ? (o - h) / c + (o < h ? 6 : 0) : d == o ? (h - a) / c + 2 : (a - o) / c + 4) * 60;
            return [f, d === 0 ? 0 : c / d, d];
          },
          "hsb-rgb": function(a, o, h) {
            a = (a / 60 % 6 + 6) % 6;
            var g = Math.floor(a), d = a - g, g = s[g], c = [
              h,
              h * (1 - o),
              h * (1 - o * d),
              h * (1 - o * (1 - d))
            ];
            return [c[g[0]], c[g[1]], c[g[2]]];
          },
          "rgb-hsl": function(a, o, h) {
            var d = Math.max(a, o, h), g = Math.min(a, o, h), c = d - g, f = c === 0, b = f ? 0 : (d == a ? (o - h) / c + (o < h ? 6 : 0) : d == o ? (h - a) / c + 2 : (a - o) / c + 4) * 60, v = (d + g) / 2, x = f ? 0 : v < 0.5 ? c / (d + g) : c / (2 - d - g);
            return [b, x, v];
          },
          "hsl-rgb": function(a, o, h) {
            if (a = (a / 360 % 1 + 1) % 1, o === 0)
              return [h, h, h];
            for (var d = [a + 1 / 3, a, a - 1 / 3], g = h < 0.5 ? h * (1 + o) : h + o - h * o, c = 2 * h - g, f = [], b = 0; b < 3; b++) {
              var v = d[b];
              v < 0 && (v += 1), v > 1 && (v -= 1), f[b] = 6 * v < 1 ? c + (g - c) * 6 * v : 2 * v < 1 ? g : 3 * v < 2 ? c + (g - c) * (2 / 3 - v) * 6 : c;
            }
            return f;
          },
          "rgb-gray": function(a, o, h) {
            return [a * 0.2989 + o * 0.587 + h * 0.114];
          },
          "gray-rgb": function(a) {
            return [a, a, a];
          },
          "gray-hsb": function(a) {
            return [0, 0, a];
          },
          "gray-hsl": function(a) {
            return [0, 0, a];
          },
          "gradient-rgb": function() {
            return [];
          },
          "rgb-gradient": function() {
            return [];
          }
        };
        return T.each(t, function(a, o) {
          e[o] = [], T.each(a, function(h, d) {
            var g = T.capitalize(h), c = /^(hue|saturation)$/.test(h), f = e[o][d] = o === "gradient" ? h === "gradient" ? function(b) {
              var v = this._components[0];
              return b = Ze.read(
                Array.isArray(b) ? b : arguments,
                0,
                { readNull: !0 }
              ), v !== b && (v && v._removeOwner(this), b && b._addOwner(this)), b;
            } : function() {
              return E.read(arguments, 0, {
                readNull: h === "highlight",
                clone: !0
              });
            } : function(b) {
              return b == null || isNaN(b) ? 0 : +b;
            };
            this["get" + g] = function() {
              return this._type === o || c && /^hs[bl]$/.test(this._type) ? this._components[d] : this._convert(o)[d];
            }, this["set" + g] = function(b) {
              this._type !== o && !(c && /^hs[bl]$/.test(this._type)) && (this._components = this._convert(o), this._properties = t[o], this._type = o), this._components[d] = f.call(this, b), this._changed();
            };
          }, this);
        }, {
          _class: "Color",
          _readIndex: !0,
          initialize: function a(o) {
            var h = arguments, d = this.__read, g = 0, c, f, b, v;
            Array.isArray(o) && (h = o, o = h[0]);
            var x = o != null && typeof o;
            if (x === "string" && o in t && (c = o, o = h[1], Array.isArray(o) ? (f = o, b = h[2]) : (d && (g = 1), h = T.slice(h, 1), x = typeof o)), !f) {
              if (v = x === "number" ? h : x === "object" && o.length != null ? o : null, v) {
                c || (c = v.length >= 3 ? "rgb" : "gray");
                var _ = t[c].length;
                b = v[_], d && (g += v === arguments ? _ + (b != null ? 1 : 0) : 1), v.length > _ && (v = T.slice(v, 0, _));
              } else if (x === "string") {
                var m = r(o);
                c = m[0], f = m[1], f.length === 4 && (b = f[3], f.length--);
              } else if (x === "object")
                if (o.constructor === a) {
                  if (c = o._type, f = o._components.slice(), b = o._alpha, c === "gradient")
                    for (var l = 1, p = f.length; l < p; l++) {
                      var y = f[l];
                      y && (f[l] = y.clone());
                    }
                } else if (o.constructor === Ze)
                  c = "gradient", v = h;
                else {
                  c = "hue" in o ? "lightness" in o ? "hsl" : "hsb" : "gradient" in o || "stops" in o || "radial" in o ? "gradient" : "gray" in o ? "gray" : "rgb";
                  var S = t[c], w = e[c];
                  this._components = f = [];
                  for (var l = 0, p = S.length; l < p; l++) {
                    var C = o[S[l]];
                    C == null && !l && c === "gradient" && "stops" in o && (C = {
                      stops: o.stops,
                      radial: o.radial
                    }), C = w[l].call(this, C), C != null && (f[l] = C);
                  }
                  b = o.alpha;
                }
              d && c && (g = 1);
            }
            if (this._type = c || "rgb", !f) {
              this._components = f = [];
              for (var w = e[this._type], l = 0, p = w.length; l < p; l++) {
                var C = w[l].call(this, v && v[l]);
                C != null && (f[l] = C);
              }
            }
            return this._components = f, this._properties = t[this._type], this._alpha = b, d && (this.__read = g), this;
          },
          set: "#initialize",
          _serialize: function(a, o) {
            var h = this.getComponents();
            return T.serialize(
              /^(gray|rgb)$/.test(this._type) ? h : [this._type].concat(h),
              a,
              !0,
              o
            );
          },
          _changed: function() {
            this._canvasStyle = null, this._owner && (this._setter ? this._owner[this._setter](this) : this._owner._changed(129));
          },
          _convert: function(a) {
            var o;
            return this._type === a ? this._components.slice() : (o = u[this._type + "-" + a]) ? o.apply(this, this._components) : u["rgb-" + a].apply(
              this,
              u[this._type + "-rgb"].apply(
                this,
                this._components
              )
            );
          },
          convert: function(a) {
            return new Bt(a, this._convert(a), this._alpha);
          },
          getType: function() {
            return this._type;
          },
          setType: function(a) {
            this._components = this._convert(a), this._properties = t[a], this._type = a;
          },
          getComponents: function() {
            var a = this._components.slice();
            return this._alpha != null && a.push(this._alpha), a;
          },
          getAlpha: function() {
            return this._alpha != null ? this._alpha : 1;
          },
          setAlpha: function(a) {
            this._alpha = a == null ? null : Math.min(Math.max(a, 0), 1), this._changed();
          },
          hasAlpha: function() {
            return this._alpha != null;
          },
          equals: function(a) {
            var o = T.isPlainValue(a, !0) ? Bt.read(arguments) : a;
            return o === this || o && this._class === o._class && this._type === o._type && this.getAlpha() === o.getAlpha() && T.equals(this._components, o._components) || !1;
          },
          toString: function() {
            for (var a = this._properties, o = [], h = this._type === "gradient", d = St.instance, g = 0, c = a.length; g < c; g++) {
              var f = this._components[g];
              f != null && o.push(a[g] + ": " + (h ? f : d.number(f)));
            }
            return this._alpha != null && o.push("alpha: " + d.number(this._alpha)), "{ " + o.join(", ") + " }";
          },
          toCSS: function(a) {
            var o = this._convert("rgb"), h = a || this._alpha == null ? 1 : this._alpha;
            function d(g) {
              return Math.round((g < 0 ? 0 : g > 1 ? 1 : g) * 255);
            }
            return o = [
              d(o[0]),
              d(o[1]),
              d(o[2])
            ], h < 1 && o.push(h < 0 ? 0 : h), a ? "#" + ((1 << 24) + (o[0] << 16) + (o[1] << 8) + o[2]).toString(16).slice(1) : (o.length == 4 ? "rgba(" : "rgb(") + o.join(",") + ")";
          },
          toCanvasStyle: function(a, o) {
            if (this._canvasStyle)
              return this._canvasStyle;
            if (this._type !== "gradient")
              return this._canvasStyle = this.toCSS();
            var h = this._components, d = h[0], g = d._stops, c = h[1], f = h[2], b = h[3], v = o && o.inverted(), x;
            if (v && (c = v._transformPoint(c), f = v._transformPoint(f), b && (b = v._transformPoint(b))), d._radial) {
              var _ = f.getDistance(c);
              if (b) {
                var m = b.subtract(c);
                m.getLength() > _ && (b = c.add(m.normalize(_ - 0.1)));
              }
              var l = b || c;
              x = a.createRadialGradient(
                l.x,
                l.y,
                0,
                c.x,
                c.y,
                _
              );
            } else
              x = a.createLinearGradient(
                c.x,
                c.y,
                f.x,
                f.y
              );
            for (var p = 0, y = g.length; p < y; p++) {
              var S = g[p], w = S._offset;
              x.addColorStop(
                w ?? p / (y - 1),
                S._color.toCanvasStyle()
              );
            }
            return this._canvasStyle = x;
          },
          transform: function(a) {
            if (this._type === "gradient") {
              for (var o = this._components, h = 1, d = o.length; h < d; h++) {
                var g = o[h];
                a._transformPoint(g, g, !0);
              }
              this._changed();
            }
          },
          statics: {
            _types: t,
            random: function() {
              var a = Math.random;
              return new Bt(a(), a(), a());
            },
            _setOwner: function(a, o, h) {
              return a && (a._owner && o && a._owner !== o && (a = a.clone()), !a._owner ^ !o && (a._owner = o || null, a._setter = h || null)), a;
            }
          }
        });
      }(),
      new function() {
        var t = {
          add: function(e, i) {
            return e + i;
          },
          subtract: function(e, i) {
            return e - i;
          },
          multiply: function(e, i) {
            return e * i;
          },
          divide: function(e, i) {
            return e / i;
          }
        };
        return T.each(t, function(e, i) {
          this[i] = function(n) {
            n = Bt.read(arguments);
            for (var r = this._type, s = this._components, u = n._convert(r), a = 0, o = s.length; a < o; a++)
              u[a] = e(s[a], u[a]);
            return new Bt(
              r,
              u,
              this._alpha != null ? e(this._alpha, n.getAlpha()) : null
            );
          };
        }, {});
      }()
    ), Ze = T.extend({
      _class: "Gradient",
      initialize: function(e, i) {
        this._id = xt.get(), e && T.isPlainObject(e) && (this.set(e), e = i = null), this._stops == null && this.setStops(e || ["white", "black"]), this._radial == null && this.setRadial(typeof i == "string" && i === "radial" || i || !1);
      },
      _serialize: function(t, e) {
        return e.add(this, function() {
          return T.serialize(
            [this._stops, this._radial],
            t,
            !0,
            e
          );
        });
      },
      _changed: function() {
        for (var t = 0, e = this._owners && this._owners.length; t < e; t++)
          this._owners[t]._changed();
      },
      _addOwner: function(t) {
        this._owners || (this._owners = []), this._owners.push(t);
      },
      _removeOwner: function(t) {
        var e = this._owners ? this._owners.indexOf(t) : -1;
        e != -1 && (this._owners.splice(e, 1), this._owners.length || (this._owners = F));
      },
      clone: function() {
        for (var t = [], e = 0, i = this._stops.length; e < i; e++)
          t[e] = this._stops[e].clone();
        return new Ze(t, this._radial);
      },
      getStops: function() {
        return this._stops;
      },
      setStops: function(t) {
        if (t.length < 2)
          throw new Error(
            "Gradient stop list needs to contain at least two stops."
          );
        var e = this._stops;
        if (e)
          for (var i = 0, n = e.length; i < n; i++)
            e[i]._owner = F;
        e = this._stops = ni.readList(t, 0, { clone: !0 });
        for (var i = 0, n = e.length; i < n; i++)
          e[i]._owner = this;
        this._changed();
      },
      getRadial: function() {
        return this._radial;
      },
      setRadial: function(t) {
        this._radial = t, this._changed();
      },
      equals: function(t) {
        if (t === this)
          return !0;
        if (t && this._class === t._class) {
          var e = this._stops, i = t._stops, n = e.length;
          if (n === i.length) {
            for (var r = 0; r < n; r++)
              if (!e[r].equals(i[r]))
                return !1;
            return !0;
          }
        }
        return !1;
      }
    }), ni = T.extend({
      _class: "GradientStop",
      initialize: function(e, i) {
        var n = e, r = i;
        typeof e == "object" && i === F && (Array.isArray(e) && typeof e[0] != "number" ? (n = e[0], r = e[1]) : ("color" in e || "offset" in e || "rampPoint" in e) && (n = e.color, r = e.offset || e.rampPoint || 0)), this.setColor(n), this.setOffset(r);
      },
      clone: function() {
        return new ni(this._color.clone(), this._offset);
      },
      _serialize: function(t, e) {
        var i = this._color, n = this._offset;
        return T.serialize(
          n == null ? [i] : [i, n],
          t,
          !0,
          e
        );
      },
      _changed: function() {
        this._owner && this._owner._changed(129);
      },
      getOffset: function() {
        return this._offset;
      },
      setOffset: function(t) {
        this._offset = t, this._changed();
      },
      getRampPoint: "#getOffset",
      setRampPoint: "#setOffset",
      getColor: function() {
        return this._color;
      },
      setColor: function() {
        Bt._setOwner(this._color, null), this._color = Bt._setOwner(
          Bt.read(arguments, 0),
          this,
          "setColor"
        ), this._changed();
      },
      equals: function(t) {
        return t === this || t && this._class === t._class && this._color.equals(t._color) && this._offset == t._offset || !1;
      }
    }), ri = T.extend(new function() {
      var t = {
        fillColor: null,
        fillRule: "nonzero",
        strokeColor: null,
        strokeWidth: 1,
        strokeCap: "butt",
        strokeJoin: "miter",
        strokeScaling: !0,
        miterLimit: 10,
        dashOffset: 0,
        dashArray: [],
        shadowColor: null,
        shadowBlur: 0,
        shadowOffset: new E(),
        selectedColor: null
      }, e = T.set({}, t, {
        fontFamily: "sans-serif",
        fontWeight: "normal",
        fontSize: 12,
        leading: null,
        justification: "left"
      }), i = T.set({}, e, {
        fillColor: new Bt()
      }), n = {
        strokeWidth: 193,
        strokeCap: 193,
        strokeJoin: 193,
        strokeScaling: 201,
        miterLimit: 193,
        fontFamily: 9,
        fontWeight: 9,
        fontSize: 9,
        font: 9,
        leading: 9,
        justification: 9
      }, r = {
        beans: !0
      }, s = {
        _class: "Style",
        beans: !0,
        initialize: function(a, o, h) {
          this._values = {}, this._owner = o, this._project = o && o._project || h || _t.project, this._defaults = !o || o instanceof jt ? e : o instanceof He ? i : t, a && this.set(a);
        }
      };
      return T.each(e, function(u, a) {
        var o = /Color$/.test(a), h = a === "shadowOffset", d = T.capitalize(a), g = n[a], c = "set" + d, f = "get" + d;
        s[c] = function(b) {
          var v = this._owner, x = v && v._children, _ = x && x.length > 0 && !(v instanceof fe);
          if (_)
            for (var m = 0, l = x.length; m < l; m++)
              x[m]._style[c](b);
          if ((a === "selectedColor" || !_) && a in this._defaults) {
            var p = this._values[a];
            p !== b && (o && (p && (Bt._setOwner(p, null), p._canvasStyle = null), b && b.constructor === Bt && (b = Bt._setOwner(
              b,
              v,
              _ && c
            ))), this._values[a] = b, v && v._changed(g || 129));
          }
        }, s[f] = function(b) {
          var v = this._owner, x = v && v._children, _ = x && x.length > 0 && !(v instanceof fe), m;
          if (_ && !b)
            for (var l = 0, p = x.length; l < p; l++) {
              var y = x[l]._style[f]();
              if (!l)
                m = y;
              else if (!T.equals(m, y))
                return F;
            }
          else if (a in this._defaults) {
            var m = this._values[a];
            if (m === F)
              m = this._defaults[a], m && m.clone && (m = m.clone());
            else {
              var S = o ? Bt : h ? E : null;
              S && !(m && m.constructor === S) && (this._values[a] = m = S.read(
                [m],
                0,
                { readNull: !0, clone: !0 }
              ));
            }
          }
          return m && o && (m = Bt._setOwner(m, v, _ && c)), m;
        }, r[f] = function(b) {
          return this._style[f](b);
        }, r[c] = function(b) {
          this._style[c](b);
        };
      }), T.each({
        Font: "FontFamily",
        WindingRule: "FillRule"
      }, function(u, a) {
        var o = "get" + a, h = "set" + a;
        s[o] = r[o] = "#get" + u, s[h] = r[h] = "#set" + u;
      }), ft.inject(r), s;
    }(), {
      set: function(t) {
        var e = t instanceof ri, i = e ? t._values : t;
        if (i) {
          for (var n in i)
            if (n in this._defaults) {
              var r = i[n];
              this[n] = r && e && r.clone ? r.clone() : r;
            }
        }
      },
      equals: function(t) {
        function e(i, n, r) {
          var s = i._values, u = n._values, a = n._defaults;
          for (var o in s) {
            var h = s[o], d = u[o];
            if (!(r && o in u) && !T.equals(
              h,
              d === F ? a[o] : d
            ))
              return !1;
          }
          return !0;
        }
        return t === this || t && this._class === t._class && e(this, t) && e(t, this, !0) || !1;
      },
      _dispose: function() {
        var t;
        t = this.getFillColor(), t && (t._canvasStyle = null), t = this.getStrokeColor(), t && (t._canvasStyle = null), t = this.getShadowColor(), t && (t._canvasStyle = null);
      },
      hasFill: function() {
        var t = this.getFillColor();
        return !!t && t.alpha > 0;
      },
      hasStroke: function() {
        var t = this.getStrokeColor();
        return !!t && t.alpha > 0 && this.getStrokeWidth() > 0;
      },
      hasShadow: function() {
        var t = this.getShadowColor();
        return !!t && t.alpha > 0 && (this.getShadowBlur() > 0 || !this.getShadowOffset().isZero());
      },
      getView: function() {
        return this._project._view;
      },
      getFontStyle: function() {
        var t = this.getFontSize();
        return this.getFontWeight() + " " + t + (/[a-z]/i.test(t + "") ? " " : "px ") + this.getFontFamily();
      },
      getFont: "#getFontFamily",
      setFont: "#setFontFamily",
      getLeading: function t() {
        var e = t.base.call(this), i = this.getFontSize();
        return /pt|em|%|px/.test(i) && (i = this.getView().getPixelSize(i)), e ?? i * 1.2;
      }
    }), At = new function() {
      function t(e, i, n, r) {
        for (var s = ["", "webkit", "moz", "Moz", "ms", "o"], u = i[0].toUpperCase() + i.substring(1), a = 0; a < 6; a++) {
          var o = s[a], h = o ? o + u : i;
          if (h in e) {
            if (n)
              e[h] = r;
            else
              return e[h];
            break;
          }
        }
      }
      return {
        getStyles: function(e) {
          var i = e && e.nodeType !== 9 ? e.ownerDocument : e, n = i && i.defaultView;
          return n && n.getComputedStyle(e, "");
        },
        getBounds: function(e, i) {
          var n = e.ownerDocument, r = n.body, s = n.documentElement, u;
          try {
            u = e.getBoundingClientRect();
          } catch {
            u = { left: 0, top: 0, width: 0, height: 0 };
          }
          var a = u.left - (s.clientLeft || r.clientLeft || 0), o = u.top - (s.clientTop || r.clientTop || 0);
          if (!i) {
            var h = n.defaultView;
            a += h.pageXOffset || s.scrollLeft || r.scrollLeft, o += h.pageYOffset || s.scrollTop || r.scrollTop;
          }
          return new et(a, o, u.width, u.height);
        },
        getViewportBounds: function(e) {
          var i = e.ownerDocument, n = i.defaultView, r = i.documentElement;
          return new et(
            0,
            0,
            n.innerWidth || r.clientWidth,
            n.innerHeight || r.clientHeight
          );
        },
        getOffset: function(e, i) {
          return At.getBounds(e, i).getPoint();
        },
        getSize: function(e) {
          return At.getBounds(e, !0).getSize();
        },
        isInvisible: function(e) {
          return At.getSize(e).equals(new W(0, 0));
        },
        isInView: function(e) {
          return !At.isInvisible(e) && At.getViewportBounds(e).intersects(
            At.getBounds(e, !0)
          );
        },
        isInserted: function(e) {
          return tt.body.contains(e);
        },
        getPrefixed: function(e, i) {
          return e && t(e, i);
        },
        setPrefixed: function(e, i, n) {
          if (typeof i == "object")
            for (var r in i)
              t(e, r, !0, i[r]);
          else
            t(e, i, !0, n);
        }
      };
    }(), Nt = {
      add: function(t, e) {
        if (t)
          for (var i in e)
            for (var n = e[i], r = i.split(/[\s,]+/g), s = 0, u = r.length; s < u; s++) {
              var a = r[s], o = t === tt && (a === "touchstart" || a === "touchmove") ? { passive: !1 } : !1;
              t.addEventListener(a, n, o);
            }
      },
      remove: function(t, e) {
        if (t)
          for (var i in e)
            for (var n = e[i], r = i.split(/[\s,]+/g), s = 0, u = r.length; s < u; s++)
              t.removeEventListener(r[s], n, !1);
      },
      getPoint: function(t) {
        var e = t.targetTouches ? t.targetTouches.length ? t.targetTouches[0] : t.changedTouches[0] : t;
        return new E(
          e.pageX || e.clientX + tt.documentElement.scrollLeft,
          e.pageY || e.clientY + tt.documentElement.scrollTop
        );
      },
      getTarget: function(t) {
        return t.target || t.srcElement;
      },
      getRelatedTarget: function(t) {
        return t.relatedTarget || t.toElement;
      },
      getOffset: function(t, e) {
        return Nt.getPoint(t).subtract(At.getOffset(
          e || Nt.getTarget(t)
        ));
      }
    };
    Nt.requestAnimationFrame = new function() {
      var t = At.getPrefixed($, "requestAnimationFrame"), e = !1, i = [], n;
      function r() {
        var s = i;
        i = [];
        for (var u = 0, a = s.length; u < a; u++)
          s[u]();
        e = t && i.length, e && t(r);
      }
      return function(s) {
        i.push(s), t ? e || (t(r), e = !0) : n || (n = setInterval(r, 1e3 / 60));
      };
    }();
    var Tt = T.extend(
      vt,
      {
        _class: "View",
        initialize: function t(e, i) {
          function n(g) {
            return i[g] || parseInt(i.getAttribute(g), 10);
          }
          function r() {
            var g = At.getSize(i);
            return g.isNaN() || g.isZero() ? new W(n("width"), n("height")) : g;
          }
          var s;
          if ($ && i) {
            this._id = i.getAttribute("id"), this._id == null && i.setAttribute("id", this._id = "paper-view-" + t._id++), Nt.add(i, this._viewEvents);
            var u = "none";
            if (At.setPrefixed(i.style, {
              userDrag: u,
              userSelect: u,
              touchCallout: u,
              contentZooming: u,
              tapHighlightColor: "rgba(0,0,0,0)"
            }), yt.hasAttribute(i, "resize")) {
              var a = this;
              Nt.add($, this._windowEvents = {
                resize: function() {
                  a.setViewSize(r());
                }
              });
            }
            if (s = r(), yt.hasAttribute(i, "stats") && typeof Stats < "u") {
              this._stats = new Stats();
              var o = this._stats.domElement, h = o.style, d = At.getOffset(i);
              h.position = "absolute", h.left = d.x + "px", h.top = d.y + "px", tt.body.appendChild(o);
            }
          } else
            s = new W(i), i = null;
          this._project = e, this._scope = e._scope, this._element = i, this._pixelRatio || (this._pixelRatio = $ && $.devicePixelRatio || 1), this._setElementSize(s.width, s.height), this._viewSize = s, t._views.push(this), t._viewsById[this._id] = this, (this._matrix = new wt())._owner = this, t._focused || (t._focused = this), this._frameItems = {}, this._frameItemCount = 0, this._itemEvents = { native: {}, virtual: {} }, this._autoUpdate = !_t.agent.node, this._needsUpdate = !1;
        },
        remove: function() {
          if (!this._project)
            return !1;
          Tt._focused === this && (Tt._focused = null), Tt._views.splice(Tt._views.indexOf(this), 1), delete Tt._viewsById[this._id];
          var t = this._project;
          return t._view === this && (t._view = null), Nt.remove(this._element, this._viewEvents), Nt.remove($, this._windowEvents), this._element = this._project = null, this.off("frame"), this._animate = !1, this._frameItems = {}, !0;
        },
        _events: T.each(
          ft._itemHandlers.concat(["onResize", "onKeyDown", "onKeyUp"]),
          function(t) {
            this[t] = {};
          },
          {
            onFrame: {
              install: function() {
                this.play();
              },
              uninstall: function() {
                this.pause();
              }
            }
          }
        ),
        _animate: !1,
        _time: 0,
        _count: 0,
        getAutoUpdate: function() {
          return this._autoUpdate;
        },
        setAutoUpdate: function(t) {
          this._autoUpdate = t, t && this.requestUpdate();
        },
        update: function() {
        },
        draw: function() {
          this.update();
        },
        requestUpdate: function() {
          if (!this._requested) {
            var t = this;
            Nt.requestAnimationFrame(function() {
              if (t._requested = !1, t._animate) {
                t.requestUpdate();
                var e = t._element;
                (!At.getPrefixed(tt, "hidden") || yt.getAttribute(e, "keepalive") === "true") && At.isInView(e) && t._handleFrame();
              }
              t._autoUpdate && t.update();
            }), this._requested = !0;
          }
        },
        play: function() {
          this._animate = !0, this.requestUpdate();
        },
        pause: function() {
          this._animate = !1;
        },
        _handleFrame: function() {
          _t = this._scope;
          var t = Date.now() / 1e3, e = this._last ? t - this._last : 0;
          this._last = t, this.emit("frame", new T({
            delta: e,
            time: this._time += e,
            count: this._count++
          })), this._stats && this._stats.update();
        },
        _animateItem: function(t, e) {
          var i = this._frameItems;
          e ? (i[t._id] = {
            item: t,
            time: 0,
            count: 0
          }, ++this._frameItemCount === 1 && this.on("frame", this._handleFrameItems)) : (delete i[t._id], --this._frameItemCount === 0 && this.off("frame", this._handleFrameItems));
        },
        _handleFrameItems: function(t) {
          for (var e in this._frameItems) {
            var i = this._frameItems[e];
            i.item.emit("frame", new T(t, {
              time: i.time += t.delta,
              count: i.count++
            }));
          }
        },
        _changed: function() {
          this._project._changed(4097), this._bounds = this._decomposed = F;
        },
        getElement: function() {
          return this._element;
        },
        getPixelRatio: function() {
          return this._pixelRatio;
        },
        getResolution: function() {
          return this._pixelRatio * 72;
        },
        getViewSize: function() {
          var t = this._viewSize;
          return new Wt(t.width, t.height, this, "setViewSize");
        },
        setViewSize: function() {
          var t = W.read(arguments), e = t.subtract(this._viewSize);
          e.isZero() || (this._setElementSize(t.width, t.height), this._viewSize.set(t), this._changed(), this.emit("resize", { size: t, delta: e }), this._autoUpdate && this.update());
        },
        _setElementSize: function(t, e) {
          var i = this._element;
          i && (i.width !== t && (i.width = t), i.height !== e && (i.height = e));
        },
        getBounds: function() {
          return this._bounds || (this._bounds = this._matrix.inverted()._transformBounds(
            new et(new E(), this._viewSize)
          )), this._bounds;
        },
        getSize: function() {
          return this.getBounds().getSize();
        },
        isVisible: function() {
          return At.isInView(this._element);
        },
        isInserted: function() {
          return At.isInserted(this._element);
        },
        getPixelSize: function(t) {
          var e = this._element, i;
          if (e) {
            var n = e.parentNode, r = tt.createElement("div");
            r.style.fontSize = t, n.appendChild(r), i = parseFloat(At.getStyles(r).fontSize), n.removeChild(r);
          } else
            i = parseFloat(i);
          return i;
        },
        getTextWidth: function(t, e) {
          return 0;
        }
      },
      T.each(["rotate", "scale", "shear", "skew"], function(t) {
        var e = t === "rotate";
        this[t] = function() {
          var i = arguments, n = (e ? T : E).read(i), r = E.read(i, 0, { readNull: !0 });
          return this.transform(new wt()[t](
            n,
            r || this.getCenter(!0)
          ));
        };
      }, {
        _decompose: function() {
          return this._decomposed || (this._decomposed = this._matrix.decompose());
        },
        translate: function() {
          var t = new wt();
          return this.transform(t.translate.apply(t, arguments));
        },
        getCenter: function() {
          return this.getBounds().getCenter();
        },
        setCenter: function() {
          var t = E.read(arguments);
          this.translate(this.getCenter().subtract(t));
        },
        getZoom: function() {
          var t = this._decompose().scaling;
          return (t.x + t.y) / 2;
        },
        setZoom: function(t) {
          this.transform(new wt().scale(
            t / this.getZoom(),
            this.getCenter()
          ));
        },
        getRotation: function() {
          return this._decompose().rotation;
        },
        setRotation: function(t) {
          var e = this.getRotation();
          e != null && t != null && this.rotate(t - e);
        },
        getScaling: function() {
          var t = this._decompose().scaling;
          return new Zt(t.x, t.y, this, "setScaling");
        },
        setScaling: function() {
          var t = this.getScaling(), e = E.read(arguments, 0, { clone: !0, readNull: !0 });
          t && e && this.scale(e.x / t.x, e.y / t.y);
        },
        getMatrix: function() {
          return this._matrix;
        },
        setMatrix: function() {
          var t = this._matrix;
          t.set.apply(t, arguments);
        },
        transform: function(t) {
          this._matrix.append(t);
        },
        scrollBy: function() {
          this.translate(E.read(arguments).negate());
        }
      }),
      {
        projectToView: function() {
          return this._matrix._transformPoint(E.read(arguments));
        },
        viewToProject: function() {
          return this._matrix._inverseTransform(E.read(arguments));
        },
        getEventPoint: function(t) {
          return this.viewToProject(Nt.getOffset(t, this._element));
        }
      },
      {
        statics: {
          _views: [],
          _viewsById: {},
          _id: 0,
          create: function(t, e) {
            tt && typeof e == "string" && (e = tt.getElementById(e));
            var i = $ ? $i : Tt;
            return new i(t, e);
          }
        }
      },
      new function() {
        if (!$)
          return;
        var t, e, i = !1, n = !1;
        function r(P) {
          var O = Nt.getTarget(P);
          return O.getAttribute && Tt._viewsById[O.getAttribute("id")];
        }
        function s() {
          var P = Tt._focused;
          if (!P || !P.isVisible()) {
            for (var O = 0, L = Tt._views.length; O < L; O++)
              if ((P = Tt._views[O]).isVisible()) {
                Tt._focused = e = P;
                break;
              }
          }
        }
        function u(P, O, L) {
          P._handleMouseEvent("mousemove", O, L);
        }
        var a = $.navigator, o, h, d;
        a.pointerEnabled || a.msPointerEnabled ? (o = "pointerdown MSPointerDown", h = "pointermove MSPointerMove", d = "pointerup pointercancel MSPointerUp MSPointerCancel") : (o = "touchstart", h = "touchmove", d = "touchend touchcancel", "ontouchstart" in $ && a.userAgent.match(
          /mobile|tablet|ip(ad|hone|od)|android|silk/i
        ) || (o += " mousedown", h += " mousemove", d += " mouseup"));
        var g = {}, c = {
          mouseout: function(P) {
            var O = Tt._focused, L = Nt.getRelatedTarget(P);
            if (O && (!L || L.nodeName === "HTML")) {
              var B = Nt.getOffset(P, O._element), N = B.x, D = Math.abs, Z = D(N), G = 1 << 25, Y = Z - G;
              B.x = D(Y) < Z ? Y * (N < 0 ? -1 : 1) : N, u(O, P, O.viewToProject(B));
            }
          },
          scroll: s
        };
        g[o] = function(P) {
          var O = Tt._focused = r(P);
          i || (i = !0, O._handleMouseEvent("mousedown", P));
        }, c[h] = function(P) {
          var O = Tt._focused;
          if (!n) {
            var L = r(P);
            L ? O !== L && (O && u(O, P), t || (t = O), O = Tt._focused = e = L) : e && e === O && (t && !t.isInserted() && (t = null), O = Tt._focused = t, t = null, s());
          }
          O && u(O, P);
        }, c[o] = function() {
          n = !0;
        }, c[d] = function(P) {
          var O = Tt._focused;
          O && i && O._handleMouseEvent("mouseup", P), n = i = !1;
        }, Nt.add(tt, c), Nt.add($, {
          load: s
        });
        var f = !1, b = !1, v = {
          doubleclick: "click",
          mousedrag: "mousemove"
        }, x = !1, _, m, l, p, y, S, w, C;
        function I(P, O, L, B, N, D, Z) {
          var G = !1, Y;
          function X(V, U) {
            if (V.responds(U)) {
              if (Y || (Y = new en(
                U,
                B,
                N,
                O || V,
                D ? N.subtract(D) : null
              )), V.emit(U, Y) && (f = !0, Y.prevented && (b = !0), Y.stopped))
                return G = !0;
            } else {
              var K = v[U];
              if (K)
                return X(V, K);
            }
          }
          for (; P && P !== Z && !X(P, L); )
            P = P._parent;
          return G;
        }
        function M(P, O, L, B, N, D) {
          return P._project.removeOn(L), b = f = !1, y && I(
            y,
            null,
            L,
            B,
            N,
            D
          ) || O && O !== y && !O.isDescendant(y) && I(O, null, L === "mousedrag" ? "mousemove" : L, B, N, D, y) || I(
            P,
            y || O || P,
            L,
            B,
            N,
            D
          );
        }
        var k = {
          mousedown: {
            mousedown: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mouseup: {
            mouseup: 1,
            mousedrag: 1,
            click: 1,
            doubleclick: 1
          },
          mousemove: {
            mousedrag: 1,
            mousemove: 1,
            mouseenter: 1,
            mouseleave: 1
          }
        };
        return {
          _viewEvents: g,
          _handleMouseEvent: function(P, O, L) {
            var B = this._itemEvents, N = B.native[P], D = P === "mousemove", Z = this._scope.tool, G = this;
            function Y(rt) {
              return B.virtual[rt] || G.responds(rt) || Z && Z.responds(rt);
            }
            D && i && Y("mousedrag") && (P = "mousedrag"), L || (L = this.getEventPoint(O));
            var X = this.getBounds().contains(L), V = N && X && G._project.hitTest(L, {
              tolerance: 0,
              fill: !0,
              stroke: !0
            }), U = V && V.item || null, K = !1, Q = {};
            if (Q[P.substr(5)] = !0, N && U !== p && (p && I(p, null, "mouseleave", O, L), U && I(U, null, "mouseenter", O, L), p = U), x ^ X && (I(
              this,
              null,
              X ? "mouseenter" : "mouseleave",
              O,
              L
            ), K = !0), (X || Q.drag) && !L.equals(m) && (M(
              this,
              U,
              D ? P : "mousemove",
              O,
              L,
              m
            ), K = !0), x = X, Q.down && X || Q.up && _) {
              if (M(this, U, P, O, L, _), Q.down) {
                if (C = U === S && Date.now() - w < 300, l = S = U, !b && U) {
                  for (var J = U; J && !J.responds("mousedrag"); )
                    J = J._parent;
                  J && (y = U);
                }
                _ = L;
              } else
                Q.up && (!b && U === l && (w = Date.now(), M(this, U, C ? "doubleclick" : "click", O, L, _), C = !1), l = y = null);
              x = !1, K = !0;
            }
            m = L, K && Z && (f = Z._handleMouseEvent(P, O, L, Q) || f), O.cancelable !== !1 && (f && !Q.move || Q.down && Y("mouseup")) && O.preventDefault();
          },
          _handleKeyEvent: function(P, O, L, B) {
            var N = this._scope, D = N.tool, Z;
            function G(Y) {
              Y.responds(P) && (_t = N, Y.emit(P, Z = Z || new tn(P, O, L, B)));
            }
            this.isVisible() && (G(this), D && D.responds(P) && G(D));
          },
          _countItemEvent: function(P, O) {
            var L = this._itemEvents, B = L.native, N = L.virtual;
            for (var D in k)
              B[D] = (B[D] || 0) + (k[D][P] || 0) * O;
            N[P] = (N[P] || 0) + O;
          },
          statics: {
            updateFocus: s,
            _resetState: function() {
              i = n = f = x = !1, t = e = _ = m = l = p = y = S = w = C = null;
            }
          }
        };
      }()
    ), $i = Tt.extend({
      _class: "CanvasView",
      initialize: function(e, i) {
        if (!(i instanceof $.HTMLCanvasElement)) {
          var n = W.read(arguments, 1);
          if (n.isZero())
            throw new Error(
              "Cannot create CanvasView with the provided argument: " + T.slice(arguments, 1)
            );
          i = Dt.getCanvas(n);
        }
        var r = this._context = i.getContext("2d");
        if (r.save(), this._pixelRatio = 1, !/^off|false$/.test(yt.getAttribute(i, "hidpi"))) {
          var s = $.devicePixelRatio || 1, u = At.getPrefixed(
            r,
            "backingStorePixelRatio"
          ) || 1;
          this._pixelRatio = s / u;
        }
        Tt.call(this, e, i), this._needsUpdate = !0;
      },
      remove: function t() {
        return this._context.restore(), t.base.call(this);
      },
      _setElementSize: function t(e, i) {
        var n = this._pixelRatio;
        if (t.base.call(this, e * n, i * n), n !== 1) {
          var r = this._element, s = this._context;
          if (!yt.hasAttribute(r, "resize")) {
            var u = r.style;
            u.width = e + "px", u.height = i + "px";
          }
          s.restore(), s.save(), s.scale(n, n);
        }
      },
      getContext: function() {
        return this._context;
      },
      getPixelSize: function t(e) {
        var i = _t.agent, n;
        if (i && i.firefox)
          n = t.base.call(this, e);
        else {
          var r = this._context, s = r.font;
          r.font = e + " serif", n = parseFloat(r.font), r.font = s;
        }
        return n;
      },
      getTextWidth: function(t, e) {
        var i = this._context, n = i.font, r = 0;
        i.font = t;
        for (var s = 0, u = e.length; s < u; s++)
          r = Math.max(r, i.measureText(e[s]).width);
        return i.font = n, r;
      },
      update: function() {
        if (!this._needsUpdate)
          return !1;
        var t = this._project, e = this._context, i = this._viewSize;
        return e.clearRect(0, 0, i.width + 1, i.height + 1), t && t.draw(e, this._matrix, this._pixelRatio), this._needsUpdate = !1, !0;
      }
    }), We = T.extend({
      _class: "Event",
      initialize: function(e) {
        this.event = e, this.type = e && e.type;
      },
      prevented: !1,
      stopped: !1,
      preventDefault: function() {
        this.prevented = !0, this.event.preventDefault();
      },
      stopPropagation: function() {
        this.stopped = !0, this.event.stopPropagation();
      },
      stop: function() {
        this.stopPropagation(), this.preventDefault();
      },
      getTimeStamp: function() {
        return this.event.timeStamp;
      },
      getModifiers: function() {
        return Ci.modifiers;
      }
    }), tn = We.extend({
      _class: "KeyEvent",
      initialize: function(e, i, n, r) {
        this.type = e, this.event = i, this.key = n, this.character = r;
      },
      toString: function() {
        return "{ type: '" + this.type + "', key: '" + this.key + "', character: '" + this.character + "', modifiers: " + this.getModifiers() + " }";
      }
    }), Ci = new function() {
      var t = {
        "	": "tab",
        " ": "space",
        "\b": "backspace",
        "": "delete",
        Spacebar: "space",
        Del: "delete",
        Win: "meta",
        Esc: "escape"
      }, e = {
        tab: "	",
        space: " ",
        enter: "\r"
      }, i = {}, n = {}, r, s, u = new T({
        shift: !1,
        control: !1,
        alt: !1,
        meta: !1,
        capsLock: !1,
        space: !1
      }).inject({
        option: {
          get: function() {
            return this.alt;
          }
        },
        command: {
          get: function() {
            var h = _t && _t.agent;
            return h && h.mac ? this.meta : this.control;
          }
        }
      });
      function a(h) {
        var d = h.key || h.keyIdentifier;
        return d = /^U\+/.test(d) ? String.fromCharCode(parseInt(d.substr(2), 16)) : /^Arrow[A-Z]/.test(d) ? d.substr(5) : d === "Unidentified" || d === F ? String.fromCharCode(h.keyCode) : d, t[d] || (d.length > 1 ? T.hyphenate(d) : d.toLowerCase());
      }
      function o(h, d, g, c) {
        var f = Tt._focused, b;
        if (i[d] = h, h ? n[d] = g : delete n[d], d.length > 1 && (b = T.camelize(d)) in u) {
          u[b] = h;
          var v = _t && _t.agent;
          if (b === "meta" && v && v.mac)
            if (h)
              r = {};
            else {
              for (var x in r)
                x in n && o(!1, x, r[x], c);
              r = null;
            }
        } else
          h && r && (r[d] = g);
        f && f._handleKeyEvent(
          h ? "keydown" : "keyup",
          c,
          d,
          g
        );
      }
      return Nt.add(tt, {
        keydown: function(h) {
          var d = a(h), g = _t && _t.agent;
          d.length > 1 || g && g.chrome && (h.altKey || g.mac && h.metaKey || !g.mac && h.ctrlKey) ? o(
            !0,
            d,
            e[d] || (d.length > 1 ? "" : d),
            h
          ) : s = d;
        },
        keypress: function(h) {
          if (s) {
            var d = a(h), g = h.charCode, c = g >= 32 ? String.fromCharCode(g) : d.length > 1 ? "" : d;
            d !== s && (d = c.toLowerCase()), o(!0, d, c, h), s = null;
          }
        },
        keyup: function(h) {
          var d = a(h);
          d in n && o(!1, d, n[d], h);
        }
      }), Nt.add($, {
        blur: function(h) {
          for (var d in n)
            o(!1, d, n[d], h);
        }
      }), {
        modifiers: u,
        isDown: function(h) {
          return !!i[h];
        }
      };
    }(), en = We.extend({
      _class: "MouseEvent",
      initialize: function(e, i, n, r, s) {
        this.type = e, this.event = i, this.point = n, this.target = r, this.delta = s;
      },
      toString: function() {
        return "{ type: '" + this.type + "', point: " + this.point + ", target: " + this.target + (this.delta ? ", delta: " + this.delta : "") + ", modifiers: " + this.getModifiers() + " }";
      }
    }), nn = We.extend({
      _class: "ToolEvent",
      _item: null,
      initialize: function(e, i, n) {
        this.tool = e, this.type = i, this.event = n;
      },
      _choosePoint: function(t, e) {
        return t || (e ? e.clone() : null);
      },
      getPoint: function() {
        return this._choosePoint(this._point, this.tool._point);
      },
      setPoint: function(t) {
        this._point = t;
      },
      getLastPoint: function() {
        return this._choosePoint(this._lastPoint, this.tool._lastPoint);
      },
      setLastPoint: function(t) {
        this._lastPoint = t;
      },
      getDownPoint: function() {
        return this._choosePoint(this._downPoint, this.tool._downPoint);
      },
      setDownPoint: function(t) {
        this._downPoint = t;
      },
      getMiddlePoint: function() {
        return !this._middlePoint && this.tool._lastPoint ? this.tool._point.add(this.tool._lastPoint).divide(2) : this._middlePoint;
      },
      setMiddlePoint: function(t) {
        this._middlePoint = t;
      },
      getDelta: function() {
        return !this._delta && this.tool._lastPoint ? this.tool._point.subtract(this.tool._lastPoint) : this._delta;
      },
      setDelta: function(t) {
        this._delta = t;
      },
      getCount: function() {
        return this.tool[/^mouse(down|up)$/.test(this.type) ? "_downCount" : "_moveCount"];
      },
      setCount: function(t) {
        this.tool[/^mouse(down|up)$/.test(this.type) ? "downCount" : "count"] = t;
      },
      getItem: function() {
        if (!this._item) {
          var t = this.tool._scope.project.hitTest(this.getPoint());
          if (t) {
            for (var e = t.item, i = e._parent; /^(Group|CompoundPath)$/.test(i._class); )
              e = i, i = i._parent;
            this._item = e;
          }
        }
        return this._item;
      },
      setItem: function(t) {
        this._item = t;
      },
      toString: function() {
        return "{ type: " + this.type + ", point: " + this.getPoint() + ", count: " + this.getCount() + ", modifiers: " + this.getModifiers() + " }";
      }
    }), rn = Ct.extend({
      _class: "Tool",
      _list: "tools",
      _reference: "tool",
      _events: [
        "onMouseDown",
        "onMouseUp",
        "onMouseDrag",
        "onMouseMove",
        "onActivate",
        "onDeactivate",
        "onEditOptions",
        "onKeyDown",
        "onKeyUp"
      ],
      initialize: function(e) {
        Ct.call(this), this._moveCount = -1, this._downCount = -1, this.set(e);
      },
      getMinDistance: function() {
        return this._minDistance;
      },
      setMinDistance: function(t) {
        this._minDistance = t, t != null && this._maxDistance != null && t > this._maxDistance && (this._maxDistance = t);
      },
      getMaxDistance: function() {
        return this._maxDistance;
      },
      setMaxDistance: function(t) {
        this._maxDistance = t, this._minDistance != null && t != null && t < this._minDistance && (this._minDistance = t);
      },
      getFixedDistance: function() {
        return this._minDistance == this._maxDistance ? this._minDistance : null;
      },
      setFixedDistance: function(t) {
        this._minDistance = this._maxDistance = t;
      },
      _handleMouseEvent: function(t, e, i, n) {
        _t = this._scope, n.drag && !this.responds(t) && (t = "mousemove");
        var r = n.move || n.drag, s = this.responds(t), u = this.minDistance, a = this.maxDistance, o = !1, h = this;
        function d(c, f) {
          var b = i, v = r ? h._point : h._downPoint || b;
          if (r) {
            if (h._moveCount >= 0 && b.equals(v))
              return !1;
            if (v && (c != null || f != null)) {
              var x = b.subtract(v), _ = x.getLength();
              if (_ < (c || 0))
                return !1;
              f && (b = v.add(x.normalize(
                Math.min(_, f)
              )));
            }
            h._moveCount++;
          }
          return h._point = b, h._lastPoint = v || b, n.down && (h._moveCount = -1, h._downPoint = b, h._downCount++), !0;
        }
        function g() {
          s && (o = h.emit(t, new nn(h, t, e)) || o);
        }
        if (n.down)
          d(), g();
        else if (n.up)
          d(null, a), g();
        else if (s)
          for (; d(u, a); )
            g();
        return o;
      }
    }), sn = T.extend(vt, {
      _class: "Tween",
      statics: {
        easings: new T({
          linear: function(t) {
            return t;
          },
          easeInQuad: function(t) {
            return t * t;
          },
          easeOutQuad: function(t) {
            return t * (2 - t);
          },
          easeInOutQuad: function(t) {
            return t < 0.5 ? 2 * t * t : -1 + 2 * (2 - t) * t;
          },
          easeInCubic: function(t) {
            return t * t * t;
          },
          easeOutCubic: function(t) {
            return --t * t * t + 1;
          },
          easeInOutCubic: function(t) {
            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
          },
          easeInQuart: function(t) {
            return t * t * t * t;
          },
          easeOutQuart: function(t) {
            return 1 - --t * t * t * t;
          },
          easeInOutQuart: function(t) {
            return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
          },
          easeInQuint: function(t) {
            return t * t * t * t * t;
          },
          easeOutQuint: function(t) {
            return 1 + --t * t * t * t * t;
          },
          easeInOutQuint: function(t) {
            return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
          }
        })
      },
      initialize: function t(e, i, n, r, s, u) {
        this.object = e;
        var a = typeof s, o = a === "function";
        this.type = o ? a : a === "string" ? s : "linear", this.easing = o ? s : t.easings[this.type], this.duration = r, this.running = !1, this._then = null, this._startTime = null;
        var h = i || n;
        this._keys = h ? Object.keys(h) : [], this._parsedKeys = this._parseKeys(this._keys), this._from = h && this._getState(i), this._to = h && this._getState(n), u !== !1 && this.start();
      },
      then: function(t) {
        return this._then = t, this;
      },
      start: function() {
        return this._startTime = null, this.running = !0, this;
      },
      stop: function() {
        return this.running = !1, this;
      },
      update: function(t) {
        if (this.running) {
          t >= 1 && (t = 1, this.running = !1);
          for (var e = this.easing(t), i = this._keys, n = function(d) {
            return typeof d == "function" ? d(e, t) : d;
          }, r = 0, s = i && i.length; r < s; r++) {
            var u = i[r], a = n(this._from[u]), o = n(this._to[u]), h = a && o && a.__add && o.__add ? o.__subtract(a).__multiply(e).__add(a) : (o - a) * e + a;
            this._setProperty(this._parsedKeys[u], h);
          }
          this.responds("update") && this.emit("update", new T({
            progress: t,
            factor: e
          })), !this.running && this._then && this._then(this.object);
        }
        return this;
      },
      _events: {
        onUpdate: {}
      },
      _handleFrame: function(t) {
        var e = this._startTime, i = e ? (t - e) / this.duration : 0;
        e || (this._startTime = t), this.update(i);
      },
      _getState: function(t) {
        for (var e = this._keys, i = {}, n = 0, r = e.length; n < r; n++) {
          var s = e[n], u = this._parsedKeys[s], a = this._getProperty(u), o;
          if (t) {
            var h = this._resolveValue(a, t[s]);
            this._setProperty(u, h), o = this._getProperty(u), o = o && o.clone ? o.clone() : o, this._setProperty(u, a);
          } else
            o = a && a.clone ? a.clone() : a;
          i[s] = o;
        }
        return i;
      },
      _resolveValue: function(t, e) {
        if (e) {
          if (Array.isArray(e) && e.length === 2) {
            var i = e[0];
            return i && i.match && i.match(/^[+\-\*\/]=/) ? this._calculate(t, i[0], e[1]) : e;
          } else if (typeof e == "string") {
            var n = e.match(/^[+\-*/]=(.*)/);
            if (n) {
              var r = JSON.parse(n[1].replace(
                /(['"])?([a-zA-Z0-9_]+)(['"])?:/g,
                '"$2": '
              ));
              return this._calculate(t, e[0], r);
            }
          }
        }
        return e;
      },
      _calculate: function(t, e, i) {
        return _t.PaperScript.calculateBinary(t, e, i);
      },
      _parseKeys: function(t) {
        for (var e = {}, i = 0, n = t.length; i < n; i++) {
          var r = t[i], s = r.replace(/\.([^.]*)/g, "/$1").replace(/\[['"]?([^'"\]]*)['"]?\]/g, "/$1");
          e[r] = s.split("/");
        }
        return e;
      },
      _getProperty: function(t, e) {
        for (var i = this.object, n = 0, r = t.length - (e || 0); n < r && i; n++)
          i = i[t[n]];
        return i;
      },
      _setProperty: function(t, e) {
        var i = this._getProperty(t, 1);
        i && (i[t[t.length - 1]] = e);
      }
    }), Pi = {
      request: function(t) {
        var e = new q.XMLHttpRequest();
        return e.open(
          (t.method || "get").toUpperCase(),
          t.url,
          T.pick(t.async, !0)
        ), t.mimeType && e.overrideMimeType(t.mimeType), e.onload = function() {
          var i = e.status;
          i === 0 || i === 200 ? t.onLoad && t.onLoad.call(e, e.responseText) : e.onerror();
        }, e.onerror = function() {
          var i = e.status, n = 'Could not load "' + t.url + '" (Status: ' + i + ")";
          if (t.onError)
            t.onError(n, i);
          else
            throw new Error(n);
        }, e.send(null);
      }
    }, Dt = T.exports.CanvasProvider = {
      canvases: [],
      getCanvas: function(t, e, i) {
        if (!$)
          return null;
        var n, r = !0;
        typeof t == "object" && (e = t.height, t = t.width), this.canvases.length ? n = this.canvases.pop() : (n = tt.createElement("canvas"), r = !1);
        var s = n.getContext("2d", i || {});
        if (!s)
          throw new Error("Canvas " + n + " is unable to provide a 2D context.");
        return n.width === t && n.height === e ? r && s.clearRect(0, 0, t + 1, e + 1) : (n.width = t, n.height = e), s.save(), n;
      },
      getContext: function(t, e, i) {
        var n = this.getCanvas(t, e, i);
        return n ? n.getContext("2d", i || {}) : null;
      },
      release: function(t) {
        var e = t && t.canvas ? t.canvas : t;
        e && e.getContext && (e.getContext("2d").restore(), this.canvases.push(e));
      }
    }, si = new function() {
      var t = Math.min, e = Math.max, i = Math.abs, n, r, s, u, a, o, h, d, g, c, f;
      function b(y, S, w) {
        return 0.2989 * y + 0.587 * S + 0.114 * w;
      }
      function v(y, S, w, M) {
        var I = M - b(y, S, w);
        g = y + I, c = S + I, f = w + I;
        var M = b(g, c, f), k = t(g, c, f), P = e(g, c, f);
        if (k < 0) {
          var O = M - k;
          g = M + (g - M) * M / O, c = M + (c - M) * M / O, f = M + (f - M) * M / O;
        }
        if (P > 255) {
          var L = 255 - M, B = P - M;
          g = M + (g - M) * L / B, c = M + (c - M) * L / B, f = M + (f - M) * L / B;
        }
      }
      function x(y, S, w) {
        return e(y, S, w) - t(y, S, w);
      }
      function _(y, S, w, C) {
        var I = [y, S, w], M = e(y, S, w), k = t(y, S, w), P;
        k = k === y ? 0 : k === S ? 1 : 2, M = M === y ? 0 : M === S ? 1 : 2, P = t(k, M) === 0 ? e(k, M) === 1 ? 2 : 1 : 0, I[M] > I[k] ? (I[P] = (I[P] - I[k]) * C / (I[M] - I[k]), I[M] = C) : I[P] = I[M] = 0, I[k] = 0, g = I[0], c = I[1], f = I[2];
      }
      var m = {
        multiply: function() {
          g = a * n / 255, c = o * r / 255, f = h * s / 255;
        },
        screen: function() {
          g = a + n - a * n / 255, c = o + r - o * r / 255, f = h + s - h * s / 255;
        },
        overlay: function() {
          g = a < 128 ? 2 * a * n / 255 : 255 - 2 * (255 - a) * (255 - n) / 255, c = o < 128 ? 2 * o * r / 255 : 255 - 2 * (255 - o) * (255 - r) / 255, f = h < 128 ? 2 * h * s / 255 : 255 - 2 * (255 - h) * (255 - s) / 255;
        },
        "soft-light": function() {
          var y = n * a / 255;
          g = y + a * (255 - (255 - a) * (255 - n) / 255 - y) / 255, y = r * o / 255, c = y + o * (255 - (255 - o) * (255 - r) / 255 - y) / 255, y = s * h / 255, f = y + h * (255 - (255 - h) * (255 - s) / 255 - y) / 255;
        },
        "hard-light": function() {
          g = n < 128 ? 2 * n * a / 255 : 255 - 2 * (255 - n) * (255 - a) / 255, c = r < 128 ? 2 * r * o / 255 : 255 - 2 * (255 - r) * (255 - o) / 255, f = s < 128 ? 2 * s * h / 255 : 255 - 2 * (255 - s) * (255 - h) / 255;
        },
        "color-dodge": function() {
          g = a === 0 ? 0 : n === 255 ? 255 : t(255, 255 * a / (255 - n)), c = o === 0 ? 0 : r === 255 ? 255 : t(255, 255 * o / (255 - r)), f = h === 0 ? 0 : s === 255 ? 255 : t(255, 255 * h / (255 - s));
        },
        "color-burn": function() {
          g = a === 255 ? 255 : n === 0 ? 0 : e(0, 255 - (255 - a) * 255 / n), c = o === 255 ? 255 : r === 0 ? 0 : e(0, 255 - (255 - o) * 255 / r), f = h === 255 ? 255 : s === 0 ? 0 : e(0, 255 - (255 - h) * 255 / s);
        },
        darken: function() {
          g = a < n ? a : n, c = o < r ? o : r, f = h < s ? h : s;
        },
        lighten: function() {
          g = a > n ? a : n, c = o > r ? o : r, f = h > s ? h : s;
        },
        difference: function() {
          g = a - n, g < 0 && (g = -g), c = o - r, c < 0 && (c = -c), f = h - s, f < 0 && (f = -f);
        },
        exclusion: function() {
          g = a + n * (255 - a - a) / 255, c = o + r * (255 - o - o) / 255, f = h + s * (255 - h - h) / 255;
        },
        hue: function() {
          _(n, r, s, x(a, o, h)), v(g, c, f, b(a, o, h));
        },
        saturation: function() {
          _(a, o, h, x(n, r, s)), v(g, c, f, b(a, o, h));
        },
        luminosity: function() {
          v(a, o, h, b(n, r, s));
        },
        color: function() {
          v(n, r, s, b(a, o, h));
        },
        add: function() {
          g = t(a + n, 255), c = t(o + r, 255), f = t(h + s, 255);
        },
        subtract: function() {
          g = e(a - n, 0), c = e(o - r, 0), f = e(h - s, 0);
        },
        average: function() {
          g = (a + n) / 2, c = (o + r) / 2, f = (h + s) / 2;
        },
        negation: function() {
          g = 255 - i(255 - n - a), c = 255 - i(255 - r - o), f = 255 - i(255 - s - h);
        }
      }, l = this.nativeModes = T.each([
        "source-over",
        "source-in",
        "source-out",
        "source-atop",
        "destination-over",
        "destination-in",
        "destination-out",
        "destination-atop",
        "lighter",
        "darker",
        "copy",
        "xor"
      ], function(y) {
        this[y] = !0;
      }, {}), p = Dt.getContext(1, 1, { willReadFrequently: !0 });
      p && (T.each(m, function(y, S) {
        var w = S === "darken", C = !1;
        p.save();
        try {
          p.fillStyle = w ? "#300" : "#a00", p.fillRect(0, 0, 1, 1), p.globalCompositeOperation = S, p.globalCompositeOperation === S && (p.fillStyle = w ? "#a00" : "#300", p.fillRect(0, 0, 1, 1), C = p.getImageData(0, 0, 1, 1).data[0] !== w ? 170 : 51);
        } catch {
        }
        p.restore(), l[S] = C;
      }), Dt.release(p)), this.process = function(y, S, w, C, I) {
        var M = S.canvas, k = y === "normal";
        if (k || l[y])
          w.save(), w.setTransform(1, 0, 0, 1, 0, 0), w.globalAlpha = C, k || (w.globalCompositeOperation = y), w.drawImage(M, I.x, I.y), w.restore();
        else {
          var P = m[y];
          if (!P)
            return;
          for (var O = w.getImageData(
            I.x,
            I.y,
            M.width,
            M.height
          ), L = O.data, B = S.getImageData(
            0,
            0,
            M.width,
            M.height
          ).data, N = 0, D = L.length; N < D; N += 4) {
            n = B[N], a = L[N], r = B[N + 1], o = L[N + 1], s = B[N + 2], h = L[N + 2], u = B[N + 3], d = L[N + 3], P();
            var Z = u * C / 255, G = 1 - Z;
            L[N] = Z * g + G * a, L[N + 1] = Z * c + G * o, L[N + 2] = Z * f + G * h, L[N + 3] = u * C + G * d;
          }
          w.putImageData(O, I.x, I.y);
        }
      };
    }(), Ot = new function() {
      var t = "http://www.w3.org/2000/svg", e = "http://www.w3.org/2000/xmlns", i = "http://www.w3.org/1999/xlink", n = {
        href: i,
        xlink: e,
        xmlns: e + "/",
        "xmlns:xlink": e + "/"
      };
      function r(a, o, h) {
        return u(tt.createElementNS(t, a), o, h);
      }
      function s(a, o) {
        var h = n[o], d = h ? a.getAttributeNS(h, o) : a.getAttribute(o);
        return d === "null" ? null : d;
      }
      function u(a, o, h) {
        for (var d in o) {
          var g = o[d], c = n[d];
          typeof g == "number" && h && (g = h.number(g)), c ? a.setAttributeNS(c, d, g) : a.setAttribute(d, g);
        }
        return a;
      }
      return {
        svg: t,
        xmlns: e,
        xlink: i,
        create: r,
        get: s,
        set: u
      };
    }(), Ii = T.each({
      fillColor: ["fill", "color"],
      fillRule: ["fill-rule", "string"],
      strokeColor: ["stroke", "color"],
      strokeWidth: ["stroke-width", "number"],
      strokeCap: ["stroke-linecap", "string"],
      strokeJoin: ["stroke-linejoin", "string"],
      strokeScaling: ["vector-effect", "lookup", {
        true: "none",
        false: "non-scaling-stroke"
      }, function(t, e) {
        return !e && (t instanceof Ae || t instanceof It || t instanceof He);
      }],
      miterLimit: ["stroke-miterlimit", "number"],
      dashArray: ["stroke-dasharray", "array"],
      dashOffset: ["stroke-dashoffset", "number"],
      fontFamily: ["font-family", "string"],
      fontWeight: ["font-weight", "string"],
      fontSize: ["font-size", "number"],
      justification: ["text-anchor", "lookup", {
        left: "start",
        center: "middle",
        right: "end"
      }],
      opacity: ["opacity", "number"],
      blendMode: ["mix-blend-mode", "style"]
    }, function(t, e) {
      var i = T.capitalize(e), n = t[2];
      this[e] = {
        type: t[1],
        property: e,
        attribute: t[0],
        toSVG: n,
        fromSVG: n && T.each(n, function(r, s) {
          this[r] = s;
        }, {}),
        exportFilter: t[3],
        get: "get" + i,
        set: "set" + i
      };
    }, {});
    new function() {
      var t;
      function e(m, l, p) {
        var y = new T(), S = m.getTranslation();
        if (l) {
          var w;
          m.isInvertible() ? (m = m._shiftless(), w = m._inverseTransform(S), S = null) : w = new E(), y[p ? "cx" : "x"] = w.x, y[p ? "cy" : "y"] = w.y;
        }
        if (!m.isIdentity()) {
          var C = m.decompose();
          if (C) {
            var I = [], M = C.rotation, k = C.scaling, P = C.skewing;
            S && !S.isZero() && I.push("translate(" + t.point(S) + ")"), M && I.push("rotate(" + t.number(M) + ")"), (!lt.isZero(k.x - 1) || !lt.isZero(k.y - 1)) && I.push("scale(" + t.point(k) + ")"), P.x && I.push("skewX(" + t.number(P.x) + ")"), P.y && I.push("skewY(" + t.number(P.y) + ")"), y.transform = I.join(" ");
          } else
            y.transform = "matrix(" + m.getValues().join(",") + ")";
        }
        return y;
      }
      function i(m, l) {
        for (var p = e(m._matrix), y = m._children, S = Ot.create("g", p, t), w = 0, C = y.length; w < C; w++) {
          var I = y[w], M = x(I, l);
          if (M)
            if (I.isClipMask()) {
              var k = Ot.create("clipPath");
              k.appendChild(M), b(I, k, "clip"), Ot.set(S, {
                "clip-path": "url(#" + k.id + ")"
              });
            } else
              S.appendChild(M);
        }
        return S;
      }
      function n(m, l) {
        var p = e(m._matrix, !0), y = m.getSize(), S = m.getImage();
        return p.x -= y.width / 2, p.y -= y.height / 2, p.width = y.width, p.height = y.height, p.href = l.embedImages == !1 && S && S.src || m.toDataURL(), Ot.create("image", p, t);
      }
      function r(m, l) {
        var p = l.matchShapes;
        if (p) {
          var y = m.toShape(!1);
          if (y)
            return s(y);
        }
        var S = m._segments, w = S.length, C, I = e(m._matrix);
        if (p && w >= 2 && !m.hasHandles())
          if (w > 2) {
            C = m._closed ? "polygon" : "polyline";
            for (var M = [], k = 0; k < w; k++)
              M.push(t.point(S[k]._point));
            I.points = M.join(" ");
          } else {
            C = "line";
            var P = S[0]._point, O = S[1]._point;
            I.set({
              x1: P.x,
              y1: P.y,
              x2: O.x,
              y2: O.y
            });
          }
        else
          C = "path", I.d = m.getPathData(null, l.precision);
        return Ot.create(C, I, t);
      }
      function s(m) {
        var l = m._type, p = m._radius, y = e(m._matrix, !0, l !== "rectangle");
        if (l === "rectangle") {
          l = "rect";
          var S = m._size, w = S.width, C = S.height;
          y.x -= w / 2, y.y -= C / 2, y.width = w, y.height = C, p.isZero() && (p = null);
        }
        return p && (l === "circle" ? y.r = p : (y.rx = p.width, y.ry = p.height)), Ot.create(l, y, t);
      }
      function u(m, l) {
        var p = e(m._matrix), y = m.getPathData(null, l.precision);
        return y && (p.d = y), Ot.create("path", p, t);
      }
      function a(m, l) {
        var p = e(m._matrix, !0), y = m._definition, S = f(y, "symbol"), w = y._item, C = w.getStrokeBounds();
        return S || (S = Ot.create("symbol", {
          viewBox: t.rectangle(C)
        }), S.appendChild(x(w, l)), b(y, S, "symbol")), p.href = "#" + S.id, p.x += C.x, p.y += C.y, p.width = C.width, p.height = C.height, p.overflow = "visible", Ot.create("use", p, t);
      }
      function o(m) {
        var l = f(m, "color");
        if (!l) {
          var p = m.getGradient(), y = p._radial, S = m.getOrigin(), w = m.getDestination(), C;
          if (y) {
            C = {
              cx: S.x,
              cy: S.y,
              r: S.getDistance(w)
            };
            var I = m.getHighlight();
            I && (C.fx = I.x, C.fy = I.y);
          } else
            C = {
              x1: S.x,
              y1: S.y,
              x2: w.x,
              y2: w.y
            };
          C.gradientUnits = "userSpaceOnUse", l = Ot.create((y ? "radial" : "linear") + "Gradient", C, t);
          for (var M = p._stops, k = 0, P = M.length; k < P; k++) {
            var O = M[k], L = O._color, B = L.getAlpha(), N = O._offset;
            C = {
              offset: N ?? k / (P - 1)
            }, L && (C["stop-color"] = L.toCSS(!0)), B < 1 && (C["stop-opacity"] = B), l.appendChild(
              Ot.create("stop", C, t)
            );
          }
          b(m, l, "color");
        }
        return "url(#" + l.id + ")";
      }
      function h(m) {
        var l = Ot.create(
          "text",
          e(m._matrix, !0),
          t
        );
        return l.textContent = m._content, l;
      }
      var d = {
        Group: i,
        Layer: i,
        Raster: n,
        Path: r,
        Shape: s,
        CompoundPath: u,
        SymbolItem: a,
        PointText: h
      };
      function g(m, l, p) {
        var y = {}, S = !p && m.getParent(), w = [];
        return m._name != null && (y.id = m._name), T.each(Ii, function(C) {
          var I = C.get, M = C.type, k = m[I]();
          if (C.exportFilter ? C.exportFilter(m, k) : !S || !T.equals(S[I](), k)) {
            if (M === "color" && k != null) {
              var P = k.getAlpha();
              P < 1 && (y[C.attribute + "-opacity"] = P);
            }
            M === "style" ? w.push(C.attribute + ": " + k) : y[C.attribute] = k == null ? "none" : M === "color" ? k.gradient ? o(k) : k.toCSS(!0) : M === "array" ? k.join(",") : M === "lookup" ? C.toSVG[k] : k;
          }
        }), w.length && (y.style = w.join(";")), y.opacity === 1 && delete y.opacity, m._visible || (y.visibility = "hidden"), Ot.set(l, y, t);
      }
      var c;
      function f(m, l) {
        return c || (c = { ids: {}, svgs: {} }), m && c.svgs[l + "-" + (m._id || m.__id || (m.__id = xt.get("svg")))];
      }
      function b(m, l, p) {
        c || f();
        var y = c.ids[p] = (c.ids[p] || 0) + 1;
        l.id = p + "-" + y, c.svgs[p + "-" + (m._id || m.__id)] = l;
      }
      function v(m, l) {
        var p = m, y = null;
        if (c) {
          p = m.nodeName.toLowerCase() === "svg" && m;
          for (var S in c.svgs)
            y || (p || (p = Ot.create("svg"), p.appendChild(m)), y = p.insertBefore(
              Ot.create("defs"),
              p.firstChild
            )), y.appendChild(c.svgs[S]);
          c = null;
        }
        return l.asString ? new q.XMLSerializer().serializeToString(p) : p;
      }
      function x(m, l, p) {
        var y = d[m._class], S = y && y(m, l);
        if (S) {
          var w = l.onExport;
          w && (S = w(m, S, l) || S);
          var C = JSON.stringify(m._data);
          C && C !== "{}" && C !== "null" && S.setAttribute("data-paper-data", C);
        }
        return S && g(m, S, p);
      }
      function _(m) {
        return m || (m = {}), t = new St(m.precision), m;
      }
      ft.inject({
        exportSVG: function(m) {
          return m = _(m), v(x(this, m, !0), m);
        }
      }), Te.inject({
        exportSVG: function(m) {
          m = _(m);
          var l = this._children, p = this.getView(), y = T.pick(m.bounds, "view"), S = m.matrix || y === "view" && p._matrix, w = S && wt.read([S]), C = y === "view" ? new et([0, 0], p.getViewSize()) : y === "content" ? ft._getBounds(l, w, { stroke: !0 }).rect : et.read([y], 0, { readNull: !0 }), I = {
            version: "1.1",
            xmlns: Ot.svg,
            "xmlns:xlink": Ot.xlink
          };
          C && (I.width = C.width, I.height = C.height, (C.x || C.x === 0 || C.y || C.y === 0) && (I.viewBox = t.rectangle(C)));
          var M = Ot.create("svg", I, t), k = M;
          w && !w.isIdentity() && (k = M.appendChild(Ot.create(
            "g",
            e(w),
            t
          )));
          for (var P = 0, O = l.length; P < O; P++)
            k.appendChild(x(l[P], m, !0));
          return v(M, m);
        }
      });
    }(), new function() {
      var t = {}, e;
      function i(l, p, y, S, w, C) {
        var I = Ot.get(l, p) || C, M = I == null ? S ? null : y ? "" : 0 : y ? I : parseFloat(I);
        return /%\s*$/.test(I) ? M / 100 * (w ? 1 : e[/x|^width/.test(p) ? "width" : "height"]) : M;
      }
      function n(l, p, y, S, w, C, I) {
        return p = i(l, p || "x", !1, S, w, C), y = i(l, y || "y", !1, S, w, I), S && (p == null || y == null) ? null : new E(p, y);
      }
      function r(l, p, y, S, w) {
        return p = i(l, p || "width", !1, S, w), y = i(l, y || "height", !1, S, w), S && (p == null || y == null) ? null : new W(p, y);
      }
      function s(l, p, y) {
        return l === "none" ? null : p === "number" ? parseFloat(l) : p === "array" ? l ? l.split(/[\s,]+/g).map(parseFloat) : [] : p === "color" ? x(l) || l : p === "lookup" ? y[l] : l;
      }
      function u(l, p, y, S) {
        var w = l.childNodes, C = p === "clippath", I = p === "defs", M = new jt(), k = M._project, P = k._currentStyle, O = [];
        if (!C && !I && (M = v(M, l, S), k._currentStyle = M._style.clone()), S)
          for (var L = l.querySelectorAll("defs"), B = 0, N = L.length; B < N; B++)
            _(L[B], y, !1);
        for (var B = 0, N = w.length; B < N; B++) {
          var D = w[B], Z;
          D.nodeType === 1 && !/^defs$/i.test(D.nodeName) && (Z = _(D, y, !1)) && !(Z instanceof $t) && O.push(Z);
        }
        return M.addChildren(O), C && (M = v(M.reduce(), l, S)), k._currentStyle = P, (C || I) && (M.remove(), M = null), M;
      }
      function a(l, p) {
        for (var y = l.getAttribute("points").match(
          /[+-]?(?:\d*\.\d+|\d+\.?)(?:[eE][+-]?\d+)?/g
        ), S = [], w = 0, C = y.length; w < C; w += 2)
          S.push(new E(
            parseFloat(y[w]),
            parseFloat(y[w + 1])
          ));
        var I = new pt(S);
        return p === "polygon" && I.closePath(), I;
      }
      function o(l) {
        return Ae.create(l.getAttribute("d"));
      }
      function h(l, p) {
        var y = (i(l, "href", !0) || "").substring(1), S = p === "radialgradient", w;
        if (y)
          w = t[y].getGradient(), w._radial ^ S && (w = w.clone(), w._radial = S);
        else {
          for (var C = l.childNodes, I = [], M = 0, k = C.length; M < k; M++) {
            var P = C[M];
            P.nodeType === 1 && I.push(v(new ni(), P));
          }
          w = new Ze(I, S);
        }
        var O, L, B, N = i(l, "gradientUnits", !0) !== "userSpaceOnUse";
        S ? (O = n(
          l,
          "cx",
          "cy",
          !1,
          N,
          "50%",
          "50%"
        ), L = O.add(
          i(l, "r", !1, !1, N, "50%"),
          0
        ), B = n(l, "fx", "fy", !0, N)) : (O = n(
          l,
          "x1",
          "y1",
          !1,
          N,
          "0%",
          "0%"
        ), L = n(
          l,
          "x2",
          "y2",
          !1,
          N,
          "100%",
          "0%"
        ));
        var D = v(
          new Bt(w, O, L, B),
          l
        );
        return D._scaleToBounds = N, null;
      }
      var d = {
        "#document": function(l, p, y, S) {
          for (var w = l.childNodes, C = 0, I = w.length; C < I; C++) {
            var M = w[C];
            if (M.nodeType === 1)
              return _(M, y, S);
          }
        },
        g: u,
        svg: u,
        clippath: u,
        polygon: a,
        polyline: a,
        path: o,
        lineargradient: h,
        radialgradient: h,
        image: function(l) {
          var p = new he(i(l, "href", !0));
          return p.on("load", function() {
            var y = r(l);
            this.setSize(y);
            var S = n(l).add(y.divide(2));
            this._matrix.append(new wt().translate(S));
          }), p;
        },
        symbol: function(l, p, y, S) {
          return new $t(
            u(l, p, y, S),
            !0
          );
        },
        defs: u,
        use: function(l) {
          var p = (i(l, "href", !0) || "").substring(1), y = t[p], S = n(l);
          return y ? y instanceof $t ? y.place(S) : y.clone().translate(S) : null;
        },
        circle: function(l) {
          return new It.Circle(
            n(l, "cx", "cy"),
            i(l, "r")
          );
        },
        ellipse: function(l) {
          return new It.Ellipse({
            center: n(l, "cx", "cy"),
            radius: r(l, "rx", "ry")
          });
        },
        rect: function(l) {
          return new It.Rectangle(new et(
            n(l),
            r(l)
          ), r(l, "rx", "ry"));
        },
        line: function(l) {
          return new pt.Line(
            n(l, "x1", "y1"),
            n(l, "x2", "y2")
          );
        },
        text: function(l) {
          var p = new Qi(n(l).add(
            n(l, "dx", "dy")
          ));
          return p.setContent(l.textContent.trim() || ""), p;
        },
        switch: u
      };
      function g(l, p, y, S) {
        if (l.transform) {
          for (var w = (S.getAttribute(y) || "").split(/\)\s*/g), C = new wt(), I = 0, M = w.length; I < M; I++) {
            var k = w[I];
            if (!k)
              break;
            for (var P = k.split(/\(\s*/), O = P[0], L = P[1].split(/[\s,]+/g), B = 0, N = L.length; B < N; B++)
              L[B] = parseFloat(L[B]);
            switch (O) {
              case "matrix":
                C.append(
                  new wt(L[0], L[1], L[2], L[3], L[4], L[5])
                );
                break;
              case "rotate":
                C.rotate(L[0], L[1] || 0, L[2] || 0);
                break;
              case "translate":
                C.translate(L[0], L[1] || 0);
                break;
              case "scale":
                C.scale(L);
                break;
              case "skewX":
                C.skew(L[0], 0);
                break;
              case "skewY":
                C.skew(0, L[0]);
                break;
            }
          }
          l.transform(C);
        }
      }
      function c(l, p, y) {
        var S = y === "fill-opacity" ? "getFillColor" : "getStrokeColor", w = l[S] && l[S]();
        w && w.setAlpha(parseFloat(p));
      }
      var f = T.set(T.each(Ii, function(l) {
        this[l.attribute] = function(p, y) {
          if (p[l.set] && (p[l.set](s(y, l.type, l.fromSVG)), l.type === "color")) {
            var S = p[l.get]();
            if (S && S._scaleToBounds) {
              var w = p.getBounds();
              S.transform(new wt().translate(w.getPoint()).scale(w.getSize()));
            }
          }
        };
      }, {}), {
        id: function(l, p) {
          t[p] = l, l.setName && l.setName(p);
        },
        "clip-path": function(l, p) {
          var y = x(p);
          if (y)
            if (y = y.clone(), y.setClipMask(!0), l instanceof jt)
              l.insertChild(0, y);
            else
              return new jt(y, l);
        },
        gradientTransform: g,
        transform: g,
        "fill-opacity": c,
        "stroke-opacity": c,
        visibility: function(l, p) {
          l.setVisible && l.setVisible(p === "visible");
        },
        display: function(l, p) {
          l.setVisible && l.setVisible(p !== null);
        },
        "stop-color": function(l, p) {
          l.setColor && l.setColor(p);
        },
        "stop-opacity": function(l, p) {
          l._color && l._color.setAlpha(parseFloat(p));
        },
        offset: function(l, p) {
          if (l.setOffset) {
            var y = p.match(/(.*)%$/);
            l.setOffset(y ? y[1] / 100 : parseFloat(p));
          }
        },
        viewBox: function(l, p, y, S, w) {
          var C = new et(s(p, "array")), I = r(S, null, null, !0), M, k;
          if (l instanceof jt) {
            var P = I ? I.divide(C.getSize()) : 1, k = new wt().scale(P).translate(C.getPoint().negate());
            M = l;
          } else
            l instanceof $t && (I && C.setSize(I), M = l._item);
          if (M) {
            if (b(S, "overflow", w) !== "visible") {
              var O = new It.Rectangle(C);
              O.setClipMask(!0), M.addChild(O);
            }
            k && M.transform(k);
          }
        }
      });
      function b(l, p, y) {
        var S = l.attributes[p], w = S && S.value;
        if (!w && l.style) {
          var C = T.camelize(p);
          w = l.style[C], !w && y.node[C] !== y.parent[C] && (w = y.node[C]);
        }
        return w ? w === "none" ? null : w : F;
      }
      function v(l, p, y) {
        var S = p.parentNode, w = {
          node: At.getStyles(p) || {},
          parent: !y && !/^defs$/i.test(S.tagName) && At.getStyles(S) || {}
        };
        return T.each(f, function(C, I) {
          var M = b(p, I, w);
          l = M !== F && C(l, M, I, p, w) || l;
        }), l;
      }
      function x(l) {
        var p = l && l.match(/\((?:["'#]*)([^"')]+)/), y = p && p[1], S = y && t[$ ? y.replace($.location.href.split("#")[0] + "#", "") : y];
        return S && S._scaleToBounds && (S = S.clone(), S._scaleToBounds = !0), S;
      }
      function _(l, p, y) {
        var S = l.nodeName.toLowerCase(), w = S !== "#document", C = tt.body, I, M, k;
        y && w && (e = _t.getView().getSize(), e = r(l, null, null, !0) || e, I = Ot.create("svg", {
          style: "stroke-width: 1px; stroke-miterlimit: 10"
        }), M = l.parentNode, k = l.nextSibling, I.appendChild(l), C.appendChild(I));
        var P = _t.settings, O = P.applyMatrix, L = P.insertItems;
        P.applyMatrix = !1, P.insertItems = !1;
        var B = d[S], N = B && B(l, S, p, y) || null;
        if (P.insertItems = L, P.applyMatrix = O, N) {
          w && !(N instanceof jt) && (N = v(N, l, y));
          var D = p.onImport, Z = w && l.getAttribute("data-paper-data");
          D && (N = D(l, N, p) || N), p.expandShapes && N instanceof It && (N.remove(), N = N.toPath()), Z && (N._data = JSON.parse(Z));
        }
        return I && (C.removeChild(I), M && (k ? M.insertBefore(l, k) : M.appendChild(l))), y && (t = {}, N && T.pick(p.applyMatrix, O) && N.matrix.apply(!0, !0)), N;
      }
      function m(l, p, y) {
        if (!l)
          return null;
        p = typeof p == "function" ? { onLoad: p } : p || {};
        var S = _t, w = null;
        function C(P) {
          try {
            var O = typeof P == "object" ? P : new q.DOMParser().parseFromString(
              P.trim(),
              "image/svg+xml"
            );
            if (!O.nodeName)
              throw O = null, new Error("Unsupported SVG source: " + l);
            _t = S, w = _(O, p, !0), (!p || p.insert !== !1) && y._insertItem(F, w);
            var L = p.onLoad;
            L && L(w, P);
          } catch (B) {
            I(B);
          }
        }
        function I(P, O) {
          var L = p.onError;
          if (L)
            L(P, O);
          else
            throw new Error(P);
        }
        if (typeof l == "string" && !/^[\s\S]*</.test(l)) {
          var M = tt.getElementById(l);
          M ? C(M) : Pi.request({
            url: l,
            async: !0,
            onLoad: C,
            onError: I
          });
        } else if (typeof File < "u" && l instanceof File) {
          var k = new FileReader();
          return k.onload = function() {
            C(k.result);
          }, k.onerror = function() {
            I(k.error);
          }, k.readAsText(l);
        } else
          C(l);
        return w;
      }
      ft.inject({
        importSVG: function(l, p) {
          return m(l, p, this);
        }
      }), Te.inject({
        importSVG: function(l, p) {
          return this.activate(), m(l, p, this);
        }
      });
    }(), T.exports.PaperScript = function() {
      var t = this, e = t.acorn;
      if (!e && typeof Wn < "u")
        try {
          e = require("acorn");
        } catch {
        }
      if (!e) {
        var i, n;
        e = i = n = {}, function(v, x) {
          if (typeof i == "object" && typeof n == "object")
            return x(i);
          if (typeof F == "function" && F.amd)
            return F(["exports"], x);
          x(v.acorn || (v.acorn = {}));
        }(this, function(v) {
          v.version = "0.5.0";
          var x, _, m, l;
          v.parse = function(A, z) {
            return _ = String(A), m = _.length, y(z), Vi(), zn(x.program);
          };
          var p = v.defaultOptions = {
            ecmaVersion: 5,
            strictSemicolons: !1,
            allowTrailingCommas: !0,
            forbidReserved: !1,
            allowReturnOutsideFunction: !1,
            locations: !1,
            onComment: null,
            ranges: !1,
            program: null,
            sourceFile: null,
            directSourceFile: null
          };
          function y(A) {
            x = A || {};
            for (var z in p)
              Object.prototype.hasOwnProperty.call(x, z) || (x[z] = p[z]);
            l = x.sourceFile || null;
          }
          var S = v.getLineInfo = function(A, z) {
            for (var R = 1, H = 0; ; ) {
              Le.lastIndex = H;
              var st = Le.exec(A);
              if (st && st.index < z)
                ++R, H = st.index + st[0].length;
              else
                break;
            }
            return { line: R, column: z - H };
          };
          v.tokenize = function(A, z) {
            _ = String(A), m = _.length, y(z), Vi();
            var R = {};
            function H(st) {
              return Z = I, Pe(st), R.start = C, R.end = I, R.startLoc = M, R.endLoc = k, R.type = P, R.value = O, R;
            }
            return H.jumpTo = function(st, at) {
              if (w = st, x.locations) {
                B = 1, N = Le.lastIndex = 0;
                for (var ht; (ht = Le.exec(_)) && ht.index < st; )
                  ++B, N = ht.index + ht[0].length;
              }
              L = at, ze();
            }, H;
          };
          var w, C, I, M, k, P, O, L, B, N, D, Z, G, Y, X, V;
          function U(A, z) {
            var R = S(_, A);
            z += " (" + R.line + ":" + R.column + ")";
            var H = new SyntaxError(z);
            throw H.pos = A, H.loc = R, H.raisedAt = w, H;
          }
          var K = [], Q = { type: "num" }, J = { type: "regexp" }, rt = { type: "string" }, nt = { type: "name" }, ot = { type: "eof" }, ct = { keyword: "break" }, ut = { keyword: "case", beforeExpr: !0 }, Ft = { keyword: "catch" }, Rt = { keyword: "continue" }, Gt = { keyword: "debugger" }, kt = { keyword: "default" }, bt = { keyword: "do", isLoop: !0 }, Lt = { keyword: "else", beforeExpr: !0 }, Jt = { keyword: "finally" }, Vt = { keyword: "for", isLoop: !0 }, ee = { keyword: "function" }, pe = { keyword: "if" }, ne = { keyword: "return", beforeExpr: !0 }, re = { keyword: "switch" }, Qt = { keyword: "throw", beforeExpr: !0 }, te = { keyword: "try" }, me = { keyword: "var" }, se = { keyword: "while", isLoop: !0 }, Ge = { keyword: "with" }, Mi = { keyword: "new", beforeExpr: !0 }, Ti = { keyword: "this" }, Ai = { keyword: "null", atomValue: null }, Oi = { keyword: "true", atomValue: !0 }, ki = { keyword: "false", atomValue: !1 }, Ye = { keyword: "in", binop: 7, beforeExpr: !0 }, ai = {
            break: ct,
            case: ut,
            catch: Ft,
            continue: Rt,
            debugger: Gt,
            default: kt,
            do: bt,
            else: Lt,
            finally: Jt,
            for: Vt,
            function: ee,
            if: pe,
            return: ne,
            switch: re,
            throw: Qt,
            try: te,
            var: me,
            while: se,
            with: Ge,
            null: Ai,
            true: Oi,
            false: ki,
            new: Mi,
            in: Ye,
            instanceof: { keyword: "instanceof", binop: 7, beforeExpr: !0 },
            this: Ti,
            typeof: { keyword: "typeof", prefix: !0, beforeExpr: !0 },
            void: { keyword: "void", prefix: !0, beforeExpr: !0 },
            delete: { keyword: "delete", prefix: !0, beforeExpr: !0 }
          }, je = { type: "[", beforeExpr: !0 }, Ke = { type: "]" }, Oe = { type: "{", beforeExpr: !0 }, xe = { type: "}" }, ce = { type: "(", beforeExpr: !0 }, ae = { type: ")" }, _e = { type: ",", beforeExpr: !0 }, de = { type: ";", beforeExpr: !0 }, ke = { type: ":", beforeExpr: !0 }, ui = { type: "." }, oi = { type: "?", beforeExpr: !0 }, hi = { binop: 10, beforeExpr: !0 }, li = { isAssign: !0, beforeExpr: !0 }, Se = { isAssign: !0, beforeExpr: !0 }, an = { postfix: !0, prefix: !0, isUpdate: !0 }, Li = { prefix: !0, beforeExpr: !0 }, zi = { binop: 1, beforeExpr: !0 }, Ei = { binop: 2, beforeExpr: !0 }, un = { binop: 3, beforeExpr: !0 }, on = { binop: 4, beforeExpr: !0 }, hn = { binop: 5, beforeExpr: !0 }, ln = { binop: 6, beforeExpr: !0 }, fn = { binop: 7, beforeExpr: !0 }, cn = { binop: 8, beforeExpr: !0 }, dn = { binop: 9, prefix: !0, beforeExpr: !0 }, _n = { binop: 10, beforeExpr: !0 };
          v.tokTypes = {
            bracketL: je,
            bracketR: Ke,
            braceL: Oe,
            braceR: xe,
            parenL: ce,
            parenR: ae,
            comma: _e,
            semi: de,
            colon: ke,
            dot: ui,
            question: oi,
            slash: hi,
            eq: li,
            name: nt,
            eof: ot,
            num: Q,
            regexp: J,
            string: rt
          };
          for (var Bi in ai)
            v.tokTypes["_" + Bi] = ai[Bi];
          function De(A) {
            A = A.split(" ");
            var z = "", R = [];
            t:
              for (var H = 0; H < A.length; ++H) {
                for (var st = 0; st < R.length; ++st)
                  if (R[st][0].length == A[H].length) {
                    R[st].push(A[H]);
                    continue t;
                  }
                R.push([A[H]]);
              }
            function at(mt) {
              if (mt.length == 1)
                return z += "return str === " + JSON.stringify(mt[0]) + ";";
              z += "switch(str){";
              for (var oe = 0; oe < mt.length; ++oe)
                z += "case " + JSON.stringify(mt[oe]) + ":";
              z += "return true}return false;";
            }
            if (R.length > 3) {
              R.sort(function(mt, oe) {
                return oe.length - mt.length;
              }), z += "switch(str.length){";
              for (var H = 0; H < R.length; ++H) {
                var ht = R[H];
                z += "case " + ht[0].length + ":", at(ht);
              }
              z += "}";
            } else
              at(A);
            return new Function("str", z);
          }
          var gn = De("abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile"), vn = De("class enum extends super const export import"), Ni = De("implements interface let package private protected public static yield"), Xe = De("eval arguments"), pn = De("break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this"), mn = /[\u1680\u180e\u2000-\u200a\u202f\u205f\u3000\ufeff]/, Di = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԧԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠࢢ-ࢬऄ-हऽॐक़-ॡॱ-ॷॹ-ॿঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-ళవ-హఽౘౙౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൠൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛰᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦫᧁ-ᧇᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿌ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚗꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꞎꞐ-ꞓꞠ-Ɦꟸ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꪀ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", wn = "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ؚؠ-ىٲ-ۓۧ-ۨۻ-ۼܰ-݊ࠀ-ࠔࠛ-ࠣࠥ-ࠧࠩ-࠭ࡀ-ࡗࣤ-ࣾऀ-ःऺ-़ा-ॏ॑-ॗॢ-ॣ०-९ঁ-ঃ়া-ৄেৈৗয়-ৠਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣ૦-૯ଁ-ଃ଼ା-ୄେୈୋ-୍ୖୗୟ-ୠ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఁ-ఃె-ైొ-్ౕౖౢ-ౣ౦-౯ಂಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢ-ೣ೦-೯ംഃെ-ൈൗൢ-ൣ൦-൯ංඃ්ා-ුූෘ-ෟෲෳิ-ฺเ-ๅ๐-๙ິ-ູ່-ໍ໐-໙༘༙༠-༩༹༵༷ཁ-ཇཱ-྄྆-྇ྍ-ྗྙ-ྼ࿆က-ဩ၀-၉ၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟ᜎ-ᜐᜠ-ᜰᝀ-ᝐᝲᝳក-ឲ៝០-៩᠋-᠍᠐-᠙ᤠ-ᤫᤰ-᤻ᥑ-ᥭᦰ-ᧀᧈ-ᧉ᧐-᧙ᨀ-ᨕᨠ-ᩓ᩠-᩿᩼-᪉᪐-᪙ᭆ-ᭋ᭐-᭙᭫-᭳᮰-᮹᯦-᯳ᰀ-ᰢ᱀-᱉ᱛ-ᱽ᳐-᳒ᴀ-ᶾḁ-ἕ‌‍‿⁀⁔⃐-⃥⃜⃡-⃰ⶁ-ⶖⷠ-ⷿ〡-〨゙゚Ꙁ-ꙭꙴ-꙽ꚟ꛰-꛱ꟸ-ꠀ꠆ꠋꠣ-ꠧꢀ-ꢁꢴ-꣄꣐-꣙ꣳ-ꣷ꤀-꤉ꤦ-꤭ꤰ-ꥅꦀ-ꦃ꦳-꧀ꨀ-ꨧꩀ-ꩁꩌ-ꩍ꩐-꩙ꩻꫠ-ꫩꫲ-ꫳꯀ-ꯡ꯬꯭꯰-꯹ﬠ-ﬨ︀-️︠-︦︳︴﹍-﹏０-９＿", Fi = new RegExp("[" + Di + "]"), yn = new RegExp("[" + Di + wn + "]"), Je = /[\n\r\u2028\u2029]/, Le = /\r\n|[\n\r\u2028\u2029]/g, Qe = v.isIdentifierStart = function(A) {
            return A < 65 ? A === 36 : A < 91 ? !0 : A < 97 ? A === 95 : A < 123 ? !0 : A >= 170 && Fi.test(String.fromCharCode(A));
          }, Ri = v.isIdentifierChar = function(A) {
            return A < 48 ? A === 36 : A < 58 ? !0 : A < 65 ? !1 : A < 91 ? !0 : A < 97 ? A === 95 : A < 123 ? !0 : A >= 170 && yn.test(String.fromCharCode(A));
          };
          function Ce() {
            this.line = B, this.column = w - N;
          }
          function Vi() {
            B = 1, w = N = 0, L = !0, ze();
          }
          function Ut(A, z) {
            I = w, x.locations && (k = new Ce()), P = A, ze(), O = z, L = A.beforeExpr;
          }
          function bn() {
            var A = x.onComment && x.locations && new Ce(), z = w, R = _.indexOf("*/", w += 2);
            if (R === -1 && U(w - 2, "Unterminated comment"), w = R + 2, x.locations) {
              Le.lastIndex = z;
              for (var H; (H = Le.exec(_)) && H.index < w; )
                ++B, N = H.index + H[0].length;
            }
            x.onComment && x.onComment(
              !0,
              _.slice(z + 2, R),
              z,
              w,
              A,
              x.locations && new Ce()
            );
          }
          function fi() {
            for (var A = w, z = x.onComment && x.locations && new Ce(), R = _.charCodeAt(w += 2); w < m && R !== 10 && R !== 13 && R !== 8232 && R !== 8233; )
              ++w, R = _.charCodeAt(w);
            x.onComment && x.onComment(
              !1,
              _.slice(A + 2, w),
              A,
              w,
              z,
              x.locations && new Ce()
            );
          }
          function ze() {
            for (; w < m; ) {
              var A = _.charCodeAt(w);
              if (A === 32)
                ++w;
              else if (A === 13) {
                ++w;
                var z = _.charCodeAt(w);
                z === 10 && ++w, x.locations && (++B, N = w);
              } else if (A === 10 || A === 8232 || A === 8233)
                ++w, x.locations && (++B, N = w);
              else if (A > 8 && A < 14)
                ++w;
              else if (A === 47) {
                var z = _.charCodeAt(w + 1);
                if (z === 42)
                  bn();
                else if (z === 47)
                  fi();
                else
                  break;
              } else if (A === 160)
                ++w;
              else if (A >= 5760 && mn.test(String.fromCharCode(A)))
                ++w;
              else
                break;
            }
          }
          function xn() {
            var A = _.charCodeAt(w + 1);
            return A >= 48 && A <= 57 ? Ui(!0) : (++w, Ut(ui));
          }
          function Sn() {
            var A = _.charCodeAt(w + 1);
            return L ? (++w, qi()) : A === 61 ? Ht(Se, 2) : Ht(hi, 1);
          }
          function Cn() {
            var A = _.charCodeAt(w + 1);
            return A === 61 ? Ht(Se, 2) : Ht(_n, 1);
          }
          function Pn(A) {
            var z = _.charCodeAt(w + 1);
            return z === A ? Ht(A === 124 ? zi : Ei, 2) : z === 61 ? Ht(Se, 2) : Ht(A === 124 ? un : hn, 1);
          }
          function In() {
            var A = _.charCodeAt(w + 1);
            return A === 61 ? Ht(Se, 2) : Ht(on, 1);
          }
          function Mn(A) {
            var z = _.charCodeAt(w + 1);
            return z === A ? z == 45 && _.charCodeAt(w + 2) == 62 && Je.test(_.slice(Z, w)) ? (w += 3, fi(), ze(), Pe()) : Ht(an, 2) : z === 61 ? Ht(Se, 2) : Ht(dn, 1);
          }
          function Tn(A) {
            var z = _.charCodeAt(w + 1), R = 1;
            return z === A ? (R = A === 62 && _.charCodeAt(w + 2) === 62 ? 3 : 2, _.charCodeAt(w + R) === 61 ? Ht(Se, R + 1) : Ht(cn, R)) : z == 33 && A == 60 && _.charCodeAt(w + 2) == 45 && _.charCodeAt(w + 3) == 45 ? (w += 4, fi(), ze(), Pe()) : (z === 61 && (R = _.charCodeAt(w + 2) === 61 ? 3 : 2), Ht(fn, R));
          }
          function An(A) {
            var z = _.charCodeAt(w + 1);
            return z === 61 ? Ht(ln, _.charCodeAt(w + 2) === 61 ? 3 : 2) : Ht(A === 61 ? li : Li, 1);
          }
          function On(A) {
            switch (A) {
              case 46:
                return xn();
              case 40:
                return ++w, Ut(ce);
              case 41:
                return ++w, Ut(ae);
              case 59:
                return ++w, Ut(de);
              case 44:
                return ++w, Ut(_e);
              case 91:
                return ++w, Ut(je);
              case 93:
                return ++w, Ut(Ke);
              case 123:
                return ++w, Ut(Oe);
              case 125:
                return ++w, Ut(xe);
              case 58:
                return ++w, Ut(ke);
              case 63:
                return ++w, Ut(oi);
              case 48:
                var z = _.charCodeAt(w + 1);
                if (z === 120 || z === 88)
                  return kn();
              case 49:
              case 50:
              case 51:
              case 52:
              case 53:
              case 54:
              case 55:
              case 56:
              case 57:
                return Ui(!1);
              case 34:
              case 39:
                return Ln(A);
              case 47:
                return Sn();
              case 37:
              case 42:
                return Cn();
              case 124:
              case 38:
                return Pn(A);
              case 94:
                return In();
              case 43:
              case 45:
                return Mn(A);
              case 60:
              case 62:
                return Tn(A);
              case 61:
              case 33:
                return An(A);
              case 126:
                return Ht(Li, 1);
            }
            return !1;
          }
          function Pe(A) {
            if (A ? w = C + 1 : C = w, x.locations && (M = new Ce()), A)
              return qi();
            if (w >= m)
              return Ut(ot);
            var z = _.charCodeAt(w);
            if (Qe(z) || z === 92)
              return Zi();
            var R = On(z);
            if (R === !1) {
              var H = String.fromCharCode(z);
              if (H === "\\" || Fi.test(H))
                return Zi();
              U(w, "Unexpected character '" + H + "'");
            }
            return R;
          }
          function Ht(A, z) {
            var R = _.slice(w, w + z);
            w += z, Ut(A, R);
          }
          function qi() {
            for (var st = "", A, z, R = w; ; ) {
              w >= m && U(R, "Unterminated regular expression");
              var H = _.charAt(w);
              if (Je.test(H) && U(R, "Unterminated regular expression"), A)
                A = !1;
              else {
                if (H === "[")
                  z = !0;
                else if (H === "]" && z)
                  z = !1;
                else if (H === "/" && !z)
                  break;
                A = H === "\\";
              }
              ++w;
            }
            var st = _.slice(R, w);
            ++w;
            var at = Hi();
            at && !/^[gmsiy]*$/.test(at) && U(R, "Invalid regexp flag");
            try {
              var ht = new RegExp(st, at);
            } catch (mt) {
              mt instanceof SyntaxError && U(R, mt.message), U(mt);
            }
            return Ut(J, ht);
          }
          function Fe(A, z) {
            for (var R = w, H = 0, st = 0, at = z ?? 1 / 0; st < at; ++st) {
              var ht = _.charCodeAt(w), mt;
              if (ht >= 97 ? mt = ht - 97 + 10 : ht >= 65 ? mt = ht - 65 + 10 : ht >= 48 && ht <= 57 ? mt = ht - 48 : mt = 1 / 0, mt >= A)
                break;
              ++w, H = H * A + mt;
            }
            return w === R || z != null && w - R !== z ? null : H;
          }
          function kn() {
            w += 2;
            var A = Fe(16);
            return A == null && U(C + 2, "Expected hexadecimal number"), Qe(_.charCodeAt(w)) && U(w, "Identifier directly after number"), Ut(Q, A);
          }
          function Ui(A) {
            var z = w, R = !1, H = _.charCodeAt(w) === 48;
            !A && Fe(10) === null && U(z, "Invalid number"), _.charCodeAt(w) === 46 && (++w, Fe(10), R = !0);
            var st = _.charCodeAt(w);
            (st === 69 || st === 101) && (st = _.charCodeAt(++w), (st === 43 || st === 45) && ++w, Fe(10) === null && U(z, "Invalid number"), R = !0), Qe(_.charCodeAt(w)) && U(w, "Identifier directly after number");
            var at = _.slice(z, w), ht;
            return R ? ht = parseFloat(at) : !H || at.length === 1 ? ht = parseInt(at, 10) : /[89]/.test(at) || V ? U(z, "Invalid number") : ht = parseInt(at, 8), Ut(Q, ht);
          }
          function Ln(A) {
            w++;
            for (var z = ""; ; ) {
              w >= m && U(C, "Unterminated string constant");
              var R = _.charCodeAt(w);
              if (R === A)
                return ++w, Ut(rt, z);
              if (R === 92) {
                R = _.charCodeAt(++w);
                var H = /^[0-7]+/.exec(_.slice(w, w + 3));
                for (H && (H = H[0]); H && parseInt(H, 8) > 255; )
                  H = H.slice(0, -1);
                if (H === "0" && (H = null), ++w, H)
                  V && U(w - 2, "Octal literal in strict mode"), z += String.fromCharCode(parseInt(H, 8)), w += H.length - 1;
                else
                  switch (R) {
                    case 110:
                      z += `
`;
                      break;
                    case 114:
                      z += "\r";
                      break;
                    case 120:
                      z += String.fromCharCode($e(2));
                      break;
                    case 117:
                      z += String.fromCharCode($e(4));
                      break;
                    case 85:
                      z += String.fromCharCode($e(8));
                      break;
                    case 116:
                      z += "	";
                      break;
                    case 98:
                      z += "\b";
                      break;
                    case 118:
                      z += "\v";
                      break;
                    case 102:
                      z += "\f";
                      break;
                    case 48:
                      z += "\0";
                      break;
                    case 13:
                      _.charCodeAt(w) === 10 && ++w;
                    case 10:
                      x.locations && (N = w, ++B);
                      break;
                    default:
                      z += String.fromCharCode(R);
                      break;
                  }
              } else
                (R === 13 || R === 10 || R === 8232 || R === 8233) && U(C, "Unterminated string constant"), z += String.fromCharCode(R), ++w;
            }
          }
          function $e(A) {
            var z = Fe(16, A);
            return z === null && U(C, "Bad character escape sequence"), z;
          }
          var Ee;
          function Hi() {
            Ee = !1;
            for (var A, z = !0, R = w; ; ) {
              var H = _.charCodeAt(w);
              if (Ri(H))
                Ee && (A += _.charAt(w)), ++w;
              else if (H === 92) {
                Ee || (A = _.slice(R, w)), Ee = !0, _.charCodeAt(++w) != 117 && U(w, "Expecting Unicode escape sequence \\uXXXX"), ++w;
                var st = $e(4), at = String.fromCharCode(st);
                at || U(w - 1, "Invalid Unicode escape"), (z ? Qe(st) : Ri(st)) || U(w - 4, "Invalid Unicode escape"), A += at;
              } else
                break;
              z = !1;
            }
            return Ee ? A : _.slice(R, w);
          }
          function Zi() {
            var A = Hi(), z = nt;
            return !Ee && pn(A) && (z = ai[A]), Ut(z, A);
          }
          function gt() {
            D = C, Z = I, G = k, Pe();
          }
          function ci(A) {
            if (V = A, w = C, x.locations)
              for (; w < N; )
                N = _.lastIndexOf(`
`, N - 2) + 1, --B;
            ze(), Pe();
          }
          function Wi() {
            this.type = null, this.start = C, this.end = null;
          }
          function Gi() {
            this.start = M, this.end = null, l !== null && (this.source = l);
          }
          function Yt() {
            var A = new Wi();
            return x.locations && (A.loc = new Gi()), x.directSourceFile && (A.sourceFile = x.directSourceFile), x.ranges && (A.range = [C, 0]), A;
          }
          function we(A) {
            var z = new Wi();
            return z.start = A.start, x.locations && (z.loc = new Gi(), z.loc.start = A.loc.start), x.ranges && (z.range = [A.range[0], 0]), z;
          }
          function dt(A, z) {
            return A.type = z, A.end = Z, x.locations && (A.loc.end = G), x.ranges && (A.range[1] = Z), A;
          }
          function di(A) {
            return x.ecmaVersion >= 5 && A.type === "ExpressionStatement" && A.expression.type === "Literal" && A.expression.value === "use strict";
          }
          function Mt(A) {
            if (P === A)
              return gt(), !0;
          }
          function ti() {
            return !x.strictSemicolons && (P === ot || P === xe || Je.test(_.slice(Z, C)));
          }
          function Ie() {
            !Mt(de) && !ti() && ge();
          }
          function zt(A) {
            P === A ? gt() : ge();
          }
          function ge() {
            U(C, "Unexpected token");
          }
          function ei(A) {
            A.type !== "Identifier" && A.type !== "MemberExpression" && U(A.start, "Assigning to rvalue"), V && A.type === "Identifier" && Xe(A.name) && U(A.start, "Assigning to " + A.name + " in strict mode");
          }
          function zn(A) {
            D = Z = w, x.locations && (G = new Ce()), Y = V = null, X = [], Pe();
            var z = A || Yt(), R = !0;
            for (A || (z.body = []); P !== ot; ) {
              var H = ue();
              z.body.push(H), R && di(H) && ci(!0), R = !1;
            }
            return dt(z, "Program");
          }
          var _i = { kind: "loop" }, En = { kind: "switch" };
          function ue() {
            (P === hi || P === Se && O == "/=") && Pe(!0);
            var A = P, z = Yt();
            switch (A) {
              case ct:
              case Rt:
                gt();
                var R = A === ct;
                Mt(de) || ti() ? z.label = null : P !== nt ? ge() : (z.label = ye(), Ie());
                for (var H = 0; H < X.length; ++H) {
                  var st = X[H];
                  if ((z.label == null || st.name === z.label.name) && (st.kind != null && (R || st.kind === "loop") || z.label && R))
                    break;
                }
                return H === X.length && U(z.start, "Unsyntactic " + A.keyword), dt(z, R ? "BreakStatement" : "ContinueStatement");
              case Gt:
                return gt(), Ie(), dt(z, "DebuggerStatement");
              case bt:
                return gt(), X.push(_i), z.body = ue(), X.pop(), zt(se), z.test = Re(), Ie(), dt(z, "DoWhileStatement");
              case Vt:
                if (gt(), X.push(_i), zt(ce), P === de)
                  return gi(z, null);
                if (P === me) {
                  var at = Yt();
                  return gt(), ji(at, !0), dt(at, "VariableDeclaration"), at.declarations.length === 1 && Mt(Ye) ? Yi(z, at) : gi(z, at);
                }
                var at = Xt(!1, !0);
                return Mt(Ye) ? (ei(at), Yi(z, at)) : gi(z, at);
              case ee:
                return gt(), yi(z, !0);
              case pe:
                return gt(), z.test = Re(), z.consequent = ue(), z.alternate = Mt(Lt) ? ue() : null, dt(z, "IfStatement");
              case ne:
                return !Y && !x.allowReturnOutsideFunction && U(C, "'return' outside of function"), gt(), Mt(de) || ti() ? z.argument = null : (z.argument = Xt(), Ie()), dt(z, "ReturnStatement");
              case re:
                gt(), z.discriminant = Re(), z.cases = [], zt(Oe), X.push(En);
                for (var ht, mt; P != xe; )
                  if (P === ut || P === kt) {
                    var oe = P === ut;
                    ht && dt(ht, "SwitchCase"), z.cases.push(ht = Yt()), ht.consequent = [], gt(), oe ? ht.test = Xt() : (mt && U(D, "Multiple default clauses"), mt = !0, ht.test = null), zt(ke);
                  } else
                    ht || ge(), ht.consequent.push(ue());
                return ht && dt(ht, "SwitchCase"), gt(), X.pop(), dt(z, "SwitchStatement");
              case Qt:
                return gt(), Je.test(_.slice(Z, C)) && U(Z, "Illegal newline after throw"), z.argument = Xt(), Ie(), dt(z, "ThrowStatement");
              case te:
                if (gt(), z.block = Ve(), z.handler = null, P === Ft) {
                  var Me = Yt();
                  gt(), zt(ce), Me.param = ye(), V && Xe(Me.param.name) && U(Me.param.start, "Binding " + Me.param.name + " in strict mode"), zt(ae), Me.guard = null, Me.body = Ve(), z.handler = dt(Me, "CatchClause");
                }
                return z.guardedHandlers = K, z.finalizer = Mt(Jt) ? Ve() : null, !z.handler && !z.finalizer && U(z.start, "Missing catch or finally clause"), dt(z, "TryStatement");
              case me:
                return gt(), ji(z), Ie(), dt(z, "VariableDeclaration");
              case se:
                return gt(), z.test = Re(), X.push(_i), z.body = ue(), X.pop(), dt(z, "WhileStatement");
              case Ge:
                return V && U(C, "'with' in strict mode"), gt(), z.object = Re(), z.body = ue(), dt(z, "WithStatement");
              case Oe:
                return Ve();
              case de:
                return gt(), dt(z, "EmptyStatement");
              default:
                var xi = O, ii = Xt();
                if (A === nt && ii.type === "Identifier" && Mt(ke)) {
                  for (var H = 0; H < X.length; ++H)
                    X[H].name === xi && U(ii.start, "Label '" + xi + "' is already declared");
                  var Vn = P.isLoop ? "loop" : P === re ? "switch" : null;
                  return X.push({ name: xi, kind: Vn }), z.body = ue(), X.pop(), z.label = ii, dt(z, "LabeledStatement");
                } else
                  return z.expression = ii, Ie(), dt(z, "ExpressionStatement");
            }
          }
          function Re() {
            zt(ce);
            var A = Xt();
            return zt(ae), A;
          }
          function Ve(A) {
            var z = Yt(), R = !0, H = !1, st;
            for (z.body = [], zt(Oe); !Mt(xe); ) {
              var at = ue();
              z.body.push(at), R && A && di(at) && (st = H, ci(H = !0)), R = !1;
            }
            return H && !st && ci(!1), dt(z, "BlockStatement");
          }
          function gi(A, z) {
            return A.init = z, zt(de), A.test = P === de ? null : Xt(), zt(de), A.update = P === ae ? null : Xt(), zt(ae), A.body = ue(), X.pop(), dt(A, "ForStatement");
          }
          function Yi(A, z) {
            return A.left = z, A.right = Xt(), zt(ae), A.body = ue(), X.pop(), dt(A, "ForInStatement");
          }
          function ji(A, z) {
            for (A.declarations = [], A.kind = "var"; ; ) {
              var R = Yt();
              if (R.id = ye(), V && Xe(R.id.name) && U(R.id.start, "Binding " + R.id.name + " in strict mode"), R.init = Mt(li) ? Xt(!0, z) : null, A.declarations.push(dt(R, "VariableDeclarator")), !Mt(_e))
                break;
            }
            return A;
          }
          function Xt(A, z) {
            var R = vi(z);
            if (!A && P === _e) {
              var H = we(R);
              for (H.expressions = [R]; Mt(_e); )
                H.expressions.push(vi(z));
              return dt(H, "SequenceExpression");
            }
            return R;
          }
          function vi(A) {
            var z = Bn(A);
            if (P.isAssign) {
              var R = we(z);
              return R.operator = O, R.left = z, gt(), R.right = vi(A), ei(z), dt(R, "AssignmentExpression");
            }
            return z;
          }
          function Bn(A) {
            var z = Nn(A);
            if (Mt(oi)) {
              var R = we(z);
              return R.test = z, R.consequent = Xt(!0), zt(ke), R.alternate = Xt(!0, A), dt(R, "ConditionalExpression");
            }
            return z;
          }
          function Nn(A) {
            return pi(mi(), -1, A);
          }
          function pi(A, z, R) {
            var H = P.binop;
            if (H != null && (!R || P !== Ye) && H > z) {
              var st = we(A);
              st.left = A, st.operator = O;
              var at = P;
              gt(), st.right = pi(mi(), H, R);
              var ht = dt(st, at === zi || at === Ei ? "LogicalExpression" : "BinaryExpression");
              return pi(ht, z, R);
            }
            return A;
          }
          function mi() {
            if (P.prefix) {
              var A = Yt(), z = P.isUpdate;
              return A.operator = O, A.prefix = !0, L = !0, gt(), A.argument = mi(), z ? ei(A.argument) : V && A.operator === "delete" && A.argument.type === "Identifier" && U(A.start, "Deleting local variable in strict mode"), dt(A, z ? "UpdateExpression" : "UnaryExpression");
            }
            for (var R = Dn(); P.postfix && !ti(); ) {
              var A = we(R);
              A.operator = O, A.prefix = !1, A.argument = R, ei(R), gt(), R = dt(A, "UpdateExpression");
            }
            return R;
          }
          function Dn() {
            return qe(wi());
          }
          function qe(A, z) {
            if (Mt(ui)) {
              var R = we(A);
              return R.object = A, R.property = ye(!0), R.computed = !1, qe(dt(R, "MemberExpression"), z);
            } else if (Mt(je)) {
              var R = we(A);
              return R.object = A, R.property = Xt(), R.computed = !0, zt(Ke), qe(dt(R, "MemberExpression"), z);
            } else if (!z && Mt(ce)) {
              var R = we(A);
              return R.callee = A, R.arguments = bi(ae, !1), qe(dt(R, "CallExpression"), z);
            } else
              return A;
          }
          function wi() {
            switch (P) {
              case Ti:
                var H = Yt();
                return gt(), dt(H, "ThisExpression");
              case nt:
                return ye();
              case Q:
              case rt:
              case J:
                var H = Yt();
                return H.value = O, H.raw = _.slice(C, I), gt(), dt(H, "Literal");
              case Ai:
              case Oi:
              case ki:
                var H = Yt();
                return H.value = P.atomValue, H.raw = P.keyword, gt(), dt(H, "Literal");
              case ce:
                var A = M, z = C;
                gt();
                var R = Xt();
                return R.start = z, R.end = I, x.locations && (R.loc.start = A, R.loc.end = k), x.ranges && (R.range = [z, I]), zt(ae), R;
              case je:
                var H = Yt();
                return gt(), H.elements = bi(Ke, !0, !0), dt(H, "ArrayExpression");
              case Oe:
                return Rn();
              case ee:
                var H = Yt();
                return gt(), yi(H, !1);
              case Mi:
                return Fn();
              default:
                ge();
            }
          }
          function Fn() {
            var A = Yt();
            return gt(), A.callee = qe(wi(), !0), Mt(ce) ? A.arguments = bi(ae, !1) : A.arguments = K, dt(A, "NewExpression");
          }
          function Rn() {
            var A = Yt(), z = !0, R = !1;
            for (A.properties = [], gt(); !Mt(xe); ) {
              if (z)
                z = !1;
              else if (zt(_e), x.allowTrailingCommas && Mt(xe))
                break;
              var H = { key: Ki() }, st = !1, at;
              if (Mt(ke) ? (H.value = Xt(!0), at = H.kind = "init") : x.ecmaVersion >= 5 && H.key.type === "Identifier" && (H.key.name === "get" || H.key.name === "set") ? (st = R = !0, at = H.kind = H.key.name, H.key = Ki(), P !== ce && ge(), H.value = yi(Yt(), !1)) : ge(), H.key.type === "Identifier" && (V || R))
                for (var ht = 0; ht < A.properties.length; ++ht) {
                  var mt = A.properties[ht];
                  if (mt.key.name === H.key.name) {
                    var oe = at == mt.kind || st && mt.kind === "init" || at === "init" && (mt.kind === "get" || mt.kind === "set");
                    oe && !V && at === "init" && mt.kind === "init" && (oe = !1), oe && U(H.key.start, "Redefinition of property");
                  }
                }
              A.properties.push(H);
            }
            return dt(A, "ObjectExpression");
          }
          function Ki() {
            return P === Q || P === rt ? wi() : ye(!0);
          }
          function yi(A, z) {
            P === nt ? A.id = ye() : z ? ge() : A.id = null, A.params = [];
            var R = !0;
            for (zt(ce); !Mt(ae); )
              R ? R = !1 : zt(_e), A.params.push(ye());
            var H = Y, st = X;
            if (Y = !0, X = [], A.body = Ve(!0), Y = H, X = st, V || A.body.body.length && di(A.body.body[0]))
              for (var at = A.id ? -1 : 0; at < A.params.length; ++at) {
                var ht = at < 0 ? A.id : A.params[at];
                if ((Ni(ht.name) || Xe(ht.name)) && U(ht.start, "Defining '" + ht.name + "' in strict mode"), at >= 0)
                  for (var mt = 0; mt < at; ++mt)
                    ht.name === A.params[mt].name && U(ht.start, "Argument name clash in strict mode");
              }
            return dt(A, z ? "FunctionDeclaration" : "FunctionExpression");
          }
          function bi(A, z, R) {
            for (var H = [], st = !0; !Mt(A); ) {
              if (st)
                st = !1;
              else if (zt(_e), z && x.allowTrailingCommas && Mt(A))
                break;
              R && P === _e ? H.push(null) : H.push(Xt(!0));
            }
            return H;
          }
          function ye(A) {
            var z = Yt();
            return A && x.forbidReserved == "everywhere" && (A = !1), P === nt ? (!A && (x.forbidReserved && (x.ecmaVersion === 3 ? gn : vn)(O) || V && Ni(O)) && _.slice(C, I).indexOf("\\") == -1 && U(C, "The keyword '" + O + "' is reserved"), z.name = O) : A && P.keyword ? z.name = P.keyword : ge(), L = !1, gt(), dt(z, "Identifier");
          }
        }), e.version || (e = null);
      }
      function r(v, x) {
        return (t.acorn || e).parse(v, x);
      }
      var s = {
        "+": "__add",
        "-": "__subtract",
        "*": "__multiply",
        "/": "__divide",
        "%": "__modulo",
        "==": "__equals",
        "!=": "__equals"
      }, u = {
        "-": "__negate",
        "+": "__self"
      }, a = T.each(
        ["add", "subtract", "multiply", "divide", "modulo", "equals", "negate"],
        function(v) {
          this["__" + v] = "#" + v;
        },
        {
          __self: function() {
            return this;
          }
        }
      );
      E.inject(a), W.inject(a), Bt.inject(a);
      function o(v, x, _) {
        var m = s[x];
        if (v && v[m]) {
          var l = v[m](_);
          return x === "!=" ? !l : l;
        }
        switch (x) {
          case "+":
            return v + _;
          case "-":
            return v - _;
          case "*":
            return v * _;
          case "/":
            return v / _;
          case "%":
            return v % _;
          case "==":
            return v == _;
          case "!=":
            return v != _;
        }
      }
      function h(v, x) {
        var _ = u[v];
        if (x && x[_])
          return x[_]();
        switch (v) {
          case "+":
            return +x;
          case "-":
            return -x;
        }
      }
      function d(v, x) {
        if (!v)
          return "";
        x = x || {};
        var _ = [];
        function m(V) {
          for (var U = 0, K = _.length; U < K; U++) {
            var Q = _[U];
            if (Q[0] >= V)
              break;
            V += Q[1];
          }
          return V;
        }
        function l(V) {
          return v.substring(
            m(V.range[0]),
            m(V.range[1])
          );
        }
        function p(V, U) {
          return v.substring(
            m(V.range[1]),
            m(U.range[0])
          );
        }
        function y(V, U) {
          for (var K = m(V.range[0]), Q = m(V.range[1]), J = 0, rt = _.length - 1; rt >= 0; rt--)
            if (K > _[rt][0]) {
              J = rt + 1;
              break;
            }
          _.splice(J, 0, [K, U.length - Q + K]), v = v.substring(0, K) + U + v.substring(Q);
        }
        function S(V, U) {
          switch (V.type) {
            case "UnaryExpression":
              if (V.operator in u && V.argument.type !== "Literal") {
                var K = l(V.argument);
                y(V, '$__("' + V.operator + '", ' + K + ")");
              }
              break;
            case "BinaryExpression":
              if (V.operator in s && V.left.type !== "Literal") {
                var Q = l(V.left), J = l(V.right), rt = p(V.left, V.right), nt = V.operator;
                y(V, "__$__(" + Q + "," + rt.replace(
                  new RegExp("\\" + nt),
                  '"' + nt + '"'
                ) + ", " + J + ")");
              }
              break;
            case "UpdateExpression":
            case "AssignmentExpression":
              var ot = U && U.type;
              if (!(ot === "ForStatement" || ot === "BinaryExpression" && /^[=!<>]/.test(U.operator) || ot === "MemberExpression" && U.computed)) {
                if (V.type === "UpdateExpression") {
                  var K = l(V.argument), ct = "__$__(" + K + ', "' + V.operator[0] + '", 1)', ut = K + " = " + ct;
                  V.prefix ? ut = "(" + ut + ")" : (ot === "AssignmentExpression" || ot === "VariableDeclarator" || ot === "BinaryExpression") && (l(U.left || U.id) === K && (ut = ct), ut = K + "; " + ut), y(V, ut);
                } else if (/^.=$/.test(V.operator) && V.left.type !== "Literal") {
                  var Q = l(V.left), J = l(V.right), ct = Q + " = __$__(" + Q + ', "' + V.operator[0] + '", ' + J + ")";
                  y(V, /^\(.*\)$/.test(l(V)) ? "(" + ct + ")" : ct);
                }
              }
              break;
          }
        }
        function w(V) {
          switch (V.type) {
            case "ExportDefaultDeclaration":
              y({
                range: [V.start, V.declaration.start]
              }, "module.exports = ");
              break;
            case "ExportNamedDeclaration":
              var U = V.declaration, K = V.specifiers;
              if (U) {
                var Q = U.declarations;
                Q && (Q.forEach(function(rt) {
                  y(rt, "module.exports." + l(rt));
                }), y({
                  range: [
                    V.start,
                    U.start + U.kind.length
                  ]
                }, ""));
              } else if (K) {
                var J = K.map(function(rt) {
                  var nt = l(rt);
                  return "module.exports." + nt + " = " + nt + "; ";
                }).join("");
                J && y(V, J);
              }
              break;
          }
        }
        function C(V, U, K) {
          if (V) {
            for (var Q in V)
              if (Q !== "range" && Q !== "loc") {
                var J = V[Q];
                if (Array.isArray(J))
                  for (var rt = 0, nt = J.length; rt < nt; rt++)
                    C(J[rt], V, K);
                else
                  J && typeof J == "object" && C(J, V, K);
              }
            K.operatorOverloading !== !1 && S(V, U), K.moduleExports !== !1 && w(V);
          }
        }
        function I(V) {
          var U = "", K = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
          for (V = (Math.abs(V) << 1) + (V < 0 ? 1 : 0); V || !U; ) {
            var Q = V & 31;
            V >>= 5, V && (Q |= 32), U += K[Q];
          }
          return U;
        }
        var M = x.url || "", k = x.sourceMaps, P = x.paperFeatures || {}, O = x.source || v, L = x.offset || 0, B = _t.agent, N = B.versionNumber, D = !1, Z = /\r\n|\n|\r/mg, G;
        if (k && (B.chrome && N >= 30 || B.webkit && N >= 537.76 || B.firefox && N >= 23 || B.node)) {
          if (B.node)
            L -= 2;
          else if ($ && M && !$.location.href.indexOf(M)) {
            var Y = tt.getElementsByTagName("html")[0].innerHTML;
            L = Y.substr(0, Y.indexOf(v) + 1).match(
              Z
            ).length + 1;
          }
          D = L > 0 && !(B.chrome && N >= 36 || B.safari && N >= 600 || B.firefox && N >= 40 || B.node);
          var X = ["AA" + I(D ? 0 : L) + "A"];
          X.length = (v.match(Z) || []).length + 1 + (D ? L : 0), G = {
            version: 3,
            file: M,
            names: [],
            mappings: X.join(";AACA"),
            sourceRoot: "",
            sources: [M],
            sourcesContent: [O]
          };
        }
        return (P.operatorOverloading !== !1 || P.moduleExports !== !1) && C(r(v, {
          ranges: !0,
          preserveParens: !0,
          sourceType: "module"
        }), null, P), G && (D && (v = new Array(L + 1).join(`
`) + v), /^(inline|both)$/.test(k) && (v += `
//# sourceMappingURL=data:application/json;base64,` + q.btoa(unescape(encodeURIComponent(
          JSON.stringify(G)
        )))), v += `
//# sourceURL=` + (M || "paperscript")), {
          url: M,
          source: O,
          code: v,
          map: G
        };
      }
      function g(v, x, _) {
        _t = x;
        var m = x.getView(), l = /\btool\.\w+|\s+on(?:Key|Mouse)(?:Up|Down|Move|Drag)\b/.test(v) && !/\bnew\s+Tool\b/.test(v) ? new rn() : null, p = l ? l._events : [], y = ["onFrame", "onResize"].concat(p), S = [], w = [], C, I = typeof v == "object" ? v : d(v, _);
        v = I.code;
        function M(N, D) {
          for (var Z in N)
            (D || !/^_/.test(Z)) && new RegExp("([\\b\\s\\W]|^)" + Z.replace(/\$/g, "\\$") + "\\b").test(v) && (S.push(Z), w.push(N[Z]));
        }
        M(
          { __$__: o, $__: h, paper: x, tool: l },
          !0
        ), M(x), v = "var module = { exports: {} }; " + v;
        var L = T.each(y, function(N) {
          new RegExp("\\s+" + N + "\\b").test(v) && (S.push(N), this.push("module.exports." + N + " = " + N + ";"));
        }, []).join(`
`);
        L && (v += `
` + L), v += `
return module.exports;`;
        var k = _t.agent;
        if (tt && (k.chrome || k.firefox && k.versionNumber < 40)) {
          var P = tt.createElement("script"), O = tt.head || tt.getElementsByTagName("head")[0];
          k.firefox && (v = `
` + v), P.appendChild(tt.createTextNode(
            "document.__paperscript__ = function(" + S + ") {" + v + `
}`
          )), O.appendChild(P), C = tt.__paperscript__, delete tt.__paperscript__, O.removeChild(P);
        } else
          C = Function(S, v);
        var L = C && C.apply(x, w), B = L || {};
        return T.each(p, function(N) {
          var D = B[N];
          D && (l[N] = D);
        }), m && (B.onResize && m.setOnResize(B.onResize), m.emit("resize", {
          size: m.size,
          delta: new E()
        }), B.onFrame && m.setOnFrame(B.onFrame), m.requestUpdate()), L;
      }
      function c(v) {
        if (/^text\/(?:x-|)paperscript$/.test(v.type) && yt.getAttribute(v, "ignore") !== "true") {
          var x = yt.getAttribute(v, "canvas"), _ = tt.getElementById(x), m = v.src || v.getAttribute("data-src"), l = yt.hasAttribute(v, "async"), p = "data-paper-scope";
          if (!_)
            throw new Error('Unable to find canvas with id "' + x + '"');
          var y = yt.get(_.getAttribute(p)) || new yt().setup(_);
          return _.setAttribute(p, y._id), m ? Pi.request({
            url: m,
            async: l,
            mimeType: "text/plain",
            onLoad: function(S) {
              g(S, y, m);
            }
          }) : g(v.innerHTML, y, v.baseURI), v.setAttribute("data-paper-ignore", "true"), y;
        }
      }
      function f() {
        T.each(
          tt && tt.getElementsByTagName("script"),
          c
        );
      }
      function b(v) {
        return v ? c(v) : f();
      }
      return $ && (tt.readyState === "complete" ? setTimeout(f) : Nt.add($, { load: f })), {
        compile: d,
        execute: g,
        load: b,
        parse: r,
        calculateBinary: o,
        calculateUnary: h
      };
    }.call(this);
    var _t = new (yt.inject(T.exports, {
      Base: T,
      Numerical: lt,
      Key: Ci,
      DomEvent: Nt,
      DomElement: At,
      document: tt,
      window: $,
      Symbol: $t,
      PlacedSymbol: ve
    }))();
    return _t.agent.node && Xi(_t), typeof F == "function" && F.amd ? F("paper", _t) : Pt && (Pt.exports = _t), _t;
  }).call(Hn, typeof self == "object" ? self : null);
})(Gn);
class Xn {
  constructor() {
    Be(this, "_paperScope", new be.PaperScope());
    this._paperScope.setup(new be.Size(1, 1));
  }
  generateImage(q) {
    if (q.width <= 0 || q.height <= 0)
      throw new Error("Width and height must be greater than 0");
    const F = this.createShape(q), $ = this.createSplitColumns(q), tt = this.createMeasures(q);
    return {
      shape: F,
      splitColumns: $,
      measures: tt
    };
  }
  createShape(q) {
    const F = new this._paperScope.Path.Rectangle({
      point: [0, 0],
      size: [q.width, q.height],
      radius: q.shape.borderRadius,
      fillColor: q.shape.fillColor,
      strokeColor: q.shape.borderColor,
      strokeWidth: q.shape.borderWidth,
      shadowColor: q.shape.shadowColor,
      shadowBlur: q.shape.shadowBlur,
      shadowOffset: new this._paperScope.Point(q.shape.shadowOffset.x, q.shape.shadowOffset.y)
    });
    return F.position = new this._paperScope.Point(0, 0), F.remove(), {
      json: F.exportJSON(),
      svg: F.exportSVG({ asString: !0 })
    };
  }
  createSplitColumns(q) {
    const F = new this._paperScope.Group(), $ = q.width / q.splitColumns.columns, tt = q.height / q.splitColumns.rows;
    for (let T = 1; T < q.splitColumns.columns; T++) {
      const vt = T * $, yt = new this._paperScope.Path.Line({
        from: [vt, 0 + q.splitColumns.marginVertical],
        to: [vt, q.height - q.splitColumns.marginVertical],
        strokeColor: q.splitColumns.lineColor,
        strokeWidth: q.splitColumns.lineWidth,
        dashArray: q.splitColumns.lineDashArray,
        strokeScaling: !1
      });
      F.addChild(yt);
    }
    for (let T = 1; T < q.splitColumns.rows; T++) {
      const vt = T * tt, yt = new this._paperScope.Path.Line({
        from: [0 + q.splitColumns.marginVertical, vt],
        to: [q.width - q.splitColumns.marginVertical, vt],
        strokeColor: q.splitColumns.lineColor,
        strokeWidth: q.splitColumns.lineWidth,
        dashArray: q.splitColumns.lineDashArray,
        strokeScaling: !1
      });
      F.addChild(yt);
    }
    return F.position = new this._paperScope.Point(0, 0), {
      json: F.exportJSON(),
      svg: F.exportSVG({ asString: !0 })
    };
  }
  createMeasures(q) {
    const F = new this._paperScope.Group(), $ = this.createArrow(
      q,
      new this._paperScope.Point(-q.width / 2, -q.height / 2 - 10),
      new this._paperScope.Point(+q.width / 2, -q.height / 2 - 10)
    ), tt = this.createArrow(
      q,
      new this._paperScope.Point(-q.width / 2 - 10, -q.height / 2),
      new this._paperScope.Point(-q.width / 2 - 10, +q.height / 2)
    ), T = new this._paperScope.PointText({
      fillColor: q.measures.labelColor,
      fontFamily: "Courier New",
      fontWeight: "bold",
      fontSize: q.measures.labelFontSize,
      justification: "center",
      position: [0, -q.height / 2 - 20],
      content: q.measures.widthLabel
    }), vt = new this._paperScope.PointText({
      fillColor: q.measures.labelColor,
      fontFamily: "Courier New",
      fontWeight: "bold",
      fontSize: q.measures.labelFontSize,
      justification: "center",
      position: [-q.width / 2 - 20, 0],
      content: q.measures.heightLabel,
      rotation: -90
    });
    return F.addChild(T), F.addChild(vt), F.addChild($), F.addChild(tt), {
      json: F.exportJSON(),
      svg: F.exportSVG({ asString: !0 })
    };
  }
  createArrow(q, F, $) {
    const tt = new this._paperScope.Group(), T = $.subtract(F).angle, vt = {
      strokeColor: q.measures.lineColor,
      strokeWidth: q.measures.lineWidth,
      dashArray: q.measures.lineDashArray,
      strokeScaling: !1
    }, yt = new this._paperScope.Path.Line({
      from: F,
      to: $,
      ...vt
    }), Ct = new this._paperScope.Path.Line({
      from: F,
      to: F.add(new this._paperScope.Point(-5, -5)),
      ...vt
    }), qt = new this._paperScope.Path.Line({
      from: F,
      to: F.add(new this._paperScope.Point(-5, 5)),
      ...vt
    }), St = new this._paperScope.Path.Line({
      from: $,
      to: $.add(new this._paperScope.Point(-5, -5)),
      ...vt
    }), lt = new this._paperScope.Path.Line({
      from: $,
      to: $.add(new this._paperScope.Point(-5, 5)),
      ...vt
    });
    return Ct.rotate(T + 180, F), qt.rotate(T + 180, F), St.rotate(T, $), lt.rotate(T, $), tt.addChild(yt), tt.addChild(Ct), tt.addChild(qt), tt.addChild(St), tt.addChild(lt), tt;
  }
}
class Jn {
  constructor() {
    Be(this, "_paperScope", new be.PaperScope());
    this._paperScope.setup(new be.Size(1, 1));
  }
  generateArea(q) {
    if (q.width <= 0 || q.height <= 0)
      throw new Error("Width and height must be greater than 0");
    const F = new this._paperScope.Path.Rectangle({
      point: [0, 0],
      size: [q.width, q.height],
      radius: q.borderRadius
    });
    return F.position = new this._paperScope.Point(0, 0), F.remove(), {
      json: F.exportJSON(),
      svg: F.exportSVG({ asString: !0 })
    };
  }
}
class Qn {
  constructor() {
    Be(this, "_paperScope", new be.PaperScope());
    Be(this, "_baseMaterial", null);
    Be(this, "_borderMaterial", null);
    const q = document.createElement("canvas");
    q.width = 1, q.height = 1, this._paperScope.setup(new be.Size(1, 1));
  }
  generatePreview3D(q, F) {
    if (!q.columns || isNaN(q.columns) || q.columns < 1 || q.rows < 1 || !q.rows || isNaN(q.rows))
      throw new Error("Invalid columns or rows value. Columns and rows must be greater than 0 and must be a number.");
    console.log("Generating 3D preview for resizable canvas...", q), this._baseMaterial || (this._baseMaterial = new BABYLON.PBRMaterial("baseMaterial", F)), this._borderMaterial || (this._borderMaterial = new BABYLON.PBRMaterial("borderMaterial", F)), this._baseMaterial.albedoColor = new BABYLON.Color3(1, 1, 1), this._baseMaterial.metallic = 0, this._baseMaterial.roughness = 0.5, this._borderMaterial.albedoColor = new BABYLON.Color3.FromHexString(q.borderColor), this._borderMaterial.metallic = 0, this._borderMaterial.roughness = 0.5, q.useCheckerTexture && (this._baseMaterial.albedoTexture = new BABYLON.Texture("https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png", F), this._baseMaterial.albedoTexture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, this._baseMaterial.albedoTexture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE, this._borderMaterial.albedoTexture = new BABYLON.Texture("https://zakekecdn.blob.core.windows.net/cdn/Test/checker_texture.png", F), this._borderMaterial.albedoTexture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE, this._borderMaterial.albedoTexture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE);
    const $ = new BABYLON.Mesh("groupMesh", F), tt = [], T = [], vt = [];
    for (let lt = 0; lt < q.columns; lt++)
      for (let xt = 0; xt < q.rows; xt++) {
        const [E, Zt, W] = this.generateCanvasMesh(q, F, lt, xt);
        tt.push(E), T.push(Zt), vt.push(W);
      }
    const yt = BABYLON.Mesh.MergeMeshes(tt, !0, !0, void 0, !1, !1), Ct = BABYLON.Mesh.MergeMeshes(T, !0, !0, void 0, !1, !1), qt = BABYLON.Mesh.MergeMeshes(vt, !0, !0, void 0, !1, !1);
    yt.material = this._borderMaterial, Ct.material = this._baseMaterial, qt.material = this._baseMaterial, yt.parent = $, Ct.parent = $, qt.parent = $, yt.name = "borders", Ct.name = "back", qt.name = "front";
    const St = BABYLON.SceneSerializer.SerializeMesh($, !1, !0);
    return $ == null || $.dispose(), St;
  }
  generateCanvasMesh(q, F, $, tt) {
    const T = q.width / q.columns, vt = q.height / q.rows, yt = T * 0.1, Ct = BABYLON.MeshBuilder.CreateBox("borders", {
      width: T,
      height: vt,
      depth: q.depth
    }, F), qt = BABYLON.MeshBuilder.CreatePlane("front", {
      width: T,
      height: vt
    }, F), St = BABYLON.MeshBuilder.CreatePlane("back", {
      width: T,
      height: vt
    }, F);
    Ct.position = new BABYLON.Vector3(
      T / 2 + $ * (T + yt),
      vt / 2 + tt * (vt + yt)
    ), qt.position = new BABYLON.Vector3(
      T / 2 + $ * (T + yt),
      vt / 2 + tt * (vt + yt),
      -q.depth / 2
    ), St.position = new BABYLON.Vector3(
      T / 2 + $ * (T + yt),
      vt / 2 + tt * (vt + yt),
      q.depth / 2
    ), St.rotate(BABYLON.Axis.X, Math.PI, BABYLON.Space.WORLD), St.rotate(BABYLON.Axis.Z, Math.PI, BABYLON.Space.WORLD), Ct.material = this._borderMaterial, St.material = this._borderMaterial, qt.material = this._baseMaterial;
    const lt = Ct.getVerticesData(BABYLON.VertexBuffer.NormalKind), xt = Ct.getVerticesData(BABYLON.VertexBuffer.UVKind), E = qt.getVerticesData(BABYLON.VertexBuffer.UVKind), Zt = St.getVerticesData(BABYLON.VertexBuffer.UVKind);
    if (q.borderRadius > 0 && console.warn("Mirror canvas effect will not work for border radius > 0"), q.borderRadius === 0) {
      const Te = q.depth / q.width, ft = q.depth / q.height, jt = Math.min(Te, ft), Kt = T / q.width, It = vt / q.height;
      for (var W = 0; W < xt.length; W += 2) {
        const he = Math.round(lt[W / 2 * 3]), ve = Math.round(lt[W / 2 * 3 + 1]), $t = Math.round(lt[W / 2 * 3 + 2]), ie = he == -1 && ve == 0 && $t == 0, it = he == 1 && ve == 0 && $t == 0, Ne = he == 0 && ve == 1 && $t == 0, j = he == 0 && ve == -1 && $t == 0;
        if (ie) {
          var Wt = xt[W], et = xt[W + 1];
          xt[W] = et * jt + Kt * $, xt[W + 1] = Wt * It + It * tt;
        }
        if (it) {
          var Wt = xt[W], et = xt[W + 1];
          xt[W] = et * jt + (1 - jt) - Kt * (q.columns - 1 - $), xt[W + 1] = Wt * It + It * tt;
        }
        if (j) {
          var Wt = xt[W], et = xt[W + 1];
          xt[W] = et * Kt + Kt * $, xt[W + 1] = Wt * jt + It * tt;
        }
        if (Ne) {
          var Wt = xt[W], et = xt[W + 1];
          xt[W] = (-et + 1) * Kt + Kt * $, xt[W + 1] = (-Wt + 1) * jt + (1 - jt);
        }
      }
      Ct.setVerticesData(BABYLON.VertexBuffer.UVKind, xt);
      for (var W = 0; W < E.length; W += 2) {
        var Wt = E[W], et = E[W + 1];
        E[W] = Wt * Kt + Kt * $, E[W + 1] = et * It + It * tt;
      }
      qt.setVerticesData(BABYLON.VertexBuffer.UVKind, E);
      for (var W = 0; W < Zt.length; W += 2) {
        var Wt = Zt[W], et = Zt[W + 1];
        Zt[W] = Wt * Kt + Kt * (q.columns - 1 - $), Zt[W + 1] = et * It + It * tt;
      }
      St.setVerticesData(BABYLON.VertexBuffer.UVKind, Zt);
    }
    qt.isVisible = !1, St.isVisible = !1;
    var Ue = Ct.getVerticesData(BABYLON.VertexBuffer.PositionKind), wt = Ct.getVerticesData(BABYLON.VertexBuffer.NormalKind), Et = Ct.getVerticesData(BABYLON.VertexBuffer.UVKind);
    return Ue.splice(0, 8 * 3), wt.splice(0, 8 * 3), Et.splice(0, 8 * 2), Ct.setVerticesData(BABYLON.VertexBuffer.PositionKind, Ue), Ct.setVerticesData(BABYLON.VertexBuffer.NormalKind, wt), Ct.setVerticesData(BABYLON.VertexBuffer.UVKind, Et), [Ct, St, qt];
  }
  /*public generatePreview3D(options: ResizableCanvas3DOptions) {
  
          // Use paper to generate the path
          const rectangle = new this._paperScope.Path.Rectangle({
              point: [0, 0],
              size: [options.width, options.height],
              radius: options.borderRadius,
          });
  
          rectangle.flatten(options.radiusResolution);
          rectangle.remove();
  
          //Shape profile in XY plane
          const shape = [
              ...rectangle.segments.map(segment => new BABYLON.Vector3(segment.point.x, 0, segment.point.y)),
          ];
  
          var faceUV = new Array(3);
  
          // We know that the texture created from the customer is squared and the 
          // printing area is "fitted" inside the UV quadrant, at the center.
          // So, based on the width and height ratio, we know what portion of the UV map quadrant
          // we have to show, we just need to normalized the width and height in the quadrant
  
          //const ratio = options.width / options.height;
          //let width = 1;
          //let height = 1 / ratio;
  
          //if (ratio < 1) {
            //  width = 1 * ratio;
           //   height = 1;
          //}
  
          //const uvU = 0.5 - width / 2;
          //const uvV = 0.5 - height / 2;
  
          //faceUV[0] = new BABYLON.Vector4(uvU, uvV, uvU + width, uvV + height);
          //faceUV[1] = new BABYLON.Vector4(uvU, uvV, uvU + width, uvV + height);
          //faceUV[2] = new BABYLON.Vector4(uvU, uvV, uvU + width, uvV + height);
  
          faceUV[0] = new BABYLON.Vector4(0, 0, 1, 1);
          faceUV[1] = new BABYLON.Vector4(0, 0, 1, 1);
          faceUV[2] = new BABYLON.Vector4(0, 0, 1, -1);
  
  
          let mesh = BABYLON.MeshBuilder.ExtrudePolygon("canvas", {
              shape: shape,
              depth: options.depth,
              faceUV,
          }, null, earcut);
  
          // Get vertexes
          let positions = mesh!.getVerticesData(BABYLON.VertexBuffer.PositionKind) as number[];
          let indices = mesh!.getIndices() as number[];
          let normals = mesh!.getVerticesData(BABYLON.VertexBuffer.NormalKind) as number[];
          let uvs = mesh!.getVerticesData(BABYLON.VertexBuffer.UVKind) as number[];
  
          if (options.borderRadius > 0)
              console.warn("Mirror canvas effect will not work for border radius > 0")
  
          if (options.borderRadius === 0) {
              // Make the mirror UV map, normally is 0,0 1,1 but we need to use the correct portion too
              const sidePortionX = options.depth / options.width;
              const sidePortionY = options.depth / options.height;
  
              // Use the same portion for both directions
              const sidePortion = Math.min(sidePortionX, sidePortionY);
  
              for (var i = 0; i < uvs.length; i += 2) {
                  // Get the vertex normal
                  const normalX = Math.round(normals[i / 2 * 3]);
                  const normalY = Math.round(normals[i / 2 * 3 + 1]);
                  const normalZ = Math.round(normals[i / 2 * 3 + 2]);
  
  
                  // Left
                  if (normalX == -1 && normalY == 0 && normalZ == 0) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = -y * sidePortion + sidePortion;// uv is inverted??? 
                      uvs[i + 1] = -x + 1;
                  }
  
                  // Right
                  if (normalX == 1 && normalY == 0 && normalZ == 0) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = y * sidePortion - sidePortion + 1;// uv is inverted??? 
                      uvs[i + 1] = x;
  
  
                      console.log(i, uvs[i], uvs[i + 1])
                  }
  
                  // Bottom
                  if (normalX == 0 && normalY == 0 && normalZ == -1) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = x;
                      uvs[i + 1] = -y * sidePortion + sidePortion;// uv is inverted??? 
                  }
  
                  // Top
                  if (normalX == 0 && normalY == 0 && normalZ == 1) {
                      var x = uvs[i];
                      var y = uvs[i + 1];
                      uvs[i] = -x + 1;
                      uvs[i + 1] = y * sidePortion - sidePortion + 1; // uv is inverted??? 
                  }
              }
  
              mesh.setVerticesData(BABYLON.VertexBuffer.UVKind, uvs);
          }
  
          mesh?.dispose();
  
          return { positions, indices, normals, uvs };
      }*/
}



/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.tsx");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});